import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** BigInt custom scalar type */
  BigInt: any;
  /** Date custom scalar type */
  DateTime: any;
  /** Decimal custom scalar type */
  Decimal: any;
  /** Json custom scalar type */
  Json: any;
};

export type AcademicRank = {
  __typename?: 'AcademicRank';
  ProfessionalSkills: Array<ProfessionalSkills>;
  _count: AcademicRankCountOutputType;
  id: Scalars['Int'];
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};


export type AcademicRankProfessionalSkillsArgs = {
  cursor?: InputMaybe<ProfessionalSkillsWhereUniqueInput>;
  distinct?: InputMaybe<ProfessionalSkillsScalarFieldEnum>;
  orderBy?: InputMaybe<ProfessionalSkillsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProfessionalSkillsWhereInput>;
};

export type AcademicRankAvgAggregateOutputType = {
  __typename?: 'AcademicRankAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
};

export type AcademicRankAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type AcademicRankCountAggregateOutputType = {
  __typename?: 'AcademicRankCountAggregateOutputType';
  _all: Scalars['Int'];
  id: Scalars['Int'];
  titleAr: Scalars['Int'];
  titleEn: Scalars['Int'];
};

export type AcademicRankCountOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type AcademicRankCountOutputType = {
  __typename?: 'AcademicRankCountOutputType';
  ProfessionalSkills: Scalars['Int'];
};

export type AcademicRankCreateInput = {
  ProfessionalSkills?: InputMaybe<ProfessionalSkillsCreateNestedManyWithoutAcademicRankInput>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type AcademicRankCreateManyInput = {
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type AcademicRankCreateNestedOneWithoutProfessionalSkillsInput = {
  connect?: InputMaybe<AcademicRankWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AcademicRankCreateOrConnectWithoutProfessionalSkillsInput>;
  create?: InputMaybe<AcademicRankUncheckedCreateWithoutProfessionalSkillsInput>;
};

export type AcademicRankCreateOrConnectWithoutProfessionalSkillsInput = {
  create: AcademicRankUncheckedCreateWithoutProfessionalSkillsInput;
  where: AcademicRankWhereUniqueInput;
};

export type AcademicRankCreateWithoutProfessionalSkillsInput = {
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type AcademicRankMaxAggregateOutputType = {
  __typename?: 'AcademicRankMaxAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type AcademicRankMaxOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type AcademicRankMinAggregateOutputType = {
  __typename?: 'AcademicRankMinAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type AcademicRankMinOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type AcademicRankOrderByWithAggregationInput = {
  _avg?: InputMaybe<AcademicRankAvgOrderByAggregateInput>;
  _count?: InputMaybe<AcademicRankCountOrderByAggregateInput>;
  _max?: InputMaybe<AcademicRankMaxOrderByAggregateInput>;
  _min?: InputMaybe<AcademicRankMinOrderByAggregateInput>;
  _sum?: InputMaybe<AcademicRankSumOrderByAggregateInput>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type AcademicRankOrderByWithRelationInput = {
  ProfessionalSkills?: InputMaybe<ProfessionalSkillsOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type AcademicRankRelationFilter = {
  is?: InputMaybe<AcademicRankWhereInput>;
  isNot?: InputMaybe<AcademicRankWhereInput>;
};

export enum AcademicRankScalarFieldEnum {
  Id = 'id',
  TitleAr = 'titleAr',
  TitleEn = 'titleEn'
}

export type AcademicRankScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<AcademicRankScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<AcademicRankScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<AcademicRankScalarWhereWithAggregatesInput>>>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  titleAr?: InputMaybe<StringWithAggregatesFilter>;
  titleEn?: InputMaybe<StringWithAggregatesFilter>;
};

export type AcademicRankSumAggregateOutputType = {
  __typename?: 'AcademicRankSumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
};

export type AcademicRankSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type AcademicRankUncheckedCreateInput = {
  ProfessionalSkills?: InputMaybe<ProfessionalSkillsUncheckedCreateNestedManyWithoutAcademicRankInput>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type AcademicRankUncheckedCreateWithoutProfessionalSkillsInput = {
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type AcademicRankUncheckedUpdateInput = {
  ProfessionalSkills?: InputMaybe<ProfessionalSkillsUncheckedUpdateManyWithoutAcademicRankInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AcademicRankUncheckedUpdateManyInput = {
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AcademicRankUncheckedUpdateWithoutProfessionalSkillsInput = {
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AcademicRankUpdateInput = {
  ProfessionalSkills?: InputMaybe<ProfessionalSkillsUpdateManyWithoutAcademicRankInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AcademicRankUpdateManyMutationInput = {
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AcademicRankUpdateOneWithoutProfessionalSkillsInput = {
  connect?: InputMaybe<AcademicRankWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AcademicRankCreateOrConnectWithoutProfessionalSkillsInput>;
  create?: InputMaybe<AcademicRankUncheckedCreateWithoutProfessionalSkillsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<AcademicRankUncheckedUpdateWithoutProfessionalSkillsInput>;
  upsert?: InputMaybe<AcademicRankUpsertWithoutProfessionalSkillsInput>;
};

export type AcademicRankUpdateWithoutProfessionalSkillsInput = {
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AcademicRankUpsertWithoutProfessionalSkillsInput = {
  create: AcademicRankUncheckedCreateWithoutProfessionalSkillsInput;
  update: AcademicRankUncheckedUpdateWithoutProfessionalSkillsInput;
};

export type AcademicRankWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<AcademicRankWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<AcademicRankWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<AcademicRankWhereInput>>>;
  ProfessionalSkills?: InputMaybe<ProfessionalSkillsListRelationFilter>;
  id?: InputMaybe<IntFilter>;
  titleAr?: InputMaybe<StringFilter>;
  titleEn?: InputMaybe<StringFilter>;
};

export type AcademicRankWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type Account = {
  __typename?: 'Account';
  access_token?: Maybe<Scalars['String']>;
  expires_at?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  id_token?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  providerAccountId: Scalars['String'];
  refresh_token?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  session_state?: Maybe<Scalars['String']>;
  token_type?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  user: User;
  userId: Scalars['Int'];
};

export type AccountAvgAggregateOutputType = {
  __typename?: 'AccountAvgAggregateOutputType';
  expires_at?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

export type AccountAvgOrderByAggregateInput = {
  expires_at?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type AccountCountAggregateOutputType = {
  __typename?: 'AccountCountAggregateOutputType';
  _all: Scalars['Int'];
  access_token: Scalars['Int'];
  expires_at: Scalars['Int'];
  id: Scalars['Int'];
  id_token: Scalars['Int'];
  provider: Scalars['Int'];
  providerAccountId: Scalars['Int'];
  refresh_token: Scalars['Int'];
  scope: Scalars['Int'];
  session_state: Scalars['Int'];
  token_type: Scalars['Int'];
  type: Scalars['Int'];
  userId: Scalars['Int'];
};

export type AccountCountOrderByAggregateInput = {
  access_token?: InputMaybe<SortOrder>;
  expires_at?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  id_token?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  providerAccountId?: InputMaybe<SortOrder>;
  refresh_token?: InputMaybe<SortOrder>;
  scope?: InputMaybe<SortOrder>;
  session_state?: InputMaybe<SortOrder>;
  token_type?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type AccountCreateInput = {
  access_token?: InputMaybe<Scalars['String']>;
  expires_at?: InputMaybe<Scalars['Int']>;
  id_token?: InputMaybe<Scalars['String']>;
  provider: Scalars['String'];
  providerAccountId: Scalars['String'];
  refresh_token?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  session_state?: InputMaybe<Scalars['String']>;
  token_type?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  user: UserCreateNestedOneWithoutAccountsInput;
};

export type AccountCreateManyInput = {
  access_token?: InputMaybe<Scalars['String']>;
  expires_at?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  id_token?: InputMaybe<Scalars['String']>;
  provider: Scalars['String'];
  providerAccountId: Scalars['String'];
  refresh_token?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  session_state?: InputMaybe<Scalars['String']>;
  token_type?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  userId: Scalars['Int'];
};

export type AccountCreateManyUserInput = {
  access_token?: InputMaybe<Scalars['String']>;
  expires_at?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  id_token?: InputMaybe<Scalars['String']>;
  provider: Scalars['String'];
  providerAccountId: Scalars['String'];
  refresh_token?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  session_state?: InputMaybe<Scalars['String']>;
  token_type?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type AccountCreateManyUserInputEnvelope = {
  data: AccountCreateManyUserInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AccountCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<AccountWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AccountCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<AccountCreateWithoutUserInput>>>;
  createMany?: InputMaybe<AccountCreateManyUserInputEnvelope>;
};

export type AccountCreateOrConnectWithoutUserInput = {
  create: AccountUncheckedCreateWithoutUserInput;
  where: AccountWhereUniqueInput;
};

export type AccountCreateWithoutUserInput = {
  access_token?: InputMaybe<Scalars['String']>;
  expires_at?: InputMaybe<Scalars['Int']>;
  id_token?: InputMaybe<Scalars['String']>;
  provider: Scalars['String'];
  providerAccountId: Scalars['String'];
  refresh_token?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  session_state?: InputMaybe<Scalars['String']>;
  token_type?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type AccountListRelationFilter = {
  every?: InputMaybe<AccountWhereInput>;
  none?: InputMaybe<AccountWhereInput>;
  some?: InputMaybe<AccountWhereInput>;
};

export type AccountMaxAggregateOutputType = {
  __typename?: 'AccountMaxAggregateOutputType';
  access_token?: Maybe<Scalars['String']>;
  expires_at?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  id_token?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  providerAccountId?: Maybe<Scalars['String']>;
  refresh_token?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  session_state?: Maybe<Scalars['String']>;
  token_type?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
};

export type AccountMaxOrderByAggregateInput = {
  access_token?: InputMaybe<SortOrder>;
  expires_at?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  id_token?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  providerAccountId?: InputMaybe<SortOrder>;
  refresh_token?: InputMaybe<SortOrder>;
  scope?: InputMaybe<SortOrder>;
  session_state?: InputMaybe<SortOrder>;
  token_type?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type AccountMinAggregateOutputType = {
  __typename?: 'AccountMinAggregateOutputType';
  access_token?: Maybe<Scalars['String']>;
  expires_at?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  id_token?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  providerAccountId?: Maybe<Scalars['String']>;
  refresh_token?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  session_state?: Maybe<Scalars['String']>;
  token_type?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
};

export type AccountMinOrderByAggregateInput = {
  access_token?: InputMaybe<SortOrder>;
  expires_at?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  id_token?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  providerAccountId?: InputMaybe<SortOrder>;
  refresh_token?: InputMaybe<SortOrder>;
  scope?: InputMaybe<SortOrder>;
  session_state?: InputMaybe<SortOrder>;
  token_type?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type AccountOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AccountOrderByWithAggregationInput = {
  _avg?: InputMaybe<AccountAvgOrderByAggregateInput>;
  _count?: InputMaybe<AccountCountOrderByAggregateInput>;
  _max?: InputMaybe<AccountMaxOrderByAggregateInput>;
  _min?: InputMaybe<AccountMinOrderByAggregateInput>;
  _sum?: InputMaybe<AccountSumOrderByAggregateInput>;
  access_token?: InputMaybe<SortOrder>;
  expires_at?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  id_token?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  providerAccountId?: InputMaybe<SortOrder>;
  refresh_token?: InputMaybe<SortOrder>;
  scope?: InputMaybe<SortOrder>;
  session_state?: InputMaybe<SortOrder>;
  token_type?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type AccountOrderByWithRelationInput = {
  access_token?: InputMaybe<SortOrder>;
  expires_at?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  id_token?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  providerAccountId?: InputMaybe<SortOrder>;
  refresh_token?: InputMaybe<SortOrder>;
  scope?: InputMaybe<SortOrder>;
  session_state?: InputMaybe<SortOrder>;
  token_type?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export type AccountProviderProviderAccountIdCompoundUniqueInput = {
  provider: Scalars['String'];
  providerAccountId: Scalars['String'];
};

export enum AccountScalarFieldEnum {
  AccessToken = 'access_token',
  ExpiresAt = 'expires_at',
  Id = 'id',
  IdToken = 'id_token',
  Provider = 'provider',
  ProviderAccountId = 'providerAccountId',
  RefreshToken = 'refresh_token',
  Scope = 'scope',
  SessionState = 'session_state',
  TokenType = 'token_type',
  Type = 'type',
  UserId = 'userId'
}

export type AccountScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<AccountScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<AccountScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<AccountScalarWhereInput>>>;
  access_token?: InputMaybe<StringNullableFilter>;
  expires_at?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  id_token?: InputMaybe<StringNullableFilter>;
  provider?: InputMaybe<StringFilter>;
  providerAccountId?: InputMaybe<StringFilter>;
  refresh_token?: InputMaybe<StringNullableFilter>;
  scope?: InputMaybe<StringNullableFilter>;
  session_state?: InputMaybe<StringNullableFilter>;
  token_type?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type AccountScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<AccountScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<AccountScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<AccountScalarWhereWithAggregatesInput>>>;
  access_token?: InputMaybe<StringNullableWithAggregatesFilter>;
  expires_at?: InputMaybe<IntNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  id_token?: InputMaybe<StringNullableWithAggregatesFilter>;
  provider?: InputMaybe<StringWithAggregatesFilter>;
  providerAccountId?: InputMaybe<StringWithAggregatesFilter>;
  refresh_token?: InputMaybe<StringNullableWithAggregatesFilter>;
  scope?: InputMaybe<StringNullableWithAggregatesFilter>;
  session_state?: InputMaybe<StringNullableWithAggregatesFilter>;
  token_type?: InputMaybe<StringNullableWithAggregatesFilter>;
  type?: InputMaybe<StringWithAggregatesFilter>;
  userId?: InputMaybe<IntWithAggregatesFilter>;
};

export type AccountSumAggregateOutputType = {
  __typename?: 'AccountSumAggregateOutputType';
  expires_at?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

export type AccountSumOrderByAggregateInput = {
  expires_at?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type AccountUncheckedCreateInput = {
  access_token?: InputMaybe<Scalars['String']>;
  expires_at?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  id_token?: InputMaybe<Scalars['String']>;
  provider: Scalars['String'];
  providerAccountId: Scalars['String'];
  refresh_token?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  session_state?: InputMaybe<Scalars['String']>;
  token_type?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  userId: Scalars['Int'];
};

export type AccountUncheckedCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<AccountWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AccountCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<AccountCreateWithoutUserInput>>>;
  createMany?: InputMaybe<AccountCreateManyUserInputEnvelope>;
};

export type AccountUncheckedCreateWithoutUserInput = {
  access_token?: InputMaybe<Scalars['String']>;
  expires_at?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  id_token?: InputMaybe<Scalars['String']>;
  provider: Scalars['String'];
  providerAccountId: Scalars['String'];
  refresh_token?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  session_state?: InputMaybe<Scalars['String']>;
  token_type?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type AccountUncheckedUpdateInput = {
  access_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expires_at?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  id_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provider?: InputMaybe<StringFieldUpdateOperationsInput>;
  providerAccountId?: InputMaybe<StringFieldUpdateOperationsInput>;
  refresh_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  session_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  token_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  userId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type AccountUncheckedUpdateManyInput = {
  access_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expires_at?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  id_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provider?: InputMaybe<StringFieldUpdateOperationsInput>;
  providerAccountId?: InputMaybe<StringFieldUpdateOperationsInput>;
  refresh_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  session_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  token_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  userId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type AccountUncheckedUpdateManyWithoutAccountsInput = {
  access_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expires_at?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  id_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provider?: InputMaybe<StringFieldUpdateOperationsInput>;
  providerAccountId?: InputMaybe<StringFieldUpdateOperationsInput>;
  refresh_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  session_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  token_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AccountUncheckedUpdateManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<AccountWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AccountCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<AccountCreateWithoutUserInput>>>;
  createMany?: InputMaybe<AccountCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<AccountWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<AccountScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<AccountWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<AccountWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<AccountUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<AccountUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<AccountUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type AccountUncheckedUpdateWithoutUserInput = {
  access_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expires_at?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  id_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provider?: InputMaybe<StringFieldUpdateOperationsInput>;
  providerAccountId?: InputMaybe<StringFieldUpdateOperationsInput>;
  refresh_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  session_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  token_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AccountUpdateInput = {
  access_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expires_at?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provider?: InputMaybe<StringFieldUpdateOperationsInput>;
  providerAccountId?: InputMaybe<StringFieldUpdateOperationsInput>;
  refresh_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  session_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  token_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutAccountsInput>;
};

export type AccountUpdateManyMutationInput = {
  access_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expires_at?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provider?: InputMaybe<StringFieldUpdateOperationsInput>;
  providerAccountId?: InputMaybe<StringFieldUpdateOperationsInput>;
  refresh_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  session_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  token_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AccountUpdateManyWithWhereWithoutUserInput = {
  data: AccountUncheckedUpdateManyWithoutAccountsInput;
  where: AccountScalarWhereInput;
};

export type AccountUpdateManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<AccountWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AccountCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<AccountCreateWithoutUserInput>>>;
  createMany?: InputMaybe<AccountCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<AccountWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<AccountScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<AccountWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<AccountWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<AccountUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<AccountUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<AccountUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type AccountUpdateWithWhereUniqueWithoutUserInput = {
  data: AccountUncheckedUpdateWithoutUserInput;
  where: AccountWhereUniqueInput;
};

export type AccountUpdateWithoutUserInput = {
  access_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expires_at?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provider?: InputMaybe<StringFieldUpdateOperationsInput>;
  providerAccountId?: InputMaybe<StringFieldUpdateOperationsInput>;
  refresh_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  session_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  token_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AccountUpsertWithWhereUniqueWithoutUserInput = {
  create: AccountUncheckedCreateWithoutUserInput;
  update: AccountUncheckedUpdateWithoutUserInput;
  where: AccountWhereUniqueInput;
};

export type AccountWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<AccountWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<AccountWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<AccountWhereInput>>>;
  access_token?: InputMaybe<StringNullableFilter>;
  expires_at?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  id_token?: InputMaybe<StringNullableFilter>;
  provider?: InputMaybe<StringFilter>;
  providerAccountId?: InputMaybe<StringFilter>;
  refresh_token?: InputMaybe<StringNullableFilter>;
  scope?: InputMaybe<StringNullableFilter>;
  session_state?: InputMaybe<StringNullableFilter>;
  token_type?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserWhereInput>;
  userId?: InputMaybe<IntFilter>;
};

export type AccountWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  provider_providerAccountId?: InputMaybe<AccountProviderProviderAccountIdCompoundUniqueInput>;
};

export type AddExpenseType = {
  amount: Scalars['Decimal'];
  description: Scalars['String'];
  eventId?: InputMaybe<Scalars['Int']>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  receiptUrl: Scalars['String'];
  tax: Scalars['Decimal'];
  trainerEventId?: InputMaybe<Scalars['Int']>;
  transitionPurposeId: Scalars['Int'];
};

export type AddMemberToGroupInputType = {
  bookingGroupId: Scalars['Int'];
  coupon?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  eventId: Scalars['Int'];
  groupTraineeEmails?: InputMaybe<Array<Scalars['String']>>;
  isCertificateRegistrant?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant?: InputMaybe<Scalars['Boolean']>;
  methodOfDelivery?: InputMaybe<ModeOfDelivery>;
  partsIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type AddPaymentType = {
  amount: Scalars['Decimal'];
  isForCouponProfit: Scalars['Boolean'];
  receiptUrl: Scalars['String'];
  tax: Scalars['Decimal'];
  userId: Scalars['Int'];
};

export type AggregateAcademicRank = {
  __typename?: 'AggregateAcademicRank';
  _avg?: Maybe<AcademicRankAvgAggregateOutputType>;
  _count?: Maybe<AcademicRankCountAggregateOutputType>;
  _max?: Maybe<AcademicRankMaxAggregateOutputType>;
  _min?: Maybe<AcademicRankMinAggregateOutputType>;
  _sum?: Maybe<AcademicRankSumAggregateOutputType>;
};

export type AggregateAccount = {
  __typename?: 'AggregateAccount';
  _avg?: Maybe<AccountAvgAggregateOutputType>;
  _count?: Maybe<AccountCountAggregateOutputType>;
  _max?: Maybe<AccountMaxAggregateOutputType>;
  _min?: Maybe<AccountMinAggregateOutputType>;
  _sum?: Maybe<AccountSumAggregateOutputType>;
};

export type AggregateAutomatedEmails = {
  __typename?: 'AggregateAutomatedEmails';
  _avg?: Maybe<AutomatedEmailsAvgAggregateOutputType>;
  _count?: Maybe<AutomatedEmailsCountAggregateOutputType>;
  _max?: Maybe<AutomatedEmailsMaxAggregateOutputType>;
  _min?: Maybe<AutomatedEmailsMinAggregateOutputType>;
  _sum?: Maybe<AutomatedEmailsSumAggregateOutputType>;
};

export type AggregateBankAccount = {
  __typename?: 'AggregateBankAccount';
  _avg?: Maybe<BankAccountAvgAggregateOutputType>;
  _count?: Maybe<BankAccountCountAggregateOutputType>;
  _max?: Maybe<BankAccountMaxAggregateOutputType>;
  _min?: Maybe<BankAccountMinAggregateOutputType>;
  _sum?: Maybe<BankAccountSumAggregateOutputType>;
};

export type AggregateBecomeTrainerApplication = {
  __typename?: 'AggregateBecomeTrainerApplication';
  _avg?: Maybe<BecomeTrainerApplicationAvgAggregateOutputType>;
  _count?: Maybe<BecomeTrainerApplicationCountAggregateOutputType>;
  _max?: Maybe<BecomeTrainerApplicationMaxAggregateOutputType>;
  _min?: Maybe<BecomeTrainerApplicationMinAggregateOutputType>;
  _sum?: Maybe<BecomeTrainerApplicationSumAggregateOutputType>;
};

export type AggregateBlogs = {
  __typename?: 'AggregateBlogs';
  _avg?: Maybe<BlogsAvgAggregateOutputType>;
  _count?: Maybe<BlogsCountAggregateOutputType>;
  _max?: Maybe<BlogsMaxAggregateOutputType>;
  _min?: Maybe<BlogsMinAggregateOutputType>;
  _sum?: Maybe<BlogsSumAggregateOutputType>;
};

export type AggregateBookingStatus = {
  __typename?: 'AggregateBookingStatus';
  _avg?: Maybe<BookingStatusAvgAggregateOutputType>;
  _count?: Maybe<BookingStatusCountAggregateOutputType>;
  _max?: Maybe<BookingStatusMaxAggregateOutputType>;
  _min?: Maybe<BookingStatusMinAggregateOutputType>;
  _sum?: Maybe<BookingStatusSumAggregateOutputType>;
};

export type AggregateCertificate = {
  __typename?: 'AggregateCertificate';
  _avg?: Maybe<CertificateAvgAggregateOutputType>;
  _count?: Maybe<CertificateCountAggregateOutputType>;
  _max?: Maybe<CertificateMaxAggregateOutputType>;
  _min?: Maybe<CertificateMinAggregateOutputType>;
  _sum?: Maybe<CertificateSumAggregateOutputType>;
};

export type AggregateCity = {
  __typename?: 'AggregateCity';
  _avg?: Maybe<CityAvgAggregateOutputType>;
  _count?: Maybe<CityCountAggregateOutputType>;
  _max?: Maybe<CityMaxAggregateOutputType>;
  _min?: Maybe<CityMinAggregateOutputType>;
  _sum?: Maybe<CitySumAggregateOutputType>;
};

export type AggregateContactUsData = {
  __typename?: 'AggregateContactUsData';
  _avg?: Maybe<ContactUsDataAvgAggregateOutputType>;
  _count?: Maybe<ContactUsDataCountAggregateOutputType>;
  _max?: Maybe<ContactUsDataMaxAggregateOutputType>;
  _min?: Maybe<ContactUsDataMinAggregateOutputType>;
  _sum?: Maybe<ContactUsDataSumAggregateOutputType>;
};

export type AggregateCountry = {
  __typename?: 'AggregateCountry';
  _avg?: Maybe<CountryAvgAggregateOutputType>;
  _count?: Maybe<CountryCountAggregateOutputType>;
  _max?: Maybe<CountryMaxAggregateOutputType>;
  _min?: Maybe<CountryMinAggregateOutputType>;
  _sum?: Maybe<CountrySumAggregateOutputType>;
};

export type AggregateCoupon = {
  __typename?: 'AggregateCoupon';
  _avg?: Maybe<CouponAvgAggregateOutputType>;
  _count?: Maybe<CouponCountAggregateOutputType>;
  _max?: Maybe<CouponMaxAggregateOutputType>;
  _min?: Maybe<CouponMinAggregateOutputType>;
  _sum?: Maybe<CouponSumAggregateOutputType>;
};

export type AggregateCv = {
  __typename?: 'AggregateCv';
  _avg?: Maybe<CvAvgAggregateOutputType>;
  _count?: Maybe<CvCountAggregateOutputType>;
  _max?: Maybe<CvMaxAggregateOutputType>;
  _min?: Maybe<CvMinAggregateOutputType>;
  _sum?: Maybe<CvSumAggregateOutputType>;
};

export type AggregateDiscussion = {
  __typename?: 'AggregateDiscussion';
  _avg?: Maybe<DiscussionAvgAggregateOutputType>;
  _count?: Maybe<DiscussionCountAggregateOutputType>;
  _max?: Maybe<DiscussionMaxAggregateOutputType>;
  _min?: Maybe<DiscussionMinAggregateOutputType>;
  _sum?: Maybe<DiscussionSumAggregateOutputType>;
};

export type AggregateEPaymentMethod = {
  __typename?: 'AggregateEPaymentMethod';
  _avg?: Maybe<EPaymentMethodAvgAggregateOutputType>;
  _count?: Maybe<EPaymentMethodCountAggregateOutputType>;
  _max?: Maybe<EPaymentMethodMaxAggregateOutputType>;
  _min?: Maybe<EPaymentMethodMinAggregateOutputType>;
  _sum?: Maybe<EPaymentMethodSumAggregateOutputType>;
};

export type AggregateEducation = {
  __typename?: 'AggregateEducation';
  _avg?: Maybe<EducationAvgAggregateOutputType>;
  _count?: Maybe<EducationCountAggregateOutputType>;
  _max?: Maybe<EducationMaxAggregateOutputType>;
  _min?: Maybe<EducationMinAggregateOutputType>;
  _sum?: Maybe<EducationSumAggregateOutputType>;
};

export type AggregateEvent = {
  __typename?: 'AggregateEvent';
  _avg?: Maybe<EventAvgAggregateOutputType>;
  _count?: Maybe<EventCountAggregateOutputType>;
  _max?: Maybe<EventMaxAggregateOutputType>;
  _min?: Maybe<EventMinAggregateOutputType>;
  _sum?: Maybe<EventSumAggregateOutputType>;
};

export type AggregateEventDay = {
  __typename?: 'AggregateEventDay';
  _avg?: Maybe<EventDayAvgAggregateOutputType>;
  _count?: Maybe<EventDayCountAggregateOutputType>;
  _max?: Maybe<EventDayMaxAggregateOutputType>;
  _min?: Maybe<EventDayMinAggregateOutputType>;
  _sum?: Maybe<EventDaySumAggregateOutputType>;
};

export type AggregateEventFolder = {
  __typename?: 'AggregateEventFolder';
  _avg?: Maybe<EventFolderAvgAggregateOutputType>;
  _count?: Maybe<EventFolderCountAggregateOutputType>;
  _max?: Maybe<EventFolderMaxAggregateOutputType>;
  _min?: Maybe<EventFolderMinAggregateOutputType>;
  _sum?: Maybe<EventFolderSumAggregateOutputType>;
};

export type AggregateEventIdentityCardTemplate = {
  __typename?: 'AggregateEventIdentityCardTemplate';
  _avg?: Maybe<EventIdentityCardTemplateAvgAggregateOutputType>;
  _count?: Maybe<EventIdentityCardTemplateCountAggregateOutputType>;
  _max?: Maybe<EventIdentityCardTemplateMaxAggregateOutputType>;
  _min?: Maybe<EventIdentityCardTemplateMinAggregateOutputType>;
  _sum?: Maybe<EventIdentityCardTemplateSumAggregateOutputType>;
};

export type AggregateEventMediaTracking = {
  __typename?: 'AggregateEventMediaTracking';
  _avg?: Maybe<EventMediaTrackingAvgAggregateOutputType>;
  _count?: Maybe<EventMediaTrackingCountAggregateOutputType>;
  _max?: Maybe<EventMediaTrackingMaxAggregateOutputType>;
  _min?: Maybe<EventMediaTrackingMinAggregateOutputType>;
  _sum?: Maybe<EventMediaTrackingSumAggregateOutputType>;
};

export type AggregateEventPart = {
  __typename?: 'AggregateEventPart';
  _avg?: Maybe<EventPartAvgAggregateOutputType>;
  _count?: Maybe<EventPartCountAggregateOutputType>;
  _max?: Maybe<EventPartMaxAggregateOutputType>;
  _min?: Maybe<EventPartMinAggregateOutputType>;
  _sum?: Maybe<EventPartSumAggregateOutputType>;
};

export type AggregateEventType = {
  __typename?: 'AggregateEventType';
  _avg?: Maybe<EventTypeAvgAggregateOutputType>;
  _count?: Maybe<EventTypeCountAggregateOutputType>;
  _max?: Maybe<EventTypeMaxAggregateOutputType>;
  _min?: Maybe<EventTypeMinAggregateOutputType>;
  _sum?: Maybe<EventTypeSumAggregateOutputType>;
};

export type AggregateHiddenEvents = {
  __typename?: 'AggregateHiddenEvents';
  _avg?: Maybe<HiddenEventsAvgAggregateOutputType>;
  _count?: Maybe<HiddenEventsCountAggregateOutputType>;
  _max?: Maybe<HiddenEventsMaxAggregateOutputType>;
  _min?: Maybe<HiddenEventsMinAggregateOutputType>;
  _sum?: Maybe<HiddenEventsSumAggregateOutputType>;
};

export type AggregateHowHeardAboutEvent = {
  __typename?: 'AggregateHowHeardAboutEvent';
  _avg?: Maybe<HowHeardAboutEventAvgAggregateOutputType>;
  _count?: Maybe<HowHeardAboutEventCountAggregateOutputType>;
  _max?: Maybe<HowHeardAboutEventMaxAggregateOutputType>;
  _min?: Maybe<HowHeardAboutEventMinAggregateOutputType>;
  _sum?: Maybe<HowHeardAboutEventSumAggregateOutputType>;
};

export type AggregateInviterCouponProfit = {
  __typename?: 'AggregateInviterCouponProfit';
  _avg?: Maybe<InviterCouponProfitAvgAggregateOutputType>;
  _count?: Maybe<InviterCouponProfitCountAggregateOutputType>;
  _max?: Maybe<InviterCouponProfitMaxAggregateOutputType>;
  _min?: Maybe<InviterCouponProfitMinAggregateOutputType>;
  _sum?: Maybe<InviterCouponProfitSumAggregateOutputType>;
};

export type AggregateLanguage = {
  __typename?: 'AggregateLanguage';
  _avg?: Maybe<LanguageAvgAggregateOutputType>;
  _count?: Maybe<LanguageCountAggregateOutputType>;
  _max?: Maybe<LanguageMaxAggregateOutputType>;
  _min?: Maybe<LanguageMinAggregateOutputType>;
  _sum?: Maybe<LanguageSumAggregateOutputType>;
};

export type AggregateMemberNeedSettings = {
  __typename?: 'AggregateMemberNeedSettings';
  _avg?: Maybe<MemberNeedSettingsAvgAggregateOutputType>;
  _count?: Maybe<MemberNeedSettingsCountAggregateOutputType>;
  _max?: Maybe<MemberNeedSettingsMaxAggregateOutputType>;
  _min?: Maybe<MemberNeedSettingsMinAggregateOutputType>;
  _sum?: Maybe<MemberNeedSettingsSumAggregateOutputType>;
};

export type AggregateMemberNeeds = {
  __typename?: 'AggregateMemberNeeds';
  _avg?: Maybe<MemberNeedsAvgAggregateOutputType>;
  _count?: Maybe<MemberNeedsCountAggregateOutputType>;
  _max?: Maybe<MemberNeedsMaxAggregateOutputType>;
  _min?: Maybe<MemberNeedsMinAggregateOutputType>;
  _sum?: Maybe<MemberNeedsSumAggregateOutputType>;
};

export type AggregateMethodOfDelivery = {
  __typename?: 'AggregateMethodOfDelivery';
  _avg?: Maybe<MethodOfDeliveryAvgAggregateOutputType>;
  _count?: Maybe<MethodOfDeliveryCountAggregateOutputType>;
  _max?: Maybe<MethodOfDeliveryMaxAggregateOutputType>;
  _min?: Maybe<MethodOfDeliveryMinAggregateOutputType>;
  _sum?: Maybe<MethodOfDeliverySumAggregateOutputType>;
};

export type AggregateMethodOfTeachingType = {
  __typename?: 'AggregateMethodOfTeachingType';
  _avg?: Maybe<MethodOfTeachingTypeAvgAggregateOutputType>;
  _count?: Maybe<MethodOfTeachingTypeCountAggregateOutputType>;
  _max?: Maybe<MethodOfTeachingTypeMaxAggregateOutputType>;
  _min?: Maybe<MethodOfTeachingTypeMinAggregateOutputType>;
  _sum?: Maybe<MethodOfTeachingTypeSumAggregateOutputType>;
};

export type AggregateNotification = {
  __typename?: 'AggregateNotification';
  _avg?: Maybe<NotificationAvgAggregateOutputType>;
  _count?: Maybe<NotificationCountAggregateOutputType>;
  _max?: Maybe<NotificationMaxAggregateOutputType>;
  _min?: Maybe<NotificationMinAggregateOutputType>;
  _sum?: Maybe<NotificationSumAggregateOutputType>;
};

export type AggregatePaymentNetwork = {
  __typename?: 'AggregatePaymentNetwork';
  _avg?: Maybe<PaymentNetworkAvgAggregateOutputType>;
  _count?: Maybe<PaymentNetworkCountAggregateOutputType>;
  _max?: Maybe<PaymentNetworkMaxAggregateOutputType>;
  _min?: Maybe<PaymentNetworkMinAggregateOutputType>;
  _sum?: Maybe<PaymentNetworkSumAggregateOutputType>;
};

export type AggregatePaymentWay = {
  __typename?: 'AggregatePaymentWay';
  _avg?: Maybe<PaymentWayAvgAggregateOutputType>;
  _count?: Maybe<PaymentWayCountAggregateOutputType>;
  _max?: Maybe<PaymentWayMaxAggregateOutputType>;
  _min?: Maybe<PaymentWayMinAggregateOutputType>;
  _sum?: Maybe<PaymentWaySumAggregateOutputType>;
};

export type AggregatePricingPlan = {
  __typename?: 'AggregatePricingPlan';
  _avg?: Maybe<PricingPlanAvgAggregateOutputType>;
  _count?: Maybe<PricingPlanCountAggregateOutputType>;
  _max?: Maybe<PricingPlanMaxAggregateOutputType>;
  _min?: Maybe<PricingPlanMinAggregateOutputType>;
  _sum?: Maybe<PricingPlanSumAggregateOutputType>;
};

export type AggregatePricingPlanSpecialtyPrice = {
  __typename?: 'AggregatePricingPlanSpecialtyPrice';
  _avg?: Maybe<PricingPlanSpecialtyPriceAvgAggregateOutputType>;
  _count?: Maybe<PricingPlanSpecialtyPriceCountAggregateOutputType>;
  _max?: Maybe<PricingPlanSpecialtyPriceMaxAggregateOutputType>;
  _min?: Maybe<PricingPlanSpecialtyPriceMinAggregateOutputType>;
  _sum?: Maybe<PricingPlanSpecialtyPriceSumAggregateOutputType>;
};

export type AggregatePricingPlanType = {
  __typename?: 'AggregatePricingPlanType';
  _avg?: Maybe<PricingPlanTypeAvgAggregateOutputType>;
  _count?: Maybe<PricingPlanTypeCountAggregateOutputType>;
  _max?: Maybe<PricingPlanTypeMaxAggregateOutputType>;
  _min?: Maybe<PricingPlanTypeMinAggregateOutputType>;
  _sum?: Maybe<PricingPlanTypeSumAggregateOutputType>;
};

export type AggregateProfession = {
  __typename?: 'AggregateProfession';
  _avg?: Maybe<ProfessionAvgAggregateOutputType>;
  _count?: Maybe<ProfessionCountAggregateOutputType>;
  _max?: Maybe<ProfessionMaxAggregateOutputType>;
  _min?: Maybe<ProfessionMinAggregateOutputType>;
  _sum?: Maybe<ProfessionSumAggregateOutputType>;
};

export type AggregateProfessionalSkills = {
  __typename?: 'AggregateProfessionalSkills';
  _avg?: Maybe<ProfessionalSkillsAvgAggregateOutputType>;
  _count?: Maybe<ProfessionalSkillsCountAggregateOutputType>;
  _max?: Maybe<ProfessionalSkillsMaxAggregateOutputType>;
  _min?: Maybe<ProfessionalSkillsMinAggregateOutputType>;
  _sum?: Maybe<ProfessionalSkillsSumAggregateOutputType>;
};

export type AggregateQualification = {
  __typename?: 'AggregateQualification';
  _avg?: Maybe<QualificationAvgAggregateOutputType>;
  _count?: Maybe<QualificationCountAggregateOutputType>;
  _max?: Maybe<QualificationMaxAggregateOutputType>;
  _min?: Maybe<QualificationMinAggregateOutputType>;
  _sum?: Maybe<QualificationSumAggregateOutputType>;
};

export type AggregateQuiz = {
  __typename?: 'AggregateQuiz';
  _avg?: Maybe<QuizAvgAggregateOutputType>;
  _count?: Maybe<QuizCountAggregateOutputType>;
  _max?: Maybe<QuizMaxAggregateOutputType>;
  _min?: Maybe<QuizMinAggregateOutputType>;
  _sum?: Maybe<QuizSumAggregateOutputType>;
};

export type AggregateQuizQuestion = {
  __typename?: 'AggregateQuizQuestion';
  _avg?: Maybe<QuizQuestionAvgAggregateOutputType>;
  _count?: Maybe<QuizQuestionCountAggregateOutputType>;
  _max?: Maybe<QuizQuestionMaxAggregateOutputType>;
  _min?: Maybe<QuizQuestionMinAggregateOutputType>;
  _sum?: Maybe<QuizQuestionSumAggregateOutputType>;
};

export type AggregateQuizQuestionAnswer = {
  __typename?: 'AggregateQuizQuestionAnswer';
  _count?: Maybe<QuizQuestionAnswerCountAggregateOutputType>;
  _max?: Maybe<QuizQuestionAnswerMaxAggregateOutputType>;
  _min?: Maybe<QuizQuestionAnswerMinAggregateOutputType>;
};

export type AggregateQuizResult = {
  __typename?: 'AggregateQuizResult';
  _avg?: Maybe<QuizResultAvgAggregateOutputType>;
  _count?: Maybe<QuizResultCountAggregateOutputType>;
  _max?: Maybe<QuizResultMaxAggregateOutputType>;
  _min?: Maybe<QuizResultMinAggregateOutputType>;
  _sum?: Maybe<QuizResultSumAggregateOutputType>;
};

export type AggregateRank = {
  __typename?: 'AggregateRank';
  _avg?: Maybe<RankAvgAggregateOutputType>;
  _count?: Maybe<RankCountAggregateOutputType>;
  _max?: Maybe<RankMaxAggregateOutputType>;
  _min?: Maybe<RankMinAggregateOutputType>;
  _sum?: Maybe<RankSumAggregateOutputType>;
};

export type AggregateRole = {
  __typename?: 'AggregateRole';
  _avg?: Maybe<RoleAvgAggregateOutputType>;
  _count?: Maybe<RoleCountAggregateOutputType>;
  _max?: Maybe<RoleMaxAggregateOutputType>;
  _min?: Maybe<RoleMinAggregateOutputType>;
  _sum?: Maybe<RoleSumAggregateOutputType>;
};

export type AggregateScientificResearch = {
  __typename?: 'AggregateScientificResearch';
  _avg?: Maybe<ScientificResearchAvgAggregateOutputType>;
  _count?: Maybe<ScientificResearchCountAggregateOutputType>;
  _max?: Maybe<ScientificResearchMaxAggregateOutputType>;
  _min?: Maybe<ScientificResearchMinAggregateOutputType>;
  _sum?: Maybe<ScientificResearchSumAggregateOutputType>;
};

export type AggregateSession = {
  __typename?: 'AggregateSession';
  _avg?: Maybe<SessionAvgAggregateOutputType>;
  _count?: Maybe<SessionCountAggregateOutputType>;
  _max?: Maybe<SessionMaxAggregateOutputType>;
  _min?: Maybe<SessionMinAggregateOutputType>;
  _sum?: Maybe<SessionSumAggregateOutputType>;
};

export type AggregateSettings = {
  __typename?: 'AggregateSettings';
  _avg?: Maybe<SettingsAvgAggregateOutputType>;
  _count?: Maybe<SettingsCountAggregateOutputType>;
  _max?: Maybe<SettingsMaxAggregateOutputType>;
  _min?: Maybe<SettingsMinAggregateOutputType>;
  _sum?: Maybe<SettingsSumAggregateOutputType>;
};

export type AggregateSpecialty = {
  __typename?: 'AggregateSpecialty';
  _avg?: Maybe<SpecialtyAvgAggregateOutputType>;
  _count?: Maybe<SpecialtyCountAggregateOutputType>;
  _max?: Maybe<SpecialtyMaxAggregateOutputType>;
  _min?: Maybe<SpecialtyMinAggregateOutputType>;
  _sum?: Maybe<SpecialtySumAggregateOutputType>;
};

export type AggregateState = {
  __typename?: 'AggregateState';
  _avg?: Maybe<StateAvgAggregateOutputType>;
  _count?: Maybe<StateCountAggregateOutputType>;
  _max?: Maybe<StateMaxAggregateOutputType>;
  _min?: Maybe<StateMinAggregateOutputType>;
  _sum?: Maybe<StateSumAggregateOutputType>;
};

export type AggregateTemplate = {
  __typename?: 'AggregateTemplate';
  _avg?: Maybe<TemplateAvgAggregateOutputType>;
  _count?: Maybe<TemplateCountAggregateOutputType>;
  _max?: Maybe<TemplateMaxAggregateOutputType>;
  _min?: Maybe<TemplateMinAggregateOutputType>;
  _sum?: Maybe<TemplateSumAggregateOutputType>;
};

export type AggregateTraineeEvent = {
  __typename?: 'AggregateTraineeEvent';
  _avg?: Maybe<TraineeEventAvgAggregateOutputType>;
  _count?: Maybe<TraineeEventCountAggregateOutputType>;
  _max?: Maybe<TraineeEventMaxAggregateOutputType>;
  _min?: Maybe<TraineeEventMinAggregateOutputType>;
  _sum?: Maybe<TraineeEventSumAggregateOutputType>;
};

export type AggregateTraineeEventDayAttendance = {
  __typename?: 'AggregateTraineeEventDayAttendance';
  _avg?: Maybe<TraineeEventDayAttendanceAvgAggregateOutputType>;
  _count?: Maybe<TraineeEventDayAttendanceCountAggregateOutputType>;
  _max?: Maybe<TraineeEventDayAttendanceMaxAggregateOutputType>;
  _min?: Maybe<TraineeEventDayAttendanceMinAggregateOutputType>;
  _sum?: Maybe<TraineeEventDayAttendanceSumAggregateOutputType>;
};

export type AggregateTraineeEventGroup = {
  __typename?: 'AggregateTraineeEventGroup';
  _avg?: Maybe<TraineeEventGroupAvgAggregateOutputType>;
  _count?: Maybe<TraineeEventGroupCountAggregateOutputType>;
  _max?: Maybe<TraineeEventGroupMaxAggregateOutputType>;
  _min?: Maybe<TraineeEventGroupMinAggregateOutputType>;
  _sum?: Maybe<TraineeEventGroupSumAggregateOutputType>;
};

export type AggregateTraineeEventPart = {
  __typename?: 'AggregateTraineeEventPart';
  _avg?: Maybe<TraineeEventPartAvgAggregateOutputType>;
  _count?: Maybe<TraineeEventPartCountAggregateOutputType>;
  _max?: Maybe<TraineeEventPartMaxAggregateOutputType>;
  _min?: Maybe<TraineeEventPartMinAggregateOutputType>;
  _sum?: Maybe<TraineeEventPartSumAggregateOutputType>;
};

export type AggregateTraineeEventReview = {
  __typename?: 'AggregateTraineeEventReview';
  _avg?: Maybe<TraineeEventReviewAvgAggregateOutputType>;
  _count?: Maybe<TraineeEventReviewCountAggregateOutputType>;
  _max?: Maybe<TraineeEventReviewMaxAggregateOutputType>;
  _min?: Maybe<TraineeEventReviewMinAggregateOutputType>;
  _sum?: Maybe<TraineeEventReviewSumAggregateOutputType>;
};

export type AggregateTraineeEventReviewChoice = {
  __typename?: 'AggregateTraineeEventReviewChoice';
  _avg?: Maybe<TraineeEventReviewChoiceAvgAggregateOutputType>;
  _count?: Maybe<TraineeEventReviewChoiceCountAggregateOutputType>;
  _max?: Maybe<TraineeEventReviewChoiceMaxAggregateOutputType>;
  _min?: Maybe<TraineeEventReviewChoiceMinAggregateOutputType>;
  _sum?: Maybe<TraineeEventReviewChoiceSumAggregateOutputType>;
};

export type AggregateTraineeEventStudyMaterialAttendance = {
  __typename?: 'AggregateTraineeEventStudyMaterialAttendance';
  _avg?: Maybe<TraineeEventStudyMaterialAttendanceAvgAggregateOutputType>;
  _count?: Maybe<TraineeEventStudyMaterialAttendanceCountAggregateOutputType>;
  _max?: Maybe<TraineeEventStudyMaterialAttendanceMaxAggregateOutputType>;
  _min?: Maybe<TraineeEventStudyMaterialAttendanceMinAggregateOutputType>;
  _sum?: Maybe<TraineeEventStudyMaterialAttendanceSumAggregateOutputType>;
};

export type AggregateTraineeEventZoomRegistration = {
  __typename?: 'AggregateTraineeEventZoomRegistration';
  _avg?: Maybe<TraineeEventZoomRegistrationAvgAggregateOutputType>;
  _count?: Maybe<TraineeEventZoomRegistrationCountAggregateOutputType>;
  _max?: Maybe<TraineeEventZoomRegistrationMaxAggregateOutputType>;
  _min?: Maybe<TraineeEventZoomRegistrationMinAggregateOutputType>;
  _sum?: Maybe<TraineeEventZoomRegistrationSumAggregateOutputType>;
};

export type AggregateTraineeTrainerReview = {
  __typename?: 'AggregateTraineeTrainerReview';
  _avg?: Maybe<TraineeTrainerReviewAvgAggregateOutputType>;
  _count?: Maybe<TraineeTrainerReviewCountAggregateOutputType>;
  _max?: Maybe<TraineeTrainerReviewMaxAggregateOutputType>;
  _min?: Maybe<TraineeTrainerReviewMinAggregateOutputType>;
  _sum?: Maybe<TraineeTrainerReviewSumAggregateOutputType>;
};

export type AggregateTraineeTrainerReviewChoice = {
  __typename?: 'AggregateTraineeTrainerReviewChoice';
  _avg?: Maybe<TraineeTrainerReviewChoiceAvgAggregateOutputType>;
  _count?: Maybe<TraineeTrainerReviewChoiceCountAggregateOutputType>;
  _max?: Maybe<TraineeTrainerReviewChoiceMaxAggregateOutputType>;
  _min?: Maybe<TraineeTrainerReviewChoiceMinAggregateOutputType>;
  _sum?: Maybe<TraineeTrainerReviewChoiceSumAggregateOutputType>;
};

export type AggregateTrainerEvent = {
  __typename?: 'AggregateTrainerEvent';
  _avg?: Maybe<TrainerEventAvgAggregateOutputType>;
  _count?: Maybe<TrainerEventCountAggregateOutputType>;
  _max?: Maybe<TrainerEventMaxAggregateOutputType>;
  _min?: Maybe<TrainerEventMinAggregateOutputType>;
  _sum?: Maybe<TrainerEventSumAggregateOutputType>;
};

export type AggregateTrainerEventDayLesson = {
  __typename?: 'AggregateTrainerEventDayLesson';
  _avg?: Maybe<TrainerEventDayLessonAvgAggregateOutputType>;
  _count?: Maybe<TrainerEventDayLessonCountAggregateOutputType>;
  _max?: Maybe<TrainerEventDayLessonMaxAggregateOutputType>;
  _min?: Maybe<TrainerEventDayLessonMinAggregateOutputType>;
  _sum?: Maybe<TrainerEventDayLessonSumAggregateOutputType>;
};

export type AggregateTrainerEventDayLessonType = {
  __typename?: 'AggregateTrainerEventDayLessonType';
  _avg?: Maybe<TrainerEventDayLessonTypeAvgAggregateOutputType>;
  _count?: Maybe<TrainerEventDayLessonTypeCountAggregateOutputType>;
  _max?: Maybe<TrainerEventDayLessonTypeMaxAggregateOutputType>;
  _min?: Maybe<TrainerEventDayLessonTypeMinAggregateOutputType>;
  _sum?: Maybe<TrainerEventDayLessonTypeSumAggregateOutputType>;
};

export type AggregateTrainerEventDayTimeSlot = {
  __typename?: 'AggregateTrainerEventDayTimeSlot';
  _avg?: Maybe<TrainerEventDayTimeSlotAvgAggregateOutputType>;
  _count?: Maybe<TrainerEventDayTimeSlotCountAggregateOutputType>;
  _max?: Maybe<TrainerEventDayTimeSlotMaxAggregateOutputType>;
  _min?: Maybe<TrainerEventDayTimeSlotMinAggregateOutputType>;
  _sum?: Maybe<TrainerEventDayTimeSlotSumAggregateOutputType>;
};

export type AggregateTrainerEventStudyMaterial = {
  __typename?: 'AggregateTrainerEventStudyMaterial';
  _avg?: Maybe<TrainerEventStudyMaterialAvgAggregateOutputType>;
  _count?: Maybe<TrainerEventStudyMaterialCountAggregateOutputType>;
  _max?: Maybe<TrainerEventStudyMaterialMaxAggregateOutputType>;
  _min?: Maybe<TrainerEventStudyMaterialMinAggregateOutputType>;
  _sum?: Maybe<TrainerEventStudyMaterialSumAggregateOutputType>;
};

export type AggregateTrainerEventStudyMaterialGroup = {
  __typename?: 'AggregateTrainerEventStudyMaterialGroup';
  _avg?: Maybe<TrainerEventStudyMaterialGroupAvgAggregateOutputType>;
  _count?: Maybe<TrainerEventStudyMaterialGroupCountAggregateOutputType>;
  _max?: Maybe<TrainerEventStudyMaterialGroupMaxAggregateOutputType>;
  _min?: Maybe<TrainerEventStudyMaterialGroupMinAggregateOutputType>;
  _sum?: Maybe<TrainerEventStudyMaterialGroupSumAggregateOutputType>;
};

export type AggregateTrainingExperience = {
  __typename?: 'AggregateTrainingExperience';
  _avg?: Maybe<TrainingExperienceAvgAggregateOutputType>;
  _count?: Maybe<TrainingExperienceCountAggregateOutputType>;
  _max?: Maybe<TrainingExperienceMaxAggregateOutputType>;
  _min?: Maybe<TrainingExperienceMinAggregateOutputType>;
  _sum?: Maybe<TrainingExperienceSumAggregateOutputType>;
};

export type AggregateTransition = {
  __typename?: 'AggregateTransition';
  _avg?: Maybe<TransitionAvgAggregateOutputType>;
  _count?: Maybe<TransitionCountAggregateOutputType>;
  _max?: Maybe<TransitionMaxAggregateOutputType>;
  _min?: Maybe<TransitionMinAggregateOutputType>;
  _sum?: Maybe<TransitionSumAggregateOutputType>;
};

export type AggregateTransitionPurpose = {
  __typename?: 'AggregateTransitionPurpose';
  _avg?: Maybe<TransitionPurposeAvgAggregateOutputType>;
  _count?: Maybe<TransitionPurposeCountAggregateOutputType>;
  _max?: Maybe<TransitionPurposeMaxAggregateOutputType>;
  _min?: Maybe<TransitionPurposeMinAggregateOutputType>;
  _sum?: Maybe<TransitionPurposeSumAggregateOutputType>;
};

export type AggregateTransitionStatusType = {
  __typename?: 'AggregateTransitionStatusType';
  _avg?: Maybe<TransitionStatusTypeAvgAggregateOutputType>;
  _count?: Maybe<TransitionStatusTypeCountAggregateOutputType>;
  _max?: Maybe<TransitionStatusTypeMaxAggregateOutputType>;
  _min?: Maybe<TransitionStatusTypeMinAggregateOutputType>;
  _sum?: Maybe<TransitionStatusTypeSumAggregateOutputType>;
};

export type AggregateTransitionType = {
  __typename?: 'AggregateTransitionType';
  _avg?: Maybe<TransitionTypeAvgAggregateOutputType>;
  _count?: Maybe<TransitionTypeCountAggregateOutputType>;
  _max?: Maybe<TransitionTypeMaxAggregateOutputType>;
  _min?: Maybe<TransitionTypeMinAggregateOutputType>;
  _sum?: Maybe<TransitionTypeSumAggregateOutputType>;
};

export type AggregateUser = {
  __typename?: 'AggregateUser';
  _avg?: Maybe<UserAvgAggregateOutputType>;
  _count?: Maybe<UserCountAggregateOutputType>;
  _max?: Maybe<UserMaxAggregateOutputType>;
  _min?: Maybe<UserMinAggregateOutputType>;
  _sum?: Maybe<UserSumAggregateOutputType>;
};

export type AggregateVerificationToken = {
  __typename?: 'AggregateVerificationToken';
  _count?: Maybe<VerificationTokenCountAggregateOutputType>;
  _max?: Maybe<VerificationTokenMaxAggregateOutputType>;
  _min?: Maybe<VerificationTokenMinAggregateOutputType>;
};

export type AggregateZohoEmail = {
  __typename?: 'AggregateZohoEmail';
  _avg?: Maybe<ZohoEmailAvgAggregateOutputType>;
  _count?: Maybe<ZohoEmailCountAggregateOutputType>;
  _max?: Maybe<ZohoEmailMaxAggregateOutputType>;
  _min?: Maybe<ZohoEmailMinAggregateOutputType>;
  _sum?: Maybe<ZohoEmailSumAggregateOutputType>;
};

export type AggregateZoomMeeting = {
  __typename?: 'AggregateZoomMeeting';
  _avg?: Maybe<ZoomMeetingAvgAggregateOutputType>;
  _count?: Maybe<ZoomMeetingCountAggregateOutputType>;
  _max?: Maybe<ZoomMeetingMaxAggregateOutputType>;
  _min?: Maybe<ZoomMeetingMinAggregateOutputType>;
  _sum?: Maybe<ZoomMeetingSumAggregateOutputType>;
};

export type AnalyticsInputType = {
  ref?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
};

export enum ApplicationState {
  Approved = 'approved',
  Declined = 'declined',
  Pending = 'pending'
}

export type ApplyCouponToBookingInputType = {
  bookingId: Scalars['Int'];
  coupon: Scalars['String'];
};

export type AutomatedEmails = {
  __typename?: 'AutomatedEmails';
  days: Scalars['Int'];
  forRegistrans: DynamicEmailForRegistrans;
  id: Scalars['Int'];
  message?: Maybe<Scalars['String']>;
  notification?: Maybe<Notification>;
  notificationId?: Maybe<Scalars['Int']>;
  sendTo: DynamicEmailSendTo;
  template?: Maybe<Template>;
  templateId?: Maybe<Scalars['Int']>;
  time: DynamicEmailTime;
  title: Scalars['String'];
  whenEventHasClasses: DynamicwhenEventHasClasses;
};

export type AutomatedEmailsAvgAggregateOutputType = {
  __typename?: 'AutomatedEmailsAvgAggregateOutputType';
  days?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  notificationId?: Maybe<Scalars['Float']>;
  templateId?: Maybe<Scalars['Float']>;
};

export type AutomatedEmailsAvgOrderByAggregateInput = {
  days?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  notificationId?: InputMaybe<SortOrder>;
  templateId?: InputMaybe<SortOrder>;
};

export type AutomatedEmailsCountAggregateOutputType = {
  __typename?: 'AutomatedEmailsCountAggregateOutputType';
  _all: Scalars['Int'];
  days: Scalars['Int'];
  forRegistrans: Scalars['Int'];
  id: Scalars['Int'];
  message: Scalars['Int'];
  notificationId: Scalars['Int'];
  sendTo: Scalars['Int'];
  templateId: Scalars['Int'];
  time: Scalars['Int'];
  title: Scalars['Int'];
  whenEventHasClasses: Scalars['Int'];
};

export type AutomatedEmailsCountOrderByAggregateInput = {
  days?: InputMaybe<SortOrder>;
  forRegistrans?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  notificationId?: InputMaybe<SortOrder>;
  sendTo?: InputMaybe<SortOrder>;
  templateId?: InputMaybe<SortOrder>;
  time?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  whenEventHasClasses?: InputMaybe<SortOrder>;
};

export type AutomatedEmailsCreateInput = {
  days: Scalars['Int'];
  forRegistrans: DynamicEmailForRegistrans;
  message?: InputMaybe<Scalars['String']>;
  notification?: InputMaybe<NotificationCreateNestedOneWithoutAutomatedEmailsInput>;
  sendTo: DynamicEmailSendTo;
  template?: InputMaybe<TemplateCreateNestedOneWithoutAutomatedEmailsInput>;
  time: DynamicEmailTime;
  title: Scalars['String'];
  whenEventHasClasses: DynamicwhenEventHasClasses;
};

export type AutomatedEmailsCreateManyInput = {
  days: Scalars['Int'];
  forRegistrans: DynamicEmailForRegistrans;
  id?: InputMaybe<Scalars['Int']>;
  message?: InputMaybe<Scalars['String']>;
  notificationId?: InputMaybe<Scalars['Int']>;
  sendTo: DynamicEmailSendTo;
  templateId?: InputMaybe<Scalars['Int']>;
  time: DynamicEmailTime;
  title: Scalars['String'];
  whenEventHasClasses: DynamicwhenEventHasClasses;
};

export type AutomatedEmailsCreateManyNotificationInput = {
  days: Scalars['Int'];
  forRegistrans: DynamicEmailForRegistrans;
  id?: InputMaybe<Scalars['Int']>;
  message?: InputMaybe<Scalars['String']>;
  sendTo: DynamicEmailSendTo;
  templateId?: InputMaybe<Scalars['Int']>;
  time: DynamicEmailTime;
  title: Scalars['String'];
  whenEventHasClasses: DynamicwhenEventHasClasses;
};

export type AutomatedEmailsCreateManyNotificationInputEnvelope = {
  data: AutomatedEmailsCreateManyNotificationInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AutomatedEmailsCreateManyTemplateInput = {
  days: Scalars['Int'];
  forRegistrans: DynamicEmailForRegistrans;
  id?: InputMaybe<Scalars['Int']>;
  message?: InputMaybe<Scalars['String']>;
  notificationId?: InputMaybe<Scalars['Int']>;
  sendTo: DynamicEmailSendTo;
  time: DynamicEmailTime;
  title: Scalars['String'];
  whenEventHasClasses: DynamicwhenEventHasClasses;
};

export type AutomatedEmailsCreateManyTemplateInputEnvelope = {
  data: AutomatedEmailsCreateManyTemplateInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AutomatedEmailsCreateNestedManyWithoutNotificationInput = {
  connect?: InputMaybe<Array<InputMaybe<AutomatedEmailsWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AutomatedEmailsCreateOrConnectWithoutNotificationInput>>>;
  create?: InputMaybe<Array<InputMaybe<AutomatedEmailsCreateWithoutNotificationInput>>>;
  createMany?: InputMaybe<AutomatedEmailsCreateManyNotificationInputEnvelope>;
};

export type AutomatedEmailsCreateNestedManyWithoutTemplateInput = {
  connect?: InputMaybe<Array<InputMaybe<AutomatedEmailsWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AutomatedEmailsCreateOrConnectWithoutTemplateInput>>>;
  create?: InputMaybe<Array<InputMaybe<AutomatedEmailsCreateWithoutTemplateInput>>>;
  createMany?: InputMaybe<AutomatedEmailsCreateManyTemplateInputEnvelope>;
};

export type AutomatedEmailsCreateOrConnectWithoutNotificationInput = {
  create: AutomatedEmailsUncheckedCreateWithoutNotificationInput;
  where: AutomatedEmailsWhereUniqueInput;
};

export type AutomatedEmailsCreateOrConnectWithoutTemplateInput = {
  create: AutomatedEmailsUncheckedCreateWithoutTemplateInput;
  where: AutomatedEmailsWhereUniqueInput;
};

export type AutomatedEmailsCreateWithoutNotificationInput = {
  days: Scalars['Int'];
  forRegistrans: DynamicEmailForRegistrans;
  message?: InputMaybe<Scalars['String']>;
  sendTo: DynamicEmailSendTo;
  template?: InputMaybe<TemplateCreateNestedOneWithoutAutomatedEmailsInput>;
  time: DynamicEmailTime;
  title: Scalars['String'];
  whenEventHasClasses: DynamicwhenEventHasClasses;
};

export type AutomatedEmailsCreateWithoutTemplateInput = {
  days: Scalars['Int'];
  forRegistrans: DynamicEmailForRegistrans;
  message?: InputMaybe<Scalars['String']>;
  notification?: InputMaybe<NotificationCreateNestedOneWithoutAutomatedEmailsInput>;
  sendTo: DynamicEmailSendTo;
  time: DynamicEmailTime;
  title: Scalars['String'];
  whenEventHasClasses: DynamicwhenEventHasClasses;
};

export type AutomatedEmailsListRelationFilter = {
  every?: InputMaybe<AutomatedEmailsWhereInput>;
  none?: InputMaybe<AutomatedEmailsWhereInput>;
  some?: InputMaybe<AutomatedEmailsWhereInput>;
};

export type AutomatedEmailsMaxAggregateOutputType = {
  __typename?: 'AutomatedEmailsMaxAggregateOutputType';
  days?: Maybe<Scalars['Int']>;
  forRegistrans?: Maybe<DynamicEmailForRegistrans>;
  id?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  notificationId?: Maybe<Scalars['Int']>;
  sendTo?: Maybe<DynamicEmailSendTo>;
  templateId?: Maybe<Scalars['Int']>;
  time?: Maybe<DynamicEmailTime>;
  title?: Maybe<Scalars['String']>;
  whenEventHasClasses?: Maybe<DynamicwhenEventHasClasses>;
};

export type AutomatedEmailsMaxOrderByAggregateInput = {
  days?: InputMaybe<SortOrder>;
  forRegistrans?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  notificationId?: InputMaybe<SortOrder>;
  sendTo?: InputMaybe<SortOrder>;
  templateId?: InputMaybe<SortOrder>;
  time?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  whenEventHasClasses?: InputMaybe<SortOrder>;
};

export type AutomatedEmailsMinAggregateOutputType = {
  __typename?: 'AutomatedEmailsMinAggregateOutputType';
  days?: Maybe<Scalars['Int']>;
  forRegistrans?: Maybe<DynamicEmailForRegistrans>;
  id?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  notificationId?: Maybe<Scalars['Int']>;
  sendTo?: Maybe<DynamicEmailSendTo>;
  templateId?: Maybe<Scalars['Int']>;
  time?: Maybe<DynamicEmailTime>;
  title?: Maybe<Scalars['String']>;
  whenEventHasClasses?: Maybe<DynamicwhenEventHasClasses>;
};

export type AutomatedEmailsMinOrderByAggregateInput = {
  days?: InputMaybe<SortOrder>;
  forRegistrans?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  notificationId?: InputMaybe<SortOrder>;
  sendTo?: InputMaybe<SortOrder>;
  templateId?: InputMaybe<SortOrder>;
  time?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  whenEventHasClasses?: InputMaybe<SortOrder>;
};

export type AutomatedEmailsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AutomatedEmailsOrderByWithAggregationInput = {
  _avg?: InputMaybe<AutomatedEmailsAvgOrderByAggregateInput>;
  _count?: InputMaybe<AutomatedEmailsCountOrderByAggregateInput>;
  _max?: InputMaybe<AutomatedEmailsMaxOrderByAggregateInput>;
  _min?: InputMaybe<AutomatedEmailsMinOrderByAggregateInput>;
  _sum?: InputMaybe<AutomatedEmailsSumOrderByAggregateInput>;
  days?: InputMaybe<SortOrder>;
  forRegistrans?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  notificationId?: InputMaybe<SortOrder>;
  sendTo?: InputMaybe<SortOrder>;
  templateId?: InputMaybe<SortOrder>;
  time?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  whenEventHasClasses?: InputMaybe<SortOrder>;
};

export type AutomatedEmailsOrderByWithRelationInput = {
  days?: InputMaybe<SortOrder>;
  forRegistrans?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  notification?: InputMaybe<NotificationOrderByWithRelationInput>;
  notificationId?: InputMaybe<SortOrder>;
  sendTo?: InputMaybe<SortOrder>;
  template?: InputMaybe<TemplateOrderByWithRelationInput>;
  templateId?: InputMaybe<SortOrder>;
  time?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  whenEventHasClasses?: InputMaybe<SortOrder>;
};

export enum AutomatedEmailsScalarFieldEnum {
  Days = 'days',
  ForRegistrans = 'forRegistrans',
  Id = 'id',
  Message = 'message',
  NotificationId = 'notificationId',
  SendTo = 'sendTo',
  TemplateId = 'templateId',
  Time = 'time',
  Title = 'title',
  WhenEventHasClasses = 'whenEventHasClasses'
}

export type AutomatedEmailsScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<AutomatedEmailsScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<AutomatedEmailsScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<AutomatedEmailsScalarWhereInput>>>;
  days?: InputMaybe<IntFilter>;
  forRegistrans?: InputMaybe<EnumDynamicEmailForRegistransFilter>;
  id?: InputMaybe<IntFilter>;
  message?: InputMaybe<StringNullableFilter>;
  notificationId?: InputMaybe<IntNullableFilter>;
  sendTo?: InputMaybe<EnumDynamicEmailSendToFilter>;
  templateId?: InputMaybe<IntNullableFilter>;
  time?: InputMaybe<EnumDynamicEmailTimeFilter>;
  title?: InputMaybe<StringFilter>;
  whenEventHasClasses?: InputMaybe<EnumDynamicwhenEventHasClassesFilter>;
};

export type AutomatedEmailsScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<AutomatedEmailsScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<AutomatedEmailsScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<AutomatedEmailsScalarWhereWithAggregatesInput>>>;
  days?: InputMaybe<IntWithAggregatesFilter>;
  forRegistrans?: InputMaybe<EnumDynamicEmailForRegistransWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  message?: InputMaybe<StringNullableWithAggregatesFilter>;
  notificationId?: InputMaybe<IntNullableWithAggregatesFilter>;
  sendTo?: InputMaybe<EnumDynamicEmailSendToWithAggregatesFilter>;
  templateId?: InputMaybe<IntNullableWithAggregatesFilter>;
  time?: InputMaybe<EnumDynamicEmailTimeWithAggregatesFilter>;
  title?: InputMaybe<StringWithAggregatesFilter>;
  whenEventHasClasses?: InputMaybe<EnumDynamicwhenEventHasClassesWithAggregatesFilter>;
};

export type AutomatedEmailsSumAggregateOutputType = {
  __typename?: 'AutomatedEmailsSumAggregateOutputType';
  days?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  notificationId?: Maybe<Scalars['Int']>;
  templateId?: Maybe<Scalars['Int']>;
};

export type AutomatedEmailsSumOrderByAggregateInput = {
  days?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  notificationId?: InputMaybe<SortOrder>;
  templateId?: InputMaybe<SortOrder>;
};

export type AutomatedEmailsUncheckedCreateInput = {
  days: Scalars['Int'];
  forRegistrans: DynamicEmailForRegistrans;
  id?: InputMaybe<Scalars['Int']>;
  message?: InputMaybe<Scalars['String']>;
  notificationId?: InputMaybe<Scalars['Int']>;
  sendTo: DynamicEmailSendTo;
  templateId?: InputMaybe<Scalars['Int']>;
  time: DynamicEmailTime;
  title: Scalars['String'];
  whenEventHasClasses: DynamicwhenEventHasClasses;
};

export type AutomatedEmailsUncheckedCreateNestedManyWithoutNotificationInput = {
  connect?: InputMaybe<Array<InputMaybe<AutomatedEmailsWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AutomatedEmailsCreateOrConnectWithoutNotificationInput>>>;
  create?: InputMaybe<Array<InputMaybe<AutomatedEmailsCreateWithoutNotificationInput>>>;
  createMany?: InputMaybe<AutomatedEmailsCreateManyNotificationInputEnvelope>;
};

export type AutomatedEmailsUncheckedCreateNestedManyWithoutTemplateInput = {
  connect?: InputMaybe<Array<InputMaybe<AutomatedEmailsWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AutomatedEmailsCreateOrConnectWithoutTemplateInput>>>;
  create?: InputMaybe<Array<InputMaybe<AutomatedEmailsCreateWithoutTemplateInput>>>;
  createMany?: InputMaybe<AutomatedEmailsCreateManyTemplateInputEnvelope>;
};

export type AutomatedEmailsUncheckedCreateWithoutNotificationInput = {
  days: Scalars['Int'];
  forRegistrans: DynamicEmailForRegistrans;
  id?: InputMaybe<Scalars['Int']>;
  message?: InputMaybe<Scalars['String']>;
  sendTo: DynamicEmailSendTo;
  templateId?: InputMaybe<Scalars['Int']>;
  time: DynamicEmailTime;
  title: Scalars['String'];
  whenEventHasClasses: DynamicwhenEventHasClasses;
};

export type AutomatedEmailsUncheckedCreateWithoutTemplateInput = {
  days: Scalars['Int'];
  forRegistrans: DynamicEmailForRegistrans;
  id?: InputMaybe<Scalars['Int']>;
  message?: InputMaybe<Scalars['String']>;
  notificationId?: InputMaybe<Scalars['Int']>;
  sendTo: DynamicEmailSendTo;
  time: DynamicEmailTime;
  title: Scalars['String'];
  whenEventHasClasses: DynamicwhenEventHasClasses;
};

export type AutomatedEmailsUncheckedUpdateInput = {
  days?: InputMaybe<IntFieldUpdateOperationsInput>;
  forRegistrans?: InputMaybe<EnumDynamicEmailForRegistransFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sendTo?: InputMaybe<EnumDynamicEmailSendToFieldUpdateOperationsInput>;
  templateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  time?: InputMaybe<EnumDynamicEmailTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  whenEventHasClasses?: InputMaybe<EnumDynamicwhenEventHasClassesFieldUpdateOperationsInput>;
};

export type AutomatedEmailsUncheckedUpdateManyInput = {
  days?: InputMaybe<IntFieldUpdateOperationsInput>;
  forRegistrans?: InputMaybe<EnumDynamicEmailForRegistransFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sendTo?: InputMaybe<EnumDynamicEmailSendToFieldUpdateOperationsInput>;
  templateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  time?: InputMaybe<EnumDynamicEmailTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  whenEventHasClasses?: InputMaybe<EnumDynamicwhenEventHasClassesFieldUpdateOperationsInput>;
};

export type AutomatedEmailsUncheckedUpdateManyWithoutAutomatedEmailsInput = {
  days?: InputMaybe<IntFieldUpdateOperationsInput>;
  forRegistrans?: InputMaybe<EnumDynamicEmailForRegistransFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sendTo?: InputMaybe<EnumDynamicEmailSendToFieldUpdateOperationsInput>;
  time?: InputMaybe<EnumDynamicEmailTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  whenEventHasClasses?: InputMaybe<EnumDynamicwhenEventHasClassesFieldUpdateOperationsInput>;
};

export type AutomatedEmailsUncheckedUpdateManyWithoutNotificationInput = {
  connect?: InputMaybe<Array<InputMaybe<AutomatedEmailsWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AutomatedEmailsCreateOrConnectWithoutNotificationInput>>>;
  create?: InputMaybe<Array<InputMaybe<AutomatedEmailsCreateWithoutNotificationInput>>>;
  createMany?: InputMaybe<AutomatedEmailsCreateManyNotificationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<AutomatedEmailsWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<AutomatedEmailsScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<AutomatedEmailsWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<AutomatedEmailsWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<AutomatedEmailsUpdateWithWhereUniqueWithoutNotificationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<AutomatedEmailsUpdateManyWithWhereWithoutNotificationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<AutomatedEmailsUpsertWithWhereUniqueWithoutNotificationInput>>>;
};

export type AutomatedEmailsUncheckedUpdateManyWithoutTemplateInput = {
  connect?: InputMaybe<Array<InputMaybe<AutomatedEmailsWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AutomatedEmailsCreateOrConnectWithoutTemplateInput>>>;
  create?: InputMaybe<Array<InputMaybe<AutomatedEmailsCreateWithoutTemplateInput>>>;
  createMany?: InputMaybe<AutomatedEmailsCreateManyTemplateInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<AutomatedEmailsWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<AutomatedEmailsScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<AutomatedEmailsWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<AutomatedEmailsWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<AutomatedEmailsUpdateWithWhereUniqueWithoutTemplateInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<AutomatedEmailsUpdateManyWithWhereWithoutTemplateInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<AutomatedEmailsUpsertWithWhereUniqueWithoutTemplateInput>>>;
};

export type AutomatedEmailsUncheckedUpdateWithoutNotificationInput = {
  days?: InputMaybe<IntFieldUpdateOperationsInput>;
  forRegistrans?: InputMaybe<EnumDynamicEmailForRegistransFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sendTo?: InputMaybe<EnumDynamicEmailSendToFieldUpdateOperationsInput>;
  templateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  time?: InputMaybe<EnumDynamicEmailTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  whenEventHasClasses?: InputMaybe<EnumDynamicwhenEventHasClassesFieldUpdateOperationsInput>;
};

export type AutomatedEmailsUncheckedUpdateWithoutTemplateInput = {
  days?: InputMaybe<IntFieldUpdateOperationsInput>;
  forRegistrans?: InputMaybe<EnumDynamicEmailForRegistransFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sendTo?: InputMaybe<EnumDynamicEmailSendToFieldUpdateOperationsInput>;
  time?: InputMaybe<EnumDynamicEmailTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  whenEventHasClasses?: InputMaybe<EnumDynamicwhenEventHasClassesFieldUpdateOperationsInput>;
};

export type AutomatedEmailsUpdateInput = {
  days?: InputMaybe<IntFieldUpdateOperationsInput>;
  forRegistrans?: InputMaybe<EnumDynamicEmailForRegistransFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notification?: InputMaybe<NotificationUpdateOneWithoutAutomatedEmailsInput>;
  sendTo?: InputMaybe<EnumDynamicEmailSendToFieldUpdateOperationsInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutAutomatedEmailsInput>;
  time?: InputMaybe<EnumDynamicEmailTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  whenEventHasClasses?: InputMaybe<EnumDynamicwhenEventHasClassesFieldUpdateOperationsInput>;
};

export type AutomatedEmailsUpdateManyMutationInput = {
  days?: InputMaybe<IntFieldUpdateOperationsInput>;
  forRegistrans?: InputMaybe<EnumDynamicEmailForRegistransFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sendTo?: InputMaybe<EnumDynamicEmailSendToFieldUpdateOperationsInput>;
  time?: InputMaybe<EnumDynamicEmailTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  whenEventHasClasses?: InputMaybe<EnumDynamicwhenEventHasClassesFieldUpdateOperationsInput>;
};

export type AutomatedEmailsUpdateManyWithWhereWithoutNotificationInput = {
  data: AutomatedEmailsUncheckedUpdateManyWithoutAutomatedEmailsInput;
  where: AutomatedEmailsScalarWhereInput;
};

export type AutomatedEmailsUpdateManyWithWhereWithoutTemplateInput = {
  data: AutomatedEmailsUncheckedUpdateManyWithoutAutomatedEmailsInput;
  where: AutomatedEmailsScalarWhereInput;
};

export type AutomatedEmailsUpdateManyWithoutNotificationInput = {
  connect?: InputMaybe<Array<InputMaybe<AutomatedEmailsWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AutomatedEmailsCreateOrConnectWithoutNotificationInput>>>;
  create?: InputMaybe<Array<InputMaybe<AutomatedEmailsCreateWithoutNotificationInput>>>;
  createMany?: InputMaybe<AutomatedEmailsCreateManyNotificationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<AutomatedEmailsWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<AutomatedEmailsScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<AutomatedEmailsWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<AutomatedEmailsWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<AutomatedEmailsUpdateWithWhereUniqueWithoutNotificationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<AutomatedEmailsUpdateManyWithWhereWithoutNotificationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<AutomatedEmailsUpsertWithWhereUniqueWithoutNotificationInput>>>;
};

export type AutomatedEmailsUpdateManyWithoutTemplateInput = {
  connect?: InputMaybe<Array<InputMaybe<AutomatedEmailsWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<AutomatedEmailsCreateOrConnectWithoutTemplateInput>>>;
  create?: InputMaybe<Array<InputMaybe<AutomatedEmailsCreateWithoutTemplateInput>>>;
  createMany?: InputMaybe<AutomatedEmailsCreateManyTemplateInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<AutomatedEmailsWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<AutomatedEmailsScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<AutomatedEmailsWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<AutomatedEmailsWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<AutomatedEmailsUpdateWithWhereUniqueWithoutTemplateInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<AutomatedEmailsUpdateManyWithWhereWithoutTemplateInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<AutomatedEmailsUpsertWithWhereUniqueWithoutTemplateInput>>>;
};

export type AutomatedEmailsUpdateWithWhereUniqueWithoutNotificationInput = {
  data: AutomatedEmailsUncheckedUpdateWithoutNotificationInput;
  where: AutomatedEmailsWhereUniqueInput;
};

export type AutomatedEmailsUpdateWithWhereUniqueWithoutTemplateInput = {
  data: AutomatedEmailsUncheckedUpdateWithoutTemplateInput;
  where: AutomatedEmailsWhereUniqueInput;
};

export type AutomatedEmailsUpdateWithoutNotificationInput = {
  days?: InputMaybe<IntFieldUpdateOperationsInput>;
  forRegistrans?: InputMaybe<EnumDynamicEmailForRegistransFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sendTo?: InputMaybe<EnumDynamicEmailSendToFieldUpdateOperationsInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutAutomatedEmailsInput>;
  time?: InputMaybe<EnumDynamicEmailTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  whenEventHasClasses?: InputMaybe<EnumDynamicwhenEventHasClassesFieldUpdateOperationsInput>;
};

export type AutomatedEmailsUpdateWithoutTemplateInput = {
  days?: InputMaybe<IntFieldUpdateOperationsInput>;
  forRegistrans?: InputMaybe<EnumDynamicEmailForRegistransFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notification?: InputMaybe<NotificationUpdateOneWithoutAutomatedEmailsInput>;
  sendTo?: InputMaybe<EnumDynamicEmailSendToFieldUpdateOperationsInput>;
  time?: InputMaybe<EnumDynamicEmailTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  whenEventHasClasses?: InputMaybe<EnumDynamicwhenEventHasClassesFieldUpdateOperationsInput>;
};

export type AutomatedEmailsUpsertWithWhereUniqueWithoutNotificationInput = {
  create: AutomatedEmailsUncheckedCreateWithoutNotificationInput;
  update: AutomatedEmailsUncheckedUpdateWithoutNotificationInput;
  where: AutomatedEmailsWhereUniqueInput;
};

export type AutomatedEmailsUpsertWithWhereUniqueWithoutTemplateInput = {
  create: AutomatedEmailsUncheckedCreateWithoutTemplateInput;
  update: AutomatedEmailsUncheckedUpdateWithoutTemplateInput;
  where: AutomatedEmailsWhereUniqueInput;
};

export type AutomatedEmailsWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<AutomatedEmailsWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<AutomatedEmailsWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<AutomatedEmailsWhereInput>>>;
  days?: InputMaybe<IntFilter>;
  forRegistrans?: InputMaybe<EnumDynamicEmailForRegistransFilter>;
  id?: InputMaybe<IntFilter>;
  message?: InputMaybe<StringNullableFilter>;
  notification?: InputMaybe<NotificationWhereInput>;
  notificationId?: InputMaybe<IntNullableFilter>;
  sendTo?: InputMaybe<EnumDynamicEmailSendToFilter>;
  template?: InputMaybe<TemplateWhereInput>;
  templateId?: InputMaybe<IntNullableFilter>;
  time?: InputMaybe<EnumDynamicEmailTimeFilter>;
  title?: InputMaybe<StringFilter>;
  whenEventHasClasses?: InputMaybe<EnumDynamicwhenEventHasClassesFilter>;
};

export type AutomatedEmailsWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type BankAccount = {
  __typename?: 'BankAccount';
  accountHolderName?: Maybe<Scalars['String']>;
  bankName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  iban: Scalars['String'];
  id: Scalars['Int'];
  user: User;
  userId: Scalars['Int'];
};

export type BankAccountAvgAggregateOutputType = {
  __typename?: 'BankAccountAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

export type BankAccountAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type BankAccountCountAggregateOutputType = {
  __typename?: 'BankAccountCountAggregateOutputType';
  _all: Scalars['Int'];
  accountHolderName: Scalars['Int'];
  bankName: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  iban: Scalars['Int'];
  id: Scalars['Int'];
  userId: Scalars['Int'];
};

export type BankAccountCountOrderByAggregateInput = {
  accountHolderName?: InputMaybe<SortOrder>;
  bankName?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  iban?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type BankAccountCreateInput = {
  accountHolderName?: InputMaybe<Scalars['String']>;
  bankName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  iban: Scalars['String'];
  user: UserCreateNestedOneWithoutBankAccountInput;
};

export type BankAccountCreateManyInput = {
  accountHolderName?: InputMaybe<Scalars['String']>;
  bankName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  iban: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  userId: Scalars['Int'];
};

export type BankAccountCreateNestedOneWithoutUserInput = {
  connect?: InputMaybe<BankAccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BankAccountCreateOrConnectWithoutUserInput>;
  create?: InputMaybe<BankAccountUncheckedCreateWithoutUserInput>;
};

export type BankAccountCreateOrConnectWithoutUserInput = {
  create: BankAccountUncheckedCreateWithoutUserInput;
  where: BankAccountWhereUniqueInput;
};

export type BankAccountCreateWithoutUserInput = {
  accountHolderName?: InputMaybe<Scalars['String']>;
  bankName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  iban: Scalars['String'];
};

export type BankAccountMaxAggregateOutputType = {
  __typename?: 'BankAccountMaxAggregateOutputType';
  accountHolderName?: Maybe<Scalars['String']>;
  bankName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  iban?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

export type BankAccountMaxOrderByAggregateInput = {
  accountHolderName?: InputMaybe<SortOrder>;
  bankName?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  iban?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type BankAccountMinAggregateOutputType = {
  __typename?: 'BankAccountMinAggregateOutputType';
  accountHolderName?: Maybe<Scalars['String']>;
  bankName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  iban?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

export type BankAccountMinOrderByAggregateInput = {
  accountHolderName?: InputMaybe<SortOrder>;
  bankName?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  iban?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type BankAccountOrderByWithAggregationInput = {
  _avg?: InputMaybe<BankAccountAvgOrderByAggregateInput>;
  _count?: InputMaybe<BankAccountCountOrderByAggregateInput>;
  _max?: InputMaybe<BankAccountMaxOrderByAggregateInput>;
  _min?: InputMaybe<BankAccountMinOrderByAggregateInput>;
  _sum?: InputMaybe<BankAccountSumOrderByAggregateInput>;
  accountHolderName?: InputMaybe<SortOrder>;
  bankName?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  iban?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type BankAccountOrderByWithRelationInput = {
  accountHolderName?: InputMaybe<SortOrder>;
  bankName?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  iban?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export type BankAccountRelationFilter = {
  is?: InputMaybe<BankAccountWhereInput>;
  isNot?: InputMaybe<BankAccountWhereInput>;
};

export enum BankAccountScalarFieldEnum {
  AccountHolderName = 'accountHolderName',
  BankName = 'bankName',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Iban = 'iban',
  Id = 'id',
  UserId = 'userId'
}

export type BankAccountScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<BankAccountScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<BankAccountScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<BankAccountScalarWhereWithAggregatesInput>>>;
  accountHolderName?: InputMaybe<StringNullableWithAggregatesFilter>;
  bankName?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  iban?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  userId?: InputMaybe<IntWithAggregatesFilter>;
};

export type BankAccountSumAggregateOutputType = {
  __typename?: 'BankAccountSumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

export type BankAccountSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type BankAccountUncheckedCreateInput = {
  accountHolderName?: InputMaybe<Scalars['String']>;
  bankName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  iban: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  userId: Scalars['Int'];
};

export type BankAccountUncheckedCreateNestedOneWithoutUserInput = {
  connect?: InputMaybe<BankAccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BankAccountCreateOrConnectWithoutUserInput>;
  create?: InputMaybe<BankAccountUncheckedCreateWithoutUserInput>;
};

export type BankAccountUncheckedCreateWithoutUserInput = {
  accountHolderName?: InputMaybe<Scalars['String']>;
  bankName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  iban: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
};

export type BankAccountUncheckedUpdateInput = {
  accountHolderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bankName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  iban?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  userId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type BankAccountUncheckedUpdateManyInput = {
  accountHolderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bankName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  iban?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  userId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type BankAccountUncheckedUpdateOneWithoutUserInput = {
  connect?: InputMaybe<BankAccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BankAccountCreateOrConnectWithoutUserInput>;
  create?: InputMaybe<BankAccountUncheckedCreateWithoutUserInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<BankAccountUncheckedUpdateWithoutUserInput>;
  upsert?: InputMaybe<BankAccountUpsertWithoutUserInput>;
};

export type BankAccountUncheckedUpdateWithoutUserInput = {
  accountHolderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bankName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  iban?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type BankAccountUpdateInput = {
  accountHolderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bankName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  iban?: InputMaybe<StringFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutBankAccountInput>;
};

export type BankAccountUpdateManyMutationInput = {
  accountHolderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bankName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  iban?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type BankAccountUpdateOneWithoutUserInput = {
  connect?: InputMaybe<BankAccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BankAccountCreateOrConnectWithoutUserInput>;
  create?: InputMaybe<BankAccountUncheckedCreateWithoutUserInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<BankAccountUncheckedUpdateWithoutUserInput>;
  upsert?: InputMaybe<BankAccountUpsertWithoutUserInput>;
};

export type BankAccountUpdateWithoutUserInput = {
  accountHolderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bankName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  iban?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type BankAccountUpsertWithoutUserInput = {
  create: BankAccountUncheckedCreateWithoutUserInput;
  update: BankAccountUncheckedUpdateWithoutUserInput;
};

export type BankAccountWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<BankAccountWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<BankAccountWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<BankAccountWhereInput>>>;
  accountHolderName?: InputMaybe<StringNullableFilter>;
  bankName?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  iban?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  user?: InputMaybe<UserWhereInput>;
  userId?: InputMaybe<IntFilter>;
};

export type BankAccountWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type BatchPayload = {
  __typename?: 'BatchPayload';
  count: Scalars['Int'];
};

export type BecomeTrainerApplication = {
  __typename?: 'BecomeTrainerApplication';
  applicant: User;
  applicantId: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  cv?: Maybe<Cv>;
  cvId: Scalars['Int'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  rejectedCount?: Maybe<Scalars['Int']>;
  state: ApplicationState;
};

export type BecomeTrainerApplicationAvgAggregateOutputType = {
  __typename?: 'BecomeTrainerApplicationAvgAggregateOutputType';
  applicantId?: Maybe<Scalars['Float']>;
  cvId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  rejectedCount?: Maybe<Scalars['Float']>;
};

export type BecomeTrainerApplicationAvgOrderByAggregateInput = {
  applicantId?: InputMaybe<SortOrder>;
  cvId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  rejectedCount?: InputMaybe<SortOrder>;
};

export type BecomeTrainerApplicationCountAggregateOutputType = {
  __typename?: 'BecomeTrainerApplicationCountAggregateOutputType';
  _all: Scalars['Int'];
  applicantId: Scalars['Int'];
  createdAt: Scalars['Int'];
  cvId: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  rejectedCount: Scalars['Int'];
  state: Scalars['Int'];
};

export type BecomeTrainerApplicationCountOrderByAggregateInput = {
  applicantId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  cvId?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  rejectedCount?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
};

export type BecomeTrainerApplicationCreateInput = {
  applicant: UserCreateNestedOneWithoutApplicationsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv: CvCreateNestedOneWithoutApplicationsInput;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  rejectedCount?: InputMaybe<Scalars['Int']>;
  state: ApplicationState;
};

export type BecomeTrainerApplicationCreateManyApplicantInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cvId: Scalars['Int'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  rejectedCount?: InputMaybe<Scalars['Int']>;
  state: ApplicationState;
};

export type BecomeTrainerApplicationCreateManyApplicantInputEnvelope = {
  data: BecomeTrainerApplicationCreateManyApplicantInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type BecomeTrainerApplicationCreateManyCvInput = {
  applicantId: Scalars['Int'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  rejectedCount?: InputMaybe<Scalars['Int']>;
  state: ApplicationState;
};

export type BecomeTrainerApplicationCreateManyCvInputEnvelope = {
  data: BecomeTrainerApplicationCreateManyCvInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type BecomeTrainerApplicationCreateManyInput = {
  applicantId: Scalars['Int'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cvId: Scalars['Int'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  rejectedCount?: InputMaybe<Scalars['Int']>;
  state: ApplicationState;
};

export type BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput = {
  connect?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationCreateOrConnectWithoutApplicantInput>>>;
  create?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationCreateWithoutApplicantInput>>>;
  createMany?: InputMaybe<BecomeTrainerApplicationCreateManyApplicantInputEnvelope>;
};

export type BecomeTrainerApplicationCreateNestedManyWithoutCvInput = {
  connect?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationCreateOrConnectWithoutCvInput>>>;
  create?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationCreateWithoutCvInput>>>;
  createMany?: InputMaybe<BecomeTrainerApplicationCreateManyCvInputEnvelope>;
};

export type BecomeTrainerApplicationCreateOrConnectWithoutApplicantInput = {
  create: BecomeTrainerApplicationUncheckedCreateWithoutApplicantInput;
  where: BecomeTrainerApplicationWhereUniqueInput;
};

export type BecomeTrainerApplicationCreateOrConnectWithoutCvInput = {
  create: BecomeTrainerApplicationUncheckedCreateWithoutCvInput;
  where: BecomeTrainerApplicationWhereUniqueInput;
};

export type BecomeTrainerApplicationCreateWithoutApplicantInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv: CvCreateNestedOneWithoutApplicationsInput;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  rejectedCount?: InputMaybe<Scalars['Int']>;
  state: ApplicationState;
};

export type BecomeTrainerApplicationCreateWithoutCvInput = {
  applicant: UserCreateNestedOneWithoutApplicationsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  rejectedCount?: InputMaybe<Scalars['Int']>;
  state: ApplicationState;
};

export type BecomeTrainerApplicationListRelationFilter = {
  every?: InputMaybe<BecomeTrainerApplicationWhereInput>;
  none?: InputMaybe<BecomeTrainerApplicationWhereInput>;
  some?: InputMaybe<BecomeTrainerApplicationWhereInput>;
};

export type BecomeTrainerApplicationMaxAggregateOutputType = {
  __typename?: 'BecomeTrainerApplicationMaxAggregateOutputType';
  applicantId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  cvId?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  rejectedCount?: Maybe<Scalars['Int']>;
  state?: Maybe<ApplicationState>;
};

export type BecomeTrainerApplicationMaxOrderByAggregateInput = {
  applicantId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  cvId?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  rejectedCount?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
};

export type BecomeTrainerApplicationMinAggregateOutputType = {
  __typename?: 'BecomeTrainerApplicationMinAggregateOutputType';
  applicantId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  cvId?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  rejectedCount?: Maybe<Scalars['Int']>;
  state?: Maybe<ApplicationState>;
};

export type BecomeTrainerApplicationMinOrderByAggregateInput = {
  applicantId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  cvId?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  rejectedCount?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
};

export type BecomeTrainerApplicationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BecomeTrainerApplicationOrderByWithAggregationInput = {
  _avg?: InputMaybe<BecomeTrainerApplicationAvgOrderByAggregateInput>;
  _count?: InputMaybe<BecomeTrainerApplicationCountOrderByAggregateInput>;
  _max?: InputMaybe<BecomeTrainerApplicationMaxOrderByAggregateInput>;
  _min?: InputMaybe<BecomeTrainerApplicationMinOrderByAggregateInput>;
  _sum?: InputMaybe<BecomeTrainerApplicationSumOrderByAggregateInput>;
  applicantId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  cvId?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  rejectedCount?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
};

export type BecomeTrainerApplicationOrderByWithRelationInput = {
  applicant?: InputMaybe<UserOrderByWithRelationInput>;
  applicantId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  cv?: InputMaybe<CvOrderByWithRelationInput>;
  cvId?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  rejectedCount?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
};

export enum BecomeTrainerApplicationScalarFieldEnum {
  ApplicantId = 'applicantId',
  CreatedAt = 'createdAt',
  CvId = 'cvId',
  DeletedAt = 'deletedAt',
  Id = 'id',
  RejectedCount = 'rejectedCount',
  State = 'state'
}

export type BecomeTrainerApplicationScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationScalarWhereInput>>>;
  applicantId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  cvId?: InputMaybe<IntFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  rejectedCount?: InputMaybe<IntNullableFilter>;
  state?: InputMaybe<EnumApplicationStateFilter>;
};

export type BecomeTrainerApplicationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationScalarWhereWithAggregatesInput>>>;
  applicantId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  cvId?: InputMaybe<IntWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  rejectedCount?: InputMaybe<IntNullableWithAggregatesFilter>;
  state?: InputMaybe<EnumApplicationStateWithAggregatesFilter>;
};

export type BecomeTrainerApplicationSumAggregateOutputType = {
  __typename?: 'BecomeTrainerApplicationSumAggregateOutputType';
  applicantId?: Maybe<Scalars['Int']>;
  cvId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  rejectedCount?: Maybe<Scalars['Int']>;
};

export type BecomeTrainerApplicationSumOrderByAggregateInput = {
  applicantId?: InputMaybe<SortOrder>;
  cvId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  rejectedCount?: InputMaybe<SortOrder>;
};

export type BecomeTrainerApplicationUncheckedCreateInput = {
  applicantId: Scalars['Int'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cvId: Scalars['Int'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  rejectedCount?: InputMaybe<Scalars['Int']>;
  state: ApplicationState;
};

export type BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput = {
  connect?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationCreateOrConnectWithoutApplicantInput>>>;
  create?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationCreateWithoutApplicantInput>>>;
  createMany?: InputMaybe<BecomeTrainerApplicationCreateManyApplicantInputEnvelope>;
};

export type BecomeTrainerApplicationUncheckedCreateNestedManyWithoutCvInput = {
  connect?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationCreateOrConnectWithoutCvInput>>>;
  create?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationCreateWithoutCvInput>>>;
  createMany?: InputMaybe<BecomeTrainerApplicationCreateManyCvInputEnvelope>;
};

export type BecomeTrainerApplicationUncheckedCreateWithoutApplicantInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cvId: Scalars['Int'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  rejectedCount?: InputMaybe<Scalars['Int']>;
  state: ApplicationState;
};

export type BecomeTrainerApplicationUncheckedCreateWithoutCvInput = {
  applicantId: Scalars['Int'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  rejectedCount?: InputMaybe<Scalars['Int']>;
  state: ApplicationState;
};

export type BecomeTrainerApplicationUncheckedUpdateInput = {
  applicantId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cvId?: InputMaybe<IntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  rejectedCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  state?: InputMaybe<EnumApplicationStateFieldUpdateOperationsInput>;
};

export type BecomeTrainerApplicationUncheckedUpdateManyInput = {
  applicantId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cvId?: InputMaybe<IntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  rejectedCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  state?: InputMaybe<EnumApplicationStateFieldUpdateOperationsInput>;
};

export type BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput = {
  connect?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationCreateOrConnectWithoutApplicantInput>>>;
  create?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationCreateWithoutApplicantInput>>>;
  createMany?: InputMaybe<BecomeTrainerApplicationCreateManyApplicantInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationUpdateWithWhereUniqueWithoutApplicantInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationUpdateManyWithWhereWithoutApplicantInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationUpsertWithWhereUniqueWithoutApplicantInput>>>;
};

export type BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicationsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cvId?: InputMaybe<IntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  rejectedCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  state?: InputMaybe<EnumApplicationStateFieldUpdateOperationsInput>;
};

export type BecomeTrainerApplicationUncheckedUpdateManyWithoutCvInput = {
  connect?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationCreateOrConnectWithoutCvInput>>>;
  create?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationCreateWithoutCvInput>>>;
  createMany?: InputMaybe<BecomeTrainerApplicationCreateManyCvInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationUpdateWithWhereUniqueWithoutCvInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationUpdateManyWithWhereWithoutCvInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationUpsertWithWhereUniqueWithoutCvInput>>>;
};

export type BecomeTrainerApplicationUncheckedUpdateWithoutApplicantInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cvId?: InputMaybe<IntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  rejectedCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  state?: InputMaybe<EnumApplicationStateFieldUpdateOperationsInput>;
};

export type BecomeTrainerApplicationUncheckedUpdateWithoutCvInput = {
  applicantId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  rejectedCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  state?: InputMaybe<EnumApplicationStateFieldUpdateOperationsInput>;
};

export type BecomeTrainerApplicationUpdateInput = {
  applicant?: InputMaybe<UserUpdateOneRequiredWithoutApplicationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<CvUpdateOneRequiredWithoutApplicationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rejectedCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  state?: InputMaybe<EnumApplicationStateFieldUpdateOperationsInput>;
};

export type BecomeTrainerApplicationUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rejectedCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  state?: InputMaybe<EnumApplicationStateFieldUpdateOperationsInput>;
};

export type BecomeTrainerApplicationUpdateManyWithWhereWithoutApplicantInput = {
  data: BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicationsInput;
  where: BecomeTrainerApplicationScalarWhereInput;
};

export type BecomeTrainerApplicationUpdateManyWithWhereWithoutCvInput = {
  data: BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicationsInput;
  where: BecomeTrainerApplicationScalarWhereInput;
};

export type BecomeTrainerApplicationUpdateManyWithoutApplicantInput = {
  connect?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationCreateOrConnectWithoutApplicantInput>>>;
  create?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationCreateWithoutApplicantInput>>>;
  createMany?: InputMaybe<BecomeTrainerApplicationCreateManyApplicantInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationUpdateWithWhereUniqueWithoutApplicantInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationUpdateManyWithWhereWithoutApplicantInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationUpsertWithWhereUniqueWithoutApplicantInput>>>;
};

export type BecomeTrainerApplicationUpdateManyWithoutCvInput = {
  connect?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationCreateOrConnectWithoutCvInput>>>;
  create?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationCreateWithoutCvInput>>>;
  createMany?: InputMaybe<BecomeTrainerApplicationCreateManyCvInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationUpdateWithWhereUniqueWithoutCvInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationUpdateManyWithWhereWithoutCvInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationUpsertWithWhereUniqueWithoutCvInput>>>;
};

export type BecomeTrainerApplicationUpdateWithWhereUniqueWithoutApplicantInput = {
  data: BecomeTrainerApplicationUncheckedUpdateWithoutApplicantInput;
  where: BecomeTrainerApplicationWhereUniqueInput;
};

export type BecomeTrainerApplicationUpdateWithWhereUniqueWithoutCvInput = {
  data: BecomeTrainerApplicationUncheckedUpdateWithoutCvInput;
  where: BecomeTrainerApplicationWhereUniqueInput;
};

export type BecomeTrainerApplicationUpdateWithoutApplicantInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<CvUpdateOneRequiredWithoutApplicationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rejectedCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  state?: InputMaybe<EnumApplicationStateFieldUpdateOperationsInput>;
};

export type BecomeTrainerApplicationUpdateWithoutCvInput = {
  applicant?: InputMaybe<UserUpdateOneRequiredWithoutApplicationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  rejectedCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  state?: InputMaybe<EnumApplicationStateFieldUpdateOperationsInput>;
};

export type BecomeTrainerApplicationUpsertWithWhereUniqueWithoutApplicantInput = {
  create: BecomeTrainerApplicationUncheckedCreateWithoutApplicantInput;
  update: BecomeTrainerApplicationUncheckedUpdateWithoutApplicantInput;
  where: BecomeTrainerApplicationWhereUniqueInput;
};

export type BecomeTrainerApplicationUpsertWithWhereUniqueWithoutCvInput = {
  create: BecomeTrainerApplicationUncheckedCreateWithoutCvInput;
  update: BecomeTrainerApplicationUncheckedUpdateWithoutCvInput;
  where: BecomeTrainerApplicationWhereUniqueInput;
};

export type BecomeTrainerApplicationWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationWhereInput>>>;
  applicant?: InputMaybe<UserWhereInput>;
  applicantId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  cv?: InputMaybe<CvWhereInput>;
  cvId?: InputMaybe<IntFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  rejectedCount?: InputMaybe<IntNullableFilter>;
  state?: InputMaybe<EnumApplicationStateFilter>;
};

export type BecomeTrainerApplicationWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type BecomeTrainerRecord = {
  __typename?: 'BecomeTrainerRecord';
  month?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

export type BigIntNullableFilter = {
  equals?: InputMaybe<Scalars['BigInt']>;
  gt?: InputMaybe<Scalars['BigInt']>;
  gte?: InputMaybe<Scalars['BigInt']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  lt?: InputMaybe<Scalars['BigInt']>;
  lte?: InputMaybe<Scalars['BigInt']>;
  not?: InputMaybe<NestedBigIntNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type BigIntNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedBigIntNullableFilter>;
  _min?: InputMaybe<NestedBigIntNullableFilter>;
  _sum?: InputMaybe<NestedBigIntNullableFilter>;
  equals?: InputMaybe<Scalars['BigInt']>;
  gt?: InputMaybe<Scalars['BigInt']>;
  gte?: InputMaybe<Scalars['BigInt']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  lt?: InputMaybe<Scalars['BigInt']>;
  lte?: InputMaybe<Scalars['BigInt']>;
  not?: InputMaybe<NestedBigIntNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Blogs = {
  __typename?: 'Blogs';
  _count: BlogsCountOutputType;
  author?: Maybe<User>;
  authorId?: Maybe<Scalars['Int']>;
  content?: Maybe<Scalars['String']>;
  contentAr?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  descriptionAr?: Maybe<Scalars['String']>;
  event?: Maybe<User>;
  eventId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  image?: Maybe<Scalars['String']>;
  socialMedia: Array<Scalars['String']>;
  thumbnailImage?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  titleAr?: Maybe<Scalars['String']>;
};

export type BlogsAvgAggregateOutputType = {
  __typename?: 'BlogsAvgAggregateOutputType';
  authorId?: Maybe<Scalars['Float']>;
  eventId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

export type BlogsAvgOrderByAggregateInput = {
  authorId?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type BlogsCountAggregateOutputType = {
  __typename?: 'BlogsCountAggregateOutputType';
  _all: Scalars['Int'];
  authorId: Scalars['Int'];
  content: Scalars['Int'];
  contentAr: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  descriptionAr: Scalars['Int'];
  eventId: Scalars['Int'];
  id: Scalars['Int'];
  image: Scalars['Int'];
  socialMedia: Scalars['Int'];
  thumbnailImage: Scalars['Int'];
  title: Scalars['Int'];
  titleAr: Scalars['Int'];
};

export type BlogsCountOrderByAggregateInput = {
  authorId?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrder>;
  contentAr?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  descriptionAr?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  image?: InputMaybe<SortOrder>;
  socialMedia?: InputMaybe<SortOrder>;
  thumbnailImage?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
};

export type BlogsCountOutputType = {
  __typename?: 'BlogsCountOutputType';
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['Int']>;
};

export type BlogsCreateInput = {
  author?: InputMaybe<UserCreateNestedOneWithoutBlogsInput>;
  content?: InputMaybe<Scalars['String']>;
  contentAr?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<EventCreateNestedOneWithoutBlogsInput>;
  image?: InputMaybe<Scalars['String']>;
  socialMedia?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thumbnailImage?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  titleAr?: InputMaybe<Scalars['String']>;
};

export type BlogsCreateManyAuthorInput = {
  content?: InputMaybe<Scalars['String']>;
  contentAr?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['String']>;
  socialMedia?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thumbnailImage?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  titleAr?: InputMaybe<Scalars['String']>;
};

export type BlogsCreateManyAuthorInputEnvelope = {
  data: BlogsCreateManyAuthorInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type BlogsCreateManyEventInput = {
  authorId?: InputMaybe<Scalars['Int']>;
  content?: InputMaybe<Scalars['String']>;
  contentAr?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['String']>;
  socialMedia?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thumbnailImage?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  titleAr?: InputMaybe<Scalars['String']>;
};

export type BlogsCreateManyEventInputEnvelope = {
  data: BlogsCreateManyEventInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type BlogsCreateManyInput = {
  authorId?: InputMaybe<Scalars['Int']>;
  content?: InputMaybe<Scalars['String']>;
  contentAr?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['String']>;
  socialMedia?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thumbnailImage?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  titleAr?: InputMaybe<Scalars['String']>;
};

export type BlogsCreateNestedManyWithoutAuthorInput = {
  connect?: InputMaybe<Array<InputMaybe<BlogsWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BlogsCreateOrConnectWithoutAuthorInput>>>;
  create?: InputMaybe<Array<InputMaybe<BlogsCreateWithoutAuthorInput>>>;
  createMany?: InputMaybe<BlogsCreateManyAuthorInputEnvelope>;
};

export type BlogsCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<BlogsWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BlogsCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<BlogsCreateWithoutEventInput>>>;
  createMany?: InputMaybe<BlogsCreateManyEventInputEnvelope>;
};

export type BlogsCreateOrConnectWithoutAuthorInput = {
  create: BlogsUncheckedCreateWithoutAuthorInput;
  where: BlogsWhereUniqueInput;
};

export type BlogsCreateOrConnectWithoutEventInput = {
  create: BlogsUncheckedCreateWithoutEventInput;
  where: BlogsWhereUniqueInput;
};

export type BlogsCreateWithoutAuthorInput = {
  content?: InputMaybe<Scalars['String']>;
  contentAr?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<EventCreateNestedOneWithoutBlogsInput>;
  image?: InputMaybe<Scalars['String']>;
  socialMedia?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thumbnailImage?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  titleAr?: InputMaybe<Scalars['String']>;
};

export type BlogsCreateWithoutEventInput = {
  author?: InputMaybe<UserCreateNestedOneWithoutBlogsInput>;
  content?: InputMaybe<Scalars['String']>;
  contentAr?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  socialMedia?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thumbnailImage?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  titleAr?: InputMaybe<Scalars['String']>;
};

export type BlogsCreatesocialMediaInput = {
  set: Scalars['String'];
};

export type BlogsListRelationFilter = {
  every?: InputMaybe<BlogsWhereInput>;
  none?: InputMaybe<BlogsWhereInput>;
  some?: InputMaybe<BlogsWhereInput>;
};

export type BlogsMaxAggregateOutputType = {
  __typename?: 'BlogsMaxAggregateOutputType';
  authorId?: Maybe<Scalars['Int']>;
  content?: Maybe<Scalars['String']>;
  contentAr?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  descriptionAr?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  thumbnailImage?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleAr?: Maybe<Scalars['String']>;
};

export type BlogsMaxOrderByAggregateInput = {
  authorId?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrder>;
  contentAr?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  descriptionAr?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  image?: InputMaybe<SortOrder>;
  thumbnailImage?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
};

export type BlogsMinAggregateOutputType = {
  __typename?: 'BlogsMinAggregateOutputType';
  authorId?: Maybe<Scalars['Int']>;
  content?: Maybe<Scalars['String']>;
  contentAr?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  descriptionAr?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  thumbnailImage?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleAr?: Maybe<Scalars['String']>;
};

export type BlogsMinOrderByAggregateInput = {
  authorId?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrder>;
  contentAr?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  descriptionAr?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  image?: InputMaybe<SortOrder>;
  thumbnailImage?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
};

export type BlogsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BlogsOrderByWithAggregationInput = {
  _avg?: InputMaybe<BlogsAvgOrderByAggregateInput>;
  _count?: InputMaybe<BlogsCountOrderByAggregateInput>;
  _max?: InputMaybe<BlogsMaxOrderByAggregateInput>;
  _min?: InputMaybe<BlogsMinOrderByAggregateInput>;
  _sum?: InputMaybe<BlogsSumOrderByAggregateInput>;
  authorId?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrder>;
  contentAr?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  descriptionAr?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  image?: InputMaybe<SortOrder>;
  socialMedia?: InputMaybe<SortOrder>;
  thumbnailImage?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
};

export type BlogsOrderByWithRelationInput = {
  author?: InputMaybe<UserOrderByWithRelationInput>;
  authorId?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrder>;
  contentAr?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  descriptionAr?: InputMaybe<SortOrder>;
  event?: InputMaybe<EventOrderByWithRelationInput>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  image?: InputMaybe<SortOrder>;
  socialMedia?: InputMaybe<SortOrder>;
  thumbnailImage?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
};

export enum BlogsScalarFieldEnum {
  AuthorId = 'authorId',
  Content = 'content',
  ContentAr = 'contentAr',
  CreatedAt = 'createdAt',
  Description = 'description',
  DescriptionAr = 'descriptionAr',
  EventId = 'eventId',
  Id = 'id',
  Image = 'image',
  SocialMedia = 'socialMedia',
  ThumbnailImage = 'thumbnailImage',
  Title = 'title',
  TitleAr = 'titleAr'
}

export type BlogsScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<BlogsScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<BlogsScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<BlogsScalarWhereInput>>>;
  authorId?: InputMaybe<IntNullableFilter>;
  content?: InputMaybe<StringNullableFilter>;
  contentAr?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  descriptionAr?: InputMaybe<StringNullableFilter>;
  eventId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  image?: InputMaybe<StringNullableFilter>;
  socialMedia?: InputMaybe<StringNullableListFilter>;
  thumbnailImage?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  titleAr?: InputMaybe<StringNullableFilter>;
};

export type BlogsScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<BlogsScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<BlogsScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<BlogsScalarWhereWithAggregatesInput>>>;
  authorId?: InputMaybe<IntNullableWithAggregatesFilter>;
  content?: InputMaybe<StringNullableWithAggregatesFilter>;
  contentAr?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  descriptionAr?: InputMaybe<StringNullableWithAggregatesFilter>;
  eventId?: InputMaybe<IntNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  image?: InputMaybe<StringNullableWithAggregatesFilter>;
  socialMedia?: InputMaybe<StringNullableListFilter>;
  thumbnailImage?: InputMaybe<StringNullableWithAggregatesFilter>;
  title?: InputMaybe<StringWithAggregatesFilter>;
  titleAr?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type BlogsSumAggregateOutputType = {
  __typename?: 'BlogsSumAggregateOutputType';
  authorId?: Maybe<Scalars['Int']>;
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type BlogsSumOrderByAggregateInput = {
  authorId?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type BlogsUncheckedCreateInput = {
  authorId?: InputMaybe<Scalars['Int']>;
  content?: InputMaybe<Scalars['String']>;
  contentAr?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['String']>;
  socialMedia?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thumbnailImage?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  titleAr?: InputMaybe<Scalars['String']>;
};

export type BlogsUncheckedCreateNestedManyWithoutAuthorInput = {
  connect?: InputMaybe<Array<InputMaybe<BlogsWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BlogsCreateOrConnectWithoutAuthorInput>>>;
  create?: InputMaybe<Array<InputMaybe<BlogsCreateWithoutAuthorInput>>>;
  createMany?: InputMaybe<BlogsCreateManyAuthorInputEnvelope>;
};

export type BlogsUncheckedCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<BlogsWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BlogsCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<BlogsCreateWithoutEventInput>>>;
  createMany?: InputMaybe<BlogsCreateManyEventInputEnvelope>;
};

export type BlogsUncheckedCreateWithoutAuthorInput = {
  content?: InputMaybe<Scalars['String']>;
  contentAr?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['String']>;
  socialMedia?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thumbnailImage?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  titleAr?: InputMaybe<Scalars['String']>;
};

export type BlogsUncheckedCreateWithoutEventInput = {
  authorId?: InputMaybe<Scalars['Int']>;
  content?: InputMaybe<Scalars['String']>;
  contentAr?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['String']>;
  socialMedia?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thumbnailImage?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  titleAr?: InputMaybe<Scalars['String']>;
};

export type BlogsUncheckedUpdateInput = {
  authorId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contentAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  socialMedia?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thumbnailImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type BlogsUncheckedUpdateManyInput = {
  authorId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contentAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  socialMedia?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thumbnailImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type BlogsUncheckedUpdateManyWithoutAuthorInput = {
  connect?: InputMaybe<Array<InputMaybe<BlogsWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BlogsCreateOrConnectWithoutAuthorInput>>>;
  create?: InputMaybe<Array<InputMaybe<BlogsCreateWithoutAuthorInput>>>;
  createMany?: InputMaybe<BlogsCreateManyAuthorInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<BlogsWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<BlogsScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<BlogsWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<BlogsWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<BlogsUpdateWithWhereUniqueWithoutAuthorInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<BlogsUpdateManyWithWhereWithoutAuthorInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<BlogsUpsertWithWhereUniqueWithoutAuthorInput>>>;
};

export type BlogsUncheckedUpdateManyWithoutBlogsInput = {
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contentAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  socialMedia?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thumbnailImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type BlogsUncheckedUpdateManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<BlogsWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BlogsCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<BlogsCreateWithoutEventInput>>>;
  createMany?: InputMaybe<BlogsCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<BlogsWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<BlogsScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<BlogsWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<BlogsWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<BlogsUpdateWithWhereUniqueWithoutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<BlogsUpdateManyWithWhereWithoutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<BlogsUpsertWithWhereUniqueWithoutEventInput>>>;
};

export type BlogsUncheckedUpdateWithoutAuthorInput = {
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contentAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  socialMedia?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thumbnailImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type BlogsUncheckedUpdateWithoutEventInput = {
  authorId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contentAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  socialMedia?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thumbnailImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type BlogsUpdateInput = {
  author?: InputMaybe<UserUpdateOneWithoutBlogsInput>;
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contentAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneWithoutBlogsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  socialMedia?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thumbnailImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type BlogsUpdateManyMutationInput = {
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contentAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  socialMedia?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thumbnailImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type BlogsUpdateManyWithWhereWithoutAuthorInput = {
  data: BlogsUncheckedUpdateManyWithoutBlogsInput;
  where: BlogsScalarWhereInput;
};

export type BlogsUpdateManyWithWhereWithoutEventInput = {
  data: BlogsUncheckedUpdateManyWithoutBlogsInput;
  where: BlogsScalarWhereInput;
};

export type BlogsUpdateManyWithoutAuthorInput = {
  connect?: InputMaybe<Array<InputMaybe<BlogsWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BlogsCreateOrConnectWithoutAuthorInput>>>;
  create?: InputMaybe<Array<InputMaybe<BlogsCreateWithoutAuthorInput>>>;
  createMany?: InputMaybe<BlogsCreateManyAuthorInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<BlogsWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<BlogsScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<BlogsWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<BlogsWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<BlogsUpdateWithWhereUniqueWithoutAuthorInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<BlogsUpdateManyWithWhereWithoutAuthorInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<BlogsUpsertWithWhereUniqueWithoutAuthorInput>>>;
};

export type BlogsUpdateManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<BlogsWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<BlogsCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<BlogsCreateWithoutEventInput>>>;
  createMany?: InputMaybe<BlogsCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<BlogsWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<BlogsScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<BlogsWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<BlogsWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<BlogsUpdateWithWhereUniqueWithoutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<BlogsUpdateManyWithWhereWithoutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<BlogsUpsertWithWhereUniqueWithoutEventInput>>>;
};

export type BlogsUpdateWithWhereUniqueWithoutAuthorInput = {
  data: BlogsUncheckedUpdateWithoutAuthorInput;
  where: BlogsWhereUniqueInput;
};

export type BlogsUpdateWithWhereUniqueWithoutEventInput = {
  data: BlogsUncheckedUpdateWithoutEventInput;
  where: BlogsWhereUniqueInput;
};

export type BlogsUpdateWithoutAuthorInput = {
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contentAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneWithoutBlogsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  socialMedia?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thumbnailImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type BlogsUpdateWithoutEventInput = {
  author?: InputMaybe<UserUpdateOneWithoutBlogsInput>;
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contentAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  socialMedia?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thumbnailImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type BlogsUpdatesocialMediaInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type BlogsUpsertWithWhereUniqueWithoutAuthorInput = {
  create: BlogsUncheckedCreateWithoutAuthorInput;
  update: BlogsUncheckedUpdateWithoutAuthorInput;
  where: BlogsWhereUniqueInput;
};

export type BlogsUpsertWithWhereUniqueWithoutEventInput = {
  create: BlogsUncheckedCreateWithoutEventInput;
  update: BlogsUncheckedUpdateWithoutEventInput;
  where: BlogsWhereUniqueInput;
};

export type BlogsWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<BlogsWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<BlogsWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<BlogsWhereInput>>>;
  author?: InputMaybe<UserWhereInput>;
  authorId?: InputMaybe<IntNullableFilter>;
  content?: InputMaybe<StringNullableFilter>;
  contentAr?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  descriptionAr?: InputMaybe<StringNullableFilter>;
  event?: InputMaybe<EventWhereInput>;
  eventId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  image?: InputMaybe<StringNullableFilter>;
  socialMedia?: InputMaybe<StringNullableListFilter>;
  thumbnailImage?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  titleAr?: InputMaybe<StringNullableFilter>;
};

export type BlogsWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type Booking = {
  __typename?: 'Booking';
  traineeEvent: Array<Maybe<TraineeEvent>>;
  traineeEventGroup?: Maybe<TraineeEventGroup>;
};

export type BookingEmailInputType = {
  bookingId: Scalars['Int'];
  key_alias?: InputMaybe<Scalars['String']>;
  template_key: Scalars['String'];
};

export type BookingInputType = {
  coupon?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  eventId: Scalars['Int'];
  groupTraineeEmails?: InputMaybe<Array<Scalars['String']>>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isAdminBooking?: InputMaybe<Scalars['Boolean']>;
  isCertificateRegistrant?: InputMaybe<Scalars['Boolean']>;
  isGroupPay?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant?: InputMaybe<Scalars['Boolean']>;
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isSoloBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant?: InputMaybe<Scalars['Boolean']>;
  methodOfDelivery?: InputMaybe<ModeOfDelivery>;
  newTraineeEmails?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  partsIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type BookingStatus = {
  __typename?: 'BookingStatus';
  _count: BookingStatusCountOutputType;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeEvents: Array<TraineeEvent>;
};


export type BookingStatusTraineeEventsArgs = {
  cursor?: InputMaybe<TraineeEventWhereUniqueInput>;
  distinct?: InputMaybe<TraineeEventScalarFieldEnum>;
  orderBy?: InputMaybe<TraineeEventOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeEventWhereInput>;
};

export type BookingStatusAvgAggregateOutputType = {
  __typename?: 'BookingStatusAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
};

export type BookingStatusAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type BookingStatusCountAggregateOutputType = {
  __typename?: 'BookingStatusCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  titleAr: Scalars['Int'];
  titleEn: Scalars['Int'];
};

export type BookingStatusCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type BookingStatusCountOutputType = {
  __typename?: 'BookingStatusCountOutputType';
  traineeEvents: Scalars['Int'];
};

export type BookingStatusCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutBookingStatusInput>;
};

export type BookingStatusCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type BookingStatusCreateNestedOneWithoutTraineeEventsInput = {
  connect?: InputMaybe<BookingStatusWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BookingStatusCreateOrConnectWithoutTraineeEventsInput>;
  create?: InputMaybe<BookingStatusUncheckedCreateWithoutTraineeEventsInput>;
};

export type BookingStatusCreateOrConnectWithoutTraineeEventsInput = {
  create: BookingStatusUncheckedCreateWithoutTraineeEventsInput;
  where: BookingStatusWhereUniqueInput;
};

export type BookingStatusCreateWithoutTraineeEventsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type BookingStatusMaxAggregateOutputType = {
  __typename?: 'BookingStatusMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type BookingStatusMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type BookingStatusMinAggregateOutputType = {
  __typename?: 'BookingStatusMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type BookingStatusMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type BookingStatusOrderByWithAggregationInput = {
  _avg?: InputMaybe<BookingStatusAvgOrderByAggregateInput>;
  _count?: InputMaybe<BookingStatusCountOrderByAggregateInput>;
  _max?: InputMaybe<BookingStatusMaxOrderByAggregateInput>;
  _min?: InputMaybe<BookingStatusMinOrderByAggregateInput>;
  _sum?: InputMaybe<BookingStatusSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type BookingStatusOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
  traineeEvents?: InputMaybe<TraineeEventOrderByRelationAggregateInput>;
};

export type BookingStatusRelationFilter = {
  is?: InputMaybe<BookingStatusWhereInput>;
  isNot?: InputMaybe<BookingStatusWhereInput>;
};

export enum BookingStatusScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  TitleAr = 'titleAr',
  TitleEn = 'titleEn'
}

export type BookingStatusScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<BookingStatusScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<BookingStatusScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<BookingStatusScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  titleAr?: InputMaybe<StringWithAggregatesFilter>;
  titleEn?: InputMaybe<StringWithAggregatesFilter>;
};

export type BookingStatusSumAggregateOutputType = {
  __typename?: 'BookingStatusSumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
};

export type BookingStatusSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type BookingStatusUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutBookingStatusInput>;
};

export type BookingStatusUncheckedCreateWithoutTraineeEventsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type BookingStatusUncheckedUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutBookingStatusInput>;
};

export type BookingStatusUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type BookingStatusUncheckedUpdateWithoutTraineeEventsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type BookingStatusUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutBookingStatusInput>;
};

export type BookingStatusUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type BookingStatusUpdateOneWithoutTraineeEventsInput = {
  connect?: InputMaybe<BookingStatusWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BookingStatusCreateOrConnectWithoutTraineeEventsInput>;
  create?: InputMaybe<BookingStatusUncheckedCreateWithoutTraineeEventsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<BookingStatusUncheckedUpdateWithoutTraineeEventsInput>;
  upsert?: InputMaybe<BookingStatusUpsertWithoutTraineeEventsInput>;
};

export type BookingStatusUpdateWithoutTraineeEventsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type BookingStatusUpsertWithoutTraineeEventsInput = {
  create: BookingStatusUncheckedCreateWithoutTraineeEventsInput;
  update: BookingStatusUncheckedUpdateWithoutTraineeEventsInput;
};

export type BookingStatusWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<BookingStatusWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<BookingStatusWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<BookingStatusWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  titleAr?: InputMaybe<StringFilter>;
  titleEn?: InputMaybe<StringFilter>;
  traineeEvents?: InputMaybe<TraineeEventListRelationFilter>;
};

export type BookingStatusWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn?: InputMaybe<Scalars['String']>;
};

export type BoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']>;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type BoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type BoolNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedBoolNullableFilter>;
  _min?: InputMaybe<NestedBoolNullableFilter>;
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolNullableWithAggregatesFilter>;
};

export type BoolWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedBoolFilter>;
  _min?: InputMaybe<NestedBoolFilter>;
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolWithAggregatesFilter>;
};

export type Certificate = {
  __typename?: 'Certificate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<Event>;
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isEligible?: Maybe<Scalars['Boolean']>;
  metaData?: Maybe<Scalars['Json']>;
  template?: Maybe<Template>;
  templateId?: Maybe<Scalars['Int']>;
  trainee?: Maybe<User>;
  traineeEvent?: Maybe<TraineeEvent>;
  traineeEventId?: Maybe<Scalars['Int']>;
  traineeId?: Maybe<Scalars['Int']>;
};

export type CertificateAvgAggregateOutputType = {
  __typename?: 'CertificateAvgAggregateOutputType';
  eventId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  templateId?: Maybe<Scalars['Float']>;
  traineeEventId?: Maybe<Scalars['Float']>;
  traineeId?: Maybe<Scalars['Float']>;
  trainerEventId?: Maybe<Scalars['Float']>;
};

export type CertificateAvgOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  templateId?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  traineeId?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
};

export type CertificateCountAggregateOutputType = {
  __typename?: 'CertificateCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  eventId: Scalars['Int'];
  id: Scalars['Int'];
  isEligible: Scalars['Int'];
  metaData: Scalars['Int'];
  templateId: Scalars['Int'];
  traineeEventId: Scalars['Int'];
  traineeId: Scalars['Int'];
  trainerEventId: Scalars['Int'];
};

export type CertificateCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isEligible?: InputMaybe<SortOrder>;
  metaData?: InputMaybe<SortOrder>;
  templateId?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  traineeId?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
};

export type CertificateCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  event: EventCreateNestedOneWithoutCertificateInput;
  isEligible?: InputMaybe<Scalars['Boolean']>;
  metaData?: InputMaybe<Scalars['Json']>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutCertificateInput>;
  trainee?: InputMaybe<UserCreateNestedOneWithoutCertificateInput>;
  traineeEvent?: InputMaybe<TraineeEventCreateNestedOneWithoutCertificateInput>;
  trainerEvent?: InputMaybe<TrainerEventCreateNestedOneWithoutCertificateInput>;
};

export type CertificateCreateManyEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  isEligible?: InputMaybe<Scalars['Boolean']>;
  metaData?: InputMaybe<Scalars['Json']>;
  templateId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  traineeId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
};

export type CertificateCreateManyEventInputEnvelope = {
  data: CertificateCreateManyEventInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CertificateCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  isEligible?: InputMaybe<Scalars['Boolean']>;
  metaData?: InputMaybe<Scalars['Json']>;
  templateId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  traineeId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
};

export type CertificateCreateManyTemplateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  isEligible?: InputMaybe<Scalars['Boolean']>;
  metaData?: InputMaybe<Scalars['Json']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  traineeId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
};

export type CertificateCreateManyTemplateInputEnvelope = {
  data: CertificateCreateManyTemplateInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CertificateCreateManyTraineeInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  isEligible?: InputMaybe<Scalars['Boolean']>;
  metaData?: InputMaybe<Scalars['Json']>;
  templateId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
};

export type CertificateCreateManyTraineeInputEnvelope = {
  data: CertificateCreateManyTraineeInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CertificateCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<CertificateWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CertificateCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<CertificateCreateWithoutEventInput>>>;
  createMany?: InputMaybe<CertificateCreateManyEventInputEnvelope>;
};

export type CertificateCreateNestedManyWithoutTemplateInput = {
  connect?: InputMaybe<Array<InputMaybe<CertificateWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CertificateCreateOrConnectWithoutTemplateInput>>>;
  create?: InputMaybe<Array<InputMaybe<CertificateCreateWithoutTemplateInput>>>;
  createMany?: InputMaybe<CertificateCreateManyTemplateInputEnvelope>;
};

export type CertificateCreateNestedManyWithoutTraineeInput = {
  connect?: InputMaybe<Array<InputMaybe<CertificateWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CertificateCreateOrConnectWithoutTraineeInput>>>;
  create?: InputMaybe<Array<InputMaybe<CertificateCreateWithoutTraineeInput>>>;
  createMany?: InputMaybe<CertificateCreateManyTraineeInputEnvelope>;
};

export type CertificateCreateNestedOneWithoutTraineeEventInput = {
  connect?: InputMaybe<CertificateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateCreateOrConnectWithoutTraineeEventInput>;
  create?: InputMaybe<CertificateUncheckedCreateWithoutTraineeEventInput>;
};

export type CertificateCreateNestedOneWithoutTrainerEventInput = {
  connect?: InputMaybe<CertificateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateCreateOrConnectWithoutTrainerEventInput>;
  create?: InputMaybe<CertificateUncheckedCreateWithoutTrainerEventInput>;
};

export type CertificateCreateOrConnectWithoutEventInput = {
  create: CertificateUncheckedCreateWithoutEventInput;
  where: CertificateWhereUniqueInput;
};

export type CertificateCreateOrConnectWithoutTemplateInput = {
  create: CertificateUncheckedCreateWithoutTemplateInput;
  where: CertificateWhereUniqueInput;
};

export type CertificateCreateOrConnectWithoutTraineeEventInput = {
  create: CertificateUncheckedCreateWithoutTraineeEventInput;
  where: CertificateWhereUniqueInput;
};

export type CertificateCreateOrConnectWithoutTraineeInput = {
  create: CertificateUncheckedCreateWithoutTraineeInput;
  where: CertificateWhereUniqueInput;
};

export type CertificateCreateOrConnectWithoutTrainerEventInput = {
  create: CertificateUncheckedCreateWithoutTrainerEventInput;
  where: CertificateWhereUniqueInput;
};

export type CertificateCreateWithoutEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  isEligible?: InputMaybe<Scalars['Boolean']>;
  metaData?: InputMaybe<Scalars['Json']>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutCertificateInput>;
  trainee?: InputMaybe<UserCreateNestedOneWithoutCertificateInput>;
  traineeEvent?: InputMaybe<TraineeEventCreateNestedOneWithoutCertificateInput>;
  trainerEvent?: InputMaybe<TrainerEventCreateNestedOneWithoutCertificateInput>;
};

export type CertificateCreateWithoutTemplateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  event: EventCreateNestedOneWithoutCertificateInput;
  isEligible?: InputMaybe<Scalars['Boolean']>;
  metaData?: InputMaybe<Scalars['Json']>;
  trainee?: InputMaybe<UserCreateNestedOneWithoutCertificateInput>;
  traineeEvent?: InputMaybe<TraineeEventCreateNestedOneWithoutCertificateInput>;
  trainerEvent?: InputMaybe<TrainerEventCreateNestedOneWithoutCertificateInput>;
};

export type CertificateCreateWithoutTraineeEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  event: EventCreateNestedOneWithoutCertificateInput;
  isEligible?: InputMaybe<Scalars['Boolean']>;
  metaData?: InputMaybe<Scalars['Json']>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutCertificateInput>;
  trainee?: InputMaybe<UserCreateNestedOneWithoutCertificateInput>;
  trainerEvent?: InputMaybe<TrainerEventCreateNestedOneWithoutCertificateInput>;
};

export type CertificateCreateWithoutTraineeInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  event: EventCreateNestedOneWithoutCertificateInput;
  isEligible?: InputMaybe<Scalars['Boolean']>;
  metaData?: InputMaybe<Scalars['Json']>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutCertificateInput>;
  traineeEvent?: InputMaybe<TraineeEventCreateNestedOneWithoutCertificateInput>;
  trainerEvent?: InputMaybe<TrainerEventCreateNestedOneWithoutCertificateInput>;
};

export type CertificateCreateWithoutTrainerEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  event: EventCreateNestedOneWithoutCertificateInput;
  isEligible?: InputMaybe<Scalars['Boolean']>;
  metaData?: InputMaybe<Scalars['Json']>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutCertificateInput>;
  trainee?: InputMaybe<UserCreateNestedOneWithoutCertificateInput>;
  traineeEvent?: InputMaybe<TraineeEventCreateNestedOneWithoutCertificateInput>;
};

export type CertificateListRelationFilter = {
  every?: InputMaybe<CertificateWhereInput>;
  none?: InputMaybe<CertificateWhereInput>;
  some?: InputMaybe<CertificateWhereInput>;
};

export type CertificateMaxAggregateOutputType = {
  __typename?: 'CertificateMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isEligible?: Maybe<Scalars['Boolean']>;
  templateId?: Maybe<Scalars['Int']>;
  traineeEventId?: Maybe<Scalars['Int']>;
  traineeId?: Maybe<Scalars['Int']>;
  trainerEventId?: Maybe<Scalars['Int']>;
};

export type CertificateMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isEligible?: InputMaybe<SortOrder>;
  templateId?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  traineeId?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
};

export type CertificateMinAggregateOutputType = {
  __typename?: 'CertificateMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isEligible?: Maybe<Scalars['Boolean']>;
  templateId?: Maybe<Scalars['Int']>;
  traineeEventId?: Maybe<Scalars['Int']>;
  traineeId?: Maybe<Scalars['Int']>;
  trainerEventId?: Maybe<Scalars['Int']>;
};

export type CertificateMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isEligible?: InputMaybe<SortOrder>;
  templateId?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  traineeId?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
};

export type CertificateOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CertificateOrderByWithAggregationInput = {
  _avg?: InputMaybe<CertificateAvgOrderByAggregateInput>;
  _count?: InputMaybe<CertificateCountOrderByAggregateInput>;
  _max?: InputMaybe<CertificateMaxOrderByAggregateInput>;
  _min?: InputMaybe<CertificateMinOrderByAggregateInput>;
  _sum?: InputMaybe<CertificateSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isEligible?: InputMaybe<SortOrder>;
  metaData?: InputMaybe<SortOrder>;
  templateId?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  traineeId?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
};

export type CertificateOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  event?: InputMaybe<EventOrderByWithRelationInput>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isEligible?: InputMaybe<SortOrder>;
  metaData?: InputMaybe<SortOrder>;
  template?: InputMaybe<TemplateOrderByWithRelationInput>;
  templateId?: InputMaybe<SortOrder>;
  trainee?: InputMaybe<UserOrderByWithRelationInput>;
  traineeEvent?: InputMaybe<TraineeEventOrderByWithRelationInput>;
  traineeEventId?: InputMaybe<SortOrder>;
  traineeId?: InputMaybe<SortOrder>;
  trainerEvent?: InputMaybe<TrainerEventOrderByWithRelationInput>;
  trainerEventId?: InputMaybe<SortOrder>;
};

export type CertificateRelationFilter = {
  is?: InputMaybe<CertificateWhereInput>;
  isNot?: InputMaybe<CertificateWhereInput>;
};

export enum CertificateScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  EventId = 'eventId',
  Id = 'id',
  IsEligible = 'isEligible',
  MetaData = 'metaData',
  TemplateId = 'templateId',
  TraineeEventId = 'traineeEventId',
  TraineeId = 'traineeId',
  TrainerEventId = 'trainerEventId'
}

export type CertificateScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<CertificateScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<CertificateScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CertificateScalarWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  eventId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  isEligible?: InputMaybe<BoolNullableFilter>;
  metaData?: InputMaybe<JsonNullableFilter>;
  templateId?: InputMaybe<IntNullableFilter>;
  traineeEventId?: InputMaybe<IntNullableFilter>;
  traineeId?: InputMaybe<IntNullableFilter>;
  trainerEventId?: InputMaybe<IntNullableFilter>;
};

export type CertificateScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<CertificateScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<CertificateScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CertificateScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  eventId?: InputMaybe<IntWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  isEligible?: InputMaybe<BoolNullableWithAggregatesFilter>;
  metaData?: InputMaybe<JsonNullableWithAggregatesFilter>;
  templateId?: InputMaybe<IntNullableWithAggregatesFilter>;
  traineeEventId?: InputMaybe<IntNullableWithAggregatesFilter>;
  traineeId?: InputMaybe<IntNullableWithAggregatesFilter>;
  trainerEventId?: InputMaybe<IntNullableWithAggregatesFilter>;
};

export type CertificateSumAggregateOutputType = {
  __typename?: 'CertificateSumAggregateOutputType';
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  templateId?: Maybe<Scalars['Int']>;
  traineeEventId?: Maybe<Scalars['Int']>;
  traineeId?: Maybe<Scalars['Int']>;
  trainerEventId?: Maybe<Scalars['Int']>;
};

export type CertificateSumOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  templateId?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  traineeId?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
};

export type CertificateSummery = {
  __typename?: 'CertificateSummery';
  traineeCertificate?: Maybe<Template>;
  traineeEvent?: Maybe<TraineeEvent>;
  trainerCertificate?: Maybe<Template>;
};

export type CertificateUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  isEligible?: InputMaybe<Scalars['Boolean']>;
  metaData?: InputMaybe<Scalars['Json']>;
  templateId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  traineeId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
};

export type CertificateUncheckedCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<CertificateWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CertificateCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<CertificateCreateWithoutEventInput>>>;
  createMany?: InputMaybe<CertificateCreateManyEventInputEnvelope>;
};

export type CertificateUncheckedCreateNestedManyWithoutTemplateInput = {
  connect?: InputMaybe<Array<InputMaybe<CertificateWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CertificateCreateOrConnectWithoutTemplateInput>>>;
  create?: InputMaybe<Array<InputMaybe<CertificateCreateWithoutTemplateInput>>>;
  createMany?: InputMaybe<CertificateCreateManyTemplateInputEnvelope>;
};

export type CertificateUncheckedCreateNestedManyWithoutTraineeInput = {
  connect?: InputMaybe<Array<InputMaybe<CertificateWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CertificateCreateOrConnectWithoutTraineeInput>>>;
  create?: InputMaybe<Array<InputMaybe<CertificateCreateWithoutTraineeInput>>>;
  createMany?: InputMaybe<CertificateCreateManyTraineeInputEnvelope>;
};

export type CertificateUncheckedCreateNestedOneWithoutTraineeEventInput = {
  connect?: InputMaybe<CertificateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateCreateOrConnectWithoutTraineeEventInput>;
  create?: InputMaybe<CertificateUncheckedCreateWithoutTraineeEventInput>;
};

export type CertificateUncheckedCreateNestedOneWithoutTrainerEventInput = {
  connect?: InputMaybe<CertificateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateCreateOrConnectWithoutTrainerEventInput>;
  create?: InputMaybe<CertificateUncheckedCreateWithoutTrainerEventInput>;
};

export type CertificateUncheckedCreateWithoutEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  isEligible?: InputMaybe<Scalars['Boolean']>;
  metaData?: InputMaybe<Scalars['Json']>;
  templateId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  traineeId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
};

export type CertificateUncheckedCreateWithoutTemplateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  isEligible?: InputMaybe<Scalars['Boolean']>;
  metaData?: InputMaybe<Scalars['Json']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  traineeId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
};

export type CertificateUncheckedCreateWithoutTraineeEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  isEligible?: InputMaybe<Scalars['Boolean']>;
  metaData?: InputMaybe<Scalars['Json']>;
  templateId?: InputMaybe<Scalars['Int']>;
  traineeId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
};

export type CertificateUncheckedCreateWithoutTraineeInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  isEligible?: InputMaybe<Scalars['Boolean']>;
  metaData?: InputMaybe<Scalars['Json']>;
  templateId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
};

export type CertificateUncheckedCreateWithoutTrainerEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  isEligible?: InputMaybe<Scalars['Boolean']>;
  metaData?: InputMaybe<Scalars['Json']>;
  templateId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  traineeId?: InputMaybe<Scalars['Int']>;
};

export type CertificateUncheckedUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isEligible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metaData?: InputMaybe<Scalars['Json']>;
  templateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type CertificateUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isEligible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metaData?: InputMaybe<Scalars['Json']>;
  templateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type CertificateUncheckedUpdateManyWithoutCertificateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isEligible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metaData?: InputMaybe<Scalars['Json']>;
  templateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type CertificateUncheckedUpdateManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<CertificateWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CertificateCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<CertificateCreateWithoutEventInput>>>;
  createMany?: InputMaybe<CertificateCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<CertificateWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CertificateScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CertificateWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CertificateWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CertificateUpdateWithWhereUniqueWithoutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CertificateUpdateManyWithWhereWithoutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CertificateUpsertWithWhereUniqueWithoutEventInput>>>;
};

export type CertificateUncheckedUpdateManyWithoutTemplateInput = {
  connect?: InputMaybe<Array<InputMaybe<CertificateWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CertificateCreateOrConnectWithoutTemplateInput>>>;
  create?: InputMaybe<Array<InputMaybe<CertificateCreateWithoutTemplateInput>>>;
  createMany?: InputMaybe<CertificateCreateManyTemplateInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<CertificateWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CertificateScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CertificateWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CertificateWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CertificateUpdateWithWhereUniqueWithoutTemplateInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CertificateUpdateManyWithWhereWithoutTemplateInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CertificateUpsertWithWhereUniqueWithoutTemplateInput>>>;
};

export type CertificateUncheckedUpdateManyWithoutTraineeInput = {
  connect?: InputMaybe<Array<InputMaybe<CertificateWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CertificateCreateOrConnectWithoutTraineeInput>>>;
  create?: InputMaybe<Array<InputMaybe<CertificateCreateWithoutTraineeInput>>>;
  createMany?: InputMaybe<CertificateCreateManyTraineeInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<CertificateWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CertificateScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CertificateWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CertificateWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CertificateUpdateWithWhereUniqueWithoutTraineeInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CertificateUpdateManyWithWhereWithoutTraineeInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CertificateUpsertWithWhereUniqueWithoutTraineeInput>>>;
};

export type CertificateUncheckedUpdateOneWithoutTraineeEventInput = {
  connect?: InputMaybe<CertificateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateCreateOrConnectWithoutTraineeEventInput>;
  create?: InputMaybe<CertificateUncheckedCreateWithoutTraineeEventInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CertificateUncheckedUpdateWithoutTraineeEventInput>;
  upsert?: InputMaybe<CertificateUpsertWithoutTraineeEventInput>;
};

export type CertificateUncheckedUpdateOneWithoutTrainerEventInput = {
  connect?: InputMaybe<CertificateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateCreateOrConnectWithoutTrainerEventInput>;
  create?: InputMaybe<CertificateUncheckedCreateWithoutTrainerEventInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CertificateUncheckedUpdateWithoutTrainerEventInput>;
  upsert?: InputMaybe<CertificateUpsertWithoutTrainerEventInput>;
};

export type CertificateUncheckedUpdateWithoutEventInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isEligible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metaData?: InputMaybe<Scalars['Json']>;
  templateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type CertificateUncheckedUpdateWithoutTemplateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isEligible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metaData?: InputMaybe<Scalars['Json']>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type CertificateUncheckedUpdateWithoutTraineeEventInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isEligible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metaData?: InputMaybe<Scalars['Json']>;
  templateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type CertificateUncheckedUpdateWithoutTraineeInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isEligible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metaData?: InputMaybe<Scalars['Json']>;
  templateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type CertificateUncheckedUpdateWithoutTrainerEventInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isEligible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metaData?: InputMaybe<Scalars['Json']>;
  templateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type CertificateUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutCertificateInput>;
  isEligible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metaData?: InputMaybe<Scalars['Json']>;
  template?: InputMaybe<TemplateUpdateOneWithoutCertificateInput>;
  trainee?: InputMaybe<UserUpdateOneWithoutCertificateInput>;
  traineeEvent?: InputMaybe<TraineeEventUpdateOneWithoutCertificateInput>;
  trainerEvent?: InputMaybe<TrainerEventUpdateOneWithoutCertificateInput>;
};

export type CertificateUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  isEligible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metaData?: InputMaybe<Scalars['Json']>;
};

export type CertificateUpdateManyWithWhereWithoutEventInput = {
  data: CertificateUncheckedUpdateManyWithoutCertificateInput;
  where: CertificateScalarWhereInput;
};

export type CertificateUpdateManyWithWhereWithoutTemplateInput = {
  data: CertificateUncheckedUpdateManyWithoutCertificateInput;
  where: CertificateScalarWhereInput;
};

export type CertificateUpdateManyWithWhereWithoutTraineeInput = {
  data: CertificateUncheckedUpdateManyWithoutCertificateInput;
  where: CertificateScalarWhereInput;
};

export type CertificateUpdateManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<CertificateWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CertificateCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<CertificateCreateWithoutEventInput>>>;
  createMany?: InputMaybe<CertificateCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<CertificateWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CertificateScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CertificateWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CertificateWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CertificateUpdateWithWhereUniqueWithoutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CertificateUpdateManyWithWhereWithoutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CertificateUpsertWithWhereUniqueWithoutEventInput>>>;
};

export type CertificateUpdateManyWithoutTemplateInput = {
  connect?: InputMaybe<Array<InputMaybe<CertificateWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CertificateCreateOrConnectWithoutTemplateInput>>>;
  create?: InputMaybe<Array<InputMaybe<CertificateCreateWithoutTemplateInput>>>;
  createMany?: InputMaybe<CertificateCreateManyTemplateInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<CertificateWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CertificateScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CertificateWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CertificateWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CertificateUpdateWithWhereUniqueWithoutTemplateInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CertificateUpdateManyWithWhereWithoutTemplateInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CertificateUpsertWithWhereUniqueWithoutTemplateInput>>>;
};

export type CertificateUpdateManyWithoutTraineeInput = {
  connect?: InputMaybe<Array<InputMaybe<CertificateWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CertificateCreateOrConnectWithoutTraineeInput>>>;
  create?: InputMaybe<Array<InputMaybe<CertificateCreateWithoutTraineeInput>>>;
  createMany?: InputMaybe<CertificateCreateManyTraineeInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<CertificateWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CertificateScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CertificateWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CertificateWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CertificateUpdateWithWhereUniqueWithoutTraineeInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CertificateUpdateManyWithWhereWithoutTraineeInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CertificateUpsertWithWhereUniqueWithoutTraineeInput>>>;
};

export type CertificateUpdateOneWithoutTraineeEventInput = {
  connect?: InputMaybe<CertificateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateCreateOrConnectWithoutTraineeEventInput>;
  create?: InputMaybe<CertificateUncheckedCreateWithoutTraineeEventInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CertificateUncheckedUpdateWithoutTraineeEventInput>;
  upsert?: InputMaybe<CertificateUpsertWithoutTraineeEventInput>;
};

export type CertificateUpdateOneWithoutTrainerEventInput = {
  connect?: InputMaybe<CertificateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateCreateOrConnectWithoutTrainerEventInput>;
  create?: InputMaybe<CertificateUncheckedCreateWithoutTrainerEventInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CertificateUncheckedUpdateWithoutTrainerEventInput>;
  upsert?: InputMaybe<CertificateUpsertWithoutTrainerEventInput>;
};

export type CertificateUpdateWithWhereUniqueWithoutEventInput = {
  data: CertificateUncheckedUpdateWithoutEventInput;
  where: CertificateWhereUniqueInput;
};

export type CertificateUpdateWithWhereUniqueWithoutTemplateInput = {
  data: CertificateUncheckedUpdateWithoutTemplateInput;
  where: CertificateWhereUniqueInput;
};

export type CertificateUpdateWithWhereUniqueWithoutTraineeInput = {
  data: CertificateUncheckedUpdateWithoutTraineeInput;
  where: CertificateWhereUniqueInput;
};

export type CertificateUpdateWithoutEventInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  isEligible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metaData?: InputMaybe<Scalars['Json']>;
  template?: InputMaybe<TemplateUpdateOneWithoutCertificateInput>;
  trainee?: InputMaybe<UserUpdateOneWithoutCertificateInput>;
  traineeEvent?: InputMaybe<TraineeEventUpdateOneWithoutCertificateInput>;
  trainerEvent?: InputMaybe<TrainerEventUpdateOneWithoutCertificateInput>;
};

export type CertificateUpdateWithoutTemplateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutCertificateInput>;
  isEligible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metaData?: InputMaybe<Scalars['Json']>;
  trainee?: InputMaybe<UserUpdateOneWithoutCertificateInput>;
  traineeEvent?: InputMaybe<TraineeEventUpdateOneWithoutCertificateInput>;
  trainerEvent?: InputMaybe<TrainerEventUpdateOneWithoutCertificateInput>;
};

export type CertificateUpdateWithoutTraineeEventInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutCertificateInput>;
  isEligible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metaData?: InputMaybe<Scalars['Json']>;
  template?: InputMaybe<TemplateUpdateOneWithoutCertificateInput>;
  trainee?: InputMaybe<UserUpdateOneWithoutCertificateInput>;
  trainerEvent?: InputMaybe<TrainerEventUpdateOneWithoutCertificateInput>;
};

export type CertificateUpdateWithoutTraineeInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutCertificateInput>;
  isEligible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metaData?: InputMaybe<Scalars['Json']>;
  template?: InputMaybe<TemplateUpdateOneWithoutCertificateInput>;
  traineeEvent?: InputMaybe<TraineeEventUpdateOneWithoutCertificateInput>;
  trainerEvent?: InputMaybe<TrainerEventUpdateOneWithoutCertificateInput>;
};

export type CertificateUpdateWithoutTrainerEventInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutCertificateInput>;
  isEligible?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metaData?: InputMaybe<Scalars['Json']>;
  template?: InputMaybe<TemplateUpdateOneWithoutCertificateInput>;
  trainee?: InputMaybe<UserUpdateOneWithoutCertificateInput>;
  traineeEvent?: InputMaybe<TraineeEventUpdateOneWithoutCertificateInput>;
};

export type CertificateUpsertWithWhereUniqueWithoutEventInput = {
  create: CertificateUncheckedCreateWithoutEventInput;
  update: CertificateUncheckedUpdateWithoutEventInput;
  where: CertificateWhereUniqueInput;
};

export type CertificateUpsertWithWhereUniqueWithoutTemplateInput = {
  create: CertificateUncheckedCreateWithoutTemplateInput;
  update: CertificateUncheckedUpdateWithoutTemplateInput;
  where: CertificateWhereUniqueInput;
};

export type CertificateUpsertWithWhereUniqueWithoutTraineeInput = {
  create: CertificateUncheckedCreateWithoutTraineeInput;
  update: CertificateUncheckedUpdateWithoutTraineeInput;
  where: CertificateWhereUniqueInput;
};

export type CertificateUpsertWithoutTraineeEventInput = {
  create: CertificateUncheckedCreateWithoutTraineeEventInput;
  update: CertificateUncheckedUpdateWithoutTraineeEventInput;
};

export type CertificateUpsertWithoutTrainerEventInput = {
  create: CertificateUncheckedCreateWithoutTrainerEventInput;
  update: CertificateUncheckedUpdateWithoutTrainerEventInput;
};

export type CertificateWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<CertificateWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<CertificateWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CertificateWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  event?: InputMaybe<EventWhereInput>;
  eventId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  isEligible?: InputMaybe<BoolNullableFilter>;
  metaData?: InputMaybe<JsonNullableFilter>;
  template?: InputMaybe<TemplateWhereInput>;
  templateId?: InputMaybe<IntNullableFilter>;
  trainee?: InputMaybe<UserWhereInput>;
  traineeEvent?: InputMaybe<TraineeEventWhereInput>;
  traineeEventId?: InputMaybe<IntNullableFilter>;
  traineeId?: InputMaybe<IntNullableFilter>;
  trainerEvent?: InputMaybe<TrainerEventWhereInput>;
  trainerEventId?: InputMaybe<IntNullableFilter>;
};

export type CertificateWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
};

export type City = {
  __typename?: 'City';
  _count: CityCountOutputType;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  events: Array<Event>;
  id: Scalars['Int'];
  latitude?: Maybe<Scalars['Decimal']>;
  longitude?: Maybe<Scalars['Decimal']>;
  name: Scalars['String'];
  stateId?: Maybe<Scalars['Int']>;
  states?: Maybe<State>;
  users: Array<User>;
};


export type CityEventsArgs = {
  cursor?: InputMaybe<EventWhereUniqueInput>;
  distinct?: InputMaybe<EventScalarFieldEnum>;
  orderBy?: InputMaybe<EventOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EventWhereInput>;
};


export type CityUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<UserScalarFieldEnum>;
  orderBy?: InputMaybe<UserOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};

export type CityAvgAggregateOutputType = {
  __typename?: 'CityAvgAggregateOutputType';
  countryId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Decimal']>;
  longitude?: Maybe<Scalars['Decimal']>;
  stateId?: Maybe<Scalars['Float']>;
};

export type CityAvgOrderByAggregateInput = {
  countryId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  latitude?: InputMaybe<SortOrder>;
  longitude?: InputMaybe<SortOrder>;
  stateId?: InputMaybe<SortOrder>;
};

export type CityCountAggregateOutputType = {
  __typename?: 'CityCountAggregateOutputType';
  _all: Scalars['Int'];
  countryId: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  latitude: Scalars['Int'];
  longitude: Scalars['Int'];
  name: Scalars['Int'];
  nameAr: Scalars['Int'];
  stateId: Scalars['Int'];
};

export type CityCountOrderByAggregateInput = {
  countryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  latitude?: InputMaybe<SortOrder>;
  longitude?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nameAr?: InputMaybe<SortOrder>;
  stateId?: InputMaybe<SortOrder>;
};

export type CityCountOutputType = {
  __typename?: 'CityCountOutputType';
  events: Scalars['Int'];
  users: Scalars['Int'];
};

export type CityCreateInput = {
  country?: InputMaybe<CountryCreateNestedOneWithoutCitiesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<EventCreateNestedManyWithoutCityInput>;
  latitude?: InputMaybe<Scalars['Decimal']>;
  longitude?: InputMaybe<Scalars['Decimal']>;
  name: Scalars['String'];
  nameAr?: InputMaybe<Scalars['String']>;
  states?: InputMaybe<StateCreateNestedOneWithoutCitiesInput>;
  users?: InputMaybe<UserCreateNestedManyWithoutCityInput>;
};

export type CityCreateManyCountryInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['Decimal']>;
  longitude?: InputMaybe<Scalars['Decimal']>;
  name: Scalars['String'];
  nameAr?: InputMaybe<Scalars['String']>;
  stateId?: InputMaybe<Scalars['Int']>;
};

export type CityCreateManyCountryInputEnvelope = {
  data: CityCreateManyCountryInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CityCreateManyInput = {
  countryId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['Decimal']>;
  longitude?: InputMaybe<Scalars['Decimal']>;
  name: Scalars['String'];
  nameAr?: InputMaybe<Scalars['String']>;
  stateId?: InputMaybe<Scalars['Int']>;
};

export type CityCreateManyStatesInput = {
  countryId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['Decimal']>;
  longitude?: InputMaybe<Scalars['Decimal']>;
  name: Scalars['String'];
  nameAr?: InputMaybe<Scalars['String']>;
};

export type CityCreateManyStatesInputEnvelope = {
  data: CityCreateManyStatesInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CityCreateNestedManyWithoutCountryInput = {
  connect?: InputMaybe<Array<InputMaybe<CityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CityCreateOrConnectWithoutCountryInput>>>;
  create?: InputMaybe<Array<InputMaybe<CityCreateWithoutCountryInput>>>;
  createMany?: InputMaybe<CityCreateManyCountryInputEnvelope>;
};

export type CityCreateNestedManyWithoutStatesInput = {
  connect?: InputMaybe<Array<InputMaybe<CityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CityCreateOrConnectWithoutStatesInput>>>;
  create?: InputMaybe<Array<InputMaybe<CityCreateWithoutStatesInput>>>;
  createMany?: InputMaybe<CityCreateManyStatesInputEnvelope>;
};

export type CityCreateNestedOneWithoutEventsInput = {
  connect?: InputMaybe<CityWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CityCreateOrConnectWithoutEventsInput>;
  create?: InputMaybe<CityUncheckedCreateWithoutEventsInput>;
};

export type CityCreateNestedOneWithoutUsersInput = {
  connect?: InputMaybe<CityWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CityCreateOrConnectWithoutUsersInput>;
  create?: InputMaybe<CityUncheckedCreateWithoutUsersInput>;
};

export type CityCreateOrConnectWithoutCountryInput = {
  create: CityUncheckedCreateWithoutCountryInput;
  where: CityWhereUniqueInput;
};

export type CityCreateOrConnectWithoutEventsInput = {
  create: CityUncheckedCreateWithoutEventsInput;
  where: CityWhereUniqueInput;
};

export type CityCreateOrConnectWithoutStatesInput = {
  create: CityUncheckedCreateWithoutStatesInput;
  where: CityWhereUniqueInput;
};

export type CityCreateOrConnectWithoutUsersInput = {
  create: CityUncheckedCreateWithoutUsersInput;
  where: CityWhereUniqueInput;
};

export type CityCreateWithoutCountryInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<EventCreateNestedManyWithoutCityInput>;
  latitude?: InputMaybe<Scalars['Decimal']>;
  longitude?: InputMaybe<Scalars['Decimal']>;
  name: Scalars['String'];
  nameAr?: InputMaybe<Scalars['String']>;
  states?: InputMaybe<StateCreateNestedOneWithoutCitiesInput>;
  users?: InputMaybe<UserCreateNestedManyWithoutCityInput>;
};

export type CityCreateWithoutEventsInput = {
  country?: InputMaybe<CountryCreateNestedOneWithoutCitiesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  latitude?: InputMaybe<Scalars['Decimal']>;
  longitude?: InputMaybe<Scalars['Decimal']>;
  name: Scalars['String'];
  nameAr?: InputMaybe<Scalars['String']>;
  states?: InputMaybe<StateCreateNestedOneWithoutCitiesInput>;
  users?: InputMaybe<UserCreateNestedManyWithoutCityInput>;
};

export type CityCreateWithoutStatesInput = {
  country?: InputMaybe<CountryCreateNestedOneWithoutCitiesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<EventCreateNestedManyWithoutCityInput>;
  latitude?: InputMaybe<Scalars['Decimal']>;
  longitude?: InputMaybe<Scalars['Decimal']>;
  name: Scalars['String'];
  nameAr?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<UserCreateNestedManyWithoutCityInput>;
};

export type CityCreateWithoutUsersInput = {
  country?: InputMaybe<CountryCreateNestedOneWithoutCitiesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<EventCreateNestedManyWithoutCityInput>;
  latitude?: InputMaybe<Scalars['Decimal']>;
  longitude?: InputMaybe<Scalars['Decimal']>;
  name: Scalars['String'];
  nameAr?: InputMaybe<Scalars['String']>;
  states?: InputMaybe<StateCreateNestedOneWithoutCitiesInput>;
};

export type CityListRelationFilter = {
  every?: InputMaybe<CityWhereInput>;
  none?: InputMaybe<CityWhereInput>;
  some?: InputMaybe<CityWhereInput>;
};

export type CityMaxAggregateOutputType = {
  __typename?: 'CityMaxAggregateOutputType';
  countryId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  latitude?: Maybe<Scalars['Decimal']>;
  longitude?: Maybe<Scalars['Decimal']>;
  name?: Maybe<Scalars['String']>;
  nameAr?: Maybe<Scalars['String']>;
  stateId?: Maybe<Scalars['Int']>;
};

export type CityMaxOrderByAggregateInput = {
  countryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  latitude?: InputMaybe<SortOrder>;
  longitude?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nameAr?: InputMaybe<SortOrder>;
  stateId?: InputMaybe<SortOrder>;
};

export type CityMinAggregateOutputType = {
  __typename?: 'CityMinAggregateOutputType';
  countryId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  latitude?: Maybe<Scalars['Decimal']>;
  longitude?: Maybe<Scalars['Decimal']>;
  name?: Maybe<Scalars['String']>;
  nameAr?: Maybe<Scalars['String']>;
  stateId?: Maybe<Scalars['Int']>;
};

export type CityMinOrderByAggregateInput = {
  countryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  latitude?: InputMaybe<SortOrder>;
  longitude?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nameAr?: InputMaybe<SortOrder>;
  stateId?: InputMaybe<SortOrder>;
};

export type CityOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CityOrderByWithAggregationInput = {
  _avg?: InputMaybe<CityAvgOrderByAggregateInput>;
  _count?: InputMaybe<CityCountOrderByAggregateInput>;
  _max?: InputMaybe<CityMaxOrderByAggregateInput>;
  _min?: InputMaybe<CityMinOrderByAggregateInput>;
  _sum?: InputMaybe<CitySumOrderByAggregateInput>;
  countryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  latitude?: InputMaybe<SortOrder>;
  longitude?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nameAr?: InputMaybe<SortOrder>;
  stateId?: InputMaybe<SortOrder>;
};

export type CityOrderByWithRelationInput = {
  country?: InputMaybe<CountryOrderByWithRelationInput>;
  countryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  events?: InputMaybe<EventOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  latitude?: InputMaybe<SortOrder>;
  longitude?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nameAr?: InputMaybe<SortOrder>;
  stateId?: InputMaybe<SortOrder>;
  states?: InputMaybe<StateOrderByWithRelationInput>;
  users?: InputMaybe<UserOrderByRelationAggregateInput>;
};

export type CityRelationFilter = {
  is?: InputMaybe<CityWhereInput>;
  isNot?: InputMaybe<CityWhereInput>;
};

export enum CityScalarFieldEnum {
  CountryId = 'countryId',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  Latitude = 'latitude',
  Longitude = 'longitude',
  Name = 'name',
  NameAr = 'nameAr',
  StateId = 'stateId'
}

export type CityScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<CityScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<CityScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CityScalarWhereInput>>>;
  countryId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  latitude?: InputMaybe<DecimalNullableFilter>;
  longitude?: InputMaybe<DecimalNullableFilter>;
  name?: InputMaybe<StringFilter>;
  nameAr?: InputMaybe<StringNullableFilter>;
  stateId?: InputMaybe<IntNullableFilter>;
};

export type CityScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<CityScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<CityScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CityScalarWhereWithAggregatesInput>>>;
  countryId?: InputMaybe<IntNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  latitude?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  longitude?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  nameAr?: InputMaybe<StringNullableWithAggregatesFilter>;
  stateId?: InputMaybe<IntNullableWithAggregatesFilter>;
};

export type CitySumAggregateOutputType = {
  __typename?: 'CitySumAggregateOutputType';
  countryId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  latitude?: Maybe<Scalars['Decimal']>;
  longitude?: Maybe<Scalars['Decimal']>;
  stateId?: Maybe<Scalars['Int']>;
};

export type CitySumOrderByAggregateInput = {
  countryId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  latitude?: InputMaybe<SortOrder>;
  longitude?: InputMaybe<SortOrder>;
  stateId?: InputMaybe<SortOrder>;
};

export type CityUncheckedCreateInput = {
  countryId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutCityInput>;
  id?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['Decimal']>;
  longitude?: InputMaybe<Scalars['Decimal']>;
  name: Scalars['String'];
  nameAr?: InputMaybe<Scalars['String']>;
  stateId?: InputMaybe<Scalars['Int']>;
  users?: InputMaybe<UserUncheckedCreateNestedManyWithoutCityInput>;
};

export type CityUncheckedCreateNestedManyWithoutCountryInput = {
  connect?: InputMaybe<Array<InputMaybe<CityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CityCreateOrConnectWithoutCountryInput>>>;
  create?: InputMaybe<Array<InputMaybe<CityCreateWithoutCountryInput>>>;
  createMany?: InputMaybe<CityCreateManyCountryInputEnvelope>;
};

export type CityUncheckedCreateNestedManyWithoutStatesInput = {
  connect?: InputMaybe<Array<InputMaybe<CityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CityCreateOrConnectWithoutStatesInput>>>;
  create?: InputMaybe<Array<InputMaybe<CityCreateWithoutStatesInput>>>;
  createMany?: InputMaybe<CityCreateManyStatesInputEnvelope>;
};

export type CityUncheckedCreateWithoutCountryInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutCityInput>;
  id?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['Decimal']>;
  longitude?: InputMaybe<Scalars['Decimal']>;
  name: Scalars['String'];
  nameAr?: InputMaybe<Scalars['String']>;
  stateId?: InputMaybe<Scalars['Int']>;
  users?: InputMaybe<UserUncheckedCreateNestedManyWithoutCityInput>;
};

export type CityUncheckedCreateWithoutEventsInput = {
  countryId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['Decimal']>;
  longitude?: InputMaybe<Scalars['Decimal']>;
  name: Scalars['String'];
  nameAr?: InputMaybe<Scalars['String']>;
  stateId?: InputMaybe<Scalars['Int']>;
  users?: InputMaybe<UserUncheckedCreateNestedManyWithoutCityInput>;
};

export type CityUncheckedCreateWithoutStatesInput = {
  countryId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutCityInput>;
  id?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['Decimal']>;
  longitude?: InputMaybe<Scalars['Decimal']>;
  name: Scalars['String'];
  nameAr?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<UserUncheckedCreateNestedManyWithoutCityInput>;
};

export type CityUncheckedCreateWithoutUsersInput = {
  countryId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutCityInput>;
  id?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['Decimal']>;
  longitude?: InputMaybe<Scalars['Decimal']>;
  name: Scalars['String'];
  nameAr?: InputMaybe<Scalars['String']>;
  stateId?: InputMaybe<Scalars['Int']>;
};

export type CityUncheckedUpdateInput = {
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutCityInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  latitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  longitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUncheckedUpdateManyWithoutCityInput>;
};

export type CityUncheckedUpdateManyInput = {
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  latitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  longitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type CityUncheckedUpdateManyWithoutCitiesInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  latitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  longitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type CityUncheckedUpdateManyWithoutCountryInput = {
  connect?: InputMaybe<Array<InputMaybe<CityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CityCreateOrConnectWithoutCountryInput>>>;
  create?: InputMaybe<Array<InputMaybe<CityCreateWithoutCountryInput>>>;
  createMany?: InputMaybe<CityCreateManyCountryInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<CityWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CityScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CityWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CityWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CityUpdateWithWhereUniqueWithoutCountryInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CityUpdateManyWithWhereWithoutCountryInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CityUpsertWithWhereUniqueWithoutCountryInput>>>;
};

export type CityUncheckedUpdateManyWithoutStatesInput = {
  connect?: InputMaybe<Array<InputMaybe<CityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CityCreateOrConnectWithoutStatesInput>>>;
  create?: InputMaybe<Array<InputMaybe<CityCreateWithoutStatesInput>>>;
  createMany?: InputMaybe<CityCreateManyStatesInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<CityWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CityScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CityWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CityWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CityUpdateWithWhereUniqueWithoutStatesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CityUpdateManyWithWhereWithoutStatesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CityUpsertWithWhereUniqueWithoutStatesInput>>>;
};

export type CityUncheckedUpdateWithoutCountryInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutCityInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  latitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  longitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUncheckedUpdateManyWithoutCityInput>;
};

export type CityUncheckedUpdateWithoutEventsInput = {
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  latitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  longitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUncheckedUpdateManyWithoutCityInput>;
};

export type CityUncheckedUpdateWithoutStatesInput = {
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutCityInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  latitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  longitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUncheckedUpdateManyWithoutCityInput>;
};

export type CityUncheckedUpdateWithoutUsersInput = {
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutCityInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  latitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  longitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type CityUpdateInput = {
  country?: InputMaybe<CountryUpdateOneWithoutCitiesInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventUpdateManyWithoutCityInput>;
  latitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  longitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  states?: InputMaybe<StateUpdateOneWithoutCitiesInput>;
  users?: InputMaybe<UserUpdateManyWithoutCityInput>;
};

export type CityUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  latitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  longitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CityUpdateManyWithWhereWithoutCountryInput = {
  data: CityUncheckedUpdateManyWithoutCitiesInput;
  where: CityScalarWhereInput;
};

export type CityUpdateManyWithWhereWithoutStatesInput = {
  data: CityUncheckedUpdateManyWithoutCitiesInput;
  where: CityScalarWhereInput;
};

export type CityUpdateManyWithoutCountryInput = {
  connect?: InputMaybe<Array<InputMaybe<CityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CityCreateOrConnectWithoutCountryInput>>>;
  create?: InputMaybe<Array<InputMaybe<CityCreateWithoutCountryInput>>>;
  createMany?: InputMaybe<CityCreateManyCountryInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<CityWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CityScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CityWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CityWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CityUpdateWithWhereUniqueWithoutCountryInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CityUpdateManyWithWhereWithoutCountryInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CityUpsertWithWhereUniqueWithoutCountryInput>>>;
};

export type CityUpdateManyWithoutStatesInput = {
  connect?: InputMaybe<Array<InputMaybe<CityWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CityCreateOrConnectWithoutStatesInput>>>;
  create?: InputMaybe<Array<InputMaybe<CityCreateWithoutStatesInput>>>;
  createMany?: InputMaybe<CityCreateManyStatesInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<CityWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CityScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CityWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CityWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CityUpdateWithWhereUniqueWithoutStatesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CityUpdateManyWithWhereWithoutStatesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CityUpsertWithWhereUniqueWithoutStatesInput>>>;
};

export type CityUpdateOneWithoutEventsInput = {
  connect?: InputMaybe<CityWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CityCreateOrConnectWithoutEventsInput>;
  create?: InputMaybe<CityUncheckedCreateWithoutEventsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CityUncheckedUpdateWithoutEventsInput>;
  upsert?: InputMaybe<CityUpsertWithoutEventsInput>;
};

export type CityUpdateOneWithoutUsersInput = {
  connect?: InputMaybe<CityWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CityCreateOrConnectWithoutUsersInput>;
  create?: InputMaybe<CityUncheckedCreateWithoutUsersInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CityUncheckedUpdateWithoutUsersInput>;
  upsert?: InputMaybe<CityUpsertWithoutUsersInput>;
};

export type CityUpdateWithWhereUniqueWithoutCountryInput = {
  data: CityUncheckedUpdateWithoutCountryInput;
  where: CityWhereUniqueInput;
};

export type CityUpdateWithWhereUniqueWithoutStatesInput = {
  data: CityUncheckedUpdateWithoutStatesInput;
  where: CityWhereUniqueInput;
};

export type CityUpdateWithoutCountryInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventUpdateManyWithoutCityInput>;
  latitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  longitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  states?: InputMaybe<StateUpdateOneWithoutCitiesInput>;
  users?: InputMaybe<UserUpdateManyWithoutCityInput>;
};

export type CityUpdateWithoutEventsInput = {
  country?: InputMaybe<CountryUpdateOneWithoutCitiesInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  latitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  longitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  states?: InputMaybe<StateUpdateOneWithoutCitiesInput>;
  users?: InputMaybe<UserUpdateManyWithoutCityInput>;
};

export type CityUpdateWithoutStatesInput = {
  country?: InputMaybe<CountryUpdateOneWithoutCitiesInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventUpdateManyWithoutCityInput>;
  latitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  longitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUpdateManyWithoutCityInput>;
};

export type CityUpdateWithoutUsersInput = {
  country?: InputMaybe<CountryUpdateOneWithoutCitiesInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventUpdateManyWithoutCityInput>;
  latitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  longitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  states?: InputMaybe<StateUpdateOneWithoutCitiesInput>;
};

export type CityUpsertWithWhereUniqueWithoutCountryInput = {
  create: CityUncheckedCreateWithoutCountryInput;
  update: CityUncheckedUpdateWithoutCountryInput;
  where: CityWhereUniqueInput;
};

export type CityUpsertWithWhereUniqueWithoutStatesInput = {
  create: CityUncheckedCreateWithoutStatesInput;
  update: CityUncheckedUpdateWithoutStatesInput;
  where: CityWhereUniqueInput;
};

export type CityUpsertWithoutEventsInput = {
  create: CityUncheckedCreateWithoutEventsInput;
  update: CityUncheckedUpdateWithoutEventsInput;
};

export type CityUpsertWithoutUsersInput = {
  create: CityUncheckedCreateWithoutUsersInput;
  update: CityUncheckedUpdateWithoutUsersInput;
};

export type CityWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<CityWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<CityWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CityWhereInput>>>;
  country?: InputMaybe<CountryWhereInput>;
  countryId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  events?: InputMaybe<EventListRelationFilter>;
  id?: InputMaybe<IntFilter>;
  latitude?: InputMaybe<DecimalNullableFilter>;
  longitude?: InputMaybe<DecimalNullableFilter>;
  name?: InputMaybe<StringFilter>;
  nameAr?: InputMaybe<StringNullableFilter>;
  stateId?: InputMaybe<IntNullableFilter>;
  states?: InputMaybe<StateWhereInput>;
  users?: InputMaybe<UserListRelationFilter>;
};

export type CityWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type ContactUsData = {
  __typename?: 'ContactUsData';
  attachment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['Int'];
  isRead?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  message: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  reason: Scalars['String'];
  subject: Scalars['String'];
};

export type ContactUsDataAvgAggregateOutputType = {
  __typename?: 'ContactUsDataAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
};

export type ContactUsDataAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type ContactUsDataCountAggregateOutputType = {
  __typename?: 'ContactUsDataCountAggregateOutputType';
  _all: Scalars['Int'];
  attachment: Scalars['Int'];
  email: Scalars['Int'];
  firstName: Scalars['Int'];
  id: Scalars['Int'];
  isRead: Scalars['Int'];
  lastName: Scalars['Int'];
  message: Scalars['Int'];
  phoneNumber: Scalars['Int'];
  reason: Scalars['Int'];
  subject: Scalars['Int'];
};

export type ContactUsDataCountOrderByAggregateInput = {
  attachment?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isRead?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  reason?: InputMaybe<SortOrder>;
  subject?: InputMaybe<SortOrder>;
};

export type ContactUsDataCreateInput = {
  attachment?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  isRead?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
};

export type ContactUsDataCreateManyInput = {
  attachment?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isRead?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
};

export type ContactUsDataMaxAggregateOutputType = {
  __typename?: 'ContactUsDataMaxAggregateOutputType';
  attachment?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isRead?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
};

export type ContactUsDataMaxOrderByAggregateInput = {
  attachment?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isRead?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  reason?: InputMaybe<SortOrder>;
  subject?: InputMaybe<SortOrder>;
};

export type ContactUsDataMinAggregateOutputType = {
  __typename?: 'ContactUsDataMinAggregateOutputType';
  attachment?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isRead?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
};

export type ContactUsDataMinOrderByAggregateInput = {
  attachment?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isRead?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  reason?: InputMaybe<SortOrder>;
  subject?: InputMaybe<SortOrder>;
};

export type ContactUsDataOrderByWithAggregationInput = {
  _avg?: InputMaybe<ContactUsDataAvgOrderByAggregateInput>;
  _count?: InputMaybe<ContactUsDataCountOrderByAggregateInput>;
  _max?: InputMaybe<ContactUsDataMaxOrderByAggregateInput>;
  _min?: InputMaybe<ContactUsDataMinOrderByAggregateInput>;
  _sum?: InputMaybe<ContactUsDataSumOrderByAggregateInput>;
  attachment?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isRead?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  reason?: InputMaybe<SortOrder>;
  subject?: InputMaybe<SortOrder>;
};

export type ContactUsDataOrderByWithRelationInput = {
  attachment?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isRead?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  reason?: InputMaybe<SortOrder>;
  subject?: InputMaybe<SortOrder>;
};

export enum ContactUsDataScalarFieldEnum {
  Attachment = 'attachment',
  Email = 'email',
  FirstName = 'firstName',
  Id = 'id',
  IsRead = 'isRead',
  LastName = 'lastName',
  Message = 'message',
  PhoneNumber = 'phoneNumber',
  Reason = 'reason',
  Subject = 'subject'
}

export type ContactUsDataScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<ContactUsDataScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ContactUsDataScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ContactUsDataScalarWhereWithAggregatesInput>>>;
  attachment?: InputMaybe<StringNullableWithAggregatesFilter>;
  email?: InputMaybe<StringNullableWithAggregatesFilter>;
  firstName?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  isRead?: InputMaybe<BoolWithAggregatesFilter>;
  lastName?: InputMaybe<StringNullableWithAggregatesFilter>;
  message?: InputMaybe<StringNullableWithAggregatesFilter>;
  phoneNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
  reason?: InputMaybe<StringNullableWithAggregatesFilter>;
  subject?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type ContactUsDataSumAggregateOutputType = {
  __typename?: 'ContactUsDataSumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
};

export type ContactUsDataSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type ContactUsDataUncheckedCreateInput = {
  attachment?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isRead?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
};

export type ContactUsDataUncheckedUpdateInput = {
  attachment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isRead?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ContactUsDataUncheckedUpdateManyInput = {
  attachment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isRead?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ContactUsDataUpdateInput = {
  attachment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isRead?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ContactUsDataUpdateManyMutationInput = {
  attachment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isRead?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ContactUsDataWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ContactUsDataWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ContactUsDataWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ContactUsDataWhereInput>>>;
  attachment?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<StringNullableFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  isRead?: InputMaybe<BoolFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  message?: InputMaybe<StringNullableFilter>;
  phoneNumber?: InputMaybe<StringNullableFilter>;
  reason?: InputMaybe<StringNullableFilter>;
  subject?: InputMaybe<StringNullableFilter>;
};

export type ContactUsDataWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type ContactUsType = {
  attachment: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  message: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  reason: Scalars['String'];
  subject: Scalars['String'];
};

export type CountRecord = {
  __typename?: 'CountRecord';
  month?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

export type Country = {
  __typename?: 'Country';
  _count: CountryCountOutputType;
  cities: Array<City>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  states: Array<State>;
  users: Array<User>;
  usersNationality: Array<User>;
};


export type CountryCitiesArgs = {
  cursor?: InputMaybe<CityWhereUniqueInput>;
  distinct?: InputMaybe<CityScalarFieldEnum>;
  orderBy?: InputMaybe<CityOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CityWhereInput>;
};


export type CountryStatesArgs = {
  cursor?: InputMaybe<StateWhereUniqueInput>;
  distinct?: InputMaybe<StateScalarFieldEnum>;
  orderBy?: InputMaybe<StateOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<StateWhereInput>;
};


export type CountryUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<UserScalarFieldEnum>;
  orderBy?: InputMaybe<UserOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};


export type CountryUsersNationalityArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<UserScalarFieldEnum>;
  orderBy?: InputMaybe<UserOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};

export type CountryAvgAggregateOutputType = {
  __typename?: 'CountryAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
};

export type CountryAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type CountryCountAggregateOutputType = {
  __typename?: 'CountryCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  nameAr: Scalars['Int'];
};

export type CountryCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nameAr?: InputMaybe<SortOrder>;
};

export type CountryCountOutputType = {
  __typename?: 'CountryCountOutputType';
  cities: Scalars['Int'];
  states: Scalars['Int'];
  users: Scalars['Int'];
  usersNationality: Scalars['Int'];
};

export type CountryCreateInput = {
  cities?: InputMaybe<CityCreateNestedManyWithoutCountryInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  name: Scalars['String'];
  nameAr?: InputMaybe<Scalars['String']>;
  states?: InputMaybe<StateCreateNestedManyWithoutCountryInput>;
  users?: InputMaybe<UserCreateNestedManyWithoutCountryInput>;
  usersNationality?: InputMaybe<UserCreateNestedManyWithoutNationalityInput>;
};

export type CountryCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  nameAr?: InputMaybe<Scalars['String']>;
};

export type CountryCreateNestedOneWithoutCitiesInput = {
  connect?: InputMaybe<CountryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CountryCreateOrConnectWithoutCitiesInput>;
  create?: InputMaybe<CountryUncheckedCreateWithoutCitiesInput>;
};

export type CountryCreateNestedOneWithoutStatesInput = {
  connect?: InputMaybe<CountryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CountryCreateOrConnectWithoutStatesInput>;
  create?: InputMaybe<CountryUncheckedCreateWithoutStatesInput>;
};

export type CountryCreateNestedOneWithoutUsersInput = {
  connect?: InputMaybe<CountryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CountryCreateOrConnectWithoutUsersInput>;
  create?: InputMaybe<CountryUncheckedCreateWithoutUsersInput>;
};

export type CountryCreateNestedOneWithoutUsersNationalityInput = {
  connect?: InputMaybe<CountryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CountryCreateOrConnectWithoutUsersNationalityInput>;
  create?: InputMaybe<CountryUncheckedCreateWithoutUsersNationalityInput>;
};

export type CountryCreateOrConnectWithoutCitiesInput = {
  create: CountryUncheckedCreateWithoutCitiesInput;
  where: CountryWhereUniqueInput;
};

export type CountryCreateOrConnectWithoutStatesInput = {
  create: CountryUncheckedCreateWithoutStatesInput;
  where: CountryWhereUniqueInput;
};

export type CountryCreateOrConnectWithoutUsersInput = {
  create: CountryUncheckedCreateWithoutUsersInput;
  where: CountryWhereUniqueInput;
};

export type CountryCreateOrConnectWithoutUsersNationalityInput = {
  create: CountryUncheckedCreateWithoutUsersNationalityInput;
  where: CountryWhereUniqueInput;
};

export type CountryCreateWithoutCitiesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  name: Scalars['String'];
  nameAr?: InputMaybe<Scalars['String']>;
  states?: InputMaybe<StateCreateNestedManyWithoutCountryInput>;
  users?: InputMaybe<UserCreateNestedManyWithoutCountryInput>;
  usersNationality?: InputMaybe<UserCreateNestedManyWithoutNationalityInput>;
};

export type CountryCreateWithoutStatesInput = {
  cities?: InputMaybe<CityCreateNestedManyWithoutCountryInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  name: Scalars['String'];
  nameAr?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<UserCreateNestedManyWithoutCountryInput>;
  usersNationality?: InputMaybe<UserCreateNestedManyWithoutNationalityInput>;
};

export type CountryCreateWithoutUsersInput = {
  cities?: InputMaybe<CityCreateNestedManyWithoutCountryInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  name: Scalars['String'];
  nameAr?: InputMaybe<Scalars['String']>;
  states?: InputMaybe<StateCreateNestedManyWithoutCountryInput>;
  usersNationality?: InputMaybe<UserCreateNestedManyWithoutNationalityInput>;
};

export type CountryCreateWithoutUsersNationalityInput = {
  cities?: InputMaybe<CityCreateNestedManyWithoutCountryInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  name: Scalars['String'];
  nameAr?: InputMaybe<Scalars['String']>;
  states?: InputMaybe<StateCreateNestedManyWithoutCountryInput>;
  users?: InputMaybe<UserCreateNestedManyWithoutCountryInput>;
};

export type CountryMaxAggregateOutputType = {
  __typename?: 'CountryMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  nameAr?: Maybe<Scalars['String']>;
};

export type CountryMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nameAr?: InputMaybe<SortOrder>;
};

export type CountryMinAggregateOutputType = {
  __typename?: 'CountryMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  nameAr?: Maybe<Scalars['String']>;
};

export type CountryMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nameAr?: InputMaybe<SortOrder>;
};

export type CountryOrderByWithAggregationInput = {
  _avg?: InputMaybe<CountryAvgOrderByAggregateInput>;
  _count?: InputMaybe<CountryCountOrderByAggregateInput>;
  _max?: InputMaybe<CountryMaxOrderByAggregateInput>;
  _min?: InputMaybe<CountryMinOrderByAggregateInput>;
  _sum?: InputMaybe<CountrySumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nameAr?: InputMaybe<SortOrder>;
};

export type CountryOrderByWithRelationInput = {
  cities?: InputMaybe<CityOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nameAr?: InputMaybe<SortOrder>;
  states?: InputMaybe<StateOrderByRelationAggregateInput>;
  users?: InputMaybe<UserOrderByRelationAggregateInput>;
  usersNationality?: InputMaybe<UserOrderByRelationAggregateInput>;
};

export type CountryRelationFilter = {
  is?: InputMaybe<CountryWhereInput>;
  isNot?: InputMaybe<CountryWhereInput>;
};

export enum CountryScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  Name = 'name',
  NameAr = 'nameAr'
}

export type CountryScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<CountryScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<CountryScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CountryScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  nameAr?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type CountrySumAggregateOutputType = {
  __typename?: 'CountrySumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
};

export type CountrySumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type CountryUncheckedCreateInput = {
  cities?: InputMaybe<CityUncheckedCreateNestedManyWithoutCountryInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  nameAr?: InputMaybe<Scalars['String']>;
  states?: InputMaybe<StateUncheckedCreateNestedManyWithoutCountryInput>;
  users?: InputMaybe<UserUncheckedCreateNestedManyWithoutCountryInput>;
  usersNationality?: InputMaybe<UserUncheckedCreateNestedManyWithoutNationalityInput>;
};

export type CountryUncheckedCreateWithoutCitiesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  nameAr?: InputMaybe<Scalars['String']>;
  states?: InputMaybe<StateUncheckedCreateNestedManyWithoutCountryInput>;
  users?: InputMaybe<UserUncheckedCreateNestedManyWithoutCountryInput>;
  usersNationality?: InputMaybe<UserUncheckedCreateNestedManyWithoutNationalityInput>;
};

export type CountryUncheckedCreateWithoutStatesInput = {
  cities?: InputMaybe<CityUncheckedCreateNestedManyWithoutCountryInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  nameAr?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<UserUncheckedCreateNestedManyWithoutCountryInput>;
  usersNationality?: InputMaybe<UserUncheckedCreateNestedManyWithoutNationalityInput>;
};

export type CountryUncheckedCreateWithoutUsersInput = {
  cities?: InputMaybe<CityUncheckedCreateNestedManyWithoutCountryInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  nameAr?: InputMaybe<Scalars['String']>;
  states?: InputMaybe<StateUncheckedCreateNestedManyWithoutCountryInput>;
  usersNationality?: InputMaybe<UserUncheckedCreateNestedManyWithoutNationalityInput>;
};

export type CountryUncheckedCreateWithoutUsersNationalityInput = {
  cities?: InputMaybe<CityUncheckedCreateNestedManyWithoutCountryInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  nameAr?: InputMaybe<Scalars['String']>;
  states?: InputMaybe<StateUncheckedCreateNestedManyWithoutCountryInput>;
  users?: InputMaybe<UserUncheckedCreateNestedManyWithoutCountryInput>;
};

export type CountryUncheckedUpdateInput = {
  cities?: InputMaybe<CityUncheckedUpdateManyWithoutCountryInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  states?: InputMaybe<StateUncheckedUpdateManyWithoutCountryInput>;
  users?: InputMaybe<UserUncheckedUpdateManyWithoutCountryInput>;
  usersNationality?: InputMaybe<UserUncheckedUpdateManyWithoutNationalityInput>;
};

export type CountryUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CountryUncheckedUpdateWithoutCitiesInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  states?: InputMaybe<StateUncheckedUpdateManyWithoutCountryInput>;
  users?: InputMaybe<UserUncheckedUpdateManyWithoutCountryInput>;
  usersNationality?: InputMaybe<UserUncheckedUpdateManyWithoutNationalityInput>;
};

export type CountryUncheckedUpdateWithoutStatesInput = {
  cities?: InputMaybe<CityUncheckedUpdateManyWithoutCountryInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUncheckedUpdateManyWithoutCountryInput>;
  usersNationality?: InputMaybe<UserUncheckedUpdateManyWithoutNationalityInput>;
};

export type CountryUncheckedUpdateWithoutUsersInput = {
  cities?: InputMaybe<CityUncheckedUpdateManyWithoutCountryInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  states?: InputMaybe<StateUncheckedUpdateManyWithoutCountryInput>;
  usersNationality?: InputMaybe<UserUncheckedUpdateManyWithoutNationalityInput>;
};

export type CountryUncheckedUpdateWithoutUsersNationalityInput = {
  cities?: InputMaybe<CityUncheckedUpdateManyWithoutCountryInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  states?: InputMaybe<StateUncheckedUpdateManyWithoutCountryInput>;
  users?: InputMaybe<UserUncheckedUpdateManyWithoutCountryInput>;
};

export type CountryUpdateInput = {
  cities?: InputMaybe<CityUpdateManyWithoutCountryInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  states?: InputMaybe<StateUpdateManyWithoutCountryInput>;
  users?: InputMaybe<UserUpdateManyWithoutCountryInput>;
  usersNationality?: InputMaybe<UserUpdateManyWithoutNationalityInput>;
};

export type CountryUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CountryUpdateOneWithoutCitiesInput = {
  connect?: InputMaybe<CountryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CountryCreateOrConnectWithoutCitiesInput>;
  create?: InputMaybe<CountryUncheckedCreateWithoutCitiesInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CountryUncheckedUpdateWithoutCitiesInput>;
  upsert?: InputMaybe<CountryUpsertWithoutCitiesInput>;
};

export type CountryUpdateOneWithoutStatesInput = {
  connect?: InputMaybe<CountryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CountryCreateOrConnectWithoutStatesInput>;
  create?: InputMaybe<CountryUncheckedCreateWithoutStatesInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CountryUncheckedUpdateWithoutStatesInput>;
  upsert?: InputMaybe<CountryUpsertWithoutStatesInput>;
};

export type CountryUpdateOneWithoutUsersInput = {
  connect?: InputMaybe<CountryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CountryCreateOrConnectWithoutUsersInput>;
  create?: InputMaybe<CountryUncheckedCreateWithoutUsersInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CountryUncheckedUpdateWithoutUsersInput>;
  upsert?: InputMaybe<CountryUpsertWithoutUsersInput>;
};

export type CountryUpdateOneWithoutUsersNationalityInput = {
  connect?: InputMaybe<CountryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CountryCreateOrConnectWithoutUsersNationalityInput>;
  create?: InputMaybe<CountryUncheckedCreateWithoutUsersNationalityInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CountryUncheckedUpdateWithoutUsersNationalityInput>;
  upsert?: InputMaybe<CountryUpsertWithoutUsersNationalityInput>;
};

export type CountryUpdateWithoutCitiesInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  states?: InputMaybe<StateUpdateManyWithoutCountryInput>;
  users?: InputMaybe<UserUpdateManyWithoutCountryInput>;
  usersNationality?: InputMaybe<UserUpdateManyWithoutNationalityInput>;
};

export type CountryUpdateWithoutStatesInput = {
  cities?: InputMaybe<CityUpdateManyWithoutCountryInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUpdateManyWithoutCountryInput>;
  usersNationality?: InputMaybe<UserUpdateManyWithoutNationalityInput>;
};

export type CountryUpdateWithoutUsersInput = {
  cities?: InputMaybe<CityUpdateManyWithoutCountryInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  states?: InputMaybe<StateUpdateManyWithoutCountryInput>;
  usersNationality?: InputMaybe<UserUpdateManyWithoutNationalityInput>;
};

export type CountryUpdateWithoutUsersNationalityInput = {
  cities?: InputMaybe<CityUpdateManyWithoutCountryInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  states?: InputMaybe<StateUpdateManyWithoutCountryInput>;
  users?: InputMaybe<UserUpdateManyWithoutCountryInput>;
};

export type CountryUpsertWithoutCitiesInput = {
  create: CountryUncheckedCreateWithoutCitiesInput;
  update: CountryUncheckedUpdateWithoutCitiesInput;
};

export type CountryUpsertWithoutStatesInput = {
  create: CountryUncheckedCreateWithoutStatesInput;
  update: CountryUncheckedUpdateWithoutStatesInput;
};

export type CountryUpsertWithoutUsersInput = {
  create: CountryUncheckedCreateWithoutUsersInput;
  update: CountryUncheckedUpdateWithoutUsersInput;
};

export type CountryUpsertWithoutUsersNationalityInput = {
  create: CountryUncheckedCreateWithoutUsersNationalityInput;
  update: CountryUncheckedUpdateWithoutUsersNationalityInput;
};

export type CountryWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<CountryWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<CountryWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CountryWhereInput>>>;
  cities?: InputMaybe<CityListRelationFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  nameAr?: InputMaybe<StringNullableFilter>;
  states?: InputMaybe<StateListRelationFilter>;
  users?: InputMaybe<UserListRelationFilter>;
  usersNationality?: InputMaybe<UserListRelationFilter>;
};

export type CountryWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Coupon = {
  __typename?: 'Coupon';
  _count: CouponCountOutputType;
  code: Scalars['String'];
  couponType: CouponType;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  events: Array<Event>;
  expiryDate: Scalars['DateTime'];
  fixedAmountDiscount?: Maybe<Scalars['Decimal']>;
  fixedAmountMarketerProfit?: Maybe<Scalars['Decimal']>;
  id: Scalars['Int'];
  inviter?: Maybe<User>;
  inviterId?: Maybe<Scalars['Int']>;
  isForAllEvents: Scalars['Boolean'];
  isForAllSpecialties: Scalars['Boolean'];
  marketerProfitType?: Maybe<MarketerProfitType>;
  percentageDiscount?: Maybe<Scalars['Decimal']>;
  percentageMarketerProfit?: Maybe<Scalars['Decimal']>;
  percentageMaxAmount?: Maybe<Scalars['Decimal']>;
  professions: Array<Profession>;
};


export type CouponEventsArgs = {
  cursor?: InputMaybe<EventWhereUniqueInput>;
  distinct?: InputMaybe<EventScalarFieldEnum>;
  orderBy?: InputMaybe<EventOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EventWhereInput>;
};


export type CouponProfessionsArgs = {
  cursor?: InputMaybe<ProfessionWhereUniqueInput>;
  distinct?: InputMaybe<ProfessionScalarFieldEnum>;
  orderBy?: InputMaybe<ProfessionOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProfessionWhereInput>;
};

export type CouponAvgAggregateOutputType = {
  __typename?: 'CouponAvgAggregateOutputType';
  fixedAmountDiscount?: Maybe<Scalars['Decimal']>;
  fixedAmountMarketerProfit?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['Float']>;
  inviterId?: Maybe<Scalars['Float']>;
  percentageDiscount?: Maybe<Scalars['Decimal']>;
  percentageMarketerProfit?: Maybe<Scalars['Decimal']>;
  percentageMaxAmount?: Maybe<Scalars['Decimal']>;
};

export type CouponAvgOrderByAggregateInput = {
  fixedAmountDiscount?: InputMaybe<SortOrder>;
  fixedAmountMarketerProfit?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inviterId?: InputMaybe<SortOrder>;
  percentageDiscount?: InputMaybe<SortOrder>;
  percentageMarketerProfit?: InputMaybe<SortOrder>;
  percentageMaxAmount?: InputMaybe<SortOrder>;
};

export type CouponCountAggregateOutputType = {
  __typename?: 'CouponCountAggregateOutputType';
  _all: Scalars['Int'];
  code: Scalars['Int'];
  couponType: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  expiryDate: Scalars['Int'];
  fixedAmountDiscount: Scalars['Int'];
  fixedAmountMarketerProfit: Scalars['Int'];
  id: Scalars['Int'];
  inviterId: Scalars['Int'];
  isForAllEvents: Scalars['Int'];
  isForAllSpecialties: Scalars['Int'];
  marketerProfitType: Scalars['Int'];
  percentageDiscount: Scalars['Int'];
  percentageMarketerProfit: Scalars['Int'];
  percentageMaxAmount: Scalars['Int'];
};

export type CouponCountOrderByAggregateInput = {
  code?: InputMaybe<SortOrder>;
  couponType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  expiryDate?: InputMaybe<SortOrder>;
  fixedAmountDiscount?: InputMaybe<SortOrder>;
  fixedAmountMarketerProfit?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inviterId?: InputMaybe<SortOrder>;
  isForAllEvents?: InputMaybe<SortOrder>;
  isForAllSpecialties?: InputMaybe<SortOrder>;
  marketerProfitType?: InputMaybe<SortOrder>;
  percentageDiscount?: InputMaybe<SortOrder>;
  percentageMarketerProfit?: InputMaybe<SortOrder>;
  percentageMaxAmount?: InputMaybe<SortOrder>;
};

export type CouponCountOutputType = {
  __typename?: 'CouponCountOutputType';
  TraineeEvent: Scalars['Int'];
  TraineeEventGroup: Scalars['Int'];
  events: Scalars['Int'];
  inviterCouponProfits: Scalars['Int'];
  professions: Scalars['Int'];
};

export type CouponCreateInput = {
  TraineeEvent?: InputMaybe<TraineeEventCreateNestedManyWithoutCouponInput>;
  TraineeEventGroup?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutCouponInput>;
  code: Scalars['String'];
  couponType: CouponType;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<EventCreateNestedManyWithoutCouponsInput>;
  expiryDate: Scalars['DateTime'];
  fixedAmountDiscount?: InputMaybe<Scalars['Decimal']>;
  fixedAmountMarketerProfit?: InputMaybe<Scalars['Decimal']>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutCouponsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutCouponInput>;
  isForAllEvents: Scalars['Boolean'];
  isForAllSpecialties: Scalars['Boolean'];
  marketerProfitType?: InputMaybe<MarketerProfitType>;
  percentageDiscount?: InputMaybe<Scalars['Decimal']>;
  percentageMarketerProfit?: InputMaybe<Scalars['Decimal']>;
  percentageMaxAmount?: InputMaybe<Scalars['Decimal']>;
  professions?: InputMaybe<ProfessionCreateNestedManyWithoutCouponInput>;
};

export type CouponCreateManyInput = {
  code: Scalars['String'];
  couponType: CouponType;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  expiryDate: Scalars['DateTime'];
  fixedAmountDiscount?: InputMaybe<Scalars['Decimal']>;
  fixedAmountMarketerProfit?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isForAllEvents: Scalars['Boolean'];
  isForAllSpecialties: Scalars['Boolean'];
  marketerProfitType?: InputMaybe<MarketerProfitType>;
  percentageDiscount?: InputMaybe<Scalars['Decimal']>;
  percentageMarketerProfit?: InputMaybe<Scalars['Decimal']>;
  percentageMaxAmount?: InputMaybe<Scalars['Decimal']>;
};

export type CouponCreateManyInviterInput = {
  code: Scalars['String'];
  couponType: CouponType;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  expiryDate: Scalars['DateTime'];
  fixedAmountDiscount?: InputMaybe<Scalars['Decimal']>;
  fixedAmountMarketerProfit?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['Int']>;
  isForAllEvents: Scalars['Boolean'];
  isForAllSpecialties: Scalars['Boolean'];
  marketerProfitType?: InputMaybe<MarketerProfitType>;
  percentageDiscount?: InputMaybe<Scalars['Decimal']>;
  percentageMarketerProfit?: InputMaybe<Scalars['Decimal']>;
  percentageMaxAmount?: InputMaybe<Scalars['Decimal']>;
};

export type CouponCreateManyInviterInputEnvelope = {
  data: CouponCreateManyInviterInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CouponCreateNestedManyWithoutEventsInput = {
  connect?: InputMaybe<Array<InputMaybe<CouponWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CouponCreateOrConnectWithoutEventsInput>>>;
  create?: InputMaybe<Array<InputMaybe<CouponCreateWithoutEventsInput>>>;
};

export type CouponCreateNestedManyWithoutInviterInput = {
  connect?: InputMaybe<Array<InputMaybe<CouponWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CouponCreateOrConnectWithoutInviterInput>>>;
  create?: InputMaybe<Array<InputMaybe<CouponCreateWithoutInviterInput>>>;
  createMany?: InputMaybe<CouponCreateManyInviterInputEnvelope>;
};

export type CouponCreateNestedOneWithoutInviterCouponProfitsInput = {
  connect?: InputMaybe<CouponWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CouponCreateOrConnectWithoutInviterCouponProfitsInput>;
  create?: InputMaybe<CouponUncheckedCreateWithoutInviterCouponProfitsInput>;
};

export type CouponCreateNestedOneWithoutProfessionsInput = {
  connect?: InputMaybe<CouponWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CouponCreateOrConnectWithoutProfessionsInput>;
  create?: InputMaybe<CouponUncheckedCreateWithoutProfessionsInput>;
};

export type CouponCreateNestedOneWithoutTraineeEventGroupInput = {
  connect?: InputMaybe<CouponWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CouponCreateOrConnectWithoutTraineeEventGroupInput>;
  create?: InputMaybe<CouponUncheckedCreateWithoutTraineeEventGroupInput>;
};

export type CouponCreateNestedOneWithoutTraineeEventInput = {
  connect?: InputMaybe<CouponWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CouponCreateOrConnectWithoutTraineeEventInput>;
  create?: InputMaybe<CouponUncheckedCreateWithoutTraineeEventInput>;
};

export type CouponCreateOrConnectWithoutEventsInput = {
  create: CouponUncheckedCreateWithoutEventsInput;
  where: CouponWhereUniqueInput;
};

export type CouponCreateOrConnectWithoutInviterCouponProfitsInput = {
  create: CouponUncheckedCreateWithoutInviterCouponProfitsInput;
  where: CouponWhereUniqueInput;
};

export type CouponCreateOrConnectWithoutInviterInput = {
  create: CouponUncheckedCreateWithoutInviterInput;
  where: CouponWhereUniqueInput;
};

export type CouponCreateOrConnectWithoutProfessionsInput = {
  create: CouponUncheckedCreateWithoutProfessionsInput;
  where: CouponWhereUniqueInput;
};

export type CouponCreateOrConnectWithoutTraineeEventGroupInput = {
  create: CouponUncheckedCreateWithoutTraineeEventGroupInput;
  where: CouponWhereUniqueInput;
};

export type CouponCreateOrConnectWithoutTraineeEventInput = {
  create: CouponUncheckedCreateWithoutTraineeEventInput;
  where: CouponWhereUniqueInput;
};

export type CouponCreateWithoutEventsInput = {
  TraineeEvent?: InputMaybe<TraineeEventCreateNestedManyWithoutCouponInput>;
  TraineeEventGroup?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutCouponInput>;
  code: Scalars['String'];
  couponType: CouponType;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  expiryDate: Scalars['DateTime'];
  fixedAmountDiscount?: InputMaybe<Scalars['Decimal']>;
  fixedAmountMarketerProfit?: InputMaybe<Scalars['Decimal']>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutCouponsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutCouponInput>;
  isForAllEvents: Scalars['Boolean'];
  isForAllSpecialties: Scalars['Boolean'];
  marketerProfitType?: InputMaybe<MarketerProfitType>;
  percentageDiscount?: InputMaybe<Scalars['Decimal']>;
  percentageMarketerProfit?: InputMaybe<Scalars['Decimal']>;
  percentageMaxAmount?: InputMaybe<Scalars['Decimal']>;
  professions?: InputMaybe<ProfessionCreateNestedManyWithoutCouponInput>;
};

export type CouponCreateWithoutInviterCouponProfitsInput = {
  TraineeEvent?: InputMaybe<TraineeEventCreateNestedManyWithoutCouponInput>;
  TraineeEventGroup?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutCouponInput>;
  code: Scalars['String'];
  couponType: CouponType;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<EventCreateNestedManyWithoutCouponsInput>;
  expiryDate: Scalars['DateTime'];
  fixedAmountDiscount?: InputMaybe<Scalars['Decimal']>;
  fixedAmountMarketerProfit?: InputMaybe<Scalars['Decimal']>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutCouponsInput>;
  isForAllEvents: Scalars['Boolean'];
  isForAllSpecialties: Scalars['Boolean'];
  marketerProfitType?: InputMaybe<MarketerProfitType>;
  percentageDiscount?: InputMaybe<Scalars['Decimal']>;
  percentageMarketerProfit?: InputMaybe<Scalars['Decimal']>;
  percentageMaxAmount?: InputMaybe<Scalars['Decimal']>;
  professions?: InputMaybe<ProfessionCreateNestedManyWithoutCouponInput>;
};

export type CouponCreateWithoutInviterInput = {
  TraineeEvent?: InputMaybe<TraineeEventCreateNestedManyWithoutCouponInput>;
  TraineeEventGroup?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutCouponInput>;
  code: Scalars['String'];
  couponType: CouponType;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<EventCreateNestedManyWithoutCouponsInput>;
  expiryDate: Scalars['DateTime'];
  fixedAmountDiscount?: InputMaybe<Scalars['Decimal']>;
  fixedAmountMarketerProfit?: InputMaybe<Scalars['Decimal']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutCouponInput>;
  isForAllEvents: Scalars['Boolean'];
  isForAllSpecialties: Scalars['Boolean'];
  marketerProfitType?: InputMaybe<MarketerProfitType>;
  percentageDiscount?: InputMaybe<Scalars['Decimal']>;
  percentageMarketerProfit?: InputMaybe<Scalars['Decimal']>;
  percentageMaxAmount?: InputMaybe<Scalars['Decimal']>;
  professions?: InputMaybe<ProfessionCreateNestedManyWithoutCouponInput>;
};

export type CouponCreateWithoutProfessionsInput = {
  TraineeEvent?: InputMaybe<TraineeEventCreateNestedManyWithoutCouponInput>;
  TraineeEventGroup?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutCouponInput>;
  code: Scalars['String'];
  couponType: CouponType;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<EventCreateNestedManyWithoutCouponsInput>;
  expiryDate: Scalars['DateTime'];
  fixedAmountDiscount?: InputMaybe<Scalars['Decimal']>;
  fixedAmountMarketerProfit?: InputMaybe<Scalars['Decimal']>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutCouponsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutCouponInput>;
  isForAllEvents: Scalars['Boolean'];
  isForAllSpecialties: Scalars['Boolean'];
  marketerProfitType?: InputMaybe<MarketerProfitType>;
  percentageDiscount?: InputMaybe<Scalars['Decimal']>;
  percentageMarketerProfit?: InputMaybe<Scalars['Decimal']>;
  percentageMaxAmount?: InputMaybe<Scalars['Decimal']>;
};

export type CouponCreateWithoutTraineeEventGroupInput = {
  TraineeEvent?: InputMaybe<TraineeEventCreateNestedManyWithoutCouponInput>;
  code: Scalars['String'];
  couponType: CouponType;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<EventCreateNestedManyWithoutCouponsInput>;
  expiryDate: Scalars['DateTime'];
  fixedAmountDiscount?: InputMaybe<Scalars['Decimal']>;
  fixedAmountMarketerProfit?: InputMaybe<Scalars['Decimal']>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutCouponsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutCouponInput>;
  isForAllEvents: Scalars['Boolean'];
  isForAllSpecialties: Scalars['Boolean'];
  marketerProfitType?: InputMaybe<MarketerProfitType>;
  percentageDiscount?: InputMaybe<Scalars['Decimal']>;
  percentageMarketerProfit?: InputMaybe<Scalars['Decimal']>;
  percentageMaxAmount?: InputMaybe<Scalars['Decimal']>;
  professions?: InputMaybe<ProfessionCreateNestedManyWithoutCouponInput>;
};

export type CouponCreateWithoutTraineeEventInput = {
  TraineeEventGroup?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutCouponInput>;
  code: Scalars['String'];
  couponType: CouponType;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<EventCreateNestedManyWithoutCouponsInput>;
  expiryDate: Scalars['DateTime'];
  fixedAmountDiscount?: InputMaybe<Scalars['Decimal']>;
  fixedAmountMarketerProfit?: InputMaybe<Scalars['Decimal']>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutCouponsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutCouponInput>;
  isForAllEvents: Scalars['Boolean'];
  isForAllSpecialties: Scalars['Boolean'];
  marketerProfitType?: InputMaybe<MarketerProfitType>;
  percentageDiscount?: InputMaybe<Scalars['Decimal']>;
  percentageMarketerProfit?: InputMaybe<Scalars['Decimal']>;
  percentageMaxAmount?: InputMaybe<Scalars['Decimal']>;
  professions?: InputMaybe<ProfessionCreateNestedManyWithoutCouponInput>;
};

export type CouponListRelationFilter = {
  every?: InputMaybe<CouponWhereInput>;
  none?: InputMaybe<CouponWhereInput>;
  some?: InputMaybe<CouponWhereInput>;
};

export type CouponMaxAggregateOutputType = {
  __typename?: 'CouponMaxAggregateOutputType';
  code?: Maybe<Scalars['String']>;
  couponType?: Maybe<CouponType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  fixedAmountDiscount?: Maybe<Scalars['Decimal']>;
  fixedAmountMarketerProfit?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['Int']>;
  inviterId?: Maybe<Scalars['Int']>;
  isForAllEvents?: Maybe<Scalars['Boolean']>;
  isForAllSpecialties?: Maybe<Scalars['Boolean']>;
  marketerProfitType?: Maybe<MarketerProfitType>;
  percentageDiscount?: Maybe<Scalars['Decimal']>;
  percentageMarketerProfit?: Maybe<Scalars['Decimal']>;
  percentageMaxAmount?: Maybe<Scalars['Decimal']>;
};

export type CouponMaxOrderByAggregateInput = {
  code?: InputMaybe<SortOrder>;
  couponType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  expiryDate?: InputMaybe<SortOrder>;
  fixedAmountDiscount?: InputMaybe<SortOrder>;
  fixedAmountMarketerProfit?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inviterId?: InputMaybe<SortOrder>;
  isForAllEvents?: InputMaybe<SortOrder>;
  isForAllSpecialties?: InputMaybe<SortOrder>;
  marketerProfitType?: InputMaybe<SortOrder>;
  percentageDiscount?: InputMaybe<SortOrder>;
  percentageMarketerProfit?: InputMaybe<SortOrder>;
  percentageMaxAmount?: InputMaybe<SortOrder>;
};

export type CouponMinAggregateOutputType = {
  __typename?: 'CouponMinAggregateOutputType';
  code?: Maybe<Scalars['String']>;
  couponType?: Maybe<CouponType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  fixedAmountDiscount?: Maybe<Scalars['Decimal']>;
  fixedAmountMarketerProfit?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['Int']>;
  inviterId?: Maybe<Scalars['Int']>;
  isForAllEvents?: Maybe<Scalars['Boolean']>;
  isForAllSpecialties?: Maybe<Scalars['Boolean']>;
  marketerProfitType?: Maybe<MarketerProfitType>;
  percentageDiscount?: Maybe<Scalars['Decimal']>;
  percentageMarketerProfit?: Maybe<Scalars['Decimal']>;
  percentageMaxAmount?: Maybe<Scalars['Decimal']>;
};

export type CouponMinOrderByAggregateInput = {
  code?: InputMaybe<SortOrder>;
  couponType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  expiryDate?: InputMaybe<SortOrder>;
  fixedAmountDiscount?: InputMaybe<SortOrder>;
  fixedAmountMarketerProfit?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inviterId?: InputMaybe<SortOrder>;
  isForAllEvents?: InputMaybe<SortOrder>;
  isForAllSpecialties?: InputMaybe<SortOrder>;
  marketerProfitType?: InputMaybe<SortOrder>;
  percentageDiscount?: InputMaybe<SortOrder>;
  percentageMarketerProfit?: InputMaybe<SortOrder>;
  percentageMaxAmount?: InputMaybe<SortOrder>;
};

export type CouponOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CouponOrderByWithAggregationInput = {
  _avg?: InputMaybe<CouponAvgOrderByAggregateInput>;
  _count?: InputMaybe<CouponCountOrderByAggregateInput>;
  _max?: InputMaybe<CouponMaxOrderByAggregateInput>;
  _min?: InputMaybe<CouponMinOrderByAggregateInput>;
  _sum?: InputMaybe<CouponSumOrderByAggregateInput>;
  code?: InputMaybe<SortOrder>;
  couponType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  expiryDate?: InputMaybe<SortOrder>;
  fixedAmountDiscount?: InputMaybe<SortOrder>;
  fixedAmountMarketerProfit?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inviterId?: InputMaybe<SortOrder>;
  isForAllEvents?: InputMaybe<SortOrder>;
  isForAllSpecialties?: InputMaybe<SortOrder>;
  marketerProfitType?: InputMaybe<SortOrder>;
  percentageDiscount?: InputMaybe<SortOrder>;
  percentageMarketerProfit?: InputMaybe<SortOrder>;
  percentageMaxAmount?: InputMaybe<SortOrder>;
};

export type CouponOrderByWithRelationInput = {
  TraineeEvent?: InputMaybe<TraineeEventOrderByRelationAggregateInput>;
  TraineeEventGroup?: InputMaybe<TraineeEventGroupOrderByRelationAggregateInput>;
  code?: InputMaybe<SortOrder>;
  couponType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  events?: InputMaybe<EventOrderByRelationAggregateInput>;
  expiryDate?: InputMaybe<SortOrder>;
  fixedAmountDiscount?: InputMaybe<SortOrder>;
  fixedAmountMarketerProfit?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inviter?: InputMaybe<UserOrderByWithRelationInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitOrderByRelationAggregateInput>;
  inviterId?: InputMaybe<SortOrder>;
  isForAllEvents?: InputMaybe<SortOrder>;
  isForAllSpecialties?: InputMaybe<SortOrder>;
  marketerProfitType?: InputMaybe<SortOrder>;
  percentageDiscount?: InputMaybe<SortOrder>;
  percentageMarketerProfit?: InputMaybe<SortOrder>;
  percentageMaxAmount?: InputMaybe<SortOrder>;
  professions?: InputMaybe<ProfessionOrderByRelationAggregateInput>;
};

export type CouponRelationFilter = {
  is?: InputMaybe<CouponWhereInput>;
  isNot?: InputMaybe<CouponWhereInput>;
};

export enum CouponScalarFieldEnum {
  Code = 'code',
  CouponType = 'couponType',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  ExpiryDate = 'expiryDate',
  FixedAmountDiscount = 'fixedAmountDiscount',
  FixedAmountMarketerProfit = 'fixedAmountMarketerProfit',
  Id = 'id',
  InviterId = 'inviterId',
  IsForAllEvents = 'isForAllEvents',
  IsForAllSpecialties = 'isForAllSpecialties',
  MarketerProfitType = 'marketerProfitType',
  PercentageDiscount = 'percentageDiscount',
  PercentageMarketerProfit = 'percentageMarketerProfit',
  PercentageMaxAmount = 'percentageMaxAmount'
}

export type CouponScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<CouponScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<CouponScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CouponScalarWhereInput>>>;
  code?: InputMaybe<StringFilter>;
  couponType?: InputMaybe<EnumCouponTypeFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  expiryDate?: InputMaybe<DateTimeFilter>;
  fixedAmountDiscount?: InputMaybe<DecimalNullableFilter>;
  fixedAmountMarketerProfit?: InputMaybe<DecimalNullableFilter>;
  id?: InputMaybe<IntFilter>;
  inviterId?: InputMaybe<IntNullableFilter>;
  isForAllEvents?: InputMaybe<BoolFilter>;
  isForAllSpecialties?: InputMaybe<BoolFilter>;
  marketerProfitType?: InputMaybe<EnumMarketerProfitTypeNullableFilter>;
  percentageDiscount?: InputMaybe<DecimalNullableFilter>;
  percentageMarketerProfit?: InputMaybe<DecimalNullableFilter>;
  percentageMaxAmount?: InputMaybe<DecimalNullableFilter>;
};

export type CouponScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<CouponScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<CouponScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CouponScalarWhereWithAggregatesInput>>>;
  code?: InputMaybe<StringWithAggregatesFilter>;
  couponType?: InputMaybe<EnumCouponTypeWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  expiryDate?: InputMaybe<DateTimeWithAggregatesFilter>;
  fixedAmountDiscount?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  fixedAmountMarketerProfit?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  inviterId?: InputMaybe<IntNullableWithAggregatesFilter>;
  isForAllEvents?: InputMaybe<BoolWithAggregatesFilter>;
  isForAllSpecialties?: InputMaybe<BoolWithAggregatesFilter>;
  marketerProfitType?: InputMaybe<EnumMarketerProfitTypeNullableWithAggregatesFilter>;
  percentageDiscount?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  percentageMarketerProfit?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  percentageMaxAmount?: InputMaybe<DecimalNullableWithAggregatesFilter>;
};

export type CouponSumAggregateOutputType = {
  __typename?: 'CouponSumAggregateOutputType';
  fixedAmountDiscount?: Maybe<Scalars['Decimal']>;
  fixedAmountMarketerProfit?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['Int']>;
  inviterId?: Maybe<Scalars['Int']>;
  percentageDiscount?: Maybe<Scalars['Decimal']>;
  percentageMarketerProfit?: Maybe<Scalars['Decimal']>;
  percentageMaxAmount?: Maybe<Scalars['Decimal']>;
};

export type CouponSumOrderByAggregateInput = {
  fixedAmountDiscount?: InputMaybe<SortOrder>;
  fixedAmountMarketerProfit?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inviterId?: InputMaybe<SortOrder>;
  percentageDiscount?: InputMaybe<SortOrder>;
  percentageMarketerProfit?: InputMaybe<SortOrder>;
  percentageMaxAmount?: InputMaybe<SortOrder>;
};

export enum CouponType {
  Fixed = 'fixed',
  Percentage = 'percentage'
}

export type CouponUncheckedCreateInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutCouponInput>;
  TraineeEventGroup?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutCouponInput>;
  code: Scalars['String'];
  couponType: CouponType;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutCouponsInput>;
  expiryDate: Scalars['DateTime'];
  fixedAmountDiscount?: InputMaybe<Scalars['Decimal']>;
  fixedAmountMarketerProfit?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutCouponInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isForAllEvents: Scalars['Boolean'];
  isForAllSpecialties: Scalars['Boolean'];
  marketerProfitType?: InputMaybe<MarketerProfitType>;
  percentageDiscount?: InputMaybe<Scalars['Decimal']>;
  percentageMarketerProfit?: InputMaybe<Scalars['Decimal']>;
  percentageMaxAmount?: InputMaybe<Scalars['Decimal']>;
  professions?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutCouponInput>;
};

export type CouponUncheckedCreateNestedManyWithoutEventsInput = {
  connect?: InputMaybe<Array<InputMaybe<CouponWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CouponCreateOrConnectWithoutEventsInput>>>;
  create?: InputMaybe<Array<InputMaybe<CouponCreateWithoutEventsInput>>>;
};

export type CouponUncheckedCreateNestedManyWithoutInviterInput = {
  connect?: InputMaybe<Array<InputMaybe<CouponWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CouponCreateOrConnectWithoutInviterInput>>>;
  create?: InputMaybe<Array<InputMaybe<CouponCreateWithoutInviterInput>>>;
  createMany?: InputMaybe<CouponCreateManyInviterInputEnvelope>;
};

export type CouponUncheckedCreateWithoutEventsInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutCouponInput>;
  TraineeEventGroup?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutCouponInput>;
  code: Scalars['String'];
  couponType: CouponType;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  expiryDate: Scalars['DateTime'];
  fixedAmountDiscount?: InputMaybe<Scalars['Decimal']>;
  fixedAmountMarketerProfit?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutCouponInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isForAllEvents: Scalars['Boolean'];
  isForAllSpecialties: Scalars['Boolean'];
  marketerProfitType?: InputMaybe<MarketerProfitType>;
  percentageDiscount?: InputMaybe<Scalars['Decimal']>;
  percentageMarketerProfit?: InputMaybe<Scalars['Decimal']>;
  percentageMaxAmount?: InputMaybe<Scalars['Decimal']>;
  professions?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutCouponInput>;
};

export type CouponUncheckedCreateWithoutInviterCouponProfitsInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutCouponInput>;
  TraineeEventGroup?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutCouponInput>;
  code: Scalars['String'];
  couponType: CouponType;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutCouponsInput>;
  expiryDate: Scalars['DateTime'];
  fixedAmountDiscount?: InputMaybe<Scalars['Decimal']>;
  fixedAmountMarketerProfit?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isForAllEvents: Scalars['Boolean'];
  isForAllSpecialties: Scalars['Boolean'];
  marketerProfitType?: InputMaybe<MarketerProfitType>;
  percentageDiscount?: InputMaybe<Scalars['Decimal']>;
  percentageMarketerProfit?: InputMaybe<Scalars['Decimal']>;
  percentageMaxAmount?: InputMaybe<Scalars['Decimal']>;
  professions?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutCouponInput>;
};

export type CouponUncheckedCreateWithoutInviterInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutCouponInput>;
  TraineeEventGroup?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutCouponInput>;
  code: Scalars['String'];
  couponType: CouponType;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutCouponsInput>;
  expiryDate: Scalars['DateTime'];
  fixedAmountDiscount?: InputMaybe<Scalars['Decimal']>;
  fixedAmountMarketerProfit?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutCouponInput>;
  isForAllEvents: Scalars['Boolean'];
  isForAllSpecialties: Scalars['Boolean'];
  marketerProfitType?: InputMaybe<MarketerProfitType>;
  percentageDiscount?: InputMaybe<Scalars['Decimal']>;
  percentageMarketerProfit?: InputMaybe<Scalars['Decimal']>;
  percentageMaxAmount?: InputMaybe<Scalars['Decimal']>;
  professions?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutCouponInput>;
};

export type CouponUncheckedCreateWithoutProfessionsInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutCouponInput>;
  TraineeEventGroup?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutCouponInput>;
  code: Scalars['String'];
  couponType: CouponType;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutCouponsInput>;
  expiryDate: Scalars['DateTime'];
  fixedAmountDiscount?: InputMaybe<Scalars['Decimal']>;
  fixedAmountMarketerProfit?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutCouponInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isForAllEvents: Scalars['Boolean'];
  isForAllSpecialties: Scalars['Boolean'];
  marketerProfitType?: InputMaybe<MarketerProfitType>;
  percentageDiscount?: InputMaybe<Scalars['Decimal']>;
  percentageMarketerProfit?: InputMaybe<Scalars['Decimal']>;
  percentageMaxAmount?: InputMaybe<Scalars['Decimal']>;
};

export type CouponUncheckedCreateWithoutTraineeEventGroupInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutCouponInput>;
  code: Scalars['String'];
  couponType: CouponType;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutCouponsInput>;
  expiryDate: Scalars['DateTime'];
  fixedAmountDiscount?: InputMaybe<Scalars['Decimal']>;
  fixedAmountMarketerProfit?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutCouponInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isForAllEvents: Scalars['Boolean'];
  isForAllSpecialties: Scalars['Boolean'];
  marketerProfitType?: InputMaybe<MarketerProfitType>;
  percentageDiscount?: InputMaybe<Scalars['Decimal']>;
  percentageMarketerProfit?: InputMaybe<Scalars['Decimal']>;
  percentageMaxAmount?: InputMaybe<Scalars['Decimal']>;
  professions?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutCouponInput>;
};

export type CouponUncheckedCreateWithoutTraineeEventInput = {
  TraineeEventGroup?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutCouponInput>;
  code: Scalars['String'];
  couponType: CouponType;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutCouponsInput>;
  expiryDate: Scalars['DateTime'];
  fixedAmountDiscount?: InputMaybe<Scalars['Decimal']>;
  fixedAmountMarketerProfit?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutCouponInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isForAllEvents: Scalars['Boolean'];
  isForAllSpecialties: Scalars['Boolean'];
  marketerProfitType?: InputMaybe<MarketerProfitType>;
  percentageDiscount?: InputMaybe<Scalars['Decimal']>;
  percentageMarketerProfit?: InputMaybe<Scalars['Decimal']>;
  percentageMaxAmount?: InputMaybe<Scalars['Decimal']>;
  professions?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutCouponInput>;
};

export type CouponUncheckedUpdateInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutCouponInput>;
  TraineeEventGroup?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutCouponInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  couponType?: InputMaybe<EnumCouponTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutCouponsInput>;
  expiryDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fixedAmountDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  fixedAmountMarketerProfit?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutCouponInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isForAllEvents?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isForAllSpecialties?: InputMaybe<BoolFieldUpdateOperationsInput>;
  marketerProfitType?: InputMaybe<NullableEnumMarketerProfitTypeFieldUpdateOperationsInput>;
  percentageDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  percentageMarketerProfit?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  percentageMaxAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  professions?: InputMaybe<ProfessionUncheckedUpdateManyWithoutCouponInput>;
};

export type CouponUncheckedUpdateManyInput = {
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  couponType?: InputMaybe<EnumCouponTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fixedAmountDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  fixedAmountMarketerProfit?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isForAllEvents?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isForAllSpecialties?: InputMaybe<BoolFieldUpdateOperationsInput>;
  marketerProfitType?: InputMaybe<NullableEnumMarketerProfitTypeFieldUpdateOperationsInput>;
  percentageDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  percentageMarketerProfit?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  percentageMaxAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type CouponUncheckedUpdateManyWithoutCouponsInput = {
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  couponType?: InputMaybe<EnumCouponTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fixedAmountDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  fixedAmountMarketerProfit?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isForAllEvents?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isForAllSpecialties?: InputMaybe<BoolFieldUpdateOperationsInput>;
  marketerProfitType?: InputMaybe<NullableEnumMarketerProfitTypeFieldUpdateOperationsInput>;
  percentageDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  percentageMarketerProfit?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  percentageMaxAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type CouponUncheckedUpdateManyWithoutEventsInput = {
  connect?: InputMaybe<Array<InputMaybe<CouponWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CouponCreateOrConnectWithoutEventsInput>>>;
  create?: InputMaybe<Array<InputMaybe<CouponCreateWithoutEventsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<CouponWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CouponScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CouponWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CouponWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CouponUpdateWithWhereUniqueWithoutEventsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CouponUpdateManyWithWhereWithoutEventsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CouponUpsertWithWhereUniqueWithoutEventsInput>>>;
};

export type CouponUncheckedUpdateManyWithoutInviterInput = {
  connect?: InputMaybe<Array<InputMaybe<CouponWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CouponCreateOrConnectWithoutInviterInput>>>;
  create?: InputMaybe<Array<InputMaybe<CouponCreateWithoutInviterInput>>>;
  createMany?: InputMaybe<CouponCreateManyInviterInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<CouponWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CouponScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CouponWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CouponWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CouponUpdateWithWhereUniqueWithoutInviterInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CouponUpdateManyWithWhereWithoutInviterInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CouponUpsertWithWhereUniqueWithoutInviterInput>>>;
};

export type CouponUncheckedUpdateWithoutEventsInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutCouponInput>;
  TraineeEventGroup?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutCouponInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  couponType?: InputMaybe<EnumCouponTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fixedAmountDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  fixedAmountMarketerProfit?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutCouponInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isForAllEvents?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isForAllSpecialties?: InputMaybe<BoolFieldUpdateOperationsInput>;
  marketerProfitType?: InputMaybe<NullableEnumMarketerProfitTypeFieldUpdateOperationsInput>;
  percentageDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  percentageMarketerProfit?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  percentageMaxAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  professions?: InputMaybe<ProfessionUncheckedUpdateManyWithoutCouponInput>;
};

export type CouponUncheckedUpdateWithoutInviterCouponProfitsInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutCouponInput>;
  TraineeEventGroup?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutCouponInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  couponType?: InputMaybe<EnumCouponTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutCouponsInput>;
  expiryDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fixedAmountDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  fixedAmountMarketerProfit?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isForAllEvents?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isForAllSpecialties?: InputMaybe<BoolFieldUpdateOperationsInput>;
  marketerProfitType?: InputMaybe<NullableEnumMarketerProfitTypeFieldUpdateOperationsInput>;
  percentageDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  percentageMarketerProfit?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  percentageMaxAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  professions?: InputMaybe<ProfessionUncheckedUpdateManyWithoutCouponInput>;
};

export type CouponUncheckedUpdateWithoutInviterInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutCouponInput>;
  TraineeEventGroup?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutCouponInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  couponType?: InputMaybe<EnumCouponTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutCouponsInput>;
  expiryDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fixedAmountDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  fixedAmountMarketerProfit?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutCouponInput>;
  isForAllEvents?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isForAllSpecialties?: InputMaybe<BoolFieldUpdateOperationsInput>;
  marketerProfitType?: InputMaybe<NullableEnumMarketerProfitTypeFieldUpdateOperationsInput>;
  percentageDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  percentageMarketerProfit?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  percentageMaxAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  professions?: InputMaybe<ProfessionUncheckedUpdateManyWithoutCouponInput>;
};

export type CouponUncheckedUpdateWithoutProfessionsInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutCouponInput>;
  TraineeEventGroup?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutCouponInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  couponType?: InputMaybe<EnumCouponTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutCouponsInput>;
  expiryDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fixedAmountDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  fixedAmountMarketerProfit?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutCouponInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isForAllEvents?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isForAllSpecialties?: InputMaybe<BoolFieldUpdateOperationsInput>;
  marketerProfitType?: InputMaybe<NullableEnumMarketerProfitTypeFieldUpdateOperationsInput>;
  percentageDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  percentageMarketerProfit?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  percentageMaxAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type CouponUncheckedUpdateWithoutTraineeEventGroupInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutCouponInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  couponType?: InputMaybe<EnumCouponTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutCouponsInput>;
  expiryDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fixedAmountDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  fixedAmountMarketerProfit?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutCouponInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isForAllEvents?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isForAllSpecialties?: InputMaybe<BoolFieldUpdateOperationsInput>;
  marketerProfitType?: InputMaybe<NullableEnumMarketerProfitTypeFieldUpdateOperationsInput>;
  percentageDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  percentageMarketerProfit?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  percentageMaxAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  professions?: InputMaybe<ProfessionUncheckedUpdateManyWithoutCouponInput>;
};

export type CouponUncheckedUpdateWithoutTraineeEventInput = {
  TraineeEventGroup?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutCouponInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  couponType?: InputMaybe<EnumCouponTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutCouponsInput>;
  expiryDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fixedAmountDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  fixedAmountMarketerProfit?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutCouponInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isForAllEvents?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isForAllSpecialties?: InputMaybe<BoolFieldUpdateOperationsInput>;
  marketerProfitType?: InputMaybe<NullableEnumMarketerProfitTypeFieldUpdateOperationsInput>;
  percentageDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  percentageMarketerProfit?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  percentageMaxAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  professions?: InputMaybe<ProfessionUncheckedUpdateManyWithoutCouponInput>;
};

export type CouponUpdateInput = {
  TraineeEvent?: InputMaybe<TraineeEventUpdateManyWithoutCouponInput>;
  TraineeEventGroup?: InputMaybe<TraineeEventGroupUpdateManyWithoutCouponInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  couponType?: InputMaybe<EnumCouponTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventUpdateManyWithoutCouponsInput>;
  expiryDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fixedAmountDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  fixedAmountMarketerProfit?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutCouponsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutCouponInput>;
  isForAllEvents?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isForAllSpecialties?: InputMaybe<BoolFieldUpdateOperationsInput>;
  marketerProfitType?: InputMaybe<NullableEnumMarketerProfitTypeFieldUpdateOperationsInput>;
  percentageDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  percentageMarketerProfit?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  percentageMaxAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  professions?: InputMaybe<ProfessionUpdateManyWithoutCouponInput>;
};

export type CouponUpdateManyMutationInput = {
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  couponType?: InputMaybe<EnumCouponTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fixedAmountDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  fixedAmountMarketerProfit?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  isForAllEvents?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isForAllSpecialties?: InputMaybe<BoolFieldUpdateOperationsInput>;
  marketerProfitType?: InputMaybe<NullableEnumMarketerProfitTypeFieldUpdateOperationsInput>;
  percentageDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  percentageMarketerProfit?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  percentageMaxAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type CouponUpdateManyWithWhereWithoutEventsInput = {
  data: CouponUncheckedUpdateManyWithoutCouponsInput;
  where: CouponScalarWhereInput;
};

export type CouponUpdateManyWithWhereWithoutInviterInput = {
  data: CouponUncheckedUpdateManyWithoutCouponsInput;
  where: CouponScalarWhereInput;
};

export type CouponUpdateManyWithoutEventsInput = {
  connect?: InputMaybe<Array<InputMaybe<CouponWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CouponCreateOrConnectWithoutEventsInput>>>;
  create?: InputMaybe<Array<InputMaybe<CouponCreateWithoutEventsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<CouponWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CouponScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CouponWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CouponWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CouponUpdateWithWhereUniqueWithoutEventsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CouponUpdateManyWithWhereWithoutEventsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CouponUpsertWithWhereUniqueWithoutEventsInput>>>;
};

export type CouponUpdateManyWithoutInviterInput = {
  connect?: InputMaybe<Array<InputMaybe<CouponWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CouponCreateOrConnectWithoutInviterInput>>>;
  create?: InputMaybe<Array<InputMaybe<CouponCreateWithoutInviterInput>>>;
  createMany?: InputMaybe<CouponCreateManyInviterInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<CouponWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CouponScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CouponWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CouponWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CouponUpdateWithWhereUniqueWithoutInviterInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CouponUpdateManyWithWhereWithoutInviterInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CouponUpsertWithWhereUniqueWithoutInviterInput>>>;
};

export type CouponUpdateOneWithoutInviterCouponProfitsInput = {
  connect?: InputMaybe<CouponWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CouponCreateOrConnectWithoutInviterCouponProfitsInput>;
  create?: InputMaybe<CouponUncheckedCreateWithoutInviterCouponProfitsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CouponUncheckedUpdateWithoutInviterCouponProfitsInput>;
  upsert?: InputMaybe<CouponUpsertWithoutInviterCouponProfitsInput>;
};

export type CouponUpdateOneWithoutProfessionsInput = {
  connect?: InputMaybe<CouponWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CouponCreateOrConnectWithoutProfessionsInput>;
  create?: InputMaybe<CouponUncheckedCreateWithoutProfessionsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CouponUncheckedUpdateWithoutProfessionsInput>;
  upsert?: InputMaybe<CouponUpsertWithoutProfessionsInput>;
};

export type CouponUpdateOneWithoutTraineeEventGroupInput = {
  connect?: InputMaybe<CouponWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CouponCreateOrConnectWithoutTraineeEventGroupInput>;
  create?: InputMaybe<CouponUncheckedCreateWithoutTraineeEventGroupInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CouponUncheckedUpdateWithoutTraineeEventGroupInput>;
  upsert?: InputMaybe<CouponUpsertWithoutTraineeEventGroupInput>;
};

export type CouponUpdateOneWithoutTraineeEventInput = {
  connect?: InputMaybe<CouponWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CouponCreateOrConnectWithoutTraineeEventInput>;
  create?: InputMaybe<CouponUncheckedCreateWithoutTraineeEventInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CouponUncheckedUpdateWithoutTraineeEventInput>;
  upsert?: InputMaybe<CouponUpsertWithoutTraineeEventInput>;
};

export type CouponUpdateWithWhereUniqueWithoutEventsInput = {
  data: CouponUncheckedUpdateWithoutEventsInput;
  where: CouponWhereUniqueInput;
};

export type CouponUpdateWithWhereUniqueWithoutInviterInput = {
  data: CouponUncheckedUpdateWithoutInviterInput;
  where: CouponWhereUniqueInput;
};

export type CouponUpdateWithoutEventsInput = {
  TraineeEvent?: InputMaybe<TraineeEventUpdateManyWithoutCouponInput>;
  TraineeEventGroup?: InputMaybe<TraineeEventGroupUpdateManyWithoutCouponInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  couponType?: InputMaybe<EnumCouponTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fixedAmountDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  fixedAmountMarketerProfit?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutCouponsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutCouponInput>;
  isForAllEvents?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isForAllSpecialties?: InputMaybe<BoolFieldUpdateOperationsInput>;
  marketerProfitType?: InputMaybe<NullableEnumMarketerProfitTypeFieldUpdateOperationsInput>;
  percentageDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  percentageMarketerProfit?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  percentageMaxAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  professions?: InputMaybe<ProfessionUpdateManyWithoutCouponInput>;
};

export type CouponUpdateWithoutInviterCouponProfitsInput = {
  TraineeEvent?: InputMaybe<TraineeEventUpdateManyWithoutCouponInput>;
  TraineeEventGroup?: InputMaybe<TraineeEventGroupUpdateManyWithoutCouponInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  couponType?: InputMaybe<EnumCouponTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventUpdateManyWithoutCouponsInput>;
  expiryDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fixedAmountDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  fixedAmountMarketerProfit?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutCouponsInput>;
  isForAllEvents?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isForAllSpecialties?: InputMaybe<BoolFieldUpdateOperationsInput>;
  marketerProfitType?: InputMaybe<NullableEnumMarketerProfitTypeFieldUpdateOperationsInput>;
  percentageDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  percentageMarketerProfit?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  percentageMaxAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  professions?: InputMaybe<ProfessionUpdateManyWithoutCouponInput>;
};

export type CouponUpdateWithoutInviterInput = {
  TraineeEvent?: InputMaybe<TraineeEventUpdateManyWithoutCouponInput>;
  TraineeEventGroup?: InputMaybe<TraineeEventGroupUpdateManyWithoutCouponInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  couponType?: InputMaybe<EnumCouponTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventUpdateManyWithoutCouponsInput>;
  expiryDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fixedAmountDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  fixedAmountMarketerProfit?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutCouponInput>;
  isForAllEvents?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isForAllSpecialties?: InputMaybe<BoolFieldUpdateOperationsInput>;
  marketerProfitType?: InputMaybe<NullableEnumMarketerProfitTypeFieldUpdateOperationsInput>;
  percentageDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  percentageMarketerProfit?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  percentageMaxAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  professions?: InputMaybe<ProfessionUpdateManyWithoutCouponInput>;
};

export type CouponUpdateWithoutProfessionsInput = {
  TraineeEvent?: InputMaybe<TraineeEventUpdateManyWithoutCouponInput>;
  TraineeEventGroup?: InputMaybe<TraineeEventGroupUpdateManyWithoutCouponInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  couponType?: InputMaybe<EnumCouponTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventUpdateManyWithoutCouponsInput>;
  expiryDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fixedAmountDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  fixedAmountMarketerProfit?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutCouponsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutCouponInput>;
  isForAllEvents?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isForAllSpecialties?: InputMaybe<BoolFieldUpdateOperationsInput>;
  marketerProfitType?: InputMaybe<NullableEnumMarketerProfitTypeFieldUpdateOperationsInput>;
  percentageDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  percentageMarketerProfit?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  percentageMaxAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type CouponUpdateWithoutTraineeEventGroupInput = {
  TraineeEvent?: InputMaybe<TraineeEventUpdateManyWithoutCouponInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  couponType?: InputMaybe<EnumCouponTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventUpdateManyWithoutCouponsInput>;
  expiryDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fixedAmountDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  fixedAmountMarketerProfit?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutCouponsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutCouponInput>;
  isForAllEvents?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isForAllSpecialties?: InputMaybe<BoolFieldUpdateOperationsInput>;
  marketerProfitType?: InputMaybe<NullableEnumMarketerProfitTypeFieldUpdateOperationsInput>;
  percentageDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  percentageMarketerProfit?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  percentageMaxAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  professions?: InputMaybe<ProfessionUpdateManyWithoutCouponInput>;
};

export type CouponUpdateWithoutTraineeEventInput = {
  TraineeEventGroup?: InputMaybe<TraineeEventGroupUpdateManyWithoutCouponInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  couponType?: InputMaybe<EnumCouponTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventUpdateManyWithoutCouponsInput>;
  expiryDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fixedAmountDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  fixedAmountMarketerProfit?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutCouponsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutCouponInput>;
  isForAllEvents?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isForAllSpecialties?: InputMaybe<BoolFieldUpdateOperationsInput>;
  marketerProfitType?: InputMaybe<NullableEnumMarketerProfitTypeFieldUpdateOperationsInput>;
  percentageDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  percentageMarketerProfit?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  percentageMaxAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  professions?: InputMaybe<ProfessionUpdateManyWithoutCouponInput>;
};

export type CouponUpsertWithWhereUniqueWithoutEventsInput = {
  create: CouponUncheckedCreateWithoutEventsInput;
  update: CouponUncheckedUpdateWithoutEventsInput;
  where: CouponWhereUniqueInput;
};

export type CouponUpsertWithWhereUniqueWithoutInviterInput = {
  create: CouponUncheckedCreateWithoutInviterInput;
  update: CouponUncheckedUpdateWithoutInviterInput;
  where: CouponWhereUniqueInput;
};

export type CouponUpsertWithoutInviterCouponProfitsInput = {
  create: CouponUncheckedCreateWithoutInviterCouponProfitsInput;
  update: CouponUncheckedUpdateWithoutInviterCouponProfitsInput;
};

export type CouponUpsertWithoutProfessionsInput = {
  create: CouponUncheckedCreateWithoutProfessionsInput;
  update: CouponUncheckedUpdateWithoutProfessionsInput;
};

export type CouponUpsertWithoutTraineeEventGroupInput = {
  create: CouponUncheckedCreateWithoutTraineeEventGroupInput;
  update: CouponUncheckedUpdateWithoutTraineeEventGroupInput;
};

export type CouponUpsertWithoutTraineeEventInput = {
  create: CouponUncheckedCreateWithoutTraineeEventInput;
  update: CouponUncheckedUpdateWithoutTraineeEventInput;
};

export type CouponWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<CouponWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<CouponWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CouponWhereInput>>>;
  TraineeEvent?: InputMaybe<TraineeEventListRelationFilter>;
  TraineeEventGroup?: InputMaybe<TraineeEventGroupListRelationFilter>;
  code?: InputMaybe<StringFilter>;
  couponType?: InputMaybe<EnumCouponTypeFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  events?: InputMaybe<EventListRelationFilter>;
  expiryDate?: InputMaybe<DateTimeFilter>;
  fixedAmountDiscount?: InputMaybe<DecimalNullableFilter>;
  fixedAmountMarketerProfit?: InputMaybe<DecimalNullableFilter>;
  id?: InputMaybe<IntFilter>;
  inviter?: InputMaybe<UserWhereInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitListRelationFilter>;
  inviterId?: InputMaybe<IntNullableFilter>;
  isForAllEvents?: InputMaybe<BoolFilter>;
  isForAllSpecialties?: InputMaybe<BoolFilter>;
  marketerProfitType?: InputMaybe<EnumMarketerProfitTypeNullableFilter>;
  percentageDiscount?: InputMaybe<DecimalNullableFilter>;
  percentageMarketerProfit?: InputMaybe<DecimalNullableFilter>;
  percentageMaxAmount?: InputMaybe<DecimalNullableFilter>;
  professions?: InputMaybe<ProfessionListRelationFilter>;
};

export type CouponWhereUniqueInput = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type CoursesPaths = {
  __typename?: 'CoursesPaths';
  id?: Maybe<Scalars['Int']>;
};

export type Cv = {
  __typename?: 'Cv';
  User?: Maybe<User>;
  _count: CvCountOutputType;
  education: Array<Education>;
  id: Scalars['Int'];
  professionalSkills: Array<ProfessionalSkills>;
  qualification?: Maybe<Qualification>;
  qualificationId?: Maybe<Scalars['Int']>;
  rank?: Maybe<Rank>;
  rankId?: Maybe<Scalars['Int']>;
  scientificResearches: Array<ScientificResearch>;
  trainingExperience: Array<TrainingExperience>;
};


export type CvEducationArgs = {
  cursor?: InputMaybe<EducationWhereUniqueInput>;
  distinct?: InputMaybe<EducationScalarFieldEnum>;
  orderBy?: InputMaybe<EducationOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EducationWhereInput>;
};


export type CvProfessionalSkillsArgs = {
  cursor?: InputMaybe<ProfessionalSkillsWhereUniqueInput>;
  distinct?: InputMaybe<ProfessionalSkillsScalarFieldEnum>;
  orderBy?: InputMaybe<ProfessionalSkillsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProfessionalSkillsWhereInput>;
};


export type CvScientificResearchesArgs = {
  cursor?: InputMaybe<ScientificResearchWhereUniqueInput>;
  distinct?: InputMaybe<ScientificResearchScalarFieldEnum>;
  orderBy?: InputMaybe<ScientificResearchOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScientificResearchWhereInput>;
};


export type CvTrainingExperienceArgs = {
  cursor?: InputMaybe<TrainingExperienceWhereUniqueInput>;
  distinct?: InputMaybe<TrainingExperienceScalarFieldEnum>;
  orderBy?: InputMaybe<TrainingExperienceOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TrainingExperienceWhereInput>;
};

export type CvAvgAggregateOutputType = {
  __typename?: 'CvAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
  qualificationId?: Maybe<Scalars['Float']>;
  rankId?: Maybe<Scalars['Float']>;
};

export type CvAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  qualificationId?: InputMaybe<SortOrder>;
  rankId?: InputMaybe<SortOrder>;
};

export type CvCountAggregateOutputType = {
  __typename?: 'CvCountAggregateOutputType';
  _all: Scalars['Int'];
  id: Scalars['Int'];
  qualificationId: Scalars['Int'];
  rankId: Scalars['Int'];
};

export type CvCountOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  qualificationId?: InputMaybe<SortOrder>;
  rankId?: InputMaybe<SortOrder>;
};

export type CvCountOutputType = {
  __typename?: 'CvCountOutputType';
  applications: Scalars['Int'];
  education: Scalars['Int'];
  professionalSkills: Scalars['Int'];
  scientificResearches: Scalars['Int'];
  trainingExperience: Scalars['Int'];
};

export type CvCreateInput = {
  User?: InputMaybe<UserCreateNestedOneWithoutTrainerCvInput>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutCvInput>;
  education?: InputMaybe<EducationCreateNestedManyWithoutCvInput>;
  professionalSkills?: InputMaybe<ProfessionalSkillsCreateNestedManyWithoutCvInput>;
  qualification?: InputMaybe<QualificationCreateNestedOneWithoutCvInput>;
  rank?: InputMaybe<RankCreateNestedOneWithoutCvInput>;
  scientificResearches?: InputMaybe<ScientificResearchCreateNestedManyWithoutCvInput>;
  trainingExperience?: InputMaybe<TrainingExperienceCreateNestedManyWithoutCvInput>;
};

export type CvCreateManyInput = {
  id?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  rankId?: InputMaybe<Scalars['Int']>;
};

export type CvCreateManyQualificationInput = {
  id?: InputMaybe<Scalars['Int']>;
  rankId?: InputMaybe<Scalars['Int']>;
};

export type CvCreateManyQualificationInputEnvelope = {
  data: CvCreateManyQualificationInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CvCreateManyRankInput = {
  id?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
};

export type CvCreateManyRankInputEnvelope = {
  data: CvCreateManyRankInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CvCreateNestedManyWithoutQualificationInput = {
  connect?: InputMaybe<Array<InputMaybe<CvWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CvCreateOrConnectWithoutQualificationInput>>>;
  create?: InputMaybe<Array<InputMaybe<CvCreateWithoutQualificationInput>>>;
  createMany?: InputMaybe<CvCreateManyQualificationInputEnvelope>;
};

export type CvCreateNestedManyWithoutRankInput = {
  connect?: InputMaybe<Array<InputMaybe<CvWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CvCreateOrConnectWithoutRankInput>>>;
  create?: InputMaybe<Array<InputMaybe<CvCreateWithoutRankInput>>>;
  createMany?: InputMaybe<CvCreateManyRankInputEnvelope>;
};

export type CvCreateNestedOneWithoutApplicationsInput = {
  connect?: InputMaybe<CvWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CvCreateOrConnectWithoutApplicationsInput>;
  create?: InputMaybe<CvUncheckedCreateWithoutApplicationsInput>;
};

export type CvCreateNestedOneWithoutEducationInput = {
  connect?: InputMaybe<CvWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CvCreateOrConnectWithoutEducationInput>;
  create?: InputMaybe<CvUncheckedCreateWithoutEducationInput>;
};

export type CvCreateNestedOneWithoutProfessionalSkillsInput = {
  connect?: InputMaybe<CvWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CvCreateOrConnectWithoutProfessionalSkillsInput>;
  create?: InputMaybe<CvUncheckedCreateWithoutProfessionalSkillsInput>;
};

export type CvCreateNestedOneWithoutScientificResearchesInput = {
  connect?: InputMaybe<CvWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CvCreateOrConnectWithoutScientificResearchesInput>;
  create?: InputMaybe<CvUncheckedCreateWithoutScientificResearchesInput>;
};

export type CvCreateNestedOneWithoutTrainingExperienceInput = {
  connect?: InputMaybe<CvWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CvCreateOrConnectWithoutTrainingExperienceInput>;
  create?: InputMaybe<CvUncheckedCreateWithoutTrainingExperienceInput>;
};

export type CvCreateNestedOneWithoutUserInput = {
  connect?: InputMaybe<CvWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CvCreateOrConnectWithoutUserInput>;
  create?: InputMaybe<CvUncheckedCreateWithoutUserInput>;
};

export type CvCreateOrConnectWithoutApplicationsInput = {
  create: CvUncheckedCreateWithoutApplicationsInput;
  where: CvWhereUniqueInput;
};

export type CvCreateOrConnectWithoutEducationInput = {
  create: CvUncheckedCreateWithoutEducationInput;
  where: CvWhereUniqueInput;
};

export type CvCreateOrConnectWithoutProfessionalSkillsInput = {
  create: CvUncheckedCreateWithoutProfessionalSkillsInput;
  where: CvWhereUniqueInput;
};

export type CvCreateOrConnectWithoutQualificationInput = {
  create: CvUncheckedCreateWithoutQualificationInput;
  where: CvWhereUniqueInput;
};

export type CvCreateOrConnectWithoutRankInput = {
  create: CvUncheckedCreateWithoutRankInput;
  where: CvWhereUniqueInput;
};

export type CvCreateOrConnectWithoutScientificResearchesInput = {
  create: CvUncheckedCreateWithoutScientificResearchesInput;
  where: CvWhereUniqueInput;
};

export type CvCreateOrConnectWithoutTrainingExperienceInput = {
  create: CvUncheckedCreateWithoutTrainingExperienceInput;
  where: CvWhereUniqueInput;
};

export type CvCreateOrConnectWithoutUserInput = {
  create: CvUncheckedCreateWithoutUserInput;
  where: CvWhereUniqueInput;
};

export type CvCreateWithoutApplicationsInput = {
  User?: InputMaybe<UserCreateNestedOneWithoutTrainerCvInput>;
  education?: InputMaybe<EducationCreateNestedManyWithoutCvInput>;
  professionalSkills?: InputMaybe<ProfessionalSkillsCreateNestedManyWithoutCvInput>;
  qualification?: InputMaybe<QualificationCreateNestedOneWithoutCvInput>;
  rank?: InputMaybe<RankCreateNestedOneWithoutCvInput>;
  scientificResearches?: InputMaybe<ScientificResearchCreateNestedManyWithoutCvInput>;
  trainingExperience?: InputMaybe<TrainingExperienceCreateNestedManyWithoutCvInput>;
};

export type CvCreateWithoutEducationInput = {
  User?: InputMaybe<UserCreateNestedOneWithoutTrainerCvInput>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutCvInput>;
  professionalSkills?: InputMaybe<ProfessionalSkillsCreateNestedManyWithoutCvInput>;
  qualification?: InputMaybe<QualificationCreateNestedOneWithoutCvInput>;
  rank?: InputMaybe<RankCreateNestedOneWithoutCvInput>;
  scientificResearches?: InputMaybe<ScientificResearchCreateNestedManyWithoutCvInput>;
  trainingExperience?: InputMaybe<TrainingExperienceCreateNestedManyWithoutCvInput>;
};

export type CvCreateWithoutProfessionalSkillsInput = {
  User?: InputMaybe<UserCreateNestedOneWithoutTrainerCvInput>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutCvInput>;
  education?: InputMaybe<EducationCreateNestedManyWithoutCvInput>;
  qualification?: InputMaybe<QualificationCreateNestedOneWithoutCvInput>;
  rank?: InputMaybe<RankCreateNestedOneWithoutCvInput>;
  scientificResearches?: InputMaybe<ScientificResearchCreateNestedManyWithoutCvInput>;
  trainingExperience?: InputMaybe<TrainingExperienceCreateNestedManyWithoutCvInput>;
};

export type CvCreateWithoutQualificationInput = {
  User?: InputMaybe<UserCreateNestedOneWithoutTrainerCvInput>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutCvInput>;
  education?: InputMaybe<EducationCreateNestedManyWithoutCvInput>;
  professionalSkills?: InputMaybe<ProfessionalSkillsCreateNestedManyWithoutCvInput>;
  rank?: InputMaybe<RankCreateNestedOneWithoutCvInput>;
  scientificResearches?: InputMaybe<ScientificResearchCreateNestedManyWithoutCvInput>;
  trainingExperience?: InputMaybe<TrainingExperienceCreateNestedManyWithoutCvInput>;
};

export type CvCreateWithoutRankInput = {
  User?: InputMaybe<UserCreateNestedOneWithoutTrainerCvInput>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutCvInput>;
  education?: InputMaybe<EducationCreateNestedManyWithoutCvInput>;
  professionalSkills?: InputMaybe<ProfessionalSkillsCreateNestedManyWithoutCvInput>;
  qualification?: InputMaybe<QualificationCreateNestedOneWithoutCvInput>;
  scientificResearches?: InputMaybe<ScientificResearchCreateNestedManyWithoutCvInput>;
  trainingExperience?: InputMaybe<TrainingExperienceCreateNestedManyWithoutCvInput>;
};

export type CvCreateWithoutScientificResearchesInput = {
  User?: InputMaybe<UserCreateNestedOneWithoutTrainerCvInput>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutCvInput>;
  education?: InputMaybe<EducationCreateNestedManyWithoutCvInput>;
  professionalSkills?: InputMaybe<ProfessionalSkillsCreateNestedManyWithoutCvInput>;
  qualification?: InputMaybe<QualificationCreateNestedOneWithoutCvInput>;
  rank?: InputMaybe<RankCreateNestedOneWithoutCvInput>;
  trainingExperience?: InputMaybe<TrainingExperienceCreateNestedManyWithoutCvInput>;
};

export type CvCreateWithoutTrainingExperienceInput = {
  User?: InputMaybe<UserCreateNestedOneWithoutTrainerCvInput>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutCvInput>;
  education?: InputMaybe<EducationCreateNestedManyWithoutCvInput>;
  professionalSkills?: InputMaybe<ProfessionalSkillsCreateNestedManyWithoutCvInput>;
  qualification?: InputMaybe<QualificationCreateNestedOneWithoutCvInput>;
  rank?: InputMaybe<RankCreateNestedOneWithoutCvInput>;
  scientificResearches?: InputMaybe<ScientificResearchCreateNestedManyWithoutCvInput>;
};

export type CvCreateWithoutUserInput = {
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutCvInput>;
  education?: InputMaybe<EducationCreateNestedManyWithoutCvInput>;
  professionalSkills?: InputMaybe<ProfessionalSkillsCreateNestedManyWithoutCvInput>;
  qualification?: InputMaybe<QualificationCreateNestedOneWithoutCvInput>;
  rank?: InputMaybe<RankCreateNestedOneWithoutCvInput>;
  scientificResearches?: InputMaybe<ScientificResearchCreateNestedManyWithoutCvInput>;
  trainingExperience?: InputMaybe<TrainingExperienceCreateNestedManyWithoutCvInput>;
};

export type CvListRelationFilter = {
  every?: InputMaybe<CvWhereInput>;
  none?: InputMaybe<CvWhereInput>;
  some?: InputMaybe<CvWhereInput>;
};

export type CvMaxAggregateOutputType = {
  __typename?: 'CvMaxAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
  qualificationId?: Maybe<Scalars['Int']>;
  rankId?: Maybe<Scalars['Int']>;
};

export type CvMaxOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  qualificationId?: InputMaybe<SortOrder>;
  rankId?: InputMaybe<SortOrder>;
};

export type CvMinAggregateOutputType = {
  __typename?: 'CvMinAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
  qualificationId?: Maybe<Scalars['Int']>;
  rankId?: Maybe<Scalars['Int']>;
};

export type CvMinOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  qualificationId?: InputMaybe<SortOrder>;
  rankId?: InputMaybe<SortOrder>;
};

export type CvOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CvOrderByWithAggregationInput = {
  _avg?: InputMaybe<CvAvgOrderByAggregateInput>;
  _count?: InputMaybe<CvCountOrderByAggregateInput>;
  _max?: InputMaybe<CvMaxOrderByAggregateInput>;
  _min?: InputMaybe<CvMinOrderByAggregateInput>;
  _sum?: InputMaybe<CvSumOrderByAggregateInput>;
  id?: InputMaybe<SortOrder>;
  qualificationId?: InputMaybe<SortOrder>;
  rankId?: InputMaybe<SortOrder>;
};

export type CvOrderByWithRelationInput = {
  User?: InputMaybe<UserOrderByWithRelationInput>;
  applications?: InputMaybe<BecomeTrainerApplicationOrderByRelationAggregateInput>;
  education?: InputMaybe<EducationOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  professionalSkills?: InputMaybe<ProfessionalSkillsOrderByRelationAggregateInput>;
  qualification?: InputMaybe<QualificationOrderByWithRelationInput>;
  qualificationId?: InputMaybe<SortOrder>;
  rank?: InputMaybe<RankOrderByWithRelationInput>;
  rankId?: InputMaybe<SortOrder>;
  scientificResearches?: InputMaybe<ScientificResearchOrderByRelationAggregateInput>;
  trainingExperience?: InputMaybe<TrainingExperienceOrderByRelationAggregateInput>;
};

export type CvRelationFilter = {
  is?: InputMaybe<CvWhereInput>;
  isNot?: InputMaybe<CvWhereInput>;
};

export enum CvScalarFieldEnum {
  Id = 'id',
  QualificationId = 'qualificationId',
  RankId = 'rankId'
}

export type CvScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<CvScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<CvScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CvScalarWhereInput>>>;
  id?: InputMaybe<IntFilter>;
  qualificationId?: InputMaybe<IntNullableFilter>;
  rankId?: InputMaybe<IntNullableFilter>;
};

export type CvScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<CvScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<CvScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CvScalarWhereWithAggregatesInput>>>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  qualificationId?: InputMaybe<IntNullableWithAggregatesFilter>;
  rankId?: InputMaybe<IntNullableWithAggregatesFilter>;
};

export type CvSumAggregateOutputType = {
  __typename?: 'CvSumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
  qualificationId?: Maybe<Scalars['Int']>;
  rankId?: Maybe<Scalars['Int']>;
};

export type CvSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  qualificationId?: InputMaybe<SortOrder>;
  rankId?: InputMaybe<SortOrder>;
};

export type CvUncheckedCreateInput = {
  User?: InputMaybe<UserUncheckedCreateNestedOneWithoutTrainerCvInput>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutCvInput>;
  education?: InputMaybe<EducationUncheckedCreateNestedManyWithoutCvInput>;
  id?: InputMaybe<Scalars['Int']>;
  professionalSkills?: InputMaybe<ProfessionalSkillsUncheckedCreateNestedManyWithoutCvInput>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  rankId?: InputMaybe<Scalars['Int']>;
  scientificResearches?: InputMaybe<ScientificResearchUncheckedCreateNestedManyWithoutCvInput>;
  trainingExperience?: InputMaybe<TrainingExperienceUncheckedCreateNestedManyWithoutCvInput>;
};

export type CvUncheckedCreateNestedManyWithoutQualificationInput = {
  connect?: InputMaybe<Array<InputMaybe<CvWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CvCreateOrConnectWithoutQualificationInput>>>;
  create?: InputMaybe<Array<InputMaybe<CvCreateWithoutQualificationInput>>>;
  createMany?: InputMaybe<CvCreateManyQualificationInputEnvelope>;
};

export type CvUncheckedCreateNestedManyWithoutRankInput = {
  connect?: InputMaybe<Array<InputMaybe<CvWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CvCreateOrConnectWithoutRankInput>>>;
  create?: InputMaybe<Array<InputMaybe<CvCreateWithoutRankInput>>>;
  createMany?: InputMaybe<CvCreateManyRankInputEnvelope>;
};

export type CvUncheckedCreateWithoutApplicationsInput = {
  User?: InputMaybe<UserUncheckedCreateNestedOneWithoutTrainerCvInput>;
  education?: InputMaybe<EducationUncheckedCreateNestedManyWithoutCvInput>;
  id?: InputMaybe<Scalars['Int']>;
  professionalSkills?: InputMaybe<ProfessionalSkillsUncheckedCreateNestedManyWithoutCvInput>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  rankId?: InputMaybe<Scalars['Int']>;
  scientificResearches?: InputMaybe<ScientificResearchUncheckedCreateNestedManyWithoutCvInput>;
  trainingExperience?: InputMaybe<TrainingExperienceUncheckedCreateNestedManyWithoutCvInput>;
};

export type CvUncheckedCreateWithoutEducationInput = {
  User?: InputMaybe<UserUncheckedCreateNestedOneWithoutTrainerCvInput>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutCvInput>;
  id?: InputMaybe<Scalars['Int']>;
  professionalSkills?: InputMaybe<ProfessionalSkillsUncheckedCreateNestedManyWithoutCvInput>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  rankId?: InputMaybe<Scalars['Int']>;
  scientificResearches?: InputMaybe<ScientificResearchUncheckedCreateNestedManyWithoutCvInput>;
  trainingExperience?: InputMaybe<TrainingExperienceUncheckedCreateNestedManyWithoutCvInput>;
};

export type CvUncheckedCreateWithoutProfessionalSkillsInput = {
  User?: InputMaybe<UserUncheckedCreateNestedOneWithoutTrainerCvInput>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutCvInput>;
  education?: InputMaybe<EducationUncheckedCreateNestedManyWithoutCvInput>;
  id?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  rankId?: InputMaybe<Scalars['Int']>;
  scientificResearches?: InputMaybe<ScientificResearchUncheckedCreateNestedManyWithoutCvInput>;
  trainingExperience?: InputMaybe<TrainingExperienceUncheckedCreateNestedManyWithoutCvInput>;
};

export type CvUncheckedCreateWithoutQualificationInput = {
  User?: InputMaybe<UserUncheckedCreateNestedOneWithoutTrainerCvInput>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutCvInput>;
  education?: InputMaybe<EducationUncheckedCreateNestedManyWithoutCvInput>;
  id?: InputMaybe<Scalars['Int']>;
  professionalSkills?: InputMaybe<ProfessionalSkillsUncheckedCreateNestedManyWithoutCvInput>;
  rankId?: InputMaybe<Scalars['Int']>;
  scientificResearches?: InputMaybe<ScientificResearchUncheckedCreateNestedManyWithoutCvInput>;
  trainingExperience?: InputMaybe<TrainingExperienceUncheckedCreateNestedManyWithoutCvInput>;
};

export type CvUncheckedCreateWithoutRankInput = {
  User?: InputMaybe<UserUncheckedCreateNestedOneWithoutTrainerCvInput>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutCvInput>;
  education?: InputMaybe<EducationUncheckedCreateNestedManyWithoutCvInput>;
  id?: InputMaybe<Scalars['Int']>;
  professionalSkills?: InputMaybe<ProfessionalSkillsUncheckedCreateNestedManyWithoutCvInput>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  scientificResearches?: InputMaybe<ScientificResearchUncheckedCreateNestedManyWithoutCvInput>;
  trainingExperience?: InputMaybe<TrainingExperienceUncheckedCreateNestedManyWithoutCvInput>;
};

export type CvUncheckedCreateWithoutScientificResearchesInput = {
  User?: InputMaybe<UserUncheckedCreateNestedOneWithoutTrainerCvInput>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutCvInput>;
  education?: InputMaybe<EducationUncheckedCreateNestedManyWithoutCvInput>;
  id?: InputMaybe<Scalars['Int']>;
  professionalSkills?: InputMaybe<ProfessionalSkillsUncheckedCreateNestedManyWithoutCvInput>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  rankId?: InputMaybe<Scalars['Int']>;
  trainingExperience?: InputMaybe<TrainingExperienceUncheckedCreateNestedManyWithoutCvInput>;
};

export type CvUncheckedCreateWithoutTrainingExperienceInput = {
  User?: InputMaybe<UserUncheckedCreateNestedOneWithoutTrainerCvInput>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutCvInput>;
  education?: InputMaybe<EducationUncheckedCreateNestedManyWithoutCvInput>;
  id?: InputMaybe<Scalars['Int']>;
  professionalSkills?: InputMaybe<ProfessionalSkillsUncheckedCreateNestedManyWithoutCvInput>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  rankId?: InputMaybe<Scalars['Int']>;
  scientificResearches?: InputMaybe<ScientificResearchUncheckedCreateNestedManyWithoutCvInput>;
};

export type CvUncheckedCreateWithoutUserInput = {
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutCvInput>;
  education?: InputMaybe<EducationUncheckedCreateNestedManyWithoutCvInput>;
  id?: InputMaybe<Scalars['Int']>;
  professionalSkills?: InputMaybe<ProfessionalSkillsUncheckedCreateNestedManyWithoutCvInput>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  rankId?: InputMaybe<Scalars['Int']>;
  scientificResearches?: InputMaybe<ScientificResearchUncheckedCreateNestedManyWithoutCvInput>;
  trainingExperience?: InputMaybe<TrainingExperienceUncheckedCreateNestedManyWithoutCvInput>;
};

export type CvUncheckedUpdateInput = {
  User?: InputMaybe<UserUncheckedUpdateOneWithoutTrainerCvInput>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutCvInput>;
  education?: InputMaybe<EducationUncheckedUpdateManyWithoutCvInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  professionalSkills?: InputMaybe<ProfessionalSkillsUncheckedUpdateManyWithoutCvInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  rankId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  scientificResearches?: InputMaybe<ScientificResearchUncheckedUpdateManyWithoutCvInput>;
  trainingExperience?: InputMaybe<TrainingExperienceUncheckedUpdateManyWithoutCvInput>;
};

export type CvUncheckedUpdateManyInput = {
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  rankId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type CvUncheckedUpdateManyWithoutCvInput = {
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  rankId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type CvUncheckedUpdateManyWithoutQualificationInput = {
  connect?: InputMaybe<Array<InputMaybe<CvWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CvCreateOrConnectWithoutQualificationInput>>>;
  create?: InputMaybe<Array<InputMaybe<CvCreateWithoutQualificationInput>>>;
  createMany?: InputMaybe<CvCreateManyQualificationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<CvWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CvScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CvWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CvWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CvUpdateWithWhereUniqueWithoutQualificationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CvUpdateManyWithWhereWithoutQualificationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CvUpsertWithWhereUniqueWithoutQualificationInput>>>;
};

export type CvUncheckedUpdateManyWithoutRankInput = {
  connect?: InputMaybe<Array<InputMaybe<CvWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CvCreateOrConnectWithoutRankInput>>>;
  create?: InputMaybe<Array<InputMaybe<CvCreateWithoutRankInput>>>;
  createMany?: InputMaybe<CvCreateManyRankInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<CvWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CvScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CvWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CvWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CvUpdateWithWhereUniqueWithoutRankInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CvUpdateManyWithWhereWithoutRankInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CvUpsertWithWhereUniqueWithoutRankInput>>>;
};

export type CvUncheckedUpdateWithoutApplicationsInput = {
  User?: InputMaybe<UserUncheckedUpdateOneWithoutTrainerCvInput>;
  education?: InputMaybe<EducationUncheckedUpdateManyWithoutCvInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  professionalSkills?: InputMaybe<ProfessionalSkillsUncheckedUpdateManyWithoutCvInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  rankId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  scientificResearches?: InputMaybe<ScientificResearchUncheckedUpdateManyWithoutCvInput>;
  trainingExperience?: InputMaybe<TrainingExperienceUncheckedUpdateManyWithoutCvInput>;
};

export type CvUncheckedUpdateWithoutEducationInput = {
  User?: InputMaybe<UserUncheckedUpdateOneWithoutTrainerCvInput>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutCvInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  professionalSkills?: InputMaybe<ProfessionalSkillsUncheckedUpdateManyWithoutCvInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  rankId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  scientificResearches?: InputMaybe<ScientificResearchUncheckedUpdateManyWithoutCvInput>;
  trainingExperience?: InputMaybe<TrainingExperienceUncheckedUpdateManyWithoutCvInput>;
};

export type CvUncheckedUpdateWithoutProfessionalSkillsInput = {
  User?: InputMaybe<UserUncheckedUpdateOneWithoutTrainerCvInput>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutCvInput>;
  education?: InputMaybe<EducationUncheckedUpdateManyWithoutCvInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  rankId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  scientificResearches?: InputMaybe<ScientificResearchUncheckedUpdateManyWithoutCvInput>;
  trainingExperience?: InputMaybe<TrainingExperienceUncheckedUpdateManyWithoutCvInput>;
};

export type CvUncheckedUpdateWithoutQualificationInput = {
  User?: InputMaybe<UserUncheckedUpdateOneWithoutTrainerCvInput>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutCvInput>;
  education?: InputMaybe<EducationUncheckedUpdateManyWithoutCvInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  professionalSkills?: InputMaybe<ProfessionalSkillsUncheckedUpdateManyWithoutCvInput>;
  rankId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  scientificResearches?: InputMaybe<ScientificResearchUncheckedUpdateManyWithoutCvInput>;
  trainingExperience?: InputMaybe<TrainingExperienceUncheckedUpdateManyWithoutCvInput>;
};

export type CvUncheckedUpdateWithoutRankInput = {
  User?: InputMaybe<UserUncheckedUpdateOneWithoutTrainerCvInput>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutCvInput>;
  education?: InputMaybe<EducationUncheckedUpdateManyWithoutCvInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  professionalSkills?: InputMaybe<ProfessionalSkillsUncheckedUpdateManyWithoutCvInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  scientificResearches?: InputMaybe<ScientificResearchUncheckedUpdateManyWithoutCvInput>;
  trainingExperience?: InputMaybe<TrainingExperienceUncheckedUpdateManyWithoutCvInput>;
};

export type CvUncheckedUpdateWithoutScientificResearchesInput = {
  User?: InputMaybe<UserUncheckedUpdateOneWithoutTrainerCvInput>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutCvInput>;
  education?: InputMaybe<EducationUncheckedUpdateManyWithoutCvInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  professionalSkills?: InputMaybe<ProfessionalSkillsUncheckedUpdateManyWithoutCvInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  rankId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainingExperience?: InputMaybe<TrainingExperienceUncheckedUpdateManyWithoutCvInput>;
};

export type CvUncheckedUpdateWithoutTrainingExperienceInput = {
  User?: InputMaybe<UserUncheckedUpdateOneWithoutTrainerCvInput>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutCvInput>;
  education?: InputMaybe<EducationUncheckedUpdateManyWithoutCvInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  professionalSkills?: InputMaybe<ProfessionalSkillsUncheckedUpdateManyWithoutCvInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  rankId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  scientificResearches?: InputMaybe<ScientificResearchUncheckedUpdateManyWithoutCvInput>;
};

export type CvUncheckedUpdateWithoutUserInput = {
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutCvInput>;
  education?: InputMaybe<EducationUncheckedUpdateManyWithoutCvInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  professionalSkills?: InputMaybe<ProfessionalSkillsUncheckedUpdateManyWithoutCvInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  rankId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  scientificResearches?: InputMaybe<ScientificResearchUncheckedUpdateManyWithoutCvInput>;
  trainingExperience?: InputMaybe<TrainingExperienceUncheckedUpdateManyWithoutCvInput>;
};

export type CvUpdateInput = {
  User?: InputMaybe<UserUpdateOneWithoutTrainerCvInput>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutCvInput>;
  education?: InputMaybe<EducationUpdateManyWithoutCvInput>;
  professionalSkills?: InputMaybe<ProfessionalSkillsUpdateManyWithoutCvInput>;
  qualification?: InputMaybe<QualificationUpdateOneWithoutCvInput>;
  rank?: InputMaybe<RankUpdateOneWithoutCvInput>;
  scientificResearches?: InputMaybe<ScientificResearchUpdateManyWithoutCvInput>;
  trainingExperience?: InputMaybe<TrainingExperienceUpdateManyWithoutCvInput>;
};

export type CvUpdateManyWithWhereWithoutQualificationInput = {
  data: CvUncheckedUpdateManyWithoutCvInput;
  where: CvScalarWhereInput;
};

export type CvUpdateManyWithWhereWithoutRankInput = {
  data: CvUncheckedUpdateManyWithoutCvInput;
  where: CvScalarWhereInput;
};

export type CvUpdateManyWithoutQualificationInput = {
  connect?: InputMaybe<Array<InputMaybe<CvWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CvCreateOrConnectWithoutQualificationInput>>>;
  create?: InputMaybe<Array<InputMaybe<CvCreateWithoutQualificationInput>>>;
  createMany?: InputMaybe<CvCreateManyQualificationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<CvWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CvScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CvWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CvWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CvUpdateWithWhereUniqueWithoutQualificationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CvUpdateManyWithWhereWithoutQualificationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CvUpsertWithWhereUniqueWithoutQualificationInput>>>;
};

export type CvUpdateManyWithoutRankInput = {
  connect?: InputMaybe<Array<InputMaybe<CvWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<CvCreateOrConnectWithoutRankInput>>>;
  create?: InputMaybe<Array<InputMaybe<CvCreateWithoutRankInput>>>;
  createMany?: InputMaybe<CvCreateManyRankInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<CvWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<CvScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<CvWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<CvWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CvUpdateWithWhereUniqueWithoutRankInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<CvUpdateManyWithWhereWithoutRankInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<CvUpsertWithWhereUniqueWithoutRankInput>>>;
};

export type CvUpdateOneRequiredWithoutApplicationsInput = {
  connect?: InputMaybe<CvWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CvCreateOrConnectWithoutApplicationsInput>;
  create?: InputMaybe<CvUncheckedCreateWithoutApplicationsInput>;
  update?: InputMaybe<CvUncheckedUpdateWithoutApplicationsInput>;
  upsert?: InputMaybe<CvUpsertWithoutApplicationsInput>;
};

export type CvUpdateOneWithoutEducationInput = {
  connect?: InputMaybe<CvWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CvCreateOrConnectWithoutEducationInput>;
  create?: InputMaybe<CvUncheckedCreateWithoutEducationInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CvUncheckedUpdateWithoutEducationInput>;
  upsert?: InputMaybe<CvUpsertWithoutEducationInput>;
};

export type CvUpdateOneWithoutProfessionalSkillsInput = {
  connect?: InputMaybe<CvWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CvCreateOrConnectWithoutProfessionalSkillsInput>;
  create?: InputMaybe<CvUncheckedCreateWithoutProfessionalSkillsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CvUncheckedUpdateWithoutProfessionalSkillsInput>;
  upsert?: InputMaybe<CvUpsertWithoutProfessionalSkillsInput>;
};

export type CvUpdateOneWithoutScientificResearchesInput = {
  connect?: InputMaybe<CvWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CvCreateOrConnectWithoutScientificResearchesInput>;
  create?: InputMaybe<CvUncheckedCreateWithoutScientificResearchesInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CvUncheckedUpdateWithoutScientificResearchesInput>;
  upsert?: InputMaybe<CvUpsertWithoutScientificResearchesInput>;
};

export type CvUpdateOneWithoutTrainingExperienceInput = {
  connect?: InputMaybe<CvWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CvCreateOrConnectWithoutTrainingExperienceInput>;
  create?: InputMaybe<CvUncheckedCreateWithoutTrainingExperienceInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CvUncheckedUpdateWithoutTrainingExperienceInput>;
  upsert?: InputMaybe<CvUpsertWithoutTrainingExperienceInput>;
};

export type CvUpdateOneWithoutUserInput = {
  connect?: InputMaybe<CvWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CvCreateOrConnectWithoutUserInput>;
  create?: InputMaybe<CvUncheckedCreateWithoutUserInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CvUncheckedUpdateWithoutUserInput>;
  upsert?: InputMaybe<CvUpsertWithoutUserInput>;
};

export type CvUpdateWithWhereUniqueWithoutQualificationInput = {
  data: CvUncheckedUpdateWithoutQualificationInput;
  where: CvWhereUniqueInput;
};

export type CvUpdateWithWhereUniqueWithoutRankInput = {
  data: CvUncheckedUpdateWithoutRankInput;
  where: CvWhereUniqueInput;
};

export type CvUpdateWithoutApplicationsInput = {
  User?: InputMaybe<UserUpdateOneWithoutTrainerCvInput>;
  education?: InputMaybe<EducationUpdateManyWithoutCvInput>;
  professionalSkills?: InputMaybe<ProfessionalSkillsUpdateManyWithoutCvInput>;
  qualification?: InputMaybe<QualificationUpdateOneWithoutCvInput>;
  rank?: InputMaybe<RankUpdateOneWithoutCvInput>;
  scientificResearches?: InputMaybe<ScientificResearchUpdateManyWithoutCvInput>;
  trainingExperience?: InputMaybe<TrainingExperienceUpdateManyWithoutCvInput>;
};

export type CvUpdateWithoutEducationInput = {
  User?: InputMaybe<UserUpdateOneWithoutTrainerCvInput>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutCvInput>;
  professionalSkills?: InputMaybe<ProfessionalSkillsUpdateManyWithoutCvInput>;
  qualification?: InputMaybe<QualificationUpdateOneWithoutCvInput>;
  rank?: InputMaybe<RankUpdateOneWithoutCvInput>;
  scientificResearches?: InputMaybe<ScientificResearchUpdateManyWithoutCvInput>;
  trainingExperience?: InputMaybe<TrainingExperienceUpdateManyWithoutCvInput>;
};

export type CvUpdateWithoutProfessionalSkillsInput = {
  User?: InputMaybe<UserUpdateOneWithoutTrainerCvInput>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutCvInput>;
  education?: InputMaybe<EducationUpdateManyWithoutCvInput>;
  qualification?: InputMaybe<QualificationUpdateOneWithoutCvInput>;
  rank?: InputMaybe<RankUpdateOneWithoutCvInput>;
  scientificResearches?: InputMaybe<ScientificResearchUpdateManyWithoutCvInput>;
  trainingExperience?: InputMaybe<TrainingExperienceUpdateManyWithoutCvInput>;
};

export type CvUpdateWithoutQualificationInput = {
  User?: InputMaybe<UserUpdateOneWithoutTrainerCvInput>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutCvInput>;
  education?: InputMaybe<EducationUpdateManyWithoutCvInput>;
  professionalSkills?: InputMaybe<ProfessionalSkillsUpdateManyWithoutCvInput>;
  rank?: InputMaybe<RankUpdateOneWithoutCvInput>;
  scientificResearches?: InputMaybe<ScientificResearchUpdateManyWithoutCvInput>;
  trainingExperience?: InputMaybe<TrainingExperienceUpdateManyWithoutCvInput>;
};

export type CvUpdateWithoutRankInput = {
  User?: InputMaybe<UserUpdateOneWithoutTrainerCvInput>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutCvInput>;
  education?: InputMaybe<EducationUpdateManyWithoutCvInput>;
  professionalSkills?: InputMaybe<ProfessionalSkillsUpdateManyWithoutCvInput>;
  qualification?: InputMaybe<QualificationUpdateOneWithoutCvInput>;
  scientificResearches?: InputMaybe<ScientificResearchUpdateManyWithoutCvInput>;
  trainingExperience?: InputMaybe<TrainingExperienceUpdateManyWithoutCvInput>;
};

export type CvUpdateWithoutScientificResearchesInput = {
  User?: InputMaybe<UserUpdateOneWithoutTrainerCvInput>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutCvInput>;
  education?: InputMaybe<EducationUpdateManyWithoutCvInput>;
  professionalSkills?: InputMaybe<ProfessionalSkillsUpdateManyWithoutCvInput>;
  qualification?: InputMaybe<QualificationUpdateOneWithoutCvInput>;
  rank?: InputMaybe<RankUpdateOneWithoutCvInput>;
  trainingExperience?: InputMaybe<TrainingExperienceUpdateManyWithoutCvInput>;
};

export type CvUpdateWithoutTrainingExperienceInput = {
  User?: InputMaybe<UserUpdateOneWithoutTrainerCvInput>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutCvInput>;
  education?: InputMaybe<EducationUpdateManyWithoutCvInput>;
  professionalSkills?: InputMaybe<ProfessionalSkillsUpdateManyWithoutCvInput>;
  qualification?: InputMaybe<QualificationUpdateOneWithoutCvInput>;
  rank?: InputMaybe<RankUpdateOneWithoutCvInput>;
  scientificResearches?: InputMaybe<ScientificResearchUpdateManyWithoutCvInput>;
};

export type CvUpdateWithoutUserInput = {
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutCvInput>;
  education?: InputMaybe<EducationUpdateManyWithoutCvInput>;
  professionalSkills?: InputMaybe<ProfessionalSkillsUpdateManyWithoutCvInput>;
  qualification?: InputMaybe<QualificationUpdateOneWithoutCvInput>;
  rank?: InputMaybe<RankUpdateOneWithoutCvInput>;
  scientificResearches?: InputMaybe<ScientificResearchUpdateManyWithoutCvInput>;
  trainingExperience?: InputMaybe<TrainingExperienceUpdateManyWithoutCvInput>;
};

export type CvUpsertWithWhereUniqueWithoutQualificationInput = {
  create: CvUncheckedCreateWithoutQualificationInput;
  update: CvUncheckedUpdateWithoutQualificationInput;
  where: CvWhereUniqueInput;
};

export type CvUpsertWithWhereUniqueWithoutRankInput = {
  create: CvUncheckedCreateWithoutRankInput;
  update: CvUncheckedUpdateWithoutRankInput;
  where: CvWhereUniqueInput;
};

export type CvUpsertWithoutApplicationsInput = {
  create: CvUncheckedCreateWithoutApplicationsInput;
  update: CvUncheckedUpdateWithoutApplicationsInput;
};

export type CvUpsertWithoutEducationInput = {
  create: CvUncheckedCreateWithoutEducationInput;
  update: CvUncheckedUpdateWithoutEducationInput;
};

export type CvUpsertWithoutProfessionalSkillsInput = {
  create: CvUncheckedCreateWithoutProfessionalSkillsInput;
  update: CvUncheckedUpdateWithoutProfessionalSkillsInput;
};

export type CvUpsertWithoutScientificResearchesInput = {
  create: CvUncheckedCreateWithoutScientificResearchesInput;
  update: CvUncheckedUpdateWithoutScientificResearchesInput;
};

export type CvUpsertWithoutTrainingExperienceInput = {
  create: CvUncheckedCreateWithoutTrainingExperienceInput;
  update: CvUncheckedUpdateWithoutTrainingExperienceInput;
};

export type CvUpsertWithoutUserInput = {
  create: CvUncheckedCreateWithoutUserInput;
  update: CvUncheckedUpdateWithoutUserInput;
};

export type CvWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<CvWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<CvWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CvWhereInput>>>;
  User?: InputMaybe<UserWhereInput>;
  applications?: InputMaybe<BecomeTrainerApplicationListRelationFilter>;
  education?: InputMaybe<EducationListRelationFilter>;
  id?: InputMaybe<IntFilter>;
  professionalSkills?: InputMaybe<ProfessionalSkillsListRelationFilter>;
  qualification?: InputMaybe<QualificationWhereInput>;
  qualificationId?: InputMaybe<IntNullableFilter>;
  rank?: InputMaybe<RankWhereInput>;
  rankId?: InputMaybe<IntNullableFilter>;
  scientificResearches?: InputMaybe<ScientificResearchListRelationFilter>;
  trainingExperience?: InputMaybe<TrainingExperienceListRelationFilter>;
};

export type CvWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type DateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
};

export type DateTimeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedDateTimeNullableFilter>;
  _min?: InputMaybe<NestedDateTimeNullableFilter>;
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
};

export type DateTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDateTimeFilter>;
  _min?: InputMaybe<NestedDateTimeFilter>;
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
};

export type DecimalFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Decimal']>;
  divide?: InputMaybe<Scalars['Decimal']>;
  increment?: InputMaybe<Scalars['Decimal']>;
  multiply?: InputMaybe<Scalars['Decimal']>;
  set?: InputMaybe<Scalars['Decimal']>;
};

export type DecimalFilter = {
  equals?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  gte?: InputMaybe<Scalars['Decimal']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
  lt?: InputMaybe<Scalars['Decimal']>;
  lte?: InputMaybe<Scalars['Decimal']>;
  not?: InputMaybe<NestedDecimalFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
};

export type DecimalNullableFilter = {
  equals?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  gte?: InputMaybe<Scalars['Decimal']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
  lt?: InputMaybe<Scalars['Decimal']>;
  lte?: InputMaybe<Scalars['Decimal']>;
  not?: InputMaybe<NestedDecimalNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
};

export type DecimalNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedDecimalNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedDecimalNullableFilter>;
  _min?: InputMaybe<NestedDecimalNullableFilter>;
  _sum?: InputMaybe<NestedDecimalNullableFilter>;
  equals?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  gte?: InputMaybe<Scalars['Decimal']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
  lt?: InputMaybe<Scalars['Decimal']>;
  lte?: InputMaybe<Scalars['Decimal']>;
  not?: InputMaybe<NestedDecimalNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
};

export type DecimalWithAggregatesFilter = {
  _avg?: InputMaybe<NestedDecimalFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDecimalFilter>;
  _min?: InputMaybe<NestedDecimalFilter>;
  _sum?: InputMaybe<NestedDecimalFilter>;
  equals?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  gte?: InputMaybe<Scalars['Decimal']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
  lt?: InputMaybe<Scalars['Decimal']>;
  lte?: InputMaybe<Scalars['Decimal']>;
  not?: InputMaybe<NestedDecimalWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
};

export type Discussion = {
  __typename?: 'Discussion';
  Event: Event;
  Parent?: Maybe<Discussion>;
  Replies: Array<Discussion>;
  User: User;
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  eventId: Scalars['Int'];
  id: Scalars['Int'];
  parentId?: Maybe<Scalars['Int']>;
  userId: Scalars['Int'];
};

export type DiscussionAvgAggregateOutputType = {
  __typename?: 'DiscussionAvgAggregateOutputType';
  eventId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parentId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

export type DiscussionAvgOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  parentId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type DiscussionCountAggregateOutputType = {
  __typename?: 'DiscussionCountAggregateOutputType';
  _all: Scalars['Int'];
  comment: Scalars['Int'];
  createdAt: Scalars['Int'];
  eventId: Scalars['Int'];
  id: Scalars['Int'];
  parentId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type DiscussionCountOrderByAggregateInput = {
  comment?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  parentId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type DiscussionCountOutputType = {
  __typename?: 'DiscussionCountOutputType';
  Replies: Scalars['Int'];
};

export type DiscussionCreateInput = {
  Event: EventCreateNestedOneWithoutDiscussionInput;
  Parent?: InputMaybe<DiscussionCreateNestedOneWithoutRepliesInput>;
  Replies?: InputMaybe<DiscussionCreateNestedManyWithoutParentInput>;
  User: UserCreateNestedOneWithoutDiscussionInput;
  comment: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
};

export type DiscussionCreateManyEventInput = {
  comment: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  parentId?: InputMaybe<Scalars['Int']>;
  userId: Scalars['Int'];
};

export type DiscussionCreateManyEventInputEnvelope = {
  data: DiscussionCreateManyEventInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DiscussionCreateManyInput = {
  comment: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  parentId?: InputMaybe<Scalars['Int']>;
  userId: Scalars['Int'];
};

export type DiscussionCreateManyParentInput = {
  comment: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  userId: Scalars['Int'];
};

export type DiscussionCreateManyParentInputEnvelope = {
  data: DiscussionCreateManyParentInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DiscussionCreateManyUserInput = {
  comment: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  parentId?: InputMaybe<Scalars['Int']>;
};

export type DiscussionCreateManyUserInputEnvelope = {
  data: DiscussionCreateManyUserInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DiscussionCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<DiscussionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DiscussionCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<DiscussionCreateWithoutEventInput>>>;
  createMany?: InputMaybe<DiscussionCreateManyEventInputEnvelope>;
};

export type DiscussionCreateNestedManyWithoutParentInput = {
  connect?: InputMaybe<Array<InputMaybe<DiscussionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DiscussionCreateOrConnectWithoutParentInput>>>;
  create?: InputMaybe<Array<InputMaybe<DiscussionCreateWithoutParentInput>>>;
  createMany?: InputMaybe<DiscussionCreateManyParentInputEnvelope>;
};

export type DiscussionCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<DiscussionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DiscussionCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<DiscussionCreateWithoutUserInput>>>;
  createMany?: InputMaybe<DiscussionCreateManyUserInputEnvelope>;
};

export type DiscussionCreateNestedOneWithoutRepliesInput = {
  connect?: InputMaybe<DiscussionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DiscussionCreateOrConnectWithoutRepliesInput>;
  create?: InputMaybe<DiscussionUncheckedCreateWithoutRepliesInput>;
};

export type DiscussionCreateOrConnectWithoutEventInput = {
  create: DiscussionUncheckedCreateWithoutEventInput;
  where: DiscussionWhereUniqueInput;
};

export type DiscussionCreateOrConnectWithoutParentInput = {
  create: DiscussionUncheckedCreateWithoutParentInput;
  where: DiscussionWhereUniqueInput;
};

export type DiscussionCreateOrConnectWithoutRepliesInput = {
  create: DiscussionUncheckedCreateWithoutRepliesInput;
  where: DiscussionWhereUniqueInput;
};

export type DiscussionCreateOrConnectWithoutUserInput = {
  create: DiscussionUncheckedCreateWithoutUserInput;
  where: DiscussionWhereUniqueInput;
};

export type DiscussionCreateWithoutEventInput = {
  Parent?: InputMaybe<DiscussionCreateNestedOneWithoutRepliesInput>;
  Replies?: InputMaybe<DiscussionCreateNestedManyWithoutParentInput>;
  User: UserCreateNestedOneWithoutDiscussionInput;
  comment: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
};

export type DiscussionCreateWithoutParentInput = {
  Event: EventCreateNestedOneWithoutDiscussionInput;
  Replies?: InputMaybe<DiscussionCreateNestedManyWithoutParentInput>;
  User: UserCreateNestedOneWithoutDiscussionInput;
  comment: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
};

export type DiscussionCreateWithoutRepliesInput = {
  Event: EventCreateNestedOneWithoutDiscussionInput;
  Parent?: InputMaybe<DiscussionCreateNestedOneWithoutRepliesInput>;
  User: UserCreateNestedOneWithoutDiscussionInput;
  comment: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
};

export type DiscussionCreateWithoutUserInput = {
  Event: EventCreateNestedOneWithoutDiscussionInput;
  Parent?: InputMaybe<DiscussionCreateNestedOneWithoutRepliesInput>;
  Replies?: InputMaybe<DiscussionCreateNestedManyWithoutParentInput>;
  comment: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
};

export type DiscussionListRelationFilter = {
  every?: InputMaybe<DiscussionWhereInput>;
  none?: InputMaybe<DiscussionWhereInput>;
  some?: InputMaybe<DiscussionWhereInput>;
};

export type DiscussionMaxAggregateOutputType = {
  __typename?: 'DiscussionMaxAggregateOutputType';
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  parentId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

export type DiscussionMaxOrderByAggregateInput = {
  comment?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  parentId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type DiscussionMinAggregateOutputType = {
  __typename?: 'DiscussionMinAggregateOutputType';
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  parentId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

export type DiscussionMinOrderByAggregateInput = {
  comment?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  parentId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type DiscussionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DiscussionOrderByWithAggregationInput = {
  _avg?: InputMaybe<DiscussionAvgOrderByAggregateInput>;
  _count?: InputMaybe<DiscussionCountOrderByAggregateInput>;
  _max?: InputMaybe<DiscussionMaxOrderByAggregateInput>;
  _min?: InputMaybe<DiscussionMinOrderByAggregateInput>;
  _sum?: InputMaybe<DiscussionSumOrderByAggregateInput>;
  comment?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  parentId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type DiscussionOrderByWithRelationInput = {
  Event?: InputMaybe<EventOrderByWithRelationInput>;
  Parent?: InputMaybe<DiscussionOrderByWithRelationInput>;
  Replies?: InputMaybe<DiscussionOrderByRelationAggregateInput>;
  User?: InputMaybe<UserOrderByWithRelationInput>;
  comment?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  parentId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type DiscussionRelationFilter = {
  is?: InputMaybe<DiscussionWhereInput>;
  isNot?: InputMaybe<DiscussionWhereInput>;
};

export enum DiscussionScalarFieldEnum {
  Comment = 'comment',
  CreatedAt = 'createdAt',
  EventId = 'eventId',
  Id = 'id',
  ParentId = 'parentId',
  UserId = 'userId'
}

export type DiscussionScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<DiscussionScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<DiscussionScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<DiscussionScalarWhereInput>>>;
  comment?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  eventId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  parentId?: InputMaybe<IntNullableFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type DiscussionScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<DiscussionScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<DiscussionScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<DiscussionScalarWhereWithAggregatesInput>>>;
  comment?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  eventId?: InputMaybe<IntWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  parentId?: InputMaybe<IntNullableWithAggregatesFilter>;
  userId?: InputMaybe<IntWithAggregatesFilter>;
};

export type DiscussionSumAggregateOutputType = {
  __typename?: 'DiscussionSumAggregateOutputType';
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  parentId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

export type DiscussionSumOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  parentId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type DiscussionUncheckedCreateInput = {
  Replies?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutParentInput>;
  comment: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  parentId?: InputMaybe<Scalars['Int']>;
  userId: Scalars['Int'];
};

export type DiscussionUncheckedCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<DiscussionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DiscussionCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<DiscussionCreateWithoutEventInput>>>;
  createMany?: InputMaybe<DiscussionCreateManyEventInputEnvelope>;
};

export type DiscussionUncheckedCreateNestedManyWithoutParentInput = {
  connect?: InputMaybe<Array<InputMaybe<DiscussionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DiscussionCreateOrConnectWithoutParentInput>>>;
  create?: InputMaybe<Array<InputMaybe<DiscussionCreateWithoutParentInput>>>;
  createMany?: InputMaybe<DiscussionCreateManyParentInputEnvelope>;
};

export type DiscussionUncheckedCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<DiscussionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DiscussionCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<DiscussionCreateWithoutUserInput>>>;
  createMany?: InputMaybe<DiscussionCreateManyUserInputEnvelope>;
};

export type DiscussionUncheckedCreateWithoutEventInput = {
  Replies?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutParentInput>;
  comment: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  parentId?: InputMaybe<Scalars['Int']>;
  userId: Scalars['Int'];
};

export type DiscussionUncheckedCreateWithoutParentInput = {
  Replies?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutParentInput>;
  comment: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  userId: Scalars['Int'];
};

export type DiscussionUncheckedCreateWithoutRepliesInput = {
  comment: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  parentId?: InputMaybe<Scalars['Int']>;
  userId: Scalars['Int'];
};

export type DiscussionUncheckedCreateWithoutUserInput = {
  Replies?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutParentInput>;
  comment: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  parentId?: InputMaybe<Scalars['Int']>;
};

export type DiscussionUncheckedUpdateInput = {
  Replies?: InputMaybe<DiscussionUncheckedUpdateManyWithoutParentInput>;
  comment?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  userId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DiscussionUncheckedUpdateManyInput = {
  comment?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  userId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DiscussionUncheckedUpdateManyWithoutDiscussionInput = {
  comment?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type DiscussionUncheckedUpdateManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<DiscussionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DiscussionCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<DiscussionCreateWithoutEventInput>>>;
  createMany?: InputMaybe<DiscussionCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<DiscussionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DiscussionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DiscussionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DiscussionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DiscussionUpdateWithWhereUniqueWithoutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DiscussionUpdateManyWithWhereWithoutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DiscussionUpsertWithWhereUniqueWithoutEventInput>>>;
};

export type DiscussionUncheckedUpdateManyWithoutParentInput = {
  connect?: InputMaybe<Array<InputMaybe<DiscussionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DiscussionCreateOrConnectWithoutParentInput>>>;
  create?: InputMaybe<Array<InputMaybe<DiscussionCreateWithoutParentInput>>>;
  createMany?: InputMaybe<DiscussionCreateManyParentInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<DiscussionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DiscussionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DiscussionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DiscussionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DiscussionUpdateWithWhereUniqueWithoutParentInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DiscussionUpdateManyWithWhereWithoutParentInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DiscussionUpsertWithWhereUniqueWithoutParentInput>>>;
};

export type DiscussionUncheckedUpdateManyWithoutRepliesInput = {
  comment?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  userId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DiscussionUncheckedUpdateManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<DiscussionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DiscussionCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<DiscussionCreateWithoutUserInput>>>;
  createMany?: InputMaybe<DiscussionCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<DiscussionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DiscussionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DiscussionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DiscussionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DiscussionUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DiscussionUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DiscussionUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type DiscussionUncheckedUpdateWithoutEventInput = {
  Replies?: InputMaybe<DiscussionUncheckedUpdateManyWithoutParentInput>;
  comment?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  userId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DiscussionUncheckedUpdateWithoutParentInput = {
  Replies?: InputMaybe<DiscussionUncheckedUpdateManyWithoutParentInput>;
  comment?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  userId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DiscussionUncheckedUpdateWithoutRepliesInput = {
  comment?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  userId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DiscussionUncheckedUpdateWithoutUserInput = {
  Replies?: InputMaybe<DiscussionUncheckedUpdateManyWithoutParentInput>;
  comment?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type DiscussionUpdateInput = {
  Event?: InputMaybe<EventUpdateOneRequiredWithoutDiscussionInput>;
  Parent?: InputMaybe<DiscussionUpdateOneWithoutRepliesInput>;
  Replies?: InputMaybe<DiscussionUpdateManyWithoutParentInput>;
  User?: InputMaybe<UserUpdateOneRequiredWithoutDiscussionInput>;
  comment?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DiscussionUpdateManyMutationInput = {
  comment?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DiscussionUpdateManyWithWhereWithoutEventInput = {
  data: DiscussionUncheckedUpdateManyWithoutDiscussionInput;
  where: DiscussionScalarWhereInput;
};

export type DiscussionUpdateManyWithWhereWithoutParentInput = {
  data: DiscussionUncheckedUpdateManyWithoutRepliesInput;
  where: DiscussionScalarWhereInput;
};

export type DiscussionUpdateManyWithWhereWithoutUserInput = {
  data: DiscussionUncheckedUpdateManyWithoutDiscussionInput;
  where: DiscussionScalarWhereInput;
};

export type DiscussionUpdateManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<DiscussionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DiscussionCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<DiscussionCreateWithoutEventInput>>>;
  createMany?: InputMaybe<DiscussionCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<DiscussionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DiscussionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DiscussionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DiscussionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DiscussionUpdateWithWhereUniqueWithoutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DiscussionUpdateManyWithWhereWithoutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DiscussionUpsertWithWhereUniqueWithoutEventInput>>>;
};

export type DiscussionUpdateManyWithoutParentInput = {
  connect?: InputMaybe<Array<InputMaybe<DiscussionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DiscussionCreateOrConnectWithoutParentInput>>>;
  create?: InputMaybe<Array<InputMaybe<DiscussionCreateWithoutParentInput>>>;
  createMany?: InputMaybe<DiscussionCreateManyParentInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<DiscussionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DiscussionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DiscussionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DiscussionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DiscussionUpdateWithWhereUniqueWithoutParentInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DiscussionUpdateManyWithWhereWithoutParentInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DiscussionUpsertWithWhereUniqueWithoutParentInput>>>;
};

export type DiscussionUpdateManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<DiscussionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<DiscussionCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<DiscussionCreateWithoutUserInput>>>;
  createMany?: InputMaybe<DiscussionCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<DiscussionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<DiscussionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<DiscussionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<DiscussionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DiscussionUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<DiscussionUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<DiscussionUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type DiscussionUpdateOneWithoutRepliesInput = {
  connect?: InputMaybe<DiscussionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DiscussionCreateOrConnectWithoutRepliesInput>;
  create?: InputMaybe<DiscussionUncheckedCreateWithoutRepliesInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<DiscussionUncheckedUpdateWithoutRepliesInput>;
  upsert?: InputMaybe<DiscussionUpsertWithoutRepliesInput>;
};

export type DiscussionUpdateWithWhereUniqueWithoutEventInput = {
  data: DiscussionUncheckedUpdateWithoutEventInput;
  where: DiscussionWhereUniqueInput;
};

export type DiscussionUpdateWithWhereUniqueWithoutParentInput = {
  data: DiscussionUncheckedUpdateWithoutParentInput;
  where: DiscussionWhereUniqueInput;
};

export type DiscussionUpdateWithWhereUniqueWithoutUserInput = {
  data: DiscussionUncheckedUpdateWithoutUserInput;
  where: DiscussionWhereUniqueInput;
};

export type DiscussionUpdateWithoutEventInput = {
  Parent?: InputMaybe<DiscussionUpdateOneWithoutRepliesInput>;
  Replies?: InputMaybe<DiscussionUpdateManyWithoutParentInput>;
  User?: InputMaybe<UserUpdateOneRequiredWithoutDiscussionInput>;
  comment?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DiscussionUpdateWithoutParentInput = {
  Event?: InputMaybe<EventUpdateOneRequiredWithoutDiscussionInput>;
  Replies?: InputMaybe<DiscussionUpdateManyWithoutParentInput>;
  User?: InputMaybe<UserUpdateOneRequiredWithoutDiscussionInput>;
  comment?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DiscussionUpdateWithoutRepliesInput = {
  Event?: InputMaybe<EventUpdateOneRequiredWithoutDiscussionInput>;
  Parent?: InputMaybe<DiscussionUpdateOneWithoutRepliesInput>;
  User?: InputMaybe<UserUpdateOneRequiredWithoutDiscussionInput>;
  comment?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DiscussionUpdateWithoutUserInput = {
  Event?: InputMaybe<EventUpdateOneRequiredWithoutDiscussionInput>;
  Parent?: InputMaybe<DiscussionUpdateOneWithoutRepliesInput>;
  Replies?: InputMaybe<DiscussionUpdateManyWithoutParentInput>;
  comment?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DiscussionUpsertWithWhereUniqueWithoutEventInput = {
  create: DiscussionUncheckedCreateWithoutEventInput;
  update: DiscussionUncheckedUpdateWithoutEventInput;
  where: DiscussionWhereUniqueInput;
};

export type DiscussionUpsertWithWhereUniqueWithoutParentInput = {
  create: DiscussionUncheckedCreateWithoutParentInput;
  update: DiscussionUncheckedUpdateWithoutParentInput;
  where: DiscussionWhereUniqueInput;
};

export type DiscussionUpsertWithWhereUniqueWithoutUserInput = {
  create: DiscussionUncheckedCreateWithoutUserInput;
  update: DiscussionUncheckedUpdateWithoutUserInput;
  where: DiscussionWhereUniqueInput;
};

export type DiscussionUpsertWithoutRepliesInput = {
  create: DiscussionUncheckedCreateWithoutRepliesInput;
  update: DiscussionUncheckedUpdateWithoutRepliesInput;
};

export type DiscussionWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<DiscussionWhereInput>>>;
  Event?: InputMaybe<EventWhereInput>;
  NOT?: InputMaybe<Array<InputMaybe<DiscussionWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<DiscussionWhereInput>>>;
  Parent?: InputMaybe<DiscussionWhereInput>;
  Replies?: InputMaybe<DiscussionListRelationFilter>;
  User?: InputMaybe<UserWhereInput>;
  comment?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  eventId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  parentId?: InputMaybe<IntNullableFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type DiscussionWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export enum DynamicEmailForRegistrans {
  All = 'all',
  CertificateAndCmeIsFree = 'certificateAndCMEIsFree',
  CertificateAndCmeIsPaid = 'certificateAndCMEIsPaid',
  CertificateIsPaid = 'certificateIsPaid',
  HavingTheSameSpecialty = 'havingTheSameSpecialty',
  JustRegister = 'justRegister',
  Paid = 'paid',
  ToBeReminded = 'toBeReminded',
  Unpaid = 'unpaid'
}

export enum DynamicEmailSendTo {
  All = 'all',
  Marketer = 'marketer',
  Organizer = 'organizer',
  Trainees = 'trainees',
  Trainers = 'trainers'
}

export enum DynamicEmailTime {
  AfterCertificateIssued = 'afterCertificateIssued',
  AfterEvent = 'afterEvent',
  AfterPayment = 'afterPayment',
  AfterPublishingEvent = 'afterPublishingEvent',
  BeforeEvent = 'beforeEvent',
  BeforeLateRegistration = 'beforeLateRegistration',
  EmergancyAfterChangeOfDateTime = 'emergancyAfterChangeOfDateTime',
  EmergancyAfterChangeOfLocation = 'emergancyAfterChangeOfLocation',
  EmergancyAfterChangeOfTrainers = 'emergancyAfterChangeOfTrainers',
  EmergancyAfterEventCancellation = 'emergancyAfterEventCancellation',
  RemindMe = 'remindMe'
}

export enum DynamicwhenEventHasClasses {
  All = 'all',
  Offline = 'offline',
  Online = 'online'
}

export type EPaymentMethod = {
  __typename?: 'EPaymentMethod';
  TraineeEvent: Array<TraineeEvent>;
  _count: EPaymentMethodCountOutputType;
  id: Scalars['Int'];
  name: Scalars['String'];
};


export type EPaymentMethodTraineeEventArgs = {
  cursor?: InputMaybe<TraineeEventWhereUniqueInput>;
  distinct?: InputMaybe<TraineeEventScalarFieldEnum>;
  orderBy?: InputMaybe<TraineeEventOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeEventWhereInput>;
};

export type EPaymentMethodAvgAggregateOutputType = {
  __typename?: 'EPaymentMethodAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
};

export type EPaymentMethodAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type EPaymentMethodCountAggregateOutputType = {
  __typename?: 'EPaymentMethodCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
};

export type EPaymentMethodCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type EPaymentMethodCountOutputType = {
  __typename?: 'EPaymentMethodCountOutputType';
  TraineeEvent: Scalars['Int'];
};

export type EPaymentMethodCreateInput = {
  TraineeEvent?: InputMaybe<TraineeEventCreateNestedManyWithoutEPaymentMethodInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  name: Scalars['String'];
};

export type EPaymentMethodCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type EPaymentMethodCreateNestedOneWithoutTraineeEventInput = {
  connect?: InputMaybe<EPaymentMethodWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EPaymentMethodCreateOrConnectWithoutTraineeEventInput>;
  create?: InputMaybe<EPaymentMethodUncheckedCreateWithoutTraineeEventInput>;
};

export type EPaymentMethodCreateOrConnectWithoutTraineeEventInput = {
  create: EPaymentMethodUncheckedCreateWithoutTraineeEventInput;
  where: EPaymentMethodWhereUniqueInput;
};

export type EPaymentMethodCreateWithoutTraineeEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  name: Scalars['String'];
};

export type EPaymentMethodMaxAggregateOutputType = {
  __typename?: 'EPaymentMethodMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type EPaymentMethodMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type EPaymentMethodMinAggregateOutputType = {
  __typename?: 'EPaymentMethodMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type EPaymentMethodMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type EPaymentMethodOrderByWithAggregationInput = {
  _avg?: InputMaybe<EPaymentMethodAvgOrderByAggregateInput>;
  _count?: InputMaybe<EPaymentMethodCountOrderByAggregateInput>;
  _max?: InputMaybe<EPaymentMethodMaxOrderByAggregateInput>;
  _min?: InputMaybe<EPaymentMethodMinOrderByAggregateInput>;
  _sum?: InputMaybe<EPaymentMethodSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type EPaymentMethodOrderByWithRelationInput = {
  TraineeEvent?: InputMaybe<TraineeEventOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type EPaymentMethodRelationFilter = {
  is?: InputMaybe<EPaymentMethodWhereInput>;
  isNot?: InputMaybe<EPaymentMethodWhereInput>;
};

export enum EPaymentMethodScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name'
}

export type EPaymentMethodScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<EPaymentMethodScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<EPaymentMethodScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<EPaymentMethodScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
};

export type EPaymentMethodSumAggregateOutputType = {
  __typename?: 'EPaymentMethodSumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
};

export type EPaymentMethodSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type EPaymentMethodUncheckedCreateInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEPaymentMethodInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type EPaymentMethodUncheckedCreateWithoutTraineeEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type EPaymentMethodUncheckedUpdateInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEPaymentMethodInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EPaymentMethodUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EPaymentMethodUncheckedUpdateWithoutTraineeEventInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EPaymentMethodUpdateInput = {
  TraineeEvent?: InputMaybe<TraineeEventUpdateManyWithoutEPaymentMethodInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EPaymentMethodUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EPaymentMethodUpdateOneWithoutTraineeEventInput = {
  connect?: InputMaybe<EPaymentMethodWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EPaymentMethodCreateOrConnectWithoutTraineeEventInput>;
  create?: InputMaybe<EPaymentMethodUncheckedCreateWithoutTraineeEventInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<EPaymentMethodUncheckedUpdateWithoutTraineeEventInput>;
  upsert?: InputMaybe<EPaymentMethodUpsertWithoutTraineeEventInput>;
};

export type EPaymentMethodUpdateWithoutTraineeEventInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EPaymentMethodUpsertWithoutTraineeEventInput = {
  create: EPaymentMethodUncheckedCreateWithoutTraineeEventInput;
  update: EPaymentMethodUncheckedUpdateWithoutTraineeEventInput;
};

export type EPaymentMethodWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<EPaymentMethodWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<EPaymentMethodWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<EPaymentMethodWhereInput>>>;
  TraineeEvent?: InputMaybe<TraineeEventListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
};

export type EPaymentMethodWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type Education = {
  __typename?: 'Education';
  Cv?: Maybe<Cv>;
  cvId?: Maybe<Scalars['Int']>;
  graduationYear?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  profession?: Maybe<Profession>;
  professionId?: Maybe<Scalars['Int']>;
  qualification?: Maybe<Qualification>;
  qualificationId?: Maybe<Scalars['Int']>;
  specialty?: Maybe<Specialty>;
  specialtyId?: Maybe<Scalars['Int']>;
  university?: Maybe<Scalars['String']>;
};

export type EducationAvgAggregateOutputType = {
  __typename?: 'EducationAvgAggregateOutputType';
  cvId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  professionId?: Maybe<Scalars['Float']>;
  qualificationId?: Maybe<Scalars['Float']>;
  specialtyId?: Maybe<Scalars['Float']>;
};

export type EducationAvgOrderByAggregateInput = {
  cvId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  professionId?: InputMaybe<SortOrder>;
  qualificationId?: InputMaybe<SortOrder>;
  specialtyId?: InputMaybe<SortOrder>;
};

export type EducationCountAggregateOutputType = {
  __typename?: 'EducationCountAggregateOutputType';
  _all: Scalars['Int'];
  cvId: Scalars['Int'];
  graduationYear: Scalars['Int'];
  id: Scalars['Int'];
  professionId: Scalars['Int'];
  qualificationId: Scalars['Int'];
  specialtyId: Scalars['Int'];
  university: Scalars['Int'];
};

export type EducationCountOrderByAggregateInput = {
  cvId?: InputMaybe<SortOrder>;
  graduationYear?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  professionId?: InputMaybe<SortOrder>;
  qualificationId?: InputMaybe<SortOrder>;
  specialtyId?: InputMaybe<SortOrder>;
  university?: InputMaybe<SortOrder>;
};

export type EducationCreateInput = {
  Cv?: InputMaybe<CvCreateNestedOneWithoutEducationInput>;
  graduationYear?: InputMaybe<Scalars['DateTime']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutEducationInput>;
  qualification?: InputMaybe<QualificationCreateNestedOneWithoutEducationInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutEducationInput>;
  university?: InputMaybe<Scalars['String']>;
};

export type EducationCreateManyCvInput = {
  graduationYear?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  university?: InputMaybe<Scalars['String']>;
};

export type EducationCreateManyCvInputEnvelope = {
  data: EducationCreateManyCvInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type EducationCreateManyInput = {
  cvId?: InputMaybe<Scalars['Int']>;
  graduationYear?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  university?: InputMaybe<Scalars['String']>;
};

export type EducationCreateManyProfessionInput = {
  cvId?: InputMaybe<Scalars['Int']>;
  graduationYear?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  university?: InputMaybe<Scalars['String']>;
};

export type EducationCreateManyProfessionInputEnvelope = {
  data: EducationCreateManyProfessionInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type EducationCreateManyQualificationInput = {
  cvId?: InputMaybe<Scalars['Int']>;
  graduationYear?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  professionId?: InputMaybe<Scalars['Int']>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  university?: InputMaybe<Scalars['String']>;
};

export type EducationCreateManyQualificationInputEnvelope = {
  data: EducationCreateManyQualificationInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type EducationCreateManySpecialtyInput = {
  cvId?: InputMaybe<Scalars['Int']>;
  graduationYear?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  university?: InputMaybe<Scalars['String']>;
};

export type EducationCreateManySpecialtyInputEnvelope = {
  data: EducationCreateManySpecialtyInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type EducationCreateNestedManyWithoutCvInput = {
  connect?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EducationCreateOrConnectWithoutCvInput>>>;
  create?: InputMaybe<Array<InputMaybe<EducationCreateWithoutCvInput>>>;
  createMany?: InputMaybe<EducationCreateManyCvInputEnvelope>;
};

export type EducationCreateNestedManyWithoutProfessionInput = {
  connect?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EducationCreateOrConnectWithoutProfessionInput>>>;
  create?: InputMaybe<Array<InputMaybe<EducationCreateWithoutProfessionInput>>>;
  createMany?: InputMaybe<EducationCreateManyProfessionInputEnvelope>;
};

export type EducationCreateNestedManyWithoutQualificationInput = {
  connect?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EducationCreateOrConnectWithoutQualificationInput>>>;
  create?: InputMaybe<Array<InputMaybe<EducationCreateWithoutQualificationInput>>>;
  createMany?: InputMaybe<EducationCreateManyQualificationInputEnvelope>;
};

export type EducationCreateNestedManyWithoutSpecialtyInput = {
  connect?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EducationCreateOrConnectWithoutSpecialtyInput>>>;
  create?: InputMaybe<Array<InputMaybe<EducationCreateWithoutSpecialtyInput>>>;
  createMany?: InputMaybe<EducationCreateManySpecialtyInputEnvelope>;
};

export type EducationCreateOrConnectWithoutCvInput = {
  create: EducationUncheckedCreateWithoutCvInput;
  where: EducationWhereUniqueInput;
};

export type EducationCreateOrConnectWithoutProfessionInput = {
  create: EducationUncheckedCreateWithoutProfessionInput;
  where: EducationWhereUniqueInput;
};

export type EducationCreateOrConnectWithoutQualificationInput = {
  create: EducationUncheckedCreateWithoutQualificationInput;
  where: EducationWhereUniqueInput;
};

export type EducationCreateOrConnectWithoutSpecialtyInput = {
  create: EducationUncheckedCreateWithoutSpecialtyInput;
  where: EducationWhereUniqueInput;
};

export type EducationCreateWithoutCvInput = {
  graduationYear?: InputMaybe<Scalars['DateTime']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutEducationInput>;
  qualification?: InputMaybe<QualificationCreateNestedOneWithoutEducationInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutEducationInput>;
  university?: InputMaybe<Scalars['String']>;
};

export type EducationCreateWithoutProfessionInput = {
  Cv?: InputMaybe<CvCreateNestedOneWithoutEducationInput>;
  graduationYear?: InputMaybe<Scalars['DateTime']>;
  qualification?: InputMaybe<QualificationCreateNestedOneWithoutEducationInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutEducationInput>;
  university?: InputMaybe<Scalars['String']>;
};

export type EducationCreateWithoutQualificationInput = {
  Cv?: InputMaybe<CvCreateNestedOneWithoutEducationInput>;
  graduationYear?: InputMaybe<Scalars['DateTime']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutEducationInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutEducationInput>;
  university?: InputMaybe<Scalars['String']>;
};

export type EducationCreateWithoutSpecialtyInput = {
  Cv?: InputMaybe<CvCreateNestedOneWithoutEducationInput>;
  graduationYear?: InputMaybe<Scalars['DateTime']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutEducationInput>;
  qualification?: InputMaybe<QualificationCreateNestedOneWithoutEducationInput>;
  university?: InputMaybe<Scalars['String']>;
};

export type EducationListRelationFilter = {
  every?: InputMaybe<EducationWhereInput>;
  none?: InputMaybe<EducationWhereInput>;
  some?: InputMaybe<EducationWhereInput>;
};

export type EducationMaxAggregateOutputType = {
  __typename?: 'EducationMaxAggregateOutputType';
  cvId?: Maybe<Scalars['Int']>;
  graduationYear?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  professionId?: Maybe<Scalars['Int']>;
  qualificationId?: Maybe<Scalars['Int']>;
  specialtyId?: Maybe<Scalars['Int']>;
  university?: Maybe<Scalars['String']>;
};

export type EducationMaxOrderByAggregateInput = {
  cvId?: InputMaybe<SortOrder>;
  graduationYear?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  professionId?: InputMaybe<SortOrder>;
  qualificationId?: InputMaybe<SortOrder>;
  specialtyId?: InputMaybe<SortOrder>;
  university?: InputMaybe<SortOrder>;
};

export type EducationMinAggregateOutputType = {
  __typename?: 'EducationMinAggregateOutputType';
  cvId?: Maybe<Scalars['Int']>;
  graduationYear?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  professionId?: Maybe<Scalars['Int']>;
  qualificationId?: Maybe<Scalars['Int']>;
  specialtyId?: Maybe<Scalars['Int']>;
  university?: Maybe<Scalars['String']>;
};

export type EducationMinOrderByAggregateInput = {
  cvId?: InputMaybe<SortOrder>;
  graduationYear?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  professionId?: InputMaybe<SortOrder>;
  qualificationId?: InputMaybe<SortOrder>;
  specialtyId?: InputMaybe<SortOrder>;
  university?: InputMaybe<SortOrder>;
};

export type EducationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type EducationOrderByWithAggregationInput = {
  _avg?: InputMaybe<EducationAvgOrderByAggregateInput>;
  _count?: InputMaybe<EducationCountOrderByAggregateInput>;
  _max?: InputMaybe<EducationMaxOrderByAggregateInput>;
  _min?: InputMaybe<EducationMinOrderByAggregateInput>;
  _sum?: InputMaybe<EducationSumOrderByAggregateInput>;
  cvId?: InputMaybe<SortOrder>;
  graduationYear?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  professionId?: InputMaybe<SortOrder>;
  qualificationId?: InputMaybe<SortOrder>;
  specialtyId?: InputMaybe<SortOrder>;
  university?: InputMaybe<SortOrder>;
};

export type EducationOrderByWithRelationInput = {
  Cv?: InputMaybe<CvOrderByWithRelationInput>;
  cvId?: InputMaybe<SortOrder>;
  graduationYear?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  profession?: InputMaybe<ProfessionOrderByWithRelationInput>;
  professionId?: InputMaybe<SortOrder>;
  qualification?: InputMaybe<QualificationOrderByWithRelationInput>;
  qualificationId?: InputMaybe<SortOrder>;
  specialty?: InputMaybe<SpecialtyOrderByWithRelationInput>;
  specialtyId?: InputMaybe<SortOrder>;
  university?: InputMaybe<SortOrder>;
};

export enum EducationScalarFieldEnum {
  CvId = 'cvId',
  GraduationYear = 'graduationYear',
  Id = 'id',
  ProfessionId = 'professionId',
  QualificationId = 'qualificationId',
  SpecialtyId = 'specialtyId',
  University = 'university'
}

export type EducationScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<EducationScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<EducationScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<EducationScalarWhereInput>>>;
  cvId?: InputMaybe<IntNullableFilter>;
  graduationYear?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  professionId?: InputMaybe<IntNullableFilter>;
  qualificationId?: InputMaybe<IntNullableFilter>;
  specialtyId?: InputMaybe<IntNullableFilter>;
  university?: InputMaybe<StringNullableFilter>;
};

export type EducationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<EducationScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<EducationScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<EducationScalarWhereWithAggregatesInput>>>;
  cvId?: InputMaybe<IntNullableWithAggregatesFilter>;
  graduationYear?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  professionId?: InputMaybe<IntNullableWithAggregatesFilter>;
  qualificationId?: InputMaybe<IntNullableWithAggregatesFilter>;
  specialtyId?: InputMaybe<IntNullableWithAggregatesFilter>;
  university?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type EducationSumAggregateOutputType = {
  __typename?: 'EducationSumAggregateOutputType';
  cvId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  professionId?: Maybe<Scalars['Int']>;
  qualificationId?: Maybe<Scalars['Int']>;
  specialtyId?: Maybe<Scalars['Int']>;
};

export type EducationSumOrderByAggregateInput = {
  cvId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  professionId?: InputMaybe<SortOrder>;
  qualificationId?: InputMaybe<SortOrder>;
  specialtyId?: InputMaybe<SortOrder>;
};

export type EducationUncheckedCreateInput = {
  cvId?: InputMaybe<Scalars['Int']>;
  graduationYear?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  university?: InputMaybe<Scalars['String']>;
};

export type EducationUncheckedCreateNestedManyWithoutCvInput = {
  connect?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EducationCreateOrConnectWithoutCvInput>>>;
  create?: InputMaybe<Array<InputMaybe<EducationCreateWithoutCvInput>>>;
  createMany?: InputMaybe<EducationCreateManyCvInputEnvelope>;
};

export type EducationUncheckedCreateNestedManyWithoutProfessionInput = {
  connect?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EducationCreateOrConnectWithoutProfessionInput>>>;
  create?: InputMaybe<Array<InputMaybe<EducationCreateWithoutProfessionInput>>>;
  createMany?: InputMaybe<EducationCreateManyProfessionInputEnvelope>;
};

export type EducationUncheckedCreateNestedManyWithoutQualificationInput = {
  connect?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EducationCreateOrConnectWithoutQualificationInput>>>;
  create?: InputMaybe<Array<InputMaybe<EducationCreateWithoutQualificationInput>>>;
  createMany?: InputMaybe<EducationCreateManyQualificationInputEnvelope>;
};

export type EducationUncheckedCreateNestedManyWithoutSpecialtyInput = {
  connect?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EducationCreateOrConnectWithoutSpecialtyInput>>>;
  create?: InputMaybe<Array<InputMaybe<EducationCreateWithoutSpecialtyInput>>>;
  createMany?: InputMaybe<EducationCreateManySpecialtyInputEnvelope>;
};

export type EducationUncheckedCreateWithoutCvInput = {
  graduationYear?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  university?: InputMaybe<Scalars['String']>;
};

export type EducationUncheckedCreateWithoutProfessionInput = {
  cvId?: InputMaybe<Scalars['Int']>;
  graduationYear?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  university?: InputMaybe<Scalars['String']>;
};

export type EducationUncheckedCreateWithoutQualificationInput = {
  cvId?: InputMaybe<Scalars['Int']>;
  graduationYear?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  professionId?: InputMaybe<Scalars['Int']>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  university?: InputMaybe<Scalars['String']>;
};

export type EducationUncheckedCreateWithoutSpecialtyInput = {
  cvId?: InputMaybe<Scalars['Int']>;
  graduationYear?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  university?: InputMaybe<Scalars['String']>;
};

export type EducationUncheckedUpdateInput = {
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  graduationYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  university?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EducationUncheckedUpdateManyInput = {
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  graduationYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  university?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EducationUncheckedUpdateManyWithoutCvInput = {
  connect?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EducationCreateOrConnectWithoutCvInput>>>;
  create?: InputMaybe<Array<InputMaybe<EducationCreateWithoutCvInput>>>;
  createMany?: InputMaybe<EducationCreateManyCvInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EducationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EducationUpdateWithWhereUniqueWithoutCvInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EducationUpdateManyWithWhereWithoutCvInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EducationUpsertWithWhereUniqueWithoutCvInput>>>;
};

export type EducationUncheckedUpdateManyWithoutEducationInput = {
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  graduationYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  university?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EducationUncheckedUpdateManyWithoutProfessionInput = {
  connect?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EducationCreateOrConnectWithoutProfessionInput>>>;
  create?: InputMaybe<Array<InputMaybe<EducationCreateWithoutProfessionInput>>>;
  createMany?: InputMaybe<EducationCreateManyProfessionInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EducationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EducationUpdateWithWhereUniqueWithoutProfessionInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EducationUpdateManyWithWhereWithoutProfessionInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EducationUpsertWithWhereUniqueWithoutProfessionInput>>>;
};

export type EducationUncheckedUpdateManyWithoutQualificationInput = {
  connect?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EducationCreateOrConnectWithoutQualificationInput>>>;
  create?: InputMaybe<Array<InputMaybe<EducationCreateWithoutQualificationInput>>>;
  createMany?: InputMaybe<EducationCreateManyQualificationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EducationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EducationUpdateWithWhereUniqueWithoutQualificationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EducationUpdateManyWithWhereWithoutQualificationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EducationUpsertWithWhereUniqueWithoutQualificationInput>>>;
};

export type EducationUncheckedUpdateManyWithoutSpecialtyInput = {
  connect?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EducationCreateOrConnectWithoutSpecialtyInput>>>;
  create?: InputMaybe<Array<InputMaybe<EducationCreateWithoutSpecialtyInput>>>;
  createMany?: InputMaybe<EducationCreateManySpecialtyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EducationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EducationUpdateWithWhereUniqueWithoutSpecialtyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EducationUpdateManyWithWhereWithoutSpecialtyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EducationUpsertWithWhereUniqueWithoutSpecialtyInput>>>;
};

export type EducationUncheckedUpdateWithoutCvInput = {
  graduationYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  university?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EducationUncheckedUpdateWithoutProfessionInput = {
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  graduationYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  university?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EducationUncheckedUpdateWithoutQualificationInput = {
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  graduationYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  university?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EducationUncheckedUpdateWithoutSpecialtyInput = {
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  graduationYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  university?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EducationUpdateInput = {
  Cv?: InputMaybe<CvUpdateOneWithoutEducationInput>;
  graduationYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutEducationInput>;
  qualification?: InputMaybe<QualificationUpdateOneWithoutEducationInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutEducationInput>;
  university?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EducationUpdateManyMutationInput = {
  graduationYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  university?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EducationUpdateManyWithWhereWithoutCvInput = {
  data: EducationUncheckedUpdateManyWithoutEducationInput;
  where: EducationScalarWhereInput;
};

export type EducationUpdateManyWithWhereWithoutProfessionInput = {
  data: EducationUncheckedUpdateManyWithoutEducationInput;
  where: EducationScalarWhereInput;
};

export type EducationUpdateManyWithWhereWithoutQualificationInput = {
  data: EducationUncheckedUpdateManyWithoutEducationInput;
  where: EducationScalarWhereInput;
};

export type EducationUpdateManyWithWhereWithoutSpecialtyInput = {
  data: EducationUncheckedUpdateManyWithoutEducationInput;
  where: EducationScalarWhereInput;
};

export type EducationUpdateManyWithoutCvInput = {
  connect?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EducationCreateOrConnectWithoutCvInput>>>;
  create?: InputMaybe<Array<InputMaybe<EducationCreateWithoutCvInput>>>;
  createMany?: InputMaybe<EducationCreateManyCvInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EducationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EducationUpdateWithWhereUniqueWithoutCvInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EducationUpdateManyWithWhereWithoutCvInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EducationUpsertWithWhereUniqueWithoutCvInput>>>;
};

export type EducationUpdateManyWithoutProfessionInput = {
  connect?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EducationCreateOrConnectWithoutProfessionInput>>>;
  create?: InputMaybe<Array<InputMaybe<EducationCreateWithoutProfessionInput>>>;
  createMany?: InputMaybe<EducationCreateManyProfessionInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EducationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EducationUpdateWithWhereUniqueWithoutProfessionInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EducationUpdateManyWithWhereWithoutProfessionInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EducationUpsertWithWhereUniqueWithoutProfessionInput>>>;
};

export type EducationUpdateManyWithoutQualificationInput = {
  connect?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EducationCreateOrConnectWithoutQualificationInput>>>;
  create?: InputMaybe<Array<InputMaybe<EducationCreateWithoutQualificationInput>>>;
  createMany?: InputMaybe<EducationCreateManyQualificationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EducationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EducationUpdateWithWhereUniqueWithoutQualificationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EducationUpdateManyWithWhereWithoutQualificationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EducationUpsertWithWhereUniqueWithoutQualificationInput>>>;
};

export type EducationUpdateManyWithoutSpecialtyInput = {
  connect?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EducationCreateOrConnectWithoutSpecialtyInput>>>;
  create?: InputMaybe<Array<InputMaybe<EducationCreateWithoutSpecialtyInput>>>;
  createMany?: InputMaybe<EducationCreateManySpecialtyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EducationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EducationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EducationUpdateWithWhereUniqueWithoutSpecialtyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EducationUpdateManyWithWhereWithoutSpecialtyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EducationUpsertWithWhereUniqueWithoutSpecialtyInput>>>;
};

export type EducationUpdateWithWhereUniqueWithoutCvInput = {
  data: EducationUncheckedUpdateWithoutCvInput;
  where: EducationWhereUniqueInput;
};

export type EducationUpdateWithWhereUniqueWithoutProfessionInput = {
  data: EducationUncheckedUpdateWithoutProfessionInput;
  where: EducationWhereUniqueInput;
};

export type EducationUpdateWithWhereUniqueWithoutQualificationInput = {
  data: EducationUncheckedUpdateWithoutQualificationInput;
  where: EducationWhereUniqueInput;
};

export type EducationUpdateWithWhereUniqueWithoutSpecialtyInput = {
  data: EducationUncheckedUpdateWithoutSpecialtyInput;
  where: EducationWhereUniqueInput;
};

export type EducationUpdateWithoutCvInput = {
  graduationYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutEducationInput>;
  qualification?: InputMaybe<QualificationUpdateOneWithoutEducationInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutEducationInput>;
  university?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EducationUpdateWithoutProfessionInput = {
  Cv?: InputMaybe<CvUpdateOneWithoutEducationInput>;
  graduationYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  qualification?: InputMaybe<QualificationUpdateOneWithoutEducationInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutEducationInput>;
  university?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EducationUpdateWithoutQualificationInput = {
  Cv?: InputMaybe<CvUpdateOneWithoutEducationInput>;
  graduationYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutEducationInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutEducationInput>;
  university?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EducationUpdateWithoutSpecialtyInput = {
  Cv?: InputMaybe<CvUpdateOneWithoutEducationInput>;
  graduationYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutEducationInput>;
  qualification?: InputMaybe<QualificationUpdateOneWithoutEducationInput>;
  university?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EducationUpsertWithWhereUniqueWithoutCvInput = {
  create: EducationUncheckedCreateWithoutCvInput;
  update: EducationUncheckedUpdateWithoutCvInput;
  where: EducationWhereUniqueInput;
};

export type EducationUpsertWithWhereUniqueWithoutProfessionInput = {
  create: EducationUncheckedCreateWithoutProfessionInput;
  update: EducationUncheckedUpdateWithoutProfessionInput;
  where: EducationWhereUniqueInput;
};

export type EducationUpsertWithWhereUniqueWithoutQualificationInput = {
  create: EducationUncheckedCreateWithoutQualificationInput;
  update: EducationUncheckedUpdateWithoutQualificationInput;
  where: EducationWhereUniqueInput;
};

export type EducationUpsertWithWhereUniqueWithoutSpecialtyInput = {
  create: EducationUncheckedCreateWithoutSpecialtyInput;
  update: EducationUncheckedUpdateWithoutSpecialtyInput;
  where: EducationWhereUniqueInput;
};

export type EducationWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<EducationWhereInput>>>;
  Cv?: InputMaybe<CvWhereInput>;
  NOT?: InputMaybe<Array<InputMaybe<EducationWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<EducationWhereInput>>>;
  cvId?: InputMaybe<IntNullableFilter>;
  graduationYear?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  profession?: InputMaybe<ProfessionWhereInput>;
  professionId?: InputMaybe<IntNullableFilter>;
  qualification?: InputMaybe<QualificationWhereInput>;
  qualificationId?: InputMaybe<IntNullableFilter>;
  specialty?: InputMaybe<SpecialtyWhereInput>;
  specialtyId?: InputMaybe<IntNullableFilter>;
  university?: InputMaybe<StringNullableFilter>;
};

export type EducationWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type EmailTemplate = {
  __typename?: 'EmailTemplate';
  event: Event;
  listEmailOutput: Array<Maybe<ListEmailOutput>>;
};

export type EnumApplicationStateFieldUpdateOperationsInput = {
  set?: InputMaybe<ApplicationState>;
};

export type EnumApplicationStateFilter = {
  equals?: InputMaybe<ApplicationState>;
  in?: InputMaybe<Array<InputMaybe<ApplicationState>>>;
  not?: InputMaybe<NestedEnumApplicationStateFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ApplicationState>>>;
};

export type EnumApplicationStateWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumApplicationStateFilter>;
  _min?: InputMaybe<NestedEnumApplicationStateFilter>;
  equals?: InputMaybe<ApplicationState>;
  in?: InputMaybe<Array<InputMaybe<ApplicationState>>>;
  not?: InputMaybe<NestedEnumApplicationStateWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ApplicationState>>>;
};

export type EnumCouponTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<CouponType>;
};

export type EnumCouponTypeFilter = {
  equals?: InputMaybe<CouponType>;
  in?: InputMaybe<Array<InputMaybe<CouponType>>>;
  not?: InputMaybe<NestedEnumCouponTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<CouponType>>>;
};

export type EnumCouponTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumCouponTypeFilter>;
  _min?: InputMaybe<NestedEnumCouponTypeFilter>;
  equals?: InputMaybe<CouponType>;
  in?: InputMaybe<Array<InputMaybe<CouponType>>>;
  not?: InputMaybe<NestedEnumCouponTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<CouponType>>>;
};

export type EnumDynamicEmailForRegistransFieldUpdateOperationsInput = {
  set?: InputMaybe<DynamicEmailForRegistrans>;
};

export type EnumDynamicEmailForRegistransFilter = {
  equals?: InputMaybe<DynamicEmailForRegistrans>;
  in?: InputMaybe<Array<InputMaybe<DynamicEmailForRegistrans>>>;
  not?: InputMaybe<NestedEnumDynamicEmailForRegistransFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DynamicEmailForRegistrans>>>;
};

export type EnumDynamicEmailForRegistransWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDynamicEmailForRegistransFilter>;
  _min?: InputMaybe<NestedEnumDynamicEmailForRegistransFilter>;
  equals?: InputMaybe<DynamicEmailForRegistrans>;
  in?: InputMaybe<Array<InputMaybe<DynamicEmailForRegistrans>>>;
  not?: InputMaybe<NestedEnumDynamicEmailForRegistransWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DynamicEmailForRegistrans>>>;
};

export type EnumDynamicEmailSendToFieldUpdateOperationsInput = {
  set?: InputMaybe<DynamicEmailSendTo>;
};

export type EnumDynamicEmailSendToFilter = {
  equals?: InputMaybe<DynamicEmailSendTo>;
  in?: InputMaybe<Array<InputMaybe<DynamicEmailSendTo>>>;
  not?: InputMaybe<NestedEnumDynamicEmailSendToFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DynamicEmailSendTo>>>;
};

export type EnumDynamicEmailSendToWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDynamicEmailSendToFilter>;
  _min?: InputMaybe<NestedEnumDynamicEmailSendToFilter>;
  equals?: InputMaybe<DynamicEmailSendTo>;
  in?: InputMaybe<Array<InputMaybe<DynamicEmailSendTo>>>;
  not?: InputMaybe<NestedEnumDynamicEmailSendToWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DynamicEmailSendTo>>>;
};

export type EnumDynamicEmailTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<DynamicEmailTime>;
};

export type EnumDynamicEmailTimeFilter = {
  equals?: InputMaybe<DynamicEmailTime>;
  in?: InputMaybe<Array<InputMaybe<DynamicEmailTime>>>;
  not?: InputMaybe<NestedEnumDynamicEmailTimeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DynamicEmailTime>>>;
};

export type EnumDynamicEmailTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDynamicEmailTimeFilter>;
  _min?: InputMaybe<NestedEnumDynamicEmailTimeFilter>;
  equals?: InputMaybe<DynamicEmailTime>;
  in?: InputMaybe<Array<InputMaybe<DynamicEmailTime>>>;
  not?: InputMaybe<NestedEnumDynamicEmailTimeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DynamicEmailTime>>>;
};

export type EnumDynamicwhenEventHasClassesFieldUpdateOperationsInput = {
  set?: InputMaybe<DynamicwhenEventHasClasses>;
};

export type EnumDynamicwhenEventHasClassesFilter = {
  equals?: InputMaybe<DynamicwhenEventHasClasses>;
  in?: InputMaybe<Array<InputMaybe<DynamicwhenEventHasClasses>>>;
  not?: InputMaybe<NestedEnumDynamicwhenEventHasClassesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DynamicwhenEventHasClasses>>>;
};

export type EnumDynamicwhenEventHasClassesWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDynamicwhenEventHasClassesFilter>;
  _min?: InputMaybe<NestedEnumDynamicwhenEventHasClassesFilter>;
  equals?: InputMaybe<DynamicwhenEventHasClasses>;
  in?: InputMaybe<Array<InputMaybe<DynamicwhenEventHasClasses>>>;
  not?: InputMaybe<NestedEnumDynamicwhenEventHasClassesWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DynamicwhenEventHasClasses>>>;
};

export type EnumGenderNullableFilter = {
  equals?: InputMaybe<Gender>;
  in?: InputMaybe<Array<InputMaybe<Gender>>>;
  not?: InputMaybe<NestedEnumGenderNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Gender>>>;
};

export type EnumGenderNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumGenderNullableFilter>;
  _min?: InputMaybe<NestedEnumGenderNullableFilter>;
  equals?: InputMaybe<Gender>;
  in?: InputMaybe<Array<InputMaybe<Gender>>>;
  not?: InputMaybe<NestedEnumGenderNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Gender>>>;
};

export type EnumLanguageEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<LanguageEnum>;
};

export type EnumLanguageEnumFilter = {
  equals?: InputMaybe<LanguageEnum>;
  in?: InputMaybe<Array<InputMaybe<LanguageEnum>>>;
  not?: InputMaybe<NestedEnumLanguageEnumFilter>;
  notIn?: InputMaybe<Array<InputMaybe<LanguageEnum>>>;
};

export type EnumLanguageEnumWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumLanguageEnumFilter>;
  _min?: InputMaybe<NestedEnumLanguageEnumFilter>;
  equals?: InputMaybe<LanguageEnum>;
  in?: InputMaybe<Array<InputMaybe<LanguageEnum>>>;
  not?: InputMaybe<NestedEnumLanguageEnumWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<LanguageEnum>>>;
};

export type EnumMarketerProfitTypeNullableFilter = {
  equals?: InputMaybe<MarketerProfitType>;
  in?: InputMaybe<Array<InputMaybe<MarketerProfitType>>>;
  not?: InputMaybe<NestedEnumMarketerProfitTypeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<MarketerProfitType>>>;
};

export type EnumMarketerProfitTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumMarketerProfitTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumMarketerProfitTypeNullableFilter>;
  equals?: InputMaybe<MarketerProfitType>;
  in?: InputMaybe<Array<InputMaybe<MarketerProfitType>>>;
  not?: InputMaybe<NestedEnumMarketerProfitTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<MarketerProfitType>>>;
};

export type EnumMemberNeedsStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<MemberNeedsStatus>;
};

export type EnumMemberNeedsStatusFilter = {
  equals?: InputMaybe<MemberNeedsStatus>;
  in?: InputMaybe<Array<InputMaybe<MemberNeedsStatus>>>;
  not?: InputMaybe<NestedEnumMemberNeedsStatusFilter>;
  notIn?: InputMaybe<Array<InputMaybe<MemberNeedsStatus>>>;
};

export type EnumMemberNeedsStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumMemberNeedsStatusFilter>;
  _min?: InputMaybe<NestedEnumMemberNeedsStatusFilter>;
  equals?: InputMaybe<MemberNeedsStatus>;
  in?: InputMaybe<Array<InputMaybe<MemberNeedsStatus>>>;
  not?: InputMaybe<NestedEnumMemberNeedsStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<MemberNeedsStatus>>>;
};

export type EnumPaymentTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<PaymentType>;
};

export type EnumPaymentTypeFilter = {
  equals?: InputMaybe<PaymentType>;
  in?: InputMaybe<Array<InputMaybe<PaymentType>>>;
  not?: InputMaybe<NestedEnumPaymentTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PaymentType>>>;
};

export type EnumPaymentTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPaymentTypeFilter>;
  _min?: InputMaybe<NestedEnumPaymentTypeFilter>;
  equals?: InputMaybe<PaymentType>;
  in?: InputMaybe<Array<InputMaybe<PaymentType>>>;
  not?: InputMaybe<NestedEnumPaymentTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PaymentType>>>;
};

export type EnumProfessionalSkillsTypeNullableFilter = {
  equals?: InputMaybe<ProfessionalSkillsType>;
  in?: InputMaybe<Array<InputMaybe<ProfessionalSkillsType>>>;
  not?: InputMaybe<NestedEnumProfessionalSkillsTypeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ProfessionalSkillsType>>>;
};

export type EnumProfessionalSkillsTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumProfessionalSkillsTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumProfessionalSkillsTypeNullableFilter>;
  equals?: InputMaybe<ProfessionalSkillsType>;
  in?: InputMaybe<Array<InputMaybe<ProfessionalSkillsType>>>;
  not?: InputMaybe<NestedEnumProfessionalSkillsTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ProfessionalSkillsType>>>;
};

export type EnumScientificResearchRoleNullableFilter = {
  equals?: InputMaybe<ScientificResearchRole>;
  in?: InputMaybe<Array<InputMaybe<ScientificResearchRole>>>;
  not?: InputMaybe<NestedEnumScientificResearchRoleNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ScientificResearchRole>>>;
};

export type EnumScientificResearchRoleNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumScientificResearchRoleNullableFilter>;
  _min?: InputMaybe<NestedEnumScientificResearchRoleNullableFilter>;
  equals?: InputMaybe<ScientificResearchRole>;
  in?: InputMaybe<Array<InputMaybe<ScientificResearchRole>>>;
  not?: InputMaybe<NestedEnumScientificResearchRoleNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ScientificResearchRole>>>;
};

export type EnumScientificResearchTypeNullableFilter = {
  equals?: InputMaybe<ScientificResearchType>;
  in?: InputMaybe<Array<InputMaybe<ScientificResearchType>>>;
  not?: InputMaybe<NestedEnumScientificResearchTypeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ScientificResearchType>>>;
};

export type EnumScientificResearchTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumScientificResearchTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumScientificResearchTypeNullableFilter>;
  equals?: InputMaybe<ScientificResearchType>;
  in?: InputMaybe<Array<InputMaybe<ScientificResearchType>>>;
  not?: InputMaybe<NestedEnumScientificResearchTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ScientificResearchType>>>;
};

export type EnumTemplatePurposeFieldUpdateOperationsInput = {
  set?: InputMaybe<TemplatePurpose>;
};

export type EnumTemplatePurposeFilter = {
  equals?: InputMaybe<TemplatePurpose>;
  in?: InputMaybe<Array<InputMaybe<TemplatePurpose>>>;
  not?: InputMaybe<NestedEnumTemplatePurposeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<TemplatePurpose>>>;
};

export type EnumTemplatePurposeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumTemplatePurposeFilter>;
  _min?: InputMaybe<NestedEnumTemplatePurposeFilter>;
  equals?: InputMaybe<TemplatePurpose>;
  in?: InputMaybe<Array<InputMaybe<TemplatePurpose>>>;
  not?: InputMaybe<NestedEnumTemplatePurposeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<TemplatePurpose>>>;
};

export type EnumToTransferTypeNullableFilter = {
  equals?: InputMaybe<ToTransferType>;
  in?: InputMaybe<Array<InputMaybe<ToTransferType>>>;
  not?: InputMaybe<NestedEnumToTransferTypeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ToTransferType>>>;
};

export type EnumToTransferTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumToTransferTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumToTransferTypeNullableFilter>;
  equals?: InputMaybe<ToTransferType>;
  in?: InputMaybe<Array<InputMaybe<ToTransferType>>>;
  not?: InputMaybe<NestedEnumToTransferTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ToTransferType>>>;
};

export type Event = {
  __typename?: 'Event';
  Blogs: Array<Blogs>;
  Certificate: Array<Certificate>;
  Discussion: Array<Discussion>;
  Quiz?: Maybe<Quiz>;
  ZoomMeeting?: Maybe<ZoomMeeting>;
  _count: EventCountOutputType;
  addedBy?: Maybe<User>;
  addedById?: Maybe<Scalars['Int']>;
  address?: Maybe<Scalars['String']>;
  addressAr?: Maybe<Scalars['String']>;
  addressInstructions?: Maybe<Scalars['String']>;
  addressInstructionsAr?: Maybe<Scalars['String']>;
  backgroundImagesUrls: Array<Scalars['String']>;
  city?: Maybe<City>;
  cityId?: Maybe<Scalars['Int']>;
  cmeHours?: Maybe<Scalars['Decimal']>;
  cmeNumber?: Maybe<Scalars['String']>;
  coupons: Array<Coupon>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultLanguage?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  descriptionAr?: Maybe<Scalars['String']>;
  descriptionEn?: Maybe<Scalars['String']>;
  discussionStatus: Scalars['Boolean'];
  endDate?: Maybe<Scalars['DateTime']>;
  eventDays: Array<EventDay>;
  eventIdentityCardTemplate?: Maybe<EventIdentityCardTemplate>;
  eventLanguages: Array<Language>;
  eventMediaTracking: Array<EventMediaTracking>;
  eventParts: Array<EventPart>;
  eventType: EventType;
  eventTypeId: Scalars['Int'];
  expensesTransitions: Array<Transition>;
  folder: EventFolder;
  folderId: Scalars['Int'];
  hideVideoProgress?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  imageUrl?: Maybe<Scalars['String']>;
  introductionAr?: Maybe<Scalars['String']>;
  introductionEn?: Maybe<Scalars['String']>;
  inviterCouponProfits?: Maybe<Array<InviterCouponProfit>>;
  invitersCanApprovePayments?: Maybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: Maybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: Maybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: Maybe<Scalars['Boolean']>;
  isSponsored: Scalars['Boolean'];
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr: Array<Scalars['String']>;
  keywordsEn: Array<Scalars['String']>;
  leaderTrainer?: Maybe<User>;
  leaderTrainerId?: Maybe<Scalars['Int']>;
  locationLatitude?: Maybe<Scalars['Decimal']>;
  locationLongitude?: Maybe<Scalars['Decimal']>;
  mainThemeAr?: Maybe<Scalars['String']>;
  mainThemeEn?: Maybe<Scalars['String']>;
  meetingId?: Maybe<Scalars['String']>;
  methodOfDelivery: MethodOfDelivery;
  methodOfDeliveryId?: Maybe<Scalars['Int']>;
  minAttendancePercentageToGetCertificate?: Maybe<Scalars['Decimal']>;
  numberOfVisits?: Maybe<Scalars['Int']>;
  objectivesAr?: Maybe<Scalars['String']>;
  objectivesEn?: Maybe<Scalars['String']>;
  onlineCapacity?: Maybe<Scalars['Int']>;
  onsiteCapacity?: Maybe<Scalars['Int']>;
  outcomesAr?: Maybe<Scalars['String']>;
  outcomesEn?: Maybe<Scalars['String']>;
  package?: Maybe<Event>;
  packageEvents: Array<Event>;
  packageId?: Maybe<Scalars['Int']>;
  pricingPlan: PricingPlan;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees: Array<User>;
  shortDescriptionAr?: Maybe<Scalars['String']>;
  shortDescriptionEn?: Maybe<Scalars['String']>;
  sponsorshipImagesUrls?: Maybe<Scalars['Json']>;
  startDate?: Maybe<Scalars['DateTime']>;
  targetedAudiences: Array<Profession>;
  targetedSpecialities: Array<Specialty>;
  timeTableStatus: Scalars['Boolean'];
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: Maybe<Template>;
  traineeCertificateTemplateId?: Maybe<Scalars['Int']>;
  traineeEventGroups: Array<TraineeEventGroup>;
  traineeEventReviews: Array<TraineeEventReview>;
  traineeEvents: Array<TraineeEvent>;
  trainerCertificateTemplate?: Maybe<Template>;
  trainerCertificateTemplateId?: Maybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups: Array<TrainerEventStudyMaterialGroup>;
  trainerEventStudyMaterials: Array<TrainerEventStudyMaterial>;
  trainerEvents: Array<TrainerEvent>;
  visibleOnArchive?: Maybe<Scalars['Boolean']>;
  visitedTrainees: Array<User>;
  whyTargetedAudienceAr?: Maybe<Scalars['String']>;
  whyTargetedAudienceEn?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['String']>;
  zoomMeetingId?: Maybe<Scalars['Int']>;
  zoomMode?: Maybe<Scalars['String']>;
};


export type EventCertificateArgs = {
  cursor?: InputMaybe<CertificateWhereUniqueInput>;
  distinct?: InputMaybe<CertificateScalarFieldEnum>;
  orderBy?: InputMaybe<CertificateOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CertificateWhereInput>;
};


export type EventDiscussionArgs = {
  cursor?: InputMaybe<DiscussionWhereUniqueInput>;
  distinct?: InputMaybe<DiscussionScalarFieldEnum>;
  orderBy?: InputMaybe<DiscussionOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DiscussionWhereInput>;
};


export type EventCouponsArgs = {
  cursor?: InputMaybe<CouponWhereUniqueInput>;
  distinct?: InputMaybe<CouponScalarFieldEnum>;
  orderBy?: InputMaybe<CouponOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CouponWhereInput>;
};


export type EventEventDaysArgs = {
  cursor?: InputMaybe<EventDayWhereUniqueInput>;
  distinct?: InputMaybe<EventDayScalarFieldEnum>;
  orderBy?: InputMaybe<EventDayOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EventDayWhereInput>;
};


export type EventEventLanguagesArgs = {
  cursor?: InputMaybe<LanguageWhereUniqueInput>;
  distinct?: InputMaybe<LanguageScalarFieldEnum>;
  orderBy?: InputMaybe<LanguageOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LanguageWhereInput>;
};


export type EventEventPartsArgs = {
  cursor?: InputMaybe<EventPartWhereUniqueInput>;
  distinct?: InputMaybe<EventPartScalarFieldEnum>;
  orderBy?: InputMaybe<EventPartOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EventPartWhereInput>;
};


export type EventExpensesTransitionsArgs = {
  cursor?: InputMaybe<TransitionWhereUniqueInput>;
  distinct?: InputMaybe<TransitionScalarFieldEnum>;
  orderBy?: InputMaybe<TransitionOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TransitionWhereInput>;
};


export type EventPackageEventsArgs = {
  cursor?: InputMaybe<EventWhereUniqueInput>;
  distinct?: InputMaybe<EventScalarFieldEnum>;
  orderBy?: InputMaybe<EventOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EventWhereInput>;
};


export type EventRemindMeTraineesArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<UserScalarFieldEnum>;
  orderBy?: InputMaybe<UserOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};


export type EventTargetedAudiencesArgs = {
  cursor?: InputMaybe<ProfessionWhereUniqueInput>;
  distinct?: InputMaybe<ProfessionScalarFieldEnum>;
  orderBy?: InputMaybe<ProfessionOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProfessionWhereInput>;
};


export type EventTargetedSpecialitiesArgs = {
  cursor?: InputMaybe<SpecialtyWhereUniqueInput>;
  distinct?: InputMaybe<SpecialtyScalarFieldEnum>;
  orderBy?: InputMaybe<SpecialtyOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SpecialtyWhereInput>;
};


export type EventTraineeEventGroupsArgs = {
  cursor?: InputMaybe<TraineeEventGroupWhereUniqueInput>;
  distinct?: InputMaybe<TraineeEventGroupScalarFieldEnum>;
  orderBy?: InputMaybe<TraineeEventGroupOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeEventGroupWhereInput>;
};


export type EventTraineeEventReviewsArgs = {
  cursor?: InputMaybe<TraineeEventReviewWhereUniqueInput>;
  distinct?: InputMaybe<TraineeEventReviewScalarFieldEnum>;
  orderBy?: InputMaybe<TraineeEventReviewOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeEventReviewWhereInput>;
};


export type EventTraineeEventsArgs = {
  cursor?: InputMaybe<TraineeEventWhereUniqueInput>;
  distinct?: InputMaybe<TraineeEventScalarFieldEnum>;
  orderBy?: InputMaybe<TraineeEventOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeEventWhereInput>;
};


export type EventTrainerEventStudyMaterialsArgs = {
  cursor?: InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>;
  distinct?: InputMaybe<TrainerEventStudyMaterialScalarFieldEnum>;
  orderBy?: InputMaybe<TrainerEventStudyMaterialOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TrainerEventStudyMaterialWhereInput>;
};


export type EventTrainerEventsArgs = {
  cursor?: InputMaybe<TrainerEventWhereUniqueInput>;
  distinct?: InputMaybe<TrainerEventScalarFieldEnum>;
  orderBy?: InputMaybe<TrainerEventOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TrainerEventWhereInput>;
};


export type EventVisitedTraineesArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<UserScalarFieldEnum>;
  orderBy?: InputMaybe<UserOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};

export type EventAvgAggregateOutputType = {
  __typename?: 'EventAvgAggregateOutputType';
  addedById?: Maybe<Scalars['Float']>;
  cityId?: Maybe<Scalars['Float']>;
  cmeHours?: Maybe<Scalars['Decimal']>;
  eventTypeId?: Maybe<Scalars['Float']>;
  folderId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  leaderTrainerId?: Maybe<Scalars['Float']>;
  locationLatitude?: Maybe<Scalars['Decimal']>;
  locationLongitude?: Maybe<Scalars['Decimal']>;
  methodOfDeliveryId?: Maybe<Scalars['Float']>;
  minAttendancePercentageToGetCertificate?: Maybe<Scalars['Decimal']>;
  numberOfVisits?: Maybe<Scalars['Float']>;
  onlineCapacity?: Maybe<Scalars['Float']>;
  onsiteCapacity?: Maybe<Scalars['Float']>;
  packageId?: Maybe<Scalars['Float']>;
  pricingPlanId?: Maybe<Scalars['Float']>;
  traineeCertificateTemplateId?: Maybe<Scalars['Float']>;
  trainerCertificateTemplateId?: Maybe<Scalars['Float']>;
  zoomMeetingId?: Maybe<Scalars['Float']>;
};

export type EventAvgOrderByAggregateInput = {
  addedById?: InputMaybe<SortOrder>;
  cityId?: InputMaybe<SortOrder>;
  cmeHours?: InputMaybe<SortOrder>;
  eventTypeId?: InputMaybe<SortOrder>;
  folderId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  leaderTrainerId?: InputMaybe<SortOrder>;
  locationLatitude?: InputMaybe<SortOrder>;
  locationLongitude?: InputMaybe<SortOrder>;
  methodOfDeliveryId?: InputMaybe<SortOrder>;
  minAttendancePercentageToGetCertificate?: InputMaybe<SortOrder>;
  numberOfVisits?: InputMaybe<SortOrder>;
  onlineCapacity?: InputMaybe<SortOrder>;
  onsiteCapacity?: InputMaybe<SortOrder>;
  packageId?: InputMaybe<SortOrder>;
  pricingPlanId?: InputMaybe<SortOrder>;
  traineeCertificateTemplateId?: InputMaybe<SortOrder>;
  trainerCertificateTemplateId?: InputMaybe<SortOrder>;
  zoomMeetingId?: InputMaybe<SortOrder>;
};

export type EventCoulmn = {
  __typename?: 'EventCoulmn';
  month?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

export type EventCountAggregateOutputType = {
  __typename?: 'EventCountAggregateOutputType';
  _all: Scalars['Int'];
  addedById: Scalars['Int'];
  address: Scalars['Int'];
  addressAr: Scalars['Int'];
  addressInstructions: Scalars['Int'];
  addressInstructionsAr: Scalars['Int'];
  backgroundImagesUrls: Scalars['Int'];
  cityId: Scalars['Int'];
  cmeHours: Scalars['Int'];
  cmeNumber: Scalars['Int'];
  createdAt: Scalars['Int'];
  defaultLanguage: Scalars['Int'];
  deletedAt: Scalars['Int'];
  descriptionAr: Scalars['Int'];
  descriptionEn: Scalars['Int'];
  discussionStatus: Scalars['Int'];
  endDate: Scalars['Int'];
  eventTypeId: Scalars['Int'];
  folderId: Scalars['Int'];
  hideVideoProgress: Scalars['Int'];
  id: Scalars['Int'];
  imageUrl: Scalars['Int'];
  introductionAr: Scalars['Int'];
  introductionEn: Scalars['Int'];
  invitersCanApprovePayments: Scalars['Int'];
  isAccredited: Scalars['Int'];
  isAccreditedSHA: Scalars['Int'];
  isAllProfessionsTargeted: Scalars['Int'];
  isContentProvidedByAcademy: Scalars['Int'];
  isRegistraionClosed: Scalars['Int'];
  isSponsored: Scalars['Int'];
  isTraineeCertificateAvailable: Scalars['Int'];
  isTrainerCertificateAvailable: Scalars['Int'];
  keywordsAr: Scalars['Int'];
  keywordsEn: Scalars['Int'];
  leaderTrainerId: Scalars['Int'];
  locationLatitude: Scalars['Int'];
  locationLongitude: Scalars['Int'];
  mainThemeAr: Scalars['Int'];
  mainThemeEn: Scalars['Int'];
  meetingId: Scalars['Int'];
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate: Scalars['Int'];
  numberOfVisits: Scalars['Int'];
  objectivesAr: Scalars['Int'];
  objectivesEn: Scalars['Int'];
  onlineCapacity: Scalars['Int'];
  onsiteCapacity: Scalars['Int'];
  outcomesAr: Scalars['Int'];
  outcomesEn: Scalars['Int'];
  packageId: Scalars['Int'];
  pricingPlanId: Scalars['Int'];
  shortDescriptionAr: Scalars['Int'];
  shortDescriptionEn: Scalars['Int'];
  sponsorshipImagesUrls: Scalars['Int'];
  startDate: Scalars['Int'];
  timeTableStatus: Scalars['Int'];
  titleAr: Scalars['Int'];
  titleEn: Scalars['Int'];
  traineeCertificateTemplateId: Scalars['Int'];
  trainerCertificateTemplateId: Scalars['Int'];
  visibleOnArchive: Scalars['Int'];
  whyTargetedAudienceAr: Scalars['Int'];
  whyTargetedAudienceEn: Scalars['Int'];
  youtubeUrl: Scalars['Int'];
  zoomMeetingId: Scalars['Int'];
  zoomMode: Scalars['Int'];
};

export type EventCountOrderByAggregateInput = {
  addedById?: InputMaybe<SortOrder>;
  address?: InputMaybe<SortOrder>;
  addressAr?: InputMaybe<SortOrder>;
  addressInstructions?: InputMaybe<SortOrder>;
  addressInstructionsAr?: InputMaybe<SortOrder>;
  backgroundImagesUrls?: InputMaybe<SortOrder>;
  cityId?: InputMaybe<SortOrder>;
  cmeHours?: InputMaybe<SortOrder>;
  cmeNumber?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  defaultLanguage?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  descriptionAr?: InputMaybe<SortOrder>;
  descriptionEn?: InputMaybe<SortOrder>;
  discussionStatus?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  eventTypeId?: InputMaybe<SortOrder>;
  folderId?: InputMaybe<SortOrder>;
  hideVideoProgress?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  introductionAr?: InputMaybe<SortOrder>;
  introductionEn?: InputMaybe<SortOrder>;
  invitersCanApprovePayments?: InputMaybe<SortOrder>;
  isAccredited?: InputMaybe<SortOrder>;
  isAccreditedSHA?: InputMaybe<SortOrder>;
  isAllProfessionsTargeted?: InputMaybe<SortOrder>;
  isContentProvidedByAcademy?: InputMaybe<SortOrder>;
  isRegistraionClosed?: InputMaybe<SortOrder>;
  isSponsored?: InputMaybe<SortOrder>;
  isTraineeCertificateAvailable?: InputMaybe<SortOrder>;
  isTrainerCertificateAvailable?: InputMaybe<SortOrder>;
  keywordsAr?: InputMaybe<SortOrder>;
  keywordsEn?: InputMaybe<SortOrder>;
  leaderTrainerId?: InputMaybe<SortOrder>;
  locationLatitude?: InputMaybe<SortOrder>;
  locationLongitude?: InputMaybe<SortOrder>;
  mainThemeAr?: InputMaybe<SortOrder>;
  mainThemeEn?: InputMaybe<SortOrder>;
  meetingId?: InputMaybe<SortOrder>;
  methodOfDeliveryId?: InputMaybe<SortOrder>;
  minAttendancePercentageToGetCertificate?: InputMaybe<SortOrder>;
  numberOfVisits?: InputMaybe<SortOrder>;
  objectivesAr?: InputMaybe<SortOrder>;
  objectivesEn?: InputMaybe<SortOrder>;
  onlineCapacity?: InputMaybe<SortOrder>;
  onsiteCapacity?: InputMaybe<SortOrder>;
  outcomesAr?: InputMaybe<SortOrder>;
  outcomesEn?: InputMaybe<SortOrder>;
  packageId?: InputMaybe<SortOrder>;
  pricingPlanId?: InputMaybe<SortOrder>;
  shortDescriptionAr?: InputMaybe<SortOrder>;
  shortDescriptionEn?: InputMaybe<SortOrder>;
  sponsorshipImagesUrls?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  timeTableStatus?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
  traineeCertificateTemplateId?: InputMaybe<SortOrder>;
  trainerCertificateTemplateId?: InputMaybe<SortOrder>;
  visibleOnArchive?: InputMaybe<SortOrder>;
  whyTargetedAudienceAr?: InputMaybe<SortOrder>;
  whyTargetedAudienceEn?: InputMaybe<SortOrder>;
  youtubeUrl?: InputMaybe<SortOrder>;
  zoomMeetingId?: InputMaybe<SortOrder>;
  zoomMode?: InputMaybe<SortOrder>;
};

export type EventCountOutputType = {
  __typename?: 'EventCountOutputType';
  Blogs: Scalars['Int'];
  Certificate: Scalars['Int'];
  Discussion: Scalars['Int'];
  QuizResult: Scalars['Int'];
  ZohoEmail: Scalars['Int'];
  coupons: Scalars['Int'];
  eventDays: Scalars['Int'];
  eventLanguages: Scalars['Int'];
  eventMediaTracking: Scalars['Int'];
  eventParts: Scalars['Int'];
  expensesTransitions: Scalars['Int'];
  inviterCouponProfits: Scalars['Int'];
  packageEvents: Scalars['Int'];
  remindMeTrainees: Scalars['Int'];
  targetedAudiences: Scalars['Int'];
  targetedSpecialities: Scalars['Int'];
  traineeEventGroups: Scalars['Int'];
  traineeEventReviews: Scalars['Int'];
  traineeEvents: Scalars['Int'];
  trainerEventStudyMaterialGroups: Scalars['Int'];
  trainerEventStudyMaterials: Scalars['Int'];
  trainerEvents: Scalars['Int'];
  visitedTrainees: Scalars['Int'];
};

export type EventCreateInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateManyAddedByInput = {
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventTypeId: Scalars['Int'];
  folderId: Scalars['Int'];
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateManyAddedByInputEnvelope = {
  data: EventCreateManyAddedByInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type EventCreateManyCityInput = {
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventTypeId: Scalars['Int'];
  folderId: Scalars['Int'];
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateManyCityInputEnvelope = {
  data: EventCreateManyCityInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type EventCreateManyEventTypeInput = {
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  folderId: Scalars['Int'];
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateManyEventTypeInputEnvelope = {
  data: EventCreateManyEventTypeInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type EventCreateManyFolderInput = {
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventTypeId: Scalars['Int'];
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateManyFolderInputEnvelope = {
  data: EventCreateManyFolderInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type EventCreateManyInput = {
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventTypeId: Scalars['Int'];
  folderId: Scalars['Int'];
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateManyLeaderTrainerInput = {
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventTypeId: Scalars['Int'];
  folderId: Scalars['Int'];
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateManyLeaderTrainerInputEnvelope = {
  data: EventCreateManyLeaderTrainerInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type EventCreateManyMethodOfDeliveryInput = {
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventTypeId: Scalars['Int'];
  folderId: Scalars['Int'];
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateManyMethodOfDeliveryInputEnvelope = {
  data: EventCreateManyMethodOfDeliveryInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type EventCreateManyPackageInput = {
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventTypeId: Scalars['Int'];
  folderId: Scalars['Int'];
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  pricingPlanId: Scalars['Int'];
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateManyPackageInputEnvelope = {
  data: EventCreateManyPackageInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type EventCreateManyTraineeCertificateTemplateInput = {
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventTypeId: Scalars['Int'];
  folderId: Scalars['Int'];
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateManyTraineeCertificateTemplateInputEnvelope = {
  data: EventCreateManyTraineeCertificateTemplateInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type EventCreateManyTrainerCertificateTemplateInput = {
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventTypeId: Scalars['Int'];
  folderId: Scalars['Int'];
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateManyTrainerCertificateTemplateInputEnvelope = {
  data: EventCreateManyTrainerCertificateTemplateInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type EventCreateManyZoomMeetingInput = {
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventTypeId: Scalars['Int'];
  folderId: Scalars['Int'];
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateManyZoomMeetingInputEnvelope = {
  data: EventCreateManyZoomMeetingInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type EventCreateNestedManyWithoutAddedByInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutAddedByInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutAddedByInput>>>;
  createMany?: InputMaybe<EventCreateManyAddedByInputEnvelope>;
};

export type EventCreateNestedManyWithoutCityInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutCityInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutCityInput>>>;
  createMany?: InputMaybe<EventCreateManyCityInputEnvelope>;
};

export type EventCreateNestedManyWithoutCouponsInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutCouponsInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutCouponsInput>>>;
};

export type EventCreateNestedManyWithoutEventLanguagesInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutEventLanguagesInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutEventLanguagesInput>>>;
};

export type EventCreateNestedManyWithoutEventTypeInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutEventTypeInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutEventTypeInput>>>;
  createMany?: InputMaybe<EventCreateManyEventTypeInputEnvelope>;
};

export type EventCreateNestedManyWithoutFolderInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutFolderInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutFolderInput>>>;
  createMany?: InputMaybe<EventCreateManyFolderInputEnvelope>;
};

export type EventCreateNestedManyWithoutLeaderTrainerInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutLeaderTrainerInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutLeaderTrainerInput>>>;
  createMany?: InputMaybe<EventCreateManyLeaderTrainerInputEnvelope>;
};

export type EventCreateNestedManyWithoutMethodOfDeliveryInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutMethodOfDeliveryInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutMethodOfDeliveryInput>>>;
  createMany?: InputMaybe<EventCreateManyMethodOfDeliveryInputEnvelope>;
};

export type EventCreateNestedManyWithoutPackageInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutPackageInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutPackageInput>>>;
  createMany?: InputMaybe<EventCreateManyPackageInputEnvelope>;
};

export type EventCreateNestedManyWithoutRemindMeTraineesInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutRemindMeTraineesInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutRemindMeTraineesInput>>>;
};

export type EventCreateNestedManyWithoutTargetedAudiencesInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutTargetedAudiencesInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutTargetedAudiencesInput>>>;
};

export type EventCreateNestedManyWithoutTargetedSpecialitiesInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutTargetedSpecialitiesInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutTargetedSpecialitiesInput>>>;
};

export type EventCreateNestedManyWithoutTraineeCertificateTemplateInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutTraineeCertificateTemplateInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutTraineeCertificateTemplateInput>>>;
  createMany?: InputMaybe<EventCreateManyTraineeCertificateTemplateInputEnvelope>;
};

export type EventCreateNestedManyWithoutTrainerCertificateTemplateInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutTrainerCertificateTemplateInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutTrainerCertificateTemplateInput>>>;
  createMany?: InputMaybe<EventCreateManyTrainerCertificateTemplateInputEnvelope>;
};

export type EventCreateNestedManyWithoutVisitedTraineesInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutVisitedTraineesInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutVisitedTraineesInput>>>;
};

export type EventCreateNestedManyWithoutZoomMeetingInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutZoomMeetingInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutZoomMeetingInput>>>;
  createMany?: InputMaybe<EventCreateManyZoomMeetingInputEnvelope>;
};

export type EventCreateNestedOneWithoutBlogsInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutBlogsInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutBlogsInput>;
};

export type EventCreateNestedOneWithoutCertificateInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutCertificateInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutCertificateInput>;
};

export type EventCreateNestedOneWithoutDiscussionInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutDiscussionInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutDiscussionInput>;
};

export type EventCreateNestedOneWithoutEventDaysInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutEventDaysInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutEventDaysInput>;
};

export type EventCreateNestedOneWithoutEventIdentityCardTemplateInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutEventIdentityCardTemplateInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutEventIdentityCardTemplateInput>;
};

export type EventCreateNestedOneWithoutEventMediaTrackingInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutEventMediaTrackingInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutEventMediaTrackingInput>;
};

export type EventCreateNestedOneWithoutEventPartsInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutEventPartsInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutEventPartsInput>;
};

export type EventCreateNestedOneWithoutExpensesTransitionsInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutExpensesTransitionsInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutExpensesTransitionsInput>;
};

export type EventCreateNestedOneWithoutHiddenEventInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutHiddenEventInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutHiddenEventInput>;
};

export type EventCreateNestedOneWithoutInviterCouponProfitsInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutInviterCouponProfitsInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutInviterCouponProfitsInput>;
};

export type EventCreateNestedOneWithoutPackageEventsInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutPackageEventsInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutPackageEventsInput>;
};

export type EventCreateNestedOneWithoutPricingPlanInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutPricingPlanInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutPricingPlanInput>;
};

export type EventCreateNestedOneWithoutQuizInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutQuizInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutQuizInput>;
};

export type EventCreateNestedOneWithoutQuizResultInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutQuizResultInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutQuizResultInput>;
};

export type EventCreateNestedOneWithoutTraineeEventGroupsInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutTraineeEventGroupsInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutTraineeEventGroupsInput>;
};

export type EventCreateNestedOneWithoutTraineeEventReviewsInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutTraineeEventReviewsInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutTraineeEventReviewsInput>;
};

export type EventCreateNestedOneWithoutTraineeEventsInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutTraineeEventsInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutTraineeEventsInput>;
};

export type EventCreateNestedOneWithoutTrainerEventStudyMaterialGroupsInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutTrainerEventStudyMaterialGroupsInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutTrainerEventStudyMaterialGroupsInput>;
};

export type EventCreateNestedOneWithoutTrainerEventStudyMaterialsInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutTrainerEventStudyMaterialsInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutTrainerEventStudyMaterialsInput>;
};

export type EventCreateNestedOneWithoutTrainerEventsInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutTrainerEventsInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutTrainerEventsInput>;
};

export type EventCreateNestedOneWithoutZohoEmailInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutZohoEmailInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutZohoEmailInput>;
};

export type EventCreateOrConnectWithoutAddedByInput = {
  create: EventUncheckedCreateWithoutAddedByInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutBlogsInput = {
  create: EventUncheckedCreateWithoutBlogsInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutCertificateInput = {
  create: EventUncheckedCreateWithoutCertificateInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutCityInput = {
  create: EventUncheckedCreateWithoutCityInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutCouponsInput = {
  create: EventUncheckedCreateWithoutCouponsInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutDiscussionInput = {
  create: EventUncheckedCreateWithoutDiscussionInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutEventDaysInput = {
  create: EventUncheckedCreateWithoutEventDaysInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutEventIdentityCardTemplateInput = {
  create: EventUncheckedCreateWithoutEventIdentityCardTemplateInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutEventLanguagesInput = {
  create: EventUncheckedCreateWithoutEventLanguagesInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutEventMediaTrackingInput = {
  create: EventUncheckedCreateWithoutEventMediaTrackingInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutEventPartsInput = {
  create: EventUncheckedCreateWithoutEventPartsInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutEventTypeInput = {
  create: EventUncheckedCreateWithoutEventTypeInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutExpensesTransitionsInput = {
  create: EventUncheckedCreateWithoutExpensesTransitionsInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutFolderInput = {
  create: EventUncheckedCreateWithoutFolderInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutHiddenEventInput = {
  create: EventUncheckedCreateWithoutHiddenEventInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutInviterCouponProfitsInput = {
  create: EventUncheckedCreateWithoutInviterCouponProfitsInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutLeaderTrainerInput = {
  create: EventUncheckedCreateWithoutLeaderTrainerInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutMethodOfDeliveryInput = {
  create: EventUncheckedCreateWithoutMethodOfDeliveryInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutPackageEventsInput = {
  create: EventUncheckedCreateWithoutPackageEventsInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutPackageInput = {
  create: EventUncheckedCreateWithoutPackageInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutPricingPlanInput = {
  create: EventUncheckedCreateWithoutPricingPlanInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutQuizInput = {
  create: EventUncheckedCreateWithoutQuizInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutQuizResultInput = {
  create: EventUncheckedCreateWithoutQuizResultInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutRemindMeTraineesInput = {
  create: EventUncheckedCreateWithoutRemindMeTraineesInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutTargetedAudiencesInput = {
  create: EventUncheckedCreateWithoutTargetedAudiencesInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutTargetedSpecialitiesInput = {
  create: EventUncheckedCreateWithoutTargetedSpecialitiesInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutTraineeCertificateTemplateInput = {
  create: EventUncheckedCreateWithoutTraineeCertificateTemplateInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutTraineeEventGroupsInput = {
  create: EventUncheckedCreateWithoutTraineeEventGroupsInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutTraineeEventReviewsInput = {
  create: EventUncheckedCreateWithoutTraineeEventReviewsInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutTraineeEventsInput = {
  create: EventUncheckedCreateWithoutTraineeEventsInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutTrainerCertificateTemplateInput = {
  create: EventUncheckedCreateWithoutTrainerCertificateTemplateInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutTrainerEventStudyMaterialGroupsInput = {
  create: EventUncheckedCreateWithoutTrainerEventStudyMaterialGroupsInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutTrainerEventStudyMaterialsInput = {
  create: EventUncheckedCreateWithoutTrainerEventStudyMaterialsInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutTrainerEventsInput = {
  create: EventUncheckedCreateWithoutTrainerEventsInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutVisitedTraineesInput = {
  create: EventUncheckedCreateWithoutVisitedTraineesInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutZohoEmailInput = {
  create: EventUncheckedCreateWithoutZohoEmailInput;
  where: EventWhereUniqueInput;
};

export type EventCreateOrConnectWithoutZoomMeetingInput = {
  create: EventUncheckedCreateWithoutZoomMeetingInput;
  where: EventWhereUniqueInput;
};

export type EventCreateWithoutAddedByInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutBlogsInput = {
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutCertificateInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutCityInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutCouponsInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutDiscussionInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutEventDaysInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutEventIdentityCardTemplateInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutEventLanguagesInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutEventMediaTrackingInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutEventPartsInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutEventTypeInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutExpensesTransitionsInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutFolderInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutHiddenEventInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutInviterCouponProfitsInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutLeaderTrainerInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutMethodOfDeliveryInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutPackageEventsInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutPackageInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutPricingPlanInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutQuizInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutQuizResultInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutRemindMeTraineesInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutTargetedAudiencesInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutTargetedSpecialitiesInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutTraineeCertificateTemplateInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutTraineeEventGroupsInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutTraineeEventReviewsInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutTraineeEventsInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutTrainerCertificateTemplateInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutTrainerEventStudyMaterialGroupsInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutTrainerEventStudyMaterialsInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutTrainerEventsInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutVisitedTraineesInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutZohoEmailInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingCreateNestedOneWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreateWithoutZoomMeetingInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutEventInput>;
  addedBy?: InputMaybe<UserCreateNestedOneWithoutAddedEventsInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityCreateNestedOneWithoutEventsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartCreateNestedManyWithoutEventInput>;
  eventType: EventTypeCreateNestedOneWithoutEventsInput;
  expensesTransitions?: InputMaybe<TransitionCreateNestedManyWithoutEventInput>;
  folder: EventFolderCreateNestedOneWithoutEventsInput;
  hiddenEvent?: InputMaybe<HiddenEventsCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserCreateNestedOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDelivery: MethodOfDeliveryCreateNestedOneWithoutEventsInput;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  package?: InputMaybe<EventCreateNestedOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventCreateNestedManyWithoutPackageInput>;
  pricingPlan: PricingPlanCreateNestedOneWithoutEventInput;
  remindMeTrainees?: InputMaybe<UserCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateCreateNestedOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventCreatebackgroundImagesUrlsInput = {
  set: Scalars['String'];
};

export type EventCreatekeywordsArInput = {
  set: Scalars['String'];
};

export type EventCreatekeywordsEnInput = {
  set: Scalars['String'];
};

export type EventDay = {
  __typename?: 'EventDay';
  _count?: Maybe<EventDayCountOutputType>;
  attendanceHours?: Maybe<Scalars['Decimal']>;
  brother?: Maybe<EventDay>;
  brotherId?: Maybe<Scalars['Int']>;
  cmeHours?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  endTime?: Maybe<Scalars['DateTime']>;
  event?: Maybe<Event>;
  eventId?: Maybe<Scalars['Int']>;
  eventPart?: Maybe<EventPart>;
  eventPartId?: Maybe<Scalars['Int']>;
  hasBrother?: Maybe<Scalars['Boolean']>;
  hasWorkshop?: Maybe<Scalars['Boolean']>;
  hidden?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  methodOfDelivery?: Maybe<MethodOfDelivery>;
  methodOfDeliveryId?: Maybe<Scalars['Int']>;
  outlineAr?: Maybe<Scalars['String']>;
  outlineEn?: Maybe<Scalars['String']>;
  siblings?: Maybe<Array<Maybe<EventDay>>>;
  startTime?: Maybe<Scalars['DateTime']>;
  traineeAttendance?: Maybe<Array<Maybe<TraineeEventDayAttendance>>>;
  trainerLessons?: Maybe<Array<Maybe<TrainerEventDayLesson>>>;
  trainerTimeSlots?: Maybe<Array<Maybe<TrainerEventDayTimeSlot>>>;
  zoomDuration?: Maybe<Scalars['Int']>;
  zoomMeetingUUID?: Maybe<Scalars['String']>;
  zoomMeetings?: Maybe<Array<Maybe<ZoomMeeting>>>;
};


export type EventDaySiblingsArgs = {
  cursor?: InputMaybe<EventDayWhereUniqueInput>;
  distinct?: InputMaybe<EventDayScalarFieldEnum>;
  orderBy?: InputMaybe<EventDayOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EventDayWhereInput>;
};


export type EventDayTraineeAttendanceArgs = {
  cursor?: InputMaybe<TraineeEventDayAttendanceWhereUniqueInput>;
  distinct?: InputMaybe<TraineeEventDayAttendanceScalarFieldEnum>;
  orderBy?: InputMaybe<TraineeEventDayAttendanceOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeEventDayAttendanceWhereInput>;
};


export type EventDayTrainerLessonsArgs = {
  cursor?: InputMaybe<TrainerEventDayLessonWhereUniqueInput>;
  distinct?: InputMaybe<TrainerEventDayLessonScalarFieldEnum>;
  orderBy?: InputMaybe<TrainerEventDayLessonOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TrainerEventDayLessonWhereInput>;
};


export type EventDayTrainerTimeSlotsArgs = {
  cursor?: InputMaybe<TrainerEventDayTimeSlotWhereUniqueInput>;
  distinct?: InputMaybe<TrainerEventDayTimeSlotScalarFieldEnum>;
  orderBy?: InputMaybe<TrainerEventDayTimeSlotOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TrainerEventDayTimeSlotWhereInput>;
};


export type EventDayZoomMeetingsArgs = {
  cursor?: InputMaybe<ZoomMeetingWhereUniqueInput>;
  distinct?: InputMaybe<ZoomMeetingScalarFieldEnum>;
  orderBy?: InputMaybe<ZoomMeetingOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ZoomMeetingWhereInput>;
};

export type EventDayAvgAggregateOutputType = {
  __typename?: 'EventDayAvgAggregateOutputType';
  attendanceHours?: Maybe<Scalars['Decimal']>;
  brotherId?: Maybe<Scalars['Float']>;
  cmeHours?: Maybe<Scalars['Decimal']>;
  eventId?: Maybe<Scalars['Float']>;
  eventPartId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  methodOfDeliveryId?: Maybe<Scalars['Float']>;
  zoomDuration?: Maybe<Scalars['Float']>;
};

export type EventDayAvgOrderByAggregateInput = {
  attendanceHours?: InputMaybe<SortOrder>;
  brotherId?: InputMaybe<SortOrder>;
  cmeHours?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  eventPartId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  methodOfDeliveryId?: InputMaybe<SortOrder>;
  zoomDuration?: InputMaybe<SortOrder>;
};

export type EventDayCountAggregateOutputType = {
  __typename?: 'EventDayCountAggregateOutputType';
  _all: Scalars['Int'];
  attendanceHours: Scalars['Int'];
  brotherId: Scalars['Int'];
  cmeHours: Scalars['Int'];
  createdAt: Scalars['Int'];
  date: Scalars['Int'];
  deletedAt: Scalars['Int'];
  endTime: Scalars['Int'];
  eventId: Scalars['Int'];
  eventPartId: Scalars['Int'];
  hasWorkshop: Scalars['Int'];
  hidden: Scalars['Int'];
  id: Scalars['Int'];
  methodOfDeliveryId: Scalars['Int'];
  outlineAr: Scalars['Int'];
  outlineEn: Scalars['Int'];
  startTime: Scalars['Int'];
  zoomDuration: Scalars['Int'];
  zoomMeetingUUID: Scalars['Int'];
};

export type EventDayCountOrderByAggregateInput = {
  attendanceHours?: InputMaybe<SortOrder>;
  brotherId?: InputMaybe<SortOrder>;
  cmeHours?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  eventPartId?: InputMaybe<SortOrder>;
  hasWorkshop?: InputMaybe<SortOrder>;
  hidden?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  methodOfDeliveryId?: InputMaybe<SortOrder>;
  outlineAr?: InputMaybe<SortOrder>;
  outlineEn?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  zoomDuration?: InputMaybe<SortOrder>;
  zoomMeetingUUID?: InputMaybe<SortOrder>;
};

export type EventDayCountOutputType = {
  __typename?: 'EventDayCountOutputType';
  TraineeEvent: Scalars['Int'];
  siblings: Scalars['Int'];
  traineeAttendance: Scalars['Int'];
  trainerLessons: Scalars['Int'];
  trainerTimeSlots: Scalars['Int'];
  zoomMeetings: Scalars['Int'];
};

export type EventDayCreateInput = {
  TraineeEvent?: InputMaybe<TraineeEventCreateNestedManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<Scalars['Decimal']>;
  brother?: InputMaybe<EventDayCreateNestedOneWithoutSiblingsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  event: EventCreateNestedOneWithoutEventDaysInput;
  eventPart?: InputMaybe<EventPartCreateNestedOneWithoutEventDaysInput>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryCreateNestedOneWithoutEventDayInput>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  siblings?: InputMaybe<EventDayCreateNestedManyWithoutBrotherInput>;
  startTime: Scalars['DateTime'];
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceCreateNestedManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonCreateNestedManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<Scalars['Int']>;
  zoomMeetingUUID?: InputMaybe<Scalars['String']>;
  zoomMeetings?: InputMaybe<ZoomMeetingCreateNestedManyWithoutEventDayInput>;
};

export type EventDayCreateManyBrotherInput = {
  attendanceHours?: InputMaybe<Scalars['Decimal']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventId: Scalars['Int'];
  eventPartId?: InputMaybe<Scalars['Int']>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  startTime: Scalars['DateTime'];
  zoomDuration?: InputMaybe<Scalars['Int']>;
  zoomMeetingUUID?: InputMaybe<Scalars['String']>;
};

export type EventDayCreateManyBrotherInputEnvelope = {
  data: EventDayCreateManyBrotherInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type EventDayCreateManyEventInput = {
  attendanceHours?: InputMaybe<Scalars['Decimal']>;
  brotherId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventPartId?: InputMaybe<Scalars['Int']>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  startTime: Scalars['DateTime'];
  zoomDuration?: InputMaybe<Scalars['Int']>;
  zoomMeetingUUID?: InputMaybe<Scalars['String']>;
};

export type EventDayCreateManyEventInputEnvelope = {
  data: EventDayCreateManyEventInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type EventDayCreateManyEventPartInput = {
  attendanceHours?: InputMaybe<Scalars['Decimal']>;
  brotherId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventId: Scalars['Int'];
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  startTime: Scalars['DateTime'];
  zoomDuration?: InputMaybe<Scalars['Int']>;
  zoomMeetingUUID?: InputMaybe<Scalars['String']>;
};

export type EventDayCreateManyEventPartInputEnvelope = {
  data: EventDayCreateManyEventPartInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type EventDayCreateManyInput = {
  attendanceHours?: InputMaybe<Scalars['Decimal']>;
  brotherId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventId: Scalars['Int'];
  eventPartId?: InputMaybe<Scalars['Int']>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  startTime: Scalars['DateTime'];
  zoomDuration?: InputMaybe<Scalars['Int']>;
  zoomMeetingUUID?: InputMaybe<Scalars['String']>;
};

export type EventDayCreateManyMethodOfDeliveryInput = {
  attendanceHours?: InputMaybe<Scalars['Decimal']>;
  brotherId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventId: Scalars['Int'];
  eventPartId?: InputMaybe<Scalars['Int']>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  startTime: Scalars['DateTime'];
  zoomDuration?: InputMaybe<Scalars['Int']>;
  zoomMeetingUUID?: InputMaybe<Scalars['String']>;
};

export type EventDayCreateManyMethodOfDeliveryInputEnvelope = {
  data: EventDayCreateManyMethodOfDeliveryInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type EventDayCreateNestedManyWithoutBrotherInput = {
  connect?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventDayCreateOrConnectWithoutBrotherInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventDayCreateWithoutBrotherInput>>>;
  createMany?: InputMaybe<EventDayCreateManyBrotherInputEnvelope>;
};

export type EventDayCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventDayCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventDayCreateWithoutEventInput>>>;
  createMany?: InputMaybe<EventDayCreateManyEventInputEnvelope>;
};

export type EventDayCreateNestedManyWithoutEventPartInput = {
  connect?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventDayCreateOrConnectWithoutEventPartInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventDayCreateWithoutEventPartInput>>>;
  createMany?: InputMaybe<EventDayCreateManyEventPartInputEnvelope>;
};

export type EventDayCreateNestedManyWithoutMethodOfDeliveryInput = {
  connect?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventDayCreateOrConnectWithoutMethodOfDeliveryInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventDayCreateWithoutMethodOfDeliveryInput>>>;
  createMany?: InputMaybe<EventDayCreateManyMethodOfDeliveryInputEnvelope>;
};

export type EventDayCreateNestedOneWithoutSiblingsInput = {
  connect?: InputMaybe<EventDayWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventDayCreateOrConnectWithoutSiblingsInput>;
  create?: InputMaybe<EventDayUncheckedCreateWithoutSiblingsInput>;
};

export type EventDayCreateNestedOneWithoutTraineeAttendanceInput = {
  connect?: InputMaybe<EventDayWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventDayCreateOrConnectWithoutTraineeAttendanceInput>;
  create?: InputMaybe<EventDayUncheckedCreateWithoutTraineeAttendanceInput>;
};

export type EventDayCreateNestedOneWithoutTraineeEventInput = {
  connect?: InputMaybe<EventDayWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventDayCreateOrConnectWithoutTraineeEventInput>;
  create?: InputMaybe<EventDayUncheckedCreateWithoutTraineeEventInput>;
};

export type EventDayCreateNestedOneWithoutTrainerLessonsInput = {
  connect?: InputMaybe<EventDayWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventDayCreateOrConnectWithoutTrainerLessonsInput>;
  create?: InputMaybe<EventDayUncheckedCreateWithoutTrainerLessonsInput>;
};

export type EventDayCreateNestedOneWithoutTrainerTimeSlotsInput = {
  connect?: InputMaybe<EventDayWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventDayCreateOrConnectWithoutTrainerTimeSlotsInput>;
  create?: InputMaybe<EventDayUncheckedCreateWithoutTrainerTimeSlotsInput>;
};

export type EventDayCreateNestedOneWithoutZoomMeetingsInput = {
  connect?: InputMaybe<EventDayWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventDayCreateOrConnectWithoutZoomMeetingsInput>;
  create?: InputMaybe<EventDayUncheckedCreateWithoutZoomMeetingsInput>;
};

export type EventDayCreateOrConnectWithoutBrotherInput = {
  create: EventDayUncheckedCreateWithoutBrotherInput;
  where: EventDayWhereUniqueInput;
};

export type EventDayCreateOrConnectWithoutEventInput = {
  create: EventDayUncheckedCreateWithoutEventInput;
  where: EventDayWhereUniqueInput;
};

export type EventDayCreateOrConnectWithoutEventPartInput = {
  create: EventDayUncheckedCreateWithoutEventPartInput;
  where: EventDayWhereUniqueInput;
};

export type EventDayCreateOrConnectWithoutMethodOfDeliveryInput = {
  create: EventDayUncheckedCreateWithoutMethodOfDeliveryInput;
  where: EventDayWhereUniqueInput;
};

export type EventDayCreateOrConnectWithoutSiblingsInput = {
  create: EventDayUncheckedCreateWithoutSiblingsInput;
  where: EventDayWhereUniqueInput;
};

export type EventDayCreateOrConnectWithoutTraineeAttendanceInput = {
  create: EventDayUncheckedCreateWithoutTraineeAttendanceInput;
  where: EventDayWhereUniqueInput;
};

export type EventDayCreateOrConnectWithoutTraineeEventInput = {
  create: EventDayUncheckedCreateWithoutTraineeEventInput;
  where: EventDayWhereUniqueInput;
};

export type EventDayCreateOrConnectWithoutTrainerLessonsInput = {
  create: EventDayUncheckedCreateWithoutTrainerLessonsInput;
  where: EventDayWhereUniqueInput;
};

export type EventDayCreateOrConnectWithoutTrainerTimeSlotsInput = {
  create: EventDayUncheckedCreateWithoutTrainerTimeSlotsInput;
  where: EventDayWhereUniqueInput;
};

export type EventDayCreateOrConnectWithoutZoomMeetingsInput = {
  create: EventDayUncheckedCreateWithoutZoomMeetingsInput;
  where: EventDayWhereUniqueInput;
};

export type EventDayCreateWithoutBrotherInput = {
  TraineeEvent?: InputMaybe<TraineeEventCreateNestedManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<Scalars['Decimal']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  event: EventCreateNestedOneWithoutEventDaysInput;
  eventPart?: InputMaybe<EventPartCreateNestedOneWithoutEventDaysInput>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryCreateNestedOneWithoutEventDayInput>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  siblings?: InputMaybe<EventDayCreateNestedManyWithoutBrotherInput>;
  startTime: Scalars['DateTime'];
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceCreateNestedManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonCreateNestedManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<Scalars['Int']>;
  zoomMeetingUUID?: InputMaybe<Scalars['String']>;
  zoomMeetings?: InputMaybe<ZoomMeetingCreateNestedManyWithoutEventDayInput>;
};

export type EventDayCreateWithoutEventInput = {
  TraineeEvent?: InputMaybe<TraineeEventCreateNestedManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<Scalars['Decimal']>;
  brother?: InputMaybe<EventDayCreateNestedOneWithoutSiblingsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventPart?: InputMaybe<EventPartCreateNestedOneWithoutEventDaysInput>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryCreateNestedOneWithoutEventDayInput>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  siblings?: InputMaybe<EventDayCreateNestedManyWithoutBrotherInput>;
  startTime: Scalars['DateTime'];
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceCreateNestedManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonCreateNestedManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<Scalars['Int']>;
  zoomMeetingUUID?: InputMaybe<Scalars['String']>;
  zoomMeetings?: InputMaybe<ZoomMeetingCreateNestedManyWithoutEventDayInput>;
};

export type EventDayCreateWithoutEventPartInput = {
  TraineeEvent?: InputMaybe<TraineeEventCreateNestedManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<Scalars['Decimal']>;
  brother?: InputMaybe<EventDayCreateNestedOneWithoutSiblingsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  event: EventCreateNestedOneWithoutEventDaysInput;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryCreateNestedOneWithoutEventDayInput>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  siblings?: InputMaybe<EventDayCreateNestedManyWithoutBrotherInput>;
  startTime: Scalars['DateTime'];
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceCreateNestedManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonCreateNestedManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<Scalars['Int']>;
  zoomMeetingUUID?: InputMaybe<Scalars['String']>;
  zoomMeetings?: InputMaybe<ZoomMeetingCreateNestedManyWithoutEventDayInput>;
};

export type EventDayCreateWithoutMethodOfDeliveryInput = {
  TraineeEvent?: InputMaybe<TraineeEventCreateNestedManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<Scalars['Decimal']>;
  brother?: InputMaybe<EventDayCreateNestedOneWithoutSiblingsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  event: EventCreateNestedOneWithoutEventDaysInput;
  eventPart?: InputMaybe<EventPartCreateNestedOneWithoutEventDaysInput>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  siblings?: InputMaybe<EventDayCreateNestedManyWithoutBrotherInput>;
  startTime: Scalars['DateTime'];
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceCreateNestedManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonCreateNestedManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<Scalars['Int']>;
  zoomMeetingUUID?: InputMaybe<Scalars['String']>;
  zoomMeetings?: InputMaybe<ZoomMeetingCreateNestedManyWithoutEventDayInput>;
};

export type EventDayCreateWithoutSiblingsInput = {
  TraineeEvent?: InputMaybe<TraineeEventCreateNestedManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<Scalars['Decimal']>;
  brother?: InputMaybe<EventDayCreateNestedOneWithoutSiblingsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  event: EventCreateNestedOneWithoutEventDaysInput;
  eventPart?: InputMaybe<EventPartCreateNestedOneWithoutEventDaysInput>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryCreateNestedOneWithoutEventDayInput>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  startTime: Scalars['DateTime'];
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceCreateNestedManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonCreateNestedManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<Scalars['Int']>;
  zoomMeetingUUID?: InputMaybe<Scalars['String']>;
  zoomMeetings?: InputMaybe<ZoomMeetingCreateNestedManyWithoutEventDayInput>;
};

export type EventDayCreateWithoutTraineeAttendanceInput = {
  TraineeEvent?: InputMaybe<TraineeEventCreateNestedManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<Scalars['Decimal']>;
  brother?: InputMaybe<EventDayCreateNestedOneWithoutSiblingsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  event: EventCreateNestedOneWithoutEventDaysInput;
  eventPart?: InputMaybe<EventPartCreateNestedOneWithoutEventDaysInput>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryCreateNestedOneWithoutEventDayInput>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  siblings?: InputMaybe<EventDayCreateNestedManyWithoutBrotherInput>;
  startTime: Scalars['DateTime'];
  trainerLessons?: InputMaybe<TrainerEventDayLessonCreateNestedManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<Scalars['Int']>;
  zoomMeetingUUID?: InputMaybe<Scalars['String']>;
  zoomMeetings?: InputMaybe<ZoomMeetingCreateNestedManyWithoutEventDayInput>;
};

export type EventDayCreateWithoutTraineeEventInput = {
  attendanceHours?: InputMaybe<Scalars['Decimal']>;
  brother?: InputMaybe<EventDayCreateNestedOneWithoutSiblingsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  event: EventCreateNestedOneWithoutEventDaysInput;
  eventPart?: InputMaybe<EventPartCreateNestedOneWithoutEventDaysInput>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryCreateNestedOneWithoutEventDayInput>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  siblings?: InputMaybe<EventDayCreateNestedManyWithoutBrotherInput>;
  startTime: Scalars['DateTime'];
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceCreateNestedManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonCreateNestedManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<Scalars['Int']>;
  zoomMeetingUUID?: InputMaybe<Scalars['String']>;
  zoomMeetings?: InputMaybe<ZoomMeetingCreateNestedManyWithoutEventDayInput>;
};

export type EventDayCreateWithoutTrainerLessonsInput = {
  TraineeEvent?: InputMaybe<TraineeEventCreateNestedManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<Scalars['Decimal']>;
  brother?: InputMaybe<EventDayCreateNestedOneWithoutSiblingsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  event: EventCreateNestedOneWithoutEventDaysInput;
  eventPart?: InputMaybe<EventPartCreateNestedOneWithoutEventDaysInput>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryCreateNestedOneWithoutEventDayInput>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  siblings?: InputMaybe<EventDayCreateNestedManyWithoutBrotherInput>;
  startTime: Scalars['DateTime'];
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceCreateNestedManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<Scalars['Int']>;
  zoomMeetingUUID?: InputMaybe<Scalars['String']>;
  zoomMeetings?: InputMaybe<ZoomMeetingCreateNestedManyWithoutEventDayInput>;
};

export type EventDayCreateWithoutTrainerTimeSlotsInput = {
  TraineeEvent?: InputMaybe<TraineeEventCreateNestedManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<Scalars['Decimal']>;
  brother?: InputMaybe<EventDayCreateNestedOneWithoutSiblingsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  event: EventCreateNestedOneWithoutEventDaysInput;
  eventPart?: InputMaybe<EventPartCreateNestedOneWithoutEventDaysInput>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryCreateNestedOneWithoutEventDayInput>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  siblings?: InputMaybe<EventDayCreateNestedManyWithoutBrotherInput>;
  startTime: Scalars['DateTime'];
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceCreateNestedManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonCreateNestedManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<Scalars['Int']>;
  zoomMeetingUUID?: InputMaybe<Scalars['String']>;
  zoomMeetings?: InputMaybe<ZoomMeetingCreateNestedManyWithoutEventDayInput>;
};

export type EventDayCreateWithoutZoomMeetingsInput = {
  TraineeEvent?: InputMaybe<TraineeEventCreateNestedManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<Scalars['Decimal']>;
  brother?: InputMaybe<EventDayCreateNestedOneWithoutSiblingsInput>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  event: EventCreateNestedOneWithoutEventDaysInput;
  eventPart?: InputMaybe<EventPartCreateNestedOneWithoutEventDaysInput>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryCreateNestedOneWithoutEventDayInput>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  siblings?: InputMaybe<EventDayCreateNestedManyWithoutBrotherInput>;
  startTime: Scalars['DateTime'];
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceCreateNestedManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonCreateNestedManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<Scalars['Int']>;
  zoomMeetingUUID?: InputMaybe<Scalars['String']>;
};

export type EventDayListRelationFilter = {
  every?: InputMaybe<EventDayWhereInput>;
  none?: InputMaybe<EventDayWhereInput>;
  some?: InputMaybe<EventDayWhereInput>;
};

export type EventDayMaxAggregateOutputType = {
  __typename?: 'EventDayMaxAggregateOutputType';
  attendanceHours?: Maybe<Scalars['Decimal']>;
  brotherId?: Maybe<Scalars['Int']>;
  cmeHours?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  endTime?: Maybe<Scalars['DateTime']>;
  eventId?: Maybe<Scalars['Int']>;
  eventPartId?: Maybe<Scalars['Int']>;
  hasWorkshop?: Maybe<Scalars['Boolean']>;
  hidden?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  methodOfDeliveryId?: Maybe<Scalars['Int']>;
  outlineAr?: Maybe<Scalars['String']>;
  outlineEn?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['DateTime']>;
  zoomDuration?: Maybe<Scalars['Int']>;
  zoomMeetingUUID?: Maybe<Scalars['String']>;
};

export type EventDayMaxOrderByAggregateInput = {
  attendanceHours?: InputMaybe<SortOrder>;
  brotherId?: InputMaybe<SortOrder>;
  cmeHours?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  eventPartId?: InputMaybe<SortOrder>;
  hasWorkshop?: InputMaybe<SortOrder>;
  hidden?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  methodOfDeliveryId?: InputMaybe<SortOrder>;
  outlineAr?: InputMaybe<SortOrder>;
  outlineEn?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  zoomDuration?: InputMaybe<SortOrder>;
  zoomMeetingUUID?: InputMaybe<SortOrder>;
};

export type EventDayMinAggregateOutputType = {
  __typename?: 'EventDayMinAggregateOutputType';
  attendanceHours?: Maybe<Scalars['Decimal']>;
  brotherId?: Maybe<Scalars['Int']>;
  cmeHours?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  endTime?: Maybe<Scalars['DateTime']>;
  eventId?: Maybe<Scalars['Int']>;
  eventPartId?: Maybe<Scalars['Int']>;
  hasWorkshop?: Maybe<Scalars['Boolean']>;
  hidden?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  methodOfDeliveryId?: Maybe<Scalars['Int']>;
  outlineAr?: Maybe<Scalars['String']>;
  outlineEn?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['DateTime']>;
  zoomDuration?: Maybe<Scalars['Int']>;
  zoomMeetingUUID?: Maybe<Scalars['String']>;
};

export type EventDayMinOrderByAggregateInput = {
  attendanceHours?: InputMaybe<SortOrder>;
  brotherId?: InputMaybe<SortOrder>;
  cmeHours?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  eventPartId?: InputMaybe<SortOrder>;
  hasWorkshop?: InputMaybe<SortOrder>;
  hidden?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  methodOfDeliveryId?: InputMaybe<SortOrder>;
  outlineAr?: InputMaybe<SortOrder>;
  outlineEn?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  zoomDuration?: InputMaybe<SortOrder>;
  zoomMeetingUUID?: InputMaybe<SortOrder>;
};

export type EventDayOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type EventDayOrderByWithAggregationInput = {
  _avg?: InputMaybe<EventDayAvgOrderByAggregateInput>;
  _count?: InputMaybe<EventDayCountOrderByAggregateInput>;
  _max?: InputMaybe<EventDayMaxOrderByAggregateInput>;
  _min?: InputMaybe<EventDayMinOrderByAggregateInput>;
  _sum?: InputMaybe<EventDaySumOrderByAggregateInput>;
  attendanceHours?: InputMaybe<SortOrder>;
  brotherId?: InputMaybe<SortOrder>;
  cmeHours?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  eventPartId?: InputMaybe<SortOrder>;
  hasWorkshop?: InputMaybe<SortOrder>;
  hidden?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  methodOfDeliveryId?: InputMaybe<SortOrder>;
  outlineAr?: InputMaybe<SortOrder>;
  outlineEn?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  zoomDuration?: InputMaybe<SortOrder>;
  zoomMeetingUUID?: InputMaybe<SortOrder>;
};

export type EventDayOrderByWithRelationInput = {
  TraineeEvent?: InputMaybe<TraineeEventOrderByRelationAggregateInput>;
  attendanceHours?: InputMaybe<SortOrder>;
  brother?: InputMaybe<EventDayOrderByWithRelationInput>;
  brotherId?: InputMaybe<SortOrder>;
  cmeHours?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  event?: InputMaybe<EventOrderByWithRelationInput>;
  eventId?: InputMaybe<SortOrder>;
  eventPart?: InputMaybe<EventPartOrderByWithRelationInput>;
  eventPartId?: InputMaybe<SortOrder>;
  hasWorkshop?: InputMaybe<SortOrder>;
  hidden?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryOrderByWithRelationInput>;
  methodOfDeliveryId?: InputMaybe<SortOrder>;
  outlineAr?: InputMaybe<SortOrder>;
  outlineEn?: InputMaybe<SortOrder>;
  siblings?: InputMaybe<EventDayOrderByRelationAggregateInput>;
  startTime?: InputMaybe<SortOrder>;
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceOrderByRelationAggregateInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonOrderByRelationAggregateInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotOrderByRelationAggregateInput>;
  zoomDuration?: InputMaybe<SortOrder>;
  zoomMeetingUUID?: InputMaybe<SortOrder>;
  zoomMeetings?: InputMaybe<ZoomMeetingOrderByRelationAggregateInput>;
};

export type EventDayRelationFilter = {
  is?: InputMaybe<EventDayWhereInput>;
  isNot?: InputMaybe<EventDayWhereInput>;
};

export enum EventDayScalarFieldEnum {
  AttendanceHours = 'attendanceHours',
  BrotherId = 'brotherId',
  CmeHours = 'cmeHours',
  CreatedAt = 'createdAt',
  Date = 'date',
  DeletedAt = 'deletedAt',
  EndTime = 'endTime',
  EventId = 'eventId',
  EventPartId = 'eventPartId',
  HasWorkshop = 'hasWorkshop',
  Hidden = 'hidden',
  Id = 'id',
  MethodOfDeliveryId = 'methodOfDeliveryId',
  OutlineAr = 'outlineAr',
  OutlineEn = 'outlineEn',
  StartTime = 'startTime',
  ZoomDuration = 'zoomDuration',
  ZoomMeetingUuid = 'zoomMeetingUUID'
}

export type EventDayScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<EventDayScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<EventDayScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<EventDayScalarWhereInput>>>;
  attendanceHours?: InputMaybe<DecimalNullableFilter>;
  brotherId?: InputMaybe<IntNullableFilter>;
  cmeHours?: InputMaybe<DecimalNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  date?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  endTime?: InputMaybe<DateTimeFilter>;
  eventId?: InputMaybe<IntFilter>;
  eventPartId?: InputMaybe<IntNullableFilter>;
  hasWorkshop?: InputMaybe<BoolNullableFilter>;
  hidden?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<IntFilter>;
  methodOfDeliveryId?: InputMaybe<IntNullableFilter>;
  outlineAr?: InputMaybe<StringFilter>;
  outlineEn?: InputMaybe<StringFilter>;
  startTime?: InputMaybe<DateTimeFilter>;
  zoomDuration?: InputMaybe<IntNullableFilter>;
  zoomMeetingUUID?: InputMaybe<StringNullableFilter>;
};

export type EventDayScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<EventDayScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<EventDayScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<EventDayScalarWhereWithAggregatesInput>>>;
  attendanceHours?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  brotherId?: InputMaybe<IntNullableWithAggregatesFilter>;
  cmeHours?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  date?: InputMaybe<DateTimeWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  endTime?: InputMaybe<DateTimeWithAggregatesFilter>;
  eventId?: InputMaybe<IntWithAggregatesFilter>;
  eventPartId?: InputMaybe<IntNullableWithAggregatesFilter>;
  hasWorkshop?: InputMaybe<BoolNullableWithAggregatesFilter>;
  hidden?: InputMaybe<BoolNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  methodOfDeliveryId?: InputMaybe<IntNullableWithAggregatesFilter>;
  outlineAr?: InputMaybe<StringWithAggregatesFilter>;
  outlineEn?: InputMaybe<StringWithAggregatesFilter>;
  startTime?: InputMaybe<DateTimeWithAggregatesFilter>;
  zoomDuration?: InputMaybe<IntNullableWithAggregatesFilter>;
  zoomMeetingUUID?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type EventDaySumAggregateOutputType = {
  __typename?: 'EventDaySumAggregateOutputType';
  attendanceHours?: Maybe<Scalars['Decimal']>;
  brotherId?: Maybe<Scalars['Int']>;
  cmeHours?: Maybe<Scalars['Decimal']>;
  eventId?: Maybe<Scalars['Int']>;
  eventPartId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  methodOfDeliveryId?: Maybe<Scalars['Int']>;
  zoomDuration?: Maybe<Scalars['Int']>;
};

export type EventDaySumOrderByAggregateInput = {
  attendanceHours?: InputMaybe<SortOrder>;
  brotherId?: InputMaybe<SortOrder>;
  cmeHours?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  eventPartId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  methodOfDeliveryId?: InputMaybe<SortOrder>;
  zoomDuration?: InputMaybe<SortOrder>;
};

export type EventDayUncheckedCreateInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<Scalars['Decimal']>;
  brotherId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventId: Scalars['Int'];
  eventPartId?: InputMaybe<Scalars['Int']>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  siblings?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutBrotherInput>;
  startTime: Scalars['DateTime'];
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceUncheckedCreateNestedManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonUncheckedCreateNestedManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<Scalars['Int']>;
  zoomMeetingUUID?: InputMaybe<Scalars['String']>;
  zoomMeetings?: InputMaybe<ZoomMeetingUncheckedCreateNestedManyWithoutEventDayInput>;
};

export type EventDayUncheckedCreateNestedManyWithoutBrotherInput = {
  connect?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventDayCreateOrConnectWithoutBrotherInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventDayCreateWithoutBrotherInput>>>;
  createMany?: InputMaybe<EventDayCreateManyBrotherInputEnvelope>;
};

export type EventDayUncheckedCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventDayCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventDayCreateWithoutEventInput>>>;
  createMany?: InputMaybe<EventDayCreateManyEventInputEnvelope>;
};

export type EventDayUncheckedCreateNestedManyWithoutEventPartInput = {
  connect?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventDayCreateOrConnectWithoutEventPartInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventDayCreateWithoutEventPartInput>>>;
  createMany?: InputMaybe<EventDayCreateManyEventPartInputEnvelope>;
};

export type EventDayUncheckedCreateNestedManyWithoutMethodOfDeliveryInput = {
  connect?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventDayCreateOrConnectWithoutMethodOfDeliveryInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventDayCreateWithoutMethodOfDeliveryInput>>>;
  createMany?: InputMaybe<EventDayCreateManyMethodOfDeliveryInputEnvelope>;
};

export type EventDayUncheckedCreateWithoutBrotherInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<Scalars['Decimal']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventId: Scalars['Int'];
  eventPartId?: InputMaybe<Scalars['Int']>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  siblings?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutBrotherInput>;
  startTime: Scalars['DateTime'];
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceUncheckedCreateNestedManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonUncheckedCreateNestedManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<Scalars['Int']>;
  zoomMeetingUUID?: InputMaybe<Scalars['String']>;
  zoomMeetings?: InputMaybe<ZoomMeetingUncheckedCreateNestedManyWithoutEventDayInput>;
};

export type EventDayUncheckedCreateWithoutEventInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<Scalars['Decimal']>;
  brotherId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventPartId?: InputMaybe<Scalars['Int']>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  siblings?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutBrotherInput>;
  startTime: Scalars['DateTime'];
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceUncheckedCreateNestedManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonUncheckedCreateNestedManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<Scalars['Int']>;
  zoomMeetingUUID?: InputMaybe<Scalars['String']>;
  zoomMeetings?: InputMaybe<ZoomMeetingUncheckedCreateNestedManyWithoutEventDayInput>;
};

export type EventDayUncheckedCreateWithoutEventPartInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<Scalars['Decimal']>;
  brotherId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventId: Scalars['Int'];
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  siblings?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutBrotherInput>;
  startTime: Scalars['DateTime'];
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceUncheckedCreateNestedManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonUncheckedCreateNestedManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<Scalars['Int']>;
  zoomMeetingUUID?: InputMaybe<Scalars['String']>;
  zoomMeetings?: InputMaybe<ZoomMeetingUncheckedCreateNestedManyWithoutEventDayInput>;
};

export type EventDayUncheckedCreateWithoutMethodOfDeliveryInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<Scalars['Decimal']>;
  brotherId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventId: Scalars['Int'];
  eventPartId?: InputMaybe<Scalars['Int']>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  siblings?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutBrotherInput>;
  startTime: Scalars['DateTime'];
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceUncheckedCreateNestedManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonUncheckedCreateNestedManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<Scalars['Int']>;
  zoomMeetingUUID?: InputMaybe<Scalars['String']>;
  zoomMeetings?: InputMaybe<ZoomMeetingUncheckedCreateNestedManyWithoutEventDayInput>;
};

export type EventDayUncheckedCreateWithoutSiblingsInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<Scalars['Decimal']>;
  brotherId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventId: Scalars['Int'];
  eventPartId?: InputMaybe<Scalars['Int']>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  startTime: Scalars['DateTime'];
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceUncheckedCreateNestedManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonUncheckedCreateNestedManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<Scalars['Int']>;
  zoomMeetingUUID?: InputMaybe<Scalars['String']>;
  zoomMeetings?: InputMaybe<ZoomMeetingUncheckedCreateNestedManyWithoutEventDayInput>;
};

export type EventDayUncheckedCreateWithoutTraineeAttendanceInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<Scalars['Decimal']>;
  brotherId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventId: Scalars['Int'];
  eventPartId?: InputMaybe<Scalars['Int']>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  siblings?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutBrotherInput>;
  startTime: Scalars['DateTime'];
  trainerLessons?: InputMaybe<TrainerEventDayLessonUncheckedCreateNestedManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<Scalars['Int']>;
  zoomMeetingUUID?: InputMaybe<Scalars['String']>;
  zoomMeetings?: InputMaybe<ZoomMeetingUncheckedCreateNestedManyWithoutEventDayInput>;
};

export type EventDayUncheckedCreateWithoutTraineeEventInput = {
  attendanceHours?: InputMaybe<Scalars['Decimal']>;
  brotherId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventId: Scalars['Int'];
  eventPartId?: InputMaybe<Scalars['Int']>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  siblings?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutBrotherInput>;
  startTime: Scalars['DateTime'];
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceUncheckedCreateNestedManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonUncheckedCreateNestedManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<Scalars['Int']>;
  zoomMeetingUUID?: InputMaybe<Scalars['String']>;
  zoomMeetings?: InputMaybe<ZoomMeetingUncheckedCreateNestedManyWithoutEventDayInput>;
};

export type EventDayUncheckedCreateWithoutTrainerLessonsInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<Scalars['Decimal']>;
  brotherId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventId: Scalars['Int'];
  eventPartId?: InputMaybe<Scalars['Int']>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  siblings?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutBrotherInput>;
  startTime: Scalars['DateTime'];
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceUncheckedCreateNestedManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<Scalars['Int']>;
  zoomMeetingUUID?: InputMaybe<Scalars['String']>;
  zoomMeetings?: InputMaybe<ZoomMeetingUncheckedCreateNestedManyWithoutEventDayInput>;
};

export type EventDayUncheckedCreateWithoutTrainerTimeSlotsInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<Scalars['Decimal']>;
  brotherId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventId: Scalars['Int'];
  eventPartId?: InputMaybe<Scalars['Int']>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  siblings?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutBrotherInput>;
  startTime: Scalars['DateTime'];
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceUncheckedCreateNestedManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonUncheckedCreateNestedManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<Scalars['Int']>;
  zoomMeetingUUID?: InputMaybe<Scalars['String']>;
  zoomMeetings?: InputMaybe<ZoomMeetingUncheckedCreateNestedManyWithoutEventDayInput>;
};

export type EventDayUncheckedCreateWithoutZoomMeetingsInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<Scalars['Decimal']>;
  brotherId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventId: Scalars['Int'];
  eventPartId?: InputMaybe<Scalars['Int']>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  siblings?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutBrotherInput>;
  startTime: Scalars['DateTime'];
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceUncheckedCreateNestedManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonUncheckedCreateNestedManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<Scalars['Int']>;
  zoomMeetingUUID?: InputMaybe<Scalars['String']>;
};

export type EventDayUncheckedUpdateInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  brotherId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  eventPartId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hidden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  siblings?: InputMaybe<EventDayUncheckedUpdateManyWithoutBrotherInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceUncheckedUpdateManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonUncheckedUpdateManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMeetingUUID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetings?: InputMaybe<ZoomMeetingUncheckedUpdateManyWithoutEventDayInput>;
};

export type EventDayUncheckedUpdateManyInput = {
  attendanceHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  brotherId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  eventPartId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hidden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  zoomDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMeetingUUID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventDayUncheckedUpdateManyWithoutBrotherInput = {
  connect?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventDayCreateOrConnectWithoutBrotherInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventDayCreateWithoutBrotherInput>>>;
  createMany?: InputMaybe<EventDayCreateManyBrotherInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventDayScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventDayUpdateWithWhereUniqueWithoutBrotherInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventDayUpdateManyWithWhereWithoutBrotherInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventDayUpsertWithWhereUniqueWithoutBrotherInput>>>;
};

export type EventDayUncheckedUpdateManyWithoutEventDayInput = {
  attendanceHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  brotherId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  eventPartId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hidden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  zoomDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMeetingUUID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventDayUncheckedUpdateManyWithoutEventDaysInput = {
  attendanceHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  brotherId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventPartId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hidden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  zoomDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMeetingUUID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventDayUncheckedUpdateManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventDayCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventDayCreateWithoutEventInput>>>;
  createMany?: InputMaybe<EventDayCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventDayScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventDayUpdateWithWhereUniqueWithoutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventDayUpdateManyWithWhereWithoutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventDayUpsertWithWhereUniqueWithoutEventInput>>>;
};

export type EventDayUncheckedUpdateManyWithoutEventPartInput = {
  connect?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventDayCreateOrConnectWithoutEventPartInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventDayCreateWithoutEventPartInput>>>;
  createMany?: InputMaybe<EventDayCreateManyEventPartInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventDayScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventDayUpdateWithWhereUniqueWithoutEventPartInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventDayUpdateManyWithWhereWithoutEventPartInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventDayUpsertWithWhereUniqueWithoutEventPartInput>>>;
};

export type EventDayUncheckedUpdateManyWithoutMethodOfDeliveryInput = {
  connect?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventDayCreateOrConnectWithoutMethodOfDeliveryInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventDayCreateWithoutMethodOfDeliveryInput>>>;
  createMany?: InputMaybe<EventDayCreateManyMethodOfDeliveryInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventDayScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventDayUpdateWithWhereUniqueWithoutMethodOfDeliveryInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventDayUpdateManyWithWhereWithoutMethodOfDeliveryInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventDayUpsertWithWhereUniqueWithoutMethodOfDeliveryInput>>>;
};

export type EventDayUncheckedUpdateManyWithoutSiblingsInput = {
  attendanceHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  eventPartId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hidden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  zoomDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMeetingUUID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventDayUncheckedUpdateWithoutBrotherInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  eventPartId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hidden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  siblings?: InputMaybe<EventDayUncheckedUpdateManyWithoutBrotherInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceUncheckedUpdateManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonUncheckedUpdateManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMeetingUUID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetings?: InputMaybe<ZoomMeetingUncheckedUpdateManyWithoutEventDayInput>;
};

export type EventDayUncheckedUpdateWithoutEventInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  brotherId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventPartId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hidden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  siblings?: InputMaybe<EventDayUncheckedUpdateManyWithoutBrotherInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceUncheckedUpdateManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonUncheckedUpdateManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMeetingUUID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetings?: InputMaybe<ZoomMeetingUncheckedUpdateManyWithoutEventDayInput>;
};

export type EventDayUncheckedUpdateWithoutEventPartInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  brotherId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hidden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  siblings?: InputMaybe<EventDayUncheckedUpdateManyWithoutBrotherInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceUncheckedUpdateManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonUncheckedUpdateManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMeetingUUID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetings?: InputMaybe<ZoomMeetingUncheckedUpdateManyWithoutEventDayInput>;
};

export type EventDayUncheckedUpdateWithoutMethodOfDeliveryInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  brotherId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  eventPartId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hidden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  siblings?: InputMaybe<EventDayUncheckedUpdateManyWithoutBrotherInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceUncheckedUpdateManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonUncheckedUpdateManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMeetingUUID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetings?: InputMaybe<ZoomMeetingUncheckedUpdateManyWithoutEventDayInput>;
};

export type EventDayUncheckedUpdateWithoutSiblingsInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  brotherId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  eventPartId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hidden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceUncheckedUpdateManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonUncheckedUpdateManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMeetingUUID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetings?: InputMaybe<ZoomMeetingUncheckedUpdateManyWithoutEventDayInput>;
};

export type EventDayUncheckedUpdateWithoutTraineeAttendanceInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  brotherId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  eventPartId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hidden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  siblings?: InputMaybe<EventDayUncheckedUpdateManyWithoutBrotherInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonUncheckedUpdateManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMeetingUUID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetings?: InputMaybe<ZoomMeetingUncheckedUpdateManyWithoutEventDayInput>;
};

export type EventDayUncheckedUpdateWithoutTraineeEventInput = {
  attendanceHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  brotherId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  eventPartId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hidden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  siblings?: InputMaybe<EventDayUncheckedUpdateManyWithoutBrotherInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceUncheckedUpdateManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonUncheckedUpdateManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMeetingUUID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetings?: InputMaybe<ZoomMeetingUncheckedUpdateManyWithoutEventDayInput>;
};

export type EventDayUncheckedUpdateWithoutTrainerLessonsInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  brotherId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  eventPartId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hidden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  siblings?: InputMaybe<EventDayUncheckedUpdateManyWithoutBrotherInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceUncheckedUpdateManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMeetingUUID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetings?: InputMaybe<ZoomMeetingUncheckedUpdateManyWithoutEventDayInput>;
};

export type EventDayUncheckedUpdateWithoutTrainerTimeSlotsInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  brotherId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  eventPartId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hidden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  siblings?: InputMaybe<EventDayUncheckedUpdateManyWithoutBrotherInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceUncheckedUpdateManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonUncheckedUpdateManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMeetingUUID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetings?: InputMaybe<ZoomMeetingUncheckedUpdateManyWithoutEventDayInput>;
};

export type EventDayUncheckedUpdateWithoutZoomMeetingsInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  brotherId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  eventPartId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hidden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  siblings?: InputMaybe<EventDayUncheckedUpdateManyWithoutBrotherInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceUncheckedUpdateManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonUncheckedUpdateManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMeetingUUID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventDayUpdateInput = {
  TraineeEvent?: InputMaybe<TraineeEventUpdateManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  brother?: InputMaybe<EventDayUpdateOneWithoutSiblingsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutEventDaysInput>;
  eventPart?: InputMaybe<EventPartUpdateOneWithoutEventDaysInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hidden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneWithoutEventDayInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  siblings?: InputMaybe<EventDayUpdateManyWithoutBrotherInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceUpdateManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonUpdateManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMeetingUUID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetings?: InputMaybe<ZoomMeetingUpdateManyWithoutEventDayInput>;
};

export type EventDayUpdateManyMutationInput = {
  attendanceHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hidden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  zoomDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMeetingUUID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventDayUpdateManyWithWhereWithoutBrotherInput = {
  data: EventDayUncheckedUpdateManyWithoutSiblingsInput;
  where: EventDayScalarWhereInput;
};

export type EventDayUpdateManyWithWhereWithoutEventInput = {
  data: EventDayUncheckedUpdateManyWithoutEventDaysInput;
  where: EventDayScalarWhereInput;
};

export type EventDayUpdateManyWithWhereWithoutEventPartInput = {
  data: EventDayUncheckedUpdateManyWithoutEventDaysInput;
  where: EventDayScalarWhereInput;
};

export type EventDayUpdateManyWithWhereWithoutMethodOfDeliveryInput = {
  data: EventDayUncheckedUpdateManyWithoutEventDayInput;
  where: EventDayScalarWhereInput;
};

export type EventDayUpdateManyWithoutBrotherInput = {
  connect?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventDayCreateOrConnectWithoutBrotherInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventDayCreateWithoutBrotherInput>>>;
  createMany?: InputMaybe<EventDayCreateManyBrotherInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventDayScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventDayUpdateWithWhereUniqueWithoutBrotherInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventDayUpdateManyWithWhereWithoutBrotherInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventDayUpsertWithWhereUniqueWithoutBrotherInput>>>;
};

export type EventDayUpdateManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventDayCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventDayCreateWithoutEventInput>>>;
  createMany?: InputMaybe<EventDayCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventDayScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventDayUpdateWithWhereUniqueWithoutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventDayUpdateManyWithWhereWithoutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventDayUpsertWithWhereUniqueWithoutEventInput>>>;
};

export type EventDayUpdateManyWithoutEventPartInput = {
  connect?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventDayCreateOrConnectWithoutEventPartInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventDayCreateWithoutEventPartInput>>>;
  createMany?: InputMaybe<EventDayCreateManyEventPartInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventDayScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventDayUpdateWithWhereUniqueWithoutEventPartInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventDayUpdateManyWithWhereWithoutEventPartInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventDayUpsertWithWhereUniqueWithoutEventPartInput>>>;
};

export type EventDayUpdateManyWithoutMethodOfDeliveryInput = {
  connect?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventDayCreateOrConnectWithoutMethodOfDeliveryInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventDayCreateWithoutMethodOfDeliveryInput>>>;
  createMany?: InputMaybe<EventDayCreateManyMethodOfDeliveryInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventDayScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventDayWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventDayUpdateWithWhereUniqueWithoutMethodOfDeliveryInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventDayUpdateManyWithWhereWithoutMethodOfDeliveryInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventDayUpsertWithWhereUniqueWithoutMethodOfDeliveryInput>>>;
};

export type EventDayUpdateOneRequiredWithoutTraineeAttendanceInput = {
  connect?: InputMaybe<EventDayWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventDayCreateOrConnectWithoutTraineeAttendanceInput>;
  create?: InputMaybe<EventDayUncheckedCreateWithoutTraineeAttendanceInput>;
  update?: InputMaybe<EventDayUncheckedUpdateWithoutTraineeAttendanceInput>;
  upsert?: InputMaybe<EventDayUpsertWithoutTraineeAttendanceInput>;
};

export type EventDayUpdateOneRequiredWithoutTrainerLessonsInput = {
  connect?: InputMaybe<EventDayWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventDayCreateOrConnectWithoutTrainerLessonsInput>;
  create?: InputMaybe<EventDayUncheckedCreateWithoutTrainerLessonsInput>;
  update?: InputMaybe<EventDayUncheckedUpdateWithoutTrainerLessonsInput>;
  upsert?: InputMaybe<EventDayUpsertWithoutTrainerLessonsInput>;
};

export type EventDayUpdateOneRequiredWithoutTrainerTimeSlotsInput = {
  connect?: InputMaybe<EventDayWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventDayCreateOrConnectWithoutTrainerTimeSlotsInput>;
  create?: InputMaybe<EventDayUncheckedCreateWithoutTrainerTimeSlotsInput>;
  update?: InputMaybe<EventDayUncheckedUpdateWithoutTrainerTimeSlotsInput>;
  upsert?: InputMaybe<EventDayUpsertWithoutTrainerTimeSlotsInput>;
};

export type EventDayUpdateOneWithoutSiblingsInput = {
  connect?: InputMaybe<EventDayWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventDayCreateOrConnectWithoutSiblingsInput>;
  create?: InputMaybe<EventDayUncheckedCreateWithoutSiblingsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<EventDayUncheckedUpdateWithoutSiblingsInput>;
  upsert?: InputMaybe<EventDayUpsertWithoutSiblingsInput>;
};

export type EventDayUpdateOneWithoutTraineeEventInput = {
  connect?: InputMaybe<EventDayWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventDayCreateOrConnectWithoutTraineeEventInput>;
  create?: InputMaybe<EventDayUncheckedCreateWithoutTraineeEventInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<EventDayUncheckedUpdateWithoutTraineeEventInput>;
  upsert?: InputMaybe<EventDayUpsertWithoutTraineeEventInput>;
};

export type EventDayUpdateOneWithoutZoomMeetingsInput = {
  connect?: InputMaybe<EventDayWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventDayCreateOrConnectWithoutZoomMeetingsInput>;
  create?: InputMaybe<EventDayUncheckedCreateWithoutZoomMeetingsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<EventDayUncheckedUpdateWithoutZoomMeetingsInput>;
  upsert?: InputMaybe<EventDayUpsertWithoutZoomMeetingsInput>;
};

export type EventDayUpdateWithWhereUniqueWithoutBrotherInput = {
  data: EventDayUncheckedUpdateWithoutBrotherInput;
  where: EventDayWhereUniqueInput;
};

export type EventDayUpdateWithWhereUniqueWithoutEventInput = {
  data: EventDayUncheckedUpdateWithoutEventInput;
  where: EventDayWhereUniqueInput;
};

export type EventDayUpdateWithWhereUniqueWithoutEventPartInput = {
  data: EventDayUncheckedUpdateWithoutEventPartInput;
  where: EventDayWhereUniqueInput;
};

export type EventDayUpdateWithWhereUniqueWithoutMethodOfDeliveryInput = {
  data: EventDayUncheckedUpdateWithoutMethodOfDeliveryInput;
  where: EventDayWhereUniqueInput;
};

export type EventDayUpdateWithoutBrotherInput = {
  TraineeEvent?: InputMaybe<TraineeEventUpdateManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutEventDaysInput>;
  eventPart?: InputMaybe<EventPartUpdateOneWithoutEventDaysInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hidden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneWithoutEventDayInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  siblings?: InputMaybe<EventDayUpdateManyWithoutBrotherInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceUpdateManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonUpdateManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMeetingUUID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetings?: InputMaybe<ZoomMeetingUpdateManyWithoutEventDayInput>;
};

export type EventDayUpdateWithoutEventInput = {
  TraineeEvent?: InputMaybe<TraineeEventUpdateManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  brother?: InputMaybe<EventDayUpdateOneWithoutSiblingsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventPart?: InputMaybe<EventPartUpdateOneWithoutEventDaysInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hidden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneWithoutEventDayInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  siblings?: InputMaybe<EventDayUpdateManyWithoutBrotherInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceUpdateManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonUpdateManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMeetingUUID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetings?: InputMaybe<ZoomMeetingUpdateManyWithoutEventDayInput>;
};

export type EventDayUpdateWithoutEventPartInput = {
  TraineeEvent?: InputMaybe<TraineeEventUpdateManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  brother?: InputMaybe<EventDayUpdateOneWithoutSiblingsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutEventDaysInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hidden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneWithoutEventDayInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  siblings?: InputMaybe<EventDayUpdateManyWithoutBrotherInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceUpdateManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonUpdateManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMeetingUUID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetings?: InputMaybe<ZoomMeetingUpdateManyWithoutEventDayInput>;
};

export type EventDayUpdateWithoutMethodOfDeliveryInput = {
  TraineeEvent?: InputMaybe<TraineeEventUpdateManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  brother?: InputMaybe<EventDayUpdateOneWithoutSiblingsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutEventDaysInput>;
  eventPart?: InputMaybe<EventPartUpdateOneWithoutEventDaysInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hidden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  siblings?: InputMaybe<EventDayUpdateManyWithoutBrotherInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceUpdateManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonUpdateManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMeetingUUID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetings?: InputMaybe<ZoomMeetingUpdateManyWithoutEventDayInput>;
};

export type EventDayUpdateWithoutSiblingsInput = {
  TraineeEvent?: InputMaybe<TraineeEventUpdateManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  brother?: InputMaybe<EventDayUpdateOneWithoutSiblingsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutEventDaysInput>;
  eventPart?: InputMaybe<EventPartUpdateOneWithoutEventDaysInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hidden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneWithoutEventDayInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceUpdateManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonUpdateManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMeetingUUID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetings?: InputMaybe<ZoomMeetingUpdateManyWithoutEventDayInput>;
};

export type EventDayUpdateWithoutTraineeAttendanceInput = {
  TraineeEvent?: InputMaybe<TraineeEventUpdateManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  brother?: InputMaybe<EventDayUpdateOneWithoutSiblingsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutEventDaysInput>;
  eventPart?: InputMaybe<EventPartUpdateOneWithoutEventDaysInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hidden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneWithoutEventDayInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  siblings?: InputMaybe<EventDayUpdateManyWithoutBrotherInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonUpdateManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMeetingUUID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetings?: InputMaybe<ZoomMeetingUpdateManyWithoutEventDayInput>;
};

export type EventDayUpdateWithoutTraineeEventInput = {
  attendanceHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  brother?: InputMaybe<EventDayUpdateOneWithoutSiblingsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutEventDaysInput>;
  eventPart?: InputMaybe<EventPartUpdateOneWithoutEventDaysInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hidden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneWithoutEventDayInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  siblings?: InputMaybe<EventDayUpdateManyWithoutBrotherInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceUpdateManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonUpdateManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMeetingUUID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetings?: InputMaybe<ZoomMeetingUpdateManyWithoutEventDayInput>;
};

export type EventDayUpdateWithoutTrainerLessonsInput = {
  TraineeEvent?: InputMaybe<TraineeEventUpdateManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  brother?: InputMaybe<EventDayUpdateOneWithoutSiblingsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutEventDaysInput>;
  eventPart?: InputMaybe<EventPartUpdateOneWithoutEventDaysInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hidden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneWithoutEventDayInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  siblings?: InputMaybe<EventDayUpdateManyWithoutBrotherInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceUpdateManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMeetingUUID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetings?: InputMaybe<ZoomMeetingUpdateManyWithoutEventDayInput>;
};

export type EventDayUpdateWithoutTrainerTimeSlotsInput = {
  TraineeEvent?: InputMaybe<TraineeEventUpdateManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  brother?: InputMaybe<EventDayUpdateOneWithoutSiblingsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutEventDaysInput>;
  eventPart?: InputMaybe<EventPartUpdateOneWithoutEventDaysInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hidden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneWithoutEventDayInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  siblings?: InputMaybe<EventDayUpdateManyWithoutBrotherInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceUpdateManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonUpdateManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMeetingUUID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetings?: InputMaybe<ZoomMeetingUpdateManyWithoutEventDayInput>;
};

export type EventDayUpdateWithoutZoomMeetingsInput = {
  TraineeEvent?: InputMaybe<TraineeEventUpdateManyWithoutEventDayInput>;
  attendanceHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  brother?: InputMaybe<EventDayUpdateOneWithoutSiblingsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutEventDaysInput>;
  eventPart?: InputMaybe<EventPartUpdateOneWithoutEventDaysInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hidden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneWithoutEventDayInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  siblings?: InputMaybe<EventDayUpdateManyWithoutBrotherInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceUpdateManyWithoutEventDayInput>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonUpdateManyWithoutEventDayInput>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutEventDayInput>;
  zoomDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMeetingUUID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventDayUpsertWithWhereUniqueWithoutBrotherInput = {
  create: EventDayUncheckedCreateWithoutBrotherInput;
  update: EventDayUncheckedUpdateWithoutBrotherInput;
  where: EventDayWhereUniqueInput;
};

export type EventDayUpsertWithWhereUniqueWithoutEventInput = {
  create: EventDayUncheckedCreateWithoutEventInput;
  update: EventDayUncheckedUpdateWithoutEventInput;
  where: EventDayWhereUniqueInput;
};

export type EventDayUpsertWithWhereUniqueWithoutEventPartInput = {
  create: EventDayUncheckedCreateWithoutEventPartInput;
  update: EventDayUncheckedUpdateWithoutEventPartInput;
  where: EventDayWhereUniqueInput;
};

export type EventDayUpsertWithWhereUniqueWithoutMethodOfDeliveryInput = {
  create: EventDayUncheckedCreateWithoutMethodOfDeliveryInput;
  update: EventDayUncheckedUpdateWithoutMethodOfDeliveryInput;
  where: EventDayWhereUniqueInput;
};

export type EventDayUpsertWithoutSiblingsInput = {
  create: EventDayUncheckedCreateWithoutSiblingsInput;
  update: EventDayUncheckedUpdateWithoutSiblingsInput;
};

export type EventDayUpsertWithoutTraineeAttendanceInput = {
  create: EventDayUncheckedCreateWithoutTraineeAttendanceInput;
  update: EventDayUncheckedUpdateWithoutTraineeAttendanceInput;
};

export type EventDayUpsertWithoutTraineeEventInput = {
  create: EventDayUncheckedCreateWithoutTraineeEventInput;
  update: EventDayUncheckedUpdateWithoutTraineeEventInput;
};

export type EventDayUpsertWithoutTrainerLessonsInput = {
  create: EventDayUncheckedCreateWithoutTrainerLessonsInput;
  update: EventDayUncheckedUpdateWithoutTrainerLessonsInput;
};

export type EventDayUpsertWithoutTrainerTimeSlotsInput = {
  create: EventDayUncheckedCreateWithoutTrainerTimeSlotsInput;
  update: EventDayUncheckedUpdateWithoutTrainerTimeSlotsInput;
};

export type EventDayUpsertWithoutZoomMeetingsInput = {
  create: EventDayUncheckedCreateWithoutZoomMeetingsInput;
  update: EventDayUncheckedUpdateWithoutZoomMeetingsInput;
};

export type EventDayWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<EventDayWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<EventDayWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<EventDayWhereInput>>>;
  TraineeEvent?: InputMaybe<TraineeEventListRelationFilter>;
  attendanceHours?: InputMaybe<DecimalNullableFilter>;
  brother?: InputMaybe<EventDayWhereInput>;
  brotherId?: InputMaybe<IntNullableFilter>;
  cmeHours?: InputMaybe<DecimalNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  date?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  endTime?: InputMaybe<DateTimeFilter>;
  event?: InputMaybe<EventWhereInput>;
  eventId?: InputMaybe<IntFilter>;
  eventPart?: InputMaybe<EventPartWhereInput>;
  eventPartId?: InputMaybe<IntNullableFilter>;
  hasWorkshop?: InputMaybe<BoolNullableFilter>;
  hidden?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<IntFilter>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryWhereInput>;
  methodOfDeliveryId?: InputMaybe<IntNullableFilter>;
  outlineAr?: InputMaybe<StringFilter>;
  outlineEn?: InputMaybe<StringFilter>;
  siblings?: InputMaybe<EventDayListRelationFilter>;
  startTime?: InputMaybe<DateTimeFilter>;
  traineeAttendance?: InputMaybe<TraineeEventDayAttendanceListRelationFilter>;
  trainerLessons?: InputMaybe<TrainerEventDayLessonListRelationFilter>;
  trainerTimeSlots?: InputMaybe<TrainerEventDayTimeSlotListRelationFilter>;
  zoomDuration?: InputMaybe<IntNullableFilter>;
  zoomMeetingUUID?: InputMaybe<StringNullableFilter>;
  zoomMeetings?: InputMaybe<ZoomMeetingListRelationFilter>;
};

export type EventDayWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type EventDetailsOutput = {
  __typename?: 'EventDetailsOutput';
  Discussion?: Maybe<Array<Maybe<Discussion>>>;
  Quiz?: Maybe<Quiz>;
  ZoomMeeting?: Maybe<ZoomMeeting>;
  address?: Maybe<Scalars['String']>;
  addressInstructions?: Maybe<Scalars['String']>;
  backgroundImagesUrls?: Maybe<Array<Maybe<Scalars['String']>>>;
  cmeHours?: Maybe<Scalars['Decimal']>;
  cmeNumber?: Maybe<Scalars['String']>;
  defaultLanguage?: Maybe<Scalars['String']>;
  descriptionAr?: Maybe<Scalars['String']>;
  descriptionEn?: Maybe<Scalars['String']>;
  discussionStatus?: Maybe<Scalars['Boolean']>;
  endDate?: Maybe<Scalars['DateTime']>;
  eventDays?: Maybe<Array<Maybe<EventDay>>>;
  eventLanguages?: Maybe<Array<Maybe<Language>>>;
  eventParts?: Maybe<Array<Maybe<EventPart>>>;
  eventType?: Maybe<EventType>;
  folder?: Maybe<EventFolder>;
  id?: Maybe<Scalars['Int']>;
  introductionAr?: Maybe<Scalars['String']>;
  introductionEn?: Maybe<Scalars['String']>;
  isAccredited?: Maybe<Scalars['Boolean']>;
  isAccreditedSHA?: Maybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: Maybe<Scalars['Boolean']>;
  isSponsored?: Maybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable?: Maybe<Scalars['Boolean']>;
  keywordsAr?: Maybe<Array<Maybe<Scalars['String']>>>;
  keywordsEn?: Maybe<Array<Maybe<Scalars['String']>>>;
  locationLatitude?: Maybe<Scalars['Decimal']>;
  locationLongitude?: Maybe<Scalars['Decimal']>;
  mainThemeAr?: Maybe<Scalars['String']>;
  mainThemeEn?: Maybe<Scalars['String']>;
  meetingId?: Maybe<Scalars['String']>;
  methodOfDelivery?: Maybe<MethodOfDelivery>;
  objectivesAr?: Maybe<Scalars['String']>;
  objectivesEn?: Maybe<Scalars['String']>;
  outcomesAr?: Maybe<Scalars['String']>;
  outcomesEn?: Maybe<Scalars['String']>;
  package?: Maybe<Event>;
  packageEvents?: Maybe<Array<Maybe<Event>>>;
  price?: Maybe<Scalars['String']>;
  pricingPlan?: Maybe<PricingPlan>;
  shortDescriptionAr?: Maybe<Scalars['String']>;
  shortDescriptionEn?: Maybe<Scalars['String']>;
  sponsorshipImagesUrls?: Maybe<Scalars['Json']>;
  startDate?: Maybe<Scalars['DateTime']>;
  targetedAudiences?: Maybe<Array<Maybe<Profession>>>;
  targetedSpecialities?: Maybe<Array<Maybe<Specialty>>>;
  timeTableStatus?: Maybe<Scalars['Boolean']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
  traineeEvents?: Maybe<Array<Maybe<TraineeEventModel>>>;
  trainerEvents?: Maybe<Array<Maybe<TrainerEvent>>>;
  whyTargetedAudienceAr?: Maybe<Scalars['String']>;
  whyTargetedAudienceEn?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['String']>;
  zoomMeetingId?: Maybe<Scalars['Int']>;
};

export type EventFolder = {
  __typename?: 'EventFolder';
  _count: EventFolderCountOutputType;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  events: Array<Event>;
  id: Scalars['Int'];
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};


export type EventFolderEventsArgs = {
  cursor?: InputMaybe<EventWhereUniqueInput>;
  distinct?: InputMaybe<EventScalarFieldEnum>;
  orderBy?: InputMaybe<EventOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EventWhereInput>;
};

export type EventFolderAvgAggregateOutputType = {
  __typename?: 'EventFolderAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
};

export type EventFolderAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type EventFolderCountAggregateOutputType = {
  __typename?: 'EventFolderCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  titleAr: Scalars['Int'];
  titleEn: Scalars['Int'];
};

export type EventFolderCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type EventFolderCountOutputType = {
  __typename?: 'EventFolderCountOutputType';
  events: Scalars['Int'];
};

export type EventFolderCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<EventCreateNestedManyWithoutFolderInput>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type EventFolderCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type EventFolderCreateNestedOneWithoutEventsInput = {
  connect?: InputMaybe<EventFolderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventFolderCreateOrConnectWithoutEventsInput>;
  create?: InputMaybe<EventFolderUncheckedCreateWithoutEventsInput>;
};

export type EventFolderCreateOrConnectWithoutEventsInput = {
  create: EventFolderUncheckedCreateWithoutEventsInput;
  where: EventFolderWhereUniqueInput;
};

export type EventFolderCreateWithoutEventsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type EventFolderMaxAggregateOutputType = {
  __typename?: 'EventFolderMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type EventFolderMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type EventFolderMinAggregateOutputType = {
  __typename?: 'EventFolderMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type EventFolderMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type EventFolderOrderByWithAggregationInput = {
  _avg?: InputMaybe<EventFolderAvgOrderByAggregateInput>;
  _count?: InputMaybe<EventFolderCountOrderByAggregateInput>;
  _max?: InputMaybe<EventFolderMaxOrderByAggregateInput>;
  _min?: InputMaybe<EventFolderMinOrderByAggregateInput>;
  _sum?: InputMaybe<EventFolderSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type EventFolderOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  events?: InputMaybe<EventOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type EventFolderRelationFilter = {
  is?: InputMaybe<EventFolderWhereInput>;
  isNot?: InputMaybe<EventFolderWhereInput>;
};

export enum EventFolderScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  TitleAr = 'titleAr',
  TitleEn = 'titleEn'
}

export type EventFolderScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<EventFolderScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<EventFolderScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<EventFolderScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  titleAr?: InputMaybe<StringWithAggregatesFilter>;
  titleEn?: InputMaybe<StringWithAggregatesFilter>;
};

export type EventFolderSumAggregateOutputType = {
  __typename?: 'EventFolderSumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
};

export type EventFolderSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type EventFolderUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutFolderInput>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type EventFolderUncheckedCreateWithoutEventsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type EventFolderUncheckedUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutFolderInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EventFolderUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EventFolderUncheckedUpdateWithoutEventsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EventFolderUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventUpdateManyWithoutFolderInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EventFolderUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EventFolderUpdateOneRequiredWithoutEventsInput = {
  connect?: InputMaybe<EventFolderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventFolderCreateOrConnectWithoutEventsInput>;
  create?: InputMaybe<EventFolderUncheckedCreateWithoutEventsInput>;
  update?: InputMaybe<EventFolderUncheckedUpdateWithoutEventsInput>;
  upsert?: InputMaybe<EventFolderUpsertWithoutEventsInput>;
};

export type EventFolderUpdateWithoutEventsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EventFolderUpsertWithoutEventsInput = {
  create: EventFolderUncheckedCreateWithoutEventsInput;
  update: EventFolderUncheckedUpdateWithoutEventsInput;
};

export type EventFolderWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<EventFolderWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<EventFolderWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<EventFolderWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  events?: InputMaybe<EventListRelationFilter>;
  id?: InputMaybe<IntFilter>;
  titleAr?: InputMaybe<StringFilter>;
  titleEn?: InputMaybe<StringFilter>;
};

export type EventFolderWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn?: InputMaybe<Scalars['String']>;
};

export type EventIdentityCardTemplate = {
  __typename?: 'EventIdentityCardTemplate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<Event>;
  eventId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  templateData?: Maybe<Scalars['Json']>;
};

export type EventIdentityCardTemplateAvgAggregateOutputType = {
  __typename?: 'EventIdentityCardTemplateAvgAggregateOutputType';
  eventId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

export type EventIdentityCardTemplateAvgOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type EventIdentityCardTemplateCountAggregateOutputType = {
  __typename?: 'EventIdentityCardTemplateCountAggregateOutputType';
  _all: Scalars['Int'];
  eventId: Scalars['Int'];
  id: Scalars['Int'];
  templateData: Scalars['Int'];
};

export type EventIdentityCardTemplateCountOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  templateData?: InputMaybe<SortOrder>;
};

export type EventIdentityCardTemplateCreateInput = {
  event?: InputMaybe<EventCreateNestedOneWithoutEventIdentityCardTemplateInput>;
  templateData: Scalars['Json'];
};

export type EventIdentityCardTemplateCreateManyInput = {
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  templateData: Scalars['Json'];
};

export type EventIdentityCardTemplateCreateNestedOneWithoutEventInput = {
  connect?: InputMaybe<EventIdentityCardTemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventIdentityCardTemplateCreateOrConnectWithoutEventInput>;
  create?: InputMaybe<EventIdentityCardTemplateUncheckedCreateWithoutEventInput>;
};

export type EventIdentityCardTemplateCreateOrConnectWithoutEventInput = {
  create: EventIdentityCardTemplateUncheckedCreateWithoutEventInput;
  where: EventIdentityCardTemplateWhereUniqueInput;
};

export type EventIdentityCardTemplateCreateWithoutEventInput = {
  templateData: Scalars['Json'];
};

export type EventIdentityCardTemplateMaxAggregateOutputType = {
  __typename?: 'EventIdentityCardTemplateMaxAggregateOutputType';
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type EventIdentityCardTemplateMaxOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type EventIdentityCardTemplateMinAggregateOutputType = {
  __typename?: 'EventIdentityCardTemplateMinAggregateOutputType';
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type EventIdentityCardTemplateMinOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type EventIdentityCardTemplateOrderByWithAggregationInput = {
  _avg?: InputMaybe<EventIdentityCardTemplateAvgOrderByAggregateInput>;
  _count?: InputMaybe<EventIdentityCardTemplateCountOrderByAggregateInput>;
  _max?: InputMaybe<EventIdentityCardTemplateMaxOrderByAggregateInput>;
  _min?: InputMaybe<EventIdentityCardTemplateMinOrderByAggregateInput>;
  _sum?: InputMaybe<EventIdentityCardTemplateSumOrderByAggregateInput>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  templateData?: InputMaybe<SortOrder>;
};

export type EventIdentityCardTemplateOrderByWithRelationInput = {
  event?: InputMaybe<EventOrderByWithRelationInput>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  templateData?: InputMaybe<SortOrder>;
};

export type EventIdentityCardTemplateRelationFilter = {
  is?: InputMaybe<EventIdentityCardTemplateWhereInput>;
  isNot?: InputMaybe<EventIdentityCardTemplateWhereInput>;
};

export enum EventIdentityCardTemplateScalarFieldEnum {
  EventId = 'eventId',
  Id = 'id',
  TemplateData = 'templateData'
}

export type EventIdentityCardTemplateScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<EventIdentityCardTemplateScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<EventIdentityCardTemplateScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<EventIdentityCardTemplateScalarWhereWithAggregatesInput>>>;
  eventId?: InputMaybe<IntNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  templateData?: InputMaybe<JsonWithAggregatesFilter>;
};

export type EventIdentityCardTemplateSumAggregateOutputType = {
  __typename?: 'EventIdentityCardTemplateSumAggregateOutputType';
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type EventIdentityCardTemplateSumOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type EventIdentityCardTemplateUncheckedCreateInput = {
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  templateData: Scalars['Json'];
};

export type EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput = {
  connect?: InputMaybe<EventIdentityCardTemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventIdentityCardTemplateCreateOrConnectWithoutEventInput>;
  create?: InputMaybe<EventIdentityCardTemplateUncheckedCreateWithoutEventInput>;
};

export type EventIdentityCardTemplateUncheckedCreateWithoutEventInput = {
  id?: InputMaybe<Scalars['Int']>;
  templateData: Scalars['Json'];
};

export type EventIdentityCardTemplateUncheckedUpdateInput = {
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  templateData?: InputMaybe<Scalars['Json']>;
};

export type EventIdentityCardTemplateUncheckedUpdateManyInput = {
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  templateData?: InputMaybe<Scalars['Json']>;
};

export type EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput = {
  connect?: InputMaybe<EventIdentityCardTemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventIdentityCardTemplateCreateOrConnectWithoutEventInput>;
  create?: InputMaybe<EventIdentityCardTemplateUncheckedCreateWithoutEventInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateWithoutEventInput>;
  upsert?: InputMaybe<EventIdentityCardTemplateUpsertWithoutEventInput>;
};

export type EventIdentityCardTemplateUncheckedUpdateWithoutEventInput = {
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  templateData?: InputMaybe<Scalars['Json']>;
};

export type EventIdentityCardTemplateUpdateInput = {
  event?: InputMaybe<EventUpdateOneWithoutEventIdentityCardTemplateInput>;
  templateData?: InputMaybe<Scalars['Json']>;
};

export type EventIdentityCardTemplateUpdateManyMutationInput = {
  templateData?: InputMaybe<Scalars['Json']>;
};

export type EventIdentityCardTemplateUpdateOneWithoutEventInput = {
  connect?: InputMaybe<EventIdentityCardTemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventIdentityCardTemplateCreateOrConnectWithoutEventInput>;
  create?: InputMaybe<EventIdentityCardTemplateUncheckedCreateWithoutEventInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateWithoutEventInput>;
  upsert?: InputMaybe<EventIdentityCardTemplateUpsertWithoutEventInput>;
};

export type EventIdentityCardTemplateUpdateWithoutEventInput = {
  templateData?: InputMaybe<Scalars['Json']>;
};

export type EventIdentityCardTemplateUpsertWithoutEventInput = {
  create: EventIdentityCardTemplateUncheckedCreateWithoutEventInput;
  update: EventIdentityCardTemplateUncheckedUpdateWithoutEventInput;
};

export type EventIdentityCardTemplateWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<EventIdentityCardTemplateWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<EventIdentityCardTemplateWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<EventIdentityCardTemplateWhereInput>>>;
  event?: InputMaybe<EventWhereInput>;
  eventId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  templateData?: InputMaybe<JsonFilter>;
};

export type EventIdentityCardTemplateWhereUniqueInput = {
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type EventListRelationFilter = {
  every?: InputMaybe<EventWhereInput>;
  none?: InputMaybe<EventWhereInput>;
  some?: InputMaybe<EventWhereInput>;
};

export type EventMaxAggregateOutputType = {
  __typename?: 'EventMaxAggregateOutputType';
  addedById?: Maybe<Scalars['Int']>;
  address?: Maybe<Scalars['String']>;
  addressAr?: Maybe<Scalars['String']>;
  addressInstructions?: Maybe<Scalars['String']>;
  addressInstructionsAr?: Maybe<Scalars['String']>;
  cityId?: Maybe<Scalars['Int']>;
  cmeHours?: Maybe<Scalars['Decimal']>;
  cmeNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultLanguage?: Maybe<LanguageEnum>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  descriptionAr?: Maybe<Scalars['String']>;
  descriptionEn?: Maybe<Scalars['String']>;
  discussionStatus?: Maybe<Scalars['Boolean']>;
  endDate?: Maybe<Scalars['DateTime']>;
  eventTypeId?: Maybe<Scalars['Int']>;
  folderId?: Maybe<Scalars['Int']>;
  hideVideoProgress?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  imageUrl?: Maybe<Scalars['String']>;
  introductionAr?: Maybe<Scalars['String']>;
  introductionEn?: Maybe<Scalars['String']>;
  invitersCanApprovePayments?: Maybe<Scalars['Boolean']>;
  isAccredited?: Maybe<Scalars['Boolean']>;
  isAccreditedSHA?: Maybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: Maybe<Scalars['Boolean']>;
  isContentProvidedByAcademy?: Maybe<Scalars['Boolean']>;
  isRegistraionClosed?: Maybe<Scalars['Boolean']>;
  isSponsored?: Maybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable?: Maybe<Scalars['Boolean']>;
  isTrainerCertificateAvailable?: Maybe<Scalars['Boolean']>;
  leaderTrainerId?: Maybe<Scalars['Int']>;
  locationLatitude?: Maybe<Scalars['Decimal']>;
  locationLongitude?: Maybe<Scalars['Decimal']>;
  mainThemeAr?: Maybe<Scalars['String']>;
  mainThemeEn?: Maybe<Scalars['String']>;
  meetingId?: Maybe<Scalars['String']>;
  methodOfDeliveryId?: Maybe<Scalars['Int']>;
  minAttendancePercentageToGetCertificate?: Maybe<Scalars['Decimal']>;
  numberOfVisits?: Maybe<Scalars['Int']>;
  objectivesAr?: Maybe<Scalars['String']>;
  objectivesEn?: Maybe<Scalars['String']>;
  onlineCapacity?: Maybe<Scalars['Int']>;
  onsiteCapacity?: Maybe<Scalars['Int']>;
  outcomesAr?: Maybe<Scalars['String']>;
  outcomesEn?: Maybe<Scalars['String']>;
  packageId?: Maybe<Scalars['Int']>;
  pricingPlanId?: Maybe<Scalars['Int']>;
  shortDescriptionAr?: Maybe<Scalars['String']>;
  shortDescriptionEn?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  timeTableStatus?: Maybe<Scalars['Boolean']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
  traineeCertificateTemplateId?: Maybe<Scalars['Int']>;
  trainerCertificateTemplateId?: Maybe<Scalars['Int']>;
  visibleOnArchive?: Maybe<Scalars['Boolean']>;
  whyTargetedAudienceAr?: Maybe<Scalars['String']>;
  whyTargetedAudienceEn?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['String']>;
  zoomMeetingId?: Maybe<Scalars['Int']>;
  zoomMode?: Maybe<Scalars['String']>;
};

export type EventMaxOrderByAggregateInput = {
  addedById?: InputMaybe<SortOrder>;
  address?: InputMaybe<SortOrder>;
  addressAr?: InputMaybe<SortOrder>;
  addressInstructions?: InputMaybe<SortOrder>;
  addressInstructionsAr?: InputMaybe<SortOrder>;
  cityId?: InputMaybe<SortOrder>;
  cmeHours?: InputMaybe<SortOrder>;
  cmeNumber?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  defaultLanguage?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  descriptionAr?: InputMaybe<SortOrder>;
  descriptionEn?: InputMaybe<SortOrder>;
  discussionStatus?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  eventTypeId?: InputMaybe<SortOrder>;
  folderId?: InputMaybe<SortOrder>;
  hideVideoProgress?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  introductionAr?: InputMaybe<SortOrder>;
  introductionEn?: InputMaybe<SortOrder>;
  invitersCanApprovePayments?: InputMaybe<SortOrder>;
  isAccredited?: InputMaybe<SortOrder>;
  isAccreditedSHA?: InputMaybe<SortOrder>;
  isAllProfessionsTargeted?: InputMaybe<SortOrder>;
  isContentProvidedByAcademy?: InputMaybe<SortOrder>;
  isRegistraionClosed?: InputMaybe<SortOrder>;
  isSponsored?: InputMaybe<SortOrder>;
  isTraineeCertificateAvailable?: InputMaybe<SortOrder>;
  isTrainerCertificateAvailable?: InputMaybe<SortOrder>;
  leaderTrainerId?: InputMaybe<SortOrder>;
  locationLatitude?: InputMaybe<SortOrder>;
  locationLongitude?: InputMaybe<SortOrder>;
  mainThemeAr?: InputMaybe<SortOrder>;
  mainThemeEn?: InputMaybe<SortOrder>;
  meetingId?: InputMaybe<SortOrder>;
  methodOfDeliveryId?: InputMaybe<SortOrder>;
  minAttendancePercentageToGetCertificate?: InputMaybe<SortOrder>;
  numberOfVisits?: InputMaybe<SortOrder>;
  objectivesAr?: InputMaybe<SortOrder>;
  objectivesEn?: InputMaybe<SortOrder>;
  onlineCapacity?: InputMaybe<SortOrder>;
  onsiteCapacity?: InputMaybe<SortOrder>;
  outcomesAr?: InputMaybe<SortOrder>;
  outcomesEn?: InputMaybe<SortOrder>;
  packageId?: InputMaybe<SortOrder>;
  pricingPlanId?: InputMaybe<SortOrder>;
  shortDescriptionAr?: InputMaybe<SortOrder>;
  shortDescriptionEn?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  timeTableStatus?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
  traineeCertificateTemplateId?: InputMaybe<SortOrder>;
  trainerCertificateTemplateId?: InputMaybe<SortOrder>;
  visibleOnArchive?: InputMaybe<SortOrder>;
  whyTargetedAudienceAr?: InputMaybe<SortOrder>;
  whyTargetedAudienceEn?: InputMaybe<SortOrder>;
  youtubeUrl?: InputMaybe<SortOrder>;
  zoomMeetingId?: InputMaybe<SortOrder>;
  zoomMode?: InputMaybe<SortOrder>;
};

export type EventMediaTracking = {
  __typename?: 'EventMediaTracking';
  anat?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['Boolean']>;
  ertiqaa?: Maybe<Scalars['Boolean']>;
  event?: Maybe<Event>;
  eventId?: Maybe<Scalars['Int']>;
  facebook?: Maybe<Scalars['Boolean']>;
  friend?: Maybe<Scalars['Boolean']>;
  google?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  instagram?: Maybe<Scalars['Boolean']>;
  linkedin?: Maybe<Scalars['Boolean']>;
  telegram?: Maybe<Scalars['Boolean']>;
  trainee?: Maybe<User>;
  traineeId?: Maybe<Scalars['Int']>;
  twitter?: Maybe<Scalars['Boolean']>;
  whatsApp?: Maybe<Scalars['Boolean']>;
};

export type EventMediaTrackingAvgAggregateOutputType = {
  __typename?: 'EventMediaTrackingAvgAggregateOutputType';
  eventId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  traineeId?: Maybe<Scalars['Float']>;
};

export type EventMediaTrackingAvgOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  traineeId?: InputMaybe<SortOrder>;
};

export type EventMediaTrackingCountAggregateOutputType = {
  __typename?: 'EventMediaTrackingCountAggregateOutputType';
  _all: Scalars['Int'];
  anat: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  email: Scalars['Int'];
  ertiqaa: Scalars['Int'];
  eventId: Scalars['Int'];
  facebook: Scalars['Int'];
  friend: Scalars['Int'];
  google: Scalars['Int'];
  id: Scalars['Int'];
  instagram: Scalars['Int'];
  linkedin: Scalars['Int'];
  telegram: Scalars['Int'];
  traineeId: Scalars['Int'];
  twitter: Scalars['Int'];
  whatsApp: Scalars['Int'];
};

export type EventMediaTrackingCountOrderByAggregateInput = {
  anat?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  ertiqaa?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  facebook?: InputMaybe<SortOrder>;
  friend?: InputMaybe<SortOrder>;
  google?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  instagram?: InputMaybe<SortOrder>;
  linkedin?: InputMaybe<SortOrder>;
  telegram?: InputMaybe<SortOrder>;
  traineeId?: InputMaybe<SortOrder>;
  twitter?: InputMaybe<SortOrder>;
  whatsApp?: InputMaybe<SortOrder>;
};

export type EventMediaTrackingCreateInput = {
  anat: Scalars['Boolean'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['Boolean'];
  ertiqaa: Scalars['Boolean'];
  event?: InputMaybe<EventCreateNestedOneWithoutEventMediaTrackingInput>;
  facebook: Scalars['Boolean'];
  friend: Scalars['Boolean'];
  google: Scalars['Boolean'];
  instagram: Scalars['Boolean'];
  linkedin: Scalars['Boolean'];
  telegram: Scalars['Boolean'];
  trainee?: InputMaybe<UserCreateNestedOneWithoutEventMediaTrackingInput>;
  twitter: Scalars['Boolean'];
  whatsApp: Scalars['Boolean'];
};

export type EventMediaTrackingCreateManyEventInput = {
  anat: Scalars['Boolean'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['Boolean'];
  ertiqaa: Scalars['Boolean'];
  facebook: Scalars['Boolean'];
  friend: Scalars['Boolean'];
  google: Scalars['Boolean'];
  id?: InputMaybe<Scalars['Int']>;
  instagram: Scalars['Boolean'];
  linkedin: Scalars['Boolean'];
  telegram: Scalars['Boolean'];
  traineeId: Scalars['Int'];
  twitter: Scalars['Boolean'];
  whatsApp: Scalars['Boolean'];
};

export type EventMediaTrackingCreateManyEventInputEnvelope = {
  data: EventMediaTrackingCreateManyEventInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type EventMediaTrackingCreateManyInput = {
  anat: Scalars['Boolean'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['Boolean'];
  ertiqaa: Scalars['Boolean'];
  eventId: Scalars['Int'];
  facebook: Scalars['Boolean'];
  friend: Scalars['Boolean'];
  google: Scalars['Boolean'];
  id?: InputMaybe<Scalars['Int']>;
  instagram: Scalars['Boolean'];
  linkedin: Scalars['Boolean'];
  telegram: Scalars['Boolean'];
  traineeId: Scalars['Int'];
  twitter: Scalars['Boolean'];
  whatsApp: Scalars['Boolean'];
};

export type EventMediaTrackingCreateManyTraineeInput = {
  anat: Scalars['Boolean'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['Boolean'];
  ertiqaa: Scalars['Boolean'];
  eventId: Scalars['Int'];
  facebook: Scalars['Boolean'];
  friend: Scalars['Boolean'];
  google: Scalars['Boolean'];
  id?: InputMaybe<Scalars['Int']>;
  instagram: Scalars['Boolean'];
  linkedin: Scalars['Boolean'];
  telegram: Scalars['Boolean'];
  twitter: Scalars['Boolean'];
  whatsApp: Scalars['Boolean'];
};

export type EventMediaTrackingCreateManyTraineeInputEnvelope = {
  data: EventMediaTrackingCreateManyTraineeInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type EventMediaTrackingCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<EventMediaTrackingWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventMediaTrackingCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventMediaTrackingCreateWithoutEventInput>>>;
  createMany?: InputMaybe<EventMediaTrackingCreateManyEventInputEnvelope>;
};

export type EventMediaTrackingCreateNestedManyWithoutTraineeInput = {
  connect?: InputMaybe<Array<InputMaybe<EventMediaTrackingWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventMediaTrackingCreateOrConnectWithoutTraineeInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventMediaTrackingCreateWithoutTraineeInput>>>;
  createMany?: InputMaybe<EventMediaTrackingCreateManyTraineeInputEnvelope>;
};

export type EventMediaTrackingCreateOrConnectWithoutEventInput = {
  create: EventMediaTrackingUncheckedCreateWithoutEventInput;
  where: EventMediaTrackingWhereUniqueInput;
};

export type EventMediaTrackingCreateOrConnectWithoutTraineeInput = {
  create: EventMediaTrackingUncheckedCreateWithoutTraineeInput;
  where: EventMediaTrackingWhereUniqueInput;
};

export type EventMediaTrackingCreateWithoutEventInput = {
  anat: Scalars['Boolean'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['Boolean'];
  ertiqaa: Scalars['Boolean'];
  facebook: Scalars['Boolean'];
  friend: Scalars['Boolean'];
  google: Scalars['Boolean'];
  instagram: Scalars['Boolean'];
  linkedin: Scalars['Boolean'];
  telegram: Scalars['Boolean'];
  trainee?: InputMaybe<UserCreateNestedOneWithoutEventMediaTrackingInput>;
  twitter: Scalars['Boolean'];
  whatsApp: Scalars['Boolean'];
};

export type EventMediaTrackingCreateWithoutTraineeInput = {
  anat: Scalars['Boolean'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['Boolean'];
  ertiqaa: Scalars['Boolean'];
  event?: InputMaybe<EventCreateNestedOneWithoutEventMediaTrackingInput>;
  facebook: Scalars['Boolean'];
  friend: Scalars['Boolean'];
  google: Scalars['Boolean'];
  instagram: Scalars['Boolean'];
  linkedin: Scalars['Boolean'];
  telegram: Scalars['Boolean'];
  twitter: Scalars['Boolean'];
  whatsApp: Scalars['Boolean'];
};

export type EventMediaTrackingListRelationFilter = {
  every?: InputMaybe<EventMediaTrackingWhereInput>;
  none?: InputMaybe<EventMediaTrackingWhereInput>;
  some?: InputMaybe<EventMediaTrackingWhereInput>;
};

export type EventMediaTrackingMaxAggregateOutputType = {
  __typename?: 'EventMediaTrackingMaxAggregateOutputType';
  anat?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['Boolean']>;
  ertiqaa?: Maybe<Scalars['Boolean']>;
  eventId?: Maybe<Scalars['Int']>;
  facebook?: Maybe<Scalars['Boolean']>;
  friend?: Maybe<Scalars['Boolean']>;
  google?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  instagram?: Maybe<Scalars['Boolean']>;
  linkedin?: Maybe<Scalars['Boolean']>;
  telegram?: Maybe<Scalars['Boolean']>;
  traineeId?: Maybe<Scalars['Int']>;
  twitter?: Maybe<Scalars['Boolean']>;
  whatsApp?: Maybe<Scalars['Boolean']>;
};

export type EventMediaTrackingMaxOrderByAggregateInput = {
  anat?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  ertiqaa?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  facebook?: InputMaybe<SortOrder>;
  friend?: InputMaybe<SortOrder>;
  google?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  instagram?: InputMaybe<SortOrder>;
  linkedin?: InputMaybe<SortOrder>;
  telegram?: InputMaybe<SortOrder>;
  traineeId?: InputMaybe<SortOrder>;
  twitter?: InputMaybe<SortOrder>;
  whatsApp?: InputMaybe<SortOrder>;
};

export type EventMediaTrackingMinAggregateOutputType = {
  __typename?: 'EventMediaTrackingMinAggregateOutputType';
  anat?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['Boolean']>;
  ertiqaa?: Maybe<Scalars['Boolean']>;
  eventId?: Maybe<Scalars['Int']>;
  facebook?: Maybe<Scalars['Boolean']>;
  friend?: Maybe<Scalars['Boolean']>;
  google?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  instagram?: Maybe<Scalars['Boolean']>;
  linkedin?: Maybe<Scalars['Boolean']>;
  telegram?: Maybe<Scalars['Boolean']>;
  traineeId?: Maybe<Scalars['Int']>;
  twitter?: Maybe<Scalars['Boolean']>;
  whatsApp?: Maybe<Scalars['Boolean']>;
};

export type EventMediaTrackingMinOrderByAggregateInput = {
  anat?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  ertiqaa?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  facebook?: InputMaybe<SortOrder>;
  friend?: InputMaybe<SortOrder>;
  google?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  instagram?: InputMaybe<SortOrder>;
  linkedin?: InputMaybe<SortOrder>;
  telegram?: InputMaybe<SortOrder>;
  traineeId?: InputMaybe<SortOrder>;
  twitter?: InputMaybe<SortOrder>;
  whatsApp?: InputMaybe<SortOrder>;
};

export type EventMediaTrackingOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type EventMediaTrackingOrderByWithAggregationInput = {
  _avg?: InputMaybe<EventMediaTrackingAvgOrderByAggregateInput>;
  _count?: InputMaybe<EventMediaTrackingCountOrderByAggregateInput>;
  _max?: InputMaybe<EventMediaTrackingMaxOrderByAggregateInput>;
  _min?: InputMaybe<EventMediaTrackingMinOrderByAggregateInput>;
  _sum?: InputMaybe<EventMediaTrackingSumOrderByAggregateInput>;
  anat?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  ertiqaa?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  facebook?: InputMaybe<SortOrder>;
  friend?: InputMaybe<SortOrder>;
  google?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  instagram?: InputMaybe<SortOrder>;
  linkedin?: InputMaybe<SortOrder>;
  telegram?: InputMaybe<SortOrder>;
  traineeId?: InputMaybe<SortOrder>;
  twitter?: InputMaybe<SortOrder>;
  whatsApp?: InputMaybe<SortOrder>;
};

export type EventMediaTrackingOrderByWithRelationInput = {
  anat?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  ertiqaa?: InputMaybe<SortOrder>;
  event?: InputMaybe<EventOrderByWithRelationInput>;
  eventId?: InputMaybe<SortOrder>;
  facebook?: InputMaybe<SortOrder>;
  friend?: InputMaybe<SortOrder>;
  google?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  instagram?: InputMaybe<SortOrder>;
  linkedin?: InputMaybe<SortOrder>;
  telegram?: InputMaybe<SortOrder>;
  trainee?: InputMaybe<UserOrderByWithRelationInput>;
  traineeId?: InputMaybe<SortOrder>;
  twitter?: InputMaybe<SortOrder>;
  whatsApp?: InputMaybe<SortOrder>;
};

export enum EventMediaTrackingScalarFieldEnum {
  Anat = 'anat',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Email = 'email',
  Ertiqaa = 'ertiqaa',
  EventId = 'eventId',
  Facebook = 'facebook',
  Friend = 'friend',
  Google = 'google',
  Id = 'id',
  Instagram = 'instagram',
  Linkedin = 'linkedin',
  Telegram = 'telegram',
  TraineeId = 'traineeId',
  Twitter = 'twitter',
  WhatsApp = 'whatsApp'
}

export type EventMediaTrackingScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<EventMediaTrackingScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<EventMediaTrackingScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<EventMediaTrackingScalarWhereInput>>>;
  anat?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  email?: InputMaybe<BoolFilter>;
  ertiqaa?: InputMaybe<BoolFilter>;
  eventId?: InputMaybe<IntFilter>;
  facebook?: InputMaybe<BoolFilter>;
  friend?: InputMaybe<BoolFilter>;
  google?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
  instagram?: InputMaybe<BoolFilter>;
  linkedin?: InputMaybe<BoolFilter>;
  telegram?: InputMaybe<BoolFilter>;
  traineeId?: InputMaybe<IntFilter>;
  twitter?: InputMaybe<BoolFilter>;
  whatsApp?: InputMaybe<BoolFilter>;
};

export type EventMediaTrackingScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<EventMediaTrackingScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<EventMediaTrackingScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<EventMediaTrackingScalarWhereWithAggregatesInput>>>;
  anat?: InputMaybe<BoolWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  email?: InputMaybe<BoolWithAggregatesFilter>;
  ertiqaa?: InputMaybe<BoolWithAggregatesFilter>;
  eventId?: InputMaybe<IntWithAggregatesFilter>;
  facebook?: InputMaybe<BoolWithAggregatesFilter>;
  friend?: InputMaybe<BoolWithAggregatesFilter>;
  google?: InputMaybe<BoolWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  instagram?: InputMaybe<BoolWithAggregatesFilter>;
  linkedin?: InputMaybe<BoolWithAggregatesFilter>;
  telegram?: InputMaybe<BoolWithAggregatesFilter>;
  traineeId?: InputMaybe<IntWithAggregatesFilter>;
  twitter?: InputMaybe<BoolWithAggregatesFilter>;
  whatsApp?: InputMaybe<BoolWithAggregatesFilter>;
};

export type EventMediaTrackingSumAggregateOutputType = {
  __typename?: 'EventMediaTrackingSumAggregateOutputType';
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  traineeId?: Maybe<Scalars['Int']>;
};

export type EventMediaTrackingSumOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  traineeId?: InputMaybe<SortOrder>;
};

export type EventMediaTrackingUncheckedCreateInput = {
  anat: Scalars['Boolean'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['Boolean'];
  ertiqaa: Scalars['Boolean'];
  eventId: Scalars['Int'];
  facebook: Scalars['Boolean'];
  friend: Scalars['Boolean'];
  google: Scalars['Boolean'];
  id?: InputMaybe<Scalars['Int']>;
  instagram: Scalars['Boolean'];
  linkedin: Scalars['Boolean'];
  telegram: Scalars['Boolean'];
  traineeId: Scalars['Int'];
  twitter: Scalars['Boolean'];
  whatsApp: Scalars['Boolean'];
};

export type EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<EventMediaTrackingWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventMediaTrackingCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventMediaTrackingCreateWithoutEventInput>>>;
  createMany?: InputMaybe<EventMediaTrackingCreateManyEventInputEnvelope>;
};

export type EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput = {
  connect?: InputMaybe<Array<InputMaybe<EventMediaTrackingWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventMediaTrackingCreateOrConnectWithoutTraineeInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventMediaTrackingCreateWithoutTraineeInput>>>;
  createMany?: InputMaybe<EventMediaTrackingCreateManyTraineeInputEnvelope>;
};

export type EventMediaTrackingUncheckedCreateWithoutEventInput = {
  anat: Scalars['Boolean'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['Boolean'];
  ertiqaa: Scalars['Boolean'];
  facebook: Scalars['Boolean'];
  friend: Scalars['Boolean'];
  google: Scalars['Boolean'];
  id?: InputMaybe<Scalars['Int']>;
  instagram: Scalars['Boolean'];
  linkedin: Scalars['Boolean'];
  telegram: Scalars['Boolean'];
  traineeId: Scalars['Int'];
  twitter: Scalars['Boolean'];
  whatsApp: Scalars['Boolean'];
};

export type EventMediaTrackingUncheckedCreateWithoutTraineeInput = {
  anat: Scalars['Boolean'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['Boolean'];
  ertiqaa: Scalars['Boolean'];
  eventId: Scalars['Int'];
  facebook: Scalars['Boolean'];
  friend: Scalars['Boolean'];
  google: Scalars['Boolean'];
  id?: InputMaybe<Scalars['Int']>;
  instagram: Scalars['Boolean'];
  linkedin: Scalars['Boolean'];
  telegram: Scalars['Boolean'];
  twitter: Scalars['Boolean'];
  whatsApp: Scalars['Boolean'];
};

export type EventMediaTrackingUncheckedUpdateInput = {
  anat?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<BoolFieldUpdateOperationsInput>;
  ertiqaa?: InputMaybe<BoolFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  facebook?: InputMaybe<BoolFieldUpdateOperationsInput>;
  friend?: InputMaybe<BoolFieldUpdateOperationsInput>;
  google?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  instagram?: InputMaybe<BoolFieldUpdateOperationsInput>;
  linkedin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  telegram?: InputMaybe<BoolFieldUpdateOperationsInput>;
  traineeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  twitter?: InputMaybe<BoolFieldUpdateOperationsInput>;
  whatsApp?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type EventMediaTrackingUncheckedUpdateManyInput = {
  anat?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<BoolFieldUpdateOperationsInput>;
  ertiqaa?: InputMaybe<BoolFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  facebook?: InputMaybe<BoolFieldUpdateOperationsInput>;
  friend?: InputMaybe<BoolFieldUpdateOperationsInput>;
  google?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  instagram?: InputMaybe<BoolFieldUpdateOperationsInput>;
  linkedin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  telegram?: InputMaybe<BoolFieldUpdateOperationsInput>;
  traineeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  twitter?: InputMaybe<BoolFieldUpdateOperationsInput>;
  whatsApp?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type EventMediaTrackingUncheckedUpdateManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<EventMediaTrackingWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventMediaTrackingCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventMediaTrackingCreateWithoutEventInput>>>;
  createMany?: InputMaybe<EventMediaTrackingCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EventMediaTrackingWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventMediaTrackingScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventMediaTrackingWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventMediaTrackingWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventMediaTrackingUpdateWithWhereUniqueWithoutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventMediaTrackingUpdateManyWithWhereWithoutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventMediaTrackingUpsertWithWhereUniqueWithoutEventInput>>>;
};

export type EventMediaTrackingUncheckedUpdateManyWithoutEventMediaTrackingInput = {
  anat?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<BoolFieldUpdateOperationsInput>;
  ertiqaa?: InputMaybe<BoolFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  facebook?: InputMaybe<BoolFieldUpdateOperationsInput>;
  friend?: InputMaybe<BoolFieldUpdateOperationsInput>;
  google?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  instagram?: InputMaybe<BoolFieldUpdateOperationsInput>;
  linkedin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  telegram?: InputMaybe<BoolFieldUpdateOperationsInput>;
  twitter?: InputMaybe<BoolFieldUpdateOperationsInput>;
  whatsApp?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput = {
  connect?: InputMaybe<Array<InputMaybe<EventMediaTrackingWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventMediaTrackingCreateOrConnectWithoutTraineeInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventMediaTrackingCreateWithoutTraineeInput>>>;
  createMany?: InputMaybe<EventMediaTrackingCreateManyTraineeInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EventMediaTrackingWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventMediaTrackingScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventMediaTrackingWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventMediaTrackingWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventMediaTrackingUpdateWithWhereUniqueWithoutTraineeInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventMediaTrackingUpdateManyWithWhereWithoutTraineeInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventMediaTrackingUpsertWithWhereUniqueWithoutTraineeInput>>>;
};

export type EventMediaTrackingUncheckedUpdateWithoutEventInput = {
  anat?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<BoolFieldUpdateOperationsInput>;
  ertiqaa?: InputMaybe<BoolFieldUpdateOperationsInput>;
  facebook?: InputMaybe<BoolFieldUpdateOperationsInput>;
  friend?: InputMaybe<BoolFieldUpdateOperationsInput>;
  google?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  instagram?: InputMaybe<BoolFieldUpdateOperationsInput>;
  linkedin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  telegram?: InputMaybe<BoolFieldUpdateOperationsInput>;
  traineeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  twitter?: InputMaybe<BoolFieldUpdateOperationsInput>;
  whatsApp?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type EventMediaTrackingUncheckedUpdateWithoutTraineeInput = {
  anat?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<BoolFieldUpdateOperationsInput>;
  ertiqaa?: InputMaybe<BoolFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  facebook?: InputMaybe<BoolFieldUpdateOperationsInput>;
  friend?: InputMaybe<BoolFieldUpdateOperationsInput>;
  google?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  instagram?: InputMaybe<BoolFieldUpdateOperationsInput>;
  linkedin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  telegram?: InputMaybe<BoolFieldUpdateOperationsInput>;
  twitter?: InputMaybe<BoolFieldUpdateOperationsInput>;
  whatsApp?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type EventMediaTrackingUpdateInput = {
  anat?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<BoolFieldUpdateOperationsInput>;
  ertiqaa?: InputMaybe<BoolFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneWithoutEventMediaTrackingInput>;
  facebook?: InputMaybe<BoolFieldUpdateOperationsInput>;
  friend?: InputMaybe<BoolFieldUpdateOperationsInput>;
  google?: InputMaybe<BoolFieldUpdateOperationsInput>;
  instagram?: InputMaybe<BoolFieldUpdateOperationsInput>;
  linkedin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  telegram?: InputMaybe<BoolFieldUpdateOperationsInput>;
  trainee?: InputMaybe<UserUpdateOneWithoutEventMediaTrackingInput>;
  twitter?: InputMaybe<BoolFieldUpdateOperationsInput>;
  whatsApp?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type EventMediaTrackingUpdateManyMutationInput = {
  anat?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<BoolFieldUpdateOperationsInput>;
  ertiqaa?: InputMaybe<BoolFieldUpdateOperationsInput>;
  facebook?: InputMaybe<BoolFieldUpdateOperationsInput>;
  friend?: InputMaybe<BoolFieldUpdateOperationsInput>;
  google?: InputMaybe<BoolFieldUpdateOperationsInput>;
  instagram?: InputMaybe<BoolFieldUpdateOperationsInput>;
  linkedin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  telegram?: InputMaybe<BoolFieldUpdateOperationsInput>;
  twitter?: InputMaybe<BoolFieldUpdateOperationsInput>;
  whatsApp?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type EventMediaTrackingUpdateManyWithWhereWithoutEventInput = {
  data: EventMediaTrackingUncheckedUpdateManyWithoutEventMediaTrackingInput;
  where: EventMediaTrackingScalarWhereInput;
};

export type EventMediaTrackingUpdateManyWithWhereWithoutTraineeInput = {
  data: EventMediaTrackingUncheckedUpdateManyWithoutEventMediaTrackingInput;
  where: EventMediaTrackingScalarWhereInput;
};

export type EventMediaTrackingUpdateManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<EventMediaTrackingWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventMediaTrackingCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventMediaTrackingCreateWithoutEventInput>>>;
  createMany?: InputMaybe<EventMediaTrackingCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EventMediaTrackingWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventMediaTrackingScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventMediaTrackingWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventMediaTrackingWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventMediaTrackingUpdateWithWhereUniqueWithoutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventMediaTrackingUpdateManyWithWhereWithoutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventMediaTrackingUpsertWithWhereUniqueWithoutEventInput>>>;
};

export type EventMediaTrackingUpdateManyWithoutTraineeInput = {
  connect?: InputMaybe<Array<InputMaybe<EventMediaTrackingWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventMediaTrackingCreateOrConnectWithoutTraineeInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventMediaTrackingCreateWithoutTraineeInput>>>;
  createMany?: InputMaybe<EventMediaTrackingCreateManyTraineeInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EventMediaTrackingWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventMediaTrackingScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventMediaTrackingWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventMediaTrackingWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventMediaTrackingUpdateWithWhereUniqueWithoutTraineeInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventMediaTrackingUpdateManyWithWhereWithoutTraineeInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventMediaTrackingUpsertWithWhereUniqueWithoutTraineeInput>>>;
};

export type EventMediaTrackingUpdateWithWhereUniqueWithoutEventInput = {
  data: EventMediaTrackingUncheckedUpdateWithoutEventInput;
  where: EventMediaTrackingWhereUniqueInput;
};

export type EventMediaTrackingUpdateWithWhereUniqueWithoutTraineeInput = {
  data: EventMediaTrackingUncheckedUpdateWithoutTraineeInput;
  where: EventMediaTrackingWhereUniqueInput;
};

export type EventMediaTrackingUpdateWithoutEventInput = {
  anat?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<BoolFieldUpdateOperationsInput>;
  ertiqaa?: InputMaybe<BoolFieldUpdateOperationsInput>;
  facebook?: InputMaybe<BoolFieldUpdateOperationsInput>;
  friend?: InputMaybe<BoolFieldUpdateOperationsInput>;
  google?: InputMaybe<BoolFieldUpdateOperationsInput>;
  instagram?: InputMaybe<BoolFieldUpdateOperationsInput>;
  linkedin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  telegram?: InputMaybe<BoolFieldUpdateOperationsInput>;
  trainee?: InputMaybe<UserUpdateOneWithoutEventMediaTrackingInput>;
  twitter?: InputMaybe<BoolFieldUpdateOperationsInput>;
  whatsApp?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type EventMediaTrackingUpdateWithoutTraineeInput = {
  anat?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<BoolFieldUpdateOperationsInput>;
  ertiqaa?: InputMaybe<BoolFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneWithoutEventMediaTrackingInput>;
  facebook?: InputMaybe<BoolFieldUpdateOperationsInput>;
  friend?: InputMaybe<BoolFieldUpdateOperationsInput>;
  google?: InputMaybe<BoolFieldUpdateOperationsInput>;
  instagram?: InputMaybe<BoolFieldUpdateOperationsInput>;
  linkedin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  telegram?: InputMaybe<BoolFieldUpdateOperationsInput>;
  twitter?: InputMaybe<BoolFieldUpdateOperationsInput>;
  whatsApp?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type EventMediaTrackingUpsertWithWhereUniqueWithoutEventInput = {
  create: EventMediaTrackingUncheckedCreateWithoutEventInput;
  update: EventMediaTrackingUncheckedUpdateWithoutEventInput;
  where: EventMediaTrackingWhereUniqueInput;
};

export type EventMediaTrackingUpsertWithWhereUniqueWithoutTraineeInput = {
  create: EventMediaTrackingUncheckedCreateWithoutTraineeInput;
  update: EventMediaTrackingUncheckedUpdateWithoutTraineeInput;
  where: EventMediaTrackingWhereUniqueInput;
};

export type EventMediaTrackingWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<EventMediaTrackingWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<EventMediaTrackingWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<EventMediaTrackingWhereInput>>>;
  anat?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  email?: InputMaybe<BoolFilter>;
  ertiqaa?: InputMaybe<BoolFilter>;
  event?: InputMaybe<EventWhereInput>;
  eventId?: InputMaybe<IntFilter>;
  facebook?: InputMaybe<BoolFilter>;
  friend?: InputMaybe<BoolFilter>;
  google?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
  instagram?: InputMaybe<BoolFilter>;
  linkedin?: InputMaybe<BoolFilter>;
  telegram?: InputMaybe<BoolFilter>;
  trainee?: InputMaybe<UserWhereInput>;
  traineeId?: InputMaybe<IntFilter>;
  twitter?: InputMaybe<BoolFilter>;
  whatsApp?: InputMaybe<BoolFilter>;
};

export type EventMediaTrackingWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type EventMinAggregateOutputType = {
  __typename?: 'EventMinAggregateOutputType';
  addedById?: Maybe<Scalars['Int']>;
  address?: Maybe<Scalars['String']>;
  addressAr?: Maybe<Scalars['String']>;
  addressInstructions?: Maybe<Scalars['String']>;
  addressInstructionsAr?: Maybe<Scalars['String']>;
  cityId?: Maybe<Scalars['Int']>;
  cmeHours?: Maybe<Scalars['Decimal']>;
  cmeNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultLanguage?: Maybe<LanguageEnum>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  descriptionAr?: Maybe<Scalars['String']>;
  descriptionEn?: Maybe<Scalars['String']>;
  discussionStatus?: Maybe<Scalars['Boolean']>;
  endDate?: Maybe<Scalars['DateTime']>;
  eventTypeId?: Maybe<Scalars['Int']>;
  folderId?: Maybe<Scalars['Int']>;
  hideVideoProgress?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  imageUrl?: Maybe<Scalars['String']>;
  introductionAr?: Maybe<Scalars['String']>;
  introductionEn?: Maybe<Scalars['String']>;
  invitersCanApprovePayments?: Maybe<Scalars['Boolean']>;
  isAccredited?: Maybe<Scalars['Boolean']>;
  isAccreditedSHA?: Maybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: Maybe<Scalars['Boolean']>;
  isContentProvidedByAcademy?: Maybe<Scalars['Boolean']>;
  isRegistraionClosed?: Maybe<Scalars['Boolean']>;
  isSponsored?: Maybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable?: Maybe<Scalars['Boolean']>;
  isTrainerCertificateAvailable?: Maybe<Scalars['Boolean']>;
  leaderTrainerId?: Maybe<Scalars['Int']>;
  locationLatitude?: Maybe<Scalars['Decimal']>;
  locationLongitude?: Maybe<Scalars['Decimal']>;
  mainThemeAr?: Maybe<Scalars['String']>;
  mainThemeEn?: Maybe<Scalars['String']>;
  meetingId?: Maybe<Scalars['String']>;
  methodOfDeliveryId?: Maybe<Scalars['Int']>;
  minAttendancePercentageToGetCertificate?: Maybe<Scalars['Decimal']>;
  numberOfVisits?: Maybe<Scalars['Int']>;
  objectivesAr?: Maybe<Scalars['String']>;
  objectivesEn?: Maybe<Scalars['String']>;
  onlineCapacity?: Maybe<Scalars['Int']>;
  onsiteCapacity?: Maybe<Scalars['Int']>;
  outcomesAr?: Maybe<Scalars['String']>;
  outcomesEn?: Maybe<Scalars['String']>;
  packageId?: Maybe<Scalars['Int']>;
  pricingPlanId?: Maybe<Scalars['Int']>;
  shortDescriptionAr?: Maybe<Scalars['String']>;
  shortDescriptionEn?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  timeTableStatus?: Maybe<Scalars['Boolean']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
  traineeCertificateTemplateId?: Maybe<Scalars['Int']>;
  trainerCertificateTemplateId?: Maybe<Scalars['Int']>;
  visibleOnArchive?: Maybe<Scalars['Boolean']>;
  whyTargetedAudienceAr?: Maybe<Scalars['String']>;
  whyTargetedAudienceEn?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['String']>;
  zoomMeetingId?: Maybe<Scalars['Int']>;
  zoomMode?: Maybe<Scalars['String']>;
};

export type EventMinOrderByAggregateInput = {
  addedById?: InputMaybe<SortOrder>;
  address?: InputMaybe<SortOrder>;
  addressAr?: InputMaybe<SortOrder>;
  addressInstructions?: InputMaybe<SortOrder>;
  addressInstructionsAr?: InputMaybe<SortOrder>;
  cityId?: InputMaybe<SortOrder>;
  cmeHours?: InputMaybe<SortOrder>;
  cmeNumber?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  defaultLanguage?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  descriptionAr?: InputMaybe<SortOrder>;
  descriptionEn?: InputMaybe<SortOrder>;
  discussionStatus?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  eventTypeId?: InputMaybe<SortOrder>;
  folderId?: InputMaybe<SortOrder>;
  hideVideoProgress?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  introductionAr?: InputMaybe<SortOrder>;
  introductionEn?: InputMaybe<SortOrder>;
  invitersCanApprovePayments?: InputMaybe<SortOrder>;
  isAccredited?: InputMaybe<SortOrder>;
  isAccreditedSHA?: InputMaybe<SortOrder>;
  isAllProfessionsTargeted?: InputMaybe<SortOrder>;
  isContentProvidedByAcademy?: InputMaybe<SortOrder>;
  isRegistraionClosed?: InputMaybe<SortOrder>;
  isSponsored?: InputMaybe<SortOrder>;
  isTraineeCertificateAvailable?: InputMaybe<SortOrder>;
  isTrainerCertificateAvailable?: InputMaybe<SortOrder>;
  leaderTrainerId?: InputMaybe<SortOrder>;
  locationLatitude?: InputMaybe<SortOrder>;
  locationLongitude?: InputMaybe<SortOrder>;
  mainThemeAr?: InputMaybe<SortOrder>;
  mainThemeEn?: InputMaybe<SortOrder>;
  meetingId?: InputMaybe<SortOrder>;
  methodOfDeliveryId?: InputMaybe<SortOrder>;
  minAttendancePercentageToGetCertificate?: InputMaybe<SortOrder>;
  numberOfVisits?: InputMaybe<SortOrder>;
  objectivesAr?: InputMaybe<SortOrder>;
  objectivesEn?: InputMaybe<SortOrder>;
  onlineCapacity?: InputMaybe<SortOrder>;
  onsiteCapacity?: InputMaybe<SortOrder>;
  outcomesAr?: InputMaybe<SortOrder>;
  outcomesEn?: InputMaybe<SortOrder>;
  packageId?: InputMaybe<SortOrder>;
  pricingPlanId?: InputMaybe<SortOrder>;
  shortDescriptionAr?: InputMaybe<SortOrder>;
  shortDescriptionEn?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  timeTableStatus?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
  traineeCertificateTemplateId?: InputMaybe<SortOrder>;
  trainerCertificateTemplateId?: InputMaybe<SortOrder>;
  visibleOnArchive?: InputMaybe<SortOrder>;
  whyTargetedAudienceAr?: InputMaybe<SortOrder>;
  whyTargetedAudienceEn?: InputMaybe<SortOrder>;
  youtubeUrl?: InputMaybe<SortOrder>;
  zoomMeetingId?: InputMaybe<SortOrder>;
  zoomMode?: InputMaybe<SortOrder>;
};

export type EventOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type EventOrderByWithAggregationInput = {
  _avg?: InputMaybe<EventAvgOrderByAggregateInput>;
  _count?: InputMaybe<EventCountOrderByAggregateInput>;
  _max?: InputMaybe<EventMaxOrderByAggregateInput>;
  _min?: InputMaybe<EventMinOrderByAggregateInput>;
  _sum?: InputMaybe<EventSumOrderByAggregateInput>;
  addedById?: InputMaybe<SortOrder>;
  address?: InputMaybe<SortOrder>;
  addressAr?: InputMaybe<SortOrder>;
  addressInstructions?: InputMaybe<SortOrder>;
  addressInstructionsAr?: InputMaybe<SortOrder>;
  backgroundImagesUrls?: InputMaybe<SortOrder>;
  cityId?: InputMaybe<SortOrder>;
  cmeHours?: InputMaybe<SortOrder>;
  cmeNumber?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  defaultLanguage?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  descriptionAr?: InputMaybe<SortOrder>;
  descriptionEn?: InputMaybe<SortOrder>;
  discussionStatus?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  eventTypeId?: InputMaybe<SortOrder>;
  folderId?: InputMaybe<SortOrder>;
  hideVideoProgress?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  introductionAr?: InputMaybe<SortOrder>;
  introductionEn?: InputMaybe<SortOrder>;
  invitersCanApprovePayments?: InputMaybe<SortOrder>;
  isAccredited?: InputMaybe<SortOrder>;
  isAccreditedSHA?: InputMaybe<SortOrder>;
  isAllProfessionsTargeted?: InputMaybe<SortOrder>;
  isContentProvidedByAcademy?: InputMaybe<SortOrder>;
  isRegistraionClosed?: InputMaybe<SortOrder>;
  isSponsored?: InputMaybe<SortOrder>;
  isTraineeCertificateAvailable?: InputMaybe<SortOrder>;
  isTrainerCertificateAvailable?: InputMaybe<SortOrder>;
  keywordsAr?: InputMaybe<SortOrder>;
  keywordsEn?: InputMaybe<SortOrder>;
  leaderTrainerId?: InputMaybe<SortOrder>;
  locationLatitude?: InputMaybe<SortOrder>;
  locationLongitude?: InputMaybe<SortOrder>;
  mainThemeAr?: InputMaybe<SortOrder>;
  mainThemeEn?: InputMaybe<SortOrder>;
  meetingId?: InputMaybe<SortOrder>;
  methodOfDeliveryId?: InputMaybe<SortOrder>;
  minAttendancePercentageToGetCertificate?: InputMaybe<SortOrder>;
  numberOfVisits?: InputMaybe<SortOrder>;
  objectivesAr?: InputMaybe<SortOrder>;
  objectivesEn?: InputMaybe<SortOrder>;
  onlineCapacity?: InputMaybe<SortOrder>;
  onsiteCapacity?: InputMaybe<SortOrder>;
  outcomesAr?: InputMaybe<SortOrder>;
  outcomesEn?: InputMaybe<SortOrder>;
  packageId?: InputMaybe<SortOrder>;
  pricingPlanId?: InputMaybe<SortOrder>;
  shortDescriptionAr?: InputMaybe<SortOrder>;
  shortDescriptionEn?: InputMaybe<SortOrder>;
  sponsorshipImagesUrls?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  timeTableStatus?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
  traineeCertificateTemplateId?: InputMaybe<SortOrder>;
  trainerCertificateTemplateId?: InputMaybe<SortOrder>;
  visibleOnArchive?: InputMaybe<SortOrder>;
  whyTargetedAudienceAr?: InputMaybe<SortOrder>;
  whyTargetedAudienceEn?: InputMaybe<SortOrder>;
  youtubeUrl?: InputMaybe<SortOrder>;
  zoomMeetingId?: InputMaybe<SortOrder>;
  zoomMode?: InputMaybe<SortOrder>;
};

export type EventOrderByWithRelationInput = {
  Blogs?: InputMaybe<BlogsOrderByRelationAggregateInput>;
  Certificate?: InputMaybe<CertificateOrderByRelationAggregateInput>;
  Discussion?: InputMaybe<DiscussionOrderByRelationAggregateInput>;
  Quiz?: InputMaybe<QuizOrderByWithRelationInput>;
  QuizResult?: InputMaybe<QuizResultOrderByRelationAggregateInput>;
  ZohoEmail?: InputMaybe<ZohoEmailOrderByRelationAggregateInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingOrderByWithRelationInput>;
  addedBy?: InputMaybe<UserOrderByWithRelationInput>;
  addedById?: InputMaybe<SortOrder>;
  address?: InputMaybe<SortOrder>;
  addressAr?: InputMaybe<SortOrder>;
  addressInstructions?: InputMaybe<SortOrder>;
  addressInstructionsAr?: InputMaybe<SortOrder>;
  backgroundImagesUrls?: InputMaybe<SortOrder>;
  city?: InputMaybe<CityOrderByWithRelationInput>;
  cityId?: InputMaybe<SortOrder>;
  cmeHours?: InputMaybe<SortOrder>;
  cmeNumber?: InputMaybe<SortOrder>;
  coupons?: InputMaybe<CouponOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  defaultLanguage?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  descriptionAr?: InputMaybe<SortOrder>;
  descriptionEn?: InputMaybe<SortOrder>;
  discussionStatus?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  eventDays?: InputMaybe<EventDayOrderByRelationAggregateInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateOrderByWithRelationInput>;
  eventLanguages?: InputMaybe<LanguageOrderByRelationAggregateInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingOrderByRelationAggregateInput>;
  eventParts?: InputMaybe<EventPartOrderByRelationAggregateInput>;
  eventType?: InputMaybe<EventTypeOrderByWithRelationInput>;
  eventTypeId?: InputMaybe<SortOrder>;
  expensesTransitions?: InputMaybe<TransitionOrderByRelationAggregateInput>;
  folder?: InputMaybe<EventFolderOrderByWithRelationInput>;
  folderId?: InputMaybe<SortOrder>;
  hiddenEvent?: InputMaybe<HiddenEventsOrderByWithRelationInput>;
  hideVideoProgress?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  introductionAr?: InputMaybe<SortOrder>;
  introductionEn?: InputMaybe<SortOrder>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitOrderByRelationAggregateInput>;
  invitersCanApprovePayments?: InputMaybe<SortOrder>;
  isAccredited?: InputMaybe<SortOrder>;
  isAccreditedSHA?: InputMaybe<SortOrder>;
  isAllProfessionsTargeted?: InputMaybe<SortOrder>;
  isContentProvidedByAcademy?: InputMaybe<SortOrder>;
  isRegistraionClosed?: InputMaybe<SortOrder>;
  isSponsored?: InputMaybe<SortOrder>;
  isTraineeCertificateAvailable?: InputMaybe<SortOrder>;
  isTrainerCertificateAvailable?: InputMaybe<SortOrder>;
  keywordsAr?: InputMaybe<SortOrder>;
  keywordsEn?: InputMaybe<SortOrder>;
  leaderTrainer?: InputMaybe<UserOrderByWithRelationInput>;
  leaderTrainerId?: InputMaybe<SortOrder>;
  locationLatitude?: InputMaybe<SortOrder>;
  locationLongitude?: InputMaybe<SortOrder>;
  mainThemeAr?: InputMaybe<SortOrder>;
  mainThemeEn?: InputMaybe<SortOrder>;
  meetingId?: InputMaybe<SortOrder>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryOrderByWithRelationInput>;
  methodOfDeliveryId?: InputMaybe<SortOrder>;
  minAttendancePercentageToGetCertificate?: InputMaybe<SortOrder>;
  numberOfVisits?: InputMaybe<SortOrder>;
  objectivesAr?: InputMaybe<SortOrder>;
  objectivesEn?: InputMaybe<SortOrder>;
  onlineCapacity?: InputMaybe<SortOrder>;
  onsiteCapacity?: InputMaybe<SortOrder>;
  outcomesAr?: InputMaybe<SortOrder>;
  outcomesEn?: InputMaybe<SortOrder>;
  package?: InputMaybe<EventOrderByWithRelationInput>;
  packageEvents?: InputMaybe<EventOrderByRelationAggregateInput>;
  packageId?: InputMaybe<SortOrder>;
  pricingPlan?: InputMaybe<PricingPlanOrderByWithRelationInput>;
  pricingPlanId?: InputMaybe<SortOrder>;
  remindMeTrainees?: InputMaybe<UserOrderByRelationAggregateInput>;
  shortDescriptionAr?: InputMaybe<SortOrder>;
  shortDescriptionEn?: InputMaybe<SortOrder>;
  sponsorshipImagesUrls?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  targetedAudiences?: InputMaybe<ProfessionOrderByRelationAggregateInput>;
  targetedSpecialities?: InputMaybe<SpecialtyOrderByRelationAggregateInput>;
  timeTableStatus?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
  traineeCertificateTemplate?: InputMaybe<TemplateOrderByWithRelationInput>;
  traineeCertificateTemplateId?: InputMaybe<SortOrder>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupOrderByRelationAggregateInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewOrderByRelationAggregateInput>;
  traineeEvents?: InputMaybe<TraineeEventOrderByRelationAggregateInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateOrderByWithRelationInput>;
  trainerCertificateTemplateId?: InputMaybe<SortOrder>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupOrderByRelationAggregateInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialOrderByRelationAggregateInput>;
  trainerEvents?: InputMaybe<TrainerEventOrderByRelationAggregateInput>;
  visibleOnArchive?: InputMaybe<SortOrder>;
  visitedTrainees?: InputMaybe<UserOrderByRelationAggregateInput>;
  whyTargetedAudienceAr?: InputMaybe<SortOrder>;
  whyTargetedAudienceEn?: InputMaybe<SortOrder>;
  youtubeUrl?: InputMaybe<SortOrder>;
  zoomMeetingId?: InputMaybe<SortOrder>;
  zoomMode?: InputMaybe<SortOrder>;
};

export type EventPart = {
  __typename?: 'EventPart';
  _count: EventPartCountOutputType;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: Event;
  eventDays: Array<EventDay>;
  eventId: Scalars['Int'];
  id: Scalars['Int'];
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  pricingPlan: PricingPlan;
  pricingPlanId: Scalars['Int'];
  trainees: Array<TraineeEventPart>;
};


export type EventPartEventDaysArgs = {
  cursor?: InputMaybe<EventDayWhereUniqueInput>;
  distinct?: InputMaybe<EventDayScalarFieldEnum>;
  orderBy?: InputMaybe<EventDayOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EventDayWhereInput>;
};


export type EventPartTraineesArgs = {
  cursor?: InputMaybe<TraineeEventPartWhereUniqueInput>;
  distinct?: InputMaybe<TraineeEventPartScalarFieldEnum>;
  orderBy?: InputMaybe<TraineeEventPartOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeEventPartWhereInput>;
};

export type EventPartAvgAggregateOutputType = {
  __typename?: 'EventPartAvgAggregateOutputType';
  eventId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  pricingPlanId?: Maybe<Scalars['Float']>;
};

export type EventPartAvgOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pricingPlanId?: InputMaybe<SortOrder>;
};

export type EventPartCountAggregateOutputType = {
  __typename?: 'EventPartCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  eventId: Scalars['Int'];
  id: Scalars['Int'];
  outlineAr: Scalars['Int'];
  outlineEn: Scalars['Int'];
  pricingPlanId: Scalars['Int'];
};

export type EventPartCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  outlineAr?: InputMaybe<SortOrder>;
  outlineEn?: InputMaybe<SortOrder>;
  pricingPlanId?: InputMaybe<SortOrder>;
};

export type EventPartCountOutputType = {
  __typename?: 'EventPartCountOutputType';
  eventDays: Scalars['Int'];
  trainees: Scalars['Int'];
};

export type EventPartCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  event: EventCreateNestedOneWithoutEventPartsInput;
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventPartInput>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  pricingPlan: PricingPlanCreateNestedOneWithoutEventPartInput;
  trainees?: InputMaybe<TraineeEventPartCreateNestedManyWithoutEventPartInput>;
};

export type EventPartCreateManyEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  pricingPlanId: Scalars['Int'];
};

export type EventPartCreateManyEventInputEnvelope = {
  data: EventPartCreateManyEventInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type EventPartCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  pricingPlanId: Scalars['Int'];
};

export type EventPartCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<EventPartWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventPartCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventPartCreateWithoutEventInput>>>;
  createMany?: InputMaybe<EventPartCreateManyEventInputEnvelope>;
};

export type EventPartCreateNestedOneWithoutEventDaysInput = {
  connect?: InputMaybe<EventPartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventPartCreateOrConnectWithoutEventDaysInput>;
  create?: InputMaybe<EventPartUncheckedCreateWithoutEventDaysInput>;
};

export type EventPartCreateNestedOneWithoutPricingPlanInput = {
  connect?: InputMaybe<EventPartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventPartCreateOrConnectWithoutPricingPlanInput>;
  create?: InputMaybe<EventPartUncheckedCreateWithoutPricingPlanInput>;
};

export type EventPartCreateNestedOneWithoutTraineesInput = {
  connect?: InputMaybe<EventPartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventPartCreateOrConnectWithoutTraineesInput>;
  create?: InputMaybe<EventPartUncheckedCreateWithoutTraineesInput>;
};

export type EventPartCreateOrConnectWithoutEventDaysInput = {
  create: EventPartUncheckedCreateWithoutEventDaysInput;
  where: EventPartWhereUniqueInput;
};

export type EventPartCreateOrConnectWithoutEventInput = {
  create: EventPartUncheckedCreateWithoutEventInput;
  where: EventPartWhereUniqueInput;
};

export type EventPartCreateOrConnectWithoutPricingPlanInput = {
  create: EventPartUncheckedCreateWithoutPricingPlanInput;
  where: EventPartWhereUniqueInput;
};

export type EventPartCreateOrConnectWithoutTraineesInput = {
  create: EventPartUncheckedCreateWithoutTraineesInput;
  where: EventPartWhereUniqueInput;
};

export type EventPartCreateWithoutEventDaysInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  event: EventCreateNestedOneWithoutEventPartsInput;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  pricingPlan: PricingPlanCreateNestedOneWithoutEventPartInput;
  trainees?: InputMaybe<TraineeEventPartCreateNestedManyWithoutEventPartInput>;
};

export type EventPartCreateWithoutEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventPartInput>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  pricingPlan: PricingPlanCreateNestedOneWithoutEventPartInput;
  trainees?: InputMaybe<TraineeEventPartCreateNestedManyWithoutEventPartInput>;
};

export type EventPartCreateWithoutPricingPlanInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  event: EventCreateNestedOneWithoutEventPartsInput;
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventPartInput>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  trainees?: InputMaybe<TraineeEventPartCreateNestedManyWithoutEventPartInput>;
};

export type EventPartCreateWithoutTraineesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  event: EventCreateNestedOneWithoutEventPartsInput;
  eventDays?: InputMaybe<EventDayCreateNestedManyWithoutEventPartInput>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  pricingPlan: PricingPlanCreateNestedOneWithoutEventPartInput;
};

export type EventPartListRelationFilter = {
  every?: InputMaybe<EventPartWhereInput>;
  none?: InputMaybe<EventPartWhereInput>;
  some?: InputMaybe<EventPartWhereInput>;
};

export type EventPartMaxAggregateOutputType = {
  __typename?: 'EventPartMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  outlineAr?: Maybe<Scalars['String']>;
  outlineEn?: Maybe<Scalars['String']>;
  pricingPlanId?: Maybe<Scalars['Int']>;
};

export type EventPartMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  outlineAr?: InputMaybe<SortOrder>;
  outlineEn?: InputMaybe<SortOrder>;
  pricingPlanId?: InputMaybe<SortOrder>;
};

export type EventPartMinAggregateOutputType = {
  __typename?: 'EventPartMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  outlineAr?: Maybe<Scalars['String']>;
  outlineEn?: Maybe<Scalars['String']>;
  pricingPlanId?: Maybe<Scalars['Int']>;
};

export type EventPartMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  outlineAr?: InputMaybe<SortOrder>;
  outlineEn?: InputMaybe<SortOrder>;
  pricingPlanId?: InputMaybe<SortOrder>;
};

export type EventPartOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type EventPartOrderByWithAggregationInput = {
  _avg?: InputMaybe<EventPartAvgOrderByAggregateInput>;
  _count?: InputMaybe<EventPartCountOrderByAggregateInput>;
  _max?: InputMaybe<EventPartMaxOrderByAggregateInput>;
  _min?: InputMaybe<EventPartMinOrderByAggregateInput>;
  _sum?: InputMaybe<EventPartSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  outlineAr?: InputMaybe<SortOrder>;
  outlineEn?: InputMaybe<SortOrder>;
  pricingPlanId?: InputMaybe<SortOrder>;
};

export type EventPartOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  event?: InputMaybe<EventOrderByWithRelationInput>;
  eventDays?: InputMaybe<EventDayOrderByRelationAggregateInput>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  outlineAr?: InputMaybe<SortOrder>;
  outlineEn?: InputMaybe<SortOrder>;
  pricingPlan?: InputMaybe<PricingPlanOrderByWithRelationInput>;
  pricingPlanId?: InputMaybe<SortOrder>;
  trainees?: InputMaybe<TraineeEventPartOrderByRelationAggregateInput>;
};

export type EventPartRelationFilter = {
  is?: InputMaybe<EventPartWhereInput>;
  isNot?: InputMaybe<EventPartWhereInput>;
};

export enum EventPartScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  EventId = 'eventId',
  Id = 'id',
  OutlineAr = 'outlineAr',
  OutlineEn = 'outlineEn',
  PricingPlanId = 'pricingPlanId'
}

export type EventPartScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<EventPartScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<EventPartScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<EventPartScalarWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  eventId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  outlineAr?: InputMaybe<StringFilter>;
  outlineEn?: InputMaybe<StringFilter>;
  pricingPlanId?: InputMaybe<IntFilter>;
};

export type EventPartScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<EventPartScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<EventPartScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<EventPartScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  eventId?: InputMaybe<IntWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  outlineAr?: InputMaybe<StringWithAggregatesFilter>;
  outlineEn?: InputMaybe<StringWithAggregatesFilter>;
  pricingPlanId?: InputMaybe<IntWithAggregatesFilter>;
};

export type EventPartSumAggregateOutputType = {
  __typename?: 'EventPartSumAggregateOutputType';
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  pricingPlanId?: Maybe<Scalars['Int']>;
};

export type EventPartSumOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pricingPlanId?: InputMaybe<SortOrder>;
};

export type EventPartUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventPartInput>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  pricingPlanId: Scalars['Int'];
  trainees?: InputMaybe<TraineeEventPartUncheckedCreateNestedManyWithoutEventPartInput>;
};

export type EventPartUncheckedCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<EventPartWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventPartCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventPartCreateWithoutEventInput>>>;
  createMany?: InputMaybe<EventPartCreateManyEventInputEnvelope>;
};

export type EventPartUncheckedCreateNestedOneWithoutPricingPlanInput = {
  connect?: InputMaybe<EventPartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventPartCreateOrConnectWithoutPricingPlanInput>;
  create?: InputMaybe<EventPartUncheckedCreateWithoutPricingPlanInput>;
};

export type EventPartUncheckedCreateWithoutEventDaysInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  pricingPlanId: Scalars['Int'];
  trainees?: InputMaybe<TraineeEventPartUncheckedCreateNestedManyWithoutEventPartInput>;
};

export type EventPartUncheckedCreateWithoutEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventPartInput>;
  id?: InputMaybe<Scalars['Int']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  pricingPlanId: Scalars['Int'];
  trainees?: InputMaybe<TraineeEventPartUncheckedCreateNestedManyWithoutEventPartInput>;
};

export type EventPartUncheckedCreateWithoutPricingPlanInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventPartInput>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  trainees?: InputMaybe<TraineeEventPartUncheckedCreateNestedManyWithoutEventPartInput>;
};

export type EventPartUncheckedCreateWithoutTraineesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventPartInput>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  pricingPlanId: Scalars['Int'];
};

export type EventPartUncheckedUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventPartInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  trainees?: InputMaybe<TraineeEventPartUncheckedUpdateManyWithoutEventPartInput>;
};

export type EventPartUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type EventPartUncheckedUpdateManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<EventPartWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventPartCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventPartCreateWithoutEventInput>>>;
  createMany?: InputMaybe<EventPartCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EventPartWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventPartScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventPartWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventPartWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventPartUpdateWithWhereUniqueWithoutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventPartUpdateManyWithWhereWithoutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventPartUpsertWithWhereUniqueWithoutEventInput>>>;
};

export type EventPartUncheckedUpdateManyWithoutEventPartsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type EventPartUncheckedUpdateOneWithoutPricingPlanInput = {
  connect?: InputMaybe<EventPartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventPartCreateOrConnectWithoutPricingPlanInput>;
  create?: InputMaybe<EventPartUncheckedCreateWithoutPricingPlanInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<EventPartUncheckedUpdateWithoutPricingPlanInput>;
  upsert?: InputMaybe<EventPartUpsertWithoutPricingPlanInput>;
};

export type EventPartUncheckedUpdateWithoutEventDaysInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  trainees?: InputMaybe<TraineeEventPartUncheckedUpdateManyWithoutEventPartInput>;
};

export type EventPartUncheckedUpdateWithoutEventInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventPartInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventPartInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  trainees?: InputMaybe<TraineeEventPartUncheckedUpdateManyWithoutEventPartInput>;
};

export type EventPartUncheckedUpdateWithoutPricingPlanInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventPartInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  trainees?: InputMaybe<TraineeEventPartUncheckedUpdateManyWithoutEventPartInput>;
};

export type EventPartUncheckedUpdateWithoutTraineesInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventPartInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type EventPartUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutEventPartsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventPartInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventPartInput>;
  trainees?: InputMaybe<TraineeEventPartUpdateManyWithoutEventPartInput>;
};

export type EventPartUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EventPartUpdateManyWithWhereWithoutEventInput = {
  data: EventPartUncheckedUpdateManyWithoutEventPartsInput;
  where: EventPartScalarWhereInput;
};

export type EventPartUpdateManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<EventPartWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventPartCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventPartCreateWithoutEventInput>>>;
  createMany?: InputMaybe<EventPartCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EventPartWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventPartScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventPartWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventPartWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventPartUpdateWithWhereUniqueWithoutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventPartUpdateManyWithWhereWithoutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventPartUpsertWithWhereUniqueWithoutEventInput>>>;
};

export type EventPartUpdateOneRequiredWithoutTraineesInput = {
  connect?: InputMaybe<EventPartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventPartCreateOrConnectWithoutTraineesInput>;
  create?: InputMaybe<EventPartUncheckedCreateWithoutTraineesInput>;
  update?: InputMaybe<EventPartUncheckedUpdateWithoutTraineesInput>;
  upsert?: InputMaybe<EventPartUpsertWithoutTraineesInput>;
};

export type EventPartUpdateOneWithoutEventDaysInput = {
  connect?: InputMaybe<EventPartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventPartCreateOrConnectWithoutEventDaysInput>;
  create?: InputMaybe<EventPartUncheckedCreateWithoutEventDaysInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<EventPartUncheckedUpdateWithoutEventDaysInput>;
  upsert?: InputMaybe<EventPartUpsertWithoutEventDaysInput>;
};

export type EventPartUpdateOneWithoutPricingPlanInput = {
  connect?: InputMaybe<EventPartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventPartCreateOrConnectWithoutPricingPlanInput>;
  create?: InputMaybe<EventPartUncheckedCreateWithoutPricingPlanInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<EventPartUncheckedUpdateWithoutPricingPlanInput>;
  upsert?: InputMaybe<EventPartUpsertWithoutPricingPlanInput>;
};

export type EventPartUpdateWithWhereUniqueWithoutEventInput = {
  data: EventPartUncheckedUpdateWithoutEventInput;
  where: EventPartWhereUniqueInput;
};

export type EventPartUpdateWithoutEventDaysInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutEventPartsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventPartInput>;
  trainees?: InputMaybe<TraineeEventPartUpdateManyWithoutEventPartInput>;
};

export type EventPartUpdateWithoutEventInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventPartInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventPartInput>;
  trainees?: InputMaybe<TraineeEventPartUpdateManyWithoutEventPartInput>;
};

export type EventPartUpdateWithoutPricingPlanInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutEventPartsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventPartInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  trainees?: InputMaybe<TraineeEventPartUpdateManyWithoutEventPartInput>;
};

export type EventPartUpdateWithoutTraineesInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutEventPartsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventPartInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventPartInput>;
};

export type EventPartUpsertWithWhereUniqueWithoutEventInput = {
  create: EventPartUncheckedCreateWithoutEventInput;
  update: EventPartUncheckedUpdateWithoutEventInput;
  where: EventPartWhereUniqueInput;
};

export type EventPartUpsertWithoutEventDaysInput = {
  create: EventPartUncheckedCreateWithoutEventDaysInput;
  update: EventPartUncheckedUpdateWithoutEventDaysInput;
};

export type EventPartUpsertWithoutPricingPlanInput = {
  create: EventPartUncheckedCreateWithoutPricingPlanInput;
  update: EventPartUncheckedUpdateWithoutPricingPlanInput;
};

export type EventPartUpsertWithoutTraineesInput = {
  create: EventPartUncheckedCreateWithoutTraineesInput;
  update: EventPartUncheckedUpdateWithoutTraineesInput;
};

export type EventPartWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<EventPartWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<EventPartWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<EventPartWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  event?: InputMaybe<EventWhereInput>;
  eventDays?: InputMaybe<EventDayListRelationFilter>;
  eventId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  outlineAr?: InputMaybe<StringFilter>;
  outlineEn?: InputMaybe<StringFilter>;
  pricingPlan?: InputMaybe<PricingPlanWhereInput>;
  pricingPlanId?: InputMaybe<IntFilter>;
  trainees?: InputMaybe<TraineeEventPartListRelationFilter>;
};

export type EventPartWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  pricingPlanId?: InputMaybe<Scalars['Int']>;
};

export type EventRelationFilter = {
  is?: InputMaybe<EventWhereInput>;
  isNot?: InputMaybe<EventWhereInput>;
};

export enum EventScalarFieldEnum {
  AddedById = 'addedById',
  Address = 'address',
  AddressAr = 'addressAr',
  AddressInstructions = 'addressInstructions',
  AddressInstructionsAr = 'addressInstructionsAr',
  BackgroundImagesUrls = 'backgroundImagesUrls',
  CityId = 'cityId',
  CmeHours = 'cmeHours',
  CmeNumber = 'cmeNumber',
  CreatedAt = 'createdAt',
  DefaultLanguage = 'defaultLanguage',
  DeletedAt = 'deletedAt',
  DescriptionAr = 'descriptionAr',
  DescriptionEn = 'descriptionEn',
  DiscussionStatus = 'discussionStatus',
  EndDate = 'endDate',
  EventTypeId = 'eventTypeId',
  FolderId = 'folderId',
  HideVideoProgress = 'hideVideoProgress',
  Id = 'id',
  ImageUrl = 'imageUrl',
  IntroductionAr = 'introductionAr',
  IntroductionEn = 'introductionEn',
  InvitersCanApprovePayments = 'invitersCanApprovePayments',
  IsAccredited = 'isAccredited',
  IsAccreditedSha = 'isAccreditedSHA',
  IsAllProfessionsTargeted = 'isAllProfessionsTargeted',
  IsContentProvidedByAcademy = 'isContentProvidedByAcademy',
  IsRegistraionClosed = 'isRegistraionClosed',
  IsSponsored = 'isSponsored',
  IsTraineeCertificateAvailable = 'isTraineeCertificateAvailable',
  IsTrainerCertificateAvailable = 'isTrainerCertificateAvailable',
  KeywordsAr = 'keywordsAr',
  KeywordsEn = 'keywordsEn',
  LeaderTrainerId = 'leaderTrainerId',
  LocationLatitude = 'locationLatitude',
  LocationLongitude = 'locationLongitude',
  MainThemeAr = 'mainThemeAr',
  MainThemeEn = 'mainThemeEn',
  MeetingId = 'meetingId',
  MethodOfDeliveryId = 'methodOfDeliveryId',
  MinAttendancePercentageToGetCertificate = 'minAttendancePercentageToGetCertificate',
  NumberOfVisits = 'numberOfVisits',
  ObjectivesAr = 'objectivesAr',
  ObjectivesEn = 'objectivesEn',
  OnlineCapacity = 'onlineCapacity',
  OnsiteCapacity = 'onsiteCapacity',
  OutcomesAr = 'outcomesAr',
  OutcomesEn = 'outcomesEn',
  PackageId = 'packageId',
  PricingPlanId = 'pricingPlanId',
  ShortDescriptionAr = 'shortDescriptionAr',
  ShortDescriptionEn = 'shortDescriptionEn',
  SponsorshipImagesUrls = 'sponsorshipImagesUrls',
  StartDate = 'startDate',
  TimeTableStatus = 'timeTableStatus',
  TitleAr = 'titleAr',
  TitleEn = 'titleEn',
  TraineeCertificateTemplateId = 'traineeCertificateTemplateId',
  TrainerCertificateTemplateId = 'trainerCertificateTemplateId',
  VisibleOnArchive = 'visibleOnArchive',
  WhyTargetedAudienceAr = 'whyTargetedAudienceAr',
  WhyTargetedAudienceEn = 'whyTargetedAudienceEn',
  YoutubeUrl = 'youtubeUrl',
  ZoomMeetingId = 'zoomMeetingId',
  ZoomMode = 'zoomMode'
}

export type EventScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  addedById?: InputMaybe<IntNullableFilter>;
  address?: InputMaybe<StringNullableFilter>;
  addressAr?: InputMaybe<StringNullableFilter>;
  addressInstructions?: InputMaybe<StringNullableFilter>;
  addressInstructionsAr?: InputMaybe<StringNullableFilter>;
  backgroundImagesUrls?: InputMaybe<StringNullableListFilter>;
  cityId?: InputMaybe<IntNullableFilter>;
  cmeHours?: InputMaybe<DecimalNullableFilter>;
  cmeNumber?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  descriptionAr?: InputMaybe<StringNullableFilter>;
  descriptionEn?: InputMaybe<StringNullableFilter>;
  discussionStatus?: InputMaybe<BoolFilter>;
  endDate?: InputMaybe<DateTimeFilter>;
  eventTypeId?: InputMaybe<IntFilter>;
  folderId?: InputMaybe<IntFilter>;
  hideVideoProgress?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<IntFilter>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  introductionAr?: InputMaybe<StringNullableFilter>;
  introductionEn?: InputMaybe<StringNullableFilter>;
  invitersCanApprovePayments?: InputMaybe<BoolNullableFilter>;
  isAccredited?: InputMaybe<BoolFilter>;
  isAccreditedSHA?: InputMaybe<BoolFilter>;
  isAllProfessionsTargeted?: InputMaybe<BoolNullableFilter>;
  isContentProvidedByAcademy?: InputMaybe<BoolFilter>;
  isRegistraionClosed?: InputMaybe<BoolNullableFilter>;
  isSponsored?: InputMaybe<BoolFilter>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFilter>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFilter>;
  keywordsAr?: InputMaybe<StringNullableListFilter>;
  keywordsEn?: InputMaybe<StringNullableListFilter>;
  leaderTrainerId?: InputMaybe<IntNullableFilter>;
  locationLatitude?: InputMaybe<DecimalNullableFilter>;
  locationLongitude?: InputMaybe<DecimalNullableFilter>;
  mainThemeAr?: InputMaybe<StringNullableFilter>;
  mainThemeEn?: InputMaybe<StringNullableFilter>;
  meetingId?: InputMaybe<StringNullableFilter>;
  methodOfDeliveryId?: InputMaybe<IntFilter>;
  minAttendancePercentageToGetCertificate?: InputMaybe<DecimalNullableFilter>;
  numberOfVisits?: InputMaybe<IntNullableFilter>;
  objectivesAr?: InputMaybe<StringNullableFilter>;
  objectivesEn?: InputMaybe<StringNullableFilter>;
  onlineCapacity?: InputMaybe<IntNullableFilter>;
  onsiteCapacity?: InputMaybe<IntNullableFilter>;
  outcomesAr?: InputMaybe<StringNullableFilter>;
  outcomesEn?: InputMaybe<StringNullableFilter>;
  packageId?: InputMaybe<IntNullableFilter>;
  pricingPlanId?: InputMaybe<IntFilter>;
  shortDescriptionAr?: InputMaybe<StringNullableFilter>;
  shortDescriptionEn?: InputMaybe<StringNullableFilter>;
  sponsorshipImagesUrls?: InputMaybe<JsonNullableFilter>;
  startDate?: InputMaybe<DateTimeFilter>;
  timeTableStatus?: InputMaybe<BoolFilter>;
  titleAr?: InputMaybe<StringFilter>;
  titleEn?: InputMaybe<StringFilter>;
  traineeCertificateTemplateId?: InputMaybe<IntNullableFilter>;
  trainerCertificateTemplateId?: InputMaybe<IntNullableFilter>;
  visibleOnArchive?: InputMaybe<BoolNullableFilter>;
  whyTargetedAudienceAr?: InputMaybe<StringNullableFilter>;
  whyTargetedAudienceEn?: InputMaybe<StringNullableFilter>;
  youtubeUrl?: InputMaybe<StringNullableFilter>;
  zoomMeetingId?: InputMaybe<IntNullableFilter>;
  zoomMode?: InputMaybe<StringNullableFilter>;
};

export type EventScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<EventScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<EventScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<EventScalarWhereWithAggregatesInput>>>;
  addedById?: InputMaybe<IntNullableWithAggregatesFilter>;
  address?: InputMaybe<StringNullableWithAggregatesFilter>;
  addressAr?: InputMaybe<StringNullableWithAggregatesFilter>;
  addressInstructions?: InputMaybe<StringNullableWithAggregatesFilter>;
  addressInstructionsAr?: InputMaybe<StringNullableWithAggregatesFilter>;
  backgroundImagesUrls?: InputMaybe<StringNullableListFilter>;
  cityId?: InputMaybe<IntNullableWithAggregatesFilter>;
  cmeHours?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  cmeNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  descriptionAr?: InputMaybe<StringNullableWithAggregatesFilter>;
  descriptionEn?: InputMaybe<StringNullableWithAggregatesFilter>;
  discussionStatus?: InputMaybe<BoolWithAggregatesFilter>;
  endDate?: InputMaybe<DateTimeWithAggregatesFilter>;
  eventTypeId?: InputMaybe<IntWithAggregatesFilter>;
  folderId?: InputMaybe<IntWithAggregatesFilter>;
  hideVideoProgress?: InputMaybe<BoolNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  imageUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  introductionAr?: InputMaybe<StringNullableWithAggregatesFilter>;
  introductionEn?: InputMaybe<StringNullableWithAggregatesFilter>;
  invitersCanApprovePayments?: InputMaybe<BoolNullableWithAggregatesFilter>;
  isAccredited?: InputMaybe<BoolWithAggregatesFilter>;
  isAccreditedSHA?: InputMaybe<BoolWithAggregatesFilter>;
  isAllProfessionsTargeted?: InputMaybe<BoolNullableWithAggregatesFilter>;
  isContentProvidedByAcademy?: InputMaybe<BoolWithAggregatesFilter>;
  isRegistraionClosed?: InputMaybe<BoolNullableWithAggregatesFilter>;
  isSponsored?: InputMaybe<BoolWithAggregatesFilter>;
  isTraineeCertificateAvailable?: InputMaybe<BoolWithAggregatesFilter>;
  isTrainerCertificateAvailable?: InputMaybe<BoolWithAggregatesFilter>;
  keywordsAr?: InputMaybe<StringNullableListFilter>;
  keywordsEn?: InputMaybe<StringNullableListFilter>;
  leaderTrainerId?: InputMaybe<IntNullableWithAggregatesFilter>;
  locationLatitude?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  locationLongitude?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  mainThemeAr?: InputMaybe<StringNullableWithAggregatesFilter>;
  mainThemeEn?: InputMaybe<StringNullableWithAggregatesFilter>;
  meetingId?: InputMaybe<StringNullableWithAggregatesFilter>;
  methodOfDeliveryId?: InputMaybe<IntWithAggregatesFilter>;
  minAttendancePercentageToGetCertificate?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  numberOfVisits?: InputMaybe<IntNullableWithAggregatesFilter>;
  objectivesAr?: InputMaybe<StringNullableWithAggregatesFilter>;
  objectivesEn?: InputMaybe<StringNullableWithAggregatesFilter>;
  onlineCapacity?: InputMaybe<IntNullableWithAggregatesFilter>;
  onsiteCapacity?: InputMaybe<IntNullableWithAggregatesFilter>;
  outcomesAr?: InputMaybe<StringNullableWithAggregatesFilter>;
  outcomesEn?: InputMaybe<StringNullableWithAggregatesFilter>;
  packageId?: InputMaybe<IntNullableWithAggregatesFilter>;
  pricingPlanId?: InputMaybe<IntWithAggregatesFilter>;
  shortDescriptionAr?: InputMaybe<StringNullableWithAggregatesFilter>;
  shortDescriptionEn?: InputMaybe<StringNullableWithAggregatesFilter>;
  sponsorshipImagesUrls?: InputMaybe<JsonNullableWithAggregatesFilter>;
  startDate?: InputMaybe<DateTimeWithAggregatesFilter>;
  timeTableStatus?: InputMaybe<BoolWithAggregatesFilter>;
  titleAr?: InputMaybe<StringWithAggregatesFilter>;
  titleEn?: InputMaybe<StringWithAggregatesFilter>;
  traineeCertificateTemplateId?: InputMaybe<IntNullableWithAggregatesFilter>;
  trainerCertificateTemplateId?: InputMaybe<IntNullableWithAggregatesFilter>;
  visibleOnArchive?: InputMaybe<BoolNullableWithAggregatesFilter>;
  whyTargetedAudienceAr?: InputMaybe<StringNullableWithAggregatesFilter>;
  whyTargetedAudienceEn?: InputMaybe<StringNullableWithAggregatesFilter>;
  youtubeUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  zoomMeetingId?: InputMaybe<IntNullableWithAggregatesFilter>;
  zoomMode?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type EventSumAggregateOutputType = {
  __typename?: 'EventSumAggregateOutputType';
  addedById?: Maybe<Scalars['Int']>;
  cityId?: Maybe<Scalars['Int']>;
  cmeHours?: Maybe<Scalars['Decimal']>;
  eventTypeId?: Maybe<Scalars['Int']>;
  folderId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  leaderTrainerId?: Maybe<Scalars['Int']>;
  locationLatitude?: Maybe<Scalars['Decimal']>;
  locationLongitude?: Maybe<Scalars['Decimal']>;
  methodOfDeliveryId?: Maybe<Scalars['Int']>;
  minAttendancePercentageToGetCertificate?: Maybe<Scalars['Decimal']>;
  numberOfVisits?: Maybe<Scalars['Int']>;
  onlineCapacity?: Maybe<Scalars['Int']>;
  onsiteCapacity?: Maybe<Scalars['Int']>;
  packageId?: Maybe<Scalars['Int']>;
  pricingPlanId?: Maybe<Scalars['Int']>;
  traineeCertificateTemplateId?: Maybe<Scalars['Int']>;
  trainerCertificateTemplateId?: Maybe<Scalars['Int']>;
  zoomMeetingId?: Maybe<Scalars['Int']>;
};

export type EventSumOrderByAggregateInput = {
  addedById?: InputMaybe<SortOrder>;
  cityId?: InputMaybe<SortOrder>;
  cmeHours?: InputMaybe<SortOrder>;
  eventTypeId?: InputMaybe<SortOrder>;
  folderId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  leaderTrainerId?: InputMaybe<SortOrder>;
  locationLatitude?: InputMaybe<SortOrder>;
  locationLongitude?: InputMaybe<SortOrder>;
  methodOfDeliveryId?: InputMaybe<SortOrder>;
  minAttendancePercentageToGetCertificate?: InputMaybe<SortOrder>;
  numberOfVisits?: InputMaybe<SortOrder>;
  onlineCapacity?: InputMaybe<SortOrder>;
  onsiteCapacity?: InputMaybe<SortOrder>;
  packageId?: InputMaybe<SortOrder>;
  pricingPlanId?: InputMaybe<SortOrder>;
  traineeCertificateTemplateId?: InputMaybe<SortOrder>;
  trainerCertificateTemplateId?: InputMaybe<SortOrder>;
  zoomMeetingId?: InputMaybe<SortOrder>;
};

export type EventType = {
  __typename?: 'EventType';
  _count: EventTypeCountOutputType;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  events: Array<Event>;
  id: Scalars['Int'];
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};


export type EventTypeEventsArgs = {
  cursor?: InputMaybe<EventWhereUniqueInput>;
  distinct?: InputMaybe<EventScalarFieldEnum>;
  orderBy?: InputMaybe<EventOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EventWhereInput>;
};

export type EventTypeAvgAggregateOutputType = {
  __typename?: 'EventTypeAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
};

export type EventTypeAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type EventTypeCountAggregateOutputType = {
  __typename?: 'EventTypeCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  titleAr: Scalars['Int'];
  titleEn: Scalars['Int'];
};

export type EventTypeCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type EventTypeCountOutputType = {
  __typename?: 'EventTypeCountOutputType';
  events: Scalars['Int'];
};

export type EventTypeCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<EventCreateNestedManyWithoutEventTypeInput>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type EventTypeCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type EventTypeCreateNestedOneWithoutEventsInput = {
  connect?: InputMaybe<EventTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventTypeCreateOrConnectWithoutEventsInput>;
  create?: InputMaybe<EventTypeUncheckedCreateWithoutEventsInput>;
};

export type EventTypeCreateOrConnectWithoutEventsInput = {
  create: EventTypeUncheckedCreateWithoutEventsInput;
  where: EventTypeWhereUniqueInput;
};

export type EventTypeCreateWithoutEventsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type EventTypeMaxAggregateOutputType = {
  __typename?: 'EventTypeMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type EventTypeMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type EventTypeMinAggregateOutputType = {
  __typename?: 'EventTypeMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type EventTypeMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type EventTypeOrderByWithAggregationInput = {
  _avg?: InputMaybe<EventTypeAvgOrderByAggregateInput>;
  _count?: InputMaybe<EventTypeCountOrderByAggregateInput>;
  _max?: InputMaybe<EventTypeMaxOrderByAggregateInput>;
  _min?: InputMaybe<EventTypeMinOrderByAggregateInput>;
  _sum?: InputMaybe<EventTypeSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type EventTypeOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  events?: InputMaybe<EventOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type EventTypeRelationFilter = {
  is?: InputMaybe<EventTypeWhereInput>;
  isNot?: InputMaybe<EventTypeWhereInput>;
};

export enum EventTypeScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  TitleAr = 'titleAr',
  TitleEn = 'titleEn'
}

export type EventTypeScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<EventTypeScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<EventTypeScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<EventTypeScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  titleAr?: InputMaybe<StringWithAggregatesFilter>;
  titleEn?: InputMaybe<StringWithAggregatesFilter>;
};

export type EventTypeSumAggregateOutputType = {
  __typename?: 'EventTypeSumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
};

export type EventTypeSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type EventTypeUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutEventTypeInput>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type EventTypeUncheckedCreateWithoutEventsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type EventTypeUncheckedUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutEventTypeInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EventTypeUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EventTypeUncheckedUpdateWithoutEventsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EventTypeUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventUpdateManyWithoutEventTypeInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EventTypeUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EventTypeUpdateOneRequiredWithoutEventsInput = {
  connect?: InputMaybe<EventTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventTypeCreateOrConnectWithoutEventsInput>;
  create?: InputMaybe<EventTypeUncheckedCreateWithoutEventsInput>;
  update?: InputMaybe<EventTypeUncheckedUpdateWithoutEventsInput>;
  upsert?: InputMaybe<EventTypeUpsertWithoutEventsInput>;
};

export type EventTypeUpdateWithoutEventsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type EventTypeUpsertWithoutEventsInput = {
  create: EventTypeUncheckedCreateWithoutEventsInput;
  update: EventTypeUncheckedUpdateWithoutEventsInput;
};

export type EventTypeWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<EventTypeWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<EventTypeWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<EventTypeWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  events?: InputMaybe<EventListRelationFilter>;
  id?: InputMaybe<IntFilter>;
  titleAr?: InputMaybe<StringFilter>;
  titleEn?: InputMaybe<StringFilter>;
};

export type EventTypeWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateNestedManyWithoutAddedByInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutAddedByInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutAddedByInput>>>;
  createMany?: InputMaybe<EventCreateManyAddedByInputEnvelope>;
};

export type EventUncheckedCreateNestedManyWithoutCityInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutCityInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutCityInput>>>;
  createMany?: InputMaybe<EventCreateManyCityInputEnvelope>;
};

export type EventUncheckedCreateNestedManyWithoutCouponsInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutCouponsInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutCouponsInput>>>;
};

export type EventUncheckedCreateNestedManyWithoutEventLanguagesInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutEventLanguagesInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutEventLanguagesInput>>>;
};

export type EventUncheckedCreateNestedManyWithoutEventTypeInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutEventTypeInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutEventTypeInput>>>;
  createMany?: InputMaybe<EventCreateManyEventTypeInputEnvelope>;
};

export type EventUncheckedCreateNestedManyWithoutFolderInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutFolderInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutFolderInput>>>;
  createMany?: InputMaybe<EventCreateManyFolderInputEnvelope>;
};

export type EventUncheckedCreateNestedManyWithoutLeaderTrainerInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutLeaderTrainerInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutLeaderTrainerInput>>>;
  createMany?: InputMaybe<EventCreateManyLeaderTrainerInputEnvelope>;
};

export type EventUncheckedCreateNestedManyWithoutMethodOfDeliveryInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutMethodOfDeliveryInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutMethodOfDeliveryInput>>>;
  createMany?: InputMaybe<EventCreateManyMethodOfDeliveryInputEnvelope>;
};

export type EventUncheckedCreateNestedManyWithoutPackageInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutPackageInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutPackageInput>>>;
  createMany?: InputMaybe<EventCreateManyPackageInputEnvelope>;
};

export type EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutRemindMeTraineesInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutRemindMeTraineesInput>>>;
};

export type EventUncheckedCreateNestedManyWithoutTargetedAudiencesInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutTargetedAudiencesInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutTargetedAudiencesInput>>>;
};

export type EventUncheckedCreateNestedManyWithoutTargetedSpecialitiesInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutTargetedSpecialitiesInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutTargetedSpecialitiesInput>>>;
};

export type EventUncheckedCreateNestedManyWithoutTraineeCertificateTemplateInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutTraineeCertificateTemplateInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutTraineeCertificateTemplateInput>>>;
  createMany?: InputMaybe<EventCreateManyTraineeCertificateTemplateInputEnvelope>;
};

export type EventUncheckedCreateNestedManyWithoutTrainerCertificateTemplateInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutTrainerCertificateTemplateInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutTrainerCertificateTemplateInput>>>;
  createMany?: InputMaybe<EventCreateManyTrainerCertificateTemplateInputEnvelope>;
};

export type EventUncheckedCreateNestedManyWithoutVisitedTraineesInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutVisitedTraineesInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutVisitedTraineesInput>>>;
};

export type EventUncheckedCreateNestedManyWithoutZoomMeetingInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutZoomMeetingInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutZoomMeetingInput>>>;
  createMany?: InputMaybe<EventCreateManyZoomMeetingInputEnvelope>;
};

export type EventUncheckedCreateNestedOneWithoutPricingPlanInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutPricingPlanInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutPricingPlanInput>;
};

export type EventUncheckedCreateWithoutAddedByInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutBlogsInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutCertificateInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutCityInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutCouponsInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutDiscussionInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutEventDaysInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutEventIdentityCardTemplateInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutEventLanguagesInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutEventMediaTrackingInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutEventPartsInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutEventTypeInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutExpensesTransitionsInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutFolderInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutHiddenEventInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutInviterCouponProfitsInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutLeaderTrainerInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutMethodOfDeliveryInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutPackageEventsInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutPackageInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutPricingPlanInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutQuizInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutQuizResultInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutRemindMeTraineesInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutTargetedAudiencesInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutTargetedSpecialitiesInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutTraineeCertificateTemplateInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutTraineeEventGroupsInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutTraineeEventReviewsInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutTraineeEventsInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutTrainerCertificateTemplateInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutTrainerEventStudyMaterialGroupsInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutTrainerEventStudyMaterialsInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutTrainerEventsInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutVisitedTraineesInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutZohoEmailInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['Int']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedCreateWithoutZoomMeetingInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedCreateNestedOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutEventInput>;
  addedById?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  addressAr?: InputMaybe<Scalars['String']>;
  addressInstructions?: InputMaybe<Scalars['String']>;
  addressInstructionsAr?: InputMaybe<Scalars['String']>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<Scalars['Int']>;
  cmeHours?: InputMaybe<Scalars['Decimal']>;
  cmeNumber?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutEventsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultLanguage?: InputMaybe<LanguageEnum>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  descriptionAr?: InputMaybe<Scalars['String']>;
  descriptionEn?: InputMaybe<Scalars['String']>;
  discussionStatus?: InputMaybe<Scalars['Boolean']>;
  endDate: Scalars['DateTime'];
  eventDays?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedCreateNestedOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedCreateNestedManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedCreateNestedManyWithoutEventInput>;
  eventTypeId: Scalars['Int'];
  expensesTransitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutEventInput>;
  folderId: Scalars['Int'];
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedCreateNestedOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<Scalars['Boolean']>;
  isAccredited: Scalars['Boolean'];
  isAccreditedSHA?: InputMaybe<Scalars['Boolean']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  isContentProvidedByAcademy: Scalars['Boolean'];
  isRegistraionClosed?: InputMaybe<Scalars['Boolean']>;
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  isTraineeCertificateAvailable: Scalars['Boolean'];
  isTrainerCertificateAvailable: Scalars['Boolean'];
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<Scalars['Int']>;
  locationLatitude?: InputMaybe<Scalars['Decimal']>;
  locationLongitude?: InputMaybe<Scalars['Decimal']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  methodOfDeliveryId: Scalars['Int'];
  minAttendancePercentageToGetCertificate?: InputMaybe<Scalars['Decimal']>;
  numberOfVisits?: InputMaybe<Scalars['Int']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  onlineCapacity?: InputMaybe<Scalars['Int']>;
  onsiteCapacity?: InputMaybe<Scalars['Int']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  packageEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutPackageInput>;
  packageId?: InputMaybe<Scalars['Int']>;
  pricingPlanId: Scalars['Int'];
  remindMeTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<Scalars['String']>;
  shortDescriptionEn?: InputMaybe<Scalars['String']>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate: Scalars['DateTime'];
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<Scalars['Boolean']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<Scalars['Boolean']>;
  visitedTrainees?: InputMaybe<UserUncheckedCreateNestedManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zoomMode?: InputMaybe<Scalars['String']>;
};

export type EventUncheckedUpdateInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateManyInput = {
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateManyWithoutAddedByInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutAddedByInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutAddedByInput>>>;
  createMany?: InputMaybe<EventCreateManyAddedByInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventUpdateWithWhereUniqueWithoutAddedByInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventUpdateManyWithWhereWithoutAddedByInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventUpsertWithWhereUniqueWithoutAddedByInput>>>;
};

export type EventUncheckedUpdateManyWithoutAddedEventsInput = {
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateManyWithoutCityInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutCityInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutCityInput>>>;
  createMany?: InputMaybe<EventCreateManyCityInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventUpdateWithWhereUniqueWithoutCityInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventUpdateManyWithWhereWithoutCityInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventUpsertWithWhereUniqueWithoutCityInput>>>;
};

export type EventUncheckedUpdateManyWithoutCouponsInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutCouponsInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutCouponsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventUpdateWithWhereUniqueWithoutCouponsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventUpdateManyWithWhereWithoutCouponsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventUpsertWithWhereUniqueWithoutCouponsInput>>>;
};

export type EventUncheckedUpdateManyWithoutEventInput = {
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateManyWithoutEventLanguagesInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutEventLanguagesInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutEventLanguagesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventUpdateWithWhereUniqueWithoutEventLanguagesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventUpdateManyWithWhereWithoutEventLanguagesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventUpsertWithWhereUniqueWithoutEventLanguagesInput>>>;
};

export type EventUncheckedUpdateManyWithoutEventTypeInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutEventTypeInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutEventTypeInput>>>;
  createMany?: InputMaybe<EventCreateManyEventTypeInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventUpdateWithWhereUniqueWithoutEventTypeInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventUpdateManyWithWhereWithoutEventTypeInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventUpsertWithWhereUniqueWithoutEventTypeInput>>>;
};

export type EventUncheckedUpdateManyWithoutEventsInput = {
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateManyWithoutFolderInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutFolderInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutFolderInput>>>;
  createMany?: InputMaybe<EventCreateManyFolderInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventUpdateWithWhereUniqueWithoutFolderInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventUpdateManyWithWhereWithoutFolderInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventUpsertWithWhereUniqueWithoutFolderInput>>>;
};

export type EventUncheckedUpdateManyWithoutLeaderTrainerInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutLeaderTrainerInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutLeaderTrainerInput>>>;
  createMany?: InputMaybe<EventCreateManyLeaderTrainerInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventUpdateWithWhereUniqueWithoutLeaderTrainerInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventUpdateManyWithWhereWithoutLeaderTrainerInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventUpsertWithWhereUniqueWithoutLeaderTrainerInput>>>;
};

export type EventUncheckedUpdateManyWithoutMethodOfDeliveryInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutMethodOfDeliveryInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutMethodOfDeliveryInput>>>;
  createMany?: InputMaybe<EventCreateManyMethodOfDeliveryInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventUpdateWithWhereUniqueWithoutMethodOfDeliveryInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventUpdateManyWithWhereWithoutMethodOfDeliveryInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventUpsertWithWhereUniqueWithoutMethodOfDeliveryInput>>>;
};

export type EventUncheckedUpdateManyWithoutPackageEventsInput = {
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateManyWithoutPackageInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutPackageInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutPackageInput>>>;
  createMany?: InputMaybe<EventCreateManyPackageInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventUpdateWithWhereUniqueWithoutPackageInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventUpdateManyWithWhereWithoutPackageInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventUpsertWithWhereUniqueWithoutPackageInput>>>;
};

export type EventUncheckedUpdateManyWithoutRemindMeEventsInput = {
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateManyWithoutRemindMeTraineesInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutRemindMeTraineesInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutRemindMeTraineesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventUpdateWithWhereUniqueWithoutRemindMeTraineesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventUpdateManyWithWhereWithoutRemindMeTraineesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventUpsertWithWhereUniqueWithoutRemindMeTraineesInput>>>;
};

export type EventUncheckedUpdateManyWithoutTargetedAudiencesInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutTargetedAudiencesInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutTargetedAudiencesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventUpdateWithWhereUniqueWithoutTargetedAudiencesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventUpdateManyWithWhereWithoutTargetedAudiencesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventUpsertWithWhereUniqueWithoutTargetedAudiencesInput>>>;
};

export type EventUncheckedUpdateManyWithoutTargetedSpecialitiesInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutTargetedSpecialitiesInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutTargetedSpecialitiesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventUpdateWithWhereUniqueWithoutTargetedSpecialitiesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventUpdateManyWithWhereWithoutTargetedSpecialitiesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventUpsertWithWhereUniqueWithoutTargetedSpecialitiesInput>>>;
};

export type EventUncheckedUpdateManyWithoutTraineeCertificateEventsInput = {
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateManyWithoutTraineeCertificateTemplateInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutTraineeCertificateTemplateInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutTraineeCertificateTemplateInput>>>;
  createMany?: InputMaybe<EventCreateManyTraineeCertificateTemplateInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventUpdateWithWhereUniqueWithoutTraineeCertificateTemplateInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventUpdateManyWithWhereWithoutTraineeCertificateTemplateInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventUpsertWithWhereUniqueWithoutTraineeCertificateTemplateInput>>>;
};

export type EventUncheckedUpdateManyWithoutTrainerCertificateEventsInput = {
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateManyWithoutTrainerCertificateTemplateInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutTrainerCertificateTemplateInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutTrainerCertificateTemplateInput>>>;
  createMany?: InputMaybe<EventCreateManyTrainerCertificateTemplateInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventUpdateWithWhereUniqueWithoutTrainerCertificateTemplateInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventUpdateManyWithWhereWithoutTrainerCertificateTemplateInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventUpsertWithWhereUniqueWithoutTrainerCertificateTemplateInput>>>;
};

export type EventUncheckedUpdateManyWithoutVisitedEventsInput = {
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateManyWithoutVisitedTraineesInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutVisitedTraineesInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutVisitedTraineesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventUpdateWithWhereUniqueWithoutVisitedTraineesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventUpdateManyWithWhereWithoutVisitedTraineesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventUpsertWithWhereUniqueWithoutVisitedTraineesInput>>>;
};

export type EventUncheckedUpdateManyWithoutZoomMeetingInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutZoomMeetingInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutZoomMeetingInput>>>;
  createMany?: InputMaybe<EventCreateManyZoomMeetingInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventUpdateWithWhereUniqueWithoutZoomMeetingInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventUpdateManyWithWhereWithoutZoomMeetingInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventUpsertWithWhereUniqueWithoutZoomMeetingInput>>>;
};

export type EventUncheckedUpdateOneWithoutPricingPlanInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutPricingPlanInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutPricingPlanInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<EventUncheckedUpdateWithoutPricingPlanInput>;
  upsert?: InputMaybe<EventUpsertWithoutPricingPlanInput>;
};

export type EventUncheckedUpdateWithoutAddedByInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutBlogsInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutCertificateInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutCityInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutCouponsInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutDiscussionInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutEventDaysInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutEventIdentityCardTemplateInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutEventLanguagesInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutEventMediaTrackingInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutEventPartsInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutEventTypeInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutExpensesTransitionsInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutFolderInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutHiddenEventInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutInviterCouponProfitsInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutLeaderTrainerInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutMethodOfDeliveryInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutPackageEventsInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutPackageInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutPricingPlanInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutQuizInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutQuizResultInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutRemindMeTraineesInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutTargetedAudiencesInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutTargetedSpecialitiesInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutTraineeCertificateTemplateInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutTraineeEventGroupsInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutTraineeEventReviewsInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutTraineeEventsInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutTrainerCertificateTemplateInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutTrainerEventStudyMaterialGroupsInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutTrainerEventStudyMaterialsInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutTrainerEventsInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutVisitedTraineesInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutZohoEmailInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUncheckedUpdateWithoutZoomMeetingInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUncheckedUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutEventInput>;
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUncheckedUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUncheckedUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUncheckedUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUncheckedUpdateManyWithoutEventInput>;
  eventTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  expensesTransitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutEventInput>;
  folderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUncheckedUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUncheckedUpdateManyWithoutPackageInput>;
  packageId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  remindMeTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutEventInput>;
  trainerCertificateTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUncheckedUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateManyMutationInput = {
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateManyWithWhereWithoutAddedByInput = {
  data: EventUncheckedUpdateManyWithoutAddedEventsInput;
  where: EventScalarWhereInput;
};

export type EventUpdateManyWithWhereWithoutCityInput = {
  data: EventUncheckedUpdateManyWithoutEventsInput;
  where: EventScalarWhereInput;
};

export type EventUpdateManyWithWhereWithoutCouponsInput = {
  data: EventUncheckedUpdateManyWithoutEventsInput;
  where: EventScalarWhereInput;
};

export type EventUpdateManyWithWhereWithoutEventLanguagesInput = {
  data: EventUncheckedUpdateManyWithoutEventsInput;
  where: EventScalarWhereInput;
};

export type EventUpdateManyWithWhereWithoutEventTypeInput = {
  data: EventUncheckedUpdateManyWithoutEventsInput;
  where: EventScalarWhereInput;
};

export type EventUpdateManyWithWhereWithoutFolderInput = {
  data: EventUncheckedUpdateManyWithoutEventsInput;
  where: EventScalarWhereInput;
};

export type EventUpdateManyWithWhereWithoutLeaderTrainerInput = {
  data: EventUncheckedUpdateManyWithoutEventsInput;
  where: EventScalarWhereInput;
};

export type EventUpdateManyWithWhereWithoutMethodOfDeliveryInput = {
  data: EventUncheckedUpdateManyWithoutEventsInput;
  where: EventScalarWhereInput;
};

export type EventUpdateManyWithWhereWithoutPackageInput = {
  data: EventUncheckedUpdateManyWithoutPackageEventsInput;
  where: EventScalarWhereInput;
};

export type EventUpdateManyWithWhereWithoutRemindMeTraineesInput = {
  data: EventUncheckedUpdateManyWithoutRemindMeEventsInput;
  where: EventScalarWhereInput;
};

export type EventUpdateManyWithWhereWithoutTargetedAudiencesInput = {
  data: EventUncheckedUpdateManyWithoutEventsInput;
  where: EventScalarWhereInput;
};

export type EventUpdateManyWithWhereWithoutTargetedSpecialitiesInput = {
  data: EventUncheckedUpdateManyWithoutEventInput;
  where: EventScalarWhereInput;
};

export type EventUpdateManyWithWhereWithoutTraineeCertificateTemplateInput = {
  data: EventUncheckedUpdateManyWithoutTraineeCertificateEventsInput;
  where: EventScalarWhereInput;
};

export type EventUpdateManyWithWhereWithoutTrainerCertificateTemplateInput = {
  data: EventUncheckedUpdateManyWithoutTrainerCertificateEventsInput;
  where: EventScalarWhereInput;
};

export type EventUpdateManyWithWhereWithoutVisitedTraineesInput = {
  data: EventUncheckedUpdateManyWithoutVisitedEventsInput;
  where: EventScalarWhereInput;
};

export type EventUpdateManyWithWhereWithoutZoomMeetingInput = {
  data: EventUncheckedUpdateManyWithoutEventInput;
  where: EventScalarWhereInput;
};

export type EventUpdateManyWithoutAddedByInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutAddedByInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutAddedByInput>>>;
  createMany?: InputMaybe<EventCreateManyAddedByInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventUpdateWithWhereUniqueWithoutAddedByInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventUpdateManyWithWhereWithoutAddedByInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventUpsertWithWhereUniqueWithoutAddedByInput>>>;
};

export type EventUpdateManyWithoutCityInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutCityInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutCityInput>>>;
  createMany?: InputMaybe<EventCreateManyCityInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventUpdateWithWhereUniqueWithoutCityInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventUpdateManyWithWhereWithoutCityInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventUpsertWithWhereUniqueWithoutCityInput>>>;
};

export type EventUpdateManyWithoutCouponsInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutCouponsInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutCouponsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventUpdateWithWhereUniqueWithoutCouponsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventUpdateManyWithWhereWithoutCouponsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventUpsertWithWhereUniqueWithoutCouponsInput>>>;
};

export type EventUpdateManyWithoutEventLanguagesInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutEventLanguagesInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutEventLanguagesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventUpdateWithWhereUniqueWithoutEventLanguagesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventUpdateManyWithWhereWithoutEventLanguagesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventUpsertWithWhereUniqueWithoutEventLanguagesInput>>>;
};

export type EventUpdateManyWithoutEventTypeInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutEventTypeInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutEventTypeInput>>>;
  createMany?: InputMaybe<EventCreateManyEventTypeInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventUpdateWithWhereUniqueWithoutEventTypeInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventUpdateManyWithWhereWithoutEventTypeInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventUpsertWithWhereUniqueWithoutEventTypeInput>>>;
};

export type EventUpdateManyWithoutFolderInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutFolderInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutFolderInput>>>;
  createMany?: InputMaybe<EventCreateManyFolderInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventUpdateWithWhereUniqueWithoutFolderInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventUpdateManyWithWhereWithoutFolderInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventUpsertWithWhereUniqueWithoutFolderInput>>>;
};

export type EventUpdateManyWithoutLeaderTrainerInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutLeaderTrainerInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutLeaderTrainerInput>>>;
  createMany?: InputMaybe<EventCreateManyLeaderTrainerInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventUpdateWithWhereUniqueWithoutLeaderTrainerInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventUpdateManyWithWhereWithoutLeaderTrainerInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventUpsertWithWhereUniqueWithoutLeaderTrainerInput>>>;
};

export type EventUpdateManyWithoutMethodOfDeliveryInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutMethodOfDeliveryInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutMethodOfDeliveryInput>>>;
  createMany?: InputMaybe<EventCreateManyMethodOfDeliveryInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventUpdateWithWhereUniqueWithoutMethodOfDeliveryInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventUpdateManyWithWhereWithoutMethodOfDeliveryInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventUpsertWithWhereUniqueWithoutMethodOfDeliveryInput>>>;
};

export type EventUpdateManyWithoutPackageInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutPackageInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutPackageInput>>>;
  createMany?: InputMaybe<EventCreateManyPackageInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventUpdateWithWhereUniqueWithoutPackageInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventUpdateManyWithWhereWithoutPackageInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventUpsertWithWhereUniqueWithoutPackageInput>>>;
};

export type EventUpdateManyWithoutRemindMeTraineesInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutRemindMeTraineesInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutRemindMeTraineesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventUpdateWithWhereUniqueWithoutRemindMeTraineesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventUpdateManyWithWhereWithoutRemindMeTraineesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventUpsertWithWhereUniqueWithoutRemindMeTraineesInput>>>;
};

export type EventUpdateManyWithoutTargetedAudiencesInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutTargetedAudiencesInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutTargetedAudiencesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventUpdateWithWhereUniqueWithoutTargetedAudiencesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventUpdateManyWithWhereWithoutTargetedAudiencesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventUpsertWithWhereUniqueWithoutTargetedAudiencesInput>>>;
};

export type EventUpdateManyWithoutTargetedSpecialitiesInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutTargetedSpecialitiesInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutTargetedSpecialitiesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventUpdateWithWhereUniqueWithoutTargetedSpecialitiesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventUpdateManyWithWhereWithoutTargetedSpecialitiesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventUpsertWithWhereUniqueWithoutTargetedSpecialitiesInput>>>;
};

export type EventUpdateManyWithoutTraineeCertificateTemplateInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutTraineeCertificateTemplateInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutTraineeCertificateTemplateInput>>>;
  createMany?: InputMaybe<EventCreateManyTraineeCertificateTemplateInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventUpdateWithWhereUniqueWithoutTraineeCertificateTemplateInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventUpdateManyWithWhereWithoutTraineeCertificateTemplateInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventUpsertWithWhereUniqueWithoutTraineeCertificateTemplateInput>>>;
};

export type EventUpdateManyWithoutTrainerCertificateTemplateInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutTrainerCertificateTemplateInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutTrainerCertificateTemplateInput>>>;
  createMany?: InputMaybe<EventCreateManyTrainerCertificateTemplateInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventUpdateWithWhereUniqueWithoutTrainerCertificateTemplateInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventUpdateManyWithWhereWithoutTrainerCertificateTemplateInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventUpsertWithWhereUniqueWithoutTrainerCertificateTemplateInput>>>;
};

export type EventUpdateManyWithoutVisitedTraineesInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutVisitedTraineesInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutVisitedTraineesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventUpdateWithWhereUniqueWithoutVisitedTraineesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventUpdateManyWithWhereWithoutVisitedTraineesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventUpsertWithWhereUniqueWithoutVisitedTraineesInput>>>;
};

export type EventUpdateManyWithoutZoomMeetingInput = {
  connect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<EventCreateOrConnectWithoutZoomMeetingInput>>>;
  create?: InputMaybe<Array<InputMaybe<EventCreateWithoutZoomMeetingInput>>>;
  createMany?: InputMaybe<EventCreateManyZoomMeetingInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<EventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<EventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<EventUpdateWithWhereUniqueWithoutZoomMeetingInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<EventUpdateManyWithWhereWithoutZoomMeetingInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<EventUpsertWithWhereUniqueWithoutZoomMeetingInput>>>;
};

export type EventUpdateOneRequiredWithoutCertificateInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutCertificateInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutCertificateInput>;
  update?: InputMaybe<EventUncheckedUpdateWithoutCertificateInput>;
  upsert?: InputMaybe<EventUpsertWithoutCertificateInput>;
};

export type EventUpdateOneRequiredWithoutDiscussionInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutDiscussionInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutDiscussionInput>;
  update?: InputMaybe<EventUncheckedUpdateWithoutDiscussionInput>;
  upsert?: InputMaybe<EventUpsertWithoutDiscussionInput>;
};

export type EventUpdateOneRequiredWithoutEventDaysInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutEventDaysInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutEventDaysInput>;
  update?: InputMaybe<EventUncheckedUpdateWithoutEventDaysInput>;
  upsert?: InputMaybe<EventUpsertWithoutEventDaysInput>;
};

export type EventUpdateOneRequiredWithoutEventPartsInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutEventPartsInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutEventPartsInput>;
  update?: InputMaybe<EventUncheckedUpdateWithoutEventPartsInput>;
  upsert?: InputMaybe<EventUpsertWithoutEventPartsInput>;
};

export type EventUpdateOneRequiredWithoutTraineeEventGroupsInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutTraineeEventGroupsInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutTraineeEventGroupsInput>;
  update?: InputMaybe<EventUncheckedUpdateWithoutTraineeEventGroupsInput>;
  upsert?: InputMaybe<EventUpsertWithoutTraineeEventGroupsInput>;
};

export type EventUpdateOneRequiredWithoutTraineeEventReviewsInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutTraineeEventReviewsInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutTraineeEventReviewsInput>;
  update?: InputMaybe<EventUncheckedUpdateWithoutTraineeEventReviewsInput>;
  upsert?: InputMaybe<EventUpsertWithoutTraineeEventReviewsInput>;
};

export type EventUpdateOneRequiredWithoutTraineeEventsInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutTraineeEventsInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutTraineeEventsInput>;
  update?: InputMaybe<EventUncheckedUpdateWithoutTraineeEventsInput>;
  upsert?: InputMaybe<EventUpsertWithoutTraineeEventsInput>;
};

export type EventUpdateOneRequiredWithoutTrainerEventStudyMaterialGroupsInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutTrainerEventStudyMaterialGroupsInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutTrainerEventStudyMaterialGroupsInput>;
  update?: InputMaybe<EventUncheckedUpdateWithoutTrainerEventStudyMaterialGroupsInput>;
  upsert?: InputMaybe<EventUpsertWithoutTrainerEventStudyMaterialGroupsInput>;
};

export type EventUpdateOneRequiredWithoutTrainerEventStudyMaterialsInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutTrainerEventStudyMaterialsInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutTrainerEventStudyMaterialsInput>;
  update?: InputMaybe<EventUncheckedUpdateWithoutTrainerEventStudyMaterialsInput>;
  upsert?: InputMaybe<EventUpsertWithoutTrainerEventStudyMaterialsInput>;
};

export type EventUpdateOneRequiredWithoutTrainerEventsInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutTrainerEventsInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutTrainerEventsInput>;
  update?: InputMaybe<EventUncheckedUpdateWithoutTrainerEventsInput>;
  upsert?: InputMaybe<EventUpsertWithoutTrainerEventsInput>;
};

export type EventUpdateOneWithoutBlogsInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutBlogsInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutBlogsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<EventUncheckedUpdateWithoutBlogsInput>;
  upsert?: InputMaybe<EventUpsertWithoutBlogsInput>;
};

export type EventUpdateOneWithoutEventIdentityCardTemplateInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutEventIdentityCardTemplateInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutEventIdentityCardTemplateInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<EventUncheckedUpdateWithoutEventIdentityCardTemplateInput>;
  upsert?: InputMaybe<EventUpsertWithoutEventIdentityCardTemplateInput>;
};

export type EventUpdateOneWithoutEventMediaTrackingInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutEventMediaTrackingInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutEventMediaTrackingInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<EventUncheckedUpdateWithoutEventMediaTrackingInput>;
  upsert?: InputMaybe<EventUpsertWithoutEventMediaTrackingInput>;
};

export type EventUpdateOneWithoutExpensesTransitionsInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutExpensesTransitionsInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutExpensesTransitionsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<EventUncheckedUpdateWithoutExpensesTransitionsInput>;
  upsert?: InputMaybe<EventUpsertWithoutExpensesTransitionsInput>;
};

export type EventUpdateOneWithoutHiddenEventInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutHiddenEventInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutHiddenEventInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<EventUncheckedUpdateWithoutHiddenEventInput>;
  upsert?: InputMaybe<EventUpsertWithoutHiddenEventInput>;
};

export type EventUpdateOneWithoutInviterCouponProfitsInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutInviterCouponProfitsInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutInviterCouponProfitsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<EventUncheckedUpdateWithoutInviterCouponProfitsInput>;
  upsert?: InputMaybe<EventUpsertWithoutInviterCouponProfitsInput>;
};

export type EventUpdateOneWithoutPackageEventsInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutPackageEventsInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutPackageEventsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<EventUncheckedUpdateWithoutPackageEventsInput>;
  upsert?: InputMaybe<EventUpsertWithoutPackageEventsInput>;
};

export type EventUpdateOneWithoutPricingPlanInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutPricingPlanInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutPricingPlanInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<EventUncheckedUpdateWithoutPricingPlanInput>;
  upsert?: InputMaybe<EventUpsertWithoutPricingPlanInput>;
};

export type EventUpdateOneWithoutQuizInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutQuizInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutQuizInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<EventUncheckedUpdateWithoutQuizInput>;
  upsert?: InputMaybe<EventUpsertWithoutQuizInput>;
};

export type EventUpdateOneWithoutQuizResultInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutQuizResultInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutQuizResultInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<EventUncheckedUpdateWithoutQuizResultInput>;
  upsert?: InputMaybe<EventUpsertWithoutQuizResultInput>;
};

export type EventUpdateOneWithoutZohoEmailInput = {
  connect?: InputMaybe<EventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EventCreateOrConnectWithoutZohoEmailInput>;
  create?: InputMaybe<EventUncheckedCreateWithoutZohoEmailInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<EventUncheckedUpdateWithoutZohoEmailInput>;
  upsert?: InputMaybe<EventUpsertWithoutZohoEmailInput>;
};

export type EventUpdateWithWhereUniqueWithoutAddedByInput = {
  data: EventUncheckedUpdateWithoutAddedByInput;
  where: EventWhereUniqueInput;
};

export type EventUpdateWithWhereUniqueWithoutCityInput = {
  data: EventUncheckedUpdateWithoutCityInput;
  where: EventWhereUniqueInput;
};

export type EventUpdateWithWhereUniqueWithoutCouponsInput = {
  data: EventUncheckedUpdateWithoutCouponsInput;
  where: EventWhereUniqueInput;
};

export type EventUpdateWithWhereUniqueWithoutEventLanguagesInput = {
  data: EventUncheckedUpdateWithoutEventLanguagesInput;
  where: EventWhereUniqueInput;
};

export type EventUpdateWithWhereUniqueWithoutEventTypeInput = {
  data: EventUncheckedUpdateWithoutEventTypeInput;
  where: EventWhereUniqueInput;
};

export type EventUpdateWithWhereUniqueWithoutFolderInput = {
  data: EventUncheckedUpdateWithoutFolderInput;
  where: EventWhereUniqueInput;
};

export type EventUpdateWithWhereUniqueWithoutLeaderTrainerInput = {
  data: EventUncheckedUpdateWithoutLeaderTrainerInput;
  where: EventWhereUniqueInput;
};

export type EventUpdateWithWhereUniqueWithoutMethodOfDeliveryInput = {
  data: EventUncheckedUpdateWithoutMethodOfDeliveryInput;
  where: EventWhereUniqueInput;
};

export type EventUpdateWithWhereUniqueWithoutPackageInput = {
  data: EventUncheckedUpdateWithoutPackageInput;
  where: EventWhereUniqueInput;
};

export type EventUpdateWithWhereUniqueWithoutRemindMeTraineesInput = {
  data: EventUncheckedUpdateWithoutRemindMeTraineesInput;
  where: EventWhereUniqueInput;
};

export type EventUpdateWithWhereUniqueWithoutTargetedAudiencesInput = {
  data: EventUncheckedUpdateWithoutTargetedAudiencesInput;
  where: EventWhereUniqueInput;
};

export type EventUpdateWithWhereUniqueWithoutTargetedSpecialitiesInput = {
  data: EventUncheckedUpdateWithoutTargetedSpecialitiesInput;
  where: EventWhereUniqueInput;
};

export type EventUpdateWithWhereUniqueWithoutTraineeCertificateTemplateInput = {
  data: EventUncheckedUpdateWithoutTraineeCertificateTemplateInput;
  where: EventWhereUniqueInput;
};

export type EventUpdateWithWhereUniqueWithoutTrainerCertificateTemplateInput = {
  data: EventUncheckedUpdateWithoutTrainerCertificateTemplateInput;
  where: EventWhereUniqueInput;
};

export type EventUpdateWithWhereUniqueWithoutVisitedTraineesInput = {
  data: EventUncheckedUpdateWithoutVisitedTraineesInput;
  where: EventWhereUniqueInput;
};

export type EventUpdateWithWhereUniqueWithoutZoomMeetingInput = {
  data: EventUncheckedUpdateWithoutZoomMeetingInput;
  where: EventWhereUniqueInput;
};

export type EventUpdateWithoutAddedByInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutBlogsInput = {
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutCertificateInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutCityInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutCouponsInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutDiscussionInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutEventDaysInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutEventIdentityCardTemplateInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutEventLanguagesInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutEventMediaTrackingInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutEventPartsInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutEventTypeInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutExpensesTransitionsInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutFolderInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutHiddenEventInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutInviterCouponProfitsInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutLeaderTrainerInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutMethodOfDeliveryInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutPackageEventsInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutPackageInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutPricingPlanInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutQuizInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutQuizResultInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutRemindMeTraineesInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutTargetedAudiencesInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutTargetedSpecialitiesInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutTraineeCertificateTemplateInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutTraineeEventGroupsInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutTraineeEventReviewsInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutTraineeEventsInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutTrainerCertificateTemplateInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutTrainerEventStudyMaterialGroupsInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutTrainerEventStudyMaterialsInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutTrainerEventsInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutVisitedTraineesInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutZohoEmailInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZoomMeeting?: InputMaybe<ZoomMeetingUpdateOneWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdateWithoutZoomMeetingInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutEventInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutEventInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutEventInput>;
  Quiz?: InputMaybe<QuizUpdateOneWithoutEventInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutEventInput>;
  addedBy?: InputMaybe<UserUpdateOneWithoutAddedEventsInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressInstructionsAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  backgroundImagesUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  city?: InputMaybe<CityUpdateOneWithoutEventsInput>;
  cmeHours?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cmeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutEventsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  descriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discussionStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDays?: InputMaybe<EventDayUpdateManyWithoutEventInput>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateUpdateOneWithoutEventInput>;
  eventLanguages?: InputMaybe<LanguageUpdateManyWithoutEventsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutEventInput>;
  eventParts?: InputMaybe<EventPartUpdateManyWithoutEventInput>;
  eventType?: InputMaybe<EventTypeUpdateOneRequiredWithoutEventsInput>;
  expensesTransitions?: InputMaybe<TransitionUpdateManyWithoutEventInput>;
  folder?: InputMaybe<EventFolderUpdateOneRequiredWithoutEventsInput>;
  hiddenEvent?: InputMaybe<HiddenEventsUpdateOneWithoutEventInput>;
  hideVideoProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutEventInput>;
  invitersCanApprovePayments?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isAccredited?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccreditedSHA?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContentProvidedByAcademy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRegistraionClosed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSponsored?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keywordsAr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywordsEn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  leaderTrainer?: InputMaybe<UserUpdateOneWithoutEventsInput>;
  locationLatitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  locationLongitude?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneRequiredWithoutEventsInput>;
  minAttendancePercentageToGetCertificate?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  numberOfVisits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onsiteCapacity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<EventUpdateOneWithoutPackageEventsInput>;
  packageEvents?: InputMaybe<EventUpdateManyWithoutPackageInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutEventInput>;
  remindMeTrainees?: InputMaybe<UserUpdateManyWithoutRemindMeEventsInput>;
  shortDescriptionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescriptionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sponsorshipImagesUrls?: InputMaybe<Scalars['Json']>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutEventInput>;
  timeTableStatus?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTraineeCertificateEventsInput>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutEventInput>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutEventInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutEventInput>;
  trainerCertificateTemplate?: InputMaybe<TemplateUpdateOneWithoutTrainerCertificateEventsInput>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutEventInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutEventInput>;
  visibleOnArchive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  visitedTrainees?: InputMaybe<UserUpdateManyWithoutVisitedEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EventUpdatebackgroundImagesUrlsInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EventUpdatekeywordsArInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EventUpdatekeywordsEnInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EventUpsertWithWhereUniqueWithoutAddedByInput = {
  create: EventUncheckedCreateWithoutAddedByInput;
  update: EventUncheckedUpdateWithoutAddedByInput;
  where: EventWhereUniqueInput;
};

export type EventUpsertWithWhereUniqueWithoutCityInput = {
  create: EventUncheckedCreateWithoutCityInput;
  update: EventUncheckedUpdateWithoutCityInput;
  where: EventWhereUniqueInput;
};

export type EventUpsertWithWhereUniqueWithoutCouponsInput = {
  create: EventUncheckedCreateWithoutCouponsInput;
  update: EventUncheckedUpdateWithoutCouponsInput;
  where: EventWhereUniqueInput;
};

export type EventUpsertWithWhereUniqueWithoutEventLanguagesInput = {
  create: EventUncheckedCreateWithoutEventLanguagesInput;
  update: EventUncheckedUpdateWithoutEventLanguagesInput;
  where: EventWhereUniqueInput;
};

export type EventUpsertWithWhereUniqueWithoutEventTypeInput = {
  create: EventUncheckedCreateWithoutEventTypeInput;
  update: EventUncheckedUpdateWithoutEventTypeInput;
  where: EventWhereUniqueInput;
};

export type EventUpsertWithWhereUniqueWithoutFolderInput = {
  create: EventUncheckedCreateWithoutFolderInput;
  update: EventUncheckedUpdateWithoutFolderInput;
  where: EventWhereUniqueInput;
};

export type EventUpsertWithWhereUniqueWithoutLeaderTrainerInput = {
  create: EventUncheckedCreateWithoutLeaderTrainerInput;
  update: EventUncheckedUpdateWithoutLeaderTrainerInput;
  where: EventWhereUniqueInput;
};

export type EventUpsertWithWhereUniqueWithoutMethodOfDeliveryInput = {
  create: EventUncheckedCreateWithoutMethodOfDeliveryInput;
  update: EventUncheckedUpdateWithoutMethodOfDeliveryInput;
  where: EventWhereUniqueInput;
};

export type EventUpsertWithWhereUniqueWithoutPackageInput = {
  create: EventUncheckedCreateWithoutPackageInput;
  update: EventUncheckedUpdateWithoutPackageInput;
  where: EventWhereUniqueInput;
};

export type EventUpsertWithWhereUniqueWithoutRemindMeTraineesInput = {
  create: EventUncheckedCreateWithoutRemindMeTraineesInput;
  update: EventUncheckedUpdateWithoutRemindMeTraineesInput;
  where: EventWhereUniqueInput;
};

export type EventUpsertWithWhereUniqueWithoutTargetedAudiencesInput = {
  create: EventUncheckedCreateWithoutTargetedAudiencesInput;
  update: EventUncheckedUpdateWithoutTargetedAudiencesInput;
  where: EventWhereUniqueInput;
};

export type EventUpsertWithWhereUniqueWithoutTargetedSpecialitiesInput = {
  create: EventUncheckedCreateWithoutTargetedSpecialitiesInput;
  update: EventUncheckedUpdateWithoutTargetedSpecialitiesInput;
  where: EventWhereUniqueInput;
};

export type EventUpsertWithWhereUniqueWithoutTraineeCertificateTemplateInput = {
  create: EventUncheckedCreateWithoutTraineeCertificateTemplateInput;
  update: EventUncheckedUpdateWithoutTraineeCertificateTemplateInput;
  where: EventWhereUniqueInput;
};

export type EventUpsertWithWhereUniqueWithoutTrainerCertificateTemplateInput = {
  create: EventUncheckedCreateWithoutTrainerCertificateTemplateInput;
  update: EventUncheckedUpdateWithoutTrainerCertificateTemplateInput;
  where: EventWhereUniqueInput;
};

export type EventUpsertWithWhereUniqueWithoutVisitedTraineesInput = {
  create: EventUncheckedCreateWithoutVisitedTraineesInput;
  update: EventUncheckedUpdateWithoutVisitedTraineesInput;
  where: EventWhereUniqueInput;
};

export type EventUpsertWithWhereUniqueWithoutZoomMeetingInput = {
  create: EventUncheckedCreateWithoutZoomMeetingInput;
  update: EventUncheckedUpdateWithoutZoomMeetingInput;
  where: EventWhereUniqueInput;
};

export type EventUpsertWithoutBlogsInput = {
  create: EventUncheckedCreateWithoutBlogsInput;
  update: EventUncheckedUpdateWithoutBlogsInput;
};

export type EventUpsertWithoutCertificateInput = {
  create: EventUncheckedCreateWithoutCertificateInput;
  update: EventUncheckedUpdateWithoutCertificateInput;
};

export type EventUpsertWithoutDiscussionInput = {
  create: EventUncheckedCreateWithoutDiscussionInput;
  update: EventUncheckedUpdateWithoutDiscussionInput;
};

export type EventUpsertWithoutEventDaysInput = {
  create: EventUncheckedCreateWithoutEventDaysInput;
  update: EventUncheckedUpdateWithoutEventDaysInput;
};

export type EventUpsertWithoutEventIdentityCardTemplateInput = {
  create: EventUncheckedCreateWithoutEventIdentityCardTemplateInput;
  update: EventUncheckedUpdateWithoutEventIdentityCardTemplateInput;
};

export type EventUpsertWithoutEventMediaTrackingInput = {
  create: EventUncheckedCreateWithoutEventMediaTrackingInput;
  update: EventUncheckedUpdateWithoutEventMediaTrackingInput;
};

export type EventUpsertWithoutEventPartsInput = {
  create: EventUncheckedCreateWithoutEventPartsInput;
  update: EventUncheckedUpdateWithoutEventPartsInput;
};

export type EventUpsertWithoutExpensesTransitionsInput = {
  create: EventUncheckedCreateWithoutExpensesTransitionsInput;
  update: EventUncheckedUpdateWithoutExpensesTransitionsInput;
};

export type EventUpsertWithoutHiddenEventInput = {
  create: EventUncheckedCreateWithoutHiddenEventInput;
  update: EventUncheckedUpdateWithoutHiddenEventInput;
};

export type EventUpsertWithoutInviterCouponProfitsInput = {
  create: EventUncheckedCreateWithoutInviterCouponProfitsInput;
  update: EventUncheckedUpdateWithoutInviterCouponProfitsInput;
};

export type EventUpsertWithoutPackageEventsInput = {
  create: EventUncheckedCreateWithoutPackageEventsInput;
  update: EventUncheckedUpdateWithoutPackageEventsInput;
};

export type EventUpsertWithoutPricingPlanInput = {
  create: EventUncheckedCreateWithoutPricingPlanInput;
  update: EventUncheckedUpdateWithoutPricingPlanInput;
};

export type EventUpsertWithoutQuizInput = {
  create: EventUncheckedCreateWithoutQuizInput;
  update: EventUncheckedUpdateWithoutQuizInput;
};

export type EventUpsertWithoutQuizResultInput = {
  create: EventUncheckedCreateWithoutQuizResultInput;
  update: EventUncheckedUpdateWithoutQuizResultInput;
};

export type EventUpsertWithoutTraineeEventGroupsInput = {
  create: EventUncheckedCreateWithoutTraineeEventGroupsInput;
  update: EventUncheckedUpdateWithoutTraineeEventGroupsInput;
};

export type EventUpsertWithoutTraineeEventReviewsInput = {
  create: EventUncheckedCreateWithoutTraineeEventReviewsInput;
  update: EventUncheckedUpdateWithoutTraineeEventReviewsInput;
};

export type EventUpsertWithoutTraineeEventsInput = {
  create: EventUncheckedCreateWithoutTraineeEventsInput;
  update: EventUncheckedUpdateWithoutTraineeEventsInput;
};

export type EventUpsertWithoutTrainerEventStudyMaterialGroupsInput = {
  create: EventUncheckedCreateWithoutTrainerEventStudyMaterialGroupsInput;
  update: EventUncheckedUpdateWithoutTrainerEventStudyMaterialGroupsInput;
};

export type EventUpsertWithoutTrainerEventStudyMaterialsInput = {
  create: EventUncheckedCreateWithoutTrainerEventStudyMaterialsInput;
  update: EventUncheckedUpdateWithoutTrainerEventStudyMaterialsInput;
};

export type EventUpsertWithoutTrainerEventsInput = {
  create: EventUncheckedCreateWithoutTrainerEventsInput;
  update: EventUncheckedUpdateWithoutTrainerEventsInput;
};

export type EventUpsertWithoutZohoEmailInput = {
  create: EventUncheckedCreateWithoutZohoEmailInput;
  update: EventUncheckedUpdateWithoutZohoEmailInput;
};

export type EventWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<EventWhereInput>>>;
  Blogs?: InputMaybe<BlogsListRelationFilter>;
  Certificate?: InputMaybe<CertificateListRelationFilter>;
  Discussion?: InputMaybe<DiscussionListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<EventWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<EventWhereInput>>>;
  Quiz?: InputMaybe<QuizWhereInput>;
  QuizResult?: InputMaybe<QuizResultListRelationFilter>;
  ZohoEmail?: InputMaybe<ZohoEmailListRelationFilter>;
  ZoomMeeting?: InputMaybe<ZoomMeetingWhereInput>;
  addedBy?: InputMaybe<UserWhereInput>;
  addedById?: InputMaybe<IntNullableFilter>;
  address?: InputMaybe<StringNullableFilter>;
  addressAr?: InputMaybe<StringNullableFilter>;
  addressInstructions?: InputMaybe<StringNullableFilter>;
  addressInstructionsAr?: InputMaybe<StringNullableFilter>;
  backgroundImagesUrls?: InputMaybe<StringNullableListFilter>;
  city?: InputMaybe<CityWhereInput>;
  cityId?: InputMaybe<IntNullableFilter>;
  cmeHours?: InputMaybe<DecimalNullableFilter>;
  cmeNumber?: InputMaybe<StringNullableFilter>;
  coupons?: InputMaybe<CouponListRelationFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  defaultLanguage?: InputMaybe<EnumLanguageEnumFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  descriptionAr?: InputMaybe<StringNullableFilter>;
  descriptionEn?: InputMaybe<StringNullableFilter>;
  discussionStatus?: InputMaybe<BoolFilter>;
  endDate?: InputMaybe<DateTimeFilter>;
  eventDays?: InputMaybe<EventDayListRelationFilter>;
  eventIdentityCardTemplate?: InputMaybe<EventIdentityCardTemplateWhereInput>;
  eventLanguages?: InputMaybe<LanguageListRelationFilter>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingListRelationFilter>;
  eventParts?: InputMaybe<EventPartListRelationFilter>;
  eventType?: InputMaybe<EventTypeWhereInput>;
  eventTypeId?: InputMaybe<IntFilter>;
  expensesTransitions?: InputMaybe<TransitionListRelationFilter>;
  folder?: InputMaybe<EventFolderWhereInput>;
  folderId?: InputMaybe<IntFilter>;
  hiddenEvent?: InputMaybe<HiddenEventsWhereInput>;
  hideVideoProgress?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<IntFilter>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  introductionAr?: InputMaybe<StringNullableFilter>;
  introductionEn?: InputMaybe<StringNullableFilter>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitListRelationFilter>;
  invitersCanApprovePayments?: InputMaybe<BoolNullableFilter>;
  isAccredited?: InputMaybe<BoolFilter>;
  isAccreditedSHA?: InputMaybe<BoolFilter>;
  isAllProfessionsTargeted?: InputMaybe<BoolNullableFilter>;
  isContentProvidedByAcademy?: InputMaybe<BoolFilter>;
  isRegistraionClosed?: InputMaybe<BoolNullableFilter>;
  isSponsored?: InputMaybe<BoolFilter>;
  isTraineeCertificateAvailable?: InputMaybe<BoolFilter>;
  isTrainerCertificateAvailable?: InputMaybe<BoolFilter>;
  keywordsAr?: InputMaybe<StringNullableListFilter>;
  keywordsEn?: InputMaybe<StringNullableListFilter>;
  leaderTrainer?: InputMaybe<UserWhereInput>;
  leaderTrainerId?: InputMaybe<IntNullableFilter>;
  locationLatitude?: InputMaybe<DecimalNullableFilter>;
  locationLongitude?: InputMaybe<DecimalNullableFilter>;
  mainThemeAr?: InputMaybe<StringNullableFilter>;
  mainThemeEn?: InputMaybe<StringNullableFilter>;
  meetingId?: InputMaybe<StringNullableFilter>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryWhereInput>;
  methodOfDeliveryId?: InputMaybe<IntFilter>;
  minAttendancePercentageToGetCertificate?: InputMaybe<DecimalNullableFilter>;
  numberOfVisits?: InputMaybe<IntNullableFilter>;
  objectivesAr?: InputMaybe<StringNullableFilter>;
  objectivesEn?: InputMaybe<StringNullableFilter>;
  onlineCapacity?: InputMaybe<IntNullableFilter>;
  onsiteCapacity?: InputMaybe<IntNullableFilter>;
  outcomesAr?: InputMaybe<StringNullableFilter>;
  outcomesEn?: InputMaybe<StringNullableFilter>;
  package?: InputMaybe<EventWhereInput>;
  packageEvents?: InputMaybe<EventListRelationFilter>;
  packageId?: InputMaybe<IntNullableFilter>;
  pricingPlan?: InputMaybe<PricingPlanWhereInput>;
  pricingPlanId?: InputMaybe<IntFilter>;
  remindMeTrainees?: InputMaybe<UserListRelationFilter>;
  shortDescriptionAr?: InputMaybe<StringNullableFilter>;
  shortDescriptionEn?: InputMaybe<StringNullableFilter>;
  sponsorshipImagesUrls?: InputMaybe<JsonNullableFilter>;
  startDate?: InputMaybe<DateTimeFilter>;
  targetedAudiences?: InputMaybe<ProfessionListRelationFilter>;
  targetedSpecialities?: InputMaybe<SpecialtyListRelationFilter>;
  timeTableStatus?: InputMaybe<BoolFilter>;
  titleAr?: InputMaybe<StringFilter>;
  titleEn?: InputMaybe<StringFilter>;
  traineeCertificateTemplate?: InputMaybe<TemplateWhereInput>;
  traineeCertificateTemplateId?: InputMaybe<IntNullableFilter>;
  traineeEventGroups?: InputMaybe<TraineeEventGroupListRelationFilter>;
  traineeEventReviews?: InputMaybe<TraineeEventReviewListRelationFilter>;
  traineeEvents?: InputMaybe<TraineeEventListRelationFilter>;
  trainerCertificateTemplate?: InputMaybe<TemplateWhereInput>;
  trainerCertificateTemplateId?: InputMaybe<IntNullableFilter>;
  trainerEventStudyMaterialGroups?: InputMaybe<TrainerEventStudyMaterialGroupListRelationFilter>;
  trainerEventStudyMaterials?: InputMaybe<TrainerEventStudyMaterialListRelationFilter>;
  trainerEvents?: InputMaybe<TrainerEventListRelationFilter>;
  visibleOnArchive?: InputMaybe<BoolNullableFilter>;
  visitedTrainees?: InputMaybe<UserListRelationFilter>;
  whyTargetedAudienceAr?: InputMaybe<StringNullableFilter>;
  whyTargetedAudienceEn?: InputMaybe<StringNullableFilter>;
  youtubeUrl?: InputMaybe<StringNullableFilter>;
  zoomMeetingId?: InputMaybe<IntNullableFilter>;
  zoomMode?: InputMaybe<StringNullableFilter>;
};

export type EventWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  pricingPlanId?: InputMaybe<Scalars['Int']>;
};

export type EventsReport = {
  __typename?: 'EventsReport';
  EventResult: Array<EventCoulmn>;
  howHeardAboutEventResult: Array<HowHeardAboutEventCoulmn>;
  isProvidedByAcadmeyResult: Array<ProvidedByCoulmn>;
  languageResult: Array<LanguageCoulmn>;
};

export type EventsReportUniqueObject = {
  greaterDate?: InputMaybe<Scalars['DateTime']>;
  smallerDate?: InputMaybe<Scalars['DateTime']>;
  variance: Variance;
};

export type FcmInputType = {
  body: Scalars['String'];
  color?: InputMaybe<Scalars['String']>;
  eventId: Scalars['Int'];
  img?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export enum Gender {
  Female = 'female',
  Male = 'male'
}

export type GenderRecord = {
  __typename?: 'GenderRecord';
  gender?: Maybe<Scalars['String']>;
  month?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

export type HiddenEvents = {
  __typename?: 'HiddenEvents';
  _count: HiddenEventsCountAggregateOutputType;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<Event>;
  eventId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
};


export type HiddenEventsEventArgs = {
  cursor?: InputMaybe<EventWhereUniqueInput>;
  distinct?: InputMaybe<EventScalarFieldEnum>;
  orderBy?: InputMaybe<EventOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EventWhereInput>;
};

export type HiddenEventsAvgAggregateOutputType = {
  __typename?: 'HiddenEventsAvgAggregateOutputType';
  eventId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

export type HiddenEventsAvgOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type HiddenEventsCountAggregateOutputType = {
  __typename?: 'HiddenEventsCountAggregateOutputType';
  _all: Scalars['Int'];
  eventId: Scalars['Int'];
  id: Scalars['Int'];
};

export type HiddenEventsCountOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type HiddenEventsCreateInput = {
  event?: InputMaybe<EventCreateNestedOneWithoutHiddenEventInput>;
};

export type HiddenEventsCreateManyInput = {
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type HiddenEventsCreateNestedOneWithoutEventInput = {
  connect?: InputMaybe<HiddenEventsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<HiddenEventsCreateOrConnectWithoutEventInput>;
  create?: InputMaybe<HiddenEventsUncheckedCreateWithoutEventInput>;
};

export type HiddenEventsCreateOrConnectWithoutEventInput = {
  create: HiddenEventsUncheckedCreateWithoutEventInput;
  where: HiddenEventsWhereUniqueInput;
};

export type HiddenEventsMaxAggregateOutputType = {
  __typename?: 'HiddenEventsMaxAggregateOutputType';
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type HiddenEventsMaxOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type HiddenEventsMinAggregateOutputType = {
  __typename?: 'HiddenEventsMinAggregateOutputType';
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type HiddenEventsMinOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type HiddenEventsOrderByWithAggregationInput = {
  _avg?: InputMaybe<HiddenEventsAvgOrderByAggregateInput>;
  _count?: InputMaybe<HiddenEventsCountOrderByAggregateInput>;
  _max?: InputMaybe<HiddenEventsMaxOrderByAggregateInput>;
  _min?: InputMaybe<HiddenEventsMinOrderByAggregateInput>;
  _sum?: InputMaybe<HiddenEventsSumOrderByAggregateInput>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type HiddenEventsOrderByWithRelationInput = {
  event?: InputMaybe<EventOrderByWithRelationInput>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type HiddenEventsRelationFilter = {
  is?: InputMaybe<HiddenEventsWhereInput>;
  isNot?: InputMaybe<HiddenEventsWhereInput>;
};

export enum HiddenEventsScalarFieldEnum {
  EventId = 'eventId',
  Id = 'id'
}

export type HiddenEventsScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<HiddenEventsScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<HiddenEventsScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<HiddenEventsScalarWhereWithAggregatesInput>>>;
  eventId?: InputMaybe<IntNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
};

export type HiddenEventsSumAggregateOutputType = {
  __typename?: 'HiddenEventsSumAggregateOutputType';
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type HiddenEventsSumOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type HiddenEventsUncheckedCreateInput = {
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type HiddenEventsUncheckedCreateNestedOneWithoutEventInput = {
  connect?: InputMaybe<HiddenEventsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<HiddenEventsCreateOrConnectWithoutEventInput>;
  create?: InputMaybe<HiddenEventsUncheckedCreateWithoutEventInput>;
};

export type HiddenEventsUncheckedCreateWithoutEventInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type HiddenEventsUncheckedUpdateInput = {
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type HiddenEventsUncheckedUpdateManyInput = {
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type HiddenEventsUncheckedUpdateOneWithoutEventInput = {
  connect?: InputMaybe<HiddenEventsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<HiddenEventsCreateOrConnectWithoutEventInput>;
  create?: InputMaybe<HiddenEventsUncheckedCreateWithoutEventInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<HiddenEventsUncheckedUpdateWithoutEventInput>;
  upsert?: InputMaybe<HiddenEventsUpsertWithoutEventInput>;
};

export type HiddenEventsUncheckedUpdateWithoutEventInput = {
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type HiddenEventsUpdateInput = {
  event?: InputMaybe<EventUpdateOneWithoutHiddenEventInput>;
};

export type HiddenEventsUpdateOneWithoutEventInput = {
  connect?: InputMaybe<HiddenEventsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<HiddenEventsCreateOrConnectWithoutEventInput>;
  create?: InputMaybe<HiddenEventsUncheckedCreateWithoutEventInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<HiddenEventsUncheckedUpdateWithoutEventInput>;
  upsert?: InputMaybe<HiddenEventsUpsertWithoutEventInput>;
};

export type HiddenEventsUpsertWithoutEventInput = {
  create: HiddenEventsUncheckedCreateWithoutEventInput;
  update: HiddenEventsUncheckedUpdateWithoutEventInput;
};

export type HiddenEventsWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<HiddenEventsWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<HiddenEventsWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<HiddenEventsWhereInput>>>;
  event?: InputMaybe<EventWhereInput>;
  eventId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
};

export type HiddenEventsWhereUniqueInput = {
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type HowHeardAboutEvent = {
  __typename?: 'HowHeardAboutEvent';
  _count: HowHeardAboutEventCountOutputType;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeEvents: Array<TraineeEvent>;
};


export type HowHeardAboutEventTraineeEventsArgs = {
  cursor?: InputMaybe<TraineeEventWhereUniqueInput>;
  distinct?: InputMaybe<TraineeEventScalarFieldEnum>;
  orderBy?: InputMaybe<TraineeEventOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeEventWhereInput>;
};

export type HowHeardAboutEventAvgAggregateOutputType = {
  __typename?: 'HowHeardAboutEventAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
};

export type HowHeardAboutEventAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type HowHeardAboutEventCoulmn = {
  __typename?: 'HowHeardAboutEventCoulmn';
  howHeardAboutEventId?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

export type HowHeardAboutEventCountAggregateOutputType = {
  __typename?: 'HowHeardAboutEventCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  titleAr: Scalars['Int'];
  titleEn: Scalars['Int'];
};

export type HowHeardAboutEventCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type HowHeardAboutEventCountOutputType = {
  __typename?: 'HowHeardAboutEventCountOutputType';
  traineeEvents: Scalars['Int'];
};

export type HowHeardAboutEventCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutHowHeardAboutEventInput>;
};

export type HowHeardAboutEventCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type HowHeardAboutEventCreateNestedOneWithoutTraineeEventsInput = {
  connect?: InputMaybe<HowHeardAboutEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<HowHeardAboutEventCreateOrConnectWithoutTraineeEventsInput>;
  create?: InputMaybe<HowHeardAboutEventUncheckedCreateWithoutTraineeEventsInput>;
};

export type HowHeardAboutEventCreateOrConnectWithoutTraineeEventsInput = {
  create: HowHeardAboutEventUncheckedCreateWithoutTraineeEventsInput;
  where: HowHeardAboutEventWhereUniqueInput;
};

export type HowHeardAboutEventCreateWithoutTraineeEventsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type HowHeardAboutEventMaxAggregateOutputType = {
  __typename?: 'HowHeardAboutEventMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type HowHeardAboutEventMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type HowHeardAboutEventMinAggregateOutputType = {
  __typename?: 'HowHeardAboutEventMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type HowHeardAboutEventMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type HowHeardAboutEventOrderByWithAggregationInput = {
  _avg?: InputMaybe<HowHeardAboutEventAvgOrderByAggregateInput>;
  _count?: InputMaybe<HowHeardAboutEventCountOrderByAggregateInput>;
  _max?: InputMaybe<HowHeardAboutEventMaxOrderByAggregateInput>;
  _min?: InputMaybe<HowHeardAboutEventMinOrderByAggregateInput>;
  _sum?: InputMaybe<HowHeardAboutEventSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type HowHeardAboutEventOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
  traineeEvents?: InputMaybe<TraineeEventOrderByRelationAggregateInput>;
};

export type HowHeardAboutEventRelationFilter = {
  is?: InputMaybe<HowHeardAboutEventWhereInput>;
  isNot?: InputMaybe<HowHeardAboutEventWhereInput>;
};

export enum HowHeardAboutEventScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  TitleAr = 'titleAr',
  TitleEn = 'titleEn'
}

export type HowHeardAboutEventScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<HowHeardAboutEventScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<HowHeardAboutEventScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<HowHeardAboutEventScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  titleAr?: InputMaybe<StringWithAggregatesFilter>;
  titleEn?: InputMaybe<StringWithAggregatesFilter>;
};

export type HowHeardAboutEventSumAggregateOutputType = {
  __typename?: 'HowHeardAboutEventSumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
};

export type HowHeardAboutEventSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type HowHeardAboutEventUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutHowHeardAboutEventInput>;
};

export type HowHeardAboutEventUncheckedCreateWithoutTraineeEventsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type HowHeardAboutEventUncheckedUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutHowHeardAboutEventInput>;
};

export type HowHeardAboutEventUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type HowHeardAboutEventUncheckedUpdateWithoutTraineeEventsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type HowHeardAboutEventUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutHowHeardAboutEventInput>;
};

export type HowHeardAboutEventUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type HowHeardAboutEventUpdateOneWithoutTraineeEventsInput = {
  connect?: InputMaybe<HowHeardAboutEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<HowHeardAboutEventCreateOrConnectWithoutTraineeEventsInput>;
  create?: InputMaybe<HowHeardAboutEventUncheckedCreateWithoutTraineeEventsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<HowHeardAboutEventUncheckedUpdateWithoutTraineeEventsInput>;
  upsert?: InputMaybe<HowHeardAboutEventUpsertWithoutTraineeEventsInput>;
};

export type HowHeardAboutEventUpdateWithoutTraineeEventsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type HowHeardAboutEventUpsertWithoutTraineeEventsInput = {
  create: HowHeardAboutEventUncheckedCreateWithoutTraineeEventsInput;
  update: HowHeardAboutEventUncheckedUpdateWithoutTraineeEventsInput;
};

export type HowHeardAboutEventWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<HowHeardAboutEventWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<HowHeardAboutEventWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<HowHeardAboutEventWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  titleAr?: InputMaybe<StringFilter>;
  titleEn?: InputMaybe<StringFilter>;
  traineeEvents?: InputMaybe<TraineeEventListRelationFilter>;
};

export type HowHeardAboutEventWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn?: InputMaybe<Scalars['String']>;
};

export type InitiateBookingTransitionInputType = {
  paymentWayId: Scalars['Int'];
  traineeEventId: Scalars['Int'];
};

export type IntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']>;
  divide?: InputMaybe<Scalars['Int']>;
  increment?: InputMaybe<Scalars['Int']>;
  multiply?: InputMaybe<Scalars['Int']>;
  set?: InputMaybe<Scalars['Int']>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type IntNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedIntNullableFilter>;
  _min?: InputMaybe<NestedIntNullableFilter>;
  _sum?: InputMaybe<NestedIntNullableFilter>;
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type IntWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedIntFilter>;
  _min?: InputMaybe<NestedIntFilter>;
  _sum?: InputMaybe<NestedIntFilter>;
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type InviterCouponProfit = {
  __typename?: 'InviterCouponProfit';
  _count: InviterCouponProfitCountAggregateOutputType;
  coupon: Coupon;
  couponId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: Array<Event>;
  eventId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  inviter: Array<User>;
  inviterId?: Maybe<Scalars['Int']>;
  profit?: Maybe<Scalars['Decimal']>;
  traineeEvent: TraineeEvent;
  traineeEventId?: Maybe<Scalars['Int']>;
  user: User;
  userId?: Maybe<Scalars['Int']>;
};


export type InviterCouponProfitTraineeEventArgs = {
  cursor?: InputMaybe<TraineeEventWhereUniqueInput>;
  distinct?: InputMaybe<TraineeEventScalarFieldEnum>;
  orderBy?: InputMaybe<TraineeEventOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeEventWhereInput>;
};

export type InviterCouponProfitAvgAggregateOutputType = {
  __typename?: 'InviterCouponProfitAvgAggregateOutputType';
  couponId?: Maybe<Scalars['Float']>;
  eventId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  inviterId?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Decimal']>;
  traineeEventId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

export type InviterCouponProfitAvgOrderByAggregateInput = {
  couponId?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inviterId?: InputMaybe<SortOrder>;
  profit?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type InviterCouponProfitCountAggregateOutputType = {
  __typename?: 'InviterCouponProfitCountAggregateOutputType';
  _all: Scalars['Int'];
  couponId: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  eventId: Scalars['Int'];
  id: Scalars['Int'];
  inviterId: Scalars['Int'];
  profit: Scalars['Int'];
  traineeEventId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type InviterCouponProfitCountOrderByAggregateInput = {
  couponId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inviterId?: InputMaybe<SortOrder>;
  profit?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type InviterCouponProfitCreateInput = {
  coupon?: InputMaybe<CouponCreateNestedOneWithoutInviterCouponProfitsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  event?: InputMaybe<EventCreateNestedOneWithoutInviterCouponProfitsInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInviterCouponProfitsInput>;
  profit?: InputMaybe<Scalars['Decimal']>;
  traineeEvent?: InputMaybe<TraineeEventCreateNestedOneWithoutInviterCouponProfitInput>;
  user?: InputMaybe<UserCreateNestedOneWithoutUserCouponProfitsInput>;
};

export type InviterCouponProfitCreateManyCouponInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterId?: InputMaybe<Scalars['Int']>;
  profit?: InputMaybe<Scalars['Decimal']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type InviterCouponProfitCreateManyCouponInputEnvelope = {
  data: InviterCouponProfitCreateManyCouponInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type InviterCouponProfitCreateManyEventInput = {
  couponId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterId?: InputMaybe<Scalars['Int']>;
  profit?: InputMaybe<Scalars['Decimal']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type InviterCouponProfitCreateManyEventInputEnvelope = {
  data: InviterCouponProfitCreateManyEventInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type InviterCouponProfitCreateManyInput = {
  couponId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterId?: InputMaybe<Scalars['Int']>;
  profit?: InputMaybe<Scalars['Decimal']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type InviterCouponProfitCreateManyInviterInput = {
  couponId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  profit?: InputMaybe<Scalars['Decimal']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type InviterCouponProfitCreateManyInviterInputEnvelope = {
  data: InviterCouponProfitCreateManyInviterInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type InviterCouponProfitCreateManyUserInput = {
  couponId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterId?: InputMaybe<Scalars['Int']>;
  profit?: InputMaybe<Scalars['Decimal']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
};

export type InviterCouponProfitCreateManyUserInputEnvelope = {
  data: InviterCouponProfitCreateManyUserInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type InviterCouponProfitCreateNestedManyWithoutCouponInput = {
  connect?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<InviterCouponProfitCreateOrConnectWithoutCouponInput>>>;
  create?: InputMaybe<Array<InputMaybe<InviterCouponProfitCreateWithoutCouponInput>>>;
  createMany?: InputMaybe<InviterCouponProfitCreateManyCouponInputEnvelope>;
};

export type InviterCouponProfitCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<InviterCouponProfitCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<InviterCouponProfitCreateWithoutEventInput>>>;
  createMany?: InputMaybe<InviterCouponProfitCreateManyEventInputEnvelope>;
};

export type InviterCouponProfitCreateNestedManyWithoutInviterInput = {
  connect?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<InviterCouponProfitCreateOrConnectWithoutInviterInput>>>;
  create?: InputMaybe<Array<InputMaybe<InviterCouponProfitCreateWithoutInviterInput>>>;
  createMany?: InputMaybe<InviterCouponProfitCreateManyInviterInputEnvelope>;
};

export type InviterCouponProfitCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<InviterCouponProfitCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<InviterCouponProfitCreateWithoutUserInput>>>;
  createMany?: InputMaybe<InviterCouponProfitCreateManyUserInputEnvelope>;
};

export type InviterCouponProfitCreateNestedOneWithoutTraineeEventInput = {
  connect?: InputMaybe<InviterCouponProfitWhereUniqueInput>;
  connectOrCreate?: InputMaybe<InviterCouponProfitCreateOrConnectWithoutTraineeEventInput>;
  create?: InputMaybe<InviterCouponProfitUncheckedCreateWithoutTraineeEventInput>;
};

export type InviterCouponProfitCreateOrConnectWithoutCouponInput = {
  create: InviterCouponProfitUncheckedCreateWithoutCouponInput;
  where: InviterCouponProfitWhereUniqueInput;
};

export type InviterCouponProfitCreateOrConnectWithoutEventInput = {
  create: InviterCouponProfitUncheckedCreateWithoutEventInput;
  where: InviterCouponProfitWhereUniqueInput;
};

export type InviterCouponProfitCreateOrConnectWithoutInviterInput = {
  create: InviterCouponProfitUncheckedCreateWithoutInviterInput;
  where: InviterCouponProfitWhereUniqueInput;
};

export type InviterCouponProfitCreateOrConnectWithoutTraineeEventInput = {
  create: InviterCouponProfitUncheckedCreateWithoutTraineeEventInput;
  where: InviterCouponProfitWhereUniqueInput;
};

export type InviterCouponProfitCreateOrConnectWithoutUserInput = {
  create: InviterCouponProfitUncheckedCreateWithoutUserInput;
  where: InviterCouponProfitWhereUniqueInput;
};

export type InviterCouponProfitCreateWithoutCouponInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  event?: InputMaybe<EventCreateNestedOneWithoutInviterCouponProfitsInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInviterCouponProfitsInput>;
  profit?: InputMaybe<Scalars['Decimal']>;
  traineeEvent?: InputMaybe<TraineeEventCreateNestedOneWithoutInviterCouponProfitInput>;
  user?: InputMaybe<UserCreateNestedOneWithoutUserCouponProfitsInput>;
};

export type InviterCouponProfitCreateWithoutEventInput = {
  coupon?: InputMaybe<CouponCreateNestedOneWithoutInviterCouponProfitsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInviterCouponProfitsInput>;
  profit?: InputMaybe<Scalars['Decimal']>;
  traineeEvent?: InputMaybe<TraineeEventCreateNestedOneWithoutInviterCouponProfitInput>;
  user?: InputMaybe<UserCreateNestedOneWithoutUserCouponProfitsInput>;
};

export type InviterCouponProfitCreateWithoutInviterInput = {
  coupon?: InputMaybe<CouponCreateNestedOneWithoutInviterCouponProfitsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  event?: InputMaybe<EventCreateNestedOneWithoutInviterCouponProfitsInput>;
  profit?: InputMaybe<Scalars['Decimal']>;
  traineeEvent?: InputMaybe<TraineeEventCreateNestedOneWithoutInviterCouponProfitInput>;
  user?: InputMaybe<UserCreateNestedOneWithoutUserCouponProfitsInput>;
};

export type InviterCouponProfitCreateWithoutTraineeEventInput = {
  coupon?: InputMaybe<CouponCreateNestedOneWithoutInviterCouponProfitsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  event?: InputMaybe<EventCreateNestedOneWithoutInviterCouponProfitsInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInviterCouponProfitsInput>;
  profit?: InputMaybe<Scalars['Decimal']>;
  user?: InputMaybe<UserCreateNestedOneWithoutUserCouponProfitsInput>;
};

export type InviterCouponProfitCreateWithoutUserInput = {
  coupon?: InputMaybe<CouponCreateNestedOneWithoutInviterCouponProfitsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  event?: InputMaybe<EventCreateNestedOneWithoutInviterCouponProfitsInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInviterCouponProfitsInput>;
  profit?: InputMaybe<Scalars['Decimal']>;
  traineeEvent?: InputMaybe<TraineeEventCreateNestedOneWithoutInviterCouponProfitInput>;
};

export type InviterCouponProfitListRelationFilter = {
  every?: InputMaybe<InviterCouponProfitWhereInput>;
  none?: InputMaybe<InviterCouponProfitWhereInput>;
  some?: InputMaybe<InviterCouponProfitWhereInput>;
};

export type InviterCouponProfitMaxAggregateOutputType = {
  __typename?: 'InviterCouponProfitMaxAggregateOutputType';
  couponId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  inviterId?: Maybe<Scalars['Int']>;
  profit?: Maybe<Scalars['Decimal']>;
  traineeEventId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

export type InviterCouponProfitMaxOrderByAggregateInput = {
  couponId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inviterId?: InputMaybe<SortOrder>;
  profit?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type InviterCouponProfitMinAggregateOutputType = {
  __typename?: 'InviterCouponProfitMinAggregateOutputType';
  couponId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  inviterId?: Maybe<Scalars['Int']>;
  profit?: Maybe<Scalars['Decimal']>;
  traineeEventId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

export type InviterCouponProfitMinOrderByAggregateInput = {
  couponId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inviterId?: InputMaybe<SortOrder>;
  profit?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type InviterCouponProfitOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type InviterCouponProfitOrderByWithAggregationInput = {
  _avg?: InputMaybe<InviterCouponProfitAvgOrderByAggregateInput>;
  _count?: InputMaybe<InviterCouponProfitCountOrderByAggregateInput>;
  _max?: InputMaybe<InviterCouponProfitMaxOrderByAggregateInput>;
  _min?: InputMaybe<InviterCouponProfitMinOrderByAggregateInput>;
  _sum?: InputMaybe<InviterCouponProfitSumOrderByAggregateInput>;
  couponId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inviterId?: InputMaybe<SortOrder>;
  profit?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type InviterCouponProfitOrderByWithRelationInput = {
  coupon?: InputMaybe<CouponOrderByWithRelationInput>;
  couponId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  event?: InputMaybe<EventOrderByWithRelationInput>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inviter?: InputMaybe<UserOrderByWithRelationInput>;
  inviterId?: InputMaybe<SortOrder>;
  profit?: InputMaybe<SortOrder>;
  traineeEvent?: InputMaybe<TraineeEventOrderByWithRelationInput>;
  traineeEventId?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export type InviterCouponProfitRelationFilter = {
  is?: InputMaybe<InviterCouponProfitWhereInput>;
  isNot?: InputMaybe<InviterCouponProfitWhereInput>;
};

export enum InviterCouponProfitScalarFieldEnum {
  CouponId = 'couponId',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  EventId = 'eventId',
  Id = 'id',
  InviterId = 'inviterId',
  Profit = 'profit',
  TraineeEventId = 'traineeEventId',
  UserId = 'userId'
}

export type InviterCouponProfitScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<InviterCouponProfitScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<InviterCouponProfitScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<InviterCouponProfitScalarWhereInput>>>;
  couponId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  eventId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  inviterId?: InputMaybe<IntNullableFilter>;
  profit?: InputMaybe<DecimalFilter>;
  traineeEventId?: InputMaybe<IntNullableFilter>;
  userId?: InputMaybe<IntNullableFilter>;
};

export type InviterCouponProfitScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<InviterCouponProfitScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<InviterCouponProfitScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<InviterCouponProfitScalarWhereWithAggregatesInput>>>;
  couponId?: InputMaybe<IntNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  eventId?: InputMaybe<IntNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  inviterId?: InputMaybe<IntNullableWithAggregatesFilter>;
  profit?: InputMaybe<DecimalWithAggregatesFilter>;
  traineeEventId?: InputMaybe<IntNullableWithAggregatesFilter>;
  userId?: InputMaybe<IntNullableWithAggregatesFilter>;
};

export type InviterCouponProfitSumAggregateOutputType = {
  __typename?: 'InviterCouponProfitSumAggregateOutputType';
  couponId?: Maybe<Scalars['Int']>;
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  inviterId?: Maybe<Scalars['Int']>;
  profit?: Maybe<Scalars['Decimal']>;
  traineeEventId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

export type InviterCouponProfitSumOrderByAggregateInput = {
  couponId?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inviterId?: InputMaybe<SortOrder>;
  profit?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type InviterCouponProfitUncheckedCreateInput = {
  couponId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterId?: InputMaybe<Scalars['Int']>;
  profit?: InputMaybe<Scalars['Decimal']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type InviterCouponProfitUncheckedCreateNestedManyWithoutCouponInput = {
  connect?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<InviterCouponProfitCreateOrConnectWithoutCouponInput>>>;
  create?: InputMaybe<Array<InputMaybe<InviterCouponProfitCreateWithoutCouponInput>>>;
  createMany?: InputMaybe<InviterCouponProfitCreateManyCouponInputEnvelope>;
};

export type InviterCouponProfitUncheckedCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<InviterCouponProfitCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<InviterCouponProfitCreateWithoutEventInput>>>;
  createMany?: InputMaybe<InviterCouponProfitCreateManyEventInputEnvelope>;
};

export type InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput = {
  connect?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<InviterCouponProfitCreateOrConnectWithoutInviterInput>>>;
  create?: InputMaybe<Array<InputMaybe<InviterCouponProfitCreateWithoutInviterInput>>>;
  createMany?: InputMaybe<InviterCouponProfitCreateManyInviterInputEnvelope>;
};

export type InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<InviterCouponProfitCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<InviterCouponProfitCreateWithoutUserInput>>>;
  createMany?: InputMaybe<InviterCouponProfitCreateManyUserInputEnvelope>;
};

export type InviterCouponProfitUncheckedCreateNestedOneWithoutTraineeEventInput = {
  connect?: InputMaybe<InviterCouponProfitWhereUniqueInput>;
  connectOrCreate?: InputMaybe<InviterCouponProfitCreateOrConnectWithoutTraineeEventInput>;
  create?: InputMaybe<InviterCouponProfitUncheckedCreateWithoutTraineeEventInput>;
};

export type InviterCouponProfitUncheckedCreateWithoutCouponInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterId?: InputMaybe<Scalars['Int']>;
  profit?: InputMaybe<Scalars['Decimal']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type InviterCouponProfitUncheckedCreateWithoutEventInput = {
  couponId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterId?: InputMaybe<Scalars['Int']>;
  profit?: InputMaybe<Scalars['Decimal']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type InviterCouponProfitUncheckedCreateWithoutInviterInput = {
  couponId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  profit?: InputMaybe<Scalars['Decimal']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type InviterCouponProfitUncheckedCreateWithoutTraineeEventInput = {
  couponId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterId?: InputMaybe<Scalars['Int']>;
  profit?: InputMaybe<Scalars['Decimal']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type InviterCouponProfitUncheckedCreateWithoutUserInput = {
  couponId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterId?: InputMaybe<Scalars['Int']>;
  profit?: InputMaybe<Scalars['Decimal']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
};

export type InviterCouponProfitUncheckedUpdateInput = {
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  profit?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type InviterCouponProfitUncheckedUpdateManyInput = {
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  profit?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type InviterCouponProfitUncheckedUpdateManyWithoutCouponInput = {
  connect?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<InviterCouponProfitCreateOrConnectWithoutCouponInput>>>;
  create?: InputMaybe<Array<InputMaybe<InviterCouponProfitCreateWithoutCouponInput>>>;
  createMany?: InputMaybe<InviterCouponProfitCreateManyCouponInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<InviterCouponProfitScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<InviterCouponProfitUpdateWithWhereUniqueWithoutCouponInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<InviterCouponProfitUpdateManyWithWhereWithoutCouponInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<InviterCouponProfitUpsertWithWhereUniqueWithoutCouponInput>>>;
};

export type InviterCouponProfitUncheckedUpdateManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<InviterCouponProfitCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<InviterCouponProfitCreateWithoutEventInput>>>;
  createMany?: InputMaybe<InviterCouponProfitCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<InviterCouponProfitScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<InviterCouponProfitUpdateWithWhereUniqueWithoutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<InviterCouponProfitUpdateManyWithWhereWithoutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<InviterCouponProfitUpsertWithWhereUniqueWithoutEventInput>>>;
};

export type InviterCouponProfitUncheckedUpdateManyWithoutInviterCouponProfitsInput = {
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  profit?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type InviterCouponProfitUncheckedUpdateManyWithoutInviterInput = {
  connect?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<InviterCouponProfitCreateOrConnectWithoutInviterInput>>>;
  create?: InputMaybe<Array<InputMaybe<InviterCouponProfitCreateWithoutInviterInput>>>;
  createMany?: InputMaybe<InviterCouponProfitCreateManyInviterInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<InviterCouponProfitScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<InviterCouponProfitUpdateWithWhereUniqueWithoutInviterInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<InviterCouponProfitUpdateManyWithWhereWithoutInviterInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<InviterCouponProfitUpsertWithWhereUniqueWithoutInviterInput>>>;
};

export type InviterCouponProfitUncheckedUpdateManyWithoutUserCouponProfitsInput = {
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  profit?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type InviterCouponProfitUncheckedUpdateManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<InviterCouponProfitCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<InviterCouponProfitCreateWithoutUserInput>>>;
  createMany?: InputMaybe<InviterCouponProfitCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<InviterCouponProfitScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<InviterCouponProfitUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<InviterCouponProfitUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<InviterCouponProfitUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type InviterCouponProfitUncheckedUpdateOneWithoutTraineeEventInput = {
  connect?: InputMaybe<InviterCouponProfitWhereUniqueInput>;
  connectOrCreate?: InputMaybe<InviterCouponProfitCreateOrConnectWithoutTraineeEventInput>;
  create?: InputMaybe<InviterCouponProfitUncheckedCreateWithoutTraineeEventInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<InviterCouponProfitUncheckedUpdateWithoutTraineeEventInput>;
  upsert?: InputMaybe<InviterCouponProfitUpsertWithoutTraineeEventInput>;
};

export type InviterCouponProfitUncheckedUpdateWithoutCouponInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  profit?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type InviterCouponProfitUncheckedUpdateWithoutEventInput = {
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  profit?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type InviterCouponProfitUncheckedUpdateWithoutInviterInput = {
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  profit?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type InviterCouponProfitUncheckedUpdateWithoutTraineeEventInput = {
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  profit?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type InviterCouponProfitUncheckedUpdateWithoutUserInput = {
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  profit?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type InviterCouponProfitUpdateInput = {
  coupon?: InputMaybe<CouponUpdateOneWithoutInviterCouponProfitsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneWithoutInviterCouponProfitsInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInviterCouponProfitsInput>;
  profit?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEvent?: InputMaybe<TraineeEventUpdateOneWithoutInviterCouponProfitInput>;
  user?: InputMaybe<UserUpdateOneWithoutUserCouponProfitsInput>;
};

export type InviterCouponProfitUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  profit?: InputMaybe<DecimalFieldUpdateOperationsInput>;
};

export type InviterCouponProfitUpdateManyWithWhereWithoutCouponInput = {
  data: InviterCouponProfitUncheckedUpdateManyWithoutInviterCouponProfitsInput;
  where: InviterCouponProfitScalarWhereInput;
};

export type InviterCouponProfitUpdateManyWithWhereWithoutEventInput = {
  data: InviterCouponProfitUncheckedUpdateManyWithoutInviterCouponProfitsInput;
  where: InviterCouponProfitScalarWhereInput;
};

export type InviterCouponProfitUpdateManyWithWhereWithoutInviterInput = {
  data: InviterCouponProfitUncheckedUpdateManyWithoutInviterCouponProfitsInput;
  where: InviterCouponProfitScalarWhereInput;
};

export type InviterCouponProfitUpdateManyWithWhereWithoutUserInput = {
  data: InviterCouponProfitUncheckedUpdateManyWithoutUserCouponProfitsInput;
  where: InviterCouponProfitScalarWhereInput;
};

export type InviterCouponProfitUpdateManyWithoutCouponInput = {
  connect?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<InviterCouponProfitCreateOrConnectWithoutCouponInput>>>;
  create?: InputMaybe<Array<InputMaybe<InviterCouponProfitCreateWithoutCouponInput>>>;
  createMany?: InputMaybe<InviterCouponProfitCreateManyCouponInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<InviterCouponProfitScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<InviterCouponProfitUpdateWithWhereUniqueWithoutCouponInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<InviterCouponProfitUpdateManyWithWhereWithoutCouponInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<InviterCouponProfitUpsertWithWhereUniqueWithoutCouponInput>>>;
};

export type InviterCouponProfitUpdateManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<InviterCouponProfitCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<InviterCouponProfitCreateWithoutEventInput>>>;
  createMany?: InputMaybe<InviterCouponProfitCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<InviterCouponProfitScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<InviterCouponProfitUpdateWithWhereUniqueWithoutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<InviterCouponProfitUpdateManyWithWhereWithoutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<InviterCouponProfitUpsertWithWhereUniqueWithoutEventInput>>>;
};

export type InviterCouponProfitUpdateManyWithoutInviterInput = {
  connect?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<InviterCouponProfitCreateOrConnectWithoutInviterInput>>>;
  create?: InputMaybe<Array<InputMaybe<InviterCouponProfitCreateWithoutInviterInput>>>;
  createMany?: InputMaybe<InviterCouponProfitCreateManyInviterInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<InviterCouponProfitScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<InviterCouponProfitUpdateWithWhereUniqueWithoutInviterInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<InviterCouponProfitUpdateManyWithWhereWithoutInviterInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<InviterCouponProfitUpsertWithWhereUniqueWithoutInviterInput>>>;
};

export type InviterCouponProfitUpdateManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<InviterCouponProfitCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<InviterCouponProfitCreateWithoutUserInput>>>;
  createMany?: InputMaybe<InviterCouponProfitCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<InviterCouponProfitScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<InviterCouponProfitUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<InviterCouponProfitUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<InviterCouponProfitUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type InviterCouponProfitUpdateOneWithoutTraineeEventInput = {
  connect?: InputMaybe<InviterCouponProfitWhereUniqueInput>;
  connectOrCreate?: InputMaybe<InviterCouponProfitCreateOrConnectWithoutTraineeEventInput>;
  create?: InputMaybe<InviterCouponProfitUncheckedCreateWithoutTraineeEventInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<InviterCouponProfitUncheckedUpdateWithoutTraineeEventInput>;
  upsert?: InputMaybe<InviterCouponProfitUpsertWithoutTraineeEventInput>;
};

export type InviterCouponProfitUpdateWithWhereUniqueWithoutCouponInput = {
  data: InviterCouponProfitUncheckedUpdateWithoutCouponInput;
  where: InviterCouponProfitWhereUniqueInput;
};

export type InviterCouponProfitUpdateWithWhereUniqueWithoutEventInput = {
  data: InviterCouponProfitUncheckedUpdateWithoutEventInput;
  where: InviterCouponProfitWhereUniqueInput;
};

export type InviterCouponProfitUpdateWithWhereUniqueWithoutInviterInput = {
  data: InviterCouponProfitUncheckedUpdateWithoutInviterInput;
  where: InviterCouponProfitWhereUniqueInput;
};

export type InviterCouponProfitUpdateWithWhereUniqueWithoutUserInput = {
  data: InviterCouponProfitUncheckedUpdateWithoutUserInput;
  where: InviterCouponProfitWhereUniqueInput;
};

export type InviterCouponProfitUpdateWithoutCouponInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneWithoutInviterCouponProfitsInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInviterCouponProfitsInput>;
  profit?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEvent?: InputMaybe<TraineeEventUpdateOneWithoutInviterCouponProfitInput>;
  user?: InputMaybe<UserUpdateOneWithoutUserCouponProfitsInput>;
};

export type InviterCouponProfitUpdateWithoutEventInput = {
  coupon?: InputMaybe<CouponUpdateOneWithoutInviterCouponProfitsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInviterCouponProfitsInput>;
  profit?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEvent?: InputMaybe<TraineeEventUpdateOneWithoutInviterCouponProfitInput>;
  user?: InputMaybe<UserUpdateOneWithoutUserCouponProfitsInput>;
};

export type InviterCouponProfitUpdateWithoutInviterInput = {
  coupon?: InputMaybe<CouponUpdateOneWithoutInviterCouponProfitsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneWithoutInviterCouponProfitsInput>;
  profit?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEvent?: InputMaybe<TraineeEventUpdateOneWithoutInviterCouponProfitInput>;
  user?: InputMaybe<UserUpdateOneWithoutUserCouponProfitsInput>;
};

export type InviterCouponProfitUpdateWithoutTraineeEventInput = {
  coupon?: InputMaybe<CouponUpdateOneWithoutInviterCouponProfitsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneWithoutInviterCouponProfitsInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInviterCouponProfitsInput>;
  profit?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutUserCouponProfitsInput>;
};

export type InviterCouponProfitUpdateWithoutUserInput = {
  coupon?: InputMaybe<CouponUpdateOneWithoutInviterCouponProfitsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneWithoutInviterCouponProfitsInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInviterCouponProfitsInput>;
  profit?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEvent?: InputMaybe<TraineeEventUpdateOneWithoutInviterCouponProfitInput>;
};

export type InviterCouponProfitUpsertWithWhereUniqueWithoutCouponInput = {
  create: InviterCouponProfitUncheckedCreateWithoutCouponInput;
  update: InviterCouponProfitUncheckedUpdateWithoutCouponInput;
  where: InviterCouponProfitWhereUniqueInput;
};

export type InviterCouponProfitUpsertWithWhereUniqueWithoutEventInput = {
  create: InviterCouponProfitUncheckedCreateWithoutEventInput;
  update: InviterCouponProfitUncheckedUpdateWithoutEventInput;
  where: InviterCouponProfitWhereUniqueInput;
};

export type InviterCouponProfitUpsertWithWhereUniqueWithoutInviterInput = {
  create: InviterCouponProfitUncheckedCreateWithoutInviterInput;
  update: InviterCouponProfitUncheckedUpdateWithoutInviterInput;
  where: InviterCouponProfitWhereUniqueInput;
};

export type InviterCouponProfitUpsertWithWhereUniqueWithoutUserInput = {
  create: InviterCouponProfitUncheckedCreateWithoutUserInput;
  update: InviterCouponProfitUncheckedUpdateWithoutUserInput;
  where: InviterCouponProfitWhereUniqueInput;
};

export type InviterCouponProfitUpsertWithoutTraineeEventInput = {
  create: InviterCouponProfitUncheckedCreateWithoutTraineeEventInput;
  update: InviterCouponProfitUncheckedUpdateWithoutTraineeEventInput;
};

export type InviterCouponProfitWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<InviterCouponProfitWhereInput>>>;
  coupon?: InputMaybe<CouponWhereInput>;
  couponId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  event?: InputMaybe<EventWhereInput>;
  eventId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  inviter?: InputMaybe<UserWhereInput>;
  inviterId?: InputMaybe<IntNullableFilter>;
  profit?: InputMaybe<DecimalFilter>;
  traineeEvent?: InputMaybe<TraineeEventWhereInput>;
  traineeEventId?: InputMaybe<IntNullableFilter>;
  user?: InputMaybe<UserWhereInput>;
  userId?: InputMaybe<IntNullableFilter>;
};

export type InviterCouponProfitWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
};

export type JsonFilter = {
  equals?: InputMaybe<Scalars['Json']>;
  not?: InputMaybe<Scalars['Json']>;
};

export enum JsonNullValueFilter {
  AnyNull = 'AnyNull',
  DbNull = 'DbNull',
  JsonNull = 'JsonNull'
}

export enum JsonNullValueInput {
  JsonNull = 'JsonNull'
}

export type JsonNullableFilter = {
  equals?: InputMaybe<Scalars['Json']>;
  not?: InputMaybe<Scalars['Json']>;
};

export type JsonNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedJsonNullableFilter>;
  _min?: InputMaybe<NestedJsonNullableFilter>;
  equals?: InputMaybe<Scalars['Json']>;
  not?: InputMaybe<Scalars['Json']>;
};

export type JsonWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedJsonFilter>;
  _min?: InputMaybe<NestedJsonFilter>;
  equals?: InputMaybe<Scalars['Json']>;
  not?: InputMaybe<Scalars['Json']>;
};

export type Language = {
  __typename?: 'Language';
  _count: LanguageCountOutputType;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  events: Array<Event>;
  id: Scalars['Int'];
  title: Scalars['String'];
};


export type LanguageEventsArgs = {
  cursor?: InputMaybe<EventWhereUniqueInput>;
  distinct?: InputMaybe<EventScalarFieldEnum>;
  orderBy?: InputMaybe<EventOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EventWhereInput>;
};

export type LanguageAvgAggregateOutputType = {
  __typename?: 'LanguageAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
};

export type LanguageAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type LanguageCoulmn = {
  __typename?: 'LanguageCoulmn';
  languageId?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

export type LanguageCountAggregateOutputType = {
  __typename?: 'LanguageCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  title: Scalars['Int'];
};

export type LanguageCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type LanguageCountOutputType = {
  __typename?: 'LanguageCountOutputType';
  events: Scalars['Int'];
};

export type LanguageCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<EventCreateNestedManyWithoutEventLanguagesInput>;
  title: Scalars['String'];
};

export type LanguageCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type LanguageCreateNestedManyWithoutEventsInput = {
  connect?: InputMaybe<Array<InputMaybe<LanguageWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<LanguageCreateOrConnectWithoutEventsInput>>>;
  create?: InputMaybe<Array<InputMaybe<LanguageCreateWithoutEventsInput>>>;
};

export type LanguageCreateOrConnectWithoutEventsInput = {
  create: LanguageUncheckedCreateWithoutEventsInput;
  where: LanguageWhereUniqueInput;
};

export type LanguageCreateWithoutEventsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
};

export enum LanguageEnum {
  Ar = 'ar',
  En = 'en'
}

export type LanguageListRelationFilter = {
  every?: InputMaybe<LanguageWhereInput>;
  none?: InputMaybe<LanguageWhereInput>;
  some?: InputMaybe<LanguageWhereInput>;
};

export type LanguageMaxAggregateOutputType = {
  __typename?: 'LanguageMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type LanguageMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type LanguageMinAggregateOutputType = {
  __typename?: 'LanguageMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type LanguageMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type LanguageOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type LanguageOrderByWithAggregationInput = {
  _avg?: InputMaybe<LanguageAvgOrderByAggregateInput>;
  _count?: InputMaybe<LanguageCountOrderByAggregateInput>;
  _max?: InputMaybe<LanguageMaxOrderByAggregateInput>;
  _min?: InputMaybe<LanguageMinOrderByAggregateInput>;
  _sum?: InputMaybe<LanguageSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type LanguageOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  events?: InputMaybe<EventOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export enum LanguageScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  Title = 'title'
}

export type LanguageScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<LanguageScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<LanguageScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<LanguageScalarWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  title?: InputMaybe<StringFilter>;
};

export type LanguageScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<LanguageScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<LanguageScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<LanguageScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  title?: InputMaybe<StringWithAggregatesFilter>;
};

export type LanguageSumAggregateOutputType = {
  __typename?: 'LanguageSumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
};

export type LanguageSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type LanguageUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutEventLanguagesInput>;
  id?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type LanguageUncheckedCreateNestedManyWithoutEventsInput = {
  connect?: InputMaybe<Array<InputMaybe<LanguageWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<LanguageCreateOrConnectWithoutEventsInput>>>;
  create?: InputMaybe<Array<InputMaybe<LanguageCreateWithoutEventsInput>>>;
};

export type LanguageUncheckedCreateWithoutEventsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type LanguageUncheckedUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutEventLanguagesInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type LanguageUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type LanguageUncheckedUpdateManyWithoutEventLanguagesInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type LanguageUncheckedUpdateManyWithoutEventsInput = {
  connect?: InputMaybe<Array<InputMaybe<LanguageWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<LanguageCreateOrConnectWithoutEventsInput>>>;
  create?: InputMaybe<Array<InputMaybe<LanguageCreateWithoutEventsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<LanguageWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<LanguageScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<LanguageWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<LanguageWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<LanguageUpdateWithWhereUniqueWithoutEventsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<LanguageUpdateManyWithWhereWithoutEventsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<LanguageUpsertWithWhereUniqueWithoutEventsInput>>>;
};

export type LanguageUncheckedUpdateWithoutEventsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type LanguageUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventUpdateManyWithoutEventLanguagesInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type LanguageUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type LanguageUpdateManyWithWhereWithoutEventsInput = {
  data: LanguageUncheckedUpdateManyWithoutEventLanguagesInput;
  where: LanguageScalarWhereInput;
};

export type LanguageUpdateManyWithoutEventsInput = {
  connect?: InputMaybe<Array<InputMaybe<LanguageWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<LanguageCreateOrConnectWithoutEventsInput>>>;
  create?: InputMaybe<Array<InputMaybe<LanguageCreateWithoutEventsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<LanguageWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<LanguageScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<LanguageWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<LanguageWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<LanguageUpdateWithWhereUniqueWithoutEventsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<LanguageUpdateManyWithWhereWithoutEventsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<LanguageUpsertWithWhereUniqueWithoutEventsInput>>>;
};

export type LanguageUpdateWithWhereUniqueWithoutEventsInput = {
  data: LanguageUncheckedUpdateWithoutEventsInput;
  where: LanguageWhereUniqueInput;
};

export type LanguageUpdateWithoutEventsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type LanguageUpsertWithWhereUniqueWithoutEventsInput = {
  create: LanguageUncheckedCreateWithoutEventsInput;
  update: LanguageUncheckedUpdateWithoutEventsInput;
  where: LanguageWhereUniqueInput;
};

export type LanguageWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<LanguageWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<LanguageWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<LanguageWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  events?: InputMaybe<EventListRelationFilter>;
  id?: InputMaybe<IntFilter>;
  title?: InputMaybe<StringFilter>;
};

export type LanguageWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export enum MarketerProfitType {
  Fixed = 'fixed',
  Percentage = 'percentage'
}

export type MarketersReport = {
  __typename?: 'MarketersReport';
  countRecord: Array<CountRecord>;
};

export type MarketersReportUniqueObject = {
  greaterDate?: InputMaybe<Scalars['DateTime']>;
  smallerDate?: InputMaybe<Scalars['DateTime']>;
  variance: Variance;
};

export type MemberNeedSettings = {
  __typename?: 'MemberNeedSettings';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  titleAr: Scalars['String'];
  titleEn?: Maybe<Scalars['String']>;
};

export type MemberNeedSettingsAvgAggregateOutputType = {
  __typename?: 'MemberNeedSettingsAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
};

export type MemberNeedSettingsAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type MemberNeedSettingsCountAggregateOutputType = {
  __typename?: 'MemberNeedSettingsCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  titleAr: Scalars['Int'];
  titleEn: Scalars['Int'];
};

export type MemberNeedSettingsCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type MemberNeedSettingsCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type MemberNeedSettingsCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type MemberNeedSettingsMaxAggregateOutputType = {
  __typename?: 'MemberNeedSettingsMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type MemberNeedSettingsMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type MemberNeedSettingsMinAggregateOutputType = {
  __typename?: 'MemberNeedSettingsMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type MemberNeedSettingsMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type MemberNeedSettingsOrderByWithAggregationInput = {
  _avg?: InputMaybe<MemberNeedSettingsAvgOrderByAggregateInput>;
  _count?: InputMaybe<MemberNeedSettingsCountOrderByAggregateInput>;
  _max?: InputMaybe<MemberNeedSettingsMaxOrderByAggregateInput>;
  _min?: InputMaybe<MemberNeedSettingsMinOrderByAggregateInput>;
  _sum?: InputMaybe<MemberNeedSettingsSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type MemberNeedSettingsOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export enum MemberNeedSettingsScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  TitleAr = 'titleAr',
  TitleEn = 'titleEn'
}

export type MemberNeedSettingsScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<MemberNeedSettingsScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<MemberNeedSettingsScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<MemberNeedSettingsScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  titleAr?: InputMaybe<StringWithAggregatesFilter>;
  titleEn?: InputMaybe<StringWithAggregatesFilter>;
};

export type MemberNeedSettingsSumAggregateOutputType = {
  __typename?: 'MemberNeedSettingsSumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
};

export type MemberNeedSettingsSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type MemberNeedSettingsUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type MemberNeedSettingsUncheckedUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MemberNeedSettingsUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MemberNeedSettingsUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MemberNeedSettingsUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MemberNeedSettingsWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<MemberNeedSettingsWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<MemberNeedSettingsWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<MemberNeedSettingsWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  titleAr?: InputMaybe<StringFilter>;
  titleEn?: InputMaybe<StringFilter>;
};

export type MemberNeedSettingsWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn?: InputMaybe<Scalars['String']>;
};

export type MemberNeeds = {
  __typename?: 'MemberNeeds';
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['Json']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  status: MemberNeedsStatus;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']>;
};

export type MemberNeedsAvgAggregateOutputType = {
  __typename?: 'MemberNeedsAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

export type MemberNeedsAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type MemberNeedsCountAggregateOutputType = {
  __typename?: 'MemberNeedsCountAggregateOutputType';
  _all: Scalars['Int'];
  courseTitle: Scalars['Int'];
  createdAt: Scalars['Int'];
  data: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  information: Scalars['Int'];
  objectives: Scalars['Int'];
  status: Scalars['Int'];
  userId: Scalars['Int'];
};

export type MemberNeedsCountOrderByAggregateInput = {
  courseTitle?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  information?: InputMaybe<SortOrder>;
  objectives?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type MemberNeedsCreateInput = {
  courseTitle?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data?: InputMaybe<Scalars['Json']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  information?: InputMaybe<Scalars['String']>;
  objectives?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<MemberNeedsStatus>;
  user?: InputMaybe<UserCreateNestedOneWithoutMemberNeedsInput>;
};

export type MemberNeedsCreateManyInput = {
  courseTitle?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data?: InputMaybe<Scalars['Json']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  information?: InputMaybe<Scalars['String']>;
  objectives?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<MemberNeedsStatus>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type MemberNeedsCreateManyUserInput = {
  courseTitle?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data?: InputMaybe<Scalars['Json']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  information?: InputMaybe<Scalars['String']>;
  objectives?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<MemberNeedsStatus>;
};

export type MemberNeedsCreateManyUserInputEnvelope = {
  data: MemberNeedsCreateManyUserInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MemberNeedsCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<MemberNeedsWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<MemberNeedsCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<MemberNeedsCreateWithoutUserInput>>>;
  createMany?: InputMaybe<MemberNeedsCreateManyUserInputEnvelope>;
};

export type MemberNeedsCreateOrConnectWithoutUserInput = {
  create: MemberNeedsUncheckedCreateWithoutUserInput;
  where: MemberNeedsWhereUniqueInput;
};

export type MemberNeedsCreateWithoutUserInput = {
  courseTitle?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data?: InputMaybe<Scalars['Json']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  information?: InputMaybe<Scalars['String']>;
  objectives?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<MemberNeedsStatus>;
};

export type MemberNeedsListRelationFilter = {
  every?: InputMaybe<MemberNeedsWhereInput>;
  none?: InputMaybe<MemberNeedsWhereInput>;
  some?: InputMaybe<MemberNeedsWhereInput>;
};

export type MemberNeedsMaxAggregateOutputType = {
  __typename?: 'MemberNeedsMaxAggregateOutputType';
  courseTitle?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  information?: Maybe<Scalars['String']>;
  objectives?: Maybe<Scalars['String']>;
  status?: Maybe<MemberNeedsStatus>;
  userId?: Maybe<Scalars['Int']>;
};

export type MemberNeedsMaxOrderByAggregateInput = {
  courseTitle?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  information?: InputMaybe<SortOrder>;
  objectives?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type MemberNeedsMinAggregateOutputType = {
  __typename?: 'MemberNeedsMinAggregateOutputType';
  courseTitle?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  information?: Maybe<Scalars['String']>;
  objectives?: Maybe<Scalars['String']>;
  status?: Maybe<MemberNeedsStatus>;
  userId?: Maybe<Scalars['Int']>;
};

export type MemberNeedsMinOrderByAggregateInput = {
  courseTitle?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  information?: InputMaybe<SortOrder>;
  objectives?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type MemberNeedsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type MemberNeedsOrderByWithAggregationInput = {
  _avg?: InputMaybe<MemberNeedsAvgOrderByAggregateInput>;
  _count?: InputMaybe<MemberNeedsCountOrderByAggregateInput>;
  _max?: InputMaybe<MemberNeedsMaxOrderByAggregateInput>;
  _min?: InputMaybe<MemberNeedsMinOrderByAggregateInput>;
  _sum?: InputMaybe<MemberNeedsSumOrderByAggregateInput>;
  courseTitle?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  information?: InputMaybe<SortOrder>;
  objectives?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type MemberNeedsOrderByWithRelationInput = {
  courseTitle?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  information?: InputMaybe<SortOrder>;
  objectives?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum MemberNeedsScalarFieldEnum {
  CourseTitle = 'courseTitle',
  CreatedAt = 'createdAt',
  Data = 'data',
  DeletedAt = 'deletedAt',
  Id = 'id',
  Information = 'information',
  Objectives = 'objectives',
  Status = 'status',
  UserId = 'userId'
}

export type MemberNeedsScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<MemberNeedsScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<MemberNeedsScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<MemberNeedsScalarWhereInput>>>;
  courseTitle?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  data?: InputMaybe<JsonFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  information?: InputMaybe<StringNullableFilter>;
  objectives?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumMemberNeedsStatusFilter>;
  userId?: InputMaybe<IntNullableFilter>;
};

export type MemberNeedsScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<MemberNeedsScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<MemberNeedsScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<MemberNeedsScalarWhereWithAggregatesInput>>>;
  courseTitle?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  data?: InputMaybe<JsonWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  information?: InputMaybe<StringNullableWithAggregatesFilter>;
  objectives?: InputMaybe<StringNullableWithAggregatesFilter>;
  status?: InputMaybe<EnumMemberNeedsStatusWithAggregatesFilter>;
  userId?: InputMaybe<IntNullableWithAggregatesFilter>;
};

export enum MemberNeedsStatus {
  Approved = 'approved',
  Declined = 'declined',
  Important = 'important',
  Pending = 'pending'
}

export type MemberNeedsSumAggregateOutputType = {
  __typename?: 'MemberNeedsSumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

export type MemberNeedsSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type MemberNeedsUncheckedCreateInput = {
  courseTitle?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data?: InputMaybe<Scalars['Json']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  information?: InputMaybe<Scalars['String']>;
  objectives?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<MemberNeedsStatus>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type MemberNeedsUncheckedCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<MemberNeedsWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<MemberNeedsCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<MemberNeedsCreateWithoutUserInput>>>;
  createMany?: InputMaybe<MemberNeedsCreateManyUserInputEnvelope>;
};

export type MemberNeedsUncheckedCreateWithoutUserInput = {
  courseTitle?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data?: InputMaybe<Scalars['Json']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  information?: InputMaybe<Scalars['String']>;
  objectives?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<MemberNeedsStatus>;
};

export type MemberNeedsUncheckedUpdateInput = {
  courseTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  information?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectives?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMemberNeedsStatusFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type MemberNeedsUncheckedUpdateManyInput = {
  courseTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  information?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectives?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMemberNeedsStatusFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type MemberNeedsUncheckedUpdateManyWithoutMemberNeedsInput = {
  courseTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  information?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectives?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMemberNeedsStatusFieldUpdateOperationsInput>;
};

export type MemberNeedsUncheckedUpdateManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<MemberNeedsWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<MemberNeedsCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<MemberNeedsCreateWithoutUserInput>>>;
  createMany?: InputMaybe<MemberNeedsCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<MemberNeedsWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<MemberNeedsScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<MemberNeedsWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<MemberNeedsWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<MemberNeedsUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<MemberNeedsUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<MemberNeedsUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type MemberNeedsUncheckedUpdateWithoutUserInput = {
  courseTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  information?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectives?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMemberNeedsStatusFieldUpdateOperationsInput>;
};

export type MemberNeedsUpdateInput = {
  courseTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  information?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectives?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMemberNeedsStatusFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutMemberNeedsInput>;
};

export type MemberNeedsUpdateManyMutationInput = {
  courseTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  information?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectives?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMemberNeedsStatusFieldUpdateOperationsInput>;
};

export type MemberNeedsUpdateManyWithWhereWithoutUserInput = {
  data: MemberNeedsUncheckedUpdateManyWithoutMemberNeedsInput;
  where: MemberNeedsScalarWhereInput;
};

export type MemberNeedsUpdateManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<MemberNeedsWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<MemberNeedsCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<MemberNeedsCreateWithoutUserInput>>>;
  createMany?: InputMaybe<MemberNeedsCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<MemberNeedsWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<MemberNeedsScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<MemberNeedsWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<MemberNeedsWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<MemberNeedsUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<MemberNeedsUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<MemberNeedsUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type MemberNeedsUpdateWithWhereUniqueWithoutUserInput = {
  data: MemberNeedsUncheckedUpdateWithoutUserInput;
  where: MemberNeedsWhereUniqueInput;
};

export type MemberNeedsUpdateWithoutUserInput = {
  courseTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  information?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectives?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumMemberNeedsStatusFieldUpdateOperationsInput>;
};

export type MemberNeedsUpsertWithWhereUniqueWithoutUserInput = {
  create: MemberNeedsUncheckedCreateWithoutUserInput;
  update: MemberNeedsUncheckedUpdateWithoutUserInput;
  where: MemberNeedsWhereUniqueInput;
};

export type MemberNeedsWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<MemberNeedsWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<MemberNeedsWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<MemberNeedsWhereInput>>>;
  courseTitle?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  data?: InputMaybe<JsonFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  information?: InputMaybe<StringNullableFilter>;
  objectives?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumMemberNeedsStatusFilter>;
  user?: InputMaybe<UserWhereInput>;
  userId?: InputMaybe<IntNullableFilter>;
};

export type MemberNeedsWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type MergeAccountsInputType = {
  mainUserId: Scalars['Int'];
  secondaryUserEmail: Scalars['String'];
};

export type MethodOfDelivery = {
  __typename?: 'MethodOfDelivery';
  _count: MethodOfDeliveryCountOutputType;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  events: Array<Event>;
  id: Scalars['Int'];
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};


export type MethodOfDeliveryEventsArgs = {
  cursor?: InputMaybe<EventWhereUniqueInput>;
  distinct?: InputMaybe<EventScalarFieldEnum>;
  orderBy?: InputMaybe<EventOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EventWhereInput>;
};

export type MethodOfDeliveryAvgAggregateOutputType = {
  __typename?: 'MethodOfDeliveryAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
};

export type MethodOfDeliveryAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type MethodOfDeliveryCountAggregateOutputType = {
  __typename?: 'MethodOfDeliveryCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  titleAr: Scalars['Int'];
  titleEn: Scalars['Int'];
};

export type MethodOfDeliveryCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type MethodOfDeliveryCountOutputType = {
  __typename?: 'MethodOfDeliveryCountOutputType';
  EventDay: Scalars['Int'];
  TraineeEvent: Scalars['Int'];
  events: Scalars['Int'];
};

export type MethodOfDeliveryCreateInput = {
  EventDay?: InputMaybe<EventDayCreateNestedManyWithoutMethodOfDeliveryInput>;
  TraineeEvent?: InputMaybe<TraineeEventCreateNestedManyWithoutMethodOfDeliveryInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<EventCreateNestedManyWithoutMethodOfDeliveryInput>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type MethodOfDeliveryCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type MethodOfDeliveryCreateNestedOneWithoutEventDayInput = {
  connect?: InputMaybe<MethodOfDeliveryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MethodOfDeliveryCreateOrConnectWithoutEventDayInput>;
  create?: InputMaybe<MethodOfDeliveryUncheckedCreateWithoutEventDayInput>;
};

export type MethodOfDeliveryCreateNestedOneWithoutEventsInput = {
  connect?: InputMaybe<MethodOfDeliveryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MethodOfDeliveryCreateOrConnectWithoutEventsInput>;
  create?: InputMaybe<MethodOfDeliveryUncheckedCreateWithoutEventsInput>;
};

export type MethodOfDeliveryCreateNestedOneWithoutTraineeEventInput = {
  connect?: InputMaybe<MethodOfDeliveryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MethodOfDeliveryCreateOrConnectWithoutTraineeEventInput>;
  create?: InputMaybe<MethodOfDeliveryUncheckedCreateWithoutTraineeEventInput>;
};

export type MethodOfDeliveryCreateOrConnectWithoutEventDayInput = {
  create: MethodOfDeliveryUncheckedCreateWithoutEventDayInput;
  where: MethodOfDeliveryWhereUniqueInput;
};

export type MethodOfDeliveryCreateOrConnectWithoutEventsInput = {
  create: MethodOfDeliveryUncheckedCreateWithoutEventsInput;
  where: MethodOfDeliveryWhereUniqueInput;
};

export type MethodOfDeliveryCreateOrConnectWithoutTraineeEventInput = {
  create: MethodOfDeliveryUncheckedCreateWithoutTraineeEventInput;
  where: MethodOfDeliveryWhereUniqueInput;
};

export type MethodOfDeliveryCreateWithoutEventDayInput = {
  TraineeEvent?: InputMaybe<TraineeEventCreateNestedManyWithoutMethodOfDeliveryInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<EventCreateNestedManyWithoutMethodOfDeliveryInput>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type MethodOfDeliveryCreateWithoutEventsInput = {
  EventDay?: InputMaybe<EventDayCreateNestedManyWithoutMethodOfDeliveryInput>;
  TraineeEvent?: InputMaybe<TraineeEventCreateNestedManyWithoutMethodOfDeliveryInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type MethodOfDeliveryCreateWithoutTraineeEventInput = {
  EventDay?: InputMaybe<EventDayCreateNestedManyWithoutMethodOfDeliveryInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<EventCreateNestedManyWithoutMethodOfDeliveryInput>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type MethodOfDeliveryMaxAggregateOutputType = {
  __typename?: 'MethodOfDeliveryMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type MethodOfDeliveryMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type MethodOfDeliveryMinAggregateOutputType = {
  __typename?: 'MethodOfDeliveryMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type MethodOfDeliveryMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type MethodOfDeliveryOrderByWithAggregationInput = {
  _avg?: InputMaybe<MethodOfDeliveryAvgOrderByAggregateInput>;
  _count?: InputMaybe<MethodOfDeliveryCountOrderByAggregateInput>;
  _max?: InputMaybe<MethodOfDeliveryMaxOrderByAggregateInput>;
  _min?: InputMaybe<MethodOfDeliveryMinOrderByAggregateInput>;
  _sum?: InputMaybe<MethodOfDeliverySumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type MethodOfDeliveryOrderByWithRelationInput = {
  EventDay?: InputMaybe<EventDayOrderByRelationAggregateInput>;
  TraineeEvent?: InputMaybe<TraineeEventOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  events?: InputMaybe<EventOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type MethodOfDeliveryRelationFilter = {
  is?: InputMaybe<MethodOfDeliveryWhereInput>;
  isNot?: InputMaybe<MethodOfDeliveryWhereInput>;
};

export enum MethodOfDeliveryScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  TitleAr = 'titleAr',
  TitleEn = 'titleEn'
}

export type MethodOfDeliveryScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<MethodOfDeliveryScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<MethodOfDeliveryScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<MethodOfDeliveryScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  titleAr?: InputMaybe<StringWithAggregatesFilter>;
  titleEn?: InputMaybe<StringWithAggregatesFilter>;
};

export type MethodOfDeliverySumAggregateOutputType = {
  __typename?: 'MethodOfDeliverySumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
};

export type MethodOfDeliverySumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type MethodOfDeliveryUncheckedCreateInput = {
  EventDay?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutMethodOfDeliveryInput>;
  TraineeEvent?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutMethodOfDeliveryInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutMethodOfDeliveryInput>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type MethodOfDeliveryUncheckedCreateWithoutEventDayInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutMethodOfDeliveryInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutMethodOfDeliveryInput>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type MethodOfDeliveryUncheckedCreateWithoutEventsInput = {
  EventDay?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutMethodOfDeliveryInput>;
  TraineeEvent?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutMethodOfDeliveryInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type MethodOfDeliveryUncheckedCreateWithoutTraineeEventInput = {
  EventDay?: InputMaybe<EventDayUncheckedCreateNestedManyWithoutMethodOfDeliveryInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutMethodOfDeliveryInput>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type MethodOfDeliveryUncheckedUpdateInput = {
  EventDay?: InputMaybe<EventDayUncheckedUpdateManyWithoutMethodOfDeliveryInput>;
  TraineeEvent?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutMethodOfDeliveryInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutMethodOfDeliveryInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MethodOfDeliveryUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MethodOfDeliveryUncheckedUpdateWithoutEventDayInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutMethodOfDeliveryInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutMethodOfDeliveryInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MethodOfDeliveryUncheckedUpdateWithoutEventsInput = {
  EventDay?: InputMaybe<EventDayUncheckedUpdateManyWithoutMethodOfDeliveryInput>;
  TraineeEvent?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutMethodOfDeliveryInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MethodOfDeliveryUncheckedUpdateWithoutTraineeEventInput = {
  EventDay?: InputMaybe<EventDayUncheckedUpdateManyWithoutMethodOfDeliveryInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutMethodOfDeliveryInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MethodOfDeliveryUpdateInput = {
  EventDay?: InputMaybe<EventDayUpdateManyWithoutMethodOfDeliveryInput>;
  TraineeEvent?: InputMaybe<TraineeEventUpdateManyWithoutMethodOfDeliveryInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventUpdateManyWithoutMethodOfDeliveryInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MethodOfDeliveryUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MethodOfDeliveryUpdateOneRequiredWithoutEventsInput = {
  connect?: InputMaybe<MethodOfDeliveryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MethodOfDeliveryCreateOrConnectWithoutEventsInput>;
  create?: InputMaybe<MethodOfDeliveryUncheckedCreateWithoutEventsInput>;
  update?: InputMaybe<MethodOfDeliveryUncheckedUpdateWithoutEventsInput>;
  upsert?: InputMaybe<MethodOfDeliveryUpsertWithoutEventsInput>;
};

export type MethodOfDeliveryUpdateOneWithoutEventDayInput = {
  connect?: InputMaybe<MethodOfDeliveryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MethodOfDeliveryCreateOrConnectWithoutEventDayInput>;
  create?: InputMaybe<MethodOfDeliveryUncheckedCreateWithoutEventDayInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<MethodOfDeliveryUncheckedUpdateWithoutEventDayInput>;
  upsert?: InputMaybe<MethodOfDeliveryUpsertWithoutEventDayInput>;
};

export type MethodOfDeliveryUpdateOneWithoutTraineeEventInput = {
  connect?: InputMaybe<MethodOfDeliveryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MethodOfDeliveryCreateOrConnectWithoutTraineeEventInput>;
  create?: InputMaybe<MethodOfDeliveryUncheckedCreateWithoutTraineeEventInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<MethodOfDeliveryUncheckedUpdateWithoutTraineeEventInput>;
  upsert?: InputMaybe<MethodOfDeliveryUpsertWithoutTraineeEventInput>;
};

export type MethodOfDeliveryUpdateWithoutEventDayInput = {
  TraineeEvent?: InputMaybe<TraineeEventUpdateManyWithoutMethodOfDeliveryInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventUpdateManyWithoutMethodOfDeliveryInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MethodOfDeliveryUpdateWithoutEventsInput = {
  EventDay?: InputMaybe<EventDayUpdateManyWithoutMethodOfDeliveryInput>;
  TraineeEvent?: InputMaybe<TraineeEventUpdateManyWithoutMethodOfDeliveryInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MethodOfDeliveryUpdateWithoutTraineeEventInput = {
  EventDay?: InputMaybe<EventDayUpdateManyWithoutMethodOfDeliveryInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventUpdateManyWithoutMethodOfDeliveryInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MethodOfDeliveryUpsertWithoutEventDayInput = {
  create: MethodOfDeliveryUncheckedCreateWithoutEventDayInput;
  update: MethodOfDeliveryUncheckedUpdateWithoutEventDayInput;
};

export type MethodOfDeliveryUpsertWithoutEventsInput = {
  create: MethodOfDeliveryUncheckedCreateWithoutEventsInput;
  update: MethodOfDeliveryUncheckedUpdateWithoutEventsInput;
};

export type MethodOfDeliveryUpsertWithoutTraineeEventInput = {
  create: MethodOfDeliveryUncheckedCreateWithoutTraineeEventInput;
  update: MethodOfDeliveryUncheckedUpdateWithoutTraineeEventInput;
};

export type MethodOfDeliveryWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<MethodOfDeliveryWhereInput>>>;
  EventDay?: InputMaybe<EventDayListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<MethodOfDeliveryWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<MethodOfDeliveryWhereInput>>>;
  TraineeEvent?: InputMaybe<TraineeEventListRelationFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  events?: InputMaybe<EventListRelationFilter>;
  id?: InputMaybe<IntFilter>;
  titleAr?: InputMaybe<StringFilter>;
  titleEn?: InputMaybe<StringFilter>;
};

export type MethodOfDeliveryWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn?: InputMaybe<Scalars['String']>;
};

export type MethodOfTeachingType = {
  __typename?: 'MethodOfTeachingType';
  _count: MethodOfTeachingTypeCountOutputType;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  lessons: Array<TrainerEventDayLesson>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};


export type MethodOfTeachingTypeLessonsArgs = {
  cursor?: InputMaybe<TrainerEventDayLessonWhereUniqueInput>;
  distinct?: InputMaybe<TrainerEventDayLessonScalarFieldEnum>;
  orderBy?: InputMaybe<TrainerEventDayLessonOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TrainerEventDayLessonWhereInput>;
};

export type MethodOfTeachingTypeAvgAggregateOutputType = {
  __typename?: 'MethodOfTeachingTypeAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
};

export type MethodOfTeachingTypeAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type MethodOfTeachingTypeCountAggregateOutputType = {
  __typename?: 'MethodOfTeachingTypeCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  titleAr: Scalars['Int'];
  titleEn: Scalars['Int'];
};

export type MethodOfTeachingTypeCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type MethodOfTeachingTypeCountOutputType = {
  __typename?: 'MethodOfTeachingTypeCountOutputType';
  lessons: Scalars['Int'];
};

export type MethodOfTeachingTypeCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  lessons?: InputMaybe<TrainerEventDayLessonCreateNestedManyWithoutMethodOfTeachingInput>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type MethodOfTeachingTypeCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type MethodOfTeachingTypeCreateNestedOneWithoutLessonsInput = {
  connect?: InputMaybe<MethodOfTeachingTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MethodOfTeachingTypeCreateOrConnectWithoutLessonsInput>;
  create?: InputMaybe<MethodOfTeachingTypeUncheckedCreateWithoutLessonsInput>;
};

export type MethodOfTeachingTypeCreateOrConnectWithoutLessonsInput = {
  create: MethodOfTeachingTypeUncheckedCreateWithoutLessonsInput;
  where: MethodOfTeachingTypeWhereUniqueInput;
};

export type MethodOfTeachingTypeCreateWithoutLessonsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type MethodOfTeachingTypeMaxAggregateOutputType = {
  __typename?: 'MethodOfTeachingTypeMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type MethodOfTeachingTypeMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type MethodOfTeachingTypeMinAggregateOutputType = {
  __typename?: 'MethodOfTeachingTypeMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type MethodOfTeachingTypeMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type MethodOfTeachingTypeOrderByWithAggregationInput = {
  _avg?: InputMaybe<MethodOfTeachingTypeAvgOrderByAggregateInput>;
  _count?: InputMaybe<MethodOfTeachingTypeCountOrderByAggregateInput>;
  _max?: InputMaybe<MethodOfTeachingTypeMaxOrderByAggregateInput>;
  _min?: InputMaybe<MethodOfTeachingTypeMinOrderByAggregateInput>;
  _sum?: InputMaybe<MethodOfTeachingTypeSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type MethodOfTeachingTypeOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lessons?: InputMaybe<TrainerEventDayLessonOrderByRelationAggregateInput>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type MethodOfTeachingTypeRelationFilter = {
  is?: InputMaybe<MethodOfTeachingTypeWhereInput>;
  isNot?: InputMaybe<MethodOfTeachingTypeWhereInput>;
};

export enum MethodOfTeachingTypeScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  TitleAr = 'titleAr',
  TitleEn = 'titleEn'
}

export type MethodOfTeachingTypeScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<MethodOfTeachingTypeScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<MethodOfTeachingTypeScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<MethodOfTeachingTypeScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  titleAr?: InputMaybe<StringWithAggregatesFilter>;
  titleEn?: InputMaybe<StringWithAggregatesFilter>;
};

export type MethodOfTeachingTypeSumAggregateOutputType = {
  __typename?: 'MethodOfTeachingTypeSumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
};

export type MethodOfTeachingTypeSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type MethodOfTeachingTypeUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  lessons?: InputMaybe<TrainerEventDayLessonUncheckedCreateNestedManyWithoutMethodOfTeachingInput>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type MethodOfTeachingTypeUncheckedCreateWithoutLessonsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type MethodOfTeachingTypeUncheckedUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  lessons?: InputMaybe<TrainerEventDayLessonUncheckedUpdateManyWithoutMethodOfTeachingInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MethodOfTeachingTypeUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MethodOfTeachingTypeUncheckedUpdateWithoutLessonsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MethodOfTeachingTypeUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lessons?: InputMaybe<TrainerEventDayLessonUpdateManyWithoutMethodOfTeachingInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MethodOfTeachingTypeUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MethodOfTeachingTypeUpdateOneWithoutLessonsInput = {
  connect?: InputMaybe<MethodOfTeachingTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MethodOfTeachingTypeCreateOrConnectWithoutLessonsInput>;
  create?: InputMaybe<MethodOfTeachingTypeUncheckedCreateWithoutLessonsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<MethodOfTeachingTypeUncheckedUpdateWithoutLessonsInput>;
  upsert?: InputMaybe<MethodOfTeachingTypeUpsertWithoutLessonsInput>;
};

export type MethodOfTeachingTypeUpdateWithoutLessonsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MethodOfTeachingTypeUpsertWithoutLessonsInput = {
  create: MethodOfTeachingTypeUncheckedCreateWithoutLessonsInput;
  update: MethodOfTeachingTypeUncheckedUpdateWithoutLessonsInput;
};

export type MethodOfTeachingTypeWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<MethodOfTeachingTypeWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<MethodOfTeachingTypeWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<MethodOfTeachingTypeWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  lessons?: InputMaybe<TrainerEventDayLessonListRelationFilter>;
  titleAr?: InputMaybe<StringFilter>;
  titleEn?: InputMaybe<StringFilter>;
};

export type MethodOfTeachingTypeWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn?: InputMaybe<Scalars['String']>;
};

export type MsgTemplate = {
  __typename?: 'MsgTemplate';
  event: Event;
  listMsgOutput: Array<Maybe<ListMsgOutput>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  AddBooking: Booking;
  AddContactUsData: Array<Maybe<ContactUsData>>;
  AddExpense: Transition;
  AddMemberNeedSettings: Array<Maybe<MemberNeedSettings>>;
  AddMemberNeeds: Array<Maybe<MemberNeeds>>;
  AddMemberToGroup: TraineeEventGroup;
  AddPayment: Done;
  AddProfessionalSkill: Array<Maybe<ProfessionalSkills>>;
  AddRemindMe: Scalars['Boolean'];
  AddReview: Scalars['Boolean'];
  AddScientificResearch: Array<Maybe<ScientificResearch>>;
  AddTrainingExperience: Array<Maybe<TrainingExperience>>;
  ApplyCouponToBooking: Scalars['Boolean'];
  CancelEvent: Event;
  ContactUs: Scalars['Boolean'];
  EmergancyNotification: Event;
  InitiateBookingTransition: Transition;
  UpdateBooking: Booking;
  UpdateContactUsData: Array<Maybe<ContactUsData>>;
  addEducation: Array<Maybe<Education>>;
  addEventIdentityCardTemplate: EventIdentityCardTemplate;
  addEventMediaTracking: EventMediaTracking;
  addHowHeardAboutEvent: Scalars['Boolean'];
  analytics: Scalars['Boolean'];
  buyCertificate: TraineeEvent;
  createManyZoomRegistrant: ZoomRegistrant;
  createOneAutomatedEmails: AutomatedEmails;
  createOneBecomeTrainerApplication: BecomeTrainerApplication;
  createOneBlogs: Blogs;
  createOneCoupon: Coupon;
  createOneDiscussion: Discussion;
  createOneEvent: Event;
  createOneHiddenEvents: HiddenEvents;
  createOneProfession: Profession;
  createOneQuiz: Quiz;
  createOneQuizQuestion: QuizQuestion;
  createOneQuizQuestionAnswer: QuizQuestionAnswer;
  createOneQuizResult: QuizResult;
  createOneSpecialty: Specialty;
  createOneTemplate: Template;
  createOneTraineeEvent: TraineeEvent;
  createOneTraineeEventGroup: TraineeEventGroup;
  createOneTraineeEventReviewChoice: TraineeEventReviewChoice;
  createOneTraineeTrainerReviewChoice: TraineeTrainerReviewChoice;
  createOneTrainerEventDayLesson: TrainerEventDayLesson;
  createOneTrainerEventDayLessonType: TrainerEventDayLessonType;
  createOneTrainerEventStudyMaterial: TrainerEventStudyMaterial;
  createOneTrainerEventStudyMaterialGroup: TrainerEventStudyMaterialGroup;
  createOneUser: User;
  createOneZoom: Zoom;
  createOneZoomMeeting: ZoomMeeting;
  createOneZoomRegistrant: ZoomRegistrant;
  deleteEvent: Event;
  deleteManyCoupon: BatchPayload;
  deleteManyHiddenEvents: BatchPayload;
  deleteManyProfession: BatchPayload;
  deleteManySpecialty: BatchPayload;
  deleteManyTraineeEvent: BatchPayload;
  deleteManyTraineeEventGroup: BatchPayload;
  deleteManyUsers: BatchPayload;
  deleteOneAutomatedEmails?: Maybe<AutomatedEmails>;
  deleteOneBlogs?: Maybe<Blogs>;
  deleteOneCoupon?: Maybe<Coupon>;
  deleteOneHiddenEvents?: Maybe<HiddenEvents>;
  deleteOneProfession?: Maybe<Profession>;
  deleteOneQuiz?: Maybe<Quiz>;
  deleteOneQuizQuestion?: Maybe<QuizQuestion>;
  deleteOneQuizQuestionAnswer?: Maybe<QuizQuestionAnswer>;
  deleteOneSpecialty?: Maybe<Specialty>;
  deleteOneTemplate?: Maybe<Template>;
  deleteOneTraineeEvent?: Maybe<TraineeEvent>;
  deleteOneTraineeEventGroup?: Maybe<TraineeEventGroup>;
  deleteOneTraineeEventReviewChoice?: Maybe<TraineeEventReviewChoice>;
  deleteOneTraineeTrainerReviewChoice?: Maybe<TraineeTrainerReviewChoice>;
  deleteOneTrainerEventDayLesson?: Maybe<TrainerEventDayLesson>;
  deleteOneTrainerEventDayLessonType?: Maybe<TrainerEventDayLessonType>;
  deleteOneTrainerEventStudyMaterial?: Maybe<TrainerEventStudyMaterial>;
  deleteOneTrainerEventStudyMaterialGroup?: Maybe<TrainerEventStudyMaterialGroup>;
  deleteOneUser: User;
  deleteOneZoomRegistrant?: Maybe<ZoomRegistrant>;
  destroyWhatsApp?: Maybe<Scalars['Boolean']>;
  eventStopRegistration: Event;
  freeBooking: FreeBookingOutput;
  generateCertificate: Scalars['Boolean'];
  initializeWhatsApp?: Maybe<Scalars['Boolean']>;
  logoutWhatsApp?: Maybe<Scalars['Boolean']>;
  mergeAccounts: Scalars['Boolean'];
  moyasarInitiateTransition?: Maybe<Scalars['Boolean']>;
  payWithWallet: WalletPaymentSuccess;
  readNotification: BatchPayload;
  recordAttendance?: Maybe<RecordAttendanceResult>;
  remindMe: Scalars['Boolean'];
  removeContactUsData?: Maybe<Array<Maybe<ContactUsData>>>;
  removeEducation: Array<Maybe<Education>>;
  removeEventMediaTracking?: Maybe<Array<Maybe<EventMediaTracking>>>;
  removeExpenseMutation?: Maybe<Transition>;
  removeMemberNeedSettings?: Maybe<Array<Maybe<MemberNeedSettings>>>;
  removeMemberNeeds?: Maybe<Array<Maybe<MemberNeeds>>>;
  removeProfessionalSkill: Array<Maybe<ProfessionalSkills>>;
  removeScientificResearch: Array<Maybe<ScientificResearch>>;
  removeTrainingExperience?: Maybe<Array<Maybe<TrainingExperience>>>;
  resendBookingEmail: TraineeEvent;
  resendCertificate: Scalars['Boolean'];
  resetWhatsApp?: Maybe<Scalars['Boolean']>;
  sendEmail: Scalars['Boolean'];
  sendFCM: Scalars['Boolean'];
  turnToGuest: TraineeEvent;
  updateAllBookingsMethod: TraineeEvent;
  updateBankAccount: BankAccount;
  updateBookingId: TraineeEvent;
  updateBookingMethod: TraineeEvent;
  updateBookingTransitionStatus: Transition;
  updateCardFeeSettings: Settings;
  updateCv: Cv;
  updateGeneralCouponSettings: Settings;
  updateHeroImages?: Maybe<Array<Maybe<Settings>>>;
  updateInstantNotifications: Settings;
  updateJob: Scheduling;
  updateManyCoupon: BatchPayload;
  updateManyProfession: BatchPayload;
  updateManyQuizQuestion: BatchPayload;
  updateManySpecialty: BatchPayload;
  updateManyTraineeEvent: BatchPayload;
  updateManyTraineeEventGroup: BatchPayload;
  updateOneAutomatedEmails: AutomatedEmails;
  updateOneBecomeTrainerApplication: BecomeTrainerApplication;
  updateOneBlogs: Blogs;
  updateOneCoupon: Coupon;
  updateOneCv: Cv;
  updateOneEvent: Event;
  updateOneEventDay: EventDay;
  updateOnePricingPlan: PricingPlan;
  updateOneProfession: Profession;
  updateOneQuiz: Quiz;
  updateOneQuizQuestion: QuizQuestion;
  updateOneQuizQuestionAnswer: QuizQuestionAnswer;
  updateOneSpecialty: Specialty;
  updateOneTemplate: Template;
  updateOneTraineeEvent: TraineeEvent;
  updateOneTraineeEventDayAttendance: Scalars['Boolean'];
  updateOneTraineeEventGroup: TraineeEventGroup;
  updateOneTraineeEventReviewChoice: TraineeEventReviewChoice;
  updateOneTraineeEventStudyMaterialAttendance: Scalars['Boolean'];
  updateOneTraineeTrainerReviewChoice: TraineeTrainerReviewChoice;
  updateOneTrainerEvent: TrainerEvent;
  updateOneTrainerEventDayLesson: TrainerEventDayLesson;
  updateOneTrainerEventDayLessonType: TrainerEventDayLessonType;
  updateOneTrainerEventStudyMaterial?: Maybe<TrainerEventStudyMaterial>;
  updateOneTrainerEventStudyMaterialGroup?: Maybe<TrainerEventStudyMaterialGroup>;
  updateOneUser: User;
  updateOneZoom: Zoom;
  updateOneZoomMeeting: ZoomMeeting;
  updateProfile: User;
  updatePublishExpenseSettings: Settings;
  updateRemoveUserPasswordSettings: Settings;
  updateTaxNumberSettings: Settings;
  updateTaxSettings: Settings;
  updateWhatsAppMsgs: Settings;
  upsertOneCoupon: Coupon;
  upsertOneEvent: Event;
  upsertOneProfession: Profession;
  upsertOneSpecialty: Specialty;
  upsertOneTemplate: Template;
  upsertOneTraineeEvent: TraineeEvent;
  upsertOneTraineeEventGroup: TraineeEventGroup;
  whatsAppSendMany: Scalars['Boolean'];
};


export type MutationAddBookingArgs = {
  data: BookingInputType;
};


export type MutationAddContactUsDataArgs = {
  data: AddContactUsDataType;
};


export type MutationAddExpenseArgs = {
  data: AddExpenseType;
};


export type MutationAddMemberNeedSettingsArgs = {
  data: AddMemberNeedSettingsType;
};


export type MutationAddMemberNeedsArgs = {
  data: AddMemberNeedsType;
};


export type MutationAddMemberToGroupArgs = {
  data: AddMemberToGroupInputType;
};


export type MutationAddPaymentArgs = {
  data: AddPaymentType;
};


export type MutationAddProfessionalSkillArgs = {
  data: AddProfessionalSkillInputType;
};


export type MutationAddRemindMeArgs = {
  data: RemindMeInputType;
};


export type MutationAddReviewArgs = {
  data: ReviewInput;
};


export type MutationAddScientificResearchArgs = {
  data: AddScientificResearchInputType;
};


export type MutationAddTrainingExperienceArgs = {
  data: AddTrainingExperienceInputType;
};


export type MutationApplyCouponToBookingArgs = {
  data: ApplyCouponToBookingInputType;
};


export type MutationCancelEventArgs = {
  where: EventIdInput;
};


export type MutationContactUsArgs = {
  data: ContactUsType;
};


export type MutationEmergancyNotificationArgs = {
  where: EmergancyNotificationInput;
};


export type MutationInitiateBookingTransitionArgs = {
  data: InitiateBookingTransitionInputType;
};


export type MutationUpdateBookingArgs = {
  data: UpdateBookingInputType;
};


export type MutationUpdateContactUsDataArgs = {
  data: UpdateContactUsDataType;
};


export type MutationAddEducationArgs = {
  data: AddEducationInputType;
};


export type MutationAddEventIdentityCardTemplateArgs = {
  data: AddEventIdentityCardTemplateType;
};


export type MutationAddEventMediaTrackingArgs = {
  data: AddEventMediaTrackingType;
};


export type MutationAddHowHeardAboutEventArgs = {
  data: AddHowHeardAboutEventInputType;
};


export type MutationAnalyticsArgs = {
  data: AnalyticsInputType;
};


export type MutationBuyCertificateArgs = {
  data: TraineeEventUpdateInput;
  where: TraineeEventWhereUniqueInput;
};


export type MutationCreateManyZoomRegistrantArgs = {
  data: Array<ZoomRegistrantCreateOneInput>;
};


export type MutationCreateOneAutomatedEmailsArgs = {
  data: AutomatedEmailsCreateInput;
};


export type MutationCreateOneBlogsArgs = {
  data: BlogsCreateInput;
};


export type MutationCreateOneCouponArgs = {
  data: CouponCreateInput;
};


export type MutationCreateOneDiscussionArgs = {
  data: DiscussionCreateInput;
};


export type MutationCreateOneEventArgs = {
  data: EventCreateInput;
};


export type MutationCreateOneHiddenEventsArgs = {
  data: HiddenEventsCreateInput;
};


export type MutationCreateOneProfessionArgs = {
  data: ProfessionCreateInput;
};


export type MutationCreateOneQuizArgs = {
  data?: InputMaybe<QuizCreateOneInput>;
};


export type MutationCreateOneQuizQuestionArgs = {
  data: QuizQuestionCreateInput;
};


export type MutationCreateOneQuizQuestionAnswerArgs = {
  data: QuizQuestionAnswerCreateInput;
};


export type MutationCreateOneQuizResultArgs = {
  data: QuizResultCreateOneInput;
};


export type MutationCreateOneSpecialtyArgs = {
  data: SpecialtyCreateInput;
};


export type MutationCreateOneTemplateArgs = {
  certificateType?: InputMaybe<Scalars['String']>;
  data: TemplateCreateInput;
};


export type MutationCreateOneTraineeEventArgs = {
  data: TraineeEventCreateInput;
};


export type MutationCreateOneTraineeEventGroupArgs = {
  data: TraineeEventGroupCreateInput;
};


export type MutationCreateOneTraineeEventReviewChoiceArgs = {
  data: TraineeEventReviewChoiceCreateInput;
};


export type MutationCreateOneTraineeTrainerReviewChoiceArgs = {
  data: TraineeTrainerReviewChoiceCreateInput;
};


export type MutationCreateOneTrainerEventDayLessonArgs = {
  data: TrainerEventDayLessonCreateInput;
};


export type MutationCreateOneTrainerEventDayLessonTypeArgs = {
  data: TrainerEventDayLessonTypeCreateInput;
};


export type MutationCreateOneTrainerEventStudyMaterialArgs = {
  data: TrainerEventStudyMaterialCreateInput;
  quizValues: Scalars['Json'];
};


export type MutationCreateOneTrainerEventStudyMaterialGroupArgs = {
  data: TrainerEventStudyMaterialGroupCreateInput;
};


export type MutationCreateOneUserArgs = {
  data: UserCreateInput;
};


export type MutationCreateOneZoomArgs = {
  data: ZoomCreateInput;
};


export type MutationCreateOneZoomMeetingArgs = {
  data: ZoomMeetingCreateInput;
};


export type MutationCreateOneZoomRegistrantArgs = {
  data: ZoomRegistrantCreateOneInput;
};


export type MutationDeleteEventArgs = {
  where: EventIdInput;
};


export type MutationDeleteManyCouponArgs = {
  where?: InputMaybe<CouponWhereInput>;
};


export type MutationDeleteManyHiddenEventsArgs = {
  where?: InputMaybe<HiddenEventsWhereInput>;
};


export type MutationDeleteManyProfessionArgs = {
  where?: InputMaybe<ProfessionWhereInput>;
};


export type MutationDeleteManySpecialtyArgs = {
  where?: InputMaybe<SpecialtyWhereInput>;
};


export type MutationDeleteManyTraineeEventArgs = {
  where?: InputMaybe<TraineeEventWhereInput>;
};


export type MutationDeleteManyTraineeEventGroupArgs = {
  where?: InputMaybe<TraineeEventGroupWhereInput>;
};


export type MutationDeleteManyUsersArgs = {
  where?: InputMaybe<UserWhereInput>;
};


export type MutationDeleteOneAutomatedEmailsArgs = {
  where: AutomatedEmailsWhereUniqueInput;
};


export type MutationDeleteOneBlogsArgs = {
  where: BlogsWhereUniqueInput;
};


export type MutationDeleteOneCouponArgs = {
  where: CouponWhereUniqueInput;
};


export type MutationDeleteOneHiddenEventsArgs = {
  where: HiddenEventsWhereUniqueInput;
};


export type MutationDeleteOneProfessionArgs = {
  where: ProfessionWhereUniqueInput;
};


export type MutationDeleteOneQuizArgs = {
  where: QuizWhereUniqueInput;
};


export type MutationDeleteOneQuizQuestionArgs = {
  where: QuizQuestionWhereUniqueInput;
};


export type MutationDeleteOneQuizQuestionAnswerArgs = {
  where: QuizQuestionAnswerWhereUniqueInput;
};


export type MutationDeleteOneSpecialtyArgs = {
  where: SpecialtyWhereUniqueInput;
};


export type MutationDeleteOneTemplateArgs = {
  where: TemplateWhereUniqueInput;
};


export type MutationDeleteOneTraineeEventArgs = {
  where: TraineeEventWhereUniqueInput;
};


export type MutationDeleteOneTraineeEventGroupArgs = {
  where: TraineeEventGroupWhereUniqueInput;
};


export type MutationDeleteOneTraineeEventReviewChoiceArgs = {
  where: TraineeEventReviewChoiceWhereUniqueInput;
};


export type MutationDeleteOneTraineeTrainerReviewChoiceArgs = {
  where: TraineeTrainerReviewChoiceWhereUniqueInput;
};


export type MutationDeleteOneTrainerEventDayLessonArgs = {
  where: TrainerEventDayLessonWhereUniqueInput;
};


export type MutationDeleteOneTrainerEventDayLessonTypeArgs = {
  where: TrainerEventDayLessonTypeWhereUniqueInput;
};


export type MutationDeleteOneTrainerEventStudyMaterialArgs = {
  where: TrainerEventStudyMaterialWhereUniqueInput;
};


export type MutationDeleteOneTrainerEventStudyMaterialGroupArgs = {
  where: TrainerEventStudyMaterialGroupWhereUniqueInput;
};


export type MutationDeleteOneUserArgs = {
  where: UserWhereUniqueInput;
};


export type MutationDeleteOneZoomRegistrantArgs = {
  where: ZoomRegistrantWhereUniqueInput;
};


export type MutationDestroyWhatsAppArgs = {
  data: DestroyWhatsAppInputType;
};


export type MutationEventStopRegistrationArgs = {
  where: EventStopInput;
};


export type MutationFreeBookingArgs = {
  data: FreeBookingInputType;
};


export type MutationGenerateCertificateArgs = {
  data: GenerateCertificateInputType;
};


export type MutationInitializeWhatsAppArgs = {
  data: InitializeWhatsAppInputType;
};


export type MutationLogoutWhatsAppArgs = {
  data: LogoutWhatsAppInputType;
};


export type MutationMergeAccountsArgs = {
  data: MergeAccountsInputType;
};


export type MutationMoyasarInitiateTransitionArgs = {
  data: MoyasarInitiateTransition;
};


export type MutationPayWithWalletArgs = {
  data: WalletTransition;
};


export type MutationRecordAttendanceArgs = {
  data: RecordAttendanceInput;
};


export type MutationRemindMeArgs = {
  data: RemindInputType;
};


export type MutationRemoveContactUsDataArgs = {
  where: RemoveContactUsDataType;
};


export type MutationRemoveEducationArgs = {
  data: RemoveEducationInputType;
};


export type MutationRemoveEventMediaTrackingArgs = {
  where: RemoveEventMediaTrackingType;
};


export type MutationRemoveExpenseMutationArgs = {
  data: RemoveExpenseInputType;
};


export type MutationRemoveMemberNeedSettingsArgs = {
  where: RemoveMemberNeedSettingsType;
};


export type MutationRemoveMemberNeedsArgs = {
  where: RemoveMemberNeedsType;
};


export type MutationRemoveProfessionalSkillArgs = {
  data: RemoveProfessionalSkillInputType;
};


export type MutationRemoveScientificResearchArgs = {
  where: RemoveScientificResearchInputType;
};


export type MutationRemoveTrainingExperienceArgs = {
  where: RemoveTrainingExperienceInputType;
};


export type MutationResendBookingEmailArgs = {
  data: BookingEmailInputType;
};


export type MutationResendCertificateArgs = {
  where: ResendCertificateInput;
};


export type MutationResetWhatsAppArgs = {
  data: ResetWhatsAppInputType;
};


export type MutationSendEmailArgs = {
  data: SendEmailInputType;
};


export type MutationSendFcmArgs = {
  data: FcmInputType;
};


export type MutationTurnToGuestArgs = {
  data: TurnToGuestInputType;
};


export type MutationUpdateAllBookingsMethodArgs = {
  data: UpdateAllBookingsMethodInputType;
};


export type MutationUpdateBankAccountArgs = {
  data: UpdateBankAccountInputType;
};


export type MutationUpdateBookingIdArgs = {
  data: UpdateBookingIdInputType;
};


export type MutationUpdateBookingMethodArgs = {
  data: UpdateBookingMethodInputType;
};


export type MutationUpdateBookingTransitionStatusArgs = {
  data: UpdateBookingTransitionStatusInputType;
};


export type MutationUpdateCardFeeSettingsArgs = {
  data: CardFeeInputType;
};


export type MutationUpdateCvArgs = {
  data: UpdateCvInputType;
};


export type MutationUpdateGeneralCouponSettingsArgs = {
  data: GeneralCouponInputType;
};


export type MutationUpdateHeroImagesArgs = {
  eventImages?: InputMaybe<Array<IndexImagesInputType>>;
  indexImages?: InputMaybe<Array<IndexImagesInputType>>;
};


export type MutationUpdateInstantNotificationsArgs = {
  data: InstantNotificationsBellInputType;
};


export type MutationUpdateJobArgs = {
  data: UpdateJobInput;
};


export type MutationUpdateManyCouponArgs = {
  data: CouponUpdateManyMutationInput;
  where?: InputMaybe<CouponWhereInput>;
};


export type MutationUpdateManyProfessionArgs = {
  data: ProfessionUpdateManyMutationInput;
  where?: InputMaybe<ProfessionWhereInput>;
};


export type MutationUpdateManyQuizQuestionArgs = {
  data: Array<InputMaybe<QuizQuestionUpdateManyInput>>;
};


export type MutationUpdateManySpecialtyArgs = {
  data: SpecialtyUpdateManyMutationInput;
  where?: InputMaybe<SpecialtyWhereInput>;
};


export type MutationUpdateManyTraineeEventArgs = {
  data: TraineeEventUpdateManyMutationInput;
  where?: InputMaybe<TraineeEventWhereInput>;
};


export type MutationUpdateManyTraineeEventGroupArgs = {
  data: TraineeEventGroupUpdateManyMutationInput;
  where?: InputMaybe<TraineeEventGroupWhereInput>;
};


export type MutationUpdateOneAutomatedEmailsArgs = {
  data: AutomatedEmailsUpdateInput;
  where: AutomatedEmailsWhereUniqueInput;
};


export type MutationUpdateOneBecomeTrainerApplicationArgs = {
  data: BecomeTrainerApplicationUpdateInput;
  where: BecomeTrainerApplicationWhereUniqueInput;
};


export type MutationUpdateOneBlogsArgs = {
  data: BlogsUpdateInput;
  where: BlogsWhereUniqueInput;
};


export type MutationUpdateOneCouponArgs = {
  data: CouponUpdateInput;
  where: CouponWhereUniqueInput;
};


export type MutationUpdateOneCvArgs = {
  data: CvUpdateInput;
  where: CvWhereUniqueInput;
};


export type MutationUpdateOneEventArgs = {
  data: EventUpdateInput;
  where: EventWhereUniqueInput;
};


export type MutationUpdateOneEventDayArgs = {
  data: EventDayUpdateInput;
  where: EventDayWhereUniqueInput;
};


export type MutationUpdateOnePricingPlanArgs = {
  data: PricingPlanUpdateInput;
  where: PricingPlanWhereUniqueInput;
};


export type MutationUpdateOneProfessionArgs = {
  data: ProfessionUpdateInput;
  where: ProfessionWhereUniqueInput;
};


export type MutationUpdateOneQuizArgs = {
  data: QuizUpdateInput;
  where: QuizWhereUniqueInput;
};


export type MutationUpdateOneQuizQuestionArgs = {
  data: QuizQuestionUpdateInput;
  where: QuizQuestionWhereUniqueInput;
};


export type MutationUpdateOneQuizQuestionAnswerArgs = {
  data: QuizQuestionAnswerUpdateInput;
  where: QuizQuestionAnswerWhereUniqueInput;
};


export type MutationUpdateOneSpecialtyArgs = {
  data: SpecialtyUpdateInput;
  where: SpecialtyWhereUniqueInput;
};


export type MutationUpdateOneTemplateArgs = {
  data: TemplateUpdateInput;
  where: TemplateWhereUniqueInput;
};


export type MutationUpdateOneTraineeEventArgs = {
  data: TraineeEventUpdateInput;
  where: TraineeEventWhereUniqueInput;
};


export type MutationUpdateOneTraineeEventDayAttendanceArgs = {
  data: SetAttendanceType;
};


export type MutationUpdateOneTraineeEventGroupArgs = {
  data: TraineeEventGroupUpdateInput;
  where: TraineeEventGroupWhereUniqueInput;
};


export type MutationUpdateOneTraineeEventReviewChoiceArgs = {
  data: TraineeEventReviewChoiceUpdateInput;
  where: TraineeEventReviewChoiceWhereUniqueInput;
};


export type MutationUpdateOneTraineeEventStudyMaterialAttendanceArgs = {
  data: SetStudyMaterialAttendanceType;
};


export type MutationUpdateOneTraineeTrainerReviewChoiceArgs = {
  data: TraineeTrainerReviewChoiceUpdateInput;
  where: TraineeTrainerReviewChoiceWhereUniqueInput;
};


export type MutationUpdateOneTrainerEventArgs = {
  data: TrainerEventUpdateInput;
  where: TrainerEventWhereUniqueInput;
};


export type MutationUpdateOneTrainerEventDayLessonArgs = {
  data: TrainerEventDayLessonUpdateInput;
  where: TrainerEventDayLessonWhereUniqueInput;
};


export type MutationUpdateOneTrainerEventDayLessonTypeArgs = {
  data: TrainerEventDayLessonTypeUpdateInput;
  where: TrainerEventDayLessonTypeWhereUniqueInput;
};


export type MutationUpdateOneTrainerEventStudyMaterialArgs = {
  data: TrainerEventStudyMaterialUpdateInput;
  quizValues?: InputMaybe<Scalars['Json']>;
  where: TrainerEventStudyMaterialWhereUniqueInput;
};


export type MutationUpdateOneTrainerEventStudyMaterialGroupArgs = {
  data: TrainerEventStudyMaterialGroupUpdateInput;
  where: TrainerEventStudyMaterialGroupWhereUniqueInput;
};


export type MutationUpdateOneUserArgs = {
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
};


export type MutationUpdateOneZoomArgs = {
  data: ZoomUpdateInput;
  where: ZoomWhereUpdateInput;
};


export type MutationUpdateOneZoomMeetingArgs = {
  data: ZoomMeetingUpdateInput;
  where: ZoomMeetingWhereUniqueInput;
};


export type MutationUpdateProfileArgs = {
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
};


export type MutationUpdatePublishExpenseSettingsArgs = {
  data: PublishExpenseInputType;
};


export type MutationUpdateRemoveUserPasswordSettingsArgs = {
  data: RemoveUserPasswordInputType;
};


export type MutationUpdateTaxNumberSettingsArgs = {
  data: TaxNumberInputType;
};


export type MutationUpdateTaxSettingsArgs = {
  data: TaxInputType;
};


export type MutationUpdateWhatsAppMsgsArgs = {
  data: UpdateWhatsAppMsgsInputType;
};


export type MutationUpsertOneCouponArgs = {
  create: CouponCreateInput;
  update: CouponUpdateInput;
  where: CouponWhereUniqueInput;
};


export type MutationUpsertOneEventArgs = {
  create: EventCreateInput;
  update: EventUpdateInput;
  where: EventWhereUniqueInput;
};


export type MutationUpsertOneProfessionArgs = {
  create: ProfessionCreateInput;
  update: ProfessionUpdateInput;
  where: ProfessionWhereUniqueInput;
};


export type MutationUpsertOneSpecialtyArgs = {
  create: SpecialtyCreateInput;
  update: SpecialtyUpdateInput;
  where: SpecialtyWhereUniqueInput;
};


export type MutationUpsertOneTemplateArgs = {
  create: TemplateCreateInput;
  update: TemplateUpdateInput;
  where: TemplateWhereUniqueInput;
};


export type MutationUpsertOneTraineeEventArgs = {
  create: TraineeEventCreateInput;
  update: TraineeEventUpdateInput;
  where: TraineeEventWhereUniqueInput;
};


export type MutationUpsertOneTraineeEventGroupArgs = {
  create: TraineeEventGroupCreateInput;
  update: TraineeEventGroupUpdateInput;
  where: TraineeEventGroupWhereUniqueInput;
};


export type MutationWhatsAppSendManyArgs = {
  data: WhatsAppSendManyInputType;
};

export enum Nationality {
  NonSaudi = 'NON_SAUDI',
  Saudi = 'SAUDI'
}

export type NestedBigIntNullableFilter = {
  equals?: InputMaybe<Scalars['BigInt']>;
  gt?: InputMaybe<Scalars['BigInt']>;
  gte?: InputMaybe<Scalars['BigInt']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  lt?: InputMaybe<Scalars['BigInt']>;
  lte?: InputMaybe<Scalars['BigInt']>;
  not?: InputMaybe<NestedBigIntNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type NestedBigIntNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedBigIntNullableFilter>;
  _min?: InputMaybe<NestedBigIntNullableFilter>;
  _sum?: InputMaybe<NestedBigIntNullableFilter>;
  equals?: InputMaybe<Scalars['BigInt']>;
  gt?: InputMaybe<Scalars['BigInt']>;
  gte?: InputMaybe<Scalars['BigInt']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  lt?: InputMaybe<Scalars['BigInt']>;
  lte?: InputMaybe<Scalars['BigInt']>;
  not?: InputMaybe<NestedBigIntNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedBoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type NestedBoolNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedBoolNullableFilter>;
  _min?: InputMaybe<NestedBoolNullableFilter>;
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolNullableWithAggregatesFilter>;
};

export type NestedBoolWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedBoolFilter>;
  _min?: InputMaybe<NestedBoolFilter>;
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolWithAggregatesFilter>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
};

export type NestedDateTimeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedDateTimeNullableFilter>;
  _min?: InputMaybe<NestedDateTimeNullableFilter>;
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
};

export type NestedDateTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDateTimeFilter>;
  _min?: InputMaybe<NestedDateTimeFilter>;
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
};

export type NestedDecimalFilter = {
  equals?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  gte?: InputMaybe<Scalars['Decimal']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
  lt?: InputMaybe<Scalars['Decimal']>;
  lte?: InputMaybe<Scalars['Decimal']>;
  not?: InputMaybe<NestedDecimalFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
};

export type NestedDecimalNullableFilter = {
  equals?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  gte?: InputMaybe<Scalars['Decimal']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
  lt?: InputMaybe<Scalars['Decimal']>;
  lte?: InputMaybe<Scalars['Decimal']>;
  not?: InputMaybe<NestedDecimalNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
};

export type NestedDecimalNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedDecimalNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedDecimalNullableFilter>;
  _min?: InputMaybe<NestedDecimalNullableFilter>;
  _sum?: InputMaybe<NestedDecimalNullableFilter>;
  equals?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  gte?: InputMaybe<Scalars['Decimal']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
  lt?: InputMaybe<Scalars['Decimal']>;
  lte?: InputMaybe<Scalars['Decimal']>;
  not?: InputMaybe<NestedDecimalNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
};

export type NestedDecimalWithAggregatesFilter = {
  _avg?: InputMaybe<NestedDecimalFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDecimalFilter>;
  _min?: InputMaybe<NestedDecimalFilter>;
  _sum?: InputMaybe<NestedDecimalFilter>;
  equals?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  gte?: InputMaybe<Scalars['Decimal']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
  lt?: InputMaybe<Scalars['Decimal']>;
  lte?: InputMaybe<Scalars['Decimal']>;
  not?: InputMaybe<NestedDecimalWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
};

export type NestedEnumApplicationStateFilter = {
  equals?: InputMaybe<ApplicationState>;
  in?: InputMaybe<Array<InputMaybe<ApplicationState>>>;
  not?: InputMaybe<NestedEnumApplicationStateFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ApplicationState>>>;
};

export type NestedEnumApplicationStateWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumApplicationStateFilter>;
  _min?: InputMaybe<NestedEnumApplicationStateFilter>;
  equals?: InputMaybe<ApplicationState>;
  in?: InputMaybe<Array<InputMaybe<ApplicationState>>>;
  not?: InputMaybe<NestedEnumApplicationStateWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ApplicationState>>>;
};

export type NestedEnumCouponTypeFilter = {
  equals?: InputMaybe<CouponType>;
  in?: InputMaybe<Array<InputMaybe<CouponType>>>;
  not?: InputMaybe<NestedEnumCouponTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<CouponType>>>;
};

export type NestedEnumCouponTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumCouponTypeFilter>;
  _min?: InputMaybe<NestedEnumCouponTypeFilter>;
  equals?: InputMaybe<CouponType>;
  in?: InputMaybe<Array<InputMaybe<CouponType>>>;
  not?: InputMaybe<NestedEnumCouponTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<CouponType>>>;
};

export type NestedEnumDynamicEmailForRegistransFilter = {
  equals?: InputMaybe<DynamicEmailForRegistrans>;
  in?: InputMaybe<Array<InputMaybe<DynamicEmailForRegistrans>>>;
  not?: InputMaybe<NestedEnumDynamicEmailForRegistransFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DynamicEmailForRegistrans>>>;
};

export type NestedEnumDynamicEmailForRegistransWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDynamicEmailForRegistransFilter>;
  _min?: InputMaybe<NestedEnumDynamicEmailForRegistransFilter>;
  equals?: InputMaybe<DynamicEmailForRegistrans>;
  in?: InputMaybe<Array<InputMaybe<DynamicEmailForRegistrans>>>;
  not?: InputMaybe<NestedEnumDynamicEmailForRegistransWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DynamicEmailForRegistrans>>>;
};

export type NestedEnumDynamicEmailSendToFilter = {
  equals?: InputMaybe<DynamicEmailSendTo>;
  in?: InputMaybe<Array<InputMaybe<DynamicEmailSendTo>>>;
  not?: InputMaybe<NestedEnumDynamicEmailSendToFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DynamicEmailSendTo>>>;
};

export type NestedEnumDynamicEmailSendToWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDynamicEmailSendToFilter>;
  _min?: InputMaybe<NestedEnumDynamicEmailSendToFilter>;
  equals?: InputMaybe<DynamicEmailSendTo>;
  in?: InputMaybe<Array<InputMaybe<DynamicEmailSendTo>>>;
  not?: InputMaybe<NestedEnumDynamicEmailSendToWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DynamicEmailSendTo>>>;
};

export type NestedEnumDynamicEmailTimeFilter = {
  equals?: InputMaybe<DynamicEmailTime>;
  in?: InputMaybe<Array<InputMaybe<DynamicEmailTime>>>;
  not?: InputMaybe<NestedEnumDynamicEmailTimeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DynamicEmailTime>>>;
};

export type NestedEnumDynamicEmailTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDynamicEmailTimeFilter>;
  _min?: InputMaybe<NestedEnumDynamicEmailTimeFilter>;
  equals?: InputMaybe<DynamicEmailTime>;
  in?: InputMaybe<Array<InputMaybe<DynamicEmailTime>>>;
  not?: InputMaybe<NestedEnumDynamicEmailTimeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DynamicEmailTime>>>;
};

export type NestedEnumDynamicwhenEventHasClassesFilter = {
  equals?: InputMaybe<DynamicwhenEventHasClasses>;
  in?: InputMaybe<Array<InputMaybe<DynamicwhenEventHasClasses>>>;
  not?: InputMaybe<NestedEnumDynamicwhenEventHasClassesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DynamicwhenEventHasClasses>>>;
};

export type NestedEnumDynamicwhenEventHasClassesWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDynamicwhenEventHasClassesFilter>;
  _min?: InputMaybe<NestedEnumDynamicwhenEventHasClassesFilter>;
  equals?: InputMaybe<DynamicwhenEventHasClasses>;
  in?: InputMaybe<Array<InputMaybe<DynamicwhenEventHasClasses>>>;
  not?: InputMaybe<NestedEnumDynamicwhenEventHasClassesWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<DynamicwhenEventHasClasses>>>;
};

export type NestedEnumGenderNullableFilter = {
  equals?: InputMaybe<Gender>;
  in?: InputMaybe<Array<InputMaybe<Gender>>>;
  not?: InputMaybe<NestedEnumGenderNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Gender>>>;
};

export type NestedEnumGenderNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumGenderNullableFilter>;
  _min?: InputMaybe<NestedEnumGenderNullableFilter>;
  equals?: InputMaybe<Gender>;
  in?: InputMaybe<Array<InputMaybe<Gender>>>;
  not?: InputMaybe<NestedEnumGenderNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Gender>>>;
};

export type NestedEnumLanguageEnumFilter = {
  equals?: InputMaybe<LanguageEnum>;
  in?: InputMaybe<Array<InputMaybe<LanguageEnum>>>;
  not?: InputMaybe<NestedEnumLanguageEnumFilter>;
  notIn?: InputMaybe<Array<InputMaybe<LanguageEnum>>>;
};

export type NestedEnumLanguageEnumWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumLanguageEnumFilter>;
  _min?: InputMaybe<NestedEnumLanguageEnumFilter>;
  equals?: InputMaybe<LanguageEnum>;
  in?: InputMaybe<Array<InputMaybe<LanguageEnum>>>;
  not?: InputMaybe<NestedEnumLanguageEnumWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<LanguageEnum>>>;
};

export type NestedEnumMarketerProfitTypeNullableFilter = {
  equals?: InputMaybe<MarketerProfitType>;
  in?: InputMaybe<Array<InputMaybe<MarketerProfitType>>>;
  not?: InputMaybe<NestedEnumMarketerProfitTypeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<MarketerProfitType>>>;
};

export type NestedEnumMarketerProfitTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumMarketerProfitTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumMarketerProfitTypeNullableFilter>;
  equals?: InputMaybe<MarketerProfitType>;
  in?: InputMaybe<Array<InputMaybe<MarketerProfitType>>>;
  not?: InputMaybe<NestedEnumMarketerProfitTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<MarketerProfitType>>>;
};

export type NestedEnumMemberNeedsStatusFilter = {
  equals?: InputMaybe<MemberNeedsStatus>;
  in?: InputMaybe<Array<InputMaybe<MemberNeedsStatus>>>;
  not?: InputMaybe<NestedEnumMemberNeedsStatusFilter>;
  notIn?: InputMaybe<Array<InputMaybe<MemberNeedsStatus>>>;
};

export type NestedEnumMemberNeedsStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumMemberNeedsStatusFilter>;
  _min?: InputMaybe<NestedEnumMemberNeedsStatusFilter>;
  equals?: InputMaybe<MemberNeedsStatus>;
  in?: InputMaybe<Array<InputMaybe<MemberNeedsStatus>>>;
  not?: InputMaybe<NestedEnumMemberNeedsStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<MemberNeedsStatus>>>;
};

export type NestedEnumPaymentTypeFilter = {
  equals?: InputMaybe<PaymentType>;
  in?: InputMaybe<Array<InputMaybe<PaymentType>>>;
  not?: InputMaybe<NestedEnumPaymentTypeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PaymentType>>>;
};

export type NestedEnumPaymentTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPaymentTypeFilter>;
  _min?: InputMaybe<NestedEnumPaymentTypeFilter>;
  equals?: InputMaybe<PaymentType>;
  in?: InputMaybe<Array<InputMaybe<PaymentType>>>;
  not?: InputMaybe<NestedEnumPaymentTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<PaymentType>>>;
};

export type NestedEnumProfessionalSkillsTypeNullableFilter = {
  equals?: InputMaybe<ProfessionalSkillsType>;
  in?: InputMaybe<Array<InputMaybe<ProfessionalSkillsType>>>;
  not?: InputMaybe<NestedEnumProfessionalSkillsTypeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ProfessionalSkillsType>>>;
};

export type NestedEnumProfessionalSkillsTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumProfessionalSkillsTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumProfessionalSkillsTypeNullableFilter>;
  equals?: InputMaybe<ProfessionalSkillsType>;
  in?: InputMaybe<Array<InputMaybe<ProfessionalSkillsType>>>;
  not?: InputMaybe<NestedEnumProfessionalSkillsTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ProfessionalSkillsType>>>;
};

export type NestedEnumScientificResearchRoleNullableFilter = {
  equals?: InputMaybe<ScientificResearchRole>;
  in?: InputMaybe<Array<InputMaybe<ScientificResearchRole>>>;
  not?: InputMaybe<NestedEnumScientificResearchRoleNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ScientificResearchRole>>>;
};

export type NestedEnumScientificResearchRoleNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumScientificResearchRoleNullableFilter>;
  _min?: InputMaybe<NestedEnumScientificResearchRoleNullableFilter>;
  equals?: InputMaybe<ScientificResearchRole>;
  in?: InputMaybe<Array<InputMaybe<ScientificResearchRole>>>;
  not?: InputMaybe<NestedEnumScientificResearchRoleNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ScientificResearchRole>>>;
};

export type NestedEnumScientificResearchTypeNullableFilter = {
  equals?: InputMaybe<ScientificResearchType>;
  in?: InputMaybe<Array<InputMaybe<ScientificResearchType>>>;
  not?: InputMaybe<NestedEnumScientificResearchTypeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ScientificResearchType>>>;
};

export type NestedEnumScientificResearchTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumScientificResearchTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumScientificResearchTypeNullableFilter>;
  equals?: InputMaybe<ScientificResearchType>;
  in?: InputMaybe<Array<InputMaybe<ScientificResearchType>>>;
  not?: InputMaybe<NestedEnumScientificResearchTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ScientificResearchType>>>;
};

export type NestedEnumTemplatePurposeFilter = {
  equals?: InputMaybe<TemplatePurpose>;
  in?: InputMaybe<Array<InputMaybe<TemplatePurpose>>>;
  not?: InputMaybe<NestedEnumTemplatePurposeFilter>;
  notIn?: InputMaybe<Array<InputMaybe<TemplatePurpose>>>;
};

export type NestedEnumTemplatePurposeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumTemplatePurposeFilter>;
  _min?: InputMaybe<NestedEnumTemplatePurposeFilter>;
  equals?: InputMaybe<TemplatePurpose>;
  in?: InputMaybe<Array<InputMaybe<TemplatePurpose>>>;
  not?: InputMaybe<NestedEnumTemplatePurposeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<TemplatePurpose>>>;
};

export type NestedEnumToTransferTypeNullableFilter = {
  equals?: InputMaybe<ToTransferType>;
  in?: InputMaybe<Array<InputMaybe<ToTransferType>>>;
  not?: InputMaybe<NestedEnumToTransferTypeNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ToTransferType>>>;
};

export type NestedEnumToTransferTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumToTransferTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumToTransferTypeNullableFilter>;
  equals?: InputMaybe<ToTransferType>;
  in?: InputMaybe<Array<InputMaybe<ToTransferType>>>;
  not?: InputMaybe<NestedEnumToTransferTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<ToTransferType>>>;
};

export type NestedFloatFilter = {
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type NestedFloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type NestedIntNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedIntNullableFilter>;
  _min?: InputMaybe<NestedIntNullableFilter>;
  _sum?: InputMaybe<NestedIntNullableFilter>;
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type NestedIntWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedIntFilter>;
  _min?: InputMaybe<NestedIntFilter>;
  _sum?: InputMaybe<NestedIntFilter>;
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type NestedJsonFilter = {
  equals?: InputMaybe<Scalars['Json']>;
  not?: InputMaybe<Scalars['Json']>;
};

export type NestedJsonNullableFilter = {
  equals?: InputMaybe<Scalars['Json']>;
  not?: InputMaybe<Scalars['Json']>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedStringNullableFilter>;
  _min?: InputMaybe<NestedStringNullableFilter>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedStringFilter>;
  _min?: InputMaybe<NestedStringFilter>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type Notification = {
  __typename?: 'Notification';
  AutomatedEmails: Array<AutomatedEmails>;
  _count: NotificationCountOutputType;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  link?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['Json']>;
  read?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']>;
};


export type NotificationAutomatedEmailsArgs = {
  cursor?: InputMaybe<AutomatedEmailsWhereUniqueInput>;
  distinct?: InputMaybe<AutomatedEmailsScalarFieldEnum>;
  orderBy?: InputMaybe<AutomatedEmailsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AutomatedEmailsWhereInput>;
};

export type NotificationAvgAggregateOutputType = {
  __typename?: 'NotificationAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

export type NotificationAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type NotificationCountAggregateOutputType = {
  __typename?: 'NotificationCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  link: Scalars['Int'];
  message: Scalars['Int'];
  metadata: Scalars['Int'];
  read: Scalars['Int'];
  title: Scalars['Int'];
  userId: Scalars['Int'];
};

export type NotificationCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  link?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrder>;
  read?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type NotificationCountOutputType = {
  __typename?: 'NotificationCountOutputType';
  AutomatedEmails: Scalars['Int'];
};

export type NotificationCreateInput = {
  AutomatedEmails?: InputMaybe<AutomatedEmailsCreateNestedManyWithoutNotificationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  link?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['Json']>;
  read?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<UserCreateNestedOneWithoutNotificationInput>;
};

export type NotificationCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  link?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['Json']>;
  read?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type NotificationCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  link?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['Json']>;
  read?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type NotificationCreateManyUserInputEnvelope = {
  data: NotificationCreateManyUserInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type NotificationCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<NotificationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<NotificationCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<NotificationCreateWithoutUserInput>>>;
  createMany?: InputMaybe<NotificationCreateManyUserInputEnvelope>;
};

export type NotificationCreateNestedOneWithoutAutomatedEmailsInput = {
  connect?: InputMaybe<NotificationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NotificationCreateOrConnectWithoutAutomatedEmailsInput>;
  create?: InputMaybe<NotificationUncheckedCreateWithoutAutomatedEmailsInput>;
};

export type NotificationCreateOrConnectWithoutAutomatedEmailsInput = {
  create: NotificationUncheckedCreateWithoutAutomatedEmailsInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationCreateOrConnectWithoutUserInput = {
  create: NotificationUncheckedCreateWithoutUserInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationCreateWithoutAutomatedEmailsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  link?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['Json']>;
  read?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<UserCreateNestedOneWithoutNotificationInput>;
};

export type NotificationCreateWithoutUserInput = {
  AutomatedEmails?: InputMaybe<AutomatedEmailsCreateNestedManyWithoutNotificationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  link?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['Json']>;
  read?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type NotificationFindManyInputType = {
  userId?: InputMaybe<Scalars['Int']>;
};

export type NotificationListRelationFilter = {
  every?: InputMaybe<NotificationWhereInput>;
  none?: InputMaybe<NotificationWhereInput>;
  some?: InputMaybe<NotificationWhereInput>;
};

export type NotificationMaxAggregateOutputType = {
  __typename?: 'NotificationMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  link?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  read?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
};

export type NotificationMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  link?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  read?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type NotificationMinAggregateOutputType = {
  __typename?: 'NotificationMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  link?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  read?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
};

export type NotificationMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  link?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  read?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type NotificationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type NotificationOrderByWithAggregationInput = {
  _avg?: InputMaybe<NotificationAvgOrderByAggregateInput>;
  _count?: InputMaybe<NotificationCountOrderByAggregateInput>;
  _max?: InputMaybe<NotificationMaxOrderByAggregateInput>;
  _min?: InputMaybe<NotificationMinOrderByAggregateInput>;
  _sum?: InputMaybe<NotificationSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  link?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrder>;
  read?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type NotificationOrderByWithRelationInput = {
  AutomatedEmails?: InputMaybe<AutomatedEmailsOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  link?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrder>;
  read?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export type NotificationRelationFilter = {
  is?: InputMaybe<NotificationWhereInput>;
  isNot?: InputMaybe<NotificationWhereInput>;
};

export enum NotificationScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Link = 'link',
  Message = 'message',
  Metadata = 'metadata',
  Read = 'read',
  Title = 'title',
  UserId = 'userId'
}

export type NotificationScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<NotificationScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<NotificationScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<NotificationScalarWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  link?: InputMaybe<StringNullableFilter>;
  message?: InputMaybe<StringNullableFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  read?: InputMaybe<BoolNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  userId?: InputMaybe<IntNullableFilter>;
};

export type NotificationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<NotificationScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<NotificationScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<NotificationScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  link?: InputMaybe<StringNullableWithAggregatesFilter>;
  message?: InputMaybe<StringNullableWithAggregatesFilter>;
  metadata?: InputMaybe<JsonNullableWithAggregatesFilter>;
  read?: InputMaybe<BoolNullableWithAggregatesFilter>;
  title?: InputMaybe<StringNullableWithAggregatesFilter>;
  userId?: InputMaybe<IntNullableWithAggregatesFilter>;
};

export type NotificationSumAggregateOutputType = {
  __typename?: 'NotificationSumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

export type NotificationSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export enum NotificationType {
  EmergancyAfterChangeOfDateTime = 'emergancyAfterChangeOfDateTime',
  EmergancyAfterChangeOfLocation = 'emergancyAfterChangeOfLocation',
  EmergancyAfterChangeOfTrainers = 'emergancyAfterChangeOfTrainers'
}

export type NotificationUncheckedCreateInput = {
  AutomatedEmails?: InputMaybe<AutomatedEmailsUncheckedCreateNestedManyWithoutNotificationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  link?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['Json']>;
  read?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type NotificationUncheckedCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<NotificationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<NotificationCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<NotificationCreateWithoutUserInput>>>;
  createMany?: InputMaybe<NotificationCreateManyUserInputEnvelope>;
};

export type NotificationUncheckedCreateWithoutAutomatedEmailsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  link?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['Json']>;
  read?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type NotificationUncheckedCreateWithoutUserInput = {
  AutomatedEmails?: InputMaybe<AutomatedEmailsUncheckedCreateNestedManyWithoutNotificationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  link?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['Json']>;
  read?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type NotificationUncheckedUpdateInput = {
  AutomatedEmails?: InputMaybe<AutomatedEmailsUncheckedUpdateManyWithoutNotificationInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  link?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']>;
  read?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type NotificationUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  link?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']>;
  read?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type NotificationUncheckedUpdateManyWithoutNotificationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  link?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']>;
  read?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type NotificationUncheckedUpdateManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<NotificationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<NotificationCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<NotificationCreateWithoutUserInput>>>;
  createMany?: InputMaybe<NotificationCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<NotificationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<NotificationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<NotificationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<NotificationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<NotificationUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<NotificationUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<NotificationUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type NotificationUncheckedUpdateWithoutAutomatedEmailsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  link?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']>;
  read?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type NotificationUncheckedUpdateWithoutUserInput = {
  AutomatedEmails?: InputMaybe<AutomatedEmailsUncheckedUpdateManyWithoutNotificationInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  link?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']>;
  read?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type NotificationUpdateInput = {
  AutomatedEmails?: InputMaybe<AutomatedEmailsUpdateManyWithoutNotificationInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  link?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']>;
  read?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutNotificationInput>;
};

export type NotificationUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  link?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']>;
  read?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type NotificationUpdateManyWithWhereWithoutUserInput = {
  data: NotificationUncheckedUpdateManyWithoutNotificationInput;
  where: NotificationScalarWhereInput;
};

export type NotificationUpdateManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<NotificationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<NotificationCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<NotificationCreateWithoutUserInput>>>;
  createMany?: InputMaybe<NotificationCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<NotificationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<NotificationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<NotificationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<NotificationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<NotificationUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<NotificationUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<NotificationUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type NotificationUpdateOneWithoutAutomatedEmailsInput = {
  connect?: InputMaybe<NotificationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NotificationCreateOrConnectWithoutAutomatedEmailsInput>;
  create?: InputMaybe<NotificationUncheckedCreateWithoutAutomatedEmailsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<NotificationUncheckedUpdateWithoutAutomatedEmailsInput>;
  upsert?: InputMaybe<NotificationUpsertWithoutAutomatedEmailsInput>;
};

export type NotificationUpdateWithWhereUniqueWithoutUserInput = {
  data: NotificationUncheckedUpdateWithoutUserInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpdateWithoutAutomatedEmailsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  link?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']>;
  read?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutNotificationInput>;
};

export type NotificationUpdateWithoutUserInput = {
  AutomatedEmails?: InputMaybe<AutomatedEmailsUpdateManyWithoutNotificationInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  link?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['Json']>;
  read?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type NotificationUpsertWithWhereUniqueWithoutUserInput = {
  create: NotificationUncheckedCreateWithoutUserInput;
  update: NotificationUncheckedUpdateWithoutUserInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpsertWithoutAutomatedEmailsInput = {
  create: NotificationUncheckedCreateWithoutAutomatedEmailsInput;
  update: NotificationUncheckedUpdateWithoutAutomatedEmailsInput;
};

export type NotificationWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<NotificationWhereInput>>>;
  AutomatedEmails?: InputMaybe<AutomatedEmailsListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<NotificationWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<NotificationWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  link?: InputMaybe<StringNullableFilter>;
  message?: InputMaybe<StringNullableFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  read?: InputMaybe<BoolNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  user?: InputMaybe<UserWhereInput>;
  userId?: InputMaybe<IntNullableFilter>;
};

export type NotificationWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type NullableBigIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['BigInt']>;
  divide?: InputMaybe<Scalars['BigInt']>;
  increment?: InputMaybe<Scalars['BigInt']>;
  multiply?: InputMaybe<Scalars['BigInt']>;
  set?: InputMaybe<Scalars['BigInt']>;
};

export type NullableBoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']>;
};

export type NullableDateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']>;
};

export type NullableDecimalFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Decimal']>;
  divide?: InputMaybe<Scalars['Decimal']>;
  increment?: InputMaybe<Scalars['Decimal']>;
  multiply?: InputMaybe<Scalars['Decimal']>;
  set?: InputMaybe<Scalars['Decimal']>;
};

export type NullableEnumGenderFieldUpdateOperationsInput = {
  set?: InputMaybe<Gender>;
};

export type NullableEnumMarketerProfitTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<MarketerProfitType>;
};

export type NullableEnumProfessionalSkillsTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<ProfessionalSkillsType>;
};

export type NullableEnumScientificResearchRoleFieldUpdateOperationsInput = {
  set?: InputMaybe<ScientificResearchRole>;
};

export type NullableEnumScientificResearchTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<ScientificResearchType>;
};

export type NullableEnumToTransferTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<ToTransferType>;
};

export type NullableIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']>;
  divide?: InputMaybe<Scalars['Int']>;
  increment?: InputMaybe<Scalars['Int']>;
  multiply?: InputMaybe<Scalars['Int']>;
  set?: InputMaybe<Scalars['Int']>;
};

export enum NullableJsonNullValueInput {
  DbNull = 'DbNull',
  JsonNull = 'JsonNull'
}

export type NullableStringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']>;
};

export type OrganizersReport = {
  __typename?: 'OrganizersReport';
  countRecord: Array<CountRecord>;
};

export type OrganizersReportUniqueObject = {
  greaterDate?: InputMaybe<Scalars['DateTime']>;
  smallerDate?: InputMaybe<Scalars['DateTime']>;
  variance: Variance;
};

export type PaymentNetwork = {
  __typename?: 'PaymentNetwork';
  TraineeEvent: Array<TraineeEvent>;
  _count: PaymentNetworkCountOutputType;
  id: Scalars['Int'];
  name: Scalars['String'];
};


export type PaymentNetworkTraineeEventArgs = {
  cursor?: InputMaybe<TraineeEventWhereUniqueInput>;
  distinct?: InputMaybe<TraineeEventScalarFieldEnum>;
  orderBy?: InputMaybe<TraineeEventOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeEventWhereInput>;
};

export type PaymentNetworkAvgAggregateOutputType = {
  __typename?: 'PaymentNetworkAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
};

export type PaymentNetworkAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type PaymentNetworkCountAggregateOutputType = {
  __typename?: 'PaymentNetworkCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
};

export type PaymentNetworkCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type PaymentNetworkCountOutputType = {
  __typename?: 'PaymentNetworkCountOutputType';
  TraineeEvent: Scalars['Int'];
};

export type PaymentNetworkCreateInput = {
  TraineeEvent?: InputMaybe<TraineeEventCreateNestedManyWithoutPaymentNetworkInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  name: Scalars['String'];
};

export type PaymentNetworkCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type PaymentNetworkCreateNestedOneWithoutTraineeEventInput = {
  connect?: InputMaybe<PaymentNetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PaymentNetworkCreateOrConnectWithoutTraineeEventInput>;
  create?: InputMaybe<PaymentNetworkUncheckedCreateWithoutTraineeEventInput>;
};

export type PaymentNetworkCreateOrConnectWithoutTraineeEventInput = {
  create: PaymentNetworkUncheckedCreateWithoutTraineeEventInput;
  where: PaymentNetworkWhereUniqueInput;
};

export type PaymentNetworkCreateWithoutTraineeEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  name: Scalars['String'];
};

export type PaymentNetworkMaxAggregateOutputType = {
  __typename?: 'PaymentNetworkMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type PaymentNetworkMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type PaymentNetworkMinAggregateOutputType = {
  __typename?: 'PaymentNetworkMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type PaymentNetworkMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type PaymentNetworkOrderByWithAggregationInput = {
  _avg?: InputMaybe<PaymentNetworkAvgOrderByAggregateInput>;
  _count?: InputMaybe<PaymentNetworkCountOrderByAggregateInput>;
  _max?: InputMaybe<PaymentNetworkMaxOrderByAggregateInput>;
  _min?: InputMaybe<PaymentNetworkMinOrderByAggregateInput>;
  _sum?: InputMaybe<PaymentNetworkSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type PaymentNetworkOrderByWithRelationInput = {
  TraineeEvent?: InputMaybe<TraineeEventOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type PaymentNetworkRelationFilter = {
  is?: InputMaybe<PaymentNetworkWhereInput>;
  isNot?: InputMaybe<PaymentNetworkWhereInput>;
};

export enum PaymentNetworkScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name'
}

export type PaymentNetworkScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<PaymentNetworkScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<PaymentNetworkScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PaymentNetworkScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
};

export type PaymentNetworkSumAggregateOutputType = {
  __typename?: 'PaymentNetworkSumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
};

export type PaymentNetworkSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type PaymentNetworkUncheckedCreateInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutPaymentNetworkInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type PaymentNetworkUncheckedCreateWithoutTraineeEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type PaymentNetworkUncheckedUpdateInput = {
  TraineeEvent?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutPaymentNetworkInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PaymentNetworkUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PaymentNetworkUncheckedUpdateWithoutTraineeEventInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PaymentNetworkUpdateInput = {
  TraineeEvent?: InputMaybe<TraineeEventUpdateManyWithoutPaymentNetworkInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PaymentNetworkUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PaymentNetworkUpdateOneWithoutTraineeEventInput = {
  connect?: InputMaybe<PaymentNetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PaymentNetworkCreateOrConnectWithoutTraineeEventInput>;
  create?: InputMaybe<PaymentNetworkUncheckedCreateWithoutTraineeEventInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<PaymentNetworkUncheckedUpdateWithoutTraineeEventInput>;
  upsert?: InputMaybe<PaymentNetworkUpsertWithoutTraineeEventInput>;
};

export type PaymentNetworkUpdateWithoutTraineeEventInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PaymentNetworkUpsertWithoutTraineeEventInput = {
  create: PaymentNetworkUncheckedCreateWithoutTraineeEventInput;
  update: PaymentNetworkUncheckedUpdateWithoutTraineeEventInput;
};

export type PaymentNetworkWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<PaymentNetworkWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<PaymentNetworkWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PaymentNetworkWhereInput>>>;
  TraineeEvent?: InputMaybe<TraineeEventListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
};

export type PaymentNetworkWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export enum PaymentType {
  Electronic = 'electronic',
  External = 'external'
}

export type PaymentWay = {
  __typename?: 'PaymentWay';
  Transition: Array<Transition>;
  _count: PaymentWayCountOutputType;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  title: Scalars['String'];
};


export type PaymentWayTransitionArgs = {
  cursor?: InputMaybe<TransitionWhereUniqueInput>;
  distinct?: InputMaybe<TransitionScalarFieldEnum>;
  orderBy?: InputMaybe<TransitionOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TransitionWhereInput>;
};

export type PaymentWayAvgAggregateOutputType = {
  __typename?: 'PaymentWayAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
};

export type PaymentWayAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type PaymentWayCountAggregateOutputType = {
  __typename?: 'PaymentWayCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  title: Scalars['Int'];
};

export type PaymentWayCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type PaymentWayCountOutputType = {
  __typename?: 'PaymentWayCountOutputType';
  Transition: Scalars['Int'];
};

export type PaymentWayCreateInput = {
  Transition?: InputMaybe<TransitionCreateNestedManyWithoutPaymentWayInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
};

export type PaymentWayCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type PaymentWayCreateNestedOneWithoutTransitionInput = {
  connect?: InputMaybe<PaymentWayWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PaymentWayCreateOrConnectWithoutTransitionInput>;
  create?: InputMaybe<PaymentWayUncheckedCreateWithoutTransitionInput>;
};

export type PaymentWayCreateOrConnectWithoutTransitionInput = {
  create: PaymentWayUncheckedCreateWithoutTransitionInput;
  where: PaymentWayWhereUniqueInput;
};

export type PaymentWayCreateWithoutTransitionInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
};

export type PaymentWayMaxAggregateOutputType = {
  __typename?: 'PaymentWayMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type PaymentWayMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type PaymentWayMinAggregateOutputType = {
  __typename?: 'PaymentWayMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type PaymentWayMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type PaymentWayOrderByWithAggregationInput = {
  _avg?: InputMaybe<PaymentWayAvgOrderByAggregateInput>;
  _count?: InputMaybe<PaymentWayCountOrderByAggregateInput>;
  _max?: InputMaybe<PaymentWayMaxOrderByAggregateInput>;
  _min?: InputMaybe<PaymentWayMinOrderByAggregateInput>;
  _sum?: InputMaybe<PaymentWaySumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type PaymentWayOrderByWithRelationInput = {
  Transition?: InputMaybe<TransitionOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type PaymentWayRelationFilter = {
  is?: InputMaybe<PaymentWayWhereInput>;
  isNot?: InputMaybe<PaymentWayWhereInput>;
};

export enum PaymentWayScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  Title = 'title'
}

export type PaymentWayScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<PaymentWayScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<PaymentWayScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PaymentWayScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  title?: InputMaybe<StringWithAggregatesFilter>;
};

export type PaymentWaySumAggregateOutputType = {
  __typename?: 'PaymentWaySumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
};

export type PaymentWaySumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type PaymentWayUncheckedCreateInput = {
  Transition?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutPaymentWayInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type PaymentWayUncheckedCreateWithoutTransitionInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type PaymentWayUncheckedUpdateInput = {
  Transition?: InputMaybe<TransitionUncheckedUpdateManyWithoutPaymentWayInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PaymentWayUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PaymentWayUncheckedUpdateWithoutTransitionInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PaymentWayUpdateInput = {
  Transition?: InputMaybe<TransitionUpdateManyWithoutPaymentWayInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PaymentWayUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PaymentWayUpdateOneRequiredWithoutTransitionInput = {
  connect?: InputMaybe<PaymentWayWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PaymentWayCreateOrConnectWithoutTransitionInput>;
  create?: InputMaybe<PaymentWayUncheckedCreateWithoutTransitionInput>;
  update?: InputMaybe<PaymentWayUncheckedUpdateWithoutTransitionInput>;
  upsert?: InputMaybe<PaymentWayUpsertWithoutTransitionInput>;
};

export type PaymentWayUpdateWithoutTransitionInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PaymentWayUpsertWithoutTransitionInput = {
  create: PaymentWayUncheckedCreateWithoutTransitionInput;
  update: PaymentWayUncheckedUpdateWithoutTransitionInput;
};

export type PaymentWayWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<PaymentWayWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<PaymentWayWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PaymentWayWhereInput>>>;
  Transition?: InputMaybe<TransitionListRelationFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  title?: InputMaybe<StringFilter>;
};

export type PaymentWayWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type PricingPlan = {
  __typename?: 'PricingPlan';
  Event?: Maybe<Event>;
  _count: PricingPlanCountOutputType;
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: Maybe<Scalars['Decimal']>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: Maybe<Scalars['Decimal']>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: Maybe<Scalars['Decimal']>;
  cardFee?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  discountEndDate?: Maybe<Scalars['DateTime']>;
  discountPercentage?: Maybe<Scalars['Decimal']>;
  eventPart?: Maybe<EventPart>;
  freePlanCertificateCmeIsPaid?: Maybe<Scalars['Boolean']>;
  freePlanCertificateCmePrice?: Maybe<Scalars['Decimal']>;
  freePlanCertificateStatus?: Maybe<Scalars['String']>;
  groupDiscountEndDate?: Maybe<Scalars['DateTime']>;
  groupDiscountMinNumberOfRegistrants?: Maybe<Scalars['Int']>;
  groupDiscountPrice?: Maybe<Scalars['Decimal']>;
  hasDiscount?: Maybe<Scalars['Boolean']>;
  hasDiscountEndDate?: Maybe<Scalars['Boolean']>;
  hasGroupDiscount?: Maybe<Scalars['Boolean']>;
  hasGroupDiscountEndDate?: Maybe<Scalars['Boolean']>;
  hasLateRegistration?: Maybe<Scalars['Boolean']>;
  hasMultiPartDiscount?: Maybe<Scalars['Boolean']>;
  hasWorkshop?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  lateRegistrationStartDate?: Maybe<Scalars['DateTime']>;
  multiPartDiscountPrice?: Maybe<Scalars['Decimal']>;
  paidPlanLateRegistrationPrice?: Maybe<Scalars['Decimal']>;
  paidPlanOnsitePrice?: Maybe<Scalars['Decimal']>;
  paidPlanPrice?: Maybe<Scalars['Decimal']>;
  paymentType?: Maybe<Scalars['String']>;
  pricingPlanSpecialtyPrices: Array<PricingPlanSpecialtyPrice>;
  pricingPlanType?: Maybe<PricingPlanType>;
  pricingPlanTypeId?: Maybe<Scalars['Int']>;
  workshopGroupDiscountPrice?: Maybe<Scalars['Decimal']>;
  workshopLateRegistrationPrice?: Maybe<Scalars['Decimal']>;
  workshopPrice?: Maybe<Scalars['Decimal']>;
};


export type PricingPlanPricingPlanSpecialtyPricesArgs = {
  cursor?: InputMaybe<PricingPlanSpecialtyPriceWhereUniqueInput>;
  distinct?: InputMaybe<PricingPlanSpecialtyPriceScalarFieldEnum>;
  orderBy?: InputMaybe<PricingPlanSpecialtyPriceOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PricingPlanSpecialtyPriceWhereInput>;
};

export type PricingPlanAvgAggregateOutputType = {
  __typename?: 'PricingPlanAvgAggregateOutputType';
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: Maybe<Scalars['Decimal']>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: Maybe<Scalars['Decimal']>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: Maybe<Scalars['Decimal']>;
  discountPercentage?: Maybe<Scalars['Decimal']>;
  freePlanCertificateCmePrice?: Maybe<Scalars['Decimal']>;
  groupDiscountMinNumberOfRegistrants?: Maybe<Scalars['Float']>;
  groupDiscountPrice?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['Float']>;
  multiPartDiscountPrice?: Maybe<Scalars['Decimal']>;
  paidPlanLateRegistrationPrice?: Maybe<Scalars['Decimal']>;
  paidPlanOfflinePrice?: Maybe<Scalars['Decimal']>;
  paidPlanOnsitePrice?: Maybe<Scalars['Decimal']>;
  paidPlanPrice?: Maybe<Scalars['Decimal']>;
  pricingPlanTypeId?: Maybe<Scalars['Float']>;
  workshopGroupDiscountPrice?: Maybe<Scalars['Decimal']>;
  workshopLateRegistrationPrice?: Maybe<Scalars['Decimal']>;
  workshopPrice?: Maybe<Scalars['Decimal']>;
};

export type PricingPlanAvgOrderByAggregateInput = {
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<SortOrder>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<SortOrder>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<SortOrder>;
  discountPercentage?: InputMaybe<SortOrder>;
  freePlanCertificateCmePrice?: InputMaybe<SortOrder>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<SortOrder>;
  groupDiscountPrice?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  multiPartDiscountPrice?: InputMaybe<SortOrder>;
  paidPlanLateRegistrationPrice?: InputMaybe<SortOrder>;
  paidPlanOfflinePrice?: InputMaybe<SortOrder>;
  paidPlanOnsitePrice?: InputMaybe<SortOrder>;
  paidPlanPrice?: InputMaybe<SortOrder>;
  pricingPlanTypeId?: InputMaybe<SortOrder>;
  workshopGroupDiscountPrice?: InputMaybe<SortOrder>;
  workshopLateRegistrationPrice?: InputMaybe<SortOrder>;
  workshopPrice?: InputMaybe<SortOrder>;
};

export type PricingPlanCountAggregateOutputType = {
  __typename?: 'PricingPlanCountAggregateOutputType';
  _all: Scalars['Int'];
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice: Scalars['Int'];
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice: Scalars['Int'];
  basedOnSpecialtyPlanOtherSpecialtiesPrice: Scalars['Int'];
  cardFee: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  discountEndDate: Scalars['Int'];
  discountPercentage: Scalars['Int'];
  freePlanCertificateCmeIsPaid: Scalars['Int'];
  freePlanCertificateCmePrice: Scalars['Int'];
  freePlanCertificateStatus: Scalars['Int'];
  groupDiscountEndDate: Scalars['Int'];
  groupDiscountMinNumberOfRegistrants: Scalars['Int'];
  groupDiscountPrice: Scalars['Int'];
  hasDiscount: Scalars['Int'];
  hasDiscountEndDate: Scalars['Int'];
  hasGroupDiscount: Scalars['Int'];
  hasGroupDiscountEndDate: Scalars['Int'];
  hasLateRegistration: Scalars['Int'];
  hasMultiPartDiscount: Scalars['Int'];
  hasWorkshop: Scalars['Int'];
  id: Scalars['Int'];
  lateRegistrationStartDate: Scalars['Int'];
  multiPartDiscountPrice: Scalars['Int'];
  paidPlanLateRegistrationPrice: Scalars['Int'];
  paidPlanOfflinePrice: Scalars['Int'];
  paidPlanOnsitePrice: Scalars['Int'];
  paidPlanPrice: Scalars['Int'];
  paymentType: Scalars['Int'];
  pricingPlanTypeId: Scalars['Int'];
  workshopGroupDiscountPrice: Scalars['Int'];
  workshopLateRegistrationPrice: Scalars['Int'];
  workshopPrice: Scalars['Int'];
};

export type PricingPlanCountOrderByAggregateInput = {
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<SortOrder>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<SortOrder>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<SortOrder>;
  cardFee?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  discountEndDate?: InputMaybe<SortOrder>;
  discountPercentage?: InputMaybe<SortOrder>;
  freePlanCertificateCmeIsPaid?: InputMaybe<SortOrder>;
  freePlanCertificateCmePrice?: InputMaybe<SortOrder>;
  freePlanCertificateStatus?: InputMaybe<SortOrder>;
  groupDiscountEndDate?: InputMaybe<SortOrder>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<SortOrder>;
  groupDiscountPrice?: InputMaybe<SortOrder>;
  hasDiscount?: InputMaybe<SortOrder>;
  hasDiscountEndDate?: InputMaybe<SortOrder>;
  hasGroupDiscount?: InputMaybe<SortOrder>;
  hasGroupDiscountEndDate?: InputMaybe<SortOrder>;
  hasLateRegistration?: InputMaybe<SortOrder>;
  hasMultiPartDiscount?: InputMaybe<SortOrder>;
  hasWorkshop?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lateRegistrationStartDate?: InputMaybe<SortOrder>;
  multiPartDiscountPrice?: InputMaybe<SortOrder>;
  paidPlanLateRegistrationPrice?: InputMaybe<SortOrder>;
  paidPlanOfflinePrice?: InputMaybe<SortOrder>;
  paidPlanOnsitePrice?: InputMaybe<SortOrder>;
  paidPlanPrice?: InputMaybe<SortOrder>;
  paymentType?: InputMaybe<SortOrder>;
  pricingPlanTypeId?: InputMaybe<SortOrder>;
  workshopGroupDiscountPrice?: InputMaybe<SortOrder>;
  workshopLateRegistrationPrice?: InputMaybe<SortOrder>;
  workshopPrice?: InputMaybe<SortOrder>;
};

export type PricingPlanCountOutputType = {
  __typename?: 'PricingPlanCountOutputType';
  pricingPlanSpecialtyPrices: Scalars['Int'];
};

export type PricingPlanCreateInput = {
  Event?: InputMaybe<EventCreateNestedOneWithoutPricingPlanInput>;
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<Scalars['Decimal']>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<Scalars['Decimal']>;
  cardFee?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  discountEndDate?: InputMaybe<Scalars['DateTime']>;
  discountPercentage?: InputMaybe<Scalars['Decimal']>;
  eventPart?: InputMaybe<EventPartCreateNestedOneWithoutPricingPlanInput>;
  freePlanCertificateCmeIsPaid?: InputMaybe<Scalars['Boolean']>;
  freePlanCertificateCmePrice?: InputMaybe<Scalars['Decimal']>;
  freePlanCertificateStatus?: InputMaybe<Scalars['String']>;
  groupDiscountEndDate?: InputMaybe<Scalars['DateTime']>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<Scalars['Int']>;
  groupDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  hasDiscount?: InputMaybe<Scalars['Boolean']>;
  hasDiscountEndDate?: InputMaybe<Scalars['Boolean']>;
  hasGroupDiscount?: InputMaybe<Scalars['Boolean']>;
  hasGroupDiscountEndDate?: InputMaybe<Scalars['Boolean']>;
  hasLateRegistration?: InputMaybe<Scalars['Boolean']>;
  hasMultiPartDiscount?: InputMaybe<Scalars['Boolean']>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  lateRegistrationStartDate?: InputMaybe<Scalars['DateTime']>;
  multiPartDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanOfflinePrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanOnsitePrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanPrice?: InputMaybe<Scalars['Decimal']>;
  paymentType?: InputMaybe<PaymentType>;
  pricingPlanSpecialtyPrices?: InputMaybe<PricingPlanSpecialtyPriceCreateNestedManyWithoutPricingPlanInput>;
  pricingPlanType?: InputMaybe<PricingPlanTypeCreateNestedOneWithoutPricingPlansInput>;
  workshopGroupDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  workshopLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type PricingPlanCreateManyInput = {
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<Scalars['Decimal']>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<Scalars['Decimal']>;
  cardFee?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  discountEndDate?: InputMaybe<Scalars['DateTime']>;
  discountPercentage?: InputMaybe<Scalars['Decimal']>;
  freePlanCertificateCmeIsPaid?: InputMaybe<Scalars['Boolean']>;
  freePlanCertificateCmePrice?: InputMaybe<Scalars['Decimal']>;
  freePlanCertificateStatus?: InputMaybe<Scalars['String']>;
  groupDiscountEndDate?: InputMaybe<Scalars['DateTime']>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<Scalars['Int']>;
  groupDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  hasDiscount?: InputMaybe<Scalars['Boolean']>;
  hasDiscountEndDate?: InputMaybe<Scalars['Boolean']>;
  hasGroupDiscount?: InputMaybe<Scalars['Boolean']>;
  hasGroupDiscountEndDate?: InputMaybe<Scalars['Boolean']>;
  hasLateRegistration?: InputMaybe<Scalars['Boolean']>;
  hasMultiPartDiscount?: InputMaybe<Scalars['Boolean']>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  lateRegistrationStartDate?: InputMaybe<Scalars['DateTime']>;
  multiPartDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanOfflinePrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanOnsitePrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanPrice?: InputMaybe<Scalars['Decimal']>;
  paymentType?: InputMaybe<PaymentType>;
  pricingPlanTypeId?: InputMaybe<Scalars['Int']>;
  workshopGroupDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  workshopLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type PricingPlanCreateManyPricingPlanTypeInput = {
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<Scalars['Decimal']>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<Scalars['Decimal']>;
  cardFee?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  discountEndDate?: InputMaybe<Scalars['DateTime']>;
  discountPercentage?: InputMaybe<Scalars['Decimal']>;
  freePlanCertificateCmeIsPaid?: InputMaybe<Scalars['Boolean']>;
  freePlanCertificateCmePrice?: InputMaybe<Scalars['Decimal']>;
  freePlanCertificateStatus?: InputMaybe<Scalars['String']>;
  groupDiscountEndDate?: InputMaybe<Scalars['DateTime']>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<Scalars['Int']>;
  groupDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  hasDiscount?: InputMaybe<Scalars['Boolean']>;
  hasDiscountEndDate?: InputMaybe<Scalars['Boolean']>;
  hasGroupDiscount?: InputMaybe<Scalars['Boolean']>;
  hasGroupDiscountEndDate?: InputMaybe<Scalars['Boolean']>;
  hasLateRegistration?: InputMaybe<Scalars['Boolean']>;
  hasMultiPartDiscount?: InputMaybe<Scalars['Boolean']>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  lateRegistrationStartDate?: InputMaybe<Scalars['DateTime']>;
  multiPartDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanOfflinePrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanOnsitePrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanPrice?: InputMaybe<Scalars['Decimal']>;
  paymentType?: InputMaybe<PaymentType>;
  workshopGroupDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  workshopLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type PricingPlanCreateManyPricingPlanTypeInputEnvelope = {
  data: PricingPlanCreateManyPricingPlanTypeInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type PricingPlanCreateNestedManyWithoutPricingPlanTypeInput = {
  connect?: InputMaybe<Array<InputMaybe<PricingPlanWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PricingPlanCreateOrConnectWithoutPricingPlanTypeInput>>>;
  create?: InputMaybe<Array<InputMaybe<PricingPlanCreateWithoutPricingPlanTypeInput>>>;
  createMany?: InputMaybe<PricingPlanCreateManyPricingPlanTypeInputEnvelope>;
};

export type PricingPlanCreateNestedOneWithoutEventInput = {
  connect?: InputMaybe<PricingPlanWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PricingPlanCreateOrConnectWithoutEventInput>;
  create?: InputMaybe<PricingPlanUncheckedCreateWithoutEventInput>;
};

export type PricingPlanCreateNestedOneWithoutEventPartInput = {
  connect?: InputMaybe<PricingPlanWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PricingPlanCreateOrConnectWithoutEventPartInput>;
  create?: InputMaybe<PricingPlanUncheckedCreateWithoutEventPartInput>;
};

export type PricingPlanCreateNestedOneWithoutPricingPlanSpecialtyPricesInput = {
  connect?: InputMaybe<PricingPlanWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PricingPlanCreateOrConnectWithoutPricingPlanSpecialtyPricesInput>;
  create?: InputMaybe<PricingPlanUncheckedCreateWithoutPricingPlanSpecialtyPricesInput>;
};

export type PricingPlanCreateOrConnectWithoutEventInput = {
  create: PricingPlanUncheckedCreateWithoutEventInput;
  where: PricingPlanWhereUniqueInput;
};

export type PricingPlanCreateOrConnectWithoutEventPartInput = {
  create: PricingPlanUncheckedCreateWithoutEventPartInput;
  where: PricingPlanWhereUniqueInput;
};

export type PricingPlanCreateOrConnectWithoutPricingPlanSpecialtyPricesInput = {
  create: PricingPlanUncheckedCreateWithoutPricingPlanSpecialtyPricesInput;
  where: PricingPlanWhereUniqueInput;
};

export type PricingPlanCreateOrConnectWithoutPricingPlanTypeInput = {
  create: PricingPlanUncheckedCreateWithoutPricingPlanTypeInput;
  where: PricingPlanWhereUniqueInput;
};

export type PricingPlanCreateWithoutEventInput = {
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<Scalars['Decimal']>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<Scalars['Decimal']>;
  cardFee?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  discountEndDate?: InputMaybe<Scalars['DateTime']>;
  discountPercentage?: InputMaybe<Scalars['Decimal']>;
  eventPart?: InputMaybe<EventPartCreateNestedOneWithoutPricingPlanInput>;
  freePlanCertificateCmeIsPaid?: InputMaybe<Scalars['Boolean']>;
  freePlanCertificateCmePrice?: InputMaybe<Scalars['Decimal']>;
  freePlanCertificateStatus?: InputMaybe<Scalars['String']>;
  groupDiscountEndDate?: InputMaybe<Scalars['DateTime']>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<Scalars['Int']>;
  groupDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  hasDiscount?: InputMaybe<Scalars['Boolean']>;
  hasDiscountEndDate?: InputMaybe<Scalars['Boolean']>;
  hasGroupDiscount?: InputMaybe<Scalars['Boolean']>;
  hasGroupDiscountEndDate?: InputMaybe<Scalars['Boolean']>;
  hasLateRegistration?: InputMaybe<Scalars['Boolean']>;
  hasMultiPartDiscount?: InputMaybe<Scalars['Boolean']>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  lateRegistrationStartDate?: InputMaybe<Scalars['DateTime']>;
  multiPartDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanOfflinePrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanOnsitePrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanPrice?: InputMaybe<Scalars['Decimal']>;
  paymentType?: InputMaybe<PaymentType>;
  pricingPlanSpecialtyPrices?: InputMaybe<PricingPlanSpecialtyPriceCreateNestedManyWithoutPricingPlanInput>;
  pricingPlanType?: InputMaybe<PricingPlanTypeCreateNestedOneWithoutPricingPlansInput>;
  workshopGroupDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  workshopLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type PricingPlanCreateWithoutEventPartInput = {
  Event?: InputMaybe<EventCreateNestedOneWithoutPricingPlanInput>;
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<Scalars['Decimal']>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<Scalars['Decimal']>;
  cardFee?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  discountEndDate?: InputMaybe<Scalars['DateTime']>;
  discountPercentage?: InputMaybe<Scalars['Decimal']>;
  freePlanCertificateCmeIsPaid?: InputMaybe<Scalars['Boolean']>;
  freePlanCertificateCmePrice?: InputMaybe<Scalars['Decimal']>;
  freePlanCertificateStatus?: InputMaybe<Scalars['String']>;
  groupDiscountEndDate?: InputMaybe<Scalars['DateTime']>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<Scalars['Int']>;
  groupDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  hasDiscount?: InputMaybe<Scalars['Boolean']>;
  hasDiscountEndDate?: InputMaybe<Scalars['Boolean']>;
  hasGroupDiscount?: InputMaybe<Scalars['Boolean']>;
  hasGroupDiscountEndDate?: InputMaybe<Scalars['Boolean']>;
  hasLateRegistration?: InputMaybe<Scalars['Boolean']>;
  hasMultiPartDiscount?: InputMaybe<Scalars['Boolean']>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  lateRegistrationStartDate?: InputMaybe<Scalars['DateTime']>;
  multiPartDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanOfflinePrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanOnsitePrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanPrice?: InputMaybe<Scalars['Decimal']>;
  paymentType?: InputMaybe<PaymentType>;
  pricingPlanSpecialtyPrices?: InputMaybe<PricingPlanSpecialtyPriceCreateNestedManyWithoutPricingPlanInput>;
  pricingPlanType?: InputMaybe<PricingPlanTypeCreateNestedOneWithoutPricingPlansInput>;
  workshopGroupDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  workshopLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type PricingPlanCreateWithoutPricingPlanSpecialtyPricesInput = {
  Event?: InputMaybe<EventCreateNestedOneWithoutPricingPlanInput>;
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<Scalars['Decimal']>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<Scalars['Decimal']>;
  cardFee?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  discountEndDate?: InputMaybe<Scalars['DateTime']>;
  discountPercentage?: InputMaybe<Scalars['Decimal']>;
  eventPart?: InputMaybe<EventPartCreateNestedOneWithoutPricingPlanInput>;
  freePlanCertificateCmeIsPaid?: InputMaybe<Scalars['Boolean']>;
  freePlanCertificateCmePrice?: InputMaybe<Scalars['Decimal']>;
  freePlanCertificateStatus?: InputMaybe<Scalars['String']>;
  groupDiscountEndDate?: InputMaybe<Scalars['DateTime']>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<Scalars['Int']>;
  groupDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  hasDiscount?: InputMaybe<Scalars['Boolean']>;
  hasDiscountEndDate?: InputMaybe<Scalars['Boolean']>;
  hasGroupDiscount?: InputMaybe<Scalars['Boolean']>;
  hasGroupDiscountEndDate?: InputMaybe<Scalars['Boolean']>;
  hasLateRegistration?: InputMaybe<Scalars['Boolean']>;
  hasMultiPartDiscount?: InputMaybe<Scalars['Boolean']>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  lateRegistrationStartDate?: InputMaybe<Scalars['DateTime']>;
  multiPartDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanOfflinePrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanOnsitePrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanPrice?: InputMaybe<Scalars['Decimal']>;
  paymentType?: InputMaybe<PaymentType>;
  pricingPlanType?: InputMaybe<PricingPlanTypeCreateNestedOneWithoutPricingPlansInput>;
  workshopGroupDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  workshopLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type PricingPlanCreateWithoutPricingPlanTypeInput = {
  Event?: InputMaybe<EventCreateNestedOneWithoutPricingPlanInput>;
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<Scalars['Decimal']>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<Scalars['Decimal']>;
  cardFee?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  discountEndDate?: InputMaybe<Scalars['DateTime']>;
  discountPercentage?: InputMaybe<Scalars['Decimal']>;
  eventPart?: InputMaybe<EventPartCreateNestedOneWithoutPricingPlanInput>;
  freePlanCertificateCmeIsPaid?: InputMaybe<Scalars['Boolean']>;
  freePlanCertificateCmePrice?: InputMaybe<Scalars['Decimal']>;
  freePlanCertificateStatus?: InputMaybe<Scalars['String']>;
  groupDiscountEndDate?: InputMaybe<Scalars['DateTime']>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<Scalars['Int']>;
  groupDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  hasDiscount?: InputMaybe<Scalars['Boolean']>;
  hasDiscountEndDate?: InputMaybe<Scalars['Boolean']>;
  hasGroupDiscount?: InputMaybe<Scalars['Boolean']>;
  hasGroupDiscountEndDate?: InputMaybe<Scalars['Boolean']>;
  hasLateRegistration?: InputMaybe<Scalars['Boolean']>;
  hasMultiPartDiscount?: InputMaybe<Scalars['Boolean']>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  lateRegistrationStartDate?: InputMaybe<Scalars['DateTime']>;
  multiPartDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanOfflinePrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanOnsitePrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanPrice?: InputMaybe<Scalars['Decimal']>;
  paymentType?: InputMaybe<PaymentType>;
  pricingPlanSpecialtyPrices?: InputMaybe<PricingPlanSpecialtyPriceCreateNestedManyWithoutPricingPlanInput>;
  workshopGroupDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  workshopLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type PricingPlanListRelationFilter = {
  every?: InputMaybe<PricingPlanWhereInput>;
  none?: InputMaybe<PricingPlanWhereInput>;
  some?: InputMaybe<PricingPlanWhereInput>;
};

export type PricingPlanMaxAggregateOutputType = {
  __typename?: 'PricingPlanMaxAggregateOutputType';
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: Maybe<Scalars['Decimal']>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: Maybe<Scalars['Decimal']>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: Maybe<Scalars['Decimal']>;
  cardFee?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  discountEndDate?: Maybe<Scalars['DateTime']>;
  discountPercentage?: Maybe<Scalars['Decimal']>;
  freePlanCertificateCmeIsPaid?: Maybe<Scalars['Boolean']>;
  freePlanCertificateCmePrice?: Maybe<Scalars['Decimal']>;
  freePlanCertificateStatus?: Maybe<Scalars['String']>;
  groupDiscountEndDate?: Maybe<Scalars['DateTime']>;
  groupDiscountMinNumberOfRegistrants?: Maybe<Scalars['Int']>;
  groupDiscountPrice?: Maybe<Scalars['Decimal']>;
  hasDiscount?: Maybe<Scalars['Boolean']>;
  hasDiscountEndDate?: Maybe<Scalars['Boolean']>;
  hasGroupDiscount?: Maybe<Scalars['Boolean']>;
  hasGroupDiscountEndDate?: Maybe<Scalars['Boolean']>;
  hasLateRegistration?: Maybe<Scalars['Boolean']>;
  hasMultiPartDiscount?: Maybe<Scalars['Boolean']>;
  hasWorkshop?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  lateRegistrationStartDate?: Maybe<Scalars['DateTime']>;
  multiPartDiscountPrice?: Maybe<Scalars['Decimal']>;
  paidPlanLateRegistrationPrice?: Maybe<Scalars['Decimal']>;
  paidPlanOfflinePrice?: Maybe<Scalars['Decimal']>;
  paidPlanOnsitePrice?: Maybe<Scalars['Decimal']>;
  paidPlanPrice?: Maybe<Scalars['Decimal']>;
  paymentType?: Maybe<PaymentType>;
  pricingPlanTypeId?: Maybe<Scalars['Int']>;
  workshopGroupDiscountPrice?: Maybe<Scalars['Decimal']>;
  workshopLateRegistrationPrice?: Maybe<Scalars['Decimal']>;
  workshopPrice?: Maybe<Scalars['Decimal']>;
};

export type PricingPlanMaxOrderByAggregateInput = {
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<SortOrder>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<SortOrder>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<SortOrder>;
  cardFee?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  discountEndDate?: InputMaybe<SortOrder>;
  discountPercentage?: InputMaybe<SortOrder>;
  freePlanCertificateCmeIsPaid?: InputMaybe<SortOrder>;
  freePlanCertificateCmePrice?: InputMaybe<SortOrder>;
  freePlanCertificateStatus?: InputMaybe<SortOrder>;
  groupDiscountEndDate?: InputMaybe<SortOrder>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<SortOrder>;
  groupDiscountPrice?: InputMaybe<SortOrder>;
  hasDiscount?: InputMaybe<SortOrder>;
  hasDiscountEndDate?: InputMaybe<SortOrder>;
  hasGroupDiscount?: InputMaybe<SortOrder>;
  hasGroupDiscountEndDate?: InputMaybe<SortOrder>;
  hasLateRegistration?: InputMaybe<SortOrder>;
  hasMultiPartDiscount?: InputMaybe<SortOrder>;
  hasWorkshop?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lateRegistrationStartDate?: InputMaybe<SortOrder>;
  multiPartDiscountPrice?: InputMaybe<SortOrder>;
  paidPlanLateRegistrationPrice?: InputMaybe<SortOrder>;
  paidPlanOfflinePrice?: InputMaybe<SortOrder>;
  paidPlanOnsitePrice?: InputMaybe<SortOrder>;
  paidPlanPrice?: InputMaybe<SortOrder>;
  paymentType?: InputMaybe<SortOrder>;
  pricingPlanTypeId?: InputMaybe<SortOrder>;
  workshopGroupDiscountPrice?: InputMaybe<SortOrder>;
  workshopLateRegistrationPrice?: InputMaybe<SortOrder>;
  workshopPrice?: InputMaybe<SortOrder>;
};

export type PricingPlanMinAggregateOutputType = {
  __typename?: 'PricingPlanMinAggregateOutputType';
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: Maybe<Scalars['Decimal']>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: Maybe<Scalars['Decimal']>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: Maybe<Scalars['Decimal']>;
  cardFee?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  discountEndDate?: Maybe<Scalars['DateTime']>;
  discountPercentage?: Maybe<Scalars['Decimal']>;
  freePlanCertificateCmeIsPaid?: Maybe<Scalars['Boolean']>;
  freePlanCertificateCmePrice?: Maybe<Scalars['Decimal']>;
  freePlanCertificateStatus?: Maybe<Scalars['String']>;
  groupDiscountEndDate?: Maybe<Scalars['DateTime']>;
  groupDiscountMinNumberOfRegistrants?: Maybe<Scalars['Int']>;
  groupDiscountPrice?: Maybe<Scalars['Decimal']>;
  hasDiscount?: Maybe<Scalars['Boolean']>;
  hasDiscountEndDate?: Maybe<Scalars['Boolean']>;
  hasGroupDiscount?: Maybe<Scalars['Boolean']>;
  hasGroupDiscountEndDate?: Maybe<Scalars['Boolean']>;
  hasLateRegistration?: Maybe<Scalars['Boolean']>;
  hasMultiPartDiscount?: Maybe<Scalars['Boolean']>;
  hasWorkshop?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  lateRegistrationStartDate?: Maybe<Scalars['DateTime']>;
  multiPartDiscountPrice?: Maybe<Scalars['Decimal']>;
  paidPlanLateRegistrationPrice?: Maybe<Scalars['Decimal']>;
  paidPlanOfflinePrice?: Maybe<Scalars['Decimal']>;
  paidPlanOnsitePrice?: Maybe<Scalars['Decimal']>;
  paidPlanPrice?: Maybe<Scalars['Decimal']>;
  paymentType?: Maybe<PaymentType>;
  pricingPlanTypeId?: Maybe<Scalars['Int']>;
  workshopGroupDiscountPrice?: Maybe<Scalars['Decimal']>;
  workshopLateRegistrationPrice?: Maybe<Scalars['Decimal']>;
  workshopPrice?: Maybe<Scalars['Decimal']>;
};

export type PricingPlanMinOrderByAggregateInput = {
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<SortOrder>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<SortOrder>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<SortOrder>;
  cardFee?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  discountEndDate?: InputMaybe<SortOrder>;
  discountPercentage?: InputMaybe<SortOrder>;
  freePlanCertificateCmeIsPaid?: InputMaybe<SortOrder>;
  freePlanCertificateCmePrice?: InputMaybe<SortOrder>;
  freePlanCertificateStatus?: InputMaybe<SortOrder>;
  groupDiscountEndDate?: InputMaybe<SortOrder>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<SortOrder>;
  groupDiscountPrice?: InputMaybe<SortOrder>;
  hasDiscount?: InputMaybe<SortOrder>;
  hasDiscountEndDate?: InputMaybe<SortOrder>;
  hasGroupDiscount?: InputMaybe<SortOrder>;
  hasGroupDiscountEndDate?: InputMaybe<SortOrder>;
  hasLateRegistration?: InputMaybe<SortOrder>;
  hasMultiPartDiscount?: InputMaybe<SortOrder>;
  hasWorkshop?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lateRegistrationStartDate?: InputMaybe<SortOrder>;
  multiPartDiscountPrice?: InputMaybe<SortOrder>;
  paidPlanLateRegistrationPrice?: InputMaybe<SortOrder>;
  paidPlanOfflinePrice?: InputMaybe<SortOrder>;
  paidPlanOnsitePrice?: InputMaybe<SortOrder>;
  paidPlanPrice?: InputMaybe<SortOrder>;
  paymentType?: InputMaybe<SortOrder>;
  pricingPlanTypeId?: InputMaybe<SortOrder>;
  workshopGroupDiscountPrice?: InputMaybe<SortOrder>;
  workshopLateRegistrationPrice?: InputMaybe<SortOrder>;
  workshopPrice?: InputMaybe<SortOrder>;
};

export type PricingPlanOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PricingPlanOrderByWithAggregationInput = {
  _avg?: InputMaybe<PricingPlanAvgOrderByAggregateInput>;
  _count?: InputMaybe<PricingPlanCountOrderByAggregateInput>;
  _max?: InputMaybe<PricingPlanMaxOrderByAggregateInput>;
  _min?: InputMaybe<PricingPlanMinOrderByAggregateInput>;
  _sum?: InputMaybe<PricingPlanSumOrderByAggregateInput>;
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<SortOrder>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<SortOrder>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<SortOrder>;
  cardFee?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  discountEndDate?: InputMaybe<SortOrder>;
  discountPercentage?: InputMaybe<SortOrder>;
  freePlanCertificateCmeIsPaid?: InputMaybe<SortOrder>;
  freePlanCertificateCmePrice?: InputMaybe<SortOrder>;
  freePlanCertificateStatus?: InputMaybe<SortOrder>;
  groupDiscountEndDate?: InputMaybe<SortOrder>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<SortOrder>;
  groupDiscountPrice?: InputMaybe<SortOrder>;
  hasDiscount?: InputMaybe<SortOrder>;
  hasDiscountEndDate?: InputMaybe<SortOrder>;
  hasGroupDiscount?: InputMaybe<SortOrder>;
  hasGroupDiscountEndDate?: InputMaybe<SortOrder>;
  hasLateRegistration?: InputMaybe<SortOrder>;
  hasMultiPartDiscount?: InputMaybe<SortOrder>;
  hasWorkshop?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lateRegistrationStartDate?: InputMaybe<SortOrder>;
  multiPartDiscountPrice?: InputMaybe<SortOrder>;
  paidPlanLateRegistrationPrice?: InputMaybe<SortOrder>;
  paidPlanOfflinePrice?: InputMaybe<SortOrder>;
  paidPlanOnsitePrice?: InputMaybe<SortOrder>;
  paidPlanPrice?: InputMaybe<SortOrder>;
  paymentType?: InputMaybe<SortOrder>;
  pricingPlanTypeId?: InputMaybe<SortOrder>;
  workshopGroupDiscountPrice?: InputMaybe<SortOrder>;
  workshopLateRegistrationPrice?: InputMaybe<SortOrder>;
  workshopPrice?: InputMaybe<SortOrder>;
};

export type PricingPlanOrderByWithRelationInput = {
  Event?: InputMaybe<EventOrderByWithRelationInput>;
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<SortOrder>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<SortOrder>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<SortOrder>;
  cardFee?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  discountEndDate?: InputMaybe<SortOrder>;
  discountPercentage?: InputMaybe<SortOrder>;
  eventPart?: InputMaybe<EventPartOrderByWithRelationInput>;
  freePlanCertificateCmeIsPaid?: InputMaybe<SortOrder>;
  freePlanCertificateCmePrice?: InputMaybe<SortOrder>;
  freePlanCertificateStatus?: InputMaybe<SortOrder>;
  groupDiscountEndDate?: InputMaybe<SortOrder>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<SortOrder>;
  groupDiscountPrice?: InputMaybe<SortOrder>;
  hasDiscount?: InputMaybe<SortOrder>;
  hasDiscountEndDate?: InputMaybe<SortOrder>;
  hasGroupDiscount?: InputMaybe<SortOrder>;
  hasGroupDiscountEndDate?: InputMaybe<SortOrder>;
  hasLateRegistration?: InputMaybe<SortOrder>;
  hasMultiPartDiscount?: InputMaybe<SortOrder>;
  hasWorkshop?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lateRegistrationStartDate?: InputMaybe<SortOrder>;
  multiPartDiscountPrice?: InputMaybe<SortOrder>;
  paidPlanLateRegistrationPrice?: InputMaybe<SortOrder>;
  paidPlanOfflinePrice?: InputMaybe<SortOrder>;
  paidPlanOnsitePrice?: InputMaybe<SortOrder>;
  paidPlanPrice?: InputMaybe<SortOrder>;
  paymentType?: InputMaybe<SortOrder>;
  pricingPlanSpecialtyPrices?: InputMaybe<PricingPlanSpecialtyPriceOrderByRelationAggregateInput>;
  pricingPlanType?: InputMaybe<PricingPlanTypeOrderByWithRelationInput>;
  pricingPlanTypeId?: InputMaybe<SortOrder>;
  workshopGroupDiscountPrice?: InputMaybe<SortOrder>;
  workshopLateRegistrationPrice?: InputMaybe<SortOrder>;
  workshopPrice?: InputMaybe<SortOrder>;
};

export type PricingPlanRelationFilter = {
  is?: InputMaybe<PricingPlanWhereInput>;
  isNot?: InputMaybe<PricingPlanWhereInput>;
};

export enum PricingPlanScalarFieldEnum {
  BasedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice = 'basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice',
  BasedOnSpecialtyPlanOtherSpecialtiesOnsitePrice = 'basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice',
  BasedOnSpecialtyPlanOtherSpecialtiesPrice = 'basedOnSpecialtyPlanOtherSpecialtiesPrice',
  CardFee = 'cardFee',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  DiscountEndDate = 'discountEndDate',
  DiscountPercentage = 'discountPercentage',
  FreePlanCertificateCmeIsPaid = 'freePlanCertificateCmeIsPaid',
  FreePlanCertificateCmePrice = 'freePlanCertificateCmePrice',
  FreePlanCertificateStatus = 'freePlanCertificateStatus',
  GroupDiscountEndDate = 'groupDiscountEndDate',
  GroupDiscountMinNumberOfRegistrants = 'groupDiscountMinNumberOfRegistrants',
  GroupDiscountPrice = 'groupDiscountPrice',
  HasDiscount = 'hasDiscount',
  HasDiscountEndDate = 'hasDiscountEndDate',
  HasGroupDiscount = 'hasGroupDiscount',
  HasGroupDiscountEndDate = 'hasGroupDiscountEndDate',
  HasLateRegistration = 'hasLateRegistration',
  HasMultiPartDiscount = 'hasMultiPartDiscount',
  HasWorkshop = 'hasWorkshop',
  Id = 'id',
  LateRegistrationStartDate = 'lateRegistrationStartDate',
  MultiPartDiscountPrice = 'multiPartDiscountPrice',
  PaidPlanLateRegistrationPrice = 'paidPlanLateRegistrationPrice',
  PaidPlanOfflinePrice = 'paidPlanOfflinePrice',
  PaidPlanOnsitePrice = 'paidPlanOnsitePrice',
  PaidPlanPrice = 'paidPlanPrice',
  PaymentType = 'paymentType',
  PricingPlanTypeId = 'pricingPlanTypeId',
  WorkshopGroupDiscountPrice = 'workshopGroupDiscountPrice',
  WorkshopLateRegistrationPrice = 'workshopLateRegistrationPrice',
  WorkshopPrice = 'workshopPrice'
}

export type PricingPlanScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<PricingPlanScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<PricingPlanScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PricingPlanScalarWhereInput>>>;
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<DecimalNullableFilter>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<DecimalNullableFilter>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<DecimalNullableFilter>;
  cardFee?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  discountEndDate?: InputMaybe<DateTimeNullableFilter>;
  discountPercentage?: InputMaybe<DecimalNullableFilter>;
  freePlanCertificateCmeIsPaid?: InputMaybe<BoolNullableFilter>;
  freePlanCertificateCmePrice?: InputMaybe<DecimalNullableFilter>;
  freePlanCertificateStatus?: InputMaybe<StringNullableFilter>;
  groupDiscountEndDate?: InputMaybe<DateTimeNullableFilter>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<IntNullableFilter>;
  groupDiscountPrice?: InputMaybe<DecimalNullableFilter>;
  hasDiscount?: InputMaybe<BoolNullableFilter>;
  hasDiscountEndDate?: InputMaybe<BoolNullableFilter>;
  hasGroupDiscount?: InputMaybe<BoolNullableFilter>;
  hasGroupDiscountEndDate?: InputMaybe<BoolNullableFilter>;
  hasLateRegistration?: InputMaybe<BoolNullableFilter>;
  hasMultiPartDiscount?: InputMaybe<BoolNullableFilter>;
  hasWorkshop?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<IntFilter>;
  lateRegistrationStartDate?: InputMaybe<DateTimeNullableFilter>;
  multiPartDiscountPrice?: InputMaybe<DecimalNullableFilter>;
  paidPlanLateRegistrationPrice?: InputMaybe<DecimalNullableFilter>;
  paidPlanOfflinePrice?: InputMaybe<DecimalNullableFilter>;
  paidPlanOnsitePrice?: InputMaybe<DecimalNullableFilter>;
  paidPlanPrice?: InputMaybe<DecimalNullableFilter>;
  paymentType?: InputMaybe<EnumPaymentTypeFilter>;
  pricingPlanTypeId?: InputMaybe<IntNullableFilter>;
  workshopGroupDiscountPrice?: InputMaybe<DecimalNullableFilter>;
  workshopLateRegistrationPrice?: InputMaybe<DecimalNullableFilter>;
  workshopPrice?: InputMaybe<DecimalNullableFilter>;
};

export type PricingPlanScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<PricingPlanScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<PricingPlanScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PricingPlanScalarWhereWithAggregatesInput>>>;
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  cardFee?: InputMaybe<BoolNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  discountEndDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  discountPercentage?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  freePlanCertificateCmeIsPaid?: InputMaybe<BoolNullableWithAggregatesFilter>;
  freePlanCertificateCmePrice?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  freePlanCertificateStatus?: InputMaybe<StringNullableWithAggregatesFilter>;
  groupDiscountEndDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<IntNullableWithAggregatesFilter>;
  groupDiscountPrice?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  hasDiscount?: InputMaybe<BoolNullableWithAggregatesFilter>;
  hasDiscountEndDate?: InputMaybe<BoolNullableWithAggregatesFilter>;
  hasGroupDiscount?: InputMaybe<BoolNullableWithAggregatesFilter>;
  hasGroupDiscountEndDate?: InputMaybe<BoolNullableWithAggregatesFilter>;
  hasLateRegistration?: InputMaybe<BoolNullableWithAggregatesFilter>;
  hasMultiPartDiscount?: InputMaybe<BoolNullableWithAggregatesFilter>;
  hasWorkshop?: InputMaybe<BoolNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  lateRegistrationStartDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  multiPartDiscountPrice?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  paidPlanLateRegistrationPrice?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  paidPlanOfflinePrice?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  paidPlanOnsitePrice?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  paidPlanPrice?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  paymentType?: InputMaybe<EnumPaymentTypeWithAggregatesFilter>;
  pricingPlanTypeId?: InputMaybe<IntNullableWithAggregatesFilter>;
  workshopGroupDiscountPrice?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  workshopLateRegistrationPrice?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  workshopPrice?: InputMaybe<DecimalNullableWithAggregatesFilter>;
};

export type PricingPlanSpecialtyPrice = {
  __typename?: 'PricingPlanSpecialtyPrice';
  LateRegistrationPrice?: Maybe<Scalars['Decimal']>;
  _count: PricingPlanSpecialtyPriceCountOutputType;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  price: Scalars['Decimal'];
  priceOnsite?: Maybe<Scalars['Decimal']>;
  pricingPlan: PricingPlan;
  pricingPlanId: Scalars['Int'];
  professions: Array<Profession>;
};


export type PricingPlanSpecialtyPriceProfessionsArgs = {
  cursor?: InputMaybe<ProfessionWhereUniqueInput>;
  distinct?: InputMaybe<ProfessionScalarFieldEnum>;
  orderBy?: InputMaybe<ProfessionOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProfessionWhereInput>;
};

export type PricingPlanSpecialtyPriceAvgAggregateOutputType = {
  __typename?: 'PricingPlanSpecialtyPriceAvgAggregateOutputType';
  LateRegistrationPrice?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Decimal']>;
  priceOnsite?: Maybe<Scalars['Decimal']>;
  pricingPlanId?: Maybe<Scalars['Float']>;
};

export type PricingPlanSpecialtyPriceAvgOrderByAggregateInput = {
  LateRegistrationPrice?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  priceOnsite?: InputMaybe<SortOrder>;
  pricingPlanId?: InputMaybe<SortOrder>;
};

export type PricingPlanSpecialtyPriceCountAggregateOutputType = {
  __typename?: 'PricingPlanSpecialtyPriceCountAggregateOutputType';
  LateRegistrationPrice: Scalars['Int'];
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  price: Scalars['Int'];
  priceOnsite: Scalars['Int'];
  pricingPlanId: Scalars['Int'];
};

export type PricingPlanSpecialtyPriceCountOrderByAggregateInput = {
  LateRegistrationPrice?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  priceOnsite?: InputMaybe<SortOrder>;
  pricingPlanId?: InputMaybe<SortOrder>;
};

export type PricingPlanSpecialtyPriceCountOutputType = {
  __typename?: 'PricingPlanSpecialtyPriceCountOutputType';
  professions: Scalars['Int'];
};

export type PricingPlanSpecialtyPriceCreateInput = {
  LateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  price: Scalars['Decimal'];
  priceOnsite?: InputMaybe<Scalars['Decimal']>;
  pricingPlan: PricingPlanCreateNestedOneWithoutPricingPlanSpecialtyPricesInput;
  professions?: InputMaybe<ProfessionCreateNestedManyWithoutPricingPlansInput>;
};

export type PricingPlanSpecialtyPriceCreateManyInput = {
  LateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  priceOnsite?: InputMaybe<Scalars['Decimal']>;
  pricingPlanId: Scalars['Int'];
};

export type PricingPlanSpecialtyPriceCreateManyPricingPlanInput = {
  LateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  priceOnsite?: InputMaybe<Scalars['Decimal']>;
};

export type PricingPlanSpecialtyPriceCreateManyPricingPlanInputEnvelope = {
  data: PricingPlanSpecialtyPriceCreateManyPricingPlanInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type PricingPlanSpecialtyPriceCreateNestedManyWithoutPricingPlanInput = {
  connect?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceCreateOrConnectWithoutPricingPlanInput>>>;
  create?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceCreateWithoutPricingPlanInput>>>;
  createMany?: InputMaybe<PricingPlanSpecialtyPriceCreateManyPricingPlanInputEnvelope>;
};

export type PricingPlanSpecialtyPriceCreateNestedManyWithoutProfessionsInput = {
  connect?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceCreateOrConnectWithoutProfessionsInput>>>;
  create?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceCreateWithoutProfessionsInput>>>;
};

export type PricingPlanSpecialtyPriceCreateOrConnectWithoutPricingPlanInput = {
  create: PricingPlanSpecialtyPriceUncheckedCreateWithoutPricingPlanInput;
  where: PricingPlanSpecialtyPriceWhereUniqueInput;
};

export type PricingPlanSpecialtyPriceCreateOrConnectWithoutProfessionsInput = {
  create: PricingPlanSpecialtyPriceUncheckedCreateWithoutProfessionsInput;
  where: PricingPlanSpecialtyPriceWhereUniqueInput;
};

export type PricingPlanSpecialtyPriceCreateWithoutPricingPlanInput = {
  LateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  price: Scalars['Decimal'];
  priceOnsite?: InputMaybe<Scalars['Decimal']>;
  professions?: InputMaybe<ProfessionCreateNestedManyWithoutPricingPlansInput>;
};

export type PricingPlanSpecialtyPriceCreateWithoutProfessionsInput = {
  LateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  price: Scalars['Decimal'];
  priceOnsite?: InputMaybe<Scalars['Decimal']>;
  pricingPlan: PricingPlanCreateNestedOneWithoutPricingPlanSpecialtyPricesInput;
};

export type PricingPlanSpecialtyPriceListRelationFilter = {
  every?: InputMaybe<PricingPlanSpecialtyPriceWhereInput>;
  none?: InputMaybe<PricingPlanSpecialtyPriceWhereInput>;
  some?: InputMaybe<PricingPlanSpecialtyPriceWhereInput>;
};

export type PricingPlanSpecialtyPriceMaxAggregateOutputType = {
  __typename?: 'PricingPlanSpecialtyPriceMaxAggregateOutputType';
  LateRegistrationPrice?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Decimal']>;
  priceOnsite?: Maybe<Scalars['Decimal']>;
  pricingPlanId?: Maybe<Scalars['Int']>;
};

export type PricingPlanSpecialtyPriceMaxOrderByAggregateInput = {
  LateRegistrationPrice?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  priceOnsite?: InputMaybe<SortOrder>;
  pricingPlanId?: InputMaybe<SortOrder>;
};

export type PricingPlanSpecialtyPriceMinAggregateOutputType = {
  __typename?: 'PricingPlanSpecialtyPriceMinAggregateOutputType';
  LateRegistrationPrice?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Decimal']>;
  priceOnsite?: Maybe<Scalars['Decimal']>;
  pricingPlanId?: Maybe<Scalars['Int']>;
};

export type PricingPlanSpecialtyPriceMinOrderByAggregateInput = {
  LateRegistrationPrice?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  priceOnsite?: InputMaybe<SortOrder>;
  pricingPlanId?: InputMaybe<SortOrder>;
};

export type PricingPlanSpecialtyPriceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PricingPlanSpecialtyPriceOrderByWithAggregationInput = {
  LateRegistrationPrice?: InputMaybe<SortOrder>;
  _avg?: InputMaybe<PricingPlanSpecialtyPriceAvgOrderByAggregateInput>;
  _count?: InputMaybe<PricingPlanSpecialtyPriceCountOrderByAggregateInput>;
  _max?: InputMaybe<PricingPlanSpecialtyPriceMaxOrderByAggregateInput>;
  _min?: InputMaybe<PricingPlanSpecialtyPriceMinOrderByAggregateInput>;
  _sum?: InputMaybe<PricingPlanSpecialtyPriceSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  priceOnsite?: InputMaybe<SortOrder>;
  pricingPlanId?: InputMaybe<SortOrder>;
};

export type PricingPlanSpecialtyPriceOrderByWithRelationInput = {
  LateRegistrationPrice?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  priceOnsite?: InputMaybe<SortOrder>;
  pricingPlan?: InputMaybe<PricingPlanOrderByWithRelationInput>;
  pricingPlanId?: InputMaybe<SortOrder>;
  professions?: InputMaybe<ProfessionOrderByRelationAggregateInput>;
};

export enum PricingPlanSpecialtyPriceScalarFieldEnum {
  LateRegistrationPrice = 'LateRegistrationPrice',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  Price = 'price',
  PriceOnsite = 'priceOnsite',
  PricingPlanId = 'pricingPlanId'
}

export type PricingPlanSpecialtyPriceScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceScalarWhereInput>>>;
  LateRegistrationPrice?: InputMaybe<DecimalNullableFilter>;
  NOT?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceScalarWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  price?: InputMaybe<DecimalFilter>;
  priceOnsite?: InputMaybe<DecimalNullableFilter>;
  pricingPlanId?: InputMaybe<IntFilter>;
};

export type PricingPlanSpecialtyPriceScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceScalarWhereWithAggregatesInput>>>;
  LateRegistrationPrice?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  NOT?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  price?: InputMaybe<DecimalWithAggregatesFilter>;
  priceOnsite?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  pricingPlanId?: InputMaybe<IntWithAggregatesFilter>;
};

export type PricingPlanSpecialtyPriceSumAggregateOutputType = {
  __typename?: 'PricingPlanSpecialtyPriceSumAggregateOutputType';
  LateRegistrationPrice?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Decimal']>;
  priceOnsite?: Maybe<Scalars['Decimal']>;
  pricingPlanId?: Maybe<Scalars['Int']>;
};

export type PricingPlanSpecialtyPriceSumOrderByAggregateInput = {
  LateRegistrationPrice?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  priceOnsite?: InputMaybe<SortOrder>;
  pricingPlanId?: InputMaybe<SortOrder>;
};

export type PricingPlanSpecialtyPriceUncheckedCreateInput = {
  LateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  priceOnsite?: InputMaybe<Scalars['Decimal']>;
  pricingPlanId: Scalars['Int'];
  professions?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutPricingPlansInput>;
};

export type PricingPlanSpecialtyPriceUncheckedCreateNestedManyWithoutPricingPlanInput = {
  connect?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceCreateOrConnectWithoutPricingPlanInput>>>;
  create?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceCreateWithoutPricingPlanInput>>>;
  createMany?: InputMaybe<PricingPlanSpecialtyPriceCreateManyPricingPlanInputEnvelope>;
};

export type PricingPlanSpecialtyPriceUncheckedCreateNestedManyWithoutProfessionsInput = {
  connect?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceCreateOrConnectWithoutProfessionsInput>>>;
  create?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceCreateWithoutProfessionsInput>>>;
};

export type PricingPlanSpecialtyPriceUncheckedCreateWithoutPricingPlanInput = {
  LateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  priceOnsite?: InputMaybe<Scalars['Decimal']>;
  professions?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutPricingPlansInput>;
};

export type PricingPlanSpecialtyPriceUncheckedCreateWithoutProfessionsInput = {
  LateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  priceOnsite?: InputMaybe<Scalars['Decimal']>;
  pricingPlanId: Scalars['Int'];
};

export type PricingPlanSpecialtyPriceUncheckedUpdateInput = {
  LateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  priceOnsite?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
  professions?: InputMaybe<ProfessionUncheckedUpdateManyWithoutPricingPlansInput>;
};

export type PricingPlanSpecialtyPriceUncheckedUpdateManyInput = {
  LateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  priceOnsite?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type PricingPlanSpecialtyPriceUncheckedUpdateManyWithoutPricingPlanInput = {
  connect?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceCreateOrConnectWithoutPricingPlanInput>>>;
  create?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceCreateWithoutPricingPlanInput>>>;
  createMany?: InputMaybe<PricingPlanSpecialtyPriceCreateManyPricingPlanInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceUpdateWithWhereUniqueWithoutPricingPlanInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceUpdateManyWithWhereWithoutPricingPlanInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceUpsertWithWhereUniqueWithoutPricingPlanInput>>>;
};

export type PricingPlanSpecialtyPriceUncheckedUpdateManyWithoutPricingPlanSpecialtyPricesInput = {
  LateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  priceOnsite?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type PricingPlanSpecialtyPriceUncheckedUpdateManyWithoutPricingPlansInput = {
  LateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  priceOnsite?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type PricingPlanSpecialtyPriceUncheckedUpdateManyWithoutProfessionsInput = {
  connect?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceCreateOrConnectWithoutProfessionsInput>>>;
  create?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceCreateWithoutProfessionsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceUpdateWithWhereUniqueWithoutProfessionsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceUpdateManyWithWhereWithoutProfessionsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceUpsertWithWhereUniqueWithoutProfessionsInput>>>;
};

export type PricingPlanSpecialtyPriceUncheckedUpdateWithoutPricingPlanInput = {
  LateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  priceOnsite?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  professions?: InputMaybe<ProfessionUncheckedUpdateManyWithoutPricingPlansInput>;
};

export type PricingPlanSpecialtyPriceUncheckedUpdateWithoutProfessionsInput = {
  LateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  priceOnsite?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  pricingPlanId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type PricingPlanSpecialtyPriceUpdateInput = {
  LateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  priceOnsite?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutPricingPlanSpecialtyPricesInput>;
  professions?: InputMaybe<ProfessionUpdateManyWithoutPricingPlansInput>;
};

export type PricingPlanSpecialtyPriceUpdateManyMutationInput = {
  LateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  priceOnsite?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type PricingPlanSpecialtyPriceUpdateManyWithWhereWithoutPricingPlanInput = {
  data: PricingPlanSpecialtyPriceUncheckedUpdateManyWithoutPricingPlanSpecialtyPricesInput;
  where: PricingPlanSpecialtyPriceScalarWhereInput;
};

export type PricingPlanSpecialtyPriceUpdateManyWithWhereWithoutProfessionsInput = {
  data: PricingPlanSpecialtyPriceUncheckedUpdateManyWithoutPricingPlansInput;
  where: PricingPlanSpecialtyPriceScalarWhereInput;
};

export type PricingPlanSpecialtyPriceUpdateManyWithoutPricingPlanInput = {
  connect?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceCreateOrConnectWithoutPricingPlanInput>>>;
  create?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceCreateWithoutPricingPlanInput>>>;
  createMany?: InputMaybe<PricingPlanSpecialtyPriceCreateManyPricingPlanInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceUpdateWithWhereUniqueWithoutPricingPlanInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceUpdateManyWithWhereWithoutPricingPlanInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceUpsertWithWhereUniqueWithoutPricingPlanInput>>>;
};

export type PricingPlanSpecialtyPriceUpdateManyWithoutProfessionsInput = {
  connect?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceCreateOrConnectWithoutProfessionsInput>>>;
  create?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceCreateWithoutProfessionsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceUpdateWithWhereUniqueWithoutProfessionsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceUpdateManyWithWhereWithoutProfessionsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceUpsertWithWhereUniqueWithoutProfessionsInput>>>;
};

export type PricingPlanSpecialtyPriceUpdateWithWhereUniqueWithoutPricingPlanInput = {
  data: PricingPlanSpecialtyPriceUncheckedUpdateWithoutPricingPlanInput;
  where: PricingPlanSpecialtyPriceWhereUniqueInput;
};

export type PricingPlanSpecialtyPriceUpdateWithWhereUniqueWithoutProfessionsInput = {
  data: PricingPlanSpecialtyPriceUncheckedUpdateWithoutProfessionsInput;
  where: PricingPlanSpecialtyPriceWhereUniqueInput;
};

export type PricingPlanSpecialtyPriceUpdateWithoutPricingPlanInput = {
  LateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  priceOnsite?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  professions?: InputMaybe<ProfessionUpdateManyWithoutPricingPlansInput>;
};

export type PricingPlanSpecialtyPriceUpdateWithoutProfessionsInput = {
  LateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  priceOnsite?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  pricingPlan?: InputMaybe<PricingPlanUpdateOneRequiredWithoutPricingPlanSpecialtyPricesInput>;
};

export type PricingPlanSpecialtyPriceUpsertWithWhereUniqueWithoutPricingPlanInput = {
  create: PricingPlanSpecialtyPriceUncheckedCreateWithoutPricingPlanInput;
  update: PricingPlanSpecialtyPriceUncheckedUpdateWithoutPricingPlanInput;
  where: PricingPlanSpecialtyPriceWhereUniqueInput;
};

export type PricingPlanSpecialtyPriceUpsertWithWhereUniqueWithoutProfessionsInput = {
  create: PricingPlanSpecialtyPriceUncheckedCreateWithoutProfessionsInput;
  update: PricingPlanSpecialtyPriceUncheckedUpdateWithoutProfessionsInput;
  where: PricingPlanSpecialtyPriceWhereUniqueInput;
};

export type PricingPlanSpecialtyPriceWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceWhereInput>>>;
  LateRegistrationPrice?: InputMaybe<DecimalNullableFilter>;
  NOT?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PricingPlanSpecialtyPriceWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  price?: InputMaybe<DecimalFilter>;
  priceOnsite?: InputMaybe<DecimalNullableFilter>;
  pricingPlan?: InputMaybe<PricingPlanWhereInput>;
  pricingPlanId?: InputMaybe<IntFilter>;
  professions?: InputMaybe<ProfessionListRelationFilter>;
};

export type PricingPlanSpecialtyPriceWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type PricingPlanSumAggregateOutputType = {
  __typename?: 'PricingPlanSumAggregateOutputType';
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: Maybe<Scalars['Decimal']>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: Maybe<Scalars['Decimal']>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: Maybe<Scalars['Decimal']>;
  discountPercentage?: Maybe<Scalars['Decimal']>;
  freePlanCertificateCmePrice?: Maybe<Scalars['Decimal']>;
  groupDiscountMinNumberOfRegistrants?: Maybe<Scalars['Int']>;
  groupDiscountPrice?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['Int']>;
  multiPartDiscountPrice?: Maybe<Scalars['Decimal']>;
  paidPlanLateRegistrationPrice?: Maybe<Scalars['Decimal']>;
  paidPlanOfflinePrice?: Maybe<Scalars['Decimal']>;
  paidPlanOnsitePrice?: Maybe<Scalars['Decimal']>;
  paidPlanPrice?: Maybe<Scalars['Decimal']>;
  pricingPlanTypeId?: Maybe<Scalars['Int']>;
  workshopGroupDiscountPrice?: Maybe<Scalars['Decimal']>;
  workshopLateRegistrationPrice?: Maybe<Scalars['Decimal']>;
  workshopPrice?: Maybe<Scalars['Decimal']>;
};

export type PricingPlanSumOrderByAggregateInput = {
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<SortOrder>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<SortOrder>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<SortOrder>;
  discountPercentage?: InputMaybe<SortOrder>;
  freePlanCertificateCmePrice?: InputMaybe<SortOrder>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<SortOrder>;
  groupDiscountPrice?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  multiPartDiscountPrice?: InputMaybe<SortOrder>;
  paidPlanLateRegistrationPrice?: InputMaybe<SortOrder>;
  paidPlanOfflinePrice?: InputMaybe<SortOrder>;
  paidPlanOnsitePrice?: InputMaybe<SortOrder>;
  paidPlanPrice?: InputMaybe<SortOrder>;
  pricingPlanTypeId?: InputMaybe<SortOrder>;
  workshopGroupDiscountPrice?: InputMaybe<SortOrder>;
  workshopLateRegistrationPrice?: InputMaybe<SortOrder>;
  workshopPrice?: InputMaybe<SortOrder>;
};

export type PricingPlanType = {
  __typename?: 'PricingPlanType';
  _count: PricingPlanTypeCountOutputType;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  pricingPlans: Array<PricingPlan>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};


export type PricingPlanTypePricingPlansArgs = {
  cursor?: InputMaybe<PricingPlanWhereUniqueInput>;
  distinct?: InputMaybe<PricingPlanScalarFieldEnum>;
  orderBy?: InputMaybe<PricingPlanOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PricingPlanWhereInput>;
};

export type PricingPlanTypeAvgAggregateOutputType = {
  __typename?: 'PricingPlanTypeAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
};

export type PricingPlanTypeAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type PricingPlanTypeCountAggregateOutputType = {
  __typename?: 'PricingPlanTypeCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  titleAr: Scalars['Int'];
  titleEn: Scalars['Int'];
};

export type PricingPlanTypeCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type PricingPlanTypeCountOutputType = {
  __typename?: 'PricingPlanTypeCountOutputType';
  pricingPlans: Scalars['Int'];
};

export type PricingPlanTypeCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  pricingPlans?: InputMaybe<PricingPlanCreateNestedManyWithoutPricingPlanTypeInput>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type PricingPlanTypeCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type PricingPlanTypeCreateNestedOneWithoutPricingPlansInput = {
  connect?: InputMaybe<PricingPlanTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PricingPlanTypeCreateOrConnectWithoutPricingPlansInput>;
  create?: InputMaybe<PricingPlanTypeUncheckedCreateWithoutPricingPlansInput>;
};

export type PricingPlanTypeCreateOrConnectWithoutPricingPlansInput = {
  create: PricingPlanTypeUncheckedCreateWithoutPricingPlansInput;
  where: PricingPlanTypeWhereUniqueInput;
};

export type PricingPlanTypeCreateWithoutPricingPlansInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type PricingPlanTypeMaxAggregateOutputType = {
  __typename?: 'PricingPlanTypeMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type PricingPlanTypeMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type PricingPlanTypeMinAggregateOutputType = {
  __typename?: 'PricingPlanTypeMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type PricingPlanTypeMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type PricingPlanTypeOrderByWithAggregationInput = {
  _avg?: InputMaybe<PricingPlanTypeAvgOrderByAggregateInput>;
  _count?: InputMaybe<PricingPlanTypeCountOrderByAggregateInput>;
  _max?: InputMaybe<PricingPlanTypeMaxOrderByAggregateInput>;
  _min?: InputMaybe<PricingPlanTypeMinOrderByAggregateInput>;
  _sum?: InputMaybe<PricingPlanTypeSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type PricingPlanTypeOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pricingPlans?: InputMaybe<PricingPlanOrderByRelationAggregateInput>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type PricingPlanTypeRelationFilter = {
  is?: InputMaybe<PricingPlanTypeWhereInput>;
  isNot?: InputMaybe<PricingPlanTypeWhereInput>;
};

export enum PricingPlanTypeScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  TitleAr = 'titleAr',
  TitleEn = 'titleEn'
}

export type PricingPlanTypeScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<PricingPlanTypeScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<PricingPlanTypeScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PricingPlanTypeScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  titleAr?: InputMaybe<StringWithAggregatesFilter>;
  titleEn?: InputMaybe<StringWithAggregatesFilter>;
};

export type PricingPlanTypeSumAggregateOutputType = {
  __typename?: 'PricingPlanTypeSumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
};

export type PricingPlanTypeSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type PricingPlanTypeUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  pricingPlans?: InputMaybe<PricingPlanUncheckedCreateNestedManyWithoutPricingPlanTypeInput>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type PricingPlanTypeUncheckedCreateWithoutPricingPlansInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type PricingPlanTypeUncheckedUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  pricingPlans?: InputMaybe<PricingPlanUncheckedUpdateManyWithoutPricingPlanTypeInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PricingPlanTypeUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PricingPlanTypeUncheckedUpdateWithoutPricingPlansInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PricingPlanTypeUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  pricingPlans?: InputMaybe<PricingPlanUpdateManyWithoutPricingPlanTypeInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PricingPlanTypeUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PricingPlanTypeUpdateOneWithoutPricingPlansInput = {
  connect?: InputMaybe<PricingPlanTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PricingPlanTypeCreateOrConnectWithoutPricingPlansInput>;
  create?: InputMaybe<PricingPlanTypeUncheckedCreateWithoutPricingPlansInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<PricingPlanTypeUncheckedUpdateWithoutPricingPlansInput>;
  upsert?: InputMaybe<PricingPlanTypeUpsertWithoutPricingPlansInput>;
};

export type PricingPlanTypeUpdateWithoutPricingPlansInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PricingPlanTypeUpsertWithoutPricingPlansInput = {
  create: PricingPlanTypeUncheckedCreateWithoutPricingPlansInput;
  update: PricingPlanTypeUncheckedUpdateWithoutPricingPlansInput;
};

export type PricingPlanTypeWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<PricingPlanTypeWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<PricingPlanTypeWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PricingPlanTypeWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  pricingPlans?: InputMaybe<PricingPlanListRelationFilter>;
  titleAr?: InputMaybe<StringFilter>;
  titleEn?: InputMaybe<StringFilter>;
};

export type PricingPlanTypeWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn?: InputMaybe<Scalars['String']>;
};

export type PricingPlanUncheckedCreateInput = {
  Event?: InputMaybe<EventUncheckedCreateNestedOneWithoutPricingPlanInput>;
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<Scalars['Decimal']>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<Scalars['Decimal']>;
  cardFee?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  discountEndDate?: InputMaybe<Scalars['DateTime']>;
  discountPercentage?: InputMaybe<Scalars['Decimal']>;
  eventPart?: InputMaybe<EventPartUncheckedCreateNestedOneWithoutPricingPlanInput>;
  freePlanCertificateCmeIsPaid?: InputMaybe<Scalars['Boolean']>;
  freePlanCertificateCmePrice?: InputMaybe<Scalars['Decimal']>;
  freePlanCertificateStatus?: InputMaybe<Scalars['String']>;
  groupDiscountEndDate?: InputMaybe<Scalars['DateTime']>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<Scalars['Int']>;
  groupDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  hasDiscount?: InputMaybe<Scalars['Boolean']>;
  hasDiscountEndDate?: InputMaybe<Scalars['Boolean']>;
  hasGroupDiscount?: InputMaybe<Scalars['Boolean']>;
  hasGroupDiscountEndDate?: InputMaybe<Scalars['Boolean']>;
  hasLateRegistration?: InputMaybe<Scalars['Boolean']>;
  hasMultiPartDiscount?: InputMaybe<Scalars['Boolean']>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  lateRegistrationStartDate?: InputMaybe<Scalars['DateTime']>;
  multiPartDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanOfflinePrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanOnsitePrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanPrice?: InputMaybe<Scalars['Decimal']>;
  paymentType?: InputMaybe<PaymentType>;
  pricingPlanSpecialtyPrices?: InputMaybe<PricingPlanSpecialtyPriceUncheckedCreateNestedManyWithoutPricingPlanInput>;
  pricingPlanTypeId?: InputMaybe<Scalars['Int']>;
  workshopGroupDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  workshopLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type PricingPlanUncheckedCreateNestedManyWithoutPricingPlanTypeInput = {
  connect?: InputMaybe<Array<InputMaybe<PricingPlanWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PricingPlanCreateOrConnectWithoutPricingPlanTypeInput>>>;
  create?: InputMaybe<Array<InputMaybe<PricingPlanCreateWithoutPricingPlanTypeInput>>>;
  createMany?: InputMaybe<PricingPlanCreateManyPricingPlanTypeInputEnvelope>;
};

export type PricingPlanUncheckedCreateWithoutEventInput = {
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<Scalars['Decimal']>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<Scalars['Decimal']>;
  cardFee?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  discountEndDate?: InputMaybe<Scalars['DateTime']>;
  discountPercentage?: InputMaybe<Scalars['Decimal']>;
  eventPart?: InputMaybe<EventPartUncheckedCreateNestedOneWithoutPricingPlanInput>;
  freePlanCertificateCmeIsPaid?: InputMaybe<Scalars['Boolean']>;
  freePlanCertificateCmePrice?: InputMaybe<Scalars['Decimal']>;
  freePlanCertificateStatus?: InputMaybe<Scalars['String']>;
  groupDiscountEndDate?: InputMaybe<Scalars['DateTime']>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<Scalars['Int']>;
  groupDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  hasDiscount?: InputMaybe<Scalars['Boolean']>;
  hasDiscountEndDate?: InputMaybe<Scalars['Boolean']>;
  hasGroupDiscount?: InputMaybe<Scalars['Boolean']>;
  hasGroupDiscountEndDate?: InputMaybe<Scalars['Boolean']>;
  hasLateRegistration?: InputMaybe<Scalars['Boolean']>;
  hasMultiPartDiscount?: InputMaybe<Scalars['Boolean']>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  lateRegistrationStartDate?: InputMaybe<Scalars['DateTime']>;
  multiPartDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanOfflinePrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanOnsitePrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanPrice?: InputMaybe<Scalars['Decimal']>;
  paymentType?: InputMaybe<PaymentType>;
  pricingPlanSpecialtyPrices?: InputMaybe<PricingPlanSpecialtyPriceUncheckedCreateNestedManyWithoutPricingPlanInput>;
  pricingPlanTypeId?: InputMaybe<Scalars['Int']>;
  workshopGroupDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  workshopLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type PricingPlanUncheckedCreateWithoutEventPartInput = {
  Event?: InputMaybe<EventUncheckedCreateNestedOneWithoutPricingPlanInput>;
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<Scalars['Decimal']>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<Scalars['Decimal']>;
  cardFee?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  discountEndDate?: InputMaybe<Scalars['DateTime']>;
  discountPercentage?: InputMaybe<Scalars['Decimal']>;
  freePlanCertificateCmeIsPaid?: InputMaybe<Scalars['Boolean']>;
  freePlanCertificateCmePrice?: InputMaybe<Scalars['Decimal']>;
  freePlanCertificateStatus?: InputMaybe<Scalars['String']>;
  groupDiscountEndDate?: InputMaybe<Scalars['DateTime']>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<Scalars['Int']>;
  groupDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  hasDiscount?: InputMaybe<Scalars['Boolean']>;
  hasDiscountEndDate?: InputMaybe<Scalars['Boolean']>;
  hasGroupDiscount?: InputMaybe<Scalars['Boolean']>;
  hasGroupDiscountEndDate?: InputMaybe<Scalars['Boolean']>;
  hasLateRegistration?: InputMaybe<Scalars['Boolean']>;
  hasMultiPartDiscount?: InputMaybe<Scalars['Boolean']>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  lateRegistrationStartDate?: InputMaybe<Scalars['DateTime']>;
  multiPartDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanOfflinePrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanOnsitePrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanPrice?: InputMaybe<Scalars['Decimal']>;
  paymentType?: InputMaybe<PaymentType>;
  pricingPlanSpecialtyPrices?: InputMaybe<PricingPlanSpecialtyPriceUncheckedCreateNestedManyWithoutPricingPlanInput>;
  pricingPlanTypeId?: InputMaybe<Scalars['Int']>;
  workshopGroupDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  workshopLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type PricingPlanUncheckedCreateWithoutPricingPlanSpecialtyPricesInput = {
  Event?: InputMaybe<EventUncheckedCreateNestedOneWithoutPricingPlanInput>;
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<Scalars['Decimal']>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<Scalars['Decimal']>;
  cardFee?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  discountEndDate?: InputMaybe<Scalars['DateTime']>;
  discountPercentage?: InputMaybe<Scalars['Decimal']>;
  eventPart?: InputMaybe<EventPartUncheckedCreateNestedOneWithoutPricingPlanInput>;
  freePlanCertificateCmeIsPaid?: InputMaybe<Scalars['Boolean']>;
  freePlanCertificateCmePrice?: InputMaybe<Scalars['Decimal']>;
  freePlanCertificateStatus?: InputMaybe<Scalars['String']>;
  groupDiscountEndDate?: InputMaybe<Scalars['DateTime']>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<Scalars['Int']>;
  groupDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  hasDiscount?: InputMaybe<Scalars['Boolean']>;
  hasDiscountEndDate?: InputMaybe<Scalars['Boolean']>;
  hasGroupDiscount?: InputMaybe<Scalars['Boolean']>;
  hasGroupDiscountEndDate?: InputMaybe<Scalars['Boolean']>;
  hasLateRegistration?: InputMaybe<Scalars['Boolean']>;
  hasMultiPartDiscount?: InputMaybe<Scalars['Boolean']>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  lateRegistrationStartDate?: InputMaybe<Scalars['DateTime']>;
  multiPartDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanOfflinePrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanOnsitePrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanPrice?: InputMaybe<Scalars['Decimal']>;
  paymentType?: InputMaybe<PaymentType>;
  pricingPlanTypeId?: InputMaybe<Scalars['Int']>;
  workshopGroupDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  workshopLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type PricingPlanUncheckedCreateWithoutPricingPlanTypeInput = {
  Event?: InputMaybe<EventUncheckedCreateNestedOneWithoutPricingPlanInput>;
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<Scalars['Decimal']>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<Scalars['Decimal']>;
  cardFee?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  discountEndDate?: InputMaybe<Scalars['DateTime']>;
  discountPercentage?: InputMaybe<Scalars['Decimal']>;
  eventPart?: InputMaybe<EventPartUncheckedCreateNestedOneWithoutPricingPlanInput>;
  freePlanCertificateCmeIsPaid?: InputMaybe<Scalars['Boolean']>;
  freePlanCertificateCmePrice?: InputMaybe<Scalars['Decimal']>;
  freePlanCertificateStatus?: InputMaybe<Scalars['String']>;
  groupDiscountEndDate?: InputMaybe<Scalars['DateTime']>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<Scalars['Int']>;
  groupDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  hasDiscount?: InputMaybe<Scalars['Boolean']>;
  hasDiscountEndDate?: InputMaybe<Scalars['Boolean']>;
  hasGroupDiscount?: InputMaybe<Scalars['Boolean']>;
  hasGroupDiscountEndDate?: InputMaybe<Scalars['Boolean']>;
  hasLateRegistration?: InputMaybe<Scalars['Boolean']>;
  hasMultiPartDiscount?: InputMaybe<Scalars['Boolean']>;
  hasWorkshop?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  lateRegistrationStartDate?: InputMaybe<Scalars['DateTime']>;
  multiPartDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanOfflinePrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanOnsitePrice?: InputMaybe<Scalars['Decimal']>;
  paidPlanPrice?: InputMaybe<Scalars['Decimal']>;
  paymentType?: InputMaybe<PaymentType>;
  pricingPlanSpecialtyPrices?: InputMaybe<PricingPlanSpecialtyPriceUncheckedCreateNestedManyWithoutPricingPlanInput>;
  workshopGroupDiscountPrice?: InputMaybe<Scalars['Decimal']>;
  workshopLateRegistrationPrice?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type PricingPlanUncheckedUpdateInput = {
  Event?: InputMaybe<EventUncheckedUpdateOneWithoutPricingPlanInput>;
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cardFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountPercentage?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  eventPart?: InputMaybe<EventPartUncheckedUpdateOneWithoutPricingPlanInput>;
  freePlanCertificateCmeIsPaid?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  freePlanCertificateCmePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  freePlanCertificateStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  groupDiscountEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  groupDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  hasDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasDiscountEndDate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasGroupDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasGroupDiscountEndDate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasLateRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasMultiPartDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  lateRegistrationStartDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  multiPartDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanOfflinePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanOnsitePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paymentType?: InputMaybe<EnumPaymentTypeFieldUpdateOperationsInput>;
  pricingPlanSpecialtyPrices?: InputMaybe<PricingPlanSpecialtyPriceUncheckedUpdateManyWithoutPricingPlanInput>;
  pricingPlanTypeId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  workshopGroupDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type PricingPlanUncheckedUpdateManyInput = {
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cardFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountPercentage?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  freePlanCertificateCmeIsPaid?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  freePlanCertificateCmePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  freePlanCertificateStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  groupDiscountEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  groupDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  hasDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasDiscountEndDate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasGroupDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasGroupDiscountEndDate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasLateRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasMultiPartDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  lateRegistrationStartDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  multiPartDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanOfflinePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanOnsitePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paymentType?: InputMaybe<EnumPaymentTypeFieldUpdateOperationsInput>;
  pricingPlanTypeId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  workshopGroupDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type PricingPlanUncheckedUpdateManyWithoutPricingPlanTypeInput = {
  connect?: InputMaybe<Array<InputMaybe<PricingPlanWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PricingPlanCreateOrConnectWithoutPricingPlanTypeInput>>>;
  create?: InputMaybe<Array<InputMaybe<PricingPlanCreateWithoutPricingPlanTypeInput>>>;
  createMany?: InputMaybe<PricingPlanCreateManyPricingPlanTypeInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<PricingPlanWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<PricingPlanScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<PricingPlanWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<PricingPlanWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<PricingPlanUpdateWithWhereUniqueWithoutPricingPlanTypeInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<PricingPlanUpdateManyWithWhereWithoutPricingPlanTypeInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<PricingPlanUpsertWithWhereUniqueWithoutPricingPlanTypeInput>>>;
};

export type PricingPlanUncheckedUpdateManyWithoutPricingPlansInput = {
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cardFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountPercentage?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  freePlanCertificateCmeIsPaid?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  freePlanCertificateCmePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  freePlanCertificateStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  groupDiscountEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  groupDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  hasDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasDiscountEndDate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasGroupDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasGroupDiscountEndDate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasLateRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasMultiPartDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  lateRegistrationStartDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  multiPartDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanOfflinePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanOnsitePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paymentType?: InputMaybe<EnumPaymentTypeFieldUpdateOperationsInput>;
  workshopGroupDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type PricingPlanUncheckedUpdateWithoutEventInput = {
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cardFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountPercentage?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  eventPart?: InputMaybe<EventPartUncheckedUpdateOneWithoutPricingPlanInput>;
  freePlanCertificateCmeIsPaid?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  freePlanCertificateCmePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  freePlanCertificateStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  groupDiscountEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  groupDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  hasDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasDiscountEndDate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasGroupDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasGroupDiscountEndDate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasLateRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasMultiPartDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  lateRegistrationStartDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  multiPartDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanOfflinePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanOnsitePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paymentType?: InputMaybe<EnumPaymentTypeFieldUpdateOperationsInput>;
  pricingPlanSpecialtyPrices?: InputMaybe<PricingPlanSpecialtyPriceUncheckedUpdateManyWithoutPricingPlanInput>;
  pricingPlanTypeId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  workshopGroupDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type PricingPlanUncheckedUpdateWithoutEventPartInput = {
  Event?: InputMaybe<EventUncheckedUpdateOneWithoutPricingPlanInput>;
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cardFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountPercentage?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  freePlanCertificateCmeIsPaid?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  freePlanCertificateCmePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  freePlanCertificateStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  groupDiscountEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  groupDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  hasDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasDiscountEndDate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasGroupDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasGroupDiscountEndDate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasLateRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasMultiPartDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  lateRegistrationStartDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  multiPartDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanOfflinePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanOnsitePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paymentType?: InputMaybe<EnumPaymentTypeFieldUpdateOperationsInput>;
  pricingPlanSpecialtyPrices?: InputMaybe<PricingPlanSpecialtyPriceUncheckedUpdateManyWithoutPricingPlanInput>;
  pricingPlanTypeId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  workshopGroupDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type PricingPlanUncheckedUpdateWithoutPricingPlanSpecialtyPricesInput = {
  Event?: InputMaybe<EventUncheckedUpdateOneWithoutPricingPlanInput>;
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cardFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountPercentage?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  eventPart?: InputMaybe<EventPartUncheckedUpdateOneWithoutPricingPlanInput>;
  freePlanCertificateCmeIsPaid?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  freePlanCertificateCmePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  freePlanCertificateStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  groupDiscountEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  groupDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  hasDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasDiscountEndDate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasGroupDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasGroupDiscountEndDate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasLateRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasMultiPartDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  lateRegistrationStartDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  multiPartDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanOfflinePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanOnsitePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paymentType?: InputMaybe<EnumPaymentTypeFieldUpdateOperationsInput>;
  pricingPlanTypeId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  workshopGroupDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type PricingPlanUncheckedUpdateWithoutPricingPlanTypeInput = {
  Event?: InputMaybe<EventUncheckedUpdateOneWithoutPricingPlanInput>;
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cardFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountPercentage?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  eventPart?: InputMaybe<EventPartUncheckedUpdateOneWithoutPricingPlanInput>;
  freePlanCertificateCmeIsPaid?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  freePlanCertificateCmePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  freePlanCertificateStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  groupDiscountEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  groupDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  hasDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasDiscountEndDate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasGroupDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasGroupDiscountEndDate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasLateRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasMultiPartDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  lateRegistrationStartDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  multiPartDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanOfflinePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanOnsitePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paymentType?: InputMaybe<EnumPaymentTypeFieldUpdateOperationsInput>;
  pricingPlanSpecialtyPrices?: InputMaybe<PricingPlanSpecialtyPriceUncheckedUpdateManyWithoutPricingPlanInput>;
  workshopGroupDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type PricingPlanUpdateInput = {
  Event?: InputMaybe<EventUpdateOneWithoutPricingPlanInput>;
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cardFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountPercentage?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  eventPart?: InputMaybe<EventPartUpdateOneWithoutPricingPlanInput>;
  freePlanCertificateCmeIsPaid?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  freePlanCertificateCmePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  freePlanCertificateStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  groupDiscountEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  groupDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  hasDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasDiscountEndDate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasGroupDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasGroupDiscountEndDate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasLateRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasMultiPartDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  lateRegistrationStartDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  multiPartDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanOfflinePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanOnsitePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paymentType?: InputMaybe<EnumPaymentTypeFieldUpdateOperationsInput>;
  pricingPlanSpecialtyPrices?: InputMaybe<PricingPlanSpecialtyPriceUpdateManyWithoutPricingPlanInput>;
  pricingPlanType?: InputMaybe<PricingPlanTypeUpdateOneWithoutPricingPlansInput>;
  workshopGroupDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type PricingPlanUpdateManyMutationInput = {
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cardFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountPercentage?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  freePlanCertificateCmeIsPaid?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  freePlanCertificateCmePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  freePlanCertificateStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  groupDiscountEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  groupDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  hasDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasDiscountEndDate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasGroupDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasGroupDiscountEndDate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasLateRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasMultiPartDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  lateRegistrationStartDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  multiPartDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanOfflinePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanOnsitePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paymentType?: InputMaybe<EnumPaymentTypeFieldUpdateOperationsInput>;
  workshopGroupDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type PricingPlanUpdateManyWithWhereWithoutPricingPlanTypeInput = {
  data: PricingPlanUncheckedUpdateManyWithoutPricingPlansInput;
  where: PricingPlanScalarWhereInput;
};

export type PricingPlanUpdateManyWithoutPricingPlanTypeInput = {
  connect?: InputMaybe<Array<InputMaybe<PricingPlanWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<PricingPlanCreateOrConnectWithoutPricingPlanTypeInput>>>;
  create?: InputMaybe<Array<InputMaybe<PricingPlanCreateWithoutPricingPlanTypeInput>>>;
  createMany?: InputMaybe<PricingPlanCreateManyPricingPlanTypeInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<PricingPlanWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<PricingPlanScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<PricingPlanWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<PricingPlanWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<PricingPlanUpdateWithWhereUniqueWithoutPricingPlanTypeInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<PricingPlanUpdateManyWithWhereWithoutPricingPlanTypeInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<PricingPlanUpsertWithWhereUniqueWithoutPricingPlanTypeInput>>>;
};

export type PricingPlanUpdateOneRequiredWithoutEventInput = {
  connect?: InputMaybe<PricingPlanWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PricingPlanCreateOrConnectWithoutEventInput>;
  create?: InputMaybe<PricingPlanUncheckedCreateWithoutEventInput>;
  update?: InputMaybe<PricingPlanUncheckedUpdateWithoutEventInput>;
  upsert?: InputMaybe<PricingPlanUpsertWithoutEventInput>;
};

export type PricingPlanUpdateOneRequiredWithoutEventPartInput = {
  connect?: InputMaybe<PricingPlanWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PricingPlanCreateOrConnectWithoutEventPartInput>;
  create?: InputMaybe<PricingPlanUncheckedCreateWithoutEventPartInput>;
  update?: InputMaybe<PricingPlanUncheckedUpdateWithoutEventPartInput>;
  upsert?: InputMaybe<PricingPlanUpsertWithoutEventPartInput>;
};

export type PricingPlanUpdateOneRequiredWithoutPricingPlanSpecialtyPricesInput = {
  connect?: InputMaybe<PricingPlanWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PricingPlanCreateOrConnectWithoutPricingPlanSpecialtyPricesInput>;
  create?: InputMaybe<PricingPlanUncheckedCreateWithoutPricingPlanSpecialtyPricesInput>;
  update?: InputMaybe<PricingPlanUncheckedUpdateWithoutPricingPlanSpecialtyPricesInput>;
  upsert?: InputMaybe<PricingPlanUpsertWithoutPricingPlanSpecialtyPricesInput>;
};

export type PricingPlanUpdateWithWhereUniqueWithoutPricingPlanTypeInput = {
  data: PricingPlanUncheckedUpdateWithoutPricingPlanTypeInput;
  where: PricingPlanWhereUniqueInput;
};

export type PricingPlanUpdateWithoutEventInput = {
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cardFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountPercentage?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  eventPart?: InputMaybe<EventPartUpdateOneWithoutPricingPlanInput>;
  freePlanCertificateCmeIsPaid?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  freePlanCertificateCmePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  freePlanCertificateStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  groupDiscountEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  groupDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  hasDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasDiscountEndDate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasGroupDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasGroupDiscountEndDate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasLateRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasMultiPartDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  lateRegistrationStartDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  multiPartDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanOfflinePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanOnsitePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paymentType?: InputMaybe<EnumPaymentTypeFieldUpdateOperationsInput>;
  pricingPlanSpecialtyPrices?: InputMaybe<PricingPlanSpecialtyPriceUpdateManyWithoutPricingPlanInput>;
  pricingPlanType?: InputMaybe<PricingPlanTypeUpdateOneWithoutPricingPlansInput>;
  workshopGroupDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type PricingPlanUpdateWithoutEventPartInput = {
  Event?: InputMaybe<EventUpdateOneWithoutPricingPlanInput>;
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cardFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountPercentage?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  freePlanCertificateCmeIsPaid?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  freePlanCertificateCmePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  freePlanCertificateStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  groupDiscountEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  groupDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  hasDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasDiscountEndDate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasGroupDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasGroupDiscountEndDate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasLateRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasMultiPartDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  lateRegistrationStartDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  multiPartDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanOfflinePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanOnsitePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paymentType?: InputMaybe<EnumPaymentTypeFieldUpdateOperationsInput>;
  pricingPlanSpecialtyPrices?: InputMaybe<PricingPlanSpecialtyPriceUpdateManyWithoutPricingPlanInput>;
  pricingPlanType?: InputMaybe<PricingPlanTypeUpdateOneWithoutPricingPlansInput>;
  workshopGroupDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type PricingPlanUpdateWithoutPricingPlanSpecialtyPricesInput = {
  Event?: InputMaybe<EventUpdateOneWithoutPricingPlanInput>;
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cardFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountPercentage?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  eventPart?: InputMaybe<EventPartUpdateOneWithoutPricingPlanInput>;
  freePlanCertificateCmeIsPaid?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  freePlanCertificateCmePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  freePlanCertificateStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  groupDiscountEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  groupDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  hasDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasDiscountEndDate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasGroupDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasGroupDiscountEndDate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasLateRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasMultiPartDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  lateRegistrationStartDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  multiPartDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanOfflinePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanOnsitePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paymentType?: InputMaybe<EnumPaymentTypeFieldUpdateOperationsInput>;
  pricingPlanType?: InputMaybe<PricingPlanTypeUpdateOneWithoutPricingPlansInput>;
  workshopGroupDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type PricingPlanUpdateWithoutPricingPlanTypeInput = {
  Event?: InputMaybe<EventUpdateOneWithoutPricingPlanInput>;
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  cardFee?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountPercentage?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  eventPart?: InputMaybe<EventPartUpdateOneWithoutPricingPlanInput>;
  freePlanCertificateCmeIsPaid?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  freePlanCertificateCmePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  freePlanCertificateStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  groupDiscountEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  groupDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  hasDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasDiscountEndDate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasGroupDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasGroupDiscountEndDate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasLateRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasMultiPartDiscount?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasWorkshop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  lateRegistrationStartDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  multiPartDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanOfflinePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanOnsitePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paidPlanPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  paymentType?: InputMaybe<EnumPaymentTypeFieldUpdateOperationsInput>;
  pricingPlanSpecialtyPrices?: InputMaybe<PricingPlanSpecialtyPriceUpdateManyWithoutPricingPlanInput>;
  workshopGroupDiscountPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopLateRegistrationPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type PricingPlanUpsertWithWhereUniqueWithoutPricingPlanTypeInput = {
  create: PricingPlanUncheckedCreateWithoutPricingPlanTypeInput;
  update: PricingPlanUncheckedUpdateWithoutPricingPlanTypeInput;
  where: PricingPlanWhereUniqueInput;
};

export type PricingPlanUpsertWithoutEventInput = {
  create: PricingPlanUncheckedCreateWithoutEventInput;
  update: PricingPlanUncheckedUpdateWithoutEventInput;
};

export type PricingPlanUpsertWithoutEventPartInput = {
  create: PricingPlanUncheckedCreateWithoutEventPartInput;
  update: PricingPlanUncheckedUpdateWithoutEventPartInput;
};

export type PricingPlanUpsertWithoutPricingPlanSpecialtyPricesInput = {
  create: PricingPlanUncheckedCreateWithoutPricingPlanSpecialtyPricesInput;
  update: PricingPlanUncheckedUpdateWithoutPricingPlanSpecialtyPricesInput;
};

export type PricingPlanWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<PricingPlanWhereInput>>>;
  Event?: InputMaybe<EventWhereInput>;
  NOT?: InputMaybe<Array<InputMaybe<PricingPlanWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<PricingPlanWhereInput>>>;
  basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: InputMaybe<DecimalNullableFilter>;
  basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: InputMaybe<DecimalNullableFilter>;
  basedOnSpecialtyPlanOtherSpecialtiesPrice?: InputMaybe<DecimalNullableFilter>;
  cardFee?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  discountEndDate?: InputMaybe<DateTimeNullableFilter>;
  discountPercentage?: InputMaybe<DecimalNullableFilter>;
  eventPart?: InputMaybe<EventPartWhereInput>;
  freePlanCertificateCmeIsPaid?: InputMaybe<BoolNullableFilter>;
  freePlanCertificateCmePrice?: InputMaybe<DecimalNullableFilter>;
  freePlanCertificateStatus?: InputMaybe<StringNullableFilter>;
  groupDiscountEndDate?: InputMaybe<DateTimeNullableFilter>;
  groupDiscountMinNumberOfRegistrants?: InputMaybe<IntNullableFilter>;
  groupDiscountPrice?: InputMaybe<DecimalNullableFilter>;
  hasDiscount?: InputMaybe<BoolNullableFilter>;
  hasDiscountEndDate?: InputMaybe<BoolNullableFilter>;
  hasGroupDiscount?: InputMaybe<BoolNullableFilter>;
  hasGroupDiscountEndDate?: InputMaybe<BoolNullableFilter>;
  hasLateRegistration?: InputMaybe<BoolNullableFilter>;
  hasMultiPartDiscount?: InputMaybe<BoolNullableFilter>;
  hasWorkshop?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<IntFilter>;
  lateRegistrationStartDate?: InputMaybe<DateTimeNullableFilter>;
  multiPartDiscountPrice?: InputMaybe<DecimalNullableFilter>;
  paidPlanLateRegistrationPrice?: InputMaybe<DecimalNullableFilter>;
  paidPlanOfflinePrice?: InputMaybe<DecimalNullableFilter>;
  paidPlanOnsitePrice?: InputMaybe<DecimalNullableFilter>;
  paidPlanPrice?: InputMaybe<DecimalNullableFilter>;
  paymentType?: InputMaybe<EnumPaymentTypeFilter>;
  pricingPlanSpecialtyPrices?: InputMaybe<PricingPlanSpecialtyPriceListRelationFilter>;
  pricingPlanType?: InputMaybe<PricingPlanTypeWhereInput>;
  pricingPlanTypeId?: InputMaybe<IntNullableFilter>;
  workshopGroupDiscountPrice?: InputMaybe<DecimalNullableFilter>;
  workshopLateRegistrationPrice?: InputMaybe<DecimalNullableFilter>;
  workshopPrice?: InputMaybe<DecimalNullableFilter>;
};

export type PricingPlanWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type Profession = {
  __typename?: 'Profession';
  Coupon?: Maybe<Coupon>;
  Education: Array<Education>;
  Events: Array<Event>;
  Specialties: Array<Specialty>;
  _count: ProfessionCountOutputType;
  couponId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  pricingPlans: Array<PricingPlanSpecialtyPrice>;
  sortOrder?: Maybe<Scalars['Int']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn: Scalars['String'];
  trainerEvents: Array<TrainerEvent>;
  users: Array<User>;
};


export type ProfessionEducationArgs = {
  cursor?: InputMaybe<EducationWhereUniqueInput>;
  distinct?: InputMaybe<EducationScalarFieldEnum>;
  orderBy?: InputMaybe<EducationOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EducationWhereInput>;
};


export type ProfessionEventsArgs = {
  cursor?: InputMaybe<EventWhereUniqueInput>;
  distinct?: InputMaybe<EventScalarFieldEnum>;
  orderBy?: InputMaybe<EventOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EventWhereInput>;
};


export type ProfessionSpecialtiesArgs = {
  cursor?: InputMaybe<SpecialtyWhereUniqueInput>;
  distinct?: InputMaybe<SpecialtyScalarFieldEnum>;
  orderBy?: InputMaybe<SpecialtyOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SpecialtyWhereInput>;
};


export type ProfessionPricingPlansArgs = {
  cursor?: InputMaybe<PricingPlanSpecialtyPriceWhereUniqueInput>;
  distinct?: InputMaybe<PricingPlanSpecialtyPriceScalarFieldEnum>;
  orderBy?: InputMaybe<PricingPlanSpecialtyPriceOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PricingPlanSpecialtyPriceWhereInput>;
};


export type ProfessionTrainerEventsArgs = {
  cursor?: InputMaybe<TrainerEventWhereUniqueInput>;
  distinct?: InputMaybe<TrainerEventScalarFieldEnum>;
  orderBy?: InputMaybe<TrainerEventOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TrainerEventWhereInput>;
};


export type ProfessionUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<UserScalarFieldEnum>;
  orderBy?: InputMaybe<UserOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};

export type ProfessionAvgAggregateOutputType = {
  __typename?: 'ProfessionAvgAggregateOutputType';
  couponId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sortOrder?: Maybe<Scalars['Float']>;
};

export type ProfessionAvgOrderByAggregateInput = {
  couponId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type ProfessionCountAggregateOutputType = {
  __typename?: 'ProfessionCountAggregateOutputType';
  _all: Scalars['Int'];
  couponId: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  sortOrder: Scalars['Int'];
  titleAr: Scalars['Int'];
  titleEn: Scalars['Int'];
};

export type ProfessionCountOrderByAggregateInput = {
  couponId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type ProfessionCountOutputType = {
  __typename?: 'ProfessionCountOutputType';
  Education: Scalars['Int'];
  Events: Scalars['Int'];
  Specialties: Scalars['Int'];
  pricingPlans: Scalars['Int'];
  trainerEvents: Scalars['Int'];
  users: Scalars['Int'];
};

export type ProfessionCreateInput = {
  Coupon?: InputMaybe<CouponCreateNestedOneWithoutProfessionsInput>;
  Education?: InputMaybe<EducationCreateNestedManyWithoutProfessionInput>;
  Events?: InputMaybe<EventCreateNestedManyWithoutTargetedAudiencesInput>;
  Specialties?: InputMaybe<SpecialtyCreateNestedManyWithoutProfessionInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  pricingPlans?: InputMaybe<PricingPlanSpecialtyPriceCreateNestedManyWithoutProfessionsInput>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn: Scalars['String'];
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTargetedAudiencesInput>;
  users?: InputMaybe<UserCreateNestedManyWithoutProfessionInput>;
};

export type ProfessionCreateManyCouponInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn: Scalars['String'];
};

export type ProfessionCreateManyCouponInputEnvelope = {
  data: ProfessionCreateManyCouponInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ProfessionCreateManyInput = {
  couponId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn: Scalars['String'];
};

export type ProfessionCreateNestedManyWithoutCouponInput = {
  connect?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ProfessionCreateOrConnectWithoutCouponInput>>>;
  create?: InputMaybe<Array<InputMaybe<ProfessionCreateWithoutCouponInput>>>;
  createMany?: InputMaybe<ProfessionCreateManyCouponInputEnvelope>;
};

export type ProfessionCreateNestedManyWithoutEventsInput = {
  connect?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ProfessionCreateOrConnectWithoutEventsInput>>>;
  create?: InputMaybe<Array<InputMaybe<ProfessionCreateWithoutEventsInput>>>;
};

export type ProfessionCreateNestedManyWithoutPricingPlansInput = {
  connect?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ProfessionCreateOrConnectWithoutPricingPlansInput>>>;
  create?: InputMaybe<Array<InputMaybe<ProfessionCreateWithoutPricingPlansInput>>>;
};

export type ProfessionCreateNestedManyWithoutTrainerEventsInput = {
  connect?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ProfessionCreateOrConnectWithoutTrainerEventsInput>>>;
  create?: InputMaybe<Array<InputMaybe<ProfessionCreateWithoutTrainerEventsInput>>>;
};

export type ProfessionCreateNestedOneWithoutEducationInput = {
  connect?: InputMaybe<ProfessionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfessionCreateOrConnectWithoutEducationInput>;
  create?: InputMaybe<ProfessionUncheckedCreateWithoutEducationInput>;
};

export type ProfessionCreateNestedOneWithoutSpecialtiesInput = {
  connect?: InputMaybe<ProfessionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfessionCreateOrConnectWithoutSpecialtiesInput>;
  create?: InputMaybe<ProfessionUncheckedCreateWithoutSpecialtiesInput>;
};

export type ProfessionCreateNestedOneWithoutUsersInput = {
  connect?: InputMaybe<ProfessionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfessionCreateOrConnectWithoutUsersInput>;
  create?: InputMaybe<ProfessionUncheckedCreateWithoutUsersInput>;
};

export type ProfessionCreateOrConnectWithoutCouponInput = {
  create: ProfessionUncheckedCreateWithoutCouponInput;
  where: ProfessionWhereUniqueInput;
};

export type ProfessionCreateOrConnectWithoutEducationInput = {
  create: ProfessionUncheckedCreateWithoutEducationInput;
  where: ProfessionWhereUniqueInput;
};

export type ProfessionCreateOrConnectWithoutEventsInput = {
  create: ProfessionUncheckedCreateWithoutEventsInput;
  where: ProfessionWhereUniqueInput;
};

export type ProfessionCreateOrConnectWithoutPricingPlansInput = {
  create: ProfessionUncheckedCreateWithoutPricingPlansInput;
  where: ProfessionWhereUniqueInput;
};

export type ProfessionCreateOrConnectWithoutSpecialtiesInput = {
  create: ProfessionUncheckedCreateWithoutSpecialtiesInput;
  where: ProfessionWhereUniqueInput;
};

export type ProfessionCreateOrConnectWithoutTrainerEventsInput = {
  create: ProfessionUncheckedCreateWithoutTrainerEventsInput;
  where: ProfessionWhereUniqueInput;
};

export type ProfessionCreateOrConnectWithoutUsersInput = {
  create: ProfessionUncheckedCreateWithoutUsersInput;
  where: ProfessionWhereUniqueInput;
};

export type ProfessionCreateWithoutCouponInput = {
  Education?: InputMaybe<EducationCreateNestedManyWithoutProfessionInput>;
  Events?: InputMaybe<EventCreateNestedManyWithoutTargetedAudiencesInput>;
  Specialties?: InputMaybe<SpecialtyCreateNestedManyWithoutProfessionInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  pricingPlans?: InputMaybe<PricingPlanSpecialtyPriceCreateNestedManyWithoutProfessionsInput>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn: Scalars['String'];
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTargetedAudiencesInput>;
  users?: InputMaybe<UserCreateNestedManyWithoutProfessionInput>;
};

export type ProfessionCreateWithoutEducationInput = {
  Coupon?: InputMaybe<CouponCreateNestedOneWithoutProfessionsInput>;
  Events?: InputMaybe<EventCreateNestedManyWithoutTargetedAudiencesInput>;
  Specialties?: InputMaybe<SpecialtyCreateNestedManyWithoutProfessionInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  pricingPlans?: InputMaybe<PricingPlanSpecialtyPriceCreateNestedManyWithoutProfessionsInput>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn: Scalars['String'];
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTargetedAudiencesInput>;
  users?: InputMaybe<UserCreateNestedManyWithoutProfessionInput>;
};

export type ProfessionCreateWithoutEventsInput = {
  Coupon?: InputMaybe<CouponCreateNestedOneWithoutProfessionsInput>;
  Education?: InputMaybe<EducationCreateNestedManyWithoutProfessionInput>;
  Specialties?: InputMaybe<SpecialtyCreateNestedManyWithoutProfessionInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  pricingPlans?: InputMaybe<PricingPlanSpecialtyPriceCreateNestedManyWithoutProfessionsInput>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn: Scalars['String'];
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTargetedAudiencesInput>;
  users?: InputMaybe<UserCreateNestedManyWithoutProfessionInput>;
};

export type ProfessionCreateWithoutPricingPlansInput = {
  Coupon?: InputMaybe<CouponCreateNestedOneWithoutProfessionsInput>;
  Education?: InputMaybe<EducationCreateNestedManyWithoutProfessionInput>;
  Events?: InputMaybe<EventCreateNestedManyWithoutTargetedAudiencesInput>;
  Specialties?: InputMaybe<SpecialtyCreateNestedManyWithoutProfessionInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn: Scalars['String'];
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTargetedAudiencesInput>;
  users?: InputMaybe<UserCreateNestedManyWithoutProfessionInput>;
};

export type ProfessionCreateWithoutSpecialtiesInput = {
  Coupon?: InputMaybe<CouponCreateNestedOneWithoutProfessionsInput>;
  Education?: InputMaybe<EducationCreateNestedManyWithoutProfessionInput>;
  Events?: InputMaybe<EventCreateNestedManyWithoutTargetedAudiencesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  pricingPlans?: InputMaybe<PricingPlanSpecialtyPriceCreateNestedManyWithoutProfessionsInput>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn: Scalars['String'];
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTargetedAudiencesInput>;
  users?: InputMaybe<UserCreateNestedManyWithoutProfessionInput>;
};

export type ProfessionCreateWithoutTrainerEventsInput = {
  Coupon?: InputMaybe<CouponCreateNestedOneWithoutProfessionsInput>;
  Education?: InputMaybe<EducationCreateNestedManyWithoutProfessionInput>;
  Events?: InputMaybe<EventCreateNestedManyWithoutTargetedAudiencesInput>;
  Specialties?: InputMaybe<SpecialtyCreateNestedManyWithoutProfessionInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  pricingPlans?: InputMaybe<PricingPlanSpecialtyPriceCreateNestedManyWithoutProfessionsInput>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn: Scalars['String'];
  users?: InputMaybe<UserCreateNestedManyWithoutProfessionInput>;
};

export type ProfessionCreateWithoutUsersInput = {
  Coupon?: InputMaybe<CouponCreateNestedOneWithoutProfessionsInput>;
  Education?: InputMaybe<EducationCreateNestedManyWithoutProfessionInput>;
  Events?: InputMaybe<EventCreateNestedManyWithoutTargetedAudiencesInput>;
  Specialties?: InputMaybe<SpecialtyCreateNestedManyWithoutProfessionInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  pricingPlans?: InputMaybe<PricingPlanSpecialtyPriceCreateNestedManyWithoutProfessionsInput>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn: Scalars['String'];
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTargetedAudiencesInput>;
};

export type ProfessionListRelationFilter = {
  every?: InputMaybe<ProfessionWhereInput>;
  none?: InputMaybe<ProfessionWhereInput>;
  some?: InputMaybe<ProfessionWhereInput>;
};

export type ProfessionMaxAggregateOutputType = {
  __typename?: 'ProfessionMaxAggregateOutputType';
  couponId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  sortOrder?: Maybe<Scalars['Int']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type ProfessionMaxOrderByAggregateInput = {
  couponId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type ProfessionMinAggregateOutputType = {
  __typename?: 'ProfessionMinAggregateOutputType';
  couponId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  sortOrder?: Maybe<Scalars['Int']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type ProfessionMinOrderByAggregateInput = {
  couponId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type ProfessionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProfessionOrderByWithAggregationInput = {
  _avg?: InputMaybe<ProfessionAvgOrderByAggregateInput>;
  _count?: InputMaybe<ProfessionCountOrderByAggregateInput>;
  _max?: InputMaybe<ProfessionMaxOrderByAggregateInput>;
  _min?: InputMaybe<ProfessionMinOrderByAggregateInput>;
  _sum?: InputMaybe<ProfessionSumOrderByAggregateInput>;
  couponId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type ProfessionOrderByWithRelationInput = {
  Coupon?: InputMaybe<CouponOrderByWithRelationInput>;
  Education?: InputMaybe<EducationOrderByRelationAggregateInput>;
  Events?: InputMaybe<EventOrderByRelationAggregateInput>;
  Specialties?: InputMaybe<SpecialtyOrderByRelationAggregateInput>;
  couponId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pricingPlans?: InputMaybe<PricingPlanSpecialtyPriceOrderByRelationAggregateInput>;
  sortOrder?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
  trainerEvents?: InputMaybe<TrainerEventOrderByRelationAggregateInput>;
  users?: InputMaybe<UserOrderByRelationAggregateInput>;
};

export type ProfessionRelationFilter = {
  is?: InputMaybe<ProfessionWhereInput>;
  isNot?: InputMaybe<ProfessionWhereInput>;
};

export enum ProfessionScalarFieldEnum {
  CouponId = 'couponId',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  SortOrder = 'sortOrder',
  TitleAr = 'titleAr',
  TitleEn = 'titleEn'
}

export type ProfessionScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ProfessionScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ProfessionScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ProfessionScalarWhereInput>>>;
  couponId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  sortOrder?: InputMaybe<IntNullableFilter>;
  titleAr?: InputMaybe<StringNullableFilter>;
  titleEn?: InputMaybe<StringFilter>;
};

export type ProfessionScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<ProfessionScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ProfessionScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ProfessionScalarWhereWithAggregatesInput>>>;
  couponId?: InputMaybe<IntNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  sortOrder?: InputMaybe<IntNullableWithAggregatesFilter>;
  titleAr?: InputMaybe<StringNullableWithAggregatesFilter>;
  titleEn?: InputMaybe<StringWithAggregatesFilter>;
};

export type ProfessionSumAggregateOutputType = {
  __typename?: 'ProfessionSumAggregateOutputType';
  couponId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  sortOrder?: Maybe<Scalars['Int']>;
};

export type ProfessionSumOrderByAggregateInput = {
  couponId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type ProfessionUncheckedCreateInput = {
  Education?: InputMaybe<EducationUncheckedCreateNestedManyWithoutProfessionInput>;
  Events?: InputMaybe<EventUncheckedCreateNestedManyWithoutTargetedAudiencesInput>;
  Specialties?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutProfessionInput>;
  couponId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  pricingPlans?: InputMaybe<PricingPlanSpecialtyPriceUncheckedCreateNestedManyWithoutProfessionsInput>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn: Scalars['String'];
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTargetedAudiencesInput>;
  users?: InputMaybe<UserUncheckedCreateNestedManyWithoutProfessionInput>;
};

export type ProfessionUncheckedCreateNestedManyWithoutCouponInput = {
  connect?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ProfessionCreateOrConnectWithoutCouponInput>>>;
  create?: InputMaybe<Array<InputMaybe<ProfessionCreateWithoutCouponInput>>>;
  createMany?: InputMaybe<ProfessionCreateManyCouponInputEnvelope>;
};

export type ProfessionUncheckedCreateNestedManyWithoutEventsInput = {
  connect?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ProfessionCreateOrConnectWithoutEventsInput>>>;
  create?: InputMaybe<Array<InputMaybe<ProfessionCreateWithoutEventsInput>>>;
};

export type ProfessionUncheckedCreateNestedManyWithoutPricingPlansInput = {
  connect?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ProfessionCreateOrConnectWithoutPricingPlansInput>>>;
  create?: InputMaybe<Array<InputMaybe<ProfessionCreateWithoutPricingPlansInput>>>;
};

export type ProfessionUncheckedCreateNestedManyWithoutTrainerEventsInput = {
  connect?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ProfessionCreateOrConnectWithoutTrainerEventsInput>>>;
  create?: InputMaybe<Array<InputMaybe<ProfessionCreateWithoutTrainerEventsInput>>>;
};

export type ProfessionUncheckedCreateWithoutCouponInput = {
  Education?: InputMaybe<EducationUncheckedCreateNestedManyWithoutProfessionInput>;
  Events?: InputMaybe<EventUncheckedCreateNestedManyWithoutTargetedAudiencesInput>;
  Specialties?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutProfessionInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  pricingPlans?: InputMaybe<PricingPlanSpecialtyPriceUncheckedCreateNestedManyWithoutProfessionsInput>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn: Scalars['String'];
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTargetedAudiencesInput>;
  users?: InputMaybe<UserUncheckedCreateNestedManyWithoutProfessionInput>;
};

export type ProfessionUncheckedCreateWithoutEducationInput = {
  Events?: InputMaybe<EventUncheckedCreateNestedManyWithoutTargetedAudiencesInput>;
  Specialties?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutProfessionInput>;
  couponId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  pricingPlans?: InputMaybe<PricingPlanSpecialtyPriceUncheckedCreateNestedManyWithoutProfessionsInput>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn: Scalars['String'];
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTargetedAudiencesInput>;
  users?: InputMaybe<UserUncheckedCreateNestedManyWithoutProfessionInput>;
};

export type ProfessionUncheckedCreateWithoutEventsInput = {
  Education?: InputMaybe<EducationUncheckedCreateNestedManyWithoutProfessionInput>;
  Specialties?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutProfessionInput>;
  couponId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  pricingPlans?: InputMaybe<PricingPlanSpecialtyPriceUncheckedCreateNestedManyWithoutProfessionsInput>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn: Scalars['String'];
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTargetedAudiencesInput>;
  users?: InputMaybe<UserUncheckedCreateNestedManyWithoutProfessionInput>;
};

export type ProfessionUncheckedCreateWithoutPricingPlansInput = {
  Education?: InputMaybe<EducationUncheckedCreateNestedManyWithoutProfessionInput>;
  Events?: InputMaybe<EventUncheckedCreateNestedManyWithoutTargetedAudiencesInput>;
  Specialties?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutProfessionInput>;
  couponId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn: Scalars['String'];
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTargetedAudiencesInput>;
  users?: InputMaybe<UserUncheckedCreateNestedManyWithoutProfessionInput>;
};

export type ProfessionUncheckedCreateWithoutSpecialtiesInput = {
  Education?: InputMaybe<EducationUncheckedCreateNestedManyWithoutProfessionInput>;
  Events?: InputMaybe<EventUncheckedCreateNestedManyWithoutTargetedAudiencesInput>;
  couponId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  pricingPlans?: InputMaybe<PricingPlanSpecialtyPriceUncheckedCreateNestedManyWithoutProfessionsInput>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn: Scalars['String'];
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTargetedAudiencesInput>;
  users?: InputMaybe<UserUncheckedCreateNestedManyWithoutProfessionInput>;
};

export type ProfessionUncheckedCreateWithoutTrainerEventsInput = {
  Education?: InputMaybe<EducationUncheckedCreateNestedManyWithoutProfessionInput>;
  Events?: InputMaybe<EventUncheckedCreateNestedManyWithoutTargetedAudiencesInput>;
  Specialties?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutProfessionInput>;
  couponId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  pricingPlans?: InputMaybe<PricingPlanSpecialtyPriceUncheckedCreateNestedManyWithoutProfessionsInput>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn: Scalars['String'];
  users?: InputMaybe<UserUncheckedCreateNestedManyWithoutProfessionInput>;
};

export type ProfessionUncheckedCreateWithoutUsersInput = {
  Education?: InputMaybe<EducationUncheckedCreateNestedManyWithoutProfessionInput>;
  Events?: InputMaybe<EventUncheckedCreateNestedManyWithoutTargetedAudiencesInput>;
  Specialties?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutProfessionInput>;
  couponId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  pricingPlans?: InputMaybe<PricingPlanSpecialtyPriceUncheckedCreateNestedManyWithoutProfessionsInput>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn: Scalars['String'];
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTargetedAudiencesInput>;
};

export type ProfessionUncheckedUpdateInput = {
  Education?: InputMaybe<EducationUncheckedUpdateManyWithoutProfessionInput>;
  Events?: InputMaybe<EventUncheckedUpdateManyWithoutTargetedAudiencesInput>;
  Specialties?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutProfessionInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  pricingPlans?: InputMaybe<PricingPlanSpecialtyPriceUncheckedUpdateManyWithoutProfessionsInput>;
  sortOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTargetedAudiencesInput>;
  users?: InputMaybe<UserUncheckedUpdateManyWithoutProfessionInput>;
};

export type ProfessionUncheckedUpdateManyInput = {
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProfessionUncheckedUpdateManyWithoutCouponInput = {
  connect?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ProfessionCreateOrConnectWithoutCouponInput>>>;
  create?: InputMaybe<Array<InputMaybe<ProfessionCreateWithoutCouponInput>>>;
  createMany?: InputMaybe<ProfessionCreateManyCouponInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ProfessionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ProfessionUpdateWithWhereUniqueWithoutCouponInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ProfessionUpdateManyWithWhereWithoutCouponInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ProfessionUpsertWithWhereUniqueWithoutCouponInput>>>;
};

export type ProfessionUncheckedUpdateManyWithoutEventsInput = {
  connect?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ProfessionCreateOrConnectWithoutEventsInput>>>;
  create?: InputMaybe<Array<InputMaybe<ProfessionCreateWithoutEventsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ProfessionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ProfessionUpdateWithWhereUniqueWithoutEventsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ProfessionUpdateManyWithWhereWithoutEventsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ProfessionUpsertWithWhereUniqueWithoutEventsInput>>>;
};

export type ProfessionUncheckedUpdateManyWithoutPricingPlansInput = {
  connect?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ProfessionCreateOrConnectWithoutPricingPlansInput>>>;
  create?: InputMaybe<Array<InputMaybe<ProfessionCreateWithoutPricingPlansInput>>>;
  delete?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ProfessionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ProfessionUpdateWithWhereUniqueWithoutPricingPlansInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ProfessionUpdateManyWithWhereWithoutPricingPlansInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ProfessionUpsertWithWhereUniqueWithoutPricingPlansInput>>>;
};

export type ProfessionUncheckedUpdateManyWithoutProfessionsInput = {
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProfessionUncheckedUpdateManyWithoutTargetedAudiencesInput = {
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProfessionUncheckedUpdateManyWithoutTrainerEventsInput = {
  connect?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ProfessionCreateOrConnectWithoutTrainerEventsInput>>>;
  create?: InputMaybe<Array<InputMaybe<ProfessionCreateWithoutTrainerEventsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ProfessionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ProfessionUpdateWithWhereUniqueWithoutTrainerEventsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ProfessionUpdateManyWithWhereWithoutTrainerEventsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ProfessionUpsertWithWhereUniqueWithoutTrainerEventsInput>>>;
};

export type ProfessionUncheckedUpdateWithoutCouponInput = {
  Education?: InputMaybe<EducationUncheckedUpdateManyWithoutProfessionInput>;
  Events?: InputMaybe<EventUncheckedUpdateManyWithoutTargetedAudiencesInput>;
  Specialties?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutProfessionInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  pricingPlans?: InputMaybe<PricingPlanSpecialtyPriceUncheckedUpdateManyWithoutProfessionsInput>;
  sortOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTargetedAudiencesInput>;
  users?: InputMaybe<UserUncheckedUpdateManyWithoutProfessionInput>;
};

export type ProfessionUncheckedUpdateWithoutEducationInput = {
  Events?: InputMaybe<EventUncheckedUpdateManyWithoutTargetedAudiencesInput>;
  Specialties?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutProfessionInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  pricingPlans?: InputMaybe<PricingPlanSpecialtyPriceUncheckedUpdateManyWithoutProfessionsInput>;
  sortOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTargetedAudiencesInput>;
  users?: InputMaybe<UserUncheckedUpdateManyWithoutProfessionInput>;
};

export type ProfessionUncheckedUpdateWithoutEventsInput = {
  Education?: InputMaybe<EducationUncheckedUpdateManyWithoutProfessionInput>;
  Specialties?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutProfessionInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  pricingPlans?: InputMaybe<PricingPlanSpecialtyPriceUncheckedUpdateManyWithoutProfessionsInput>;
  sortOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTargetedAudiencesInput>;
  users?: InputMaybe<UserUncheckedUpdateManyWithoutProfessionInput>;
};

export type ProfessionUncheckedUpdateWithoutPricingPlansInput = {
  Education?: InputMaybe<EducationUncheckedUpdateManyWithoutProfessionInput>;
  Events?: InputMaybe<EventUncheckedUpdateManyWithoutTargetedAudiencesInput>;
  Specialties?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutProfessionInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTargetedAudiencesInput>;
  users?: InputMaybe<UserUncheckedUpdateManyWithoutProfessionInput>;
};

export type ProfessionUncheckedUpdateWithoutSpecialtiesInput = {
  Education?: InputMaybe<EducationUncheckedUpdateManyWithoutProfessionInput>;
  Events?: InputMaybe<EventUncheckedUpdateManyWithoutTargetedAudiencesInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  pricingPlans?: InputMaybe<PricingPlanSpecialtyPriceUncheckedUpdateManyWithoutProfessionsInput>;
  sortOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTargetedAudiencesInput>;
  users?: InputMaybe<UserUncheckedUpdateManyWithoutProfessionInput>;
};

export type ProfessionUncheckedUpdateWithoutTrainerEventsInput = {
  Education?: InputMaybe<EducationUncheckedUpdateManyWithoutProfessionInput>;
  Events?: InputMaybe<EventUncheckedUpdateManyWithoutTargetedAudiencesInput>;
  Specialties?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutProfessionInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  pricingPlans?: InputMaybe<PricingPlanSpecialtyPriceUncheckedUpdateManyWithoutProfessionsInput>;
  sortOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUncheckedUpdateManyWithoutProfessionInput>;
};

export type ProfessionUncheckedUpdateWithoutUsersInput = {
  Education?: InputMaybe<EducationUncheckedUpdateManyWithoutProfessionInput>;
  Events?: InputMaybe<EventUncheckedUpdateManyWithoutTargetedAudiencesInput>;
  Specialties?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutProfessionInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  pricingPlans?: InputMaybe<PricingPlanSpecialtyPriceUncheckedUpdateManyWithoutProfessionsInput>;
  sortOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTargetedAudiencesInput>;
};

export type ProfessionUpdateInput = {
  Coupon?: InputMaybe<CouponUpdateOneWithoutProfessionsInput>;
  Education?: InputMaybe<EducationUpdateManyWithoutProfessionInput>;
  Events?: InputMaybe<EventUpdateManyWithoutTargetedAudiencesInput>;
  Specialties?: InputMaybe<SpecialtyUpdateManyWithoutProfessionInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  pricingPlans?: InputMaybe<PricingPlanSpecialtyPriceUpdateManyWithoutProfessionsInput>;
  sortOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTargetedAudiencesInput>;
  users?: InputMaybe<UserUpdateManyWithoutProfessionInput>;
};

export type ProfessionUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProfessionUpdateManyWithWhereWithoutCouponInput = {
  data: ProfessionUncheckedUpdateManyWithoutProfessionsInput;
  where: ProfessionScalarWhereInput;
};

export type ProfessionUpdateManyWithWhereWithoutEventsInput = {
  data: ProfessionUncheckedUpdateManyWithoutTargetedAudiencesInput;
  where: ProfessionScalarWhereInput;
};

export type ProfessionUpdateManyWithWhereWithoutPricingPlansInput = {
  data: ProfessionUncheckedUpdateManyWithoutProfessionsInput;
  where: ProfessionScalarWhereInput;
};

export type ProfessionUpdateManyWithWhereWithoutTrainerEventsInput = {
  data: ProfessionUncheckedUpdateManyWithoutTargetedAudiencesInput;
  where: ProfessionScalarWhereInput;
};

export type ProfessionUpdateManyWithoutCouponInput = {
  connect?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ProfessionCreateOrConnectWithoutCouponInput>>>;
  create?: InputMaybe<Array<InputMaybe<ProfessionCreateWithoutCouponInput>>>;
  createMany?: InputMaybe<ProfessionCreateManyCouponInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ProfessionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ProfessionUpdateWithWhereUniqueWithoutCouponInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ProfessionUpdateManyWithWhereWithoutCouponInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ProfessionUpsertWithWhereUniqueWithoutCouponInput>>>;
};

export type ProfessionUpdateManyWithoutEventsInput = {
  connect?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ProfessionCreateOrConnectWithoutEventsInput>>>;
  create?: InputMaybe<Array<InputMaybe<ProfessionCreateWithoutEventsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ProfessionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ProfessionUpdateWithWhereUniqueWithoutEventsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ProfessionUpdateManyWithWhereWithoutEventsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ProfessionUpsertWithWhereUniqueWithoutEventsInput>>>;
};

export type ProfessionUpdateManyWithoutPricingPlansInput = {
  connect?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ProfessionCreateOrConnectWithoutPricingPlansInput>>>;
  create?: InputMaybe<Array<InputMaybe<ProfessionCreateWithoutPricingPlansInput>>>;
  delete?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ProfessionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ProfessionUpdateWithWhereUniqueWithoutPricingPlansInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ProfessionUpdateManyWithWhereWithoutPricingPlansInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ProfessionUpsertWithWhereUniqueWithoutPricingPlansInput>>>;
};

export type ProfessionUpdateManyWithoutTrainerEventsInput = {
  connect?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ProfessionCreateOrConnectWithoutTrainerEventsInput>>>;
  create?: InputMaybe<Array<InputMaybe<ProfessionCreateWithoutTrainerEventsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ProfessionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ProfessionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ProfessionUpdateWithWhereUniqueWithoutTrainerEventsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ProfessionUpdateManyWithWhereWithoutTrainerEventsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ProfessionUpsertWithWhereUniqueWithoutTrainerEventsInput>>>;
};

export type ProfessionUpdateOneRequiredWithoutSpecialtiesInput = {
  connect?: InputMaybe<ProfessionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfessionCreateOrConnectWithoutSpecialtiesInput>;
  create?: InputMaybe<ProfessionUncheckedCreateWithoutSpecialtiesInput>;
  update?: InputMaybe<ProfessionUncheckedUpdateWithoutSpecialtiesInput>;
  upsert?: InputMaybe<ProfessionUpsertWithoutSpecialtiesInput>;
};

export type ProfessionUpdateOneWithoutEducationInput = {
  connect?: InputMaybe<ProfessionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfessionCreateOrConnectWithoutEducationInput>;
  create?: InputMaybe<ProfessionUncheckedCreateWithoutEducationInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<ProfessionUncheckedUpdateWithoutEducationInput>;
  upsert?: InputMaybe<ProfessionUpsertWithoutEducationInput>;
};

export type ProfessionUpdateOneWithoutUsersInput = {
  connect?: InputMaybe<ProfessionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfessionCreateOrConnectWithoutUsersInput>;
  create?: InputMaybe<ProfessionUncheckedCreateWithoutUsersInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<ProfessionUncheckedUpdateWithoutUsersInput>;
  upsert?: InputMaybe<ProfessionUpsertWithoutUsersInput>;
};

export type ProfessionUpdateWithWhereUniqueWithoutCouponInput = {
  data: ProfessionUncheckedUpdateWithoutCouponInput;
  where: ProfessionWhereUniqueInput;
};

export type ProfessionUpdateWithWhereUniqueWithoutEventsInput = {
  data: ProfessionUncheckedUpdateWithoutEventsInput;
  where: ProfessionWhereUniqueInput;
};

export type ProfessionUpdateWithWhereUniqueWithoutPricingPlansInput = {
  data: ProfessionUncheckedUpdateWithoutPricingPlansInput;
  where: ProfessionWhereUniqueInput;
};

export type ProfessionUpdateWithWhereUniqueWithoutTrainerEventsInput = {
  data: ProfessionUncheckedUpdateWithoutTrainerEventsInput;
  where: ProfessionWhereUniqueInput;
};

export type ProfessionUpdateWithoutCouponInput = {
  Education?: InputMaybe<EducationUpdateManyWithoutProfessionInput>;
  Events?: InputMaybe<EventUpdateManyWithoutTargetedAudiencesInput>;
  Specialties?: InputMaybe<SpecialtyUpdateManyWithoutProfessionInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  pricingPlans?: InputMaybe<PricingPlanSpecialtyPriceUpdateManyWithoutProfessionsInput>;
  sortOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTargetedAudiencesInput>;
  users?: InputMaybe<UserUpdateManyWithoutProfessionInput>;
};

export type ProfessionUpdateWithoutEducationInput = {
  Coupon?: InputMaybe<CouponUpdateOneWithoutProfessionsInput>;
  Events?: InputMaybe<EventUpdateManyWithoutTargetedAudiencesInput>;
  Specialties?: InputMaybe<SpecialtyUpdateManyWithoutProfessionInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  pricingPlans?: InputMaybe<PricingPlanSpecialtyPriceUpdateManyWithoutProfessionsInput>;
  sortOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTargetedAudiencesInput>;
  users?: InputMaybe<UserUpdateManyWithoutProfessionInput>;
};

export type ProfessionUpdateWithoutEventsInput = {
  Coupon?: InputMaybe<CouponUpdateOneWithoutProfessionsInput>;
  Education?: InputMaybe<EducationUpdateManyWithoutProfessionInput>;
  Specialties?: InputMaybe<SpecialtyUpdateManyWithoutProfessionInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  pricingPlans?: InputMaybe<PricingPlanSpecialtyPriceUpdateManyWithoutProfessionsInput>;
  sortOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTargetedAudiencesInput>;
  users?: InputMaybe<UserUpdateManyWithoutProfessionInput>;
};

export type ProfessionUpdateWithoutPricingPlansInput = {
  Coupon?: InputMaybe<CouponUpdateOneWithoutProfessionsInput>;
  Education?: InputMaybe<EducationUpdateManyWithoutProfessionInput>;
  Events?: InputMaybe<EventUpdateManyWithoutTargetedAudiencesInput>;
  Specialties?: InputMaybe<SpecialtyUpdateManyWithoutProfessionInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sortOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTargetedAudiencesInput>;
  users?: InputMaybe<UserUpdateManyWithoutProfessionInput>;
};

export type ProfessionUpdateWithoutSpecialtiesInput = {
  Coupon?: InputMaybe<CouponUpdateOneWithoutProfessionsInput>;
  Education?: InputMaybe<EducationUpdateManyWithoutProfessionInput>;
  Events?: InputMaybe<EventUpdateManyWithoutTargetedAudiencesInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  pricingPlans?: InputMaybe<PricingPlanSpecialtyPriceUpdateManyWithoutProfessionsInput>;
  sortOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTargetedAudiencesInput>;
  users?: InputMaybe<UserUpdateManyWithoutProfessionInput>;
};

export type ProfessionUpdateWithoutTrainerEventsInput = {
  Coupon?: InputMaybe<CouponUpdateOneWithoutProfessionsInput>;
  Education?: InputMaybe<EducationUpdateManyWithoutProfessionInput>;
  Events?: InputMaybe<EventUpdateManyWithoutTargetedAudiencesInput>;
  Specialties?: InputMaybe<SpecialtyUpdateManyWithoutProfessionInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  pricingPlans?: InputMaybe<PricingPlanSpecialtyPriceUpdateManyWithoutProfessionsInput>;
  sortOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUpdateManyWithoutProfessionInput>;
};

export type ProfessionUpdateWithoutUsersInput = {
  Coupon?: InputMaybe<CouponUpdateOneWithoutProfessionsInput>;
  Education?: InputMaybe<EducationUpdateManyWithoutProfessionInput>;
  Events?: InputMaybe<EventUpdateManyWithoutTargetedAudiencesInput>;
  Specialties?: InputMaybe<SpecialtyUpdateManyWithoutProfessionInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  pricingPlans?: InputMaybe<PricingPlanSpecialtyPriceUpdateManyWithoutProfessionsInput>;
  sortOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTargetedAudiencesInput>;
};

export type ProfessionUpsertWithWhereUniqueWithoutCouponInput = {
  create: ProfessionUncheckedCreateWithoutCouponInput;
  update: ProfessionUncheckedUpdateWithoutCouponInput;
  where: ProfessionWhereUniqueInput;
};

export type ProfessionUpsertWithWhereUniqueWithoutEventsInput = {
  create: ProfessionUncheckedCreateWithoutEventsInput;
  update: ProfessionUncheckedUpdateWithoutEventsInput;
  where: ProfessionWhereUniqueInput;
};

export type ProfessionUpsertWithWhereUniqueWithoutPricingPlansInput = {
  create: ProfessionUncheckedCreateWithoutPricingPlansInput;
  update: ProfessionUncheckedUpdateWithoutPricingPlansInput;
  where: ProfessionWhereUniqueInput;
};

export type ProfessionUpsertWithWhereUniqueWithoutTrainerEventsInput = {
  create: ProfessionUncheckedCreateWithoutTrainerEventsInput;
  update: ProfessionUncheckedUpdateWithoutTrainerEventsInput;
  where: ProfessionWhereUniqueInput;
};

export type ProfessionUpsertWithoutEducationInput = {
  create: ProfessionUncheckedCreateWithoutEducationInput;
  update: ProfessionUncheckedUpdateWithoutEducationInput;
};

export type ProfessionUpsertWithoutSpecialtiesInput = {
  create: ProfessionUncheckedCreateWithoutSpecialtiesInput;
  update: ProfessionUncheckedUpdateWithoutSpecialtiesInput;
};

export type ProfessionUpsertWithoutUsersInput = {
  create: ProfessionUncheckedCreateWithoutUsersInput;
  update: ProfessionUncheckedUpdateWithoutUsersInput;
};

export type ProfessionWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ProfessionWhereInput>>>;
  Coupon?: InputMaybe<CouponWhereInput>;
  Education?: InputMaybe<EducationListRelationFilter>;
  Events?: InputMaybe<EventListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<ProfessionWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ProfessionWhereInput>>>;
  Specialties?: InputMaybe<SpecialtyListRelationFilter>;
  couponId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  pricingPlans?: InputMaybe<PricingPlanSpecialtyPriceListRelationFilter>;
  sortOrder?: InputMaybe<IntNullableFilter>;
  titleAr?: InputMaybe<StringNullableFilter>;
  titleEn?: InputMaybe<StringFilter>;
  trainerEvents?: InputMaybe<TrainerEventListRelationFilter>;
  users?: InputMaybe<UserListRelationFilter>;
};

export type ProfessionWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  titleEn?: InputMaybe<Scalars['String']>;
};

export type ProfessionalSkills = {
  __typename?: 'ProfessionalSkills';
  Cv?: Maybe<Cv>;
  academicRank?: Maybe<AcademicRank>;
  academicRankId?: Maybe<Scalars['Int']>;
  cvId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  natureOfWork?: Maybe<Scalars['String']>;
  placeOfWork?: Maybe<Scalars['String']>;
  type?: Maybe<ProfessionalSkillsType>;
  yearsOfExperience?: Maybe<Scalars['Int']>;
};

export type ProfessionalSkillsAvgAggregateOutputType = {
  __typename?: 'ProfessionalSkillsAvgAggregateOutputType';
  academicRankId?: Maybe<Scalars['Float']>;
  cvId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  yearsOfExperience?: Maybe<Scalars['Float']>;
};

export type ProfessionalSkillsAvgOrderByAggregateInput = {
  academicRankId?: InputMaybe<SortOrder>;
  cvId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  yearsOfExperience?: InputMaybe<SortOrder>;
};

export type ProfessionalSkillsCountAggregateOutputType = {
  __typename?: 'ProfessionalSkillsCountAggregateOutputType';
  _all: Scalars['Int'];
  academicRankId: Scalars['Int'];
  cvId: Scalars['Int'];
  id: Scalars['Int'];
  natureOfWork: Scalars['Int'];
  placeOfWork: Scalars['Int'];
  type: Scalars['Int'];
  yearsOfExperience: Scalars['Int'];
};

export type ProfessionalSkillsCountOrderByAggregateInput = {
  academicRankId?: InputMaybe<SortOrder>;
  cvId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  natureOfWork?: InputMaybe<SortOrder>;
  placeOfWork?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  yearsOfExperience?: InputMaybe<SortOrder>;
};

export type ProfessionalSkillsCreateInput = {
  Cv?: InputMaybe<CvCreateNestedOneWithoutProfessionalSkillsInput>;
  academicRank?: InputMaybe<AcademicRankCreateNestedOneWithoutProfessionalSkillsInput>;
  natureOfWork?: InputMaybe<Scalars['String']>;
  placeOfWork?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ProfessionalSkillsType>;
  yearsOfExperience?: InputMaybe<Scalars['Int']>;
};

export type ProfessionalSkillsCreateManyAcademicRankInput = {
  cvId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  natureOfWork?: InputMaybe<Scalars['String']>;
  placeOfWork?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ProfessionalSkillsType>;
  yearsOfExperience?: InputMaybe<Scalars['Int']>;
};

export type ProfessionalSkillsCreateManyAcademicRankInputEnvelope = {
  data: ProfessionalSkillsCreateManyAcademicRankInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ProfessionalSkillsCreateManyCvInput = {
  academicRankId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  natureOfWork?: InputMaybe<Scalars['String']>;
  placeOfWork?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ProfessionalSkillsType>;
  yearsOfExperience?: InputMaybe<Scalars['Int']>;
};

export type ProfessionalSkillsCreateManyCvInputEnvelope = {
  data: ProfessionalSkillsCreateManyCvInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ProfessionalSkillsCreateManyInput = {
  academicRankId?: InputMaybe<Scalars['Int']>;
  cvId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  natureOfWork?: InputMaybe<Scalars['String']>;
  placeOfWork?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ProfessionalSkillsType>;
  yearsOfExperience?: InputMaybe<Scalars['Int']>;
};

export type ProfessionalSkillsCreateNestedManyWithoutAcademicRankInput = {
  connect?: InputMaybe<Array<InputMaybe<ProfessionalSkillsWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ProfessionalSkillsCreateOrConnectWithoutAcademicRankInput>>>;
  create?: InputMaybe<Array<InputMaybe<ProfessionalSkillsCreateWithoutAcademicRankInput>>>;
  createMany?: InputMaybe<ProfessionalSkillsCreateManyAcademicRankInputEnvelope>;
};

export type ProfessionalSkillsCreateNestedManyWithoutCvInput = {
  connect?: InputMaybe<Array<InputMaybe<ProfessionalSkillsWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ProfessionalSkillsCreateOrConnectWithoutCvInput>>>;
  create?: InputMaybe<Array<InputMaybe<ProfessionalSkillsCreateWithoutCvInput>>>;
  createMany?: InputMaybe<ProfessionalSkillsCreateManyCvInputEnvelope>;
};

export type ProfessionalSkillsCreateOrConnectWithoutAcademicRankInput = {
  create: ProfessionalSkillsUncheckedCreateWithoutAcademicRankInput;
  where: ProfessionalSkillsWhereUniqueInput;
};

export type ProfessionalSkillsCreateOrConnectWithoutCvInput = {
  create: ProfessionalSkillsUncheckedCreateWithoutCvInput;
  where: ProfessionalSkillsWhereUniqueInput;
};

export type ProfessionalSkillsCreateWithoutAcademicRankInput = {
  Cv?: InputMaybe<CvCreateNestedOneWithoutProfessionalSkillsInput>;
  natureOfWork?: InputMaybe<Scalars['String']>;
  placeOfWork?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ProfessionalSkillsType>;
  yearsOfExperience?: InputMaybe<Scalars['Int']>;
};

export type ProfessionalSkillsCreateWithoutCvInput = {
  academicRank?: InputMaybe<AcademicRankCreateNestedOneWithoutProfessionalSkillsInput>;
  natureOfWork?: InputMaybe<Scalars['String']>;
  placeOfWork?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ProfessionalSkillsType>;
  yearsOfExperience?: InputMaybe<Scalars['Int']>;
};

export type ProfessionalSkillsListRelationFilter = {
  every?: InputMaybe<ProfessionalSkillsWhereInput>;
  none?: InputMaybe<ProfessionalSkillsWhereInput>;
  some?: InputMaybe<ProfessionalSkillsWhereInput>;
};

export type ProfessionalSkillsMaxAggregateOutputType = {
  __typename?: 'ProfessionalSkillsMaxAggregateOutputType';
  academicRankId?: Maybe<Scalars['Int']>;
  cvId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  natureOfWork?: Maybe<Scalars['String']>;
  placeOfWork?: Maybe<Scalars['String']>;
  type?: Maybe<ProfessionalSkillsType>;
  yearsOfExperience?: Maybe<Scalars['Int']>;
};

export type ProfessionalSkillsMaxOrderByAggregateInput = {
  academicRankId?: InputMaybe<SortOrder>;
  cvId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  natureOfWork?: InputMaybe<SortOrder>;
  placeOfWork?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  yearsOfExperience?: InputMaybe<SortOrder>;
};

export type ProfessionalSkillsMinAggregateOutputType = {
  __typename?: 'ProfessionalSkillsMinAggregateOutputType';
  academicRankId?: Maybe<Scalars['Int']>;
  cvId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  natureOfWork?: Maybe<Scalars['String']>;
  placeOfWork?: Maybe<Scalars['String']>;
  type?: Maybe<ProfessionalSkillsType>;
  yearsOfExperience?: Maybe<Scalars['Int']>;
};

export type ProfessionalSkillsMinOrderByAggregateInput = {
  academicRankId?: InputMaybe<SortOrder>;
  cvId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  natureOfWork?: InputMaybe<SortOrder>;
  placeOfWork?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  yearsOfExperience?: InputMaybe<SortOrder>;
};

export type ProfessionalSkillsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProfessionalSkillsOrderByWithAggregationInput = {
  _avg?: InputMaybe<ProfessionalSkillsAvgOrderByAggregateInput>;
  _count?: InputMaybe<ProfessionalSkillsCountOrderByAggregateInput>;
  _max?: InputMaybe<ProfessionalSkillsMaxOrderByAggregateInput>;
  _min?: InputMaybe<ProfessionalSkillsMinOrderByAggregateInput>;
  _sum?: InputMaybe<ProfessionalSkillsSumOrderByAggregateInput>;
  academicRankId?: InputMaybe<SortOrder>;
  cvId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  natureOfWork?: InputMaybe<SortOrder>;
  placeOfWork?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  yearsOfExperience?: InputMaybe<SortOrder>;
};

export type ProfessionalSkillsOrderByWithRelationInput = {
  Cv?: InputMaybe<CvOrderByWithRelationInput>;
  academicRank?: InputMaybe<AcademicRankOrderByWithRelationInput>;
  academicRankId?: InputMaybe<SortOrder>;
  cvId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  natureOfWork?: InputMaybe<SortOrder>;
  placeOfWork?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  yearsOfExperience?: InputMaybe<SortOrder>;
};

export enum ProfessionalSkillsScalarFieldEnum {
  AcademicRankId = 'academicRankId',
  CvId = 'cvId',
  Id = 'id',
  NatureOfWork = 'natureOfWork',
  PlaceOfWork = 'placeOfWork',
  Type = 'type',
  YearsOfExperience = 'yearsOfExperience'
}

export type ProfessionalSkillsScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ProfessionalSkillsScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ProfessionalSkillsScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ProfessionalSkillsScalarWhereInput>>>;
  academicRankId?: InputMaybe<IntNullableFilter>;
  cvId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  natureOfWork?: InputMaybe<StringNullableFilter>;
  placeOfWork?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumProfessionalSkillsTypeNullableFilter>;
  yearsOfExperience?: InputMaybe<IntNullableFilter>;
};

export type ProfessionalSkillsScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<ProfessionalSkillsScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ProfessionalSkillsScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ProfessionalSkillsScalarWhereWithAggregatesInput>>>;
  academicRankId?: InputMaybe<IntNullableWithAggregatesFilter>;
  cvId?: InputMaybe<IntNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  natureOfWork?: InputMaybe<StringNullableWithAggregatesFilter>;
  placeOfWork?: InputMaybe<StringNullableWithAggregatesFilter>;
  type?: InputMaybe<EnumProfessionalSkillsTypeNullableWithAggregatesFilter>;
  yearsOfExperience?: InputMaybe<IntNullableWithAggregatesFilter>;
};

export type ProfessionalSkillsSumAggregateOutputType = {
  __typename?: 'ProfessionalSkillsSumAggregateOutputType';
  academicRankId?: Maybe<Scalars['Int']>;
  cvId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  yearsOfExperience?: Maybe<Scalars['Int']>;
};

export type ProfessionalSkillsSumOrderByAggregateInput = {
  academicRankId?: InputMaybe<SortOrder>;
  cvId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  yearsOfExperience?: InputMaybe<SortOrder>;
};

export enum ProfessionalSkillsType {
  Academic = 'academic',
  PracticalExperiance = 'practicalExperiance'
}

export type ProfessionalSkillsUncheckedCreateInput = {
  academicRankId?: InputMaybe<Scalars['Int']>;
  cvId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  natureOfWork?: InputMaybe<Scalars['String']>;
  placeOfWork?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ProfessionalSkillsType>;
  yearsOfExperience?: InputMaybe<Scalars['Int']>;
};

export type ProfessionalSkillsUncheckedCreateNestedManyWithoutAcademicRankInput = {
  connect?: InputMaybe<Array<InputMaybe<ProfessionalSkillsWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ProfessionalSkillsCreateOrConnectWithoutAcademicRankInput>>>;
  create?: InputMaybe<Array<InputMaybe<ProfessionalSkillsCreateWithoutAcademicRankInput>>>;
  createMany?: InputMaybe<ProfessionalSkillsCreateManyAcademicRankInputEnvelope>;
};

export type ProfessionalSkillsUncheckedCreateNestedManyWithoutCvInput = {
  connect?: InputMaybe<Array<InputMaybe<ProfessionalSkillsWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ProfessionalSkillsCreateOrConnectWithoutCvInput>>>;
  create?: InputMaybe<Array<InputMaybe<ProfessionalSkillsCreateWithoutCvInput>>>;
  createMany?: InputMaybe<ProfessionalSkillsCreateManyCvInputEnvelope>;
};

export type ProfessionalSkillsUncheckedCreateWithoutAcademicRankInput = {
  cvId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  natureOfWork?: InputMaybe<Scalars['String']>;
  placeOfWork?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ProfessionalSkillsType>;
  yearsOfExperience?: InputMaybe<Scalars['Int']>;
};

export type ProfessionalSkillsUncheckedCreateWithoutCvInput = {
  academicRankId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  natureOfWork?: InputMaybe<Scalars['String']>;
  placeOfWork?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ProfessionalSkillsType>;
  yearsOfExperience?: InputMaybe<Scalars['Int']>;
};

export type ProfessionalSkillsUncheckedUpdateInput = {
  academicRankId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  natureOfWork?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  placeOfWork?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumProfessionalSkillsTypeFieldUpdateOperationsInput>;
  yearsOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ProfessionalSkillsUncheckedUpdateManyInput = {
  academicRankId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  natureOfWork?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  placeOfWork?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumProfessionalSkillsTypeFieldUpdateOperationsInput>;
  yearsOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ProfessionalSkillsUncheckedUpdateManyWithoutAcademicRankInput = {
  connect?: InputMaybe<Array<InputMaybe<ProfessionalSkillsWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ProfessionalSkillsCreateOrConnectWithoutAcademicRankInput>>>;
  create?: InputMaybe<Array<InputMaybe<ProfessionalSkillsCreateWithoutAcademicRankInput>>>;
  createMany?: InputMaybe<ProfessionalSkillsCreateManyAcademicRankInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ProfessionalSkillsWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ProfessionalSkillsScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ProfessionalSkillsWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ProfessionalSkillsWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ProfessionalSkillsUpdateWithWhereUniqueWithoutAcademicRankInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ProfessionalSkillsUpdateManyWithWhereWithoutAcademicRankInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ProfessionalSkillsUpsertWithWhereUniqueWithoutAcademicRankInput>>>;
};

export type ProfessionalSkillsUncheckedUpdateManyWithoutCvInput = {
  connect?: InputMaybe<Array<InputMaybe<ProfessionalSkillsWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ProfessionalSkillsCreateOrConnectWithoutCvInput>>>;
  create?: InputMaybe<Array<InputMaybe<ProfessionalSkillsCreateWithoutCvInput>>>;
  createMany?: InputMaybe<ProfessionalSkillsCreateManyCvInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ProfessionalSkillsWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ProfessionalSkillsScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ProfessionalSkillsWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ProfessionalSkillsWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ProfessionalSkillsUpdateWithWhereUniqueWithoutCvInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ProfessionalSkillsUpdateManyWithWhereWithoutCvInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ProfessionalSkillsUpsertWithWhereUniqueWithoutCvInput>>>;
};

export type ProfessionalSkillsUncheckedUpdateManyWithoutProfessionalSkillsInput = {
  academicRankId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  natureOfWork?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  placeOfWork?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumProfessionalSkillsTypeFieldUpdateOperationsInput>;
  yearsOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ProfessionalSkillsUncheckedUpdateWithoutAcademicRankInput = {
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  natureOfWork?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  placeOfWork?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumProfessionalSkillsTypeFieldUpdateOperationsInput>;
  yearsOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ProfessionalSkillsUncheckedUpdateWithoutCvInput = {
  academicRankId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  natureOfWork?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  placeOfWork?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumProfessionalSkillsTypeFieldUpdateOperationsInput>;
  yearsOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ProfessionalSkillsUpdateInput = {
  Cv?: InputMaybe<CvUpdateOneWithoutProfessionalSkillsInput>;
  academicRank?: InputMaybe<AcademicRankUpdateOneWithoutProfessionalSkillsInput>;
  natureOfWork?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  placeOfWork?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumProfessionalSkillsTypeFieldUpdateOperationsInput>;
  yearsOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ProfessionalSkillsUpdateManyMutationInput = {
  natureOfWork?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  placeOfWork?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumProfessionalSkillsTypeFieldUpdateOperationsInput>;
  yearsOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ProfessionalSkillsUpdateManyWithWhereWithoutAcademicRankInput = {
  data: ProfessionalSkillsUncheckedUpdateManyWithoutProfessionalSkillsInput;
  where: ProfessionalSkillsScalarWhereInput;
};

export type ProfessionalSkillsUpdateManyWithWhereWithoutCvInput = {
  data: ProfessionalSkillsUncheckedUpdateManyWithoutProfessionalSkillsInput;
  where: ProfessionalSkillsScalarWhereInput;
};

export type ProfessionalSkillsUpdateManyWithoutAcademicRankInput = {
  connect?: InputMaybe<Array<InputMaybe<ProfessionalSkillsWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ProfessionalSkillsCreateOrConnectWithoutAcademicRankInput>>>;
  create?: InputMaybe<Array<InputMaybe<ProfessionalSkillsCreateWithoutAcademicRankInput>>>;
  createMany?: InputMaybe<ProfessionalSkillsCreateManyAcademicRankInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ProfessionalSkillsWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ProfessionalSkillsScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ProfessionalSkillsWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ProfessionalSkillsWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ProfessionalSkillsUpdateWithWhereUniqueWithoutAcademicRankInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ProfessionalSkillsUpdateManyWithWhereWithoutAcademicRankInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ProfessionalSkillsUpsertWithWhereUniqueWithoutAcademicRankInput>>>;
};

export type ProfessionalSkillsUpdateManyWithoutCvInput = {
  connect?: InputMaybe<Array<InputMaybe<ProfessionalSkillsWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ProfessionalSkillsCreateOrConnectWithoutCvInput>>>;
  create?: InputMaybe<Array<InputMaybe<ProfessionalSkillsCreateWithoutCvInput>>>;
  createMany?: InputMaybe<ProfessionalSkillsCreateManyCvInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ProfessionalSkillsWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ProfessionalSkillsScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ProfessionalSkillsWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ProfessionalSkillsWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ProfessionalSkillsUpdateWithWhereUniqueWithoutCvInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ProfessionalSkillsUpdateManyWithWhereWithoutCvInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ProfessionalSkillsUpsertWithWhereUniqueWithoutCvInput>>>;
};

export type ProfessionalSkillsUpdateWithWhereUniqueWithoutAcademicRankInput = {
  data: ProfessionalSkillsUncheckedUpdateWithoutAcademicRankInput;
  where: ProfessionalSkillsWhereUniqueInput;
};

export type ProfessionalSkillsUpdateWithWhereUniqueWithoutCvInput = {
  data: ProfessionalSkillsUncheckedUpdateWithoutCvInput;
  where: ProfessionalSkillsWhereUniqueInput;
};

export type ProfessionalSkillsUpdateWithoutAcademicRankInput = {
  Cv?: InputMaybe<CvUpdateOneWithoutProfessionalSkillsInput>;
  natureOfWork?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  placeOfWork?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumProfessionalSkillsTypeFieldUpdateOperationsInput>;
  yearsOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ProfessionalSkillsUpdateWithoutCvInput = {
  academicRank?: InputMaybe<AcademicRankUpdateOneWithoutProfessionalSkillsInput>;
  natureOfWork?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  placeOfWork?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumProfessionalSkillsTypeFieldUpdateOperationsInput>;
  yearsOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ProfessionalSkillsUpsertWithWhereUniqueWithoutAcademicRankInput = {
  create: ProfessionalSkillsUncheckedCreateWithoutAcademicRankInput;
  update: ProfessionalSkillsUncheckedUpdateWithoutAcademicRankInput;
  where: ProfessionalSkillsWhereUniqueInput;
};

export type ProfessionalSkillsUpsertWithWhereUniqueWithoutCvInput = {
  create: ProfessionalSkillsUncheckedCreateWithoutCvInput;
  update: ProfessionalSkillsUncheckedUpdateWithoutCvInput;
  where: ProfessionalSkillsWhereUniqueInput;
};

export type ProfessionalSkillsWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ProfessionalSkillsWhereInput>>>;
  Cv?: InputMaybe<CvWhereInput>;
  NOT?: InputMaybe<Array<InputMaybe<ProfessionalSkillsWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ProfessionalSkillsWhereInput>>>;
  academicRank?: InputMaybe<AcademicRankWhereInput>;
  academicRankId?: InputMaybe<IntNullableFilter>;
  cvId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  natureOfWork?: InputMaybe<StringNullableFilter>;
  placeOfWork?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumProfessionalSkillsTypeNullableFilter>;
  yearsOfExperience?: InputMaybe<IntNullableFilter>;
};

export type ProfessionalSkillsWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type ProvidedByCoulmn = {
  __typename?: 'ProvidedByCoulmn';
  isContentProvidedByAcademy?: Maybe<Scalars['Boolean']>;
  month?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

export type Qualification = {
  __typename?: 'Qualification';
  Cv: Array<Cv>;
  Education: Array<Education>;
  _count: QualificationCountOutputType;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  title: Scalars['String'];
};


export type QualificationCvArgs = {
  cursor?: InputMaybe<CvWhereUniqueInput>;
  distinct?: InputMaybe<CvScalarFieldEnum>;
  orderBy?: InputMaybe<CvOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CvWhereInput>;
};


export type QualificationEducationArgs = {
  cursor?: InputMaybe<EducationWhereUniqueInput>;
  distinct?: InputMaybe<EducationScalarFieldEnum>;
  orderBy?: InputMaybe<EducationOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EducationWhereInput>;
};

export type QualificationAvgAggregateOutputType = {
  __typename?: 'QualificationAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
};

export type QualificationAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type QualificationCountAggregateOutputType = {
  __typename?: 'QualificationCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  title: Scalars['Int'];
};

export type QualificationCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type QualificationCountOutputType = {
  __typename?: 'QualificationCountOutputType';
  Cv: Scalars['Int'];
  Education: Scalars['Int'];
  User: Scalars['Int'];
};

export type QualificationCreateInput = {
  Cv?: InputMaybe<CvCreateNestedManyWithoutQualificationInput>;
  Education?: InputMaybe<EducationCreateNestedManyWithoutQualificationInput>;
  User?: InputMaybe<UserCreateNestedManyWithoutQualificationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
};

export type QualificationCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type QualificationCreateNestedOneWithoutCvInput = {
  connect?: InputMaybe<QualificationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QualificationCreateOrConnectWithoutCvInput>;
  create?: InputMaybe<QualificationUncheckedCreateWithoutCvInput>;
};

export type QualificationCreateNestedOneWithoutEducationInput = {
  connect?: InputMaybe<QualificationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QualificationCreateOrConnectWithoutEducationInput>;
  create?: InputMaybe<QualificationUncheckedCreateWithoutEducationInput>;
};

export type QualificationCreateNestedOneWithoutUserInput = {
  connect?: InputMaybe<QualificationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QualificationCreateOrConnectWithoutUserInput>;
  create?: InputMaybe<QualificationUncheckedCreateWithoutUserInput>;
};

export type QualificationCreateOrConnectWithoutCvInput = {
  create: QualificationUncheckedCreateWithoutCvInput;
  where: QualificationWhereUniqueInput;
};

export type QualificationCreateOrConnectWithoutEducationInput = {
  create: QualificationUncheckedCreateWithoutEducationInput;
  where: QualificationWhereUniqueInput;
};

export type QualificationCreateOrConnectWithoutUserInput = {
  create: QualificationUncheckedCreateWithoutUserInput;
  where: QualificationWhereUniqueInput;
};

export type QualificationCreateWithoutCvInput = {
  Education?: InputMaybe<EducationCreateNestedManyWithoutQualificationInput>;
  User?: InputMaybe<UserCreateNestedManyWithoutQualificationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
};

export type QualificationCreateWithoutEducationInput = {
  Cv?: InputMaybe<CvCreateNestedManyWithoutQualificationInput>;
  User?: InputMaybe<UserCreateNestedManyWithoutQualificationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
};

export type QualificationCreateWithoutUserInput = {
  Cv?: InputMaybe<CvCreateNestedManyWithoutQualificationInput>;
  Education?: InputMaybe<EducationCreateNestedManyWithoutQualificationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
};

export type QualificationMaxAggregateOutputType = {
  __typename?: 'QualificationMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type QualificationMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type QualificationMinAggregateOutputType = {
  __typename?: 'QualificationMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type QualificationMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type QualificationOrderByWithAggregationInput = {
  _avg?: InputMaybe<QualificationAvgOrderByAggregateInput>;
  _count?: InputMaybe<QualificationCountOrderByAggregateInput>;
  _max?: InputMaybe<QualificationMaxOrderByAggregateInput>;
  _min?: InputMaybe<QualificationMinOrderByAggregateInput>;
  _sum?: InputMaybe<QualificationSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type QualificationOrderByWithRelationInput = {
  Cv?: InputMaybe<CvOrderByRelationAggregateInput>;
  Education?: InputMaybe<EducationOrderByRelationAggregateInput>;
  User?: InputMaybe<UserOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type QualificationRelationFilter = {
  is?: InputMaybe<QualificationWhereInput>;
  isNot?: InputMaybe<QualificationWhereInput>;
};

export enum QualificationScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  Title = 'title'
}

export type QualificationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<QualificationScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<QualificationScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<QualificationScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  title?: InputMaybe<StringWithAggregatesFilter>;
};

export type QualificationSumAggregateOutputType = {
  __typename?: 'QualificationSumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
};

export type QualificationSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type QualificationUncheckedCreateInput = {
  Cv?: InputMaybe<CvUncheckedCreateNestedManyWithoutQualificationInput>;
  Education?: InputMaybe<EducationUncheckedCreateNestedManyWithoutQualificationInput>;
  User?: InputMaybe<UserUncheckedCreateNestedManyWithoutQualificationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type QualificationUncheckedCreateWithoutCvInput = {
  Education?: InputMaybe<EducationUncheckedCreateNestedManyWithoutQualificationInput>;
  User?: InputMaybe<UserUncheckedCreateNestedManyWithoutQualificationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type QualificationUncheckedCreateWithoutEducationInput = {
  Cv?: InputMaybe<CvUncheckedCreateNestedManyWithoutQualificationInput>;
  User?: InputMaybe<UserUncheckedCreateNestedManyWithoutQualificationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type QualificationUncheckedCreateWithoutUserInput = {
  Cv?: InputMaybe<CvUncheckedCreateNestedManyWithoutQualificationInput>;
  Education?: InputMaybe<EducationUncheckedCreateNestedManyWithoutQualificationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type QualificationUncheckedUpdateInput = {
  Cv?: InputMaybe<CvUncheckedUpdateManyWithoutQualificationInput>;
  Education?: InputMaybe<EducationUncheckedUpdateManyWithoutQualificationInput>;
  User?: InputMaybe<UserUncheckedUpdateManyWithoutQualificationInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type QualificationUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type QualificationUncheckedUpdateWithoutCvInput = {
  Education?: InputMaybe<EducationUncheckedUpdateManyWithoutQualificationInput>;
  User?: InputMaybe<UserUncheckedUpdateManyWithoutQualificationInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type QualificationUncheckedUpdateWithoutEducationInput = {
  Cv?: InputMaybe<CvUncheckedUpdateManyWithoutQualificationInput>;
  User?: InputMaybe<UserUncheckedUpdateManyWithoutQualificationInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type QualificationUncheckedUpdateWithoutUserInput = {
  Cv?: InputMaybe<CvUncheckedUpdateManyWithoutQualificationInput>;
  Education?: InputMaybe<EducationUncheckedUpdateManyWithoutQualificationInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type QualificationUpdateInput = {
  Cv?: InputMaybe<CvUpdateManyWithoutQualificationInput>;
  Education?: InputMaybe<EducationUpdateManyWithoutQualificationInput>;
  User?: InputMaybe<UserUpdateManyWithoutQualificationInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type QualificationUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type QualificationUpdateOneWithoutCvInput = {
  connect?: InputMaybe<QualificationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QualificationCreateOrConnectWithoutCvInput>;
  create?: InputMaybe<QualificationUncheckedCreateWithoutCvInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<QualificationUncheckedUpdateWithoutCvInput>;
  upsert?: InputMaybe<QualificationUpsertWithoutCvInput>;
};

export type QualificationUpdateOneWithoutEducationInput = {
  connect?: InputMaybe<QualificationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QualificationCreateOrConnectWithoutEducationInput>;
  create?: InputMaybe<QualificationUncheckedCreateWithoutEducationInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<QualificationUncheckedUpdateWithoutEducationInput>;
  upsert?: InputMaybe<QualificationUpsertWithoutEducationInput>;
};

export type QualificationUpdateOneWithoutUserInput = {
  connect?: InputMaybe<QualificationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QualificationCreateOrConnectWithoutUserInput>;
  create?: InputMaybe<QualificationUncheckedCreateWithoutUserInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<QualificationUncheckedUpdateWithoutUserInput>;
  upsert?: InputMaybe<QualificationUpsertWithoutUserInput>;
};

export type QualificationUpdateWithoutCvInput = {
  Education?: InputMaybe<EducationUpdateManyWithoutQualificationInput>;
  User?: InputMaybe<UserUpdateManyWithoutQualificationInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type QualificationUpdateWithoutEducationInput = {
  Cv?: InputMaybe<CvUpdateManyWithoutQualificationInput>;
  User?: InputMaybe<UserUpdateManyWithoutQualificationInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type QualificationUpdateWithoutUserInput = {
  Cv?: InputMaybe<CvUpdateManyWithoutQualificationInput>;
  Education?: InputMaybe<EducationUpdateManyWithoutQualificationInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type QualificationUpsertWithoutCvInput = {
  create: QualificationUncheckedCreateWithoutCvInput;
  update: QualificationUncheckedUpdateWithoutCvInput;
};

export type QualificationUpsertWithoutEducationInput = {
  create: QualificationUncheckedCreateWithoutEducationInput;
  update: QualificationUncheckedUpdateWithoutEducationInput;
};

export type QualificationUpsertWithoutUserInput = {
  create: QualificationUncheckedCreateWithoutUserInput;
  update: QualificationUncheckedUpdateWithoutUserInput;
};

export type QualificationWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<QualificationWhereInput>>>;
  Cv?: InputMaybe<CvListRelationFilter>;
  Education?: InputMaybe<EducationListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<QualificationWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<QualificationWhereInput>>>;
  User?: InputMaybe<UserListRelationFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  title?: InputMaybe<StringFilter>;
};

export type QualificationWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  CoursesPaths: Array<Maybe<CoursesPaths>>;
  EventDetailsOutput: EventDetailsOutput;
  adminAnalysis: AdminAnalysisOutput;
  aggregateCoupon?: Maybe<AggregateCoupon>;
  aggregateHiddenEvents?: Maybe<AggregateHiddenEvents>;
  aggregateProfession?: Maybe<AggregateProfession>;
  aggregateSpecialty?: Maybe<AggregateSpecialty>;
  aggregateTraineeEvent?: Maybe<AggregateTraineeEvent>;
  aggregateTraineeEventGroup?: Maybe<AggregateTraineeEventGroup>;
  eventAnalysis: Array<EventAnalysisOutput>;
  findCardFee?: Maybe<Settings>;
  findFirstCoupon?: Maybe<Coupon>;
  findFirstHiddenEvents?: Maybe<HiddenEvents>;
  findFirstProfession?: Maybe<Profession>;
  findFirstQuizResult?: Maybe<QuizResult>;
  findFirstSpecialty?: Maybe<Specialty>;
  findFirstTraineeEvent?: Maybe<TraineeEvent>;
  findFirstTraineeEventGroup?: Maybe<TraineeEventGroup>;
  findGeneralCoupon?: Maybe<Settings>;
  findHeroImages?: Maybe<Array<Maybe<Settings>>>;
  findManyAcademicRank: Array<AcademicRank>;
  findManyAutomatedEmails: Array<AutomatedEmails>;
  findManyBecomeTrainerApplication: Array<BecomeTrainerApplication>;
  findManyBecomeTrainerApplicationCount: Scalars['Int'];
  findManyBlogs: Array<Blogs>;
  findManyBlogsCount: Scalars['Int'];
  findManyCity: Array<City>;
  findManyContactUsData: Array<ContactUsData>;
  findManyContactUsDataCount: Scalars['Int'];
  findManyCountry: Array<Country>;
  findManyCoupon: Array<Coupon>;
  findManyCouponCount: Scalars['Int'];
  findManyEmail: EmailTemplate;
  findManyEvent: Array<Event>;
  findManyEventCount: Scalars['Int'];
  findManyEventDay: Array<EventDay>;
  findManyEventMediaTracking: Array<EventMediaTracking>;
  findManyEventMediaTrackingCount: Scalars['Int'];
  findManyEventType: Array<EventType>;
  findManyHiddenEvents: Array<HiddenEvents>;
  findManyHiddenEventsCount: Scalars['Int'];
  findManyHowHeardAboutEvent: Array<HowHeardAboutEvent>;
  findManyLanguage: Array<Language>;
  findManyMemberNeedSettings: Array<MemberNeedSettings>;
  findManyMemberNeedSettingsCount: Scalars['Int'];
  findManyMemberNeeds: Array<MemberNeeds>;
  findManyMemberNeedsCount: Scalars['Int'];
  findManyMethodOfTeachingType: Array<MethodOfTeachingType>;
  findManyNotification: Array<Notification>;
  findManyProfession: Array<Profession>;
  findManyProfessionCount: Scalars['Int'];
  findManyQualification: Array<Qualification>;
  findManyQuizResult: Array<QuizResult>;
  findManyRank: Array<Rank>;
  findManySpecialty: Array<Specialty>;
  findManySpecialtyCount: Scalars['Int'];
  findManyState: Array<State>;
  findManyTemplate: Array<Template>;
  findManyTemplateCount: Scalars['Int'];
  findManyTraineeEvent: Array<TraineeEvent>;
  findManyTraineeEventCount: Scalars['Int'];
  findManyTraineeEventDayAttendance: Array<TraineeEventDayAttendance>;
  findManyTraineeEventGroup: Array<TraineeEventGroup>;
  findManyTraineeEventGroupCount: Scalars['Int'];
  findManyTraineeEventReviewChoice: Array<TraineeEventReviewChoice>;
  findManyTraineeEventReviewChoiceCount: Scalars['Int'];
  findManyTraineeTrainerReviewChoice: Array<TraineeTrainerReviewChoice>;
  findManyTraineeTrainerReviewChoiceCount: Scalars['Int'];
  findManyTrainerEvent: Array<TrainerEvent>;
  findManyTrainerEventCount: Scalars['Int'];
  findManyTrainerEventStudyMaterial: Array<TrainerEventStudyMaterial>;
  findManyTrainerEventStudyMaterialCount: Scalars['Int'];
  findManyTrainerEventStudyMaterialGroup: Array<TrainerEventStudyMaterialGroup>;
  findManyTrainerEventStudyMaterialGroupCount: Scalars['Int'];
  findManyTransition: Array<Transition>;
  findManyTransitionCount: Scalars['Int'];
  findManyTransitionStatusType: Array<TransitionStatusType>;
  findManyUser: Array<User>;
  findManyUserCount: Scalars['Int'];
  findManyZohoEmails?: Maybe<Array<Maybe<ZohoEmail>>>;
  findManyZoomMeeting: Array<ZoomMeeting>;
  findManyZoomRegistrant?: Maybe<Array<Maybe<ZoomRegistrant>>>;
  findOneTrainerEventStudyMaterial?: Maybe<TrainerEventStudyMaterial>;
  findOneTrainerEventStudyMaterialGroup?: Maybe<TrainerEventStudyMaterialGroup>;
  findOneZoom?: Maybe<Zoom>;
  findProfile?: Maybe<User>;
  findPublishExpense?: Maybe<Settings>;
  findRemoveUserPassword?: Maybe<Settings>;
  findReview?: Maybe<FindReviewOutput>;
  findScheduling?: Maybe<Array<Maybe<Scheduling>>>;
  findUniqueCity?: Maybe<City>;
  findUniqueCountry?: Maybe<Country>;
  findUniqueCoupon?: Maybe<Coupon>;
  findUniqueEvent?: Maybe<Event>;
  findUniqueEventDay?: Maybe<EventDay>;
  findUniqueEventFolder?: Maybe<EventFolder>;
  findUniqueEventIdentityCardTemplate?: Maybe<EventIdentityCardTemplate>;
  findUniqueEventsReport: EventsReport;
  findUniqueHiddenEvents?: Maybe<HiddenEvents>;
  findUniqueMarketersReport: MarketersReport;
  findUniqueOrganizersReport: OrganizersReport;
  findUniqueProfession?: Maybe<Profession>;
  findUniqueQuiz?: Maybe<Quiz>;
  findUniqueRole?: Maybe<Role>;
  findUniqueSettings?: Maybe<Settings>;
  findUniqueSpecialty?: Maybe<Specialty>;
  findUniqueTemplate?: Maybe<Template>;
  findUniqueTraineeEvent?: Maybe<TraineeEvent>;
  findUniqueTraineeEventGroup?: Maybe<TraineeEventGroup>;
  findUniqueTraineesReport: TraineesReport;
  findUniqueTrainerEvent?: Maybe<TrainerEvent>;
  findUniqueTrainersReport: TrainersReport;
  findUniqueTransition?: Maybe<Transition>;
  findUniqueUser?: Maybe<User>;
  findUniqueZoomRegistrant?: Maybe<ZoomRegistrant>;
  findVatNumber?: Maybe<Settings>;
  findWAState?: Maybe<WaStateType>;
  findWhatsAppMsgs: MsgTemplate;
  getBooking: Booking;
  getCertificate?: Maybe<Certificate>;
  getCertification?: Maybe<CertificateSummery>;
  getCoursePrice: GetCoursePriceOutput;
  getWalletTransition: WalletTransitionPayment;
  incomeStatement: Array<IncomeStatementOutput>;
  listCourses?: Maybe<Array<Maybe<ListCoursesOutput>>>;
  marketerAnalysis: MarketerAnalysisOutput;
  orgnizerAnalysis: OrgnizerAnalysisOutput;
  traineeAnalysis: TraineeAnalysisOutput;
  trainerAnalysis: TrainerAnalysisOutput;
  whatsAppGetQr?: Maybe<Settings>;
};


export type QueryEventDetailsOutputArgs = {
  id: Scalars['Int'];
};


export type QueryAdminAnalysisArgs = {
  where: AdminAnalysisWhere;
};


export type QueryAggregateCouponArgs = {
  cursor?: InputMaybe<CouponWhereUniqueInput>;
  orderBy?: InputMaybe<Array<InputMaybe<CouponOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CouponWhereInput>;
};


export type QueryAggregateHiddenEventsArgs = {
  cursor?: InputMaybe<HiddenEventsWhereUniqueInput>;
  orderBy?: InputMaybe<Array<InputMaybe<HiddenEventsOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HiddenEventsWhereInput>;
};


export type QueryAggregateProfessionArgs = {
  cursor?: InputMaybe<ProfessionWhereUniqueInput>;
  orderBy?: InputMaybe<Array<InputMaybe<ProfessionOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProfessionWhereInput>;
};


export type QueryAggregateSpecialtyArgs = {
  cursor?: InputMaybe<SpecialtyWhereUniqueInput>;
  orderBy?: InputMaybe<Array<InputMaybe<SpecialtyOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SpecialtyWhereInput>;
};


export type QueryAggregateTraineeEventArgs = {
  cursor?: InputMaybe<TraineeEventWhereUniqueInput>;
  orderBy?: InputMaybe<Array<InputMaybe<TraineeEventOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeEventWhereInput>;
};


export type QueryAggregateTraineeEventGroupArgs = {
  cursor?: InputMaybe<TraineeEventGroupWhereUniqueInput>;
  orderBy?: InputMaybe<Array<InputMaybe<TraineeEventGroupOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeEventGroupWhereInput>;
};


export type QueryEventAnalysisArgs = {
  where: EventAnalysisWhere;
};


export type QueryFindFirstCouponArgs = {
  cursor?: InputMaybe<CouponWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<CouponScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<CouponOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CouponWhereInput>;
};


export type QueryFindFirstHiddenEventsArgs = {
  cursor?: InputMaybe<HiddenEventsWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<HiddenEventsScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<HiddenEventsOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HiddenEventsWhereInput>;
};


export type QueryFindFirstProfessionArgs = {
  cursor?: InputMaybe<ProfessionWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<ProfessionScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<ProfessionOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProfessionWhereInput>;
};


export type QueryFindFirstQuizResultArgs = {
  cursor?: InputMaybe<QuizResultWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<QuizResultScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<QuizResultOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<QuizResultWhereInput>;
};


export type QueryFindFirstSpecialtyArgs = {
  cursor?: InputMaybe<SpecialtyWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<SpecialtyScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<SpecialtyOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SpecialtyWhereInput>;
};


export type QueryFindFirstTraineeEventArgs = {
  cursor?: InputMaybe<TraineeEventWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<TraineeEventScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<TraineeEventOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeEventWhereInput>;
};


export type QueryFindFirstTraineeEventGroupArgs = {
  cursor?: InputMaybe<TraineeEventGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<TraineeEventGroupScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<TraineeEventGroupOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeEventGroupWhereInput>;
};


export type QueryFindManyAcademicRankArgs = {
  cursor?: InputMaybe<AcademicRankWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<AcademicRankScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<AcademicRankOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AcademicRankWhereInput>;
};


export type QueryFindManyAutomatedEmailsArgs = {
  cursor?: InputMaybe<AutomatedEmailsWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<AutomatedEmailsScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<AutomatedEmailsOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AutomatedEmailsWhereInput>;
};


export type QueryFindManyBecomeTrainerApplicationArgs = {
  cursor?: InputMaybe<BecomeTrainerApplicationWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BecomeTrainerApplicationWhereInput>;
};


export type QueryFindManyBecomeTrainerApplicationCountArgs = {
  cursor?: InputMaybe<BecomeTrainerApplicationWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<BecomeTrainerApplicationOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BecomeTrainerApplicationWhereInput>;
};


export type QueryFindManyBlogsArgs = {
  cursor?: InputMaybe<BlogsWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<BlogsScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<BlogsOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BlogsWhereInput>;
};


export type QueryFindManyBlogsCountArgs = {
  cursor?: InputMaybe<BlogsWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<BlogsScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<BlogsOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BlogsWhereInput>;
};


export type QueryFindManyCityArgs = {
  cursor?: InputMaybe<CityWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<CityScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<CityOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CityWhereInput>;
};


export type QueryFindManyContactUsDataArgs = {
  cursor?: InputMaybe<ContactUsDataWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<ContactUsDataScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<ContactUsDataOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContactUsDataWhereInput>;
};


export type QueryFindManyContactUsDataCountArgs = {
  cursor?: InputMaybe<ContactUsDataWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<ContactUsDataScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<ContactUsDataOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContactUsDataWhereInput>;
};


export type QueryFindManyCountryArgs = {
  cursor?: InputMaybe<CountryWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<CountryScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<CountryOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CountryWhereInput>;
};


export type QueryFindManyCouponArgs = {
  cursor?: InputMaybe<CouponWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<CouponScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<CouponOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CouponWhereInput>;
};


export type QueryFindManyCouponCountArgs = {
  cursor?: InputMaybe<CouponWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<CouponScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<CouponOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CouponWhereInput>;
};


export type QueryFindManyEmailArgs = {
  where: EmailWhereInput;
};


export type QueryFindManyEventArgs = {
  cursor?: InputMaybe<EventWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<EventScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<EventOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EventWhereInput>;
};


export type QueryFindManyEventCountArgs = {
  cursor?: InputMaybe<EventWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<EventScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<EventOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EventWhereInput>;
};


export type QueryFindManyEventDayArgs = {
  cursor?: InputMaybe<EventDayWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<EventDayScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<EventDayOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EventDayWhereInput>;
};


export type QueryFindManyEventMediaTrackingArgs = {
  cursor?: InputMaybe<EventMediaTrackingWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<EventMediaTrackingScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<EventMediaTrackingOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EventMediaTrackingWhereInput>;
};


export type QueryFindManyEventMediaTrackingCountArgs = {
  cursor?: InputMaybe<EventMediaTrackingWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<EventMediaTrackingScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<EventMediaTrackingOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EventMediaTrackingWhereInput>;
};


export type QueryFindManyEventTypeArgs = {
  cursor?: InputMaybe<EventTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<EventTypeScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<EventTypeOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EventTypeWhereInput>;
};


export type QueryFindManyHiddenEventsArgs = {
  cursor?: InputMaybe<HiddenEventsWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<HiddenEventsScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<HiddenEventsOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HiddenEventsWhereInput>;
};


export type QueryFindManyHiddenEventsCountArgs = {
  cursor?: InputMaybe<HiddenEventsWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<HiddenEventsScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<HiddenEventsOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HiddenEventsWhereInput>;
};


export type QueryFindManyLanguageArgs = {
  cursor?: InputMaybe<LanguageWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<LanguageScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<LanguageOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LanguageWhereInput>;
};


export type QueryFindManyMemberNeedSettingsArgs = {
  cursor?: InputMaybe<MemberNeedSettingsWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<MemberNeedSettingsScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<MemberNeedSettingsOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MemberNeedSettingsWhereInput>;
};


export type QueryFindManyMemberNeedSettingsCountArgs = {
  cursor?: InputMaybe<MemberNeedSettingsWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<MemberNeedSettingsScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<MemberNeedSettingsOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MemberNeedSettingsWhereInput>;
};


export type QueryFindManyMemberNeedsArgs = {
  cursor?: InputMaybe<MemberNeedsWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<MemberNeedsScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<MemberNeedsOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MemberNeedsWhereInput>;
};


export type QueryFindManyMemberNeedsCountArgs = {
  cursor?: InputMaybe<MemberNeedsWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<MemberNeedsScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<MemberNeedsOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MemberNeedsWhereInput>;
};


export type QueryFindManyMethodOfTeachingTypeArgs = {
  cursor?: InputMaybe<MethodOfTeachingTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<MethodOfTeachingTypeScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<MethodOfTeachingTypeOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MethodOfTeachingTypeWhereInput>;
};


export type QueryFindManyNotificationArgs = {
  where?: InputMaybe<NotificationFindManyInputType>;
};


export type QueryFindManyProfessionArgs = {
  cursor?: InputMaybe<ProfessionWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<ProfessionScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<ProfessionOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProfessionWhereInput>;
};


export type QueryFindManyProfessionCountArgs = {
  cursor?: InputMaybe<ProfessionWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<ProfessionScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<ProfessionOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProfessionWhereInput>;
};


export type QueryFindManyQualificationArgs = {
  cursor?: InputMaybe<QualificationWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<QualificationScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<QualificationOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<QualificationWhereInput>;
};


export type QueryFindManyQuizResultArgs = {
  cursor?: InputMaybe<QuizResultWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<QuizResultScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<QuizResultOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<QuizResultWhereInput>;
};


export type QueryFindManyRankArgs = {
  cursor?: InputMaybe<RankWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<RankScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<RankOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RankWhereInput>;
};


export type QueryFindManySpecialtyArgs = {
  cursor?: InputMaybe<SpecialtyWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<SpecialtyScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<SpecialtyOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SpecialtyWhereInput>;
};


export type QueryFindManySpecialtyCountArgs = {
  cursor?: InputMaybe<SpecialtyWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<SpecialtyScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<SpecialtyOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SpecialtyWhereInput>;
};


export type QueryFindManyStateArgs = {
  cursor?: InputMaybe<StateWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<StateScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<StateOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<StateWhereInput>;
};


export type QueryFindManyTemplateArgs = {
  cursor?: InputMaybe<TemplateWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<TemplateScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<TemplateOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TemplateWhereInput>;
};


export type QueryFindManyTemplateCountArgs = {
  cursor?: InputMaybe<TemplateWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<TemplateScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<TemplateOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TemplateWhereInput>;
};


export type QueryFindManyTraineeEventArgs = {
  cursor?: InputMaybe<TraineeEventWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<TraineeEventScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<TraineeEventOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeEventWhereInput>;
};


export type QueryFindManyTraineeEventCountArgs = {
  cursor?: InputMaybe<TraineeEventWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<TraineeEventScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<TraineeEventOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeEventWhereInput>;
};


export type QueryFindManyTraineeEventDayAttendanceArgs = {
  where: GetAttendanceType;
};


export type QueryFindManyTraineeEventGroupArgs = {
  cursor?: InputMaybe<TraineeEventGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<TraineeEventGroupScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<TraineeEventGroupOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeEventGroupWhereInput>;
};


export type QueryFindManyTraineeEventGroupCountArgs = {
  cursor?: InputMaybe<TraineeEventGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<TraineeEventGroupScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<TraineeEventGroupOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeEventGroupWhereInput>;
};


export type QueryFindManyTraineeEventReviewChoiceArgs = {
  cursor?: InputMaybe<TraineeEventReviewChoiceWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeEventReviewChoiceWhereInput>;
};


export type QueryFindManyTraineeEventReviewChoiceCountArgs = {
  cursor?: InputMaybe<TraineeEventReviewChoiceWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeEventReviewChoiceWhereInput>;
};


export type QueryFindManyTraineeTrainerReviewChoiceArgs = {
  cursor?: InputMaybe<TraineeTrainerReviewChoiceWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeTrainerReviewChoiceWhereInput>;
};


export type QueryFindManyTraineeTrainerReviewChoiceCountArgs = {
  cursor?: InputMaybe<TraineeTrainerReviewChoiceWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeTrainerReviewChoiceWhereInput>;
};


export type QueryFindManyTrainerEventArgs = {
  cursor?: InputMaybe<TrainerEventWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<TrainerEventScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<TrainerEventOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TrainerEventWhereInput>;
};


export type QueryFindManyTrainerEventCountArgs = {
  cursor?: InputMaybe<TrainerEventWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<TrainerEventScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<TrainerEventOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TrainerEventWhereInput>;
};


export type QueryFindManyTrainerEventStudyMaterialArgs = {
  cursor?: InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TrainerEventStudyMaterialWhereInput>;
};


export type QueryFindManyTrainerEventStudyMaterialCountArgs = {
  cursor?: InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TrainerEventStudyMaterialWhereInput>;
};


export type QueryFindManyTrainerEventStudyMaterialGroupArgs = {
  cursor?: InputMaybe<TrainerEventStudyMaterialGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TrainerEventStudyMaterialGroupWhereInput>;
};


export type QueryFindManyTrainerEventStudyMaterialGroupCountArgs = {
  cursor?: InputMaybe<TrainerEventStudyMaterialGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TrainerEventStudyMaterialGroupWhereInput>;
};


export type QueryFindManyTransitionArgs = {
  cursor?: InputMaybe<TransitionWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<TransitionScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<TransitionOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TransitionWhereInput>;
};


export type QueryFindManyTransitionCountArgs = {
  cursor?: InputMaybe<TransitionWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<TransitionScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<TransitionOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TransitionWhereInput>;
};


export type QueryFindManyTransitionStatusTypeArgs = {
  cursor?: InputMaybe<TransitionStatusTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<TransitionStatusTypeScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<TransitionStatusTypeOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TransitionStatusTypeWhereInput>;
};


export type QueryFindManyUserArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<UserScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<UserOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryFindManyUserCountArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<UserScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<UserOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryFindManyZohoEmailsArgs = {
  cursor?: InputMaybe<ZohoEmailWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<ZohoEmailScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<ZohoEmailOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where: ZohoEmailWhereInput;
};


export type QueryFindManyZoomMeetingArgs = {
  cursor?: InputMaybe<ZoomMeetingWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<ZoomMeetingScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<ZoomMeetingOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ZoomMeetingWhereInput>;
};


export type QueryFindManyZoomRegistrantArgs = {
  where: ZoomRegistrantWhereManyInput;
};


export type QueryFindOneTrainerEventStudyMaterialArgs = {
  where: TrainerEventStudyMaterialWhereUniqueInput;
};


export type QueryFindOneTrainerEventStudyMaterialGroupArgs = {
  where: TrainerEventStudyMaterialGroupWhereUniqueInput;
};


export type QueryFindOneZoomArgs = {
  where: ZoomWhereUniqueInput;
};


export type QueryFindProfileArgs = {
  where: UserWhereUniqueInput;
};


export type QueryFindReviewArgs = {
  where: FindReviewInput;
};


export type QueryFindSchedulingArgs = {
  where: FindSchedulingInput;
};


export type QueryFindUniqueCityArgs = {
  where: CityWhereUniqueInput;
};


export type QueryFindUniqueCountryArgs = {
  where: CountryWhereUniqueInput;
};


export type QueryFindUniqueCouponArgs = {
  where: CouponWhereUniqueInput;
};


export type QueryFindUniqueEventArgs = {
  where: EventWhereUniqueInput;
};


export type QueryFindUniqueEventDayArgs = {
  where: EventDayWhereUniqueInput;
};


export type QueryFindUniqueEventFolderArgs = {
  where: EventFolderWhereUniqueInput;
};


export type QueryFindUniqueEventIdentityCardTemplateArgs = {
  where: EventIdentityCardTemplateWhereUniqueInput;
};


export type QueryFindUniqueEventsReportArgs = {
  where: EventsReportUniqueObject;
};


export type QueryFindUniqueHiddenEventsArgs = {
  where: HiddenEventsWhereUniqueInput;
};


export type QueryFindUniqueMarketersReportArgs = {
  where: MarketersReportUniqueObject;
};


export type QueryFindUniqueOrganizersReportArgs = {
  where: OrganizersReportUniqueObject;
};


export type QueryFindUniqueProfessionArgs = {
  where: ProfessionWhereUniqueInput;
};


export type QueryFindUniqueQuizArgs = {
  where?: InputMaybe<QuizWhereUniqueInput>;
};


export type QueryFindUniqueRoleArgs = {
  where: RoleWhereUniqueInput;
};


export type QueryFindUniqueSettingsArgs = {
  where: SettingsWhereUniqueInput;
};


export type QueryFindUniqueSpecialtyArgs = {
  where: SpecialtyWhereUniqueInput;
};


export type QueryFindUniqueTemplateArgs = {
  where: TemplateWhereUniqueInput;
};


export type QueryFindUniqueTraineeEventArgs = {
  where: TraineeEventWhereUniqueInput;
};


export type QueryFindUniqueTraineeEventGroupArgs = {
  where: TraineeEventGroupWhereUniqueInput;
};


export type QueryFindUniqueTraineesReportArgs = {
  where: TraineesReportUniqueObject;
};


export type QueryFindUniqueTrainerEventArgs = {
  where: TrainerEventWhereUniqueInput;
};


export type QueryFindUniqueTrainersReportArgs = {
  where: TrainersReportUniqueObject;
};


export type QueryFindUniqueTransitionArgs = {
  where: TransitionWhereUniqueInput;
};


export type QueryFindUniqueUserArgs = {
  where: UserWhereUniqueInput;
};


export type QueryFindUniqueZoomRegistrantArgs = {
  where: ZoomRegistrantWherefindUniqueInput;
};


export type QueryFindWhatsAppMsgsArgs = {
  where: FindWhatsAppMsgsInput;
};


export type QueryGetBookingArgs = {
  data: GetBookingInputType;
};


export type QueryGetCertificateArgs = {
  certificateId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
};


export type QueryGetCertificationArgs = {
  data: GetCertInputType;
};


export type QueryGetCoursePriceArgs = {
  data: BookingInputType;
};


export type QueryGetWalletTransitionArgs = {
  data: GetWalletInputType;
};


export type QueryIncomeStatementArgs = {
  where: IncomeStatementWhereInput;
};


export type QueryListCoursesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EventWhereInput>;
};


export type QueryMarketerAnalysisArgs = {
  where: MarketerAnalysisWhere;
};


export type QueryOrgnizerAnalysisArgs = {
  where: OrgnizerAnalysisWhere;
};


export type QueryTraineeAnalysisArgs = {
  where: TraineeAnalysisWhere;
};


export type QueryTrainerAnalysisArgs = {
  where: TrainerAnalysisWhere;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type Quiz = {
  __typename?: 'Quiz';
  Event: Event;
  QuizQuestion: Array<QuizQuestion>;
  QuizResult: Array<QuizResult>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};


export type QuizQuizQuestionArgs = {
  cursor?: InputMaybe<QuizQuestionWhereUniqueInput>;
  distinct?: InputMaybe<QuizQuestionScalarFieldEnum>;
  orderBy?: InputMaybe<QuizQuestionOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<QuizQuestionWhereInput>;
};


export type QuizQuizResultArgs = {
  cursor?: InputMaybe<QuizResultWhereUniqueInput>;
  distinct?: InputMaybe<QuizResultScalarFieldEnum>;
  orderBy?: InputMaybe<QuizResultOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<QuizResultWhereInput>;
};

export type QuizAvgAggregateOutputType = {
  __typename?: 'QuizAvgAggregateOutputType';
  eventId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

export type QuizAvgOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type QuizCountAggregateOutputType = {
  __typename?: 'QuizCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  eventId: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
};

export type QuizCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type QuizCountOutputType = {
  __typename?: 'QuizCountOutputType';
  QuizQuestion: Scalars['Int'];
  QuizResult: Scalars['Int'];
  TrainerEventStudyMaterial: Scalars['Int'];
};

export type QuizCreateInput = {
  Event?: InputMaybe<EventCreateNestedOneWithoutQuizInput>;
  QuizQuestion?: InputMaybe<QuizQuestionCreateNestedManyWithoutQuizInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutQuizInput>;
  TrainerEventStudyMaterial?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutQuizInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
};

export type QuizCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type QuizCreateNestedOneWithoutEventInput = {
  connect?: InputMaybe<QuizWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuizCreateOrConnectWithoutEventInput>;
  create?: InputMaybe<QuizUncheckedCreateWithoutEventInput>;
};

export type QuizCreateNestedOneWithoutQuizQuestionInput = {
  connect?: InputMaybe<QuizWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuizCreateOrConnectWithoutQuizQuestionInput>;
  create?: InputMaybe<QuizUncheckedCreateWithoutQuizQuestionInput>;
};

export type QuizCreateNestedOneWithoutQuizResultInput = {
  connect?: InputMaybe<QuizWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuizCreateOrConnectWithoutQuizResultInput>;
  create?: InputMaybe<QuizUncheckedCreateWithoutQuizResultInput>;
};

export type QuizCreateNestedOneWithoutTrainerEventStudyMaterialInput = {
  connect?: InputMaybe<QuizWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuizCreateOrConnectWithoutTrainerEventStudyMaterialInput>;
  create?: InputMaybe<QuizUncheckedCreateWithoutTrainerEventStudyMaterialInput>;
};

/** Quiz Create one Input */
export type QuizCreateOneInput = {
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
};

export type QuizCreateOrConnectWithoutEventInput = {
  create: QuizUncheckedCreateWithoutEventInput;
  where: QuizWhereUniqueInput;
};

export type QuizCreateOrConnectWithoutQuizQuestionInput = {
  create: QuizUncheckedCreateWithoutQuizQuestionInput;
  where: QuizWhereUniqueInput;
};

export type QuizCreateOrConnectWithoutQuizResultInput = {
  create: QuizUncheckedCreateWithoutQuizResultInput;
  where: QuizWhereUniqueInput;
};

export type QuizCreateOrConnectWithoutTrainerEventStudyMaterialInput = {
  create: QuizUncheckedCreateWithoutTrainerEventStudyMaterialInput;
  where: QuizWhereUniqueInput;
};

export type QuizCreateWithoutEventInput = {
  QuizQuestion?: InputMaybe<QuizQuestionCreateNestedManyWithoutQuizInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutQuizInput>;
  TrainerEventStudyMaterial?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutQuizInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
};

export type QuizCreateWithoutQuizQuestionInput = {
  Event?: InputMaybe<EventCreateNestedOneWithoutQuizInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutQuizInput>;
  TrainerEventStudyMaterial?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutQuizInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
};

export type QuizCreateWithoutQuizResultInput = {
  Event?: InputMaybe<EventCreateNestedOneWithoutQuizInput>;
  QuizQuestion?: InputMaybe<QuizQuestionCreateNestedManyWithoutQuizInput>;
  TrainerEventStudyMaterial?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutQuizInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
};

export type QuizCreateWithoutTrainerEventStudyMaterialInput = {
  Event?: InputMaybe<EventCreateNestedOneWithoutQuizInput>;
  QuizQuestion?: InputMaybe<QuizQuestionCreateNestedManyWithoutQuizInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutQuizInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
};

export type QuizMaxAggregateOutputType = {
  __typename?: 'QuizMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type QuizMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type QuizMinAggregateOutputType = {
  __typename?: 'QuizMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type QuizMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type QuizOrderByWithAggregationInput = {
  _avg?: InputMaybe<QuizAvgOrderByAggregateInput>;
  _count?: InputMaybe<QuizCountOrderByAggregateInput>;
  _max?: InputMaybe<QuizMaxOrderByAggregateInput>;
  _min?: InputMaybe<QuizMinOrderByAggregateInput>;
  _sum?: InputMaybe<QuizSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type QuizOrderByWithRelationInput = {
  Event?: InputMaybe<EventOrderByWithRelationInput>;
  QuizQuestion?: InputMaybe<QuizQuestionOrderByRelationAggregateInput>;
  QuizResult?: InputMaybe<QuizResultOrderByRelationAggregateInput>;
  TrainerEventStudyMaterial?: InputMaybe<TrainerEventStudyMaterialOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type QuizQuestion = {
  __typename?: 'QuizQuestion';
  Quiz: Quiz;
  QuizQuestionAnswer: Array<QuizQuestionAnswer>;
  QuizResult: Array<QuizResult>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  questionAr: Scalars['String'];
  questionEn: Scalars['String'];
  questionOrder?: Maybe<Scalars['Int']>;
  questionType: Scalars['String'];
  quizId: Scalars['Int'];
  rightAnswer?: Maybe<Scalars['String']>;
};


export type QuizQuestionQuizQuestionAnswerArgs = {
  cursor?: InputMaybe<QuizQuestionAnswerWhereUniqueInput>;
  distinct?: InputMaybe<QuizQuestionAnswerScalarFieldEnum>;
  orderBy?: InputMaybe<QuizQuestionAnswerOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<QuizQuestionAnswerWhereInput>;
};


export type QuizQuestionQuizResultArgs = {
  cursor?: InputMaybe<QuizResultWhereUniqueInput>;
  distinct?: InputMaybe<QuizResultScalarFieldEnum>;
  orderBy?: InputMaybe<QuizResultOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<QuizResultWhereInput>;
};

export type QuizQuestionAnswer = {
  __typename?: 'QuizQuestionAnswer';
  QuizQuestion: QuizQuestion;
  QuizResult: Array<QuizResult>;
  answerAr: Scalars['String'];
  answerEn: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  quizQuestionId: Scalars['String'];
};


export type QuizQuestionAnswerQuizResultArgs = {
  cursor?: InputMaybe<QuizResultWhereUniqueInput>;
  distinct?: InputMaybe<QuizResultScalarFieldEnum>;
  orderBy?: InputMaybe<QuizResultOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<QuizResultWhereInput>;
};

export type QuizQuestionAnswerCountAggregateOutputType = {
  __typename?: 'QuizQuestionAnswerCountAggregateOutputType';
  _all: Scalars['Int'];
  answerAr: Scalars['Int'];
  answerEn: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  quizQuestionId: Scalars['Int'];
};

export type QuizQuestionAnswerCountOrderByAggregateInput = {
  answerAr?: InputMaybe<SortOrder>;
  answerEn?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  quizQuestionId?: InputMaybe<SortOrder>;
};

export type QuizQuestionAnswerCountOutputType = {
  __typename?: 'QuizQuestionAnswerCountOutputType';
  QuizQuestion_QuizQuestion_rightAnswerToQuizQuestionAnswer: Scalars['Int'];
  QuizResult: Scalars['Int'];
};

export type QuizQuestionAnswerCreateInput = {
  QuizQuestion: QuizQuestionCreateNestedOneWithoutQuizQuestionAnswerInput;
  QuizQuestion_QuizQuestion_rightAnswerToQuizQuestionAnswer?: InputMaybe<QuizQuestionCreateNestedManyWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutQuizQuestionAnswerInput>;
  answerAr: Scalars['String'];
  answerEn: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
};

export type QuizQuestionAnswerCreateManyInput = {
  answerAr: Scalars['String'];
  answerEn: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  quizQuestionId: Scalars['String'];
};

export type QuizQuestionAnswerCreateManyQuizQuestionInput = {
  answerAr: Scalars['String'];
  answerEn: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
};

export type QuizQuestionAnswerCreateManyQuizQuestionInputEnvelope = {
  data: QuizQuestionAnswerCreateManyQuizQuestionInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type QuizQuestionAnswerCreateNestedManyWithoutQuizQuestionInput = {
  connect?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerCreateOrConnectWithoutQuizQuestionInput>>>;
  create?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerCreateWithoutQuizQuestionInput>>>;
  createMany?: InputMaybe<QuizQuestionAnswerCreateManyQuizQuestionInputEnvelope>;
};

export type QuizQuestionAnswerCreateNestedOneWithoutQuizQuestion_QuizQuestion_RightAnswerToQuizQuestionAnswerInput = {
  connect?: InputMaybe<QuizQuestionAnswerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuizQuestionAnswerCreateOrConnectWithoutQuizQuestion_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>;
  create?: InputMaybe<QuizQuestionAnswerUncheckedCreateWithoutQuizQuestion_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>;
};

export type QuizQuestionAnswerCreateNestedOneWithoutQuizResultInput = {
  connect?: InputMaybe<QuizQuestionAnswerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuizQuestionAnswerCreateOrConnectWithoutQuizResultInput>;
  create?: InputMaybe<QuizQuestionAnswerUncheckedCreateWithoutQuizResultInput>;
};

export type QuizQuestionAnswerCreateOrConnectWithoutQuizQuestionInput = {
  create: QuizQuestionAnswerUncheckedCreateWithoutQuizQuestionInput;
  where: QuizQuestionAnswerWhereUniqueInput;
};

export type QuizQuestionAnswerCreateOrConnectWithoutQuizQuestion_QuizQuestion_RightAnswerToQuizQuestionAnswerInput = {
  create: QuizQuestionAnswerUncheckedCreateWithoutQuizQuestion_QuizQuestion_RightAnswerToQuizQuestionAnswerInput;
  where: QuizQuestionAnswerWhereUniqueInput;
};

export type QuizQuestionAnswerCreateOrConnectWithoutQuizResultInput = {
  create: QuizQuestionAnswerUncheckedCreateWithoutQuizResultInput;
  where: QuizQuestionAnswerWhereUniqueInput;
};

export type QuizQuestionAnswerCreateWithoutQuizQuestionInput = {
  QuizQuestion_QuizQuestion_rightAnswerToQuizQuestionAnswer?: InputMaybe<QuizQuestionCreateNestedManyWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutQuizQuestionAnswerInput>;
  answerAr: Scalars['String'];
  answerEn: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
};

export type QuizQuestionAnswerCreateWithoutQuizQuestion_QuizQuestion_RightAnswerToQuizQuestionAnswerInput = {
  QuizQuestion: QuizQuestionCreateNestedOneWithoutQuizQuestionAnswerInput;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutQuizQuestionAnswerInput>;
  answerAr: Scalars['String'];
  answerEn: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
};

export type QuizQuestionAnswerCreateWithoutQuizResultInput = {
  QuizQuestion: QuizQuestionCreateNestedOneWithoutQuizQuestionAnswerInput;
  QuizQuestion_QuizQuestion_rightAnswerToQuizQuestionAnswer?: InputMaybe<QuizQuestionCreateNestedManyWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>;
  answerAr: Scalars['String'];
  answerEn: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
};

export type QuizQuestionAnswerListRelationFilter = {
  every?: InputMaybe<QuizQuestionAnswerWhereInput>;
  none?: InputMaybe<QuizQuestionAnswerWhereInput>;
  some?: InputMaybe<QuizQuestionAnswerWhereInput>;
};

export type QuizQuestionAnswerMaxAggregateOutputType = {
  __typename?: 'QuizQuestionAnswerMaxAggregateOutputType';
  answerAr?: Maybe<Scalars['String']>;
  answerEn?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  quizQuestionId?: Maybe<Scalars['String']>;
};

export type QuizQuestionAnswerMaxOrderByAggregateInput = {
  answerAr?: InputMaybe<SortOrder>;
  answerEn?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  quizQuestionId?: InputMaybe<SortOrder>;
};

export type QuizQuestionAnswerMinAggregateOutputType = {
  __typename?: 'QuizQuestionAnswerMinAggregateOutputType';
  answerAr?: Maybe<Scalars['String']>;
  answerEn?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  quizQuestionId?: Maybe<Scalars['String']>;
};

export type QuizQuestionAnswerMinOrderByAggregateInput = {
  answerAr?: InputMaybe<SortOrder>;
  answerEn?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  quizQuestionId?: InputMaybe<SortOrder>;
};

export type QuizQuestionAnswerOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type QuizQuestionAnswerOrderByWithAggregationInput = {
  _count?: InputMaybe<QuizQuestionAnswerCountOrderByAggregateInput>;
  _max?: InputMaybe<QuizQuestionAnswerMaxOrderByAggregateInput>;
  _min?: InputMaybe<QuizQuestionAnswerMinOrderByAggregateInput>;
  answerAr?: InputMaybe<SortOrder>;
  answerEn?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  quizQuestionId?: InputMaybe<SortOrder>;
};

export type QuizQuestionAnswerOrderByWithRelationInput = {
  QuizQuestion?: InputMaybe<QuizQuestionOrderByWithRelationInput>;
  QuizQuestion_QuizQuestion_rightAnswerToQuizQuestionAnswer?: InputMaybe<QuizQuestionOrderByRelationAggregateInput>;
  QuizResult?: InputMaybe<QuizResultOrderByRelationAggregateInput>;
  answerAr?: InputMaybe<SortOrder>;
  answerEn?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  quizQuestionId?: InputMaybe<SortOrder>;
};

export type QuizQuestionAnswerRelationFilter = {
  is?: InputMaybe<QuizQuestionAnswerWhereInput>;
  isNot?: InputMaybe<QuizQuestionAnswerWhereInput>;
};

export enum QuizQuestionAnswerScalarFieldEnum {
  AnswerAr = 'answerAr',
  AnswerEn = 'answerEn',
  CreatedAt = 'createdAt',
  Id = 'id',
  QuizQuestionId = 'quizQuestionId'
}

export type QuizQuestionAnswerScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerScalarWhereInput>>>;
  answerAr?: InputMaybe<StringFilter>;
  answerEn?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  quizQuestionId?: InputMaybe<StringFilter>;
};

export type QuizQuestionAnswerScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerScalarWhereWithAggregatesInput>>>;
  answerAr?: InputMaybe<StringWithAggregatesFilter>;
  answerEn?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  quizQuestionId?: InputMaybe<StringWithAggregatesFilter>;
};

export type QuizQuestionAnswerUncheckedCreateInput = {
  QuizQuestion_QuizQuestion_rightAnswerToQuizQuestionAnswer?: InputMaybe<QuizQuestionUncheckedCreateNestedManyWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutQuizQuestionAnswerInput>;
  answerAr: Scalars['String'];
  answerEn: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  quizQuestionId: Scalars['String'];
};

export type QuizQuestionAnswerUncheckedCreateNestedManyWithoutQuizQuestionInput = {
  connect?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerCreateOrConnectWithoutQuizQuestionInput>>>;
  create?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerCreateWithoutQuizQuestionInput>>>;
  createMany?: InputMaybe<QuizQuestionAnswerCreateManyQuizQuestionInputEnvelope>;
};

export type QuizQuestionAnswerUncheckedCreateWithoutQuizQuestionInput = {
  QuizQuestion_QuizQuestion_rightAnswerToQuizQuestionAnswer?: InputMaybe<QuizQuestionUncheckedCreateNestedManyWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutQuizQuestionAnswerInput>;
  answerAr: Scalars['String'];
  answerEn: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
};

export type QuizQuestionAnswerUncheckedCreateWithoutQuizQuestion_QuizQuestion_RightAnswerToQuizQuestionAnswerInput = {
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutQuizQuestionAnswerInput>;
  answerAr: Scalars['String'];
  answerEn: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  quizQuestionId: Scalars['String'];
};

export type QuizQuestionAnswerUncheckedCreateWithoutQuizResultInput = {
  QuizQuestion_QuizQuestion_rightAnswerToQuizQuestionAnswer?: InputMaybe<QuizQuestionUncheckedCreateNestedManyWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>;
  answerAr: Scalars['String'];
  answerEn: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  quizQuestionId: Scalars['String'];
};

export type QuizQuestionAnswerUncheckedUpdateInput = {
  QuizQuestion_QuizQuestion_rightAnswerToQuizQuestionAnswer?: InputMaybe<QuizQuestionUncheckedUpdateManyWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutQuizQuestionAnswerInput>;
  answerAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  answerEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  quizQuestionId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type QuizQuestionAnswerUncheckedUpdateManyInput = {
  answerAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  answerEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  quizQuestionId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type QuizQuestionAnswerUncheckedUpdateManyWithoutQuizQuestionAnswerInput = {
  answerAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  answerEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type QuizQuestionAnswerUncheckedUpdateManyWithoutQuizQuestionInput = {
  connect?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerCreateOrConnectWithoutQuizQuestionInput>>>;
  create?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerCreateWithoutQuizQuestionInput>>>;
  createMany?: InputMaybe<QuizQuestionAnswerCreateManyQuizQuestionInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerUpdateWithWhereUniqueWithoutQuizQuestionInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerUpdateManyWithWhereWithoutQuizQuestionInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerUpsertWithWhereUniqueWithoutQuizQuestionInput>>>;
};

export type QuizQuestionAnswerUncheckedUpdateWithoutQuizQuestionInput = {
  QuizQuestion_QuizQuestion_rightAnswerToQuizQuestionAnswer?: InputMaybe<QuizQuestionUncheckedUpdateManyWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutQuizQuestionAnswerInput>;
  answerAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  answerEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type QuizQuestionAnswerUncheckedUpdateWithoutQuizQuestion_QuizQuestion_RightAnswerToQuizQuestionAnswerInput = {
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutQuizQuestionAnswerInput>;
  answerAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  answerEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  quizQuestionId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type QuizQuestionAnswerUncheckedUpdateWithoutQuizResultInput = {
  QuizQuestion_QuizQuestion_rightAnswerToQuizQuestionAnswer?: InputMaybe<QuizQuestionUncheckedUpdateManyWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>;
  answerAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  answerEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  quizQuestionId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type QuizQuestionAnswerUpdateInput = {
  QuizQuestion?: InputMaybe<QuizQuestionUpdateOneRequiredWithoutQuizQuestionAnswerInput>;
  QuizQuestion_QuizQuestion_rightAnswerToQuizQuestionAnswer?: InputMaybe<QuizQuestionUpdateManyWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutQuizQuestionAnswerInput>;
  answerAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  answerEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type QuizQuestionAnswerUpdateManyMutationInput = {
  answerAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  answerEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type QuizQuestionAnswerUpdateManyWithWhereWithoutQuizQuestionInput = {
  data: QuizQuestionAnswerUncheckedUpdateManyWithoutQuizQuestionAnswerInput;
  where: QuizQuestionAnswerScalarWhereInput;
};

export type QuizQuestionAnswerUpdateManyWithoutQuizQuestionInput = {
  connect?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerCreateOrConnectWithoutQuizQuestionInput>>>;
  create?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerCreateWithoutQuizQuestionInput>>>;
  createMany?: InputMaybe<QuizQuestionAnswerCreateManyQuizQuestionInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerUpdateWithWhereUniqueWithoutQuizQuestionInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerUpdateManyWithWhereWithoutQuizQuestionInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerUpsertWithWhereUniqueWithoutQuizQuestionInput>>>;
};

export type QuizQuestionAnswerUpdateOneRequiredWithoutQuizResultInput = {
  connect?: InputMaybe<QuizQuestionAnswerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuizQuestionAnswerCreateOrConnectWithoutQuizResultInput>;
  create?: InputMaybe<QuizQuestionAnswerUncheckedCreateWithoutQuizResultInput>;
  update?: InputMaybe<QuizQuestionAnswerUncheckedUpdateWithoutQuizResultInput>;
  upsert?: InputMaybe<QuizQuestionAnswerUpsertWithoutQuizResultInput>;
};

export type QuizQuestionAnswerUpdateOneWithoutQuizQuestion_QuizQuestion_RightAnswerToQuizQuestionAnswerInput = {
  connect?: InputMaybe<QuizQuestionAnswerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuizQuestionAnswerCreateOrConnectWithoutQuizQuestion_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>;
  create?: InputMaybe<QuizQuestionAnswerUncheckedCreateWithoutQuizQuestion_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<QuizQuestionAnswerUncheckedUpdateWithoutQuizQuestion_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>;
  upsert?: InputMaybe<QuizQuestionAnswerUpsertWithoutQuizQuestion_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>;
};

export type QuizQuestionAnswerUpdateWithWhereUniqueWithoutQuizQuestionInput = {
  data: QuizQuestionAnswerUncheckedUpdateWithoutQuizQuestionInput;
  where: QuizQuestionAnswerWhereUniqueInput;
};

export type QuizQuestionAnswerUpdateWithoutQuizQuestionInput = {
  QuizQuestion_QuizQuestion_rightAnswerToQuizQuestionAnswer?: InputMaybe<QuizQuestionUpdateManyWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutQuizQuestionAnswerInput>;
  answerAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  answerEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type QuizQuestionAnswerUpdateWithoutQuizQuestion_QuizQuestion_RightAnswerToQuizQuestionAnswerInput = {
  QuizQuestion?: InputMaybe<QuizQuestionUpdateOneRequiredWithoutQuizQuestionAnswerInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutQuizQuestionAnswerInput>;
  answerAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  answerEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type QuizQuestionAnswerUpdateWithoutQuizResultInput = {
  QuizQuestion?: InputMaybe<QuizQuestionUpdateOneRequiredWithoutQuizQuestionAnswerInput>;
  QuizQuestion_QuizQuestion_rightAnswerToQuizQuestionAnswer?: InputMaybe<QuizQuestionUpdateManyWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>;
  answerAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  answerEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type QuizQuestionAnswerUpsertWithWhereUniqueWithoutQuizQuestionInput = {
  create: QuizQuestionAnswerUncheckedCreateWithoutQuizQuestionInput;
  update: QuizQuestionAnswerUncheckedUpdateWithoutQuizQuestionInput;
  where: QuizQuestionAnswerWhereUniqueInput;
};

export type QuizQuestionAnswerUpsertWithoutQuizQuestion_QuizQuestion_RightAnswerToQuizQuestionAnswerInput = {
  create: QuizQuestionAnswerUncheckedCreateWithoutQuizQuestion_QuizQuestion_RightAnswerToQuizQuestionAnswerInput;
  update: QuizQuestionAnswerUncheckedUpdateWithoutQuizQuestion_QuizQuestion_RightAnswerToQuizQuestionAnswerInput;
};

export type QuizQuestionAnswerUpsertWithoutQuizResultInput = {
  create: QuizQuestionAnswerUncheckedCreateWithoutQuizResultInput;
  update: QuizQuestionAnswerUncheckedUpdateWithoutQuizResultInput;
};

export type QuizQuestionAnswerWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<QuizQuestionAnswerWhereInput>>>;
  QuizQuestion?: InputMaybe<QuizQuestionWhereInput>;
  QuizQuestion_QuizQuestion_rightAnswerToQuizQuestionAnswer?: InputMaybe<QuizQuestionListRelationFilter>;
  QuizResult?: InputMaybe<QuizResultListRelationFilter>;
  answerAr?: InputMaybe<StringFilter>;
  answerEn?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  quizQuestionId?: InputMaybe<StringFilter>;
};

export type QuizQuestionAnswerWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type QuizQuestionAvgAggregateOutputType = {
  __typename?: 'QuizQuestionAvgAggregateOutputType';
  questionOrder?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
};

export type QuizQuestionAvgOrderByAggregateInput = {
  questionOrder?: InputMaybe<SortOrder>;
  quizId?: InputMaybe<SortOrder>;
};

export type QuizQuestionCountAggregateOutputType = {
  __typename?: 'QuizQuestionCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  questionAr: Scalars['Int'];
  questionEn: Scalars['Int'];
  questionOrder: Scalars['Int'];
  questionType: Scalars['Int'];
  quizId: Scalars['Int'];
  rightAnswer: Scalars['Int'];
};

export type QuizQuestionCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  questionAr?: InputMaybe<SortOrder>;
  questionEn?: InputMaybe<SortOrder>;
  questionOrder?: InputMaybe<SortOrder>;
  questionType?: InputMaybe<SortOrder>;
  quizId?: InputMaybe<SortOrder>;
  rightAnswer?: InputMaybe<SortOrder>;
};

export type QuizQuestionCountOutputType = {
  __typename?: 'QuizQuestionCountOutputType';
  QuizQuestionAnswer: Scalars['Int'];
  QuizResult: Scalars['Int'];
};

export type QuizQuestionCreateInput = {
  Quiz: QuizCreateNestedOneWithoutQuizQuestionInput;
  QuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerCreateNestedManyWithoutQuizQuestionInput>;
  QuizQuestionAnswer_QuizQuestion_rightAnswerToQuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerCreateNestedOneWithoutQuizQuestion_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutQuizQuestionInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  questionAr: Scalars['String'];
  questionEn: Scalars['String'];
  questionOrder?: InputMaybe<Scalars['Int']>;
  questionType: Scalars['String'];
};

export type QuizQuestionCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  questionAr: Scalars['String'];
  questionEn: Scalars['String'];
  questionOrder?: InputMaybe<Scalars['Int']>;
  questionType: Scalars['String'];
  quizId: Scalars['Int'];
  rightAnswer?: InputMaybe<Scalars['String']>;
};

export type QuizQuestionCreateManyQuizInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  questionAr: Scalars['String'];
  questionEn: Scalars['String'];
  questionOrder?: InputMaybe<Scalars['Int']>;
  questionType: Scalars['String'];
  rightAnswer?: InputMaybe<Scalars['String']>;
};

export type QuizQuestionCreateManyQuizInputEnvelope = {
  data: QuizQuestionCreateManyQuizInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type QuizQuestionCreateManyQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  questionAr: Scalars['String'];
  questionEn: Scalars['String'];
  questionOrder?: InputMaybe<Scalars['Int']>;
  questionType: Scalars['String'];
  quizId: Scalars['Int'];
};

export type QuizQuestionCreateManyQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInputEnvelope = {
  data: QuizQuestionCreateManyQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type QuizQuestionCreateNestedManyWithoutQuizInput = {
  connect?: InputMaybe<Array<InputMaybe<QuizQuestionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<QuizQuestionCreateOrConnectWithoutQuizInput>>>;
  create?: InputMaybe<Array<InputMaybe<QuizQuestionCreateWithoutQuizInput>>>;
  createMany?: InputMaybe<QuizQuestionCreateManyQuizInputEnvelope>;
};

export type QuizQuestionCreateNestedManyWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput = {
  connect?: InputMaybe<Array<InputMaybe<QuizQuestionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<QuizQuestionCreateOrConnectWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>>>;
  create?: InputMaybe<Array<InputMaybe<QuizQuestionCreateWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>>>;
  createMany?: InputMaybe<QuizQuestionCreateManyQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInputEnvelope>;
};

export type QuizQuestionCreateNestedOneWithoutQuizQuestionAnswerInput = {
  connect?: InputMaybe<QuizQuestionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuizQuestionCreateOrConnectWithoutQuizQuestionAnswerInput>;
  create?: InputMaybe<QuizQuestionUncheckedCreateWithoutQuizQuestionAnswerInput>;
};

export type QuizQuestionCreateNestedOneWithoutQuizResultInput = {
  connect?: InputMaybe<QuizQuestionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuizQuestionCreateOrConnectWithoutQuizResultInput>;
  create?: InputMaybe<QuizQuestionUncheckedCreateWithoutQuizResultInput>;
};

export type QuizQuestionCreateOrConnectWithoutQuizInput = {
  create: QuizQuestionUncheckedCreateWithoutQuizInput;
  where: QuizQuestionWhereUniqueInput;
};

export type QuizQuestionCreateOrConnectWithoutQuizQuestionAnswerInput = {
  create: QuizQuestionUncheckedCreateWithoutQuizQuestionAnswerInput;
  where: QuizQuestionWhereUniqueInput;
};

export type QuizQuestionCreateOrConnectWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput = {
  create: QuizQuestionUncheckedCreateWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput;
  where: QuizQuestionWhereUniqueInput;
};

export type QuizQuestionCreateOrConnectWithoutQuizResultInput = {
  create: QuizQuestionUncheckedCreateWithoutQuizResultInput;
  where: QuizQuestionWhereUniqueInput;
};

export type QuizQuestionCreateWithoutQuizInput = {
  QuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerCreateNestedManyWithoutQuizQuestionInput>;
  QuizQuestionAnswer_QuizQuestion_rightAnswerToQuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerCreateNestedOneWithoutQuizQuestion_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutQuizQuestionInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  questionAr: Scalars['String'];
  questionEn: Scalars['String'];
  questionOrder?: InputMaybe<Scalars['Int']>;
  questionType: Scalars['String'];
};

export type QuizQuestionCreateWithoutQuizQuestionAnswerInput = {
  Quiz: QuizCreateNestedOneWithoutQuizQuestionInput;
  QuizQuestionAnswer_QuizQuestion_rightAnswerToQuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerCreateNestedOneWithoutQuizQuestion_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutQuizQuestionInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  questionAr: Scalars['String'];
  questionEn: Scalars['String'];
  questionOrder?: InputMaybe<Scalars['Int']>;
  questionType: Scalars['String'];
};

export type QuizQuestionCreateWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput = {
  Quiz: QuizCreateNestedOneWithoutQuizQuestionInput;
  QuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerCreateNestedManyWithoutQuizQuestionInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutQuizQuestionInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  questionAr: Scalars['String'];
  questionEn: Scalars['String'];
  questionOrder?: InputMaybe<Scalars['Int']>;
  questionType: Scalars['String'];
};

export type QuizQuestionCreateWithoutQuizResultInput = {
  Quiz: QuizCreateNestedOneWithoutQuizQuestionInput;
  QuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerCreateNestedManyWithoutQuizQuestionInput>;
  QuizQuestionAnswer_QuizQuestion_rightAnswerToQuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerCreateNestedOneWithoutQuizQuestion_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  questionAr: Scalars['String'];
  questionEn: Scalars['String'];
  questionOrder?: InputMaybe<Scalars['Int']>;
  questionType: Scalars['String'];
};

export type QuizQuestionListRelationFilter = {
  every?: InputMaybe<QuizQuestionWhereInput>;
  none?: InputMaybe<QuizQuestionWhereInput>;
  some?: InputMaybe<QuizQuestionWhereInput>;
};

export type QuizQuestionMaxAggregateOutputType = {
  __typename?: 'QuizQuestionMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  questionAr?: Maybe<Scalars['String']>;
  questionEn?: Maybe<Scalars['String']>;
  questionOrder?: Maybe<Scalars['Int']>;
  questionType?: Maybe<Scalars['String']>;
  quizId?: Maybe<Scalars['Int']>;
  rightAnswer?: Maybe<Scalars['String']>;
};

export type QuizQuestionMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  questionAr?: InputMaybe<SortOrder>;
  questionEn?: InputMaybe<SortOrder>;
  questionOrder?: InputMaybe<SortOrder>;
  questionType?: InputMaybe<SortOrder>;
  quizId?: InputMaybe<SortOrder>;
  rightAnswer?: InputMaybe<SortOrder>;
};

export type QuizQuestionMinAggregateOutputType = {
  __typename?: 'QuizQuestionMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  questionAr?: Maybe<Scalars['String']>;
  questionEn?: Maybe<Scalars['String']>;
  questionOrder?: Maybe<Scalars['Int']>;
  questionType?: Maybe<Scalars['String']>;
  quizId?: Maybe<Scalars['Int']>;
  rightAnswer?: Maybe<Scalars['String']>;
};

export type QuizQuestionMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  questionAr?: InputMaybe<SortOrder>;
  questionEn?: InputMaybe<SortOrder>;
  questionOrder?: InputMaybe<SortOrder>;
  questionType?: InputMaybe<SortOrder>;
  quizId?: InputMaybe<SortOrder>;
  rightAnswer?: InputMaybe<SortOrder>;
};

export type QuizQuestionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type QuizQuestionOrderByWithAggregationInput = {
  _avg?: InputMaybe<QuizQuestionAvgOrderByAggregateInput>;
  _count?: InputMaybe<QuizQuestionCountOrderByAggregateInput>;
  _max?: InputMaybe<QuizQuestionMaxOrderByAggregateInput>;
  _min?: InputMaybe<QuizQuestionMinOrderByAggregateInput>;
  _sum?: InputMaybe<QuizQuestionSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  questionAr?: InputMaybe<SortOrder>;
  questionEn?: InputMaybe<SortOrder>;
  questionOrder?: InputMaybe<SortOrder>;
  questionType?: InputMaybe<SortOrder>;
  quizId?: InputMaybe<SortOrder>;
  rightAnswer?: InputMaybe<SortOrder>;
};

export type QuizQuestionOrderByWithRelationInput = {
  Quiz?: InputMaybe<QuizOrderByWithRelationInput>;
  QuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerOrderByRelationAggregateInput>;
  QuizQuestionAnswer_QuizQuestion_rightAnswerToQuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerOrderByWithRelationInput>;
  QuizResult?: InputMaybe<QuizResultOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  questionAr?: InputMaybe<SortOrder>;
  questionEn?: InputMaybe<SortOrder>;
  questionOrder?: InputMaybe<SortOrder>;
  questionType?: InputMaybe<SortOrder>;
  quizId?: InputMaybe<SortOrder>;
  rightAnswer?: InputMaybe<SortOrder>;
};

export type QuizQuestionRelationFilter = {
  is?: InputMaybe<QuizQuestionWhereInput>;
  isNot?: InputMaybe<QuizQuestionWhereInput>;
};

export enum QuizQuestionScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  QuestionAr = 'questionAr',
  QuestionEn = 'questionEn',
  QuestionOrder = 'questionOrder',
  QuestionType = 'questionType',
  QuizId = 'quizId',
  RightAnswer = 'rightAnswer'
}

export type QuizQuestionScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<QuizQuestionScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<QuizQuestionScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<QuizQuestionScalarWhereInput>>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  questionAr?: InputMaybe<StringFilter>;
  questionEn?: InputMaybe<StringFilter>;
  questionOrder?: InputMaybe<IntNullableFilter>;
  questionType?: InputMaybe<StringFilter>;
  quizId?: InputMaybe<IntFilter>;
  rightAnswer?: InputMaybe<StringNullableFilter>;
};

export type QuizQuestionScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<QuizQuestionScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<QuizQuestionScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<QuizQuestionScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  questionAr?: InputMaybe<StringWithAggregatesFilter>;
  questionEn?: InputMaybe<StringWithAggregatesFilter>;
  questionOrder?: InputMaybe<IntNullableWithAggregatesFilter>;
  questionType?: InputMaybe<StringWithAggregatesFilter>;
  quizId?: InputMaybe<IntWithAggregatesFilter>;
  rightAnswer?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type QuizQuestionSumAggregateOutputType = {
  __typename?: 'QuizQuestionSumAggregateOutputType';
  questionOrder?: Maybe<Scalars['Int']>;
  quizId?: Maybe<Scalars['Int']>;
};

export type QuizQuestionSumOrderByAggregateInput = {
  questionOrder?: InputMaybe<SortOrder>;
  quizId?: InputMaybe<SortOrder>;
};

export type QuizQuestionUncheckedCreateInput = {
  QuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerUncheckedCreateNestedManyWithoutQuizQuestionInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutQuizQuestionInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  questionAr: Scalars['String'];
  questionEn: Scalars['String'];
  questionOrder?: InputMaybe<Scalars['Int']>;
  questionType: Scalars['String'];
  quizId: Scalars['Int'];
  rightAnswer?: InputMaybe<Scalars['String']>;
};

export type QuizQuestionUncheckedCreateNestedManyWithoutQuizInput = {
  connect?: InputMaybe<Array<InputMaybe<QuizQuestionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<QuizQuestionCreateOrConnectWithoutQuizInput>>>;
  create?: InputMaybe<Array<InputMaybe<QuizQuestionCreateWithoutQuizInput>>>;
  createMany?: InputMaybe<QuizQuestionCreateManyQuizInputEnvelope>;
};

export type QuizQuestionUncheckedCreateNestedManyWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput = {
  connect?: InputMaybe<Array<InputMaybe<QuizQuestionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<QuizQuestionCreateOrConnectWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>>>;
  create?: InputMaybe<Array<InputMaybe<QuizQuestionCreateWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>>>;
  createMany?: InputMaybe<QuizQuestionCreateManyQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInputEnvelope>;
};

export type QuizQuestionUncheckedCreateWithoutQuizInput = {
  QuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerUncheckedCreateNestedManyWithoutQuizQuestionInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutQuizQuestionInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  questionAr: Scalars['String'];
  questionEn: Scalars['String'];
  questionOrder?: InputMaybe<Scalars['Int']>;
  questionType: Scalars['String'];
  rightAnswer?: InputMaybe<Scalars['String']>;
};

export type QuizQuestionUncheckedCreateWithoutQuizQuestionAnswerInput = {
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutQuizQuestionInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  questionAr: Scalars['String'];
  questionEn: Scalars['String'];
  questionOrder?: InputMaybe<Scalars['Int']>;
  questionType: Scalars['String'];
  quizId: Scalars['Int'];
  rightAnswer?: InputMaybe<Scalars['String']>;
};

export type QuizQuestionUncheckedCreateWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput = {
  QuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerUncheckedCreateNestedManyWithoutQuizQuestionInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutQuizQuestionInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  questionAr: Scalars['String'];
  questionEn: Scalars['String'];
  questionOrder?: InputMaybe<Scalars['Int']>;
  questionType: Scalars['String'];
  quizId: Scalars['Int'];
};

export type QuizQuestionUncheckedCreateWithoutQuizResultInput = {
  QuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerUncheckedCreateNestedManyWithoutQuizQuestionInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  questionAr: Scalars['String'];
  questionEn: Scalars['String'];
  questionOrder?: InputMaybe<Scalars['Int']>;
  questionType: Scalars['String'];
  quizId: Scalars['Int'];
  rightAnswer?: InputMaybe<Scalars['String']>;
};

export type QuizQuestionUncheckedUpdateInput = {
  QuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerUncheckedUpdateManyWithoutQuizQuestionInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutQuizQuestionInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  questionType?: InputMaybe<StringFieldUpdateOperationsInput>;
  quizId?: InputMaybe<IntFieldUpdateOperationsInput>;
  rightAnswer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type QuizQuestionUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  questionType?: InputMaybe<StringFieldUpdateOperationsInput>;
  quizId?: InputMaybe<IntFieldUpdateOperationsInput>;
  rightAnswer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type QuizQuestionUncheckedUpdateManyWithoutQuizInput = {
  connect?: InputMaybe<Array<InputMaybe<QuizQuestionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<QuizQuestionCreateOrConnectWithoutQuizInput>>>;
  create?: InputMaybe<Array<InputMaybe<QuizQuestionCreateWithoutQuizInput>>>;
  createMany?: InputMaybe<QuizQuestionCreateManyQuizInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<QuizQuestionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<QuizQuestionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<QuizQuestionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<QuizQuestionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<QuizQuestionUpdateWithWhereUniqueWithoutQuizInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<QuizQuestionUpdateManyWithWhereWithoutQuizInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<QuizQuestionUpsertWithWhereUniqueWithoutQuizInput>>>;
};

export type QuizQuestionUncheckedUpdateManyWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput = {
  connect?: InputMaybe<Array<InputMaybe<QuizQuestionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<QuizQuestionCreateOrConnectWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>>>;
  create?: InputMaybe<Array<InputMaybe<QuizQuestionCreateWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>>>;
  createMany?: InputMaybe<QuizQuestionCreateManyQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<QuizQuestionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<QuizQuestionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<QuizQuestionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<QuizQuestionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<QuizQuestionUpdateWithWhereUniqueWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<QuizQuestionUpdateManyWithWhereWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<QuizQuestionUpsertWithWhereUniqueWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>>>;
};

export type QuizQuestionUncheckedUpdateManyWithoutQuizQuestionInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  questionType?: InputMaybe<StringFieldUpdateOperationsInput>;
  rightAnswer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type QuizQuestionUncheckedUpdateManyWithoutQuizQuestion_QuizQuestion_RightAnswerToQuizQuestionAnswerInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  questionType?: InputMaybe<StringFieldUpdateOperationsInput>;
  quizId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type QuizQuestionUncheckedUpdateWithoutQuizInput = {
  QuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerUncheckedUpdateManyWithoutQuizQuestionInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutQuizQuestionInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  questionType?: InputMaybe<StringFieldUpdateOperationsInput>;
  rightAnswer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type QuizQuestionUncheckedUpdateWithoutQuizQuestionAnswerInput = {
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutQuizQuestionInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  questionType?: InputMaybe<StringFieldUpdateOperationsInput>;
  quizId?: InputMaybe<IntFieldUpdateOperationsInput>;
  rightAnswer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type QuizQuestionUncheckedUpdateWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput = {
  QuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerUncheckedUpdateManyWithoutQuizQuestionInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutQuizQuestionInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  questionType?: InputMaybe<StringFieldUpdateOperationsInput>;
  quizId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type QuizQuestionUncheckedUpdateWithoutQuizResultInput = {
  QuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerUncheckedUpdateManyWithoutQuizQuestionInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  questionType?: InputMaybe<StringFieldUpdateOperationsInput>;
  quizId?: InputMaybe<IntFieldUpdateOperationsInput>;
  rightAnswer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type QuizQuestionUpdateInput = {
  Quiz?: InputMaybe<QuizUpdateOneRequiredWithoutQuizQuestionInput>;
  QuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerUpdateManyWithoutQuizQuestionInput>;
  QuizQuestionAnswer_QuizQuestion_rightAnswerToQuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerUpdateOneWithoutQuizQuestion_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutQuizQuestionInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  questionType?: InputMaybe<StringFieldUpdateOperationsInput>;
};

/** Quiz Question Update many Input */
export type QuizQuestionUpdateManyInput = {
  id: Scalars['String'];
  questionOrder: Scalars['Int'];
};

export type QuizQuestionUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  questionType?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type QuizQuestionUpdateManyWithWhereWithoutQuizInput = {
  data: QuizQuestionUncheckedUpdateManyWithoutQuizQuestionInput;
  where: QuizQuestionScalarWhereInput;
};

export type QuizQuestionUpdateManyWithWhereWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput = {
  data: QuizQuestionUncheckedUpdateManyWithoutQuizQuestion_QuizQuestion_RightAnswerToQuizQuestionAnswerInput;
  where: QuizQuestionScalarWhereInput;
};

export type QuizQuestionUpdateManyWithoutQuizInput = {
  connect?: InputMaybe<Array<InputMaybe<QuizQuestionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<QuizQuestionCreateOrConnectWithoutQuizInput>>>;
  create?: InputMaybe<Array<InputMaybe<QuizQuestionCreateWithoutQuizInput>>>;
  createMany?: InputMaybe<QuizQuestionCreateManyQuizInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<QuizQuestionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<QuizQuestionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<QuizQuestionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<QuizQuestionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<QuizQuestionUpdateWithWhereUniqueWithoutQuizInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<QuizQuestionUpdateManyWithWhereWithoutQuizInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<QuizQuestionUpsertWithWhereUniqueWithoutQuizInput>>>;
};

export type QuizQuestionUpdateManyWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput = {
  connect?: InputMaybe<Array<InputMaybe<QuizQuestionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<QuizQuestionCreateOrConnectWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>>>;
  create?: InputMaybe<Array<InputMaybe<QuizQuestionCreateWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>>>;
  createMany?: InputMaybe<QuizQuestionCreateManyQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<QuizQuestionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<QuizQuestionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<QuizQuestionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<QuizQuestionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<QuizQuestionUpdateWithWhereUniqueWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<QuizQuestionUpdateManyWithWhereWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<QuizQuestionUpsertWithWhereUniqueWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>>>;
};

export type QuizQuestionUpdateOneRequiredWithoutQuizQuestionAnswerInput = {
  connect?: InputMaybe<QuizQuestionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuizQuestionCreateOrConnectWithoutQuizQuestionAnswerInput>;
  create?: InputMaybe<QuizQuestionUncheckedCreateWithoutQuizQuestionAnswerInput>;
  update?: InputMaybe<QuizQuestionUncheckedUpdateWithoutQuizQuestionAnswerInput>;
  upsert?: InputMaybe<QuizQuestionUpsertWithoutQuizQuestionAnswerInput>;
};

export type QuizQuestionUpdateOneRequiredWithoutQuizResultInput = {
  connect?: InputMaybe<QuizQuestionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuizQuestionCreateOrConnectWithoutQuizResultInput>;
  create?: InputMaybe<QuizQuestionUncheckedCreateWithoutQuizResultInput>;
  update?: InputMaybe<QuizQuestionUncheckedUpdateWithoutQuizResultInput>;
  upsert?: InputMaybe<QuizQuestionUpsertWithoutQuizResultInput>;
};

export type QuizQuestionUpdateWithWhereUniqueWithoutQuizInput = {
  data: QuizQuestionUncheckedUpdateWithoutQuizInput;
  where: QuizQuestionWhereUniqueInput;
};

export type QuizQuestionUpdateWithWhereUniqueWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput = {
  data: QuizQuestionUncheckedUpdateWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput;
  where: QuizQuestionWhereUniqueInput;
};

export type QuizQuestionUpdateWithoutQuizInput = {
  QuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerUpdateManyWithoutQuizQuestionInput>;
  QuizQuestionAnswer_QuizQuestion_rightAnswerToQuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerUpdateOneWithoutQuizQuestion_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutQuizQuestionInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  questionType?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type QuizQuestionUpdateWithoutQuizQuestionAnswerInput = {
  Quiz?: InputMaybe<QuizUpdateOneRequiredWithoutQuizQuestionInput>;
  QuizQuestionAnswer_QuizQuestion_rightAnswerToQuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerUpdateOneWithoutQuizQuestion_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutQuizQuestionInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  questionType?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type QuizQuestionUpdateWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput = {
  Quiz?: InputMaybe<QuizUpdateOneRequiredWithoutQuizQuestionInput>;
  QuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerUpdateManyWithoutQuizQuestionInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutQuizQuestionInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  questionType?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type QuizQuestionUpdateWithoutQuizResultInput = {
  Quiz?: InputMaybe<QuizUpdateOneRequiredWithoutQuizQuestionInput>;
  QuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerUpdateManyWithoutQuizQuestionInput>;
  QuizQuestionAnswer_QuizQuestion_rightAnswerToQuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerUpdateOneWithoutQuizQuestion_QuizQuestion_RightAnswerToQuizQuestionAnswerInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  questionOrder?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  questionType?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type QuizQuestionUpsertWithWhereUniqueWithoutQuizInput = {
  create: QuizQuestionUncheckedCreateWithoutQuizInput;
  update: QuizQuestionUncheckedUpdateWithoutQuizInput;
  where: QuizQuestionWhereUniqueInput;
};

export type QuizQuestionUpsertWithWhereUniqueWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput = {
  create: QuizQuestionUncheckedCreateWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput;
  update: QuizQuestionUncheckedUpdateWithoutQuizQuestionAnswer_QuizQuestion_RightAnswerToQuizQuestionAnswerInput;
  where: QuizQuestionWhereUniqueInput;
};

export type QuizQuestionUpsertWithoutQuizQuestionAnswerInput = {
  create: QuizQuestionUncheckedCreateWithoutQuizQuestionAnswerInput;
  update: QuizQuestionUncheckedUpdateWithoutQuizQuestionAnswerInput;
};

export type QuizQuestionUpsertWithoutQuizResultInput = {
  create: QuizQuestionUncheckedCreateWithoutQuizResultInput;
  update: QuizQuestionUncheckedUpdateWithoutQuizResultInput;
};

export type QuizQuestionWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<QuizQuestionWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<QuizQuestionWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<QuizQuestionWhereInput>>>;
  Quiz?: InputMaybe<QuizWhereInput>;
  QuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerListRelationFilter>;
  QuizQuestionAnswer_QuizQuestion_rightAnswerToQuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerWhereInput>;
  QuizResult?: InputMaybe<QuizResultListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  questionAr?: InputMaybe<StringFilter>;
  questionEn?: InputMaybe<StringFilter>;
  questionOrder?: InputMaybe<IntNullableFilter>;
  questionType?: InputMaybe<StringFilter>;
  quizId?: InputMaybe<IntFilter>;
  rightAnswer?: InputMaybe<StringNullableFilter>;
};

export type QuizQuestionWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type QuizRelationFilter = {
  is?: InputMaybe<QuizWhereInput>;
  isNot?: InputMaybe<QuizWhereInput>;
};

export type QuizResult = {
  __typename?: 'QuizResult';
  Event: Event;
  Quiz: Quiz;
  QuizQuestion: QuizQuestion;
  QuizQuestionAnswer: QuizQuestionAnswer;
  User: User;
  eventId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  quizId?: Maybe<Scalars['Int']>;
  quizQuestionAnswerId?: Maybe<Scalars['String']>;
  quizQuestionId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
};

export type QuizResultAvgAggregateOutputType = {
  __typename?: 'QuizResultAvgAggregateOutputType';
  eventId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

export type QuizResultAvgOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  quizId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type QuizResultCountAggregateOutputType = {
  __typename?: 'QuizResultCountAggregateOutputType';
  _all: Scalars['Int'];
  eventId: Scalars['Int'];
  id: Scalars['Int'];
  quizId: Scalars['Int'];
  quizQuestionAnswerId: Scalars['Int'];
  quizQuestionId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type QuizResultCountOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  quizId?: InputMaybe<SortOrder>;
  quizQuestionAnswerId?: InputMaybe<SortOrder>;
  quizQuestionId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type QuizResultCreateInput = {
  Event?: InputMaybe<EventCreateNestedOneWithoutQuizResultInput>;
  Quiz: QuizCreateNestedOneWithoutQuizResultInput;
  QuizQuestion: QuizQuestionCreateNestedOneWithoutQuizResultInput;
  QuizQuestionAnswer: QuizQuestionAnswerCreateNestedOneWithoutQuizResultInput;
  User: UserCreateNestedOneWithoutQuizResultInput;
};

export type QuizResultCreateManyEventInput = {
  id?: InputMaybe<Scalars['Int']>;
  quizId: Scalars['Int'];
  quizQuestionAnswerId: Scalars['String'];
  quizQuestionId: Scalars['String'];
  userId: Scalars['Int'];
};

export type QuizResultCreateManyEventInputEnvelope = {
  data: QuizResultCreateManyEventInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type QuizResultCreateManyInput = {
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  quizId: Scalars['Int'];
  quizQuestionAnswerId: Scalars['String'];
  quizQuestionId: Scalars['String'];
  userId: Scalars['Int'];
};

export type QuizResultCreateManyQuizInput = {
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  quizQuestionAnswerId: Scalars['String'];
  quizQuestionId: Scalars['String'];
  userId: Scalars['Int'];
};

export type QuizResultCreateManyQuizInputEnvelope = {
  data: QuizResultCreateManyQuizInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type QuizResultCreateManyQuizQuestionAnswerInput = {
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  quizId: Scalars['Int'];
  quizQuestionId: Scalars['String'];
  userId: Scalars['Int'];
};

export type QuizResultCreateManyQuizQuestionAnswerInputEnvelope = {
  data: QuizResultCreateManyQuizQuestionAnswerInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type QuizResultCreateManyQuizQuestionInput = {
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  quizId: Scalars['Int'];
  quizQuestionAnswerId: Scalars['String'];
  userId: Scalars['Int'];
};

export type QuizResultCreateManyQuizQuestionInputEnvelope = {
  data: QuizResultCreateManyQuizQuestionInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type QuizResultCreateManyUserInput = {
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  quizId: Scalars['Int'];
  quizQuestionAnswerId: Scalars['String'];
  quizQuestionId: Scalars['String'];
};

export type QuizResultCreateManyUserInputEnvelope = {
  data: QuizResultCreateManyUserInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type QuizResultCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<QuizResultCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<QuizResultCreateWithoutEventInput>>>;
  createMany?: InputMaybe<QuizResultCreateManyEventInputEnvelope>;
};

export type QuizResultCreateNestedManyWithoutQuizInput = {
  connect?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<QuizResultCreateOrConnectWithoutQuizInput>>>;
  create?: InputMaybe<Array<InputMaybe<QuizResultCreateWithoutQuizInput>>>;
  createMany?: InputMaybe<QuizResultCreateManyQuizInputEnvelope>;
};

export type QuizResultCreateNestedManyWithoutQuizQuestionAnswerInput = {
  connect?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<QuizResultCreateOrConnectWithoutQuizQuestionAnswerInput>>>;
  create?: InputMaybe<Array<InputMaybe<QuizResultCreateWithoutQuizQuestionAnswerInput>>>;
  createMany?: InputMaybe<QuizResultCreateManyQuizQuestionAnswerInputEnvelope>;
};

export type QuizResultCreateNestedManyWithoutQuizQuestionInput = {
  connect?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<QuizResultCreateOrConnectWithoutQuizQuestionInput>>>;
  create?: InputMaybe<Array<InputMaybe<QuizResultCreateWithoutQuizQuestionInput>>>;
  createMany?: InputMaybe<QuizResultCreateManyQuizQuestionInputEnvelope>;
};

export type QuizResultCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<QuizResultCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<QuizResultCreateWithoutUserInput>>>;
  createMany?: InputMaybe<QuizResultCreateManyUserInputEnvelope>;
};

/** Input type for creating a QuizResult */
export type QuizResultCreateOneInput = {
  eventId?: InputMaybe<Scalars['Int']>;
  quizId?: InputMaybe<Scalars['Int']>;
  quizQuestionAnswerId?: InputMaybe<Scalars['String']>;
  quizQuestionId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type QuizResultCreateOrConnectWithoutEventInput = {
  create: QuizResultUncheckedCreateWithoutEventInput;
  where: QuizResultWhereUniqueInput;
};

export type QuizResultCreateOrConnectWithoutQuizInput = {
  create: QuizResultUncheckedCreateWithoutQuizInput;
  where: QuizResultWhereUniqueInput;
};

export type QuizResultCreateOrConnectWithoutQuizQuestionAnswerInput = {
  create: QuizResultUncheckedCreateWithoutQuizQuestionAnswerInput;
  where: QuizResultWhereUniqueInput;
};

export type QuizResultCreateOrConnectWithoutQuizQuestionInput = {
  create: QuizResultUncheckedCreateWithoutQuizQuestionInput;
  where: QuizResultWhereUniqueInput;
};

export type QuizResultCreateOrConnectWithoutUserInput = {
  create: QuizResultUncheckedCreateWithoutUserInput;
  where: QuizResultWhereUniqueInput;
};

export type QuizResultCreateWithoutEventInput = {
  Quiz: QuizCreateNestedOneWithoutQuizResultInput;
  QuizQuestion: QuizQuestionCreateNestedOneWithoutQuizResultInput;
  QuizQuestionAnswer: QuizQuestionAnswerCreateNestedOneWithoutQuizResultInput;
  User: UserCreateNestedOneWithoutQuizResultInput;
};

export type QuizResultCreateWithoutQuizInput = {
  Event?: InputMaybe<EventCreateNestedOneWithoutQuizResultInput>;
  QuizQuestion: QuizQuestionCreateNestedOneWithoutQuizResultInput;
  QuizQuestionAnswer: QuizQuestionAnswerCreateNestedOneWithoutQuizResultInput;
  User: UserCreateNestedOneWithoutQuizResultInput;
};

export type QuizResultCreateWithoutQuizQuestionAnswerInput = {
  Event?: InputMaybe<EventCreateNestedOneWithoutQuizResultInput>;
  Quiz: QuizCreateNestedOneWithoutQuizResultInput;
  QuizQuestion: QuizQuestionCreateNestedOneWithoutQuizResultInput;
  User: UserCreateNestedOneWithoutQuizResultInput;
};

export type QuizResultCreateWithoutQuizQuestionInput = {
  Event?: InputMaybe<EventCreateNestedOneWithoutQuizResultInput>;
  Quiz: QuizCreateNestedOneWithoutQuizResultInput;
  QuizQuestionAnswer: QuizQuestionAnswerCreateNestedOneWithoutQuizResultInput;
  User: UserCreateNestedOneWithoutQuizResultInput;
};

export type QuizResultCreateWithoutUserInput = {
  Event?: InputMaybe<EventCreateNestedOneWithoutQuizResultInput>;
  Quiz: QuizCreateNestedOneWithoutQuizResultInput;
  QuizQuestion: QuizQuestionCreateNestedOneWithoutQuizResultInput;
  QuizQuestionAnswer: QuizQuestionAnswerCreateNestedOneWithoutQuizResultInput;
};

export type QuizResultListRelationFilter = {
  every?: InputMaybe<QuizResultWhereInput>;
  none?: InputMaybe<QuizResultWhereInput>;
  some?: InputMaybe<QuizResultWhereInput>;
};

export type QuizResultMaxAggregateOutputType = {
  __typename?: 'QuizResultMaxAggregateOutputType';
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  quizId?: Maybe<Scalars['Int']>;
  quizQuestionAnswerId?: Maybe<Scalars['String']>;
  quizQuestionId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
};

export type QuizResultMaxOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  quizId?: InputMaybe<SortOrder>;
  quizQuestionAnswerId?: InputMaybe<SortOrder>;
  quizQuestionId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type QuizResultMinAggregateOutputType = {
  __typename?: 'QuizResultMinAggregateOutputType';
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  quizId?: Maybe<Scalars['Int']>;
  quizQuestionAnswerId?: Maybe<Scalars['String']>;
  quizQuestionId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
};

export type QuizResultMinOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  quizId?: InputMaybe<SortOrder>;
  quizQuestionAnswerId?: InputMaybe<SortOrder>;
  quizQuestionId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type QuizResultOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type QuizResultOrderByWithAggregationInput = {
  _avg?: InputMaybe<QuizResultAvgOrderByAggregateInput>;
  _count?: InputMaybe<QuizResultCountOrderByAggregateInput>;
  _max?: InputMaybe<QuizResultMaxOrderByAggregateInput>;
  _min?: InputMaybe<QuizResultMinOrderByAggregateInput>;
  _sum?: InputMaybe<QuizResultSumOrderByAggregateInput>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  quizId?: InputMaybe<SortOrder>;
  quizQuestionAnswerId?: InputMaybe<SortOrder>;
  quizQuestionId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type QuizResultOrderByWithRelationInput = {
  Event?: InputMaybe<EventOrderByWithRelationInput>;
  Quiz?: InputMaybe<QuizOrderByWithRelationInput>;
  QuizQuestion?: InputMaybe<QuizQuestionOrderByWithRelationInput>;
  QuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerOrderByWithRelationInput>;
  User?: InputMaybe<UserOrderByWithRelationInput>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  quizId?: InputMaybe<SortOrder>;
  quizQuestionAnswerId?: InputMaybe<SortOrder>;
  quizQuestionId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export enum QuizResultScalarFieldEnum {
  EventId = 'eventId',
  Id = 'id',
  QuizId = 'quizId',
  QuizQuestionAnswerId = 'quizQuestionAnswerId',
  QuizQuestionId = 'quizQuestionId',
  UserId = 'userId'
}

export type QuizResultScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<QuizResultScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<QuizResultScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<QuizResultScalarWhereInput>>>;
  eventId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  quizId?: InputMaybe<IntFilter>;
  quizQuestionAnswerId?: InputMaybe<StringFilter>;
  quizQuestionId?: InputMaybe<StringFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type QuizResultScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<QuizResultScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<QuizResultScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<QuizResultScalarWhereWithAggregatesInput>>>;
  eventId?: InputMaybe<IntNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  quizId?: InputMaybe<IntWithAggregatesFilter>;
  quizQuestionAnswerId?: InputMaybe<StringWithAggregatesFilter>;
  quizQuestionId?: InputMaybe<StringWithAggregatesFilter>;
  userId?: InputMaybe<IntWithAggregatesFilter>;
};

export type QuizResultSumAggregateOutputType = {
  __typename?: 'QuizResultSumAggregateOutputType';
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  quizId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

export type QuizResultSumOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  quizId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type QuizResultUncheckedCreateInput = {
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  quizId: Scalars['Int'];
  quizQuestionAnswerId: Scalars['String'];
  quizQuestionId: Scalars['String'];
  userId: Scalars['Int'];
};

export type QuizResultUncheckedCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<QuizResultCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<QuizResultCreateWithoutEventInput>>>;
  createMany?: InputMaybe<QuizResultCreateManyEventInputEnvelope>;
};

export type QuizResultUncheckedCreateNestedManyWithoutQuizInput = {
  connect?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<QuizResultCreateOrConnectWithoutQuizInput>>>;
  create?: InputMaybe<Array<InputMaybe<QuizResultCreateWithoutQuizInput>>>;
  createMany?: InputMaybe<QuizResultCreateManyQuizInputEnvelope>;
};

export type QuizResultUncheckedCreateNestedManyWithoutQuizQuestionAnswerInput = {
  connect?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<QuizResultCreateOrConnectWithoutQuizQuestionAnswerInput>>>;
  create?: InputMaybe<Array<InputMaybe<QuizResultCreateWithoutQuizQuestionAnswerInput>>>;
  createMany?: InputMaybe<QuizResultCreateManyQuizQuestionAnswerInputEnvelope>;
};

export type QuizResultUncheckedCreateNestedManyWithoutQuizQuestionInput = {
  connect?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<QuizResultCreateOrConnectWithoutQuizQuestionInput>>>;
  create?: InputMaybe<Array<InputMaybe<QuizResultCreateWithoutQuizQuestionInput>>>;
  createMany?: InputMaybe<QuizResultCreateManyQuizQuestionInputEnvelope>;
};

export type QuizResultUncheckedCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<QuizResultCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<QuizResultCreateWithoutUserInput>>>;
  createMany?: InputMaybe<QuizResultCreateManyUserInputEnvelope>;
};

export type QuizResultUncheckedCreateWithoutEventInput = {
  id?: InputMaybe<Scalars['Int']>;
  quizId: Scalars['Int'];
  quizQuestionAnswerId: Scalars['String'];
  quizQuestionId: Scalars['String'];
  userId: Scalars['Int'];
};

export type QuizResultUncheckedCreateWithoutQuizInput = {
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  quizQuestionAnswerId: Scalars['String'];
  quizQuestionId: Scalars['String'];
  userId: Scalars['Int'];
};

export type QuizResultUncheckedCreateWithoutQuizQuestionAnswerInput = {
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  quizId: Scalars['Int'];
  quizQuestionId: Scalars['String'];
  userId: Scalars['Int'];
};

export type QuizResultUncheckedCreateWithoutQuizQuestionInput = {
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  quizId: Scalars['Int'];
  quizQuestionAnswerId: Scalars['String'];
  userId: Scalars['Int'];
};

export type QuizResultUncheckedCreateWithoutUserInput = {
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  quizId: Scalars['Int'];
  quizQuestionAnswerId: Scalars['String'];
  quizQuestionId: Scalars['String'];
};

export type QuizResultUncheckedUpdateInput = {
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  quizId?: InputMaybe<IntFieldUpdateOperationsInput>;
  quizQuestionAnswerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  quizQuestionId?: InputMaybe<StringFieldUpdateOperationsInput>;
  userId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type QuizResultUncheckedUpdateManyInput = {
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  quizId?: InputMaybe<IntFieldUpdateOperationsInput>;
  quizQuestionAnswerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  quizQuestionId?: InputMaybe<StringFieldUpdateOperationsInput>;
  userId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type QuizResultUncheckedUpdateManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<QuizResultCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<QuizResultCreateWithoutEventInput>>>;
  createMany?: InputMaybe<QuizResultCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<QuizResultScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<QuizResultUpdateWithWhereUniqueWithoutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<QuizResultUpdateManyWithWhereWithoutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<QuizResultUpsertWithWhereUniqueWithoutEventInput>>>;
};

export type QuizResultUncheckedUpdateManyWithoutQuizInput = {
  connect?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<QuizResultCreateOrConnectWithoutQuizInput>>>;
  create?: InputMaybe<Array<InputMaybe<QuizResultCreateWithoutQuizInput>>>;
  createMany?: InputMaybe<QuizResultCreateManyQuizInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<QuizResultScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<QuizResultUpdateWithWhereUniqueWithoutQuizInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<QuizResultUpdateManyWithWhereWithoutQuizInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<QuizResultUpsertWithWhereUniqueWithoutQuizInput>>>;
};

export type QuizResultUncheckedUpdateManyWithoutQuizQuestionAnswerInput = {
  connect?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<QuizResultCreateOrConnectWithoutQuizQuestionAnswerInput>>>;
  create?: InputMaybe<Array<InputMaybe<QuizResultCreateWithoutQuizQuestionAnswerInput>>>;
  createMany?: InputMaybe<QuizResultCreateManyQuizQuestionAnswerInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<QuizResultScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<QuizResultUpdateWithWhereUniqueWithoutQuizQuestionAnswerInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<QuizResultUpdateManyWithWhereWithoutQuizQuestionAnswerInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<QuizResultUpsertWithWhereUniqueWithoutQuizQuestionAnswerInput>>>;
};

export type QuizResultUncheckedUpdateManyWithoutQuizQuestionInput = {
  connect?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<QuizResultCreateOrConnectWithoutQuizQuestionInput>>>;
  create?: InputMaybe<Array<InputMaybe<QuizResultCreateWithoutQuizQuestionInput>>>;
  createMany?: InputMaybe<QuizResultCreateManyQuizQuestionInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<QuizResultScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<QuizResultUpdateWithWhereUniqueWithoutQuizQuestionInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<QuizResultUpdateManyWithWhereWithoutQuizQuestionInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<QuizResultUpsertWithWhereUniqueWithoutQuizQuestionInput>>>;
};

export type QuizResultUncheckedUpdateManyWithoutQuizResultInput = {
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  quizId?: InputMaybe<IntFieldUpdateOperationsInput>;
  quizQuestionAnswerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  quizQuestionId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type QuizResultUncheckedUpdateManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<QuizResultCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<QuizResultCreateWithoutUserInput>>>;
  createMany?: InputMaybe<QuizResultCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<QuizResultScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<QuizResultUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<QuizResultUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<QuizResultUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type QuizResultUncheckedUpdateWithoutEventInput = {
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  quizId?: InputMaybe<IntFieldUpdateOperationsInput>;
  quizQuestionAnswerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  quizQuestionId?: InputMaybe<StringFieldUpdateOperationsInput>;
  userId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type QuizResultUncheckedUpdateWithoutQuizInput = {
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  quizQuestionAnswerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  quizQuestionId?: InputMaybe<StringFieldUpdateOperationsInput>;
  userId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type QuizResultUncheckedUpdateWithoutQuizQuestionAnswerInput = {
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  quizId?: InputMaybe<IntFieldUpdateOperationsInput>;
  quizQuestionId?: InputMaybe<StringFieldUpdateOperationsInput>;
  userId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type QuizResultUncheckedUpdateWithoutQuizQuestionInput = {
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  quizId?: InputMaybe<IntFieldUpdateOperationsInput>;
  quizQuestionAnswerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  userId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type QuizResultUncheckedUpdateWithoutUserInput = {
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  quizId?: InputMaybe<IntFieldUpdateOperationsInput>;
  quizQuestionAnswerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  quizQuestionId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type QuizResultUpdateInput = {
  Event?: InputMaybe<EventUpdateOneWithoutQuizResultInput>;
  Quiz?: InputMaybe<QuizUpdateOneRequiredWithoutQuizResultInput>;
  QuizQuestion?: InputMaybe<QuizQuestionUpdateOneRequiredWithoutQuizResultInput>;
  QuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerUpdateOneRequiredWithoutQuizResultInput>;
  User?: InputMaybe<UserUpdateOneRequiredWithoutQuizResultInput>;
};

export type QuizResultUpdateManyWithWhereWithoutEventInput = {
  data: QuizResultUncheckedUpdateManyWithoutQuizResultInput;
  where: QuizResultScalarWhereInput;
};

export type QuizResultUpdateManyWithWhereWithoutQuizInput = {
  data: QuizResultUncheckedUpdateManyWithoutQuizResultInput;
  where: QuizResultScalarWhereInput;
};

export type QuizResultUpdateManyWithWhereWithoutQuizQuestionAnswerInput = {
  data: QuizResultUncheckedUpdateManyWithoutQuizResultInput;
  where: QuizResultScalarWhereInput;
};

export type QuizResultUpdateManyWithWhereWithoutQuizQuestionInput = {
  data: QuizResultUncheckedUpdateManyWithoutQuizResultInput;
  where: QuizResultScalarWhereInput;
};

export type QuizResultUpdateManyWithWhereWithoutUserInput = {
  data: QuizResultUncheckedUpdateManyWithoutQuizResultInput;
  where: QuizResultScalarWhereInput;
};

export type QuizResultUpdateManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<QuizResultCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<QuizResultCreateWithoutEventInput>>>;
  createMany?: InputMaybe<QuizResultCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<QuizResultScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<QuizResultUpdateWithWhereUniqueWithoutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<QuizResultUpdateManyWithWhereWithoutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<QuizResultUpsertWithWhereUniqueWithoutEventInput>>>;
};

export type QuizResultUpdateManyWithoutQuizInput = {
  connect?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<QuizResultCreateOrConnectWithoutQuizInput>>>;
  create?: InputMaybe<Array<InputMaybe<QuizResultCreateWithoutQuizInput>>>;
  createMany?: InputMaybe<QuizResultCreateManyQuizInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<QuizResultScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<QuizResultUpdateWithWhereUniqueWithoutQuizInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<QuizResultUpdateManyWithWhereWithoutQuizInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<QuizResultUpsertWithWhereUniqueWithoutQuizInput>>>;
};

export type QuizResultUpdateManyWithoutQuizQuestionAnswerInput = {
  connect?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<QuizResultCreateOrConnectWithoutQuizQuestionAnswerInput>>>;
  create?: InputMaybe<Array<InputMaybe<QuizResultCreateWithoutQuizQuestionAnswerInput>>>;
  createMany?: InputMaybe<QuizResultCreateManyQuizQuestionAnswerInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<QuizResultScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<QuizResultUpdateWithWhereUniqueWithoutQuizQuestionAnswerInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<QuizResultUpdateManyWithWhereWithoutQuizQuestionAnswerInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<QuizResultUpsertWithWhereUniqueWithoutQuizQuestionAnswerInput>>>;
};

export type QuizResultUpdateManyWithoutQuizQuestionInput = {
  connect?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<QuizResultCreateOrConnectWithoutQuizQuestionInput>>>;
  create?: InputMaybe<Array<InputMaybe<QuizResultCreateWithoutQuizQuestionInput>>>;
  createMany?: InputMaybe<QuizResultCreateManyQuizQuestionInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<QuizResultScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<QuizResultUpdateWithWhereUniqueWithoutQuizQuestionInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<QuizResultUpdateManyWithWhereWithoutQuizQuestionInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<QuizResultUpsertWithWhereUniqueWithoutQuizQuestionInput>>>;
};

export type QuizResultUpdateManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<QuizResultCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<QuizResultCreateWithoutUserInput>>>;
  createMany?: InputMaybe<QuizResultCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<QuizResultScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<QuizResultWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<QuizResultUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<QuizResultUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<QuizResultUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type QuizResultUpdateWithWhereUniqueWithoutEventInput = {
  data: QuizResultUncheckedUpdateWithoutEventInput;
  where: QuizResultWhereUniqueInput;
};

export type QuizResultUpdateWithWhereUniqueWithoutQuizInput = {
  data: QuizResultUncheckedUpdateWithoutQuizInput;
  where: QuizResultWhereUniqueInput;
};

export type QuizResultUpdateWithWhereUniqueWithoutQuizQuestionAnswerInput = {
  data: QuizResultUncheckedUpdateWithoutQuizQuestionAnswerInput;
  where: QuizResultWhereUniqueInput;
};

export type QuizResultUpdateWithWhereUniqueWithoutQuizQuestionInput = {
  data: QuizResultUncheckedUpdateWithoutQuizQuestionInput;
  where: QuizResultWhereUniqueInput;
};

export type QuizResultUpdateWithWhereUniqueWithoutUserInput = {
  data: QuizResultUncheckedUpdateWithoutUserInput;
  where: QuizResultWhereUniqueInput;
};

export type QuizResultUpdateWithoutEventInput = {
  Quiz?: InputMaybe<QuizUpdateOneRequiredWithoutQuizResultInput>;
  QuizQuestion?: InputMaybe<QuizQuestionUpdateOneRequiredWithoutQuizResultInput>;
  QuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerUpdateOneRequiredWithoutQuizResultInput>;
  User?: InputMaybe<UserUpdateOneRequiredWithoutQuizResultInput>;
};

export type QuizResultUpdateWithoutQuizInput = {
  Event?: InputMaybe<EventUpdateOneWithoutQuizResultInput>;
  QuizQuestion?: InputMaybe<QuizQuestionUpdateOneRequiredWithoutQuizResultInput>;
  QuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerUpdateOneRequiredWithoutQuizResultInput>;
  User?: InputMaybe<UserUpdateOneRequiredWithoutQuizResultInput>;
};

export type QuizResultUpdateWithoutQuizQuestionAnswerInput = {
  Event?: InputMaybe<EventUpdateOneWithoutQuizResultInput>;
  Quiz?: InputMaybe<QuizUpdateOneRequiredWithoutQuizResultInput>;
  QuizQuestion?: InputMaybe<QuizQuestionUpdateOneRequiredWithoutQuizResultInput>;
  User?: InputMaybe<UserUpdateOneRequiredWithoutQuizResultInput>;
};

export type QuizResultUpdateWithoutQuizQuestionInput = {
  Event?: InputMaybe<EventUpdateOneWithoutQuizResultInput>;
  Quiz?: InputMaybe<QuizUpdateOneRequiredWithoutQuizResultInput>;
  QuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerUpdateOneRequiredWithoutQuizResultInput>;
  User?: InputMaybe<UserUpdateOneRequiredWithoutQuizResultInput>;
};

export type QuizResultUpdateWithoutUserInput = {
  Event?: InputMaybe<EventUpdateOneWithoutQuizResultInput>;
  Quiz?: InputMaybe<QuizUpdateOneRequiredWithoutQuizResultInput>;
  QuizQuestion?: InputMaybe<QuizQuestionUpdateOneRequiredWithoutQuizResultInput>;
  QuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerUpdateOneRequiredWithoutQuizResultInput>;
};

export type QuizResultUpsertWithWhereUniqueWithoutEventInput = {
  create: QuizResultUncheckedCreateWithoutEventInput;
  update: QuizResultUncheckedUpdateWithoutEventInput;
  where: QuizResultWhereUniqueInput;
};

export type QuizResultUpsertWithWhereUniqueWithoutQuizInput = {
  create: QuizResultUncheckedCreateWithoutQuizInput;
  update: QuizResultUncheckedUpdateWithoutQuizInput;
  where: QuizResultWhereUniqueInput;
};

export type QuizResultUpsertWithWhereUniqueWithoutQuizQuestionAnswerInput = {
  create: QuizResultUncheckedCreateWithoutQuizQuestionAnswerInput;
  update: QuizResultUncheckedUpdateWithoutQuizQuestionAnswerInput;
  where: QuizResultWhereUniqueInput;
};

export type QuizResultUpsertWithWhereUniqueWithoutQuizQuestionInput = {
  create: QuizResultUncheckedCreateWithoutQuizQuestionInput;
  update: QuizResultUncheckedUpdateWithoutQuizQuestionInput;
  where: QuizResultWhereUniqueInput;
};

export type QuizResultUpsertWithWhereUniqueWithoutUserInput = {
  create: QuizResultUncheckedCreateWithoutUserInput;
  update: QuizResultUncheckedUpdateWithoutUserInput;
  where: QuizResultWhereUniqueInput;
};

export type QuizResultWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<QuizResultWhereInput>>>;
  Event?: InputMaybe<EventWhereInput>;
  NOT?: InputMaybe<Array<InputMaybe<QuizResultWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<QuizResultWhereInput>>>;
  Quiz?: InputMaybe<QuizWhereInput>;
  QuizQuestion?: InputMaybe<QuizQuestionWhereInput>;
  QuizQuestionAnswer?: InputMaybe<QuizQuestionAnswerWhereInput>;
  User?: InputMaybe<UserWhereInput>;
  eventId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  quizId?: InputMaybe<IntFilter>;
  quizQuestionAnswerId?: InputMaybe<StringFilter>;
  quizQuestionId?: InputMaybe<StringFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type QuizResultWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export enum QuizScalarFieldEnum {
  CreatedAt = 'createdAt',
  EventId = 'eventId',
  Id = 'id',
  Name = 'name'
}

export type QuizScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<QuizScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<QuizScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<QuizScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  eventId?: InputMaybe<IntNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  name?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type QuizSumAggregateOutputType = {
  __typename?: 'QuizSumAggregateOutputType';
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type QuizSumOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type QuizUncheckedCreateInput = {
  QuizQuestion?: InputMaybe<QuizQuestionUncheckedCreateNestedManyWithoutQuizInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutQuizInput>;
  TrainerEventStudyMaterial?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutQuizInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type QuizUncheckedCreateNestedOneWithoutEventInput = {
  connect?: InputMaybe<QuizWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuizCreateOrConnectWithoutEventInput>;
  create?: InputMaybe<QuizUncheckedCreateWithoutEventInput>;
};

export type QuizUncheckedCreateWithoutEventInput = {
  QuizQuestion?: InputMaybe<QuizQuestionUncheckedCreateNestedManyWithoutQuizInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutQuizInput>;
  TrainerEventStudyMaterial?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutQuizInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type QuizUncheckedCreateWithoutQuizQuestionInput = {
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutQuizInput>;
  TrainerEventStudyMaterial?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutQuizInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type QuizUncheckedCreateWithoutQuizResultInput = {
  QuizQuestion?: InputMaybe<QuizQuestionUncheckedCreateNestedManyWithoutQuizInput>;
  TrainerEventStudyMaterial?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutQuizInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type QuizUncheckedCreateWithoutTrainerEventStudyMaterialInput = {
  QuizQuestion?: InputMaybe<QuizQuestionUncheckedCreateNestedManyWithoutQuizInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutQuizInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type QuizUncheckedUpdateInput = {
  QuizQuestion?: InputMaybe<QuizQuestionUncheckedUpdateManyWithoutQuizInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutQuizInput>;
  TrainerEventStudyMaterial?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutQuizInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type QuizUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type QuizUncheckedUpdateOneWithoutEventInput = {
  connect?: InputMaybe<QuizWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuizCreateOrConnectWithoutEventInput>;
  create?: InputMaybe<QuizUncheckedCreateWithoutEventInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<QuizUncheckedUpdateWithoutEventInput>;
  upsert?: InputMaybe<QuizUpsertWithoutEventInput>;
};

export type QuizUncheckedUpdateWithoutEventInput = {
  QuizQuestion?: InputMaybe<QuizQuestionUncheckedUpdateManyWithoutQuizInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutQuizInput>;
  TrainerEventStudyMaterial?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutQuizInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type QuizUncheckedUpdateWithoutQuizQuestionInput = {
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutQuizInput>;
  TrainerEventStudyMaterial?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutQuizInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type QuizUncheckedUpdateWithoutQuizResultInput = {
  QuizQuestion?: InputMaybe<QuizQuestionUncheckedUpdateManyWithoutQuizInput>;
  TrainerEventStudyMaterial?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutQuizInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type QuizUncheckedUpdateWithoutTrainerEventStudyMaterialInput = {
  QuizQuestion?: InputMaybe<QuizQuestionUncheckedUpdateManyWithoutQuizInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutQuizInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type QuizUpdateInput = {
  Event?: InputMaybe<EventUpdateOneWithoutQuizInput>;
  QuizQuestion?: InputMaybe<QuizQuestionUpdateManyWithoutQuizInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutQuizInput>;
  TrainerEventStudyMaterial?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutQuizInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type QuizUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type QuizUpdateOneRequiredWithoutQuizQuestionInput = {
  connect?: InputMaybe<QuizWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuizCreateOrConnectWithoutQuizQuestionInput>;
  create?: InputMaybe<QuizUncheckedCreateWithoutQuizQuestionInput>;
  update?: InputMaybe<QuizUncheckedUpdateWithoutQuizQuestionInput>;
  upsert?: InputMaybe<QuizUpsertWithoutQuizQuestionInput>;
};

export type QuizUpdateOneRequiredWithoutQuizResultInput = {
  connect?: InputMaybe<QuizWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuizCreateOrConnectWithoutQuizResultInput>;
  create?: InputMaybe<QuizUncheckedCreateWithoutQuizResultInput>;
  update?: InputMaybe<QuizUncheckedUpdateWithoutQuizResultInput>;
  upsert?: InputMaybe<QuizUpsertWithoutQuizResultInput>;
};

export type QuizUpdateOneWithoutEventInput = {
  connect?: InputMaybe<QuizWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuizCreateOrConnectWithoutEventInput>;
  create?: InputMaybe<QuizUncheckedCreateWithoutEventInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<QuizUncheckedUpdateWithoutEventInput>;
  upsert?: InputMaybe<QuizUpsertWithoutEventInput>;
};

export type QuizUpdateOneWithoutTrainerEventStudyMaterialInput = {
  connect?: InputMaybe<QuizWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuizCreateOrConnectWithoutTrainerEventStudyMaterialInput>;
  create?: InputMaybe<QuizUncheckedCreateWithoutTrainerEventStudyMaterialInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<QuizUncheckedUpdateWithoutTrainerEventStudyMaterialInput>;
  upsert?: InputMaybe<QuizUpsertWithoutTrainerEventStudyMaterialInput>;
};

export type QuizUpdateWithoutEventInput = {
  QuizQuestion?: InputMaybe<QuizQuestionUpdateManyWithoutQuizInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutQuizInput>;
  TrainerEventStudyMaterial?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutQuizInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type QuizUpdateWithoutQuizQuestionInput = {
  Event?: InputMaybe<EventUpdateOneWithoutQuizInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutQuizInput>;
  TrainerEventStudyMaterial?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutQuizInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type QuizUpdateWithoutQuizResultInput = {
  Event?: InputMaybe<EventUpdateOneWithoutQuizInput>;
  QuizQuestion?: InputMaybe<QuizQuestionUpdateManyWithoutQuizInput>;
  TrainerEventStudyMaterial?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutQuizInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type QuizUpdateWithoutTrainerEventStudyMaterialInput = {
  Event?: InputMaybe<EventUpdateOneWithoutQuizInput>;
  QuizQuestion?: InputMaybe<QuizQuestionUpdateManyWithoutQuizInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutQuizInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type QuizUpsertWithoutEventInput = {
  create: QuizUncheckedCreateWithoutEventInput;
  update: QuizUncheckedUpdateWithoutEventInput;
};

export type QuizUpsertWithoutQuizQuestionInput = {
  create: QuizUncheckedCreateWithoutQuizQuestionInput;
  update: QuizUncheckedUpdateWithoutQuizQuestionInput;
};

export type QuizUpsertWithoutQuizResultInput = {
  create: QuizUncheckedCreateWithoutQuizResultInput;
  update: QuizUncheckedUpdateWithoutQuizResultInput;
};

export type QuizUpsertWithoutTrainerEventStudyMaterialInput = {
  create: QuizUncheckedCreateWithoutTrainerEventStudyMaterialInput;
  update: QuizUncheckedUpdateWithoutTrainerEventStudyMaterialInput;
};

export type QuizWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<QuizWhereInput>>>;
  Event?: InputMaybe<EventWhereInput>;
  NOT?: InputMaybe<Array<InputMaybe<QuizWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<QuizWhereInput>>>;
  QuizQuestion?: InputMaybe<QuizQuestionListRelationFilter>;
  QuizResult?: InputMaybe<QuizResultListRelationFilter>;
  TrainerEventStudyMaterial?: InputMaybe<TrainerEventStudyMaterialListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  eventId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringNullableFilter>;
};

export type QuizWhereUniqueInput = {
  eventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type Rank = {
  __typename?: 'Rank';
  Cv: Array<Cv>;
  _count: RankCountOutputType;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  title: Scalars['String'];
};


export type RankCvArgs = {
  cursor?: InputMaybe<CvWhereUniqueInput>;
  distinct?: InputMaybe<CvScalarFieldEnum>;
  orderBy?: InputMaybe<CvOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CvWhereInput>;
};

export type RankAvgAggregateOutputType = {
  __typename?: 'RankAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
};

export type RankAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type RankCountAggregateOutputType = {
  __typename?: 'RankCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  title: Scalars['Int'];
};

export type RankCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type RankCountOutputType = {
  __typename?: 'RankCountOutputType';
  Cv: Scalars['Int'];
};

export type RankCreateInput = {
  Cv?: InputMaybe<CvCreateNestedManyWithoutRankInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
};

export type RankCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type RankCreateNestedOneWithoutCvInput = {
  connect?: InputMaybe<RankWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RankCreateOrConnectWithoutCvInput>;
  create?: InputMaybe<RankUncheckedCreateWithoutCvInput>;
};

export type RankCreateOrConnectWithoutCvInput = {
  create: RankUncheckedCreateWithoutCvInput;
  where: RankWhereUniqueInput;
};

export type RankCreateWithoutCvInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
};

export type RankMaxAggregateOutputType = {
  __typename?: 'RankMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type RankMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type RankMinAggregateOutputType = {
  __typename?: 'RankMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type RankMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type RankOrderByWithAggregationInput = {
  _avg?: InputMaybe<RankAvgOrderByAggregateInput>;
  _count?: InputMaybe<RankCountOrderByAggregateInput>;
  _max?: InputMaybe<RankMaxOrderByAggregateInput>;
  _min?: InputMaybe<RankMinOrderByAggregateInput>;
  _sum?: InputMaybe<RankSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type RankOrderByWithRelationInput = {
  Cv?: InputMaybe<CvOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type RankRelationFilter = {
  is?: InputMaybe<RankWhereInput>;
  isNot?: InputMaybe<RankWhereInput>;
};

export enum RankScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  Title = 'title'
}

export type RankScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<RankScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<RankScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<RankScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  title?: InputMaybe<StringWithAggregatesFilter>;
};

export type RankSumAggregateOutputType = {
  __typename?: 'RankSumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
};

export type RankSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type RankUncheckedCreateInput = {
  Cv?: InputMaybe<CvUncheckedCreateNestedManyWithoutRankInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type RankUncheckedCreateWithoutCvInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type RankUncheckedUpdateInput = {
  Cv?: InputMaybe<CvUncheckedUpdateManyWithoutRankInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RankUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RankUncheckedUpdateWithoutCvInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RankUpdateInput = {
  Cv?: InputMaybe<CvUpdateManyWithoutRankInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RankUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RankUpdateOneWithoutCvInput = {
  connect?: InputMaybe<RankWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RankCreateOrConnectWithoutCvInput>;
  create?: InputMaybe<RankUncheckedCreateWithoutCvInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<RankUncheckedUpdateWithoutCvInput>;
  upsert?: InputMaybe<RankUpsertWithoutCvInput>;
};

export type RankUpdateWithoutCvInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RankUpsertWithoutCvInput = {
  create: RankUncheckedCreateWithoutCvInput;
  update: RankUncheckedUpdateWithoutCvInput;
};

export type RankWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<RankWhereInput>>>;
  Cv?: InputMaybe<CvListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<RankWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<RankWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  title?: InputMaybe<StringFilter>;
};

export type RankWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Recurrence = {
  __typename?: 'Recurrence';
  end_date_time?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['Int']>;
};

export type RecurrenceCreateInput = {
  end_date_time?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['Int']>;
};

export type RecurrenceUpdateInput = {
  end_date_time?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['Int']>;
};

export type RegionRecord = {
  __typename?: 'RegionRecord';
  city?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['Decimal']>;
  lng?: Maybe<Scalars['Decimal']>;
  month?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

export type RemindInputType = {
  newEventId: Scalars['Int'];
  oldEventId: Scalars['Int'];
};

export type RemindMeInputType = {
  eventId: Scalars['Int'];
};

export type ReviewInput = {
  eventReviewInput?: InputMaybe<EventReviewInput>;
  trainerReviewInput?: InputMaybe<TrainerReviewInput>;
};

export type Role = {
  __typename?: 'Role';
  _count: RoleCountOutputType;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  users: Array<User>;
};


export type RoleUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<UserScalarFieldEnum>;
  orderBy?: InputMaybe<UserOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};

export type RoleAvgAggregateOutputType = {
  __typename?: 'RoleAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
};

export type RoleAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type RoleCountAggregateOutputType = {
  __typename?: 'RoleCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  titleAr: Scalars['Int'];
  titleEn: Scalars['Int'];
};

export type RoleCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type RoleCountOutputType = {
  __typename?: 'RoleCountOutputType';
  users: Scalars['Int'];
};

export type RoleCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  users?: InputMaybe<UserCreateNestedManyWithoutRoleInput>;
};

export type RoleCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type RoleCreateNestedOneWithoutUsersInput = {
  connect?: InputMaybe<RoleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RoleCreateOrConnectWithoutUsersInput>;
  create?: InputMaybe<RoleUncheckedCreateWithoutUsersInput>;
};

export type RoleCreateOrConnectWithoutUsersInput = {
  create: RoleUncheckedCreateWithoutUsersInput;
  where: RoleWhereUniqueInput;
};

export type RoleCreateWithoutUsersInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type RoleMaxAggregateOutputType = {
  __typename?: 'RoleMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type RoleMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type RoleMinAggregateOutputType = {
  __typename?: 'RoleMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type RoleMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type RoleOrderByWithAggregationInput = {
  _avg?: InputMaybe<RoleAvgOrderByAggregateInput>;
  _count?: InputMaybe<RoleCountOrderByAggregateInput>;
  _max?: InputMaybe<RoleMaxOrderByAggregateInput>;
  _min?: InputMaybe<RoleMinOrderByAggregateInput>;
  _sum?: InputMaybe<RoleSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type RoleOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
  users?: InputMaybe<UserOrderByRelationAggregateInput>;
};

export type RoleRelationFilter = {
  is?: InputMaybe<RoleWhereInput>;
  isNot?: InputMaybe<RoleWhereInput>;
};

export enum RoleScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  TitleAr = 'titleAr',
  TitleEn = 'titleEn'
}

export type RoleScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<RoleScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<RoleScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<RoleScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  titleAr?: InputMaybe<StringWithAggregatesFilter>;
  titleEn?: InputMaybe<StringWithAggregatesFilter>;
};

export type RoleSumAggregateOutputType = {
  __typename?: 'RoleSumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
};

export type RoleSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type RoleUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  users?: InputMaybe<UserUncheckedCreateNestedManyWithoutRoleInput>;
};

export type RoleUncheckedCreateWithoutUsersInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type RoleUncheckedUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUncheckedUpdateManyWithoutRoleInput>;
};

export type RoleUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RoleUncheckedUpdateWithoutUsersInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RoleUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUpdateManyWithoutRoleInput>;
};

export type RoleUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RoleUpdateOneRequiredWithoutUsersInput = {
  connect?: InputMaybe<RoleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RoleCreateOrConnectWithoutUsersInput>;
  create?: InputMaybe<RoleUncheckedCreateWithoutUsersInput>;
  update?: InputMaybe<RoleUncheckedUpdateWithoutUsersInput>;
  upsert?: InputMaybe<RoleUpsertWithoutUsersInput>;
};

export type RoleUpdateWithoutUsersInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RoleUpsertWithoutUsersInput = {
  create: RoleUncheckedCreateWithoutUsersInput;
  update: RoleUncheckedUpdateWithoutUsersInput;
};

export type RoleWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<RoleWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<RoleWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<RoleWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  titleAr?: InputMaybe<StringFilter>;
  titleEn?: InputMaybe<StringFilter>;
  users?: InputMaybe<UserListRelationFilter>;
};

export type RoleWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn?: InputMaybe<Scalars['String']>;
};

export type Scheduling = {
  __typename?: 'Scheduling';
  id: Scalars['String'];
  name: Scalars['String'];
  startOn: Scalars['DateTime'];
  startedon?: Maybe<Scalars['DateTime']>;
  state: Scalars['String'];
};

export type ScientificResearch = {
  __typename?: 'ScientificResearch';
  Cv?: Maybe<Cv>;
  cvId?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  role?: Maybe<ScientificResearchRole>;
  type?: Maybe<ScientificResearchType>;
};

export type ScientificResearchAvgAggregateOutputType = {
  __typename?: 'ScientificResearchAvgAggregateOutputType';
  cvId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

export type ScientificResearchAvgOrderByAggregateInput = {
  cvId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type ScientificResearchCountAggregateOutputType = {
  __typename?: 'ScientificResearchCountAggregateOutputType';
  _all: Scalars['Int'];
  cvId: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  role: Scalars['Int'];
  type: Scalars['Int'];
};

export type ScientificResearchCountOrderByAggregateInput = {
  cvId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type ScientificResearchCreateInput = {
  Cv?: InputMaybe<CvCreateNestedOneWithoutScientificResearchesInput>;
  description?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<ScientificResearchRole>;
  type?: InputMaybe<ScientificResearchType>;
};

export type ScientificResearchCreateManyCvInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<ScientificResearchRole>;
  type?: InputMaybe<ScientificResearchType>;
};

export type ScientificResearchCreateManyCvInputEnvelope = {
  data: ScientificResearchCreateManyCvInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ScientificResearchCreateManyInput = {
  cvId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<ScientificResearchRole>;
  type?: InputMaybe<ScientificResearchType>;
};

export type ScientificResearchCreateNestedManyWithoutCvInput = {
  connect?: InputMaybe<Array<InputMaybe<ScientificResearchWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ScientificResearchCreateOrConnectWithoutCvInput>>>;
  create?: InputMaybe<Array<InputMaybe<ScientificResearchCreateWithoutCvInput>>>;
  createMany?: InputMaybe<ScientificResearchCreateManyCvInputEnvelope>;
};

export type ScientificResearchCreateOrConnectWithoutCvInput = {
  create: ScientificResearchUncheckedCreateWithoutCvInput;
  where: ScientificResearchWhereUniqueInput;
};

export type ScientificResearchCreateWithoutCvInput = {
  description?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<ScientificResearchRole>;
  type?: InputMaybe<ScientificResearchType>;
};

export type ScientificResearchListRelationFilter = {
  every?: InputMaybe<ScientificResearchWhereInput>;
  none?: InputMaybe<ScientificResearchWhereInput>;
  some?: InputMaybe<ScientificResearchWhereInput>;
};

export type ScientificResearchMaxAggregateOutputType = {
  __typename?: 'ScientificResearchMaxAggregateOutputType';
  cvId?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  role?: Maybe<ScientificResearchRole>;
  type?: Maybe<ScientificResearchType>;
};

export type ScientificResearchMaxOrderByAggregateInput = {
  cvId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type ScientificResearchMinAggregateOutputType = {
  __typename?: 'ScientificResearchMinAggregateOutputType';
  cvId?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  role?: Maybe<ScientificResearchRole>;
  type?: Maybe<ScientificResearchType>;
};

export type ScientificResearchMinOrderByAggregateInput = {
  cvId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type ScientificResearchOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ScientificResearchOrderByWithAggregationInput = {
  _avg?: InputMaybe<ScientificResearchAvgOrderByAggregateInput>;
  _count?: InputMaybe<ScientificResearchCountOrderByAggregateInput>;
  _max?: InputMaybe<ScientificResearchMaxOrderByAggregateInput>;
  _min?: InputMaybe<ScientificResearchMinOrderByAggregateInput>;
  _sum?: InputMaybe<ScientificResearchSumOrderByAggregateInput>;
  cvId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type ScientificResearchOrderByWithRelationInput = {
  Cv?: InputMaybe<CvOrderByWithRelationInput>;
  cvId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export enum ScientificResearchRole {
  Assistant = 'assistant',
  Lead = 'lead'
}

export enum ScientificResearchScalarFieldEnum {
  CvId = 'cvId',
  Description = 'description',
  Id = 'id',
  Role = 'role',
  Type = 'type'
}

export type ScientificResearchScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ScientificResearchScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ScientificResearchScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ScientificResearchScalarWhereInput>>>;
  cvId?: InputMaybe<IntNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  role?: InputMaybe<EnumScientificResearchRoleNullableFilter>;
  type?: InputMaybe<EnumScientificResearchTypeNullableFilter>;
};

export type ScientificResearchScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<ScientificResearchScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ScientificResearchScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ScientificResearchScalarWhereWithAggregatesInput>>>;
  cvId?: InputMaybe<IntNullableWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  role?: InputMaybe<EnumScientificResearchRoleNullableWithAggregatesFilter>;
  type?: InputMaybe<EnumScientificResearchTypeNullableWithAggregatesFilter>;
};

export type ScientificResearchSumAggregateOutputType = {
  __typename?: 'ScientificResearchSumAggregateOutputType';
  cvId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type ScientificResearchSumOrderByAggregateInput = {
  cvId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export enum ScientificResearchType {
  Conferences = 'conferences',
  Journals = 'journals'
}

export type ScientificResearchUncheckedCreateInput = {
  cvId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<ScientificResearchRole>;
  type?: InputMaybe<ScientificResearchType>;
};

export type ScientificResearchUncheckedCreateNestedManyWithoutCvInput = {
  connect?: InputMaybe<Array<InputMaybe<ScientificResearchWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ScientificResearchCreateOrConnectWithoutCvInput>>>;
  create?: InputMaybe<Array<InputMaybe<ScientificResearchCreateWithoutCvInput>>>;
  createMany?: InputMaybe<ScientificResearchCreateManyCvInputEnvelope>;
};

export type ScientificResearchUncheckedCreateWithoutCvInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<ScientificResearchRole>;
  type?: InputMaybe<ScientificResearchType>;
};

export type ScientificResearchUncheckedUpdateInput = {
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  role?: InputMaybe<NullableEnumScientificResearchRoleFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumScientificResearchTypeFieldUpdateOperationsInput>;
};

export type ScientificResearchUncheckedUpdateManyInput = {
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  role?: InputMaybe<NullableEnumScientificResearchRoleFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumScientificResearchTypeFieldUpdateOperationsInput>;
};

export type ScientificResearchUncheckedUpdateManyWithoutCvInput = {
  connect?: InputMaybe<Array<InputMaybe<ScientificResearchWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ScientificResearchCreateOrConnectWithoutCvInput>>>;
  create?: InputMaybe<Array<InputMaybe<ScientificResearchCreateWithoutCvInput>>>;
  createMany?: InputMaybe<ScientificResearchCreateManyCvInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ScientificResearchWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ScientificResearchScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ScientificResearchWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ScientificResearchWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ScientificResearchUpdateWithWhereUniqueWithoutCvInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ScientificResearchUpdateManyWithWhereWithoutCvInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ScientificResearchUpsertWithWhereUniqueWithoutCvInput>>>;
};

export type ScientificResearchUncheckedUpdateManyWithoutScientificResearchesInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  role?: InputMaybe<NullableEnumScientificResearchRoleFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumScientificResearchTypeFieldUpdateOperationsInput>;
};

export type ScientificResearchUncheckedUpdateWithoutCvInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  role?: InputMaybe<NullableEnumScientificResearchRoleFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumScientificResearchTypeFieldUpdateOperationsInput>;
};

export type ScientificResearchUpdateInput = {
  Cv?: InputMaybe<CvUpdateOneWithoutScientificResearchesInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<NullableEnumScientificResearchRoleFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumScientificResearchTypeFieldUpdateOperationsInput>;
};

export type ScientificResearchUpdateManyMutationInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<NullableEnumScientificResearchRoleFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumScientificResearchTypeFieldUpdateOperationsInput>;
};

export type ScientificResearchUpdateManyWithWhereWithoutCvInput = {
  data: ScientificResearchUncheckedUpdateManyWithoutScientificResearchesInput;
  where: ScientificResearchScalarWhereInput;
};

export type ScientificResearchUpdateManyWithoutCvInput = {
  connect?: InputMaybe<Array<InputMaybe<ScientificResearchWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ScientificResearchCreateOrConnectWithoutCvInput>>>;
  create?: InputMaybe<Array<InputMaybe<ScientificResearchCreateWithoutCvInput>>>;
  createMany?: InputMaybe<ScientificResearchCreateManyCvInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ScientificResearchWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ScientificResearchScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ScientificResearchWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ScientificResearchWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ScientificResearchUpdateWithWhereUniqueWithoutCvInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ScientificResearchUpdateManyWithWhereWithoutCvInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ScientificResearchUpsertWithWhereUniqueWithoutCvInput>>>;
};

export type ScientificResearchUpdateWithWhereUniqueWithoutCvInput = {
  data: ScientificResearchUncheckedUpdateWithoutCvInput;
  where: ScientificResearchWhereUniqueInput;
};

export type ScientificResearchUpdateWithoutCvInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<NullableEnumScientificResearchRoleFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumScientificResearchTypeFieldUpdateOperationsInput>;
};

export type ScientificResearchUpsertWithWhereUniqueWithoutCvInput = {
  create: ScientificResearchUncheckedCreateWithoutCvInput;
  update: ScientificResearchUncheckedUpdateWithoutCvInput;
  where: ScientificResearchWhereUniqueInput;
};

export type ScientificResearchWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ScientificResearchWhereInput>>>;
  Cv?: InputMaybe<CvWhereInput>;
  NOT?: InputMaybe<Array<InputMaybe<ScientificResearchWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ScientificResearchWhereInput>>>;
  cvId?: InputMaybe<IntNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  role?: InputMaybe<EnumScientificResearchRoleNullableFilter>;
  type?: InputMaybe<EnumScientificResearchTypeNullableFilter>;
};

export type ScientificResearchWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type Session = {
  __typename?: 'Session';
  expires: Scalars['DateTime'];
  id: Scalars['Int'];
  sessionToken: Scalars['String'];
  user: User;
  userId: Scalars['Int'];
};

export type SessionAvgAggregateOutputType = {
  __typename?: 'SessionAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

export type SessionAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type SessionCountAggregateOutputType = {
  __typename?: 'SessionCountAggregateOutputType';
  _all: Scalars['Int'];
  expires: Scalars['Int'];
  id: Scalars['Int'];
  sessionToken: Scalars['Int'];
  userId: Scalars['Int'];
};

export type SessionCountOrderByAggregateInput = {
  expires?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  sessionToken?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type SessionCreateInput = {
  expires: Scalars['DateTime'];
  sessionToken: Scalars['String'];
  user: UserCreateNestedOneWithoutSessionsInput;
};

export type SessionCreateManyInput = {
  expires: Scalars['DateTime'];
  id?: InputMaybe<Scalars['Int']>;
  sessionToken: Scalars['String'];
  userId: Scalars['Int'];
};

export type SessionCreateManyUserInput = {
  expires: Scalars['DateTime'];
  id?: InputMaybe<Scalars['Int']>;
  sessionToken: Scalars['String'];
};

export type SessionCreateManyUserInputEnvelope = {
  data: SessionCreateManyUserInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type SessionCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<SessionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<SessionCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<SessionCreateWithoutUserInput>>>;
  createMany?: InputMaybe<SessionCreateManyUserInputEnvelope>;
};

export type SessionCreateOrConnectWithoutUserInput = {
  create: SessionUncheckedCreateWithoutUserInput;
  where: SessionWhereUniqueInput;
};

export type SessionCreateWithoutUserInput = {
  expires: Scalars['DateTime'];
  sessionToken: Scalars['String'];
};

export type SessionListRelationFilter = {
  every?: InputMaybe<SessionWhereInput>;
  none?: InputMaybe<SessionWhereInput>;
  some?: InputMaybe<SessionWhereInput>;
};

export type SessionMaxAggregateOutputType = {
  __typename?: 'SessionMaxAggregateOutputType';
  expires?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  sessionToken?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
};

export type SessionMaxOrderByAggregateInput = {
  expires?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  sessionToken?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type SessionMinAggregateOutputType = {
  __typename?: 'SessionMinAggregateOutputType';
  expires?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  sessionToken?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
};

export type SessionMinOrderByAggregateInput = {
  expires?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  sessionToken?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type SessionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type SessionOrderByWithAggregationInput = {
  _avg?: InputMaybe<SessionAvgOrderByAggregateInput>;
  _count?: InputMaybe<SessionCountOrderByAggregateInput>;
  _max?: InputMaybe<SessionMaxOrderByAggregateInput>;
  _min?: InputMaybe<SessionMinOrderByAggregateInput>;
  _sum?: InputMaybe<SessionSumOrderByAggregateInput>;
  expires?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  sessionToken?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type SessionOrderByWithRelationInput = {
  expires?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  sessionToken?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum SessionScalarFieldEnum {
  Expires = 'expires',
  Id = 'id',
  SessionToken = 'sessionToken',
  UserId = 'userId'
}

export type SessionScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<SessionScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<SessionScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<SessionScalarWhereInput>>>;
  expires?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  sessionToken?: InputMaybe<StringFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type SessionScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<SessionScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<SessionScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<SessionScalarWhereWithAggregatesInput>>>;
  expires?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  sessionToken?: InputMaybe<StringWithAggregatesFilter>;
  userId?: InputMaybe<IntWithAggregatesFilter>;
};

export type SessionSumAggregateOutputType = {
  __typename?: 'SessionSumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

export type SessionSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type SessionUncheckedCreateInput = {
  expires: Scalars['DateTime'];
  id?: InputMaybe<Scalars['Int']>;
  sessionToken: Scalars['String'];
  userId: Scalars['Int'];
};

export type SessionUncheckedCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<SessionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<SessionCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<SessionCreateWithoutUserInput>>>;
  createMany?: InputMaybe<SessionCreateManyUserInputEnvelope>;
};

export type SessionUncheckedCreateWithoutUserInput = {
  expires: Scalars['DateTime'];
  id?: InputMaybe<Scalars['Int']>;
  sessionToken: Scalars['String'];
};

export type SessionUncheckedUpdateInput = {
  expires?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  sessionToken?: InputMaybe<StringFieldUpdateOperationsInput>;
  userId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type SessionUncheckedUpdateManyInput = {
  expires?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  sessionToken?: InputMaybe<StringFieldUpdateOperationsInput>;
  userId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type SessionUncheckedUpdateManyWithoutSessionsInput = {
  expires?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  sessionToken?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SessionUncheckedUpdateManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<SessionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<SessionCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<SessionCreateWithoutUserInput>>>;
  createMany?: InputMaybe<SessionCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<SessionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<SessionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<SessionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<SessionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<SessionUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<SessionUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<SessionUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type SessionUncheckedUpdateWithoutUserInput = {
  expires?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  sessionToken?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SessionUpdateInput = {
  expires?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sessionToken?: InputMaybe<StringFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutSessionsInput>;
};

export type SessionUpdateManyMutationInput = {
  expires?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sessionToken?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SessionUpdateManyWithWhereWithoutUserInput = {
  data: SessionUncheckedUpdateManyWithoutSessionsInput;
  where: SessionScalarWhereInput;
};

export type SessionUpdateManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<SessionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<SessionCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<SessionCreateWithoutUserInput>>>;
  createMany?: InputMaybe<SessionCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<SessionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<SessionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<SessionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<SessionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<SessionUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<SessionUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<SessionUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type SessionUpdateWithWhereUniqueWithoutUserInput = {
  data: SessionUncheckedUpdateWithoutUserInput;
  where: SessionWhereUniqueInput;
};

export type SessionUpdateWithoutUserInput = {
  expires?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  sessionToken?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SessionUpsertWithWhereUniqueWithoutUserInput = {
  create: SessionUncheckedCreateWithoutUserInput;
  update: SessionUncheckedUpdateWithoutUserInput;
  where: SessionWhereUniqueInput;
};

export type SessionWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<SessionWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<SessionWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<SessionWhereInput>>>;
  expires?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  sessionToken?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserWhereInput>;
  userId?: InputMaybe<IntFilter>;
};

export type SessionWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  sessionToken?: InputMaybe<Scalars['String']>;
};

export type Settings = {
  __typename?: 'Settings';
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  nameAr: Scalars['String'];
  nameEn: Scalars['String'];
  value?: Maybe<Scalars['Json']>;
};

export type SettingsAvgAggregateOutputType = {
  __typename?: 'SettingsAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
};

export type SettingsAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type SettingsCountAggregateOutputType = {
  __typename?: 'SettingsCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  nameAr: Scalars['Int'];
  nameEn: Scalars['Int'];
  value: Scalars['Int'];
};

export type SettingsCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  nameAr?: InputMaybe<SortOrder>;
  nameEn?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type SettingsCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  nameAr: Scalars['String'];
  nameEn: Scalars['String'];
  value?: InputMaybe<Scalars['Json']>;
};

export type SettingsCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  nameAr: Scalars['String'];
  nameEn: Scalars['String'];
  value?: InputMaybe<Scalars['Json']>;
};

export type SettingsMaxAggregateOutputType = {
  __typename?: 'SettingsMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  nameAr?: Maybe<Scalars['String']>;
  nameEn?: Maybe<Scalars['String']>;
};

export type SettingsMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  nameAr?: InputMaybe<SortOrder>;
  nameEn?: InputMaybe<SortOrder>;
};

export type SettingsMinAggregateOutputType = {
  __typename?: 'SettingsMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  nameAr?: Maybe<Scalars['String']>;
  nameEn?: Maybe<Scalars['String']>;
};

export type SettingsMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  nameAr?: InputMaybe<SortOrder>;
  nameEn?: InputMaybe<SortOrder>;
};

export type SettingsOrderByWithAggregationInput = {
  _avg?: InputMaybe<SettingsAvgOrderByAggregateInput>;
  _count?: InputMaybe<SettingsCountOrderByAggregateInput>;
  _max?: InputMaybe<SettingsMaxOrderByAggregateInput>;
  _min?: InputMaybe<SettingsMinOrderByAggregateInput>;
  _sum?: InputMaybe<SettingsSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  nameAr?: InputMaybe<SortOrder>;
  nameEn?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type SettingsOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  nameAr?: InputMaybe<SortOrder>;
  nameEn?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export enum SettingsScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  NameAr = 'nameAr',
  NameEn = 'nameEn',
  Value = 'value'
}

export type SettingsScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<SettingsScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<SettingsScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<SettingsScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  nameAr?: InputMaybe<StringWithAggregatesFilter>;
  nameEn?: InputMaybe<StringWithAggregatesFilter>;
  value?: InputMaybe<JsonNullableWithAggregatesFilter>;
};

export type SettingsSumAggregateOutputType = {
  __typename?: 'SettingsSumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
};

export type SettingsSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type SettingsUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  nameAr: Scalars['String'];
  nameEn: Scalars['String'];
  value?: InputMaybe<Scalars['Json']>;
};

export type SettingsUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  value?: InputMaybe<Scalars['Json']>;
};

export type SettingsUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  value?: InputMaybe<Scalars['Json']>;
};

export type SettingsUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  value?: InputMaybe<Scalars['Json']>;
};

export type SettingsUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  value?: InputMaybe<Scalars['Json']>;
};

export type SettingsWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<SettingsWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<SettingsWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<SettingsWhereInput>>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  nameAr?: InputMaybe<StringFilter>;
  nameEn?: InputMaybe<StringFilter>;
  value?: InputMaybe<JsonNullableFilter>;
};

export type SettingsWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type Specialty = {
  __typename?: 'Specialty';
  Education: Array<Education>;
  _count: SpecialtyCountOutputType;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  profession: Profession;
  professionId: Scalars['Int'];
  titleAr?: Maybe<Scalars['String']>;
  titleEn: Scalars['String'];
  users: Array<User>;
};


export type SpecialtyEducationArgs = {
  cursor?: InputMaybe<EducationWhereUniqueInput>;
  distinct?: InputMaybe<EducationScalarFieldEnum>;
  orderBy?: InputMaybe<EducationOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EducationWhereInput>;
};


export type SpecialtyUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<UserScalarFieldEnum>;
  orderBy?: InputMaybe<UserOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};

export type SpecialtyAvgAggregateOutputType = {
  __typename?: 'SpecialtyAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
  professionId?: Maybe<Scalars['Float']>;
};

export type SpecialtyAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  professionId?: InputMaybe<SortOrder>;
};

export type SpecialtyCountAggregateOutputType = {
  __typename?: 'SpecialtyCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  professionId: Scalars['Int'];
  titleAr: Scalars['Int'];
  titleEn: Scalars['Int'];
};

export type SpecialtyCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  professionId?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type SpecialtyCountOutputType = {
  __typename?: 'SpecialtyCountOutputType';
  Education: Scalars['Int'];
  Event: Scalars['Int'];
  TrainerEvent: Scalars['Int'];
  users: Scalars['Int'];
};

export type SpecialtyCreateInput = {
  Education?: InputMaybe<EducationCreateNestedManyWithoutSpecialtyInput>;
  Event?: InputMaybe<EventCreateNestedManyWithoutTargetedSpecialitiesInput>;
  TrainerEvent?: InputMaybe<TrainerEventCreateNestedManyWithoutTargetedSpecialitiesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  profession: ProfessionCreateNestedOneWithoutSpecialtiesInput;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn: Scalars['String'];
  users?: InputMaybe<UserCreateNestedManyWithoutSpecialtyInput>;
};

export type SpecialtyCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  professionId: Scalars['Int'];
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn: Scalars['String'];
};

export type SpecialtyCreateManyProfessionInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn: Scalars['String'];
};

export type SpecialtyCreateManyProfessionInputEnvelope = {
  data: SpecialtyCreateManyProfessionInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type SpecialtyCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<SpecialtyWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<SpecialtyCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<SpecialtyCreateWithoutEventInput>>>;
};

export type SpecialtyCreateNestedManyWithoutProfessionInput = {
  connect?: InputMaybe<Array<InputMaybe<SpecialtyWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<SpecialtyCreateOrConnectWithoutProfessionInput>>>;
  create?: InputMaybe<Array<InputMaybe<SpecialtyCreateWithoutProfessionInput>>>;
  createMany?: InputMaybe<SpecialtyCreateManyProfessionInputEnvelope>;
};

export type SpecialtyCreateNestedManyWithoutTrainerEventInput = {
  connect?: InputMaybe<Array<InputMaybe<SpecialtyWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<SpecialtyCreateOrConnectWithoutTrainerEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<SpecialtyCreateWithoutTrainerEventInput>>>;
};

export type SpecialtyCreateNestedOneWithoutEducationInput = {
  connect?: InputMaybe<SpecialtyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SpecialtyCreateOrConnectWithoutEducationInput>;
  create?: InputMaybe<SpecialtyUncheckedCreateWithoutEducationInput>;
};

export type SpecialtyCreateNestedOneWithoutUsersInput = {
  connect?: InputMaybe<SpecialtyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SpecialtyCreateOrConnectWithoutUsersInput>;
  create?: InputMaybe<SpecialtyUncheckedCreateWithoutUsersInput>;
};

export type SpecialtyCreateOrConnectWithoutEducationInput = {
  create: SpecialtyUncheckedCreateWithoutEducationInput;
  where: SpecialtyWhereUniqueInput;
};

export type SpecialtyCreateOrConnectWithoutEventInput = {
  create: SpecialtyUncheckedCreateWithoutEventInput;
  where: SpecialtyWhereUniqueInput;
};

export type SpecialtyCreateOrConnectWithoutProfessionInput = {
  create: SpecialtyUncheckedCreateWithoutProfessionInput;
  where: SpecialtyWhereUniqueInput;
};

export type SpecialtyCreateOrConnectWithoutTrainerEventInput = {
  create: SpecialtyUncheckedCreateWithoutTrainerEventInput;
  where: SpecialtyWhereUniqueInput;
};

export type SpecialtyCreateOrConnectWithoutUsersInput = {
  create: SpecialtyUncheckedCreateWithoutUsersInput;
  where: SpecialtyWhereUniqueInput;
};

export type SpecialtyCreateWithoutEducationInput = {
  Event?: InputMaybe<EventCreateNestedManyWithoutTargetedSpecialitiesInput>;
  TrainerEvent?: InputMaybe<TrainerEventCreateNestedManyWithoutTargetedSpecialitiesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  profession: ProfessionCreateNestedOneWithoutSpecialtiesInput;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn: Scalars['String'];
  users?: InputMaybe<UserCreateNestedManyWithoutSpecialtyInput>;
};

export type SpecialtyCreateWithoutEventInput = {
  Education?: InputMaybe<EducationCreateNestedManyWithoutSpecialtyInput>;
  TrainerEvent?: InputMaybe<TrainerEventCreateNestedManyWithoutTargetedSpecialitiesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  profession: ProfessionCreateNestedOneWithoutSpecialtiesInput;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn: Scalars['String'];
  users?: InputMaybe<UserCreateNestedManyWithoutSpecialtyInput>;
};

export type SpecialtyCreateWithoutProfessionInput = {
  Education?: InputMaybe<EducationCreateNestedManyWithoutSpecialtyInput>;
  Event?: InputMaybe<EventCreateNestedManyWithoutTargetedSpecialitiesInput>;
  TrainerEvent?: InputMaybe<TrainerEventCreateNestedManyWithoutTargetedSpecialitiesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn: Scalars['String'];
  users?: InputMaybe<UserCreateNestedManyWithoutSpecialtyInput>;
};

export type SpecialtyCreateWithoutTrainerEventInput = {
  Education?: InputMaybe<EducationCreateNestedManyWithoutSpecialtyInput>;
  Event?: InputMaybe<EventCreateNestedManyWithoutTargetedSpecialitiesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  profession: ProfessionCreateNestedOneWithoutSpecialtiesInput;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn: Scalars['String'];
  users?: InputMaybe<UserCreateNestedManyWithoutSpecialtyInput>;
};

export type SpecialtyCreateWithoutUsersInput = {
  Education?: InputMaybe<EducationCreateNestedManyWithoutSpecialtyInput>;
  Event?: InputMaybe<EventCreateNestedManyWithoutTargetedSpecialitiesInput>;
  TrainerEvent?: InputMaybe<TrainerEventCreateNestedManyWithoutTargetedSpecialitiesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  profession: ProfessionCreateNestedOneWithoutSpecialtiesInput;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn: Scalars['String'];
};

export type SpecialtyListRelationFilter = {
  every?: InputMaybe<SpecialtyWhereInput>;
  none?: InputMaybe<SpecialtyWhereInput>;
  some?: InputMaybe<SpecialtyWhereInput>;
};

export type SpecialtyMaxAggregateOutputType = {
  __typename?: 'SpecialtyMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  professionId?: Maybe<Scalars['Int']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type SpecialtyMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  professionId?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type SpecialtyMinAggregateOutputType = {
  __typename?: 'SpecialtyMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  professionId?: Maybe<Scalars['Int']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type SpecialtyMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  professionId?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type SpecialtyOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type SpecialtyOrderByWithAggregationInput = {
  _avg?: InputMaybe<SpecialtyAvgOrderByAggregateInput>;
  _count?: InputMaybe<SpecialtyCountOrderByAggregateInput>;
  _max?: InputMaybe<SpecialtyMaxOrderByAggregateInput>;
  _min?: InputMaybe<SpecialtyMinOrderByAggregateInput>;
  _sum?: InputMaybe<SpecialtySumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  professionId?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type SpecialtyOrderByWithRelationInput = {
  Education?: InputMaybe<EducationOrderByRelationAggregateInput>;
  Event?: InputMaybe<EventOrderByRelationAggregateInput>;
  TrainerEvent?: InputMaybe<TrainerEventOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  profession?: InputMaybe<ProfessionOrderByWithRelationInput>;
  professionId?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
  users?: InputMaybe<UserOrderByRelationAggregateInput>;
};

export type SpecialtyRelationFilter = {
  is?: InputMaybe<SpecialtyWhereInput>;
  isNot?: InputMaybe<SpecialtyWhereInput>;
};

export enum SpecialtyScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  ProfessionId = 'professionId',
  TitleAr = 'titleAr',
  TitleEn = 'titleEn'
}

export type SpecialtyScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<SpecialtyScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<SpecialtyScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<SpecialtyScalarWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  professionId?: InputMaybe<IntFilter>;
  titleAr?: InputMaybe<StringNullableFilter>;
  titleEn?: InputMaybe<StringFilter>;
};

export type SpecialtyScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<SpecialtyScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<SpecialtyScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<SpecialtyScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  professionId?: InputMaybe<IntWithAggregatesFilter>;
  titleAr?: InputMaybe<StringNullableWithAggregatesFilter>;
  titleEn?: InputMaybe<StringWithAggregatesFilter>;
};

export type SpecialtySumAggregateOutputType = {
  __typename?: 'SpecialtySumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
  professionId?: Maybe<Scalars['Int']>;
};

export type SpecialtySumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  professionId?: InputMaybe<SortOrder>;
};

export type SpecialtyUncheckedCreateInput = {
  Education?: InputMaybe<EducationUncheckedCreateNestedManyWithoutSpecialtyInput>;
  Event?: InputMaybe<EventUncheckedCreateNestedManyWithoutTargetedSpecialitiesInput>;
  TrainerEvent?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTargetedSpecialitiesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  professionId: Scalars['Int'];
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn: Scalars['String'];
  users?: InputMaybe<UserUncheckedCreateNestedManyWithoutSpecialtyInput>;
};

export type SpecialtyUncheckedCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<SpecialtyWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<SpecialtyCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<SpecialtyCreateWithoutEventInput>>>;
};

export type SpecialtyUncheckedCreateNestedManyWithoutProfessionInput = {
  connect?: InputMaybe<Array<InputMaybe<SpecialtyWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<SpecialtyCreateOrConnectWithoutProfessionInput>>>;
  create?: InputMaybe<Array<InputMaybe<SpecialtyCreateWithoutProfessionInput>>>;
  createMany?: InputMaybe<SpecialtyCreateManyProfessionInputEnvelope>;
};

export type SpecialtyUncheckedCreateNestedManyWithoutTrainerEventInput = {
  connect?: InputMaybe<Array<InputMaybe<SpecialtyWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<SpecialtyCreateOrConnectWithoutTrainerEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<SpecialtyCreateWithoutTrainerEventInput>>>;
};

export type SpecialtyUncheckedCreateWithoutEducationInput = {
  Event?: InputMaybe<EventUncheckedCreateNestedManyWithoutTargetedSpecialitiesInput>;
  TrainerEvent?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTargetedSpecialitiesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  professionId: Scalars['Int'];
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn: Scalars['String'];
  users?: InputMaybe<UserUncheckedCreateNestedManyWithoutSpecialtyInput>;
};

export type SpecialtyUncheckedCreateWithoutEventInput = {
  Education?: InputMaybe<EducationUncheckedCreateNestedManyWithoutSpecialtyInput>;
  TrainerEvent?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTargetedSpecialitiesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  professionId: Scalars['Int'];
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn: Scalars['String'];
  users?: InputMaybe<UserUncheckedCreateNestedManyWithoutSpecialtyInput>;
};

export type SpecialtyUncheckedCreateWithoutProfessionInput = {
  Education?: InputMaybe<EducationUncheckedCreateNestedManyWithoutSpecialtyInput>;
  Event?: InputMaybe<EventUncheckedCreateNestedManyWithoutTargetedSpecialitiesInput>;
  TrainerEvent?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTargetedSpecialitiesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn: Scalars['String'];
  users?: InputMaybe<UserUncheckedCreateNestedManyWithoutSpecialtyInput>;
};

export type SpecialtyUncheckedCreateWithoutTrainerEventInput = {
  Education?: InputMaybe<EducationUncheckedCreateNestedManyWithoutSpecialtyInput>;
  Event?: InputMaybe<EventUncheckedCreateNestedManyWithoutTargetedSpecialitiesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  professionId: Scalars['Int'];
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn: Scalars['String'];
  users?: InputMaybe<UserUncheckedCreateNestedManyWithoutSpecialtyInput>;
};

export type SpecialtyUncheckedCreateWithoutUsersInput = {
  Education?: InputMaybe<EducationUncheckedCreateNestedManyWithoutSpecialtyInput>;
  Event?: InputMaybe<EventUncheckedCreateNestedManyWithoutTargetedSpecialitiesInput>;
  TrainerEvent?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTargetedSpecialitiesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  professionId: Scalars['Int'];
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn: Scalars['String'];
};

export type SpecialtyUncheckedUpdateInput = {
  Education?: InputMaybe<EducationUncheckedUpdateManyWithoutSpecialtyInput>;
  Event?: InputMaybe<EventUncheckedUpdateManyWithoutTargetedSpecialitiesInput>;
  TrainerEvent?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTargetedSpecialitiesInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  professionId?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUncheckedUpdateManyWithoutSpecialtyInput>;
};

export type SpecialtyUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  professionId?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SpecialtyUncheckedUpdateManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<SpecialtyWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<SpecialtyCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<SpecialtyCreateWithoutEventInput>>>;
  delete?: InputMaybe<Array<InputMaybe<SpecialtyWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<SpecialtyScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<SpecialtyWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<SpecialtyWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<SpecialtyUpdateWithWhereUniqueWithoutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<SpecialtyUpdateManyWithWhereWithoutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<SpecialtyUpsertWithWhereUniqueWithoutEventInput>>>;
};

export type SpecialtyUncheckedUpdateManyWithoutProfessionInput = {
  connect?: InputMaybe<Array<InputMaybe<SpecialtyWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<SpecialtyCreateOrConnectWithoutProfessionInput>>>;
  create?: InputMaybe<Array<InputMaybe<SpecialtyCreateWithoutProfessionInput>>>;
  createMany?: InputMaybe<SpecialtyCreateManyProfessionInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<SpecialtyWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<SpecialtyScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<SpecialtyWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<SpecialtyWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<SpecialtyUpdateWithWhereUniqueWithoutProfessionInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<SpecialtyUpdateManyWithWhereWithoutProfessionInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<SpecialtyUpsertWithWhereUniqueWithoutProfessionInput>>>;
};

export type SpecialtyUncheckedUpdateManyWithoutSpecialtiesInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SpecialtyUncheckedUpdateManyWithoutTargetedSpecialitiesInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  professionId?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SpecialtyUncheckedUpdateManyWithoutTrainerEventInput = {
  connect?: InputMaybe<Array<InputMaybe<SpecialtyWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<SpecialtyCreateOrConnectWithoutTrainerEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<SpecialtyCreateWithoutTrainerEventInput>>>;
  delete?: InputMaybe<Array<InputMaybe<SpecialtyWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<SpecialtyScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<SpecialtyWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<SpecialtyWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<SpecialtyUpdateWithWhereUniqueWithoutTrainerEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<SpecialtyUpdateManyWithWhereWithoutTrainerEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<SpecialtyUpsertWithWhereUniqueWithoutTrainerEventInput>>>;
};

export type SpecialtyUncheckedUpdateWithoutEducationInput = {
  Event?: InputMaybe<EventUncheckedUpdateManyWithoutTargetedSpecialitiesInput>;
  TrainerEvent?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTargetedSpecialitiesInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  professionId?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUncheckedUpdateManyWithoutSpecialtyInput>;
};

export type SpecialtyUncheckedUpdateWithoutEventInput = {
  Education?: InputMaybe<EducationUncheckedUpdateManyWithoutSpecialtyInput>;
  TrainerEvent?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTargetedSpecialitiesInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  professionId?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUncheckedUpdateManyWithoutSpecialtyInput>;
};

export type SpecialtyUncheckedUpdateWithoutProfessionInput = {
  Education?: InputMaybe<EducationUncheckedUpdateManyWithoutSpecialtyInput>;
  Event?: InputMaybe<EventUncheckedUpdateManyWithoutTargetedSpecialitiesInput>;
  TrainerEvent?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTargetedSpecialitiesInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUncheckedUpdateManyWithoutSpecialtyInput>;
};

export type SpecialtyUncheckedUpdateWithoutTrainerEventInput = {
  Education?: InputMaybe<EducationUncheckedUpdateManyWithoutSpecialtyInput>;
  Event?: InputMaybe<EventUncheckedUpdateManyWithoutTargetedSpecialitiesInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  professionId?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUncheckedUpdateManyWithoutSpecialtyInput>;
};

export type SpecialtyUncheckedUpdateWithoutUsersInput = {
  Education?: InputMaybe<EducationUncheckedUpdateManyWithoutSpecialtyInput>;
  Event?: InputMaybe<EventUncheckedUpdateManyWithoutTargetedSpecialitiesInput>;
  TrainerEvent?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTargetedSpecialitiesInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  professionId?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SpecialtyUpdateInput = {
  Education?: InputMaybe<EducationUpdateManyWithoutSpecialtyInput>;
  Event?: InputMaybe<EventUpdateManyWithoutTargetedSpecialitiesInput>;
  TrainerEvent?: InputMaybe<TrainerEventUpdateManyWithoutTargetedSpecialitiesInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneRequiredWithoutSpecialtiesInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUpdateManyWithoutSpecialtyInput>;
};

export type SpecialtyUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SpecialtyUpdateManyWithWhereWithoutEventInput = {
  data: SpecialtyUncheckedUpdateManyWithoutTargetedSpecialitiesInput;
  where: SpecialtyScalarWhereInput;
};

export type SpecialtyUpdateManyWithWhereWithoutProfessionInput = {
  data: SpecialtyUncheckedUpdateManyWithoutSpecialtiesInput;
  where: SpecialtyScalarWhereInput;
};

export type SpecialtyUpdateManyWithWhereWithoutTrainerEventInput = {
  data: SpecialtyUncheckedUpdateManyWithoutTargetedSpecialitiesInput;
  where: SpecialtyScalarWhereInput;
};

export type SpecialtyUpdateManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<SpecialtyWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<SpecialtyCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<SpecialtyCreateWithoutEventInput>>>;
  delete?: InputMaybe<Array<InputMaybe<SpecialtyWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<SpecialtyScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<SpecialtyWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<SpecialtyWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<SpecialtyUpdateWithWhereUniqueWithoutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<SpecialtyUpdateManyWithWhereWithoutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<SpecialtyUpsertWithWhereUniqueWithoutEventInput>>>;
};

export type SpecialtyUpdateManyWithoutProfessionInput = {
  connect?: InputMaybe<Array<InputMaybe<SpecialtyWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<SpecialtyCreateOrConnectWithoutProfessionInput>>>;
  create?: InputMaybe<Array<InputMaybe<SpecialtyCreateWithoutProfessionInput>>>;
  createMany?: InputMaybe<SpecialtyCreateManyProfessionInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<SpecialtyWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<SpecialtyScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<SpecialtyWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<SpecialtyWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<SpecialtyUpdateWithWhereUniqueWithoutProfessionInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<SpecialtyUpdateManyWithWhereWithoutProfessionInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<SpecialtyUpsertWithWhereUniqueWithoutProfessionInput>>>;
};

export type SpecialtyUpdateManyWithoutTrainerEventInput = {
  connect?: InputMaybe<Array<InputMaybe<SpecialtyWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<SpecialtyCreateOrConnectWithoutTrainerEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<SpecialtyCreateWithoutTrainerEventInput>>>;
  delete?: InputMaybe<Array<InputMaybe<SpecialtyWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<SpecialtyScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<SpecialtyWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<SpecialtyWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<SpecialtyUpdateWithWhereUniqueWithoutTrainerEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<SpecialtyUpdateManyWithWhereWithoutTrainerEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<SpecialtyUpsertWithWhereUniqueWithoutTrainerEventInput>>>;
};

export type SpecialtyUpdateOneWithoutEducationInput = {
  connect?: InputMaybe<SpecialtyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SpecialtyCreateOrConnectWithoutEducationInput>;
  create?: InputMaybe<SpecialtyUncheckedCreateWithoutEducationInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<SpecialtyUncheckedUpdateWithoutEducationInput>;
  upsert?: InputMaybe<SpecialtyUpsertWithoutEducationInput>;
};

export type SpecialtyUpdateOneWithoutUsersInput = {
  connect?: InputMaybe<SpecialtyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SpecialtyCreateOrConnectWithoutUsersInput>;
  create?: InputMaybe<SpecialtyUncheckedCreateWithoutUsersInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<SpecialtyUncheckedUpdateWithoutUsersInput>;
  upsert?: InputMaybe<SpecialtyUpsertWithoutUsersInput>;
};

export type SpecialtyUpdateWithWhereUniqueWithoutEventInput = {
  data: SpecialtyUncheckedUpdateWithoutEventInput;
  where: SpecialtyWhereUniqueInput;
};

export type SpecialtyUpdateWithWhereUniqueWithoutProfessionInput = {
  data: SpecialtyUncheckedUpdateWithoutProfessionInput;
  where: SpecialtyWhereUniqueInput;
};

export type SpecialtyUpdateWithWhereUniqueWithoutTrainerEventInput = {
  data: SpecialtyUncheckedUpdateWithoutTrainerEventInput;
  where: SpecialtyWhereUniqueInput;
};

export type SpecialtyUpdateWithoutEducationInput = {
  Event?: InputMaybe<EventUpdateManyWithoutTargetedSpecialitiesInput>;
  TrainerEvent?: InputMaybe<TrainerEventUpdateManyWithoutTargetedSpecialitiesInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneRequiredWithoutSpecialtiesInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUpdateManyWithoutSpecialtyInput>;
};

export type SpecialtyUpdateWithoutEventInput = {
  Education?: InputMaybe<EducationUpdateManyWithoutSpecialtyInput>;
  TrainerEvent?: InputMaybe<TrainerEventUpdateManyWithoutTargetedSpecialitiesInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneRequiredWithoutSpecialtiesInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUpdateManyWithoutSpecialtyInput>;
};

export type SpecialtyUpdateWithoutProfessionInput = {
  Education?: InputMaybe<EducationUpdateManyWithoutSpecialtyInput>;
  Event?: InputMaybe<EventUpdateManyWithoutTargetedSpecialitiesInput>;
  TrainerEvent?: InputMaybe<TrainerEventUpdateManyWithoutTargetedSpecialitiesInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUpdateManyWithoutSpecialtyInput>;
};

export type SpecialtyUpdateWithoutTrainerEventInput = {
  Education?: InputMaybe<EducationUpdateManyWithoutSpecialtyInput>;
  Event?: InputMaybe<EventUpdateManyWithoutTargetedSpecialitiesInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneRequiredWithoutSpecialtiesInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUpdateManyWithoutSpecialtyInput>;
};

export type SpecialtyUpdateWithoutUsersInput = {
  Education?: InputMaybe<EducationUpdateManyWithoutSpecialtyInput>;
  Event?: InputMaybe<EventUpdateManyWithoutTargetedSpecialitiesInput>;
  TrainerEvent?: InputMaybe<TrainerEventUpdateManyWithoutTargetedSpecialitiesInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneRequiredWithoutSpecialtiesInput>;
  titleAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SpecialtyUpsertWithWhereUniqueWithoutEventInput = {
  create: SpecialtyUncheckedCreateWithoutEventInput;
  update: SpecialtyUncheckedUpdateWithoutEventInput;
  where: SpecialtyWhereUniqueInput;
};

export type SpecialtyUpsertWithWhereUniqueWithoutProfessionInput = {
  create: SpecialtyUncheckedCreateWithoutProfessionInput;
  update: SpecialtyUncheckedUpdateWithoutProfessionInput;
  where: SpecialtyWhereUniqueInput;
};

export type SpecialtyUpsertWithWhereUniqueWithoutTrainerEventInput = {
  create: SpecialtyUncheckedCreateWithoutTrainerEventInput;
  update: SpecialtyUncheckedUpdateWithoutTrainerEventInput;
  where: SpecialtyWhereUniqueInput;
};

export type SpecialtyUpsertWithoutEducationInput = {
  create: SpecialtyUncheckedCreateWithoutEducationInput;
  update: SpecialtyUncheckedUpdateWithoutEducationInput;
};

export type SpecialtyUpsertWithoutUsersInput = {
  create: SpecialtyUncheckedCreateWithoutUsersInput;
  update: SpecialtyUncheckedUpdateWithoutUsersInput;
};

export type SpecialtyWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<SpecialtyWhereInput>>>;
  Education?: InputMaybe<EducationListRelationFilter>;
  Event?: InputMaybe<EventListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<SpecialtyWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<SpecialtyWhereInput>>>;
  TrainerEvent?: InputMaybe<TrainerEventListRelationFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  profession?: InputMaybe<ProfessionWhereInput>;
  professionId?: InputMaybe<IntFilter>;
  titleAr?: InputMaybe<StringNullableFilter>;
  titleEn?: InputMaybe<StringFilter>;
  users?: InputMaybe<UserListRelationFilter>;
};

export type SpecialtyWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type State = {
  __typename?: 'State';
  _count: StateCountOutputType;
  cities: Array<City>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  users: Array<User>;
};


export type StateCitiesArgs = {
  cursor?: InputMaybe<CityWhereUniqueInput>;
  distinct?: InputMaybe<CityScalarFieldEnum>;
  orderBy?: InputMaybe<CityOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CityWhereInput>;
};


export type StateUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<UserScalarFieldEnum>;
  orderBy?: InputMaybe<UserOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};

export type StateAvgAggregateOutputType = {
  __typename?: 'StateAvgAggregateOutputType';
  countryId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

export type StateAvgOrderByAggregateInput = {
  countryId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type StateCountAggregateOutputType = {
  __typename?: 'StateCountAggregateOutputType';
  _all: Scalars['Int'];
  countryId: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
};

export type StateCountOrderByAggregateInput = {
  countryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type StateCountOutputType = {
  __typename?: 'StateCountOutputType';
  cities: Scalars['Int'];
  users: Scalars['Int'];
};

export type StateCreateInput = {
  cities?: InputMaybe<CityCreateNestedManyWithoutStatesInput>;
  country?: InputMaybe<CountryCreateNestedOneWithoutStatesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  name: Scalars['String'];
  users?: InputMaybe<UserCreateNestedManyWithoutStateInput>;
};

export type StateCreateManyCountryInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type StateCreateManyCountryInputEnvelope = {
  data: StateCreateManyCountryInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type StateCreateManyInput = {
  countryId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type StateCreateNestedManyWithoutCountryInput = {
  connect?: InputMaybe<Array<InputMaybe<StateWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<StateCreateOrConnectWithoutCountryInput>>>;
  create?: InputMaybe<Array<InputMaybe<StateCreateWithoutCountryInput>>>;
  createMany?: InputMaybe<StateCreateManyCountryInputEnvelope>;
};

export type StateCreateNestedOneWithoutCitiesInput = {
  connect?: InputMaybe<StateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StateCreateOrConnectWithoutCitiesInput>;
  create?: InputMaybe<StateUncheckedCreateWithoutCitiesInput>;
};

export type StateCreateNestedOneWithoutUsersInput = {
  connect?: InputMaybe<StateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StateCreateOrConnectWithoutUsersInput>;
  create?: InputMaybe<StateUncheckedCreateWithoutUsersInput>;
};

export type StateCreateOrConnectWithoutCitiesInput = {
  create: StateUncheckedCreateWithoutCitiesInput;
  where: StateWhereUniqueInput;
};

export type StateCreateOrConnectWithoutCountryInput = {
  create: StateUncheckedCreateWithoutCountryInput;
  where: StateWhereUniqueInput;
};

export type StateCreateOrConnectWithoutUsersInput = {
  create: StateUncheckedCreateWithoutUsersInput;
  where: StateWhereUniqueInput;
};

export type StateCreateWithoutCitiesInput = {
  country?: InputMaybe<CountryCreateNestedOneWithoutStatesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  name: Scalars['String'];
  users?: InputMaybe<UserCreateNestedManyWithoutStateInput>;
};

export type StateCreateWithoutCountryInput = {
  cities?: InputMaybe<CityCreateNestedManyWithoutStatesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  name: Scalars['String'];
  users?: InputMaybe<UserCreateNestedManyWithoutStateInput>;
};

export type StateCreateWithoutUsersInput = {
  cities?: InputMaybe<CityCreateNestedManyWithoutStatesInput>;
  country?: InputMaybe<CountryCreateNestedOneWithoutStatesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  name: Scalars['String'];
};

export type StateListRelationFilter = {
  every?: InputMaybe<StateWhereInput>;
  none?: InputMaybe<StateWhereInput>;
  some?: InputMaybe<StateWhereInput>;
};

export type StateMaxAggregateOutputType = {
  __typename?: 'StateMaxAggregateOutputType';
  countryId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type StateMaxOrderByAggregateInput = {
  countryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type StateMinAggregateOutputType = {
  __typename?: 'StateMinAggregateOutputType';
  countryId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type StateMinOrderByAggregateInput = {
  countryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type StateOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type StateOrderByWithAggregationInput = {
  _avg?: InputMaybe<StateAvgOrderByAggregateInput>;
  _count?: InputMaybe<StateCountOrderByAggregateInput>;
  _max?: InputMaybe<StateMaxOrderByAggregateInput>;
  _min?: InputMaybe<StateMinOrderByAggregateInput>;
  _sum?: InputMaybe<StateSumOrderByAggregateInput>;
  countryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type StateOrderByWithRelationInput = {
  cities?: InputMaybe<CityOrderByRelationAggregateInput>;
  country?: InputMaybe<CountryOrderByWithRelationInput>;
  countryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  users?: InputMaybe<UserOrderByRelationAggregateInput>;
};

export type StateRelationFilter = {
  is?: InputMaybe<StateWhereInput>;
  isNot?: InputMaybe<StateWhereInput>;
};

export enum StateScalarFieldEnum {
  CountryId = 'countryId',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  Name = 'name'
}

export type StateScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<StateScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<StateScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<StateScalarWhereInput>>>;
  countryId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
};

export type StateScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<StateScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<StateScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<StateScalarWhereWithAggregatesInput>>>;
  countryId?: InputMaybe<IntNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
};

export type StateSumAggregateOutputType = {
  __typename?: 'StateSumAggregateOutputType';
  countryId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type StateSumOrderByAggregateInput = {
  countryId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type StateUncheckedCreateInput = {
  cities?: InputMaybe<CityUncheckedCreateNestedManyWithoutStatesInput>;
  countryId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  users?: InputMaybe<UserUncheckedCreateNestedManyWithoutStateInput>;
};

export type StateUncheckedCreateNestedManyWithoutCountryInput = {
  connect?: InputMaybe<Array<InputMaybe<StateWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<StateCreateOrConnectWithoutCountryInput>>>;
  create?: InputMaybe<Array<InputMaybe<StateCreateWithoutCountryInput>>>;
  createMany?: InputMaybe<StateCreateManyCountryInputEnvelope>;
};

export type StateUncheckedCreateWithoutCitiesInput = {
  countryId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  users?: InputMaybe<UserUncheckedCreateNestedManyWithoutStateInput>;
};

export type StateUncheckedCreateWithoutCountryInput = {
  cities?: InputMaybe<CityUncheckedCreateNestedManyWithoutStatesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  users?: InputMaybe<UserUncheckedCreateNestedManyWithoutStateInput>;
};

export type StateUncheckedCreateWithoutUsersInput = {
  cities?: InputMaybe<CityUncheckedCreateNestedManyWithoutStatesInput>;
  countryId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type StateUncheckedUpdateInput = {
  cities?: InputMaybe<CityUncheckedUpdateManyWithoutStatesInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUncheckedUpdateManyWithoutStateInput>;
};

export type StateUncheckedUpdateManyInput = {
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type StateUncheckedUpdateManyWithoutCountryInput = {
  connect?: InputMaybe<Array<InputMaybe<StateWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<StateCreateOrConnectWithoutCountryInput>>>;
  create?: InputMaybe<Array<InputMaybe<StateCreateWithoutCountryInput>>>;
  createMany?: InputMaybe<StateCreateManyCountryInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<StateWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<StateScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<StateWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<StateWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<StateUpdateWithWhereUniqueWithoutCountryInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<StateUpdateManyWithWhereWithoutCountryInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<StateUpsertWithWhereUniqueWithoutCountryInput>>>;
};

export type StateUncheckedUpdateManyWithoutStatesInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type StateUncheckedUpdateWithoutCitiesInput = {
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUncheckedUpdateManyWithoutStateInput>;
};

export type StateUncheckedUpdateWithoutCountryInput = {
  cities?: InputMaybe<CityUncheckedUpdateManyWithoutStatesInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUncheckedUpdateManyWithoutStateInput>;
};

export type StateUncheckedUpdateWithoutUsersInput = {
  cities?: InputMaybe<CityUncheckedUpdateManyWithoutStatesInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type StateUpdateInput = {
  cities?: InputMaybe<CityUpdateManyWithoutStatesInput>;
  country?: InputMaybe<CountryUpdateOneWithoutStatesInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUpdateManyWithoutStateInput>;
};

export type StateUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type StateUpdateManyWithWhereWithoutCountryInput = {
  data: StateUncheckedUpdateManyWithoutStatesInput;
  where: StateScalarWhereInput;
};

export type StateUpdateManyWithoutCountryInput = {
  connect?: InputMaybe<Array<InputMaybe<StateWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<StateCreateOrConnectWithoutCountryInput>>>;
  create?: InputMaybe<Array<InputMaybe<StateCreateWithoutCountryInput>>>;
  createMany?: InputMaybe<StateCreateManyCountryInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<StateWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<StateScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<StateWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<StateWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<StateUpdateWithWhereUniqueWithoutCountryInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<StateUpdateManyWithWhereWithoutCountryInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<StateUpsertWithWhereUniqueWithoutCountryInput>>>;
};

export type StateUpdateOneWithoutCitiesInput = {
  connect?: InputMaybe<StateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StateCreateOrConnectWithoutCitiesInput>;
  create?: InputMaybe<StateUncheckedCreateWithoutCitiesInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<StateUncheckedUpdateWithoutCitiesInput>;
  upsert?: InputMaybe<StateUpsertWithoutCitiesInput>;
};

export type StateUpdateOneWithoutUsersInput = {
  connect?: InputMaybe<StateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StateCreateOrConnectWithoutUsersInput>;
  create?: InputMaybe<StateUncheckedCreateWithoutUsersInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<StateUncheckedUpdateWithoutUsersInput>;
  upsert?: InputMaybe<StateUpsertWithoutUsersInput>;
};

export type StateUpdateWithWhereUniqueWithoutCountryInput = {
  data: StateUncheckedUpdateWithoutCountryInput;
  where: StateWhereUniqueInput;
};

export type StateUpdateWithoutCitiesInput = {
  country?: InputMaybe<CountryUpdateOneWithoutStatesInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUpdateManyWithoutStateInput>;
};

export type StateUpdateWithoutCountryInput = {
  cities?: InputMaybe<CityUpdateManyWithoutStatesInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUpdateManyWithoutStateInput>;
};

export type StateUpdateWithoutUsersInput = {
  cities?: InputMaybe<CityUpdateManyWithoutStatesInput>;
  country?: InputMaybe<CountryUpdateOneWithoutStatesInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type StateUpsertWithWhereUniqueWithoutCountryInput = {
  create: StateUncheckedCreateWithoutCountryInput;
  update: StateUncheckedUpdateWithoutCountryInput;
  where: StateWhereUniqueInput;
};

export type StateUpsertWithoutCitiesInput = {
  create: StateUncheckedCreateWithoutCitiesInput;
  update: StateUncheckedUpdateWithoutCitiesInput;
};

export type StateUpsertWithoutUsersInput = {
  create: StateUncheckedCreateWithoutUsersInput;
  update: StateUncheckedUpdateWithoutUsersInput;
};

export type StateWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<StateWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<StateWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<StateWhereInput>>>;
  cities?: InputMaybe<CityListRelationFilter>;
  country?: InputMaybe<CountryWhereInput>;
  countryId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  users?: InputMaybe<UserListRelationFilter>;
};

export type StateWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type StringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StringNullableListFilter = {
  equals?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  has?: InputMaybe<Scalars['String']>;
  hasEvery?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hasSome?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isEmpty?: InputMaybe<Scalars['Boolean']>;
};

export type StringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedStringNullableFilter>;
  _min?: InputMaybe<NestedStringNullableFilter>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedStringFilter>;
  _min?: InputMaybe<NestedStringFilter>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StudyMaterialAttendanceType = {
  traineeEventId: Scalars['Int'];
};

export type Template = {
  __typename?: 'Template';
  AutomatedEmails: Array<AutomatedEmails>;
  Certificate: Array<Certificate>;
  _count: TemplateCountOutputType;
  createdAt?: Maybe<Scalars['DateTime']>;
  data: Scalars['Json'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  key_alias?: Maybe<Scalars['String']>;
  purpose: TemplatePurpose;
  subject?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  traineeCertificateEvents: Array<Event>;
  trainerCertificateEvents: Array<Event>;
  zohoTemplateId?: Maybe<Scalars['String']>;
};


export type TemplateAutomatedEmailsArgs = {
  cursor?: InputMaybe<AutomatedEmailsWhereUniqueInput>;
  distinct?: InputMaybe<AutomatedEmailsScalarFieldEnum>;
  orderBy?: InputMaybe<AutomatedEmailsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AutomatedEmailsWhereInput>;
};


export type TemplateCertificateArgs = {
  cursor?: InputMaybe<CertificateWhereUniqueInput>;
  distinct?: InputMaybe<CertificateScalarFieldEnum>;
  orderBy?: InputMaybe<CertificateOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CertificateWhereInput>;
};


export type TemplateTraineeCertificateEventsArgs = {
  cursor?: InputMaybe<EventWhereUniqueInput>;
  distinct?: InputMaybe<EventScalarFieldEnum>;
  orderBy?: InputMaybe<EventOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EventWhereInput>;
};


export type TemplateTrainerCertificateEventsArgs = {
  cursor?: InputMaybe<EventWhereUniqueInput>;
  distinct?: InputMaybe<EventScalarFieldEnum>;
  orderBy?: InputMaybe<EventOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EventWhereInput>;
};

export type TemplateAvgAggregateOutputType = {
  __typename?: 'TemplateAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
};

export type TemplateAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type TemplateCountAggregateOutputType = {
  __typename?: 'TemplateCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  data: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  key_alias: Scalars['Int'];
  purpose: Scalars['Int'];
  subject: Scalars['Int'];
  title: Scalars['Int'];
  zohotemplateid: Scalars['Int'];
};

export type TemplateCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  key_alias?: InputMaybe<SortOrder>;
  purpose?: InputMaybe<SortOrder>;
  subject?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  zohotemplateid?: InputMaybe<SortOrder>;
};

export type TemplateCountOutputType = {
  __typename?: 'TemplateCountOutputType';
  AutomatedEmails: Scalars['Int'];
  Certificate: Scalars['Int'];
  ZohoEmail: Scalars['Int'];
  traineeCertificateEvents: Scalars['Int'];
  trainerCertificateEvents: Scalars['Int'];
};

export type TemplateCreateInput = {
  AutomatedEmails?: InputMaybe<AutomatedEmailsCreateNestedManyWithoutTemplateInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTemplateInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTemplateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data: Scalars['Json'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  key_alias?: InputMaybe<Scalars['String']>;
  purpose: TemplatePurpose;
  subject?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  traineeCertificateEvents?: InputMaybe<EventCreateNestedManyWithoutTraineeCertificateTemplateInput>;
  trainerCertificateEvents?: InputMaybe<EventCreateNestedManyWithoutTrainerCertificateTemplateInput>;
  zohotemplateid?: InputMaybe<Scalars['String']>;
};

export type TemplateCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data: Scalars['Json'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  key_alias?: InputMaybe<Scalars['String']>;
  purpose: TemplatePurpose;
  subject?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  zohotemplateid?: InputMaybe<Scalars['String']>;
};

export type TemplateCreateNestedOneWithoutAutomatedEmailsInput = {
  connect?: InputMaybe<TemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TemplateCreateOrConnectWithoutAutomatedEmailsInput>;
  create?: InputMaybe<TemplateUncheckedCreateWithoutAutomatedEmailsInput>;
};

export type TemplateCreateNestedOneWithoutCertificateInput = {
  connect?: InputMaybe<TemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TemplateCreateOrConnectWithoutCertificateInput>;
  create?: InputMaybe<TemplateUncheckedCreateWithoutCertificateInput>;
};

export type TemplateCreateNestedOneWithoutTraineeCertificateEventsInput = {
  connect?: InputMaybe<TemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TemplateCreateOrConnectWithoutTraineeCertificateEventsInput>;
  create?: InputMaybe<TemplateUncheckedCreateWithoutTraineeCertificateEventsInput>;
};

export type TemplateCreateNestedOneWithoutTrainerCertificateEventsInput = {
  connect?: InputMaybe<TemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TemplateCreateOrConnectWithoutTrainerCertificateEventsInput>;
  create?: InputMaybe<TemplateUncheckedCreateWithoutTrainerCertificateEventsInput>;
};

export type TemplateCreateNestedOneWithoutZohoEmailInput = {
  connect?: InputMaybe<TemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TemplateCreateOrConnectWithoutZohoEmailInput>;
  create?: InputMaybe<TemplateUncheckedCreateWithoutZohoEmailInput>;
};

export type TemplateCreateOrConnectWithoutAutomatedEmailsInput = {
  create: TemplateUncheckedCreateWithoutAutomatedEmailsInput;
  where: TemplateWhereUniqueInput;
};

export type TemplateCreateOrConnectWithoutCertificateInput = {
  create: TemplateUncheckedCreateWithoutCertificateInput;
  where: TemplateWhereUniqueInput;
};

export type TemplateCreateOrConnectWithoutTraineeCertificateEventsInput = {
  create: TemplateUncheckedCreateWithoutTraineeCertificateEventsInput;
  where: TemplateWhereUniqueInput;
};

export type TemplateCreateOrConnectWithoutTrainerCertificateEventsInput = {
  create: TemplateUncheckedCreateWithoutTrainerCertificateEventsInput;
  where: TemplateWhereUniqueInput;
};

export type TemplateCreateOrConnectWithoutZohoEmailInput = {
  create: TemplateUncheckedCreateWithoutZohoEmailInput;
  where: TemplateWhereUniqueInput;
};

export type TemplateCreateWithoutAutomatedEmailsInput = {
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTemplateInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTemplateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data: Scalars['Json'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  key_alias?: InputMaybe<Scalars['String']>;
  purpose: TemplatePurpose;
  subject?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  traineeCertificateEvents?: InputMaybe<EventCreateNestedManyWithoutTraineeCertificateTemplateInput>;
  trainerCertificateEvents?: InputMaybe<EventCreateNestedManyWithoutTrainerCertificateTemplateInput>;
  zohotemplateid?: InputMaybe<Scalars['String']>;
};

export type TemplateCreateWithoutCertificateInput = {
  AutomatedEmails?: InputMaybe<AutomatedEmailsCreateNestedManyWithoutTemplateInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTemplateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data: Scalars['Json'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  key_alias?: InputMaybe<Scalars['String']>;
  purpose: TemplatePurpose;
  subject?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  traineeCertificateEvents?: InputMaybe<EventCreateNestedManyWithoutTraineeCertificateTemplateInput>;
  trainerCertificateEvents?: InputMaybe<EventCreateNestedManyWithoutTrainerCertificateTemplateInput>;
  zohotemplateid?: InputMaybe<Scalars['String']>;
};

export type TemplateCreateWithoutTraineeCertificateEventsInput = {
  AutomatedEmails?: InputMaybe<AutomatedEmailsCreateNestedManyWithoutTemplateInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTemplateInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTemplateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data: Scalars['Json'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  key_alias?: InputMaybe<Scalars['String']>;
  purpose: TemplatePurpose;
  subject?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  trainerCertificateEvents?: InputMaybe<EventCreateNestedManyWithoutTrainerCertificateTemplateInput>;
  zohotemplateid?: InputMaybe<Scalars['String']>;
};

export type TemplateCreateWithoutTrainerCertificateEventsInput = {
  AutomatedEmails?: InputMaybe<AutomatedEmailsCreateNestedManyWithoutTemplateInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTemplateInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTemplateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data: Scalars['Json'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  key_alias?: InputMaybe<Scalars['String']>;
  purpose: TemplatePurpose;
  subject?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  traineeCertificateEvents?: InputMaybe<EventCreateNestedManyWithoutTraineeCertificateTemplateInput>;
  zohotemplateid?: InputMaybe<Scalars['String']>;
};

export type TemplateCreateWithoutZohoEmailInput = {
  AutomatedEmails?: InputMaybe<AutomatedEmailsCreateNestedManyWithoutTemplateInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTemplateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data: Scalars['Json'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  key_alias?: InputMaybe<Scalars['String']>;
  purpose: TemplatePurpose;
  subject?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  traineeCertificateEvents?: InputMaybe<EventCreateNestedManyWithoutTraineeCertificateTemplateInput>;
  trainerCertificateEvents?: InputMaybe<EventCreateNestedManyWithoutTrainerCertificateTemplateInput>;
  zohotemplateid?: InputMaybe<Scalars['String']>;
};

export type TemplateMaxAggregateOutputType = {
  __typename?: 'TemplateMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  key_alias?: Maybe<Scalars['String']>;
  purpose?: Maybe<TemplatePurpose>;
  subject?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  zohotemplateid?: Maybe<Scalars['String']>;
};

export type TemplateMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  key_alias?: InputMaybe<SortOrder>;
  purpose?: InputMaybe<SortOrder>;
  subject?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  zohotemplateid?: InputMaybe<SortOrder>;
};

export type TemplateMinAggregateOutputType = {
  __typename?: 'TemplateMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  key_alias?: Maybe<Scalars['String']>;
  purpose?: Maybe<TemplatePurpose>;
  subject?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  zohotemplateid?: Maybe<Scalars['String']>;
};

export type TemplateMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  key_alias?: InputMaybe<SortOrder>;
  purpose?: InputMaybe<SortOrder>;
  subject?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  zohotemplateid?: InputMaybe<SortOrder>;
};

export type TemplateOrderByWithAggregationInput = {
  _avg?: InputMaybe<TemplateAvgOrderByAggregateInput>;
  _count?: InputMaybe<TemplateCountOrderByAggregateInput>;
  _max?: InputMaybe<TemplateMaxOrderByAggregateInput>;
  _min?: InputMaybe<TemplateMinOrderByAggregateInput>;
  _sum?: InputMaybe<TemplateSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  key_alias?: InputMaybe<SortOrder>;
  purpose?: InputMaybe<SortOrder>;
  subject?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  zohotemplateid?: InputMaybe<SortOrder>;
};

export type TemplateOrderByWithRelationInput = {
  AutomatedEmails?: InputMaybe<AutomatedEmailsOrderByRelationAggregateInput>;
  Certificate?: InputMaybe<CertificateOrderByRelationAggregateInput>;
  ZohoEmail?: InputMaybe<ZohoEmailOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  key_alias?: InputMaybe<SortOrder>;
  purpose?: InputMaybe<SortOrder>;
  subject?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  traineeCertificateEvents?: InputMaybe<EventOrderByRelationAggregateInput>;
  trainerCertificateEvents?: InputMaybe<EventOrderByRelationAggregateInput>;
  zohotemplateid?: InputMaybe<SortOrder>;
};

export enum TemplatePurpose {
  Certificate = 'certificate',
  Email = 'email',
  Notification = 'notification',
  Others = 'others',
  Page = 'page'
}

export type TemplateRelationFilter = {
  is?: InputMaybe<TemplateWhereInput>;
  isNot?: InputMaybe<TemplateWhereInput>;
};

export enum TemplateScalarFieldEnum {
  CreatedAt = 'createdAt',
  Data = 'data',
  DeletedAt = 'deletedAt',
  Id = 'id',
  KeyAlias = 'key_alias',
  Purpose = 'purpose',
  Subject = 'subject',
  Title = 'title',
  Zohotemplateid = 'zohotemplateid'
}

export type TemplateScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<TemplateScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TemplateScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TemplateScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  data?: InputMaybe<JsonWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  key_alias?: InputMaybe<StringNullableWithAggregatesFilter>;
  purpose?: InputMaybe<EnumTemplatePurposeWithAggregatesFilter>;
  subject?: InputMaybe<StringNullableWithAggregatesFilter>;
  title?: InputMaybe<StringWithAggregatesFilter>;
  zohotemplateid?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type TemplateSumAggregateOutputType = {
  __typename?: 'TemplateSumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
};

export type TemplateSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type TemplateUncheckedCreateInput = {
  AutomatedEmails?: InputMaybe<AutomatedEmailsUncheckedCreateNestedManyWithoutTemplateInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTemplateInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTemplateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data: Scalars['Json'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  key_alias?: InputMaybe<Scalars['String']>;
  purpose: TemplatePurpose;
  subject?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  traineeCertificateEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutTraineeCertificateTemplateInput>;
  trainerCertificateEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutTrainerCertificateTemplateInput>;
  zohotemplateid?: InputMaybe<Scalars['String']>;
};

export type TemplateUncheckedCreateWithoutAutomatedEmailsInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTemplateInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTemplateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data: Scalars['Json'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  key_alias?: InputMaybe<Scalars['String']>;
  purpose: TemplatePurpose;
  subject?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  traineeCertificateEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutTraineeCertificateTemplateInput>;
  trainerCertificateEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutTrainerCertificateTemplateInput>;
  zohotemplateid?: InputMaybe<Scalars['String']>;
};

export type TemplateUncheckedCreateWithoutCertificateInput = {
  AutomatedEmails?: InputMaybe<AutomatedEmailsUncheckedCreateNestedManyWithoutTemplateInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTemplateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data: Scalars['Json'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  key_alias?: InputMaybe<Scalars['String']>;
  purpose: TemplatePurpose;
  subject?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  traineeCertificateEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutTraineeCertificateTemplateInput>;
  trainerCertificateEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutTrainerCertificateTemplateInput>;
  zohotemplateid?: InputMaybe<Scalars['String']>;
};

export type TemplateUncheckedCreateWithoutTraineeCertificateEventsInput = {
  AutomatedEmails?: InputMaybe<AutomatedEmailsUncheckedCreateNestedManyWithoutTemplateInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTemplateInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTemplateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data: Scalars['Json'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  key_alias?: InputMaybe<Scalars['String']>;
  purpose: TemplatePurpose;
  subject?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  trainerCertificateEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutTrainerCertificateTemplateInput>;
  zohotemplateid?: InputMaybe<Scalars['String']>;
};

export type TemplateUncheckedCreateWithoutTrainerCertificateEventsInput = {
  AutomatedEmails?: InputMaybe<AutomatedEmailsUncheckedCreateNestedManyWithoutTemplateInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTemplateInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTemplateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data: Scalars['Json'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  key_alias?: InputMaybe<Scalars['String']>;
  purpose: TemplatePurpose;
  subject?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  traineeCertificateEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutTraineeCertificateTemplateInput>;
  zohotemplateid?: InputMaybe<Scalars['String']>;
};

export type TemplateUncheckedCreateWithoutZohoEmailInput = {
  AutomatedEmails?: InputMaybe<AutomatedEmailsUncheckedCreateNestedManyWithoutTemplateInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTemplateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data: Scalars['Json'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  key_alias?: InputMaybe<Scalars['String']>;
  purpose: TemplatePurpose;
  subject?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  traineeCertificateEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutTraineeCertificateTemplateInput>;
  trainerCertificateEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutTrainerCertificateTemplateInput>;
  zohotemplateid?: InputMaybe<Scalars['String']>;
};

export type TemplateUncheckedUpdateInput = {
  AutomatedEmails?: InputMaybe<AutomatedEmailsUncheckedUpdateManyWithoutTemplateInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTemplateInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTemplateInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  key_alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  purpose?: InputMaybe<EnumTemplatePurposeFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateEvents?: InputMaybe<EventUncheckedUpdateManyWithoutTraineeCertificateTemplateInput>;
  trainerCertificateEvents?: InputMaybe<EventUncheckedUpdateManyWithoutTrainerCertificateTemplateInput>;
  zohotemplateid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TemplateUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  key_alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  purpose?: InputMaybe<EnumTemplatePurposeFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  zohotemplateid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TemplateUncheckedUpdateWithoutAutomatedEmailsInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTemplateInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTemplateInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  key_alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  purpose?: InputMaybe<EnumTemplatePurposeFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateEvents?: InputMaybe<EventUncheckedUpdateManyWithoutTraineeCertificateTemplateInput>;
  trainerCertificateEvents?: InputMaybe<EventUncheckedUpdateManyWithoutTrainerCertificateTemplateInput>;
  zohotemplateid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TemplateUncheckedUpdateWithoutCertificateInput = {
  AutomatedEmails?: InputMaybe<AutomatedEmailsUncheckedUpdateManyWithoutTemplateInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTemplateInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  key_alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  purpose?: InputMaybe<EnumTemplatePurposeFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateEvents?: InputMaybe<EventUncheckedUpdateManyWithoutTraineeCertificateTemplateInput>;
  trainerCertificateEvents?: InputMaybe<EventUncheckedUpdateManyWithoutTrainerCertificateTemplateInput>;
  zohotemplateid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TemplateUncheckedUpdateWithoutTraineeCertificateEventsInput = {
  AutomatedEmails?: InputMaybe<AutomatedEmailsUncheckedUpdateManyWithoutTemplateInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTemplateInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTemplateInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  key_alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  purpose?: InputMaybe<EnumTemplatePurposeFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  trainerCertificateEvents?: InputMaybe<EventUncheckedUpdateManyWithoutTrainerCertificateTemplateInput>;
  zohotemplateid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TemplateUncheckedUpdateWithoutTrainerCertificateEventsInput = {
  AutomatedEmails?: InputMaybe<AutomatedEmailsUncheckedUpdateManyWithoutTemplateInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTemplateInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTemplateInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  key_alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  purpose?: InputMaybe<EnumTemplatePurposeFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateEvents?: InputMaybe<EventUncheckedUpdateManyWithoutTraineeCertificateTemplateInput>;
  zohotemplateid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TemplateUncheckedUpdateWithoutZohoEmailInput = {
  AutomatedEmails?: InputMaybe<AutomatedEmailsUncheckedUpdateManyWithoutTemplateInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTemplateInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  key_alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  purpose?: InputMaybe<EnumTemplatePurposeFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateEvents?: InputMaybe<EventUncheckedUpdateManyWithoutTraineeCertificateTemplateInput>;
  trainerCertificateEvents?: InputMaybe<EventUncheckedUpdateManyWithoutTrainerCertificateTemplateInput>;
  zohotemplateid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TemplateUpdateInput = {
  AutomatedEmails?: InputMaybe<AutomatedEmailsUpdateManyWithoutTemplateInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTemplateInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTemplateInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  key_alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  purpose?: InputMaybe<EnumTemplatePurposeFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateEvents?: InputMaybe<EventUpdateManyWithoutTraineeCertificateTemplateInput>;
  trainerCertificateEvents?: InputMaybe<EventUpdateManyWithoutTrainerCertificateTemplateInput>;
  zohotemplateid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TemplateUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  key_alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  purpose?: InputMaybe<EnumTemplatePurposeFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  zohotemplateid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TemplateUpdateOneWithoutAutomatedEmailsInput = {
  connect?: InputMaybe<TemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TemplateCreateOrConnectWithoutAutomatedEmailsInput>;
  create?: InputMaybe<TemplateUncheckedCreateWithoutAutomatedEmailsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<TemplateUncheckedUpdateWithoutAutomatedEmailsInput>;
  upsert?: InputMaybe<TemplateUpsertWithoutAutomatedEmailsInput>;
};

export type TemplateUpdateOneWithoutCertificateInput = {
  connect?: InputMaybe<TemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TemplateCreateOrConnectWithoutCertificateInput>;
  create?: InputMaybe<TemplateUncheckedCreateWithoutCertificateInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<TemplateUncheckedUpdateWithoutCertificateInput>;
  upsert?: InputMaybe<TemplateUpsertWithoutCertificateInput>;
};

export type TemplateUpdateOneWithoutTraineeCertificateEventsInput = {
  connect?: InputMaybe<TemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TemplateCreateOrConnectWithoutTraineeCertificateEventsInput>;
  create?: InputMaybe<TemplateUncheckedCreateWithoutTraineeCertificateEventsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<TemplateUncheckedUpdateWithoutTraineeCertificateEventsInput>;
  upsert?: InputMaybe<TemplateUpsertWithoutTraineeCertificateEventsInput>;
};

export type TemplateUpdateOneWithoutTrainerCertificateEventsInput = {
  connect?: InputMaybe<TemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TemplateCreateOrConnectWithoutTrainerCertificateEventsInput>;
  create?: InputMaybe<TemplateUncheckedCreateWithoutTrainerCertificateEventsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<TemplateUncheckedUpdateWithoutTrainerCertificateEventsInput>;
  upsert?: InputMaybe<TemplateUpsertWithoutTrainerCertificateEventsInput>;
};

export type TemplateUpdateOneWithoutZohoEmailInput = {
  connect?: InputMaybe<TemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TemplateCreateOrConnectWithoutZohoEmailInput>;
  create?: InputMaybe<TemplateUncheckedCreateWithoutZohoEmailInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<TemplateUncheckedUpdateWithoutZohoEmailInput>;
  upsert?: InputMaybe<TemplateUpsertWithoutZohoEmailInput>;
};

export type TemplateUpdateWithoutAutomatedEmailsInput = {
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTemplateInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTemplateInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  key_alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  purpose?: InputMaybe<EnumTemplatePurposeFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateEvents?: InputMaybe<EventUpdateManyWithoutTraineeCertificateTemplateInput>;
  trainerCertificateEvents?: InputMaybe<EventUpdateManyWithoutTrainerCertificateTemplateInput>;
  zohotemplateid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TemplateUpdateWithoutCertificateInput = {
  AutomatedEmails?: InputMaybe<AutomatedEmailsUpdateManyWithoutTemplateInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTemplateInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  key_alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  purpose?: InputMaybe<EnumTemplatePurposeFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateEvents?: InputMaybe<EventUpdateManyWithoutTraineeCertificateTemplateInput>;
  trainerCertificateEvents?: InputMaybe<EventUpdateManyWithoutTrainerCertificateTemplateInput>;
  zohotemplateid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TemplateUpdateWithoutTraineeCertificateEventsInput = {
  AutomatedEmails?: InputMaybe<AutomatedEmailsUpdateManyWithoutTemplateInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTemplateInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTemplateInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  key_alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  purpose?: InputMaybe<EnumTemplatePurposeFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  trainerCertificateEvents?: InputMaybe<EventUpdateManyWithoutTrainerCertificateTemplateInput>;
  zohotemplateid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TemplateUpdateWithoutTrainerCertificateEventsInput = {
  AutomatedEmails?: InputMaybe<AutomatedEmailsUpdateManyWithoutTemplateInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTemplateInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTemplateInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  key_alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  purpose?: InputMaybe<EnumTemplatePurposeFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateEvents?: InputMaybe<EventUpdateManyWithoutTraineeCertificateTemplateInput>;
  zohotemplateid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TemplateUpdateWithoutZohoEmailInput = {
  AutomatedEmails?: InputMaybe<AutomatedEmailsUpdateManyWithoutTemplateInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTemplateInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  key_alias?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  purpose?: InputMaybe<EnumTemplatePurposeFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeCertificateEvents?: InputMaybe<EventUpdateManyWithoutTraineeCertificateTemplateInput>;
  trainerCertificateEvents?: InputMaybe<EventUpdateManyWithoutTrainerCertificateTemplateInput>;
  zohotemplateid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TemplateUpsertWithoutAutomatedEmailsInput = {
  create: TemplateUncheckedCreateWithoutAutomatedEmailsInput;
  update: TemplateUncheckedUpdateWithoutAutomatedEmailsInput;
};

export type TemplateUpsertWithoutCertificateInput = {
  create: TemplateUncheckedCreateWithoutCertificateInput;
  update: TemplateUncheckedUpdateWithoutCertificateInput;
};

export type TemplateUpsertWithoutTraineeCertificateEventsInput = {
  create: TemplateUncheckedCreateWithoutTraineeCertificateEventsInput;
  update: TemplateUncheckedUpdateWithoutTraineeCertificateEventsInput;
};

export type TemplateUpsertWithoutTrainerCertificateEventsInput = {
  create: TemplateUncheckedCreateWithoutTrainerCertificateEventsInput;
  update: TemplateUncheckedUpdateWithoutTrainerCertificateEventsInput;
};

export type TemplateUpsertWithoutZohoEmailInput = {
  create: TemplateUncheckedCreateWithoutZohoEmailInput;
  update: TemplateUncheckedUpdateWithoutZohoEmailInput;
};

export type TemplateWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TemplateWhereInput>>>;
  AutomatedEmails?: InputMaybe<AutomatedEmailsListRelationFilter>;
  Certificate?: InputMaybe<CertificateListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<TemplateWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TemplateWhereInput>>>;
  ZohoEmail?: InputMaybe<ZohoEmailListRelationFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  data?: InputMaybe<JsonFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  key_alias?: InputMaybe<StringNullableFilter>;
  purpose?: InputMaybe<EnumTemplatePurposeFilter>;
  subject?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  traineeCertificateEvents?: InputMaybe<EventListRelationFilter>;
  trainerCertificateEvents?: InputMaybe<EventListRelationFilter>;
  zohotemplateid?: InputMaybe<StringNullableFilter>;
};

export type TemplateWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  key_alias?: InputMaybe<Scalars['String']>;
  zohotemplateid?: InputMaybe<Scalars['String']>;
};

export enum ToTransferType {
  Fixed = 'fixed',
  Percentage = 'percentage'
}

export type TraineeEvent = {
  __typename?: 'TraineeEvent';
  Certificate?: Maybe<Certificate>;
  EPaymentMethod?: Maybe<EPaymentMethod>;
  PaymentNetwork?: Maybe<PaymentNetwork>;
  TraineeEventZoomRegistration: Array<TraineeEventZoomRegistration>;
  _count: TraineeEventCountOutputType;
  attendance: Array<TraineeEventDayAttendance>;
  bookingStatus?: Maybe<BookingStatus>;
  bookingStatusId?: Maybe<Scalars['Int']>;
  certificatePrice?: Maybe<Scalars['Decimal']>;
  coupon?: Maybe<Coupon>;
  couponId?: Maybe<Scalars['Int']>;
  couponeDiscount?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  ePaymentMethodId?: Maybe<Scalars['Int']>;
  emailState?: Maybe<Scalars['Json']>;
  event: Event;
  eventDay?: Maybe<EventDay>;
  eventId: Scalars['Int'];
  group?: Maybe<TraineeEventGroup>;
  groupId?: Maybe<Scalars['Int']>;
  hasBookedAllParts?: Maybe<Scalars['Boolean']>;
  howHeardAboutEvent?: Maybe<HowHeardAboutEvent>;
  howHeardAboutEventId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  inviter?: Maybe<User>;
  inviterCouponProfit?: Maybe<InviterCouponProfit>;
  inviterId?: Maybe<Scalars['Int']>;
  isCertificateIssued: Scalars['Boolean'];
  isFirstRegistration?: Maybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: Maybe<Scalars['Boolean']>;
  isIndividualPay?: Maybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: Maybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDelivery?: Maybe<MethodOfDelivery>;
  methodOfDeliveryId?: Maybe<Scalars['Int']>;
  parts: Array<TraineeEventPart>;
  paymentNetworkId?: Maybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  registrantId?: Maybe<Scalars['String']>;
  registrantToken?: Maybe<Scalars['String']>;
  review?: Maybe<TraineeEventReview>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  trainee: User;
  traineeEventStudyMaterialAttendance: Array<TraineeEventStudyMaterialAttendance>;
  traineeId: Scalars['Int'];
  traineeTrainerReviews: Array<TraineeTrainerReview>;
  transitions: Array<Transition>;
  walletBalance?: Maybe<Scalars['Decimal']>;
  workshopPrice?: Maybe<Scalars['Decimal']>;
};


export type TraineeEventTraineeEventZoomRegistrationArgs = {
  cursor?: InputMaybe<TraineeEventZoomRegistrationWhereUniqueInput>;
  distinct?: InputMaybe<TraineeEventZoomRegistrationScalarFieldEnum>;
  orderBy?: InputMaybe<TraineeEventZoomRegistrationOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeEventZoomRegistrationWhereInput>;
};


export type TraineeEventAttendanceArgs = {
  cursor?: InputMaybe<TraineeEventDayAttendanceWhereUniqueInput>;
  distinct?: InputMaybe<TraineeEventDayAttendanceScalarFieldEnum>;
  orderBy?: InputMaybe<TraineeEventDayAttendanceOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeEventDayAttendanceWhereInput>;
};


export type TraineeEventPartsArgs = {
  cursor?: InputMaybe<TraineeEventPartWhereUniqueInput>;
  distinct?: InputMaybe<TraineeEventPartScalarFieldEnum>;
  orderBy?: InputMaybe<TraineeEventPartOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeEventPartWhereInput>;
};


export type TraineeEventTraineeTrainerReviewsArgs = {
  cursor?: InputMaybe<TraineeTrainerReviewWhereUniqueInput>;
  distinct?: InputMaybe<TraineeTrainerReviewScalarFieldEnum>;
  orderBy?: InputMaybe<TraineeTrainerReviewOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeTrainerReviewWhereInput>;
};


export type TraineeEventTransitionsArgs = {
  cursor?: InputMaybe<TransitionWhereUniqueInput>;
  distinct?: InputMaybe<TransitionScalarFieldEnum>;
  orderBy?: InputMaybe<TransitionOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TransitionWhereInput>;
};

export type TraineeEventAvgAggregateOutputType = {
  __typename?: 'TraineeEventAvgAggregateOutputType';
  bookingStatusId?: Maybe<Scalars['Float']>;
  certificatePrice?: Maybe<Scalars['Decimal']>;
  couponId?: Maybe<Scalars['Float']>;
  couponeDiscount?: Maybe<Scalars['Decimal']>;
  ePaymentMethodId?: Maybe<Scalars['Float']>;
  eventDayId?: Maybe<Scalars['Float']>;
  eventId?: Maybe<Scalars['Float']>;
  groupId?: Maybe<Scalars['Float']>;
  howHeardAboutEventId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  inviterId?: Maybe<Scalars['Float']>;
  methodOfDeliveryId?: Maybe<Scalars['Float']>;
  paymentNetworkId?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Decimal']>;
  tax?: Maybe<Scalars['Decimal']>;
  totalToPay?: Maybe<Scalars['Decimal']>;
  traineeId?: Maybe<Scalars['Float']>;
  walletBalance?: Maybe<Scalars['Decimal']>;
  workshopPrice?: Maybe<Scalars['Decimal']>;
};

export type TraineeEventAvgOrderByAggregateInput = {
  bookingStatusId?: InputMaybe<SortOrder>;
  certificatePrice?: InputMaybe<SortOrder>;
  couponId?: InputMaybe<SortOrder>;
  couponeDiscount?: InputMaybe<SortOrder>;
  ePaymentMethodId?: InputMaybe<SortOrder>;
  eventDayId?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  groupId?: InputMaybe<SortOrder>;
  howHeardAboutEventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inviterId?: InputMaybe<SortOrder>;
  methodOfDeliveryId?: InputMaybe<SortOrder>;
  paymentNetworkId?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  tax?: InputMaybe<SortOrder>;
  totalToPay?: InputMaybe<SortOrder>;
  traineeId?: InputMaybe<SortOrder>;
  walletBalance?: InputMaybe<SortOrder>;
  workshopPrice?: InputMaybe<SortOrder>;
};

export type TraineeEventCountAggregateOutputType = {
  __typename?: 'TraineeEventCountAggregateOutputType';
  _all: Scalars['Int'];
  bookingStatusId: Scalars['Int'];
  certificatePrice: Scalars['Int'];
  couponId: Scalars['Int'];
  couponeDiscount: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  ePaymentMethodId: Scalars['Int'];
  emailState: Scalars['Int'];
  eventDayId: Scalars['Int'];
  eventId: Scalars['Int'];
  groupId: Scalars['Int'];
  hasBookedAllParts: Scalars['Int'];
  howHeardAboutEventId: Scalars['Int'];
  id: Scalars['Int'];
  inviterId: Scalars['Int'];
  isCertificateIssued: Scalars['Int'];
  isFirstRegistration: Scalars['Int'];
  isGroupRegistrant: Scalars['Int'];
  isGuest: Scalars['Int'];
  isIndividualPay: Scalars['Int'];
  isLateRegistrant: Scalars['Int'];
  isPackageBooking: Scalars['Int'];
  isWorkshopRegistrant: Scalars['Int'];
  methodOfDeliveryId: Scalars['Int'];
  paymentNetworkId: Scalars['Int'];
  price: Scalars['Int'];
  registrantId: Scalars['Int'];
  registrantToken: Scalars['Int'];
  tax: Scalars['Int'];
  totalToPay: Scalars['Int'];
  traineeId: Scalars['Int'];
  walletBalance: Scalars['Int'];
  workshopPrice: Scalars['Int'];
};

export type TraineeEventCountOrderByAggregateInput = {
  bookingStatusId?: InputMaybe<SortOrder>;
  certificatePrice?: InputMaybe<SortOrder>;
  couponId?: InputMaybe<SortOrder>;
  couponeDiscount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  ePaymentMethodId?: InputMaybe<SortOrder>;
  emailState?: InputMaybe<SortOrder>;
  eventDayId?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  groupId?: InputMaybe<SortOrder>;
  hasBookedAllParts?: InputMaybe<SortOrder>;
  howHeardAboutEventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inviterId?: InputMaybe<SortOrder>;
  isCertificateIssued?: InputMaybe<SortOrder>;
  isFirstRegistration?: InputMaybe<SortOrder>;
  isGroupRegistrant?: InputMaybe<SortOrder>;
  isGuest?: InputMaybe<SortOrder>;
  isIndividualPay?: InputMaybe<SortOrder>;
  isLateRegistrant?: InputMaybe<SortOrder>;
  isPackageBooking?: InputMaybe<SortOrder>;
  isWorkshopRegistrant?: InputMaybe<SortOrder>;
  methodOfDeliveryId?: InputMaybe<SortOrder>;
  paymentNetworkId?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  registrantId?: InputMaybe<SortOrder>;
  registrantToken?: InputMaybe<SortOrder>;
  tax?: InputMaybe<SortOrder>;
  totalToPay?: InputMaybe<SortOrder>;
  traineeId?: InputMaybe<SortOrder>;
  walletBalance?: InputMaybe<SortOrder>;
  workshopPrice?: InputMaybe<SortOrder>;
};

export type TraineeEventCountOutputType = {
  __typename?: 'TraineeEventCountOutputType';
  TraineeEventZoomRegistration: Scalars['Int'];
  ZohoEmail: Scalars['Int'];
  attendance: Scalars['Int'];
  parts: Scalars['Int'];
  traineeEventStudyMaterialAttendance: Scalars['Int'];
  traineeTrainerReviews: Scalars['Int'];
  transitions: Scalars['Int'];
};

export type TraineeEventCreateInput = {
  Certificate?: InputMaybe<CertificateCreateNestedOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodCreateNestedOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceCreateNestedManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusCreateNestedOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  coupon?: InputMaybe<CouponCreateNestedOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  event: EventCreateNestedOneWithoutTraineeEventsInput;
  eventDay?: InputMaybe<EventDayCreateNestedOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupCreateNestedOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventCreateNestedOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitCreateNestedOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDelivery?: InputMaybe<MethodOfDeliveryCreateNestedOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartCreateNestedManyWithoutTraineeEventInput>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  trainee: UserCreateNestedOneWithoutTraineeEventsInput;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceCreateNestedManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventCreateManyBookingStatusInput = {
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  ePaymentMethodId?: InputMaybe<Scalars['Int']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  eventId: Scalars['Int'];
  groupId?: InputMaybe<Scalars['Int']>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  paymentNetworkId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  traineeId: Scalars['Int'];
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventCreateManyBookingStatusInputEnvelope = {
  data: TraineeEventCreateManyBookingStatusInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TraineeEventCreateManyCouponInput = {
  bookingStatusId?: InputMaybe<Scalars['Int']>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  ePaymentMethodId?: InputMaybe<Scalars['Int']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  eventId: Scalars['Int'];
  groupId?: InputMaybe<Scalars['Int']>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  paymentNetworkId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  traineeId: Scalars['Int'];
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventCreateManyCouponInputEnvelope = {
  data: TraineeEventCreateManyCouponInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TraineeEventCreateManyEPaymentMethodInput = {
  bookingStatusId?: InputMaybe<Scalars['Int']>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  eventId: Scalars['Int'];
  groupId?: InputMaybe<Scalars['Int']>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  paymentNetworkId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  traineeId: Scalars['Int'];
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventCreateManyEPaymentMethodInputEnvelope = {
  data: TraineeEventCreateManyEPaymentMethodInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TraineeEventCreateManyEventDayInput = {
  bookingStatusId?: InputMaybe<Scalars['Int']>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  ePaymentMethodId?: InputMaybe<Scalars['Int']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventId: Scalars['Int'];
  groupId?: InputMaybe<Scalars['Int']>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  paymentNetworkId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  traineeId: Scalars['Int'];
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventCreateManyEventDayInputEnvelope = {
  data: TraineeEventCreateManyEventDayInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TraineeEventCreateManyEventInput = {
  bookingStatusId?: InputMaybe<Scalars['Int']>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  ePaymentMethodId?: InputMaybe<Scalars['Int']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  groupId?: InputMaybe<Scalars['Int']>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  paymentNetworkId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  traineeId: Scalars['Int'];
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventCreateManyEventInputEnvelope = {
  data: TraineeEventCreateManyEventInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TraineeEventCreateManyGroupInput = {
  bookingStatusId?: InputMaybe<Scalars['Int']>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  ePaymentMethodId?: InputMaybe<Scalars['Int']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  eventId: Scalars['Int'];
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  paymentNetworkId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  traineeId: Scalars['Int'];
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventCreateManyGroupInputEnvelope = {
  data: TraineeEventCreateManyGroupInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TraineeEventCreateManyHowHeardAboutEventInput = {
  bookingStatusId?: InputMaybe<Scalars['Int']>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  ePaymentMethodId?: InputMaybe<Scalars['Int']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  eventId: Scalars['Int'];
  groupId?: InputMaybe<Scalars['Int']>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  paymentNetworkId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  traineeId: Scalars['Int'];
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventCreateManyHowHeardAboutEventInputEnvelope = {
  data: TraineeEventCreateManyHowHeardAboutEventInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TraineeEventCreateManyInput = {
  bookingStatusId?: InputMaybe<Scalars['Int']>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  ePaymentMethodId?: InputMaybe<Scalars['Int']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  eventId: Scalars['Int'];
  groupId?: InputMaybe<Scalars['Int']>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  paymentNetworkId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  traineeId: Scalars['Int'];
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventCreateManyInviterInput = {
  bookingStatusId?: InputMaybe<Scalars['Int']>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  ePaymentMethodId?: InputMaybe<Scalars['Int']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  eventId: Scalars['Int'];
  groupId?: InputMaybe<Scalars['Int']>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  paymentNetworkId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  traineeId: Scalars['Int'];
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventCreateManyInviterInputEnvelope = {
  data: TraineeEventCreateManyInviterInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TraineeEventCreateManyMethodOfDeliveryInput = {
  bookingStatusId?: InputMaybe<Scalars['Int']>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  ePaymentMethodId?: InputMaybe<Scalars['Int']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  eventId: Scalars['Int'];
  groupId?: InputMaybe<Scalars['Int']>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  paymentNetworkId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  traineeId: Scalars['Int'];
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventCreateManyMethodOfDeliveryInputEnvelope = {
  data: TraineeEventCreateManyMethodOfDeliveryInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TraineeEventCreateManyPaymentNetworkInput = {
  bookingStatusId?: InputMaybe<Scalars['Int']>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  ePaymentMethodId?: InputMaybe<Scalars['Int']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  eventId: Scalars['Int'];
  groupId?: InputMaybe<Scalars['Int']>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  traineeId: Scalars['Int'];
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventCreateManyPaymentNetworkInputEnvelope = {
  data: TraineeEventCreateManyPaymentNetworkInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TraineeEventCreateManyTraineeInput = {
  bookingStatusId?: InputMaybe<Scalars['Int']>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  ePaymentMethodId?: InputMaybe<Scalars['Int']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  eventId: Scalars['Int'];
  groupId?: InputMaybe<Scalars['Int']>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  paymentNetworkId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventCreateManyTraineeInputEnvelope = {
  data: TraineeEventCreateManyTraineeInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TraineeEventCreateNestedManyWithoutBookingStatusInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutBookingStatusInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutBookingStatusInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyBookingStatusInputEnvelope>;
};

export type TraineeEventCreateNestedManyWithoutCouponInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutCouponInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutCouponInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyCouponInputEnvelope>;
};

export type TraineeEventCreateNestedManyWithoutEPaymentMethodInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutEPaymentMethodInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutEPaymentMethodInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyEPaymentMethodInputEnvelope>;
};

export type TraineeEventCreateNestedManyWithoutEventDayInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutEventDayInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutEventDayInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyEventDayInputEnvelope>;
};

export type TraineeEventCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutEventInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyEventInputEnvelope>;
};

export type TraineeEventCreateNestedManyWithoutGroupInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutGroupInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutGroupInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyGroupInputEnvelope>;
};

export type TraineeEventCreateNestedManyWithoutHowHeardAboutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutHowHeardAboutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutHowHeardAboutEventInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyHowHeardAboutEventInputEnvelope>;
};

export type TraineeEventCreateNestedManyWithoutInviterInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutInviterInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutInviterInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyInviterInputEnvelope>;
};

export type TraineeEventCreateNestedManyWithoutMethodOfDeliveryInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutMethodOfDeliveryInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutMethodOfDeliveryInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyMethodOfDeliveryInputEnvelope>;
};

export type TraineeEventCreateNestedManyWithoutPaymentNetworkInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutPaymentNetworkInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutPaymentNetworkInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyPaymentNetworkInputEnvelope>;
};

export type TraineeEventCreateNestedManyWithoutTraineeInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutTraineeInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutTraineeInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyTraineeInputEnvelope>;
};

export type TraineeEventCreateNestedOneWithoutAttendanceInput = {
  connect?: InputMaybe<TraineeEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TraineeEventCreateOrConnectWithoutAttendanceInput>;
  create?: InputMaybe<TraineeEventUncheckedCreateWithoutAttendanceInput>;
};

export type TraineeEventCreateNestedOneWithoutCertificateInput = {
  connect?: InputMaybe<TraineeEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TraineeEventCreateOrConnectWithoutCertificateInput>;
  create?: InputMaybe<TraineeEventUncheckedCreateWithoutCertificateInput>;
};

export type TraineeEventCreateNestedOneWithoutInviterCouponProfitInput = {
  connect?: InputMaybe<TraineeEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TraineeEventCreateOrConnectWithoutInviterCouponProfitInput>;
  create?: InputMaybe<TraineeEventUncheckedCreateWithoutInviterCouponProfitInput>;
};

export type TraineeEventCreateNestedOneWithoutPartsInput = {
  connect?: InputMaybe<TraineeEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TraineeEventCreateOrConnectWithoutPartsInput>;
  create?: InputMaybe<TraineeEventUncheckedCreateWithoutPartsInput>;
};

export type TraineeEventCreateNestedOneWithoutReviewInput = {
  connect?: InputMaybe<TraineeEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TraineeEventCreateOrConnectWithoutReviewInput>;
  create?: InputMaybe<TraineeEventUncheckedCreateWithoutReviewInput>;
};

export type TraineeEventCreateNestedOneWithoutTraineeEventStudyMaterialAttendanceInput = {
  connect?: InputMaybe<TraineeEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TraineeEventCreateOrConnectWithoutTraineeEventStudyMaterialAttendanceInput>;
  create?: InputMaybe<TraineeEventUncheckedCreateWithoutTraineeEventStudyMaterialAttendanceInput>;
};

export type TraineeEventCreateNestedOneWithoutTraineeEventZoomRegistrationInput = {
  connect?: InputMaybe<TraineeEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TraineeEventCreateOrConnectWithoutTraineeEventZoomRegistrationInput>;
  create?: InputMaybe<TraineeEventUncheckedCreateWithoutTraineeEventZoomRegistrationInput>;
};

export type TraineeEventCreateNestedOneWithoutTraineeTrainerReviewsInput = {
  connect?: InputMaybe<TraineeEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TraineeEventCreateOrConnectWithoutTraineeTrainerReviewsInput>;
  create?: InputMaybe<TraineeEventUncheckedCreateWithoutTraineeTrainerReviewsInput>;
};

export type TraineeEventCreateNestedOneWithoutTransitionsInput = {
  connect?: InputMaybe<TraineeEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TraineeEventCreateOrConnectWithoutTransitionsInput>;
  create?: InputMaybe<TraineeEventUncheckedCreateWithoutTransitionsInput>;
};

export type TraineeEventCreateNestedOneWithoutZohoEmailInput = {
  connect?: InputMaybe<TraineeEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TraineeEventCreateOrConnectWithoutZohoEmailInput>;
  create?: InputMaybe<TraineeEventUncheckedCreateWithoutZohoEmailInput>;
};

export type TraineeEventCreateOrConnectWithoutAttendanceInput = {
  create: TraineeEventUncheckedCreateWithoutAttendanceInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventCreateOrConnectWithoutBookingStatusInput = {
  create: TraineeEventUncheckedCreateWithoutBookingStatusInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventCreateOrConnectWithoutCertificateInput = {
  create: TraineeEventUncheckedCreateWithoutCertificateInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventCreateOrConnectWithoutCouponInput = {
  create: TraineeEventUncheckedCreateWithoutCouponInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventCreateOrConnectWithoutEPaymentMethodInput = {
  create: TraineeEventUncheckedCreateWithoutEPaymentMethodInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventCreateOrConnectWithoutEventDayInput = {
  create: TraineeEventUncheckedCreateWithoutEventDayInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventCreateOrConnectWithoutEventInput = {
  create: TraineeEventUncheckedCreateWithoutEventInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventCreateOrConnectWithoutGroupInput = {
  create: TraineeEventUncheckedCreateWithoutGroupInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventCreateOrConnectWithoutHowHeardAboutEventInput = {
  create: TraineeEventUncheckedCreateWithoutHowHeardAboutEventInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventCreateOrConnectWithoutInviterCouponProfitInput = {
  create: TraineeEventUncheckedCreateWithoutInviterCouponProfitInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventCreateOrConnectWithoutInviterInput = {
  create: TraineeEventUncheckedCreateWithoutInviterInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventCreateOrConnectWithoutMethodOfDeliveryInput = {
  create: TraineeEventUncheckedCreateWithoutMethodOfDeliveryInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventCreateOrConnectWithoutPartsInput = {
  create: TraineeEventUncheckedCreateWithoutPartsInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventCreateOrConnectWithoutPaymentNetworkInput = {
  create: TraineeEventUncheckedCreateWithoutPaymentNetworkInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventCreateOrConnectWithoutReviewInput = {
  create: TraineeEventUncheckedCreateWithoutReviewInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventCreateOrConnectWithoutTraineeEventStudyMaterialAttendanceInput = {
  create: TraineeEventUncheckedCreateWithoutTraineeEventStudyMaterialAttendanceInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventCreateOrConnectWithoutTraineeEventZoomRegistrationInput = {
  create: TraineeEventUncheckedCreateWithoutTraineeEventZoomRegistrationInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventCreateOrConnectWithoutTraineeInput = {
  create: TraineeEventUncheckedCreateWithoutTraineeInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventCreateOrConnectWithoutTraineeTrainerReviewsInput = {
  create: TraineeEventUncheckedCreateWithoutTraineeTrainerReviewsInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventCreateOrConnectWithoutTransitionsInput = {
  create: TraineeEventUncheckedCreateWithoutTransitionsInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventCreateOrConnectWithoutZohoEmailInput = {
  create: TraineeEventUncheckedCreateWithoutZohoEmailInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventCreateWithoutAttendanceInput = {
  Certificate?: InputMaybe<CertificateCreateNestedOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodCreateNestedOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusCreateNestedOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  coupon?: InputMaybe<CouponCreateNestedOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  event: EventCreateNestedOneWithoutTraineeEventsInput;
  eventDay?: InputMaybe<EventDayCreateNestedOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupCreateNestedOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventCreateNestedOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitCreateNestedOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDelivery?: InputMaybe<MethodOfDeliveryCreateNestedOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartCreateNestedManyWithoutTraineeEventInput>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  trainee: UserCreateNestedOneWithoutTraineeEventsInput;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceCreateNestedManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventCreateWithoutBookingStatusInput = {
  Certificate?: InputMaybe<CertificateCreateNestedOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodCreateNestedOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceCreateNestedManyWithoutTraineeEventInput>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  coupon?: InputMaybe<CouponCreateNestedOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  event: EventCreateNestedOneWithoutTraineeEventsInput;
  eventDay?: InputMaybe<EventDayCreateNestedOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupCreateNestedOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventCreateNestedOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitCreateNestedOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDelivery?: InputMaybe<MethodOfDeliveryCreateNestedOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartCreateNestedManyWithoutTraineeEventInput>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  trainee: UserCreateNestedOneWithoutTraineeEventsInput;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceCreateNestedManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventCreateWithoutCertificateInput = {
  EPaymentMethod?: InputMaybe<EPaymentMethodCreateNestedOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceCreateNestedManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusCreateNestedOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  coupon?: InputMaybe<CouponCreateNestedOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  event: EventCreateNestedOneWithoutTraineeEventsInput;
  eventDay?: InputMaybe<EventDayCreateNestedOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupCreateNestedOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventCreateNestedOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitCreateNestedOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDelivery?: InputMaybe<MethodOfDeliveryCreateNestedOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartCreateNestedManyWithoutTraineeEventInput>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  trainee: UserCreateNestedOneWithoutTraineeEventsInput;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceCreateNestedManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventCreateWithoutCouponInput = {
  Certificate?: InputMaybe<CertificateCreateNestedOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodCreateNestedOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceCreateNestedManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusCreateNestedOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  event: EventCreateNestedOneWithoutTraineeEventsInput;
  eventDay?: InputMaybe<EventDayCreateNestedOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupCreateNestedOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventCreateNestedOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitCreateNestedOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDelivery?: InputMaybe<MethodOfDeliveryCreateNestedOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartCreateNestedManyWithoutTraineeEventInput>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  trainee: UserCreateNestedOneWithoutTraineeEventsInput;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceCreateNestedManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventCreateWithoutEPaymentMethodInput = {
  Certificate?: InputMaybe<CertificateCreateNestedOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceCreateNestedManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusCreateNestedOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  coupon?: InputMaybe<CouponCreateNestedOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  event: EventCreateNestedOneWithoutTraineeEventsInput;
  eventDay?: InputMaybe<EventDayCreateNestedOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupCreateNestedOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventCreateNestedOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitCreateNestedOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDelivery?: InputMaybe<MethodOfDeliveryCreateNestedOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartCreateNestedManyWithoutTraineeEventInput>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  trainee: UserCreateNestedOneWithoutTraineeEventsInput;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceCreateNestedManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventCreateWithoutEventDayInput = {
  Certificate?: InputMaybe<CertificateCreateNestedOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodCreateNestedOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceCreateNestedManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusCreateNestedOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  coupon?: InputMaybe<CouponCreateNestedOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  event: EventCreateNestedOneWithoutTraineeEventsInput;
  group?: InputMaybe<TraineeEventGroupCreateNestedOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventCreateNestedOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitCreateNestedOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDelivery?: InputMaybe<MethodOfDeliveryCreateNestedOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartCreateNestedManyWithoutTraineeEventInput>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  trainee: UserCreateNestedOneWithoutTraineeEventsInput;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceCreateNestedManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventCreateWithoutEventInput = {
  Certificate?: InputMaybe<CertificateCreateNestedOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodCreateNestedOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceCreateNestedManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusCreateNestedOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  coupon?: InputMaybe<CouponCreateNestedOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDay?: InputMaybe<EventDayCreateNestedOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupCreateNestedOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventCreateNestedOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitCreateNestedOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDelivery?: InputMaybe<MethodOfDeliveryCreateNestedOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartCreateNestedManyWithoutTraineeEventInput>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  trainee: UserCreateNestedOneWithoutTraineeEventsInput;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceCreateNestedManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventCreateWithoutGroupInput = {
  Certificate?: InputMaybe<CertificateCreateNestedOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodCreateNestedOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceCreateNestedManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusCreateNestedOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  coupon?: InputMaybe<CouponCreateNestedOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  event: EventCreateNestedOneWithoutTraineeEventsInput;
  eventDay?: InputMaybe<EventDayCreateNestedOneWithoutTraineeEventInput>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventCreateNestedOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitCreateNestedOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDelivery?: InputMaybe<MethodOfDeliveryCreateNestedOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartCreateNestedManyWithoutTraineeEventInput>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  trainee: UserCreateNestedOneWithoutTraineeEventsInput;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceCreateNestedManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventCreateWithoutHowHeardAboutEventInput = {
  Certificate?: InputMaybe<CertificateCreateNestedOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodCreateNestedOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceCreateNestedManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusCreateNestedOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  coupon?: InputMaybe<CouponCreateNestedOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  event: EventCreateNestedOneWithoutTraineeEventsInput;
  eventDay?: InputMaybe<EventDayCreateNestedOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupCreateNestedOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitCreateNestedOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDelivery?: InputMaybe<MethodOfDeliveryCreateNestedOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartCreateNestedManyWithoutTraineeEventInput>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  trainee: UserCreateNestedOneWithoutTraineeEventsInput;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceCreateNestedManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventCreateWithoutInviterCouponProfitInput = {
  Certificate?: InputMaybe<CertificateCreateNestedOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodCreateNestedOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceCreateNestedManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusCreateNestedOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  coupon?: InputMaybe<CouponCreateNestedOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  event: EventCreateNestedOneWithoutTraineeEventsInput;
  eventDay?: InputMaybe<EventDayCreateNestedOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupCreateNestedOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventCreateNestedOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutTraineeEventInvitesInput>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDelivery?: InputMaybe<MethodOfDeliveryCreateNestedOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartCreateNestedManyWithoutTraineeEventInput>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  trainee: UserCreateNestedOneWithoutTraineeEventsInput;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceCreateNestedManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventCreateWithoutInviterInput = {
  Certificate?: InputMaybe<CertificateCreateNestedOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodCreateNestedOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceCreateNestedManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusCreateNestedOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  coupon?: InputMaybe<CouponCreateNestedOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  event: EventCreateNestedOneWithoutTraineeEventsInput;
  eventDay?: InputMaybe<EventDayCreateNestedOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupCreateNestedOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventCreateNestedOneWithoutTraineeEventsInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitCreateNestedOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDelivery?: InputMaybe<MethodOfDeliveryCreateNestedOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartCreateNestedManyWithoutTraineeEventInput>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  trainee: UserCreateNestedOneWithoutTraineeEventsInput;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceCreateNestedManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventCreateWithoutMethodOfDeliveryInput = {
  Certificate?: InputMaybe<CertificateCreateNestedOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodCreateNestedOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceCreateNestedManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusCreateNestedOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  coupon?: InputMaybe<CouponCreateNestedOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  event: EventCreateNestedOneWithoutTraineeEventsInput;
  eventDay?: InputMaybe<EventDayCreateNestedOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupCreateNestedOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventCreateNestedOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitCreateNestedOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  parts?: InputMaybe<TraineeEventPartCreateNestedManyWithoutTraineeEventInput>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  trainee: UserCreateNestedOneWithoutTraineeEventsInput;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceCreateNestedManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventCreateWithoutPartsInput = {
  Certificate?: InputMaybe<CertificateCreateNestedOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodCreateNestedOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceCreateNestedManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusCreateNestedOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  coupon?: InputMaybe<CouponCreateNestedOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  event: EventCreateNestedOneWithoutTraineeEventsInput;
  eventDay?: InputMaybe<EventDayCreateNestedOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupCreateNestedOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventCreateNestedOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitCreateNestedOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDelivery?: InputMaybe<MethodOfDeliveryCreateNestedOneWithoutTraineeEventInput>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  trainee: UserCreateNestedOneWithoutTraineeEventsInput;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceCreateNestedManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventCreateWithoutPaymentNetworkInput = {
  Certificate?: InputMaybe<CertificateCreateNestedOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceCreateNestedManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusCreateNestedOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  coupon?: InputMaybe<CouponCreateNestedOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  event: EventCreateNestedOneWithoutTraineeEventsInput;
  eventDay?: InputMaybe<EventDayCreateNestedOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupCreateNestedOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventCreateNestedOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitCreateNestedOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDelivery?: InputMaybe<MethodOfDeliveryCreateNestedOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartCreateNestedManyWithoutTraineeEventInput>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  trainee: UserCreateNestedOneWithoutTraineeEventsInput;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceCreateNestedManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventCreateWithoutReviewInput = {
  Certificate?: InputMaybe<CertificateCreateNestedOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodCreateNestedOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceCreateNestedManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusCreateNestedOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  coupon?: InputMaybe<CouponCreateNestedOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  event: EventCreateNestedOneWithoutTraineeEventsInput;
  eventDay?: InputMaybe<EventDayCreateNestedOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupCreateNestedOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventCreateNestedOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitCreateNestedOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDelivery?: InputMaybe<MethodOfDeliveryCreateNestedOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartCreateNestedManyWithoutTraineeEventInput>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  trainee: UserCreateNestedOneWithoutTraineeEventsInput;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceCreateNestedManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventCreateWithoutTraineeEventStudyMaterialAttendanceInput = {
  Certificate?: InputMaybe<CertificateCreateNestedOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodCreateNestedOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceCreateNestedManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusCreateNestedOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  coupon?: InputMaybe<CouponCreateNestedOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  event: EventCreateNestedOneWithoutTraineeEventsInput;
  eventDay?: InputMaybe<EventDayCreateNestedOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupCreateNestedOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventCreateNestedOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitCreateNestedOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDelivery?: InputMaybe<MethodOfDeliveryCreateNestedOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartCreateNestedManyWithoutTraineeEventInput>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  trainee: UserCreateNestedOneWithoutTraineeEventsInput;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventCreateWithoutTraineeEventZoomRegistrationInput = {
  Certificate?: InputMaybe<CertificateCreateNestedOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodCreateNestedOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkCreateNestedOneWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceCreateNestedManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusCreateNestedOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  coupon?: InputMaybe<CouponCreateNestedOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  event: EventCreateNestedOneWithoutTraineeEventsInput;
  eventDay?: InputMaybe<EventDayCreateNestedOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupCreateNestedOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventCreateNestedOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitCreateNestedOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDelivery?: InputMaybe<MethodOfDeliveryCreateNestedOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartCreateNestedManyWithoutTraineeEventInput>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  trainee: UserCreateNestedOneWithoutTraineeEventsInput;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceCreateNestedManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventCreateWithoutTraineeInput = {
  Certificate?: InputMaybe<CertificateCreateNestedOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodCreateNestedOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceCreateNestedManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusCreateNestedOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  coupon?: InputMaybe<CouponCreateNestedOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  event: EventCreateNestedOneWithoutTraineeEventsInput;
  eventDay?: InputMaybe<EventDayCreateNestedOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupCreateNestedOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventCreateNestedOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitCreateNestedOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDelivery?: InputMaybe<MethodOfDeliveryCreateNestedOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartCreateNestedManyWithoutTraineeEventInput>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceCreateNestedManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventCreateWithoutTraineeTrainerReviewsInput = {
  Certificate?: InputMaybe<CertificateCreateNestedOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodCreateNestedOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceCreateNestedManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusCreateNestedOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  coupon?: InputMaybe<CouponCreateNestedOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  event: EventCreateNestedOneWithoutTraineeEventsInput;
  eventDay?: InputMaybe<EventDayCreateNestedOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupCreateNestedOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventCreateNestedOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitCreateNestedOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDelivery?: InputMaybe<MethodOfDeliveryCreateNestedOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartCreateNestedManyWithoutTraineeEventInput>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  trainee: UserCreateNestedOneWithoutTraineeEventsInput;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventCreateWithoutTransitionsInput = {
  Certificate?: InputMaybe<CertificateCreateNestedOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodCreateNestedOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceCreateNestedManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusCreateNestedOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  coupon?: InputMaybe<CouponCreateNestedOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  event: EventCreateNestedOneWithoutTraineeEventsInput;
  eventDay?: InputMaybe<EventDayCreateNestedOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupCreateNestedOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventCreateNestedOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitCreateNestedOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDelivery?: InputMaybe<MethodOfDeliveryCreateNestedOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartCreateNestedManyWithoutTraineeEventInput>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  trainee: UserCreateNestedOneWithoutTraineeEventsInput;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceCreateNestedManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventCreateWithoutZohoEmailInput = {
  Certificate?: InputMaybe<CertificateCreateNestedOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodCreateNestedOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceCreateNestedManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusCreateNestedOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  coupon?: InputMaybe<CouponCreateNestedOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  event: EventCreateNestedOneWithoutTraineeEventsInput;
  eventDay?: InputMaybe<EventDayCreateNestedOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupCreateNestedOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventCreateNestedOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitCreateNestedOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDelivery?: InputMaybe<MethodOfDeliveryCreateNestedOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartCreateNestedManyWithoutTraineeEventInput>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  trainee: UserCreateNestedOneWithoutTraineeEventsInput;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceCreateNestedManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventDayAttendance = {
  __typename?: 'TraineeEventDayAttendance';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  duration?: Maybe<Scalars['Int']>;
  eventDay: EventDay;
  eventDayId: Scalars['Int'];
  id: Scalars['Int'];
  joinTime: Scalars['DateTime'];
  leaveTime?: Maybe<Scalars['DateTime']>;
  participantId: Scalars['String'];
  participantName: Scalars['String'];
  traineeEvent: TraineeEvent;
  traineeEventId: Scalars['Int'];
};

export type TraineeEventDayAttendanceAvgAggregateOutputType = {
  __typename?: 'TraineeEventDayAttendanceAvgAggregateOutputType';
  duration?: Maybe<Scalars['Float']>;
  eventDayId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  traineeEventId?: Maybe<Scalars['Float']>;
};

export type TraineeEventDayAttendanceAvgOrderByAggregateInput = {
  duration?: InputMaybe<SortOrder>;
  eventDayId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
};

export type TraineeEventDayAttendanceCountAggregateOutputType = {
  __typename?: 'TraineeEventDayAttendanceCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  duration: Scalars['Int'];
  eventDayId: Scalars['Int'];
  id: Scalars['Int'];
  isZoomMeeting: Scalars['Int'];
  joinTime: Scalars['Int'];
  leaveTime: Scalars['Int'];
  participantId: Scalars['Int'];
  participantName: Scalars['Int'];
  traineeEventId: Scalars['Int'];
};

export type TraineeEventDayAttendanceCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  eventDayId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isZoomMeeting?: InputMaybe<SortOrder>;
  joinTime?: InputMaybe<SortOrder>;
  leaveTime?: InputMaybe<SortOrder>;
  participantId?: InputMaybe<SortOrder>;
  participantName?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
};

export type TraineeEventDayAttendanceCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  eventDay: EventDayCreateNestedOneWithoutTraineeAttendanceInput;
  isZoomMeeting?: InputMaybe<Scalars['Boolean']>;
  joinTime: Scalars['DateTime'];
  leaveTime?: InputMaybe<Scalars['DateTime']>;
  participantId?: InputMaybe<Scalars['String']>;
  participantName?: InputMaybe<Scalars['String']>;
  traineeEvent?: InputMaybe<TraineeEventCreateNestedOneWithoutAttendanceInput>;
};

export type TraineeEventDayAttendanceCreateManyEventDayInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  isZoomMeeting?: InputMaybe<Scalars['Boolean']>;
  joinTime: Scalars['DateTime'];
  leaveTime?: InputMaybe<Scalars['DateTime']>;
  participantId?: InputMaybe<Scalars['String']>;
  participantName?: InputMaybe<Scalars['String']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
};

export type TraineeEventDayAttendanceCreateManyEventDayInputEnvelope = {
  data: TraineeEventDayAttendanceCreateManyEventDayInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TraineeEventDayAttendanceCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  eventDayId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  isZoomMeeting?: InputMaybe<Scalars['Boolean']>;
  joinTime: Scalars['DateTime'];
  leaveTime?: InputMaybe<Scalars['DateTime']>;
  participantId?: InputMaybe<Scalars['String']>;
  participantName?: InputMaybe<Scalars['String']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
};

export type TraineeEventDayAttendanceCreateManyTraineeEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  eventDayId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  isZoomMeeting?: InputMaybe<Scalars['Boolean']>;
  joinTime: Scalars['DateTime'];
  leaveTime?: InputMaybe<Scalars['DateTime']>;
  participantId?: InputMaybe<Scalars['String']>;
  participantName?: InputMaybe<Scalars['String']>;
};

export type TraineeEventDayAttendanceCreateManyTraineeEventInputEnvelope = {
  data: TraineeEventDayAttendanceCreateManyTraineeEventInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TraineeEventDayAttendanceCreateNestedManyWithoutEventDayInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceCreateOrConnectWithoutEventDayInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceCreateWithoutEventDayInput>>>;
  createMany?: InputMaybe<TraineeEventDayAttendanceCreateManyEventDayInputEnvelope>;
};

export type TraineeEventDayAttendanceCreateNestedManyWithoutTraineeEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceCreateOrConnectWithoutTraineeEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceCreateWithoutTraineeEventInput>>>;
  createMany?: InputMaybe<TraineeEventDayAttendanceCreateManyTraineeEventInputEnvelope>;
};

export type TraineeEventDayAttendanceCreateOrConnectWithoutEventDayInput = {
  create: TraineeEventDayAttendanceUncheckedCreateWithoutEventDayInput;
  where: TraineeEventDayAttendanceWhereUniqueInput;
};

export type TraineeEventDayAttendanceCreateOrConnectWithoutTraineeEventInput = {
  create: TraineeEventDayAttendanceUncheckedCreateWithoutTraineeEventInput;
  where: TraineeEventDayAttendanceWhereUniqueInput;
};

export type TraineeEventDayAttendanceCreateWithoutEventDayInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  isZoomMeeting?: InputMaybe<Scalars['Boolean']>;
  joinTime: Scalars['DateTime'];
  leaveTime?: InputMaybe<Scalars['DateTime']>;
  participantId?: InputMaybe<Scalars['String']>;
  participantName?: InputMaybe<Scalars['String']>;
  traineeEvent?: InputMaybe<TraineeEventCreateNestedOneWithoutAttendanceInput>;
};

export type TraineeEventDayAttendanceCreateWithoutTraineeEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  eventDay: EventDayCreateNestedOneWithoutTraineeAttendanceInput;
  isZoomMeeting?: InputMaybe<Scalars['Boolean']>;
  joinTime: Scalars['DateTime'];
  leaveTime?: InputMaybe<Scalars['DateTime']>;
  participantId?: InputMaybe<Scalars['String']>;
  participantName?: InputMaybe<Scalars['String']>;
};

export type TraineeEventDayAttendanceListRelationFilter = {
  every?: InputMaybe<TraineeEventDayAttendanceWhereInput>;
  none?: InputMaybe<TraineeEventDayAttendanceWhereInput>;
  some?: InputMaybe<TraineeEventDayAttendanceWhereInput>;
};

export type TraineeEventDayAttendanceMaxAggregateOutputType = {
  __typename?: 'TraineeEventDayAttendanceMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  duration?: Maybe<Scalars['Int']>;
  eventDayId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isZoomMeeting?: Maybe<Scalars['Boolean']>;
  joinTime?: Maybe<Scalars['DateTime']>;
  leaveTime?: Maybe<Scalars['DateTime']>;
  participantId?: Maybe<Scalars['String']>;
  participantName?: Maybe<Scalars['String']>;
  traineeEventId?: Maybe<Scalars['Int']>;
};

export type TraineeEventDayAttendanceMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  eventDayId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isZoomMeeting?: InputMaybe<SortOrder>;
  joinTime?: InputMaybe<SortOrder>;
  leaveTime?: InputMaybe<SortOrder>;
  participantId?: InputMaybe<SortOrder>;
  participantName?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
};

export type TraineeEventDayAttendanceMinAggregateOutputType = {
  __typename?: 'TraineeEventDayAttendanceMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  duration?: Maybe<Scalars['Int']>;
  eventDayId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isZoomMeeting?: Maybe<Scalars['Boolean']>;
  joinTime?: Maybe<Scalars['DateTime']>;
  leaveTime?: Maybe<Scalars['DateTime']>;
  participantId?: Maybe<Scalars['String']>;
  participantName?: Maybe<Scalars['String']>;
  traineeEventId?: Maybe<Scalars['Int']>;
};

export type TraineeEventDayAttendanceMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  eventDayId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isZoomMeeting?: InputMaybe<SortOrder>;
  joinTime?: InputMaybe<SortOrder>;
  leaveTime?: InputMaybe<SortOrder>;
  participantId?: InputMaybe<SortOrder>;
  participantName?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
};

export type TraineeEventDayAttendanceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TraineeEventDayAttendanceOrderByWithAggregationInput = {
  _avg?: InputMaybe<TraineeEventDayAttendanceAvgOrderByAggregateInput>;
  _count?: InputMaybe<TraineeEventDayAttendanceCountOrderByAggregateInput>;
  _max?: InputMaybe<TraineeEventDayAttendanceMaxOrderByAggregateInput>;
  _min?: InputMaybe<TraineeEventDayAttendanceMinOrderByAggregateInput>;
  _sum?: InputMaybe<TraineeEventDayAttendanceSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  eventDayId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isZoomMeeting?: InputMaybe<SortOrder>;
  joinTime?: InputMaybe<SortOrder>;
  leaveTime?: InputMaybe<SortOrder>;
  participantId?: InputMaybe<SortOrder>;
  participantName?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
};

export type TraineeEventDayAttendanceOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  eventDay?: InputMaybe<EventDayOrderByWithRelationInput>;
  eventDayId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isZoomMeeting?: InputMaybe<SortOrder>;
  joinTime?: InputMaybe<SortOrder>;
  leaveTime?: InputMaybe<SortOrder>;
  participantId?: InputMaybe<SortOrder>;
  participantName?: InputMaybe<SortOrder>;
  traineeEvent?: InputMaybe<TraineeEventOrderByWithRelationInput>;
  traineeEventId?: InputMaybe<SortOrder>;
};

export enum TraineeEventDayAttendanceScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Duration = 'duration',
  EventDayId = 'eventDayId',
  Id = 'id',
  IsZoomMeeting = 'isZoomMeeting',
  JoinTime = 'joinTime',
  LeaveTime = 'leaveTime',
  ParticipantId = 'participantId',
  ParticipantName = 'participantName',
  TraineeEventId = 'traineeEventId'
}

export type TraineeEventDayAttendanceScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceScalarWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  duration?: InputMaybe<IntNullableFilter>;
  eventDayId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  isZoomMeeting?: InputMaybe<BoolFilter>;
  joinTime?: InputMaybe<DateTimeFilter>;
  leaveTime?: InputMaybe<DateTimeNullableFilter>;
  participantId?: InputMaybe<StringNullableFilter>;
  participantName?: InputMaybe<StringNullableFilter>;
  traineeEventId?: InputMaybe<IntNullableFilter>;
};

export type TraineeEventDayAttendanceScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  duration?: InputMaybe<IntNullableWithAggregatesFilter>;
  eventDayId?: InputMaybe<IntWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  isZoomMeeting?: InputMaybe<BoolWithAggregatesFilter>;
  joinTime?: InputMaybe<DateTimeWithAggregatesFilter>;
  leaveTime?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  participantId?: InputMaybe<StringNullableWithAggregatesFilter>;
  participantName?: InputMaybe<StringNullableWithAggregatesFilter>;
  traineeEventId?: InputMaybe<IntNullableWithAggregatesFilter>;
};

export type TraineeEventDayAttendanceSumAggregateOutputType = {
  __typename?: 'TraineeEventDayAttendanceSumAggregateOutputType';
  duration?: Maybe<Scalars['Int']>;
  eventDayId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  traineeEventId?: Maybe<Scalars['Int']>;
};

export type TraineeEventDayAttendanceSumOrderByAggregateInput = {
  duration?: InputMaybe<SortOrder>;
  eventDayId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
};

export type TraineeEventDayAttendanceUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  eventDayId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  isZoomMeeting?: InputMaybe<Scalars['Boolean']>;
  joinTime: Scalars['DateTime'];
  leaveTime?: InputMaybe<Scalars['DateTime']>;
  participantId?: InputMaybe<Scalars['String']>;
  participantName?: InputMaybe<Scalars['String']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
};

export type TraineeEventDayAttendanceUncheckedCreateNestedManyWithoutEventDayInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceCreateOrConnectWithoutEventDayInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceCreateWithoutEventDayInput>>>;
  createMany?: InputMaybe<TraineeEventDayAttendanceCreateManyEventDayInputEnvelope>;
};

export type TraineeEventDayAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceCreateOrConnectWithoutTraineeEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceCreateWithoutTraineeEventInput>>>;
  createMany?: InputMaybe<TraineeEventDayAttendanceCreateManyTraineeEventInputEnvelope>;
};

export type TraineeEventDayAttendanceUncheckedCreateWithoutEventDayInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  isZoomMeeting?: InputMaybe<Scalars['Boolean']>;
  joinTime: Scalars['DateTime'];
  leaveTime?: InputMaybe<Scalars['DateTime']>;
  participantId?: InputMaybe<Scalars['String']>;
  participantName?: InputMaybe<Scalars['String']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
};

export type TraineeEventDayAttendanceUncheckedCreateWithoutTraineeEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  eventDayId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  isZoomMeeting?: InputMaybe<Scalars['Boolean']>;
  joinTime: Scalars['DateTime'];
  leaveTime?: InputMaybe<Scalars['DateTime']>;
  participantId?: InputMaybe<Scalars['String']>;
  participantName?: InputMaybe<Scalars['String']>;
};

export type TraineeEventDayAttendanceUncheckedUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  eventDayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isZoomMeeting?: InputMaybe<BoolFieldUpdateOperationsInput>;
  joinTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  leaveTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  participantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  participantName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type TraineeEventDayAttendanceUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  eventDayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isZoomMeeting?: InputMaybe<BoolFieldUpdateOperationsInput>;
  joinTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  leaveTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  participantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  participantName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type TraineeEventDayAttendanceUncheckedUpdateManyWithoutAttendanceInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  eventDayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isZoomMeeting?: InputMaybe<BoolFieldUpdateOperationsInput>;
  joinTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  leaveTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  participantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  participantName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeEventDayAttendanceUncheckedUpdateManyWithoutEventDayInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceCreateOrConnectWithoutEventDayInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceCreateWithoutEventDayInput>>>;
  createMany?: InputMaybe<TraineeEventDayAttendanceCreateManyEventDayInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceUpdateWithWhereUniqueWithoutEventDayInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceUpdateManyWithWhereWithoutEventDayInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceUpsertWithWhereUniqueWithoutEventDayInput>>>;
};

export type TraineeEventDayAttendanceUncheckedUpdateManyWithoutTraineeAttendanceInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isZoomMeeting?: InputMaybe<BoolFieldUpdateOperationsInput>;
  joinTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  leaveTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  participantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  participantName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type TraineeEventDayAttendanceUncheckedUpdateManyWithoutTraineeEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceCreateOrConnectWithoutTraineeEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceCreateWithoutTraineeEventInput>>>;
  createMany?: InputMaybe<TraineeEventDayAttendanceCreateManyTraineeEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceUpdateWithWhereUniqueWithoutTraineeEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceUpdateManyWithWhereWithoutTraineeEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceUpsertWithWhereUniqueWithoutTraineeEventInput>>>;
};

export type TraineeEventDayAttendanceUncheckedUpdateWithoutEventDayInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isZoomMeeting?: InputMaybe<BoolFieldUpdateOperationsInput>;
  joinTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  leaveTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  participantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  participantName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type TraineeEventDayAttendanceUncheckedUpdateWithoutTraineeEventInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  eventDayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isZoomMeeting?: InputMaybe<BoolFieldUpdateOperationsInput>;
  joinTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  leaveTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  participantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  participantName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeEventDayAttendanceUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  eventDay?: InputMaybe<EventDayUpdateOneRequiredWithoutTraineeAttendanceInput>;
  isZoomMeeting?: InputMaybe<BoolFieldUpdateOperationsInput>;
  joinTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  leaveTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  participantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  participantName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  traineeEvent?: InputMaybe<TraineeEventUpdateOneWithoutAttendanceInput>;
};

export type TraineeEventDayAttendanceUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isZoomMeeting?: InputMaybe<BoolFieldUpdateOperationsInput>;
  joinTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  leaveTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  participantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  participantName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeEventDayAttendanceUpdateManyWithWhereWithoutEventDayInput = {
  data: TraineeEventDayAttendanceUncheckedUpdateManyWithoutTraineeAttendanceInput;
  where: TraineeEventDayAttendanceScalarWhereInput;
};

export type TraineeEventDayAttendanceUpdateManyWithWhereWithoutTraineeEventInput = {
  data: TraineeEventDayAttendanceUncheckedUpdateManyWithoutAttendanceInput;
  where: TraineeEventDayAttendanceScalarWhereInput;
};

export type TraineeEventDayAttendanceUpdateManyWithoutEventDayInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceCreateOrConnectWithoutEventDayInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceCreateWithoutEventDayInput>>>;
  createMany?: InputMaybe<TraineeEventDayAttendanceCreateManyEventDayInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceUpdateWithWhereUniqueWithoutEventDayInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceUpdateManyWithWhereWithoutEventDayInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceUpsertWithWhereUniqueWithoutEventDayInput>>>;
};

export type TraineeEventDayAttendanceUpdateManyWithoutTraineeEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceCreateOrConnectWithoutTraineeEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceCreateWithoutTraineeEventInput>>>;
  createMany?: InputMaybe<TraineeEventDayAttendanceCreateManyTraineeEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceUpdateWithWhereUniqueWithoutTraineeEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceUpdateManyWithWhereWithoutTraineeEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceUpsertWithWhereUniqueWithoutTraineeEventInput>>>;
};

export type TraineeEventDayAttendanceUpdateWithWhereUniqueWithoutEventDayInput = {
  data: TraineeEventDayAttendanceUncheckedUpdateWithoutEventDayInput;
  where: TraineeEventDayAttendanceWhereUniqueInput;
};

export type TraineeEventDayAttendanceUpdateWithWhereUniqueWithoutTraineeEventInput = {
  data: TraineeEventDayAttendanceUncheckedUpdateWithoutTraineeEventInput;
  where: TraineeEventDayAttendanceWhereUniqueInput;
};

export type TraineeEventDayAttendanceUpdateWithoutEventDayInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isZoomMeeting?: InputMaybe<BoolFieldUpdateOperationsInput>;
  joinTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  leaveTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  participantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  participantName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  traineeEvent?: InputMaybe<TraineeEventUpdateOneWithoutAttendanceInput>;
};

export type TraineeEventDayAttendanceUpdateWithoutTraineeEventInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  eventDay?: InputMaybe<EventDayUpdateOneRequiredWithoutTraineeAttendanceInput>;
  isZoomMeeting?: InputMaybe<BoolFieldUpdateOperationsInput>;
  joinTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  leaveTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  participantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  participantName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeEventDayAttendanceUpsertWithWhereUniqueWithoutEventDayInput = {
  create: TraineeEventDayAttendanceUncheckedCreateWithoutEventDayInput;
  update: TraineeEventDayAttendanceUncheckedUpdateWithoutEventDayInput;
  where: TraineeEventDayAttendanceWhereUniqueInput;
};

export type TraineeEventDayAttendanceUpsertWithWhereUniqueWithoutTraineeEventInput = {
  create: TraineeEventDayAttendanceUncheckedCreateWithoutTraineeEventInput;
  update: TraineeEventDayAttendanceUncheckedUpdateWithoutTraineeEventInput;
  where: TraineeEventDayAttendanceWhereUniqueInput;
};

export type TraineeEventDayAttendanceWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TraineeEventDayAttendanceWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  duration?: InputMaybe<IntNullableFilter>;
  eventDay?: InputMaybe<EventDayWhereInput>;
  eventDayId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  isZoomMeeting?: InputMaybe<BoolFilter>;
  joinTime?: InputMaybe<DateTimeFilter>;
  leaveTime?: InputMaybe<DateTimeNullableFilter>;
  participantId?: InputMaybe<StringNullableFilter>;
  participantName?: InputMaybe<StringNullableFilter>;
  traineeEvent?: InputMaybe<TraineeEventWhereInput>;
  traineeEventId?: InputMaybe<IntNullableFilter>;
};

export type TraineeEventDayAttendanceWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type TraineeEventGroup = {
  __typename?: 'TraineeEventGroup';
  _count: TraineeEventGroupCountOutputType;
  areLateRegistrants: Scalars['Boolean'];
  areWorkshopRegistrants: Scalars['Boolean'];
  coupon?: Maybe<Coupon>;
  couponId?: Maybe<Scalars['Int']>;
  couponeDiscount?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: Event;
  eventId: Scalars['Int'];
  groupCertificatePrice?: Maybe<Scalars['Decimal']>;
  groupPrice: Scalars['Decimal'];
  groupTax: Scalars['Decimal'];
  groupTotalToPay: Scalars['Decimal'];
  groupTransactions: Array<Transition>;
  groupWalletBalance?: Maybe<Scalars['Decimal']>;
  groupWorkshopPrice?: Maybe<Scalars['Decimal']>;
  id: Scalars['Int'];
  isGroupPay: Scalars['Boolean'];
  leader: User;
  leaderId: Scalars['Int'];
  traineeEvents: Array<TraineeEvent>;
};


export type TraineeEventGroupGroupTransactionsArgs = {
  cursor?: InputMaybe<TransitionWhereUniqueInput>;
  distinct?: InputMaybe<TransitionScalarFieldEnum>;
  orderBy?: InputMaybe<TransitionOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TransitionWhereInput>;
};


export type TraineeEventGroupTraineeEventsArgs = {
  cursor?: InputMaybe<TraineeEventWhereUniqueInput>;
  distinct?: InputMaybe<TraineeEventScalarFieldEnum>;
  orderBy?: InputMaybe<TraineeEventOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeEventWhereInput>;
};

export type TraineeEventGroupAvgAggregateOutputType = {
  __typename?: 'TraineeEventGroupAvgAggregateOutputType';
  couponId?: Maybe<Scalars['Float']>;
  couponeDiscount?: Maybe<Scalars['Decimal']>;
  eventId?: Maybe<Scalars['Float']>;
  groupCertificatePrice?: Maybe<Scalars['Decimal']>;
  groupPrice?: Maybe<Scalars['Decimal']>;
  groupTax?: Maybe<Scalars['Decimal']>;
  groupTotalToPay?: Maybe<Scalars['Decimal']>;
  groupWalletBalance?: Maybe<Scalars['Decimal']>;
  groupWorkshopPrice?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['Float']>;
  leaderId?: Maybe<Scalars['Float']>;
};

export type TraineeEventGroupAvgOrderByAggregateInput = {
  couponId?: InputMaybe<SortOrder>;
  couponeDiscount?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  groupCertificatePrice?: InputMaybe<SortOrder>;
  groupPrice?: InputMaybe<SortOrder>;
  groupTax?: InputMaybe<SortOrder>;
  groupTotalToPay?: InputMaybe<SortOrder>;
  groupWalletBalance?: InputMaybe<SortOrder>;
  groupWorkshopPrice?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  leaderId?: InputMaybe<SortOrder>;
};

export type TraineeEventGroupCountAggregateOutputType = {
  __typename?: 'TraineeEventGroupCountAggregateOutputType';
  _all: Scalars['Int'];
  areLateRegistrants: Scalars['Int'];
  areWorkshopRegistrants: Scalars['Int'];
  couponId: Scalars['Int'];
  couponeDiscount: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  eventId: Scalars['Int'];
  groupCertificatePrice: Scalars['Int'];
  groupPrice: Scalars['Int'];
  groupTax: Scalars['Int'];
  groupTotalToPay: Scalars['Int'];
  groupWalletBalance: Scalars['Int'];
  groupWorkshopPrice: Scalars['Int'];
  id: Scalars['Int'];
  isGroupPay: Scalars['Int'];
  leaderId: Scalars['Int'];
};

export type TraineeEventGroupCountOrderByAggregateInput = {
  areLateRegistrants?: InputMaybe<SortOrder>;
  areWorkshopRegistrants?: InputMaybe<SortOrder>;
  couponId?: InputMaybe<SortOrder>;
  couponeDiscount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  groupCertificatePrice?: InputMaybe<SortOrder>;
  groupPrice?: InputMaybe<SortOrder>;
  groupTax?: InputMaybe<SortOrder>;
  groupTotalToPay?: InputMaybe<SortOrder>;
  groupWalletBalance?: InputMaybe<SortOrder>;
  groupWorkshopPrice?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isGroupPay?: InputMaybe<SortOrder>;
  leaderId?: InputMaybe<SortOrder>;
};

export type TraineeEventGroupCountOutputType = {
  __typename?: 'TraineeEventGroupCountOutputType';
  groupTransactions: Scalars['Int'];
  traineeEvents: Scalars['Int'];
};

export type TraineeEventGroupCreateInput = {
  areLateRegistrants: Scalars['Boolean'];
  areWorkshopRegistrants: Scalars['Boolean'];
  coupon?: InputMaybe<CouponCreateNestedOneWithoutTraineeEventGroupInput>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  event: EventCreateNestedOneWithoutTraineeEventGroupsInput;
  groupCertificatePrice?: InputMaybe<Scalars['Decimal']>;
  groupPrice: Scalars['Decimal'];
  groupTax: Scalars['Decimal'];
  groupTotalToPay: Scalars['Decimal'];
  groupTransactions?: InputMaybe<TransitionCreateNestedManyWithoutTraineeEventGroupInput>;
  groupWalletBalance?: InputMaybe<Scalars['Decimal']>;
  groupWorkshopPrice?: InputMaybe<Scalars['Decimal']>;
  isGroupPay: Scalars['Boolean'];
  leader: UserCreateNestedOneWithoutLeaderEventGroupsInput;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutGroupInput>;
};

export type TraineeEventGroupCreateManyCouponInput = {
  areLateRegistrants: Scalars['Boolean'];
  areWorkshopRegistrants: Scalars['Boolean'];
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  groupCertificatePrice?: InputMaybe<Scalars['Decimal']>;
  groupPrice: Scalars['Decimal'];
  groupTax: Scalars['Decimal'];
  groupTotalToPay: Scalars['Decimal'];
  groupWalletBalance?: InputMaybe<Scalars['Decimal']>;
  groupWorkshopPrice?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['Int']>;
  isGroupPay: Scalars['Boolean'];
  leaderId: Scalars['Int'];
};

export type TraineeEventGroupCreateManyCouponInputEnvelope = {
  data: TraineeEventGroupCreateManyCouponInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TraineeEventGroupCreateManyEventInput = {
  areLateRegistrants: Scalars['Boolean'];
  areWorkshopRegistrants: Scalars['Boolean'];
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  groupCertificatePrice?: InputMaybe<Scalars['Decimal']>;
  groupPrice: Scalars['Decimal'];
  groupTax: Scalars['Decimal'];
  groupTotalToPay: Scalars['Decimal'];
  groupWalletBalance?: InputMaybe<Scalars['Decimal']>;
  groupWorkshopPrice?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['Int']>;
  isGroupPay: Scalars['Boolean'];
  leaderId: Scalars['Int'];
};

export type TraineeEventGroupCreateManyEventInputEnvelope = {
  data: TraineeEventGroupCreateManyEventInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TraineeEventGroupCreateManyInput = {
  areLateRegistrants: Scalars['Boolean'];
  areWorkshopRegistrants: Scalars['Boolean'];
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  groupCertificatePrice?: InputMaybe<Scalars['Decimal']>;
  groupPrice: Scalars['Decimal'];
  groupTax: Scalars['Decimal'];
  groupTotalToPay: Scalars['Decimal'];
  groupWalletBalance?: InputMaybe<Scalars['Decimal']>;
  groupWorkshopPrice?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['Int']>;
  isGroupPay: Scalars['Boolean'];
  leaderId: Scalars['Int'];
};

export type TraineeEventGroupCreateManyLeaderInput = {
  areLateRegistrants: Scalars['Boolean'];
  areWorkshopRegistrants: Scalars['Boolean'];
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  groupCertificatePrice?: InputMaybe<Scalars['Decimal']>;
  groupPrice: Scalars['Decimal'];
  groupTax: Scalars['Decimal'];
  groupTotalToPay: Scalars['Decimal'];
  groupWalletBalance?: InputMaybe<Scalars['Decimal']>;
  groupWorkshopPrice?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['Int']>;
  isGroupPay: Scalars['Boolean'];
};

export type TraineeEventGroupCreateManyLeaderInputEnvelope = {
  data: TraineeEventGroupCreateManyLeaderInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TraineeEventGroupCreateNestedManyWithoutCouponInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventGroupWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventGroupCreateOrConnectWithoutCouponInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventGroupCreateWithoutCouponInput>>>;
  createMany?: InputMaybe<TraineeEventGroupCreateManyCouponInputEnvelope>;
};

export type TraineeEventGroupCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventGroupWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventGroupCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventGroupCreateWithoutEventInput>>>;
  createMany?: InputMaybe<TraineeEventGroupCreateManyEventInputEnvelope>;
};

export type TraineeEventGroupCreateNestedManyWithoutLeaderInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventGroupWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventGroupCreateOrConnectWithoutLeaderInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventGroupCreateWithoutLeaderInput>>>;
  createMany?: InputMaybe<TraineeEventGroupCreateManyLeaderInputEnvelope>;
};

export type TraineeEventGroupCreateNestedOneWithoutGroupTransactionsInput = {
  connect?: InputMaybe<TraineeEventGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TraineeEventGroupCreateOrConnectWithoutGroupTransactionsInput>;
  create?: InputMaybe<TraineeEventGroupUncheckedCreateWithoutGroupTransactionsInput>;
};

export type TraineeEventGroupCreateNestedOneWithoutTraineeEventsInput = {
  connect?: InputMaybe<TraineeEventGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TraineeEventGroupCreateOrConnectWithoutTraineeEventsInput>;
  create?: InputMaybe<TraineeEventGroupUncheckedCreateWithoutTraineeEventsInput>;
};

export type TraineeEventGroupCreateOrConnectWithoutCouponInput = {
  create: TraineeEventGroupUncheckedCreateWithoutCouponInput;
  where: TraineeEventGroupWhereUniqueInput;
};

export type TraineeEventGroupCreateOrConnectWithoutEventInput = {
  create: TraineeEventGroupUncheckedCreateWithoutEventInput;
  where: TraineeEventGroupWhereUniqueInput;
};

export type TraineeEventGroupCreateOrConnectWithoutGroupTransactionsInput = {
  create: TraineeEventGroupUncheckedCreateWithoutGroupTransactionsInput;
  where: TraineeEventGroupWhereUniqueInput;
};

export type TraineeEventGroupCreateOrConnectWithoutLeaderInput = {
  create: TraineeEventGroupUncheckedCreateWithoutLeaderInput;
  where: TraineeEventGroupWhereUniqueInput;
};

export type TraineeEventGroupCreateOrConnectWithoutTraineeEventsInput = {
  create: TraineeEventGroupUncheckedCreateWithoutTraineeEventsInput;
  where: TraineeEventGroupWhereUniqueInput;
};

export type TraineeEventGroupCreateWithoutCouponInput = {
  areLateRegistrants: Scalars['Boolean'];
  areWorkshopRegistrants: Scalars['Boolean'];
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  event: EventCreateNestedOneWithoutTraineeEventGroupsInput;
  groupCertificatePrice?: InputMaybe<Scalars['Decimal']>;
  groupPrice: Scalars['Decimal'];
  groupTax: Scalars['Decimal'];
  groupTotalToPay: Scalars['Decimal'];
  groupTransactions?: InputMaybe<TransitionCreateNestedManyWithoutTraineeEventGroupInput>;
  groupWalletBalance?: InputMaybe<Scalars['Decimal']>;
  groupWorkshopPrice?: InputMaybe<Scalars['Decimal']>;
  isGroupPay: Scalars['Boolean'];
  leader: UserCreateNestedOneWithoutLeaderEventGroupsInput;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutGroupInput>;
};

export type TraineeEventGroupCreateWithoutEventInput = {
  areLateRegistrants: Scalars['Boolean'];
  areWorkshopRegistrants: Scalars['Boolean'];
  coupon?: InputMaybe<CouponCreateNestedOneWithoutTraineeEventGroupInput>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  groupCertificatePrice?: InputMaybe<Scalars['Decimal']>;
  groupPrice: Scalars['Decimal'];
  groupTax: Scalars['Decimal'];
  groupTotalToPay: Scalars['Decimal'];
  groupTransactions?: InputMaybe<TransitionCreateNestedManyWithoutTraineeEventGroupInput>;
  groupWalletBalance?: InputMaybe<Scalars['Decimal']>;
  groupWorkshopPrice?: InputMaybe<Scalars['Decimal']>;
  isGroupPay: Scalars['Boolean'];
  leader: UserCreateNestedOneWithoutLeaderEventGroupsInput;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutGroupInput>;
};

export type TraineeEventGroupCreateWithoutGroupTransactionsInput = {
  areLateRegistrants: Scalars['Boolean'];
  areWorkshopRegistrants: Scalars['Boolean'];
  coupon?: InputMaybe<CouponCreateNestedOneWithoutTraineeEventGroupInput>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  event: EventCreateNestedOneWithoutTraineeEventGroupsInput;
  groupCertificatePrice?: InputMaybe<Scalars['Decimal']>;
  groupPrice: Scalars['Decimal'];
  groupTax: Scalars['Decimal'];
  groupTotalToPay: Scalars['Decimal'];
  groupWalletBalance?: InputMaybe<Scalars['Decimal']>;
  groupWorkshopPrice?: InputMaybe<Scalars['Decimal']>;
  isGroupPay: Scalars['Boolean'];
  leader: UserCreateNestedOneWithoutLeaderEventGroupsInput;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutGroupInput>;
};

export type TraineeEventGroupCreateWithoutLeaderInput = {
  areLateRegistrants: Scalars['Boolean'];
  areWorkshopRegistrants: Scalars['Boolean'];
  coupon?: InputMaybe<CouponCreateNestedOneWithoutTraineeEventGroupInput>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  event: EventCreateNestedOneWithoutTraineeEventGroupsInput;
  groupCertificatePrice?: InputMaybe<Scalars['Decimal']>;
  groupPrice: Scalars['Decimal'];
  groupTax: Scalars['Decimal'];
  groupTotalToPay: Scalars['Decimal'];
  groupTransactions?: InputMaybe<TransitionCreateNestedManyWithoutTraineeEventGroupInput>;
  groupWalletBalance?: InputMaybe<Scalars['Decimal']>;
  groupWorkshopPrice?: InputMaybe<Scalars['Decimal']>;
  isGroupPay: Scalars['Boolean'];
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutGroupInput>;
};

export type TraineeEventGroupCreateWithoutTraineeEventsInput = {
  areLateRegistrants: Scalars['Boolean'];
  areWorkshopRegistrants: Scalars['Boolean'];
  coupon?: InputMaybe<CouponCreateNestedOneWithoutTraineeEventGroupInput>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  event: EventCreateNestedOneWithoutTraineeEventGroupsInput;
  groupCertificatePrice?: InputMaybe<Scalars['Decimal']>;
  groupPrice: Scalars['Decimal'];
  groupTax: Scalars['Decimal'];
  groupTotalToPay: Scalars['Decimal'];
  groupTransactions?: InputMaybe<TransitionCreateNestedManyWithoutTraineeEventGroupInput>;
  groupWalletBalance?: InputMaybe<Scalars['Decimal']>;
  groupWorkshopPrice?: InputMaybe<Scalars['Decimal']>;
  isGroupPay: Scalars['Boolean'];
  leader: UserCreateNestedOneWithoutLeaderEventGroupsInput;
};

export type TraineeEventGroupListRelationFilter = {
  every?: InputMaybe<TraineeEventGroupWhereInput>;
  none?: InputMaybe<TraineeEventGroupWhereInput>;
  some?: InputMaybe<TraineeEventGroupWhereInput>;
};

export type TraineeEventGroupMaxAggregateOutputType = {
  __typename?: 'TraineeEventGroupMaxAggregateOutputType';
  areLateRegistrants?: Maybe<Scalars['Boolean']>;
  areWorkshopRegistrants?: Maybe<Scalars['Boolean']>;
  couponId?: Maybe<Scalars['Int']>;
  couponeDiscount?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  eventId?: Maybe<Scalars['Int']>;
  groupCertificatePrice?: Maybe<Scalars['Decimal']>;
  groupPrice?: Maybe<Scalars['Decimal']>;
  groupTax?: Maybe<Scalars['Decimal']>;
  groupTotalToPay?: Maybe<Scalars['Decimal']>;
  groupWalletBalance?: Maybe<Scalars['Decimal']>;
  groupWorkshopPrice?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['Int']>;
  isGroupPay?: Maybe<Scalars['Boolean']>;
  leaderId?: Maybe<Scalars['Int']>;
};

export type TraineeEventGroupMaxOrderByAggregateInput = {
  areLateRegistrants?: InputMaybe<SortOrder>;
  areWorkshopRegistrants?: InputMaybe<SortOrder>;
  couponId?: InputMaybe<SortOrder>;
  couponeDiscount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  groupCertificatePrice?: InputMaybe<SortOrder>;
  groupPrice?: InputMaybe<SortOrder>;
  groupTax?: InputMaybe<SortOrder>;
  groupTotalToPay?: InputMaybe<SortOrder>;
  groupWalletBalance?: InputMaybe<SortOrder>;
  groupWorkshopPrice?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isGroupPay?: InputMaybe<SortOrder>;
  leaderId?: InputMaybe<SortOrder>;
};

export type TraineeEventGroupMinAggregateOutputType = {
  __typename?: 'TraineeEventGroupMinAggregateOutputType';
  areLateRegistrants?: Maybe<Scalars['Boolean']>;
  areWorkshopRegistrants?: Maybe<Scalars['Boolean']>;
  couponId?: Maybe<Scalars['Int']>;
  couponeDiscount?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  eventId?: Maybe<Scalars['Int']>;
  groupCertificatePrice?: Maybe<Scalars['Decimal']>;
  groupPrice?: Maybe<Scalars['Decimal']>;
  groupTax?: Maybe<Scalars['Decimal']>;
  groupTotalToPay?: Maybe<Scalars['Decimal']>;
  groupWalletBalance?: Maybe<Scalars['Decimal']>;
  groupWorkshopPrice?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['Int']>;
  isGroupPay?: Maybe<Scalars['Boolean']>;
  leaderId?: Maybe<Scalars['Int']>;
};

export type TraineeEventGroupMinOrderByAggregateInput = {
  areLateRegistrants?: InputMaybe<SortOrder>;
  areWorkshopRegistrants?: InputMaybe<SortOrder>;
  couponId?: InputMaybe<SortOrder>;
  couponeDiscount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  groupCertificatePrice?: InputMaybe<SortOrder>;
  groupPrice?: InputMaybe<SortOrder>;
  groupTax?: InputMaybe<SortOrder>;
  groupTotalToPay?: InputMaybe<SortOrder>;
  groupWalletBalance?: InputMaybe<SortOrder>;
  groupWorkshopPrice?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isGroupPay?: InputMaybe<SortOrder>;
  leaderId?: InputMaybe<SortOrder>;
};

export type TraineeEventGroupOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TraineeEventGroupOrderByWithAggregationInput = {
  _avg?: InputMaybe<TraineeEventGroupAvgOrderByAggregateInput>;
  _count?: InputMaybe<TraineeEventGroupCountOrderByAggregateInput>;
  _max?: InputMaybe<TraineeEventGroupMaxOrderByAggregateInput>;
  _min?: InputMaybe<TraineeEventGroupMinOrderByAggregateInput>;
  _sum?: InputMaybe<TraineeEventGroupSumOrderByAggregateInput>;
  areLateRegistrants?: InputMaybe<SortOrder>;
  areWorkshopRegistrants?: InputMaybe<SortOrder>;
  couponId?: InputMaybe<SortOrder>;
  couponeDiscount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  groupCertificatePrice?: InputMaybe<SortOrder>;
  groupPrice?: InputMaybe<SortOrder>;
  groupTax?: InputMaybe<SortOrder>;
  groupTotalToPay?: InputMaybe<SortOrder>;
  groupWalletBalance?: InputMaybe<SortOrder>;
  groupWorkshopPrice?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isGroupPay?: InputMaybe<SortOrder>;
  leaderId?: InputMaybe<SortOrder>;
};

export type TraineeEventGroupOrderByWithRelationInput = {
  areLateRegistrants?: InputMaybe<SortOrder>;
  areWorkshopRegistrants?: InputMaybe<SortOrder>;
  coupon?: InputMaybe<CouponOrderByWithRelationInput>;
  couponId?: InputMaybe<SortOrder>;
  couponeDiscount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  event?: InputMaybe<EventOrderByWithRelationInput>;
  eventId?: InputMaybe<SortOrder>;
  groupCertificatePrice?: InputMaybe<SortOrder>;
  groupPrice?: InputMaybe<SortOrder>;
  groupTax?: InputMaybe<SortOrder>;
  groupTotalToPay?: InputMaybe<SortOrder>;
  groupTransactions?: InputMaybe<TransitionOrderByRelationAggregateInput>;
  groupWalletBalance?: InputMaybe<SortOrder>;
  groupWorkshopPrice?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isGroupPay?: InputMaybe<SortOrder>;
  leader?: InputMaybe<UserOrderByWithRelationInput>;
  leaderId?: InputMaybe<SortOrder>;
  traineeEvents?: InputMaybe<TraineeEventOrderByRelationAggregateInput>;
};

export type TraineeEventGroupRelationFilter = {
  is?: InputMaybe<TraineeEventGroupWhereInput>;
  isNot?: InputMaybe<TraineeEventGroupWhereInput>;
};

export enum TraineeEventGroupScalarFieldEnum {
  AreLateRegistrants = 'areLateRegistrants',
  AreWorkshopRegistrants = 'areWorkshopRegistrants',
  CouponId = 'couponId',
  CouponeDiscount = 'couponeDiscount',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  EventId = 'eventId',
  GroupCertificatePrice = 'groupCertificatePrice',
  GroupPrice = 'groupPrice',
  GroupTax = 'groupTax',
  GroupTotalToPay = 'groupTotalToPay',
  GroupWalletBalance = 'groupWalletBalance',
  GroupWorkshopPrice = 'groupWorkshopPrice',
  Id = 'id',
  IsGroupPay = 'isGroupPay',
  LeaderId = 'leaderId'
}

export type TraineeEventGroupScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TraineeEventGroupScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TraineeEventGroupScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TraineeEventGroupScalarWhereInput>>>;
  areLateRegistrants?: InputMaybe<BoolFilter>;
  areWorkshopRegistrants?: InputMaybe<BoolFilter>;
  couponId?: InputMaybe<IntNullableFilter>;
  couponeDiscount?: InputMaybe<DecimalNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  eventId?: InputMaybe<IntFilter>;
  groupCertificatePrice?: InputMaybe<DecimalNullableFilter>;
  groupPrice?: InputMaybe<DecimalFilter>;
  groupTax?: InputMaybe<DecimalFilter>;
  groupTotalToPay?: InputMaybe<DecimalFilter>;
  groupWalletBalance?: InputMaybe<DecimalNullableFilter>;
  groupWorkshopPrice?: InputMaybe<DecimalNullableFilter>;
  id?: InputMaybe<IntFilter>;
  isGroupPay?: InputMaybe<BoolFilter>;
  leaderId?: InputMaybe<IntFilter>;
};

export type TraineeEventGroupScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<TraineeEventGroupScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TraineeEventGroupScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TraineeEventGroupScalarWhereWithAggregatesInput>>>;
  areLateRegistrants?: InputMaybe<BoolWithAggregatesFilter>;
  areWorkshopRegistrants?: InputMaybe<BoolWithAggregatesFilter>;
  couponId?: InputMaybe<IntNullableWithAggregatesFilter>;
  couponeDiscount?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  eventId?: InputMaybe<IntWithAggregatesFilter>;
  groupCertificatePrice?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  groupPrice?: InputMaybe<DecimalWithAggregatesFilter>;
  groupTax?: InputMaybe<DecimalWithAggregatesFilter>;
  groupTotalToPay?: InputMaybe<DecimalWithAggregatesFilter>;
  groupWalletBalance?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  groupWorkshopPrice?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  isGroupPay?: InputMaybe<BoolWithAggregatesFilter>;
  leaderId?: InputMaybe<IntWithAggregatesFilter>;
};

export type TraineeEventGroupSumAggregateOutputType = {
  __typename?: 'TraineeEventGroupSumAggregateOutputType';
  couponId?: Maybe<Scalars['Int']>;
  couponeDiscount?: Maybe<Scalars['Decimal']>;
  eventId?: Maybe<Scalars['Int']>;
  groupCertificatePrice?: Maybe<Scalars['Decimal']>;
  groupPrice?: Maybe<Scalars['Decimal']>;
  groupTax?: Maybe<Scalars['Decimal']>;
  groupTotalToPay?: Maybe<Scalars['Decimal']>;
  groupWalletBalance?: Maybe<Scalars['Decimal']>;
  groupWorkshopPrice?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['Int']>;
  leaderId?: Maybe<Scalars['Int']>;
};

export type TraineeEventGroupSumOrderByAggregateInput = {
  couponId?: InputMaybe<SortOrder>;
  couponeDiscount?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  groupCertificatePrice?: InputMaybe<SortOrder>;
  groupPrice?: InputMaybe<SortOrder>;
  groupTax?: InputMaybe<SortOrder>;
  groupTotalToPay?: InputMaybe<SortOrder>;
  groupWalletBalance?: InputMaybe<SortOrder>;
  groupWorkshopPrice?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  leaderId?: InputMaybe<SortOrder>;
};

export type TraineeEventGroupUncheckedCreateInput = {
  areLateRegistrants: Scalars['Boolean'];
  areWorkshopRegistrants: Scalars['Boolean'];
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  groupCertificatePrice?: InputMaybe<Scalars['Decimal']>;
  groupPrice: Scalars['Decimal'];
  groupTax: Scalars['Decimal'];
  groupTotalToPay: Scalars['Decimal'];
  groupTransactions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTraineeEventGroupInput>;
  groupWalletBalance?: InputMaybe<Scalars['Decimal']>;
  groupWorkshopPrice?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['Int']>;
  isGroupPay: Scalars['Boolean'];
  leaderId: Scalars['Int'];
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutGroupInput>;
};

export type TraineeEventGroupUncheckedCreateNestedManyWithoutCouponInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventGroupWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventGroupCreateOrConnectWithoutCouponInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventGroupCreateWithoutCouponInput>>>;
  createMany?: InputMaybe<TraineeEventGroupCreateManyCouponInputEnvelope>;
};

export type TraineeEventGroupUncheckedCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventGroupWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventGroupCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventGroupCreateWithoutEventInput>>>;
  createMany?: InputMaybe<TraineeEventGroupCreateManyEventInputEnvelope>;
};

export type TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventGroupWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventGroupCreateOrConnectWithoutLeaderInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventGroupCreateWithoutLeaderInput>>>;
  createMany?: InputMaybe<TraineeEventGroupCreateManyLeaderInputEnvelope>;
};

export type TraineeEventGroupUncheckedCreateWithoutCouponInput = {
  areLateRegistrants: Scalars['Boolean'];
  areWorkshopRegistrants: Scalars['Boolean'];
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  groupCertificatePrice?: InputMaybe<Scalars['Decimal']>;
  groupPrice: Scalars['Decimal'];
  groupTax: Scalars['Decimal'];
  groupTotalToPay: Scalars['Decimal'];
  groupTransactions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTraineeEventGroupInput>;
  groupWalletBalance?: InputMaybe<Scalars['Decimal']>;
  groupWorkshopPrice?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['Int']>;
  isGroupPay: Scalars['Boolean'];
  leaderId: Scalars['Int'];
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutGroupInput>;
};

export type TraineeEventGroupUncheckedCreateWithoutEventInput = {
  areLateRegistrants: Scalars['Boolean'];
  areWorkshopRegistrants: Scalars['Boolean'];
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  groupCertificatePrice?: InputMaybe<Scalars['Decimal']>;
  groupPrice: Scalars['Decimal'];
  groupTax: Scalars['Decimal'];
  groupTotalToPay: Scalars['Decimal'];
  groupTransactions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTraineeEventGroupInput>;
  groupWalletBalance?: InputMaybe<Scalars['Decimal']>;
  groupWorkshopPrice?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['Int']>;
  isGroupPay: Scalars['Boolean'];
  leaderId: Scalars['Int'];
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutGroupInput>;
};

export type TraineeEventGroupUncheckedCreateWithoutGroupTransactionsInput = {
  areLateRegistrants: Scalars['Boolean'];
  areWorkshopRegistrants: Scalars['Boolean'];
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  groupCertificatePrice?: InputMaybe<Scalars['Decimal']>;
  groupPrice: Scalars['Decimal'];
  groupTax: Scalars['Decimal'];
  groupTotalToPay: Scalars['Decimal'];
  groupWalletBalance?: InputMaybe<Scalars['Decimal']>;
  groupWorkshopPrice?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['Int']>;
  isGroupPay: Scalars['Boolean'];
  leaderId: Scalars['Int'];
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutGroupInput>;
};

export type TraineeEventGroupUncheckedCreateWithoutLeaderInput = {
  areLateRegistrants: Scalars['Boolean'];
  areWorkshopRegistrants: Scalars['Boolean'];
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  groupCertificatePrice?: InputMaybe<Scalars['Decimal']>;
  groupPrice: Scalars['Decimal'];
  groupTax: Scalars['Decimal'];
  groupTotalToPay: Scalars['Decimal'];
  groupTransactions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTraineeEventGroupInput>;
  groupWalletBalance?: InputMaybe<Scalars['Decimal']>;
  groupWorkshopPrice?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['Int']>;
  isGroupPay: Scalars['Boolean'];
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutGroupInput>;
};

export type TraineeEventGroupUncheckedCreateWithoutTraineeEventsInput = {
  areLateRegistrants: Scalars['Boolean'];
  areWorkshopRegistrants: Scalars['Boolean'];
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  groupCertificatePrice?: InputMaybe<Scalars['Decimal']>;
  groupPrice: Scalars['Decimal'];
  groupTax: Scalars['Decimal'];
  groupTotalToPay: Scalars['Decimal'];
  groupTransactions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTraineeEventGroupInput>;
  groupWalletBalance?: InputMaybe<Scalars['Decimal']>;
  groupWorkshopPrice?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['Int']>;
  isGroupPay: Scalars['Boolean'];
  leaderId: Scalars['Int'];
};

export type TraineeEventGroupUncheckedUpdateInput = {
  areLateRegistrants?: InputMaybe<BoolFieldUpdateOperationsInput>;
  areWorkshopRegistrants?: InputMaybe<BoolFieldUpdateOperationsInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  groupCertificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  groupPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTotalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTransactions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTraineeEventGroupInput>;
  groupWalletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  groupWorkshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isGroupPay?: InputMaybe<BoolFieldUpdateOperationsInput>;
  leaderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutGroupInput>;
};

export type TraineeEventGroupUncheckedUpdateManyInput = {
  areLateRegistrants?: InputMaybe<BoolFieldUpdateOperationsInput>;
  areWorkshopRegistrants?: InputMaybe<BoolFieldUpdateOperationsInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  groupCertificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  groupPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTotalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupWalletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  groupWorkshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isGroupPay?: InputMaybe<BoolFieldUpdateOperationsInput>;
  leaderId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TraineeEventGroupUncheckedUpdateManyWithoutCouponInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventGroupWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventGroupCreateOrConnectWithoutCouponInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventGroupCreateWithoutCouponInput>>>;
  createMany?: InputMaybe<TraineeEventGroupCreateManyCouponInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventGroupWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventGroupScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventGroupWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventGroupWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventGroupUpdateWithWhereUniqueWithoutCouponInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventGroupUpdateManyWithWhereWithoutCouponInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventGroupUpsertWithWhereUniqueWithoutCouponInput>>>;
};

export type TraineeEventGroupUncheckedUpdateManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventGroupWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventGroupCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventGroupCreateWithoutEventInput>>>;
  createMany?: InputMaybe<TraineeEventGroupCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventGroupWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventGroupScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventGroupWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventGroupWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventGroupUpdateWithWhereUniqueWithoutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventGroupUpdateManyWithWhereWithoutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventGroupUpsertWithWhereUniqueWithoutEventInput>>>;
};

export type TraineeEventGroupUncheckedUpdateManyWithoutLeaderEventGroupsInput = {
  areLateRegistrants?: InputMaybe<BoolFieldUpdateOperationsInput>;
  areWorkshopRegistrants?: InputMaybe<BoolFieldUpdateOperationsInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  groupCertificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  groupPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTotalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupWalletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  groupWorkshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isGroupPay?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventGroupWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventGroupCreateOrConnectWithoutLeaderInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventGroupCreateWithoutLeaderInput>>>;
  createMany?: InputMaybe<TraineeEventGroupCreateManyLeaderInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventGroupWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventGroupScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventGroupWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventGroupWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventGroupUpdateWithWhereUniqueWithoutLeaderInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventGroupUpdateManyWithWhereWithoutLeaderInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventGroupUpsertWithWhereUniqueWithoutLeaderInput>>>;
};

export type TraineeEventGroupUncheckedUpdateManyWithoutTraineeEventGroupInput = {
  areLateRegistrants?: InputMaybe<BoolFieldUpdateOperationsInput>;
  areWorkshopRegistrants?: InputMaybe<BoolFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  groupCertificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  groupPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTotalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupWalletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  groupWorkshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isGroupPay?: InputMaybe<BoolFieldUpdateOperationsInput>;
  leaderId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TraineeEventGroupUncheckedUpdateManyWithoutTraineeEventGroupsInput = {
  areLateRegistrants?: InputMaybe<BoolFieldUpdateOperationsInput>;
  areWorkshopRegistrants?: InputMaybe<BoolFieldUpdateOperationsInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  groupCertificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  groupPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTotalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupWalletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  groupWorkshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isGroupPay?: InputMaybe<BoolFieldUpdateOperationsInput>;
  leaderId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TraineeEventGroupUncheckedUpdateWithoutCouponInput = {
  areLateRegistrants?: InputMaybe<BoolFieldUpdateOperationsInput>;
  areWorkshopRegistrants?: InputMaybe<BoolFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  groupCertificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  groupPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTotalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTransactions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTraineeEventGroupInput>;
  groupWalletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  groupWorkshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isGroupPay?: InputMaybe<BoolFieldUpdateOperationsInput>;
  leaderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutGroupInput>;
};

export type TraineeEventGroupUncheckedUpdateWithoutEventInput = {
  areLateRegistrants?: InputMaybe<BoolFieldUpdateOperationsInput>;
  areWorkshopRegistrants?: InputMaybe<BoolFieldUpdateOperationsInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  groupCertificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  groupPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTotalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTransactions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTraineeEventGroupInput>;
  groupWalletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  groupWorkshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isGroupPay?: InputMaybe<BoolFieldUpdateOperationsInput>;
  leaderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutGroupInput>;
};

export type TraineeEventGroupUncheckedUpdateWithoutGroupTransactionsInput = {
  areLateRegistrants?: InputMaybe<BoolFieldUpdateOperationsInput>;
  areWorkshopRegistrants?: InputMaybe<BoolFieldUpdateOperationsInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  groupCertificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  groupPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTotalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupWalletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  groupWorkshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isGroupPay?: InputMaybe<BoolFieldUpdateOperationsInput>;
  leaderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutGroupInput>;
};

export type TraineeEventGroupUncheckedUpdateWithoutLeaderInput = {
  areLateRegistrants?: InputMaybe<BoolFieldUpdateOperationsInput>;
  areWorkshopRegistrants?: InputMaybe<BoolFieldUpdateOperationsInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  groupCertificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  groupPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTotalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTransactions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTraineeEventGroupInput>;
  groupWalletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  groupWorkshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isGroupPay?: InputMaybe<BoolFieldUpdateOperationsInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutGroupInput>;
};

export type TraineeEventGroupUncheckedUpdateWithoutTraineeEventsInput = {
  areLateRegistrants?: InputMaybe<BoolFieldUpdateOperationsInput>;
  areWorkshopRegistrants?: InputMaybe<BoolFieldUpdateOperationsInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  groupCertificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  groupPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTotalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTransactions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTraineeEventGroupInput>;
  groupWalletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  groupWorkshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isGroupPay?: InputMaybe<BoolFieldUpdateOperationsInput>;
  leaderId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TraineeEventGroupUpdateInput = {
  areLateRegistrants?: InputMaybe<BoolFieldUpdateOperationsInput>;
  areWorkshopRegistrants?: InputMaybe<BoolFieldUpdateOperationsInput>;
  coupon?: InputMaybe<CouponUpdateOneWithoutTraineeEventGroupInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTraineeEventGroupsInput>;
  groupCertificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  groupPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTotalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTransactions?: InputMaybe<TransitionUpdateManyWithoutTraineeEventGroupInput>;
  groupWalletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  groupWorkshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  isGroupPay?: InputMaybe<BoolFieldUpdateOperationsInput>;
  leader?: InputMaybe<UserUpdateOneRequiredWithoutLeaderEventGroupsInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutGroupInput>;
};

export type TraineeEventGroupUpdateManyMutationInput = {
  areLateRegistrants?: InputMaybe<BoolFieldUpdateOperationsInput>;
  areWorkshopRegistrants?: InputMaybe<BoolFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  groupCertificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  groupPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTotalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupWalletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  groupWorkshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  isGroupPay?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type TraineeEventGroupUpdateManyWithWhereWithoutCouponInput = {
  data: TraineeEventGroupUncheckedUpdateManyWithoutTraineeEventGroupInput;
  where: TraineeEventGroupScalarWhereInput;
};

export type TraineeEventGroupUpdateManyWithWhereWithoutEventInput = {
  data: TraineeEventGroupUncheckedUpdateManyWithoutTraineeEventGroupsInput;
  where: TraineeEventGroupScalarWhereInput;
};

export type TraineeEventGroupUpdateManyWithWhereWithoutLeaderInput = {
  data: TraineeEventGroupUncheckedUpdateManyWithoutLeaderEventGroupsInput;
  where: TraineeEventGroupScalarWhereInput;
};

export type TraineeEventGroupUpdateManyWithoutCouponInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventGroupWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventGroupCreateOrConnectWithoutCouponInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventGroupCreateWithoutCouponInput>>>;
  createMany?: InputMaybe<TraineeEventGroupCreateManyCouponInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventGroupWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventGroupScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventGroupWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventGroupWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventGroupUpdateWithWhereUniqueWithoutCouponInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventGroupUpdateManyWithWhereWithoutCouponInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventGroupUpsertWithWhereUniqueWithoutCouponInput>>>;
};

export type TraineeEventGroupUpdateManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventGroupWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventGroupCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventGroupCreateWithoutEventInput>>>;
  createMany?: InputMaybe<TraineeEventGroupCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventGroupWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventGroupScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventGroupWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventGroupWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventGroupUpdateWithWhereUniqueWithoutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventGroupUpdateManyWithWhereWithoutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventGroupUpsertWithWhereUniqueWithoutEventInput>>>;
};

export type TraineeEventGroupUpdateManyWithoutLeaderInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventGroupWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventGroupCreateOrConnectWithoutLeaderInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventGroupCreateWithoutLeaderInput>>>;
  createMany?: InputMaybe<TraineeEventGroupCreateManyLeaderInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventGroupWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventGroupScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventGroupWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventGroupWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventGroupUpdateWithWhereUniqueWithoutLeaderInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventGroupUpdateManyWithWhereWithoutLeaderInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventGroupUpsertWithWhereUniqueWithoutLeaderInput>>>;
};

export type TraineeEventGroupUpdateOneWithoutGroupTransactionsInput = {
  connect?: InputMaybe<TraineeEventGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TraineeEventGroupCreateOrConnectWithoutGroupTransactionsInput>;
  create?: InputMaybe<TraineeEventGroupUncheckedCreateWithoutGroupTransactionsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<TraineeEventGroupUncheckedUpdateWithoutGroupTransactionsInput>;
  upsert?: InputMaybe<TraineeEventGroupUpsertWithoutGroupTransactionsInput>;
};

export type TraineeEventGroupUpdateOneWithoutTraineeEventsInput = {
  connect?: InputMaybe<TraineeEventGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TraineeEventGroupCreateOrConnectWithoutTraineeEventsInput>;
  create?: InputMaybe<TraineeEventGroupUncheckedCreateWithoutTraineeEventsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<TraineeEventGroupUncheckedUpdateWithoutTraineeEventsInput>;
  upsert?: InputMaybe<TraineeEventGroupUpsertWithoutTraineeEventsInput>;
};

export type TraineeEventGroupUpdateWithWhereUniqueWithoutCouponInput = {
  data: TraineeEventGroupUncheckedUpdateWithoutCouponInput;
  where: TraineeEventGroupWhereUniqueInput;
};

export type TraineeEventGroupUpdateWithWhereUniqueWithoutEventInput = {
  data: TraineeEventGroupUncheckedUpdateWithoutEventInput;
  where: TraineeEventGroupWhereUniqueInput;
};

export type TraineeEventGroupUpdateWithWhereUniqueWithoutLeaderInput = {
  data: TraineeEventGroupUncheckedUpdateWithoutLeaderInput;
  where: TraineeEventGroupWhereUniqueInput;
};

export type TraineeEventGroupUpdateWithoutCouponInput = {
  areLateRegistrants?: InputMaybe<BoolFieldUpdateOperationsInput>;
  areWorkshopRegistrants?: InputMaybe<BoolFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTraineeEventGroupsInput>;
  groupCertificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  groupPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTotalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTransactions?: InputMaybe<TransitionUpdateManyWithoutTraineeEventGroupInput>;
  groupWalletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  groupWorkshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  isGroupPay?: InputMaybe<BoolFieldUpdateOperationsInput>;
  leader?: InputMaybe<UserUpdateOneRequiredWithoutLeaderEventGroupsInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutGroupInput>;
};

export type TraineeEventGroupUpdateWithoutEventInput = {
  areLateRegistrants?: InputMaybe<BoolFieldUpdateOperationsInput>;
  areWorkshopRegistrants?: InputMaybe<BoolFieldUpdateOperationsInput>;
  coupon?: InputMaybe<CouponUpdateOneWithoutTraineeEventGroupInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  groupCertificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  groupPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTotalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTransactions?: InputMaybe<TransitionUpdateManyWithoutTraineeEventGroupInput>;
  groupWalletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  groupWorkshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  isGroupPay?: InputMaybe<BoolFieldUpdateOperationsInput>;
  leader?: InputMaybe<UserUpdateOneRequiredWithoutLeaderEventGroupsInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutGroupInput>;
};

export type TraineeEventGroupUpdateWithoutGroupTransactionsInput = {
  areLateRegistrants?: InputMaybe<BoolFieldUpdateOperationsInput>;
  areWorkshopRegistrants?: InputMaybe<BoolFieldUpdateOperationsInput>;
  coupon?: InputMaybe<CouponUpdateOneWithoutTraineeEventGroupInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTraineeEventGroupsInput>;
  groupCertificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  groupPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTotalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupWalletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  groupWorkshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  isGroupPay?: InputMaybe<BoolFieldUpdateOperationsInput>;
  leader?: InputMaybe<UserUpdateOneRequiredWithoutLeaderEventGroupsInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutGroupInput>;
};

export type TraineeEventGroupUpdateWithoutLeaderInput = {
  areLateRegistrants?: InputMaybe<BoolFieldUpdateOperationsInput>;
  areWorkshopRegistrants?: InputMaybe<BoolFieldUpdateOperationsInput>;
  coupon?: InputMaybe<CouponUpdateOneWithoutTraineeEventGroupInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTraineeEventGroupsInput>;
  groupCertificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  groupPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTotalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTransactions?: InputMaybe<TransitionUpdateManyWithoutTraineeEventGroupInput>;
  groupWalletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  groupWorkshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  isGroupPay?: InputMaybe<BoolFieldUpdateOperationsInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutGroupInput>;
};

export type TraineeEventGroupUpdateWithoutTraineeEventsInput = {
  areLateRegistrants?: InputMaybe<BoolFieldUpdateOperationsInput>;
  areWorkshopRegistrants?: InputMaybe<BoolFieldUpdateOperationsInput>;
  coupon?: InputMaybe<CouponUpdateOneWithoutTraineeEventGroupInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTraineeEventGroupsInput>;
  groupCertificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  groupPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTotalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  groupTransactions?: InputMaybe<TransitionUpdateManyWithoutTraineeEventGroupInput>;
  groupWalletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  groupWorkshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  isGroupPay?: InputMaybe<BoolFieldUpdateOperationsInput>;
  leader?: InputMaybe<UserUpdateOneRequiredWithoutLeaderEventGroupsInput>;
};

export type TraineeEventGroupUpsertWithWhereUniqueWithoutCouponInput = {
  create: TraineeEventGroupUncheckedCreateWithoutCouponInput;
  update: TraineeEventGroupUncheckedUpdateWithoutCouponInput;
  where: TraineeEventGroupWhereUniqueInput;
};

export type TraineeEventGroupUpsertWithWhereUniqueWithoutEventInput = {
  create: TraineeEventGroupUncheckedCreateWithoutEventInput;
  update: TraineeEventGroupUncheckedUpdateWithoutEventInput;
  where: TraineeEventGroupWhereUniqueInput;
};

export type TraineeEventGroupUpsertWithWhereUniqueWithoutLeaderInput = {
  create: TraineeEventGroupUncheckedCreateWithoutLeaderInput;
  update: TraineeEventGroupUncheckedUpdateWithoutLeaderInput;
  where: TraineeEventGroupWhereUniqueInput;
};

export type TraineeEventGroupUpsertWithoutGroupTransactionsInput = {
  create: TraineeEventGroupUncheckedCreateWithoutGroupTransactionsInput;
  update: TraineeEventGroupUncheckedUpdateWithoutGroupTransactionsInput;
};

export type TraineeEventGroupUpsertWithoutTraineeEventsInput = {
  create: TraineeEventGroupUncheckedCreateWithoutTraineeEventsInput;
  update: TraineeEventGroupUncheckedUpdateWithoutTraineeEventsInput;
};

export type TraineeEventGroupWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TraineeEventGroupWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TraineeEventGroupWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TraineeEventGroupWhereInput>>>;
  areLateRegistrants?: InputMaybe<BoolFilter>;
  areWorkshopRegistrants?: InputMaybe<BoolFilter>;
  coupon?: InputMaybe<CouponWhereInput>;
  couponId?: InputMaybe<IntNullableFilter>;
  couponeDiscount?: InputMaybe<DecimalNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  event?: InputMaybe<EventWhereInput>;
  eventId?: InputMaybe<IntFilter>;
  groupCertificatePrice?: InputMaybe<DecimalNullableFilter>;
  groupPrice?: InputMaybe<DecimalFilter>;
  groupTax?: InputMaybe<DecimalFilter>;
  groupTotalToPay?: InputMaybe<DecimalFilter>;
  groupTransactions?: InputMaybe<TransitionListRelationFilter>;
  groupWalletBalance?: InputMaybe<DecimalNullableFilter>;
  groupWorkshopPrice?: InputMaybe<DecimalNullableFilter>;
  id?: InputMaybe<IntFilter>;
  isGroupPay?: InputMaybe<BoolFilter>;
  leader?: InputMaybe<UserWhereInput>;
  leaderId?: InputMaybe<IntFilter>;
  traineeEvents?: InputMaybe<TraineeEventListRelationFilter>;
};

export type TraineeEventGroupWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type TraineeEventListRelationFilter = {
  every?: InputMaybe<TraineeEventWhereInput>;
  none?: InputMaybe<TraineeEventWhereInput>;
  some?: InputMaybe<TraineeEventWhereInput>;
};

export type TraineeEventMaxAggregateOutputType = {
  __typename?: 'TraineeEventMaxAggregateOutputType';
  bookingStatusId?: Maybe<Scalars['Int']>;
  certificatePrice?: Maybe<Scalars['Decimal']>;
  couponId?: Maybe<Scalars['Int']>;
  couponeDiscount?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  ePaymentMethodId?: Maybe<Scalars['Int']>;
  eventDayId?: Maybe<Scalars['Int']>;
  eventId?: Maybe<Scalars['Int']>;
  groupId?: Maybe<Scalars['Int']>;
  hasBookedAllParts?: Maybe<Scalars['Boolean']>;
  howHeardAboutEventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  inviterId?: Maybe<Scalars['Int']>;
  isCertificateIssued?: Maybe<Scalars['Boolean']>;
  isFirstRegistration?: Maybe<Scalars['Boolean']>;
  isGroupRegistrant?: Maybe<Scalars['Boolean']>;
  isGuest?: Maybe<Scalars['Boolean']>;
  isIndividualPay?: Maybe<Scalars['Boolean']>;
  isLateRegistrant?: Maybe<Scalars['Boolean']>;
  isPackageBooking?: Maybe<Scalars['Boolean']>;
  isWorkshopRegistrant?: Maybe<Scalars['Boolean']>;
  methodOfDeliveryId?: Maybe<Scalars['Int']>;
  paymentNetworkId?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Decimal']>;
  registrantId?: Maybe<Scalars['String']>;
  registrantToken?: Maybe<Scalars['String']>;
  tax?: Maybe<Scalars['Decimal']>;
  totalToPay?: Maybe<Scalars['Decimal']>;
  traineeId?: Maybe<Scalars['Int']>;
  walletBalance?: Maybe<Scalars['Decimal']>;
  workshopPrice?: Maybe<Scalars['Decimal']>;
};

export type TraineeEventMaxOrderByAggregateInput = {
  bookingStatusId?: InputMaybe<SortOrder>;
  certificatePrice?: InputMaybe<SortOrder>;
  couponId?: InputMaybe<SortOrder>;
  couponeDiscount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  ePaymentMethodId?: InputMaybe<SortOrder>;
  eventDayId?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  groupId?: InputMaybe<SortOrder>;
  hasBookedAllParts?: InputMaybe<SortOrder>;
  howHeardAboutEventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inviterId?: InputMaybe<SortOrder>;
  isCertificateIssued?: InputMaybe<SortOrder>;
  isFirstRegistration?: InputMaybe<SortOrder>;
  isGroupRegistrant?: InputMaybe<SortOrder>;
  isGuest?: InputMaybe<SortOrder>;
  isIndividualPay?: InputMaybe<SortOrder>;
  isLateRegistrant?: InputMaybe<SortOrder>;
  isPackageBooking?: InputMaybe<SortOrder>;
  isWorkshopRegistrant?: InputMaybe<SortOrder>;
  methodOfDeliveryId?: InputMaybe<SortOrder>;
  paymentNetworkId?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  registrantId?: InputMaybe<SortOrder>;
  registrantToken?: InputMaybe<SortOrder>;
  tax?: InputMaybe<SortOrder>;
  totalToPay?: InputMaybe<SortOrder>;
  traineeId?: InputMaybe<SortOrder>;
  walletBalance?: InputMaybe<SortOrder>;
  workshopPrice?: InputMaybe<SortOrder>;
};

export type TraineeEventMinAggregateOutputType = {
  __typename?: 'TraineeEventMinAggregateOutputType';
  bookingStatusId?: Maybe<Scalars['Int']>;
  certificatePrice?: Maybe<Scalars['Decimal']>;
  couponId?: Maybe<Scalars['Int']>;
  couponeDiscount?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  ePaymentMethodId?: Maybe<Scalars['Int']>;
  eventDayId?: Maybe<Scalars['Int']>;
  eventId?: Maybe<Scalars['Int']>;
  groupId?: Maybe<Scalars['Int']>;
  hasBookedAllParts?: Maybe<Scalars['Boolean']>;
  howHeardAboutEventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  inviterId?: Maybe<Scalars['Int']>;
  isCertificateIssued?: Maybe<Scalars['Boolean']>;
  isFirstRegistration?: Maybe<Scalars['Boolean']>;
  isGroupRegistrant?: Maybe<Scalars['Boolean']>;
  isGuest?: Maybe<Scalars['Boolean']>;
  isIndividualPay?: Maybe<Scalars['Boolean']>;
  isLateRegistrant?: Maybe<Scalars['Boolean']>;
  isPackageBooking?: Maybe<Scalars['Boolean']>;
  isWorkshopRegistrant?: Maybe<Scalars['Boolean']>;
  methodOfDeliveryId?: Maybe<Scalars['Int']>;
  paymentNetworkId?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Decimal']>;
  registrantId?: Maybe<Scalars['String']>;
  registrantToken?: Maybe<Scalars['String']>;
  tax?: Maybe<Scalars['Decimal']>;
  totalToPay?: Maybe<Scalars['Decimal']>;
  traineeId?: Maybe<Scalars['Int']>;
  walletBalance?: Maybe<Scalars['Decimal']>;
  workshopPrice?: Maybe<Scalars['Decimal']>;
};

export type TraineeEventMinOrderByAggregateInput = {
  bookingStatusId?: InputMaybe<SortOrder>;
  certificatePrice?: InputMaybe<SortOrder>;
  couponId?: InputMaybe<SortOrder>;
  couponeDiscount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  ePaymentMethodId?: InputMaybe<SortOrder>;
  eventDayId?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  groupId?: InputMaybe<SortOrder>;
  hasBookedAllParts?: InputMaybe<SortOrder>;
  howHeardAboutEventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inviterId?: InputMaybe<SortOrder>;
  isCertificateIssued?: InputMaybe<SortOrder>;
  isFirstRegistration?: InputMaybe<SortOrder>;
  isGroupRegistrant?: InputMaybe<SortOrder>;
  isGuest?: InputMaybe<SortOrder>;
  isIndividualPay?: InputMaybe<SortOrder>;
  isLateRegistrant?: InputMaybe<SortOrder>;
  isPackageBooking?: InputMaybe<SortOrder>;
  isWorkshopRegistrant?: InputMaybe<SortOrder>;
  methodOfDeliveryId?: InputMaybe<SortOrder>;
  paymentNetworkId?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  registrantId?: InputMaybe<SortOrder>;
  registrantToken?: InputMaybe<SortOrder>;
  tax?: InputMaybe<SortOrder>;
  totalToPay?: InputMaybe<SortOrder>;
  traineeId?: InputMaybe<SortOrder>;
  walletBalance?: InputMaybe<SortOrder>;
  workshopPrice?: InputMaybe<SortOrder>;
};

export type TraineeEventModel = {
  __typename?: 'TraineeEventModel';
  bookingStatusId?: Maybe<Scalars['Int']>;
  trainee?: Maybe<TraineeModel>;
};

export type TraineeEventOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TraineeEventOrderByWithAggregationInput = {
  _avg?: InputMaybe<TraineeEventAvgOrderByAggregateInput>;
  _count?: InputMaybe<TraineeEventCountOrderByAggregateInput>;
  _max?: InputMaybe<TraineeEventMaxOrderByAggregateInput>;
  _min?: InputMaybe<TraineeEventMinOrderByAggregateInput>;
  _sum?: InputMaybe<TraineeEventSumOrderByAggregateInput>;
  bookingStatusId?: InputMaybe<SortOrder>;
  certificatePrice?: InputMaybe<SortOrder>;
  couponId?: InputMaybe<SortOrder>;
  couponeDiscount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  ePaymentMethodId?: InputMaybe<SortOrder>;
  emailState?: InputMaybe<SortOrder>;
  eventDayId?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  groupId?: InputMaybe<SortOrder>;
  hasBookedAllParts?: InputMaybe<SortOrder>;
  howHeardAboutEventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inviterId?: InputMaybe<SortOrder>;
  isCertificateIssued?: InputMaybe<SortOrder>;
  isFirstRegistration?: InputMaybe<SortOrder>;
  isGroupRegistrant?: InputMaybe<SortOrder>;
  isGuest?: InputMaybe<SortOrder>;
  isIndividualPay?: InputMaybe<SortOrder>;
  isLateRegistrant?: InputMaybe<SortOrder>;
  isPackageBooking?: InputMaybe<SortOrder>;
  isWorkshopRegistrant?: InputMaybe<SortOrder>;
  methodOfDeliveryId?: InputMaybe<SortOrder>;
  paymentNetworkId?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  registrantId?: InputMaybe<SortOrder>;
  registrantToken?: InputMaybe<SortOrder>;
  tax?: InputMaybe<SortOrder>;
  totalToPay?: InputMaybe<SortOrder>;
  traineeId?: InputMaybe<SortOrder>;
  walletBalance?: InputMaybe<SortOrder>;
  workshopPrice?: InputMaybe<SortOrder>;
};

export type TraineeEventOrderByWithRelationInput = {
  Certificate?: InputMaybe<CertificateOrderByWithRelationInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodOrderByWithRelationInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkOrderByWithRelationInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationOrderByRelationAggregateInput>;
  ZohoEmail?: InputMaybe<ZohoEmailOrderByRelationAggregateInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceOrderByRelationAggregateInput>;
  bookingStatus?: InputMaybe<BookingStatusOrderByWithRelationInput>;
  bookingStatusId?: InputMaybe<SortOrder>;
  certificatePrice?: InputMaybe<SortOrder>;
  coupon?: InputMaybe<CouponOrderByWithRelationInput>;
  couponId?: InputMaybe<SortOrder>;
  couponeDiscount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  ePaymentMethodId?: InputMaybe<SortOrder>;
  emailState?: InputMaybe<SortOrder>;
  event?: InputMaybe<EventOrderByWithRelationInput>;
  eventDay?: InputMaybe<EventDayOrderByWithRelationInput>;
  eventDayId?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  group?: InputMaybe<TraineeEventGroupOrderByWithRelationInput>;
  groupId?: InputMaybe<SortOrder>;
  hasBookedAllParts?: InputMaybe<SortOrder>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventOrderByWithRelationInput>;
  howHeardAboutEventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inviter?: InputMaybe<UserOrderByWithRelationInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitOrderByWithRelationInput>;
  inviterId?: InputMaybe<SortOrder>;
  isCertificateIssued?: InputMaybe<SortOrder>;
  isFirstRegistration?: InputMaybe<SortOrder>;
  isGroupRegistrant?: InputMaybe<SortOrder>;
  isGuest?: InputMaybe<SortOrder>;
  isIndividualPay?: InputMaybe<SortOrder>;
  isLateRegistrant?: InputMaybe<SortOrder>;
  isPackageBooking?: InputMaybe<SortOrder>;
  isWorkshopRegistrant?: InputMaybe<SortOrder>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryOrderByWithRelationInput>;
  methodOfDeliveryId?: InputMaybe<SortOrder>;
  parts?: InputMaybe<TraineeEventPartOrderByRelationAggregateInput>;
  paymentNetworkId?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  registrantId?: InputMaybe<SortOrder>;
  registrantToken?: InputMaybe<SortOrder>;
  review?: InputMaybe<TraineeEventReviewOrderByWithRelationInput>;
  tax?: InputMaybe<SortOrder>;
  totalToPay?: InputMaybe<SortOrder>;
  trainee?: InputMaybe<UserOrderByWithRelationInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceOrderByRelationAggregateInput>;
  traineeId?: InputMaybe<SortOrder>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewOrderByRelationAggregateInput>;
  transitions?: InputMaybe<TransitionOrderByRelationAggregateInput>;
  walletBalance?: InputMaybe<SortOrder>;
  workshopPrice?: InputMaybe<SortOrder>;
};

export type TraineeEventPart = {
  __typename?: 'TraineeEventPart';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  eventPart: EventPart;
  eventPartId: Scalars['Int'];
  id: Scalars['Int'];
  partTotalPrice: Scalars['Decimal'];
  traineeEvent: TraineeEvent;
  traineeEventId: Scalars['Int'];
};

export type TraineeEventPartAvgAggregateOutputType = {
  __typename?: 'TraineeEventPartAvgAggregateOutputType';
  eventPartId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  partTotalPrice?: Maybe<Scalars['Decimal']>;
  traineeEventId?: Maybe<Scalars['Float']>;
};

export type TraineeEventPartAvgOrderByAggregateInput = {
  eventPartId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  partTotalPrice?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
};

export type TraineeEventPartCountAggregateOutputType = {
  __typename?: 'TraineeEventPartCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  eventPartId: Scalars['Int'];
  id: Scalars['Int'];
  partTotalPrice: Scalars['Int'];
  traineeEventId: Scalars['Int'];
};

export type TraineeEventPartCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  eventPartId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  partTotalPrice?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
};

export type TraineeEventPartCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventPart: EventPartCreateNestedOneWithoutTraineesInput;
  partTotalPrice: Scalars['Decimal'];
  traineeEvent: TraineeEventCreateNestedOneWithoutPartsInput;
};

export type TraineeEventPartCreateManyEventPartInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  partTotalPrice: Scalars['Decimal'];
  traineeEventId: Scalars['Int'];
};

export type TraineeEventPartCreateManyEventPartInputEnvelope = {
  data: TraineeEventPartCreateManyEventPartInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TraineeEventPartCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventPartId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  partTotalPrice: Scalars['Decimal'];
  traineeEventId: Scalars['Int'];
};

export type TraineeEventPartCreateManyTraineeEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventPartId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  partTotalPrice: Scalars['Decimal'];
};

export type TraineeEventPartCreateManyTraineeEventInputEnvelope = {
  data: TraineeEventPartCreateManyTraineeEventInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TraineeEventPartCreateNestedManyWithoutEventPartInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventPartWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventPartCreateOrConnectWithoutEventPartInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventPartCreateWithoutEventPartInput>>>;
  createMany?: InputMaybe<TraineeEventPartCreateManyEventPartInputEnvelope>;
};

export type TraineeEventPartCreateNestedManyWithoutTraineeEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventPartWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventPartCreateOrConnectWithoutTraineeEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventPartCreateWithoutTraineeEventInput>>>;
  createMany?: InputMaybe<TraineeEventPartCreateManyTraineeEventInputEnvelope>;
};

export type TraineeEventPartCreateOrConnectWithoutEventPartInput = {
  create: TraineeEventPartUncheckedCreateWithoutEventPartInput;
  where: TraineeEventPartWhereUniqueInput;
};

export type TraineeEventPartCreateOrConnectWithoutTraineeEventInput = {
  create: TraineeEventPartUncheckedCreateWithoutTraineeEventInput;
  where: TraineeEventPartWhereUniqueInput;
};

export type TraineeEventPartCreateWithoutEventPartInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  partTotalPrice: Scalars['Decimal'];
  traineeEvent: TraineeEventCreateNestedOneWithoutPartsInput;
};

export type TraineeEventPartCreateWithoutTraineeEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventPart: EventPartCreateNestedOneWithoutTraineesInput;
  partTotalPrice: Scalars['Decimal'];
};

export type TraineeEventPartListRelationFilter = {
  every?: InputMaybe<TraineeEventPartWhereInput>;
  none?: InputMaybe<TraineeEventPartWhereInput>;
  some?: InputMaybe<TraineeEventPartWhereInput>;
};

export type TraineeEventPartMaxAggregateOutputType = {
  __typename?: 'TraineeEventPartMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  eventPartId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  partTotalPrice?: Maybe<Scalars['Decimal']>;
  traineeEventId?: Maybe<Scalars['Int']>;
};

export type TraineeEventPartMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  eventPartId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  partTotalPrice?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
};

export type TraineeEventPartMinAggregateOutputType = {
  __typename?: 'TraineeEventPartMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  eventPartId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  partTotalPrice?: Maybe<Scalars['Decimal']>;
  traineeEventId?: Maybe<Scalars['Int']>;
};

export type TraineeEventPartMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  eventPartId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  partTotalPrice?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
};

export type TraineeEventPartOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TraineeEventPartOrderByWithAggregationInput = {
  _avg?: InputMaybe<TraineeEventPartAvgOrderByAggregateInput>;
  _count?: InputMaybe<TraineeEventPartCountOrderByAggregateInput>;
  _max?: InputMaybe<TraineeEventPartMaxOrderByAggregateInput>;
  _min?: InputMaybe<TraineeEventPartMinOrderByAggregateInput>;
  _sum?: InputMaybe<TraineeEventPartSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  eventPartId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  partTotalPrice?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
};

export type TraineeEventPartOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  eventPart?: InputMaybe<EventPartOrderByWithRelationInput>;
  eventPartId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  partTotalPrice?: InputMaybe<SortOrder>;
  traineeEvent?: InputMaybe<TraineeEventOrderByWithRelationInput>;
  traineeEventId?: InputMaybe<SortOrder>;
};

export enum TraineeEventPartScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  EventPartId = 'eventPartId',
  Id = 'id',
  PartTotalPrice = 'partTotalPrice',
  TraineeEventId = 'traineeEventId'
}

export type TraineeEventPartScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TraineeEventPartScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TraineeEventPartScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TraineeEventPartScalarWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  eventPartId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  partTotalPrice?: InputMaybe<DecimalFilter>;
  traineeEventId?: InputMaybe<IntFilter>;
};

export type TraineeEventPartScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<TraineeEventPartScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TraineeEventPartScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TraineeEventPartScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  eventPartId?: InputMaybe<IntWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  partTotalPrice?: InputMaybe<DecimalWithAggregatesFilter>;
  traineeEventId?: InputMaybe<IntWithAggregatesFilter>;
};

export type TraineeEventPartSumAggregateOutputType = {
  __typename?: 'TraineeEventPartSumAggregateOutputType';
  eventPartId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  partTotalPrice?: Maybe<Scalars['Decimal']>;
  traineeEventId?: Maybe<Scalars['Int']>;
};

export type TraineeEventPartSumOrderByAggregateInput = {
  eventPartId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  partTotalPrice?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
};

export type TraineeEventPartUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventPartId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  partTotalPrice: Scalars['Decimal'];
  traineeEventId: Scalars['Int'];
};

export type TraineeEventPartUncheckedCreateNestedManyWithoutEventPartInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventPartWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventPartCreateOrConnectWithoutEventPartInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventPartCreateWithoutEventPartInput>>>;
  createMany?: InputMaybe<TraineeEventPartCreateManyEventPartInputEnvelope>;
};

export type TraineeEventPartUncheckedCreateNestedManyWithoutTraineeEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventPartWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventPartCreateOrConnectWithoutTraineeEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventPartCreateWithoutTraineeEventInput>>>;
  createMany?: InputMaybe<TraineeEventPartCreateManyTraineeEventInputEnvelope>;
};

export type TraineeEventPartUncheckedCreateWithoutEventPartInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  partTotalPrice: Scalars['Decimal'];
  traineeEventId: Scalars['Int'];
};

export type TraineeEventPartUncheckedCreateWithoutTraineeEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventPartId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  partTotalPrice: Scalars['Decimal'];
};

export type TraineeEventPartUncheckedUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventPartId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  partTotalPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TraineeEventPartUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventPartId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  partTotalPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TraineeEventPartUncheckedUpdateManyWithoutEventPartInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventPartWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventPartCreateOrConnectWithoutEventPartInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventPartCreateWithoutEventPartInput>>>;
  createMany?: InputMaybe<TraineeEventPartCreateManyEventPartInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventPartWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventPartScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventPartWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventPartWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventPartUpdateWithWhereUniqueWithoutEventPartInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventPartUpdateManyWithWhereWithoutEventPartInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventPartUpsertWithWhereUniqueWithoutEventPartInput>>>;
};

export type TraineeEventPartUncheckedUpdateManyWithoutPartsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventPartId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  partTotalPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
};

export type TraineeEventPartUncheckedUpdateManyWithoutTraineeEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventPartWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventPartCreateOrConnectWithoutTraineeEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventPartCreateWithoutTraineeEventInput>>>;
  createMany?: InputMaybe<TraineeEventPartCreateManyTraineeEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventPartWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventPartScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventPartWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventPartWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventPartUpdateWithWhereUniqueWithoutTraineeEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventPartUpdateManyWithWhereWithoutTraineeEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventPartUpsertWithWhereUniqueWithoutTraineeEventInput>>>;
};

export type TraineeEventPartUncheckedUpdateManyWithoutTraineesInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  partTotalPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TraineeEventPartUncheckedUpdateWithoutEventPartInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  partTotalPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TraineeEventPartUncheckedUpdateWithoutTraineeEventInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventPartId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  partTotalPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
};

export type TraineeEventPartUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventPart?: InputMaybe<EventPartUpdateOneRequiredWithoutTraineesInput>;
  partTotalPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEvent?: InputMaybe<TraineeEventUpdateOneRequiredWithoutPartsInput>;
};

export type TraineeEventPartUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  partTotalPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
};

export type TraineeEventPartUpdateManyWithWhereWithoutEventPartInput = {
  data: TraineeEventPartUncheckedUpdateManyWithoutTraineesInput;
  where: TraineeEventPartScalarWhereInput;
};

export type TraineeEventPartUpdateManyWithWhereWithoutTraineeEventInput = {
  data: TraineeEventPartUncheckedUpdateManyWithoutPartsInput;
  where: TraineeEventPartScalarWhereInput;
};

export type TraineeEventPartUpdateManyWithoutEventPartInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventPartWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventPartCreateOrConnectWithoutEventPartInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventPartCreateWithoutEventPartInput>>>;
  createMany?: InputMaybe<TraineeEventPartCreateManyEventPartInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventPartWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventPartScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventPartWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventPartWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventPartUpdateWithWhereUniqueWithoutEventPartInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventPartUpdateManyWithWhereWithoutEventPartInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventPartUpsertWithWhereUniqueWithoutEventPartInput>>>;
};

export type TraineeEventPartUpdateManyWithoutTraineeEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventPartWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventPartCreateOrConnectWithoutTraineeEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventPartCreateWithoutTraineeEventInput>>>;
  createMany?: InputMaybe<TraineeEventPartCreateManyTraineeEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventPartWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventPartScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventPartWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventPartWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventPartUpdateWithWhereUniqueWithoutTraineeEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventPartUpdateManyWithWhereWithoutTraineeEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventPartUpsertWithWhereUniqueWithoutTraineeEventInput>>>;
};

export type TraineeEventPartUpdateWithWhereUniqueWithoutEventPartInput = {
  data: TraineeEventPartUncheckedUpdateWithoutEventPartInput;
  where: TraineeEventPartWhereUniqueInput;
};

export type TraineeEventPartUpdateWithWhereUniqueWithoutTraineeEventInput = {
  data: TraineeEventPartUncheckedUpdateWithoutTraineeEventInput;
  where: TraineeEventPartWhereUniqueInput;
};

export type TraineeEventPartUpdateWithoutEventPartInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  partTotalPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEvent?: InputMaybe<TraineeEventUpdateOneRequiredWithoutPartsInput>;
};

export type TraineeEventPartUpdateWithoutTraineeEventInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventPart?: InputMaybe<EventPartUpdateOneRequiredWithoutTraineesInput>;
  partTotalPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
};

export type TraineeEventPartUpsertWithWhereUniqueWithoutEventPartInput = {
  create: TraineeEventPartUncheckedCreateWithoutEventPartInput;
  update: TraineeEventPartUncheckedUpdateWithoutEventPartInput;
  where: TraineeEventPartWhereUniqueInput;
};

export type TraineeEventPartUpsertWithWhereUniqueWithoutTraineeEventInput = {
  create: TraineeEventPartUncheckedCreateWithoutTraineeEventInput;
  update: TraineeEventPartUncheckedUpdateWithoutTraineeEventInput;
  where: TraineeEventPartWhereUniqueInput;
};

export type TraineeEventPartWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TraineeEventPartWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TraineeEventPartWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TraineeEventPartWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  eventPart?: InputMaybe<EventPartWhereInput>;
  eventPartId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  partTotalPrice?: InputMaybe<DecimalFilter>;
  traineeEvent?: InputMaybe<TraineeEventWhereInput>;
  traineeEventId?: InputMaybe<IntFilter>;
};

export type TraineeEventPartWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type TraineeEventRelationFilter = {
  is?: InputMaybe<TraineeEventWhereInput>;
  isNot?: InputMaybe<TraineeEventWhereInput>;
};

export type TraineeEventReview = {
  __typename?: 'TraineeEventReview';
  TraineeEvent: TraineeEvent;
  _count: TraineeEventReviewCountOutputType;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: Event;
  eventId: Scalars['Int'];
  id: Scalars['Int'];
  reviewOfFive: Scalars['Int'];
  traineeEventId: Scalars['Int'];
  traineeEventReviewChoices: Array<TraineeEventReviewChoice>;
  why?: Maybe<Scalars['String']>;
};


export type TraineeEventReviewTraineeEventReviewChoicesArgs = {
  cursor?: InputMaybe<TraineeEventReviewChoiceWhereUniqueInput>;
  distinct?: InputMaybe<TraineeEventReviewChoiceScalarFieldEnum>;
  orderBy?: InputMaybe<TraineeEventReviewChoiceOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeEventReviewChoiceWhereInput>;
};

export type TraineeEventReviewAvgAggregateOutputType = {
  __typename?: 'TraineeEventReviewAvgAggregateOutputType';
  eventId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  reviewOfFive?: Maybe<Scalars['Float']>;
  traineeEventId?: Maybe<Scalars['Float']>;
};

export type TraineeEventReviewAvgOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  reviewOfFive?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
};

export type TraineeEventReviewChoice = {
  __typename?: 'TraineeEventReviewChoice';
  _count: TraineeEventReviewChoiceCountOutputType;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  isGood: Scalars['Boolean'];
  reviews: Array<TraineeEventReview>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};


export type TraineeEventReviewChoiceReviewsArgs = {
  cursor?: InputMaybe<TraineeEventReviewWhereUniqueInput>;
  distinct?: InputMaybe<TraineeEventReviewScalarFieldEnum>;
  orderBy?: InputMaybe<TraineeEventReviewOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeEventReviewWhereInput>;
};

export type TraineeEventReviewChoiceAvgAggregateOutputType = {
  __typename?: 'TraineeEventReviewChoiceAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
};

export type TraineeEventReviewChoiceAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type TraineeEventReviewChoiceCountAggregateOutputType = {
  __typename?: 'TraineeEventReviewChoiceCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  isGood: Scalars['Int'];
  titleAr: Scalars['Int'];
  titleEn: Scalars['Int'];
};

export type TraineeEventReviewChoiceCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isGood?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type TraineeEventReviewChoiceCountOutputType = {
  __typename?: 'TraineeEventReviewChoiceCountOutputType';
  reviews: Scalars['Int'];
};

export type TraineeEventReviewChoiceCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  isGood: Scalars['Boolean'];
  reviews?: InputMaybe<TraineeEventReviewCreateNestedManyWithoutTraineeEventReviewChoicesInput>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type TraineeEventReviewChoiceCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  isGood: Scalars['Boolean'];
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type TraineeEventReviewChoiceCreateNestedManyWithoutReviewsInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceCreateOrConnectWithoutReviewsInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceCreateWithoutReviewsInput>>>;
};

export type TraineeEventReviewChoiceCreateOrConnectWithoutReviewsInput = {
  create: TraineeEventReviewChoiceUncheckedCreateWithoutReviewsInput;
  where: TraineeEventReviewChoiceWhereUniqueInput;
};

export type TraineeEventReviewChoiceCreateWithoutReviewsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  isGood: Scalars['Boolean'];
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type TraineeEventReviewChoiceListRelationFilter = {
  every?: InputMaybe<TraineeEventReviewChoiceWhereInput>;
  none?: InputMaybe<TraineeEventReviewChoiceWhereInput>;
  some?: InputMaybe<TraineeEventReviewChoiceWhereInput>;
};

export type TraineeEventReviewChoiceMaxAggregateOutputType = {
  __typename?: 'TraineeEventReviewChoiceMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isGood?: Maybe<Scalars['Boolean']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type TraineeEventReviewChoiceMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isGood?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type TraineeEventReviewChoiceMinAggregateOutputType = {
  __typename?: 'TraineeEventReviewChoiceMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isGood?: Maybe<Scalars['Boolean']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type TraineeEventReviewChoiceMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isGood?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type TraineeEventReviewChoiceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TraineeEventReviewChoiceOrderByWithAggregationInput = {
  _avg?: InputMaybe<TraineeEventReviewChoiceAvgOrderByAggregateInput>;
  _count?: InputMaybe<TraineeEventReviewChoiceCountOrderByAggregateInput>;
  _max?: InputMaybe<TraineeEventReviewChoiceMaxOrderByAggregateInput>;
  _min?: InputMaybe<TraineeEventReviewChoiceMinOrderByAggregateInput>;
  _sum?: InputMaybe<TraineeEventReviewChoiceSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isGood?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type TraineeEventReviewChoiceOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isGood?: InputMaybe<SortOrder>;
  reviews?: InputMaybe<TraineeEventReviewOrderByRelationAggregateInput>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export enum TraineeEventReviewChoiceScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  IsGood = 'isGood',
  TitleAr = 'titleAr',
  TitleEn = 'titleEn'
}

export type TraineeEventReviewChoiceScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceScalarWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  isGood?: InputMaybe<BoolFilter>;
  titleAr?: InputMaybe<StringFilter>;
  titleEn?: InputMaybe<StringFilter>;
};

export type TraineeEventReviewChoiceScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  isGood?: InputMaybe<BoolWithAggregatesFilter>;
  titleAr?: InputMaybe<StringWithAggregatesFilter>;
  titleEn?: InputMaybe<StringWithAggregatesFilter>;
};

export type TraineeEventReviewChoiceSumAggregateOutputType = {
  __typename?: 'TraineeEventReviewChoiceSumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
};

export type TraineeEventReviewChoiceSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type TraineeEventReviewChoiceUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  isGood: Scalars['Boolean'];
  reviews?: InputMaybe<TraineeEventReviewUncheckedCreateNestedManyWithoutTraineeEventReviewChoicesInput>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type TraineeEventReviewChoiceUncheckedCreateNestedManyWithoutReviewsInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceCreateOrConnectWithoutReviewsInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceCreateWithoutReviewsInput>>>;
};

export type TraineeEventReviewChoiceUncheckedCreateWithoutReviewsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  isGood: Scalars['Boolean'];
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type TraineeEventReviewChoiceUncheckedUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isGood?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviews?: InputMaybe<TraineeEventReviewUncheckedUpdateManyWithoutTraineeEventReviewChoicesInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TraineeEventReviewChoiceUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isGood?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TraineeEventReviewChoiceUncheckedUpdateManyWithoutReviewsInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceCreateOrConnectWithoutReviewsInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceCreateWithoutReviewsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceUpdateWithWhereUniqueWithoutReviewsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceUpdateManyWithWhereWithoutReviewsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceUpsertWithWhereUniqueWithoutReviewsInput>>>;
};

export type TraineeEventReviewChoiceUncheckedUpdateManyWithoutTraineeEventReviewChoicesInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isGood?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TraineeEventReviewChoiceUncheckedUpdateWithoutReviewsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isGood?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TraineeEventReviewChoiceUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  isGood?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviews?: InputMaybe<TraineeEventReviewUpdateManyWithoutTraineeEventReviewChoicesInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TraineeEventReviewChoiceUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  isGood?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TraineeEventReviewChoiceUpdateManyWithWhereWithoutReviewsInput = {
  data: TraineeEventReviewChoiceUncheckedUpdateManyWithoutTraineeEventReviewChoicesInput;
  where: TraineeEventReviewChoiceScalarWhereInput;
};

export type TraineeEventReviewChoiceUpdateManyWithoutReviewsInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceCreateOrConnectWithoutReviewsInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceCreateWithoutReviewsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceUpdateWithWhereUniqueWithoutReviewsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceUpdateManyWithWhereWithoutReviewsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceUpsertWithWhereUniqueWithoutReviewsInput>>>;
};

export type TraineeEventReviewChoiceUpdateWithWhereUniqueWithoutReviewsInput = {
  data: TraineeEventReviewChoiceUncheckedUpdateWithoutReviewsInput;
  where: TraineeEventReviewChoiceWhereUniqueInput;
};

export type TraineeEventReviewChoiceUpdateWithoutReviewsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  isGood?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TraineeEventReviewChoiceUpsertWithWhereUniqueWithoutReviewsInput = {
  create: TraineeEventReviewChoiceUncheckedCreateWithoutReviewsInput;
  update: TraineeEventReviewChoiceUncheckedUpdateWithoutReviewsInput;
  where: TraineeEventReviewChoiceWhereUniqueInput;
};

export type TraineeEventReviewChoiceWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TraineeEventReviewChoiceWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  isGood?: InputMaybe<BoolFilter>;
  reviews?: InputMaybe<TraineeEventReviewListRelationFilter>;
  titleAr?: InputMaybe<StringFilter>;
  titleEn?: InputMaybe<StringFilter>;
};

export type TraineeEventReviewChoiceWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type TraineeEventReviewCountAggregateOutputType = {
  __typename?: 'TraineeEventReviewCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  eventId: Scalars['Int'];
  id: Scalars['Int'];
  reviewOfFive: Scalars['Int'];
  traineeEventId: Scalars['Int'];
  why: Scalars['Int'];
};

export type TraineeEventReviewCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  reviewOfFive?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  why?: InputMaybe<SortOrder>;
};

export type TraineeEventReviewCountOutputType = {
  __typename?: 'TraineeEventReviewCountOutputType';
  traineeEventReviewChoices: Scalars['Int'];
};

export type TraineeEventReviewCreateInput = {
  TraineeEvent: TraineeEventCreateNestedOneWithoutReviewInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  event: EventCreateNestedOneWithoutTraineeEventReviewsInput;
  reviewOfFive: Scalars['Int'];
  traineeEventReviewChoices?: InputMaybe<TraineeEventReviewChoiceCreateNestedManyWithoutReviewsInput>;
  why?: InputMaybe<Scalars['String']>;
};

export type TraineeEventReviewCreateManyEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  reviewOfFive: Scalars['Int'];
  traineeEventId: Scalars['Int'];
  why?: InputMaybe<Scalars['String']>;
};

export type TraineeEventReviewCreateManyEventInputEnvelope = {
  data: TraineeEventReviewCreateManyEventInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TraineeEventReviewCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  reviewOfFive: Scalars['Int'];
  traineeEventId: Scalars['Int'];
  why?: InputMaybe<Scalars['String']>;
};

export type TraineeEventReviewCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventReviewWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventReviewCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventReviewCreateWithoutEventInput>>>;
  createMany?: InputMaybe<TraineeEventReviewCreateManyEventInputEnvelope>;
};

export type TraineeEventReviewCreateNestedManyWithoutTraineeEventReviewChoicesInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventReviewWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventReviewCreateOrConnectWithoutTraineeEventReviewChoicesInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventReviewCreateWithoutTraineeEventReviewChoicesInput>>>;
};

export type TraineeEventReviewCreateNestedOneWithoutTraineeEventInput = {
  connect?: InputMaybe<TraineeEventReviewWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TraineeEventReviewCreateOrConnectWithoutTraineeEventInput>;
  create?: InputMaybe<TraineeEventReviewUncheckedCreateWithoutTraineeEventInput>;
};

export type TraineeEventReviewCreateOrConnectWithoutEventInput = {
  create: TraineeEventReviewUncheckedCreateWithoutEventInput;
  where: TraineeEventReviewWhereUniqueInput;
};

export type TraineeEventReviewCreateOrConnectWithoutTraineeEventInput = {
  create: TraineeEventReviewUncheckedCreateWithoutTraineeEventInput;
  where: TraineeEventReviewWhereUniqueInput;
};

export type TraineeEventReviewCreateOrConnectWithoutTraineeEventReviewChoicesInput = {
  create: TraineeEventReviewUncheckedCreateWithoutTraineeEventReviewChoicesInput;
  where: TraineeEventReviewWhereUniqueInput;
};

export type TraineeEventReviewCreateWithoutEventInput = {
  TraineeEvent: TraineeEventCreateNestedOneWithoutReviewInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  reviewOfFive: Scalars['Int'];
  traineeEventReviewChoices?: InputMaybe<TraineeEventReviewChoiceCreateNestedManyWithoutReviewsInput>;
  why?: InputMaybe<Scalars['String']>;
};

export type TraineeEventReviewCreateWithoutTraineeEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  event: EventCreateNestedOneWithoutTraineeEventReviewsInput;
  reviewOfFive: Scalars['Int'];
  traineeEventReviewChoices?: InputMaybe<TraineeEventReviewChoiceCreateNestedManyWithoutReviewsInput>;
  why?: InputMaybe<Scalars['String']>;
};

export type TraineeEventReviewCreateWithoutTraineeEventReviewChoicesInput = {
  TraineeEvent: TraineeEventCreateNestedOneWithoutReviewInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  event: EventCreateNestedOneWithoutTraineeEventReviewsInput;
  reviewOfFive: Scalars['Int'];
  why?: InputMaybe<Scalars['String']>;
};

export type TraineeEventReviewListRelationFilter = {
  every?: InputMaybe<TraineeEventReviewWhereInput>;
  none?: InputMaybe<TraineeEventReviewWhereInput>;
  some?: InputMaybe<TraineeEventReviewWhereInput>;
};

export type TraineeEventReviewMaxAggregateOutputType = {
  __typename?: 'TraineeEventReviewMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  reviewOfFive?: Maybe<Scalars['Int']>;
  traineeEventId?: Maybe<Scalars['Int']>;
  why?: Maybe<Scalars['String']>;
};

export type TraineeEventReviewMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  reviewOfFive?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  why?: InputMaybe<SortOrder>;
};

export type TraineeEventReviewMinAggregateOutputType = {
  __typename?: 'TraineeEventReviewMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  reviewOfFive?: Maybe<Scalars['Int']>;
  traineeEventId?: Maybe<Scalars['Int']>;
  why?: Maybe<Scalars['String']>;
};

export type TraineeEventReviewMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  reviewOfFive?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  why?: InputMaybe<SortOrder>;
};

export type TraineeEventReviewOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TraineeEventReviewOrderByWithAggregationInput = {
  _avg?: InputMaybe<TraineeEventReviewAvgOrderByAggregateInput>;
  _count?: InputMaybe<TraineeEventReviewCountOrderByAggregateInput>;
  _max?: InputMaybe<TraineeEventReviewMaxOrderByAggregateInput>;
  _min?: InputMaybe<TraineeEventReviewMinOrderByAggregateInput>;
  _sum?: InputMaybe<TraineeEventReviewSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  reviewOfFive?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  why?: InputMaybe<SortOrder>;
};

export type TraineeEventReviewOrderByWithRelationInput = {
  TraineeEvent?: InputMaybe<TraineeEventOrderByWithRelationInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  event?: InputMaybe<EventOrderByWithRelationInput>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  reviewOfFive?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  traineeEventReviewChoices?: InputMaybe<TraineeEventReviewChoiceOrderByRelationAggregateInput>;
  why?: InputMaybe<SortOrder>;
};

export type TraineeEventReviewRelationFilter = {
  is?: InputMaybe<TraineeEventReviewWhereInput>;
  isNot?: InputMaybe<TraineeEventReviewWhereInput>;
};

export enum TraineeEventReviewScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  EventId = 'eventId',
  Id = 'id',
  ReviewOfFive = 'reviewOfFive',
  TraineeEventId = 'traineeEventId',
  Why = 'why'
}

export type TraineeEventReviewScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TraineeEventReviewScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TraineeEventReviewScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TraineeEventReviewScalarWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  eventId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  reviewOfFive?: InputMaybe<IntFilter>;
  traineeEventId?: InputMaybe<IntFilter>;
  why?: InputMaybe<StringNullableFilter>;
};

export type TraineeEventReviewScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<TraineeEventReviewScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TraineeEventReviewScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TraineeEventReviewScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  eventId?: InputMaybe<IntWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  reviewOfFive?: InputMaybe<IntWithAggregatesFilter>;
  traineeEventId?: InputMaybe<IntWithAggregatesFilter>;
  why?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type TraineeEventReviewSumAggregateOutputType = {
  __typename?: 'TraineeEventReviewSumAggregateOutputType';
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  reviewOfFive?: Maybe<Scalars['Int']>;
  traineeEventId?: Maybe<Scalars['Int']>;
};

export type TraineeEventReviewSumOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  reviewOfFive?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
};

export type TraineeEventReviewUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  reviewOfFive: Scalars['Int'];
  traineeEventId: Scalars['Int'];
  traineeEventReviewChoices?: InputMaybe<TraineeEventReviewChoiceUncheckedCreateNestedManyWithoutReviewsInput>;
  why?: InputMaybe<Scalars['String']>;
};

export type TraineeEventReviewUncheckedCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventReviewWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventReviewCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventReviewCreateWithoutEventInput>>>;
  createMany?: InputMaybe<TraineeEventReviewCreateManyEventInputEnvelope>;
};

export type TraineeEventReviewUncheckedCreateNestedManyWithoutTraineeEventReviewChoicesInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventReviewWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventReviewCreateOrConnectWithoutTraineeEventReviewChoicesInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventReviewCreateWithoutTraineeEventReviewChoicesInput>>>;
};

export type TraineeEventReviewUncheckedCreateNestedOneWithoutTraineeEventInput = {
  connect?: InputMaybe<TraineeEventReviewWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TraineeEventReviewCreateOrConnectWithoutTraineeEventInput>;
  create?: InputMaybe<TraineeEventReviewUncheckedCreateWithoutTraineeEventInput>;
};

export type TraineeEventReviewUncheckedCreateWithoutEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  reviewOfFive: Scalars['Int'];
  traineeEventId: Scalars['Int'];
  traineeEventReviewChoices?: InputMaybe<TraineeEventReviewChoiceUncheckedCreateNestedManyWithoutReviewsInput>;
  why?: InputMaybe<Scalars['String']>;
};

export type TraineeEventReviewUncheckedCreateWithoutTraineeEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  reviewOfFive: Scalars['Int'];
  traineeEventReviewChoices?: InputMaybe<TraineeEventReviewChoiceUncheckedCreateNestedManyWithoutReviewsInput>;
  why?: InputMaybe<Scalars['String']>;
};

export type TraineeEventReviewUncheckedCreateWithoutTraineeEventReviewChoicesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  reviewOfFive: Scalars['Int'];
  traineeEventId: Scalars['Int'];
  why?: InputMaybe<Scalars['String']>;
};

export type TraineeEventReviewUncheckedUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  reviewOfFive?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeEventReviewChoices?: InputMaybe<TraineeEventReviewChoiceUncheckedUpdateManyWithoutReviewsInput>;
  why?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeEventReviewUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  reviewOfFive?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  why?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeEventReviewUncheckedUpdateManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventReviewWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventReviewCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventReviewCreateWithoutEventInput>>>;
  createMany?: InputMaybe<TraineeEventReviewCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventReviewWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventReviewScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventReviewWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventReviewWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventReviewUpdateWithWhereUniqueWithoutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventReviewUpdateManyWithWhereWithoutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventReviewUpsertWithWhereUniqueWithoutEventInput>>>;
};

export type TraineeEventReviewUncheckedUpdateManyWithoutReviewsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  reviewOfFive?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  why?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeEventReviewUncheckedUpdateManyWithoutTraineeEventReviewChoicesInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventReviewWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventReviewCreateOrConnectWithoutTraineeEventReviewChoicesInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventReviewCreateWithoutTraineeEventReviewChoicesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventReviewWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventReviewScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventReviewWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventReviewWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventReviewUpdateWithWhereUniqueWithoutTraineeEventReviewChoicesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventReviewUpdateManyWithWhereWithoutTraineeEventReviewChoicesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventReviewUpsertWithWhereUniqueWithoutTraineeEventReviewChoicesInput>>>;
};

export type TraineeEventReviewUncheckedUpdateManyWithoutTraineeEventReviewsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  reviewOfFive?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  why?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeEventReviewUncheckedUpdateOneWithoutTraineeEventInput = {
  connect?: InputMaybe<TraineeEventReviewWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TraineeEventReviewCreateOrConnectWithoutTraineeEventInput>;
  create?: InputMaybe<TraineeEventReviewUncheckedCreateWithoutTraineeEventInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<TraineeEventReviewUncheckedUpdateWithoutTraineeEventInput>;
  upsert?: InputMaybe<TraineeEventReviewUpsertWithoutTraineeEventInput>;
};

export type TraineeEventReviewUncheckedUpdateWithoutEventInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  reviewOfFive?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeEventReviewChoices?: InputMaybe<TraineeEventReviewChoiceUncheckedUpdateManyWithoutReviewsInput>;
  why?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeEventReviewUncheckedUpdateWithoutTraineeEventInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  reviewOfFive?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeEventReviewChoices?: InputMaybe<TraineeEventReviewChoiceUncheckedUpdateManyWithoutReviewsInput>;
  why?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeEventReviewUncheckedUpdateWithoutTraineeEventReviewChoicesInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  reviewOfFive?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  why?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeEventReviewUpdateInput = {
  TraineeEvent?: InputMaybe<TraineeEventUpdateOneRequiredWithoutReviewInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTraineeEventReviewsInput>;
  reviewOfFive?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeEventReviewChoices?: InputMaybe<TraineeEventReviewChoiceUpdateManyWithoutReviewsInput>;
  why?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeEventReviewUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reviewOfFive?: InputMaybe<IntFieldUpdateOperationsInput>;
  why?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeEventReviewUpdateManyWithWhereWithoutEventInput = {
  data: TraineeEventReviewUncheckedUpdateManyWithoutTraineeEventReviewsInput;
  where: TraineeEventReviewScalarWhereInput;
};

export type TraineeEventReviewUpdateManyWithWhereWithoutTraineeEventReviewChoicesInput = {
  data: TraineeEventReviewUncheckedUpdateManyWithoutReviewsInput;
  where: TraineeEventReviewScalarWhereInput;
};

export type TraineeEventReviewUpdateManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventReviewWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventReviewCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventReviewCreateWithoutEventInput>>>;
  createMany?: InputMaybe<TraineeEventReviewCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventReviewWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventReviewScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventReviewWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventReviewWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventReviewUpdateWithWhereUniqueWithoutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventReviewUpdateManyWithWhereWithoutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventReviewUpsertWithWhereUniqueWithoutEventInput>>>;
};

export type TraineeEventReviewUpdateManyWithoutTraineeEventReviewChoicesInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventReviewWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventReviewCreateOrConnectWithoutTraineeEventReviewChoicesInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventReviewCreateWithoutTraineeEventReviewChoicesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventReviewWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventReviewScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventReviewWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventReviewWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventReviewUpdateWithWhereUniqueWithoutTraineeEventReviewChoicesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventReviewUpdateManyWithWhereWithoutTraineeEventReviewChoicesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventReviewUpsertWithWhereUniqueWithoutTraineeEventReviewChoicesInput>>>;
};

export type TraineeEventReviewUpdateOneWithoutTraineeEventInput = {
  connect?: InputMaybe<TraineeEventReviewWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TraineeEventReviewCreateOrConnectWithoutTraineeEventInput>;
  create?: InputMaybe<TraineeEventReviewUncheckedCreateWithoutTraineeEventInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<TraineeEventReviewUncheckedUpdateWithoutTraineeEventInput>;
  upsert?: InputMaybe<TraineeEventReviewUpsertWithoutTraineeEventInput>;
};

export type TraineeEventReviewUpdateWithWhereUniqueWithoutEventInput = {
  data: TraineeEventReviewUncheckedUpdateWithoutEventInput;
  where: TraineeEventReviewWhereUniqueInput;
};

export type TraineeEventReviewUpdateWithWhereUniqueWithoutTraineeEventReviewChoicesInput = {
  data: TraineeEventReviewUncheckedUpdateWithoutTraineeEventReviewChoicesInput;
  where: TraineeEventReviewWhereUniqueInput;
};

export type TraineeEventReviewUpdateWithoutEventInput = {
  TraineeEvent?: InputMaybe<TraineeEventUpdateOneRequiredWithoutReviewInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reviewOfFive?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeEventReviewChoices?: InputMaybe<TraineeEventReviewChoiceUpdateManyWithoutReviewsInput>;
  why?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeEventReviewUpdateWithoutTraineeEventInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTraineeEventReviewsInput>;
  reviewOfFive?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeEventReviewChoices?: InputMaybe<TraineeEventReviewChoiceUpdateManyWithoutReviewsInput>;
  why?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeEventReviewUpdateWithoutTraineeEventReviewChoicesInput = {
  TraineeEvent?: InputMaybe<TraineeEventUpdateOneRequiredWithoutReviewInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTraineeEventReviewsInput>;
  reviewOfFive?: InputMaybe<IntFieldUpdateOperationsInput>;
  why?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeEventReviewUpsertWithWhereUniqueWithoutEventInput = {
  create: TraineeEventReviewUncheckedCreateWithoutEventInput;
  update: TraineeEventReviewUncheckedUpdateWithoutEventInput;
  where: TraineeEventReviewWhereUniqueInput;
};

export type TraineeEventReviewUpsertWithWhereUniqueWithoutTraineeEventReviewChoicesInput = {
  create: TraineeEventReviewUncheckedCreateWithoutTraineeEventReviewChoicesInput;
  update: TraineeEventReviewUncheckedUpdateWithoutTraineeEventReviewChoicesInput;
  where: TraineeEventReviewWhereUniqueInput;
};

export type TraineeEventReviewUpsertWithoutTraineeEventInput = {
  create: TraineeEventReviewUncheckedCreateWithoutTraineeEventInput;
  update: TraineeEventReviewUncheckedUpdateWithoutTraineeEventInput;
};

export type TraineeEventReviewWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TraineeEventReviewWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TraineeEventReviewWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TraineeEventReviewWhereInput>>>;
  TraineeEvent?: InputMaybe<TraineeEventWhereInput>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  event?: InputMaybe<EventWhereInput>;
  eventId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  reviewOfFive?: InputMaybe<IntFilter>;
  traineeEventId?: InputMaybe<IntFilter>;
  traineeEventReviewChoices?: InputMaybe<TraineeEventReviewChoiceListRelationFilter>;
  why?: InputMaybe<StringNullableFilter>;
};

export type TraineeEventReviewWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
};

export enum TraineeEventScalarFieldEnum {
  BookingStatusId = 'bookingStatusId',
  CertificatePrice = 'certificatePrice',
  CouponId = 'couponId',
  CouponeDiscount = 'couponeDiscount',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  EPaymentMethodId = 'ePaymentMethodId',
  EmailState = 'emailState',
  EventDayId = 'eventDayId',
  EventId = 'eventId',
  GroupId = 'groupId',
  HasBookedAllParts = 'hasBookedAllParts',
  HowHeardAboutEventId = 'howHeardAboutEventId',
  Id = 'id',
  InviterId = 'inviterId',
  IsCertificateIssued = 'isCertificateIssued',
  IsFirstRegistration = 'isFirstRegistration',
  IsGroupRegistrant = 'isGroupRegistrant',
  IsGuest = 'isGuest',
  IsIndividualPay = 'isIndividualPay',
  IsLateRegistrant = 'isLateRegistrant',
  IsPackageBooking = 'isPackageBooking',
  IsWorkshopRegistrant = 'isWorkshopRegistrant',
  MethodOfDeliveryId = 'methodOfDeliveryId',
  PaymentNetworkId = 'paymentNetworkId',
  Price = 'price',
  RegistrantId = 'registrantId',
  RegistrantToken = 'registrantToken',
  Tax = 'tax',
  TotalToPay = 'totalToPay',
  TraineeId = 'traineeId',
  WalletBalance = 'walletBalance',
  WorkshopPrice = 'workshopPrice'
}

export type TraineeEventScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TraineeEventScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TraineeEventScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TraineeEventScalarWhereInput>>>;
  bookingStatusId?: InputMaybe<IntNullableFilter>;
  certificatePrice?: InputMaybe<DecimalNullableFilter>;
  couponId?: InputMaybe<IntNullableFilter>;
  couponeDiscount?: InputMaybe<DecimalNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  ePaymentMethodId?: InputMaybe<IntNullableFilter>;
  emailState?: InputMaybe<JsonNullableFilter>;
  eventDayId?: InputMaybe<IntNullableFilter>;
  eventId?: InputMaybe<IntFilter>;
  groupId?: InputMaybe<IntNullableFilter>;
  hasBookedAllParts?: InputMaybe<BoolNullableFilter>;
  howHeardAboutEventId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  inviterId?: InputMaybe<IntNullableFilter>;
  isCertificateIssued?: InputMaybe<BoolFilter>;
  isFirstRegistration?: InputMaybe<BoolNullableFilter>;
  isGroupRegistrant?: InputMaybe<BoolFilter>;
  isGuest?: InputMaybe<BoolNullableFilter>;
  isIndividualPay?: InputMaybe<BoolNullableFilter>;
  isLateRegistrant?: InputMaybe<BoolFilter>;
  isPackageBooking?: InputMaybe<BoolNullableFilter>;
  isWorkshopRegistrant?: InputMaybe<BoolFilter>;
  methodOfDeliveryId?: InputMaybe<IntNullableFilter>;
  paymentNetworkId?: InputMaybe<IntNullableFilter>;
  price?: InputMaybe<DecimalFilter>;
  registrantId?: InputMaybe<StringNullableFilter>;
  registrantToken?: InputMaybe<StringNullableFilter>;
  tax?: InputMaybe<DecimalFilter>;
  totalToPay?: InputMaybe<DecimalFilter>;
  traineeId?: InputMaybe<IntFilter>;
  walletBalance?: InputMaybe<DecimalNullableFilter>;
  workshopPrice?: InputMaybe<DecimalNullableFilter>;
};

export type TraineeEventScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<TraineeEventScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TraineeEventScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TraineeEventScalarWhereWithAggregatesInput>>>;
  bookingStatusId?: InputMaybe<IntNullableWithAggregatesFilter>;
  certificatePrice?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  couponId?: InputMaybe<IntNullableWithAggregatesFilter>;
  couponeDiscount?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  ePaymentMethodId?: InputMaybe<IntNullableWithAggregatesFilter>;
  emailState?: InputMaybe<JsonNullableWithAggregatesFilter>;
  eventDayId?: InputMaybe<IntNullableWithAggregatesFilter>;
  eventId?: InputMaybe<IntWithAggregatesFilter>;
  groupId?: InputMaybe<IntNullableWithAggregatesFilter>;
  hasBookedAllParts?: InputMaybe<BoolNullableWithAggregatesFilter>;
  howHeardAboutEventId?: InputMaybe<IntNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  inviterId?: InputMaybe<IntNullableWithAggregatesFilter>;
  isCertificateIssued?: InputMaybe<BoolWithAggregatesFilter>;
  isFirstRegistration?: InputMaybe<BoolNullableWithAggregatesFilter>;
  isGroupRegistrant?: InputMaybe<BoolWithAggregatesFilter>;
  isGuest?: InputMaybe<BoolNullableWithAggregatesFilter>;
  isIndividualPay?: InputMaybe<BoolNullableWithAggregatesFilter>;
  isLateRegistrant?: InputMaybe<BoolWithAggregatesFilter>;
  isPackageBooking?: InputMaybe<BoolNullableWithAggregatesFilter>;
  isWorkshopRegistrant?: InputMaybe<BoolWithAggregatesFilter>;
  methodOfDeliveryId?: InputMaybe<IntNullableWithAggregatesFilter>;
  paymentNetworkId?: InputMaybe<IntNullableWithAggregatesFilter>;
  price?: InputMaybe<DecimalWithAggregatesFilter>;
  registrantId?: InputMaybe<StringNullableWithAggregatesFilter>;
  registrantToken?: InputMaybe<StringNullableWithAggregatesFilter>;
  tax?: InputMaybe<DecimalWithAggregatesFilter>;
  totalToPay?: InputMaybe<DecimalWithAggregatesFilter>;
  traineeId?: InputMaybe<IntWithAggregatesFilter>;
  walletBalance?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  workshopPrice?: InputMaybe<DecimalNullableWithAggregatesFilter>;
};

export type TraineeEventStudyMaterialAttendance = {
  __typename?: 'TraineeEventStudyMaterialAttendance';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  progressPercentage?: Maybe<Scalars['Decimal']>;
  traineeEvent: TraineeEvent;
  traineeEventId: Scalars['Int'];
  trainerEventStudyMaterial: TrainerEventStudyMaterial;
  trainerEventStudyMaterialId: Scalars['Int'];
};

export type TraineeEventStudyMaterialAttendanceAvgAggregateOutputType = {
  __typename?: 'TraineeEventStudyMaterialAttendanceAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
  progressPercentage?: Maybe<Scalars['Decimal']>;
  traineeEventId?: Maybe<Scalars['Float']>;
  trainerEventStudyMaterialId?: Maybe<Scalars['Float']>;
};

export type TraineeEventStudyMaterialAttendanceAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  progressPercentage?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  trainerEventStudyMaterialId?: InputMaybe<SortOrder>;
};

export type TraineeEventStudyMaterialAttendanceCountAggregateOutputType = {
  __typename?: 'TraineeEventStudyMaterialAttendanceCountAggregateOutputType';
  _all: Scalars['Int'];
  id: Scalars['Int'];
  progressPercentage: Scalars['Int'];
  traineeEventId: Scalars['Int'];
  trainerEventStudyMaterialId: Scalars['Int'];
};

export type TraineeEventStudyMaterialAttendanceCountOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  progressPercentage?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  trainerEventStudyMaterialId?: InputMaybe<SortOrder>;
};

export type TraineeEventStudyMaterialAttendanceCreateInput = {
  progressPercentage?: InputMaybe<Scalars['Decimal']>;
  traineeEvent?: InputMaybe<TraineeEventCreateNestedOneWithoutTraineeEventStudyMaterialAttendanceInput>;
  trainerEventStudyMaterial: TrainerEventStudyMaterialCreateNestedOneWithoutTraineeEventStudyMaterialAttendanceInput;
};

export type TraineeEventStudyMaterialAttendanceCreateManyInput = {
  id?: InputMaybe<Scalars['Int']>;
  progressPercentage?: InputMaybe<Scalars['Decimal']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialId: Scalars['Int'];
};

export type TraineeEventStudyMaterialAttendanceCreateManyTraineeEventInput = {
  id?: InputMaybe<Scalars['Int']>;
  progressPercentage?: InputMaybe<Scalars['Decimal']>;
  trainerEventStudyMaterialId: Scalars['Int'];
};

export type TraineeEventStudyMaterialAttendanceCreateManyTraineeEventInputEnvelope = {
  data: TraineeEventStudyMaterialAttendanceCreateManyTraineeEventInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TraineeEventStudyMaterialAttendanceCreateManyTrainerEventStudyMaterialInput = {
  id?: InputMaybe<Scalars['Int']>;
  progressPercentage?: InputMaybe<Scalars['Decimal']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
};

export type TraineeEventStudyMaterialAttendanceCreateManyTrainerEventStudyMaterialInputEnvelope = {
  data: TraineeEventStudyMaterialAttendanceCreateManyTrainerEventStudyMaterialInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TraineeEventStudyMaterialAttendanceCreateNestedManyWithoutTraineeEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceCreateOrConnectWithoutTraineeEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceCreateWithoutTraineeEventInput>>>;
  createMany?: InputMaybe<TraineeEventStudyMaterialAttendanceCreateManyTraineeEventInputEnvelope>;
};

export type TraineeEventStudyMaterialAttendanceCreateNestedManyWithoutTrainerEventStudyMaterialInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceCreateOrConnectWithoutTrainerEventStudyMaterialInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceCreateWithoutTrainerEventStudyMaterialInput>>>;
  createMany?: InputMaybe<TraineeEventStudyMaterialAttendanceCreateManyTrainerEventStudyMaterialInputEnvelope>;
};

export type TraineeEventStudyMaterialAttendanceCreateOrConnectWithoutTraineeEventInput = {
  create: TraineeEventStudyMaterialAttendanceUncheckedCreateWithoutTraineeEventInput;
  where: TraineeEventStudyMaterialAttendanceWhereUniqueInput;
};

export type TraineeEventStudyMaterialAttendanceCreateOrConnectWithoutTrainerEventStudyMaterialInput = {
  create: TraineeEventStudyMaterialAttendanceUncheckedCreateWithoutTrainerEventStudyMaterialInput;
  where: TraineeEventStudyMaterialAttendanceWhereUniqueInput;
};

export type TraineeEventStudyMaterialAttendanceCreateWithoutTraineeEventInput = {
  progressPercentage?: InputMaybe<Scalars['Decimal']>;
  trainerEventStudyMaterial: TrainerEventStudyMaterialCreateNestedOneWithoutTraineeEventStudyMaterialAttendanceInput;
};

export type TraineeEventStudyMaterialAttendanceCreateWithoutTrainerEventStudyMaterialInput = {
  progressPercentage?: InputMaybe<Scalars['Decimal']>;
  traineeEvent?: InputMaybe<TraineeEventCreateNestedOneWithoutTraineeEventStudyMaterialAttendanceInput>;
};

export type TraineeEventStudyMaterialAttendanceListRelationFilter = {
  every?: InputMaybe<TraineeEventStudyMaterialAttendanceWhereInput>;
  none?: InputMaybe<TraineeEventStudyMaterialAttendanceWhereInput>;
  some?: InputMaybe<TraineeEventStudyMaterialAttendanceWhereInput>;
};

export type TraineeEventStudyMaterialAttendanceMaxAggregateOutputType = {
  __typename?: 'TraineeEventStudyMaterialAttendanceMaxAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
  progressPercentage?: Maybe<Scalars['Decimal']>;
  traineeEventId?: Maybe<Scalars['Int']>;
  trainerEventStudyMaterialId?: Maybe<Scalars['Int']>;
};

export type TraineeEventStudyMaterialAttendanceMaxOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  progressPercentage?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  trainerEventStudyMaterialId?: InputMaybe<SortOrder>;
};

export type TraineeEventStudyMaterialAttendanceMinAggregateOutputType = {
  __typename?: 'TraineeEventStudyMaterialAttendanceMinAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
  progressPercentage?: Maybe<Scalars['Decimal']>;
  traineeEventId?: Maybe<Scalars['Int']>;
  trainerEventStudyMaterialId?: Maybe<Scalars['Int']>;
};

export type TraineeEventStudyMaterialAttendanceMinOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  progressPercentage?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  trainerEventStudyMaterialId?: InputMaybe<SortOrder>;
};

export type TraineeEventStudyMaterialAttendanceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TraineeEventStudyMaterialAttendanceOrderByWithAggregationInput = {
  _avg?: InputMaybe<TraineeEventStudyMaterialAttendanceAvgOrderByAggregateInput>;
  _count?: InputMaybe<TraineeEventStudyMaterialAttendanceCountOrderByAggregateInput>;
  _max?: InputMaybe<TraineeEventStudyMaterialAttendanceMaxOrderByAggregateInput>;
  _min?: InputMaybe<TraineeEventStudyMaterialAttendanceMinOrderByAggregateInput>;
  _sum?: InputMaybe<TraineeEventStudyMaterialAttendanceSumOrderByAggregateInput>;
  id?: InputMaybe<SortOrder>;
  progressPercentage?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  trainerEventStudyMaterialId?: InputMaybe<SortOrder>;
};

export type TraineeEventStudyMaterialAttendanceOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  progressPercentage?: InputMaybe<SortOrder>;
  traineeEvent?: InputMaybe<TraineeEventOrderByWithRelationInput>;
  traineeEventId?: InputMaybe<SortOrder>;
  trainerEventStudyMaterial?: InputMaybe<TrainerEventStudyMaterialOrderByWithRelationInput>;
  trainerEventStudyMaterialId?: InputMaybe<SortOrder>;
};

export enum TraineeEventStudyMaterialAttendanceScalarFieldEnum {
  Id = 'id',
  ProgressPercentage = 'progressPercentage',
  TraineeEventId = 'traineeEventId',
  TrainerEventStudyMaterialId = 'trainerEventStudyMaterialId'
}

export type TraineeEventStudyMaterialAttendanceScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceScalarWhereInput>>>;
  id?: InputMaybe<IntFilter>;
  progressPercentage?: InputMaybe<DecimalFilter>;
  traineeEventId?: InputMaybe<IntNullableFilter>;
  trainerEventStudyMaterialId?: InputMaybe<IntFilter>;
};

export type TraineeEventStudyMaterialAttendanceScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceScalarWhereWithAggregatesInput>>>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  progressPercentage?: InputMaybe<DecimalWithAggregatesFilter>;
  traineeEventId?: InputMaybe<IntNullableWithAggregatesFilter>;
  trainerEventStudyMaterialId?: InputMaybe<IntWithAggregatesFilter>;
};

export type TraineeEventStudyMaterialAttendanceSumAggregateOutputType = {
  __typename?: 'TraineeEventStudyMaterialAttendanceSumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
  progressPercentage?: Maybe<Scalars['Decimal']>;
  traineeEventId?: Maybe<Scalars['Int']>;
  trainerEventStudyMaterialId?: Maybe<Scalars['Int']>;
};

export type TraineeEventStudyMaterialAttendanceSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  progressPercentage?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  trainerEventStudyMaterialId?: InputMaybe<SortOrder>;
};

export type TraineeEventStudyMaterialAttendanceTraineeEventIdTrainerEventStudyMaterialIdCompoundUniqueInput = {
  traineeEventId: Scalars['Int'];
  trainerEventStudyMaterialId: Scalars['Int'];
};

export type TraineeEventStudyMaterialAttendanceUncheckedCreateInput = {
  id?: InputMaybe<Scalars['Int']>;
  progressPercentage?: InputMaybe<Scalars['Decimal']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialId: Scalars['Int'];
};

export type TraineeEventStudyMaterialAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceCreateOrConnectWithoutTraineeEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceCreateWithoutTraineeEventInput>>>;
  createMany?: InputMaybe<TraineeEventStudyMaterialAttendanceCreateManyTraineeEventInputEnvelope>;
};

export type TraineeEventStudyMaterialAttendanceUncheckedCreateNestedManyWithoutTrainerEventStudyMaterialInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceCreateOrConnectWithoutTrainerEventStudyMaterialInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceCreateWithoutTrainerEventStudyMaterialInput>>>;
  createMany?: InputMaybe<TraineeEventStudyMaterialAttendanceCreateManyTrainerEventStudyMaterialInputEnvelope>;
};

export type TraineeEventStudyMaterialAttendanceUncheckedCreateWithoutTraineeEventInput = {
  id?: InputMaybe<Scalars['Int']>;
  progressPercentage?: InputMaybe<Scalars['Decimal']>;
  trainerEventStudyMaterialId: Scalars['Int'];
};

export type TraineeEventStudyMaterialAttendanceUncheckedCreateWithoutTrainerEventStudyMaterialInput = {
  id?: InputMaybe<Scalars['Int']>;
  progressPercentage?: InputMaybe<Scalars['Decimal']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
};

export type TraineeEventStudyMaterialAttendanceUncheckedUpdateInput = {
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  progressPercentage?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TraineeEventStudyMaterialAttendanceUncheckedUpdateManyInput = {
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  progressPercentage?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TraineeEventStudyMaterialAttendanceUncheckedUpdateManyWithoutTraineeEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceCreateOrConnectWithoutTraineeEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceCreateWithoutTraineeEventInput>>>;
  createMany?: InputMaybe<TraineeEventStudyMaterialAttendanceCreateManyTraineeEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceUpdateWithWhereUniqueWithoutTraineeEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceUpdateManyWithWhereWithoutTraineeEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceUpsertWithWhereUniqueWithoutTraineeEventInput>>>;
};

export type TraineeEventStudyMaterialAttendanceUncheckedUpdateManyWithoutTraineeEventStudyMaterialAttendanceInput = {
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  progressPercentage?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  trainerEventStudyMaterialId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TraineeEventStudyMaterialAttendanceUncheckedUpdateManyWithoutTrainerEventStudyMaterialInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceCreateOrConnectWithoutTrainerEventStudyMaterialInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceCreateWithoutTrainerEventStudyMaterialInput>>>;
  createMany?: InputMaybe<TraineeEventStudyMaterialAttendanceCreateManyTrainerEventStudyMaterialInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceUpdateWithWhereUniqueWithoutTrainerEventStudyMaterialInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceUpdateManyWithWhereWithoutTrainerEventStudyMaterialInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceUpsertWithWhereUniqueWithoutTrainerEventStudyMaterialInput>>>;
};

export type TraineeEventStudyMaterialAttendanceUncheckedUpdateWithoutTraineeEventInput = {
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  progressPercentage?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  trainerEventStudyMaterialId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TraineeEventStudyMaterialAttendanceUncheckedUpdateWithoutTrainerEventStudyMaterialInput = {
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  progressPercentage?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type TraineeEventStudyMaterialAttendanceUpdateInput = {
  progressPercentage?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEvent?: InputMaybe<TraineeEventUpdateOneWithoutTraineeEventStudyMaterialAttendanceInput>;
  trainerEventStudyMaterial?: InputMaybe<TrainerEventStudyMaterialUpdateOneRequiredWithoutTraineeEventStudyMaterialAttendanceInput>;
};

export type TraineeEventStudyMaterialAttendanceUpdateManyMutationInput = {
  progressPercentage?: InputMaybe<DecimalFieldUpdateOperationsInput>;
};

export type TraineeEventStudyMaterialAttendanceUpdateManyWithWhereWithoutTraineeEventInput = {
  data: TraineeEventStudyMaterialAttendanceUncheckedUpdateManyWithoutTraineeEventStudyMaterialAttendanceInput;
  where: TraineeEventStudyMaterialAttendanceScalarWhereInput;
};

export type TraineeEventStudyMaterialAttendanceUpdateManyWithWhereWithoutTrainerEventStudyMaterialInput = {
  data: TraineeEventStudyMaterialAttendanceUncheckedUpdateManyWithoutTraineeEventStudyMaterialAttendanceInput;
  where: TraineeEventStudyMaterialAttendanceScalarWhereInput;
};

export type TraineeEventStudyMaterialAttendanceUpdateManyWithoutTraineeEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceCreateOrConnectWithoutTraineeEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceCreateWithoutTraineeEventInput>>>;
  createMany?: InputMaybe<TraineeEventStudyMaterialAttendanceCreateManyTraineeEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceUpdateWithWhereUniqueWithoutTraineeEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceUpdateManyWithWhereWithoutTraineeEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceUpsertWithWhereUniqueWithoutTraineeEventInput>>>;
};

export type TraineeEventStudyMaterialAttendanceUpdateManyWithoutTrainerEventStudyMaterialInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceCreateOrConnectWithoutTrainerEventStudyMaterialInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceCreateWithoutTrainerEventStudyMaterialInput>>>;
  createMany?: InputMaybe<TraineeEventStudyMaterialAttendanceCreateManyTrainerEventStudyMaterialInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceUpdateWithWhereUniqueWithoutTrainerEventStudyMaterialInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceUpdateManyWithWhereWithoutTrainerEventStudyMaterialInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceUpsertWithWhereUniqueWithoutTrainerEventStudyMaterialInput>>>;
};

export type TraineeEventStudyMaterialAttendanceUpdateWithWhereUniqueWithoutTraineeEventInput = {
  data: TraineeEventStudyMaterialAttendanceUncheckedUpdateWithoutTraineeEventInput;
  where: TraineeEventStudyMaterialAttendanceWhereUniqueInput;
};

export type TraineeEventStudyMaterialAttendanceUpdateWithWhereUniqueWithoutTrainerEventStudyMaterialInput = {
  data: TraineeEventStudyMaterialAttendanceUncheckedUpdateWithoutTrainerEventStudyMaterialInput;
  where: TraineeEventStudyMaterialAttendanceWhereUniqueInput;
};

export type TraineeEventStudyMaterialAttendanceUpdateWithoutTraineeEventInput = {
  progressPercentage?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  trainerEventStudyMaterial?: InputMaybe<TrainerEventStudyMaterialUpdateOneRequiredWithoutTraineeEventStudyMaterialAttendanceInput>;
};

export type TraineeEventStudyMaterialAttendanceUpdateWithoutTrainerEventStudyMaterialInput = {
  progressPercentage?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEvent?: InputMaybe<TraineeEventUpdateOneWithoutTraineeEventStudyMaterialAttendanceInput>;
};

export type TraineeEventStudyMaterialAttendanceUpsertWithWhereUniqueWithoutTraineeEventInput = {
  create: TraineeEventStudyMaterialAttendanceUncheckedCreateWithoutTraineeEventInput;
  update: TraineeEventStudyMaterialAttendanceUncheckedUpdateWithoutTraineeEventInput;
  where: TraineeEventStudyMaterialAttendanceWhereUniqueInput;
};

export type TraineeEventStudyMaterialAttendanceUpsertWithWhereUniqueWithoutTrainerEventStudyMaterialInput = {
  create: TraineeEventStudyMaterialAttendanceUncheckedCreateWithoutTrainerEventStudyMaterialInput;
  update: TraineeEventStudyMaterialAttendanceUncheckedUpdateWithoutTrainerEventStudyMaterialInput;
  where: TraineeEventStudyMaterialAttendanceWhereUniqueInput;
};

export type TraineeEventStudyMaterialAttendanceWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TraineeEventStudyMaterialAttendanceWhereInput>>>;
  id?: InputMaybe<IntFilter>;
  progressPercentage?: InputMaybe<DecimalFilter>;
  traineeEvent?: InputMaybe<TraineeEventWhereInput>;
  traineeEventId?: InputMaybe<IntNullableFilter>;
  trainerEventStudyMaterial?: InputMaybe<TrainerEventStudyMaterialWhereInput>;
  trainerEventStudyMaterialId?: InputMaybe<IntFilter>;
};

export type TraineeEventStudyMaterialAttendanceWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  traineeEventId_trainerEventStudyMaterialId?: InputMaybe<TraineeEventStudyMaterialAttendanceTraineeEventIdTrainerEventStudyMaterialIdCompoundUniqueInput>;
};

export type TraineeEventSumAggregateOutputType = {
  __typename?: 'TraineeEventSumAggregateOutputType';
  bookingStatusId?: Maybe<Scalars['Int']>;
  certificatePrice?: Maybe<Scalars['Decimal']>;
  couponId?: Maybe<Scalars['Int']>;
  couponeDiscount?: Maybe<Scalars['Decimal']>;
  ePaymentMethodId?: Maybe<Scalars['Int']>;
  eventDayId?: Maybe<Scalars['Int']>;
  eventId?: Maybe<Scalars['Int']>;
  groupId?: Maybe<Scalars['Int']>;
  howHeardAboutEventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  inviterId?: Maybe<Scalars['Int']>;
  methodOfDeliveryId?: Maybe<Scalars['Int']>;
  paymentNetworkId?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Decimal']>;
  tax?: Maybe<Scalars['Decimal']>;
  totalToPay?: Maybe<Scalars['Decimal']>;
  traineeId?: Maybe<Scalars['Int']>;
  walletBalance?: Maybe<Scalars['Decimal']>;
  workshopPrice?: Maybe<Scalars['Decimal']>;
};

export type TraineeEventSumOrderByAggregateInput = {
  bookingStatusId?: InputMaybe<SortOrder>;
  certificatePrice?: InputMaybe<SortOrder>;
  couponId?: InputMaybe<SortOrder>;
  couponeDiscount?: InputMaybe<SortOrder>;
  ePaymentMethodId?: InputMaybe<SortOrder>;
  eventDayId?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  groupId?: InputMaybe<SortOrder>;
  howHeardAboutEventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inviterId?: InputMaybe<SortOrder>;
  methodOfDeliveryId?: InputMaybe<SortOrder>;
  paymentNetworkId?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  tax?: InputMaybe<SortOrder>;
  totalToPay?: InputMaybe<SortOrder>;
  traineeId?: InputMaybe<SortOrder>;
  walletBalance?: InputMaybe<SortOrder>;
  workshopPrice?: InputMaybe<SortOrder>;
};

export type TraineeEventTraineeIdEventIdCompoundUniqueInput = {
  eventId: Scalars['Int'];
  traineeId: Scalars['Int'];
};

export type TraineeEventUncheckedCreateInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<Scalars['Int']>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  ePaymentMethodId?: InputMaybe<Scalars['Int']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  eventId: Scalars['Int'];
  groupId?: InputMaybe<Scalars['Int']>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedCreateNestedOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  parts?: InputMaybe<TraineeEventPartUncheckedCreateNestedManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewUncheckedCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  traineeId: Scalars['Int'];
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventUncheckedCreateNestedManyWithoutBookingStatusInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutBookingStatusInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutBookingStatusInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyBookingStatusInputEnvelope>;
};

export type TraineeEventUncheckedCreateNestedManyWithoutCouponInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutCouponInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutCouponInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyCouponInputEnvelope>;
};

export type TraineeEventUncheckedCreateNestedManyWithoutEPaymentMethodInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutEPaymentMethodInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutEPaymentMethodInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyEPaymentMethodInputEnvelope>;
};

export type TraineeEventUncheckedCreateNestedManyWithoutEventDayInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutEventDayInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutEventDayInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyEventDayInputEnvelope>;
};

export type TraineeEventUncheckedCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutEventInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyEventInputEnvelope>;
};

export type TraineeEventUncheckedCreateNestedManyWithoutGroupInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutGroupInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutGroupInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyGroupInputEnvelope>;
};

export type TraineeEventUncheckedCreateNestedManyWithoutHowHeardAboutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutHowHeardAboutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutHowHeardAboutEventInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyHowHeardAboutEventInputEnvelope>;
};

export type TraineeEventUncheckedCreateNestedManyWithoutInviterInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutInviterInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutInviterInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyInviterInputEnvelope>;
};

export type TraineeEventUncheckedCreateNestedManyWithoutMethodOfDeliveryInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutMethodOfDeliveryInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutMethodOfDeliveryInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyMethodOfDeliveryInputEnvelope>;
};

export type TraineeEventUncheckedCreateNestedManyWithoutPaymentNetworkInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutPaymentNetworkInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutPaymentNetworkInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyPaymentNetworkInputEnvelope>;
};

export type TraineeEventUncheckedCreateNestedManyWithoutTraineeInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutTraineeInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutTraineeInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyTraineeInputEnvelope>;
};

export type TraineeEventUncheckedCreateWithoutAttendanceInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<Scalars['Int']>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  ePaymentMethodId?: InputMaybe<Scalars['Int']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  eventId: Scalars['Int'];
  groupId?: InputMaybe<Scalars['Int']>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedCreateNestedOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  parts?: InputMaybe<TraineeEventPartUncheckedCreateNestedManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewUncheckedCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  traineeId: Scalars['Int'];
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventUncheckedCreateWithoutBookingStatusInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  ePaymentMethodId?: InputMaybe<Scalars['Int']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  eventId: Scalars['Int'];
  groupId?: InputMaybe<Scalars['Int']>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedCreateNestedOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  parts?: InputMaybe<TraineeEventPartUncheckedCreateNestedManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewUncheckedCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  traineeId: Scalars['Int'];
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventUncheckedCreateWithoutCertificateInput = {
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<Scalars['Int']>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  ePaymentMethodId?: InputMaybe<Scalars['Int']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  eventId: Scalars['Int'];
  groupId?: InputMaybe<Scalars['Int']>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedCreateNestedOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  parts?: InputMaybe<TraineeEventPartUncheckedCreateNestedManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewUncheckedCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  traineeId: Scalars['Int'];
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventUncheckedCreateWithoutCouponInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<Scalars['Int']>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  ePaymentMethodId?: InputMaybe<Scalars['Int']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  eventId: Scalars['Int'];
  groupId?: InputMaybe<Scalars['Int']>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedCreateNestedOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  parts?: InputMaybe<TraineeEventPartUncheckedCreateNestedManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewUncheckedCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  traineeId: Scalars['Int'];
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventUncheckedCreateWithoutEPaymentMethodInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<Scalars['Int']>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  eventId: Scalars['Int'];
  groupId?: InputMaybe<Scalars['Int']>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedCreateNestedOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  parts?: InputMaybe<TraineeEventPartUncheckedCreateNestedManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewUncheckedCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  traineeId: Scalars['Int'];
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventUncheckedCreateWithoutEventDayInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<Scalars['Int']>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  ePaymentMethodId?: InputMaybe<Scalars['Int']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventId: Scalars['Int'];
  groupId?: InputMaybe<Scalars['Int']>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedCreateNestedOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  parts?: InputMaybe<TraineeEventPartUncheckedCreateNestedManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewUncheckedCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  traineeId: Scalars['Int'];
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventUncheckedCreateWithoutEventInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<Scalars['Int']>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  ePaymentMethodId?: InputMaybe<Scalars['Int']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  groupId?: InputMaybe<Scalars['Int']>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedCreateNestedOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  parts?: InputMaybe<TraineeEventPartUncheckedCreateNestedManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewUncheckedCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  traineeId: Scalars['Int'];
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventUncheckedCreateWithoutGroupInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<Scalars['Int']>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  ePaymentMethodId?: InputMaybe<Scalars['Int']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  eventId: Scalars['Int'];
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedCreateNestedOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  parts?: InputMaybe<TraineeEventPartUncheckedCreateNestedManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewUncheckedCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  traineeId: Scalars['Int'];
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventUncheckedCreateWithoutHowHeardAboutEventInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<Scalars['Int']>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  ePaymentMethodId?: InputMaybe<Scalars['Int']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  eventId: Scalars['Int'];
  groupId?: InputMaybe<Scalars['Int']>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedCreateNestedOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  parts?: InputMaybe<TraineeEventPartUncheckedCreateNestedManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewUncheckedCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  traineeId: Scalars['Int'];
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventUncheckedCreateWithoutInviterCouponProfitInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<Scalars['Int']>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  ePaymentMethodId?: InputMaybe<Scalars['Int']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  eventId: Scalars['Int'];
  groupId?: InputMaybe<Scalars['Int']>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  parts?: InputMaybe<TraineeEventPartUncheckedCreateNestedManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewUncheckedCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  traineeId: Scalars['Int'];
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventUncheckedCreateWithoutInviterInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<Scalars['Int']>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  ePaymentMethodId?: InputMaybe<Scalars['Int']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  eventId: Scalars['Int'];
  groupId?: InputMaybe<Scalars['Int']>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedCreateNestedOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  parts?: InputMaybe<TraineeEventPartUncheckedCreateNestedManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewUncheckedCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  traineeId: Scalars['Int'];
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventUncheckedCreateWithoutMethodOfDeliveryInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<Scalars['Int']>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  ePaymentMethodId?: InputMaybe<Scalars['Int']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  eventId: Scalars['Int'];
  groupId?: InputMaybe<Scalars['Int']>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedCreateNestedOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  parts?: InputMaybe<TraineeEventPartUncheckedCreateNestedManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewUncheckedCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  traineeId: Scalars['Int'];
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventUncheckedCreateWithoutPartsInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<Scalars['Int']>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  ePaymentMethodId?: InputMaybe<Scalars['Int']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  eventId: Scalars['Int'];
  groupId?: InputMaybe<Scalars['Int']>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedCreateNestedOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  paymentNetworkId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewUncheckedCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  traineeId: Scalars['Int'];
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventUncheckedCreateWithoutPaymentNetworkInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<Scalars['Int']>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  ePaymentMethodId?: InputMaybe<Scalars['Int']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  eventId: Scalars['Int'];
  groupId?: InputMaybe<Scalars['Int']>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedCreateNestedOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  parts?: InputMaybe<TraineeEventPartUncheckedCreateNestedManyWithoutTraineeEventInput>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewUncheckedCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  traineeId: Scalars['Int'];
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventUncheckedCreateWithoutReviewInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<Scalars['Int']>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  ePaymentMethodId?: InputMaybe<Scalars['Int']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  eventId: Scalars['Int'];
  groupId?: InputMaybe<Scalars['Int']>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedCreateNestedOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  parts?: InputMaybe<TraineeEventPartUncheckedCreateNestedManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  traineeId: Scalars['Int'];
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventUncheckedCreateWithoutTraineeEventStudyMaterialAttendanceInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<Scalars['Int']>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  ePaymentMethodId?: InputMaybe<Scalars['Int']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  eventId: Scalars['Int'];
  groupId?: InputMaybe<Scalars['Int']>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedCreateNestedOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  parts?: InputMaybe<TraineeEventPartUncheckedCreateNestedManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewUncheckedCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  traineeId: Scalars['Int'];
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventUncheckedCreateWithoutTraineeEventZoomRegistrationInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedOneWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<Scalars['Int']>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  ePaymentMethodId?: InputMaybe<Scalars['Int']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  eventId: Scalars['Int'];
  groupId?: InputMaybe<Scalars['Int']>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedCreateNestedOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  parts?: InputMaybe<TraineeEventPartUncheckedCreateNestedManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewUncheckedCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  traineeId: Scalars['Int'];
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventUncheckedCreateWithoutTraineeInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<Scalars['Int']>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  ePaymentMethodId?: InputMaybe<Scalars['Int']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  eventId: Scalars['Int'];
  groupId?: InputMaybe<Scalars['Int']>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedCreateNestedOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  parts?: InputMaybe<TraineeEventPartUncheckedCreateNestedManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewUncheckedCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventUncheckedCreateWithoutTraineeTrainerReviewsInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<Scalars['Int']>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  ePaymentMethodId?: InputMaybe<Scalars['Int']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  eventId: Scalars['Int'];
  groupId?: InputMaybe<Scalars['Int']>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedCreateNestedOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  parts?: InputMaybe<TraineeEventPartUncheckedCreateNestedManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewUncheckedCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  traineeId: Scalars['Int'];
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventUncheckedCreateWithoutTransitionsInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedCreateNestedManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<Scalars['Int']>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  ePaymentMethodId?: InputMaybe<Scalars['Int']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  eventId: Scalars['Int'];
  groupId?: InputMaybe<Scalars['Int']>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedCreateNestedOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  parts?: InputMaybe<TraineeEventPartUncheckedCreateNestedManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewUncheckedCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  traineeId: Scalars['Int'];
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventUncheckedCreateWithoutZohoEmailInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedCreateNestedManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<Scalars['Int']>;
  certificatePrice?: InputMaybe<Scalars['Decimal']>;
  couponId?: InputMaybe<Scalars['Int']>;
  couponeDiscount?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  ePaymentMethodId?: InputMaybe<Scalars['Int']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  eventId: Scalars['Int'];
  groupId?: InputMaybe<Scalars['Int']>;
  hasBookedAllParts?: InputMaybe<Scalars['Boolean']>;
  howHeardAboutEventId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedCreateNestedOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  isCertificateIssued?: InputMaybe<Scalars['Boolean']>;
  isFirstRegistration?: InputMaybe<Scalars['Boolean']>;
  isGroupRegistrant: Scalars['Boolean'];
  isGuest?: InputMaybe<Scalars['Boolean']>;
  isIndividualPay?: InputMaybe<Scalars['Boolean']>;
  isLateRegistrant: Scalars['Boolean'];
  isPackageBooking?: InputMaybe<Scalars['Boolean']>;
  isWorkshopRegistrant: Scalars['Boolean'];
  methodOfDeliveryId?: InputMaybe<Scalars['Int']>;
  parts?: InputMaybe<TraineeEventPartUncheckedCreateNestedManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<Scalars['Int']>;
  price: Scalars['Decimal'];
  registrantId?: InputMaybe<Scalars['String']>;
  registrantToken?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<TraineeEventReviewUncheckedCreateNestedOneWithoutTraineeEventInput>;
  tax: Scalars['Decimal'];
  totalToPay: Scalars['Decimal'];
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedCreateNestedManyWithoutTraineeEventInput>;
  traineeId: Scalars['Int'];
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedCreateNestedManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<Scalars['Decimal']>;
  workshopPrice?: InputMaybe<Scalars['Decimal']>;
};

export type TraineeEventUncheckedUpdateInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ePaymentMethodId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  groupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedUpdateOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  parts?: InputMaybe<TraineeEventPartUncheckedUpdateManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUncheckedUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  traineeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUncheckedUpdateManyInput = {
  bookingStatusId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ePaymentMethodId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  groupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  paymentNetworkId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUncheckedUpdateManyWithoutBookingStatusInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutBookingStatusInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutBookingStatusInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyBookingStatusInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventUpdateWithWhereUniqueWithoutBookingStatusInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventUpdateManyWithWhereWithoutBookingStatusInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventUpsertWithWhereUniqueWithoutBookingStatusInput>>>;
};

export type TraineeEventUncheckedUpdateManyWithoutCouponInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutCouponInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutCouponInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyCouponInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventUpdateWithWhereUniqueWithoutCouponInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventUpdateManyWithWhereWithoutCouponInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventUpsertWithWhereUniqueWithoutCouponInput>>>;
};

export type TraineeEventUncheckedUpdateManyWithoutEPaymentMethodInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutEPaymentMethodInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutEPaymentMethodInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyEPaymentMethodInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventUpdateWithWhereUniqueWithoutEPaymentMethodInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventUpdateManyWithWhereWithoutEPaymentMethodInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventUpsertWithWhereUniqueWithoutEPaymentMethodInput>>>;
};

export type TraineeEventUncheckedUpdateManyWithoutEventDayInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutEventDayInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutEventDayInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyEventDayInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventUpdateWithWhereUniqueWithoutEventDayInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventUpdateManyWithWhereWithoutEventDayInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventUpsertWithWhereUniqueWithoutEventDayInput>>>;
};

export type TraineeEventUncheckedUpdateManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutEventInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventUpdateWithWhereUniqueWithoutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventUpdateManyWithWhereWithoutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventUpsertWithWhereUniqueWithoutEventInput>>>;
};

export type TraineeEventUncheckedUpdateManyWithoutGroupInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutGroupInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutGroupInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyGroupInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventUpdateWithWhereUniqueWithoutGroupInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventUpdateManyWithWhereWithoutGroupInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventUpsertWithWhereUniqueWithoutGroupInput>>>;
};

export type TraineeEventUncheckedUpdateManyWithoutHowHeardAboutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutHowHeardAboutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutHowHeardAboutEventInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyHowHeardAboutEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventUpdateWithWhereUniqueWithoutHowHeardAboutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventUpdateManyWithWhereWithoutHowHeardAboutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventUpsertWithWhereUniqueWithoutHowHeardAboutEventInput>>>;
};

export type TraineeEventUncheckedUpdateManyWithoutInviterInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutInviterInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutInviterInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyInviterInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventUpdateWithWhereUniqueWithoutInviterInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventUpdateManyWithWhereWithoutInviterInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventUpsertWithWhereUniqueWithoutInviterInput>>>;
};

export type TraineeEventUncheckedUpdateManyWithoutMethodOfDeliveryInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutMethodOfDeliveryInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutMethodOfDeliveryInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyMethodOfDeliveryInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventUpdateWithWhereUniqueWithoutMethodOfDeliveryInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventUpdateManyWithWhereWithoutMethodOfDeliveryInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventUpsertWithWhereUniqueWithoutMethodOfDeliveryInput>>>;
};

export type TraineeEventUncheckedUpdateManyWithoutPaymentNetworkInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutPaymentNetworkInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutPaymentNetworkInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyPaymentNetworkInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventUpdateWithWhereUniqueWithoutPaymentNetworkInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventUpdateManyWithWhereWithoutPaymentNetworkInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventUpsertWithWhereUniqueWithoutPaymentNetworkInput>>>;
};

export type TraineeEventUncheckedUpdateManyWithoutTraineeEventInput = {
  bookingStatusId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ePaymentMethodId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  groupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  paymentNetworkId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUncheckedUpdateManyWithoutTraineeEventInvitesInput = {
  bookingStatusId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ePaymentMethodId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  groupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  paymentNetworkId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUncheckedUpdateManyWithoutTraineeEventsInput = {
  bookingStatusId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ePaymentMethodId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  groupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  paymentNetworkId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUncheckedUpdateManyWithoutTraineeInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutTraineeInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutTraineeInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyTraineeInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventUpdateWithWhereUniqueWithoutTraineeInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventUpdateManyWithWhereWithoutTraineeInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventUpsertWithWhereUniqueWithoutTraineeInput>>>;
};

export type TraineeEventUncheckedUpdateWithoutAttendanceInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ePaymentMethodId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  groupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedUpdateOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  parts?: InputMaybe<TraineeEventPartUncheckedUpdateManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUncheckedUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  traineeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUncheckedUpdateWithoutBookingStatusInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ePaymentMethodId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  groupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedUpdateOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  parts?: InputMaybe<TraineeEventPartUncheckedUpdateManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUncheckedUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  traineeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUncheckedUpdateWithoutCertificateInput = {
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ePaymentMethodId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  groupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedUpdateOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  parts?: InputMaybe<TraineeEventPartUncheckedUpdateManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUncheckedUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  traineeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUncheckedUpdateWithoutCouponInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ePaymentMethodId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  groupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedUpdateOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  parts?: InputMaybe<TraineeEventPartUncheckedUpdateManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUncheckedUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  traineeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUncheckedUpdateWithoutEPaymentMethodInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  groupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedUpdateOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  parts?: InputMaybe<TraineeEventPartUncheckedUpdateManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUncheckedUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  traineeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUncheckedUpdateWithoutEventDayInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ePaymentMethodId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  groupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedUpdateOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  parts?: InputMaybe<TraineeEventPartUncheckedUpdateManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUncheckedUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  traineeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUncheckedUpdateWithoutEventInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ePaymentMethodId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  groupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedUpdateOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  parts?: InputMaybe<TraineeEventPartUncheckedUpdateManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUncheckedUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  traineeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUncheckedUpdateWithoutGroupInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ePaymentMethodId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedUpdateOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  parts?: InputMaybe<TraineeEventPartUncheckedUpdateManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUncheckedUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  traineeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUncheckedUpdateWithoutHowHeardAboutEventInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ePaymentMethodId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  groupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedUpdateOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  parts?: InputMaybe<TraineeEventPartUncheckedUpdateManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUncheckedUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  traineeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUncheckedUpdateWithoutInviterCouponProfitInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ePaymentMethodId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  groupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  parts?: InputMaybe<TraineeEventPartUncheckedUpdateManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUncheckedUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  traineeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUncheckedUpdateWithoutInviterInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ePaymentMethodId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  groupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedUpdateOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  parts?: InputMaybe<TraineeEventPartUncheckedUpdateManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUncheckedUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  traineeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUncheckedUpdateWithoutMethodOfDeliveryInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ePaymentMethodId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  groupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedUpdateOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  parts?: InputMaybe<TraineeEventPartUncheckedUpdateManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUncheckedUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  traineeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUncheckedUpdateWithoutPartsInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ePaymentMethodId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  groupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedUpdateOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  paymentNetworkId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUncheckedUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  traineeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUncheckedUpdateWithoutPaymentNetworkInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ePaymentMethodId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  groupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedUpdateOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  parts?: InputMaybe<TraineeEventPartUncheckedUpdateManyWithoutTraineeEventInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUncheckedUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  traineeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUncheckedUpdateWithoutReviewInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ePaymentMethodId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  groupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedUpdateOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  parts?: InputMaybe<TraineeEventPartUncheckedUpdateManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  traineeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUncheckedUpdateWithoutTraineeEventStudyMaterialAttendanceInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ePaymentMethodId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  groupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedUpdateOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  parts?: InputMaybe<TraineeEventPartUncheckedUpdateManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUncheckedUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUncheckedUpdateWithoutTraineeEventZoomRegistrationInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateOneWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ePaymentMethodId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  groupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedUpdateOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  parts?: InputMaybe<TraineeEventPartUncheckedUpdateManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUncheckedUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  traineeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUncheckedUpdateWithoutTraineeInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ePaymentMethodId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  groupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedUpdateOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  parts?: InputMaybe<TraineeEventPartUncheckedUpdateManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUncheckedUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUncheckedUpdateWithoutTraineeTrainerReviewsInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ePaymentMethodId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  groupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedUpdateOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  parts?: InputMaybe<TraineeEventPartUncheckedUpdateManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUncheckedUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  traineeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUncheckedUpdateWithoutTransitionsInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ePaymentMethodId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  groupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedUpdateOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  parts?: InputMaybe<TraineeEventPartUncheckedUpdateManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUncheckedUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  traineeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUncheckedUpdateWithoutZohoEmailInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUncheckedUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  bookingStatusId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  couponId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ePaymentMethodId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDayId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  groupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUncheckedUpdateOneWithoutTraineeEventInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDeliveryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  parts?: InputMaybe<TraineeEventPartUncheckedUpdateManyWithoutTraineeEventInput>;
  paymentNetworkId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUncheckedUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedUpdateManyWithoutTraineeEventInput>;
  traineeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUpdateInput = {
  Certificate?: InputMaybe<CertificateUpdateOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodUpdateOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUpdateManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusUpdateOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  coupon?: InputMaybe<CouponUpdateOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTraineeEventsInput>;
  eventDay?: InputMaybe<EventDayUpdateOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupUpdateOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventUpdateOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUpdateOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartUpdateManyWithoutTraineeEventInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  trainee?: InputMaybe<UserUpdateOneRequiredWithoutTraineeEventsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUpdateManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUpdateManyMutationInput = {
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUpdateManyWithWhereWithoutBookingStatusInput = {
  data: TraineeEventUncheckedUpdateManyWithoutTraineeEventsInput;
  where: TraineeEventScalarWhereInput;
};

export type TraineeEventUpdateManyWithWhereWithoutCouponInput = {
  data: TraineeEventUncheckedUpdateManyWithoutTraineeEventInput;
  where: TraineeEventScalarWhereInput;
};

export type TraineeEventUpdateManyWithWhereWithoutEPaymentMethodInput = {
  data: TraineeEventUncheckedUpdateManyWithoutTraineeEventInput;
  where: TraineeEventScalarWhereInput;
};

export type TraineeEventUpdateManyWithWhereWithoutEventDayInput = {
  data: TraineeEventUncheckedUpdateManyWithoutTraineeEventInput;
  where: TraineeEventScalarWhereInput;
};

export type TraineeEventUpdateManyWithWhereWithoutEventInput = {
  data: TraineeEventUncheckedUpdateManyWithoutTraineeEventsInput;
  where: TraineeEventScalarWhereInput;
};

export type TraineeEventUpdateManyWithWhereWithoutGroupInput = {
  data: TraineeEventUncheckedUpdateManyWithoutTraineeEventsInput;
  where: TraineeEventScalarWhereInput;
};

export type TraineeEventUpdateManyWithWhereWithoutHowHeardAboutEventInput = {
  data: TraineeEventUncheckedUpdateManyWithoutTraineeEventsInput;
  where: TraineeEventScalarWhereInput;
};

export type TraineeEventUpdateManyWithWhereWithoutInviterInput = {
  data: TraineeEventUncheckedUpdateManyWithoutTraineeEventInvitesInput;
  where: TraineeEventScalarWhereInput;
};

export type TraineeEventUpdateManyWithWhereWithoutMethodOfDeliveryInput = {
  data: TraineeEventUncheckedUpdateManyWithoutTraineeEventInput;
  where: TraineeEventScalarWhereInput;
};

export type TraineeEventUpdateManyWithWhereWithoutPaymentNetworkInput = {
  data: TraineeEventUncheckedUpdateManyWithoutTraineeEventInput;
  where: TraineeEventScalarWhereInput;
};

export type TraineeEventUpdateManyWithWhereWithoutTraineeInput = {
  data: TraineeEventUncheckedUpdateManyWithoutTraineeEventsInput;
  where: TraineeEventScalarWhereInput;
};

export type TraineeEventUpdateManyWithoutBookingStatusInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutBookingStatusInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutBookingStatusInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyBookingStatusInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventUpdateWithWhereUniqueWithoutBookingStatusInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventUpdateManyWithWhereWithoutBookingStatusInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventUpsertWithWhereUniqueWithoutBookingStatusInput>>>;
};

export type TraineeEventUpdateManyWithoutCouponInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutCouponInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutCouponInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyCouponInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventUpdateWithWhereUniqueWithoutCouponInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventUpdateManyWithWhereWithoutCouponInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventUpsertWithWhereUniqueWithoutCouponInput>>>;
};

export type TraineeEventUpdateManyWithoutEPaymentMethodInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutEPaymentMethodInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutEPaymentMethodInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyEPaymentMethodInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventUpdateWithWhereUniqueWithoutEPaymentMethodInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventUpdateManyWithWhereWithoutEPaymentMethodInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventUpsertWithWhereUniqueWithoutEPaymentMethodInput>>>;
};

export type TraineeEventUpdateManyWithoutEventDayInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutEventDayInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutEventDayInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyEventDayInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventUpdateWithWhereUniqueWithoutEventDayInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventUpdateManyWithWhereWithoutEventDayInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventUpsertWithWhereUniqueWithoutEventDayInput>>>;
};

export type TraineeEventUpdateManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutEventInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventUpdateWithWhereUniqueWithoutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventUpdateManyWithWhereWithoutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventUpsertWithWhereUniqueWithoutEventInput>>>;
};

export type TraineeEventUpdateManyWithoutGroupInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutGroupInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutGroupInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyGroupInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventUpdateWithWhereUniqueWithoutGroupInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventUpdateManyWithWhereWithoutGroupInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventUpsertWithWhereUniqueWithoutGroupInput>>>;
};

export type TraineeEventUpdateManyWithoutHowHeardAboutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutHowHeardAboutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutHowHeardAboutEventInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyHowHeardAboutEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventUpdateWithWhereUniqueWithoutHowHeardAboutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventUpdateManyWithWhereWithoutHowHeardAboutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventUpsertWithWhereUniqueWithoutHowHeardAboutEventInput>>>;
};

export type TraineeEventUpdateManyWithoutInviterInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutInviterInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutInviterInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyInviterInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventUpdateWithWhereUniqueWithoutInviterInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventUpdateManyWithWhereWithoutInviterInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventUpsertWithWhereUniqueWithoutInviterInput>>>;
};

export type TraineeEventUpdateManyWithoutMethodOfDeliveryInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutMethodOfDeliveryInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutMethodOfDeliveryInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyMethodOfDeliveryInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventUpdateWithWhereUniqueWithoutMethodOfDeliveryInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventUpdateManyWithWhereWithoutMethodOfDeliveryInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventUpsertWithWhereUniqueWithoutMethodOfDeliveryInput>>>;
};

export type TraineeEventUpdateManyWithoutPaymentNetworkInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutPaymentNetworkInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutPaymentNetworkInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyPaymentNetworkInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventUpdateWithWhereUniqueWithoutPaymentNetworkInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventUpdateManyWithWhereWithoutPaymentNetworkInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventUpsertWithWhereUniqueWithoutPaymentNetworkInput>>>;
};

export type TraineeEventUpdateManyWithoutTraineeInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventCreateOrConnectWithoutTraineeInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventCreateWithoutTraineeInput>>>;
  createMany?: InputMaybe<TraineeEventCreateManyTraineeInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventUpdateWithWhereUniqueWithoutTraineeInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventUpdateManyWithWhereWithoutTraineeInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventUpsertWithWhereUniqueWithoutTraineeInput>>>;
};

export type TraineeEventUpdateOneRequiredWithoutPartsInput = {
  connect?: InputMaybe<TraineeEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TraineeEventCreateOrConnectWithoutPartsInput>;
  create?: InputMaybe<TraineeEventUncheckedCreateWithoutPartsInput>;
  update?: InputMaybe<TraineeEventUncheckedUpdateWithoutPartsInput>;
  upsert?: InputMaybe<TraineeEventUpsertWithoutPartsInput>;
};

export type TraineeEventUpdateOneRequiredWithoutReviewInput = {
  connect?: InputMaybe<TraineeEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TraineeEventCreateOrConnectWithoutReviewInput>;
  create?: InputMaybe<TraineeEventUncheckedCreateWithoutReviewInput>;
  update?: InputMaybe<TraineeEventUncheckedUpdateWithoutReviewInput>;
  upsert?: InputMaybe<TraineeEventUpsertWithoutReviewInput>;
};

export type TraineeEventUpdateOneRequiredWithoutTraineeTrainerReviewsInput = {
  connect?: InputMaybe<TraineeEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TraineeEventCreateOrConnectWithoutTraineeTrainerReviewsInput>;
  create?: InputMaybe<TraineeEventUncheckedCreateWithoutTraineeTrainerReviewsInput>;
  update?: InputMaybe<TraineeEventUncheckedUpdateWithoutTraineeTrainerReviewsInput>;
  upsert?: InputMaybe<TraineeEventUpsertWithoutTraineeTrainerReviewsInput>;
};

export type TraineeEventUpdateOneWithoutAttendanceInput = {
  connect?: InputMaybe<TraineeEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TraineeEventCreateOrConnectWithoutAttendanceInput>;
  create?: InputMaybe<TraineeEventUncheckedCreateWithoutAttendanceInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<TraineeEventUncheckedUpdateWithoutAttendanceInput>;
  upsert?: InputMaybe<TraineeEventUpsertWithoutAttendanceInput>;
};

export type TraineeEventUpdateOneWithoutCertificateInput = {
  connect?: InputMaybe<TraineeEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TraineeEventCreateOrConnectWithoutCertificateInput>;
  create?: InputMaybe<TraineeEventUncheckedCreateWithoutCertificateInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<TraineeEventUncheckedUpdateWithoutCertificateInput>;
  upsert?: InputMaybe<TraineeEventUpsertWithoutCertificateInput>;
};

export type TraineeEventUpdateOneWithoutInviterCouponProfitInput = {
  connect?: InputMaybe<TraineeEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TraineeEventCreateOrConnectWithoutInviterCouponProfitInput>;
  create?: InputMaybe<TraineeEventUncheckedCreateWithoutInviterCouponProfitInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<TraineeEventUncheckedUpdateWithoutInviterCouponProfitInput>;
  upsert?: InputMaybe<TraineeEventUpsertWithoutInviterCouponProfitInput>;
};

export type TraineeEventUpdateOneWithoutTraineeEventStudyMaterialAttendanceInput = {
  connect?: InputMaybe<TraineeEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TraineeEventCreateOrConnectWithoutTraineeEventStudyMaterialAttendanceInput>;
  create?: InputMaybe<TraineeEventUncheckedCreateWithoutTraineeEventStudyMaterialAttendanceInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<TraineeEventUncheckedUpdateWithoutTraineeEventStudyMaterialAttendanceInput>;
  upsert?: InputMaybe<TraineeEventUpsertWithoutTraineeEventStudyMaterialAttendanceInput>;
};

export type TraineeEventUpdateOneWithoutTraineeEventZoomRegistrationInput = {
  connect?: InputMaybe<TraineeEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TraineeEventCreateOrConnectWithoutTraineeEventZoomRegistrationInput>;
  create?: InputMaybe<TraineeEventUncheckedCreateWithoutTraineeEventZoomRegistrationInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<TraineeEventUncheckedUpdateWithoutTraineeEventZoomRegistrationInput>;
  upsert?: InputMaybe<TraineeEventUpsertWithoutTraineeEventZoomRegistrationInput>;
};

export type TraineeEventUpdateOneWithoutTransitionsInput = {
  connect?: InputMaybe<TraineeEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TraineeEventCreateOrConnectWithoutTransitionsInput>;
  create?: InputMaybe<TraineeEventUncheckedCreateWithoutTransitionsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<TraineeEventUncheckedUpdateWithoutTransitionsInput>;
  upsert?: InputMaybe<TraineeEventUpsertWithoutTransitionsInput>;
};

export type TraineeEventUpdateOneWithoutZohoEmailInput = {
  connect?: InputMaybe<TraineeEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TraineeEventCreateOrConnectWithoutZohoEmailInput>;
  create?: InputMaybe<TraineeEventUncheckedCreateWithoutZohoEmailInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<TraineeEventUncheckedUpdateWithoutZohoEmailInput>;
  upsert?: InputMaybe<TraineeEventUpsertWithoutZohoEmailInput>;
};

export type TraineeEventUpdateWithWhereUniqueWithoutBookingStatusInput = {
  data: TraineeEventUncheckedUpdateWithoutBookingStatusInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventUpdateWithWhereUniqueWithoutCouponInput = {
  data: TraineeEventUncheckedUpdateWithoutCouponInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventUpdateWithWhereUniqueWithoutEPaymentMethodInput = {
  data: TraineeEventUncheckedUpdateWithoutEPaymentMethodInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventUpdateWithWhereUniqueWithoutEventDayInput = {
  data: TraineeEventUncheckedUpdateWithoutEventDayInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventUpdateWithWhereUniqueWithoutEventInput = {
  data: TraineeEventUncheckedUpdateWithoutEventInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventUpdateWithWhereUniqueWithoutGroupInput = {
  data: TraineeEventUncheckedUpdateWithoutGroupInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventUpdateWithWhereUniqueWithoutHowHeardAboutEventInput = {
  data: TraineeEventUncheckedUpdateWithoutHowHeardAboutEventInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventUpdateWithWhereUniqueWithoutInviterInput = {
  data: TraineeEventUncheckedUpdateWithoutInviterInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventUpdateWithWhereUniqueWithoutMethodOfDeliveryInput = {
  data: TraineeEventUncheckedUpdateWithoutMethodOfDeliveryInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventUpdateWithWhereUniqueWithoutPaymentNetworkInput = {
  data: TraineeEventUncheckedUpdateWithoutPaymentNetworkInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventUpdateWithWhereUniqueWithoutTraineeInput = {
  data: TraineeEventUncheckedUpdateWithoutTraineeInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventUpdateWithoutAttendanceInput = {
  Certificate?: InputMaybe<CertificateUpdateOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodUpdateOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusUpdateOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  coupon?: InputMaybe<CouponUpdateOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTraineeEventsInput>;
  eventDay?: InputMaybe<EventDayUpdateOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupUpdateOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventUpdateOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUpdateOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartUpdateManyWithoutTraineeEventInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  trainee?: InputMaybe<UserUpdateOneRequiredWithoutTraineeEventsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUpdateManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUpdateWithoutBookingStatusInput = {
  Certificate?: InputMaybe<CertificateUpdateOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodUpdateOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUpdateManyWithoutTraineeEventInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  coupon?: InputMaybe<CouponUpdateOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTraineeEventsInput>;
  eventDay?: InputMaybe<EventDayUpdateOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupUpdateOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventUpdateOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUpdateOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartUpdateManyWithoutTraineeEventInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  trainee?: InputMaybe<UserUpdateOneRequiredWithoutTraineeEventsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUpdateManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUpdateWithoutCertificateInput = {
  EPaymentMethod?: InputMaybe<EPaymentMethodUpdateOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUpdateManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusUpdateOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  coupon?: InputMaybe<CouponUpdateOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTraineeEventsInput>;
  eventDay?: InputMaybe<EventDayUpdateOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupUpdateOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventUpdateOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUpdateOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartUpdateManyWithoutTraineeEventInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  trainee?: InputMaybe<UserUpdateOneRequiredWithoutTraineeEventsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUpdateManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUpdateWithoutCouponInput = {
  Certificate?: InputMaybe<CertificateUpdateOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodUpdateOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUpdateManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusUpdateOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTraineeEventsInput>;
  eventDay?: InputMaybe<EventDayUpdateOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupUpdateOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventUpdateOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUpdateOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartUpdateManyWithoutTraineeEventInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  trainee?: InputMaybe<UserUpdateOneRequiredWithoutTraineeEventsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUpdateManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUpdateWithoutEPaymentMethodInput = {
  Certificate?: InputMaybe<CertificateUpdateOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUpdateManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusUpdateOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  coupon?: InputMaybe<CouponUpdateOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTraineeEventsInput>;
  eventDay?: InputMaybe<EventDayUpdateOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupUpdateOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventUpdateOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUpdateOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartUpdateManyWithoutTraineeEventInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  trainee?: InputMaybe<UserUpdateOneRequiredWithoutTraineeEventsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUpdateManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUpdateWithoutEventDayInput = {
  Certificate?: InputMaybe<CertificateUpdateOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodUpdateOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUpdateManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusUpdateOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  coupon?: InputMaybe<CouponUpdateOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTraineeEventsInput>;
  group?: InputMaybe<TraineeEventGroupUpdateOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventUpdateOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUpdateOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartUpdateManyWithoutTraineeEventInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  trainee?: InputMaybe<UserUpdateOneRequiredWithoutTraineeEventsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUpdateManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUpdateWithoutEventInput = {
  Certificate?: InputMaybe<CertificateUpdateOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodUpdateOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUpdateManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusUpdateOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  coupon?: InputMaybe<CouponUpdateOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventDay?: InputMaybe<EventDayUpdateOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupUpdateOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventUpdateOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUpdateOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartUpdateManyWithoutTraineeEventInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  trainee?: InputMaybe<UserUpdateOneRequiredWithoutTraineeEventsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUpdateManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUpdateWithoutGroupInput = {
  Certificate?: InputMaybe<CertificateUpdateOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodUpdateOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUpdateManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusUpdateOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  coupon?: InputMaybe<CouponUpdateOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTraineeEventsInput>;
  eventDay?: InputMaybe<EventDayUpdateOneWithoutTraineeEventInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventUpdateOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUpdateOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartUpdateManyWithoutTraineeEventInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  trainee?: InputMaybe<UserUpdateOneRequiredWithoutTraineeEventsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUpdateManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUpdateWithoutHowHeardAboutEventInput = {
  Certificate?: InputMaybe<CertificateUpdateOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodUpdateOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUpdateManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusUpdateOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  coupon?: InputMaybe<CouponUpdateOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTraineeEventsInput>;
  eventDay?: InputMaybe<EventDayUpdateOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupUpdateOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUpdateOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartUpdateManyWithoutTraineeEventInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  trainee?: InputMaybe<UserUpdateOneRequiredWithoutTraineeEventsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUpdateManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUpdateWithoutInviterCouponProfitInput = {
  Certificate?: InputMaybe<CertificateUpdateOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodUpdateOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUpdateManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusUpdateOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  coupon?: InputMaybe<CouponUpdateOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTraineeEventsInput>;
  eventDay?: InputMaybe<EventDayUpdateOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupUpdateOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventUpdateOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutTraineeEventInvitesInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartUpdateManyWithoutTraineeEventInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  trainee?: InputMaybe<UserUpdateOneRequiredWithoutTraineeEventsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUpdateManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUpdateWithoutInviterInput = {
  Certificate?: InputMaybe<CertificateUpdateOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodUpdateOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUpdateManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusUpdateOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  coupon?: InputMaybe<CouponUpdateOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTraineeEventsInput>;
  eventDay?: InputMaybe<EventDayUpdateOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupUpdateOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventUpdateOneWithoutTraineeEventsInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUpdateOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartUpdateManyWithoutTraineeEventInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  trainee?: InputMaybe<UserUpdateOneRequiredWithoutTraineeEventsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUpdateManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUpdateWithoutMethodOfDeliveryInput = {
  Certificate?: InputMaybe<CertificateUpdateOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodUpdateOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUpdateManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusUpdateOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  coupon?: InputMaybe<CouponUpdateOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTraineeEventsInput>;
  eventDay?: InputMaybe<EventDayUpdateOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupUpdateOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventUpdateOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUpdateOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  parts?: InputMaybe<TraineeEventPartUpdateManyWithoutTraineeEventInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  trainee?: InputMaybe<UserUpdateOneRequiredWithoutTraineeEventsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUpdateManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUpdateWithoutPartsInput = {
  Certificate?: InputMaybe<CertificateUpdateOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodUpdateOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUpdateManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusUpdateOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  coupon?: InputMaybe<CouponUpdateOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTraineeEventsInput>;
  eventDay?: InputMaybe<EventDayUpdateOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupUpdateOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventUpdateOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUpdateOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneWithoutTraineeEventInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  trainee?: InputMaybe<UserUpdateOneRequiredWithoutTraineeEventsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUpdateManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUpdateWithoutPaymentNetworkInput = {
  Certificate?: InputMaybe<CertificateUpdateOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUpdateManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusUpdateOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  coupon?: InputMaybe<CouponUpdateOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTraineeEventsInput>;
  eventDay?: InputMaybe<EventDayUpdateOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupUpdateOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventUpdateOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUpdateOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartUpdateManyWithoutTraineeEventInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  trainee?: InputMaybe<UserUpdateOneRequiredWithoutTraineeEventsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUpdateManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUpdateWithoutReviewInput = {
  Certificate?: InputMaybe<CertificateUpdateOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodUpdateOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUpdateManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusUpdateOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  coupon?: InputMaybe<CouponUpdateOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTraineeEventsInput>;
  eventDay?: InputMaybe<EventDayUpdateOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupUpdateOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventUpdateOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUpdateOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartUpdateManyWithoutTraineeEventInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  trainee?: InputMaybe<UserUpdateOneRequiredWithoutTraineeEventsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUpdateManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUpdateWithoutTraineeEventStudyMaterialAttendanceInput = {
  Certificate?: InputMaybe<CertificateUpdateOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodUpdateOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUpdateManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusUpdateOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  coupon?: InputMaybe<CouponUpdateOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTraineeEventsInput>;
  eventDay?: InputMaybe<EventDayUpdateOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupUpdateOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventUpdateOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUpdateOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartUpdateManyWithoutTraineeEventInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  trainee?: InputMaybe<UserUpdateOneRequiredWithoutTraineeEventsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUpdateWithoutTraineeEventZoomRegistrationInput = {
  Certificate?: InputMaybe<CertificateUpdateOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodUpdateOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkUpdateOneWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUpdateManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusUpdateOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  coupon?: InputMaybe<CouponUpdateOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTraineeEventsInput>;
  eventDay?: InputMaybe<EventDayUpdateOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupUpdateOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventUpdateOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUpdateOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartUpdateManyWithoutTraineeEventInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  trainee?: InputMaybe<UserUpdateOneRequiredWithoutTraineeEventsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUpdateManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUpdateWithoutTraineeInput = {
  Certificate?: InputMaybe<CertificateUpdateOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodUpdateOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUpdateManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusUpdateOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  coupon?: InputMaybe<CouponUpdateOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTraineeEventsInput>;
  eventDay?: InputMaybe<EventDayUpdateOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupUpdateOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventUpdateOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUpdateOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartUpdateManyWithoutTraineeEventInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUpdateManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUpdateWithoutTraineeTrainerReviewsInput = {
  Certificate?: InputMaybe<CertificateUpdateOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodUpdateOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUpdateManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusUpdateOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  coupon?: InputMaybe<CouponUpdateOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTraineeEventsInput>;
  eventDay?: InputMaybe<EventDayUpdateOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupUpdateOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventUpdateOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUpdateOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartUpdateManyWithoutTraineeEventInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  trainee?: InputMaybe<UserUpdateOneRequiredWithoutTraineeEventsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUpdateWithoutTransitionsInput = {
  Certificate?: InputMaybe<CertificateUpdateOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodUpdateOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUpdateManyWithoutTraineeEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUpdateManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusUpdateOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  coupon?: InputMaybe<CouponUpdateOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTraineeEventsInput>;
  eventDay?: InputMaybe<EventDayUpdateOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupUpdateOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventUpdateOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUpdateOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartUpdateManyWithoutTraineeEventInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  trainee?: InputMaybe<UserUpdateOneRequiredWithoutTraineeEventsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUpdateManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUpdateWithoutZohoEmailInput = {
  Certificate?: InputMaybe<CertificateUpdateOneWithoutTraineeEventInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodUpdateOneWithoutTraineeEventInput>;
  PaymentNetwork?: InputMaybe<PaymentNetworkUpdateOneWithoutTraineeEventInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationUpdateManyWithoutTraineeEventInput>;
  attendance?: InputMaybe<TraineeEventDayAttendanceUpdateManyWithoutTraineeEventInput>;
  bookingStatus?: InputMaybe<BookingStatusUpdateOneWithoutTraineeEventsInput>;
  certificatePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  coupon?: InputMaybe<CouponUpdateOneWithoutTraineeEventInput>;
  couponeDiscount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTraineeEventsInput>;
  eventDay?: InputMaybe<EventDayUpdateOneWithoutTraineeEventInput>;
  group?: InputMaybe<TraineeEventGroupUpdateOneWithoutTraineeEventsInput>;
  hasBookedAllParts?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventUpdateOneWithoutTraineeEventsInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutTraineeEventInvitesInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitUpdateOneWithoutTraineeEventInput>;
  isCertificateIssued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFirstRegistration?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isGroupRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isGuest?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIndividualPay?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLateRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPackageBooking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isWorkshopRegistrant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryUpdateOneWithoutTraineeEventInput>;
  parts?: InputMaybe<TraineeEventPartUpdateManyWithoutTraineeEventInput>;
  price?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  review?: InputMaybe<TraineeEventReviewUpdateOneWithoutTraineeEventInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalToPay?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  trainee?: InputMaybe<UserUpdateOneRequiredWithoutTraineeEventsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUpdateManyWithoutTraineeEventInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUpdateManyWithoutTraineeEventInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutTraineeEventInput>;
  walletBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  workshopPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type TraineeEventUpsertWithWhereUniqueWithoutBookingStatusInput = {
  create: TraineeEventUncheckedCreateWithoutBookingStatusInput;
  update: TraineeEventUncheckedUpdateWithoutBookingStatusInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventUpsertWithWhereUniqueWithoutCouponInput = {
  create: TraineeEventUncheckedCreateWithoutCouponInput;
  update: TraineeEventUncheckedUpdateWithoutCouponInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventUpsertWithWhereUniqueWithoutEPaymentMethodInput = {
  create: TraineeEventUncheckedCreateWithoutEPaymentMethodInput;
  update: TraineeEventUncheckedUpdateWithoutEPaymentMethodInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventUpsertWithWhereUniqueWithoutEventDayInput = {
  create: TraineeEventUncheckedCreateWithoutEventDayInput;
  update: TraineeEventUncheckedUpdateWithoutEventDayInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventUpsertWithWhereUniqueWithoutEventInput = {
  create: TraineeEventUncheckedCreateWithoutEventInput;
  update: TraineeEventUncheckedUpdateWithoutEventInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventUpsertWithWhereUniqueWithoutGroupInput = {
  create: TraineeEventUncheckedCreateWithoutGroupInput;
  update: TraineeEventUncheckedUpdateWithoutGroupInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventUpsertWithWhereUniqueWithoutHowHeardAboutEventInput = {
  create: TraineeEventUncheckedCreateWithoutHowHeardAboutEventInput;
  update: TraineeEventUncheckedUpdateWithoutHowHeardAboutEventInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventUpsertWithWhereUniqueWithoutInviterInput = {
  create: TraineeEventUncheckedCreateWithoutInviterInput;
  update: TraineeEventUncheckedUpdateWithoutInviterInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventUpsertWithWhereUniqueWithoutMethodOfDeliveryInput = {
  create: TraineeEventUncheckedCreateWithoutMethodOfDeliveryInput;
  update: TraineeEventUncheckedUpdateWithoutMethodOfDeliveryInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventUpsertWithWhereUniqueWithoutPaymentNetworkInput = {
  create: TraineeEventUncheckedCreateWithoutPaymentNetworkInput;
  update: TraineeEventUncheckedUpdateWithoutPaymentNetworkInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventUpsertWithWhereUniqueWithoutTraineeInput = {
  create: TraineeEventUncheckedCreateWithoutTraineeInput;
  update: TraineeEventUncheckedUpdateWithoutTraineeInput;
  where: TraineeEventWhereUniqueInput;
};

export type TraineeEventUpsertWithoutAttendanceInput = {
  create: TraineeEventUncheckedCreateWithoutAttendanceInput;
  update: TraineeEventUncheckedUpdateWithoutAttendanceInput;
};

export type TraineeEventUpsertWithoutCertificateInput = {
  create: TraineeEventUncheckedCreateWithoutCertificateInput;
  update: TraineeEventUncheckedUpdateWithoutCertificateInput;
};

export type TraineeEventUpsertWithoutInviterCouponProfitInput = {
  create: TraineeEventUncheckedCreateWithoutInviterCouponProfitInput;
  update: TraineeEventUncheckedUpdateWithoutInviterCouponProfitInput;
};

export type TraineeEventUpsertWithoutPartsInput = {
  create: TraineeEventUncheckedCreateWithoutPartsInput;
  update: TraineeEventUncheckedUpdateWithoutPartsInput;
};

export type TraineeEventUpsertWithoutReviewInput = {
  create: TraineeEventUncheckedCreateWithoutReviewInput;
  update: TraineeEventUncheckedUpdateWithoutReviewInput;
};

export type TraineeEventUpsertWithoutTraineeEventStudyMaterialAttendanceInput = {
  create: TraineeEventUncheckedCreateWithoutTraineeEventStudyMaterialAttendanceInput;
  update: TraineeEventUncheckedUpdateWithoutTraineeEventStudyMaterialAttendanceInput;
};

export type TraineeEventUpsertWithoutTraineeEventZoomRegistrationInput = {
  create: TraineeEventUncheckedCreateWithoutTraineeEventZoomRegistrationInput;
  update: TraineeEventUncheckedUpdateWithoutTraineeEventZoomRegistrationInput;
};

export type TraineeEventUpsertWithoutTraineeTrainerReviewsInput = {
  create: TraineeEventUncheckedCreateWithoutTraineeTrainerReviewsInput;
  update: TraineeEventUncheckedUpdateWithoutTraineeTrainerReviewsInput;
};

export type TraineeEventUpsertWithoutTransitionsInput = {
  create: TraineeEventUncheckedCreateWithoutTransitionsInput;
  update: TraineeEventUncheckedUpdateWithoutTransitionsInput;
};

export type TraineeEventUpsertWithoutZohoEmailInput = {
  create: TraineeEventUncheckedCreateWithoutZohoEmailInput;
  update: TraineeEventUncheckedUpdateWithoutZohoEmailInput;
};

export type TraineeEventWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TraineeEventWhereInput>>>;
  Certificate?: InputMaybe<CertificateWhereInput>;
  EPaymentMethod?: InputMaybe<EPaymentMethodWhereInput>;
  NOT?: InputMaybe<Array<InputMaybe<TraineeEventWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TraineeEventWhereInput>>>;
  PaymentNetwork?: InputMaybe<PaymentNetworkWhereInput>;
  TraineeEventZoomRegistration?: InputMaybe<TraineeEventZoomRegistrationListRelationFilter>;
  ZohoEmail?: InputMaybe<ZohoEmailListRelationFilter>;
  attendance?: InputMaybe<TraineeEventDayAttendanceListRelationFilter>;
  bookingStatus?: InputMaybe<BookingStatusWhereInput>;
  bookingStatusId?: InputMaybe<IntNullableFilter>;
  certificatePrice?: InputMaybe<DecimalNullableFilter>;
  coupon?: InputMaybe<CouponWhereInput>;
  couponId?: InputMaybe<IntNullableFilter>;
  couponeDiscount?: InputMaybe<DecimalNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  ePaymentMethodId?: InputMaybe<IntNullableFilter>;
  emailState?: InputMaybe<JsonNullableFilter>;
  event?: InputMaybe<EventWhereInput>;
  eventDay?: InputMaybe<EventDayWhereInput>;
  eventDayId?: InputMaybe<IntNullableFilter>;
  eventId?: InputMaybe<IntFilter>;
  group?: InputMaybe<TraineeEventGroupWhereInput>;
  groupId?: InputMaybe<IntNullableFilter>;
  hasBookedAllParts?: InputMaybe<BoolNullableFilter>;
  howHeardAboutEvent?: InputMaybe<HowHeardAboutEventWhereInput>;
  howHeardAboutEventId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  inviter?: InputMaybe<UserWhereInput>;
  inviterCouponProfit?: InputMaybe<InviterCouponProfitWhereInput>;
  inviterId?: InputMaybe<IntNullableFilter>;
  isCertificateIssued?: InputMaybe<BoolFilter>;
  isFirstRegistration?: InputMaybe<BoolNullableFilter>;
  isGroupRegistrant?: InputMaybe<BoolFilter>;
  isGuest?: InputMaybe<BoolNullableFilter>;
  isIndividualPay?: InputMaybe<BoolNullableFilter>;
  isLateRegistrant?: InputMaybe<BoolFilter>;
  isPackageBooking?: InputMaybe<BoolNullableFilter>;
  isWorkshopRegistrant?: InputMaybe<BoolFilter>;
  methodOfDelivery?: InputMaybe<MethodOfDeliveryWhereInput>;
  methodOfDeliveryId?: InputMaybe<IntNullableFilter>;
  parts?: InputMaybe<TraineeEventPartListRelationFilter>;
  paymentNetworkId?: InputMaybe<IntNullableFilter>;
  price?: InputMaybe<DecimalFilter>;
  registrantId?: InputMaybe<StringNullableFilter>;
  registrantToken?: InputMaybe<StringNullableFilter>;
  review?: InputMaybe<TraineeEventReviewWhereInput>;
  tax?: InputMaybe<DecimalFilter>;
  totalToPay?: InputMaybe<DecimalFilter>;
  trainee?: InputMaybe<UserWhereInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceListRelationFilter>;
  traineeId?: InputMaybe<IntFilter>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewListRelationFilter>;
  transitions?: InputMaybe<TransitionListRelationFilter>;
  walletBalance?: InputMaybe<DecimalNullableFilter>;
  workshopPrice?: InputMaybe<DecimalNullableFilter>;
};

export type TraineeEventWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  traineeId_eventId?: InputMaybe<TraineeEventTraineeIdEventIdCompoundUniqueInput>;
};

export type TraineeEventZoomRegistration = {
  __typename?: 'TraineeEventZoomRegistration';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  joinUrl?: Maybe<Scalars['String']>;
  meetingId?: Maybe<Scalars['Int']>;
  registrantId?: Maybe<Scalars['String']>;
  traineeEvent?: Maybe<TraineeEvent>;
  traineeEventId?: Maybe<Scalars['Int']>;
  zoomMeetingId?: Maybe<Scalars['String']>;
};

export type TraineeEventZoomRegistrationAvgAggregateOutputType = {
  __typename?: 'TraineeEventZoomRegistrationAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
  meetingId?: Maybe<Scalars['Float']>;
  traineeEventId?: Maybe<Scalars['Float']>;
};

export type TraineeEventZoomRegistrationAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  meetingId?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
};

export type TraineeEventZoomRegistrationCountAggregateOutputType = {
  __typename?: 'TraineeEventZoomRegistrationCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  joinUrl: Scalars['Int'];
  meetingId: Scalars['Int'];
  registrantId: Scalars['Int'];
  traineeEventId: Scalars['Int'];
  zoomMeetingId: Scalars['Int'];
};

export type TraineeEventZoomRegistrationCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  joinUrl?: InputMaybe<SortOrder>;
  meetingId?: InputMaybe<SortOrder>;
  registrantId?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  zoomMeetingId?: InputMaybe<SortOrder>;
};

export type TraineeEventZoomRegistrationCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['Int']>;
  registrantId?: InputMaybe<Scalars['String']>;
  traineeEvent?: InputMaybe<TraineeEventCreateNestedOneWithoutTraineeEventZoomRegistrationInput>;
  zoomMeetingId?: InputMaybe<Scalars['String']>;
};

export type TraineeEventZoomRegistrationCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['Int']>;
  registrantId?: InputMaybe<Scalars['String']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  zoomMeetingId?: InputMaybe<Scalars['String']>;
};

export type TraineeEventZoomRegistrationCreateManyTraineeEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['Int']>;
  registrantId?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['String']>;
};

export type TraineeEventZoomRegistrationCreateManyTraineeEventInputEnvelope = {
  data: TraineeEventZoomRegistrationCreateManyTraineeEventInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TraineeEventZoomRegistrationCreateNestedManyWithoutTraineeEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationCreateOrConnectWithoutTraineeEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationCreateWithoutTraineeEventInput>>>;
  createMany?: InputMaybe<TraineeEventZoomRegistrationCreateManyTraineeEventInputEnvelope>;
};

export type TraineeEventZoomRegistrationCreateOrConnectWithoutTraineeEventInput = {
  create: TraineeEventZoomRegistrationUncheckedCreateWithoutTraineeEventInput;
  where: TraineeEventZoomRegistrationWhereUniqueInput;
};

export type TraineeEventZoomRegistrationCreateWithoutTraineeEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['Int']>;
  registrantId?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['String']>;
};

export type TraineeEventZoomRegistrationListRelationFilter = {
  every?: InputMaybe<TraineeEventZoomRegistrationWhereInput>;
  none?: InputMaybe<TraineeEventZoomRegistrationWhereInput>;
  some?: InputMaybe<TraineeEventZoomRegistrationWhereInput>;
};

export type TraineeEventZoomRegistrationMaxAggregateOutputType = {
  __typename?: 'TraineeEventZoomRegistrationMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  joinUrl?: Maybe<Scalars['String']>;
  meetingId?: Maybe<Scalars['Int']>;
  registrantId?: Maybe<Scalars['String']>;
  traineeEventId?: Maybe<Scalars['Int']>;
  zoomMeetingId?: Maybe<Scalars['String']>;
};

export type TraineeEventZoomRegistrationMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  joinUrl?: InputMaybe<SortOrder>;
  meetingId?: InputMaybe<SortOrder>;
  registrantId?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  zoomMeetingId?: InputMaybe<SortOrder>;
};

export type TraineeEventZoomRegistrationMinAggregateOutputType = {
  __typename?: 'TraineeEventZoomRegistrationMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  joinUrl?: Maybe<Scalars['String']>;
  meetingId?: Maybe<Scalars['Int']>;
  registrantId?: Maybe<Scalars['String']>;
  traineeEventId?: Maybe<Scalars['Int']>;
  zoomMeetingId?: Maybe<Scalars['String']>;
};

export type TraineeEventZoomRegistrationMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  joinUrl?: InputMaybe<SortOrder>;
  meetingId?: InputMaybe<SortOrder>;
  registrantId?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  zoomMeetingId?: InputMaybe<SortOrder>;
};

export type TraineeEventZoomRegistrationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TraineeEventZoomRegistrationOrderByWithAggregationInput = {
  _avg?: InputMaybe<TraineeEventZoomRegistrationAvgOrderByAggregateInput>;
  _count?: InputMaybe<TraineeEventZoomRegistrationCountOrderByAggregateInput>;
  _max?: InputMaybe<TraineeEventZoomRegistrationMaxOrderByAggregateInput>;
  _min?: InputMaybe<TraineeEventZoomRegistrationMinOrderByAggregateInput>;
  _sum?: InputMaybe<TraineeEventZoomRegistrationSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  joinUrl?: InputMaybe<SortOrder>;
  meetingId?: InputMaybe<SortOrder>;
  registrantId?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  zoomMeetingId?: InputMaybe<SortOrder>;
};

export type TraineeEventZoomRegistrationOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  joinUrl?: InputMaybe<SortOrder>;
  meetingId?: InputMaybe<SortOrder>;
  registrantId?: InputMaybe<SortOrder>;
  traineeEvent?: InputMaybe<TraineeEventOrderByWithRelationInput>;
  traineeEventId?: InputMaybe<SortOrder>;
  zoomMeetingId?: InputMaybe<SortOrder>;
};

export enum TraineeEventZoomRegistrationScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  JoinUrl = 'joinUrl',
  MeetingId = 'meetingId',
  RegistrantId = 'registrantId',
  TraineeEventId = 'traineeEventId',
  ZoomMeetingId = 'zoomMeetingId'
}

export type TraineeEventZoomRegistrationScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationScalarWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  joinUrl?: InputMaybe<StringNullableFilter>;
  meetingId?: InputMaybe<IntNullableFilter>;
  registrantId?: InputMaybe<StringNullableFilter>;
  traineeEventId?: InputMaybe<IntNullableFilter>;
  zoomMeetingId?: InputMaybe<StringNullableFilter>;
};

export type TraineeEventZoomRegistrationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  joinUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  meetingId?: InputMaybe<IntNullableWithAggregatesFilter>;
  registrantId?: InputMaybe<StringNullableWithAggregatesFilter>;
  traineeEventId?: InputMaybe<IntNullableWithAggregatesFilter>;
  zoomMeetingId?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type TraineeEventZoomRegistrationSumAggregateOutputType = {
  __typename?: 'TraineeEventZoomRegistrationSumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
  meetingId?: Maybe<Scalars['Int']>;
  traineeEventId?: Maybe<Scalars['Int']>;
};

export type TraineeEventZoomRegistrationSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  meetingId?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
};

export type TraineeEventZoomRegistrationUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['Int']>;
  registrantId?: InputMaybe<Scalars['String']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  zoomMeetingId?: InputMaybe<Scalars['String']>;
};

export type TraineeEventZoomRegistrationUncheckedCreateNestedManyWithoutTraineeEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationCreateOrConnectWithoutTraineeEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationCreateWithoutTraineeEventInput>>>;
  createMany?: InputMaybe<TraineeEventZoomRegistrationCreateManyTraineeEventInputEnvelope>;
};

export type TraineeEventZoomRegistrationUncheckedCreateWithoutTraineeEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['Int']>;
  registrantId?: InputMaybe<Scalars['String']>;
  zoomMeetingId?: InputMaybe<Scalars['String']>;
};

export type TraineeEventZoomRegistrationUncheckedUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeEventZoomRegistrationUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeEventZoomRegistrationUncheckedUpdateManyWithoutTraineeEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationCreateOrConnectWithoutTraineeEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationCreateWithoutTraineeEventInput>>>;
  createMany?: InputMaybe<TraineeEventZoomRegistrationCreateManyTraineeEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationUpdateWithWhereUniqueWithoutTraineeEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationUpdateManyWithWhereWithoutTraineeEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationUpsertWithWhereUniqueWithoutTraineeEventInput>>>;
};

export type TraineeEventZoomRegistrationUncheckedUpdateManyWithoutTraineeEventZoomRegistrationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeEventZoomRegistrationUncheckedUpdateWithoutTraineeEventInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeEventZoomRegistrationUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  traineeEvent?: InputMaybe<TraineeEventUpdateOneWithoutTraineeEventZoomRegistrationInput>;
  zoomMeetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeEventZoomRegistrationUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeEventZoomRegistrationUpdateManyWithWhereWithoutTraineeEventInput = {
  data: TraineeEventZoomRegistrationUncheckedUpdateManyWithoutTraineeEventZoomRegistrationInput;
  where: TraineeEventZoomRegistrationScalarWhereInput;
};

export type TraineeEventZoomRegistrationUpdateManyWithoutTraineeEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationCreateOrConnectWithoutTraineeEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationCreateWithoutTraineeEventInput>>>;
  createMany?: InputMaybe<TraineeEventZoomRegistrationCreateManyTraineeEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationUpdateWithWhereUniqueWithoutTraineeEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationUpdateManyWithWhereWithoutTraineeEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationUpsertWithWhereUniqueWithoutTraineeEventInput>>>;
};

export type TraineeEventZoomRegistrationUpdateWithWhereUniqueWithoutTraineeEventInput = {
  data: TraineeEventZoomRegistrationUncheckedUpdateWithoutTraineeEventInput;
  where: TraineeEventZoomRegistrationWhereUniqueInput;
};

export type TraineeEventZoomRegistrationUpdateWithoutTraineeEventInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zoomMeetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeEventZoomRegistrationUpsertWithWhereUniqueWithoutTraineeEventInput = {
  create: TraineeEventZoomRegistrationUncheckedCreateWithoutTraineeEventInput;
  update: TraineeEventZoomRegistrationUncheckedUpdateWithoutTraineeEventInput;
  where: TraineeEventZoomRegistrationWhereUniqueInput;
};

export type TraineeEventZoomRegistrationWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TraineeEventZoomRegistrationWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  joinUrl?: InputMaybe<StringNullableFilter>;
  meetingId?: InputMaybe<IntNullableFilter>;
  registrantId?: InputMaybe<StringNullableFilter>;
  traineeEvent?: InputMaybe<TraineeEventWhereInput>;
  traineeEventId?: InputMaybe<IntNullableFilter>;
  zoomMeetingId?: InputMaybe<StringNullableFilter>;
};

export type TraineeEventZoomRegistrationWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type TraineeModel = {
  __typename?: 'TraineeModel';
  image?: Maybe<Scalars['String']>;
};

export type TraineeTrainerReview = {
  __typename?: 'TraineeTrainerReview';
  _count: TraineeTrainerReviewCountOutputType;
  choices: Array<TraineeTrainerReviewChoice>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  reviewOfFive: Scalars['Int'];
  traineeEvent: TraineeEvent;
  traineeEventId: Scalars['Int'];
  trainerEvent: TrainerEvent;
  trainerEventId: Scalars['Int'];
  why?: Maybe<Scalars['String']>;
};


export type TraineeTrainerReviewChoicesArgs = {
  cursor?: InputMaybe<TraineeTrainerReviewChoiceWhereUniqueInput>;
  distinct?: InputMaybe<TraineeTrainerReviewChoiceScalarFieldEnum>;
  orderBy?: InputMaybe<TraineeTrainerReviewChoiceOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeTrainerReviewChoiceWhereInput>;
};

export type TraineeTrainerReviewAvgAggregateOutputType = {
  __typename?: 'TraineeTrainerReviewAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
  reviewOfFive?: Maybe<Scalars['Float']>;
  traineeEventId?: Maybe<Scalars['Float']>;
  trainerEventId?: Maybe<Scalars['Float']>;
};

export type TraineeTrainerReviewAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  reviewOfFive?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
};

export type TraineeTrainerReviewChoice = {
  __typename?: 'TraineeTrainerReviewChoice';
  _count: TraineeTrainerReviewChoiceCountOutputType;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  isGood: Scalars['Boolean'];
  reviews: Array<TraineeTrainerReview>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};


export type TraineeTrainerReviewChoiceReviewsArgs = {
  cursor?: InputMaybe<TraineeTrainerReviewWhereUniqueInput>;
  distinct?: InputMaybe<TraineeTrainerReviewScalarFieldEnum>;
  orderBy?: InputMaybe<TraineeTrainerReviewOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeTrainerReviewWhereInput>;
};

export type TraineeTrainerReviewChoiceAvgAggregateOutputType = {
  __typename?: 'TraineeTrainerReviewChoiceAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
};

export type TraineeTrainerReviewChoiceAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type TraineeTrainerReviewChoiceCountAggregateOutputType = {
  __typename?: 'TraineeTrainerReviewChoiceCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  isGood: Scalars['Int'];
  titleAr: Scalars['Int'];
  titleEn: Scalars['Int'];
};

export type TraineeTrainerReviewChoiceCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isGood?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type TraineeTrainerReviewChoiceCountOutputType = {
  __typename?: 'TraineeTrainerReviewChoiceCountOutputType';
  reviews: Scalars['Int'];
};

export type TraineeTrainerReviewChoiceCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  isGood: Scalars['Boolean'];
  reviews?: InputMaybe<TraineeTrainerReviewCreateNestedManyWithoutChoicesInput>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type TraineeTrainerReviewChoiceCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  isGood: Scalars['Boolean'];
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type TraineeTrainerReviewChoiceCreateNestedManyWithoutReviewsInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceCreateOrConnectWithoutReviewsInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceCreateWithoutReviewsInput>>>;
};

export type TraineeTrainerReviewChoiceCreateOrConnectWithoutReviewsInput = {
  create: TraineeTrainerReviewChoiceUncheckedCreateWithoutReviewsInput;
  where: TraineeTrainerReviewChoiceWhereUniqueInput;
};

export type TraineeTrainerReviewChoiceCreateWithoutReviewsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  isGood: Scalars['Boolean'];
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type TraineeTrainerReviewChoiceListRelationFilter = {
  every?: InputMaybe<TraineeTrainerReviewChoiceWhereInput>;
  none?: InputMaybe<TraineeTrainerReviewChoiceWhereInput>;
  some?: InputMaybe<TraineeTrainerReviewChoiceWhereInput>;
};

export type TraineeTrainerReviewChoiceMaxAggregateOutputType = {
  __typename?: 'TraineeTrainerReviewChoiceMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isGood?: Maybe<Scalars['Boolean']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type TraineeTrainerReviewChoiceMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isGood?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type TraineeTrainerReviewChoiceMinAggregateOutputType = {
  __typename?: 'TraineeTrainerReviewChoiceMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isGood?: Maybe<Scalars['Boolean']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type TraineeTrainerReviewChoiceMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isGood?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type TraineeTrainerReviewChoiceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TraineeTrainerReviewChoiceOrderByWithAggregationInput = {
  _avg?: InputMaybe<TraineeTrainerReviewChoiceAvgOrderByAggregateInput>;
  _count?: InputMaybe<TraineeTrainerReviewChoiceCountOrderByAggregateInput>;
  _max?: InputMaybe<TraineeTrainerReviewChoiceMaxOrderByAggregateInput>;
  _min?: InputMaybe<TraineeTrainerReviewChoiceMinOrderByAggregateInput>;
  _sum?: InputMaybe<TraineeTrainerReviewChoiceSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isGood?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type TraineeTrainerReviewChoiceOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isGood?: InputMaybe<SortOrder>;
  reviews?: InputMaybe<TraineeTrainerReviewOrderByRelationAggregateInput>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export enum TraineeTrainerReviewChoiceScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  IsGood = 'isGood',
  TitleAr = 'titleAr',
  TitleEn = 'titleEn'
}

export type TraineeTrainerReviewChoiceScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceScalarWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  isGood?: InputMaybe<BoolFilter>;
  titleAr?: InputMaybe<StringFilter>;
  titleEn?: InputMaybe<StringFilter>;
};

export type TraineeTrainerReviewChoiceScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  isGood?: InputMaybe<BoolWithAggregatesFilter>;
  titleAr?: InputMaybe<StringWithAggregatesFilter>;
  titleEn?: InputMaybe<StringWithAggregatesFilter>;
};

export type TraineeTrainerReviewChoiceSumAggregateOutputType = {
  __typename?: 'TraineeTrainerReviewChoiceSumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
};

export type TraineeTrainerReviewChoiceSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type TraineeTrainerReviewChoiceUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  isGood: Scalars['Boolean'];
  reviews?: InputMaybe<TraineeTrainerReviewUncheckedCreateNestedManyWithoutChoicesInput>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type TraineeTrainerReviewChoiceUncheckedCreateNestedManyWithoutReviewsInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceCreateOrConnectWithoutReviewsInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceCreateWithoutReviewsInput>>>;
};

export type TraineeTrainerReviewChoiceUncheckedCreateWithoutReviewsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  isGood: Scalars['Boolean'];
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type TraineeTrainerReviewChoiceUncheckedUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isGood?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviews?: InputMaybe<TraineeTrainerReviewUncheckedUpdateManyWithoutChoicesInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TraineeTrainerReviewChoiceUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isGood?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TraineeTrainerReviewChoiceUncheckedUpdateManyWithoutChoicesInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isGood?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TraineeTrainerReviewChoiceUncheckedUpdateManyWithoutReviewsInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceCreateOrConnectWithoutReviewsInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceCreateWithoutReviewsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceUpdateWithWhereUniqueWithoutReviewsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceUpdateManyWithWhereWithoutReviewsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceUpsertWithWhereUniqueWithoutReviewsInput>>>;
};

export type TraineeTrainerReviewChoiceUncheckedUpdateWithoutReviewsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isGood?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TraineeTrainerReviewChoiceUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  isGood?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviews?: InputMaybe<TraineeTrainerReviewUpdateManyWithoutChoicesInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TraineeTrainerReviewChoiceUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  isGood?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TraineeTrainerReviewChoiceUpdateManyWithWhereWithoutReviewsInput = {
  data: TraineeTrainerReviewChoiceUncheckedUpdateManyWithoutChoicesInput;
  where: TraineeTrainerReviewChoiceScalarWhereInput;
};

export type TraineeTrainerReviewChoiceUpdateManyWithoutReviewsInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceCreateOrConnectWithoutReviewsInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceCreateWithoutReviewsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceUpdateWithWhereUniqueWithoutReviewsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceUpdateManyWithWhereWithoutReviewsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceUpsertWithWhereUniqueWithoutReviewsInput>>>;
};

export type TraineeTrainerReviewChoiceUpdateWithWhereUniqueWithoutReviewsInput = {
  data: TraineeTrainerReviewChoiceUncheckedUpdateWithoutReviewsInput;
  where: TraineeTrainerReviewChoiceWhereUniqueInput;
};

export type TraineeTrainerReviewChoiceUpdateWithoutReviewsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  isGood?: InputMaybe<BoolFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TraineeTrainerReviewChoiceUpsertWithWhereUniqueWithoutReviewsInput = {
  create: TraineeTrainerReviewChoiceUncheckedCreateWithoutReviewsInput;
  update: TraineeTrainerReviewChoiceUncheckedUpdateWithoutReviewsInput;
  where: TraineeTrainerReviewChoiceWhereUniqueInput;
};

export type TraineeTrainerReviewChoiceWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewChoiceWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  isGood?: InputMaybe<BoolFilter>;
  reviews?: InputMaybe<TraineeTrainerReviewListRelationFilter>;
  titleAr?: InputMaybe<StringFilter>;
  titleEn?: InputMaybe<StringFilter>;
};

export type TraineeTrainerReviewChoiceWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type TraineeTrainerReviewCountAggregateOutputType = {
  __typename?: 'TraineeTrainerReviewCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  reviewOfFive: Scalars['Int'];
  traineeEventId: Scalars['Int'];
  trainerEventId: Scalars['Int'];
  why: Scalars['Int'];
};

export type TraineeTrainerReviewCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  reviewOfFive?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
  why?: InputMaybe<SortOrder>;
};

export type TraineeTrainerReviewCountOutputType = {
  __typename?: 'TraineeTrainerReviewCountOutputType';
  choices: Scalars['Int'];
};

export type TraineeTrainerReviewCreateInput = {
  choices?: InputMaybe<TraineeTrainerReviewChoiceCreateNestedManyWithoutReviewsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  reviewOfFive: Scalars['Int'];
  traineeEvent: TraineeEventCreateNestedOneWithoutTraineeTrainerReviewsInput;
  trainerEvent: TrainerEventCreateNestedOneWithoutTraineeTrainerReviewsInput;
  why?: InputMaybe<Scalars['String']>;
};

export type TraineeTrainerReviewCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  reviewOfFive: Scalars['Int'];
  traineeEventId: Scalars['Int'];
  trainerEventId: Scalars['Int'];
  why?: InputMaybe<Scalars['String']>;
};

export type TraineeTrainerReviewCreateManyTraineeEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  reviewOfFive: Scalars['Int'];
  trainerEventId: Scalars['Int'];
  why?: InputMaybe<Scalars['String']>;
};

export type TraineeTrainerReviewCreateManyTraineeEventInputEnvelope = {
  data: TraineeTrainerReviewCreateManyTraineeEventInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TraineeTrainerReviewCreateManyTrainerEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  reviewOfFive: Scalars['Int'];
  traineeEventId: Scalars['Int'];
  why?: InputMaybe<Scalars['String']>;
};

export type TraineeTrainerReviewCreateManyTrainerEventInputEnvelope = {
  data: TraineeTrainerReviewCreateManyTrainerEventInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TraineeTrainerReviewCreateNestedManyWithoutChoicesInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewCreateOrConnectWithoutChoicesInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewCreateWithoutChoicesInput>>>;
};

export type TraineeTrainerReviewCreateNestedManyWithoutTraineeEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewCreateOrConnectWithoutTraineeEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewCreateWithoutTraineeEventInput>>>;
  createMany?: InputMaybe<TraineeTrainerReviewCreateManyTraineeEventInputEnvelope>;
};

export type TraineeTrainerReviewCreateNestedManyWithoutTrainerEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewCreateOrConnectWithoutTrainerEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewCreateWithoutTrainerEventInput>>>;
  createMany?: InputMaybe<TraineeTrainerReviewCreateManyTrainerEventInputEnvelope>;
};

export type TraineeTrainerReviewCreateOrConnectWithoutChoicesInput = {
  create: TraineeTrainerReviewUncheckedCreateWithoutChoicesInput;
  where: TraineeTrainerReviewWhereUniqueInput;
};

export type TraineeTrainerReviewCreateOrConnectWithoutTraineeEventInput = {
  create: TraineeTrainerReviewUncheckedCreateWithoutTraineeEventInput;
  where: TraineeTrainerReviewWhereUniqueInput;
};

export type TraineeTrainerReviewCreateOrConnectWithoutTrainerEventInput = {
  create: TraineeTrainerReviewUncheckedCreateWithoutTrainerEventInput;
  where: TraineeTrainerReviewWhereUniqueInput;
};

export type TraineeTrainerReviewCreateWithoutChoicesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  reviewOfFive: Scalars['Int'];
  traineeEvent: TraineeEventCreateNestedOneWithoutTraineeTrainerReviewsInput;
  trainerEvent: TrainerEventCreateNestedOneWithoutTraineeTrainerReviewsInput;
  why?: InputMaybe<Scalars['String']>;
};

export type TraineeTrainerReviewCreateWithoutTraineeEventInput = {
  choices?: InputMaybe<TraineeTrainerReviewChoiceCreateNestedManyWithoutReviewsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  reviewOfFive: Scalars['Int'];
  trainerEvent: TrainerEventCreateNestedOneWithoutTraineeTrainerReviewsInput;
  why?: InputMaybe<Scalars['String']>;
};

export type TraineeTrainerReviewCreateWithoutTrainerEventInput = {
  choices?: InputMaybe<TraineeTrainerReviewChoiceCreateNestedManyWithoutReviewsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  reviewOfFive: Scalars['Int'];
  traineeEvent: TraineeEventCreateNestedOneWithoutTraineeTrainerReviewsInput;
  why?: InputMaybe<Scalars['String']>;
};

export type TraineeTrainerReviewListRelationFilter = {
  every?: InputMaybe<TraineeTrainerReviewWhereInput>;
  none?: InputMaybe<TraineeTrainerReviewWhereInput>;
  some?: InputMaybe<TraineeTrainerReviewWhereInput>;
};

export type TraineeTrainerReviewMaxAggregateOutputType = {
  __typename?: 'TraineeTrainerReviewMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  reviewOfFive?: Maybe<Scalars['Int']>;
  traineeEventId?: Maybe<Scalars['Int']>;
  trainerEventId?: Maybe<Scalars['Int']>;
  why?: Maybe<Scalars['String']>;
};

export type TraineeTrainerReviewMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  reviewOfFive?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
  why?: InputMaybe<SortOrder>;
};

export type TraineeTrainerReviewMinAggregateOutputType = {
  __typename?: 'TraineeTrainerReviewMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  reviewOfFive?: Maybe<Scalars['Int']>;
  traineeEventId?: Maybe<Scalars['Int']>;
  trainerEventId?: Maybe<Scalars['Int']>;
  why?: Maybe<Scalars['String']>;
};

export type TraineeTrainerReviewMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  reviewOfFive?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
  why?: InputMaybe<SortOrder>;
};

export type TraineeTrainerReviewOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TraineeTrainerReviewOrderByWithAggregationInput = {
  _avg?: InputMaybe<TraineeTrainerReviewAvgOrderByAggregateInput>;
  _count?: InputMaybe<TraineeTrainerReviewCountOrderByAggregateInput>;
  _max?: InputMaybe<TraineeTrainerReviewMaxOrderByAggregateInput>;
  _min?: InputMaybe<TraineeTrainerReviewMinOrderByAggregateInput>;
  _sum?: InputMaybe<TraineeTrainerReviewSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  reviewOfFive?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
  why?: InputMaybe<SortOrder>;
};

export type TraineeTrainerReviewOrderByWithRelationInput = {
  choices?: InputMaybe<TraineeTrainerReviewChoiceOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  reviewOfFive?: InputMaybe<SortOrder>;
  traineeEvent?: InputMaybe<TraineeEventOrderByWithRelationInput>;
  traineeEventId?: InputMaybe<SortOrder>;
  trainerEvent?: InputMaybe<TrainerEventOrderByWithRelationInput>;
  trainerEventId?: InputMaybe<SortOrder>;
  why?: InputMaybe<SortOrder>;
};

export enum TraineeTrainerReviewScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  ReviewOfFive = 'reviewOfFive',
  TraineeEventId = 'traineeEventId',
  TrainerEventId = 'trainerEventId',
  Why = 'why'
}

export type TraineeTrainerReviewScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewScalarWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  reviewOfFive?: InputMaybe<IntFilter>;
  traineeEventId?: InputMaybe<IntFilter>;
  trainerEventId?: InputMaybe<IntFilter>;
  why?: InputMaybe<StringNullableFilter>;
};

export type TraineeTrainerReviewScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  reviewOfFive?: InputMaybe<IntWithAggregatesFilter>;
  traineeEventId?: InputMaybe<IntWithAggregatesFilter>;
  trainerEventId?: InputMaybe<IntWithAggregatesFilter>;
  why?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type TraineeTrainerReviewSumAggregateOutputType = {
  __typename?: 'TraineeTrainerReviewSumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
  reviewOfFive?: Maybe<Scalars['Int']>;
  traineeEventId?: Maybe<Scalars['Int']>;
  trainerEventId?: Maybe<Scalars['Int']>;
};

export type TraineeTrainerReviewSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  reviewOfFive?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
};

export type TraineeTrainerReviewTraineeEventIdTrainerEventIdCompoundUniqueInput = {
  traineeEventId: Scalars['Int'];
  trainerEventId: Scalars['Int'];
};

export type TraineeTrainerReviewUncheckedCreateInput = {
  choices?: InputMaybe<TraineeTrainerReviewChoiceUncheckedCreateNestedManyWithoutReviewsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  reviewOfFive: Scalars['Int'];
  traineeEventId: Scalars['Int'];
  trainerEventId: Scalars['Int'];
  why?: InputMaybe<Scalars['String']>;
};

export type TraineeTrainerReviewUncheckedCreateNestedManyWithoutChoicesInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewCreateOrConnectWithoutChoicesInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewCreateWithoutChoicesInput>>>;
};

export type TraineeTrainerReviewUncheckedCreateNestedManyWithoutTraineeEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewCreateOrConnectWithoutTraineeEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewCreateWithoutTraineeEventInput>>>;
  createMany?: InputMaybe<TraineeTrainerReviewCreateManyTraineeEventInputEnvelope>;
};

export type TraineeTrainerReviewUncheckedCreateNestedManyWithoutTrainerEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewCreateOrConnectWithoutTrainerEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewCreateWithoutTrainerEventInput>>>;
  createMany?: InputMaybe<TraineeTrainerReviewCreateManyTrainerEventInputEnvelope>;
};

export type TraineeTrainerReviewUncheckedCreateWithoutChoicesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  reviewOfFive: Scalars['Int'];
  traineeEventId: Scalars['Int'];
  trainerEventId: Scalars['Int'];
  why?: InputMaybe<Scalars['String']>;
};

export type TraineeTrainerReviewUncheckedCreateWithoutTraineeEventInput = {
  choices?: InputMaybe<TraineeTrainerReviewChoiceUncheckedCreateNestedManyWithoutReviewsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  reviewOfFive: Scalars['Int'];
  trainerEventId: Scalars['Int'];
  why?: InputMaybe<Scalars['String']>;
};

export type TraineeTrainerReviewUncheckedCreateWithoutTrainerEventInput = {
  choices?: InputMaybe<TraineeTrainerReviewChoiceUncheckedCreateNestedManyWithoutReviewsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  reviewOfFive: Scalars['Int'];
  traineeEventId: Scalars['Int'];
  why?: InputMaybe<Scalars['String']>;
};

export type TraineeTrainerReviewUncheckedUpdateInput = {
  choices?: InputMaybe<TraineeTrainerReviewChoiceUncheckedUpdateManyWithoutReviewsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  reviewOfFive?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  why?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeTrainerReviewUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  reviewOfFive?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  why?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeTrainerReviewUncheckedUpdateManyWithoutChoicesInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewCreateOrConnectWithoutChoicesInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewCreateWithoutChoicesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewUpdateWithWhereUniqueWithoutChoicesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewUpdateManyWithWhereWithoutChoicesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewUpsertWithWhereUniqueWithoutChoicesInput>>>;
};

export type TraineeTrainerReviewUncheckedUpdateManyWithoutReviewsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  reviewOfFive?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  why?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeTrainerReviewUncheckedUpdateManyWithoutTraineeEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewCreateOrConnectWithoutTraineeEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewCreateWithoutTraineeEventInput>>>;
  createMany?: InputMaybe<TraineeTrainerReviewCreateManyTraineeEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewUpdateWithWhereUniqueWithoutTraineeEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewUpdateManyWithWhereWithoutTraineeEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewUpsertWithWhereUniqueWithoutTraineeEventInput>>>;
};

export type TraineeTrainerReviewUncheckedUpdateManyWithoutTraineeTrainerReviewsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  reviewOfFive?: InputMaybe<IntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  why?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeTrainerReviewUncheckedUpdateManyWithoutTrainerEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewCreateOrConnectWithoutTrainerEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewCreateWithoutTrainerEventInput>>>;
  createMany?: InputMaybe<TraineeTrainerReviewCreateManyTrainerEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewUpdateWithWhereUniqueWithoutTrainerEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewUpdateManyWithWhereWithoutTrainerEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewUpsertWithWhereUniqueWithoutTrainerEventInput>>>;
};

export type TraineeTrainerReviewUncheckedUpdateWithoutChoicesInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  reviewOfFive?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  why?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeTrainerReviewUncheckedUpdateWithoutTraineeEventInput = {
  choices?: InputMaybe<TraineeTrainerReviewChoiceUncheckedUpdateManyWithoutReviewsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  reviewOfFive?: InputMaybe<IntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  why?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeTrainerReviewUncheckedUpdateWithoutTrainerEventInput = {
  choices?: InputMaybe<TraineeTrainerReviewChoiceUncheckedUpdateManyWithoutReviewsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  reviewOfFive?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  why?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeTrainerReviewUpdateInput = {
  choices?: InputMaybe<TraineeTrainerReviewChoiceUpdateManyWithoutReviewsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reviewOfFive?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeEvent?: InputMaybe<TraineeEventUpdateOneRequiredWithoutTraineeTrainerReviewsInput>;
  trainerEvent?: InputMaybe<TrainerEventUpdateOneRequiredWithoutTraineeTrainerReviewsInput>;
  why?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeTrainerReviewUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reviewOfFive?: InputMaybe<IntFieldUpdateOperationsInput>;
  why?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeTrainerReviewUpdateManyWithWhereWithoutChoicesInput = {
  data: TraineeTrainerReviewUncheckedUpdateManyWithoutReviewsInput;
  where: TraineeTrainerReviewScalarWhereInput;
};

export type TraineeTrainerReviewUpdateManyWithWhereWithoutTraineeEventInput = {
  data: TraineeTrainerReviewUncheckedUpdateManyWithoutTraineeTrainerReviewsInput;
  where: TraineeTrainerReviewScalarWhereInput;
};

export type TraineeTrainerReviewUpdateManyWithWhereWithoutTrainerEventInput = {
  data: TraineeTrainerReviewUncheckedUpdateManyWithoutTraineeTrainerReviewsInput;
  where: TraineeTrainerReviewScalarWhereInput;
};

export type TraineeTrainerReviewUpdateManyWithoutChoicesInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewCreateOrConnectWithoutChoicesInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewCreateWithoutChoicesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewUpdateWithWhereUniqueWithoutChoicesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewUpdateManyWithWhereWithoutChoicesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewUpsertWithWhereUniqueWithoutChoicesInput>>>;
};

export type TraineeTrainerReviewUpdateManyWithoutTraineeEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewCreateOrConnectWithoutTraineeEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewCreateWithoutTraineeEventInput>>>;
  createMany?: InputMaybe<TraineeTrainerReviewCreateManyTraineeEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewUpdateWithWhereUniqueWithoutTraineeEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewUpdateManyWithWhereWithoutTraineeEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewUpsertWithWhereUniqueWithoutTraineeEventInput>>>;
};

export type TraineeTrainerReviewUpdateManyWithoutTrainerEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewCreateOrConnectWithoutTrainerEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewCreateWithoutTrainerEventInput>>>;
  createMany?: InputMaybe<TraineeTrainerReviewCreateManyTrainerEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewUpdateWithWhereUniqueWithoutTrainerEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewUpdateManyWithWhereWithoutTrainerEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewUpsertWithWhereUniqueWithoutTrainerEventInput>>>;
};

export type TraineeTrainerReviewUpdateWithWhereUniqueWithoutChoicesInput = {
  data: TraineeTrainerReviewUncheckedUpdateWithoutChoicesInput;
  where: TraineeTrainerReviewWhereUniqueInput;
};

export type TraineeTrainerReviewUpdateWithWhereUniqueWithoutTraineeEventInput = {
  data: TraineeTrainerReviewUncheckedUpdateWithoutTraineeEventInput;
  where: TraineeTrainerReviewWhereUniqueInput;
};

export type TraineeTrainerReviewUpdateWithWhereUniqueWithoutTrainerEventInput = {
  data: TraineeTrainerReviewUncheckedUpdateWithoutTrainerEventInput;
  where: TraineeTrainerReviewWhereUniqueInput;
};

export type TraineeTrainerReviewUpdateWithoutChoicesInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reviewOfFive?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeEvent?: InputMaybe<TraineeEventUpdateOneRequiredWithoutTraineeTrainerReviewsInput>;
  trainerEvent?: InputMaybe<TrainerEventUpdateOneRequiredWithoutTraineeTrainerReviewsInput>;
  why?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeTrainerReviewUpdateWithoutTraineeEventInput = {
  choices?: InputMaybe<TraineeTrainerReviewChoiceUpdateManyWithoutReviewsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reviewOfFive?: InputMaybe<IntFieldUpdateOperationsInput>;
  trainerEvent?: InputMaybe<TrainerEventUpdateOneRequiredWithoutTraineeTrainerReviewsInput>;
  why?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeTrainerReviewUpdateWithoutTrainerEventInput = {
  choices?: InputMaybe<TraineeTrainerReviewChoiceUpdateManyWithoutReviewsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reviewOfFive?: InputMaybe<IntFieldUpdateOperationsInput>;
  traineeEvent?: InputMaybe<TraineeEventUpdateOneRequiredWithoutTraineeTrainerReviewsInput>;
  why?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TraineeTrainerReviewUpsertWithWhereUniqueWithoutChoicesInput = {
  create: TraineeTrainerReviewUncheckedCreateWithoutChoicesInput;
  update: TraineeTrainerReviewUncheckedUpdateWithoutChoicesInput;
  where: TraineeTrainerReviewWhereUniqueInput;
};

export type TraineeTrainerReviewUpsertWithWhereUniqueWithoutTraineeEventInput = {
  create: TraineeTrainerReviewUncheckedCreateWithoutTraineeEventInput;
  update: TraineeTrainerReviewUncheckedUpdateWithoutTraineeEventInput;
  where: TraineeTrainerReviewWhereUniqueInput;
};

export type TraineeTrainerReviewUpsertWithWhereUniqueWithoutTrainerEventInput = {
  create: TraineeTrainerReviewUncheckedCreateWithoutTrainerEventInput;
  update: TraineeTrainerReviewUncheckedUpdateWithoutTrainerEventInput;
  where: TraineeTrainerReviewWhereUniqueInput;
};

export type TraineeTrainerReviewWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TraineeTrainerReviewWhereInput>>>;
  choices?: InputMaybe<TraineeTrainerReviewChoiceListRelationFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  reviewOfFive?: InputMaybe<IntFilter>;
  traineeEvent?: InputMaybe<TraineeEventWhereInput>;
  traineeEventId?: InputMaybe<IntFilter>;
  trainerEvent?: InputMaybe<TrainerEventWhereInput>;
  trainerEventId?: InputMaybe<IntFilter>;
  why?: InputMaybe<StringNullableFilter>;
};

export type TraineeTrainerReviewWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  traineeEventId_trainerEventId?: InputMaybe<TraineeTrainerReviewTraineeEventIdTrainerEventIdCompoundUniqueInput>;
};

export type TraineesReport = {
  __typename?: 'TraineesReport';
  genderRecord: Array<GenderRecord>;
  regionRecord: Array<RegionRecord>;
  usersWithNamesRecord: Scalars['Int'];
};

export type TraineesReportUniqueObject = {
  greaterDate?: InputMaybe<Scalars['DateTime']>;
  smallerDate?: InputMaybe<Scalars['DateTime']>;
  variance: Variance;
};

export type TrainerEvent = {
  __typename?: 'TrainerEvent';
  Certificate?: Maybe<Certificate>;
  StudyMaterials: Array<TrainerEventStudyMaterial>;
  _count: TrainerEventCountOutputType;
  contentIsAdded?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dayLessons: Array<TrainerEventDayLesson>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailState?: Maybe<Scalars['Json']>;
  event: Event;
  eventId: Scalars['Int'];
  id: Scalars['Int'];
  introductionAr?: Maybe<Scalars['String']>;
  introductionEn?: Maybe<Scalars['String']>;
  isAllProfessionsTargeted?: Maybe<Scalars['Boolean']>;
  joinUrl?: Maybe<Scalars['String']>;
  mainThemeAr?: Maybe<Scalars['String']>;
  mainThemeEn?: Maybe<Scalars['String']>;
  objectivesAr?: Maybe<Scalars['String']>;
  objectivesEn?: Maybe<Scalars['String']>;
  outcomesAr?: Maybe<Scalars['String']>;
  outcomesEn?: Maybe<Scalars['String']>;
  registrantId?: Maybe<Scalars['String']>;
  targetedAudiences: Array<Profession>;
  targetedSpecialities: Array<Specialty>;
  timeSlots: Array<TrainerEventDayTimeSlot>;
  toTransferAmount?: Maybe<Scalars['Decimal']>;
  toTransferType?: Maybe<ToTransferType>;
  traineeTrainerReviews: Array<TraineeTrainerReview>;
  trainer?: Maybe<User>;
  trainerId: Scalars['Int'];
  transitions: Array<Transition>;
  whyTargetedAudienceAr?: Maybe<Scalars['String']>;
  whyTargetedAudienceEn?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['String']>;
};


export type TrainerEventStudyMaterialsArgs = {
  cursor?: InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>;
  distinct?: InputMaybe<TrainerEventStudyMaterialScalarFieldEnum>;
  orderBy?: InputMaybe<TrainerEventStudyMaterialOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TrainerEventStudyMaterialWhereInput>;
};


export type TrainerEventDayLessonsArgs = {
  cursor?: InputMaybe<TrainerEventDayLessonWhereUniqueInput>;
  distinct?: InputMaybe<TrainerEventDayLessonScalarFieldEnum>;
  orderBy?: InputMaybe<TrainerEventDayLessonOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TrainerEventDayLessonWhereInput>;
};


export type TrainerEventTargetedAudiencesArgs = {
  cursor?: InputMaybe<ProfessionWhereUniqueInput>;
  distinct?: InputMaybe<ProfessionScalarFieldEnum>;
  orderBy?: InputMaybe<ProfessionOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProfessionWhereInput>;
};


export type TrainerEventTargetedSpecialitiesArgs = {
  cursor?: InputMaybe<SpecialtyWhereUniqueInput>;
  distinct?: InputMaybe<SpecialtyScalarFieldEnum>;
  orderBy?: InputMaybe<SpecialtyOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SpecialtyWhereInput>;
};


export type TrainerEventTimeSlotsArgs = {
  cursor?: InputMaybe<TrainerEventDayTimeSlotWhereUniqueInput>;
  distinct?: InputMaybe<TrainerEventDayTimeSlotScalarFieldEnum>;
  orderBy?: InputMaybe<TrainerEventDayTimeSlotOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TrainerEventDayTimeSlotWhereInput>;
};


export type TrainerEventTraineeTrainerReviewsArgs = {
  cursor?: InputMaybe<TraineeTrainerReviewWhereUniqueInput>;
  distinct?: InputMaybe<TraineeTrainerReviewScalarFieldEnum>;
  orderBy?: InputMaybe<TraineeTrainerReviewOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeTrainerReviewWhereInput>;
};


export type TrainerEventTransitionsArgs = {
  cursor?: InputMaybe<TransitionWhereUniqueInput>;
  distinct?: InputMaybe<TransitionScalarFieldEnum>;
  orderBy?: InputMaybe<TransitionOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TransitionWhereInput>;
};

export type TrainerEventAvgAggregateOutputType = {
  __typename?: 'TrainerEventAvgAggregateOutputType';
  eventId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  toTransferAmount?: Maybe<Scalars['Decimal']>;
  trainerId?: Maybe<Scalars['Float']>;
};

export type TrainerEventAvgOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  toTransferAmount?: InputMaybe<SortOrder>;
  trainerId?: InputMaybe<SortOrder>;
};

export type TrainerEventCountAggregateOutputType = {
  __typename?: 'TrainerEventCountAggregateOutputType';
  _all: Scalars['Int'];
  contentIsAdded: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  emailState: Scalars['Int'];
  eventId: Scalars['Int'];
  id: Scalars['Int'];
  introductionAr: Scalars['Int'];
  introductionEn: Scalars['Int'];
  isAllProfessionsTargeted: Scalars['Int'];
  joinUrl: Scalars['Int'];
  mainThemeAr: Scalars['Int'];
  mainThemeEn: Scalars['Int'];
  objectivesAr: Scalars['Int'];
  objectivesEn: Scalars['Int'];
  outcomesAr: Scalars['Int'];
  outcomesEn: Scalars['Int'];
  registrantId: Scalars['Int'];
  toTransferAmount: Scalars['Int'];
  toTransferType: Scalars['Int'];
  trainerId: Scalars['Int'];
  whyTargetedAudienceAr: Scalars['Int'];
  whyTargetedAudienceEn: Scalars['Int'];
  youtubeUrl: Scalars['Int'];
};

export type TrainerEventCountOrderByAggregateInput = {
  contentIsAdded?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  emailState?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  introductionAr?: InputMaybe<SortOrder>;
  introductionEn?: InputMaybe<SortOrder>;
  isAllProfessionsTargeted?: InputMaybe<SortOrder>;
  joinUrl?: InputMaybe<SortOrder>;
  mainThemeAr?: InputMaybe<SortOrder>;
  mainThemeEn?: InputMaybe<SortOrder>;
  objectivesAr?: InputMaybe<SortOrder>;
  objectivesEn?: InputMaybe<SortOrder>;
  outcomesAr?: InputMaybe<SortOrder>;
  outcomesEn?: InputMaybe<SortOrder>;
  registrantId?: InputMaybe<SortOrder>;
  toTransferAmount?: InputMaybe<SortOrder>;
  toTransferType?: InputMaybe<SortOrder>;
  trainerId?: InputMaybe<SortOrder>;
  whyTargetedAudienceAr?: InputMaybe<SortOrder>;
  whyTargetedAudienceEn?: InputMaybe<SortOrder>;
  youtubeUrl?: InputMaybe<SortOrder>;
};

export type TrainerEventCountOutputType = {
  __typename?: 'TrainerEventCountOutputType';
  StudyMaterials: Scalars['Int'];
  ZohoEmail: Scalars['Int'];
  dayLessons: Scalars['Int'];
  targetedAudiences: Scalars['Int'];
  targetedSpecialities: Scalars['Int'];
  timeSlots: Scalars['Int'];
  traineeTrainerReviews: Scalars['Int'];
  transitions: Scalars['Int'];
};

export type TrainerEventCreateInput = {
  Certificate?: InputMaybe<CertificateCreateNestedOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dayLessons?: InputMaybe<TrainerEventDayLessonCreateNestedManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  event: EventCreateNestedOneWithoutTrainerEventsInput;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  registrantId?: InputMaybe<Scalars['String']>;
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<Scalars['Decimal']>;
  toTransferType?: InputMaybe<ToTransferType>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewCreateNestedManyWithoutTrainerEventInput>;
  trainer: UserCreateNestedOneWithoutTrainerEventsInput;
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

export type TrainerEventCreateManyEventInput = {
  contentIsAdded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  id?: InputMaybe<Scalars['Int']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  registrantId?: InputMaybe<Scalars['String']>;
  toTransferAmount?: InputMaybe<Scalars['Decimal']>;
  toTransferType?: InputMaybe<ToTransferType>;
  trainerId: Scalars['Int'];
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

export type TrainerEventCreateManyEventInputEnvelope = {
  data: TrainerEventCreateManyEventInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TrainerEventCreateManyInput = {
  contentIsAdded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  registrantId?: InputMaybe<Scalars['String']>;
  toTransferAmount?: InputMaybe<Scalars['Decimal']>;
  toTransferType?: InputMaybe<ToTransferType>;
  trainerId: Scalars['Int'];
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

export type TrainerEventCreateManyTrainerInput = {
  contentIsAdded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  registrantId?: InputMaybe<Scalars['String']>;
  toTransferAmount?: InputMaybe<Scalars['Decimal']>;
  toTransferType?: InputMaybe<ToTransferType>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

export type TrainerEventCreateManyTrainerInputEnvelope = {
  data: TrainerEventCreateManyTrainerInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TrainerEventCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventCreateWithoutEventInput>>>;
  createMany?: InputMaybe<TrainerEventCreateManyEventInputEnvelope>;
};

export type TrainerEventCreateNestedManyWithoutTargetedAudiencesInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventCreateOrConnectWithoutTargetedAudiencesInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventCreateWithoutTargetedAudiencesInput>>>;
};

export type TrainerEventCreateNestedManyWithoutTargetedSpecialitiesInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventCreateOrConnectWithoutTargetedSpecialitiesInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventCreateWithoutTargetedSpecialitiesInput>>>;
};

export type TrainerEventCreateNestedManyWithoutTrainerInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventCreateOrConnectWithoutTrainerInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventCreateWithoutTrainerInput>>>;
  createMany?: InputMaybe<TrainerEventCreateManyTrainerInputEnvelope>;
};

export type TrainerEventCreateNestedOneWithoutCertificateInput = {
  connect?: InputMaybe<TrainerEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TrainerEventCreateOrConnectWithoutCertificateInput>;
  create?: InputMaybe<TrainerEventUncheckedCreateWithoutCertificateInput>;
};

export type TrainerEventCreateNestedOneWithoutDayLessonsInput = {
  connect?: InputMaybe<TrainerEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TrainerEventCreateOrConnectWithoutDayLessonsInput>;
  create?: InputMaybe<TrainerEventUncheckedCreateWithoutDayLessonsInput>;
};

export type TrainerEventCreateNestedOneWithoutStudyMaterialsInput = {
  connect?: InputMaybe<TrainerEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TrainerEventCreateOrConnectWithoutStudyMaterialsInput>;
  create?: InputMaybe<TrainerEventUncheckedCreateWithoutStudyMaterialsInput>;
};

export type TrainerEventCreateNestedOneWithoutTimeSlotsInput = {
  connect?: InputMaybe<TrainerEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TrainerEventCreateOrConnectWithoutTimeSlotsInput>;
  create?: InputMaybe<TrainerEventUncheckedCreateWithoutTimeSlotsInput>;
};

export type TrainerEventCreateNestedOneWithoutTraineeTrainerReviewsInput = {
  connect?: InputMaybe<TrainerEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TrainerEventCreateOrConnectWithoutTraineeTrainerReviewsInput>;
  create?: InputMaybe<TrainerEventUncheckedCreateWithoutTraineeTrainerReviewsInput>;
};

export type TrainerEventCreateNestedOneWithoutTransitionsInput = {
  connect?: InputMaybe<TrainerEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TrainerEventCreateOrConnectWithoutTransitionsInput>;
  create?: InputMaybe<TrainerEventUncheckedCreateWithoutTransitionsInput>;
};

export type TrainerEventCreateNestedOneWithoutZohoEmailInput = {
  connect?: InputMaybe<TrainerEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TrainerEventCreateOrConnectWithoutZohoEmailInput>;
  create?: InputMaybe<TrainerEventUncheckedCreateWithoutZohoEmailInput>;
};

export type TrainerEventCreateOrConnectWithoutCertificateInput = {
  create: TrainerEventUncheckedCreateWithoutCertificateInput;
  where: TrainerEventWhereUniqueInput;
};

export type TrainerEventCreateOrConnectWithoutDayLessonsInput = {
  create: TrainerEventUncheckedCreateWithoutDayLessonsInput;
  where: TrainerEventWhereUniqueInput;
};

export type TrainerEventCreateOrConnectWithoutEventInput = {
  create: TrainerEventUncheckedCreateWithoutEventInput;
  where: TrainerEventWhereUniqueInput;
};

export type TrainerEventCreateOrConnectWithoutStudyMaterialsInput = {
  create: TrainerEventUncheckedCreateWithoutStudyMaterialsInput;
  where: TrainerEventWhereUniqueInput;
};

export type TrainerEventCreateOrConnectWithoutTargetedAudiencesInput = {
  create: TrainerEventUncheckedCreateWithoutTargetedAudiencesInput;
  where: TrainerEventWhereUniqueInput;
};

export type TrainerEventCreateOrConnectWithoutTargetedSpecialitiesInput = {
  create: TrainerEventUncheckedCreateWithoutTargetedSpecialitiesInput;
  where: TrainerEventWhereUniqueInput;
};

export type TrainerEventCreateOrConnectWithoutTimeSlotsInput = {
  create: TrainerEventUncheckedCreateWithoutTimeSlotsInput;
  where: TrainerEventWhereUniqueInput;
};

export type TrainerEventCreateOrConnectWithoutTraineeTrainerReviewsInput = {
  create: TrainerEventUncheckedCreateWithoutTraineeTrainerReviewsInput;
  where: TrainerEventWhereUniqueInput;
};

export type TrainerEventCreateOrConnectWithoutTrainerInput = {
  create: TrainerEventUncheckedCreateWithoutTrainerInput;
  where: TrainerEventWhereUniqueInput;
};

export type TrainerEventCreateOrConnectWithoutTransitionsInput = {
  create: TrainerEventUncheckedCreateWithoutTransitionsInput;
  where: TrainerEventWhereUniqueInput;
};

export type TrainerEventCreateOrConnectWithoutZohoEmailInput = {
  create: TrainerEventUncheckedCreateWithoutZohoEmailInput;
  where: TrainerEventWhereUniqueInput;
};

export type TrainerEventCreateWithoutCertificateInput = {
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dayLessons?: InputMaybe<TrainerEventDayLessonCreateNestedManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  event: EventCreateNestedOneWithoutTrainerEventsInput;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  registrantId?: InputMaybe<Scalars['String']>;
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<Scalars['Decimal']>;
  toTransferType?: InputMaybe<ToTransferType>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewCreateNestedManyWithoutTrainerEventInput>;
  trainer: UserCreateNestedOneWithoutTrainerEventsInput;
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

export type TrainerEventCreateWithoutDayLessonsInput = {
  Certificate?: InputMaybe<CertificateCreateNestedOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  event: EventCreateNestedOneWithoutTrainerEventsInput;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  registrantId?: InputMaybe<Scalars['String']>;
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<Scalars['Decimal']>;
  toTransferType?: InputMaybe<ToTransferType>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewCreateNestedManyWithoutTrainerEventInput>;
  trainer: UserCreateNestedOneWithoutTrainerEventsInput;
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

export type TrainerEventCreateWithoutEventInput = {
  Certificate?: InputMaybe<CertificateCreateNestedOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dayLessons?: InputMaybe<TrainerEventDayLessonCreateNestedManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  registrantId?: InputMaybe<Scalars['String']>;
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<Scalars['Decimal']>;
  toTransferType?: InputMaybe<ToTransferType>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewCreateNestedManyWithoutTrainerEventInput>;
  trainer: UserCreateNestedOneWithoutTrainerEventsInput;
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

export type TrainerEventCreateWithoutStudyMaterialsInput = {
  Certificate?: InputMaybe<CertificateCreateNestedOneWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dayLessons?: InputMaybe<TrainerEventDayLessonCreateNestedManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  event: EventCreateNestedOneWithoutTrainerEventsInput;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  registrantId?: InputMaybe<Scalars['String']>;
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<Scalars['Decimal']>;
  toTransferType?: InputMaybe<ToTransferType>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewCreateNestedManyWithoutTrainerEventInput>;
  trainer: UserCreateNestedOneWithoutTrainerEventsInput;
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

export type TrainerEventCreateWithoutTargetedAudiencesInput = {
  Certificate?: InputMaybe<CertificateCreateNestedOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dayLessons?: InputMaybe<TrainerEventDayLessonCreateNestedManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  event: EventCreateNestedOneWithoutTrainerEventsInput;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  registrantId?: InputMaybe<Scalars['String']>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<Scalars['Decimal']>;
  toTransferType?: InputMaybe<ToTransferType>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewCreateNestedManyWithoutTrainerEventInput>;
  trainer: UserCreateNestedOneWithoutTrainerEventsInput;
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

export type TrainerEventCreateWithoutTargetedSpecialitiesInput = {
  Certificate?: InputMaybe<CertificateCreateNestedOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dayLessons?: InputMaybe<TrainerEventDayLessonCreateNestedManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  event: EventCreateNestedOneWithoutTrainerEventsInput;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  registrantId?: InputMaybe<Scalars['String']>;
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutTrainerEventsInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<Scalars['Decimal']>;
  toTransferType?: InputMaybe<ToTransferType>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewCreateNestedManyWithoutTrainerEventInput>;
  trainer: UserCreateNestedOneWithoutTrainerEventsInput;
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

export type TrainerEventCreateWithoutTimeSlotsInput = {
  Certificate?: InputMaybe<CertificateCreateNestedOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dayLessons?: InputMaybe<TrainerEventDayLessonCreateNestedManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  event: EventCreateNestedOneWithoutTrainerEventsInput;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  registrantId?: InputMaybe<Scalars['String']>;
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<Scalars['Decimal']>;
  toTransferType?: InputMaybe<ToTransferType>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewCreateNestedManyWithoutTrainerEventInput>;
  trainer: UserCreateNestedOneWithoutTrainerEventsInput;
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

export type TrainerEventCreateWithoutTraineeTrainerReviewsInput = {
  Certificate?: InputMaybe<CertificateCreateNestedOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dayLessons?: InputMaybe<TrainerEventDayLessonCreateNestedManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  event: EventCreateNestedOneWithoutTrainerEventsInput;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  registrantId?: InputMaybe<Scalars['String']>;
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<Scalars['Decimal']>;
  toTransferType?: InputMaybe<ToTransferType>;
  trainer: UserCreateNestedOneWithoutTrainerEventsInput;
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

export type TrainerEventCreateWithoutTrainerInput = {
  Certificate?: InputMaybe<CertificateCreateNestedOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dayLessons?: InputMaybe<TrainerEventDayLessonCreateNestedManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  event: EventCreateNestedOneWithoutTrainerEventsInput;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  registrantId?: InputMaybe<Scalars['String']>;
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<Scalars['Decimal']>;
  toTransferType?: InputMaybe<ToTransferType>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewCreateNestedManyWithoutTrainerEventInput>;
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

export type TrainerEventCreateWithoutTransitionsInput = {
  Certificate?: InputMaybe<CertificateCreateNestedOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dayLessons?: InputMaybe<TrainerEventDayLessonCreateNestedManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  event: EventCreateNestedOneWithoutTrainerEventsInput;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  registrantId?: InputMaybe<Scalars['String']>;
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<Scalars['Decimal']>;
  toTransferType?: InputMaybe<ToTransferType>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewCreateNestedManyWithoutTrainerEventInput>;
  trainer: UserCreateNestedOneWithoutTrainerEventsInput;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

export type TrainerEventCreateWithoutZohoEmailInput = {
  Certificate?: InputMaybe<CertificateCreateNestedOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dayLessons?: InputMaybe<TrainerEventDayLessonCreateNestedManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  event: EventCreateNestedOneWithoutTrainerEventsInput;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  registrantId?: InputMaybe<Scalars['String']>;
  targetedAudiences?: InputMaybe<ProfessionCreateNestedManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyCreateNestedManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<Scalars['Decimal']>;
  toTransferType?: InputMaybe<ToTransferType>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewCreateNestedManyWithoutTrainerEventInput>;
  trainer: UserCreateNestedOneWithoutTrainerEventsInput;
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

export type TrainerEventDayLesson = {
  __typename?: 'TrainerEventDayLesson';
  TrainerEventDayLessonType: TrainerEventDayLessonType;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventDay: EventDay;
  eventDayId: Scalars['Int'];
  id: Scalars['Int'];
  methodOfTeaching?: Maybe<MethodOfTeachingType>;
  methodOfTeachingTypeId?: Maybe<Scalars['Int']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  startTime: Scalars['DateTime'];
  trainerEvent?: Maybe<TrainerEvent>;
  trainerEventDayLessonTypeId: Scalars['Int'];
  trainerEventId?: Maybe<Scalars['Int']>;
};

export type TrainerEventDayLessonAvgAggregateOutputType = {
  __typename?: 'TrainerEventDayLessonAvgAggregateOutputType';
  eventDayId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  methodOfTeachingTypeId?: Maybe<Scalars['Float']>;
  trainerEventDayLessonTypeId?: Maybe<Scalars['Float']>;
  trainerEventId?: Maybe<Scalars['Float']>;
};

export type TrainerEventDayLessonAvgOrderByAggregateInput = {
  eventDayId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  methodOfTeachingTypeId?: InputMaybe<SortOrder>;
  trainerEventDayLessonTypeId?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
};

export type TrainerEventDayLessonCountAggregateOutputType = {
  __typename?: 'TrainerEventDayLessonCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  endTime: Scalars['Int'];
  eventDayId: Scalars['Int'];
  id: Scalars['Int'];
  methodOfTeachingTypeId: Scalars['Int'];
  outlineAr: Scalars['Int'];
  outlineEn: Scalars['Int'];
  startTime: Scalars['Int'];
  trainerEventDayLessonTypeId: Scalars['Int'];
  trainerEventId: Scalars['Int'];
};

export type TrainerEventDayLessonCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  eventDayId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  methodOfTeachingTypeId?: InputMaybe<SortOrder>;
  outlineAr?: InputMaybe<SortOrder>;
  outlineEn?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  trainerEventDayLessonTypeId?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
};

export type TrainerEventDayLessonCreateInput = {
  TrainerEventDayLessonType: TrainerEventDayLessonTypeCreateNestedOneWithoutLessonsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventDay: EventDayCreateNestedOneWithoutTrainerLessonsInput;
  methodOfTeaching?: InputMaybe<MethodOfTeachingTypeCreateNestedOneWithoutLessonsInput>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  startTime: Scalars['DateTime'];
  trainerEvent?: InputMaybe<TrainerEventCreateNestedOneWithoutDayLessonsInput>;
};

export type TrainerEventDayLessonCreateManyEventDayInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  id?: InputMaybe<Scalars['Int']>;
  methodOfTeachingTypeId?: InputMaybe<Scalars['Int']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  startTime: Scalars['DateTime'];
  trainerEventDayLessonTypeId: Scalars['Int'];
  trainerEventId?: InputMaybe<Scalars['Int']>;
};

export type TrainerEventDayLessonCreateManyEventDayInputEnvelope = {
  data: TrainerEventDayLessonCreateManyEventDayInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TrainerEventDayLessonCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventDayId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  methodOfTeachingTypeId?: InputMaybe<Scalars['Int']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  startTime: Scalars['DateTime'];
  trainerEventDayLessonTypeId: Scalars['Int'];
  trainerEventId?: InputMaybe<Scalars['Int']>;
};

export type TrainerEventDayLessonCreateManyMethodOfTeachingInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventDayId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  startTime: Scalars['DateTime'];
  trainerEventDayLessonTypeId: Scalars['Int'];
  trainerEventId?: InputMaybe<Scalars['Int']>;
};

export type TrainerEventDayLessonCreateManyMethodOfTeachingInputEnvelope = {
  data: TrainerEventDayLessonCreateManyMethodOfTeachingInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TrainerEventDayLessonCreateManyTrainerEventDayLessonTypeInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventDayId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  methodOfTeachingTypeId?: InputMaybe<Scalars['Int']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  startTime: Scalars['DateTime'];
  trainerEventId?: InputMaybe<Scalars['Int']>;
};

export type TrainerEventDayLessonCreateManyTrainerEventDayLessonTypeInputEnvelope = {
  data: TrainerEventDayLessonCreateManyTrainerEventDayLessonTypeInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TrainerEventDayLessonCreateManyTrainerEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventDayId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  methodOfTeachingTypeId?: InputMaybe<Scalars['Int']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  startTime: Scalars['DateTime'];
  trainerEventDayLessonTypeId: Scalars['Int'];
};

export type TrainerEventDayLessonCreateManyTrainerEventInputEnvelope = {
  data: TrainerEventDayLessonCreateManyTrainerEventInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TrainerEventDayLessonCreateNestedManyWithoutEventDayInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonCreateOrConnectWithoutEventDayInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonCreateWithoutEventDayInput>>>;
  createMany?: InputMaybe<TrainerEventDayLessonCreateManyEventDayInputEnvelope>;
};

export type TrainerEventDayLessonCreateNestedManyWithoutMethodOfTeachingInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonCreateOrConnectWithoutMethodOfTeachingInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonCreateWithoutMethodOfTeachingInput>>>;
  createMany?: InputMaybe<TrainerEventDayLessonCreateManyMethodOfTeachingInputEnvelope>;
};

export type TrainerEventDayLessonCreateNestedManyWithoutTrainerEventDayLessonTypeInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonCreateOrConnectWithoutTrainerEventDayLessonTypeInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonCreateWithoutTrainerEventDayLessonTypeInput>>>;
  createMany?: InputMaybe<TrainerEventDayLessonCreateManyTrainerEventDayLessonTypeInputEnvelope>;
};

export type TrainerEventDayLessonCreateNestedManyWithoutTrainerEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonCreateOrConnectWithoutTrainerEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonCreateWithoutTrainerEventInput>>>;
  createMany?: InputMaybe<TrainerEventDayLessonCreateManyTrainerEventInputEnvelope>;
};

export type TrainerEventDayLessonCreateOrConnectWithoutEventDayInput = {
  create: TrainerEventDayLessonUncheckedCreateWithoutEventDayInput;
  where: TrainerEventDayLessonWhereUniqueInput;
};

export type TrainerEventDayLessonCreateOrConnectWithoutMethodOfTeachingInput = {
  create: TrainerEventDayLessonUncheckedCreateWithoutMethodOfTeachingInput;
  where: TrainerEventDayLessonWhereUniqueInput;
};

export type TrainerEventDayLessonCreateOrConnectWithoutTrainerEventDayLessonTypeInput = {
  create: TrainerEventDayLessonUncheckedCreateWithoutTrainerEventDayLessonTypeInput;
  where: TrainerEventDayLessonWhereUniqueInput;
};

export type TrainerEventDayLessonCreateOrConnectWithoutTrainerEventInput = {
  create: TrainerEventDayLessonUncheckedCreateWithoutTrainerEventInput;
  where: TrainerEventDayLessonWhereUniqueInput;
};

export type TrainerEventDayLessonCreateWithoutEventDayInput = {
  TrainerEventDayLessonType: TrainerEventDayLessonTypeCreateNestedOneWithoutLessonsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  methodOfTeaching?: InputMaybe<MethodOfTeachingTypeCreateNestedOneWithoutLessonsInput>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  startTime: Scalars['DateTime'];
  trainerEvent?: InputMaybe<TrainerEventCreateNestedOneWithoutDayLessonsInput>;
};

export type TrainerEventDayLessonCreateWithoutMethodOfTeachingInput = {
  TrainerEventDayLessonType: TrainerEventDayLessonTypeCreateNestedOneWithoutLessonsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventDay: EventDayCreateNestedOneWithoutTrainerLessonsInput;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  startTime: Scalars['DateTime'];
  trainerEvent?: InputMaybe<TrainerEventCreateNestedOneWithoutDayLessonsInput>;
};

export type TrainerEventDayLessonCreateWithoutTrainerEventDayLessonTypeInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventDay: EventDayCreateNestedOneWithoutTrainerLessonsInput;
  methodOfTeaching?: InputMaybe<MethodOfTeachingTypeCreateNestedOneWithoutLessonsInput>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  startTime: Scalars['DateTime'];
  trainerEvent?: InputMaybe<TrainerEventCreateNestedOneWithoutDayLessonsInput>;
};

export type TrainerEventDayLessonCreateWithoutTrainerEventInput = {
  TrainerEventDayLessonType: TrainerEventDayLessonTypeCreateNestedOneWithoutLessonsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventDay: EventDayCreateNestedOneWithoutTrainerLessonsInput;
  methodOfTeaching?: InputMaybe<MethodOfTeachingTypeCreateNestedOneWithoutLessonsInput>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  startTime: Scalars['DateTime'];
};

export type TrainerEventDayLessonListRelationFilter = {
  every?: InputMaybe<TrainerEventDayLessonWhereInput>;
  none?: InputMaybe<TrainerEventDayLessonWhereInput>;
  some?: InputMaybe<TrainerEventDayLessonWhereInput>;
};

export type TrainerEventDayLessonMaxAggregateOutputType = {
  __typename?: 'TrainerEventDayLessonMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  endTime?: Maybe<Scalars['DateTime']>;
  eventDayId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  methodOfTeachingTypeId?: Maybe<Scalars['Int']>;
  outlineAr?: Maybe<Scalars['String']>;
  outlineEn?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['DateTime']>;
  trainerEventDayLessonTypeId?: Maybe<Scalars['Int']>;
  trainerEventId?: Maybe<Scalars['Int']>;
};

export type TrainerEventDayLessonMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  eventDayId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  methodOfTeachingTypeId?: InputMaybe<SortOrder>;
  outlineAr?: InputMaybe<SortOrder>;
  outlineEn?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  trainerEventDayLessonTypeId?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
};

export type TrainerEventDayLessonMinAggregateOutputType = {
  __typename?: 'TrainerEventDayLessonMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  endTime?: Maybe<Scalars['DateTime']>;
  eventDayId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  methodOfTeachingTypeId?: Maybe<Scalars['Int']>;
  outlineAr?: Maybe<Scalars['String']>;
  outlineEn?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['DateTime']>;
  trainerEventDayLessonTypeId?: Maybe<Scalars['Int']>;
  trainerEventId?: Maybe<Scalars['Int']>;
};

export type TrainerEventDayLessonMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  eventDayId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  methodOfTeachingTypeId?: InputMaybe<SortOrder>;
  outlineAr?: InputMaybe<SortOrder>;
  outlineEn?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  trainerEventDayLessonTypeId?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
};

export type TrainerEventDayLessonOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TrainerEventDayLessonOrderByWithAggregationInput = {
  _avg?: InputMaybe<TrainerEventDayLessonAvgOrderByAggregateInput>;
  _count?: InputMaybe<TrainerEventDayLessonCountOrderByAggregateInput>;
  _max?: InputMaybe<TrainerEventDayLessonMaxOrderByAggregateInput>;
  _min?: InputMaybe<TrainerEventDayLessonMinOrderByAggregateInput>;
  _sum?: InputMaybe<TrainerEventDayLessonSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  eventDayId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  methodOfTeachingTypeId?: InputMaybe<SortOrder>;
  outlineAr?: InputMaybe<SortOrder>;
  outlineEn?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  trainerEventDayLessonTypeId?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
};

export type TrainerEventDayLessonOrderByWithRelationInput = {
  TrainerEventDayLessonType?: InputMaybe<TrainerEventDayLessonTypeOrderByWithRelationInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  eventDay?: InputMaybe<EventDayOrderByWithRelationInput>;
  eventDayId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  methodOfTeaching?: InputMaybe<MethodOfTeachingTypeOrderByWithRelationInput>;
  methodOfTeachingTypeId?: InputMaybe<SortOrder>;
  outlineAr?: InputMaybe<SortOrder>;
  outlineEn?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  trainerEvent?: InputMaybe<TrainerEventOrderByWithRelationInput>;
  trainerEventDayLessonTypeId?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
};

export enum TrainerEventDayLessonScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  EndTime = 'endTime',
  EventDayId = 'eventDayId',
  Id = 'id',
  MethodOfTeachingTypeId = 'methodOfTeachingTypeId',
  OutlineAr = 'outlineAr',
  OutlineEn = 'outlineEn',
  StartTime = 'startTime',
  TrainerEventDayLessonTypeId = 'trainerEventDayLessonTypeId',
  TrainerEventId = 'trainerEventId'
}

export type TrainerEventDayLessonScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonScalarWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  endTime?: InputMaybe<DateTimeFilter>;
  eventDayId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  methodOfTeachingTypeId?: InputMaybe<IntNullableFilter>;
  outlineAr?: InputMaybe<StringFilter>;
  outlineEn?: InputMaybe<StringFilter>;
  startTime?: InputMaybe<DateTimeFilter>;
  trainerEventDayLessonTypeId?: InputMaybe<IntFilter>;
  trainerEventId?: InputMaybe<IntNullableFilter>;
};

export type TrainerEventDayLessonScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  endTime?: InputMaybe<DateTimeWithAggregatesFilter>;
  eventDayId?: InputMaybe<IntWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  methodOfTeachingTypeId?: InputMaybe<IntNullableWithAggregatesFilter>;
  outlineAr?: InputMaybe<StringWithAggregatesFilter>;
  outlineEn?: InputMaybe<StringWithAggregatesFilter>;
  startTime?: InputMaybe<DateTimeWithAggregatesFilter>;
  trainerEventDayLessonTypeId?: InputMaybe<IntWithAggregatesFilter>;
  trainerEventId?: InputMaybe<IntNullableWithAggregatesFilter>;
};

export type TrainerEventDayLessonSumAggregateOutputType = {
  __typename?: 'TrainerEventDayLessonSumAggregateOutputType';
  eventDayId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  methodOfTeachingTypeId?: Maybe<Scalars['Int']>;
  trainerEventDayLessonTypeId?: Maybe<Scalars['Int']>;
  trainerEventId?: Maybe<Scalars['Int']>;
};

export type TrainerEventDayLessonSumOrderByAggregateInput = {
  eventDayId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  methodOfTeachingTypeId?: InputMaybe<SortOrder>;
  trainerEventDayLessonTypeId?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
};

export type TrainerEventDayLessonType = {
  __typename?: 'TrainerEventDayLessonType';
  _count: TrainerEventDayLessonTypeCountOutputType;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  lessons: Array<TrainerEventDayLesson>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};


export type TrainerEventDayLessonTypeLessonsArgs = {
  cursor?: InputMaybe<TrainerEventDayLessonWhereUniqueInput>;
  distinct?: InputMaybe<TrainerEventDayLessonScalarFieldEnum>;
  orderBy?: InputMaybe<TrainerEventDayLessonOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TrainerEventDayLessonWhereInput>;
};

export type TrainerEventDayLessonTypeAvgAggregateOutputType = {
  __typename?: 'TrainerEventDayLessonTypeAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
};

export type TrainerEventDayLessonTypeAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type TrainerEventDayLessonTypeCountAggregateOutputType = {
  __typename?: 'TrainerEventDayLessonTypeCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  titleAr: Scalars['Int'];
  titleEn: Scalars['Int'];
};

export type TrainerEventDayLessonTypeCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type TrainerEventDayLessonTypeCountOutputType = {
  __typename?: 'TrainerEventDayLessonTypeCountOutputType';
  lessons: Scalars['Int'];
};

export type TrainerEventDayLessonTypeCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  lessons?: InputMaybe<TrainerEventDayLessonCreateNestedManyWithoutTrainerEventDayLessonTypeInput>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type TrainerEventDayLessonTypeCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type TrainerEventDayLessonTypeCreateNestedOneWithoutLessonsInput = {
  connect?: InputMaybe<TrainerEventDayLessonTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TrainerEventDayLessonTypeCreateOrConnectWithoutLessonsInput>;
  create?: InputMaybe<TrainerEventDayLessonTypeUncheckedCreateWithoutLessonsInput>;
};

export type TrainerEventDayLessonTypeCreateOrConnectWithoutLessonsInput = {
  create: TrainerEventDayLessonTypeUncheckedCreateWithoutLessonsInput;
  where: TrainerEventDayLessonTypeWhereUniqueInput;
};

export type TrainerEventDayLessonTypeCreateWithoutLessonsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type TrainerEventDayLessonTypeMaxAggregateOutputType = {
  __typename?: 'TrainerEventDayLessonTypeMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type TrainerEventDayLessonTypeMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type TrainerEventDayLessonTypeMinAggregateOutputType = {
  __typename?: 'TrainerEventDayLessonTypeMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type TrainerEventDayLessonTypeMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type TrainerEventDayLessonTypeOrderByWithAggregationInput = {
  _avg?: InputMaybe<TrainerEventDayLessonTypeAvgOrderByAggregateInput>;
  _count?: InputMaybe<TrainerEventDayLessonTypeCountOrderByAggregateInput>;
  _max?: InputMaybe<TrainerEventDayLessonTypeMaxOrderByAggregateInput>;
  _min?: InputMaybe<TrainerEventDayLessonTypeMinOrderByAggregateInput>;
  _sum?: InputMaybe<TrainerEventDayLessonTypeSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type TrainerEventDayLessonTypeOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lessons?: InputMaybe<TrainerEventDayLessonOrderByRelationAggregateInput>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type TrainerEventDayLessonTypeRelationFilter = {
  is?: InputMaybe<TrainerEventDayLessonTypeWhereInput>;
  isNot?: InputMaybe<TrainerEventDayLessonTypeWhereInput>;
};

export enum TrainerEventDayLessonTypeScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  TitleAr = 'titleAr',
  TitleEn = 'titleEn'
}

export type TrainerEventDayLessonTypeScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonTypeScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonTypeScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonTypeScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  titleAr?: InputMaybe<StringWithAggregatesFilter>;
  titleEn?: InputMaybe<StringWithAggregatesFilter>;
};

export type TrainerEventDayLessonTypeSumAggregateOutputType = {
  __typename?: 'TrainerEventDayLessonTypeSumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
};

export type TrainerEventDayLessonTypeSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type TrainerEventDayLessonTypeUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  lessons?: InputMaybe<TrainerEventDayLessonUncheckedCreateNestedManyWithoutTrainerEventDayLessonTypeInput>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type TrainerEventDayLessonTypeUncheckedCreateWithoutLessonsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type TrainerEventDayLessonTypeUncheckedUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  lessons?: InputMaybe<TrainerEventDayLessonUncheckedUpdateManyWithoutTrainerEventDayLessonTypeInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrainerEventDayLessonTypeUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrainerEventDayLessonTypeUncheckedUpdateWithoutLessonsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrainerEventDayLessonTypeUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lessons?: InputMaybe<TrainerEventDayLessonUpdateManyWithoutTrainerEventDayLessonTypeInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrainerEventDayLessonTypeUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrainerEventDayLessonTypeUpdateOneRequiredWithoutLessonsInput = {
  connect?: InputMaybe<TrainerEventDayLessonTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TrainerEventDayLessonTypeCreateOrConnectWithoutLessonsInput>;
  create?: InputMaybe<TrainerEventDayLessonTypeUncheckedCreateWithoutLessonsInput>;
  update?: InputMaybe<TrainerEventDayLessonTypeUncheckedUpdateWithoutLessonsInput>;
  upsert?: InputMaybe<TrainerEventDayLessonTypeUpsertWithoutLessonsInput>;
};

export type TrainerEventDayLessonTypeUpdateWithoutLessonsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrainerEventDayLessonTypeUpsertWithoutLessonsInput = {
  create: TrainerEventDayLessonTypeUncheckedCreateWithoutLessonsInput;
  update: TrainerEventDayLessonTypeUncheckedUpdateWithoutLessonsInput;
};

export type TrainerEventDayLessonTypeWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonTypeWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonTypeWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonTypeWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  lessons?: InputMaybe<TrainerEventDayLessonListRelationFilter>;
  titleAr?: InputMaybe<StringFilter>;
  titleEn?: InputMaybe<StringFilter>;
};

export type TrainerEventDayLessonTypeWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn?: InputMaybe<Scalars['String']>;
};

export type TrainerEventDayLessonUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventDayId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  methodOfTeachingTypeId?: InputMaybe<Scalars['Int']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  startTime: Scalars['DateTime'];
  trainerEventDayLessonTypeId: Scalars['Int'];
  trainerEventId?: InputMaybe<Scalars['Int']>;
};

export type TrainerEventDayLessonUncheckedCreateNestedManyWithoutEventDayInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonCreateOrConnectWithoutEventDayInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonCreateWithoutEventDayInput>>>;
  createMany?: InputMaybe<TrainerEventDayLessonCreateManyEventDayInputEnvelope>;
};

export type TrainerEventDayLessonUncheckedCreateNestedManyWithoutMethodOfTeachingInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonCreateOrConnectWithoutMethodOfTeachingInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonCreateWithoutMethodOfTeachingInput>>>;
  createMany?: InputMaybe<TrainerEventDayLessonCreateManyMethodOfTeachingInputEnvelope>;
};

export type TrainerEventDayLessonUncheckedCreateNestedManyWithoutTrainerEventDayLessonTypeInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonCreateOrConnectWithoutTrainerEventDayLessonTypeInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonCreateWithoutTrainerEventDayLessonTypeInput>>>;
  createMany?: InputMaybe<TrainerEventDayLessonCreateManyTrainerEventDayLessonTypeInputEnvelope>;
};

export type TrainerEventDayLessonUncheckedCreateNestedManyWithoutTrainerEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonCreateOrConnectWithoutTrainerEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonCreateWithoutTrainerEventInput>>>;
  createMany?: InputMaybe<TrainerEventDayLessonCreateManyTrainerEventInputEnvelope>;
};

export type TrainerEventDayLessonUncheckedCreateWithoutEventDayInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  id?: InputMaybe<Scalars['Int']>;
  methodOfTeachingTypeId?: InputMaybe<Scalars['Int']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  startTime: Scalars['DateTime'];
  trainerEventDayLessonTypeId: Scalars['Int'];
  trainerEventId?: InputMaybe<Scalars['Int']>;
};

export type TrainerEventDayLessonUncheckedCreateWithoutMethodOfTeachingInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventDayId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  startTime: Scalars['DateTime'];
  trainerEventDayLessonTypeId: Scalars['Int'];
  trainerEventId?: InputMaybe<Scalars['Int']>;
};

export type TrainerEventDayLessonUncheckedCreateWithoutTrainerEventDayLessonTypeInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventDayId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  methodOfTeachingTypeId?: InputMaybe<Scalars['Int']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  startTime: Scalars['DateTime'];
  trainerEventId?: InputMaybe<Scalars['Int']>;
};

export type TrainerEventDayLessonUncheckedCreateWithoutTrainerEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventDayId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  methodOfTeachingTypeId?: InputMaybe<Scalars['Int']>;
  outlineAr: Scalars['String'];
  outlineEn: Scalars['String'];
  startTime: Scalars['DateTime'];
  trainerEventDayLessonTypeId: Scalars['Int'];
};

export type TrainerEventDayLessonUncheckedUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  methodOfTeachingTypeId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  trainerEventDayLessonTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type TrainerEventDayLessonUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  methodOfTeachingTypeId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  trainerEventDayLessonTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type TrainerEventDayLessonUncheckedUpdateManyWithoutDayLessonsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  methodOfTeachingTypeId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  trainerEventDayLessonTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TrainerEventDayLessonUncheckedUpdateManyWithoutEventDayInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonCreateOrConnectWithoutEventDayInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonCreateWithoutEventDayInput>>>;
  createMany?: InputMaybe<TrainerEventDayLessonCreateManyEventDayInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonUpdateWithWhereUniqueWithoutEventDayInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonUpdateManyWithWhereWithoutEventDayInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonUpsertWithWhereUniqueWithoutEventDayInput>>>;
};

export type TrainerEventDayLessonUncheckedUpdateManyWithoutLessonsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  trainerEventDayLessonTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type TrainerEventDayLessonUncheckedUpdateManyWithoutMethodOfTeachingInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonCreateOrConnectWithoutMethodOfTeachingInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonCreateWithoutMethodOfTeachingInput>>>;
  createMany?: InputMaybe<TrainerEventDayLessonCreateManyMethodOfTeachingInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonUpdateWithWhereUniqueWithoutMethodOfTeachingInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonUpdateManyWithWhereWithoutMethodOfTeachingInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonUpsertWithWhereUniqueWithoutMethodOfTeachingInput>>>;
};

export type TrainerEventDayLessonUncheckedUpdateManyWithoutTrainerEventDayLessonTypeInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonCreateOrConnectWithoutTrainerEventDayLessonTypeInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonCreateWithoutTrainerEventDayLessonTypeInput>>>;
  createMany?: InputMaybe<TrainerEventDayLessonCreateManyTrainerEventDayLessonTypeInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonUpdateWithWhereUniqueWithoutTrainerEventDayLessonTypeInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonUpdateManyWithWhereWithoutTrainerEventDayLessonTypeInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonUpsertWithWhereUniqueWithoutTrainerEventDayLessonTypeInput>>>;
};

export type TrainerEventDayLessonUncheckedUpdateManyWithoutTrainerEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonCreateOrConnectWithoutTrainerEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonCreateWithoutTrainerEventInput>>>;
  createMany?: InputMaybe<TrainerEventDayLessonCreateManyTrainerEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonUpdateWithWhereUniqueWithoutTrainerEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonUpdateManyWithWhereWithoutTrainerEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonUpsertWithWhereUniqueWithoutTrainerEventInput>>>;
};

export type TrainerEventDayLessonUncheckedUpdateManyWithoutTrainerLessonsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  methodOfTeachingTypeId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  trainerEventDayLessonTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type TrainerEventDayLessonUncheckedUpdateWithoutEventDayInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  methodOfTeachingTypeId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  trainerEventDayLessonTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type TrainerEventDayLessonUncheckedUpdateWithoutMethodOfTeachingInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  trainerEventDayLessonTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type TrainerEventDayLessonUncheckedUpdateWithoutTrainerEventDayLessonTypeInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  methodOfTeachingTypeId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type TrainerEventDayLessonUncheckedUpdateWithoutTrainerEventInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  methodOfTeachingTypeId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  trainerEventDayLessonTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TrainerEventDayLessonUpdateInput = {
  TrainerEventDayLessonType?: InputMaybe<TrainerEventDayLessonTypeUpdateOneRequiredWithoutLessonsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDay?: InputMaybe<EventDayUpdateOneRequiredWithoutTrainerLessonsInput>;
  methodOfTeaching?: InputMaybe<MethodOfTeachingTypeUpdateOneWithoutLessonsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  trainerEvent?: InputMaybe<TrainerEventUpdateOneWithoutDayLessonsInput>;
};

export type TrainerEventDayLessonUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TrainerEventDayLessonUpdateManyWithWhereWithoutEventDayInput = {
  data: TrainerEventDayLessonUncheckedUpdateManyWithoutTrainerLessonsInput;
  where: TrainerEventDayLessonScalarWhereInput;
};

export type TrainerEventDayLessonUpdateManyWithWhereWithoutMethodOfTeachingInput = {
  data: TrainerEventDayLessonUncheckedUpdateManyWithoutLessonsInput;
  where: TrainerEventDayLessonScalarWhereInput;
};

export type TrainerEventDayLessonUpdateManyWithWhereWithoutTrainerEventDayLessonTypeInput = {
  data: TrainerEventDayLessonUncheckedUpdateManyWithoutLessonsInput;
  where: TrainerEventDayLessonScalarWhereInput;
};

export type TrainerEventDayLessonUpdateManyWithWhereWithoutTrainerEventInput = {
  data: TrainerEventDayLessonUncheckedUpdateManyWithoutDayLessonsInput;
  where: TrainerEventDayLessonScalarWhereInput;
};

export type TrainerEventDayLessonUpdateManyWithoutEventDayInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonCreateOrConnectWithoutEventDayInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonCreateWithoutEventDayInput>>>;
  createMany?: InputMaybe<TrainerEventDayLessonCreateManyEventDayInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonUpdateWithWhereUniqueWithoutEventDayInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonUpdateManyWithWhereWithoutEventDayInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonUpsertWithWhereUniqueWithoutEventDayInput>>>;
};

export type TrainerEventDayLessonUpdateManyWithoutMethodOfTeachingInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonCreateOrConnectWithoutMethodOfTeachingInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonCreateWithoutMethodOfTeachingInput>>>;
  createMany?: InputMaybe<TrainerEventDayLessonCreateManyMethodOfTeachingInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonUpdateWithWhereUniqueWithoutMethodOfTeachingInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonUpdateManyWithWhereWithoutMethodOfTeachingInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonUpsertWithWhereUniqueWithoutMethodOfTeachingInput>>>;
};

export type TrainerEventDayLessonUpdateManyWithoutTrainerEventDayLessonTypeInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonCreateOrConnectWithoutTrainerEventDayLessonTypeInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonCreateWithoutTrainerEventDayLessonTypeInput>>>;
  createMany?: InputMaybe<TrainerEventDayLessonCreateManyTrainerEventDayLessonTypeInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonUpdateWithWhereUniqueWithoutTrainerEventDayLessonTypeInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonUpdateManyWithWhereWithoutTrainerEventDayLessonTypeInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonUpsertWithWhereUniqueWithoutTrainerEventDayLessonTypeInput>>>;
};

export type TrainerEventDayLessonUpdateManyWithoutTrainerEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonCreateOrConnectWithoutTrainerEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonCreateWithoutTrainerEventInput>>>;
  createMany?: InputMaybe<TrainerEventDayLessonCreateManyTrainerEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonUpdateWithWhereUniqueWithoutTrainerEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonUpdateManyWithWhereWithoutTrainerEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonUpsertWithWhereUniqueWithoutTrainerEventInput>>>;
};

export type TrainerEventDayLessonUpdateWithWhereUniqueWithoutEventDayInput = {
  data: TrainerEventDayLessonUncheckedUpdateWithoutEventDayInput;
  where: TrainerEventDayLessonWhereUniqueInput;
};

export type TrainerEventDayLessonUpdateWithWhereUniqueWithoutMethodOfTeachingInput = {
  data: TrainerEventDayLessonUncheckedUpdateWithoutMethodOfTeachingInput;
  where: TrainerEventDayLessonWhereUniqueInput;
};

export type TrainerEventDayLessonUpdateWithWhereUniqueWithoutTrainerEventDayLessonTypeInput = {
  data: TrainerEventDayLessonUncheckedUpdateWithoutTrainerEventDayLessonTypeInput;
  where: TrainerEventDayLessonWhereUniqueInput;
};

export type TrainerEventDayLessonUpdateWithWhereUniqueWithoutTrainerEventInput = {
  data: TrainerEventDayLessonUncheckedUpdateWithoutTrainerEventInput;
  where: TrainerEventDayLessonWhereUniqueInput;
};

export type TrainerEventDayLessonUpdateWithoutEventDayInput = {
  TrainerEventDayLessonType?: InputMaybe<TrainerEventDayLessonTypeUpdateOneRequiredWithoutLessonsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  methodOfTeaching?: InputMaybe<MethodOfTeachingTypeUpdateOneWithoutLessonsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  trainerEvent?: InputMaybe<TrainerEventUpdateOneWithoutDayLessonsInput>;
};

export type TrainerEventDayLessonUpdateWithoutMethodOfTeachingInput = {
  TrainerEventDayLessonType?: InputMaybe<TrainerEventDayLessonTypeUpdateOneRequiredWithoutLessonsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDay?: InputMaybe<EventDayUpdateOneRequiredWithoutTrainerLessonsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  trainerEvent?: InputMaybe<TrainerEventUpdateOneWithoutDayLessonsInput>;
};

export type TrainerEventDayLessonUpdateWithoutTrainerEventDayLessonTypeInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDay?: InputMaybe<EventDayUpdateOneRequiredWithoutTrainerLessonsInput>;
  methodOfTeaching?: InputMaybe<MethodOfTeachingTypeUpdateOneWithoutLessonsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  trainerEvent?: InputMaybe<TrainerEventUpdateOneWithoutDayLessonsInput>;
};

export type TrainerEventDayLessonUpdateWithoutTrainerEventInput = {
  TrainerEventDayLessonType?: InputMaybe<TrainerEventDayLessonTypeUpdateOneRequiredWithoutLessonsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDay?: InputMaybe<EventDayUpdateOneRequiredWithoutTrainerLessonsInput>;
  methodOfTeaching?: InputMaybe<MethodOfTeachingTypeUpdateOneWithoutLessonsInput>;
  outlineAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  outlineEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TrainerEventDayLessonUpsertWithWhereUniqueWithoutEventDayInput = {
  create: TrainerEventDayLessonUncheckedCreateWithoutEventDayInput;
  update: TrainerEventDayLessonUncheckedUpdateWithoutEventDayInput;
  where: TrainerEventDayLessonWhereUniqueInput;
};

export type TrainerEventDayLessonUpsertWithWhereUniqueWithoutMethodOfTeachingInput = {
  create: TrainerEventDayLessonUncheckedCreateWithoutMethodOfTeachingInput;
  update: TrainerEventDayLessonUncheckedUpdateWithoutMethodOfTeachingInput;
  where: TrainerEventDayLessonWhereUniqueInput;
};

export type TrainerEventDayLessonUpsertWithWhereUniqueWithoutTrainerEventDayLessonTypeInput = {
  create: TrainerEventDayLessonUncheckedCreateWithoutTrainerEventDayLessonTypeInput;
  update: TrainerEventDayLessonUncheckedUpdateWithoutTrainerEventDayLessonTypeInput;
  where: TrainerEventDayLessonWhereUniqueInput;
};

export type TrainerEventDayLessonUpsertWithWhereUniqueWithoutTrainerEventInput = {
  create: TrainerEventDayLessonUncheckedCreateWithoutTrainerEventInput;
  update: TrainerEventDayLessonUncheckedUpdateWithoutTrainerEventInput;
  where: TrainerEventDayLessonWhereUniqueInput;
};

export type TrainerEventDayLessonWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TrainerEventDayLessonWhereInput>>>;
  TrainerEventDayLessonType?: InputMaybe<TrainerEventDayLessonTypeWhereInput>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  endTime?: InputMaybe<DateTimeFilter>;
  eventDay?: InputMaybe<EventDayWhereInput>;
  eventDayId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  methodOfTeaching?: InputMaybe<MethodOfTeachingTypeWhereInput>;
  methodOfTeachingTypeId?: InputMaybe<IntNullableFilter>;
  outlineAr?: InputMaybe<StringFilter>;
  outlineEn?: InputMaybe<StringFilter>;
  startTime?: InputMaybe<DateTimeFilter>;
  trainerEvent?: InputMaybe<TrainerEventWhereInput>;
  trainerEventDayLessonTypeId?: InputMaybe<IntFilter>;
  trainerEventId?: InputMaybe<IntNullableFilter>;
};

export type TrainerEventDayLessonWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type TrainerEventDayTimeSlot = {
  __typename?: 'TrainerEventDayTimeSlot';
  addedBy?: Maybe<User>;
  addedById?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventDay: EventDay;
  eventDayId: Scalars['Int'];
  id: Scalars['Int'];
  startTime: Scalars['DateTime'];
  trainerEvent: TrainerEvent;
  trainerEventId: Scalars['Int'];
};

export type TrainerEventDayTimeSlotAvgAggregateOutputType = {
  __typename?: 'TrainerEventDayTimeSlotAvgAggregateOutputType';
  addedById?: Maybe<Scalars['Float']>;
  eventDayId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  trainerEventId?: Maybe<Scalars['Float']>;
};

export type TrainerEventDayTimeSlotAvgOrderByAggregateInput = {
  addedById?: InputMaybe<SortOrder>;
  eventDayId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
};

export type TrainerEventDayTimeSlotCountAggregateOutputType = {
  __typename?: 'TrainerEventDayTimeSlotCountAggregateOutputType';
  _all: Scalars['Int'];
  addedById: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  endTime: Scalars['Int'];
  eventDayId: Scalars['Int'];
  id: Scalars['Int'];
  startTime: Scalars['Int'];
  trainerEventId: Scalars['Int'];
};

export type TrainerEventDayTimeSlotCountOrderByAggregateInput = {
  addedById?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  eventDayId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
};

export type TrainerEventDayTimeSlotCreateInput = {
  addedBy?: InputMaybe<UserCreateNestedOneWithoutTrainereventDayTimeSlotsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventDay: EventDayCreateNestedOneWithoutTrainerTimeSlotsInput;
  startTime: Scalars['DateTime'];
  trainerEvent: TrainerEventCreateNestedOneWithoutTimeSlotsInput;
};

export type TrainerEventDayTimeSlotCreateManyAddedByInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventDayId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  startTime: Scalars['DateTime'];
  trainerEventId: Scalars['Int'];
};

export type TrainerEventDayTimeSlotCreateManyAddedByInputEnvelope = {
  data: TrainerEventDayTimeSlotCreateManyAddedByInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TrainerEventDayTimeSlotCreateManyEventDayInput = {
  addedById?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  id?: InputMaybe<Scalars['Int']>;
  startTime: Scalars['DateTime'];
  trainerEventId: Scalars['Int'];
};

export type TrainerEventDayTimeSlotCreateManyEventDayInputEnvelope = {
  data: TrainerEventDayTimeSlotCreateManyEventDayInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TrainerEventDayTimeSlotCreateManyInput = {
  addedById?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventDayId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  startTime: Scalars['DateTime'];
  trainerEventId: Scalars['Int'];
};

export type TrainerEventDayTimeSlotCreateManyTrainerEventInput = {
  addedById?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventDayId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  startTime: Scalars['DateTime'];
};

export type TrainerEventDayTimeSlotCreateManyTrainerEventInputEnvelope = {
  data: TrainerEventDayTimeSlotCreateManyTrainerEventInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotCreateOrConnectWithoutAddedByInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotCreateWithoutAddedByInput>>>;
  createMany?: InputMaybe<TrainerEventDayTimeSlotCreateManyAddedByInputEnvelope>;
};

export type TrainerEventDayTimeSlotCreateNestedManyWithoutEventDayInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotCreateOrConnectWithoutEventDayInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotCreateWithoutEventDayInput>>>;
  createMany?: InputMaybe<TrainerEventDayTimeSlotCreateManyEventDayInputEnvelope>;
};

export type TrainerEventDayTimeSlotCreateNestedManyWithoutTrainerEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotCreateOrConnectWithoutTrainerEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotCreateWithoutTrainerEventInput>>>;
  createMany?: InputMaybe<TrainerEventDayTimeSlotCreateManyTrainerEventInputEnvelope>;
};

export type TrainerEventDayTimeSlotCreateOrConnectWithoutAddedByInput = {
  create: TrainerEventDayTimeSlotUncheckedCreateWithoutAddedByInput;
  where: TrainerEventDayTimeSlotWhereUniqueInput;
};

export type TrainerEventDayTimeSlotCreateOrConnectWithoutEventDayInput = {
  create: TrainerEventDayTimeSlotUncheckedCreateWithoutEventDayInput;
  where: TrainerEventDayTimeSlotWhereUniqueInput;
};

export type TrainerEventDayTimeSlotCreateOrConnectWithoutTrainerEventInput = {
  create: TrainerEventDayTimeSlotUncheckedCreateWithoutTrainerEventInput;
  where: TrainerEventDayTimeSlotWhereUniqueInput;
};

export type TrainerEventDayTimeSlotCreateWithoutAddedByInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventDay: EventDayCreateNestedOneWithoutTrainerTimeSlotsInput;
  startTime: Scalars['DateTime'];
  trainerEvent: TrainerEventCreateNestedOneWithoutTimeSlotsInput;
};

export type TrainerEventDayTimeSlotCreateWithoutEventDayInput = {
  addedBy?: InputMaybe<UserCreateNestedOneWithoutTrainereventDayTimeSlotsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  startTime: Scalars['DateTime'];
  trainerEvent: TrainerEventCreateNestedOneWithoutTimeSlotsInput;
};

export type TrainerEventDayTimeSlotCreateWithoutTrainerEventInput = {
  addedBy?: InputMaybe<UserCreateNestedOneWithoutTrainereventDayTimeSlotsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventDay: EventDayCreateNestedOneWithoutTrainerTimeSlotsInput;
  startTime: Scalars['DateTime'];
};

export type TrainerEventDayTimeSlotListRelationFilter = {
  every?: InputMaybe<TrainerEventDayTimeSlotWhereInput>;
  none?: InputMaybe<TrainerEventDayTimeSlotWhereInput>;
  some?: InputMaybe<TrainerEventDayTimeSlotWhereInput>;
};

export type TrainerEventDayTimeSlotMaxAggregateOutputType = {
  __typename?: 'TrainerEventDayTimeSlotMaxAggregateOutputType';
  addedById?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  endTime?: Maybe<Scalars['DateTime']>;
  eventDayId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  startTime?: Maybe<Scalars['DateTime']>;
  trainerEventId?: Maybe<Scalars['Int']>;
};

export type TrainerEventDayTimeSlotMaxOrderByAggregateInput = {
  addedById?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  eventDayId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
};

export type TrainerEventDayTimeSlotMinAggregateOutputType = {
  __typename?: 'TrainerEventDayTimeSlotMinAggregateOutputType';
  addedById?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  endTime?: Maybe<Scalars['DateTime']>;
  eventDayId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  startTime?: Maybe<Scalars['DateTime']>;
  trainerEventId?: Maybe<Scalars['Int']>;
};

export type TrainerEventDayTimeSlotMinOrderByAggregateInput = {
  addedById?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  eventDayId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
};

export type TrainerEventDayTimeSlotOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TrainerEventDayTimeSlotOrderByWithAggregationInput = {
  _avg?: InputMaybe<TrainerEventDayTimeSlotAvgOrderByAggregateInput>;
  _count?: InputMaybe<TrainerEventDayTimeSlotCountOrderByAggregateInput>;
  _max?: InputMaybe<TrainerEventDayTimeSlotMaxOrderByAggregateInput>;
  _min?: InputMaybe<TrainerEventDayTimeSlotMinOrderByAggregateInput>;
  _sum?: InputMaybe<TrainerEventDayTimeSlotSumOrderByAggregateInput>;
  addedById?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  eventDayId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
};

export type TrainerEventDayTimeSlotOrderByWithRelationInput = {
  addedBy?: InputMaybe<UserOrderByWithRelationInput>;
  addedById?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  eventDay?: InputMaybe<EventDayOrderByWithRelationInput>;
  eventDayId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  trainerEvent?: InputMaybe<TrainerEventOrderByWithRelationInput>;
  trainerEventId?: InputMaybe<SortOrder>;
};

export enum TrainerEventDayTimeSlotScalarFieldEnum {
  AddedById = 'addedById',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  EndTime = 'endTime',
  EventDayId = 'eventDayId',
  Id = 'id',
  StartTime = 'startTime',
  TrainerEventId = 'trainerEventId'
}

export type TrainerEventDayTimeSlotScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotScalarWhereInput>>>;
  addedById?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  endTime?: InputMaybe<DateTimeFilter>;
  eventDayId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  startTime?: InputMaybe<DateTimeFilter>;
  trainerEventId?: InputMaybe<IntFilter>;
};

export type TrainerEventDayTimeSlotScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotScalarWhereWithAggregatesInput>>>;
  addedById?: InputMaybe<IntNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  endTime?: InputMaybe<DateTimeWithAggregatesFilter>;
  eventDayId?: InputMaybe<IntWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  startTime?: InputMaybe<DateTimeWithAggregatesFilter>;
  trainerEventId?: InputMaybe<IntWithAggregatesFilter>;
};

export type TrainerEventDayTimeSlotSumAggregateOutputType = {
  __typename?: 'TrainerEventDayTimeSlotSumAggregateOutputType';
  addedById?: Maybe<Scalars['Int']>;
  eventDayId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  trainerEventId?: Maybe<Scalars['Int']>;
};

export type TrainerEventDayTimeSlotSumOrderByAggregateInput = {
  addedById?: InputMaybe<SortOrder>;
  eventDayId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
};

export type TrainerEventDayTimeSlotUncheckedCreateInput = {
  addedById?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventDayId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  startTime: Scalars['DateTime'];
  trainerEventId: Scalars['Int'];
};

export type TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotCreateOrConnectWithoutAddedByInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotCreateWithoutAddedByInput>>>;
  createMany?: InputMaybe<TrainerEventDayTimeSlotCreateManyAddedByInputEnvelope>;
};

export type TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutEventDayInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotCreateOrConnectWithoutEventDayInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotCreateWithoutEventDayInput>>>;
  createMany?: InputMaybe<TrainerEventDayTimeSlotCreateManyEventDayInputEnvelope>;
};

export type TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutTrainerEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotCreateOrConnectWithoutTrainerEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotCreateWithoutTrainerEventInput>>>;
  createMany?: InputMaybe<TrainerEventDayTimeSlotCreateManyTrainerEventInputEnvelope>;
};

export type TrainerEventDayTimeSlotUncheckedCreateWithoutAddedByInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventDayId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  startTime: Scalars['DateTime'];
  trainerEventId: Scalars['Int'];
};

export type TrainerEventDayTimeSlotUncheckedCreateWithoutEventDayInput = {
  addedById?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  id?: InputMaybe<Scalars['Int']>;
  startTime: Scalars['DateTime'];
  trainerEventId: Scalars['Int'];
};

export type TrainerEventDayTimeSlotUncheckedCreateWithoutTrainerEventInput = {
  addedById?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime: Scalars['DateTime'];
  eventDayId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  startTime: Scalars['DateTime'];
};

export type TrainerEventDayTimeSlotUncheckedUpdateInput = {
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TrainerEventDayTimeSlotUncheckedUpdateManyInput = {
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotCreateOrConnectWithoutAddedByInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotCreateWithoutAddedByInput>>>;
  createMany?: InputMaybe<TrainerEventDayTimeSlotCreateManyAddedByInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotUpdateWithWhereUniqueWithoutAddedByInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotUpdateManyWithWhereWithoutAddedByInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotUpsertWithWhereUniqueWithoutAddedByInput>>>;
};

export type TrainerEventDayTimeSlotUncheckedUpdateManyWithoutEventDayInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotCreateOrConnectWithoutEventDayInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotCreateWithoutEventDayInput>>>;
  createMany?: InputMaybe<TrainerEventDayTimeSlotCreateManyEventDayInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotUpdateWithWhereUniqueWithoutEventDayInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotUpdateManyWithWhereWithoutEventDayInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotUpsertWithWhereUniqueWithoutEventDayInput>>>;
};

export type TrainerEventDayTimeSlotUncheckedUpdateManyWithoutTimeSlotsInput = {
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TrainerEventDayTimeSlotUncheckedUpdateManyWithoutTrainerEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotCreateOrConnectWithoutTrainerEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotCreateWithoutTrainerEventInput>>>;
  createMany?: InputMaybe<TrainerEventDayTimeSlotCreateManyTrainerEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotUpdateWithWhereUniqueWithoutTrainerEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotUpdateManyWithWhereWithoutTrainerEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotUpsertWithWhereUniqueWithoutTrainerEventInput>>>;
};

export type TrainerEventDayTimeSlotUncheckedUpdateManyWithoutTrainerTimeSlotsInput = {
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TrainerEventDayTimeSlotUncheckedUpdateManyWithoutTrainereventDayTimeSlotsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TrainerEventDayTimeSlotUncheckedUpdateWithoutAddedByInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TrainerEventDayTimeSlotUncheckedUpdateWithoutEventDayInput = {
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TrainerEventDayTimeSlotUncheckedUpdateWithoutTrainerEventInput = {
  addedById?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TrainerEventDayTimeSlotUpdateInput = {
  addedBy?: InputMaybe<UserUpdateOneWithoutTrainereventDayTimeSlotsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDay?: InputMaybe<EventDayUpdateOneRequiredWithoutTrainerTimeSlotsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  trainerEvent?: InputMaybe<TrainerEventUpdateOneRequiredWithoutTimeSlotsInput>;
};

export type TrainerEventDayTimeSlotUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TrainerEventDayTimeSlotUpdateManyWithWhereWithoutAddedByInput = {
  data: TrainerEventDayTimeSlotUncheckedUpdateManyWithoutTrainereventDayTimeSlotsInput;
  where: TrainerEventDayTimeSlotScalarWhereInput;
};

export type TrainerEventDayTimeSlotUpdateManyWithWhereWithoutEventDayInput = {
  data: TrainerEventDayTimeSlotUncheckedUpdateManyWithoutTrainerTimeSlotsInput;
  where: TrainerEventDayTimeSlotScalarWhereInput;
};

export type TrainerEventDayTimeSlotUpdateManyWithWhereWithoutTrainerEventInput = {
  data: TrainerEventDayTimeSlotUncheckedUpdateManyWithoutTimeSlotsInput;
  where: TrainerEventDayTimeSlotScalarWhereInput;
};

export type TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotCreateOrConnectWithoutAddedByInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotCreateWithoutAddedByInput>>>;
  createMany?: InputMaybe<TrainerEventDayTimeSlotCreateManyAddedByInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotUpdateWithWhereUniqueWithoutAddedByInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotUpdateManyWithWhereWithoutAddedByInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotUpsertWithWhereUniqueWithoutAddedByInput>>>;
};

export type TrainerEventDayTimeSlotUpdateManyWithoutEventDayInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotCreateOrConnectWithoutEventDayInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotCreateWithoutEventDayInput>>>;
  createMany?: InputMaybe<TrainerEventDayTimeSlotCreateManyEventDayInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotUpdateWithWhereUniqueWithoutEventDayInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotUpdateManyWithWhereWithoutEventDayInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotUpsertWithWhereUniqueWithoutEventDayInput>>>;
};

export type TrainerEventDayTimeSlotUpdateManyWithoutTrainerEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotCreateOrConnectWithoutTrainerEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotCreateWithoutTrainerEventInput>>>;
  createMany?: InputMaybe<TrainerEventDayTimeSlotCreateManyTrainerEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotUpdateWithWhereUniqueWithoutTrainerEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotUpdateManyWithWhereWithoutTrainerEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotUpsertWithWhereUniqueWithoutTrainerEventInput>>>;
};

export type TrainerEventDayTimeSlotUpdateWithWhereUniqueWithoutAddedByInput = {
  data: TrainerEventDayTimeSlotUncheckedUpdateWithoutAddedByInput;
  where: TrainerEventDayTimeSlotWhereUniqueInput;
};

export type TrainerEventDayTimeSlotUpdateWithWhereUniqueWithoutEventDayInput = {
  data: TrainerEventDayTimeSlotUncheckedUpdateWithoutEventDayInput;
  where: TrainerEventDayTimeSlotWhereUniqueInput;
};

export type TrainerEventDayTimeSlotUpdateWithWhereUniqueWithoutTrainerEventInput = {
  data: TrainerEventDayTimeSlotUncheckedUpdateWithoutTrainerEventInput;
  where: TrainerEventDayTimeSlotWhereUniqueInput;
};

export type TrainerEventDayTimeSlotUpdateWithoutAddedByInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDay?: InputMaybe<EventDayUpdateOneRequiredWithoutTrainerTimeSlotsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  trainerEvent?: InputMaybe<TrainerEventUpdateOneRequiredWithoutTimeSlotsInput>;
};

export type TrainerEventDayTimeSlotUpdateWithoutEventDayInput = {
  addedBy?: InputMaybe<UserUpdateOneWithoutTrainereventDayTimeSlotsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  trainerEvent?: InputMaybe<TrainerEventUpdateOneRequiredWithoutTimeSlotsInput>;
};

export type TrainerEventDayTimeSlotUpdateWithoutTrainerEventInput = {
  addedBy?: InputMaybe<UserUpdateOneWithoutTrainereventDayTimeSlotsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventDay?: InputMaybe<EventDayUpdateOneRequiredWithoutTrainerTimeSlotsInput>;
  startTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TrainerEventDayTimeSlotUpsertWithWhereUniqueWithoutAddedByInput = {
  create: TrainerEventDayTimeSlotUncheckedCreateWithoutAddedByInput;
  update: TrainerEventDayTimeSlotUncheckedUpdateWithoutAddedByInput;
  where: TrainerEventDayTimeSlotWhereUniqueInput;
};

export type TrainerEventDayTimeSlotUpsertWithWhereUniqueWithoutEventDayInput = {
  create: TrainerEventDayTimeSlotUncheckedCreateWithoutEventDayInput;
  update: TrainerEventDayTimeSlotUncheckedUpdateWithoutEventDayInput;
  where: TrainerEventDayTimeSlotWhereUniqueInput;
};

export type TrainerEventDayTimeSlotUpsertWithWhereUniqueWithoutTrainerEventInput = {
  create: TrainerEventDayTimeSlotUncheckedCreateWithoutTrainerEventInput;
  update: TrainerEventDayTimeSlotUncheckedUpdateWithoutTrainerEventInput;
  where: TrainerEventDayTimeSlotWhereUniqueInput;
};

export type TrainerEventDayTimeSlotWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TrainerEventDayTimeSlotWhereInput>>>;
  addedBy?: InputMaybe<UserWhereInput>;
  addedById?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  endTime?: InputMaybe<DateTimeFilter>;
  eventDay?: InputMaybe<EventDayWhereInput>;
  eventDayId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  startTime?: InputMaybe<DateTimeFilter>;
  trainerEvent?: InputMaybe<TrainerEventWhereInput>;
  trainerEventId?: InputMaybe<IntFilter>;
};

export type TrainerEventDayTimeSlotWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type TrainerEventListRelationFilter = {
  every?: InputMaybe<TrainerEventWhereInput>;
  none?: InputMaybe<TrainerEventWhereInput>;
  some?: InputMaybe<TrainerEventWhereInput>;
};

export type TrainerEventMaxAggregateOutputType = {
  __typename?: 'TrainerEventMaxAggregateOutputType';
  contentIsAdded?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  introductionAr?: Maybe<Scalars['String']>;
  introductionEn?: Maybe<Scalars['String']>;
  isAllProfessionsTargeted?: Maybe<Scalars['Boolean']>;
  joinUrl?: Maybe<Scalars['String']>;
  mainThemeAr?: Maybe<Scalars['String']>;
  mainThemeEn?: Maybe<Scalars['String']>;
  objectivesAr?: Maybe<Scalars['String']>;
  objectivesEn?: Maybe<Scalars['String']>;
  outcomesAr?: Maybe<Scalars['String']>;
  outcomesEn?: Maybe<Scalars['String']>;
  registrantId?: Maybe<Scalars['String']>;
  toTransferAmount?: Maybe<Scalars['Decimal']>;
  toTransferType?: Maybe<ToTransferType>;
  trainerId?: Maybe<Scalars['Int']>;
  whyTargetedAudienceAr?: Maybe<Scalars['String']>;
  whyTargetedAudienceEn?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['String']>;
};

export type TrainerEventMaxOrderByAggregateInput = {
  contentIsAdded?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  introductionAr?: InputMaybe<SortOrder>;
  introductionEn?: InputMaybe<SortOrder>;
  isAllProfessionsTargeted?: InputMaybe<SortOrder>;
  joinUrl?: InputMaybe<SortOrder>;
  mainThemeAr?: InputMaybe<SortOrder>;
  mainThemeEn?: InputMaybe<SortOrder>;
  objectivesAr?: InputMaybe<SortOrder>;
  objectivesEn?: InputMaybe<SortOrder>;
  outcomesAr?: InputMaybe<SortOrder>;
  outcomesEn?: InputMaybe<SortOrder>;
  registrantId?: InputMaybe<SortOrder>;
  toTransferAmount?: InputMaybe<SortOrder>;
  toTransferType?: InputMaybe<SortOrder>;
  trainerId?: InputMaybe<SortOrder>;
  whyTargetedAudienceAr?: InputMaybe<SortOrder>;
  whyTargetedAudienceEn?: InputMaybe<SortOrder>;
  youtubeUrl?: InputMaybe<SortOrder>;
};

export type TrainerEventMinAggregateOutputType = {
  __typename?: 'TrainerEventMinAggregateOutputType';
  contentIsAdded?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  introductionAr?: Maybe<Scalars['String']>;
  introductionEn?: Maybe<Scalars['String']>;
  isAllProfessionsTargeted?: Maybe<Scalars['Boolean']>;
  joinUrl?: Maybe<Scalars['String']>;
  mainThemeAr?: Maybe<Scalars['String']>;
  mainThemeEn?: Maybe<Scalars['String']>;
  objectivesAr?: Maybe<Scalars['String']>;
  objectivesEn?: Maybe<Scalars['String']>;
  outcomesAr?: Maybe<Scalars['String']>;
  outcomesEn?: Maybe<Scalars['String']>;
  registrantId?: Maybe<Scalars['String']>;
  toTransferAmount?: Maybe<Scalars['Decimal']>;
  toTransferType?: Maybe<ToTransferType>;
  trainerId?: Maybe<Scalars['Int']>;
  whyTargetedAudienceAr?: Maybe<Scalars['String']>;
  whyTargetedAudienceEn?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['String']>;
};

export type TrainerEventMinOrderByAggregateInput = {
  contentIsAdded?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  introductionAr?: InputMaybe<SortOrder>;
  introductionEn?: InputMaybe<SortOrder>;
  isAllProfessionsTargeted?: InputMaybe<SortOrder>;
  joinUrl?: InputMaybe<SortOrder>;
  mainThemeAr?: InputMaybe<SortOrder>;
  mainThemeEn?: InputMaybe<SortOrder>;
  objectivesAr?: InputMaybe<SortOrder>;
  objectivesEn?: InputMaybe<SortOrder>;
  outcomesAr?: InputMaybe<SortOrder>;
  outcomesEn?: InputMaybe<SortOrder>;
  registrantId?: InputMaybe<SortOrder>;
  toTransferAmount?: InputMaybe<SortOrder>;
  toTransferType?: InputMaybe<SortOrder>;
  trainerId?: InputMaybe<SortOrder>;
  whyTargetedAudienceAr?: InputMaybe<SortOrder>;
  whyTargetedAudienceEn?: InputMaybe<SortOrder>;
  youtubeUrl?: InputMaybe<SortOrder>;
};

export type TrainerEventOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TrainerEventOrderByWithAggregationInput = {
  _avg?: InputMaybe<TrainerEventAvgOrderByAggregateInput>;
  _count?: InputMaybe<TrainerEventCountOrderByAggregateInput>;
  _max?: InputMaybe<TrainerEventMaxOrderByAggregateInput>;
  _min?: InputMaybe<TrainerEventMinOrderByAggregateInput>;
  _sum?: InputMaybe<TrainerEventSumOrderByAggregateInput>;
  contentIsAdded?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  emailState?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  introductionAr?: InputMaybe<SortOrder>;
  introductionEn?: InputMaybe<SortOrder>;
  isAllProfessionsTargeted?: InputMaybe<SortOrder>;
  joinUrl?: InputMaybe<SortOrder>;
  mainThemeAr?: InputMaybe<SortOrder>;
  mainThemeEn?: InputMaybe<SortOrder>;
  objectivesAr?: InputMaybe<SortOrder>;
  objectivesEn?: InputMaybe<SortOrder>;
  outcomesAr?: InputMaybe<SortOrder>;
  outcomesEn?: InputMaybe<SortOrder>;
  registrantId?: InputMaybe<SortOrder>;
  toTransferAmount?: InputMaybe<SortOrder>;
  toTransferType?: InputMaybe<SortOrder>;
  trainerId?: InputMaybe<SortOrder>;
  whyTargetedAudienceAr?: InputMaybe<SortOrder>;
  whyTargetedAudienceEn?: InputMaybe<SortOrder>;
  youtubeUrl?: InputMaybe<SortOrder>;
};

export type TrainerEventOrderByWithRelationInput = {
  Certificate?: InputMaybe<CertificateOrderByWithRelationInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialOrderByRelationAggregateInput>;
  ZohoEmail?: InputMaybe<ZohoEmailOrderByRelationAggregateInput>;
  contentIsAdded?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dayLessons?: InputMaybe<TrainerEventDayLessonOrderByRelationAggregateInput>;
  deletedAt?: InputMaybe<SortOrder>;
  emailState?: InputMaybe<SortOrder>;
  event?: InputMaybe<EventOrderByWithRelationInput>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  introductionAr?: InputMaybe<SortOrder>;
  introductionEn?: InputMaybe<SortOrder>;
  isAllProfessionsTargeted?: InputMaybe<SortOrder>;
  joinUrl?: InputMaybe<SortOrder>;
  mainThemeAr?: InputMaybe<SortOrder>;
  mainThemeEn?: InputMaybe<SortOrder>;
  objectivesAr?: InputMaybe<SortOrder>;
  objectivesEn?: InputMaybe<SortOrder>;
  outcomesAr?: InputMaybe<SortOrder>;
  outcomesEn?: InputMaybe<SortOrder>;
  registrantId?: InputMaybe<SortOrder>;
  targetedAudiences?: InputMaybe<ProfessionOrderByRelationAggregateInput>;
  targetedSpecialities?: InputMaybe<SpecialtyOrderByRelationAggregateInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotOrderByRelationAggregateInput>;
  toTransferAmount?: InputMaybe<SortOrder>;
  toTransferType?: InputMaybe<SortOrder>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewOrderByRelationAggregateInput>;
  trainer?: InputMaybe<UserOrderByWithRelationInput>;
  trainerId?: InputMaybe<SortOrder>;
  transitions?: InputMaybe<TransitionOrderByRelationAggregateInput>;
  whyTargetedAudienceAr?: InputMaybe<SortOrder>;
  whyTargetedAudienceEn?: InputMaybe<SortOrder>;
  youtubeUrl?: InputMaybe<SortOrder>;
};

export type TrainerEventRelationFilter = {
  is?: InputMaybe<TrainerEventWhereInput>;
  isNot?: InputMaybe<TrainerEventWhereInput>;
};

export enum TrainerEventScalarFieldEnum {
  ContentIsAdded = 'contentIsAdded',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  EmailState = 'emailState',
  EventId = 'eventId',
  Id = 'id',
  IntroductionAr = 'introductionAr',
  IntroductionEn = 'introductionEn',
  IsAllProfessionsTargeted = 'isAllProfessionsTargeted',
  JoinUrl = 'joinUrl',
  MainThemeAr = 'mainThemeAr',
  MainThemeEn = 'mainThemeEn',
  ObjectivesAr = 'objectivesAr',
  ObjectivesEn = 'objectivesEn',
  OutcomesAr = 'outcomesAr',
  OutcomesEn = 'outcomesEn',
  RegistrantId = 'registrantId',
  ToTransferAmount = 'toTransferAmount',
  ToTransferType = 'toTransferType',
  TrainerId = 'trainerId',
  WhyTargetedAudienceAr = 'whyTargetedAudienceAr',
  WhyTargetedAudienceEn = 'whyTargetedAudienceEn',
  YoutubeUrl = 'youtubeUrl'
}

export type TrainerEventScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TrainerEventScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TrainerEventScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TrainerEventScalarWhereInput>>>;
  contentIsAdded?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  emailState?: InputMaybe<JsonNullableFilter>;
  eventId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  introductionAr?: InputMaybe<StringNullableFilter>;
  introductionEn?: InputMaybe<StringNullableFilter>;
  isAllProfessionsTargeted?: InputMaybe<BoolNullableFilter>;
  joinUrl?: InputMaybe<StringNullableFilter>;
  mainThemeAr?: InputMaybe<StringNullableFilter>;
  mainThemeEn?: InputMaybe<StringNullableFilter>;
  objectivesAr?: InputMaybe<StringNullableFilter>;
  objectivesEn?: InputMaybe<StringNullableFilter>;
  outcomesAr?: InputMaybe<StringNullableFilter>;
  outcomesEn?: InputMaybe<StringNullableFilter>;
  registrantId?: InputMaybe<StringNullableFilter>;
  toTransferAmount?: InputMaybe<DecimalNullableFilter>;
  toTransferType?: InputMaybe<EnumToTransferTypeNullableFilter>;
  trainerId?: InputMaybe<IntFilter>;
  whyTargetedAudienceAr?: InputMaybe<StringNullableFilter>;
  whyTargetedAudienceEn?: InputMaybe<StringNullableFilter>;
  youtubeUrl?: InputMaybe<StringNullableFilter>;
};

export type TrainerEventScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<TrainerEventScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TrainerEventScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TrainerEventScalarWhereWithAggregatesInput>>>;
  contentIsAdded?: InputMaybe<BoolNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  emailState?: InputMaybe<JsonNullableWithAggregatesFilter>;
  eventId?: InputMaybe<IntWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  introductionAr?: InputMaybe<StringNullableWithAggregatesFilter>;
  introductionEn?: InputMaybe<StringNullableWithAggregatesFilter>;
  isAllProfessionsTargeted?: InputMaybe<BoolNullableWithAggregatesFilter>;
  joinUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  mainThemeAr?: InputMaybe<StringNullableWithAggregatesFilter>;
  mainThemeEn?: InputMaybe<StringNullableWithAggregatesFilter>;
  objectivesAr?: InputMaybe<StringNullableWithAggregatesFilter>;
  objectivesEn?: InputMaybe<StringNullableWithAggregatesFilter>;
  outcomesAr?: InputMaybe<StringNullableWithAggregatesFilter>;
  outcomesEn?: InputMaybe<StringNullableWithAggregatesFilter>;
  registrantId?: InputMaybe<StringNullableWithAggregatesFilter>;
  toTransferAmount?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  toTransferType?: InputMaybe<EnumToTransferTypeNullableWithAggregatesFilter>;
  trainerId?: InputMaybe<IntWithAggregatesFilter>;
  whyTargetedAudienceAr?: InputMaybe<StringNullableWithAggregatesFilter>;
  whyTargetedAudienceEn?: InputMaybe<StringNullableWithAggregatesFilter>;
  youtubeUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type TrainerEventStudyMaterial = {
  __typename?: 'TrainerEventStudyMaterial';
  Quiz?: Maybe<Quiz>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: Event;
  eventId: Scalars['Int'];
  id: Scalars['Int'];
  media?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  progressPercentage?: Maybe<Scalars['Decimal']>;
  title: Scalars['String'];
  traineeEventStudyMaterialAttendance: Array<TraineeEventStudyMaterialAttendance>;
  trainerEvent?: Maybe<TrainerEvent>;
  trainerEventId?: Maybe<Scalars['Int']>;
  trainerEventStudyMaterialGroup?: Maybe<TrainerEventStudyMaterialGroup>;
  trainerEventStudyMaterialGroupId?: Maybe<Scalars['Int']>;
  url: Scalars['String'];
};

export type TrainerEventStudyMaterialAvgAggregateOutputType = {
  __typename?: 'TrainerEventStudyMaterialAvgAggregateOutputType';
  eventId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  quizId?: Maybe<Scalars['Float']>;
  trainerEventId?: Maybe<Scalars['Float']>;
  trainerEventStudyMaterialGroupId?: Maybe<Scalars['Float']>;
};

export type TrainerEventStudyMaterialAvgOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  quizId?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
  trainerEventStudyMaterialGroupId?: InputMaybe<SortOrder>;
};

export type TrainerEventStudyMaterialCountAggregateOutputType = {
  __typename?: 'TrainerEventStudyMaterialCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  eventId: Scalars['Int'];
  id: Scalars['Int'];
  media: Scalars['Int'];
  order: Scalars['Int'];
  quizId: Scalars['Int'];
  title: Scalars['Int'];
  trainerEventId: Scalars['Int'];
  trainerEventStudyMaterialGroupId: Scalars['Int'];
  url: Scalars['Int'];
};

export type TrainerEventStudyMaterialCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  media?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  quizId?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
  trainerEventStudyMaterialGroupId?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type TrainerEventStudyMaterialCountOutputType = {
  __typename?: 'TrainerEventStudyMaterialCountOutputType';
  traineeEventStudyMaterialAttendance: Scalars['Int'];
};

export type TrainerEventStudyMaterialCreateInput = {
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutTrainerEventStudyMaterialInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  event: EventCreateNestedOneWithoutTrainerEventStudyMaterialsInput;
  media?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceCreateNestedManyWithoutTrainerEventStudyMaterialInput>;
  trainerEvent?: InputMaybe<TrainerEventCreateNestedOneWithoutStudyMaterialsInput>;
  trainerEventStudyMaterialGroup?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedOneWithoutStudyMaterialsInput>;
  url: Scalars['String'];
};

export type TrainerEventStudyMaterialCreateManyEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  media?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  quizId?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  trainerEventId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroupId?: InputMaybe<Scalars['Int']>;
  url: Scalars['String'];
};

export type TrainerEventStudyMaterialCreateManyEventInputEnvelope = {
  data: TrainerEventStudyMaterialCreateManyEventInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TrainerEventStudyMaterialCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  media?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  quizId?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  trainerEventId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroupId?: InputMaybe<Scalars['Int']>;
  url: Scalars['String'];
};

export type TrainerEventStudyMaterialCreateManyQuizInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  media?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  trainerEventId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroupId?: InputMaybe<Scalars['Int']>;
  url: Scalars['String'];
};

export type TrainerEventStudyMaterialCreateManyQuizInputEnvelope = {
  data: TrainerEventStudyMaterialCreateManyQuizInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TrainerEventStudyMaterialCreateManyTrainerEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  media?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  quizId?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  trainerEventStudyMaterialGroupId?: InputMaybe<Scalars['Int']>;
  url: Scalars['String'];
};

export type TrainerEventStudyMaterialCreateManyTrainerEventInputEnvelope = {
  data: TrainerEventStudyMaterialCreateManyTrainerEventInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TrainerEventStudyMaterialCreateManyTrainerEventStudyMaterialGroupInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  media?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  quizId?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  trainerEventId?: InputMaybe<Scalars['Int']>;
  url: Scalars['String'];
};

export type TrainerEventStudyMaterialCreateManyTrainerEventStudyMaterialGroupInputEnvelope = {
  data: TrainerEventStudyMaterialCreateManyTrainerEventStudyMaterialGroupInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TrainerEventStudyMaterialCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialCreateWithoutEventInput>>>;
  createMany?: InputMaybe<TrainerEventStudyMaterialCreateManyEventInputEnvelope>;
};

export type TrainerEventStudyMaterialCreateNestedManyWithoutQuizInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialCreateOrConnectWithoutQuizInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialCreateWithoutQuizInput>>>;
  createMany?: InputMaybe<TrainerEventStudyMaterialCreateManyQuizInputEnvelope>;
};

export type TrainerEventStudyMaterialCreateNestedManyWithoutTrainerEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialCreateOrConnectWithoutTrainerEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialCreateWithoutTrainerEventInput>>>;
  createMany?: InputMaybe<TrainerEventStudyMaterialCreateManyTrainerEventInputEnvelope>;
};

export type TrainerEventStudyMaterialCreateNestedManyWithoutTrainerEventStudyMaterialGroupInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialCreateOrConnectWithoutTrainerEventStudyMaterialGroupInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialCreateWithoutTrainerEventStudyMaterialGroupInput>>>;
  createMany?: InputMaybe<TrainerEventStudyMaterialCreateManyTrainerEventStudyMaterialGroupInputEnvelope>;
};

export type TrainerEventStudyMaterialCreateNestedOneWithoutTraineeEventStudyMaterialAttendanceInput = {
  connect?: InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TrainerEventStudyMaterialCreateOrConnectWithoutTraineeEventStudyMaterialAttendanceInput>;
  create?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateWithoutTraineeEventStudyMaterialAttendanceInput>;
};

export type TrainerEventStudyMaterialCreateOrConnectWithoutEventInput = {
  create: TrainerEventStudyMaterialUncheckedCreateWithoutEventInput;
  where: TrainerEventStudyMaterialWhereUniqueInput;
};

export type TrainerEventStudyMaterialCreateOrConnectWithoutQuizInput = {
  create: TrainerEventStudyMaterialUncheckedCreateWithoutQuizInput;
  where: TrainerEventStudyMaterialWhereUniqueInput;
};

export type TrainerEventStudyMaterialCreateOrConnectWithoutTraineeEventStudyMaterialAttendanceInput = {
  create: TrainerEventStudyMaterialUncheckedCreateWithoutTraineeEventStudyMaterialAttendanceInput;
  where: TrainerEventStudyMaterialWhereUniqueInput;
};

export type TrainerEventStudyMaterialCreateOrConnectWithoutTrainerEventInput = {
  create: TrainerEventStudyMaterialUncheckedCreateWithoutTrainerEventInput;
  where: TrainerEventStudyMaterialWhereUniqueInput;
};

export type TrainerEventStudyMaterialCreateOrConnectWithoutTrainerEventStudyMaterialGroupInput = {
  create: TrainerEventStudyMaterialUncheckedCreateWithoutTrainerEventStudyMaterialGroupInput;
  where: TrainerEventStudyMaterialWhereUniqueInput;
};

export type TrainerEventStudyMaterialCreateWithoutEventInput = {
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutTrainerEventStudyMaterialInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  media?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceCreateNestedManyWithoutTrainerEventStudyMaterialInput>;
  trainerEvent?: InputMaybe<TrainerEventCreateNestedOneWithoutStudyMaterialsInput>;
  trainerEventStudyMaterialGroup?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedOneWithoutStudyMaterialsInput>;
  url: Scalars['String'];
};

export type TrainerEventStudyMaterialCreateWithoutQuizInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  event: EventCreateNestedOneWithoutTrainerEventStudyMaterialsInput;
  media?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceCreateNestedManyWithoutTrainerEventStudyMaterialInput>;
  trainerEvent?: InputMaybe<TrainerEventCreateNestedOneWithoutStudyMaterialsInput>;
  trainerEventStudyMaterialGroup?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedOneWithoutStudyMaterialsInput>;
  url: Scalars['String'];
};

export type TrainerEventStudyMaterialCreateWithoutTraineeEventStudyMaterialAttendanceInput = {
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutTrainerEventStudyMaterialInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  event: EventCreateNestedOneWithoutTrainerEventStudyMaterialsInput;
  media?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  trainerEvent?: InputMaybe<TrainerEventCreateNestedOneWithoutStudyMaterialsInput>;
  trainerEventStudyMaterialGroup?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedOneWithoutStudyMaterialsInput>;
  url: Scalars['String'];
};

export type TrainerEventStudyMaterialCreateWithoutTrainerEventInput = {
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutTrainerEventStudyMaterialInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  event: EventCreateNestedOneWithoutTrainerEventStudyMaterialsInput;
  media?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceCreateNestedManyWithoutTrainerEventStudyMaterialInput>;
  trainerEventStudyMaterialGroup?: InputMaybe<TrainerEventStudyMaterialGroupCreateNestedOneWithoutStudyMaterialsInput>;
  url: Scalars['String'];
};

export type TrainerEventStudyMaterialCreateWithoutTrainerEventStudyMaterialGroupInput = {
  Quiz?: InputMaybe<QuizCreateNestedOneWithoutTrainerEventStudyMaterialInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  event: EventCreateNestedOneWithoutTrainerEventStudyMaterialsInput;
  media?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceCreateNestedManyWithoutTrainerEventStudyMaterialInput>;
  trainerEvent?: InputMaybe<TrainerEventCreateNestedOneWithoutStudyMaterialsInput>;
  url: Scalars['String'];
};

export type TrainerEventStudyMaterialGroup = {
  __typename?: 'TrainerEventStudyMaterialGroup';
  StudyMaterials: Array<TrainerEventStudyMaterial>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event: Event;
  eventId: Scalars['Int'];
  id: Scalars['Int'];
  order: Scalars['Int'];
  title: Scalars['String'];
};

export type TrainerEventStudyMaterialGroupAvgAggregateOutputType = {
  __typename?: 'TrainerEventStudyMaterialGroupAvgAggregateOutputType';
  eventId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

export type TrainerEventStudyMaterialGroupAvgOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
};

export type TrainerEventStudyMaterialGroupCountAggregateOutputType = {
  __typename?: 'TrainerEventStudyMaterialGroupCountAggregateOutputType';
  _all: Scalars['Int'];
  eventId: Scalars['Int'];
  id: Scalars['Int'];
  order: Scalars['Int'];
  title: Scalars['Int'];
};

export type TrainerEventStudyMaterialGroupCountOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type TrainerEventStudyMaterialGroupCountOutputType = {
  __typename?: 'TrainerEventStudyMaterialGroupCountOutputType';
  StudyMaterials: Scalars['Int'];
};

export type TrainerEventStudyMaterialGroupCreateInput = {
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutTrainerEventStudyMaterialGroupInput>;
  event: EventCreateNestedOneWithoutTrainerEventStudyMaterialGroupsInput;
  order?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type TrainerEventStudyMaterialGroupCreateManyEventInput = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type TrainerEventStudyMaterialGroupCreateManyEventInputEnvelope = {
  data: TrainerEventStudyMaterialGroupCreateManyEventInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TrainerEventStudyMaterialGroupCreateManyInput = {
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type TrainerEventStudyMaterialGroupCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupCreateWithoutEventInput>>>;
  createMany?: InputMaybe<TrainerEventStudyMaterialGroupCreateManyEventInputEnvelope>;
};

export type TrainerEventStudyMaterialGroupCreateNestedOneWithoutStudyMaterialsInput = {
  connect?: InputMaybe<TrainerEventStudyMaterialGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TrainerEventStudyMaterialGroupCreateOrConnectWithoutStudyMaterialsInput>;
  create?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateWithoutStudyMaterialsInput>;
};

export type TrainerEventStudyMaterialGroupCreateOrConnectWithoutEventInput = {
  create: TrainerEventStudyMaterialGroupUncheckedCreateWithoutEventInput;
  where: TrainerEventStudyMaterialGroupWhereUniqueInput;
};

export type TrainerEventStudyMaterialGroupCreateOrConnectWithoutStudyMaterialsInput = {
  create: TrainerEventStudyMaterialGroupUncheckedCreateWithoutStudyMaterialsInput;
  where: TrainerEventStudyMaterialGroupWhereUniqueInput;
};

export type TrainerEventStudyMaterialGroupCreateWithoutEventInput = {
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialCreateNestedManyWithoutTrainerEventStudyMaterialGroupInput>;
  order?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type TrainerEventStudyMaterialGroupCreateWithoutStudyMaterialsInput = {
  event: EventCreateNestedOneWithoutTrainerEventStudyMaterialGroupsInput;
  order?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type TrainerEventStudyMaterialGroupListRelationFilter = {
  every?: InputMaybe<TrainerEventStudyMaterialGroupWhereInput>;
  none?: InputMaybe<TrainerEventStudyMaterialGroupWhereInput>;
  some?: InputMaybe<TrainerEventStudyMaterialGroupWhereInput>;
};

export type TrainerEventStudyMaterialGroupMaxAggregateOutputType = {
  __typename?: 'TrainerEventStudyMaterialGroupMaxAggregateOutputType';
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type TrainerEventStudyMaterialGroupMaxOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type TrainerEventStudyMaterialGroupMinAggregateOutputType = {
  __typename?: 'TrainerEventStudyMaterialGroupMinAggregateOutputType';
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type TrainerEventStudyMaterialGroupMinOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type TrainerEventStudyMaterialGroupOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TrainerEventStudyMaterialGroupOrderByWithAggregationInput = {
  _avg?: InputMaybe<TrainerEventStudyMaterialGroupAvgOrderByAggregateInput>;
  _count?: InputMaybe<TrainerEventStudyMaterialGroupCountOrderByAggregateInput>;
  _max?: InputMaybe<TrainerEventStudyMaterialGroupMaxOrderByAggregateInput>;
  _min?: InputMaybe<TrainerEventStudyMaterialGroupMinOrderByAggregateInput>;
  _sum?: InputMaybe<TrainerEventStudyMaterialGroupSumOrderByAggregateInput>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type TrainerEventStudyMaterialGroupOrderByWithRelationInput = {
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialOrderByRelationAggregateInput>;
  event?: InputMaybe<EventOrderByWithRelationInput>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type TrainerEventStudyMaterialGroupRelationFilter = {
  is?: InputMaybe<TrainerEventStudyMaterialGroupWhereInput>;
  isNot?: InputMaybe<TrainerEventStudyMaterialGroupWhereInput>;
};

export enum TrainerEventStudyMaterialGroupScalarFieldEnum {
  EventId = 'eventId',
  Id = 'id',
  Order = 'order',
  Title = 'title'
}

export type TrainerEventStudyMaterialGroupScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupScalarWhereInput>>>;
  eventId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  order?: InputMaybe<IntFilter>;
  title?: InputMaybe<StringFilter>;
};

export type TrainerEventStudyMaterialGroupScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupScalarWhereWithAggregatesInput>>>;
  eventId?: InputMaybe<IntWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  order?: InputMaybe<IntWithAggregatesFilter>;
  title?: InputMaybe<StringWithAggregatesFilter>;
};

export type TrainerEventStudyMaterialGroupSumAggregateOutputType = {
  __typename?: 'TrainerEventStudyMaterialGroupSumAggregateOutputType';
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
};

export type TrainerEventStudyMaterialGroupSumOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
};

export type TrainerEventStudyMaterialGroupUncheckedCreateInput = {
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutTrainerEventStudyMaterialGroupInput>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type TrainerEventStudyMaterialGroupUncheckedCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupCreateWithoutEventInput>>>;
  createMany?: InputMaybe<TrainerEventStudyMaterialGroupCreateManyEventInputEnvelope>;
};

export type TrainerEventStudyMaterialGroupUncheckedCreateWithoutEventInput = {
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutTrainerEventStudyMaterialGroupInput>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type TrainerEventStudyMaterialGroupUncheckedCreateWithoutStudyMaterialsInput = {
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type TrainerEventStudyMaterialGroupUncheckedUpdateInput = {
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutTrainerEventStudyMaterialGroupInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrainerEventStudyMaterialGroupUncheckedUpdateManyInput = {
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupCreateWithoutEventInput>>>;
  createMany?: InputMaybe<TrainerEventStudyMaterialGroupCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupUpdateWithWhereUniqueWithoutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithWhereWithoutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupUpsertWithWhereUniqueWithoutEventInput>>>;
};

export type TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutTrainerEventStudyMaterialGroupsInput = {
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrainerEventStudyMaterialGroupUncheckedUpdateWithoutEventInput = {
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutTrainerEventStudyMaterialGroupInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrainerEventStudyMaterialGroupUncheckedUpdateWithoutStudyMaterialsInput = {
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrainerEventStudyMaterialGroupUpdateInput = {
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutTrainerEventStudyMaterialGroupInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTrainerEventStudyMaterialGroupsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrainerEventStudyMaterialGroupUpdateManyMutationInput = {
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrainerEventStudyMaterialGroupUpdateManyWithWhereWithoutEventInput = {
  data: TrainerEventStudyMaterialGroupUncheckedUpdateManyWithoutTrainerEventStudyMaterialGroupsInput;
  where: TrainerEventStudyMaterialGroupScalarWhereInput;
};

export type TrainerEventStudyMaterialGroupUpdateManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupCreateWithoutEventInput>>>;
  createMany?: InputMaybe<TrainerEventStudyMaterialGroupCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupUpdateWithWhereUniqueWithoutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupUpdateManyWithWhereWithoutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupUpsertWithWhereUniqueWithoutEventInput>>>;
};

export type TrainerEventStudyMaterialGroupUpdateOneWithoutStudyMaterialsInput = {
  connect?: InputMaybe<TrainerEventStudyMaterialGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TrainerEventStudyMaterialGroupCreateOrConnectWithoutStudyMaterialsInput>;
  create?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedCreateWithoutStudyMaterialsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<TrainerEventStudyMaterialGroupUncheckedUpdateWithoutStudyMaterialsInput>;
  upsert?: InputMaybe<TrainerEventStudyMaterialGroupUpsertWithoutStudyMaterialsInput>;
};

export type TrainerEventStudyMaterialGroupUpdateWithWhereUniqueWithoutEventInput = {
  data: TrainerEventStudyMaterialGroupUncheckedUpdateWithoutEventInput;
  where: TrainerEventStudyMaterialGroupWhereUniqueInput;
};

export type TrainerEventStudyMaterialGroupUpdateWithoutEventInput = {
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutTrainerEventStudyMaterialGroupInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrainerEventStudyMaterialGroupUpdateWithoutStudyMaterialsInput = {
  event?: InputMaybe<EventUpdateOneRequiredWithoutTrainerEventStudyMaterialGroupsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrainerEventStudyMaterialGroupUpsertWithWhereUniqueWithoutEventInput = {
  create: TrainerEventStudyMaterialGroupUncheckedCreateWithoutEventInput;
  update: TrainerEventStudyMaterialGroupUncheckedUpdateWithoutEventInput;
  where: TrainerEventStudyMaterialGroupWhereUniqueInput;
};

export type TrainerEventStudyMaterialGroupUpsertWithoutStudyMaterialsInput = {
  create: TrainerEventStudyMaterialGroupUncheckedCreateWithoutStudyMaterialsInput;
  update: TrainerEventStudyMaterialGroupUncheckedUpdateWithoutStudyMaterialsInput;
};

export type TrainerEventStudyMaterialGroupWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialGroupWhereInput>>>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialListRelationFilter>;
  event?: InputMaybe<EventWhereInput>;
  eventId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  order?: InputMaybe<IntFilter>;
  title?: InputMaybe<StringFilter>;
};

export type TrainerEventStudyMaterialGroupWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type TrainerEventStudyMaterialListRelationFilter = {
  every?: InputMaybe<TrainerEventStudyMaterialWhereInput>;
  none?: InputMaybe<TrainerEventStudyMaterialWhereInput>;
  some?: InputMaybe<TrainerEventStudyMaterialWhereInput>;
};

export type TrainerEventStudyMaterialMaxAggregateOutputType = {
  __typename?: 'TrainerEventStudyMaterialMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  media?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  quizId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  trainerEventId?: Maybe<Scalars['Int']>;
  trainerEventStudyMaterialGroupId?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
};

export type TrainerEventStudyMaterialMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  media?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  quizId?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
  trainerEventStudyMaterialGroupId?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type TrainerEventStudyMaterialMinAggregateOutputType = {
  __typename?: 'TrainerEventStudyMaterialMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  media?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  quizId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  trainerEventId?: Maybe<Scalars['Int']>;
  trainerEventStudyMaterialGroupId?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
};

export type TrainerEventStudyMaterialMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  media?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  quizId?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
  trainerEventStudyMaterialGroupId?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type TrainerEventStudyMaterialOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TrainerEventStudyMaterialOrderByWithAggregationInput = {
  _avg?: InputMaybe<TrainerEventStudyMaterialAvgOrderByAggregateInput>;
  _count?: InputMaybe<TrainerEventStudyMaterialCountOrderByAggregateInput>;
  _max?: InputMaybe<TrainerEventStudyMaterialMaxOrderByAggregateInput>;
  _min?: InputMaybe<TrainerEventStudyMaterialMinOrderByAggregateInput>;
  _sum?: InputMaybe<TrainerEventStudyMaterialSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  media?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  quizId?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
  trainerEventStudyMaterialGroupId?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type TrainerEventStudyMaterialOrderByWithRelationInput = {
  Quiz?: InputMaybe<QuizOrderByWithRelationInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  event?: InputMaybe<EventOrderByWithRelationInput>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  media?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  quizId?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceOrderByRelationAggregateInput>;
  trainerEvent?: InputMaybe<TrainerEventOrderByWithRelationInput>;
  trainerEventId?: InputMaybe<SortOrder>;
  trainerEventStudyMaterialGroup?: InputMaybe<TrainerEventStudyMaterialGroupOrderByWithRelationInput>;
  trainerEventStudyMaterialGroupId?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type TrainerEventStudyMaterialRelationFilter = {
  is?: InputMaybe<TrainerEventStudyMaterialWhereInput>;
  isNot?: InputMaybe<TrainerEventStudyMaterialWhereInput>;
};

export enum TrainerEventStudyMaterialScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  EventId = 'eventId',
  Id = 'id',
  Media = 'media',
  Order = 'order',
  QuizId = 'quizId',
  Title = 'title',
  TrainerEventId = 'trainerEventId',
  TrainerEventStudyMaterialGroupId = 'trainerEventStudyMaterialGroupId',
  Url = 'url'
}

export type TrainerEventStudyMaterialScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialScalarWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  eventId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  media?: InputMaybe<StringNullableFilter>;
  order?: InputMaybe<IntFilter>;
  quizId?: InputMaybe<IntNullableFilter>;
  title?: InputMaybe<StringFilter>;
  trainerEventId?: InputMaybe<IntNullableFilter>;
  trainerEventStudyMaterialGroupId?: InputMaybe<IntNullableFilter>;
  url?: InputMaybe<StringFilter>;
};

export type TrainerEventStudyMaterialScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  eventId?: InputMaybe<IntWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  media?: InputMaybe<StringNullableWithAggregatesFilter>;
  order?: InputMaybe<IntWithAggregatesFilter>;
  quizId?: InputMaybe<IntNullableWithAggregatesFilter>;
  title?: InputMaybe<StringWithAggregatesFilter>;
  trainerEventId?: InputMaybe<IntNullableWithAggregatesFilter>;
  trainerEventStudyMaterialGroupId?: InputMaybe<IntNullableWithAggregatesFilter>;
  url?: InputMaybe<StringWithAggregatesFilter>;
};

export type TrainerEventStudyMaterialSumAggregateOutputType = {
  __typename?: 'TrainerEventStudyMaterialSumAggregateOutputType';
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  quizId?: Maybe<Scalars['Int']>;
  trainerEventId?: Maybe<Scalars['Int']>;
  trainerEventStudyMaterialGroupId?: Maybe<Scalars['Int']>;
};

export type TrainerEventStudyMaterialSumOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  quizId?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
  trainerEventStudyMaterialGroupId?: InputMaybe<SortOrder>;
};

export type TrainerEventStudyMaterialUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  media?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  quizId?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedCreateNestedManyWithoutTrainerEventStudyMaterialInput>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroupId?: InputMaybe<Scalars['Int']>;
  url: Scalars['String'];
};

export type TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialCreateWithoutEventInput>>>;
  createMany?: InputMaybe<TrainerEventStudyMaterialCreateManyEventInputEnvelope>;
};

export type TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutQuizInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialCreateOrConnectWithoutQuizInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialCreateWithoutQuizInput>>>;
  createMany?: InputMaybe<TrainerEventStudyMaterialCreateManyQuizInputEnvelope>;
};

export type TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutTrainerEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialCreateOrConnectWithoutTrainerEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialCreateWithoutTrainerEventInput>>>;
  createMany?: InputMaybe<TrainerEventStudyMaterialCreateManyTrainerEventInputEnvelope>;
};

export type TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutTrainerEventStudyMaterialGroupInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialCreateOrConnectWithoutTrainerEventStudyMaterialGroupInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialCreateWithoutTrainerEventStudyMaterialGroupInput>>>;
  createMany?: InputMaybe<TrainerEventStudyMaterialCreateManyTrainerEventStudyMaterialGroupInputEnvelope>;
};

export type TrainerEventStudyMaterialUncheckedCreateWithoutEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  media?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  quizId?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedCreateNestedManyWithoutTrainerEventStudyMaterialInput>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroupId?: InputMaybe<Scalars['Int']>;
  url: Scalars['String'];
};

export type TrainerEventStudyMaterialUncheckedCreateWithoutQuizInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  media?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedCreateNestedManyWithoutTrainerEventStudyMaterialInput>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroupId?: InputMaybe<Scalars['Int']>;
  url: Scalars['String'];
};

export type TrainerEventStudyMaterialUncheckedCreateWithoutTraineeEventStudyMaterialAttendanceInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  media?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  quizId?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  trainerEventId?: InputMaybe<Scalars['Int']>;
  trainerEventStudyMaterialGroupId?: InputMaybe<Scalars['Int']>;
  url: Scalars['String'];
};

export type TrainerEventStudyMaterialUncheckedCreateWithoutTrainerEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  media?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  quizId?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedCreateNestedManyWithoutTrainerEventStudyMaterialInput>;
  trainerEventStudyMaterialGroupId?: InputMaybe<Scalars['Int']>;
  url: Scalars['String'];
};

export type TrainerEventStudyMaterialUncheckedCreateWithoutTrainerEventStudyMaterialGroupInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  media?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  quizId?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedCreateNestedManyWithoutTrainerEventStudyMaterialInput>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  url: Scalars['String'];
};

export type TrainerEventStudyMaterialUncheckedUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  media?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  quizId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedUpdateManyWithoutTrainerEventStudyMaterialInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrainerEventStudyMaterialUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  media?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  quizId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrainerEventStudyMaterialUncheckedUpdateManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialCreateWithoutEventInput>>>;
  createMany?: InputMaybe<TrainerEventStudyMaterialCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialUpdateWithWhereUniqueWithoutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialUpdateManyWithWhereWithoutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialUpsertWithWhereUniqueWithoutEventInput>>>;
};

export type TrainerEventStudyMaterialUncheckedUpdateManyWithoutQuizInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialCreateOrConnectWithoutQuizInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialCreateWithoutQuizInput>>>;
  createMany?: InputMaybe<TrainerEventStudyMaterialCreateManyQuizInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialUpdateWithWhereUniqueWithoutQuizInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialUpdateManyWithWhereWithoutQuizInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialUpsertWithWhereUniqueWithoutQuizInput>>>;
};

export type TrainerEventStudyMaterialUncheckedUpdateManyWithoutStudyMaterialsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  media?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  quizId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrainerEventStudyMaterialUncheckedUpdateManyWithoutTrainerEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialCreateOrConnectWithoutTrainerEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialCreateWithoutTrainerEventInput>>>;
  createMany?: InputMaybe<TrainerEventStudyMaterialCreateManyTrainerEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialUpdateWithWhereUniqueWithoutTrainerEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialUpdateManyWithWhereWithoutTrainerEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialUpsertWithWhereUniqueWithoutTrainerEventInput>>>;
};

export type TrainerEventStudyMaterialUncheckedUpdateManyWithoutTrainerEventStudyMaterialGroupInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialCreateOrConnectWithoutTrainerEventStudyMaterialGroupInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialCreateWithoutTrainerEventStudyMaterialGroupInput>>>;
  createMany?: InputMaybe<TrainerEventStudyMaterialCreateManyTrainerEventStudyMaterialGroupInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialUpdateWithWhereUniqueWithoutTrainerEventStudyMaterialGroupInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialUpdateManyWithWhereWithoutTrainerEventStudyMaterialGroupInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialUpsertWithWhereUniqueWithoutTrainerEventStudyMaterialGroupInput>>>;
};

export type TrainerEventStudyMaterialUncheckedUpdateManyWithoutTrainerEventStudyMaterialInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  media?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrainerEventStudyMaterialUncheckedUpdateManyWithoutTrainerEventStudyMaterialsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  media?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  quizId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrainerEventStudyMaterialUncheckedUpdateWithoutEventInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  media?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  quizId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedUpdateManyWithoutTrainerEventStudyMaterialInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrainerEventStudyMaterialUncheckedUpdateWithoutQuizInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  media?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedUpdateManyWithoutTrainerEventStudyMaterialInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrainerEventStudyMaterialUncheckedUpdateWithoutTraineeEventStudyMaterialAttendanceInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  media?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  quizId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventStudyMaterialGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrainerEventStudyMaterialUncheckedUpdateWithoutTrainerEventInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  media?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  quizId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedUpdateManyWithoutTrainerEventStudyMaterialInput>;
  trainerEventStudyMaterialGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrainerEventStudyMaterialUncheckedUpdateWithoutTrainerEventStudyMaterialGroupInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  media?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  quizId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUncheckedUpdateManyWithoutTrainerEventStudyMaterialInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrainerEventStudyMaterialUpdateInput = {
  Quiz?: InputMaybe<QuizUpdateOneWithoutTrainerEventStudyMaterialInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTrainerEventStudyMaterialsInput>;
  media?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUpdateManyWithoutTrainerEventStudyMaterialInput>;
  trainerEvent?: InputMaybe<TrainerEventUpdateOneWithoutStudyMaterialsInput>;
  trainerEventStudyMaterialGroup?: InputMaybe<TrainerEventStudyMaterialGroupUpdateOneWithoutStudyMaterialsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrainerEventStudyMaterialUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  media?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrainerEventStudyMaterialUpdateManyWithWhereWithoutEventInput = {
  data: TrainerEventStudyMaterialUncheckedUpdateManyWithoutTrainerEventStudyMaterialsInput;
  where: TrainerEventStudyMaterialScalarWhereInput;
};

export type TrainerEventStudyMaterialUpdateManyWithWhereWithoutQuizInput = {
  data: TrainerEventStudyMaterialUncheckedUpdateManyWithoutTrainerEventStudyMaterialInput;
  where: TrainerEventStudyMaterialScalarWhereInput;
};

export type TrainerEventStudyMaterialUpdateManyWithWhereWithoutTrainerEventInput = {
  data: TrainerEventStudyMaterialUncheckedUpdateManyWithoutStudyMaterialsInput;
  where: TrainerEventStudyMaterialScalarWhereInput;
};

export type TrainerEventStudyMaterialUpdateManyWithWhereWithoutTrainerEventStudyMaterialGroupInput = {
  data: TrainerEventStudyMaterialUncheckedUpdateManyWithoutStudyMaterialsInput;
  where: TrainerEventStudyMaterialScalarWhereInput;
};

export type TrainerEventStudyMaterialUpdateManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialCreateWithoutEventInput>>>;
  createMany?: InputMaybe<TrainerEventStudyMaterialCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialUpdateWithWhereUniqueWithoutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialUpdateManyWithWhereWithoutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialUpsertWithWhereUniqueWithoutEventInput>>>;
};

export type TrainerEventStudyMaterialUpdateManyWithoutQuizInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialCreateOrConnectWithoutQuizInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialCreateWithoutQuizInput>>>;
  createMany?: InputMaybe<TrainerEventStudyMaterialCreateManyQuizInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialUpdateWithWhereUniqueWithoutQuizInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialUpdateManyWithWhereWithoutQuizInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialUpsertWithWhereUniqueWithoutQuizInput>>>;
};

export type TrainerEventStudyMaterialUpdateManyWithoutTrainerEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialCreateOrConnectWithoutTrainerEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialCreateWithoutTrainerEventInput>>>;
  createMany?: InputMaybe<TrainerEventStudyMaterialCreateManyTrainerEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialUpdateWithWhereUniqueWithoutTrainerEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialUpdateManyWithWhereWithoutTrainerEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialUpsertWithWhereUniqueWithoutTrainerEventInput>>>;
};

export type TrainerEventStudyMaterialUpdateManyWithoutTrainerEventStudyMaterialGroupInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialCreateOrConnectWithoutTrainerEventStudyMaterialGroupInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialCreateWithoutTrainerEventStudyMaterialGroupInput>>>;
  createMany?: InputMaybe<TrainerEventStudyMaterialCreateManyTrainerEventStudyMaterialGroupInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialUpdateWithWhereUniqueWithoutTrainerEventStudyMaterialGroupInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialUpdateManyWithWhereWithoutTrainerEventStudyMaterialGroupInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialUpsertWithWhereUniqueWithoutTrainerEventStudyMaterialGroupInput>>>;
};

export type TrainerEventStudyMaterialUpdateOneRequiredWithoutTraineeEventStudyMaterialAttendanceInput = {
  connect?: InputMaybe<TrainerEventStudyMaterialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TrainerEventStudyMaterialCreateOrConnectWithoutTraineeEventStudyMaterialAttendanceInput>;
  create?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateWithoutTraineeEventStudyMaterialAttendanceInput>;
  update?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateWithoutTraineeEventStudyMaterialAttendanceInput>;
  upsert?: InputMaybe<TrainerEventStudyMaterialUpsertWithoutTraineeEventStudyMaterialAttendanceInput>;
};

export type TrainerEventStudyMaterialUpdateWithWhereUniqueWithoutEventInput = {
  data: TrainerEventStudyMaterialUncheckedUpdateWithoutEventInput;
  where: TrainerEventStudyMaterialWhereUniqueInput;
};

export type TrainerEventStudyMaterialUpdateWithWhereUniqueWithoutQuizInput = {
  data: TrainerEventStudyMaterialUncheckedUpdateWithoutQuizInput;
  where: TrainerEventStudyMaterialWhereUniqueInput;
};

export type TrainerEventStudyMaterialUpdateWithWhereUniqueWithoutTrainerEventInput = {
  data: TrainerEventStudyMaterialUncheckedUpdateWithoutTrainerEventInput;
  where: TrainerEventStudyMaterialWhereUniqueInput;
};

export type TrainerEventStudyMaterialUpdateWithWhereUniqueWithoutTrainerEventStudyMaterialGroupInput = {
  data: TrainerEventStudyMaterialUncheckedUpdateWithoutTrainerEventStudyMaterialGroupInput;
  where: TrainerEventStudyMaterialWhereUniqueInput;
};

export type TrainerEventStudyMaterialUpdateWithoutEventInput = {
  Quiz?: InputMaybe<QuizUpdateOneWithoutTrainerEventStudyMaterialInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  media?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUpdateManyWithoutTrainerEventStudyMaterialInput>;
  trainerEvent?: InputMaybe<TrainerEventUpdateOneWithoutStudyMaterialsInput>;
  trainerEventStudyMaterialGroup?: InputMaybe<TrainerEventStudyMaterialGroupUpdateOneWithoutStudyMaterialsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrainerEventStudyMaterialUpdateWithoutQuizInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTrainerEventStudyMaterialsInput>;
  media?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUpdateManyWithoutTrainerEventStudyMaterialInput>;
  trainerEvent?: InputMaybe<TrainerEventUpdateOneWithoutStudyMaterialsInput>;
  trainerEventStudyMaterialGroup?: InputMaybe<TrainerEventStudyMaterialGroupUpdateOneWithoutStudyMaterialsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrainerEventStudyMaterialUpdateWithoutTraineeEventStudyMaterialAttendanceInput = {
  Quiz?: InputMaybe<QuizUpdateOneWithoutTrainerEventStudyMaterialInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTrainerEventStudyMaterialsInput>;
  media?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  trainerEvent?: InputMaybe<TrainerEventUpdateOneWithoutStudyMaterialsInput>;
  trainerEventStudyMaterialGroup?: InputMaybe<TrainerEventStudyMaterialGroupUpdateOneWithoutStudyMaterialsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrainerEventStudyMaterialUpdateWithoutTrainerEventInput = {
  Quiz?: InputMaybe<QuizUpdateOneWithoutTrainerEventStudyMaterialInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTrainerEventStudyMaterialsInput>;
  media?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUpdateManyWithoutTrainerEventStudyMaterialInput>;
  trainerEventStudyMaterialGroup?: InputMaybe<TrainerEventStudyMaterialGroupUpdateOneWithoutStudyMaterialsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrainerEventStudyMaterialUpdateWithoutTrainerEventStudyMaterialGroupInput = {
  Quiz?: InputMaybe<QuizUpdateOneWithoutTrainerEventStudyMaterialInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTrainerEventStudyMaterialsInput>;
  media?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceUpdateManyWithoutTrainerEventStudyMaterialInput>;
  trainerEvent?: InputMaybe<TrainerEventUpdateOneWithoutStudyMaterialsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TrainerEventStudyMaterialUpsertWithWhereUniqueWithoutEventInput = {
  create: TrainerEventStudyMaterialUncheckedCreateWithoutEventInput;
  update: TrainerEventStudyMaterialUncheckedUpdateWithoutEventInput;
  where: TrainerEventStudyMaterialWhereUniqueInput;
};

export type TrainerEventStudyMaterialUpsertWithWhereUniqueWithoutQuizInput = {
  create: TrainerEventStudyMaterialUncheckedCreateWithoutQuizInput;
  update: TrainerEventStudyMaterialUncheckedUpdateWithoutQuizInput;
  where: TrainerEventStudyMaterialWhereUniqueInput;
};

export type TrainerEventStudyMaterialUpsertWithWhereUniqueWithoutTrainerEventInput = {
  create: TrainerEventStudyMaterialUncheckedCreateWithoutTrainerEventInput;
  update: TrainerEventStudyMaterialUncheckedUpdateWithoutTrainerEventInput;
  where: TrainerEventStudyMaterialWhereUniqueInput;
};

export type TrainerEventStudyMaterialUpsertWithWhereUniqueWithoutTrainerEventStudyMaterialGroupInput = {
  create: TrainerEventStudyMaterialUncheckedCreateWithoutTrainerEventStudyMaterialGroupInput;
  update: TrainerEventStudyMaterialUncheckedUpdateWithoutTrainerEventStudyMaterialGroupInput;
  where: TrainerEventStudyMaterialWhereUniqueInput;
};

export type TrainerEventStudyMaterialUpsertWithoutTraineeEventStudyMaterialAttendanceInput = {
  create: TrainerEventStudyMaterialUncheckedCreateWithoutTraineeEventStudyMaterialAttendanceInput;
  update: TrainerEventStudyMaterialUncheckedUpdateWithoutTraineeEventStudyMaterialAttendanceInput;
};

export type TrainerEventStudyMaterialWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TrainerEventStudyMaterialWhereInput>>>;
  Quiz?: InputMaybe<QuizWhereInput>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  event?: InputMaybe<EventWhereInput>;
  eventId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  media?: InputMaybe<StringNullableFilter>;
  order?: InputMaybe<IntFilter>;
  quizId?: InputMaybe<IntNullableFilter>;
  title?: InputMaybe<StringFilter>;
  traineeEventStudyMaterialAttendance?: InputMaybe<TraineeEventStudyMaterialAttendanceListRelationFilter>;
  trainerEvent?: InputMaybe<TrainerEventWhereInput>;
  trainerEventId?: InputMaybe<IntNullableFilter>;
  trainerEventStudyMaterialGroup?: InputMaybe<TrainerEventStudyMaterialGroupWhereInput>;
  trainerEventStudyMaterialGroupId?: InputMaybe<IntNullableFilter>;
  url?: InputMaybe<StringFilter>;
};

export type TrainerEventStudyMaterialWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type TrainerEventSumAggregateOutputType = {
  __typename?: 'TrainerEventSumAggregateOutputType';
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  toTransferAmount?: Maybe<Scalars['Decimal']>;
  trainerId?: Maybe<Scalars['Int']>;
};

export type TrainerEventSumOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  toTransferAmount?: InputMaybe<SortOrder>;
  trainerId?: InputMaybe<SortOrder>;
};

export type TrainerEventTrainerIdEventIdCompoundUniqueInput = {
  eventId: Scalars['Int'];
  trainerId: Scalars['Int'];
};

export type TrainerEventUncheckedCreateInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dayLessons?: InputMaybe<TrainerEventDayLessonUncheckedCreateNestedManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  registrantId?: InputMaybe<Scalars['String']>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<Scalars['Decimal']>;
  toTransferType?: InputMaybe<ToTransferType>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedCreateNestedManyWithoutTrainerEventInput>;
  trainerId: Scalars['Int'];
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

export type TrainerEventUncheckedCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventCreateWithoutEventInput>>>;
  createMany?: InputMaybe<TrainerEventCreateManyEventInputEnvelope>;
};

export type TrainerEventUncheckedCreateNestedManyWithoutTargetedAudiencesInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventCreateOrConnectWithoutTargetedAudiencesInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventCreateWithoutTargetedAudiencesInput>>>;
};

export type TrainerEventUncheckedCreateNestedManyWithoutTargetedSpecialitiesInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventCreateOrConnectWithoutTargetedSpecialitiesInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventCreateWithoutTargetedSpecialitiesInput>>>;
};

export type TrainerEventUncheckedCreateNestedManyWithoutTrainerInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventCreateOrConnectWithoutTrainerInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventCreateWithoutTrainerInput>>>;
  createMany?: InputMaybe<TrainerEventCreateManyTrainerInputEnvelope>;
};

export type TrainerEventUncheckedCreateWithoutCertificateInput = {
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dayLessons?: InputMaybe<TrainerEventDayLessonUncheckedCreateNestedManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  registrantId?: InputMaybe<Scalars['String']>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<Scalars['Decimal']>;
  toTransferType?: InputMaybe<ToTransferType>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedCreateNestedManyWithoutTrainerEventInput>;
  trainerId: Scalars['Int'];
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

export type TrainerEventUncheckedCreateWithoutDayLessonsInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  registrantId?: InputMaybe<Scalars['String']>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<Scalars['Decimal']>;
  toTransferType?: InputMaybe<ToTransferType>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedCreateNestedManyWithoutTrainerEventInput>;
  trainerId: Scalars['Int'];
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

export type TrainerEventUncheckedCreateWithoutEventInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dayLessons?: InputMaybe<TrainerEventDayLessonUncheckedCreateNestedManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  id?: InputMaybe<Scalars['Int']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  registrantId?: InputMaybe<Scalars['String']>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<Scalars['Decimal']>;
  toTransferType?: InputMaybe<ToTransferType>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedCreateNestedManyWithoutTrainerEventInput>;
  trainerId: Scalars['Int'];
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

export type TrainerEventUncheckedCreateWithoutStudyMaterialsInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedOneWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dayLessons?: InputMaybe<TrainerEventDayLessonUncheckedCreateNestedManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  registrantId?: InputMaybe<Scalars['String']>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<Scalars['Decimal']>;
  toTransferType?: InputMaybe<ToTransferType>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedCreateNestedManyWithoutTrainerEventInput>;
  trainerId: Scalars['Int'];
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

export type TrainerEventUncheckedCreateWithoutTargetedAudiencesInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dayLessons?: InputMaybe<TrainerEventDayLessonUncheckedCreateNestedManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  registrantId?: InputMaybe<Scalars['String']>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<Scalars['Decimal']>;
  toTransferType?: InputMaybe<ToTransferType>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedCreateNestedManyWithoutTrainerEventInput>;
  trainerId: Scalars['Int'];
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

export type TrainerEventUncheckedCreateWithoutTargetedSpecialitiesInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dayLessons?: InputMaybe<TrainerEventDayLessonUncheckedCreateNestedManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  registrantId?: InputMaybe<Scalars['String']>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutTrainerEventsInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<Scalars['Decimal']>;
  toTransferType?: InputMaybe<ToTransferType>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedCreateNestedManyWithoutTrainerEventInput>;
  trainerId: Scalars['Int'];
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

export type TrainerEventUncheckedCreateWithoutTimeSlotsInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dayLessons?: InputMaybe<TrainerEventDayLessonUncheckedCreateNestedManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  registrantId?: InputMaybe<Scalars['String']>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<Scalars['Decimal']>;
  toTransferType?: InputMaybe<ToTransferType>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedCreateNestedManyWithoutTrainerEventInput>;
  trainerId: Scalars['Int'];
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

export type TrainerEventUncheckedCreateWithoutTraineeTrainerReviewsInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dayLessons?: InputMaybe<TrainerEventDayLessonUncheckedCreateNestedManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  registrantId?: InputMaybe<Scalars['String']>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<Scalars['Decimal']>;
  toTransferType?: InputMaybe<ToTransferType>;
  trainerId: Scalars['Int'];
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

export type TrainerEventUncheckedCreateWithoutTrainerInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dayLessons?: InputMaybe<TrainerEventDayLessonUncheckedCreateNestedManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  registrantId?: InputMaybe<Scalars['String']>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<Scalars['Decimal']>;
  toTransferType?: InputMaybe<ToTransferType>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedCreateNestedManyWithoutTrainerEventInput>;
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

export type TrainerEventUncheckedCreateWithoutTransitionsInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dayLessons?: InputMaybe<TrainerEventDayLessonUncheckedCreateNestedManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  registrantId?: InputMaybe<Scalars['String']>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<Scalars['Decimal']>;
  toTransferType?: InputMaybe<ToTransferType>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedCreateNestedManyWithoutTrainerEventInput>;
  trainerId: Scalars['Int'];
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

export type TrainerEventUncheckedCreateWithoutZohoEmailInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedCreateNestedManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dayLessons?: InputMaybe<TrainerEventDayLessonUncheckedCreateNestedManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  introductionAr?: InputMaybe<Scalars['String']>;
  introductionEn?: InputMaybe<Scalars['String']>;
  isAllProfessionsTargeted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  mainThemeAr?: InputMaybe<Scalars['String']>;
  mainThemeEn?: InputMaybe<Scalars['String']>;
  objectivesAr?: InputMaybe<Scalars['String']>;
  objectivesEn?: InputMaybe<Scalars['String']>;
  outcomesAr?: InputMaybe<Scalars['String']>;
  outcomesEn?: InputMaybe<Scalars['String']>;
  registrantId?: InputMaybe<Scalars['String']>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedCreateNestedManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedCreateNestedManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<Scalars['Decimal']>;
  toTransferType?: InputMaybe<ToTransferType>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedCreateNestedManyWithoutTrainerEventInput>;
  trainerId: Scalars['Int'];
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<Scalars['String']>;
  whyTargetedAudienceEn?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

export type TrainerEventUncheckedUpdateInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dayLessons?: InputMaybe<TrainerEventDayLessonUncheckedUpdateManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  toTransferType?: InputMaybe<NullableEnumToTransferTypeFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedUpdateManyWithoutTrainerEventInput>;
  trainerId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TrainerEventUncheckedUpdateManyInput = {
  contentIsAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  toTransferAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  toTransferType?: InputMaybe<NullableEnumToTransferTypeFieldUpdateOperationsInput>;
  trainerId?: InputMaybe<IntFieldUpdateOperationsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TrainerEventUncheckedUpdateManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventCreateWithoutEventInput>>>;
  createMany?: InputMaybe<TrainerEventCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TrainerEventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TrainerEventUpdateWithWhereUniqueWithoutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TrainerEventUpdateManyWithWhereWithoutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TrainerEventUpsertWithWhereUniqueWithoutEventInput>>>;
};

export type TrainerEventUncheckedUpdateManyWithoutTargetedAudiencesInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventCreateOrConnectWithoutTargetedAudiencesInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventCreateWithoutTargetedAudiencesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TrainerEventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TrainerEventUpdateWithWhereUniqueWithoutTargetedAudiencesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TrainerEventUpdateManyWithWhereWithoutTargetedAudiencesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TrainerEventUpsertWithWhereUniqueWithoutTargetedAudiencesInput>>>;
};

export type TrainerEventUncheckedUpdateManyWithoutTargetedSpecialitiesInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventCreateOrConnectWithoutTargetedSpecialitiesInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventCreateWithoutTargetedSpecialitiesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TrainerEventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TrainerEventUpdateWithWhereUniqueWithoutTargetedSpecialitiesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TrainerEventUpdateManyWithWhereWithoutTargetedSpecialitiesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TrainerEventUpsertWithWhereUniqueWithoutTargetedSpecialitiesInput>>>;
};

export type TrainerEventUncheckedUpdateManyWithoutTrainerEventInput = {
  contentIsAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  toTransferAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  toTransferType?: InputMaybe<NullableEnumToTransferTypeFieldUpdateOperationsInput>;
  trainerId?: InputMaybe<IntFieldUpdateOperationsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TrainerEventUncheckedUpdateManyWithoutTrainerEventsInput = {
  contentIsAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  toTransferAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  toTransferType?: InputMaybe<NullableEnumToTransferTypeFieldUpdateOperationsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TrainerEventUncheckedUpdateManyWithoutTrainerInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventCreateOrConnectWithoutTrainerInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventCreateWithoutTrainerInput>>>;
  createMany?: InputMaybe<TrainerEventCreateManyTrainerInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TrainerEventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TrainerEventUpdateWithWhereUniqueWithoutTrainerInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TrainerEventUpdateManyWithWhereWithoutTrainerInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TrainerEventUpsertWithWhereUniqueWithoutTrainerInput>>>;
};

export type TrainerEventUncheckedUpdateWithoutCertificateInput = {
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dayLessons?: InputMaybe<TrainerEventDayLessonUncheckedUpdateManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  toTransferType?: InputMaybe<NullableEnumToTransferTypeFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedUpdateManyWithoutTrainerEventInput>;
  trainerId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TrainerEventUncheckedUpdateWithoutDayLessonsInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  toTransferType?: InputMaybe<NullableEnumToTransferTypeFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedUpdateManyWithoutTrainerEventInput>;
  trainerId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TrainerEventUncheckedUpdateWithoutEventInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dayLessons?: InputMaybe<TrainerEventDayLessonUncheckedUpdateManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  toTransferType?: InputMaybe<NullableEnumToTransferTypeFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedUpdateManyWithoutTrainerEventInput>;
  trainerId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TrainerEventUncheckedUpdateWithoutStudyMaterialsInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateOneWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dayLessons?: InputMaybe<TrainerEventDayLessonUncheckedUpdateManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  toTransferType?: InputMaybe<NullableEnumToTransferTypeFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedUpdateManyWithoutTrainerEventInput>;
  trainerId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TrainerEventUncheckedUpdateWithoutTargetedAudiencesInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dayLessons?: InputMaybe<TrainerEventDayLessonUncheckedUpdateManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  toTransferType?: InputMaybe<NullableEnumToTransferTypeFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedUpdateManyWithoutTrainerEventInput>;
  trainerId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TrainerEventUncheckedUpdateWithoutTargetedSpecialitiesInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dayLessons?: InputMaybe<TrainerEventDayLessonUncheckedUpdateManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutTrainerEventsInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  toTransferType?: InputMaybe<NullableEnumToTransferTypeFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedUpdateManyWithoutTrainerEventInput>;
  trainerId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TrainerEventUncheckedUpdateWithoutTimeSlotsInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dayLessons?: InputMaybe<TrainerEventDayLessonUncheckedUpdateManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  toTransferType?: InputMaybe<NullableEnumToTransferTypeFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedUpdateManyWithoutTrainerEventInput>;
  trainerId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TrainerEventUncheckedUpdateWithoutTraineeTrainerReviewsInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dayLessons?: InputMaybe<TrainerEventDayLessonUncheckedUpdateManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  toTransferType?: InputMaybe<NullableEnumToTransferTypeFieldUpdateOperationsInput>;
  trainerId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TrainerEventUncheckedUpdateWithoutTrainerInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dayLessons?: InputMaybe<TrainerEventDayLessonUncheckedUpdateManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  toTransferType?: InputMaybe<NullableEnumToTransferTypeFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedUpdateManyWithoutTrainerEventInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TrainerEventUncheckedUpdateWithoutTransitionsInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dayLessons?: InputMaybe<TrainerEventDayLessonUncheckedUpdateManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  toTransferType?: InputMaybe<NullableEnumToTransferTypeFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedUpdateManyWithoutTrainerEventInput>;
  trainerId?: InputMaybe<IntFieldUpdateOperationsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TrainerEventUncheckedUpdateWithoutZohoEmailInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUncheckedUpdateManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dayLessons?: InputMaybe<TrainerEventDayLessonUncheckedUpdateManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  eventId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUncheckedUpdateManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUncheckedUpdateManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  toTransferType?: InputMaybe<NullableEnumToTransferTypeFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUncheckedUpdateManyWithoutTrainerEventInput>;
  trainerId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TrainerEventUpdateInput = {
  Certificate?: InputMaybe<CertificateUpdateOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dayLessons?: InputMaybe<TrainerEventDayLessonUpdateManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTrainerEventsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  toTransferType?: InputMaybe<NullableEnumToTransferTypeFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUpdateManyWithoutTrainerEventInput>;
  trainer?: InputMaybe<UserUpdateOneRequiredWithoutTrainerEventsInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TrainerEventUpdateManyMutationInput = {
  contentIsAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  toTransferAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  toTransferType?: InputMaybe<NullableEnumToTransferTypeFieldUpdateOperationsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TrainerEventUpdateManyWithWhereWithoutEventInput = {
  data: TrainerEventUncheckedUpdateManyWithoutTrainerEventsInput;
  where: TrainerEventScalarWhereInput;
};

export type TrainerEventUpdateManyWithWhereWithoutTargetedAudiencesInput = {
  data: TrainerEventUncheckedUpdateManyWithoutTrainerEventsInput;
  where: TrainerEventScalarWhereInput;
};

export type TrainerEventUpdateManyWithWhereWithoutTargetedSpecialitiesInput = {
  data: TrainerEventUncheckedUpdateManyWithoutTrainerEventInput;
  where: TrainerEventScalarWhereInput;
};

export type TrainerEventUpdateManyWithWhereWithoutTrainerInput = {
  data: TrainerEventUncheckedUpdateManyWithoutTrainerEventsInput;
  where: TrainerEventScalarWhereInput;
};

export type TrainerEventUpdateManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventCreateWithoutEventInput>>>;
  createMany?: InputMaybe<TrainerEventCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TrainerEventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TrainerEventUpdateWithWhereUniqueWithoutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TrainerEventUpdateManyWithWhereWithoutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TrainerEventUpsertWithWhereUniqueWithoutEventInput>>>;
};

export type TrainerEventUpdateManyWithoutTargetedAudiencesInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventCreateOrConnectWithoutTargetedAudiencesInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventCreateWithoutTargetedAudiencesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TrainerEventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TrainerEventUpdateWithWhereUniqueWithoutTargetedAudiencesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TrainerEventUpdateManyWithWhereWithoutTargetedAudiencesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TrainerEventUpsertWithWhereUniqueWithoutTargetedAudiencesInput>>>;
};

export type TrainerEventUpdateManyWithoutTargetedSpecialitiesInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventCreateOrConnectWithoutTargetedSpecialitiesInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventCreateWithoutTargetedSpecialitiesInput>>>;
  delete?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TrainerEventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TrainerEventUpdateWithWhereUniqueWithoutTargetedSpecialitiesInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TrainerEventUpdateManyWithWhereWithoutTargetedSpecialitiesInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TrainerEventUpsertWithWhereUniqueWithoutTargetedSpecialitiesInput>>>;
};

export type TrainerEventUpdateManyWithoutTrainerInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainerEventCreateOrConnectWithoutTrainerInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainerEventCreateWithoutTrainerInput>>>;
  createMany?: InputMaybe<TrainerEventCreateManyTrainerInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TrainerEventScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TrainerEventWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TrainerEventUpdateWithWhereUniqueWithoutTrainerInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TrainerEventUpdateManyWithWhereWithoutTrainerInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TrainerEventUpsertWithWhereUniqueWithoutTrainerInput>>>;
};

export type TrainerEventUpdateOneRequiredWithoutTimeSlotsInput = {
  connect?: InputMaybe<TrainerEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TrainerEventCreateOrConnectWithoutTimeSlotsInput>;
  create?: InputMaybe<TrainerEventUncheckedCreateWithoutTimeSlotsInput>;
  update?: InputMaybe<TrainerEventUncheckedUpdateWithoutTimeSlotsInput>;
  upsert?: InputMaybe<TrainerEventUpsertWithoutTimeSlotsInput>;
};

export type TrainerEventUpdateOneRequiredWithoutTraineeTrainerReviewsInput = {
  connect?: InputMaybe<TrainerEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TrainerEventCreateOrConnectWithoutTraineeTrainerReviewsInput>;
  create?: InputMaybe<TrainerEventUncheckedCreateWithoutTraineeTrainerReviewsInput>;
  update?: InputMaybe<TrainerEventUncheckedUpdateWithoutTraineeTrainerReviewsInput>;
  upsert?: InputMaybe<TrainerEventUpsertWithoutTraineeTrainerReviewsInput>;
};

export type TrainerEventUpdateOneWithoutCertificateInput = {
  connect?: InputMaybe<TrainerEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TrainerEventCreateOrConnectWithoutCertificateInput>;
  create?: InputMaybe<TrainerEventUncheckedCreateWithoutCertificateInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<TrainerEventUncheckedUpdateWithoutCertificateInput>;
  upsert?: InputMaybe<TrainerEventUpsertWithoutCertificateInput>;
};

export type TrainerEventUpdateOneWithoutDayLessonsInput = {
  connect?: InputMaybe<TrainerEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TrainerEventCreateOrConnectWithoutDayLessonsInput>;
  create?: InputMaybe<TrainerEventUncheckedCreateWithoutDayLessonsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<TrainerEventUncheckedUpdateWithoutDayLessonsInput>;
  upsert?: InputMaybe<TrainerEventUpsertWithoutDayLessonsInput>;
};

export type TrainerEventUpdateOneWithoutStudyMaterialsInput = {
  connect?: InputMaybe<TrainerEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TrainerEventCreateOrConnectWithoutStudyMaterialsInput>;
  create?: InputMaybe<TrainerEventUncheckedCreateWithoutStudyMaterialsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<TrainerEventUncheckedUpdateWithoutStudyMaterialsInput>;
  upsert?: InputMaybe<TrainerEventUpsertWithoutStudyMaterialsInput>;
};

export type TrainerEventUpdateOneWithoutTransitionsInput = {
  connect?: InputMaybe<TrainerEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TrainerEventCreateOrConnectWithoutTransitionsInput>;
  create?: InputMaybe<TrainerEventUncheckedCreateWithoutTransitionsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<TrainerEventUncheckedUpdateWithoutTransitionsInput>;
  upsert?: InputMaybe<TrainerEventUpsertWithoutTransitionsInput>;
};

export type TrainerEventUpdateOneWithoutZohoEmailInput = {
  connect?: InputMaybe<TrainerEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TrainerEventCreateOrConnectWithoutZohoEmailInput>;
  create?: InputMaybe<TrainerEventUncheckedCreateWithoutZohoEmailInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<TrainerEventUncheckedUpdateWithoutZohoEmailInput>;
  upsert?: InputMaybe<TrainerEventUpsertWithoutZohoEmailInput>;
};

export type TrainerEventUpdateWithWhereUniqueWithoutEventInput = {
  data: TrainerEventUncheckedUpdateWithoutEventInput;
  where: TrainerEventWhereUniqueInput;
};

export type TrainerEventUpdateWithWhereUniqueWithoutTargetedAudiencesInput = {
  data: TrainerEventUncheckedUpdateWithoutTargetedAudiencesInput;
  where: TrainerEventWhereUniqueInput;
};

export type TrainerEventUpdateWithWhereUniqueWithoutTargetedSpecialitiesInput = {
  data: TrainerEventUncheckedUpdateWithoutTargetedSpecialitiesInput;
  where: TrainerEventWhereUniqueInput;
};

export type TrainerEventUpdateWithWhereUniqueWithoutTrainerInput = {
  data: TrainerEventUncheckedUpdateWithoutTrainerInput;
  where: TrainerEventWhereUniqueInput;
};

export type TrainerEventUpdateWithoutCertificateInput = {
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dayLessons?: InputMaybe<TrainerEventDayLessonUpdateManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTrainerEventsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  toTransferType?: InputMaybe<NullableEnumToTransferTypeFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUpdateManyWithoutTrainerEventInput>;
  trainer?: InputMaybe<UserUpdateOneRequiredWithoutTrainerEventsInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TrainerEventUpdateWithoutDayLessonsInput = {
  Certificate?: InputMaybe<CertificateUpdateOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTrainerEventsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  toTransferType?: InputMaybe<NullableEnumToTransferTypeFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUpdateManyWithoutTrainerEventInput>;
  trainer?: InputMaybe<UserUpdateOneRequiredWithoutTrainerEventsInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TrainerEventUpdateWithoutEventInput = {
  Certificate?: InputMaybe<CertificateUpdateOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dayLessons?: InputMaybe<TrainerEventDayLessonUpdateManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  toTransferType?: InputMaybe<NullableEnumToTransferTypeFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUpdateManyWithoutTrainerEventInput>;
  trainer?: InputMaybe<UserUpdateOneRequiredWithoutTrainerEventsInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TrainerEventUpdateWithoutStudyMaterialsInput = {
  Certificate?: InputMaybe<CertificateUpdateOneWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dayLessons?: InputMaybe<TrainerEventDayLessonUpdateManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTrainerEventsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  toTransferType?: InputMaybe<NullableEnumToTransferTypeFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUpdateManyWithoutTrainerEventInput>;
  trainer?: InputMaybe<UserUpdateOneRequiredWithoutTrainerEventsInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TrainerEventUpdateWithoutTargetedAudiencesInput = {
  Certificate?: InputMaybe<CertificateUpdateOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dayLessons?: InputMaybe<TrainerEventDayLessonUpdateManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTrainerEventsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  toTransferType?: InputMaybe<NullableEnumToTransferTypeFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUpdateManyWithoutTrainerEventInput>;
  trainer?: InputMaybe<UserUpdateOneRequiredWithoutTrainerEventsInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TrainerEventUpdateWithoutTargetedSpecialitiesInput = {
  Certificate?: InputMaybe<CertificateUpdateOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dayLessons?: InputMaybe<TrainerEventDayLessonUpdateManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTrainerEventsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutTrainerEventsInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  toTransferType?: InputMaybe<NullableEnumToTransferTypeFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUpdateManyWithoutTrainerEventInput>;
  trainer?: InputMaybe<UserUpdateOneRequiredWithoutTrainerEventsInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TrainerEventUpdateWithoutTimeSlotsInput = {
  Certificate?: InputMaybe<CertificateUpdateOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dayLessons?: InputMaybe<TrainerEventDayLessonUpdateManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTrainerEventsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  toTransferType?: InputMaybe<NullableEnumToTransferTypeFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUpdateManyWithoutTrainerEventInput>;
  trainer?: InputMaybe<UserUpdateOneRequiredWithoutTrainerEventsInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TrainerEventUpdateWithoutTraineeTrainerReviewsInput = {
  Certificate?: InputMaybe<CertificateUpdateOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dayLessons?: InputMaybe<TrainerEventDayLessonUpdateManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTrainerEventsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  toTransferType?: InputMaybe<NullableEnumToTransferTypeFieldUpdateOperationsInput>;
  trainer?: InputMaybe<UserUpdateOneRequiredWithoutTrainerEventsInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TrainerEventUpdateWithoutTrainerInput = {
  Certificate?: InputMaybe<CertificateUpdateOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dayLessons?: InputMaybe<TrainerEventDayLessonUpdateManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTrainerEventsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  toTransferType?: InputMaybe<NullableEnumToTransferTypeFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUpdateManyWithoutTrainerEventInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TrainerEventUpdateWithoutTransitionsInput = {
  Certificate?: InputMaybe<CertificateUpdateOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutTrainerEventInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dayLessons?: InputMaybe<TrainerEventDayLessonUpdateManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTrainerEventsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  toTransferType?: InputMaybe<NullableEnumToTransferTypeFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUpdateManyWithoutTrainerEventInput>;
  trainer?: InputMaybe<UserUpdateOneRequiredWithoutTrainerEventsInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TrainerEventUpdateWithoutZohoEmailInput = {
  Certificate?: InputMaybe<CertificateUpdateOneWithoutTrainerEventInput>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialUpdateManyWithoutTrainerEventInput>;
  contentIsAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dayLessons?: InputMaybe<TrainerEventDayLessonUpdateManyWithoutTrainerEventInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailState?: InputMaybe<Scalars['Json']>;
  event?: InputMaybe<EventUpdateOneRequiredWithoutTrainerEventsInput>;
  introductionAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introductionEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isAllProfessionsTargeted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainThemeEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  objectivesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  outcomesEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetedAudiences?: InputMaybe<ProfessionUpdateManyWithoutTrainerEventsInput>;
  targetedSpecialities?: InputMaybe<SpecialtyUpdateManyWithoutTrainerEventInput>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutTrainerEventInput>;
  toTransferAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  toTransferType?: InputMaybe<NullableEnumToTransferTypeFieldUpdateOperationsInput>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewUpdateManyWithoutTrainerEventInput>;
  trainer?: InputMaybe<UserUpdateOneRequiredWithoutTrainerEventsInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutTrainerEventInput>;
  whyTargetedAudienceAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whyTargetedAudienceEn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TrainerEventUpsertWithWhereUniqueWithoutEventInput = {
  create: TrainerEventUncheckedCreateWithoutEventInput;
  update: TrainerEventUncheckedUpdateWithoutEventInput;
  where: TrainerEventWhereUniqueInput;
};

export type TrainerEventUpsertWithWhereUniqueWithoutTargetedAudiencesInput = {
  create: TrainerEventUncheckedCreateWithoutTargetedAudiencesInput;
  update: TrainerEventUncheckedUpdateWithoutTargetedAudiencesInput;
  where: TrainerEventWhereUniqueInput;
};

export type TrainerEventUpsertWithWhereUniqueWithoutTargetedSpecialitiesInput = {
  create: TrainerEventUncheckedCreateWithoutTargetedSpecialitiesInput;
  update: TrainerEventUncheckedUpdateWithoutTargetedSpecialitiesInput;
  where: TrainerEventWhereUniqueInput;
};

export type TrainerEventUpsertWithWhereUniqueWithoutTrainerInput = {
  create: TrainerEventUncheckedCreateWithoutTrainerInput;
  update: TrainerEventUncheckedUpdateWithoutTrainerInput;
  where: TrainerEventWhereUniqueInput;
};

export type TrainerEventUpsertWithoutCertificateInput = {
  create: TrainerEventUncheckedCreateWithoutCertificateInput;
  update: TrainerEventUncheckedUpdateWithoutCertificateInput;
};

export type TrainerEventUpsertWithoutDayLessonsInput = {
  create: TrainerEventUncheckedCreateWithoutDayLessonsInput;
  update: TrainerEventUncheckedUpdateWithoutDayLessonsInput;
};

export type TrainerEventUpsertWithoutStudyMaterialsInput = {
  create: TrainerEventUncheckedCreateWithoutStudyMaterialsInput;
  update: TrainerEventUncheckedUpdateWithoutStudyMaterialsInput;
};

export type TrainerEventUpsertWithoutTimeSlotsInput = {
  create: TrainerEventUncheckedCreateWithoutTimeSlotsInput;
  update: TrainerEventUncheckedUpdateWithoutTimeSlotsInput;
};

export type TrainerEventUpsertWithoutTraineeTrainerReviewsInput = {
  create: TrainerEventUncheckedCreateWithoutTraineeTrainerReviewsInput;
  update: TrainerEventUncheckedUpdateWithoutTraineeTrainerReviewsInput;
};

export type TrainerEventUpsertWithoutTransitionsInput = {
  create: TrainerEventUncheckedCreateWithoutTransitionsInput;
  update: TrainerEventUncheckedUpdateWithoutTransitionsInput;
};

export type TrainerEventUpsertWithoutZohoEmailInput = {
  create: TrainerEventUncheckedCreateWithoutZohoEmailInput;
  update: TrainerEventUncheckedUpdateWithoutZohoEmailInput;
};

export type TrainerEventWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TrainerEventWhereInput>>>;
  Certificate?: InputMaybe<CertificateWhereInput>;
  NOT?: InputMaybe<Array<InputMaybe<TrainerEventWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TrainerEventWhereInput>>>;
  StudyMaterials?: InputMaybe<TrainerEventStudyMaterialListRelationFilter>;
  ZohoEmail?: InputMaybe<ZohoEmailListRelationFilter>;
  contentIsAdded?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  dayLessons?: InputMaybe<TrainerEventDayLessonListRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  emailState?: InputMaybe<JsonNullableFilter>;
  event?: InputMaybe<EventWhereInput>;
  eventId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  introductionAr?: InputMaybe<StringNullableFilter>;
  introductionEn?: InputMaybe<StringNullableFilter>;
  isAllProfessionsTargeted?: InputMaybe<BoolNullableFilter>;
  joinUrl?: InputMaybe<StringNullableFilter>;
  mainThemeAr?: InputMaybe<StringNullableFilter>;
  mainThemeEn?: InputMaybe<StringNullableFilter>;
  objectivesAr?: InputMaybe<StringNullableFilter>;
  objectivesEn?: InputMaybe<StringNullableFilter>;
  outcomesAr?: InputMaybe<StringNullableFilter>;
  outcomesEn?: InputMaybe<StringNullableFilter>;
  registrantId?: InputMaybe<StringNullableFilter>;
  targetedAudiences?: InputMaybe<ProfessionListRelationFilter>;
  targetedSpecialities?: InputMaybe<SpecialtyListRelationFilter>;
  timeSlots?: InputMaybe<TrainerEventDayTimeSlotListRelationFilter>;
  toTransferAmount?: InputMaybe<DecimalNullableFilter>;
  toTransferType?: InputMaybe<EnumToTransferTypeNullableFilter>;
  traineeTrainerReviews?: InputMaybe<TraineeTrainerReviewListRelationFilter>;
  trainer?: InputMaybe<UserWhereInput>;
  trainerId?: InputMaybe<IntFilter>;
  transitions?: InputMaybe<TransitionListRelationFilter>;
  whyTargetedAudienceAr?: InputMaybe<StringNullableFilter>;
  whyTargetedAudienceEn?: InputMaybe<StringNullableFilter>;
  youtubeUrl?: InputMaybe<StringNullableFilter>;
};

export type TrainerEventWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  trainerId_eventId?: InputMaybe<TrainerEventTrainerIdEventIdCompoundUniqueInput>;
};

export type TrainersReport = {
  __typename?: 'TrainersReport';
  becomeTrainerRecord: Array<BecomeTrainerRecord>;
  countRecord: Array<CountRecord>;
  regionRecord: Array<RegionRecord>;
};

export type TrainersReportUniqueObject = {
  greaterDate?: InputMaybe<Scalars['DateTime']>;
  smallerDate?: InputMaybe<Scalars['DateTime']>;
  variance: Variance;
};

export type TrainingExperience = {
  __typename?: 'TrainingExperience';
  Cv?: Maybe<Cv>;
  cvId?: Maybe<Scalars['Int']>;
  eventName?: Maybe<Scalars['String']>;
  executingAgency?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type TrainingExperienceAvgAggregateOutputType = {
  __typename?: 'TrainingExperienceAvgAggregateOutputType';
  cvId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

export type TrainingExperienceAvgOrderByAggregateInput = {
  cvId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type TrainingExperienceCountAggregateOutputType = {
  __typename?: 'TrainingExperienceCountAggregateOutputType';
  _all: Scalars['Int'];
  cvId: Scalars['Int'];
  eventName: Scalars['Int'];
  executingAgency: Scalars['Int'];
  id: Scalars['Int'];
};

export type TrainingExperienceCountOrderByAggregateInput = {
  cvId?: InputMaybe<SortOrder>;
  eventName?: InputMaybe<SortOrder>;
  executingAgency?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type TrainingExperienceCreateInput = {
  Cv?: InputMaybe<CvCreateNestedOneWithoutTrainingExperienceInput>;
  eventName?: InputMaybe<Scalars['String']>;
  executingAgency?: InputMaybe<Scalars['String']>;
};

export type TrainingExperienceCreateManyCvInput = {
  eventName?: InputMaybe<Scalars['String']>;
  executingAgency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type TrainingExperienceCreateManyCvInputEnvelope = {
  data: TrainingExperienceCreateManyCvInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TrainingExperienceCreateManyInput = {
  cvId?: InputMaybe<Scalars['Int']>;
  eventName?: InputMaybe<Scalars['String']>;
  executingAgency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type TrainingExperienceCreateNestedManyWithoutCvInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainingExperienceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainingExperienceCreateOrConnectWithoutCvInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainingExperienceCreateWithoutCvInput>>>;
  createMany?: InputMaybe<TrainingExperienceCreateManyCvInputEnvelope>;
};

export type TrainingExperienceCreateOrConnectWithoutCvInput = {
  create: TrainingExperienceUncheckedCreateWithoutCvInput;
  where: TrainingExperienceWhereUniqueInput;
};

export type TrainingExperienceCreateWithoutCvInput = {
  eventName?: InputMaybe<Scalars['String']>;
  executingAgency?: InputMaybe<Scalars['String']>;
};

export type TrainingExperienceListRelationFilter = {
  every?: InputMaybe<TrainingExperienceWhereInput>;
  none?: InputMaybe<TrainingExperienceWhereInput>;
  some?: InputMaybe<TrainingExperienceWhereInput>;
};

export type TrainingExperienceMaxAggregateOutputType = {
  __typename?: 'TrainingExperienceMaxAggregateOutputType';
  cvId?: Maybe<Scalars['Int']>;
  eventName?: Maybe<Scalars['String']>;
  executingAgency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type TrainingExperienceMaxOrderByAggregateInput = {
  cvId?: InputMaybe<SortOrder>;
  eventName?: InputMaybe<SortOrder>;
  executingAgency?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type TrainingExperienceMinAggregateOutputType = {
  __typename?: 'TrainingExperienceMinAggregateOutputType';
  cvId?: Maybe<Scalars['Int']>;
  eventName?: Maybe<Scalars['String']>;
  executingAgency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type TrainingExperienceMinOrderByAggregateInput = {
  cvId?: InputMaybe<SortOrder>;
  eventName?: InputMaybe<SortOrder>;
  executingAgency?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type TrainingExperienceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TrainingExperienceOrderByWithAggregationInput = {
  _avg?: InputMaybe<TrainingExperienceAvgOrderByAggregateInput>;
  _count?: InputMaybe<TrainingExperienceCountOrderByAggregateInput>;
  _max?: InputMaybe<TrainingExperienceMaxOrderByAggregateInput>;
  _min?: InputMaybe<TrainingExperienceMinOrderByAggregateInput>;
  _sum?: InputMaybe<TrainingExperienceSumOrderByAggregateInput>;
  cvId?: InputMaybe<SortOrder>;
  eventName?: InputMaybe<SortOrder>;
  executingAgency?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type TrainingExperienceOrderByWithRelationInput = {
  Cv?: InputMaybe<CvOrderByWithRelationInput>;
  cvId?: InputMaybe<SortOrder>;
  eventName?: InputMaybe<SortOrder>;
  executingAgency?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export enum TrainingExperienceScalarFieldEnum {
  CvId = 'cvId',
  EventName = 'eventName',
  ExecutingAgency = 'executingAgency',
  Id = 'id'
}

export type TrainingExperienceScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TrainingExperienceScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TrainingExperienceScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TrainingExperienceScalarWhereInput>>>;
  cvId?: InputMaybe<IntNullableFilter>;
  eventName?: InputMaybe<StringNullableFilter>;
  executingAgency?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
};

export type TrainingExperienceScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<TrainingExperienceScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TrainingExperienceScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TrainingExperienceScalarWhereWithAggregatesInput>>>;
  cvId?: InputMaybe<IntNullableWithAggregatesFilter>;
  eventName?: InputMaybe<StringNullableWithAggregatesFilter>;
  executingAgency?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
};

export type TrainingExperienceSumAggregateOutputType = {
  __typename?: 'TrainingExperienceSumAggregateOutputType';
  cvId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type TrainingExperienceSumOrderByAggregateInput = {
  cvId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type TrainingExperienceUncheckedCreateInput = {
  cvId?: InputMaybe<Scalars['Int']>;
  eventName?: InputMaybe<Scalars['String']>;
  executingAgency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type TrainingExperienceUncheckedCreateNestedManyWithoutCvInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainingExperienceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainingExperienceCreateOrConnectWithoutCvInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainingExperienceCreateWithoutCvInput>>>;
  createMany?: InputMaybe<TrainingExperienceCreateManyCvInputEnvelope>;
};

export type TrainingExperienceUncheckedCreateWithoutCvInput = {
  eventName?: InputMaybe<Scalars['String']>;
  executingAgency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type TrainingExperienceUncheckedUpdateInput = {
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  eventName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executingAgency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TrainingExperienceUncheckedUpdateManyInput = {
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  eventName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executingAgency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TrainingExperienceUncheckedUpdateManyWithoutCvInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainingExperienceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainingExperienceCreateOrConnectWithoutCvInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainingExperienceCreateWithoutCvInput>>>;
  createMany?: InputMaybe<TrainingExperienceCreateManyCvInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TrainingExperienceWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TrainingExperienceScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TrainingExperienceWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TrainingExperienceWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TrainingExperienceUpdateWithWhereUniqueWithoutCvInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TrainingExperienceUpdateManyWithWhereWithoutCvInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TrainingExperienceUpsertWithWhereUniqueWithoutCvInput>>>;
};

export type TrainingExperienceUncheckedUpdateManyWithoutTrainingExperienceInput = {
  eventName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executingAgency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TrainingExperienceUncheckedUpdateWithoutCvInput = {
  eventName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executingAgency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TrainingExperienceUpdateInput = {
  Cv?: InputMaybe<CvUpdateOneWithoutTrainingExperienceInput>;
  eventName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executingAgency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TrainingExperienceUpdateManyMutationInput = {
  eventName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executingAgency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TrainingExperienceUpdateManyWithWhereWithoutCvInput = {
  data: TrainingExperienceUncheckedUpdateManyWithoutTrainingExperienceInput;
  where: TrainingExperienceScalarWhereInput;
};

export type TrainingExperienceUpdateManyWithoutCvInput = {
  connect?: InputMaybe<Array<InputMaybe<TrainingExperienceWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TrainingExperienceCreateOrConnectWithoutCvInput>>>;
  create?: InputMaybe<Array<InputMaybe<TrainingExperienceCreateWithoutCvInput>>>;
  createMany?: InputMaybe<TrainingExperienceCreateManyCvInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TrainingExperienceWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TrainingExperienceScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TrainingExperienceWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TrainingExperienceWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TrainingExperienceUpdateWithWhereUniqueWithoutCvInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TrainingExperienceUpdateManyWithWhereWithoutCvInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TrainingExperienceUpsertWithWhereUniqueWithoutCvInput>>>;
};

export type TrainingExperienceUpdateWithWhereUniqueWithoutCvInput = {
  data: TrainingExperienceUncheckedUpdateWithoutCvInput;
  where: TrainingExperienceWhereUniqueInput;
};

export type TrainingExperienceUpdateWithoutCvInput = {
  eventName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  executingAgency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TrainingExperienceUpsertWithWhereUniqueWithoutCvInput = {
  create: TrainingExperienceUncheckedCreateWithoutCvInput;
  update: TrainingExperienceUncheckedUpdateWithoutCvInput;
  where: TrainingExperienceWhereUniqueInput;
};

export type TrainingExperienceWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TrainingExperienceWhereInput>>>;
  Cv?: InputMaybe<CvWhereInput>;
  NOT?: InputMaybe<Array<InputMaybe<TrainingExperienceWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TrainingExperienceWhereInput>>>;
  cvId?: InputMaybe<IntNullableFilter>;
  eventName?: InputMaybe<StringNullableFilter>;
  executingAgency?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
};

export type TrainingExperienceWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type Transition = {
  __typename?: 'Transition';
  amount: Scalars['Decimal'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  event?: Maybe<Event>;
  eventId?: Maybe<Scalars['Int']>;
  firstParty: User;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  firstPartyUserId: Scalars['Int'];
  fullAmount: Scalars['Decimal'];
  id: Scalars['Int'];
  isHiddenFromUser?: Maybe<Scalars['Boolean']>;
  mediator?: Maybe<User>;
  mediatorId?: Maybe<Scalars['Int']>;
  moyasarId?: Maybe<Scalars['String']>;
  paymentWay: PaymentWay;
  paymentWayId: Scalars['Int'];
  receiptUrl?: Maybe<Scalars['String']>;
  refundTransition?: Maybe<Transition>;
  refundedTransition?: Maybe<Transition>;
  secondParty?: Maybe<User>;
  secondPartyClosingBalance?: Maybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: Maybe<Scalars['Decimal']>;
  secondPartyUserId?: Maybe<Scalars['Int']>;
  status: TransitionStatusType;
  tax: Scalars['Decimal'];
  traineeEvent?: Maybe<TraineeEvent>;
  traineeEventGroup?: Maybe<TraineeEventGroup>;
  traineeEventGroupId?: Maybe<Scalars['Int']>;
  traineeEventId?: Maybe<Scalars['Int']>;
  trainerEvent?: Maybe<TrainerEvent>;
  trainerEventId?: Maybe<Scalars['Int']>;
  transitionId?: Maybe<Scalars['Int']>;
  transitionPurpose: TransitionPurpose;
  transitionPurposeId: Scalars['Int'];
  transitionStatusTypeId: Scalars['Int'];
  transitionType: TransitionType;
  transitionTypeId: Scalars['Int'];
};

export type TransitionAvgAggregateOutputType = {
  __typename?: 'TransitionAvgAggregateOutputType';
  amount?: Maybe<Scalars['Decimal']>;
  eventId?: Maybe<Scalars['Float']>;
  firstPartyClosingBalance?: Maybe<Scalars['Decimal']>;
  firstPartyOpeningBalance?: Maybe<Scalars['Decimal']>;
  firstPartyUserId?: Maybe<Scalars['Float']>;
  fullAmount?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['Float']>;
  mediatorId?: Maybe<Scalars['Float']>;
  moyasarFee?: Maybe<Scalars['Decimal']>;
  paymentWayId?: Maybe<Scalars['Float']>;
  secondPartyClosingBalance?: Maybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: Maybe<Scalars['Decimal']>;
  secondPartyUserId?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Decimal']>;
  traineeEventGroupId?: Maybe<Scalars['Float']>;
  traineeEventId?: Maybe<Scalars['Float']>;
  trainerEventId?: Maybe<Scalars['Float']>;
  transitionId?: Maybe<Scalars['Float']>;
  transitionPurposeId?: Maybe<Scalars['Float']>;
  transitionStatusTypeId?: Maybe<Scalars['Float']>;
  transitionTypeId?: Maybe<Scalars['Float']>;
};

export type TransitionAvgOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  firstPartyClosingBalance?: InputMaybe<SortOrder>;
  firstPartyOpeningBalance?: InputMaybe<SortOrder>;
  firstPartyUserId?: InputMaybe<SortOrder>;
  fullAmount?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  mediatorId?: InputMaybe<SortOrder>;
  moyasarFee?: InputMaybe<SortOrder>;
  paymentWayId?: InputMaybe<SortOrder>;
  secondPartyClosingBalance?: InputMaybe<SortOrder>;
  secondPartyOpeningBalance?: InputMaybe<SortOrder>;
  secondPartyUserId?: InputMaybe<SortOrder>;
  tax?: InputMaybe<SortOrder>;
  traineeEventGroupId?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
  transitionId?: InputMaybe<SortOrder>;
  transitionPurposeId?: InputMaybe<SortOrder>;
  transitionStatusTypeId?: InputMaybe<SortOrder>;
  transitionTypeId?: InputMaybe<SortOrder>;
};

export type TransitionCountAggregateOutputType = {
  __typename?: 'TransitionCountAggregateOutputType';
  _all: Scalars['Int'];
  amount: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  eventId: Scalars['Int'];
  firstPartyClosingBalance: Scalars['Int'];
  firstPartyOpeningBalance: Scalars['Int'];
  firstPartyUserId: Scalars['Int'];
  fullAmount: Scalars['Int'];
  id: Scalars['Int'];
  isHiddenFromUser: Scalars['Int'];
  mediatorId: Scalars['Int'];
  moyasarFee: Scalars['Int'];
  moyasarId: Scalars['Int'];
  paymentWayId: Scalars['Int'];
  receiptUrl: Scalars['Int'];
  secondPartyClosingBalance: Scalars['Int'];
  secondPartyOpeningBalance: Scalars['Int'];
  secondPartyUserId: Scalars['Int'];
  tax: Scalars['Int'];
  traineeEventGroupId: Scalars['Int'];
  traineeEventId: Scalars['Int'];
  trainerEventId: Scalars['Int'];
  transitionId: Scalars['Int'];
  transitionPurposeId: Scalars['Int'];
  transitionStatusTypeId: Scalars['Int'];
  transitionTypeId: Scalars['Int'];
};

export type TransitionCountOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  firstPartyClosingBalance?: InputMaybe<SortOrder>;
  firstPartyOpeningBalance?: InputMaybe<SortOrder>;
  firstPartyUserId?: InputMaybe<SortOrder>;
  fullAmount?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isHiddenFromUser?: InputMaybe<SortOrder>;
  mediatorId?: InputMaybe<SortOrder>;
  moyasarFee?: InputMaybe<SortOrder>;
  moyasarId?: InputMaybe<SortOrder>;
  paymentWayId?: InputMaybe<SortOrder>;
  receiptUrl?: InputMaybe<SortOrder>;
  secondPartyClosingBalance?: InputMaybe<SortOrder>;
  secondPartyOpeningBalance?: InputMaybe<SortOrder>;
  secondPartyUserId?: InputMaybe<SortOrder>;
  tax?: InputMaybe<SortOrder>;
  traineeEventGroupId?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
  transitionId?: InputMaybe<SortOrder>;
  transitionPurposeId?: InputMaybe<SortOrder>;
  transitionStatusTypeId?: InputMaybe<SortOrder>;
  transitionTypeId?: InputMaybe<SortOrder>;
};

export type TransitionCreateInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<EventCreateNestedOneWithoutExpensesTransitionsInput>;
  firstParty: UserCreateNestedOneWithoutTransitionsFirstPartyInput;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  fullAmount: Scalars['Decimal'];
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediator?: InputMaybe<UserCreateNestedOneWithoutTransactionsMediatorInput>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWay: PaymentWayCreateNestedOneWithoutTransitionInput;
  receiptUrl?: InputMaybe<Scalars['String']>;
  refundTransition?: InputMaybe<TransitionCreateNestedOneWithoutRefundedTransitionInput>;
  refundedTransition?: InputMaybe<TransitionCreateNestedOneWithoutRefundTransitionInput>;
  secondParty?: InputMaybe<UserCreateNestedOneWithoutTransitionsSecondPartyInput>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  status?: InputMaybe<TransitionStatusTypeCreateNestedOneWithoutTransitionsInput>;
  tax: Scalars['Decimal'];
  traineeEvent?: InputMaybe<TraineeEventCreateNestedOneWithoutTransitionsInput>;
  traineeEventGroup?: InputMaybe<TraineeEventGroupCreateNestedOneWithoutGroupTransactionsInput>;
  trainerEvent?: InputMaybe<TrainerEventCreateNestedOneWithoutTransitionsInput>;
  transitionPurpose: TransitionPurposeCreateNestedOneWithoutTransitionsInput;
  transitionType: TransitionTypeCreateNestedOneWithoutTransitionsInput;
};

export type TransitionCreateManyEventInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  firstPartyUserId: Scalars['Int'];
  fullAmount: Scalars['Decimal'];
  id?: InputMaybe<Scalars['Int']>;
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediatorId?: InputMaybe<Scalars['Int']>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWayId: Scalars['Int'];
  receiptUrl?: InputMaybe<Scalars['String']>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyUserId?: InputMaybe<Scalars['Int']>;
  tax: Scalars['Decimal'];
  traineeEventGroupId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  transitionId?: InputMaybe<Scalars['Int']>;
  transitionPurposeId: Scalars['Int'];
  transitionStatusTypeId?: InputMaybe<Scalars['Int']>;
  transitionTypeId: Scalars['Int'];
};

export type TransitionCreateManyEventInputEnvelope = {
  data: TransitionCreateManyEventInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TransitionCreateManyFirstPartyInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['Int']>;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  fullAmount: Scalars['Decimal'];
  id?: InputMaybe<Scalars['Int']>;
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediatorId?: InputMaybe<Scalars['Int']>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWayId: Scalars['Int'];
  receiptUrl?: InputMaybe<Scalars['String']>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyUserId?: InputMaybe<Scalars['Int']>;
  tax: Scalars['Decimal'];
  traineeEventGroupId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  transitionId?: InputMaybe<Scalars['Int']>;
  transitionPurposeId: Scalars['Int'];
  transitionStatusTypeId?: InputMaybe<Scalars['Int']>;
  transitionTypeId: Scalars['Int'];
};

export type TransitionCreateManyFirstPartyInputEnvelope = {
  data: TransitionCreateManyFirstPartyInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TransitionCreateManyInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['Int']>;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  firstPartyUserId: Scalars['Int'];
  fullAmount: Scalars['Decimal'];
  id?: InputMaybe<Scalars['Int']>;
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediatorId?: InputMaybe<Scalars['Int']>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWayId: Scalars['Int'];
  receiptUrl?: InputMaybe<Scalars['String']>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyUserId?: InputMaybe<Scalars['Int']>;
  tax: Scalars['Decimal'];
  traineeEventGroupId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  transitionId?: InputMaybe<Scalars['Int']>;
  transitionPurposeId: Scalars['Int'];
  transitionStatusTypeId?: InputMaybe<Scalars['Int']>;
  transitionTypeId: Scalars['Int'];
};

export type TransitionCreateManyMediatorInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['Int']>;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  firstPartyUserId: Scalars['Int'];
  fullAmount: Scalars['Decimal'];
  id?: InputMaybe<Scalars['Int']>;
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWayId: Scalars['Int'];
  receiptUrl?: InputMaybe<Scalars['String']>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyUserId?: InputMaybe<Scalars['Int']>;
  tax: Scalars['Decimal'];
  traineeEventGroupId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  transitionId?: InputMaybe<Scalars['Int']>;
  transitionPurposeId: Scalars['Int'];
  transitionStatusTypeId?: InputMaybe<Scalars['Int']>;
  transitionTypeId: Scalars['Int'];
};

export type TransitionCreateManyMediatorInputEnvelope = {
  data: TransitionCreateManyMediatorInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TransitionCreateManyPaymentWayInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['Int']>;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  firstPartyUserId: Scalars['Int'];
  fullAmount: Scalars['Decimal'];
  id?: InputMaybe<Scalars['Int']>;
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediatorId?: InputMaybe<Scalars['Int']>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  receiptUrl?: InputMaybe<Scalars['String']>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyUserId?: InputMaybe<Scalars['Int']>;
  tax: Scalars['Decimal'];
  traineeEventGroupId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  transitionId?: InputMaybe<Scalars['Int']>;
  transitionPurposeId: Scalars['Int'];
  transitionStatusTypeId?: InputMaybe<Scalars['Int']>;
  transitionTypeId: Scalars['Int'];
};

export type TransitionCreateManyPaymentWayInputEnvelope = {
  data: TransitionCreateManyPaymentWayInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TransitionCreateManySecondPartyInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['Int']>;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  firstPartyUserId: Scalars['Int'];
  fullAmount: Scalars['Decimal'];
  id?: InputMaybe<Scalars['Int']>;
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediatorId?: InputMaybe<Scalars['Int']>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWayId: Scalars['Int'];
  receiptUrl?: InputMaybe<Scalars['String']>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  tax: Scalars['Decimal'];
  traineeEventGroupId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  transitionId?: InputMaybe<Scalars['Int']>;
  transitionPurposeId: Scalars['Int'];
  transitionStatusTypeId?: InputMaybe<Scalars['Int']>;
  transitionTypeId: Scalars['Int'];
};

export type TransitionCreateManySecondPartyInputEnvelope = {
  data: TransitionCreateManySecondPartyInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TransitionCreateManyStatusInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['Int']>;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  firstPartyUserId: Scalars['Int'];
  fullAmount: Scalars['Decimal'];
  id?: InputMaybe<Scalars['Int']>;
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediatorId?: InputMaybe<Scalars['Int']>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWayId: Scalars['Int'];
  receiptUrl?: InputMaybe<Scalars['String']>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyUserId?: InputMaybe<Scalars['Int']>;
  tax: Scalars['Decimal'];
  traineeEventGroupId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  transitionId?: InputMaybe<Scalars['Int']>;
  transitionPurposeId: Scalars['Int'];
  transitionTypeId: Scalars['Int'];
};

export type TransitionCreateManyStatusInputEnvelope = {
  data: TransitionCreateManyStatusInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TransitionCreateManyTraineeEventGroupInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['Int']>;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  firstPartyUserId: Scalars['Int'];
  fullAmount: Scalars['Decimal'];
  id?: InputMaybe<Scalars['Int']>;
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediatorId?: InputMaybe<Scalars['Int']>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWayId: Scalars['Int'];
  receiptUrl?: InputMaybe<Scalars['String']>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyUserId?: InputMaybe<Scalars['Int']>;
  tax: Scalars['Decimal'];
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  transitionId?: InputMaybe<Scalars['Int']>;
  transitionPurposeId: Scalars['Int'];
  transitionStatusTypeId?: InputMaybe<Scalars['Int']>;
  transitionTypeId: Scalars['Int'];
};

export type TransitionCreateManyTraineeEventGroupInputEnvelope = {
  data: TransitionCreateManyTraineeEventGroupInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TransitionCreateManyTraineeEventInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['Int']>;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  firstPartyUserId: Scalars['Int'];
  fullAmount: Scalars['Decimal'];
  id?: InputMaybe<Scalars['Int']>;
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediatorId?: InputMaybe<Scalars['Int']>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWayId: Scalars['Int'];
  receiptUrl?: InputMaybe<Scalars['String']>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyUserId?: InputMaybe<Scalars['Int']>;
  tax: Scalars['Decimal'];
  traineeEventGroupId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  transitionId?: InputMaybe<Scalars['Int']>;
  transitionPurposeId: Scalars['Int'];
  transitionStatusTypeId?: InputMaybe<Scalars['Int']>;
  transitionTypeId: Scalars['Int'];
};

export type TransitionCreateManyTraineeEventInputEnvelope = {
  data: TransitionCreateManyTraineeEventInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TransitionCreateManyTrainerEventInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['Int']>;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  firstPartyUserId: Scalars['Int'];
  fullAmount: Scalars['Decimal'];
  id?: InputMaybe<Scalars['Int']>;
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediatorId?: InputMaybe<Scalars['Int']>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWayId: Scalars['Int'];
  receiptUrl?: InputMaybe<Scalars['String']>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyUserId?: InputMaybe<Scalars['Int']>;
  tax: Scalars['Decimal'];
  traineeEventGroupId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  transitionId?: InputMaybe<Scalars['Int']>;
  transitionPurposeId: Scalars['Int'];
  transitionStatusTypeId?: InputMaybe<Scalars['Int']>;
  transitionTypeId: Scalars['Int'];
};

export type TransitionCreateManyTrainerEventInputEnvelope = {
  data: TransitionCreateManyTrainerEventInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TransitionCreateManyTransitionPurposeInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['Int']>;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  firstPartyUserId: Scalars['Int'];
  fullAmount: Scalars['Decimal'];
  id?: InputMaybe<Scalars['Int']>;
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediatorId?: InputMaybe<Scalars['Int']>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWayId: Scalars['Int'];
  receiptUrl?: InputMaybe<Scalars['String']>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyUserId?: InputMaybe<Scalars['Int']>;
  tax: Scalars['Decimal'];
  traineeEventGroupId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  transitionId?: InputMaybe<Scalars['Int']>;
  transitionStatusTypeId?: InputMaybe<Scalars['Int']>;
  transitionTypeId: Scalars['Int'];
};

export type TransitionCreateManyTransitionPurposeInputEnvelope = {
  data: TransitionCreateManyTransitionPurposeInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TransitionCreateManyTransitionTypeInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['Int']>;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  firstPartyUserId: Scalars['Int'];
  fullAmount: Scalars['Decimal'];
  id?: InputMaybe<Scalars['Int']>;
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediatorId?: InputMaybe<Scalars['Int']>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWayId: Scalars['Int'];
  receiptUrl?: InputMaybe<Scalars['String']>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyUserId?: InputMaybe<Scalars['Int']>;
  tax: Scalars['Decimal'];
  traineeEventGroupId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  transitionId?: InputMaybe<Scalars['Int']>;
  transitionPurposeId: Scalars['Int'];
  transitionStatusTypeId?: InputMaybe<Scalars['Int']>;
};

export type TransitionCreateManyTransitionTypeInputEnvelope = {
  data: TransitionCreateManyTransitionTypeInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TransitionCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutEventInput>>>;
  createMany?: InputMaybe<TransitionCreateManyEventInputEnvelope>;
};

export type TransitionCreateNestedManyWithoutFirstPartyInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutFirstPartyInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutFirstPartyInput>>>;
  createMany?: InputMaybe<TransitionCreateManyFirstPartyInputEnvelope>;
};

export type TransitionCreateNestedManyWithoutMediatorInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutMediatorInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutMediatorInput>>>;
  createMany?: InputMaybe<TransitionCreateManyMediatorInputEnvelope>;
};

export type TransitionCreateNestedManyWithoutPaymentWayInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutPaymentWayInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutPaymentWayInput>>>;
  createMany?: InputMaybe<TransitionCreateManyPaymentWayInputEnvelope>;
};

export type TransitionCreateNestedManyWithoutSecondPartyInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutSecondPartyInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutSecondPartyInput>>>;
  createMany?: InputMaybe<TransitionCreateManySecondPartyInputEnvelope>;
};

export type TransitionCreateNestedManyWithoutStatusInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutStatusInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutStatusInput>>>;
  createMany?: InputMaybe<TransitionCreateManyStatusInputEnvelope>;
};

export type TransitionCreateNestedManyWithoutTraineeEventGroupInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutTraineeEventGroupInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutTraineeEventGroupInput>>>;
  createMany?: InputMaybe<TransitionCreateManyTraineeEventGroupInputEnvelope>;
};

export type TransitionCreateNestedManyWithoutTraineeEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutTraineeEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutTraineeEventInput>>>;
  createMany?: InputMaybe<TransitionCreateManyTraineeEventInputEnvelope>;
};

export type TransitionCreateNestedManyWithoutTrainerEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutTrainerEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutTrainerEventInput>>>;
  createMany?: InputMaybe<TransitionCreateManyTrainerEventInputEnvelope>;
};

export type TransitionCreateNestedManyWithoutTransitionPurposeInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutTransitionPurposeInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutTransitionPurposeInput>>>;
  createMany?: InputMaybe<TransitionCreateManyTransitionPurposeInputEnvelope>;
};

export type TransitionCreateNestedManyWithoutTransitionTypeInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutTransitionTypeInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutTransitionTypeInput>>>;
  createMany?: InputMaybe<TransitionCreateManyTransitionTypeInputEnvelope>;
};

export type TransitionCreateNestedOneWithoutRefundTransitionInput = {
  connect?: InputMaybe<TransitionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TransitionCreateOrConnectWithoutRefundTransitionInput>;
  create?: InputMaybe<TransitionUncheckedCreateWithoutRefundTransitionInput>;
};

export type TransitionCreateNestedOneWithoutRefundedTransitionInput = {
  connect?: InputMaybe<TransitionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TransitionCreateOrConnectWithoutRefundedTransitionInput>;
  create?: InputMaybe<TransitionUncheckedCreateWithoutRefundedTransitionInput>;
};

export type TransitionCreateOrConnectWithoutEventInput = {
  create: TransitionUncheckedCreateWithoutEventInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionCreateOrConnectWithoutFirstPartyInput = {
  create: TransitionUncheckedCreateWithoutFirstPartyInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionCreateOrConnectWithoutMediatorInput = {
  create: TransitionUncheckedCreateWithoutMediatorInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionCreateOrConnectWithoutPaymentWayInput = {
  create: TransitionUncheckedCreateWithoutPaymentWayInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionCreateOrConnectWithoutRefundTransitionInput = {
  create: TransitionUncheckedCreateWithoutRefundTransitionInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionCreateOrConnectWithoutRefundedTransitionInput = {
  create: TransitionUncheckedCreateWithoutRefundedTransitionInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionCreateOrConnectWithoutSecondPartyInput = {
  create: TransitionUncheckedCreateWithoutSecondPartyInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionCreateOrConnectWithoutStatusInput = {
  create: TransitionUncheckedCreateWithoutStatusInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionCreateOrConnectWithoutTraineeEventGroupInput = {
  create: TransitionUncheckedCreateWithoutTraineeEventGroupInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionCreateOrConnectWithoutTraineeEventInput = {
  create: TransitionUncheckedCreateWithoutTraineeEventInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionCreateOrConnectWithoutTrainerEventInput = {
  create: TransitionUncheckedCreateWithoutTrainerEventInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionCreateOrConnectWithoutTransitionPurposeInput = {
  create: TransitionUncheckedCreateWithoutTransitionPurposeInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionCreateOrConnectWithoutTransitionTypeInput = {
  create: TransitionUncheckedCreateWithoutTransitionTypeInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionCreateWithoutEventInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  firstParty: UserCreateNestedOneWithoutTransitionsFirstPartyInput;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  fullAmount: Scalars['Decimal'];
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediator?: InputMaybe<UserCreateNestedOneWithoutTransactionsMediatorInput>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWay: PaymentWayCreateNestedOneWithoutTransitionInput;
  receiptUrl?: InputMaybe<Scalars['String']>;
  refundTransition?: InputMaybe<TransitionCreateNestedOneWithoutRefundedTransitionInput>;
  refundedTransition?: InputMaybe<TransitionCreateNestedOneWithoutRefundTransitionInput>;
  secondParty?: InputMaybe<UserCreateNestedOneWithoutTransitionsSecondPartyInput>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  status?: InputMaybe<TransitionStatusTypeCreateNestedOneWithoutTransitionsInput>;
  tax: Scalars['Decimal'];
  traineeEvent?: InputMaybe<TraineeEventCreateNestedOneWithoutTransitionsInput>;
  traineeEventGroup?: InputMaybe<TraineeEventGroupCreateNestedOneWithoutGroupTransactionsInput>;
  trainerEvent?: InputMaybe<TrainerEventCreateNestedOneWithoutTransitionsInput>;
  transitionPurpose: TransitionPurposeCreateNestedOneWithoutTransitionsInput;
  transitionType: TransitionTypeCreateNestedOneWithoutTransitionsInput;
};

export type TransitionCreateWithoutFirstPartyInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<EventCreateNestedOneWithoutExpensesTransitionsInput>;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  fullAmount: Scalars['Decimal'];
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediator?: InputMaybe<UserCreateNestedOneWithoutTransactionsMediatorInput>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWay: PaymentWayCreateNestedOneWithoutTransitionInput;
  receiptUrl?: InputMaybe<Scalars['String']>;
  refundTransition?: InputMaybe<TransitionCreateNestedOneWithoutRefundedTransitionInput>;
  refundedTransition?: InputMaybe<TransitionCreateNestedOneWithoutRefundTransitionInput>;
  secondParty?: InputMaybe<UserCreateNestedOneWithoutTransitionsSecondPartyInput>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  status?: InputMaybe<TransitionStatusTypeCreateNestedOneWithoutTransitionsInput>;
  tax: Scalars['Decimal'];
  traineeEvent?: InputMaybe<TraineeEventCreateNestedOneWithoutTransitionsInput>;
  traineeEventGroup?: InputMaybe<TraineeEventGroupCreateNestedOneWithoutGroupTransactionsInput>;
  trainerEvent?: InputMaybe<TrainerEventCreateNestedOneWithoutTransitionsInput>;
  transitionPurpose: TransitionPurposeCreateNestedOneWithoutTransitionsInput;
  transitionType: TransitionTypeCreateNestedOneWithoutTransitionsInput;
};

export type TransitionCreateWithoutMediatorInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<EventCreateNestedOneWithoutExpensesTransitionsInput>;
  firstParty: UserCreateNestedOneWithoutTransitionsFirstPartyInput;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  fullAmount: Scalars['Decimal'];
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWay: PaymentWayCreateNestedOneWithoutTransitionInput;
  receiptUrl?: InputMaybe<Scalars['String']>;
  refundTransition?: InputMaybe<TransitionCreateNestedOneWithoutRefundedTransitionInput>;
  refundedTransition?: InputMaybe<TransitionCreateNestedOneWithoutRefundTransitionInput>;
  secondParty?: InputMaybe<UserCreateNestedOneWithoutTransitionsSecondPartyInput>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  status?: InputMaybe<TransitionStatusTypeCreateNestedOneWithoutTransitionsInput>;
  tax: Scalars['Decimal'];
  traineeEvent?: InputMaybe<TraineeEventCreateNestedOneWithoutTransitionsInput>;
  traineeEventGroup?: InputMaybe<TraineeEventGroupCreateNestedOneWithoutGroupTransactionsInput>;
  trainerEvent?: InputMaybe<TrainerEventCreateNestedOneWithoutTransitionsInput>;
  transitionPurpose: TransitionPurposeCreateNestedOneWithoutTransitionsInput;
  transitionType: TransitionTypeCreateNestedOneWithoutTransitionsInput;
};

export type TransitionCreateWithoutPaymentWayInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<EventCreateNestedOneWithoutExpensesTransitionsInput>;
  firstParty: UserCreateNestedOneWithoutTransitionsFirstPartyInput;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  fullAmount: Scalars['Decimal'];
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediator?: InputMaybe<UserCreateNestedOneWithoutTransactionsMediatorInput>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  receiptUrl?: InputMaybe<Scalars['String']>;
  refundTransition?: InputMaybe<TransitionCreateNestedOneWithoutRefundedTransitionInput>;
  refundedTransition?: InputMaybe<TransitionCreateNestedOneWithoutRefundTransitionInput>;
  secondParty?: InputMaybe<UserCreateNestedOneWithoutTransitionsSecondPartyInput>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  status?: InputMaybe<TransitionStatusTypeCreateNestedOneWithoutTransitionsInput>;
  tax: Scalars['Decimal'];
  traineeEvent?: InputMaybe<TraineeEventCreateNestedOneWithoutTransitionsInput>;
  traineeEventGroup?: InputMaybe<TraineeEventGroupCreateNestedOneWithoutGroupTransactionsInput>;
  trainerEvent?: InputMaybe<TrainerEventCreateNestedOneWithoutTransitionsInput>;
  transitionPurpose: TransitionPurposeCreateNestedOneWithoutTransitionsInput;
  transitionType: TransitionTypeCreateNestedOneWithoutTransitionsInput;
};

export type TransitionCreateWithoutRefundTransitionInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<EventCreateNestedOneWithoutExpensesTransitionsInput>;
  firstParty: UserCreateNestedOneWithoutTransitionsFirstPartyInput;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  fullAmount: Scalars['Decimal'];
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediator?: InputMaybe<UserCreateNestedOneWithoutTransactionsMediatorInput>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWay: PaymentWayCreateNestedOneWithoutTransitionInput;
  receiptUrl?: InputMaybe<Scalars['String']>;
  refundedTransition?: InputMaybe<TransitionCreateNestedOneWithoutRefundTransitionInput>;
  secondParty?: InputMaybe<UserCreateNestedOneWithoutTransitionsSecondPartyInput>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  status?: InputMaybe<TransitionStatusTypeCreateNestedOneWithoutTransitionsInput>;
  tax: Scalars['Decimal'];
  traineeEvent?: InputMaybe<TraineeEventCreateNestedOneWithoutTransitionsInput>;
  traineeEventGroup?: InputMaybe<TraineeEventGroupCreateNestedOneWithoutGroupTransactionsInput>;
  trainerEvent?: InputMaybe<TrainerEventCreateNestedOneWithoutTransitionsInput>;
  transitionPurpose: TransitionPurposeCreateNestedOneWithoutTransitionsInput;
  transitionType: TransitionTypeCreateNestedOneWithoutTransitionsInput;
};

export type TransitionCreateWithoutRefundedTransitionInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<EventCreateNestedOneWithoutExpensesTransitionsInput>;
  firstParty: UserCreateNestedOneWithoutTransitionsFirstPartyInput;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  fullAmount: Scalars['Decimal'];
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediator?: InputMaybe<UserCreateNestedOneWithoutTransactionsMediatorInput>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWay: PaymentWayCreateNestedOneWithoutTransitionInput;
  receiptUrl?: InputMaybe<Scalars['String']>;
  refundTransition?: InputMaybe<TransitionCreateNestedOneWithoutRefundedTransitionInput>;
  secondParty?: InputMaybe<UserCreateNestedOneWithoutTransitionsSecondPartyInput>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  status?: InputMaybe<TransitionStatusTypeCreateNestedOneWithoutTransitionsInput>;
  tax: Scalars['Decimal'];
  traineeEvent?: InputMaybe<TraineeEventCreateNestedOneWithoutTransitionsInput>;
  traineeEventGroup?: InputMaybe<TraineeEventGroupCreateNestedOneWithoutGroupTransactionsInput>;
  trainerEvent?: InputMaybe<TrainerEventCreateNestedOneWithoutTransitionsInput>;
  transitionPurpose: TransitionPurposeCreateNestedOneWithoutTransitionsInput;
  transitionType: TransitionTypeCreateNestedOneWithoutTransitionsInput;
};

export type TransitionCreateWithoutSecondPartyInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<EventCreateNestedOneWithoutExpensesTransitionsInput>;
  firstParty: UserCreateNestedOneWithoutTransitionsFirstPartyInput;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  fullAmount: Scalars['Decimal'];
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediator?: InputMaybe<UserCreateNestedOneWithoutTransactionsMediatorInput>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWay: PaymentWayCreateNestedOneWithoutTransitionInput;
  receiptUrl?: InputMaybe<Scalars['String']>;
  refundTransition?: InputMaybe<TransitionCreateNestedOneWithoutRefundedTransitionInput>;
  refundedTransition?: InputMaybe<TransitionCreateNestedOneWithoutRefundTransitionInput>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  status?: InputMaybe<TransitionStatusTypeCreateNestedOneWithoutTransitionsInput>;
  tax: Scalars['Decimal'];
  traineeEvent?: InputMaybe<TraineeEventCreateNestedOneWithoutTransitionsInput>;
  traineeEventGroup?: InputMaybe<TraineeEventGroupCreateNestedOneWithoutGroupTransactionsInput>;
  trainerEvent?: InputMaybe<TrainerEventCreateNestedOneWithoutTransitionsInput>;
  transitionPurpose: TransitionPurposeCreateNestedOneWithoutTransitionsInput;
  transitionType: TransitionTypeCreateNestedOneWithoutTransitionsInput;
};

export type TransitionCreateWithoutStatusInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<EventCreateNestedOneWithoutExpensesTransitionsInput>;
  firstParty: UserCreateNestedOneWithoutTransitionsFirstPartyInput;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  fullAmount: Scalars['Decimal'];
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediator?: InputMaybe<UserCreateNestedOneWithoutTransactionsMediatorInput>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWay: PaymentWayCreateNestedOneWithoutTransitionInput;
  receiptUrl?: InputMaybe<Scalars['String']>;
  refundTransition?: InputMaybe<TransitionCreateNestedOneWithoutRefundedTransitionInput>;
  refundedTransition?: InputMaybe<TransitionCreateNestedOneWithoutRefundTransitionInput>;
  secondParty?: InputMaybe<UserCreateNestedOneWithoutTransitionsSecondPartyInput>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  tax: Scalars['Decimal'];
  traineeEvent?: InputMaybe<TraineeEventCreateNestedOneWithoutTransitionsInput>;
  traineeEventGroup?: InputMaybe<TraineeEventGroupCreateNestedOneWithoutGroupTransactionsInput>;
  trainerEvent?: InputMaybe<TrainerEventCreateNestedOneWithoutTransitionsInput>;
  transitionPurpose: TransitionPurposeCreateNestedOneWithoutTransitionsInput;
  transitionType: TransitionTypeCreateNestedOneWithoutTransitionsInput;
};

export type TransitionCreateWithoutTraineeEventGroupInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<EventCreateNestedOneWithoutExpensesTransitionsInput>;
  firstParty: UserCreateNestedOneWithoutTransitionsFirstPartyInput;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  fullAmount: Scalars['Decimal'];
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediator?: InputMaybe<UserCreateNestedOneWithoutTransactionsMediatorInput>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWay: PaymentWayCreateNestedOneWithoutTransitionInput;
  receiptUrl?: InputMaybe<Scalars['String']>;
  refundTransition?: InputMaybe<TransitionCreateNestedOneWithoutRefundedTransitionInput>;
  refundedTransition?: InputMaybe<TransitionCreateNestedOneWithoutRefundTransitionInput>;
  secondParty?: InputMaybe<UserCreateNestedOneWithoutTransitionsSecondPartyInput>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  status?: InputMaybe<TransitionStatusTypeCreateNestedOneWithoutTransitionsInput>;
  tax: Scalars['Decimal'];
  traineeEvent?: InputMaybe<TraineeEventCreateNestedOneWithoutTransitionsInput>;
  trainerEvent?: InputMaybe<TrainerEventCreateNestedOneWithoutTransitionsInput>;
  transitionPurpose: TransitionPurposeCreateNestedOneWithoutTransitionsInput;
  transitionType: TransitionTypeCreateNestedOneWithoutTransitionsInput;
};

export type TransitionCreateWithoutTraineeEventInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<EventCreateNestedOneWithoutExpensesTransitionsInput>;
  firstParty: UserCreateNestedOneWithoutTransitionsFirstPartyInput;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  fullAmount: Scalars['Decimal'];
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediator?: InputMaybe<UserCreateNestedOneWithoutTransactionsMediatorInput>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWay: PaymentWayCreateNestedOneWithoutTransitionInput;
  receiptUrl?: InputMaybe<Scalars['String']>;
  refundTransition?: InputMaybe<TransitionCreateNestedOneWithoutRefundedTransitionInput>;
  refundedTransition?: InputMaybe<TransitionCreateNestedOneWithoutRefundTransitionInput>;
  secondParty?: InputMaybe<UserCreateNestedOneWithoutTransitionsSecondPartyInput>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  status?: InputMaybe<TransitionStatusTypeCreateNestedOneWithoutTransitionsInput>;
  tax: Scalars['Decimal'];
  traineeEventGroup?: InputMaybe<TraineeEventGroupCreateNestedOneWithoutGroupTransactionsInput>;
  trainerEvent?: InputMaybe<TrainerEventCreateNestedOneWithoutTransitionsInput>;
  transitionPurpose: TransitionPurposeCreateNestedOneWithoutTransitionsInput;
  transitionType: TransitionTypeCreateNestedOneWithoutTransitionsInput;
};

export type TransitionCreateWithoutTrainerEventInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<EventCreateNestedOneWithoutExpensesTransitionsInput>;
  firstParty: UserCreateNestedOneWithoutTransitionsFirstPartyInput;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  fullAmount: Scalars['Decimal'];
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediator?: InputMaybe<UserCreateNestedOneWithoutTransactionsMediatorInput>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWay: PaymentWayCreateNestedOneWithoutTransitionInput;
  receiptUrl?: InputMaybe<Scalars['String']>;
  refundTransition?: InputMaybe<TransitionCreateNestedOneWithoutRefundedTransitionInput>;
  refundedTransition?: InputMaybe<TransitionCreateNestedOneWithoutRefundTransitionInput>;
  secondParty?: InputMaybe<UserCreateNestedOneWithoutTransitionsSecondPartyInput>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  status?: InputMaybe<TransitionStatusTypeCreateNestedOneWithoutTransitionsInput>;
  tax: Scalars['Decimal'];
  traineeEvent?: InputMaybe<TraineeEventCreateNestedOneWithoutTransitionsInput>;
  traineeEventGroup?: InputMaybe<TraineeEventGroupCreateNestedOneWithoutGroupTransactionsInput>;
  transitionPurpose: TransitionPurposeCreateNestedOneWithoutTransitionsInput;
  transitionType: TransitionTypeCreateNestedOneWithoutTransitionsInput;
};

export type TransitionCreateWithoutTransitionPurposeInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<EventCreateNestedOneWithoutExpensesTransitionsInput>;
  firstParty: UserCreateNestedOneWithoutTransitionsFirstPartyInput;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  fullAmount: Scalars['Decimal'];
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediator?: InputMaybe<UserCreateNestedOneWithoutTransactionsMediatorInput>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWay: PaymentWayCreateNestedOneWithoutTransitionInput;
  receiptUrl?: InputMaybe<Scalars['String']>;
  refundTransition?: InputMaybe<TransitionCreateNestedOneWithoutRefundedTransitionInput>;
  refundedTransition?: InputMaybe<TransitionCreateNestedOneWithoutRefundTransitionInput>;
  secondParty?: InputMaybe<UserCreateNestedOneWithoutTransitionsSecondPartyInput>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  status?: InputMaybe<TransitionStatusTypeCreateNestedOneWithoutTransitionsInput>;
  tax: Scalars['Decimal'];
  traineeEvent?: InputMaybe<TraineeEventCreateNestedOneWithoutTransitionsInput>;
  traineeEventGroup?: InputMaybe<TraineeEventGroupCreateNestedOneWithoutGroupTransactionsInput>;
  trainerEvent?: InputMaybe<TrainerEventCreateNestedOneWithoutTransitionsInput>;
  transitionType: TransitionTypeCreateNestedOneWithoutTransitionsInput;
};

export type TransitionCreateWithoutTransitionTypeInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<EventCreateNestedOneWithoutExpensesTransitionsInput>;
  firstParty: UserCreateNestedOneWithoutTransitionsFirstPartyInput;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  fullAmount: Scalars['Decimal'];
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediator?: InputMaybe<UserCreateNestedOneWithoutTransactionsMediatorInput>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWay: PaymentWayCreateNestedOneWithoutTransitionInput;
  receiptUrl?: InputMaybe<Scalars['String']>;
  refundTransition?: InputMaybe<TransitionCreateNestedOneWithoutRefundedTransitionInput>;
  refundedTransition?: InputMaybe<TransitionCreateNestedOneWithoutRefundTransitionInput>;
  secondParty?: InputMaybe<UserCreateNestedOneWithoutTransitionsSecondPartyInput>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  status?: InputMaybe<TransitionStatusTypeCreateNestedOneWithoutTransitionsInput>;
  tax: Scalars['Decimal'];
  traineeEvent?: InputMaybe<TraineeEventCreateNestedOneWithoutTransitionsInput>;
  traineeEventGroup?: InputMaybe<TraineeEventGroupCreateNestedOneWithoutGroupTransactionsInput>;
  trainerEvent?: InputMaybe<TrainerEventCreateNestedOneWithoutTransitionsInput>;
  transitionPurpose: TransitionPurposeCreateNestedOneWithoutTransitionsInput;
};

export type TransitionListRelationFilter = {
  every?: InputMaybe<TransitionWhereInput>;
  none?: InputMaybe<TransitionWhereInput>;
  some?: InputMaybe<TransitionWhereInput>;
};

export type TransitionMaxAggregateOutputType = {
  __typename?: 'TransitionMaxAggregateOutputType';
  amount?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['Int']>;
  firstPartyClosingBalance?: Maybe<Scalars['Decimal']>;
  firstPartyOpeningBalance?: Maybe<Scalars['Decimal']>;
  firstPartyUserId?: Maybe<Scalars['Int']>;
  fullAmount?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['Int']>;
  isHiddenFromUser?: Maybe<Scalars['Boolean']>;
  mediatorId?: Maybe<Scalars['Int']>;
  moyasarFee?: Maybe<Scalars['Decimal']>;
  moyasarId?: Maybe<Scalars['String']>;
  paymentWayId?: Maybe<Scalars['Int']>;
  receiptUrl?: Maybe<Scalars['String']>;
  secondPartyClosingBalance?: Maybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: Maybe<Scalars['Decimal']>;
  secondPartyUserId?: Maybe<Scalars['Int']>;
  tax?: Maybe<Scalars['Decimal']>;
  traineeEventGroupId?: Maybe<Scalars['Int']>;
  traineeEventId?: Maybe<Scalars['Int']>;
  trainerEventId?: Maybe<Scalars['Int']>;
  transitionId?: Maybe<Scalars['Int']>;
  transitionPurposeId?: Maybe<Scalars['Int']>;
  transitionStatusTypeId?: Maybe<Scalars['Int']>;
  transitionTypeId?: Maybe<Scalars['Int']>;
};

export type TransitionMaxOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  firstPartyClosingBalance?: InputMaybe<SortOrder>;
  firstPartyOpeningBalance?: InputMaybe<SortOrder>;
  firstPartyUserId?: InputMaybe<SortOrder>;
  fullAmount?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isHiddenFromUser?: InputMaybe<SortOrder>;
  mediatorId?: InputMaybe<SortOrder>;
  moyasarFee?: InputMaybe<SortOrder>;
  moyasarId?: InputMaybe<SortOrder>;
  paymentWayId?: InputMaybe<SortOrder>;
  receiptUrl?: InputMaybe<SortOrder>;
  secondPartyClosingBalance?: InputMaybe<SortOrder>;
  secondPartyOpeningBalance?: InputMaybe<SortOrder>;
  secondPartyUserId?: InputMaybe<SortOrder>;
  tax?: InputMaybe<SortOrder>;
  traineeEventGroupId?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
  transitionId?: InputMaybe<SortOrder>;
  transitionPurposeId?: InputMaybe<SortOrder>;
  transitionStatusTypeId?: InputMaybe<SortOrder>;
  transitionTypeId?: InputMaybe<SortOrder>;
};

export type TransitionMinAggregateOutputType = {
  __typename?: 'TransitionMinAggregateOutputType';
  amount?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['Int']>;
  firstPartyClosingBalance?: Maybe<Scalars['Decimal']>;
  firstPartyOpeningBalance?: Maybe<Scalars['Decimal']>;
  firstPartyUserId?: Maybe<Scalars['Int']>;
  fullAmount?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['Int']>;
  isHiddenFromUser?: Maybe<Scalars['Boolean']>;
  mediatorId?: Maybe<Scalars['Int']>;
  moyasarFee?: Maybe<Scalars['Decimal']>;
  moyasarId?: Maybe<Scalars['String']>;
  paymentWayId?: Maybe<Scalars['Int']>;
  receiptUrl?: Maybe<Scalars['String']>;
  secondPartyClosingBalance?: Maybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: Maybe<Scalars['Decimal']>;
  secondPartyUserId?: Maybe<Scalars['Int']>;
  tax?: Maybe<Scalars['Decimal']>;
  traineeEventGroupId?: Maybe<Scalars['Int']>;
  traineeEventId?: Maybe<Scalars['Int']>;
  trainerEventId?: Maybe<Scalars['Int']>;
  transitionId?: Maybe<Scalars['Int']>;
  transitionPurposeId?: Maybe<Scalars['Int']>;
  transitionStatusTypeId?: Maybe<Scalars['Int']>;
  transitionTypeId?: Maybe<Scalars['Int']>;
};

export type TransitionMinOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  firstPartyClosingBalance?: InputMaybe<SortOrder>;
  firstPartyOpeningBalance?: InputMaybe<SortOrder>;
  firstPartyUserId?: InputMaybe<SortOrder>;
  fullAmount?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isHiddenFromUser?: InputMaybe<SortOrder>;
  mediatorId?: InputMaybe<SortOrder>;
  moyasarFee?: InputMaybe<SortOrder>;
  moyasarId?: InputMaybe<SortOrder>;
  paymentWayId?: InputMaybe<SortOrder>;
  receiptUrl?: InputMaybe<SortOrder>;
  secondPartyClosingBalance?: InputMaybe<SortOrder>;
  secondPartyOpeningBalance?: InputMaybe<SortOrder>;
  secondPartyUserId?: InputMaybe<SortOrder>;
  tax?: InputMaybe<SortOrder>;
  traineeEventGroupId?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
  transitionId?: InputMaybe<SortOrder>;
  transitionPurposeId?: InputMaybe<SortOrder>;
  transitionStatusTypeId?: InputMaybe<SortOrder>;
  transitionTypeId?: InputMaybe<SortOrder>;
};

export type TransitionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TransitionOrderByWithAggregationInput = {
  _avg?: InputMaybe<TransitionAvgOrderByAggregateInput>;
  _count?: InputMaybe<TransitionCountOrderByAggregateInput>;
  _max?: InputMaybe<TransitionMaxOrderByAggregateInput>;
  _min?: InputMaybe<TransitionMinOrderByAggregateInput>;
  _sum?: InputMaybe<TransitionSumOrderByAggregateInput>;
  amount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  firstPartyClosingBalance?: InputMaybe<SortOrder>;
  firstPartyOpeningBalance?: InputMaybe<SortOrder>;
  firstPartyUserId?: InputMaybe<SortOrder>;
  fullAmount?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isHiddenFromUser?: InputMaybe<SortOrder>;
  mediatorId?: InputMaybe<SortOrder>;
  moyasarFee?: InputMaybe<SortOrder>;
  moyasarId?: InputMaybe<SortOrder>;
  paymentWayId?: InputMaybe<SortOrder>;
  receiptUrl?: InputMaybe<SortOrder>;
  secondPartyClosingBalance?: InputMaybe<SortOrder>;
  secondPartyOpeningBalance?: InputMaybe<SortOrder>;
  secondPartyUserId?: InputMaybe<SortOrder>;
  tax?: InputMaybe<SortOrder>;
  traineeEventGroupId?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
  transitionId?: InputMaybe<SortOrder>;
  transitionPurposeId?: InputMaybe<SortOrder>;
  transitionStatusTypeId?: InputMaybe<SortOrder>;
  transitionTypeId?: InputMaybe<SortOrder>;
};

export type TransitionOrderByWithRelationInput = {
  amount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  event?: InputMaybe<EventOrderByWithRelationInput>;
  eventId?: InputMaybe<SortOrder>;
  firstParty?: InputMaybe<UserOrderByWithRelationInput>;
  firstPartyClosingBalance?: InputMaybe<SortOrder>;
  firstPartyOpeningBalance?: InputMaybe<SortOrder>;
  firstPartyUserId?: InputMaybe<SortOrder>;
  fullAmount?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isHiddenFromUser?: InputMaybe<SortOrder>;
  mediator?: InputMaybe<UserOrderByWithRelationInput>;
  mediatorId?: InputMaybe<SortOrder>;
  moyasarFee?: InputMaybe<SortOrder>;
  moyasarId?: InputMaybe<SortOrder>;
  paymentWay?: InputMaybe<PaymentWayOrderByWithRelationInput>;
  paymentWayId?: InputMaybe<SortOrder>;
  receiptUrl?: InputMaybe<SortOrder>;
  refundTransition?: InputMaybe<TransitionOrderByWithRelationInput>;
  refundedTransition?: InputMaybe<TransitionOrderByWithRelationInput>;
  secondParty?: InputMaybe<UserOrderByWithRelationInput>;
  secondPartyClosingBalance?: InputMaybe<SortOrder>;
  secondPartyOpeningBalance?: InputMaybe<SortOrder>;
  secondPartyUserId?: InputMaybe<SortOrder>;
  status?: InputMaybe<TransitionStatusTypeOrderByWithRelationInput>;
  tax?: InputMaybe<SortOrder>;
  traineeEvent?: InputMaybe<TraineeEventOrderByWithRelationInput>;
  traineeEventGroup?: InputMaybe<TraineeEventGroupOrderByWithRelationInput>;
  traineeEventGroupId?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  trainerEvent?: InputMaybe<TrainerEventOrderByWithRelationInput>;
  trainerEventId?: InputMaybe<SortOrder>;
  transitionId?: InputMaybe<SortOrder>;
  transitionPurpose?: InputMaybe<TransitionPurposeOrderByWithRelationInput>;
  transitionPurposeId?: InputMaybe<SortOrder>;
  transitionStatusTypeId?: InputMaybe<SortOrder>;
  transitionType?: InputMaybe<TransitionTypeOrderByWithRelationInput>;
  transitionTypeId?: InputMaybe<SortOrder>;
};

export type TransitionPurpose = {
  __typename?: 'TransitionPurpose';
  _count: TransitionPurposeCountOutputType;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  transitions: Array<Transition>;
};


export type TransitionPurposeTransitionsArgs = {
  cursor?: InputMaybe<TransitionWhereUniqueInput>;
  distinct?: InputMaybe<TransitionScalarFieldEnum>;
  orderBy?: InputMaybe<TransitionOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TransitionWhereInput>;
};

export type TransitionPurposeAvgAggregateOutputType = {
  __typename?: 'TransitionPurposeAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
};

export type TransitionPurposeAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type TransitionPurposeCountAggregateOutputType = {
  __typename?: 'TransitionPurposeCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  titleAr: Scalars['Int'];
  titleEn: Scalars['Int'];
};

export type TransitionPurposeCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type TransitionPurposeCountOutputType = {
  __typename?: 'TransitionPurposeCountOutputType';
  transitions: Scalars['Int'];
};

export type TransitionPurposeCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutTransitionPurposeInput>;
};

export type TransitionPurposeCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type TransitionPurposeCreateNestedOneWithoutTransitionsInput = {
  connect?: InputMaybe<TransitionPurposeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TransitionPurposeCreateOrConnectWithoutTransitionsInput>;
  create?: InputMaybe<TransitionPurposeUncheckedCreateWithoutTransitionsInput>;
};

export type TransitionPurposeCreateOrConnectWithoutTransitionsInput = {
  create: TransitionPurposeUncheckedCreateWithoutTransitionsInput;
  where: TransitionPurposeWhereUniqueInput;
};

export type TransitionPurposeCreateWithoutTransitionsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type TransitionPurposeMaxAggregateOutputType = {
  __typename?: 'TransitionPurposeMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type TransitionPurposeMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type TransitionPurposeMinAggregateOutputType = {
  __typename?: 'TransitionPurposeMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type TransitionPurposeMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type TransitionPurposeOrderByWithAggregationInput = {
  _avg?: InputMaybe<TransitionPurposeAvgOrderByAggregateInput>;
  _count?: InputMaybe<TransitionPurposeCountOrderByAggregateInput>;
  _max?: InputMaybe<TransitionPurposeMaxOrderByAggregateInput>;
  _min?: InputMaybe<TransitionPurposeMinOrderByAggregateInput>;
  _sum?: InputMaybe<TransitionPurposeSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type TransitionPurposeOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
  transitions?: InputMaybe<TransitionOrderByRelationAggregateInput>;
};

export type TransitionPurposeRelationFilter = {
  is?: InputMaybe<TransitionPurposeWhereInput>;
  isNot?: InputMaybe<TransitionPurposeWhereInput>;
};

export enum TransitionPurposeScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  TitleAr = 'titleAr',
  TitleEn = 'titleEn'
}

export type TransitionPurposeScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<TransitionPurposeScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TransitionPurposeScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TransitionPurposeScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  titleAr?: InputMaybe<StringWithAggregatesFilter>;
  titleEn?: InputMaybe<StringWithAggregatesFilter>;
};

export type TransitionPurposeSumAggregateOutputType = {
  __typename?: 'TransitionPurposeSumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
};

export type TransitionPurposeSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type TransitionPurposeUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTransitionPurposeInput>;
};

export type TransitionPurposeUncheckedCreateWithoutTransitionsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type TransitionPurposeUncheckedUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTransitionPurposeInput>;
};

export type TransitionPurposeUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TransitionPurposeUncheckedUpdateWithoutTransitionsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TransitionPurposeUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutTransitionPurposeInput>;
};

export type TransitionPurposeUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TransitionPurposeUpdateOneRequiredWithoutTransitionsInput = {
  connect?: InputMaybe<TransitionPurposeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TransitionPurposeCreateOrConnectWithoutTransitionsInput>;
  create?: InputMaybe<TransitionPurposeUncheckedCreateWithoutTransitionsInput>;
  update?: InputMaybe<TransitionPurposeUncheckedUpdateWithoutTransitionsInput>;
  upsert?: InputMaybe<TransitionPurposeUpsertWithoutTransitionsInput>;
};

export type TransitionPurposeUpdateWithoutTransitionsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TransitionPurposeUpsertWithoutTransitionsInput = {
  create: TransitionPurposeUncheckedCreateWithoutTransitionsInput;
  update: TransitionPurposeUncheckedUpdateWithoutTransitionsInput;
};

export type TransitionPurposeWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TransitionPurposeWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TransitionPurposeWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TransitionPurposeWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  titleAr?: InputMaybe<StringFilter>;
  titleEn?: InputMaybe<StringFilter>;
  transitions?: InputMaybe<TransitionListRelationFilter>;
};

export type TransitionPurposeWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn?: InputMaybe<Scalars['String']>;
};

export type TransitionRelationFilter = {
  is?: InputMaybe<TransitionWhereInput>;
  isNot?: InputMaybe<TransitionWhereInput>;
};

export enum TransitionScalarFieldEnum {
  Amount = 'amount',
  CreatedAt = 'createdAt',
  Description = 'description',
  EventId = 'eventId',
  FirstPartyClosingBalance = 'firstPartyClosingBalance',
  FirstPartyOpeningBalance = 'firstPartyOpeningBalance',
  FirstPartyUserId = 'firstPartyUserId',
  FullAmount = 'fullAmount',
  Id = 'id',
  IsHiddenFromUser = 'isHiddenFromUser',
  MediatorId = 'mediatorId',
  MoyasarFee = 'moyasarFee',
  MoyasarId = 'moyasarId',
  PaymentWayId = 'paymentWayId',
  ReceiptUrl = 'receiptUrl',
  SecondPartyClosingBalance = 'secondPartyClosingBalance',
  SecondPartyOpeningBalance = 'secondPartyOpeningBalance',
  SecondPartyUserId = 'secondPartyUserId',
  Tax = 'tax',
  TraineeEventGroupId = 'traineeEventGroupId',
  TraineeEventId = 'traineeEventId',
  TrainerEventId = 'trainerEventId',
  TransitionId = 'transitionId',
  TransitionPurposeId = 'transitionPurposeId',
  TransitionStatusTypeId = 'transitionStatusTypeId',
  TransitionTypeId = 'transitionTypeId'
}

export type TransitionScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TransitionScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TransitionScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TransitionScalarWhereInput>>>;
  amount?: InputMaybe<DecimalFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  eventId?: InputMaybe<IntNullableFilter>;
  firstPartyClosingBalance?: InputMaybe<DecimalFilter>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFilter>;
  firstPartyUserId?: InputMaybe<IntFilter>;
  fullAmount?: InputMaybe<DecimalFilter>;
  id?: InputMaybe<IntFilter>;
  isHiddenFromUser?: InputMaybe<BoolFilter>;
  mediatorId?: InputMaybe<IntNullableFilter>;
  moyasarFee?: InputMaybe<DecimalNullableFilter>;
  moyasarId?: InputMaybe<StringNullableFilter>;
  paymentWayId?: InputMaybe<IntFilter>;
  receiptUrl?: InputMaybe<StringNullableFilter>;
  secondPartyClosingBalance?: InputMaybe<DecimalNullableFilter>;
  secondPartyOpeningBalance?: InputMaybe<DecimalNullableFilter>;
  secondPartyUserId?: InputMaybe<IntNullableFilter>;
  tax?: InputMaybe<DecimalFilter>;
  traineeEventGroupId?: InputMaybe<IntNullableFilter>;
  traineeEventId?: InputMaybe<IntNullableFilter>;
  trainerEventId?: InputMaybe<IntNullableFilter>;
  transitionId?: InputMaybe<IntNullableFilter>;
  transitionPurposeId?: InputMaybe<IntFilter>;
  transitionStatusTypeId?: InputMaybe<IntFilter>;
  transitionTypeId?: InputMaybe<IntFilter>;
};

export type TransitionScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<TransitionScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TransitionScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TransitionScalarWhereWithAggregatesInput>>>;
  amount?: InputMaybe<DecimalWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  eventId?: InputMaybe<IntNullableWithAggregatesFilter>;
  firstPartyClosingBalance?: InputMaybe<DecimalWithAggregatesFilter>;
  firstPartyOpeningBalance?: InputMaybe<DecimalWithAggregatesFilter>;
  firstPartyUserId?: InputMaybe<IntWithAggregatesFilter>;
  fullAmount?: InputMaybe<DecimalWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  isHiddenFromUser?: InputMaybe<BoolWithAggregatesFilter>;
  mediatorId?: InputMaybe<IntNullableWithAggregatesFilter>;
  moyasarFee?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  moyasarId?: InputMaybe<StringNullableWithAggregatesFilter>;
  paymentWayId?: InputMaybe<IntWithAggregatesFilter>;
  receiptUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  secondPartyClosingBalance?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  secondPartyOpeningBalance?: InputMaybe<DecimalNullableWithAggregatesFilter>;
  secondPartyUserId?: InputMaybe<IntNullableWithAggregatesFilter>;
  tax?: InputMaybe<DecimalWithAggregatesFilter>;
  traineeEventGroupId?: InputMaybe<IntNullableWithAggregatesFilter>;
  traineeEventId?: InputMaybe<IntNullableWithAggregatesFilter>;
  trainerEventId?: InputMaybe<IntNullableWithAggregatesFilter>;
  transitionId?: InputMaybe<IntNullableWithAggregatesFilter>;
  transitionPurposeId?: InputMaybe<IntWithAggregatesFilter>;
  transitionStatusTypeId?: InputMaybe<IntWithAggregatesFilter>;
  transitionTypeId?: InputMaybe<IntWithAggregatesFilter>;
};

export type TransitionStatusType = {
  __typename?: 'TransitionStatusType';
  _count: TransitionStatusTypeCountOutputType;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  transitions: Array<Transition>;
};


export type TransitionStatusTypeTransitionsArgs = {
  cursor?: InputMaybe<TransitionWhereUniqueInput>;
  distinct?: InputMaybe<TransitionScalarFieldEnum>;
  orderBy?: InputMaybe<TransitionOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TransitionWhereInput>;
};

export type TransitionStatusTypeAvgAggregateOutputType = {
  __typename?: 'TransitionStatusTypeAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
};

export type TransitionStatusTypeAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type TransitionStatusTypeCountAggregateOutputType = {
  __typename?: 'TransitionStatusTypeCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  titleAr: Scalars['Int'];
  titleEn: Scalars['Int'];
};

export type TransitionStatusTypeCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type TransitionStatusTypeCountOutputType = {
  __typename?: 'TransitionStatusTypeCountOutputType';
  transitions: Scalars['Int'];
};

export type TransitionStatusTypeCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutStatusInput>;
};

export type TransitionStatusTypeCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type TransitionStatusTypeCreateNestedOneWithoutTransitionsInput = {
  connect?: InputMaybe<TransitionStatusTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TransitionStatusTypeCreateOrConnectWithoutTransitionsInput>;
  create?: InputMaybe<TransitionStatusTypeUncheckedCreateWithoutTransitionsInput>;
};

export type TransitionStatusTypeCreateOrConnectWithoutTransitionsInput = {
  create: TransitionStatusTypeUncheckedCreateWithoutTransitionsInput;
  where: TransitionStatusTypeWhereUniqueInput;
};

export type TransitionStatusTypeCreateWithoutTransitionsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type TransitionStatusTypeMaxAggregateOutputType = {
  __typename?: 'TransitionStatusTypeMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type TransitionStatusTypeMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type TransitionStatusTypeMinAggregateOutputType = {
  __typename?: 'TransitionStatusTypeMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type TransitionStatusTypeMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type TransitionStatusTypeOrderByWithAggregationInput = {
  _avg?: InputMaybe<TransitionStatusTypeAvgOrderByAggregateInput>;
  _count?: InputMaybe<TransitionStatusTypeCountOrderByAggregateInput>;
  _max?: InputMaybe<TransitionStatusTypeMaxOrderByAggregateInput>;
  _min?: InputMaybe<TransitionStatusTypeMinOrderByAggregateInput>;
  _sum?: InputMaybe<TransitionStatusTypeSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type TransitionStatusTypeOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
  transitions?: InputMaybe<TransitionOrderByRelationAggregateInput>;
};

export type TransitionStatusTypeRelationFilter = {
  is?: InputMaybe<TransitionStatusTypeWhereInput>;
  isNot?: InputMaybe<TransitionStatusTypeWhereInput>;
};

export enum TransitionStatusTypeScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  TitleAr = 'titleAr',
  TitleEn = 'titleEn'
}

export type TransitionStatusTypeScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<TransitionStatusTypeScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TransitionStatusTypeScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TransitionStatusTypeScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  titleAr?: InputMaybe<StringWithAggregatesFilter>;
  titleEn?: InputMaybe<StringWithAggregatesFilter>;
};

export type TransitionStatusTypeSumAggregateOutputType = {
  __typename?: 'TransitionStatusTypeSumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
};

export type TransitionStatusTypeSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type TransitionStatusTypeUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutStatusInput>;
};

export type TransitionStatusTypeUncheckedCreateWithoutTransitionsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type TransitionStatusTypeUncheckedUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutStatusInput>;
};

export type TransitionStatusTypeUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TransitionStatusTypeUncheckedUpdateWithoutTransitionsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TransitionStatusTypeUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutStatusInput>;
};

export type TransitionStatusTypeUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TransitionStatusTypeUpdateOneRequiredWithoutTransitionsInput = {
  connect?: InputMaybe<TransitionStatusTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TransitionStatusTypeCreateOrConnectWithoutTransitionsInput>;
  create?: InputMaybe<TransitionStatusTypeUncheckedCreateWithoutTransitionsInput>;
  update?: InputMaybe<TransitionStatusTypeUncheckedUpdateWithoutTransitionsInput>;
  upsert?: InputMaybe<TransitionStatusTypeUpsertWithoutTransitionsInput>;
};

export type TransitionStatusTypeUpdateWithoutTransitionsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TransitionStatusTypeUpsertWithoutTransitionsInput = {
  create: TransitionStatusTypeUncheckedCreateWithoutTransitionsInput;
  update: TransitionStatusTypeUncheckedUpdateWithoutTransitionsInput;
};

export type TransitionStatusTypeWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TransitionStatusTypeWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TransitionStatusTypeWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TransitionStatusTypeWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  titleAr?: InputMaybe<StringFilter>;
  titleEn?: InputMaybe<StringFilter>;
  transitions?: InputMaybe<TransitionListRelationFilter>;
};

export type TransitionStatusTypeWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn?: InputMaybe<Scalars['String']>;
};

export type TransitionSumAggregateOutputType = {
  __typename?: 'TransitionSumAggregateOutputType';
  amount?: Maybe<Scalars['Decimal']>;
  eventId?: Maybe<Scalars['Int']>;
  firstPartyClosingBalance?: Maybe<Scalars['Decimal']>;
  firstPartyOpeningBalance?: Maybe<Scalars['Decimal']>;
  firstPartyUserId?: Maybe<Scalars['Int']>;
  fullAmount?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['Int']>;
  mediatorId?: Maybe<Scalars['Int']>;
  moyasarFee?: Maybe<Scalars['Decimal']>;
  paymentWayId?: Maybe<Scalars['Int']>;
  secondPartyClosingBalance?: Maybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: Maybe<Scalars['Decimal']>;
  secondPartyUserId?: Maybe<Scalars['Int']>;
  tax?: Maybe<Scalars['Decimal']>;
  traineeEventGroupId?: Maybe<Scalars['Int']>;
  traineeEventId?: Maybe<Scalars['Int']>;
  trainerEventId?: Maybe<Scalars['Int']>;
  transitionId?: Maybe<Scalars['Int']>;
  transitionPurposeId?: Maybe<Scalars['Int']>;
  transitionStatusTypeId?: Maybe<Scalars['Int']>;
  transitionTypeId?: Maybe<Scalars['Int']>;
};

export type TransitionSumOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  firstPartyClosingBalance?: InputMaybe<SortOrder>;
  firstPartyOpeningBalance?: InputMaybe<SortOrder>;
  firstPartyUserId?: InputMaybe<SortOrder>;
  fullAmount?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  mediatorId?: InputMaybe<SortOrder>;
  moyasarFee?: InputMaybe<SortOrder>;
  paymentWayId?: InputMaybe<SortOrder>;
  secondPartyClosingBalance?: InputMaybe<SortOrder>;
  secondPartyOpeningBalance?: InputMaybe<SortOrder>;
  secondPartyUserId?: InputMaybe<SortOrder>;
  tax?: InputMaybe<SortOrder>;
  traineeEventGroupId?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
  transitionId?: InputMaybe<SortOrder>;
  transitionPurposeId?: InputMaybe<SortOrder>;
  transitionStatusTypeId?: InputMaybe<SortOrder>;
  transitionTypeId?: InputMaybe<SortOrder>;
};

export type TransitionType = {
  __typename?: 'TransitionType';
  _count: TransitionTypeCountOutputType;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  transitions: Array<Transition>;
};


export type TransitionTypeTransitionsArgs = {
  cursor?: InputMaybe<TransitionWhereUniqueInput>;
  distinct?: InputMaybe<TransitionScalarFieldEnum>;
  orderBy?: InputMaybe<TransitionOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TransitionWhereInput>;
};

export type TransitionTypeAvgAggregateOutputType = {
  __typename?: 'TransitionTypeAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']>;
};

export type TransitionTypeAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type TransitionTypeCountAggregateOutputType = {
  __typename?: 'TransitionTypeCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  titleAr: Scalars['Int'];
  titleEn: Scalars['Int'];
};

export type TransitionTypeCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type TransitionTypeCountOutputType = {
  __typename?: 'TransitionTypeCountOutputType';
  transitions: Scalars['Int'];
};

export type TransitionTypeCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  transitions?: InputMaybe<TransitionCreateNestedManyWithoutTransitionTypeInput>;
};

export type TransitionTypeCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type TransitionTypeCreateNestedOneWithoutTransitionsInput = {
  connect?: InputMaybe<TransitionTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TransitionTypeCreateOrConnectWithoutTransitionsInput>;
  create?: InputMaybe<TransitionTypeUncheckedCreateWithoutTransitionsInput>;
};

export type TransitionTypeCreateOrConnectWithoutTransitionsInput = {
  create: TransitionTypeUncheckedCreateWithoutTransitionsInput;
  where: TransitionTypeWhereUniqueInput;
};

export type TransitionTypeCreateWithoutTransitionsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type TransitionTypeMaxAggregateOutputType = {
  __typename?: 'TransitionTypeMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type TransitionTypeMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type TransitionTypeMinAggregateOutputType = {
  __typename?: 'TransitionTypeMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type TransitionTypeMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type TransitionTypeOrderByWithAggregationInput = {
  _avg?: InputMaybe<TransitionTypeAvgOrderByAggregateInput>;
  _count?: InputMaybe<TransitionTypeCountOrderByAggregateInput>;
  _max?: InputMaybe<TransitionTypeMaxOrderByAggregateInput>;
  _min?: InputMaybe<TransitionTypeMinOrderByAggregateInput>;
  _sum?: InputMaybe<TransitionTypeSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
};

export type TransitionTypeOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  titleAr?: InputMaybe<SortOrder>;
  titleEn?: InputMaybe<SortOrder>;
  transitions?: InputMaybe<TransitionOrderByRelationAggregateInput>;
};

export type TransitionTypeRelationFilter = {
  is?: InputMaybe<TransitionTypeWhereInput>;
  isNot?: InputMaybe<TransitionTypeWhereInput>;
};

export enum TransitionTypeScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  TitleAr = 'titleAr',
  TitleEn = 'titleEn'
}

export type TransitionTypeScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<TransitionTypeScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TransitionTypeScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TransitionTypeScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  titleAr?: InputMaybe<StringWithAggregatesFilter>;
  titleEn?: InputMaybe<StringWithAggregatesFilter>;
};

export type TransitionTypeSumAggregateOutputType = {
  __typename?: 'TransitionTypeSumAggregateOutputType';
  id?: Maybe<Scalars['Int']>;
};

export type TransitionTypeSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type TransitionTypeUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
  transitions?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutTransitionTypeInput>;
};

export type TransitionTypeUncheckedCreateWithoutTransitionsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  titleAr: Scalars['String'];
  titleEn: Scalars['String'];
};

export type TransitionTypeUncheckedUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  transitions?: InputMaybe<TransitionUncheckedUpdateManyWithoutTransitionTypeInput>;
};

export type TransitionTypeUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TransitionTypeUncheckedUpdateWithoutTransitionsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TransitionTypeUpdateInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
  transitions?: InputMaybe<TransitionUpdateManyWithoutTransitionTypeInput>;
};

export type TransitionTypeUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TransitionTypeUpdateOneRequiredWithoutTransitionsInput = {
  connect?: InputMaybe<TransitionTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TransitionTypeCreateOrConnectWithoutTransitionsInput>;
  create?: InputMaybe<TransitionTypeUncheckedCreateWithoutTransitionsInput>;
  update?: InputMaybe<TransitionTypeUncheckedUpdateWithoutTransitionsInput>;
  upsert?: InputMaybe<TransitionTypeUpsertWithoutTransitionsInput>;
};

export type TransitionTypeUpdateWithoutTransitionsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  titleAr?: InputMaybe<StringFieldUpdateOperationsInput>;
  titleEn?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TransitionTypeUpsertWithoutTransitionsInput = {
  create: TransitionTypeUncheckedCreateWithoutTransitionsInput;
  update: TransitionTypeUncheckedUpdateWithoutTransitionsInput;
};

export type TransitionTypeWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TransitionTypeWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TransitionTypeWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TransitionTypeWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  titleAr?: InputMaybe<StringFilter>;
  titleEn?: InputMaybe<StringFilter>;
  transitions?: InputMaybe<TransitionListRelationFilter>;
};

export type TransitionTypeWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn?: InputMaybe<Scalars['String']>;
};

export type TransitionUncheckedCreateInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['Int']>;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  firstPartyUserId: Scalars['Int'];
  fullAmount: Scalars['Decimal'];
  id?: InputMaybe<Scalars['Int']>;
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediatorId?: InputMaybe<Scalars['Int']>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWayId: Scalars['Int'];
  receiptUrl?: InputMaybe<Scalars['String']>;
  refundTransition?: InputMaybe<TransitionUncheckedCreateNestedOneWithoutRefundedTransitionInput>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyUserId?: InputMaybe<Scalars['Int']>;
  tax: Scalars['Decimal'];
  traineeEventGroupId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  transitionId?: InputMaybe<Scalars['Int']>;
  transitionPurposeId: Scalars['Int'];
  transitionStatusTypeId?: InputMaybe<Scalars['Int']>;
  transitionTypeId: Scalars['Int'];
};

export type TransitionUncheckedCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutEventInput>>>;
  createMany?: InputMaybe<TransitionCreateManyEventInputEnvelope>;
};

export type TransitionUncheckedCreateNestedManyWithoutFirstPartyInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutFirstPartyInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutFirstPartyInput>>>;
  createMany?: InputMaybe<TransitionCreateManyFirstPartyInputEnvelope>;
};

export type TransitionUncheckedCreateNestedManyWithoutMediatorInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutMediatorInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutMediatorInput>>>;
  createMany?: InputMaybe<TransitionCreateManyMediatorInputEnvelope>;
};

export type TransitionUncheckedCreateNestedManyWithoutPaymentWayInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutPaymentWayInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutPaymentWayInput>>>;
  createMany?: InputMaybe<TransitionCreateManyPaymentWayInputEnvelope>;
};

export type TransitionUncheckedCreateNestedManyWithoutSecondPartyInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutSecondPartyInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutSecondPartyInput>>>;
  createMany?: InputMaybe<TransitionCreateManySecondPartyInputEnvelope>;
};

export type TransitionUncheckedCreateNestedManyWithoutStatusInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutStatusInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutStatusInput>>>;
  createMany?: InputMaybe<TransitionCreateManyStatusInputEnvelope>;
};

export type TransitionUncheckedCreateNestedManyWithoutTraineeEventGroupInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutTraineeEventGroupInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutTraineeEventGroupInput>>>;
  createMany?: InputMaybe<TransitionCreateManyTraineeEventGroupInputEnvelope>;
};

export type TransitionUncheckedCreateNestedManyWithoutTraineeEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutTraineeEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutTraineeEventInput>>>;
  createMany?: InputMaybe<TransitionCreateManyTraineeEventInputEnvelope>;
};

export type TransitionUncheckedCreateNestedManyWithoutTrainerEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutTrainerEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutTrainerEventInput>>>;
  createMany?: InputMaybe<TransitionCreateManyTrainerEventInputEnvelope>;
};

export type TransitionUncheckedCreateNestedManyWithoutTransitionPurposeInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutTransitionPurposeInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutTransitionPurposeInput>>>;
  createMany?: InputMaybe<TransitionCreateManyTransitionPurposeInputEnvelope>;
};

export type TransitionUncheckedCreateNestedManyWithoutTransitionTypeInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutTransitionTypeInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutTransitionTypeInput>>>;
  createMany?: InputMaybe<TransitionCreateManyTransitionTypeInputEnvelope>;
};

export type TransitionUncheckedCreateNestedOneWithoutRefundedTransitionInput = {
  connect?: InputMaybe<TransitionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TransitionCreateOrConnectWithoutRefundedTransitionInput>;
  create?: InputMaybe<TransitionUncheckedCreateWithoutRefundedTransitionInput>;
};

export type TransitionUncheckedCreateWithoutEventInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  firstPartyUserId: Scalars['Int'];
  fullAmount: Scalars['Decimal'];
  id?: InputMaybe<Scalars['Int']>;
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediatorId?: InputMaybe<Scalars['Int']>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWayId: Scalars['Int'];
  receiptUrl?: InputMaybe<Scalars['String']>;
  refundTransition?: InputMaybe<TransitionUncheckedCreateNestedOneWithoutRefundedTransitionInput>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyUserId?: InputMaybe<Scalars['Int']>;
  tax: Scalars['Decimal'];
  traineeEventGroupId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  transitionId?: InputMaybe<Scalars['Int']>;
  transitionPurposeId: Scalars['Int'];
  transitionStatusTypeId?: InputMaybe<Scalars['Int']>;
  transitionTypeId: Scalars['Int'];
};

export type TransitionUncheckedCreateWithoutFirstPartyInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['Int']>;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  fullAmount: Scalars['Decimal'];
  id?: InputMaybe<Scalars['Int']>;
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediatorId?: InputMaybe<Scalars['Int']>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWayId: Scalars['Int'];
  receiptUrl?: InputMaybe<Scalars['String']>;
  refundTransition?: InputMaybe<TransitionUncheckedCreateNestedOneWithoutRefundedTransitionInput>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyUserId?: InputMaybe<Scalars['Int']>;
  tax: Scalars['Decimal'];
  traineeEventGroupId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  transitionId?: InputMaybe<Scalars['Int']>;
  transitionPurposeId: Scalars['Int'];
  transitionStatusTypeId?: InputMaybe<Scalars['Int']>;
  transitionTypeId: Scalars['Int'];
};

export type TransitionUncheckedCreateWithoutMediatorInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['Int']>;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  firstPartyUserId: Scalars['Int'];
  fullAmount: Scalars['Decimal'];
  id?: InputMaybe<Scalars['Int']>;
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWayId: Scalars['Int'];
  receiptUrl?: InputMaybe<Scalars['String']>;
  refundTransition?: InputMaybe<TransitionUncheckedCreateNestedOneWithoutRefundedTransitionInput>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyUserId?: InputMaybe<Scalars['Int']>;
  tax: Scalars['Decimal'];
  traineeEventGroupId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  transitionId?: InputMaybe<Scalars['Int']>;
  transitionPurposeId: Scalars['Int'];
  transitionStatusTypeId?: InputMaybe<Scalars['Int']>;
  transitionTypeId: Scalars['Int'];
};

export type TransitionUncheckedCreateWithoutPaymentWayInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['Int']>;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  firstPartyUserId: Scalars['Int'];
  fullAmount: Scalars['Decimal'];
  id?: InputMaybe<Scalars['Int']>;
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediatorId?: InputMaybe<Scalars['Int']>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  receiptUrl?: InputMaybe<Scalars['String']>;
  refundTransition?: InputMaybe<TransitionUncheckedCreateNestedOneWithoutRefundedTransitionInput>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyUserId?: InputMaybe<Scalars['Int']>;
  tax: Scalars['Decimal'];
  traineeEventGroupId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  transitionId?: InputMaybe<Scalars['Int']>;
  transitionPurposeId: Scalars['Int'];
  transitionStatusTypeId?: InputMaybe<Scalars['Int']>;
  transitionTypeId: Scalars['Int'];
};

export type TransitionUncheckedCreateWithoutRefundTransitionInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['Int']>;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  firstPartyUserId: Scalars['Int'];
  fullAmount: Scalars['Decimal'];
  id?: InputMaybe<Scalars['Int']>;
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediatorId?: InputMaybe<Scalars['Int']>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWayId: Scalars['Int'];
  receiptUrl?: InputMaybe<Scalars['String']>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyUserId?: InputMaybe<Scalars['Int']>;
  tax: Scalars['Decimal'];
  traineeEventGroupId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  transitionId?: InputMaybe<Scalars['Int']>;
  transitionPurposeId: Scalars['Int'];
  transitionStatusTypeId?: InputMaybe<Scalars['Int']>;
  transitionTypeId: Scalars['Int'];
};

export type TransitionUncheckedCreateWithoutRefundedTransitionInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['Int']>;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  firstPartyUserId: Scalars['Int'];
  fullAmount: Scalars['Decimal'];
  id?: InputMaybe<Scalars['Int']>;
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediatorId?: InputMaybe<Scalars['Int']>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWayId: Scalars['Int'];
  receiptUrl?: InputMaybe<Scalars['String']>;
  refundTransition?: InputMaybe<TransitionUncheckedCreateNestedOneWithoutRefundedTransitionInput>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyUserId?: InputMaybe<Scalars['Int']>;
  tax: Scalars['Decimal'];
  traineeEventGroupId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  transitionPurposeId: Scalars['Int'];
  transitionStatusTypeId?: InputMaybe<Scalars['Int']>;
  transitionTypeId: Scalars['Int'];
};

export type TransitionUncheckedCreateWithoutSecondPartyInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['Int']>;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  firstPartyUserId: Scalars['Int'];
  fullAmount: Scalars['Decimal'];
  id?: InputMaybe<Scalars['Int']>;
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediatorId?: InputMaybe<Scalars['Int']>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWayId: Scalars['Int'];
  receiptUrl?: InputMaybe<Scalars['String']>;
  refundTransition?: InputMaybe<TransitionUncheckedCreateNestedOneWithoutRefundedTransitionInput>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  tax: Scalars['Decimal'];
  traineeEventGroupId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  transitionId?: InputMaybe<Scalars['Int']>;
  transitionPurposeId: Scalars['Int'];
  transitionStatusTypeId?: InputMaybe<Scalars['Int']>;
  transitionTypeId: Scalars['Int'];
};

export type TransitionUncheckedCreateWithoutStatusInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['Int']>;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  firstPartyUserId: Scalars['Int'];
  fullAmount: Scalars['Decimal'];
  id?: InputMaybe<Scalars['Int']>;
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediatorId?: InputMaybe<Scalars['Int']>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWayId: Scalars['Int'];
  receiptUrl?: InputMaybe<Scalars['String']>;
  refundTransition?: InputMaybe<TransitionUncheckedCreateNestedOneWithoutRefundedTransitionInput>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyUserId?: InputMaybe<Scalars['Int']>;
  tax: Scalars['Decimal'];
  traineeEventGroupId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  transitionId?: InputMaybe<Scalars['Int']>;
  transitionPurposeId: Scalars['Int'];
  transitionTypeId: Scalars['Int'];
};

export type TransitionUncheckedCreateWithoutTraineeEventGroupInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['Int']>;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  firstPartyUserId: Scalars['Int'];
  fullAmount: Scalars['Decimal'];
  id?: InputMaybe<Scalars['Int']>;
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediatorId?: InputMaybe<Scalars['Int']>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWayId: Scalars['Int'];
  receiptUrl?: InputMaybe<Scalars['String']>;
  refundTransition?: InputMaybe<TransitionUncheckedCreateNestedOneWithoutRefundedTransitionInput>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyUserId?: InputMaybe<Scalars['Int']>;
  tax: Scalars['Decimal'];
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  transitionId?: InputMaybe<Scalars['Int']>;
  transitionPurposeId: Scalars['Int'];
  transitionStatusTypeId?: InputMaybe<Scalars['Int']>;
  transitionTypeId: Scalars['Int'];
};

export type TransitionUncheckedCreateWithoutTraineeEventInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['Int']>;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  firstPartyUserId: Scalars['Int'];
  fullAmount: Scalars['Decimal'];
  id?: InputMaybe<Scalars['Int']>;
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediatorId?: InputMaybe<Scalars['Int']>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWayId: Scalars['Int'];
  receiptUrl?: InputMaybe<Scalars['String']>;
  refundTransition?: InputMaybe<TransitionUncheckedCreateNestedOneWithoutRefundedTransitionInput>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyUserId?: InputMaybe<Scalars['Int']>;
  tax: Scalars['Decimal'];
  traineeEventGroupId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  transitionId?: InputMaybe<Scalars['Int']>;
  transitionPurposeId: Scalars['Int'];
  transitionStatusTypeId?: InputMaybe<Scalars['Int']>;
  transitionTypeId: Scalars['Int'];
};

export type TransitionUncheckedCreateWithoutTrainerEventInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['Int']>;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  firstPartyUserId: Scalars['Int'];
  fullAmount: Scalars['Decimal'];
  id?: InputMaybe<Scalars['Int']>;
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediatorId?: InputMaybe<Scalars['Int']>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWayId: Scalars['Int'];
  receiptUrl?: InputMaybe<Scalars['String']>;
  refundTransition?: InputMaybe<TransitionUncheckedCreateNestedOneWithoutRefundedTransitionInput>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyUserId?: InputMaybe<Scalars['Int']>;
  tax: Scalars['Decimal'];
  traineeEventGroupId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  transitionId?: InputMaybe<Scalars['Int']>;
  transitionPurposeId: Scalars['Int'];
  transitionStatusTypeId?: InputMaybe<Scalars['Int']>;
  transitionTypeId: Scalars['Int'];
};

export type TransitionUncheckedCreateWithoutTransitionPurposeInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['Int']>;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  firstPartyUserId: Scalars['Int'];
  fullAmount: Scalars['Decimal'];
  id?: InputMaybe<Scalars['Int']>;
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediatorId?: InputMaybe<Scalars['Int']>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWayId: Scalars['Int'];
  receiptUrl?: InputMaybe<Scalars['String']>;
  refundTransition?: InputMaybe<TransitionUncheckedCreateNestedOneWithoutRefundedTransitionInput>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyUserId?: InputMaybe<Scalars['Int']>;
  tax: Scalars['Decimal'];
  traineeEventGroupId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  transitionId?: InputMaybe<Scalars['Int']>;
  transitionStatusTypeId?: InputMaybe<Scalars['Int']>;
  transitionTypeId: Scalars['Int'];
};

export type TransitionUncheckedCreateWithoutTransitionTypeInput = {
  amount: Scalars['Decimal'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['Int']>;
  firstPartyClosingBalance: Scalars['Decimal'];
  firstPartyOpeningBalance: Scalars['Decimal'];
  firstPartyUserId: Scalars['Int'];
  fullAmount: Scalars['Decimal'];
  id?: InputMaybe<Scalars['Int']>;
  isHiddenFromUser?: InputMaybe<Scalars['Boolean']>;
  mediatorId?: InputMaybe<Scalars['Int']>;
  moyasarFee?: InputMaybe<Scalars['Decimal']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  paymentWayId: Scalars['Int'];
  receiptUrl?: InputMaybe<Scalars['String']>;
  refundTransition?: InputMaybe<TransitionUncheckedCreateNestedOneWithoutRefundedTransitionInput>;
  secondPartyClosingBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyOpeningBalance?: InputMaybe<Scalars['Decimal']>;
  secondPartyUserId?: InputMaybe<Scalars['Int']>;
  tax: Scalars['Decimal'];
  traineeEventGroupId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  transitionId?: InputMaybe<Scalars['Int']>;
  transitionPurposeId: Scalars['Int'];
  transitionStatusTypeId?: InputMaybe<Scalars['Int']>;
};

export type TransitionUncheckedUpdateInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyUserId?: InputMaybe<IntFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mediatorId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentWayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refundTransition?: InputMaybe<TransitionUncheckedUpdateOneWithoutRefundedTransitionInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyUserId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionPurposeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionStatusTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TransitionUncheckedUpdateManyInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyUserId?: InputMaybe<IntFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mediatorId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentWayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyUserId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionPurposeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionStatusTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TransitionUncheckedUpdateManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutEventInput>>>;
  createMany?: InputMaybe<TransitionCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TransitionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TransitionUpdateWithWhereUniqueWithoutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TransitionUpdateManyWithWhereWithoutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TransitionUpsertWithWhereUniqueWithoutEventInput>>>;
};

export type TransitionUncheckedUpdateManyWithoutExpensesTransitionsInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyUserId?: InputMaybe<IntFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mediatorId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentWayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyUserId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionPurposeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionStatusTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TransitionUncheckedUpdateManyWithoutFirstPartyInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutFirstPartyInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutFirstPartyInput>>>;
  createMany?: InputMaybe<TransitionCreateManyFirstPartyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TransitionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TransitionUpdateWithWhereUniqueWithoutFirstPartyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TransitionUpdateManyWithWhereWithoutFirstPartyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TransitionUpsertWithWhereUniqueWithoutFirstPartyInput>>>;
};

export type TransitionUncheckedUpdateManyWithoutGroupTransactionsInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyUserId?: InputMaybe<IntFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mediatorId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentWayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyUserId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionPurposeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionStatusTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TransitionUncheckedUpdateManyWithoutMediatorInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutMediatorInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutMediatorInput>>>;
  createMany?: InputMaybe<TransitionCreateManyMediatorInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TransitionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TransitionUpdateWithWhereUniqueWithoutMediatorInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TransitionUpdateManyWithWhereWithoutMediatorInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TransitionUpsertWithWhereUniqueWithoutMediatorInput>>>;
};

export type TransitionUncheckedUpdateManyWithoutPaymentWayInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutPaymentWayInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutPaymentWayInput>>>;
  createMany?: InputMaybe<TransitionCreateManyPaymentWayInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TransitionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TransitionUpdateWithWhereUniqueWithoutPaymentWayInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TransitionUpdateManyWithWhereWithoutPaymentWayInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TransitionUpsertWithWhereUniqueWithoutPaymentWayInput>>>;
};

export type TransitionUncheckedUpdateManyWithoutSecondPartyInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutSecondPartyInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutSecondPartyInput>>>;
  createMany?: InputMaybe<TransitionCreateManySecondPartyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TransitionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TransitionUpdateWithWhereUniqueWithoutSecondPartyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TransitionUpdateManyWithWhereWithoutSecondPartyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TransitionUpsertWithWhereUniqueWithoutSecondPartyInput>>>;
};

export type TransitionUncheckedUpdateManyWithoutStatusInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutStatusInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutStatusInput>>>;
  createMany?: InputMaybe<TransitionCreateManyStatusInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TransitionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TransitionUpdateWithWhereUniqueWithoutStatusInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TransitionUpdateManyWithWhereWithoutStatusInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TransitionUpsertWithWhereUniqueWithoutStatusInput>>>;
};

export type TransitionUncheckedUpdateManyWithoutTraineeEventGroupInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutTraineeEventGroupInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutTraineeEventGroupInput>>>;
  createMany?: InputMaybe<TransitionCreateManyTraineeEventGroupInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TransitionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TransitionUpdateWithWhereUniqueWithoutTraineeEventGroupInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TransitionUpdateManyWithWhereWithoutTraineeEventGroupInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TransitionUpsertWithWhereUniqueWithoutTraineeEventGroupInput>>>;
};

export type TransitionUncheckedUpdateManyWithoutTraineeEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutTraineeEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutTraineeEventInput>>>;
  createMany?: InputMaybe<TransitionCreateManyTraineeEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TransitionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TransitionUpdateWithWhereUniqueWithoutTraineeEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TransitionUpdateManyWithWhereWithoutTraineeEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TransitionUpsertWithWhereUniqueWithoutTraineeEventInput>>>;
};

export type TransitionUncheckedUpdateManyWithoutTrainerEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutTrainerEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutTrainerEventInput>>>;
  createMany?: InputMaybe<TransitionCreateManyTrainerEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TransitionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TransitionUpdateWithWhereUniqueWithoutTrainerEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TransitionUpdateManyWithWhereWithoutTrainerEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TransitionUpsertWithWhereUniqueWithoutTrainerEventInput>>>;
};

export type TransitionUncheckedUpdateManyWithoutTransactionsMediatorInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyUserId?: InputMaybe<IntFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentWayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyUserId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionPurposeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionStatusTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TransitionUncheckedUpdateManyWithoutTransitionInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyUserId?: InputMaybe<IntFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mediatorId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyUserId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionPurposeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionStatusTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TransitionUncheckedUpdateManyWithoutTransitionPurposeInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutTransitionPurposeInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutTransitionPurposeInput>>>;
  createMany?: InputMaybe<TransitionCreateManyTransitionPurposeInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TransitionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TransitionUpdateWithWhereUniqueWithoutTransitionPurposeInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TransitionUpdateManyWithWhereWithoutTransitionPurposeInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TransitionUpsertWithWhereUniqueWithoutTransitionPurposeInput>>>;
};

export type TransitionUncheckedUpdateManyWithoutTransitionTypeInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutTransitionTypeInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutTransitionTypeInput>>>;
  createMany?: InputMaybe<TransitionCreateManyTransitionTypeInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TransitionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TransitionUpdateWithWhereUniqueWithoutTransitionTypeInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TransitionUpdateManyWithWhereWithoutTransitionTypeInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TransitionUpsertWithWhereUniqueWithoutTransitionTypeInput>>>;
};

export type TransitionUncheckedUpdateManyWithoutTransitionsFirstPartyInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mediatorId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentWayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyUserId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionPurposeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionStatusTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TransitionUncheckedUpdateManyWithoutTransitionsInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyUserId?: InputMaybe<IntFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mediatorId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentWayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyUserId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionStatusTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TransitionUncheckedUpdateManyWithoutTransitionsSecondPartyInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyUserId?: InputMaybe<IntFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mediatorId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentWayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionPurposeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionStatusTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TransitionUncheckedUpdateOneWithoutRefundedTransitionInput = {
  connect?: InputMaybe<TransitionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TransitionCreateOrConnectWithoutRefundedTransitionInput>;
  create?: InputMaybe<TransitionUncheckedCreateWithoutRefundedTransitionInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<TransitionUncheckedUpdateWithoutRefundedTransitionInput>;
  upsert?: InputMaybe<TransitionUpsertWithoutRefundedTransitionInput>;
};

export type TransitionUncheckedUpdateWithoutEventInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyUserId?: InputMaybe<IntFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mediatorId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentWayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refundTransition?: InputMaybe<TransitionUncheckedUpdateOneWithoutRefundedTransitionInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyUserId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionPurposeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionStatusTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TransitionUncheckedUpdateWithoutFirstPartyInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mediatorId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentWayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refundTransition?: InputMaybe<TransitionUncheckedUpdateOneWithoutRefundedTransitionInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyUserId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionPurposeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionStatusTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TransitionUncheckedUpdateWithoutMediatorInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyUserId?: InputMaybe<IntFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentWayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refundTransition?: InputMaybe<TransitionUncheckedUpdateOneWithoutRefundedTransitionInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyUserId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionPurposeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionStatusTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TransitionUncheckedUpdateWithoutPaymentWayInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyUserId?: InputMaybe<IntFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mediatorId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refundTransition?: InputMaybe<TransitionUncheckedUpdateOneWithoutRefundedTransitionInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyUserId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionPurposeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionStatusTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TransitionUncheckedUpdateWithoutRefundTransitionInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyUserId?: InputMaybe<IntFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mediatorId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentWayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyUserId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionPurposeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionStatusTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TransitionUncheckedUpdateWithoutRefundedTransitionInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyUserId?: InputMaybe<IntFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mediatorId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentWayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refundTransition?: InputMaybe<TransitionUncheckedUpdateOneWithoutRefundedTransitionInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyUserId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionPurposeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionStatusTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TransitionUncheckedUpdateWithoutSecondPartyInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyUserId?: InputMaybe<IntFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mediatorId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentWayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refundTransition?: InputMaybe<TransitionUncheckedUpdateOneWithoutRefundedTransitionInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionPurposeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionStatusTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TransitionUncheckedUpdateWithoutStatusInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyUserId?: InputMaybe<IntFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mediatorId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentWayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refundTransition?: InputMaybe<TransitionUncheckedUpdateOneWithoutRefundedTransitionInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyUserId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionPurposeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TransitionUncheckedUpdateWithoutTraineeEventGroupInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyUserId?: InputMaybe<IntFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mediatorId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentWayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refundTransition?: InputMaybe<TransitionUncheckedUpdateOneWithoutRefundedTransitionInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyUserId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionPurposeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionStatusTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TransitionUncheckedUpdateWithoutTraineeEventInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyUserId?: InputMaybe<IntFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mediatorId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentWayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refundTransition?: InputMaybe<TransitionUncheckedUpdateOneWithoutRefundedTransitionInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyUserId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionPurposeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionStatusTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TransitionUncheckedUpdateWithoutTrainerEventInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyUserId?: InputMaybe<IntFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mediatorId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentWayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refundTransition?: InputMaybe<TransitionUncheckedUpdateOneWithoutRefundedTransitionInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyUserId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionPurposeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionStatusTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TransitionUncheckedUpdateWithoutTransitionPurposeInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyUserId?: InputMaybe<IntFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mediatorId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentWayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refundTransition?: InputMaybe<TransitionUncheckedUpdateOneWithoutRefundedTransitionInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyUserId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionStatusTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TransitionUncheckedUpdateWithoutTransitionTypeInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyUserId?: InputMaybe<IntFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mediatorId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentWayId?: InputMaybe<IntFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refundTransition?: InputMaybe<TransitionUncheckedUpdateOneWithoutRefundedTransitionInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyUserId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventGroupId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transitionPurposeId?: InputMaybe<IntFieldUpdateOperationsInput>;
  transitionStatusTypeId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type TransitionUpdateInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneWithoutExpensesTransitionsInput>;
  firstParty?: InputMaybe<UserUpdateOneRequiredWithoutTransitionsFirstPartyInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mediator?: InputMaybe<UserUpdateOneWithoutTransactionsMediatorInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentWay?: InputMaybe<PaymentWayUpdateOneRequiredWithoutTransitionInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refundTransition?: InputMaybe<TransitionUpdateOneWithoutRefundedTransitionInput>;
  refundedTransition?: InputMaybe<TransitionUpdateOneWithoutRefundTransitionInput>;
  secondParty?: InputMaybe<UserUpdateOneWithoutTransitionsSecondPartyInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  status?: InputMaybe<TransitionStatusTypeUpdateOneRequiredWithoutTransitionsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEvent?: InputMaybe<TraineeEventUpdateOneWithoutTransitionsInput>;
  traineeEventGroup?: InputMaybe<TraineeEventGroupUpdateOneWithoutGroupTransactionsInput>;
  trainerEvent?: InputMaybe<TrainerEventUpdateOneWithoutTransitionsInput>;
  transitionPurpose?: InputMaybe<TransitionPurposeUpdateOneRequiredWithoutTransitionsInput>;
  transitionType?: InputMaybe<TransitionTypeUpdateOneRequiredWithoutTransitionsInput>;
};

export type TransitionUpdateManyMutationInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
};

export type TransitionUpdateManyWithWhereWithoutEventInput = {
  data: TransitionUncheckedUpdateManyWithoutExpensesTransitionsInput;
  where: TransitionScalarWhereInput;
};

export type TransitionUpdateManyWithWhereWithoutFirstPartyInput = {
  data: TransitionUncheckedUpdateManyWithoutTransitionsFirstPartyInput;
  where: TransitionScalarWhereInput;
};

export type TransitionUpdateManyWithWhereWithoutMediatorInput = {
  data: TransitionUncheckedUpdateManyWithoutTransactionsMediatorInput;
  where: TransitionScalarWhereInput;
};

export type TransitionUpdateManyWithWhereWithoutPaymentWayInput = {
  data: TransitionUncheckedUpdateManyWithoutTransitionInput;
  where: TransitionScalarWhereInput;
};

export type TransitionUpdateManyWithWhereWithoutSecondPartyInput = {
  data: TransitionUncheckedUpdateManyWithoutTransitionsSecondPartyInput;
  where: TransitionScalarWhereInput;
};

export type TransitionUpdateManyWithWhereWithoutStatusInput = {
  data: TransitionUncheckedUpdateManyWithoutTransitionsInput;
  where: TransitionScalarWhereInput;
};

export type TransitionUpdateManyWithWhereWithoutTraineeEventGroupInput = {
  data: TransitionUncheckedUpdateManyWithoutGroupTransactionsInput;
  where: TransitionScalarWhereInput;
};

export type TransitionUpdateManyWithWhereWithoutTraineeEventInput = {
  data: TransitionUncheckedUpdateManyWithoutTransitionsInput;
  where: TransitionScalarWhereInput;
};

export type TransitionUpdateManyWithWhereWithoutTrainerEventInput = {
  data: TransitionUncheckedUpdateManyWithoutTransitionsInput;
  where: TransitionScalarWhereInput;
};

export type TransitionUpdateManyWithWhereWithoutTransitionPurposeInput = {
  data: TransitionUncheckedUpdateManyWithoutTransitionsInput;
  where: TransitionScalarWhereInput;
};

export type TransitionUpdateManyWithWhereWithoutTransitionTypeInput = {
  data: TransitionUncheckedUpdateManyWithoutTransitionsInput;
  where: TransitionScalarWhereInput;
};

export type TransitionUpdateManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutEventInput>>>;
  createMany?: InputMaybe<TransitionCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TransitionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TransitionUpdateWithWhereUniqueWithoutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TransitionUpdateManyWithWhereWithoutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TransitionUpsertWithWhereUniqueWithoutEventInput>>>;
};

export type TransitionUpdateManyWithoutFirstPartyInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutFirstPartyInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutFirstPartyInput>>>;
  createMany?: InputMaybe<TransitionCreateManyFirstPartyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TransitionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TransitionUpdateWithWhereUniqueWithoutFirstPartyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TransitionUpdateManyWithWhereWithoutFirstPartyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TransitionUpsertWithWhereUniqueWithoutFirstPartyInput>>>;
};

export type TransitionUpdateManyWithoutMediatorInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutMediatorInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutMediatorInput>>>;
  createMany?: InputMaybe<TransitionCreateManyMediatorInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TransitionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TransitionUpdateWithWhereUniqueWithoutMediatorInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TransitionUpdateManyWithWhereWithoutMediatorInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TransitionUpsertWithWhereUniqueWithoutMediatorInput>>>;
};

export type TransitionUpdateManyWithoutPaymentWayInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutPaymentWayInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutPaymentWayInput>>>;
  createMany?: InputMaybe<TransitionCreateManyPaymentWayInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TransitionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TransitionUpdateWithWhereUniqueWithoutPaymentWayInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TransitionUpdateManyWithWhereWithoutPaymentWayInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TransitionUpsertWithWhereUniqueWithoutPaymentWayInput>>>;
};

export type TransitionUpdateManyWithoutSecondPartyInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutSecondPartyInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutSecondPartyInput>>>;
  createMany?: InputMaybe<TransitionCreateManySecondPartyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TransitionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TransitionUpdateWithWhereUniqueWithoutSecondPartyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TransitionUpdateManyWithWhereWithoutSecondPartyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TransitionUpsertWithWhereUniqueWithoutSecondPartyInput>>>;
};

export type TransitionUpdateManyWithoutStatusInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutStatusInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutStatusInput>>>;
  createMany?: InputMaybe<TransitionCreateManyStatusInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TransitionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TransitionUpdateWithWhereUniqueWithoutStatusInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TransitionUpdateManyWithWhereWithoutStatusInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TransitionUpsertWithWhereUniqueWithoutStatusInput>>>;
};

export type TransitionUpdateManyWithoutTraineeEventGroupInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutTraineeEventGroupInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutTraineeEventGroupInput>>>;
  createMany?: InputMaybe<TransitionCreateManyTraineeEventGroupInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TransitionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TransitionUpdateWithWhereUniqueWithoutTraineeEventGroupInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TransitionUpdateManyWithWhereWithoutTraineeEventGroupInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TransitionUpsertWithWhereUniqueWithoutTraineeEventGroupInput>>>;
};

export type TransitionUpdateManyWithoutTraineeEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutTraineeEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutTraineeEventInput>>>;
  createMany?: InputMaybe<TransitionCreateManyTraineeEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TransitionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TransitionUpdateWithWhereUniqueWithoutTraineeEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TransitionUpdateManyWithWhereWithoutTraineeEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TransitionUpsertWithWhereUniqueWithoutTraineeEventInput>>>;
};

export type TransitionUpdateManyWithoutTrainerEventInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutTrainerEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutTrainerEventInput>>>;
  createMany?: InputMaybe<TransitionCreateManyTrainerEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TransitionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TransitionUpdateWithWhereUniqueWithoutTrainerEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TransitionUpdateManyWithWhereWithoutTrainerEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TransitionUpsertWithWhereUniqueWithoutTrainerEventInput>>>;
};

export type TransitionUpdateManyWithoutTransitionPurposeInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutTransitionPurposeInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutTransitionPurposeInput>>>;
  createMany?: InputMaybe<TransitionCreateManyTransitionPurposeInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TransitionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TransitionUpdateWithWhereUniqueWithoutTransitionPurposeInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TransitionUpdateManyWithWhereWithoutTransitionPurposeInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TransitionUpsertWithWhereUniqueWithoutTransitionPurposeInput>>>;
};

export type TransitionUpdateManyWithoutTransitionTypeInput = {
  connect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<TransitionCreateOrConnectWithoutTransitionTypeInput>>>;
  create?: InputMaybe<Array<InputMaybe<TransitionCreateWithoutTransitionTypeInput>>>;
  createMany?: InputMaybe<TransitionCreateManyTransitionTypeInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<TransitionScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<TransitionWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TransitionUpdateWithWhereUniqueWithoutTransitionTypeInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<TransitionUpdateManyWithWhereWithoutTransitionTypeInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<TransitionUpsertWithWhereUniqueWithoutTransitionTypeInput>>>;
};

export type TransitionUpdateOneWithoutRefundTransitionInput = {
  connect?: InputMaybe<TransitionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TransitionCreateOrConnectWithoutRefundTransitionInput>;
  create?: InputMaybe<TransitionUncheckedCreateWithoutRefundTransitionInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<TransitionUncheckedUpdateWithoutRefundTransitionInput>;
  upsert?: InputMaybe<TransitionUpsertWithoutRefundTransitionInput>;
};

export type TransitionUpdateOneWithoutRefundedTransitionInput = {
  connect?: InputMaybe<TransitionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TransitionCreateOrConnectWithoutRefundedTransitionInput>;
  create?: InputMaybe<TransitionUncheckedCreateWithoutRefundedTransitionInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<TransitionUncheckedUpdateWithoutRefundedTransitionInput>;
  upsert?: InputMaybe<TransitionUpsertWithoutRefundedTransitionInput>;
};

export type TransitionUpdateWithWhereUniqueWithoutEventInput = {
  data: TransitionUncheckedUpdateWithoutEventInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionUpdateWithWhereUniqueWithoutFirstPartyInput = {
  data: TransitionUncheckedUpdateWithoutFirstPartyInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionUpdateWithWhereUniqueWithoutMediatorInput = {
  data: TransitionUncheckedUpdateWithoutMediatorInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionUpdateWithWhereUniqueWithoutPaymentWayInput = {
  data: TransitionUncheckedUpdateWithoutPaymentWayInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionUpdateWithWhereUniqueWithoutSecondPartyInput = {
  data: TransitionUncheckedUpdateWithoutSecondPartyInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionUpdateWithWhereUniqueWithoutStatusInput = {
  data: TransitionUncheckedUpdateWithoutStatusInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionUpdateWithWhereUniqueWithoutTraineeEventGroupInput = {
  data: TransitionUncheckedUpdateWithoutTraineeEventGroupInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionUpdateWithWhereUniqueWithoutTraineeEventInput = {
  data: TransitionUncheckedUpdateWithoutTraineeEventInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionUpdateWithWhereUniqueWithoutTrainerEventInput = {
  data: TransitionUncheckedUpdateWithoutTrainerEventInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionUpdateWithWhereUniqueWithoutTransitionPurposeInput = {
  data: TransitionUncheckedUpdateWithoutTransitionPurposeInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionUpdateWithWhereUniqueWithoutTransitionTypeInput = {
  data: TransitionUncheckedUpdateWithoutTransitionTypeInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionUpdateWithoutEventInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstParty?: InputMaybe<UserUpdateOneRequiredWithoutTransitionsFirstPartyInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mediator?: InputMaybe<UserUpdateOneWithoutTransactionsMediatorInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentWay?: InputMaybe<PaymentWayUpdateOneRequiredWithoutTransitionInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refundTransition?: InputMaybe<TransitionUpdateOneWithoutRefundedTransitionInput>;
  refundedTransition?: InputMaybe<TransitionUpdateOneWithoutRefundTransitionInput>;
  secondParty?: InputMaybe<UserUpdateOneWithoutTransitionsSecondPartyInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  status?: InputMaybe<TransitionStatusTypeUpdateOneRequiredWithoutTransitionsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEvent?: InputMaybe<TraineeEventUpdateOneWithoutTransitionsInput>;
  traineeEventGroup?: InputMaybe<TraineeEventGroupUpdateOneWithoutGroupTransactionsInput>;
  trainerEvent?: InputMaybe<TrainerEventUpdateOneWithoutTransitionsInput>;
  transitionPurpose?: InputMaybe<TransitionPurposeUpdateOneRequiredWithoutTransitionsInput>;
  transitionType?: InputMaybe<TransitionTypeUpdateOneRequiredWithoutTransitionsInput>;
};

export type TransitionUpdateWithoutFirstPartyInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneWithoutExpensesTransitionsInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mediator?: InputMaybe<UserUpdateOneWithoutTransactionsMediatorInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentWay?: InputMaybe<PaymentWayUpdateOneRequiredWithoutTransitionInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refundTransition?: InputMaybe<TransitionUpdateOneWithoutRefundedTransitionInput>;
  refundedTransition?: InputMaybe<TransitionUpdateOneWithoutRefundTransitionInput>;
  secondParty?: InputMaybe<UserUpdateOneWithoutTransitionsSecondPartyInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  status?: InputMaybe<TransitionStatusTypeUpdateOneRequiredWithoutTransitionsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEvent?: InputMaybe<TraineeEventUpdateOneWithoutTransitionsInput>;
  traineeEventGroup?: InputMaybe<TraineeEventGroupUpdateOneWithoutGroupTransactionsInput>;
  trainerEvent?: InputMaybe<TrainerEventUpdateOneWithoutTransitionsInput>;
  transitionPurpose?: InputMaybe<TransitionPurposeUpdateOneRequiredWithoutTransitionsInput>;
  transitionType?: InputMaybe<TransitionTypeUpdateOneRequiredWithoutTransitionsInput>;
};

export type TransitionUpdateWithoutMediatorInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneWithoutExpensesTransitionsInput>;
  firstParty?: InputMaybe<UserUpdateOneRequiredWithoutTransitionsFirstPartyInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentWay?: InputMaybe<PaymentWayUpdateOneRequiredWithoutTransitionInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refundTransition?: InputMaybe<TransitionUpdateOneWithoutRefundedTransitionInput>;
  refundedTransition?: InputMaybe<TransitionUpdateOneWithoutRefundTransitionInput>;
  secondParty?: InputMaybe<UserUpdateOneWithoutTransitionsSecondPartyInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  status?: InputMaybe<TransitionStatusTypeUpdateOneRequiredWithoutTransitionsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEvent?: InputMaybe<TraineeEventUpdateOneWithoutTransitionsInput>;
  traineeEventGroup?: InputMaybe<TraineeEventGroupUpdateOneWithoutGroupTransactionsInput>;
  trainerEvent?: InputMaybe<TrainerEventUpdateOneWithoutTransitionsInput>;
  transitionPurpose?: InputMaybe<TransitionPurposeUpdateOneRequiredWithoutTransitionsInput>;
  transitionType?: InputMaybe<TransitionTypeUpdateOneRequiredWithoutTransitionsInput>;
};

export type TransitionUpdateWithoutPaymentWayInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneWithoutExpensesTransitionsInput>;
  firstParty?: InputMaybe<UserUpdateOneRequiredWithoutTransitionsFirstPartyInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mediator?: InputMaybe<UserUpdateOneWithoutTransactionsMediatorInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refundTransition?: InputMaybe<TransitionUpdateOneWithoutRefundedTransitionInput>;
  refundedTransition?: InputMaybe<TransitionUpdateOneWithoutRefundTransitionInput>;
  secondParty?: InputMaybe<UserUpdateOneWithoutTransitionsSecondPartyInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  status?: InputMaybe<TransitionStatusTypeUpdateOneRequiredWithoutTransitionsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEvent?: InputMaybe<TraineeEventUpdateOneWithoutTransitionsInput>;
  traineeEventGroup?: InputMaybe<TraineeEventGroupUpdateOneWithoutGroupTransactionsInput>;
  trainerEvent?: InputMaybe<TrainerEventUpdateOneWithoutTransitionsInput>;
  transitionPurpose?: InputMaybe<TransitionPurposeUpdateOneRequiredWithoutTransitionsInput>;
  transitionType?: InputMaybe<TransitionTypeUpdateOneRequiredWithoutTransitionsInput>;
};

export type TransitionUpdateWithoutRefundTransitionInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneWithoutExpensesTransitionsInput>;
  firstParty?: InputMaybe<UserUpdateOneRequiredWithoutTransitionsFirstPartyInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mediator?: InputMaybe<UserUpdateOneWithoutTransactionsMediatorInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentWay?: InputMaybe<PaymentWayUpdateOneRequiredWithoutTransitionInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refundedTransition?: InputMaybe<TransitionUpdateOneWithoutRefundTransitionInput>;
  secondParty?: InputMaybe<UserUpdateOneWithoutTransitionsSecondPartyInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  status?: InputMaybe<TransitionStatusTypeUpdateOneRequiredWithoutTransitionsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEvent?: InputMaybe<TraineeEventUpdateOneWithoutTransitionsInput>;
  traineeEventGroup?: InputMaybe<TraineeEventGroupUpdateOneWithoutGroupTransactionsInput>;
  trainerEvent?: InputMaybe<TrainerEventUpdateOneWithoutTransitionsInput>;
  transitionPurpose?: InputMaybe<TransitionPurposeUpdateOneRequiredWithoutTransitionsInput>;
  transitionType?: InputMaybe<TransitionTypeUpdateOneRequiredWithoutTransitionsInput>;
};

export type TransitionUpdateWithoutRefundedTransitionInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneWithoutExpensesTransitionsInput>;
  firstParty?: InputMaybe<UserUpdateOneRequiredWithoutTransitionsFirstPartyInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mediator?: InputMaybe<UserUpdateOneWithoutTransactionsMediatorInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentWay?: InputMaybe<PaymentWayUpdateOneRequiredWithoutTransitionInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refundTransition?: InputMaybe<TransitionUpdateOneWithoutRefundedTransitionInput>;
  secondParty?: InputMaybe<UserUpdateOneWithoutTransitionsSecondPartyInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  status?: InputMaybe<TransitionStatusTypeUpdateOneRequiredWithoutTransitionsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEvent?: InputMaybe<TraineeEventUpdateOneWithoutTransitionsInput>;
  traineeEventGroup?: InputMaybe<TraineeEventGroupUpdateOneWithoutGroupTransactionsInput>;
  trainerEvent?: InputMaybe<TrainerEventUpdateOneWithoutTransitionsInput>;
  transitionPurpose?: InputMaybe<TransitionPurposeUpdateOneRequiredWithoutTransitionsInput>;
  transitionType?: InputMaybe<TransitionTypeUpdateOneRequiredWithoutTransitionsInput>;
};

export type TransitionUpdateWithoutSecondPartyInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneWithoutExpensesTransitionsInput>;
  firstParty?: InputMaybe<UserUpdateOneRequiredWithoutTransitionsFirstPartyInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mediator?: InputMaybe<UserUpdateOneWithoutTransactionsMediatorInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentWay?: InputMaybe<PaymentWayUpdateOneRequiredWithoutTransitionInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refundTransition?: InputMaybe<TransitionUpdateOneWithoutRefundedTransitionInput>;
  refundedTransition?: InputMaybe<TransitionUpdateOneWithoutRefundTransitionInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  status?: InputMaybe<TransitionStatusTypeUpdateOneRequiredWithoutTransitionsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEvent?: InputMaybe<TraineeEventUpdateOneWithoutTransitionsInput>;
  traineeEventGroup?: InputMaybe<TraineeEventGroupUpdateOneWithoutGroupTransactionsInput>;
  trainerEvent?: InputMaybe<TrainerEventUpdateOneWithoutTransitionsInput>;
  transitionPurpose?: InputMaybe<TransitionPurposeUpdateOneRequiredWithoutTransitionsInput>;
  transitionType?: InputMaybe<TransitionTypeUpdateOneRequiredWithoutTransitionsInput>;
};

export type TransitionUpdateWithoutStatusInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneWithoutExpensesTransitionsInput>;
  firstParty?: InputMaybe<UserUpdateOneRequiredWithoutTransitionsFirstPartyInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mediator?: InputMaybe<UserUpdateOneWithoutTransactionsMediatorInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentWay?: InputMaybe<PaymentWayUpdateOneRequiredWithoutTransitionInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refundTransition?: InputMaybe<TransitionUpdateOneWithoutRefundedTransitionInput>;
  refundedTransition?: InputMaybe<TransitionUpdateOneWithoutRefundTransitionInput>;
  secondParty?: InputMaybe<UserUpdateOneWithoutTransitionsSecondPartyInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEvent?: InputMaybe<TraineeEventUpdateOneWithoutTransitionsInput>;
  traineeEventGroup?: InputMaybe<TraineeEventGroupUpdateOneWithoutGroupTransactionsInput>;
  trainerEvent?: InputMaybe<TrainerEventUpdateOneWithoutTransitionsInput>;
  transitionPurpose?: InputMaybe<TransitionPurposeUpdateOneRequiredWithoutTransitionsInput>;
  transitionType?: InputMaybe<TransitionTypeUpdateOneRequiredWithoutTransitionsInput>;
};

export type TransitionUpdateWithoutTraineeEventGroupInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneWithoutExpensesTransitionsInput>;
  firstParty?: InputMaybe<UserUpdateOneRequiredWithoutTransitionsFirstPartyInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mediator?: InputMaybe<UserUpdateOneWithoutTransactionsMediatorInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentWay?: InputMaybe<PaymentWayUpdateOneRequiredWithoutTransitionInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refundTransition?: InputMaybe<TransitionUpdateOneWithoutRefundedTransitionInput>;
  refundedTransition?: InputMaybe<TransitionUpdateOneWithoutRefundTransitionInput>;
  secondParty?: InputMaybe<UserUpdateOneWithoutTransitionsSecondPartyInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  status?: InputMaybe<TransitionStatusTypeUpdateOneRequiredWithoutTransitionsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEvent?: InputMaybe<TraineeEventUpdateOneWithoutTransitionsInput>;
  trainerEvent?: InputMaybe<TrainerEventUpdateOneWithoutTransitionsInput>;
  transitionPurpose?: InputMaybe<TransitionPurposeUpdateOneRequiredWithoutTransitionsInput>;
  transitionType?: InputMaybe<TransitionTypeUpdateOneRequiredWithoutTransitionsInput>;
};

export type TransitionUpdateWithoutTraineeEventInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneWithoutExpensesTransitionsInput>;
  firstParty?: InputMaybe<UserUpdateOneRequiredWithoutTransitionsFirstPartyInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mediator?: InputMaybe<UserUpdateOneWithoutTransactionsMediatorInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentWay?: InputMaybe<PaymentWayUpdateOneRequiredWithoutTransitionInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refundTransition?: InputMaybe<TransitionUpdateOneWithoutRefundedTransitionInput>;
  refundedTransition?: InputMaybe<TransitionUpdateOneWithoutRefundTransitionInput>;
  secondParty?: InputMaybe<UserUpdateOneWithoutTransitionsSecondPartyInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  status?: InputMaybe<TransitionStatusTypeUpdateOneRequiredWithoutTransitionsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEventGroup?: InputMaybe<TraineeEventGroupUpdateOneWithoutGroupTransactionsInput>;
  trainerEvent?: InputMaybe<TrainerEventUpdateOneWithoutTransitionsInput>;
  transitionPurpose?: InputMaybe<TransitionPurposeUpdateOneRequiredWithoutTransitionsInput>;
  transitionType?: InputMaybe<TransitionTypeUpdateOneRequiredWithoutTransitionsInput>;
};

export type TransitionUpdateWithoutTrainerEventInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneWithoutExpensesTransitionsInput>;
  firstParty?: InputMaybe<UserUpdateOneRequiredWithoutTransitionsFirstPartyInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mediator?: InputMaybe<UserUpdateOneWithoutTransactionsMediatorInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentWay?: InputMaybe<PaymentWayUpdateOneRequiredWithoutTransitionInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refundTransition?: InputMaybe<TransitionUpdateOneWithoutRefundedTransitionInput>;
  refundedTransition?: InputMaybe<TransitionUpdateOneWithoutRefundTransitionInput>;
  secondParty?: InputMaybe<UserUpdateOneWithoutTransitionsSecondPartyInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  status?: InputMaybe<TransitionStatusTypeUpdateOneRequiredWithoutTransitionsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEvent?: InputMaybe<TraineeEventUpdateOneWithoutTransitionsInput>;
  traineeEventGroup?: InputMaybe<TraineeEventGroupUpdateOneWithoutGroupTransactionsInput>;
  transitionPurpose?: InputMaybe<TransitionPurposeUpdateOneRequiredWithoutTransitionsInput>;
  transitionType?: InputMaybe<TransitionTypeUpdateOneRequiredWithoutTransitionsInput>;
};

export type TransitionUpdateWithoutTransitionPurposeInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneWithoutExpensesTransitionsInput>;
  firstParty?: InputMaybe<UserUpdateOneRequiredWithoutTransitionsFirstPartyInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mediator?: InputMaybe<UserUpdateOneWithoutTransactionsMediatorInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentWay?: InputMaybe<PaymentWayUpdateOneRequiredWithoutTransitionInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refundTransition?: InputMaybe<TransitionUpdateOneWithoutRefundedTransitionInput>;
  refundedTransition?: InputMaybe<TransitionUpdateOneWithoutRefundTransitionInput>;
  secondParty?: InputMaybe<UserUpdateOneWithoutTransitionsSecondPartyInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  status?: InputMaybe<TransitionStatusTypeUpdateOneRequiredWithoutTransitionsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEvent?: InputMaybe<TraineeEventUpdateOneWithoutTransitionsInput>;
  traineeEventGroup?: InputMaybe<TraineeEventGroupUpdateOneWithoutGroupTransactionsInput>;
  trainerEvent?: InputMaybe<TrainerEventUpdateOneWithoutTransitionsInput>;
  transitionType?: InputMaybe<TransitionTypeUpdateOneRequiredWithoutTransitionsInput>;
};

export type TransitionUpdateWithoutTransitionTypeInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  event?: InputMaybe<EventUpdateOneWithoutExpensesTransitionsInput>;
  firstParty?: InputMaybe<UserUpdateOneRequiredWithoutTransitionsFirstPartyInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  fullAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  isHiddenFromUser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  mediator?: InputMaybe<UserUpdateOneWithoutTransactionsMediatorInput>;
  moyasarFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  moyasarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentWay?: InputMaybe<PaymentWayUpdateOneRequiredWithoutTransitionInput>;
  receiptUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refundTransition?: InputMaybe<TransitionUpdateOneWithoutRefundedTransitionInput>;
  refundedTransition?: InputMaybe<TransitionUpdateOneWithoutRefundTransitionInput>;
  secondParty?: InputMaybe<UserUpdateOneWithoutTransitionsSecondPartyInput>;
  secondPartyClosingBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  secondPartyOpeningBalance?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  status?: InputMaybe<TransitionStatusTypeUpdateOneRequiredWithoutTransitionsInput>;
  tax?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  traineeEvent?: InputMaybe<TraineeEventUpdateOneWithoutTransitionsInput>;
  traineeEventGroup?: InputMaybe<TraineeEventGroupUpdateOneWithoutGroupTransactionsInput>;
  trainerEvent?: InputMaybe<TrainerEventUpdateOneWithoutTransitionsInput>;
  transitionPurpose?: InputMaybe<TransitionPurposeUpdateOneRequiredWithoutTransitionsInput>;
};

export type TransitionUpsertWithWhereUniqueWithoutEventInput = {
  create: TransitionUncheckedCreateWithoutEventInput;
  update: TransitionUncheckedUpdateWithoutEventInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionUpsertWithWhereUniqueWithoutFirstPartyInput = {
  create: TransitionUncheckedCreateWithoutFirstPartyInput;
  update: TransitionUncheckedUpdateWithoutFirstPartyInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionUpsertWithWhereUniqueWithoutMediatorInput = {
  create: TransitionUncheckedCreateWithoutMediatorInput;
  update: TransitionUncheckedUpdateWithoutMediatorInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionUpsertWithWhereUniqueWithoutPaymentWayInput = {
  create: TransitionUncheckedCreateWithoutPaymentWayInput;
  update: TransitionUncheckedUpdateWithoutPaymentWayInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionUpsertWithWhereUniqueWithoutSecondPartyInput = {
  create: TransitionUncheckedCreateWithoutSecondPartyInput;
  update: TransitionUncheckedUpdateWithoutSecondPartyInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionUpsertWithWhereUniqueWithoutStatusInput = {
  create: TransitionUncheckedCreateWithoutStatusInput;
  update: TransitionUncheckedUpdateWithoutStatusInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionUpsertWithWhereUniqueWithoutTraineeEventGroupInput = {
  create: TransitionUncheckedCreateWithoutTraineeEventGroupInput;
  update: TransitionUncheckedUpdateWithoutTraineeEventGroupInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionUpsertWithWhereUniqueWithoutTraineeEventInput = {
  create: TransitionUncheckedCreateWithoutTraineeEventInput;
  update: TransitionUncheckedUpdateWithoutTraineeEventInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionUpsertWithWhereUniqueWithoutTrainerEventInput = {
  create: TransitionUncheckedCreateWithoutTrainerEventInput;
  update: TransitionUncheckedUpdateWithoutTrainerEventInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionUpsertWithWhereUniqueWithoutTransitionPurposeInput = {
  create: TransitionUncheckedCreateWithoutTransitionPurposeInput;
  update: TransitionUncheckedUpdateWithoutTransitionPurposeInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionUpsertWithWhereUniqueWithoutTransitionTypeInput = {
  create: TransitionUncheckedCreateWithoutTransitionTypeInput;
  update: TransitionUncheckedUpdateWithoutTransitionTypeInput;
  where: TransitionWhereUniqueInput;
};

export type TransitionUpsertWithoutRefundTransitionInput = {
  create: TransitionUncheckedCreateWithoutRefundTransitionInput;
  update: TransitionUncheckedUpdateWithoutRefundTransitionInput;
};

export type TransitionUpsertWithoutRefundedTransitionInput = {
  create: TransitionUncheckedCreateWithoutRefundedTransitionInput;
  update: TransitionUncheckedUpdateWithoutRefundedTransitionInput;
};

export type TransitionWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TransitionWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<TransitionWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TransitionWhereInput>>>;
  amount?: InputMaybe<DecimalFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  event?: InputMaybe<EventWhereInput>;
  eventId?: InputMaybe<IntNullableFilter>;
  firstParty?: InputMaybe<UserWhereInput>;
  firstPartyClosingBalance?: InputMaybe<DecimalFilter>;
  firstPartyOpeningBalance?: InputMaybe<DecimalFilter>;
  firstPartyUserId?: InputMaybe<IntFilter>;
  fullAmount?: InputMaybe<DecimalFilter>;
  id?: InputMaybe<IntFilter>;
  isHiddenFromUser?: InputMaybe<BoolFilter>;
  mediator?: InputMaybe<UserWhereInput>;
  mediatorId?: InputMaybe<IntNullableFilter>;
  moyasarFee?: InputMaybe<DecimalNullableFilter>;
  moyasarId?: InputMaybe<StringNullableFilter>;
  paymentWay?: InputMaybe<PaymentWayWhereInput>;
  paymentWayId?: InputMaybe<IntFilter>;
  receiptUrl?: InputMaybe<StringNullableFilter>;
  refundTransition?: InputMaybe<TransitionWhereInput>;
  refundedTransition?: InputMaybe<TransitionWhereInput>;
  secondParty?: InputMaybe<UserWhereInput>;
  secondPartyClosingBalance?: InputMaybe<DecimalNullableFilter>;
  secondPartyOpeningBalance?: InputMaybe<DecimalNullableFilter>;
  secondPartyUserId?: InputMaybe<IntNullableFilter>;
  status?: InputMaybe<TransitionStatusTypeWhereInput>;
  tax?: InputMaybe<DecimalFilter>;
  traineeEvent?: InputMaybe<TraineeEventWhereInput>;
  traineeEventGroup?: InputMaybe<TraineeEventGroupWhereInput>;
  traineeEventGroupId?: InputMaybe<IntNullableFilter>;
  traineeEventId?: InputMaybe<IntNullableFilter>;
  trainerEvent?: InputMaybe<TrainerEventWhereInput>;
  trainerEventId?: InputMaybe<IntNullableFilter>;
  transitionId?: InputMaybe<IntNullableFilter>;
  transitionPurpose?: InputMaybe<TransitionPurposeWhereInput>;
  transitionPurposeId?: InputMaybe<IntFilter>;
  transitionStatusTypeId?: InputMaybe<IntFilter>;
  transitionType?: InputMaybe<TransitionTypeWhereInput>;
  transitionTypeId?: InputMaybe<IntFilter>;
};

export type TransitionWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  moyasarId?: InputMaybe<Scalars['String']>;
  transitionId?: InputMaybe<Scalars['Int']>;
};

export type User = {
  __typename?: 'User';
  Certificate: Array<Certificate>;
  Notification: Array<Notification>;
  Qualification?: Maybe<Qualification>;
  _count: UserCountOutputType;
  accounts: Array<Account>;
  addedEvents: Array<Event>;
  adminNotes?: Maybe<Array<Scalars['String']>>;
  applications: Array<BecomeTrainerApplication>;
  balance: Scalars['Decimal'];
  bankAccount?: Maybe<BankAccount>;
  birthday?: Maybe<Scalars['DateTime']>;
  city?: Maybe<City>;
  cityId?: Maybe<Scalars['Int']>;
  commercialRecord?: Maybe<Scalars['String']>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['Int']>;
  coupons: Array<Coupon>;
  createdAt?: Maybe<Scalars['DateTime']>;
  cv?: Maybe<Scalars['String']>;
  cvId?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: Maybe<Scalars['DateTime']>;
  eventMediaTracking: Array<EventMediaTracking>;
  events: Array<Event>;
  fcmToken?: Maybe<Scalars['String']>;
  forgotCode?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  id: Scalars['Int'];
  identityNo?: Maybe<Scalars['BigInt']>;
  image?: Maybe<Scalars['String']>;
  invitedUsers: Array<User>;
  inviter?: Maybe<User>;
  inviterId?: Maybe<Scalars['Int']>;
  leaderEventGroups: Array<TraineeEventGroup>;
  linkedIn?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  marketerBalance: Scalars['Decimal'];
  memberNeeds: Array<MemberNeeds>;
  mobileNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nameAr?: Maybe<Scalars['String']>;
  nameOnCommercialRecord?: Maybe<Scalars['String']>;
  nationality?: Maybe<Country>;
  nationalityId?: Maybe<Scalars['Int']>;
  password?: Maybe<Scalars['String']>;
  profession?: Maybe<Profession>;
  professionId?: Maybe<Scalars['Int']>;
  qualificationId?: Maybe<Scalars['Int']>;
  remindMeEvents: Array<Event>;
  role: Role;
  roleId: Scalars['Int'];
  scfhs?: Maybe<Scalars['String']>;
  scfhsExp?: Maybe<Scalars['DateTime']>;
  sessions: Array<Session>;
  specialty?: Maybe<Specialty>;
  specialtyId?: Maybe<Scalars['Int']>;
  state?: Maybe<State>;
  stateId?: Maybe<Scalars['Int']>;
  traineeEventInvites: Array<TraineeEvent>;
  traineeEvents: Array<TraineeEvent>;
  trainerCv?: Maybe<Cv>;
  trainerEvents: Array<TrainerEvent>;
  trainereventDayTimeSlots: Array<TrainerEventDayTimeSlot>;
  transactionsMediator: Array<Transition>;
  transitionsFirstParty: Array<Transition>;
  transitionsSecondParty: Array<Transition>;
  twitter?: Maybe<Scalars['String']>;
  userEmailVerified?: Maybe<Scalars['Boolean']>;
  username?: Maybe<Scalars['String']>;
  verifyEmailCode?: Maybe<Scalars['String']>;
  zohoEmails: Array<ZohoEmail>;
};


export type UserCertificateArgs = {
  cursor?: InputMaybe<CertificateWhereUniqueInput>;
  distinct?: InputMaybe<CertificateScalarFieldEnum>;
  orderBy?: InputMaybe<CertificateOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CertificateWhereInput>;
};


export type UserNotificationArgs = {
  cursor?: InputMaybe<NotificationWhereUniqueInput>;
  distinct?: InputMaybe<NotificationScalarFieldEnum>;
  orderBy?: InputMaybe<NotificationOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NotificationWhereInput>;
};


export type UserAccountsArgs = {
  cursor?: InputMaybe<AccountWhereUniqueInput>;
  distinct?: InputMaybe<AccountScalarFieldEnum>;
  orderBy?: InputMaybe<AccountOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccountWhereInput>;
};


export type UserAddedEventsArgs = {
  cursor?: InputMaybe<EventWhereUniqueInput>;
  distinct?: InputMaybe<EventScalarFieldEnum>;
  orderBy?: InputMaybe<EventOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EventWhereInput>;
};


export type UserApplicationsArgs = {
  cursor?: InputMaybe<BecomeTrainerApplicationWhereUniqueInput>;
  distinct?: InputMaybe<BecomeTrainerApplicationScalarFieldEnum>;
  orderBy?: InputMaybe<BecomeTrainerApplicationOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BecomeTrainerApplicationWhereInput>;
};


export type UserCouponsArgs = {
  cursor?: InputMaybe<CouponWhereUniqueInput>;
  distinct?: InputMaybe<CouponScalarFieldEnum>;
  orderBy?: InputMaybe<CouponOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CouponWhereInput>;
};


export type UserEventsArgs = {
  cursor?: InputMaybe<EventWhereUniqueInput>;
  distinct?: InputMaybe<EventScalarFieldEnum>;
  orderBy?: InputMaybe<EventOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EventWhereInput>;
};


export type UserInvitedUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<UserScalarFieldEnum>;
  orderBy?: InputMaybe<UserOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};


export type UserLeaderEventGroupsArgs = {
  cursor?: InputMaybe<TraineeEventGroupWhereUniqueInput>;
  distinct?: InputMaybe<TraineeEventGroupScalarFieldEnum>;
  orderBy?: InputMaybe<TraineeEventGroupOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeEventGroupWhereInput>;
};


export type UserMemberNeedsArgs = {
  cursor?: InputMaybe<MemberNeedsWhereUniqueInput>;
  distinct?: InputMaybe<MemberNeedsScalarFieldEnum>;
  orderBy?: InputMaybe<MemberNeedsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MemberNeedsWhereInput>;
};


export type UserRemindMeEventsArgs = {
  cursor?: InputMaybe<EventWhereUniqueInput>;
  distinct?: InputMaybe<EventScalarFieldEnum>;
  orderBy?: InputMaybe<EventOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EventWhereInput>;
};


export type UserSessionsArgs = {
  cursor?: InputMaybe<SessionWhereUniqueInput>;
  distinct?: InputMaybe<SessionScalarFieldEnum>;
  orderBy?: InputMaybe<SessionOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SessionWhereInput>;
};


export type UserTraineeEventInvitesArgs = {
  cursor?: InputMaybe<TraineeEventWhereUniqueInput>;
  distinct?: InputMaybe<TraineeEventScalarFieldEnum>;
  orderBy?: InputMaybe<TraineeEventOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeEventWhereInput>;
};


export type UserTraineeEventsArgs = {
  cursor?: InputMaybe<TraineeEventWhereUniqueInput>;
  distinct?: InputMaybe<TraineeEventScalarFieldEnum>;
  orderBy?: InputMaybe<TraineeEventOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TraineeEventWhereInput>;
};


export type UserTrainerEventsArgs = {
  cursor?: InputMaybe<TrainerEventWhereUniqueInput>;
  distinct?: InputMaybe<TrainerEventScalarFieldEnum>;
  orderBy?: InputMaybe<TrainerEventOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TrainerEventWhereInput>;
};


export type UserTrainereventDayTimeSlotsArgs = {
  cursor?: InputMaybe<TrainerEventDayTimeSlotWhereUniqueInput>;
  distinct?: InputMaybe<TrainerEventDayTimeSlotScalarFieldEnum>;
  orderBy?: InputMaybe<TrainerEventDayTimeSlotOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TrainerEventDayTimeSlotWhereInput>;
};


export type UserTransactionsMediatorArgs = {
  cursor?: InputMaybe<TransitionWhereUniqueInput>;
  distinct?: InputMaybe<TransitionScalarFieldEnum>;
  orderBy?: InputMaybe<TransitionOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TransitionWhereInput>;
};


export type UserTransitionsFirstPartyArgs = {
  cursor?: InputMaybe<TransitionWhereUniqueInput>;
  distinct?: InputMaybe<TransitionScalarFieldEnum>;
  orderBy?: InputMaybe<TransitionOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TransitionWhereInput>;
};


export type UserTransitionsSecondPartyArgs = {
  cursor?: InputMaybe<TransitionWhereUniqueInput>;
  distinct?: InputMaybe<TransitionScalarFieldEnum>;
  orderBy?: InputMaybe<TransitionOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TransitionWhereInput>;
};


export type UserZohoEmailsArgs = {
  cursor?: InputMaybe<ZohoEmailWhereUniqueInput>;
  distinct?: InputMaybe<ZohoEmailScalarFieldEnum>;
  orderBy?: InputMaybe<ZohoEmailOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ZohoEmailWhereInput>;
};

export type UserAvgAggregateOutputType = {
  __typename?: 'UserAvgAggregateOutputType';
  balance?: Maybe<Scalars['Decimal']>;
  cityId?: Maybe<Scalars['Float']>;
  countryId?: Maybe<Scalars['Float']>;
  cvId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  identityNo?: Maybe<Scalars['Float']>;
  inviterId?: Maybe<Scalars['Float']>;
  marketerBalance?: Maybe<Scalars['Decimal']>;
  nationalityId?: Maybe<Scalars['Float']>;
  professionId?: Maybe<Scalars['Float']>;
  qualificationId?: Maybe<Scalars['Float']>;
  roleId?: Maybe<Scalars['Float']>;
  specialtyId?: Maybe<Scalars['Float']>;
  stateId?: Maybe<Scalars['Float']>;
};

export type UserAvgOrderByAggregateInput = {
  balance?: InputMaybe<SortOrder>;
  cityId?: InputMaybe<SortOrder>;
  countryId?: InputMaybe<SortOrder>;
  cvId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identityNo?: InputMaybe<SortOrder>;
  inviterId?: InputMaybe<SortOrder>;
  marketerBalance?: InputMaybe<SortOrder>;
  nationalityId?: InputMaybe<SortOrder>;
  professionId?: InputMaybe<SortOrder>;
  qualificationId?: InputMaybe<SortOrder>;
  roleId?: InputMaybe<SortOrder>;
  specialtyId?: InputMaybe<SortOrder>;
  stateId?: InputMaybe<SortOrder>;
};

export type UserCountAggregateOutputType = {
  __typename?: 'UserCountAggregateOutputType';
  _all: Scalars['Int'];
  adminNotes: Scalars['Int'];
  balance: Scalars['Int'];
  birthday: Scalars['Int'];
  cityId: Scalars['Int'];
  commercialRecord: Scalars['Int'];
  countryId: Scalars['Int'];
  createdAt: Scalars['Int'];
  cv: Scalars['Int'];
  cvId: Scalars['Int'];
  deletedAt: Scalars['Int'];
  email: Scalars['Int'];
  emailVerified: Scalars['Int'];
  fcmToken: Scalars['Int'];
  forgotCode: Scalars['Int'];
  gender: Scalars['Int'];
  id: Scalars['Int'];
  identityNo: Scalars['Int'];
  image: Scalars['Int'];
  inviterId: Scalars['Int'];
  lastLogin: Scalars['Int'];
  linkedIn: Scalars['Int'];
  logoUrl: Scalars['Int'];
  marketerBalance: Scalars['Int'];
  mobileNumber: Scalars['Int'];
  name: Scalars['Int'];
  nameAr: Scalars['Int'];
  nameOnCommercialRecord: Scalars['Int'];
  nationalityId: Scalars['Int'];
  password: Scalars['Int'];
  professionId: Scalars['Int'];
  qualificationId: Scalars['Int'];
  roleId: Scalars['Int'];
  scfhs: Scalars['Int'];
  scfhsExp: Scalars['Int'];
  specialtyId: Scalars['Int'];
  stateId: Scalars['Int'];
  twitter: Scalars['Int'];
  userEmailVerified: Scalars['Int'];
  username: Scalars['Int'];
  verifyEmailCode: Scalars['Int'];
};

export type UserCountOrderByAggregateInput = {
  adminNotes?: InputMaybe<SortOrder>;
  balance?: InputMaybe<SortOrder>;
  birthday?: InputMaybe<SortOrder>;
  cityId?: InputMaybe<SortOrder>;
  commercialRecord?: InputMaybe<SortOrder>;
  countryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  cv?: InputMaybe<SortOrder>;
  cvId?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  emailVerified?: InputMaybe<SortOrder>;
  fcmToken?: InputMaybe<SortOrder>;
  forgotCode?: InputMaybe<SortOrder>;
  gender?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identityNo?: InputMaybe<SortOrder>;
  image?: InputMaybe<SortOrder>;
  inviterId?: InputMaybe<SortOrder>;
  lastLogin?: InputMaybe<SortOrder>;
  linkedIn?: InputMaybe<SortOrder>;
  logoUrl?: InputMaybe<SortOrder>;
  marketerBalance?: InputMaybe<SortOrder>;
  mobileNumber?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nameAr?: InputMaybe<SortOrder>;
  nameOnCommercialRecord?: InputMaybe<SortOrder>;
  nationalityId?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  professionId?: InputMaybe<SortOrder>;
  qualificationId?: InputMaybe<SortOrder>;
  roleId?: InputMaybe<SortOrder>;
  scfhs?: InputMaybe<SortOrder>;
  scfhsExp?: InputMaybe<SortOrder>;
  specialtyId?: InputMaybe<SortOrder>;
  stateId?: InputMaybe<SortOrder>;
  twitter?: InputMaybe<SortOrder>;
  userEmailVerified?: InputMaybe<SortOrder>;
  username?: InputMaybe<SortOrder>;
  verifyEmailCode?: InputMaybe<SortOrder>;
};

export type UserCountOutputType = {
  __typename?: 'UserCountOutputType';
  Blogs: Scalars['Int'];
  Certificate: Scalars['Int'];
  Discussion: Scalars['Int'];
  Notification: Scalars['Int'];
  QuizResult: Scalars['Int'];
  ZohoEmail: Scalars['Int'];
  accounts: Scalars['Int'];
  addedEvents: Scalars['Int'];
  applications: Scalars['Int'];
  coupons: Scalars['Int'];
  eventMediaTracking: Scalars['Int'];
  events: Scalars['Int'];
  invitedUsers: Scalars['Int'];
  inviterCouponProfits: Scalars['Int'];
  leaderEventGroups: Scalars['Int'];
  memberNeeds: Scalars['Int'];
  remindMeEvents: Scalars['Int'];
  sessions: Scalars['Int'];
  traineeEventInvites: Scalars['Int'];
  traineeEvents: Scalars['Int'];
  trainerEvents: Scalars['Int'];
  trainereventDayTimeSlots: Scalars['Int'];
  transactionsMediator: Scalars['Int'];
  transitionsFirstParty: Scalars['Int'];
  transitionsSecondParty: Scalars['Int'];
  userCouponProfits: Scalars['Int'];
  visitedEvents: Scalars['Int'];
};

export type UserCreateInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateManyCityInput = {
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  balance?: InputMaybe<Scalars['Decimal']>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  twitter?: InputMaybe<Scalars['String']>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
};

export type UserCreateManyCityInputEnvelope = {
  data: UserCreateManyCityInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type UserCreateManyCountryInput = {
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  balance?: InputMaybe<Scalars['Decimal']>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  twitter?: InputMaybe<Scalars['String']>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
};

export type UserCreateManyCountryInputEnvelope = {
  data: UserCreateManyCountryInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type UserCreateManyInput = {
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  balance?: InputMaybe<Scalars['Decimal']>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  twitter?: InputMaybe<Scalars['String']>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
};

export type UserCreateManyInviterInput = {
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  balance?: InputMaybe<Scalars['Decimal']>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  twitter?: InputMaybe<Scalars['String']>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
};

export type UserCreateManyInviterInputEnvelope = {
  data: UserCreateManyInviterInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type UserCreateManyNationalityInput = {
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  balance?: InputMaybe<Scalars['Decimal']>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  twitter?: InputMaybe<Scalars['String']>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
};

export type UserCreateManyNationalityInputEnvelope = {
  data: UserCreateManyNationalityInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type UserCreateManyProfessionInput = {
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  balance?: InputMaybe<Scalars['Decimal']>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  twitter?: InputMaybe<Scalars['String']>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
};

export type UserCreateManyProfessionInputEnvelope = {
  data: UserCreateManyProfessionInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type UserCreateManyQualificationInput = {
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  balance?: InputMaybe<Scalars['Decimal']>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  twitter?: InputMaybe<Scalars['String']>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
};

export type UserCreateManyQualificationInputEnvelope = {
  data: UserCreateManyQualificationInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type UserCreateManyRoleInput = {
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  balance?: InputMaybe<Scalars['Decimal']>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  twitter?: InputMaybe<Scalars['String']>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
};

export type UserCreateManyRoleInputEnvelope = {
  data: UserCreateManyRoleInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type UserCreateManySpecialtyInput = {
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  balance?: InputMaybe<Scalars['Decimal']>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  stateId?: InputMaybe<Scalars['Int']>;
  twitter?: InputMaybe<Scalars['String']>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
};

export type UserCreateManySpecialtyInputEnvelope = {
  data: UserCreateManySpecialtyInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type UserCreateManyStateInput = {
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  balance?: InputMaybe<Scalars['Decimal']>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  twitter?: InputMaybe<Scalars['String']>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
};

export type UserCreateManyStateInputEnvelope = {
  data: UserCreateManyStateInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type UserCreateNestedManyWithoutCityInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutCityInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutCityInput>>>;
  createMany?: InputMaybe<UserCreateManyCityInputEnvelope>;
};

export type UserCreateNestedManyWithoutCountryInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutCountryInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutCountryInput>>>;
  createMany?: InputMaybe<UserCreateManyCountryInputEnvelope>;
};

export type UserCreateNestedManyWithoutInviterInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutInviterInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutInviterInput>>>;
  createMany?: InputMaybe<UserCreateManyInviterInputEnvelope>;
};

export type UserCreateNestedManyWithoutNationalityInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutNationalityInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutNationalityInput>>>;
  createMany?: InputMaybe<UserCreateManyNationalityInputEnvelope>;
};

export type UserCreateNestedManyWithoutProfessionInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutProfessionInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutProfessionInput>>>;
  createMany?: InputMaybe<UserCreateManyProfessionInputEnvelope>;
};

export type UserCreateNestedManyWithoutQualificationInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutQualificationInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutQualificationInput>>>;
  createMany?: InputMaybe<UserCreateManyQualificationInputEnvelope>;
};

export type UserCreateNestedManyWithoutRemindMeEventsInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutRemindMeEventsInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutRemindMeEventsInput>>>;
};

export type UserCreateNestedManyWithoutRoleInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutRoleInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutRoleInput>>>;
  createMany?: InputMaybe<UserCreateManyRoleInputEnvelope>;
};

export type UserCreateNestedManyWithoutSpecialtyInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutSpecialtyInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutSpecialtyInput>>>;
  createMany?: InputMaybe<UserCreateManySpecialtyInputEnvelope>;
};

export type UserCreateNestedManyWithoutStateInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutStateInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutStateInput>>>;
  createMany?: InputMaybe<UserCreateManyStateInputEnvelope>;
};

export type UserCreateNestedManyWithoutVisitedEventsInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutVisitedEventsInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutVisitedEventsInput>>>;
};

export type UserCreateNestedOneWithoutAccountsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutAccountsInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutAccountsInput>;
};

export type UserCreateNestedOneWithoutAddedEventsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutAddedEventsInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutAddedEventsInput>;
};

export type UserCreateNestedOneWithoutApplicationsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutApplicationsInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutApplicationsInput>;
};

export type UserCreateNestedOneWithoutBankAccountInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutBankAccountInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutBankAccountInput>;
};

export type UserCreateNestedOneWithoutBlogsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutBlogsInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutBlogsInput>;
};

export type UserCreateNestedOneWithoutCertificateInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCertificateInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutCertificateInput>;
};

export type UserCreateNestedOneWithoutCouponsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCouponsInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutCouponsInput>;
};

export type UserCreateNestedOneWithoutDiscussionInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutDiscussionInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutDiscussionInput>;
};

export type UserCreateNestedOneWithoutEventMediaTrackingInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutEventMediaTrackingInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutEventMediaTrackingInput>;
};

export type UserCreateNestedOneWithoutEventsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutEventsInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutEventsInput>;
};

export type UserCreateNestedOneWithoutInvitedUsersInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutInvitedUsersInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutInvitedUsersInput>;
};

export type UserCreateNestedOneWithoutInviterCouponProfitsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutInviterCouponProfitsInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutInviterCouponProfitsInput>;
};

export type UserCreateNestedOneWithoutLeaderEventGroupsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutLeaderEventGroupsInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutLeaderEventGroupsInput>;
};

export type UserCreateNestedOneWithoutMemberNeedsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutMemberNeedsInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutMemberNeedsInput>;
};

export type UserCreateNestedOneWithoutNotificationInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutNotificationInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutNotificationInput>;
};

export type UserCreateNestedOneWithoutQuizResultInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutQuizResultInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutQuizResultInput>;
};

export type UserCreateNestedOneWithoutSessionsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutSessionsInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutSessionsInput>;
};

export type UserCreateNestedOneWithoutTraineeEventInvitesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutTraineeEventInvitesInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutTraineeEventInvitesInput>;
};

export type UserCreateNestedOneWithoutTraineeEventsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutTraineeEventsInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutTraineeEventsInput>;
};

export type UserCreateNestedOneWithoutTrainerCvInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutTrainerCvInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutTrainerCvInput>;
};

export type UserCreateNestedOneWithoutTrainerEventsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutTrainerEventsInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutTrainerEventsInput>;
};

export type UserCreateNestedOneWithoutTrainereventDayTimeSlotsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutTrainereventDayTimeSlotsInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutTrainereventDayTimeSlotsInput>;
};

export type UserCreateNestedOneWithoutTransactionsMediatorInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutTransactionsMediatorInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutTransactionsMediatorInput>;
};

export type UserCreateNestedOneWithoutTransitionsFirstPartyInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutTransitionsFirstPartyInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutTransitionsFirstPartyInput>;
};

export type UserCreateNestedOneWithoutTransitionsSecondPartyInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutTransitionsSecondPartyInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutTransitionsSecondPartyInput>;
};

export type UserCreateNestedOneWithoutUserCouponProfitsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutUserCouponProfitsInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutUserCouponProfitsInput>;
};

export type UserCreateNestedOneWithoutZohoEmailInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutZohoEmailInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutZohoEmailInput>;
};

export type UserCreateOrConnectWithoutAccountsInput = {
  create: UserUncheckedCreateWithoutAccountsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutAddedEventsInput = {
  create: UserUncheckedCreateWithoutAddedEventsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutApplicationsInput = {
  create: UserUncheckedCreateWithoutApplicationsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutBankAccountInput = {
  create: UserUncheckedCreateWithoutBankAccountInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutBlogsInput = {
  create: UserUncheckedCreateWithoutBlogsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCertificateInput = {
  create: UserUncheckedCreateWithoutCertificateInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCityInput = {
  create: UserUncheckedCreateWithoutCityInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCountryInput = {
  create: UserUncheckedCreateWithoutCountryInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCouponsInput = {
  create: UserUncheckedCreateWithoutCouponsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutDiscussionInput = {
  create: UserUncheckedCreateWithoutDiscussionInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutEventMediaTrackingInput = {
  create: UserUncheckedCreateWithoutEventMediaTrackingInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutEventsInput = {
  create: UserUncheckedCreateWithoutEventsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutInvitedUsersInput = {
  create: UserUncheckedCreateWithoutInvitedUsersInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutInviterCouponProfitsInput = {
  create: UserUncheckedCreateWithoutInviterCouponProfitsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutInviterInput = {
  create: UserUncheckedCreateWithoutInviterInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutLeaderEventGroupsInput = {
  create: UserUncheckedCreateWithoutLeaderEventGroupsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutMemberNeedsInput = {
  create: UserUncheckedCreateWithoutMemberNeedsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutNationalityInput = {
  create: UserUncheckedCreateWithoutNationalityInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutNotificationInput = {
  create: UserUncheckedCreateWithoutNotificationInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutProfessionInput = {
  create: UserUncheckedCreateWithoutProfessionInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutQualificationInput = {
  create: UserUncheckedCreateWithoutQualificationInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutQuizResultInput = {
  create: UserUncheckedCreateWithoutQuizResultInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutRemindMeEventsInput = {
  create: UserUncheckedCreateWithoutRemindMeEventsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutRoleInput = {
  create: UserUncheckedCreateWithoutRoleInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutSessionsInput = {
  create: UserUncheckedCreateWithoutSessionsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutSpecialtyInput = {
  create: UserUncheckedCreateWithoutSpecialtyInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutStateInput = {
  create: UserUncheckedCreateWithoutStateInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutTraineeEventInvitesInput = {
  create: UserUncheckedCreateWithoutTraineeEventInvitesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutTraineeEventsInput = {
  create: UserUncheckedCreateWithoutTraineeEventsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutTrainerCvInput = {
  create: UserUncheckedCreateWithoutTrainerCvInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutTrainerEventsInput = {
  create: UserUncheckedCreateWithoutTrainerEventsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutTrainereventDayTimeSlotsInput = {
  create: UserUncheckedCreateWithoutTrainereventDayTimeSlotsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutTransactionsMediatorInput = {
  create: UserUncheckedCreateWithoutTransactionsMediatorInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutTransitionsFirstPartyInput = {
  create: UserUncheckedCreateWithoutTransitionsFirstPartyInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutTransitionsSecondPartyInput = {
  create: UserUncheckedCreateWithoutTransitionsSecondPartyInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutUserCouponProfitsInput = {
  create: UserUncheckedCreateWithoutUserCouponProfitsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutVisitedEventsInput = {
  create: UserUncheckedCreateWithoutVisitedEventsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutZohoEmailInput = {
  create: UserUncheckedCreateWithoutZohoEmailInput;
  where: UserWhereUniqueInput;
};

export type UserCreateWithoutAccountsInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutAddedEventsInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutApplicationsInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutBankAccountInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutBlogsInput = {
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutCertificateInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutCityInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutCountryInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutCouponsInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutDiscussionInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutEventMediaTrackingInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutEventsInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutInvitedUsersInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutInviterCouponProfitsInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutInviterInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutLeaderEventGroupsInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutMemberNeedsInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutNationalityInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutNotificationInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutProfessionInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutQualificationInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutQuizResultInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutRemindMeEventsInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutRoleInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutSessionsInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutSpecialtyInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutStateInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutTraineeEventInvitesInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutTraineeEventsInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutTrainerCvInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutTrainerEventsInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutTrainereventDayTimeSlotsInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutTransactionsMediatorInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutTransitionsFirstPartyInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutTransitionsSecondPartyInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutUserCouponProfitsInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateWithoutVisitedEventsInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
};

export type UserCreateWithoutZohoEmailInput = {
  Blogs?: InputMaybe<BlogsCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationCreateNestedOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  city?: InputMaybe<CityCreateNestedOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserCreateNestedManyWithoutInviterInput>;
  inviter?: InputMaybe<UserCreateNestedOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<CountryCreateNestedOneWithoutUsersNationalityInput>;
  password?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<ProfessionCreateNestedOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventCreateNestedManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleCreateNestedOneWithoutUsersInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyCreateNestedOneWithoutUsersInput>;
  state?: InputMaybe<StateCreateNestedOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventCreateNestedManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvCreateNestedOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserCreateadminNotesInput = {
  set: Scalars['String'];
};

export type UserListRelationFilter = {
  every?: InputMaybe<UserWhereInput>;
  none?: InputMaybe<UserWhereInput>;
  some?: InputMaybe<UserWhereInput>;
};

export type UserMaxAggregateOutputType = {
  __typename?: 'UserMaxAggregateOutputType';
  balance?: Maybe<Scalars['Decimal']>;
  birthday?: Maybe<Scalars['DateTime']>;
  cityId?: Maybe<Scalars['Int']>;
  commercialRecord?: Maybe<Scalars['String']>;
  countryId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  cv?: Maybe<Scalars['String']>;
  cvId?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  emailVerified?: Maybe<Scalars['DateTime']>;
  fcmToken?: Maybe<Scalars['String']>;
  forgotCode?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  id?: Maybe<Scalars['Int']>;
  identityNo?: Maybe<Scalars['BigInt']>;
  image?: Maybe<Scalars['String']>;
  inviterId?: Maybe<Scalars['Int']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  linkedIn?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  marketerBalance?: Maybe<Scalars['Decimal']>;
  mobileNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nameAr?: Maybe<Scalars['String']>;
  nameOnCommercialRecord?: Maybe<Scalars['String']>;
  nationalityId?: Maybe<Scalars['Int']>;
  password?: Maybe<Scalars['String']>;
  professionId?: Maybe<Scalars['Int']>;
  qualificationId?: Maybe<Scalars['Int']>;
  roleId?: Maybe<Scalars['Int']>;
  scfhs?: Maybe<Scalars['String']>;
  scfhsExp?: Maybe<Scalars['DateTime']>;
  specialtyId?: Maybe<Scalars['Int']>;
  stateId?: Maybe<Scalars['Int']>;
  twitter?: Maybe<Scalars['String']>;
  userEmailVerified?: Maybe<Scalars['Boolean']>;
  username?: Maybe<Scalars['String']>;
  verifyEmailCode?: Maybe<Scalars['String']>;
};

export type UserMaxOrderByAggregateInput = {
  balance?: InputMaybe<SortOrder>;
  birthday?: InputMaybe<SortOrder>;
  cityId?: InputMaybe<SortOrder>;
  commercialRecord?: InputMaybe<SortOrder>;
  countryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  cv?: InputMaybe<SortOrder>;
  cvId?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  emailVerified?: InputMaybe<SortOrder>;
  fcmToken?: InputMaybe<SortOrder>;
  forgotCode?: InputMaybe<SortOrder>;
  gender?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identityNo?: InputMaybe<SortOrder>;
  image?: InputMaybe<SortOrder>;
  inviterId?: InputMaybe<SortOrder>;
  lastLogin?: InputMaybe<SortOrder>;
  linkedIn?: InputMaybe<SortOrder>;
  logoUrl?: InputMaybe<SortOrder>;
  marketerBalance?: InputMaybe<SortOrder>;
  mobileNumber?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nameAr?: InputMaybe<SortOrder>;
  nameOnCommercialRecord?: InputMaybe<SortOrder>;
  nationalityId?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  professionId?: InputMaybe<SortOrder>;
  qualificationId?: InputMaybe<SortOrder>;
  roleId?: InputMaybe<SortOrder>;
  scfhs?: InputMaybe<SortOrder>;
  scfhsExp?: InputMaybe<SortOrder>;
  specialtyId?: InputMaybe<SortOrder>;
  stateId?: InputMaybe<SortOrder>;
  twitter?: InputMaybe<SortOrder>;
  userEmailVerified?: InputMaybe<SortOrder>;
  username?: InputMaybe<SortOrder>;
  verifyEmailCode?: InputMaybe<SortOrder>;
};

export type UserMinAggregateOutputType = {
  __typename?: 'UserMinAggregateOutputType';
  balance?: Maybe<Scalars['Decimal']>;
  birthday?: Maybe<Scalars['DateTime']>;
  cityId?: Maybe<Scalars['Int']>;
  commercialRecord?: Maybe<Scalars['String']>;
  countryId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  cv?: Maybe<Scalars['String']>;
  cvId?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  emailVerified?: Maybe<Scalars['DateTime']>;
  fcmToken?: Maybe<Scalars['String']>;
  forgotCode?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  id?: Maybe<Scalars['Int']>;
  identityNo?: Maybe<Scalars['BigInt']>;
  image?: Maybe<Scalars['String']>;
  inviterId?: Maybe<Scalars['Int']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  linkedIn?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  marketerBalance?: Maybe<Scalars['Decimal']>;
  mobileNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nameAr?: Maybe<Scalars['String']>;
  nameOnCommercialRecord?: Maybe<Scalars['String']>;
  nationalityId?: Maybe<Scalars['Int']>;
  password?: Maybe<Scalars['String']>;
  professionId?: Maybe<Scalars['Int']>;
  qualificationId?: Maybe<Scalars['Int']>;
  roleId?: Maybe<Scalars['Int']>;
  scfhs?: Maybe<Scalars['String']>;
  scfhsExp?: Maybe<Scalars['DateTime']>;
  specialtyId?: Maybe<Scalars['Int']>;
  stateId?: Maybe<Scalars['Int']>;
  twitter?: Maybe<Scalars['String']>;
  userEmailVerified?: Maybe<Scalars['Boolean']>;
  username?: Maybe<Scalars['String']>;
  verifyEmailCode?: Maybe<Scalars['String']>;
};

export type UserMinOrderByAggregateInput = {
  balance?: InputMaybe<SortOrder>;
  birthday?: InputMaybe<SortOrder>;
  cityId?: InputMaybe<SortOrder>;
  commercialRecord?: InputMaybe<SortOrder>;
  countryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  cv?: InputMaybe<SortOrder>;
  cvId?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  emailVerified?: InputMaybe<SortOrder>;
  fcmToken?: InputMaybe<SortOrder>;
  forgotCode?: InputMaybe<SortOrder>;
  gender?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identityNo?: InputMaybe<SortOrder>;
  image?: InputMaybe<SortOrder>;
  inviterId?: InputMaybe<SortOrder>;
  lastLogin?: InputMaybe<SortOrder>;
  linkedIn?: InputMaybe<SortOrder>;
  logoUrl?: InputMaybe<SortOrder>;
  marketerBalance?: InputMaybe<SortOrder>;
  mobileNumber?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nameAr?: InputMaybe<SortOrder>;
  nameOnCommercialRecord?: InputMaybe<SortOrder>;
  nationalityId?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  professionId?: InputMaybe<SortOrder>;
  qualificationId?: InputMaybe<SortOrder>;
  roleId?: InputMaybe<SortOrder>;
  scfhs?: InputMaybe<SortOrder>;
  scfhsExp?: InputMaybe<SortOrder>;
  specialtyId?: InputMaybe<SortOrder>;
  stateId?: InputMaybe<SortOrder>;
  twitter?: InputMaybe<SortOrder>;
  userEmailVerified?: InputMaybe<SortOrder>;
  username?: InputMaybe<SortOrder>;
  verifyEmailCode?: InputMaybe<SortOrder>;
};

export type UserOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserOrderByWithAggregationInput = {
  _avg?: InputMaybe<UserAvgOrderByAggregateInput>;
  _count?: InputMaybe<UserCountOrderByAggregateInput>;
  _max?: InputMaybe<UserMaxOrderByAggregateInput>;
  _min?: InputMaybe<UserMinOrderByAggregateInput>;
  _sum?: InputMaybe<UserSumOrderByAggregateInput>;
  adminNotes?: InputMaybe<SortOrder>;
  balance?: InputMaybe<SortOrder>;
  birthday?: InputMaybe<SortOrder>;
  cityId?: InputMaybe<SortOrder>;
  commercialRecord?: InputMaybe<SortOrder>;
  countryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  cv?: InputMaybe<SortOrder>;
  cvId?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  emailVerified?: InputMaybe<SortOrder>;
  fcmToken?: InputMaybe<SortOrder>;
  forgotCode?: InputMaybe<SortOrder>;
  gender?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identityNo?: InputMaybe<SortOrder>;
  image?: InputMaybe<SortOrder>;
  inviterId?: InputMaybe<SortOrder>;
  lastLogin?: InputMaybe<SortOrder>;
  linkedIn?: InputMaybe<SortOrder>;
  logoUrl?: InputMaybe<SortOrder>;
  marketerBalance?: InputMaybe<SortOrder>;
  mobileNumber?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nameAr?: InputMaybe<SortOrder>;
  nameOnCommercialRecord?: InputMaybe<SortOrder>;
  nationalityId?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  professionId?: InputMaybe<SortOrder>;
  qualificationId?: InputMaybe<SortOrder>;
  roleId?: InputMaybe<SortOrder>;
  scfhs?: InputMaybe<SortOrder>;
  scfhsExp?: InputMaybe<SortOrder>;
  specialtyId?: InputMaybe<SortOrder>;
  stateId?: InputMaybe<SortOrder>;
  twitter?: InputMaybe<SortOrder>;
  userEmailVerified?: InputMaybe<SortOrder>;
  username?: InputMaybe<SortOrder>;
  verifyEmailCode?: InputMaybe<SortOrder>;
};

export type UserOrderByWithRelationInput = {
  Blogs?: InputMaybe<BlogsOrderByRelationAggregateInput>;
  Certificate?: InputMaybe<CertificateOrderByRelationAggregateInput>;
  Discussion?: InputMaybe<DiscussionOrderByRelationAggregateInput>;
  Notification?: InputMaybe<NotificationOrderByRelationAggregateInput>;
  Qualification?: InputMaybe<QualificationOrderByWithRelationInput>;
  QuizResult?: InputMaybe<QuizResultOrderByRelationAggregateInput>;
  ZohoEmail?: InputMaybe<ZohoEmailOrderByRelationAggregateInput>;
  accounts?: InputMaybe<AccountOrderByRelationAggregateInput>;
  addedEvents?: InputMaybe<EventOrderByRelationAggregateInput>;
  adminNotes?: InputMaybe<SortOrder>;
  applications?: InputMaybe<BecomeTrainerApplicationOrderByRelationAggregateInput>;
  balance?: InputMaybe<SortOrder>;
  bankAccount?: InputMaybe<BankAccountOrderByWithRelationInput>;
  birthday?: InputMaybe<SortOrder>;
  city?: InputMaybe<CityOrderByWithRelationInput>;
  cityId?: InputMaybe<SortOrder>;
  commercialRecord?: InputMaybe<SortOrder>;
  country?: InputMaybe<CountryOrderByWithRelationInput>;
  countryId?: InputMaybe<SortOrder>;
  coupons?: InputMaybe<CouponOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  cv?: InputMaybe<SortOrder>;
  cvId?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  emailVerified?: InputMaybe<SortOrder>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingOrderByRelationAggregateInput>;
  events?: InputMaybe<EventOrderByRelationAggregateInput>;
  fcmToken?: InputMaybe<SortOrder>;
  forgotCode?: InputMaybe<SortOrder>;
  gender?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identityNo?: InputMaybe<SortOrder>;
  image?: InputMaybe<SortOrder>;
  invitedUsers?: InputMaybe<UserOrderByRelationAggregateInput>;
  inviter?: InputMaybe<UserOrderByWithRelationInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitOrderByRelationAggregateInput>;
  inviterId?: InputMaybe<SortOrder>;
  lastLogin?: InputMaybe<SortOrder>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupOrderByRelationAggregateInput>;
  linkedIn?: InputMaybe<SortOrder>;
  logoUrl?: InputMaybe<SortOrder>;
  marketerBalance?: InputMaybe<SortOrder>;
  memberNeeds?: InputMaybe<MemberNeedsOrderByRelationAggregateInput>;
  mobileNumber?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nameAr?: InputMaybe<SortOrder>;
  nameOnCommercialRecord?: InputMaybe<SortOrder>;
  nationality?: InputMaybe<CountryOrderByWithRelationInput>;
  nationalityId?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  profession?: InputMaybe<ProfessionOrderByWithRelationInput>;
  professionId?: InputMaybe<SortOrder>;
  qualificationId?: InputMaybe<SortOrder>;
  remindMeEvents?: InputMaybe<EventOrderByRelationAggregateInput>;
  role?: InputMaybe<RoleOrderByWithRelationInput>;
  roleId?: InputMaybe<SortOrder>;
  scfhs?: InputMaybe<SortOrder>;
  scfhsExp?: InputMaybe<SortOrder>;
  sessions?: InputMaybe<SessionOrderByRelationAggregateInput>;
  specialty?: InputMaybe<SpecialtyOrderByWithRelationInput>;
  specialtyId?: InputMaybe<SortOrder>;
  state?: InputMaybe<StateOrderByWithRelationInput>;
  stateId?: InputMaybe<SortOrder>;
  traineeEventInvites?: InputMaybe<TraineeEventOrderByRelationAggregateInput>;
  traineeEvents?: InputMaybe<TraineeEventOrderByRelationAggregateInput>;
  trainerCv?: InputMaybe<CvOrderByWithRelationInput>;
  trainerEvents?: InputMaybe<TrainerEventOrderByRelationAggregateInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotOrderByRelationAggregateInput>;
  transactionsMediator?: InputMaybe<TransitionOrderByRelationAggregateInput>;
  transitionsFirstParty?: InputMaybe<TransitionOrderByRelationAggregateInput>;
  transitionsSecondParty?: InputMaybe<TransitionOrderByRelationAggregateInput>;
  twitter?: InputMaybe<SortOrder>;
  userCouponProfits?: InputMaybe<InviterCouponProfitOrderByRelationAggregateInput>;
  userEmailVerified?: InputMaybe<SortOrder>;
  username?: InputMaybe<SortOrder>;
  verifyEmailCode?: InputMaybe<SortOrder>;
  visitedEvents?: InputMaybe<EventOrderByRelationAggregateInput>;
};

export type UserRelationFilter = {
  is?: InputMaybe<UserWhereInput>;
  isNot?: InputMaybe<UserWhereInput>;
};

export enum UserScalarFieldEnum {
  AdminNotes = 'adminNotes',
  Balance = 'balance',
  Birthday = 'birthday',
  CityId = 'cityId',
  CommercialRecord = 'commercialRecord',
  CountryId = 'countryId',
  CreatedAt = 'createdAt',
  Cv = 'cv',
  CvId = 'cvId',
  DeletedAt = 'deletedAt',
  Email = 'email',
  EmailVerified = 'emailVerified',
  FcmToken = 'fcmToken',
  ForgotCode = 'forgotCode',
  Gender = 'gender',
  Id = 'id',
  IdentityNo = 'identityNo',
  Image = 'image',
  InviterId = 'inviterId',
  LastLogin = 'lastLogin',
  LinkedIn = 'linkedIn',
  LogoUrl = 'logoUrl',
  MarketerBalance = 'marketerBalance',
  MobileNumber = 'mobileNumber',
  Name = 'name',
  NameAr = 'nameAr',
  NameOnCommercialRecord = 'nameOnCommercialRecord',
  NationalityId = 'nationalityId',
  Password = 'password',
  ProfessionId = 'professionId',
  QualificationId = 'qualificationId',
  RoleId = 'roleId',
  Scfhs = 'scfhs',
  ScfhsExp = 'scfhsExp',
  SpecialtyId = 'specialtyId',
  StateId = 'stateId',
  Twitter = 'twitter',
  UserEmailVerified = 'userEmailVerified',
  Username = 'username',
  VerifyEmailCode = 'verifyEmailCode'
}

export type UserScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<UserScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<UserScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<UserScalarWhereInput>>>;
  adminNotes?: InputMaybe<StringNullableListFilter>;
  balance?: InputMaybe<DecimalFilter>;
  birthday?: InputMaybe<DateTimeNullableFilter>;
  cityId?: InputMaybe<IntNullableFilter>;
  commercialRecord?: InputMaybe<StringNullableFilter>;
  countryId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  cv?: InputMaybe<StringNullableFilter>;
  cvId?: InputMaybe<IntNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  email?: InputMaybe<StringFilter>;
  emailVerified?: InputMaybe<DateTimeNullableFilter>;
  fcmToken?: InputMaybe<StringNullableFilter>;
  forgotCode?: InputMaybe<StringNullableFilter>;
  gender?: InputMaybe<EnumGenderNullableFilter>;
  id?: InputMaybe<IntFilter>;
  identityNo?: InputMaybe<BigIntNullableFilter>;
  image?: InputMaybe<StringNullableFilter>;
  inviterId?: InputMaybe<IntNullableFilter>;
  lastLogin?: InputMaybe<DateTimeNullableFilter>;
  linkedIn?: InputMaybe<StringNullableFilter>;
  logoUrl?: InputMaybe<StringNullableFilter>;
  marketerBalance?: InputMaybe<DecimalFilter>;
  mobileNumber?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  nameAr?: InputMaybe<StringNullableFilter>;
  nameOnCommercialRecord?: InputMaybe<StringNullableFilter>;
  nationalityId?: InputMaybe<IntNullableFilter>;
  password?: InputMaybe<StringNullableFilter>;
  professionId?: InputMaybe<IntNullableFilter>;
  qualificationId?: InputMaybe<IntNullableFilter>;
  roleId?: InputMaybe<IntFilter>;
  scfhs?: InputMaybe<StringNullableFilter>;
  scfhsExp?: InputMaybe<DateTimeNullableFilter>;
  specialtyId?: InputMaybe<IntNullableFilter>;
  stateId?: InputMaybe<IntNullableFilter>;
  twitter?: InputMaybe<StringNullableFilter>;
  userEmailVerified?: InputMaybe<BoolNullableFilter>;
  username?: InputMaybe<StringNullableFilter>;
  verifyEmailCode?: InputMaybe<StringNullableFilter>;
};

export type UserScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<UserScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<UserScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<UserScalarWhereWithAggregatesInput>>>;
  adminNotes?: InputMaybe<StringNullableListFilter>;
  balance?: InputMaybe<DecimalWithAggregatesFilter>;
  birthday?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  cityId?: InputMaybe<IntNullableWithAggregatesFilter>;
  commercialRecord?: InputMaybe<StringNullableWithAggregatesFilter>;
  countryId?: InputMaybe<IntNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  cv?: InputMaybe<StringNullableWithAggregatesFilter>;
  cvId?: InputMaybe<IntNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  email?: InputMaybe<StringWithAggregatesFilter>;
  emailVerified?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  fcmToken?: InputMaybe<StringNullableWithAggregatesFilter>;
  forgotCode?: InputMaybe<StringNullableWithAggregatesFilter>;
  gender?: InputMaybe<EnumGenderNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  identityNo?: InputMaybe<BigIntNullableWithAggregatesFilter>;
  image?: InputMaybe<StringNullableWithAggregatesFilter>;
  inviterId?: InputMaybe<IntNullableWithAggregatesFilter>;
  lastLogin?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  linkedIn?: InputMaybe<StringNullableWithAggregatesFilter>;
  logoUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  marketerBalance?: InputMaybe<DecimalWithAggregatesFilter>;
  mobileNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
  name?: InputMaybe<StringNullableWithAggregatesFilter>;
  nameAr?: InputMaybe<StringNullableWithAggregatesFilter>;
  nameOnCommercialRecord?: InputMaybe<StringNullableWithAggregatesFilter>;
  nationalityId?: InputMaybe<IntNullableWithAggregatesFilter>;
  password?: InputMaybe<StringNullableWithAggregatesFilter>;
  professionId?: InputMaybe<IntNullableWithAggregatesFilter>;
  qualificationId?: InputMaybe<IntNullableWithAggregatesFilter>;
  roleId?: InputMaybe<IntWithAggregatesFilter>;
  scfhs?: InputMaybe<StringNullableWithAggregatesFilter>;
  scfhsExp?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  specialtyId?: InputMaybe<IntNullableWithAggregatesFilter>;
  stateId?: InputMaybe<IntNullableWithAggregatesFilter>;
  twitter?: InputMaybe<StringNullableWithAggregatesFilter>;
  userEmailVerified?: InputMaybe<BoolNullableWithAggregatesFilter>;
  username?: InputMaybe<StringNullableWithAggregatesFilter>;
  verifyEmailCode?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type UserSumAggregateOutputType = {
  __typename?: 'UserSumAggregateOutputType';
  balance?: Maybe<Scalars['Decimal']>;
  cityId?: Maybe<Scalars['Int']>;
  countryId?: Maybe<Scalars['Int']>;
  cvId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  identityNo?: Maybe<Scalars['BigInt']>;
  inviterId?: Maybe<Scalars['Int']>;
  marketerBalance?: Maybe<Scalars['Decimal']>;
  nationalityId?: Maybe<Scalars['Int']>;
  professionId?: Maybe<Scalars['Int']>;
  qualificationId?: Maybe<Scalars['Int']>;
  roleId?: Maybe<Scalars['Int']>;
  specialtyId?: Maybe<Scalars['Int']>;
  stateId?: Maybe<Scalars['Int']>;
};

export type UserSumOrderByAggregateInput = {
  balance?: InputMaybe<SortOrder>;
  cityId?: InputMaybe<SortOrder>;
  countryId?: InputMaybe<SortOrder>;
  cvId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identityNo?: InputMaybe<SortOrder>;
  inviterId?: InputMaybe<SortOrder>;
  marketerBalance?: InputMaybe<SortOrder>;
  nationalityId?: InputMaybe<SortOrder>;
  professionId?: InputMaybe<SortOrder>;
  qualificationId?: InputMaybe<SortOrder>;
  roleId?: InputMaybe<SortOrder>;
  specialtyId?: InputMaybe<SortOrder>;
  stateId?: InputMaybe<SortOrder>;
};

export type UserUncheckedCreateInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateNestedManyWithoutCityInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutCityInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutCityInput>>>;
  createMany?: InputMaybe<UserCreateManyCityInputEnvelope>;
};

export type UserUncheckedCreateNestedManyWithoutCountryInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutCountryInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutCountryInput>>>;
  createMany?: InputMaybe<UserCreateManyCountryInputEnvelope>;
};

export type UserUncheckedCreateNestedManyWithoutInviterInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutInviterInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutInviterInput>>>;
  createMany?: InputMaybe<UserCreateManyInviterInputEnvelope>;
};

export type UserUncheckedCreateNestedManyWithoutNationalityInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutNationalityInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutNationalityInput>>>;
  createMany?: InputMaybe<UserCreateManyNationalityInputEnvelope>;
};

export type UserUncheckedCreateNestedManyWithoutProfessionInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutProfessionInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutProfessionInput>>>;
  createMany?: InputMaybe<UserCreateManyProfessionInputEnvelope>;
};

export type UserUncheckedCreateNestedManyWithoutQualificationInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutQualificationInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutQualificationInput>>>;
  createMany?: InputMaybe<UserCreateManyQualificationInputEnvelope>;
};

export type UserUncheckedCreateNestedManyWithoutRemindMeEventsInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutRemindMeEventsInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutRemindMeEventsInput>>>;
};

export type UserUncheckedCreateNestedManyWithoutRoleInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutRoleInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutRoleInput>>>;
  createMany?: InputMaybe<UserCreateManyRoleInputEnvelope>;
};

export type UserUncheckedCreateNestedManyWithoutSpecialtyInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutSpecialtyInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutSpecialtyInput>>>;
  createMany?: InputMaybe<UserCreateManySpecialtyInputEnvelope>;
};

export type UserUncheckedCreateNestedManyWithoutStateInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutStateInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutStateInput>>>;
  createMany?: InputMaybe<UserCreateManyStateInputEnvelope>;
};

export type UserUncheckedCreateNestedManyWithoutVisitedEventsInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutVisitedEventsInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutVisitedEventsInput>>>;
};

export type UserUncheckedCreateNestedOneWithoutTrainerCvInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutTrainerCvInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutTrainerCvInput>;
};

export type UserUncheckedCreateWithoutAccountsInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutAddedEventsInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutApplicationsInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutBankAccountInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutBlogsInput = {
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutCertificateInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutCityInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutCountryInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutCouponsInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutDiscussionInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutEventMediaTrackingInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutEventsInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutInvitedUsersInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutInviterCouponProfitsInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutInviterInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutLeaderEventGroupsInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutMemberNeedsInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutNationalityInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutNotificationInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutProfessionInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutQualificationInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutQuizResultInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutRemindMeEventsInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutRoleInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutSessionsInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutSpecialtyInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutStateInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutTraineeEventInvitesInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutTraineeEventsInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutTrainerCvInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutTrainerEventsInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutTrainereventDayTimeSlotsInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutTransactionsMediatorInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutTransitionsFirstPartyInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutTransitionsSecondPartyInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutUserCouponProfitsInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedCreateWithoutVisitedEventsInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
};

export type UserUncheckedCreateWithoutZohoEmailInput = {
  Blogs?: InputMaybe<BlogsUncheckedCreateNestedManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedCreateNestedManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedCreateNestedManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedCreateNestedManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedCreateNestedManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedCreateNestedManyWithoutApplicantInput>;
  balance?: InputMaybe<Scalars['Decimal']>;
  bankAccount?: InputMaybe<BankAccountUncheckedCreateNestedOneWithoutUserInput>;
  birthday?: InputMaybe<Scalars['DateTime']>;
  cityId?: InputMaybe<Scalars['Int']>;
  commercialRecord?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  coupons?: InputMaybe<CouponUncheckedCreateNestedManyWithoutInviterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cv?: InputMaybe<Scalars['String']>;
  cvId?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailVerified?: InputMaybe<Scalars['DateTime']>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedCreateNestedManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedCreateNestedManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['Int']>;
  identityNo?: InputMaybe<Scalars['BigInt']>;
  image?: InputMaybe<Scalars['String']>;
  invitedUsers?: InputMaybe<UserUncheckedCreateNestedManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutInviterInput>;
  inviterId?: InputMaybe<Scalars['Int']>;
  lastLogin?: InputMaybe<Scalars['DateTime']>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedCreateNestedManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  marketerBalance?: InputMaybe<Scalars['Decimal']>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedCreateNestedManyWithoutUserInput>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameAr?: InputMaybe<Scalars['String']>;
  nameOnCommercialRecord?: InputMaybe<Scalars['String']>;
  nationalityId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['Int']>;
  qualificationId?: InputMaybe<Scalars['Int']>;
  remindMeEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<Scalars['Int']>;
  scfhs?: InputMaybe<Scalars['String']>;
  scfhsExp?: InputMaybe<Scalars['DateTime']>;
  sessions?: InputMaybe<SessionUncheckedCreateNestedManyWithoutUserInput>;
  specialtyId?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['Int']>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedCreateNestedManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedCreateNestedManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedCreateNestedManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedCreateNestedManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<Scalars['String']>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedCreateNestedManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
  visitedEvents?: InputMaybe<EventUncheckedCreateNestedManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateManyInput = {
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUncheckedUpdateManyWithoutCityInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutCityInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutCityInput>>>;
  createMany?: InputMaybe<UserCreateManyCityInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<UserScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<UserUpdateWithWhereUniqueWithoutCityInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<UserUpdateManyWithWhereWithoutCityInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<UserUpsertWithWhereUniqueWithoutCityInput>>>;
};

export type UserUncheckedUpdateManyWithoutCountryInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutCountryInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutCountryInput>>>;
  createMany?: InputMaybe<UserCreateManyCountryInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<UserScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<UserUpdateWithWhereUniqueWithoutCountryInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<UserUpdateManyWithWhereWithoutCountryInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<UserUpsertWithWhereUniqueWithoutCountryInput>>>;
};

export type UserUncheckedUpdateManyWithoutInvitedUsersInput = {
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUncheckedUpdateManyWithoutInviterInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutInviterInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutInviterInput>>>;
  createMany?: InputMaybe<UserCreateManyInviterInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<UserScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<UserUpdateWithWhereUniqueWithoutInviterInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<UserUpdateManyWithWhereWithoutInviterInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<UserUpsertWithWhereUniqueWithoutInviterInput>>>;
};

export type UserUncheckedUpdateManyWithoutNationalityInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutNationalityInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutNationalityInput>>>;
  createMany?: InputMaybe<UserCreateManyNationalityInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<UserScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<UserUpdateWithWhereUniqueWithoutNationalityInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<UserUpdateManyWithWhereWithoutNationalityInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<UserUpsertWithWhereUniqueWithoutNationalityInput>>>;
};

export type UserUncheckedUpdateManyWithoutProfessionInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutProfessionInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutProfessionInput>>>;
  createMany?: InputMaybe<UserCreateManyProfessionInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<UserScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<UserUpdateWithWhereUniqueWithoutProfessionInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<UserUpdateManyWithWhereWithoutProfessionInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<UserUpsertWithWhereUniqueWithoutProfessionInput>>>;
};

export type UserUncheckedUpdateManyWithoutQualificationInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutQualificationInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutQualificationInput>>>;
  createMany?: InputMaybe<UserCreateManyQualificationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<UserScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<UserUpdateWithWhereUniqueWithoutQualificationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<UserUpdateManyWithWhereWithoutQualificationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<UserUpsertWithWhereUniqueWithoutQualificationInput>>>;
};

export type UserUncheckedUpdateManyWithoutRemindMeEventsInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutRemindMeEventsInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutRemindMeEventsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<UserScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<UserUpdateWithWhereUniqueWithoutRemindMeEventsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<UserUpdateManyWithWhereWithoutRemindMeEventsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<UserUpsertWithWhereUniqueWithoutRemindMeEventsInput>>>;
};

export type UserUncheckedUpdateManyWithoutRemindMeTraineesInput = {
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUncheckedUpdateManyWithoutRoleInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutRoleInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutRoleInput>>>;
  createMany?: InputMaybe<UserCreateManyRoleInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<UserScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<UserUpdateWithWhereUniqueWithoutRoleInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<UserUpdateManyWithWhereWithoutRoleInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<UserUpsertWithWhereUniqueWithoutRoleInput>>>;
};

export type UserUncheckedUpdateManyWithoutSpecialtyInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutSpecialtyInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutSpecialtyInput>>>;
  createMany?: InputMaybe<UserCreateManySpecialtyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<UserScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<UserUpdateWithWhereUniqueWithoutSpecialtyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<UserUpdateManyWithWhereWithoutSpecialtyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<UserUpsertWithWhereUniqueWithoutSpecialtyInput>>>;
};

export type UserUncheckedUpdateManyWithoutStateInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutStateInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutStateInput>>>;
  createMany?: InputMaybe<UserCreateManyStateInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<UserScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<UserUpdateWithWhereUniqueWithoutStateInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<UserUpdateManyWithWhereWithoutStateInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<UserUpsertWithWhereUniqueWithoutStateInput>>>;
};

export type UserUncheckedUpdateManyWithoutUserInput = {
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUncheckedUpdateManyWithoutUsersInput = {
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUncheckedUpdateManyWithoutUsersNationalityInput = {
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUncheckedUpdateManyWithoutVisitedEventsInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutVisitedEventsInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutVisitedEventsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<UserScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<UserUpdateWithWhereUniqueWithoutVisitedEventsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<UserUpdateManyWithWhereWithoutVisitedEventsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<UserUpsertWithWhereUniqueWithoutVisitedEventsInput>>>;
};

export type UserUncheckedUpdateManyWithoutVisitedTraineesInput = {
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUncheckedUpdateOneWithoutTrainerCvInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutTrainerCvInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutTrainerCvInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<UserUncheckedUpdateWithoutTrainerCvInput>;
  upsert?: InputMaybe<UserUpsertWithoutTrainerCvInput>;
};

export type UserUncheckedUpdateWithoutAccountsInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutAddedEventsInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutApplicationsInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutBankAccountInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutBlogsInput = {
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutCertificateInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutCityInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutCountryInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutCouponsInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutDiscussionInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutEventMediaTrackingInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutEventsInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutInvitedUsersInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutInviterCouponProfitsInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutInviterInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutLeaderEventGroupsInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutMemberNeedsInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutNationalityInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutNotificationInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutProfessionInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutQualificationInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutQuizResultInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutRemindMeEventsInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutRoleInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutSessionsInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutSpecialtyInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutStateInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutTraineeEventInvitesInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutTraineeEventsInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutTrainerCvInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutTrainerEventsInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutTrainereventDayTimeSlotsInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutTransactionsMediatorInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutTransitionsFirstPartyInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutTransitionsSecondPartyInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutUserCouponProfitsInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUncheckedUpdateWithoutVisitedEventsInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUncheckedUpdateWithoutZohoEmailInput = {
  Blogs?: InputMaybe<BlogsUncheckedUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUncheckedUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUncheckedUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUncheckedUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUncheckedUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUncheckedUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUncheckedUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUncheckedUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUncheckedUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cvId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUncheckedUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUncheckedUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUncheckedUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutInviterInput>;
  inviterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUncheckedUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUncheckedUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationalityId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  professionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qualificationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUncheckedUpdateManyWithoutRemindMeTraineesInput>;
  roleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUncheckedUpdateManyWithoutUserInput>;
  specialtyId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUncheckedUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUncheckedUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUncheckedUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUncheckedUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUncheckedUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUncheckedUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUncheckedUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateManyMutationInput = {
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUpdateManyWithWhereWithoutCityInput = {
  data: UserUncheckedUpdateManyWithoutUsersInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithWhereWithoutCountryInput = {
  data: UserUncheckedUpdateManyWithoutUsersInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithWhereWithoutInviterInput = {
  data: UserUncheckedUpdateManyWithoutInvitedUsersInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithWhereWithoutNationalityInput = {
  data: UserUncheckedUpdateManyWithoutUsersNationalityInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithWhereWithoutProfessionInput = {
  data: UserUncheckedUpdateManyWithoutUsersInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithWhereWithoutQualificationInput = {
  data: UserUncheckedUpdateManyWithoutUserInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithWhereWithoutRemindMeEventsInput = {
  data: UserUncheckedUpdateManyWithoutRemindMeTraineesInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithWhereWithoutRoleInput = {
  data: UserUncheckedUpdateManyWithoutUsersInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithWhereWithoutSpecialtyInput = {
  data: UserUncheckedUpdateManyWithoutUsersInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithWhereWithoutStateInput = {
  data: UserUncheckedUpdateManyWithoutUsersInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithWhereWithoutVisitedEventsInput = {
  data: UserUncheckedUpdateManyWithoutVisitedTraineesInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithoutCityInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutCityInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutCityInput>>>;
  createMany?: InputMaybe<UserCreateManyCityInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<UserScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<UserUpdateWithWhereUniqueWithoutCityInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<UserUpdateManyWithWhereWithoutCityInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<UserUpsertWithWhereUniqueWithoutCityInput>>>;
};

export type UserUpdateManyWithoutCountryInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutCountryInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutCountryInput>>>;
  createMany?: InputMaybe<UserCreateManyCountryInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<UserScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<UserUpdateWithWhereUniqueWithoutCountryInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<UserUpdateManyWithWhereWithoutCountryInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<UserUpsertWithWhereUniqueWithoutCountryInput>>>;
};

export type UserUpdateManyWithoutInviterInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutInviterInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutInviterInput>>>;
  createMany?: InputMaybe<UserCreateManyInviterInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<UserScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<UserUpdateWithWhereUniqueWithoutInviterInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<UserUpdateManyWithWhereWithoutInviterInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<UserUpsertWithWhereUniqueWithoutInviterInput>>>;
};

export type UserUpdateManyWithoutNationalityInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutNationalityInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutNationalityInput>>>;
  createMany?: InputMaybe<UserCreateManyNationalityInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<UserScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<UserUpdateWithWhereUniqueWithoutNationalityInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<UserUpdateManyWithWhereWithoutNationalityInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<UserUpsertWithWhereUniqueWithoutNationalityInput>>>;
};

export type UserUpdateManyWithoutProfessionInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutProfessionInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutProfessionInput>>>;
  createMany?: InputMaybe<UserCreateManyProfessionInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<UserScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<UserUpdateWithWhereUniqueWithoutProfessionInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<UserUpdateManyWithWhereWithoutProfessionInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<UserUpsertWithWhereUniqueWithoutProfessionInput>>>;
};

export type UserUpdateManyWithoutQualificationInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutQualificationInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutQualificationInput>>>;
  createMany?: InputMaybe<UserCreateManyQualificationInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<UserScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<UserUpdateWithWhereUniqueWithoutQualificationInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<UserUpdateManyWithWhereWithoutQualificationInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<UserUpsertWithWhereUniqueWithoutQualificationInput>>>;
};

export type UserUpdateManyWithoutRemindMeEventsInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutRemindMeEventsInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutRemindMeEventsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<UserScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<UserUpdateWithWhereUniqueWithoutRemindMeEventsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<UserUpdateManyWithWhereWithoutRemindMeEventsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<UserUpsertWithWhereUniqueWithoutRemindMeEventsInput>>>;
};

export type UserUpdateManyWithoutRoleInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutRoleInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutRoleInput>>>;
  createMany?: InputMaybe<UserCreateManyRoleInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<UserScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<UserUpdateWithWhereUniqueWithoutRoleInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<UserUpdateManyWithWhereWithoutRoleInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<UserUpsertWithWhereUniqueWithoutRoleInput>>>;
};

export type UserUpdateManyWithoutSpecialtyInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutSpecialtyInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutSpecialtyInput>>>;
  createMany?: InputMaybe<UserCreateManySpecialtyInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<UserScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<UserUpdateWithWhereUniqueWithoutSpecialtyInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<UserUpdateManyWithWhereWithoutSpecialtyInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<UserUpsertWithWhereUniqueWithoutSpecialtyInput>>>;
};

export type UserUpdateManyWithoutStateInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutStateInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutStateInput>>>;
  createMany?: InputMaybe<UserCreateManyStateInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<UserScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<UserUpdateWithWhereUniqueWithoutStateInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<UserUpdateManyWithWhereWithoutStateInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<UserUpsertWithWhereUniqueWithoutStateInput>>>;
};

export type UserUpdateManyWithoutVisitedEventsInput = {
  connect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<UserCreateOrConnectWithoutVisitedEventsInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateWithoutVisitedEventsInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<UserScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<UserWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<UserUpdateWithWhereUniqueWithoutVisitedEventsInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<UserUpdateManyWithWhereWithoutVisitedEventsInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<UserUpsertWithWhereUniqueWithoutVisitedEventsInput>>>;
};

export type UserUpdateOneRequiredWithoutAccountsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutAccountsInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutAccountsInput>;
  update?: InputMaybe<UserUncheckedUpdateWithoutAccountsInput>;
  upsert?: InputMaybe<UserUpsertWithoutAccountsInput>;
};

export type UserUpdateOneRequiredWithoutApplicationsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutApplicationsInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutApplicationsInput>;
  update?: InputMaybe<UserUncheckedUpdateWithoutApplicationsInput>;
  upsert?: InputMaybe<UserUpsertWithoutApplicationsInput>;
};

export type UserUpdateOneRequiredWithoutBankAccountInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutBankAccountInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutBankAccountInput>;
  update?: InputMaybe<UserUncheckedUpdateWithoutBankAccountInput>;
  upsert?: InputMaybe<UserUpsertWithoutBankAccountInput>;
};

export type UserUpdateOneRequiredWithoutDiscussionInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutDiscussionInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutDiscussionInput>;
  update?: InputMaybe<UserUncheckedUpdateWithoutDiscussionInput>;
  upsert?: InputMaybe<UserUpsertWithoutDiscussionInput>;
};

export type UserUpdateOneRequiredWithoutLeaderEventGroupsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutLeaderEventGroupsInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutLeaderEventGroupsInput>;
  update?: InputMaybe<UserUncheckedUpdateWithoutLeaderEventGroupsInput>;
  upsert?: InputMaybe<UserUpsertWithoutLeaderEventGroupsInput>;
};

export type UserUpdateOneRequiredWithoutQuizResultInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutQuizResultInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutQuizResultInput>;
  update?: InputMaybe<UserUncheckedUpdateWithoutQuizResultInput>;
  upsert?: InputMaybe<UserUpsertWithoutQuizResultInput>;
};

export type UserUpdateOneRequiredWithoutSessionsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutSessionsInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutSessionsInput>;
  update?: InputMaybe<UserUncheckedUpdateWithoutSessionsInput>;
  upsert?: InputMaybe<UserUpsertWithoutSessionsInput>;
};

export type UserUpdateOneRequiredWithoutTraineeEventsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutTraineeEventsInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutTraineeEventsInput>;
  update?: InputMaybe<UserUncheckedUpdateWithoutTraineeEventsInput>;
  upsert?: InputMaybe<UserUpsertWithoutTraineeEventsInput>;
};

export type UserUpdateOneRequiredWithoutTrainerEventsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutTrainerEventsInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutTrainerEventsInput>;
  update?: InputMaybe<UserUncheckedUpdateWithoutTrainerEventsInput>;
  upsert?: InputMaybe<UserUpsertWithoutTrainerEventsInput>;
};

export type UserUpdateOneRequiredWithoutTransitionsFirstPartyInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutTransitionsFirstPartyInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutTransitionsFirstPartyInput>;
  update?: InputMaybe<UserUncheckedUpdateWithoutTransitionsFirstPartyInput>;
  upsert?: InputMaybe<UserUpsertWithoutTransitionsFirstPartyInput>;
};

export type UserUpdateOneWithoutAddedEventsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutAddedEventsInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutAddedEventsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<UserUncheckedUpdateWithoutAddedEventsInput>;
  upsert?: InputMaybe<UserUpsertWithoutAddedEventsInput>;
};

export type UserUpdateOneWithoutBlogsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutBlogsInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutBlogsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<UserUncheckedUpdateWithoutBlogsInput>;
  upsert?: InputMaybe<UserUpsertWithoutBlogsInput>;
};

export type UserUpdateOneWithoutCertificateInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCertificateInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutCertificateInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<UserUncheckedUpdateWithoutCertificateInput>;
  upsert?: InputMaybe<UserUpsertWithoutCertificateInput>;
};

export type UserUpdateOneWithoutCouponsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCouponsInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutCouponsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<UserUncheckedUpdateWithoutCouponsInput>;
  upsert?: InputMaybe<UserUpsertWithoutCouponsInput>;
};

export type UserUpdateOneWithoutEventMediaTrackingInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutEventMediaTrackingInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutEventMediaTrackingInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<UserUncheckedUpdateWithoutEventMediaTrackingInput>;
  upsert?: InputMaybe<UserUpsertWithoutEventMediaTrackingInput>;
};

export type UserUpdateOneWithoutEventsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutEventsInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutEventsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<UserUncheckedUpdateWithoutEventsInput>;
  upsert?: InputMaybe<UserUpsertWithoutEventsInput>;
};

export type UserUpdateOneWithoutInvitedUsersInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutInvitedUsersInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutInvitedUsersInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<UserUncheckedUpdateWithoutInvitedUsersInput>;
  upsert?: InputMaybe<UserUpsertWithoutInvitedUsersInput>;
};

export type UserUpdateOneWithoutInviterCouponProfitsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutInviterCouponProfitsInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutInviterCouponProfitsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<UserUncheckedUpdateWithoutInviterCouponProfitsInput>;
  upsert?: InputMaybe<UserUpsertWithoutInviterCouponProfitsInput>;
};

export type UserUpdateOneWithoutMemberNeedsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutMemberNeedsInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutMemberNeedsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<UserUncheckedUpdateWithoutMemberNeedsInput>;
  upsert?: InputMaybe<UserUpsertWithoutMemberNeedsInput>;
};

export type UserUpdateOneWithoutNotificationInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutNotificationInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutNotificationInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<UserUncheckedUpdateWithoutNotificationInput>;
  upsert?: InputMaybe<UserUpsertWithoutNotificationInput>;
};

export type UserUpdateOneWithoutTraineeEventInvitesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutTraineeEventInvitesInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutTraineeEventInvitesInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<UserUncheckedUpdateWithoutTraineeEventInvitesInput>;
  upsert?: InputMaybe<UserUpsertWithoutTraineeEventInvitesInput>;
};

export type UserUpdateOneWithoutTrainerCvInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutTrainerCvInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutTrainerCvInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<UserUncheckedUpdateWithoutTrainerCvInput>;
  upsert?: InputMaybe<UserUpsertWithoutTrainerCvInput>;
};

export type UserUpdateOneWithoutTrainereventDayTimeSlotsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutTrainereventDayTimeSlotsInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutTrainereventDayTimeSlotsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<UserUncheckedUpdateWithoutTrainereventDayTimeSlotsInput>;
  upsert?: InputMaybe<UserUpsertWithoutTrainereventDayTimeSlotsInput>;
};

export type UserUpdateOneWithoutTransactionsMediatorInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutTransactionsMediatorInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutTransactionsMediatorInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<UserUncheckedUpdateWithoutTransactionsMediatorInput>;
  upsert?: InputMaybe<UserUpsertWithoutTransactionsMediatorInput>;
};

export type UserUpdateOneWithoutTransitionsSecondPartyInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutTransitionsSecondPartyInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutTransitionsSecondPartyInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<UserUncheckedUpdateWithoutTransitionsSecondPartyInput>;
  upsert?: InputMaybe<UserUpsertWithoutTransitionsSecondPartyInput>;
};

export type UserUpdateOneWithoutUserCouponProfitsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutUserCouponProfitsInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutUserCouponProfitsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<UserUncheckedUpdateWithoutUserCouponProfitsInput>;
  upsert?: InputMaybe<UserUpsertWithoutUserCouponProfitsInput>;
};

export type UserUpdateOneWithoutZohoEmailInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutZohoEmailInput>;
  create?: InputMaybe<UserUncheckedCreateWithoutZohoEmailInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<UserUncheckedUpdateWithoutZohoEmailInput>;
  upsert?: InputMaybe<UserUpsertWithoutZohoEmailInput>;
};

export type UserUpdateWithWhereUniqueWithoutCityInput = {
  data: UserUncheckedUpdateWithoutCityInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithWhereUniqueWithoutCountryInput = {
  data: UserUncheckedUpdateWithoutCountryInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithWhereUniqueWithoutInviterInput = {
  data: UserUncheckedUpdateWithoutInviterInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithWhereUniqueWithoutNationalityInput = {
  data: UserUncheckedUpdateWithoutNationalityInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithWhereUniqueWithoutProfessionInput = {
  data: UserUncheckedUpdateWithoutProfessionInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithWhereUniqueWithoutQualificationInput = {
  data: UserUncheckedUpdateWithoutQualificationInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithWhereUniqueWithoutRemindMeEventsInput = {
  data: UserUncheckedUpdateWithoutRemindMeEventsInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithWhereUniqueWithoutRoleInput = {
  data: UserUncheckedUpdateWithoutRoleInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithWhereUniqueWithoutSpecialtyInput = {
  data: UserUncheckedUpdateWithoutSpecialtyInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithWhereUniqueWithoutStateInput = {
  data: UserUncheckedUpdateWithoutStateInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithWhereUniqueWithoutVisitedEventsInput = {
  data: UserUncheckedUpdateWithoutVisitedEventsInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithoutAccountsInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutAddedEventsInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutApplicationsInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutBankAccountInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutBlogsInput = {
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutCertificateInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutCityInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutCountryInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutCouponsInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutDiscussionInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutEventMediaTrackingInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutEventsInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutInvitedUsersInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutInviterCouponProfitsInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutInviterInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutLeaderEventGroupsInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutMemberNeedsInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutNationalityInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutNotificationInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutProfessionInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutQualificationInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutQuizResultInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutRemindMeEventsInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutRoleInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutSessionsInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutSpecialtyInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutStateInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutTraineeEventInvitesInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutTraineeEventsInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutTrainerCvInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutTrainerEventsInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutTrainereventDayTimeSlotsInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutTransactionsMediatorInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutTransitionsFirstPartyInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutTransitionsSecondPartyInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutUserCouponProfitsInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateWithoutVisitedEventsInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  ZohoEmail?: InputMaybe<ZohoEmailUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutZohoEmailInput = {
  Blogs?: InputMaybe<BlogsUpdateManyWithoutAuthorInput>;
  Certificate?: InputMaybe<CertificateUpdateManyWithoutTraineeInput>;
  Discussion?: InputMaybe<DiscussionUpdateManyWithoutUserInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserInput>;
  Qualification?: InputMaybe<QualificationUpdateOneWithoutUserInput>;
  QuizResult?: InputMaybe<QuizResultUpdateManyWithoutUserInput>;
  accounts?: InputMaybe<AccountUpdateManyWithoutUserInput>;
  addedEvents?: InputMaybe<EventUpdateManyWithoutAddedByInput>;
  adminNotes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applications?: InputMaybe<BecomeTrainerApplicationUpdateManyWithoutApplicantInput>;
  balance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  bankAccount?: InputMaybe<BankAccountUpdateOneWithoutUserInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  city?: InputMaybe<CityUpdateOneWithoutUsersInput>;
  commercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersInput>;
  coupons?: InputMaybe<CouponUpdateManyWithoutInviterInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cv?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingUpdateManyWithoutTraineeInput>;
  events?: InputMaybe<EventUpdateManyWithoutLeaderTrainerInput>;
  fcmToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forgotCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderFieldUpdateOperationsInput>;
  identityNo?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invitedUsers?: InputMaybe<UserUpdateManyWithoutInviterInput>;
  inviter?: InputMaybe<UserUpdateOneWithoutInvitedUsersInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutInviterInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupUpdateManyWithoutLeaderInput>;
  linkedIn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketerBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  memberNeeds?: InputMaybe<MemberNeedsUpdateManyWithoutUserInput>;
  mobileNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameAr?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCommercialRecord?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<CountryUpdateOneWithoutUsersNationalityInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profession?: InputMaybe<ProfessionUpdateOneWithoutUsersInput>;
  remindMeEvents?: InputMaybe<EventUpdateManyWithoutRemindMeTraineesInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutUsersInput>;
  scfhs?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scfhsExp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserInput>;
  specialty?: InputMaybe<SpecialtyUpdateOneWithoutUsersInput>;
  state?: InputMaybe<StateUpdateOneWithoutUsersInput>;
  traineeEventInvites?: InputMaybe<TraineeEventUpdateManyWithoutInviterInput>;
  traineeEvents?: InputMaybe<TraineeEventUpdateManyWithoutTraineeInput>;
  trainerCv?: InputMaybe<CvUpdateOneWithoutUserInput>;
  trainerEvents?: InputMaybe<TrainerEventUpdateManyWithoutTrainerInput>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotUpdateManyWithoutAddedByInput>;
  transactionsMediator?: InputMaybe<TransitionUpdateManyWithoutMediatorInput>;
  transitionsFirstParty?: InputMaybe<TransitionUpdateManyWithoutFirstPartyInput>;
  transitionsSecondParty?: InputMaybe<TransitionUpdateManyWithoutSecondPartyInput>;
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCouponProfits?: InputMaybe<InviterCouponProfitUpdateManyWithoutUserInput>;
  userEmailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  verifyEmailCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedEvents?: InputMaybe<EventUpdateManyWithoutVisitedTraineesInput>;
};

export type UserUpdateadminNotesInput = {
  push?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UserUpsertWithWhereUniqueWithoutCityInput = {
  create: UserUncheckedCreateWithoutCityInput;
  update: UserUncheckedUpdateWithoutCityInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutCountryInput = {
  create: UserUncheckedCreateWithoutCountryInput;
  update: UserUncheckedUpdateWithoutCountryInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutInviterInput = {
  create: UserUncheckedCreateWithoutInviterInput;
  update: UserUncheckedUpdateWithoutInviterInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutNationalityInput = {
  create: UserUncheckedCreateWithoutNationalityInput;
  update: UserUncheckedUpdateWithoutNationalityInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutProfessionInput = {
  create: UserUncheckedCreateWithoutProfessionInput;
  update: UserUncheckedUpdateWithoutProfessionInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutQualificationInput = {
  create: UserUncheckedCreateWithoutQualificationInput;
  update: UserUncheckedUpdateWithoutQualificationInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutRemindMeEventsInput = {
  create: UserUncheckedCreateWithoutRemindMeEventsInput;
  update: UserUncheckedUpdateWithoutRemindMeEventsInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutRoleInput = {
  create: UserUncheckedCreateWithoutRoleInput;
  update: UserUncheckedUpdateWithoutRoleInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutSpecialtyInput = {
  create: UserUncheckedCreateWithoutSpecialtyInput;
  update: UserUncheckedUpdateWithoutSpecialtyInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutStateInput = {
  create: UserUncheckedCreateWithoutStateInput;
  update: UserUncheckedUpdateWithoutStateInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutVisitedEventsInput = {
  create: UserUncheckedCreateWithoutVisitedEventsInput;
  update: UserUncheckedUpdateWithoutVisitedEventsInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithoutAccountsInput = {
  create: UserUncheckedCreateWithoutAccountsInput;
  update: UserUncheckedUpdateWithoutAccountsInput;
};

export type UserUpsertWithoutAddedEventsInput = {
  create: UserUncheckedCreateWithoutAddedEventsInput;
  update: UserUncheckedUpdateWithoutAddedEventsInput;
};

export type UserUpsertWithoutApplicationsInput = {
  create: UserUncheckedCreateWithoutApplicationsInput;
  update: UserUncheckedUpdateWithoutApplicationsInput;
};

export type UserUpsertWithoutBankAccountInput = {
  create: UserUncheckedCreateWithoutBankAccountInput;
  update: UserUncheckedUpdateWithoutBankAccountInput;
};

export type UserUpsertWithoutBlogsInput = {
  create: UserUncheckedCreateWithoutBlogsInput;
  update: UserUncheckedUpdateWithoutBlogsInput;
};

export type UserUpsertWithoutCertificateInput = {
  create: UserUncheckedCreateWithoutCertificateInput;
  update: UserUncheckedUpdateWithoutCertificateInput;
};

export type UserUpsertWithoutCouponsInput = {
  create: UserUncheckedCreateWithoutCouponsInput;
  update: UserUncheckedUpdateWithoutCouponsInput;
};

export type UserUpsertWithoutDiscussionInput = {
  create: UserUncheckedCreateWithoutDiscussionInput;
  update: UserUncheckedUpdateWithoutDiscussionInput;
};

export type UserUpsertWithoutEventMediaTrackingInput = {
  create: UserUncheckedCreateWithoutEventMediaTrackingInput;
  update: UserUncheckedUpdateWithoutEventMediaTrackingInput;
};

export type UserUpsertWithoutEventsInput = {
  create: UserUncheckedCreateWithoutEventsInput;
  update: UserUncheckedUpdateWithoutEventsInput;
};

export type UserUpsertWithoutInvitedUsersInput = {
  create: UserUncheckedCreateWithoutInvitedUsersInput;
  update: UserUncheckedUpdateWithoutInvitedUsersInput;
};

export type UserUpsertWithoutInviterCouponProfitsInput = {
  create: UserUncheckedCreateWithoutInviterCouponProfitsInput;
  update: UserUncheckedUpdateWithoutInviterCouponProfitsInput;
};

export type UserUpsertWithoutLeaderEventGroupsInput = {
  create: UserUncheckedCreateWithoutLeaderEventGroupsInput;
  update: UserUncheckedUpdateWithoutLeaderEventGroupsInput;
};

export type UserUpsertWithoutMemberNeedsInput = {
  create: UserUncheckedCreateWithoutMemberNeedsInput;
  update: UserUncheckedUpdateWithoutMemberNeedsInput;
};

export type UserUpsertWithoutNotificationInput = {
  create: UserUncheckedCreateWithoutNotificationInput;
  update: UserUncheckedUpdateWithoutNotificationInput;
};

export type UserUpsertWithoutQuizResultInput = {
  create: UserUncheckedCreateWithoutQuizResultInput;
  update: UserUncheckedUpdateWithoutQuizResultInput;
};

export type UserUpsertWithoutSessionsInput = {
  create: UserUncheckedCreateWithoutSessionsInput;
  update: UserUncheckedUpdateWithoutSessionsInput;
};

export type UserUpsertWithoutTraineeEventInvitesInput = {
  create: UserUncheckedCreateWithoutTraineeEventInvitesInput;
  update: UserUncheckedUpdateWithoutTraineeEventInvitesInput;
};

export type UserUpsertWithoutTraineeEventsInput = {
  create: UserUncheckedCreateWithoutTraineeEventsInput;
  update: UserUncheckedUpdateWithoutTraineeEventsInput;
};

export type UserUpsertWithoutTrainerCvInput = {
  create: UserUncheckedCreateWithoutTrainerCvInput;
  update: UserUncheckedUpdateWithoutTrainerCvInput;
};

export type UserUpsertWithoutTrainerEventsInput = {
  create: UserUncheckedCreateWithoutTrainerEventsInput;
  update: UserUncheckedUpdateWithoutTrainerEventsInput;
};

export type UserUpsertWithoutTrainereventDayTimeSlotsInput = {
  create: UserUncheckedCreateWithoutTrainereventDayTimeSlotsInput;
  update: UserUncheckedUpdateWithoutTrainereventDayTimeSlotsInput;
};

export type UserUpsertWithoutTransactionsMediatorInput = {
  create: UserUncheckedCreateWithoutTransactionsMediatorInput;
  update: UserUncheckedUpdateWithoutTransactionsMediatorInput;
};

export type UserUpsertWithoutTransitionsFirstPartyInput = {
  create: UserUncheckedCreateWithoutTransitionsFirstPartyInput;
  update: UserUncheckedUpdateWithoutTransitionsFirstPartyInput;
};

export type UserUpsertWithoutTransitionsSecondPartyInput = {
  create: UserUncheckedCreateWithoutTransitionsSecondPartyInput;
  update: UserUncheckedUpdateWithoutTransitionsSecondPartyInput;
};

export type UserUpsertWithoutUserCouponProfitsInput = {
  create: UserUncheckedCreateWithoutUserCouponProfitsInput;
  update: UserUncheckedUpdateWithoutUserCouponProfitsInput;
};

export type UserUpsertWithoutZohoEmailInput = {
  create: UserUncheckedCreateWithoutZohoEmailInput;
  update: UserUncheckedUpdateWithoutZohoEmailInput;
};

export type UserWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<UserWhereInput>>>;
  Blogs?: InputMaybe<BlogsListRelationFilter>;
  Certificate?: InputMaybe<CertificateListRelationFilter>;
  Discussion?: InputMaybe<DiscussionListRelationFilter>;
  NOT?: InputMaybe<Array<InputMaybe<UserWhereInput>>>;
  Notification?: InputMaybe<NotificationListRelationFilter>;
  OR?: InputMaybe<Array<InputMaybe<UserWhereInput>>>;
  Qualification?: InputMaybe<QualificationWhereInput>;
  QuizResult?: InputMaybe<QuizResultListRelationFilter>;
  ZohoEmail?: InputMaybe<ZohoEmailListRelationFilter>;
  accounts?: InputMaybe<AccountListRelationFilter>;
  addedEvents?: InputMaybe<EventListRelationFilter>;
  adminNotes?: InputMaybe<StringNullableListFilter>;
  applications?: InputMaybe<BecomeTrainerApplicationListRelationFilter>;
  balance?: InputMaybe<DecimalFilter>;
  bankAccount?: InputMaybe<BankAccountWhereInput>;
  birthday?: InputMaybe<DateTimeNullableFilter>;
  city?: InputMaybe<CityWhereInput>;
  cityId?: InputMaybe<IntNullableFilter>;
  commercialRecord?: InputMaybe<StringNullableFilter>;
  country?: InputMaybe<CountryWhereInput>;
  countryId?: InputMaybe<IntNullableFilter>;
  coupons?: InputMaybe<CouponListRelationFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  cv?: InputMaybe<StringNullableFilter>;
  cvId?: InputMaybe<IntNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  email?: InputMaybe<StringFilter>;
  emailVerified?: InputMaybe<DateTimeNullableFilter>;
  eventMediaTracking?: InputMaybe<EventMediaTrackingListRelationFilter>;
  events?: InputMaybe<EventListRelationFilter>;
  fcmToken?: InputMaybe<StringNullableFilter>;
  forgotCode?: InputMaybe<StringNullableFilter>;
  gender?: InputMaybe<EnumGenderNullableFilter>;
  id?: InputMaybe<IntFilter>;
  identityNo?: InputMaybe<BigIntNullableFilter>;
  image?: InputMaybe<StringNullableFilter>;
  invitedUsers?: InputMaybe<UserListRelationFilter>;
  inviter?: InputMaybe<UserWhereInput>;
  inviterCouponProfits?: InputMaybe<InviterCouponProfitListRelationFilter>;
  inviterId?: InputMaybe<IntNullableFilter>;
  lastLogin?: InputMaybe<DateTimeNullableFilter>;
  leaderEventGroups?: InputMaybe<TraineeEventGroupListRelationFilter>;
  linkedIn?: InputMaybe<StringNullableFilter>;
  logoUrl?: InputMaybe<StringNullableFilter>;
  marketerBalance?: InputMaybe<DecimalFilter>;
  memberNeeds?: InputMaybe<MemberNeedsListRelationFilter>;
  mobileNumber?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  nameAr?: InputMaybe<StringNullableFilter>;
  nameOnCommercialRecord?: InputMaybe<StringNullableFilter>;
  nationality?: InputMaybe<CountryWhereInput>;
  nationalityId?: InputMaybe<IntNullableFilter>;
  password?: InputMaybe<StringNullableFilter>;
  profession?: InputMaybe<ProfessionWhereInput>;
  professionId?: InputMaybe<IntNullableFilter>;
  qualificationId?: InputMaybe<IntNullableFilter>;
  remindMeEvents?: InputMaybe<EventListRelationFilter>;
  role?: InputMaybe<RoleWhereInput>;
  roleId?: InputMaybe<IntFilter>;
  scfhs?: InputMaybe<StringNullableFilter>;
  scfhsExp?: InputMaybe<DateTimeNullableFilter>;
  sessions?: InputMaybe<SessionListRelationFilter>;
  specialty?: InputMaybe<SpecialtyWhereInput>;
  specialtyId?: InputMaybe<IntNullableFilter>;
  state?: InputMaybe<StateWhereInput>;
  stateId?: InputMaybe<IntNullableFilter>;
  traineeEventInvites?: InputMaybe<TraineeEventListRelationFilter>;
  traineeEvents?: InputMaybe<TraineeEventListRelationFilter>;
  trainerCv?: InputMaybe<CvWhereInput>;
  trainerEvents?: InputMaybe<TrainerEventListRelationFilter>;
  trainereventDayTimeSlots?: InputMaybe<TrainerEventDayTimeSlotListRelationFilter>;
  transactionsMediator?: InputMaybe<TransitionListRelationFilter>;
  transitionsFirstParty?: InputMaybe<TransitionListRelationFilter>;
  transitionsSecondParty?: InputMaybe<TransitionListRelationFilter>;
  twitter?: InputMaybe<StringNullableFilter>;
  userCouponProfits?: InputMaybe<InviterCouponProfitListRelationFilter>;
  userEmailVerified?: InputMaybe<BoolNullableFilter>;
  username?: InputMaybe<StringNullableFilter>;
  verifyEmailCode?: InputMaybe<StringNullableFilter>;
  visitedEvents?: InputMaybe<EventListRelationFilter>;
};

export type UserWhereUniqueInput = {
  cvId?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  forgotCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  username?: InputMaybe<Scalars['String']>;
  verifyEmailCode?: InputMaybe<Scalars['String']>;
};

export enum Variance {
  Monthly = 'monthly',
  Yearly = 'yearly'
}

export type VerificationToken = {
  __typename?: 'VerificationToken';
  expires: Scalars['DateTime'];
  identifier: Scalars['String'];
  token: Scalars['String'];
};

export type VerificationTokenCountAggregateOutputType = {
  __typename?: 'VerificationTokenCountAggregateOutputType';
  _all: Scalars['Int'];
  expires: Scalars['Int'];
  identifier: Scalars['Int'];
  token: Scalars['Int'];
};

export type VerificationTokenCountOrderByAggregateInput = {
  expires?: InputMaybe<SortOrder>;
  identifier?: InputMaybe<SortOrder>;
  token?: InputMaybe<SortOrder>;
};

export type VerificationTokenCreateInput = {
  expires: Scalars['DateTime'];
  identifier: Scalars['String'];
  token: Scalars['String'];
};

export type VerificationTokenCreateManyInput = {
  expires: Scalars['DateTime'];
  identifier: Scalars['String'];
  token: Scalars['String'];
};

export type VerificationTokenIdentifierTokenCompoundUniqueInput = {
  identifier: Scalars['String'];
  token: Scalars['String'];
};

export type VerificationTokenMaxAggregateOutputType = {
  __typename?: 'VerificationTokenMaxAggregateOutputType';
  expires?: Maybe<Scalars['DateTime']>;
  identifier?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type VerificationTokenMaxOrderByAggregateInput = {
  expires?: InputMaybe<SortOrder>;
  identifier?: InputMaybe<SortOrder>;
  token?: InputMaybe<SortOrder>;
};

export type VerificationTokenMinAggregateOutputType = {
  __typename?: 'VerificationTokenMinAggregateOutputType';
  expires?: Maybe<Scalars['DateTime']>;
  identifier?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type VerificationTokenMinOrderByAggregateInput = {
  expires?: InputMaybe<SortOrder>;
  identifier?: InputMaybe<SortOrder>;
  token?: InputMaybe<SortOrder>;
};

export type VerificationTokenOrderByWithAggregationInput = {
  _count?: InputMaybe<VerificationTokenCountOrderByAggregateInput>;
  _max?: InputMaybe<VerificationTokenMaxOrderByAggregateInput>;
  _min?: InputMaybe<VerificationTokenMinOrderByAggregateInput>;
  expires?: InputMaybe<SortOrder>;
  identifier?: InputMaybe<SortOrder>;
  token?: InputMaybe<SortOrder>;
};

export type VerificationTokenOrderByWithRelationInput = {
  expires?: InputMaybe<SortOrder>;
  identifier?: InputMaybe<SortOrder>;
  token?: InputMaybe<SortOrder>;
};

export enum VerificationTokenScalarFieldEnum {
  Expires = 'expires',
  Identifier = 'identifier',
  Token = 'token'
}

export type VerificationTokenScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<VerificationTokenScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<VerificationTokenScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<VerificationTokenScalarWhereWithAggregatesInput>>>;
  expires?: InputMaybe<DateTimeWithAggregatesFilter>;
  identifier?: InputMaybe<StringWithAggregatesFilter>;
  token?: InputMaybe<StringWithAggregatesFilter>;
};

export type VerificationTokenUncheckedCreateInput = {
  expires: Scalars['DateTime'];
  identifier: Scalars['String'];
  token: Scalars['String'];
};

export type VerificationTokenUncheckedUpdateInput = {
  expires?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  token?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type VerificationTokenUncheckedUpdateManyInput = {
  expires?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  token?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type VerificationTokenUpdateInput = {
  expires?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  token?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type VerificationTokenUpdateManyMutationInput = {
  expires?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  token?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type VerificationTokenWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<VerificationTokenWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<VerificationTokenWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<VerificationTokenWhereInput>>>;
  expires?: InputMaybe<DateTimeFilter>;
  identifier?: InputMaybe<StringFilter>;
  token?: InputMaybe<StringFilter>;
};

export type VerificationTokenWhereUniqueInput = {
  identifier_token?: InputMaybe<VerificationTokenIdentifierTokenCompoundUniqueInput>;
  token?: InputMaybe<Scalars['String']>;
};

export type WaStateType = {
  __typename?: 'WAStateType';
  ProfilePicUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  pushName?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  wid?: Maybe<Scalars['String']>;
};

export type ZohoEmail = {
  __typename?: 'ZohoEmail';
  Event?: Maybe<Event>;
  Template?: Maybe<Template>;
  TraineeEvent?: Maybe<TraineeEvent>;
  TrainerEvent?: Maybe<TrainerEvent>;
  User?: Maybe<User>;
  clicked: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  eventId?: Maybe<Scalars['Int']>;
  hardBounce: Scalars['Boolean'];
  htmlData?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  opened: Scalars['Boolean'];
  request_id: Scalars['String'];
  sent: Scalars['Boolean'];
  softBounce: Scalars['Boolean'];
  subject?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['Int']>;
  traineeEventId?: Maybe<Scalars['Int']>;
  trainerEventId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

export type ZohoEmailAvgAggregateOutputType = {
  __typename?: 'ZohoEmailAvgAggregateOutputType';
  eventId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  templateId?: Maybe<Scalars['Float']>;
  traineeEventId?: Maybe<Scalars['Float']>;
  trainerEventId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

export type ZohoEmailAvgOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  templateId?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type ZohoEmailCountAggregateOutputType = {
  __typename?: 'ZohoEmailCountAggregateOutputType';
  _all: Scalars['Int'];
  clicked: Scalars['Int'];
  createdAt: Scalars['Int'];
  eventId: Scalars['Int'];
  hardBounce: Scalars['Int'];
  htmlData: Scalars['Int'];
  id: Scalars['Int'];
  opened: Scalars['Int'];
  request_id: Scalars['Int'];
  sent: Scalars['Int'];
  softBounce: Scalars['Int'];
  subject: Scalars['Int'];
  templateId: Scalars['Int'];
  traineeEventId: Scalars['Int'];
  trainerEventId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type ZohoEmailCountOrderByAggregateInput = {
  clicked?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  hardBounce?: InputMaybe<SortOrder>;
  htmlData?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  opened?: InputMaybe<SortOrder>;
  request_id?: InputMaybe<SortOrder>;
  sent?: InputMaybe<SortOrder>;
  softBounce?: InputMaybe<SortOrder>;
  subject?: InputMaybe<SortOrder>;
  templateId?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type ZohoEmailCreateInput = {
  Event?: InputMaybe<EventCreateNestedOneWithoutZohoEmailInput>;
  Template?: InputMaybe<TemplateCreateNestedOneWithoutZohoEmailInput>;
  TraineeEvent?: InputMaybe<TraineeEventCreateNestedOneWithoutZohoEmailInput>;
  TrainerEvent?: InputMaybe<TrainerEventCreateNestedOneWithoutZohoEmailInput>;
  User?: InputMaybe<UserCreateNestedOneWithoutZohoEmailInput>;
  clicked?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  hardBounce?: InputMaybe<Scalars['Boolean']>;
  htmlData?: InputMaybe<Scalars['String']>;
  opened?: InputMaybe<Scalars['Boolean']>;
  request_id: Scalars['String'];
  sent?: InputMaybe<Scalars['Boolean']>;
  softBounce?: InputMaybe<Scalars['Boolean']>;
  subject?: InputMaybe<Scalars['String']>;
};

export type ZohoEmailCreateManyEventInput = {
  clicked?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  hardBounce?: InputMaybe<Scalars['Boolean']>;
  htmlData?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  opened?: InputMaybe<Scalars['Boolean']>;
  request_id: Scalars['String'];
  sent?: InputMaybe<Scalars['Boolean']>;
  softBounce?: InputMaybe<Scalars['Boolean']>;
  subject?: InputMaybe<Scalars['String']>;
  templateId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type ZohoEmailCreateManyEventInputEnvelope = {
  data: ZohoEmailCreateManyEventInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ZohoEmailCreateManyInput = {
  clicked?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  eventId?: InputMaybe<Scalars['Int']>;
  hardBounce?: InputMaybe<Scalars['Boolean']>;
  htmlData?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  opened?: InputMaybe<Scalars['Boolean']>;
  request_id: Scalars['String'];
  sent?: InputMaybe<Scalars['Boolean']>;
  softBounce?: InputMaybe<Scalars['Boolean']>;
  subject?: InputMaybe<Scalars['String']>;
  templateId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type ZohoEmailCreateManyTemplateInput = {
  clicked?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  eventId?: InputMaybe<Scalars['Int']>;
  hardBounce?: InputMaybe<Scalars['Boolean']>;
  htmlData?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  opened?: InputMaybe<Scalars['Boolean']>;
  request_id: Scalars['String'];
  sent?: InputMaybe<Scalars['Boolean']>;
  softBounce?: InputMaybe<Scalars['Boolean']>;
  subject?: InputMaybe<Scalars['String']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type ZohoEmailCreateManyTemplateInputEnvelope = {
  data: ZohoEmailCreateManyTemplateInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ZohoEmailCreateManyTraineeEventInput = {
  clicked?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  eventId?: InputMaybe<Scalars['Int']>;
  hardBounce?: InputMaybe<Scalars['Boolean']>;
  htmlData?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  opened?: InputMaybe<Scalars['Boolean']>;
  request_id: Scalars['String'];
  sent?: InputMaybe<Scalars['Boolean']>;
  softBounce?: InputMaybe<Scalars['Boolean']>;
  subject?: InputMaybe<Scalars['String']>;
  templateId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type ZohoEmailCreateManyTraineeEventInputEnvelope = {
  data: ZohoEmailCreateManyTraineeEventInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ZohoEmailCreateManyTrainerEventInput = {
  clicked?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  eventId?: InputMaybe<Scalars['Int']>;
  hardBounce?: InputMaybe<Scalars['Boolean']>;
  htmlData?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  opened?: InputMaybe<Scalars['Boolean']>;
  request_id: Scalars['String'];
  sent?: InputMaybe<Scalars['Boolean']>;
  softBounce?: InputMaybe<Scalars['Boolean']>;
  subject?: InputMaybe<Scalars['String']>;
  templateId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type ZohoEmailCreateManyTrainerEventInputEnvelope = {
  data: ZohoEmailCreateManyTrainerEventInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ZohoEmailCreateManyUserInput = {
  clicked?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  eventId?: InputMaybe<Scalars['Int']>;
  hardBounce?: InputMaybe<Scalars['Boolean']>;
  htmlData?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  opened?: InputMaybe<Scalars['Boolean']>;
  request_id: Scalars['String'];
  sent?: InputMaybe<Scalars['Boolean']>;
  softBounce?: InputMaybe<Scalars['Boolean']>;
  subject?: InputMaybe<Scalars['String']>;
  templateId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
};

export type ZohoEmailCreateManyUserInputEnvelope = {
  data: ZohoEmailCreateManyUserInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ZohoEmailCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ZohoEmailCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<ZohoEmailCreateWithoutEventInput>>>;
  createMany?: InputMaybe<ZohoEmailCreateManyEventInputEnvelope>;
};

export type ZohoEmailCreateNestedManyWithoutTemplateInput = {
  connect?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ZohoEmailCreateOrConnectWithoutTemplateInput>>>;
  create?: InputMaybe<Array<InputMaybe<ZohoEmailCreateWithoutTemplateInput>>>;
  createMany?: InputMaybe<ZohoEmailCreateManyTemplateInputEnvelope>;
};

export type ZohoEmailCreateNestedManyWithoutTraineeEventInput = {
  connect?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ZohoEmailCreateOrConnectWithoutTraineeEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<ZohoEmailCreateWithoutTraineeEventInput>>>;
  createMany?: InputMaybe<ZohoEmailCreateManyTraineeEventInputEnvelope>;
};

export type ZohoEmailCreateNestedManyWithoutTrainerEventInput = {
  connect?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ZohoEmailCreateOrConnectWithoutTrainerEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<ZohoEmailCreateWithoutTrainerEventInput>>>;
  createMany?: InputMaybe<ZohoEmailCreateManyTrainerEventInputEnvelope>;
};

export type ZohoEmailCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ZohoEmailCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<ZohoEmailCreateWithoutUserInput>>>;
  createMany?: InputMaybe<ZohoEmailCreateManyUserInputEnvelope>;
};

export type ZohoEmailCreateOrConnectWithoutEventInput = {
  create: ZohoEmailUncheckedCreateWithoutEventInput;
  where: ZohoEmailWhereUniqueInput;
};

export type ZohoEmailCreateOrConnectWithoutTemplateInput = {
  create: ZohoEmailUncheckedCreateWithoutTemplateInput;
  where: ZohoEmailWhereUniqueInput;
};

export type ZohoEmailCreateOrConnectWithoutTraineeEventInput = {
  create: ZohoEmailUncheckedCreateWithoutTraineeEventInput;
  where: ZohoEmailWhereUniqueInput;
};

export type ZohoEmailCreateOrConnectWithoutTrainerEventInput = {
  create: ZohoEmailUncheckedCreateWithoutTrainerEventInput;
  where: ZohoEmailWhereUniqueInput;
};

export type ZohoEmailCreateOrConnectWithoutUserInput = {
  create: ZohoEmailUncheckedCreateWithoutUserInput;
  where: ZohoEmailWhereUniqueInput;
};

export type ZohoEmailCreateWithoutEventInput = {
  Template?: InputMaybe<TemplateCreateNestedOneWithoutZohoEmailInput>;
  TraineeEvent?: InputMaybe<TraineeEventCreateNestedOneWithoutZohoEmailInput>;
  TrainerEvent?: InputMaybe<TrainerEventCreateNestedOneWithoutZohoEmailInput>;
  User?: InputMaybe<UserCreateNestedOneWithoutZohoEmailInput>;
  clicked?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  hardBounce?: InputMaybe<Scalars['Boolean']>;
  htmlData?: InputMaybe<Scalars['String']>;
  opened?: InputMaybe<Scalars['Boolean']>;
  request_id: Scalars['String'];
  sent?: InputMaybe<Scalars['Boolean']>;
  softBounce?: InputMaybe<Scalars['Boolean']>;
  subject?: InputMaybe<Scalars['String']>;
};

export type ZohoEmailCreateWithoutTemplateInput = {
  Event?: InputMaybe<EventCreateNestedOneWithoutZohoEmailInput>;
  TraineeEvent?: InputMaybe<TraineeEventCreateNestedOneWithoutZohoEmailInput>;
  TrainerEvent?: InputMaybe<TrainerEventCreateNestedOneWithoutZohoEmailInput>;
  User?: InputMaybe<UserCreateNestedOneWithoutZohoEmailInput>;
  clicked?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  hardBounce?: InputMaybe<Scalars['Boolean']>;
  htmlData?: InputMaybe<Scalars['String']>;
  opened?: InputMaybe<Scalars['Boolean']>;
  request_id: Scalars['String'];
  sent?: InputMaybe<Scalars['Boolean']>;
  softBounce?: InputMaybe<Scalars['Boolean']>;
  subject?: InputMaybe<Scalars['String']>;
};

export type ZohoEmailCreateWithoutTraineeEventInput = {
  Event?: InputMaybe<EventCreateNestedOneWithoutZohoEmailInput>;
  Template?: InputMaybe<TemplateCreateNestedOneWithoutZohoEmailInput>;
  TrainerEvent?: InputMaybe<TrainerEventCreateNestedOneWithoutZohoEmailInput>;
  User?: InputMaybe<UserCreateNestedOneWithoutZohoEmailInput>;
  clicked?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  hardBounce?: InputMaybe<Scalars['Boolean']>;
  htmlData?: InputMaybe<Scalars['String']>;
  opened?: InputMaybe<Scalars['Boolean']>;
  request_id: Scalars['String'];
  sent?: InputMaybe<Scalars['Boolean']>;
  softBounce?: InputMaybe<Scalars['Boolean']>;
  subject?: InputMaybe<Scalars['String']>;
};

export type ZohoEmailCreateWithoutTrainerEventInput = {
  Event?: InputMaybe<EventCreateNestedOneWithoutZohoEmailInput>;
  Template?: InputMaybe<TemplateCreateNestedOneWithoutZohoEmailInput>;
  TraineeEvent?: InputMaybe<TraineeEventCreateNestedOneWithoutZohoEmailInput>;
  User?: InputMaybe<UserCreateNestedOneWithoutZohoEmailInput>;
  clicked?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  hardBounce?: InputMaybe<Scalars['Boolean']>;
  htmlData?: InputMaybe<Scalars['String']>;
  opened?: InputMaybe<Scalars['Boolean']>;
  request_id: Scalars['String'];
  sent?: InputMaybe<Scalars['Boolean']>;
  softBounce?: InputMaybe<Scalars['Boolean']>;
  subject?: InputMaybe<Scalars['String']>;
};

export type ZohoEmailCreateWithoutUserInput = {
  Event?: InputMaybe<EventCreateNestedOneWithoutZohoEmailInput>;
  Template?: InputMaybe<TemplateCreateNestedOneWithoutZohoEmailInput>;
  TraineeEvent?: InputMaybe<TraineeEventCreateNestedOneWithoutZohoEmailInput>;
  TrainerEvent?: InputMaybe<TrainerEventCreateNestedOneWithoutZohoEmailInput>;
  clicked?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  hardBounce?: InputMaybe<Scalars['Boolean']>;
  htmlData?: InputMaybe<Scalars['String']>;
  opened?: InputMaybe<Scalars['Boolean']>;
  request_id: Scalars['String'];
  sent?: InputMaybe<Scalars['Boolean']>;
  softBounce?: InputMaybe<Scalars['Boolean']>;
  subject?: InputMaybe<Scalars['String']>;
};

export type ZohoEmailListRelationFilter = {
  every?: InputMaybe<ZohoEmailWhereInput>;
  none?: InputMaybe<ZohoEmailWhereInput>;
  some?: InputMaybe<ZohoEmailWhereInput>;
};

export type ZohoEmailMaxAggregateOutputType = {
  __typename?: 'ZohoEmailMaxAggregateOutputType';
  clicked?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  eventId?: Maybe<Scalars['Int']>;
  hardBounce?: Maybe<Scalars['Boolean']>;
  htmlData?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  opened?: Maybe<Scalars['Boolean']>;
  request_id?: Maybe<Scalars['String']>;
  sent?: Maybe<Scalars['Boolean']>;
  softBounce?: Maybe<Scalars['Boolean']>;
  subject?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['Int']>;
  traineeEventId?: Maybe<Scalars['Int']>;
  trainerEventId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

export type ZohoEmailMaxOrderByAggregateInput = {
  clicked?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  hardBounce?: InputMaybe<SortOrder>;
  htmlData?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  opened?: InputMaybe<SortOrder>;
  request_id?: InputMaybe<SortOrder>;
  sent?: InputMaybe<SortOrder>;
  softBounce?: InputMaybe<SortOrder>;
  subject?: InputMaybe<SortOrder>;
  templateId?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type ZohoEmailMinAggregateOutputType = {
  __typename?: 'ZohoEmailMinAggregateOutputType';
  clicked?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  eventId?: Maybe<Scalars['Int']>;
  hardBounce?: Maybe<Scalars['Boolean']>;
  htmlData?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  opened?: Maybe<Scalars['Boolean']>;
  request_id?: Maybe<Scalars['String']>;
  sent?: Maybe<Scalars['Boolean']>;
  softBounce?: Maybe<Scalars['Boolean']>;
  subject?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['Int']>;
  traineeEventId?: Maybe<Scalars['Int']>;
  trainerEventId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

export type ZohoEmailMinOrderByAggregateInput = {
  clicked?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  hardBounce?: InputMaybe<SortOrder>;
  htmlData?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  opened?: InputMaybe<SortOrder>;
  request_id?: InputMaybe<SortOrder>;
  sent?: InputMaybe<SortOrder>;
  softBounce?: InputMaybe<SortOrder>;
  subject?: InputMaybe<SortOrder>;
  templateId?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type ZohoEmailOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ZohoEmailOrderByWithAggregationInput = {
  _avg?: InputMaybe<ZohoEmailAvgOrderByAggregateInput>;
  _count?: InputMaybe<ZohoEmailCountOrderByAggregateInput>;
  _max?: InputMaybe<ZohoEmailMaxOrderByAggregateInput>;
  _min?: InputMaybe<ZohoEmailMinOrderByAggregateInput>;
  _sum?: InputMaybe<ZohoEmailSumOrderByAggregateInput>;
  clicked?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  hardBounce?: InputMaybe<SortOrder>;
  htmlData?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  opened?: InputMaybe<SortOrder>;
  request_id?: InputMaybe<SortOrder>;
  sent?: InputMaybe<SortOrder>;
  softBounce?: InputMaybe<SortOrder>;
  subject?: InputMaybe<SortOrder>;
  templateId?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type ZohoEmailOrderByWithRelationInput = {
  Event?: InputMaybe<EventOrderByWithRelationInput>;
  Template?: InputMaybe<TemplateOrderByWithRelationInput>;
  TraineeEvent?: InputMaybe<TraineeEventOrderByWithRelationInput>;
  TrainerEvent?: InputMaybe<TrainerEventOrderByWithRelationInput>;
  User?: InputMaybe<UserOrderByWithRelationInput>;
  clicked?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  hardBounce?: InputMaybe<SortOrder>;
  htmlData?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  opened?: InputMaybe<SortOrder>;
  request_id?: InputMaybe<SortOrder>;
  sent?: InputMaybe<SortOrder>;
  softBounce?: InputMaybe<SortOrder>;
  subject?: InputMaybe<SortOrder>;
  templateId?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export enum ZohoEmailScalarFieldEnum {
  Clicked = 'clicked',
  CreatedAt = 'createdAt',
  EventId = 'eventId',
  HardBounce = 'hardBounce',
  HtmlData = 'htmlData',
  Id = 'id',
  Opened = 'opened',
  RequestId = 'request_id',
  Sent = 'sent',
  SoftBounce = 'softBounce',
  Subject = 'subject',
  TemplateId = 'templateId',
  TraineeEventId = 'traineeEventId',
  TrainerEventId = 'trainerEventId',
  UserId = 'userId'
}

export type ZohoEmailScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ZohoEmailScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ZohoEmailScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ZohoEmailScalarWhereInput>>>;
  clicked?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  eventId?: InputMaybe<IntNullableFilter>;
  hardBounce?: InputMaybe<BoolFilter>;
  htmlData?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  opened?: InputMaybe<BoolFilter>;
  request_id?: InputMaybe<StringFilter>;
  sent?: InputMaybe<BoolFilter>;
  softBounce?: InputMaybe<BoolFilter>;
  subject?: InputMaybe<StringNullableFilter>;
  templateId?: InputMaybe<IntNullableFilter>;
  traineeEventId?: InputMaybe<IntNullableFilter>;
  trainerEventId?: InputMaybe<IntNullableFilter>;
  userId?: InputMaybe<IntNullableFilter>;
};

export type ZohoEmailScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<ZohoEmailScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ZohoEmailScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ZohoEmailScalarWhereWithAggregatesInput>>>;
  clicked?: InputMaybe<BoolWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  eventId?: InputMaybe<IntNullableWithAggregatesFilter>;
  hardBounce?: InputMaybe<BoolWithAggregatesFilter>;
  htmlData?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  opened?: InputMaybe<BoolWithAggregatesFilter>;
  request_id?: InputMaybe<StringWithAggregatesFilter>;
  sent?: InputMaybe<BoolWithAggregatesFilter>;
  softBounce?: InputMaybe<BoolWithAggregatesFilter>;
  subject?: InputMaybe<StringNullableWithAggregatesFilter>;
  templateId?: InputMaybe<IntNullableWithAggregatesFilter>;
  traineeEventId?: InputMaybe<IntNullableWithAggregatesFilter>;
  trainerEventId?: InputMaybe<IntNullableWithAggregatesFilter>;
  userId?: InputMaybe<IntNullableWithAggregatesFilter>;
};

export type ZohoEmailSumAggregateOutputType = {
  __typename?: 'ZohoEmailSumAggregateOutputType';
  eventId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  templateId?: Maybe<Scalars['Int']>;
  traineeEventId?: Maybe<Scalars['Int']>;
  trainerEventId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

export type ZohoEmailSumOrderByAggregateInput = {
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  templateId?: InputMaybe<SortOrder>;
  traineeEventId?: InputMaybe<SortOrder>;
  trainerEventId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type ZohoEmailUncheckedCreateInput = {
  clicked?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  eventId?: InputMaybe<Scalars['Int']>;
  hardBounce?: InputMaybe<Scalars['Boolean']>;
  htmlData?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  opened?: InputMaybe<Scalars['Boolean']>;
  request_id: Scalars['String'];
  sent?: InputMaybe<Scalars['Boolean']>;
  softBounce?: InputMaybe<Scalars['Boolean']>;
  subject?: InputMaybe<Scalars['String']>;
  templateId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type ZohoEmailUncheckedCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ZohoEmailCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<ZohoEmailCreateWithoutEventInput>>>;
  createMany?: InputMaybe<ZohoEmailCreateManyEventInputEnvelope>;
};

export type ZohoEmailUncheckedCreateNestedManyWithoutTemplateInput = {
  connect?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ZohoEmailCreateOrConnectWithoutTemplateInput>>>;
  create?: InputMaybe<Array<InputMaybe<ZohoEmailCreateWithoutTemplateInput>>>;
  createMany?: InputMaybe<ZohoEmailCreateManyTemplateInputEnvelope>;
};

export type ZohoEmailUncheckedCreateNestedManyWithoutTraineeEventInput = {
  connect?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ZohoEmailCreateOrConnectWithoutTraineeEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<ZohoEmailCreateWithoutTraineeEventInput>>>;
  createMany?: InputMaybe<ZohoEmailCreateManyTraineeEventInputEnvelope>;
};

export type ZohoEmailUncheckedCreateNestedManyWithoutTrainerEventInput = {
  connect?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ZohoEmailCreateOrConnectWithoutTrainerEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<ZohoEmailCreateWithoutTrainerEventInput>>>;
  createMany?: InputMaybe<ZohoEmailCreateManyTrainerEventInputEnvelope>;
};

export type ZohoEmailUncheckedCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ZohoEmailCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<ZohoEmailCreateWithoutUserInput>>>;
  createMany?: InputMaybe<ZohoEmailCreateManyUserInputEnvelope>;
};

export type ZohoEmailUncheckedCreateWithoutEventInput = {
  clicked?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  hardBounce?: InputMaybe<Scalars['Boolean']>;
  htmlData?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  opened?: InputMaybe<Scalars['Boolean']>;
  request_id: Scalars['String'];
  sent?: InputMaybe<Scalars['Boolean']>;
  softBounce?: InputMaybe<Scalars['Boolean']>;
  subject?: InputMaybe<Scalars['String']>;
  templateId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type ZohoEmailUncheckedCreateWithoutTemplateInput = {
  clicked?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  eventId?: InputMaybe<Scalars['Int']>;
  hardBounce?: InputMaybe<Scalars['Boolean']>;
  htmlData?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  opened?: InputMaybe<Scalars['Boolean']>;
  request_id: Scalars['String'];
  sent?: InputMaybe<Scalars['Boolean']>;
  softBounce?: InputMaybe<Scalars['Boolean']>;
  subject?: InputMaybe<Scalars['String']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type ZohoEmailUncheckedCreateWithoutTraineeEventInput = {
  clicked?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  eventId?: InputMaybe<Scalars['Int']>;
  hardBounce?: InputMaybe<Scalars['Boolean']>;
  htmlData?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  opened?: InputMaybe<Scalars['Boolean']>;
  request_id: Scalars['String'];
  sent?: InputMaybe<Scalars['Boolean']>;
  softBounce?: InputMaybe<Scalars['Boolean']>;
  subject?: InputMaybe<Scalars['String']>;
  templateId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type ZohoEmailUncheckedCreateWithoutTrainerEventInput = {
  clicked?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  eventId?: InputMaybe<Scalars['Int']>;
  hardBounce?: InputMaybe<Scalars['Boolean']>;
  htmlData?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  opened?: InputMaybe<Scalars['Boolean']>;
  request_id: Scalars['String'];
  sent?: InputMaybe<Scalars['Boolean']>;
  softBounce?: InputMaybe<Scalars['Boolean']>;
  subject?: InputMaybe<Scalars['String']>;
  templateId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type ZohoEmailUncheckedCreateWithoutUserInput = {
  clicked?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  eventId?: InputMaybe<Scalars['Int']>;
  hardBounce?: InputMaybe<Scalars['Boolean']>;
  htmlData?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  opened?: InputMaybe<Scalars['Boolean']>;
  request_id: Scalars['String'];
  sent?: InputMaybe<Scalars['Boolean']>;
  softBounce?: InputMaybe<Scalars['Boolean']>;
  subject?: InputMaybe<Scalars['String']>;
  templateId?: InputMaybe<Scalars['Int']>;
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
};

export type ZohoEmailUncheckedUpdateInput = {
  clicked?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hardBounce?: InputMaybe<BoolFieldUpdateOperationsInput>;
  htmlData?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  opened?: InputMaybe<BoolFieldUpdateOperationsInput>;
  request_id?: InputMaybe<StringFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  softBounce?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  templateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ZohoEmailUncheckedUpdateManyInput = {
  clicked?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hardBounce?: InputMaybe<BoolFieldUpdateOperationsInput>;
  htmlData?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  opened?: InputMaybe<BoolFieldUpdateOperationsInput>;
  request_id?: InputMaybe<StringFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  softBounce?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  templateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ZohoEmailUncheckedUpdateManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ZohoEmailCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<ZohoEmailCreateWithoutEventInput>>>;
  createMany?: InputMaybe<ZohoEmailCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ZohoEmailScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ZohoEmailUpdateWithWhereUniqueWithoutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ZohoEmailUpdateManyWithWhereWithoutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ZohoEmailUpsertWithWhereUniqueWithoutEventInput>>>;
};

export type ZohoEmailUncheckedUpdateManyWithoutTemplateInput = {
  connect?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ZohoEmailCreateOrConnectWithoutTemplateInput>>>;
  create?: InputMaybe<Array<InputMaybe<ZohoEmailCreateWithoutTemplateInput>>>;
  createMany?: InputMaybe<ZohoEmailCreateManyTemplateInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ZohoEmailScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ZohoEmailUpdateWithWhereUniqueWithoutTemplateInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ZohoEmailUpdateManyWithWhereWithoutTemplateInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ZohoEmailUpsertWithWhereUniqueWithoutTemplateInput>>>;
};

export type ZohoEmailUncheckedUpdateManyWithoutTraineeEventInput = {
  connect?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ZohoEmailCreateOrConnectWithoutTraineeEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<ZohoEmailCreateWithoutTraineeEventInput>>>;
  createMany?: InputMaybe<ZohoEmailCreateManyTraineeEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ZohoEmailScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ZohoEmailUpdateWithWhereUniqueWithoutTraineeEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ZohoEmailUpdateManyWithWhereWithoutTraineeEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ZohoEmailUpsertWithWhereUniqueWithoutTraineeEventInput>>>;
};

export type ZohoEmailUncheckedUpdateManyWithoutTrainerEventInput = {
  connect?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ZohoEmailCreateOrConnectWithoutTrainerEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<ZohoEmailCreateWithoutTrainerEventInput>>>;
  createMany?: InputMaybe<ZohoEmailCreateManyTrainerEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ZohoEmailScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ZohoEmailUpdateWithWhereUniqueWithoutTrainerEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ZohoEmailUpdateManyWithWhereWithoutTrainerEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ZohoEmailUpsertWithWhereUniqueWithoutTrainerEventInput>>>;
};

export type ZohoEmailUncheckedUpdateManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ZohoEmailCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<ZohoEmailCreateWithoutUserInput>>>;
  createMany?: InputMaybe<ZohoEmailCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ZohoEmailScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ZohoEmailUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ZohoEmailUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ZohoEmailUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type ZohoEmailUncheckedUpdateManyWithoutZohoEmailInput = {
  clicked?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hardBounce?: InputMaybe<BoolFieldUpdateOperationsInput>;
  htmlData?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  opened?: InputMaybe<BoolFieldUpdateOperationsInput>;
  request_id?: InputMaybe<StringFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  softBounce?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  templateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ZohoEmailUncheckedUpdateWithoutEventInput = {
  clicked?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  hardBounce?: InputMaybe<BoolFieldUpdateOperationsInput>;
  htmlData?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  opened?: InputMaybe<BoolFieldUpdateOperationsInput>;
  request_id?: InputMaybe<StringFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  softBounce?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  templateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ZohoEmailUncheckedUpdateWithoutTemplateInput = {
  clicked?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hardBounce?: InputMaybe<BoolFieldUpdateOperationsInput>;
  htmlData?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  opened?: InputMaybe<BoolFieldUpdateOperationsInput>;
  request_id?: InputMaybe<StringFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  softBounce?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ZohoEmailUncheckedUpdateWithoutTraineeEventInput = {
  clicked?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hardBounce?: InputMaybe<BoolFieldUpdateOperationsInput>;
  htmlData?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  opened?: InputMaybe<BoolFieldUpdateOperationsInput>;
  request_id?: InputMaybe<StringFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  softBounce?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  templateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ZohoEmailUncheckedUpdateWithoutTrainerEventInput = {
  clicked?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hardBounce?: InputMaybe<BoolFieldUpdateOperationsInput>;
  htmlData?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  opened?: InputMaybe<BoolFieldUpdateOperationsInput>;
  request_id?: InputMaybe<StringFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  softBounce?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  templateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ZohoEmailUncheckedUpdateWithoutUserInput = {
  clicked?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  eventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hardBounce?: InputMaybe<BoolFieldUpdateOperationsInput>;
  htmlData?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  opened?: InputMaybe<BoolFieldUpdateOperationsInput>;
  request_id?: InputMaybe<StringFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  softBounce?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  templateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  traineeEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  trainerEventId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ZohoEmailUpdateInput = {
  Event?: InputMaybe<EventUpdateOneWithoutZohoEmailInput>;
  Template?: InputMaybe<TemplateUpdateOneWithoutZohoEmailInput>;
  TraineeEvent?: InputMaybe<TraineeEventUpdateOneWithoutZohoEmailInput>;
  TrainerEvent?: InputMaybe<TrainerEventUpdateOneWithoutZohoEmailInput>;
  User?: InputMaybe<UserUpdateOneWithoutZohoEmailInput>;
  clicked?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  hardBounce?: InputMaybe<BoolFieldUpdateOperationsInput>;
  htmlData?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  opened?: InputMaybe<BoolFieldUpdateOperationsInput>;
  request_id?: InputMaybe<StringFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  softBounce?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ZohoEmailUpdateManyMutationInput = {
  clicked?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  hardBounce?: InputMaybe<BoolFieldUpdateOperationsInput>;
  htmlData?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  opened?: InputMaybe<BoolFieldUpdateOperationsInput>;
  request_id?: InputMaybe<StringFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  softBounce?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ZohoEmailUpdateManyWithWhereWithoutEventInput = {
  data: ZohoEmailUncheckedUpdateManyWithoutZohoEmailInput;
  where: ZohoEmailScalarWhereInput;
};

export type ZohoEmailUpdateManyWithWhereWithoutTemplateInput = {
  data: ZohoEmailUncheckedUpdateManyWithoutZohoEmailInput;
  where: ZohoEmailScalarWhereInput;
};

export type ZohoEmailUpdateManyWithWhereWithoutTraineeEventInput = {
  data: ZohoEmailUncheckedUpdateManyWithoutZohoEmailInput;
  where: ZohoEmailScalarWhereInput;
};

export type ZohoEmailUpdateManyWithWhereWithoutTrainerEventInput = {
  data: ZohoEmailUncheckedUpdateManyWithoutZohoEmailInput;
  where: ZohoEmailScalarWhereInput;
};

export type ZohoEmailUpdateManyWithWhereWithoutUserInput = {
  data: ZohoEmailUncheckedUpdateManyWithoutZohoEmailInput;
  where: ZohoEmailScalarWhereInput;
};

export type ZohoEmailUpdateManyWithoutEventInput = {
  connect?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ZohoEmailCreateOrConnectWithoutEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<ZohoEmailCreateWithoutEventInput>>>;
  createMany?: InputMaybe<ZohoEmailCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ZohoEmailScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ZohoEmailUpdateWithWhereUniqueWithoutEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ZohoEmailUpdateManyWithWhereWithoutEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ZohoEmailUpsertWithWhereUniqueWithoutEventInput>>>;
};

export type ZohoEmailUpdateManyWithoutTemplateInput = {
  connect?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ZohoEmailCreateOrConnectWithoutTemplateInput>>>;
  create?: InputMaybe<Array<InputMaybe<ZohoEmailCreateWithoutTemplateInput>>>;
  createMany?: InputMaybe<ZohoEmailCreateManyTemplateInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ZohoEmailScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ZohoEmailUpdateWithWhereUniqueWithoutTemplateInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ZohoEmailUpdateManyWithWhereWithoutTemplateInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ZohoEmailUpsertWithWhereUniqueWithoutTemplateInput>>>;
};

export type ZohoEmailUpdateManyWithoutTraineeEventInput = {
  connect?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ZohoEmailCreateOrConnectWithoutTraineeEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<ZohoEmailCreateWithoutTraineeEventInput>>>;
  createMany?: InputMaybe<ZohoEmailCreateManyTraineeEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ZohoEmailScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ZohoEmailUpdateWithWhereUniqueWithoutTraineeEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ZohoEmailUpdateManyWithWhereWithoutTraineeEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ZohoEmailUpsertWithWhereUniqueWithoutTraineeEventInput>>>;
};

export type ZohoEmailUpdateManyWithoutTrainerEventInput = {
  connect?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ZohoEmailCreateOrConnectWithoutTrainerEventInput>>>;
  create?: InputMaybe<Array<InputMaybe<ZohoEmailCreateWithoutTrainerEventInput>>>;
  createMany?: InputMaybe<ZohoEmailCreateManyTrainerEventInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ZohoEmailScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ZohoEmailUpdateWithWhereUniqueWithoutTrainerEventInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ZohoEmailUpdateManyWithWhereWithoutTrainerEventInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ZohoEmailUpsertWithWhereUniqueWithoutTrainerEventInput>>>;
};

export type ZohoEmailUpdateManyWithoutUserInput = {
  connect?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ZohoEmailCreateOrConnectWithoutUserInput>>>;
  create?: InputMaybe<Array<InputMaybe<ZohoEmailCreateWithoutUserInput>>>;
  createMany?: InputMaybe<ZohoEmailCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ZohoEmailScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ZohoEmailWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ZohoEmailUpdateWithWhereUniqueWithoutUserInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ZohoEmailUpdateManyWithWhereWithoutUserInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ZohoEmailUpsertWithWhereUniqueWithoutUserInput>>>;
};

export type ZohoEmailUpdateWithWhereUniqueWithoutEventInput = {
  data: ZohoEmailUncheckedUpdateWithoutEventInput;
  where: ZohoEmailWhereUniqueInput;
};

export type ZohoEmailUpdateWithWhereUniqueWithoutTemplateInput = {
  data: ZohoEmailUncheckedUpdateWithoutTemplateInput;
  where: ZohoEmailWhereUniqueInput;
};

export type ZohoEmailUpdateWithWhereUniqueWithoutTraineeEventInput = {
  data: ZohoEmailUncheckedUpdateWithoutTraineeEventInput;
  where: ZohoEmailWhereUniqueInput;
};

export type ZohoEmailUpdateWithWhereUniqueWithoutTrainerEventInput = {
  data: ZohoEmailUncheckedUpdateWithoutTrainerEventInput;
  where: ZohoEmailWhereUniqueInput;
};

export type ZohoEmailUpdateWithWhereUniqueWithoutUserInput = {
  data: ZohoEmailUncheckedUpdateWithoutUserInput;
  where: ZohoEmailWhereUniqueInput;
};

export type ZohoEmailUpdateWithoutEventInput = {
  Template?: InputMaybe<TemplateUpdateOneWithoutZohoEmailInput>;
  TraineeEvent?: InputMaybe<TraineeEventUpdateOneWithoutZohoEmailInput>;
  TrainerEvent?: InputMaybe<TrainerEventUpdateOneWithoutZohoEmailInput>;
  User?: InputMaybe<UserUpdateOneWithoutZohoEmailInput>;
  clicked?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  hardBounce?: InputMaybe<BoolFieldUpdateOperationsInput>;
  htmlData?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  opened?: InputMaybe<BoolFieldUpdateOperationsInput>;
  request_id?: InputMaybe<StringFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  softBounce?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ZohoEmailUpdateWithoutTemplateInput = {
  Event?: InputMaybe<EventUpdateOneWithoutZohoEmailInput>;
  TraineeEvent?: InputMaybe<TraineeEventUpdateOneWithoutZohoEmailInput>;
  TrainerEvent?: InputMaybe<TrainerEventUpdateOneWithoutZohoEmailInput>;
  User?: InputMaybe<UserUpdateOneWithoutZohoEmailInput>;
  clicked?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  hardBounce?: InputMaybe<BoolFieldUpdateOperationsInput>;
  htmlData?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  opened?: InputMaybe<BoolFieldUpdateOperationsInput>;
  request_id?: InputMaybe<StringFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  softBounce?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ZohoEmailUpdateWithoutTraineeEventInput = {
  Event?: InputMaybe<EventUpdateOneWithoutZohoEmailInput>;
  Template?: InputMaybe<TemplateUpdateOneWithoutZohoEmailInput>;
  TrainerEvent?: InputMaybe<TrainerEventUpdateOneWithoutZohoEmailInput>;
  User?: InputMaybe<UserUpdateOneWithoutZohoEmailInput>;
  clicked?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  hardBounce?: InputMaybe<BoolFieldUpdateOperationsInput>;
  htmlData?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  opened?: InputMaybe<BoolFieldUpdateOperationsInput>;
  request_id?: InputMaybe<StringFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  softBounce?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ZohoEmailUpdateWithoutTrainerEventInput = {
  Event?: InputMaybe<EventUpdateOneWithoutZohoEmailInput>;
  Template?: InputMaybe<TemplateUpdateOneWithoutZohoEmailInput>;
  TraineeEvent?: InputMaybe<TraineeEventUpdateOneWithoutZohoEmailInput>;
  User?: InputMaybe<UserUpdateOneWithoutZohoEmailInput>;
  clicked?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  hardBounce?: InputMaybe<BoolFieldUpdateOperationsInput>;
  htmlData?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  opened?: InputMaybe<BoolFieldUpdateOperationsInput>;
  request_id?: InputMaybe<StringFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  softBounce?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ZohoEmailUpdateWithoutUserInput = {
  Event?: InputMaybe<EventUpdateOneWithoutZohoEmailInput>;
  Template?: InputMaybe<TemplateUpdateOneWithoutZohoEmailInput>;
  TraineeEvent?: InputMaybe<TraineeEventUpdateOneWithoutZohoEmailInput>;
  TrainerEvent?: InputMaybe<TrainerEventUpdateOneWithoutZohoEmailInput>;
  clicked?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  hardBounce?: InputMaybe<BoolFieldUpdateOperationsInput>;
  htmlData?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  opened?: InputMaybe<BoolFieldUpdateOperationsInput>;
  request_id?: InputMaybe<StringFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  softBounce?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ZohoEmailUpsertWithWhereUniqueWithoutEventInput = {
  create: ZohoEmailUncheckedCreateWithoutEventInput;
  update: ZohoEmailUncheckedUpdateWithoutEventInput;
  where: ZohoEmailWhereUniqueInput;
};

export type ZohoEmailUpsertWithWhereUniqueWithoutTemplateInput = {
  create: ZohoEmailUncheckedCreateWithoutTemplateInput;
  update: ZohoEmailUncheckedUpdateWithoutTemplateInput;
  where: ZohoEmailWhereUniqueInput;
};

export type ZohoEmailUpsertWithWhereUniqueWithoutTraineeEventInput = {
  create: ZohoEmailUncheckedCreateWithoutTraineeEventInput;
  update: ZohoEmailUncheckedUpdateWithoutTraineeEventInput;
  where: ZohoEmailWhereUniqueInput;
};

export type ZohoEmailUpsertWithWhereUniqueWithoutTrainerEventInput = {
  create: ZohoEmailUncheckedCreateWithoutTrainerEventInput;
  update: ZohoEmailUncheckedUpdateWithoutTrainerEventInput;
  where: ZohoEmailWhereUniqueInput;
};

export type ZohoEmailUpsertWithWhereUniqueWithoutUserInput = {
  create: ZohoEmailUncheckedCreateWithoutUserInput;
  update: ZohoEmailUncheckedUpdateWithoutUserInput;
  where: ZohoEmailWhereUniqueInput;
};

export type ZohoEmailWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ZohoEmailWhereInput>>>;
  Event?: InputMaybe<EventWhereInput>;
  NOT?: InputMaybe<Array<InputMaybe<ZohoEmailWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ZohoEmailWhereInput>>>;
  Template?: InputMaybe<TemplateWhereInput>;
  TraineeEvent?: InputMaybe<TraineeEventWhereInput>;
  TrainerEvent?: InputMaybe<TrainerEventWhereInput>;
  User?: InputMaybe<UserWhereInput>;
  clicked?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  eventId?: InputMaybe<IntNullableFilter>;
  hardBounce?: InputMaybe<BoolFilter>;
  htmlData?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  opened?: InputMaybe<BoolFilter>;
  request_id?: InputMaybe<StringFilter>;
  sent?: InputMaybe<BoolFilter>;
  softBounce?: InputMaybe<BoolFilter>;
  subject?: InputMaybe<StringNullableFilter>;
  templateId?: InputMaybe<IntNullableFilter>;
  traineeEventId?: InputMaybe<IntNullableFilter>;
  trainerEventId?: InputMaybe<IntNullableFilter>;
  userId?: InputMaybe<IntNullableFilter>;
};

export type ZohoEmailWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  request_id?: InputMaybe<Scalars['String']>;
};

export type Zoom = {
  __typename?: 'Zoom';
  agenda?: Maybe<Scalars['String']>;
  close_registration?: Maybe<Scalars['Boolean']>;
  default_password?: Maybe<Scalars['Boolean']>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  join_url?: Maybe<Scalars['String']>;
  occurrences?: Maybe<Array<ZoomOccurrences>>;
  password?: Maybe<Scalars['String']>;
  recurrence?: Maybe<Recurrence>;
  registration_url?: Maybe<Scalars['String']>;
  settings?: Maybe<ZoomSettings>;
  start_time?: Maybe<Scalars['String']>;
  start_url?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  topic?: Maybe<Scalars['String']>;
  tracking_fields?: Maybe<Array<Tracking_Fields>>;
  type?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
};

export type ZoomCreateInput = {
  agenda?: InputMaybe<Scalars['String']>;
  close_registration?: InputMaybe<Scalars['Boolean']>;
  default_password?: InputMaybe<Scalars['Boolean']>;
  duration?: InputMaybe<Scalars['Int']>;
  eventId: Scalars['Int'];
  password?: InputMaybe<Scalars['String']>;
  recurrence?: InputMaybe<RecurrenceCreateInput>;
  registration_url?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<ZoomSettingsCreateInput>;
  start_time?: InputMaybe<Scalars['String']>;
  start_url?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  topic?: InputMaybe<Scalars['String']>;
  tracking_fields?: InputMaybe<Array<InputMaybe<Tracking_FieldsCreateInput>>>;
  type?: InputMaybe<Scalars['Int']>;
  zoomMode: Scalars['String'];
};

export type ZoomMeeting = {
  __typename?: 'ZoomMeeting';
  EventDay?: Maybe<EventDay>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  duration?: Maybe<Scalars['Int']>;
  endDateTime?: Maybe<Scalars['DateTime']>;
  eventDayId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  isProcessed: Scalars['Boolean'];
  isStarted: Scalars['Boolean'];
  joinUrl?: Maybe<Scalars['String']>;
  meetingId?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  registrationUrl?: Maybe<Scalars['String']>;
  startDateTime?: Maybe<Scalars['DateTime']>;
  startUrl?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type ZoomMeetingAvgAggregateOutputType = {
  __typename?: 'ZoomMeetingAvgAggregateOutputType';
  duration?: Maybe<Scalars['Float']>;
  eventDayId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

export type ZoomMeetingAvgOrderByAggregateInput = {
  duration?: InputMaybe<SortOrder>;
  eventDayId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type ZoomMeetingCountAggregateOutputType = {
  __typename?: 'ZoomMeetingCountAggregateOutputType';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  duration: Scalars['Int'];
  endDateTime: Scalars['Int'];
  eventDayId: Scalars['Int'];
  id: Scalars['Int'];
  isProcessed: Scalars['Int'];
  isStarted: Scalars['Int'];
  joinUrl: Scalars['Int'];
  meetingId: Scalars['Int'];
  password: Scalars['Int'];
  registrationUrl: Scalars['Int'];
  startDateTime: Scalars['Int'];
  startUrl: Scalars['Int'];
  type: Scalars['Int'];
};

export type ZoomMeetingCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  endDateTime?: InputMaybe<SortOrder>;
  eventDayId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isProcessed?: InputMaybe<SortOrder>;
  isStarted?: InputMaybe<SortOrder>;
  joinUrl?: InputMaybe<SortOrder>;
  meetingId?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  registrationUrl?: InputMaybe<SortOrder>;
  startDateTime?: InputMaybe<SortOrder>;
  startUrl?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type ZoomMeetingCountOutputType = {
  __typename?: 'ZoomMeetingCountOutputType';
  Event: Scalars['Int'];
};

export type ZoomMeetingCreateInput = {
  Event?: InputMaybe<EventCreateNestedManyWithoutZoomMeetingInput>;
  EventDay?: InputMaybe<EventDayCreateNestedOneWithoutZoomMeetingsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  isProcessed?: InputMaybe<Scalars['Boolean']>;
  isStarted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  registrationUrl?: InputMaybe<Scalars['String']>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  startUrl?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type ZoomMeetingCreateManyEventDayInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  isProcessed?: InputMaybe<Scalars['Boolean']>;
  isStarted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  registrationUrl?: InputMaybe<Scalars['String']>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  startUrl?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type ZoomMeetingCreateManyEventDayInputEnvelope = {
  data: ZoomMeetingCreateManyEventDayInput;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ZoomMeetingCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  isProcessed?: InputMaybe<Scalars['Boolean']>;
  isStarted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  registrationUrl?: InputMaybe<Scalars['String']>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  startUrl?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type ZoomMeetingCreateNestedManyWithoutEventDayInput = {
  connect?: InputMaybe<Array<InputMaybe<ZoomMeetingWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ZoomMeetingCreateOrConnectWithoutEventDayInput>>>;
  create?: InputMaybe<Array<InputMaybe<ZoomMeetingCreateWithoutEventDayInput>>>;
  createMany?: InputMaybe<ZoomMeetingCreateManyEventDayInputEnvelope>;
};

export type ZoomMeetingCreateNestedOneWithoutEventInput = {
  connect?: InputMaybe<ZoomMeetingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ZoomMeetingCreateOrConnectWithoutEventInput>;
  create?: InputMaybe<ZoomMeetingUncheckedCreateWithoutEventInput>;
};

export type ZoomMeetingCreateOrConnectWithoutEventDayInput = {
  create: ZoomMeetingUncheckedCreateWithoutEventDayInput;
  where: ZoomMeetingWhereUniqueInput;
};

export type ZoomMeetingCreateOrConnectWithoutEventInput = {
  create: ZoomMeetingUncheckedCreateWithoutEventInput;
  where: ZoomMeetingWhereUniqueInput;
};

export type ZoomMeetingCreateWithoutEventDayInput = {
  Event?: InputMaybe<EventCreateNestedManyWithoutZoomMeetingInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  isProcessed?: InputMaybe<Scalars['Boolean']>;
  isStarted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  registrationUrl?: InputMaybe<Scalars['String']>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  startUrl?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type ZoomMeetingCreateWithoutEventInput = {
  EventDay?: InputMaybe<EventDayCreateNestedOneWithoutZoomMeetingsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  isProcessed?: InputMaybe<Scalars['Boolean']>;
  isStarted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  registrationUrl?: InputMaybe<Scalars['String']>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  startUrl?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type ZoomMeetingListRelationFilter = {
  every?: InputMaybe<ZoomMeetingWhereInput>;
  none?: InputMaybe<ZoomMeetingWhereInput>;
  some?: InputMaybe<ZoomMeetingWhereInput>;
};

export type ZoomMeetingMaxAggregateOutputType = {
  __typename?: 'ZoomMeetingMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  duration?: Maybe<Scalars['Int']>;
  endDateTime?: Maybe<Scalars['DateTime']>;
  eventDayId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isProcessed?: Maybe<Scalars['Boolean']>;
  isStarted?: Maybe<Scalars['Boolean']>;
  joinUrl?: Maybe<Scalars['String']>;
  meetingId?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  registrationUrl?: Maybe<Scalars['String']>;
  startDateTime?: Maybe<Scalars['DateTime']>;
  startUrl?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type ZoomMeetingMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  endDateTime?: InputMaybe<SortOrder>;
  eventDayId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isProcessed?: InputMaybe<SortOrder>;
  isStarted?: InputMaybe<SortOrder>;
  joinUrl?: InputMaybe<SortOrder>;
  meetingId?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  registrationUrl?: InputMaybe<SortOrder>;
  startDateTime?: InputMaybe<SortOrder>;
  startUrl?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type ZoomMeetingMinAggregateOutputType = {
  __typename?: 'ZoomMeetingMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  duration?: Maybe<Scalars['Int']>;
  endDateTime?: Maybe<Scalars['DateTime']>;
  eventDayId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isProcessed?: Maybe<Scalars['Boolean']>;
  isStarted?: Maybe<Scalars['Boolean']>;
  joinUrl?: Maybe<Scalars['String']>;
  meetingId?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  registrationUrl?: Maybe<Scalars['String']>;
  startDateTime?: Maybe<Scalars['DateTime']>;
  startUrl?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type ZoomMeetingMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  endDateTime?: InputMaybe<SortOrder>;
  eventDayId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isProcessed?: InputMaybe<SortOrder>;
  isStarted?: InputMaybe<SortOrder>;
  joinUrl?: InputMaybe<SortOrder>;
  meetingId?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  registrationUrl?: InputMaybe<SortOrder>;
  startDateTime?: InputMaybe<SortOrder>;
  startUrl?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type ZoomMeetingOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ZoomMeetingOrderByWithAggregationInput = {
  _avg?: InputMaybe<ZoomMeetingAvgOrderByAggregateInput>;
  _count?: InputMaybe<ZoomMeetingCountOrderByAggregateInput>;
  _max?: InputMaybe<ZoomMeetingMaxOrderByAggregateInput>;
  _min?: InputMaybe<ZoomMeetingMinOrderByAggregateInput>;
  _sum?: InputMaybe<ZoomMeetingSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  endDateTime?: InputMaybe<SortOrder>;
  eventDayId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isProcessed?: InputMaybe<SortOrder>;
  isStarted?: InputMaybe<SortOrder>;
  joinUrl?: InputMaybe<SortOrder>;
  meetingId?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  registrationUrl?: InputMaybe<SortOrder>;
  startDateTime?: InputMaybe<SortOrder>;
  startUrl?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type ZoomMeetingOrderByWithRelationInput = {
  Event?: InputMaybe<EventOrderByRelationAggregateInput>;
  EventDay?: InputMaybe<EventDayOrderByWithRelationInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  endDateTime?: InputMaybe<SortOrder>;
  eventDayId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isProcessed?: InputMaybe<SortOrder>;
  isStarted?: InputMaybe<SortOrder>;
  joinUrl?: InputMaybe<SortOrder>;
  meetingId?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  registrationUrl?: InputMaybe<SortOrder>;
  startDateTime?: InputMaybe<SortOrder>;
  startUrl?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type ZoomMeetingRelationFilter = {
  is?: InputMaybe<ZoomMeetingWhereInput>;
  isNot?: InputMaybe<ZoomMeetingWhereInput>;
};

export enum ZoomMeetingScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Duration = 'duration',
  EndDateTime = 'endDateTime',
  EventDayId = 'eventDayId',
  Id = 'id',
  IsProcessed = 'isProcessed',
  IsStarted = 'isStarted',
  JoinUrl = 'joinUrl',
  MeetingId = 'meetingId',
  Password = 'password',
  RegistrationUrl = 'registrationUrl',
  StartDateTime = 'startDateTime',
  StartUrl = 'startUrl',
  Type = 'type'
}

export type ZoomMeetingScalarWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ZoomMeetingScalarWhereInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ZoomMeetingScalarWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ZoomMeetingScalarWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  duration?: InputMaybe<IntNullableFilter>;
  endDateTime?: InputMaybe<DateTimeNullableFilter>;
  eventDayId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  isProcessed?: InputMaybe<BoolNullableFilter>;
  isStarted?: InputMaybe<BoolNullableFilter>;
  joinUrl?: InputMaybe<StringNullableFilter>;
  meetingId?: InputMaybe<StringNullableFilter>;
  password?: InputMaybe<StringNullableFilter>;
  registrationUrl?: InputMaybe<StringNullableFilter>;
  startDateTime?: InputMaybe<DateTimeNullableFilter>;
  startUrl?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringNullableFilter>;
};

export type ZoomMeetingScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<InputMaybe<ZoomMeetingScalarWhereWithAggregatesInput>>>;
  NOT?: InputMaybe<Array<InputMaybe<ZoomMeetingScalarWhereWithAggregatesInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ZoomMeetingScalarWhereWithAggregatesInput>>>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  duration?: InputMaybe<IntNullableWithAggregatesFilter>;
  endDateTime?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  eventDayId?: InputMaybe<IntNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  isProcessed?: InputMaybe<BoolNullableWithAggregatesFilter>;
  isStarted?: InputMaybe<BoolNullableWithAggregatesFilter>;
  joinUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  meetingId?: InputMaybe<StringNullableWithAggregatesFilter>;
  password?: InputMaybe<StringNullableWithAggregatesFilter>;
  registrationUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  startDateTime?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  startUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  type?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type ZoomMeetingSumAggregateOutputType = {
  __typename?: 'ZoomMeetingSumAggregateOutputType';
  duration?: Maybe<Scalars['Int']>;
  eventDayId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type ZoomMeetingSumOrderByAggregateInput = {
  duration?: InputMaybe<SortOrder>;
  eventDayId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type ZoomMeetingUncheckedCreateInput = {
  Event?: InputMaybe<EventUncheckedCreateNestedManyWithoutZoomMeetingInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  isProcessed?: InputMaybe<Scalars['Boolean']>;
  isStarted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  registrationUrl?: InputMaybe<Scalars['String']>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  startUrl?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type ZoomMeetingUncheckedCreateNestedManyWithoutEventDayInput = {
  connect?: InputMaybe<Array<InputMaybe<ZoomMeetingWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ZoomMeetingCreateOrConnectWithoutEventDayInput>>>;
  create?: InputMaybe<Array<InputMaybe<ZoomMeetingCreateWithoutEventDayInput>>>;
  createMany?: InputMaybe<ZoomMeetingCreateManyEventDayInputEnvelope>;
};

export type ZoomMeetingUncheckedCreateWithoutEventDayInput = {
  Event?: InputMaybe<EventUncheckedCreateNestedManyWithoutZoomMeetingInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  isProcessed?: InputMaybe<Scalars['Boolean']>;
  isStarted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  registrationUrl?: InputMaybe<Scalars['String']>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  startUrl?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type ZoomMeetingUncheckedCreateWithoutEventInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  eventDayId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  isProcessed?: InputMaybe<Scalars['Boolean']>;
  isStarted?: InputMaybe<Scalars['Boolean']>;
  joinUrl?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  registrationUrl?: InputMaybe<Scalars['String']>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  startUrl?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type ZoomMeetingUncheckedUpdateInput = {
  Event?: InputMaybe<EventUncheckedUpdateManyWithoutZoomMeetingInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  endDateTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventDayId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isProcessed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isStarted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrationUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startDateTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  startUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ZoomMeetingUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  endDateTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventDayId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isProcessed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isStarted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrationUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startDateTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  startUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ZoomMeetingUncheckedUpdateManyWithoutEventDayInput = {
  connect?: InputMaybe<Array<InputMaybe<ZoomMeetingWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ZoomMeetingCreateOrConnectWithoutEventDayInput>>>;
  create?: InputMaybe<Array<InputMaybe<ZoomMeetingCreateWithoutEventDayInput>>>;
  createMany?: InputMaybe<ZoomMeetingCreateManyEventDayInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ZoomMeetingWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ZoomMeetingScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ZoomMeetingWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ZoomMeetingWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ZoomMeetingUpdateWithWhereUniqueWithoutEventDayInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ZoomMeetingUpdateManyWithWhereWithoutEventDayInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ZoomMeetingUpsertWithWhereUniqueWithoutEventDayInput>>>;
};

export type ZoomMeetingUncheckedUpdateManyWithoutZoomMeetingsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  endDateTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isProcessed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isStarted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrationUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startDateTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  startUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ZoomMeetingUncheckedUpdateWithoutEventDayInput = {
  Event?: InputMaybe<EventUncheckedUpdateManyWithoutZoomMeetingInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  endDateTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isProcessed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isStarted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrationUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startDateTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  startUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ZoomMeetingUncheckedUpdateWithoutEventInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  endDateTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eventDayId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isProcessed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isStarted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrationUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startDateTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  startUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ZoomMeetingUpdateInput = {
  Event?: InputMaybe<EventUpdateManyWithoutZoomMeetingInput>;
  EventDay?: InputMaybe<EventDayUpdateOneWithoutZoomMeetingsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  endDateTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  isProcessed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isStarted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrationUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startDateTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  startUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ZoomMeetingUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  endDateTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  isProcessed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isStarted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrationUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startDateTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  startUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ZoomMeetingUpdateManyWithWhereWithoutEventDayInput = {
  data: ZoomMeetingUncheckedUpdateManyWithoutZoomMeetingsInput;
  where: ZoomMeetingScalarWhereInput;
};

export type ZoomMeetingUpdateManyWithoutEventDayInput = {
  connect?: InputMaybe<Array<InputMaybe<ZoomMeetingWhereUniqueInput>>>;
  connectOrCreate?: InputMaybe<Array<InputMaybe<ZoomMeetingCreateOrConnectWithoutEventDayInput>>>;
  create?: InputMaybe<Array<InputMaybe<ZoomMeetingCreateWithoutEventDayInput>>>;
  createMany?: InputMaybe<ZoomMeetingCreateManyEventDayInputEnvelope>;
  delete?: InputMaybe<Array<InputMaybe<ZoomMeetingWhereUniqueInput>>>;
  deleteMany?: InputMaybe<Array<InputMaybe<ZoomMeetingScalarWhereInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<ZoomMeetingWhereUniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<ZoomMeetingWhereUniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ZoomMeetingUpdateWithWhereUniqueWithoutEventDayInput>>>;
  updateMany?: InputMaybe<Array<InputMaybe<ZoomMeetingUpdateManyWithWhereWithoutEventDayInput>>>;
  upsert?: InputMaybe<Array<InputMaybe<ZoomMeetingUpsertWithWhereUniqueWithoutEventDayInput>>>;
};

export type ZoomMeetingUpdateOneWithoutEventInput = {
  connect?: InputMaybe<ZoomMeetingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ZoomMeetingCreateOrConnectWithoutEventInput>;
  create?: InputMaybe<ZoomMeetingUncheckedCreateWithoutEventInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<ZoomMeetingUncheckedUpdateWithoutEventInput>;
  upsert?: InputMaybe<ZoomMeetingUpsertWithoutEventInput>;
};

export type ZoomMeetingUpdateWithWhereUniqueWithoutEventDayInput = {
  data: ZoomMeetingUncheckedUpdateWithoutEventDayInput;
  where: ZoomMeetingWhereUniqueInput;
};

export type ZoomMeetingUpdateWithoutEventDayInput = {
  Event?: InputMaybe<EventUpdateManyWithoutZoomMeetingInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  endDateTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  isProcessed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isStarted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrationUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startDateTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  startUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ZoomMeetingUpdateWithoutEventInput = {
  EventDay?: InputMaybe<EventDayUpdateOneWithoutZoomMeetingsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  endDateTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  isProcessed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isStarted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  joinUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meetingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrationUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startDateTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  startUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ZoomMeetingUpsertWithWhereUniqueWithoutEventDayInput = {
  create: ZoomMeetingUncheckedCreateWithoutEventDayInput;
  update: ZoomMeetingUncheckedUpdateWithoutEventDayInput;
  where: ZoomMeetingWhereUniqueInput;
};

export type ZoomMeetingUpsertWithoutEventInput = {
  create: ZoomMeetingUncheckedCreateWithoutEventInput;
  update: ZoomMeetingUncheckedUpdateWithoutEventInput;
};

export type ZoomMeetingWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ZoomMeetingWhereInput>>>;
  Event?: InputMaybe<EventListRelationFilter>;
  EventDay?: InputMaybe<EventDayWhereInput>;
  NOT?: InputMaybe<Array<InputMaybe<ZoomMeetingWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ZoomMeetingWhereInput>>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  duration?: InputMaybe<IntNullableFilter>;
  endDateTime?: InputMaybe<DateTimeNullableFilter>;
  eventDayId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  isProcessed?: InputMaybe<BoolNullableFilter>;
  isStarted?: InputMaybe<BoolNullableFilter>;
  joinUrl?: InputMaybe<StringNullableFilter>;
  meetingId?: InputMaybe<StringNullableFilter>;
  password?: InputMaybe<StringNullableFilter>;
  registrationUrl?: InputMaybe<StringNullableFilter>;
  startDateTime?: InputMaybe<DateTimeNullableFilter>;
  startUrl?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringNullableFilter>;
};

export type ZoomMeetingWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type ZoomRegistrant = {
  __typename?: 'ZoomRegistrant';
  auto_approve?: Maybe<Scalars['Boolean']>;
  country?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  first_name: Scalars['String'];
  id?: Maybe<Scalars['BigInt']>;
  industry?: Maybe<Scalars['String']>;
  job_title?: Maybe<Scalars['String']>;
  join_url?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  meetingId?: Maybe<Scalars['BigInt']>;
  next_page_token?: Maybe<Scalars['String']>;
  page_count?: Maybe<Scalars['Int']>;
  page_number?: Maybe<Scalars['Int']>;
  page_size?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  registrantId?: Maybe<Scalars['String']>;
  registrant_id?: Maybe<Scalars['String']>;
  registrants?: Maybe<Array<ZoomRegistrantsList>>;
  total_records?: Maybe<Scalars['Int']>;
  zoomMode?: Maybe<Scalars['String']>;
};

export type ZoomRegistrantCreateOneInput = {
  country?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  eventId: Scalars['Int'];
  first_name?: InputMaybe<Scalars['String']>;
  industry?: InputMaybe<Scalars['String']>;
  isTrainer: Scalars['Boolean'];
  job_title?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  meetingId: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  zoomMode: Scalars['String'];
};

export type ZoomRegistrantWhereManyInput = {
  meetingId: Scalars['String'];
  next_page_token?: InputMaybe<Scalars['String']>;
  page_number?: InputMaybe<Scalars['Int']>;
  page_size?: InputMaybe<Scalars['Int']>;
  zoomMode: Scalars['String'];
};

export type ZoomRegistrantWhereUniqueInput = {
  eventId: Scalars['Int'];
  meetingId: Scalars['String'];
  trainerId: Scalars['Int'];
  zoomMode: Scalars['String'];
};

export type ZoomRegistrantWherefindUniqueInput = {
  meetingId: Scalars['String'];
  registrantId: Scalars['String'];
  zoomMode: Scalars['String'];
};

export type ZoomUpdateInput = {
  agenda: Scalars['String'];
  close_registration?: InputMaybe<Scalars['Boolean']>;
  default_password?: InputMaybe<Scalars['Boolean']>;
  duration?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  recurrence?: InputMaybe<RecurrenceUpdateInput>;
  settings?: InputMaybe<ZoomSettingsUpdateInput>;
  start_time: Scalars['String'];
  timezone: Scalars['String'];
  topic: Scalars['String'];
  tracking_fields?: InputMaybe<Array<InputMaybe<Tracking_FieldsUpdateInput>>>;
  type: Scalars['Int'];
};

export type ZoomWhereUniqueInput = {
  meetingId: Scalars['String'];
  zoomMode: Scalars['String'];
};

export type ZoomWhereUpdateInput = {
  eventId: Scalars['Int'];
  meetingId: Scalars['String'];
  zoomMode: Scalars['String'];
};

export type AddContactUsDataType = {
  ContactUsDataInput: ContactUsDataCreateInput;
  contactUsDataId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type AddEducationInputType = {
  education: EducationCreateInput;
  educationId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type AddEventIdentityCardTemplateType = {
  EventIdentityCardTemplateInput: EventIdentityCardTemplateUpsertWithoutEventInput;
  eventId?: InputMaybe<Scalars['Int']>;
};

export type AddEventMediaTrackingType = {
  EventMediaTrackingInput: EventMediaTrackingCreateInput;
  eventMediaTrackingId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type AddHowHeardAboutEventInputType = {
  howHeardAboutEventId: Scalars['Int'];
  traineeEventId: Scalars['Int'];
};

export type AddMemberNeedSettingsType = {
  memberNeedSettingsId?: InputMaybe<Scalars['Int']>;
  titleAr?: InputMaybe<Scalars['String']>;
  titleEn?: InputMaybe<Scalars['String']>;
};

export type AddMemberNeedsType = {
  MemberNeedsInput: MemberNeedsCreateInput;
  memberNeedsId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type AddProfessionalSkillInputType = {
  ProfessionalSkill: ProfessionalSkillsCreateInput;
  ProfessionalSkillId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type AddScientificResearchInputType = {
  scientificResearch: ScientificResearchCreateInput;
  scientificResearchId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type AddTrainingExperienceInputType = {
  trainingExperience: TrainingExperienceCreateInput;
  trainingExperienceId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type AdminAnalysisOutput = {
  __typename?: 'adminAnalysisOutput';
  createdAt?: Maybe<Scalars['DateTime']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
};

export type AdminAnalysisWhere = {
  adminId: Scalars['Int'];
};

export type CardFeeInputType = {
  fixedFee: Scalars['Int'];
  madaFee: Scalars['Decimal'];
  visaMasterFee: Scalars['Decimal'];
};

export type DestroyWhatsAppInputType = {
  destroy: Scalars['Boolean'];
};

export type Done = {
  __typename?: 'done';
  balance: Scalars['Decimal'];
};

export type EmailWhereInput = {
  eventId: Scalars['Int'];
};

export type EmergancyNotificationInput = {
  NotificationType: NotificationType;
  eventId: Scalars['Int'];
};

export type EventAnalysisOutput = {
  __typename?: 'eventAnalysisOutput';
  eventDeliveryMethod?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Json']>;
};

export type EventAnalysisWhere = {
  eventId: Scalars['Int'];
};

export type EventIdInput = {
  eventId: Scalars['Int'];
};

export type EventReviewInput = {
  reviewOfFive: Scalars['Int'];
  traineeEventId: Scalars['Int'];
  traineeEventReviewChoices?: InputMaybe<Array<Scalars['Int']>>;
  why?: InputMaybe<Scalars['String']>;
};

export type EventStopInput = {
  eventId: Scalars['Int'];
  isRegistraionClosed: Scalars['Boolean'];
};

export type FindReviewInput = {
  traineeEventId: Scalars['Int'];
};

export type FindReviewOutput = {
  __typename?: 'findReviewOutput';
  Event?: Maybe<Event>;
  TraineeEventReview?: Maybe<TraineeEventReview>;
  TraineeTrainerReview?: Maybe<Array<Maybe<TraineeTrainerReview>>>;
};

export type FindSchedulingInput = {
  eventId?: InputMaybe<Scalars['Int']>;
};

export type FindWhatsAppMsgsInput = {
  eventId: Scalars['Int'];
};

export type FreeBookingInputType = {
  bookingId: Scalars['Int'];
};

export type FreeBookingOutput = {
  __typename?: 'freeBookingOutput';
  amount_format: Scalars['Decimal'];
  date: Scalars['DateTime'];
  eventName?: Maybe<Scalars['String']>;
  fee_format: Scalars['Decimal'];
  isPaid: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  reference_number: Scalars['Int'];
  source: Scalars['String'];
};

export type GeneralCouponInputType = {
  couponId?: InputMaybe<Scalars['Int']>;
};

export type GenerateCertificateInputType = {
  ignoreAttendance: Scalars['Boolean'];
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
};

export type GetAttendanceType = {
  eventId: Scalars['Int'];
};

export type GetBookingInputType = {
  eventId?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  ref?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type GetCertInputType = {
  eventId: Scalars['Int'];
};

export type GetCoursePriceOutput = {
  __typename?: 'getCoursePriceOutput';
  IsProfessionCompatable: Array<Maybe<IncompatableProfessions>>;
  event: Event;
  seatsError?: Maybe<Scalars['String']>;
  seatsErrorArray?: Maybe<Array<Maybe<SeatsErrorArray>>>;
  traineeEvent: Array<Maybe<TraineeEvent>>;
  traineeEventGroup?: Maybe<TraineeEventGroup>;
};

export type GetWalletInputType = {
  id: Scalars['Int'];
};

export type IncomeStatementOutput = {
  __typename?: 'incomeStatementOutput';
  category: Scalars['String'];
  couponDiscount: Scalars['Decimal'];
  couponMarketerDiscount: Scalars['Decimal'];
  eventId?: Maybe<Scalars['Decimal']>;
  expenses: Scalars['Decimal'];
  income: Scalars['Decimal'];
  moyasarFee: Scalars['Decimal'];
  source: Scalars['String'];
  tax: Scalars['Decimal'];
};

export type IncomeStatementWhereInput = {
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
  variance: Variance;
};

export type IncompatableProfessions = {
  __typename?: 'incompatableProfessions';
  IsProfessionCompatable: Scalars['Boolean'];
  email: Scalars['String'];
};

export type IndexImagesInputType = {
  hidden: Scalars['Boolean'];
  url: Scalars['String'];
};

export type InitializeWhatsAppInputType = {
  initialize: Scalars['Boolean'];
};

export type InstantNotificationsBellInputType = {
  cert: Scalars['String'];
  continueRegistration: Scalars['String'];
  joinGroup: Scalars['String'];
  studyMaterial: Scalars['String'];
};

export type ListCoursesOutput = {
  __typename?: 'listCoursesOutput';
  cmeHours?: Maybe<Scalars['Decimal']>;
  defaultLanguage?: Maybe<Scalars['String']>;
  eventTypeId?: Maybe<Scalars['Int']>;
  folderId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  imageUrl?: Maybe<Scalars['String']>;
  isAccredited?: Maybe<Scalars['Boolean']>;
  isAccreditedSHA?: Maybe<Scalars['Boolean']>;
  methodOfDelivery?: Maybe<MethodOfDelivery>;
  price?: Maybe<Scalars['String']>;
  pricingPlan?: Maybe<PricingPlan>;
  shortDescriptionAr?: Maybe<Scalars['String']>;
  shortDescriptionEn?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  titleAr?: Maybe<Scalars['String']>;
  titleEn?: Maybe<Scalars['String']>;
};

export type ListEmailOutput = {
  __typename?: 'listEmailOutput';
  bookingStatus?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
  key?: Maybe<Scalars['String']>;
  method?: Maybe<Scalars['String']>;
  target?: Maybe<Scalars['String']>;
  template?: Maybe<ZohoTemplate>;
  users?: Maybe<Array<Maybe<UserslistEmailOutput>>>;
};

export type ListMsgOutput = {
  __typename?: 'listMsgOutput';
  bookingStatus?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
  key?: Maybe<Scalars['String']>;
  method?: Maybe<Scalars['String']>;
  msg?: Maybe<Scalars['String']>;
  target?: Maybe<Scalars['String']>;
  users?: Maybe<Array<Maybe<UserslistMsgOutput>>>;
};

export type LogoutWhatsAppInputType = {
  logout: Scalars['Boolean'];
};

export type MarketerAnalysisOutput = {
  __typename?: 'marketerAnalysisOutput';
  createdAt?: Maybe<Scalars['DateTime']>;
  eventsAnalysis?: Maybe<Array<Maybe<Scalars['Json']>>>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  numberOfCompletedEvents?: Maybe<Scalars['Int']>;
};

export type MarketerAnalysisWhere = {
  marketerId: Scalars['Int'];
};

export type MergeInfo = {
  currentYear?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  resetPasswordURL?: InputMaybe<Scalars['String']>;
  signupURL?: InputMaybe<Scalars['String']>;
  traineeName?: InputMaybe<Scalars['String']>;
};

export enum ModeOfDelivery {
  Online = 'ONLINE',
  Onsite = 'ONSITE'
}

export type MoyasarInitiateTransition = {
  moyasarId: Scalars['String'];
  traineeEventId: Scalars['Int'];
};

export type OrgnizerAnalysisOutput = {
  __typename?: 'orgnizerAnalysisOutput';
  createdAt?: Maybe<Scalars['DateTime']>;
  eventsAnalysis?: Maybe<Array<Maybe<Scalars['Json']>>>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  numberOfCompletedEvents?: Maybe<Scalars['Int']>;
};

export type OrgnizerAnalysisWhere = {
  orgnizerId: Scalars['Int'];
};

export type PublishExpenseInputType = {
  applicationPrice: Scalars['Decimal'];
  designPrice: Scalars['Decimal'];
  ertiqaaPrice: Scalars['Decimal'];
  learningHourPrice: Scalars['Decimal'];
  trainerPrice: Scalars['Decimal'];
  zoomPrice: Scalars['Decimal'];
};

/** when onsite mode. choose checkIn when trainee goes into the hall. checkOut  when the trainee leaves the hall before end time. */
export enum RecordAttendanceAction {
  CheckIn = 'checkIn',
  CheckOut = 'checkOut',
  GetInfo = 'getInfo'
}

export type RecordAttendanceInput = {
  action: RecordAttendanceAction;
  bookingId: Scalars['Int'];
};

export type RecordAttendanceResult = {
  __typename?: 'recordAttendanceResult';
  EventDay?: Maybe<EventDay>;
  Trainee?: Maybe<User>;
  TraineeEventDayAttendances: Array<Maybe<TraineeEventDayAttendance>>;
};

export type RemoveContactUsDataType = {
  contactUsDataId: Scalars['Int'];
};

export type RemoveEducationInputType = {
  educationId: Scalars['Int'];
  userId?: InputMaybe<Scalars['Int']>;
};

export type RemoveEventMediaTrackingType = {
  eventMediaTrackingId: Scalars['Int'];
  userId?: InputMaybe<Scalars['Int']>;
};

export type RemoveExpenseInputType = {
  transitionId: Scalars['Int'];
};

export type RemoveMemberNeedSettingsType = {
  memberNeedSettingsId: Scalars['Int'];
};

export type RemoveMemberNeedsType = {
  memberNeedsId: Scalars['Int'];
  userId?: InputMaybe<Scalars['Int']>;
};

export type RemoveProfessionalSkillInputType = {
  ProfessionalSkillId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type RemoveScientificResearchInputType = {
  scientificResearchId: Scalars['Int'];
  userId?: InputMaybe<Scalars['Int']>;
};

export type RemoveTrainingExperienceInputType = {
  trainingExperienceId: Scalars['Int'];
  userId?: InputMaybe<Scalars['Int']>;
};

export type RemoveUserPasswordInputType = {
  password?: InputMaybe<Scalars['String']>;
};

export type ResendCertificateInput = {
  id: Scalars['Int'];
};

export type ResetWhatsAppInputType = {
  reset: Scalars['Boolean'];
};

export type SeatsErrorArray = {
  __typename?: 'seatsErrorArray';
  err?: Maybe<Scalars['String']>;
  eventDayId?: Maybe<Scalars['Int']>;
};

export type SendEmailInputType = {
  email: Scalars['String'];
  key_alias: Scalars['String'];
  merge_info: MergeInfo;
  template_key: Scalars['String'];
};

export type SetAttendanceType = {
  eventId: Scalars['Int'];
  participantName: Scalars['String'];
  traineeEventId: Scalars['Int'];
};

export type SetStudyMaterialAttendanceType = {
  eventId: Scalars['Int'];
  traineeEventId: Scalars['Int'];
};

export type TaxInputType = {
  nationality: Nationality;
  percentage: Scalars['Int'];
};

export type TaxNumberInputType = {
  taxNumber: Scalars['String'];
};

export type Tracking_Fields = {
  __typename?: 'tracking_fields';
  field?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Tracking_FieldsCreateInput = {
  field?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type Tracking_FieldsUpdateInput = {
  field?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type TraineeAnalysisOutput = {
  __typename?: 'traineeAnalysisOutput';
  adminNotes?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  numberOfCompletedEvents?: Maybe<Scalars['Int']>;
  numberOfRegisteredEvents?: Maybe<Scalars['Int']>;
};

export type TraineeAnalysisWhere = {
  traineeId: Scalars['Int'];
};

export type TrainerAnalysisOutput = {
  __typename?: 'trainerAnalysisOutput';
  createdAt?: Maybe<Scalars['DateTime']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  numberOfCompletedEvents?: Maybe<Scalars['Int']>;
};

export type TrainerAnalysisWhere = {
  trainerId: Scalars['Int'];
};

export type TrainerReviewInput = {
  reviewOfFive: Scalars['Int'];
  traineeEventId: Scalars['Int'];
  traineeTrainerReviewChoices?: InputMaybe<Array<Scalars['Int']>>;
  trainerEventId: Scalars['Int'];
  why?: InputMaybe<Scalars['String']>;
};

export type TurnToGuestInputType = {
  bookingId: Scalars['Int'];
  methodOfDeliveryId: Scalars['Int'];
};

export type UpdateAllBookingsMethodInputType = {
  eventId: Scalars['Int'];
  eventMethodOfDelivery: Scalars['Int'];
  traineesMethodOfDelivery: Scalars['Int'];
};

export type UpdateBankAccountInputType = {
  data: BankAccountCreateInput;
  userId?: InputMaybe<Scalars['Int']>;
};

export type UpdateBookingIdInputType = {
  bookingLink: Scalars['String'];
  email: Scalars['String'];
};

export type UpdateBookingInputType = {
  eventDayId: Scalars['Int'];
  id: Scalars['Int'];
};

export type UpdateBookingMethodInputType = {
  id: Scalars['Int'];
  methodOfDelivery: Scalars['Int'];
};

export type UpdateBookingTransitionStatusInputType = {
  action: UpdateBookingTransitionStatusInputTypeActions;
  receiptUrl?: InputMaybe<Scalars['String']>;
  statusId?: InputMaybe<Scalars['Int']>;
  transitionId: Scalars['Int'];
};

export enum UpdateBookingTransitionStatusInputTypeActions {
  CheckPaymentGatewayStatus = 'CHECK_PAYMENT_GATEWAY_STATUS',
  EmergencyRefundBookingEvent = 'EMERGENCY_REFUND_BOOKING_EVENT',
  RefundBookingEvent = 'REFUND_BOOKING_EVENT',
  UpdateStatus = 'UPDATE_STATUS'
}

export type UpdateContactUsDataType = {
  ContactUsDataInput: ContactUsDataUpdateInput;
  contactUsDataId?: InputMaybe<Scalars['Int']>;
};

export type UpdateCvInputType = {
  data: CvUpdateInput;
  userId?: InputMaybe<Scalars['Int']>;
};

export type UpdateJobInput = {
  date?: InputMaybe<Scalars['DateTime']>;
  eventId: Scalars['Int'];
  queueName: Scalars['String'];
  singletonkey: Scalars['String'];
};

export type UpdateWhatsAppMsgsInputType = {
  beforeEightDayMsg: Scalars['String'];
  beforeOneDayOnlineMsg: Scalars['String'];
  beforeOneDayOnsiteMsg: Scalars['String'];
  enableWhatsApp: Scalars['Boolean'];
  studyMaterialMsg: Scalars['String'];
};

export type UserslistEmailOutput = {
  __typename?: 'userslistEmailOutput';
  Certificate?: Maybe<Certificate>;
  bookingId?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  emailState?: Maybe<Scalars['Json']>;
  name?: Maybe<Scalars['String']>;
  qrImage?: Maybe<Scalars['String']>;
  shouldShowEmailMsg?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['Int']>;
  zohoEmail?: Maybe<ZohoEmail>;
  zoomLink?: Maybe<Scalars['String']>;
};

export type UserslistMsgOutput = {
  __typename?: 'userslistMsgOutput';
  bookingId?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  msgState?: Maybe<Scalars['Json']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
};

export type WalletPaymentSuccess = {
  __typename?: 'walletPaymentSuccess';
  status: Scalars['String'];
  traineeEventId: Scalars['Int'];
  transition: Scalars['Int'];
};

export type WalletTransition = {
  amountPaidWithWallet: Scalars['Int'];
  balance: Scalars['Int'];
  traineeEventId: Scalars['Int'];
};

export type WalletTransitionPayment = {
  __typename?: 'walletTransitionPayment';
  amount_format: Scalars['Decimal'];
  date: Scalars['DateTime'];
  eventName?: Maybe<Scalars['String']>;
  fee_format: Scalars['Decimal'];
  isPaid: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  reference_number: Scalars['Int'];
  source: Scalars['String'];
};

export type WhatsAppSendManyInputType = {
  body: Scalars['String'];
  eventId: Scalars['Int'];
};

export type ZohoEmail = {
  __typename?: 'zohoEmail';
  Template?: Maybe<Template>;
  clicked?: Maybe<Scalars['Boolean']>;
  hardBounce?: Maybe<Scalars['Boolean']>;
  htmlData?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  opened?: Maybe<Scalars['Boolean']>;
  request_id?: Maybe<Scalars['String']>;
  sent?: Maybe<Scalars['Boolean']>;
  softBounce?: Maybe<Scalars['Boolean']>;
  subject?: Maybe<Scalars['String']>;
};

export type ZohoTemplate = {
  __typename?: 'zohoTemplate';
  html?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  template_alias?: Maybe<Scalars['String']>;
  template_key?: Maybe<Scalars['String']>;
  template_name?: Maybe<Scalars['String']>;
};

export type ZoomOccurrences = {
  __typename?: 'zoomOccurrences';
  duration?: Maybe<Scalars['Int']>;
  occurrence_id?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type ZoomRegistrantsList = {
  __typename?: 'zoomRegistrantsList';
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  job_title?: Maybe<Scalars['String']>;
  join_url?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type ZoomSettings = {
  __typename?: 'zoomSettings';
  allow_multiple_devices?: Maybe<Scalars['Boolean']>;
  approval_type?: Maybe<Scalars['Int']>;
  close_registration?: Maybe<Scalars['Boolean']>;
  meeting_authentication?: Maybe<Scalars['Boolean']>;
  registrants_confirmation_email?: Maybe<Scalars['Boolean']>;
  registrants_email_notification?: Maybe<Scalars['Boolean']>;
  registration_type?: Maybe<Scalars['Int']>;
};

export type ZoomSettingsCreateInput = {
  allow_multiple_devices?: InputMaybe<Scalars['Boolean']>;
  approval_type?: InputMaybe<Scalars['Int']>;
  close_registration?: InputMaybe<Scalars['Boolean']>;
  meeting_authentication?: InputMaybe<Scalars['Boolean']>;
  registrants_confirmation_email?: InputMaybe<Scalars['Boolean']>;
  registrants_email_notification?: InputMaybe<Scalars['Boolean']>;
  registration_type?: InputMaybe<Scalars['Int']>;
};

export type ZoomSettingsUpdateInput = {
  allow_multiple_devices?: InputMaybe<Scalars['Boolean']>;
  approval_type?: InputMaybe<Scalars['Int']>;
  close_registration?: InputMaybe<Scalars['Boolean']>;
  meeting_authentication?: InputMaybe<Scalars['Boolean']>;
  registrants_confirmation_email?: InputMaybe<Scalars['Boolean']>;
  registrants_email_notification?: InputMaybe<Scalars['Boolean']>;
  registration_type?: InputMaybe<Scalars['Int']>;
};

export type AddBlogsMutationVariables = Exact<{
  data: BlogsCreateInput;
}>;


export type AddBlogsMutation = { __typename?: 'Mutation', createOneBlogs: { __typename?: 'Blogs', id: number, title: string, titleAr?: string | null, description?: string | null, descriptionAr?: string | null, content?: string | null, contentAr?: string | null, thumbnailImage?: string | null, image?: string | null } };

export type DeleteBlogsMutationVariables = Exact<{
  where: BlogsWhereUniqueInput;
}>;


export type DeleteBlogsMutation = { __typename?: 'Mutation', deleteOneBlogs?: { __typename?: 'Blogs', id: number } | null };

export type FindManyBlogsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
  where: BlogsWhereInput;
  orderBy?: InputMaybe<Array<InputMaybe<BlogsOrderByWithRelationInput>> | InputMaybe<BlogsOrderByWithRelationInput>>;
}>;


export type FindManyBlogsQuery = { __typename?: 'Query', findManyBlogs: Array<{ __typename?: 'Blogs', id: number, title: string, titleAr?: string | null, description?: string | null, descriptionAr?: string | null, content?: string | null, contentAr?: string | null, socialMedia: Array<string>, createdAt?: any | null, image?: string | null, thumbnailImage?: string | null, author?: { __typename?: 'User', id: number, username?: string | null, logoUrl?: string | null, image?: string | null, name?: string | null, nameAr?: string | null } | null }> };

export type UpdateBlogsMutationVariables = Exact<{
  data: BlogsUpdateInput;
  where: BlogsWhereUniqueInput;
}>;


export type UpdateBlogsMutation = { __typename?: 'Mutation', updateOneBlogs: { __typename?: 'Blogs', id: number, title: string, titleAr?: string | null, description?: string | null, descriptionAr?: string | null, content?: string | null, contentAr?: string | null, thumbnailImage?: string | null, image?: string | null } };

export type FindManyCityQueryVariables = Exact<{
  where?: InputMaybe<CityWhereInput>;
}>;


export type FindManyCityQuery = { __typename?: 'Query', findManyCity: Array<{ __typename?: 'City', id: number, name: string }> };

export type FindManyCountryQueryVariables = Exact<{ [key: string]: never; }>;


export type FindManyCountryQuery = { __typename?: 'Query', findManyCountry: Array<{ __typename?: 'Country', id: number, name: string }> };

export type FindManyStateQueryVariables = Exact<{
  where?: InputMaybe<StateWhereInput>;
}>;


export type FindManyStateQuery = { __typename?: 'Query', findManyState: Array<{ __typename?: 'State', id: number, name: string }> };

export type FindUniqueCityQueryVariables = Exact<{
  where: CityWhereUniqueInput;
}>;


export type FindUniqueCityQuery = { __typename?: 'Query', findUniqueCity?: { __typename?: 'City', id: number, name: string, countryId?: number | null, stateId?: number | null } | null };

export type SendFcmMutationVariables = Exact<{
  data: FcmInputType;
}>;


export type SendFcmMutation = { __typename?: 'Mutation', sendFCM: boolean };

export type AddMemberToGroupMutationVariables = Exact<{
  data: AddMemberToGroupInputType;
}>;


export type AddMemberToGroupMutation = { __typename?: 'Mutation', AddMemberToGroup: { __typename?: 'TraineeEventGroup', id: number } };

export type DeleteOneTraineeEventGroupMutationVariables = Exact<{
  where: TraineeEventGroupWhereUniqueInput;
}>;


export type DeleteOneTraineeEventGroupMutation = { __typename?: 'Mutation', deleteOneTraineeEventGroup?: { __typename?: 'TraineeEventGroup', id: number } | null };

export type RemoveUserFromGroupMutationVariables = Exact<{
  data: TraineeEventUpdateInput;
  where: TraineeEventWhereUniqueInput;
}>;


export type RemoveUserFromGroupMutation = { __typename?: 'Mutation', updateOneTraineeEvent: { __typename?: 'TraineeEvent', id: number } };

export type ResendEmailGroupBookingMutationVariables = Exact<{
  data: BookingEmailInputType;
}>;


export type ResendEmailGroupBookingMutation = { __typename?: 'Mutation', resendBookingEmail: { __typename?: 'TraineeEvent', id: number } };

export type UpdateGroupBookingMutationVariables = Exact<{
  data: TraineeEventGroupUpdateInput;
  where: TraineeEventGroupWhereUniqueInput;
}>;


export type UpdateGroupBookingMutation = { __typename?: 'Mutation', updateOneTraineeEventGroup: { __typename?: 'TraineeEventGroup', id: number } };

export type EventRatingsQueryVariables = Exact<{
  where: EventWhereUniqueInput;
}>;


export type EventRatingsQuery = { __typename?: 'Query', findUniqueEvent?: { __typename?: 'Event', trainerEvents: Array<{ __typename?: 'TrainerEvent', event: { __typename?: 'Event', titleEn: string, titleAr: string, id: number }, traineeTrainerReviews: Array<{ __typename?: 'TraineeTrainerReview', id: number, reviewOfFive: number, why?: string | null, choices: Array<{ __typename?: 'TraineeTrainerReviewChoice', id: number, isGood: boolean, titleEn: string, titleAr: string }>, trainerEvent: { __typename?: 'TrainerEvent', trainer?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null } | null }, traineeEvent: { __typename?: 'TraineeEvent', trainee: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null } } }> }>, traineeEventReviews: Array<{ __typename?: 'TraineeEventReview', id: number, reviewOfFive: number, why?: string | null, traineeEventReviewChoices: Array<{ __typename?: 'TraineeEventReviewChoice', id: number, isGood: boolean, titleEn: string, titleAr: string }>, TraineeEvent: { __typename?: 'TraineeEvent', id: number, trainee: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null } } }> } | null };

export type FindManyRankQueryVariables = Exact<{ [key: string]: never; }>;


export type FindManyRankQuery = { __typename?: 'Query', findManyRank: Array<{ __typename?: 'Rank', id: number, title: string }> };

export type FindManyZohoEmailsQueryVariables = Exact<{
  where: ZohoEmailWhereInput;
}>;


export type FindManyZohoEmailsQuery = { __typename?: 'Query', findManyZohoEmails?: Array<{ __typename?: 'ZohoEmail', id: number, subject?: string | null, opened: boolean, createdAt: any, clicked: boolean, softBounce: boolean, hardBounce: boolean, sent: boolean, User?: { __typename?: 'User', name?: string | null, email: string, id: number, mobileNumber?: string | null, profession?: { __typename?: 'Profession', titleEn: string } | null, inviter?: { __typename?: 'User', name?: string | null } | null } | null, TraineeEvent?: { __typename?: 'TraineeEvent', id: number, bookingStatusId?: number | null, registrantToken?: string | null, Certificate?: { __typename?: 'Certificate', id?: number | null } | null } | null, Event?: { __typename?: 'Event', titleEn: string, addressInstructions?: string | null, locationLatitude?: any | null, locationLongitude?: any | null, startDate?: any | null, address?: string | null, eventDays: Array<{ __typename?: 'EventDay', startTime?: any | null }>, city?: { __typename?: 'City', name: string } | null } | null, Template?: { __typename?: 'Template', id: number, title: string, data: any, zohoTemplateId?: string | null } | null } | null> | null };

export type FindMemberBasicInfoQueryVariables = Exact<{
  where: UserWhereUniqueInput;
}>;


export type FindMemberBasicInfoQuery = { __typename?: 'Query', findUniqueUser?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, email: string, roleId: number } | null };

export type FindTraineeAttendanceQueryVariables = Exact<{
  where?: InputMaybe<TraineeEventWhereInput>;
}>;


export type FindTraineeAttendanceQuery = { __typename?: 'Query', findManyTraineeEvent: Array<{ __typename?: 'TraineeEvent', id: number, trainee: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, scfhs?: string | null, mobileNumber?: string | null, email: string }, traineeEventStudyMaterialAttendance: Array<{ __typename?: 'TraineeEventStudyMaterialAttendance', id: number, progressPercentage?: any | null, trainerEventStudyMaterialId: number, trainerEventStudyMaterial: { __typename?: 'TrainerEventStudyMaterial', id: number, title: string, media?: string | null, url: string, deletedAt?: any | null } }>, event: { __typename?: 'Event', id: number, titleEn: string, titleAr: string, eventTypeId: number, eventDays: Array<{ __typename?: 'EventDay', id?: number | null, date?: any | null, zoomDuration?: number | null, startTime?: any | null, endTime?: any | null, deletedAt?: any | null }>, trainerEventStudyMaterialGroups: Array<{ __typename?: 'TrainerEventStudyMaterialGroup', id: number, title: string, StudyMaterials: Array<{ __typename?: 'TrainerEventStudyMaterial', id: number, title: string, media?: string | null, url: string, deletedAt?: any | null, traineeEventStudyMaterialAttendance: Array<{ __typename?: 'TraineeEventStudyMaterialAttendance', id: number, progressPercentage?: any | null, trainerEventStudyMaterialId: number }> }> }> }, Certificate?: { __typename?: 'Certificate', id?: number | null } | null, attendance: Array<{ __typename?: 'TraineeEventDayAttendance', id: number, duration?: number | null, eventDayId: number, joinTime: any, leaveTime?: any | null }> }> };

export type FindUserRoleQueryVariables = Exact<{
  where: UserWhereUniqueInput;
}>;


export type FindUserRoleQuery = { __typename?: 'Query', findUniqueUser?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, email: string, image?: string | null, role: { __typename?: 'Role', id: number, titleEn: string, titleAr: string } } | null };

export type OrganizerEventsQueryVariables = Exact<{
  where: UserWhereUniqueInput;
}>;


export type OrganizerEventsQuery = { __typename?: 'Query', findUniqueUser?: { __typename?: 'User', addedEvents: Array<{ __typename?: 'Event', id: number, startDate?: any | null, endDate?: any | null, createdAt?: any | null, deletedAt?: any | null, addedBy?: { __typename?: 'User', name?: string | null, nameAr?: string | null } | null, methodOfDelivery: { __typename?: 'MethodOfDelivery', titleEn: string, titleAr: string } }> } | null };

export type TrainerRatingsQueryVariables = Exact<{
  where: UserWhereUniqueInput;
}>;


export type TrainerRatingsQuery = { __typename?: 'Query', findUniqueUser?: { __typename?: 'User', trainerEvents: Array<{ __typename?: 'TrainerEvent', event: { __typename?: 'Event', titleEn: string, titleAr: string, id: number }, traineeTrainerReviews: Array<{ __typename?: 'TraineeTrainerReview', id: number, reviewOfFive: number, why?: string | null, choices: Array<{ __typename?: 'TraineeTrainerReviewChoice', id: number, isGood: boolean, titleEn: string, titleAr: string }>, traineeEvent: { __typename?: 'TraineeEvent', trainee: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null } } }> }> } | null };

export type TraineeAttendanceQueryVariables = Exact<{
  where: UserWhereUniqueInput;
}>;


export type TraineeAttendanceQuery = { __typename?: 'Query', findUniqueUser?: { __typename?: 'User', traineeEvents: Array<{ __typename?: 'TraineeEvent', traineeId: number, event: { __typename?: 'Event', id: number, titleEn: string, titleAr: string }, attendance: Array<{ __typename?: 'TraineeEventDayAttendance', id: number, eventDayId: number, eventDay: { __typename?: 'EventDay', id?: number | null, date?: any | null, zoomDuration?: number | null, startTime?: any | null, endTime?: any | null, traineeAttendance?: Array<{ __typename?: 'TraineeEventDayAttendance', id: number, duration?: number | null, joinTime: any, leaveTime?: any | null } | null> | null } }> }> } | null };

export type TraineeEventsQueryVariables = Exact<{
  where?: InputMaybe<TraineeEventWhereInput>;
}>;


export type TraineeEventsQuery = { __typename?: 'Query', findManyTraineeEvent: Array<{ __typename?: 'TraineeEvent', id: number, totalToPay: any, isWorkshopRegistrant: boolean, trainee: { __typename?: 'User', name?: string | null, nameAr?: string | null, specialtyId?: number | null, professionId?: number | null, specialty?: { __typename?: 'Specialty', id: number, titleAr?: string | null, titleEn: string } | null, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null, city?: { __typename?: 'City', name: string, country?: { __typename?: 'Country', name: string } | null } | null, nationality?: { __typename?: 'Country', name: string } | null }, bookingStatus?: { __typename?: 'BookingStatus', id: number, titleAr: string, titleEn: string } | null, event: { __typename?: 'Event', titleEn: string, titleAr: string, startDate?: any | null, endDate?: any | null, createdAt?: any | null, deletedAt?: any | null, methodOfDelivery: { __typename?: 'MethodOfDelivery', titleEn: string, titleAr: string } }, transitions: Array<{ __typename?: 'Transition', paymentWay: { __typename?: 'PaymentWay', id: number, title: string }, status: { __typename?: 'TransitionStatusType', id: number, titleAr: string, titleEn: string } }>, attendance: Array<{ __typename?: 'TraineeEventDayAttendance', eventDayId: number, joinTime: any, leaveTime?: any | null, duration?: number | null }>, review?: { __typename?: 'TraineeEventReview', reviewOfFive: number } | null }> };

export type TraineeEventFindManyQueryQueryVariables = Exact<{
  where?: InputMaybe<TraineeEventWhereInput>;
}>;


export type TraineeEventFindManyQueryQuery = { __typename?: 'Query', findManyTraineeEvent: Array<{ __typename?: 'TraineeEvent', id: number, totalToPay: any, createdAt?: any | null, event: { __typename?: 'Event', startDate?: any | null, titleEn: string, titleAr: string, ZoomMeeting?: { __typename?: 'ZoomMeeting', type?: string | null, meetingId?: string | null } | null, methodOfDelivery: { __typename?: 'MethodOfDelivery', id: number, titleAr: string, titleEn: string }, eventDays: Array<{ __typename?: 'EventDay', id?: number | null, startTime?: any | null, endTime?: any | null }> }, inviter?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, email: string } | null, eventDay?: { __typename?: 'EventDay', id?: number | null, startTime?: any | null, endTime?: any | null } | null, bookingStatus?: { __typename?: 'BookingStatus', id: number, titleAr: string, titleEn: string } | null, trainee: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, mobileNumber?: string | null, email: string, adminNotes?: Array<string> | null, role: { __typename?: 'Role', id: number, titleAr: string, titleEn: string }, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null, eventMediaTracking: Array<{ __typename?: 'EventMediaTracking', id: number, twitter?: boolean | null, facebook?: boolean | null, instagram?: boolean | null, email?: boolean | null, linkedin?: boolean | null, whatsApp?: boolean | null, google?: boolean | null, telegram?: boolean | null, ertiqaa?: boolean | null, anat?: boolean | null, friend?: boolean | null, eventId?: number | null }> } }> };

export type TraineeEventReviewChoicesQueryVariables = Exact<{ [key: string]: never; }>;


export type TraineeEventReviewChoicesQuery = { __typename?: 'Query', findManyTraineeEventReviewChoice: Array<{ __typename?: 'TraineeEventReviewChoice', id: number, titleAr: string, titleEn: string, isGood: boolean }> };

export type TraineeNeedsQueryVariables = Exact<{
  where: UserWhereUniqueInput;
}>;


export type TraineeNeedsQuery = { __typename?: 'Query', findUniqueUser?: { __typename?: 'User', memberNeeds: Array<{ __typename?: 'MemberNeeds', id: number, data?: any | null, status: MemberNeedsStatus }> } | null };

export type TraineeRatingsQueryVariables = Exact<{
  where: UserWhereUniqueInput;
}>;


export type TraineeRatingsQuery = { __typename?: 'Query', findUniqueUser?: { __typename?: 'User', id: number, traineeEvents: Array<{ __typename?: 'TraineeEvent', id: number, event: { __typename?: 'Event', titleEn: string, titleAr: string, id: number }, traineeTrainerReviews: Array<{ __typename?: 'TraineeTrainerReview', id: number, reviewOfFive: number, why?: string | null, choices: Array<{ __typename?: 'TraineeTrainerReviewChoice', id: number, isGood: boolean, titleEn: string, titleAr: string }>, trainerEvent: { __typename?: 'TrainerEvent', trainer?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null } | null } }>, review?: { __typename?: 'TraineeEventReview', id: number, reviewOfFive: number, why?: string | null, traineeEventReviewChoices: Array<{ __typename?: 'TraineeEventReviewChoice', id: number, isGood: boolean, titleEn: string, titleAr: string }> } | null }> } | null };

export type TraineeTrainerReviewChoiceQueryVariables = Exact<{ [key: string]: never; }>;


export type TraineeTrainerReviewChoiceQuery = { __typename?: 'Query', findManyTraineeTrainerReviewChoice: Array<{ __typename?: 'TraineeTrainerReviewChoice', id: number, titleAr: string, titleEn: string, isGood: boolean }> };

export type TrainerEventsQueryVariables = Exact<{
  where?: InputMaybe<TrainerEventWhereInput>;
}>;


export type TrainerEventsQuery = { __typename?: 'Query', findManyTrainerEvent: Array<{ __typename?: 'TrainerEvent', id: number, trainer?: { __typename?: 'User', name?: string | null, nameAr?: string | null, role: { __typename?: 'Role', id: number, titleAr: string, titleEn: string } } | null, event: { __typename?: 'Event', titleEn: string, titleAr: string, startDate?: any | null, endDate?: any | null, createdAt?: any | null, deletedAt?: any | null, methodOfDelivery: { __typename?: 'MethodOfDelivery', titleEn: string, titleAr: string } }, transitions: Array<{ __typename?: 'Transition', paymentWay: { __typename?: 'PaymentWay', id: number, title: string }, status: { __typename?: 'TransitionStatusType', id: number, titleAr: string, titleEn: string } }> }> };

export type UpdateOneCvMutationVariables = Exact<{
  data: CvUpdateInput;
  where: CvWhereUniqueInput;
}>;


export type UpdateOneCvMutation = { __typename?: 'Mutation', updateOneCv: { __typename?: 'Cv', id: number, education: Array<{ __typename?: 'Education', id: number, university?: string | null, graduationYear?: any | null, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null, specialty?: { __typename?: 'Specialty', id: number, titleEn: string, titleAr?: string | null } | null, qualification?: { __typename?: 'Qualification', id: number, title: string } | null }>, qualification?: { __typename?: 'Qualification', id: number, title: string } | null, rank?: { __typename?: 'Rank', id: number, title: string } | null, professionalSkills: Array<{ __typename?: 'ProfessionalSkills', id: number, yearsOfExperience?: number | null, placeOfWork?: string | null, natureOfWork?: string | null, type?: ProfessionalSkillsType | null, academicRank?: { __typename?: 'AcademicRank', id: number, titleAr: string, titleEn: string } | null }>, trainingExperience: Array<{ __typename?: 'TrainingExperience', id: number, eventName?: string | null, executingAgency?: string | null }>, scientificResearches: Array<{ __typename?: 'ScientificResearch', id: number, description?: string | null, type?: ScientificResearchType | null, role?: ScientificResearchRole | null }> } };

export type UpdateUserRoleMutationVariables = Exact<{
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
}>;


export type UpdateUserRoleMutation = { __typename?: 'Mutation', updateOneUser: { __typename?: 'User', id: number, role: { __typename?: 'Role', id: number, titleAr: string, titleEn: string } } };

export type DestroyWaMutationVariables = Exact<{
  data: DestroyWhatsAppInputType;
}>;


export type DestroyWaMutation = { __typename?: 'Mutation', destroyWhatsApp?: boolean | null };

export type FindWaStateQueryVariables = Exact<{ [key: string]: never; }>;


export type FindWaStateQuery = { __typename?: 'Query', findWAState?: { __typename?: 'WAStateType', ProfilePicUrl?: string | null, name?: string | null, wid?: string | null, state?: string | null, platform?: string | null, pushName?: string | null } | null };

export type FindWhatsAppMsgsQueryVariables = Exact<{
  where: FindWhatsAppMsgsInput;
}>;


export type FindWhatsAppMsgsQuery = { __typename?: 'Query', findWhatsAppMsgs: { __typename?: 'MsgTemplate', event: { __typename?: 'Event', titleEn: string, titleAr: string, startDate?: any | null, locationLatitude?: any | null, locationLongitude?: any | null, cmeHours?: any | null, address?: string | null, addressInstructions?: string | null, methodOfDeliveryId?: number | null }, listMsgOutput: Array<{ __typename?: 'listMsgOutput', bookingStatus?: string | null, key?: string | null, msg?: string | null, date?: any | null, method?: string | null, target?: string | null, users?: Array<{ __typename?: 'userslistMsgOutput', name?: string | null, image?: string | null, msgState?: any | null, bookingId?: number | null, userId?: number | null, phone?: string | null } | null> | null } | null> } };

export type FindWhatsAppQrQueryVariables = Exact<{ [key: string]: never; }>;


export type FindWhatsAppQrQuery = { __typename?: 'Query', whatsAppGetQr?: { __typename?: 'Settings', value?: any | null } | null };

export type InitializeWaMutationVariables = Exact<{
  data: InitializeWhatsAppInputType;
}>;


export type InitializeWaMutation = { __typename?: 'Mutation', initializeWhatsApp?: boolean | null };

export type LogoutWaMutationVariables = Exact<{
  data: LogoutWhatsAppInputType;
}>;


export type LogoutWaMutation = { __typename?: 'Mutation', logoutWhatsApp?: boolean | null };

export type ResetWaMutationVariables = Exact<{
  data: ResetWhatsAppInputType;
}>;


export type ResetWaMutation = { __typename?: 'Mutation', resetWhatsApp?: boolean | null };

export type UpdateWhatsAppMsgsMutationVariables = Exact<{
  data: UpdateWhatsAppMsgsInputType;
}>;


export type UpdateWhatsAppMsgsMutation = { __typename?: 'Mutation', updateWhatsAppMsgs: { __typename?: 'Settings', id: number, nameAr: string, nameEn: string, value?: any | null } };

export type WhatsAppSendManyMutationVariables = Exact<{
  data: WhatsAppSendManyInputType;
}>;


export type WhatsAppSendManyMutation = { __typename?: 'Mutation', whatsAppSendMany: boolean };

export type DeleteBookingMutationVariables = Exact<{
  where: TraineeEventWhereUniqueInput;
}>;


export type DeleteBookingMutation = { __typename?: 'Mutation', deleteOneTraineeEvent?: { __typename?: 'TraineeEvent', id: number } | null };

export type GroupBookingQueryVariables = Exact<{
  where?: InputMaybe<TraineeEventGroupWhereInput>;
}>;


export type GroupBookingQuery = { __typename?: 'Query', findManyTraineeEventGroup: Array<{ __typename?: 'TraineeEventGroup', id: number, traineeEvents: Array<{ __typename?: 'TraineeEvent', id: number, totalToPay: any, createdAt?: any | null, bookingStatus?: { __typename?: 'BookingStatus', id: number, titleAr: string, titleEn: string } | null, trainee: { __typename?: 'User', id: number, name?: string | null, mobileNumber?: string | null, nameAr?: string | null }, group?: { __typename?: 'TraineeEventGroup', id: number, groupTotalToPay: any } | null, event: { __typename?: 'Event', id: number, titleEn: string, titleAr: string } }> }> };

export type TurnToGuestMutationVariables = Exact<{
  data: TurnToGuestInputType;
}>;


export type TurnToGuestMutation = { __typename?: 'Mutation', turnToGuest: { __typename?: 'TraineeEvent', id: number } };

export type UpdateAllBookingsMethodMutationVariables = Exact<{
  data: UpdateAllBookingsMethodInputType;
}>;


export type UpdateAllBookingsMethodMutation = { __typename?: 'Mutation', updateAllBookingsMethod: { __typename?: 'TraineeEvent', id: number } };

export type UpdateBookingMethodMutationVariables = Exact<{
  data: UpdateBookingMethodInputType;
}>;


export type UpdateBookingMethodMutation = { __typename?: 'Mutation', updateBookingMethod: { __typename?: 'TraineeEvent', id: number } };

export type AnalyticsMutationVariables = Exact<{
  data: AnalyticsInputType;
}>;


export type AnalyticsMutation = { __typename?: 'Mutation', analytics: boolean };

export type ContactUsMutationVariables = Exact<{
  data: ContactUsType;
}>;


export type ContactUsMutation = { __typename?: 'Mutation', ContactUs: boolean };

export type SendEmailMutationVariables = Exact<{
  data: SendEmailInputType;
}>;


export type SendEmailMutation = { __typename?: 'Mutation', sendEmail: boolean };

export type AddBookingMutationVariables = Exact<{
  data: BookingInputType;
}>;


export type AddBookingMutation = { __typename?: 'Mutation', AddBooking: { __typename?: 'Booking', traineeEvent: Array<{ __typename?: 'TraineeEvent', id: number, price: any, tax: any, totalToPay: any, isLateRegistrant: boolean, isWorkshopRegistrant: boolean, isGroupRegistrant: boolean, certificatePrice?: any | null, workshopPrice?: any | null, walletBalance?: any | null, couponeDiscount?: any | null, event: { __typename?: 'Event', id: number, titleAr: string, titleEn: string, imageUrl?: string | null, eventTypeId: number, methodOfDeliveryId?: number | null, pricingPlan: { __typename?: 'PricingPlan', cardFee?: boolean | null, hasWorkshop?: boolean | null, pricingPlanTypeId?: number | null, paymentType?: string | null }, eventType: { __typename?: 'EventType', titleAr: string, titleEn: string }, eventDays: Array<{ __typename?: 'EventDay', id?: number | null, startTime?: any | null, endTime?: any | null, hidden?: boolean | null, brotherId?: number | null, brother?: { __typename?: 'EventDay', id?: number | null, startTime?: any | null, endTime?: any | null, hidden?: boolean | null, brotherId?: number | null } | null, siblings?: Array<{ __typename?: 'EventDay', id?: number | null, startTime?: any | null, endTime?: any | null, hidden?: boolean | null, brotherId?: number | null } | null> | null, _count?: { __typename?: 'EventDayCountOutputType', trainerLessons: number } | null }>, methodOfDelivery: { __typename?: 'MethodOfDelivery', titleAr: string, titleEn: string }, eventMediaTracking: Array<{ __typename?: 'EventMediaTracking', id: number, eventId?: number | null, traineeId?: number | null }> }, trainee: { __typename?: 'User', email: string, balance: any, eventMediaTracking: Array<{ __typename?: 'EventMediaTracking', id: number, eventId?: number | null, traineeId?: number | null }> }, parts: Array<{ __typename?: 'TraineeEventPart', eventPartId: number, partTotalPrice: any, eventPart: { __typename?: 'EventPart', id: number, outlineEn: string, outlineAr: string } }> } | null>, traineeEventGroup?: { __typename?: 'TraineeEventGroup', id: number, groupPrice: any, groupWalletBalance?: any | null, groupWorkshopPrice?: any | null, groupCertificatePrice?: any | null, groupTax: any, groupTotalToPay: any, isGroupPay: boolean, couponeDiscount?: any | null } | null } };

export type AddHowHeardAboutEventMutationVariables = Exact<{
  data: AddHowHeardAboutEventInputType;
}>;


export type AddHowHeardAboutEventMutation = { __typename?: 'Mutation', addHowHeardAboutEvent: boolean };

export type AddRemindMeMutationVariables = Exact<{
  data: RemindMeInputType;
}>;


export type AddRemindMeMutation = { __typename?: 'Mutation', AddRemindMe: boolean };

export type ApplyCouponToBookingMutationVariables = Exact<{
  data: ApplyCouponToBookingInputType;
}>;


export type ApplyCouponToBookingMutation = { __typename?: 'Mutation', ApplyCouponToBooking: boolean };

export type BuyCertificateMutationVariables = Exact<{
  data: TraineeEventUpdateInput;
  where: TraineeEventWhereUniqueInput;
}>;


export type BuyCertificateMutation = { __typename?: 'Mutation', buyCertificate: { __typename?: 'TraineeEvent', id: number } };

export type FindManyHowHeardAboutEventQueryVariables = Exact<{ [key: string]: never; }>;


export type FindManyHowHeardAboutEventQuery = { __typename?: 'Query', findManyHowHeardAboutEvent: Array<{ __typename?: 'HowHeardAboutEvent', id: number, titleAr: string, titleEn: string }> };

export type FreeBookingMutationVariables = Exact<{
  data: FreeBookingInputType;
}>;


export type FreeBookingMutation = { __typename?: 'Mutation', freeBooking: { __typename?: 'freeBookingOutput', isPaid: boolean, eventName?: string | null, name?: string | null, source: string, date: any, reference_number: number, amount_format: any, fee_format: any } };

export type GetBookingQueryVariables = Exact<{
  data: GetBookingInputType;
}>;


export type GetBookingQuery = { __typename?: 'Query', getBooking: { __typename?: 'Booking', traineeEvent: Array<{ __typename?: 'TraineeEvent', id: number, price: any, tax: any, totalToPay: any, isLateRegistrant: boolean, isWorkshopRegistrant: boolean, isGroupRegistrant: boolean, certificatePrice?: any | null, workshopPrice?: any | null, walletBalance?: any | null, bookingStatusId?: number | null, couponeDiscount?: any | null, event: { __typename?: 'Event', id: number, titleAr: string, titleEn: string, imageUrl?: string | null, eventTypeId: number, methodOfDeliveryId?: number | null, eventType: { __typename?: 'EventType', titleAr: string, titleEn: string }, eventDays: Array<{ __typename?: 'EventDay', id?: number | null, startTime?: any | null, endTime?: any | null, hidden?: boolean | null, brotherId?: number | null, brother?: { __typename?: 'EventDay', id?: number | null, startTime?: any | null, endTime?: any | null, hidden?: boolean | null, brotherId?: number | null } | null, siblings?: Array<{ __typename?: 'EventDay', id?: number | null, startTime?: any | null, endTime?: any | null, hidden?: boolean | null, brotherId?: number | null } | null> | null, _count?: { __typename?: 'EventDayCountOutputType', trainerLessons: number } | null }>, methodOfDelivery: { __typename?: 'MethodOfDelivery', titleAr: string, titleEn: string }, pricingPlan: { __typename?: 'PricingPlan', cardFee?: boolean | null, hasWorkshop?: boolean | null, pricingPlanTypeId?: number | null, paymentType?: string | null }, eventMediaTracking: Array<{ __typename?: 'EventMediaTracking', id: number, eventId?: number | null, traineeId?: number | null }> }, trainee: { __typename?: 'User', balance: any, email: string, eventMediaTracking: Array<{ __typename?: 'EventMediaTracking', id: number, eventId?: number | null, traineeId?: number | null }> }, parts: Array<{ __typename?: 'TraineeEventPart', eventPartId: number, partTotalPrice: any, eventPart: { __typename?: 'EventPart', id: number, outlineEn: string, outlineAr: string } }> } | null>, traineeEventGroup?: { __typename?: 'TraineeEventGroup', id: number, groupPrice: any, groupWalletBalance?: any | null, groupWorkshopPrice?: any | null, groupCertificatePrice?: any | null, groupTax: any, groupTotalToPay: any, isGroupPay: boolean, couponeDiscount?: any | null } | null } };

export type GetBookingEventIdQueryVariables = Exact<{
  data: GetBookingInputType;
}>;


export type GetBookingEventIdQuery = { __typename?: 'Query', getBooking: { __typename?: 'Booking', traineeEvent: Array<{ __typename?: 'TraineeEvent', id: number, trainee: { __typename?: 'User', name?: string | null }, event: { __typename?: 'Event', titleAr: string, titleEn: string, defaultLanguage?: string | null, id: number } } | null> } };

export type GetWalletTransitionQueryVariables = Exact<{
  data: GetWalletInputType;
}>;


export type GetWalletTransitionQuery = { __typename?: 'Query', getWalletTransition: { __typename?: 'walletTransitionPayment', isPaid: boolean, eventName?: string | null, name?: string | null, source: string, date: any, reference_number: number, amount_format: any, fee_format: any } };

export type HasBookingQueryVariables = Exact<{
  where: TraineeEventWhereUniqueInput;
}>;


export type HasBookingQuery = { __typename?: 'Query', findUniqueTraineeEvent?: { __typename?: 'TraineeEvent', id: number, bookingStatus?: { __typename?: 'BookingStatus', id: number } | null } | null };

export type InitiateBookingTransitionMutationVariables = Exact<{
  data: InitiateBookingTransitionInputType;
}>;


export type InitiateBookingTransitionMutation = { __typename?: 'Mutation', InitiateBookingTransition: { __typename?: 'Transition', id: number, amount: any, tax: any, fullAmount: any, mediator?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null } | null, paymentWay: { __typename?: 'PaymentWay', id: number, title: string }, transitionPurpose: { __typename?: 'TransitionPurpose', id: number, titleAr: string, titleEn: string }, status: { __typename?: 'TransitionStatusType', id: number, titleEn: string, titleAr: string } } };

export type MoyasarInitiateTransitionMutationVariables = Exact<{
  data: MoyasarInitiateTransition;
}>;


export type MoyasarInitiateTransitionMutation = { __typename?: 'Mutation', moyasarInitiateTransition?: boolean | null };

export type PayWithWalletMutationVariables = Exact<{
  data: WalletTransition;
}>;


export type PayWithWalletMutation = { __typename?: 'Mutation', payWithWallet: { __typename?: 'walletPaymentSuccess', transition: number, traineeEventId: number, status: string } };

export type UpdateBookingMutationVariables = Exact<{
  data: UpdateBookingInputType;
}>;


export type UpdateBookingMutation = { __typename?: 'Mutation', UpdateBooking: { __typename?: 'Booking', traineeEvent: Array<{ __typename?: 'TraineeEvent', id: number, price: any, tax: any, totalToPay: any, isLateRegistrant: boolean, isWorkshopRegistrant: boolean, isGroupRegistrant: boolean, certificatePrice?: any | null, workshopPrice?: any | null, walletBalance?: any | null, bookingStatusId?: number | null, eventId: number } | null> } };

export type GetCoursePriceQueryVariables = Exact<{
  data: BookingInputType;
}>;


export type GetCoursePriceQuery = { __typename?: 'Query', getCoursePrice: { __typename?: 'getCoursePriceOutput', seatsError?: string | null, event: { __typename?: 'Event', titleAr: string, titleEn: string, imageUrl?: string | null, eventTypeId: number, defaultLanguage?: string | null, isAccredited: boolean, methodOfDeliveryId?: number | null, pricingPlan: { __typename?: 'PricingPlan', cardFee?: boolean | null, pricingPlanTypeId?: number | null, freePlanCertificateStatus?: string | null, hasDiscount?: boolean | null, discountPercentage?: any | null, hasDiscountEndDate?: boolean | null, discountEndDate?: any | null }, eventType: { __typename?: 'EventType', titleAr: string, titleEn: string }, eventDays: Array<{ __typename?: 'EventDay', id?: number | null, startTime?: any | null, endTime?: any | null, _count?: { __typename?: 'EventDayCountOutputType', trainerLessons: number } | null }>, methodOfDelivery: { __typename?: 'MethodOfDelivery', titleAr: string, titleEn: string } }, traineeEvent: Array<{ __typename?: 'TraineeEvent', price: any, tax: any, totalToPay: any, walletBalance?: any | null, isLateRegistrant: boolean, isWorkshopRegistrant: boolean, isGroupRegistrant: boolean, certificatePrice?: any | null, workshopPrice?: any | null, trainee: { __typename?: 'User', email: string }, parts: Array<{ __typename?: 'TraineeEventPart', eventPartId: number, partTotalPrice: any }> } | null>, IsProfessionCompatable: Array<{ __typename?: 'incompatableProfessions', email: string, IsProfessionCompatable: boolean } | null>, traineeEventGroup?: { __typename?: 'TraineeEventGroup', id: number, groupWorkshopPrice?: any | null, groupWalletBalance?: any | null, groupTotalToPay: any, groupTax: any, groupPrice: any, groupCertificatePrice?: any | null, areWorkshopRegistrants: boolean, areLateRegistrants: boolean, isGroupPay: boolean, traineeEvents: Array<{ __typename?: 'TraineeEvent', price: any, tax: any, totalToPay: any, walletBalance?: any | null, isLateRegistrant: boolean, isWorkshopRegistrant: boolean, isGroupRegistrant: boolean, certificatePrice?: any | null, workshopPrice?: any | null, parts: Array<{ __typename?: 'TraineeEventPart', eventPartId: number, partTotalPrice: any }> }> } | null, seatsErrorArray?: Array<{ __typename?: 'seatsErrorArray', eventDayId?: number | null, err?: string | null } | null> | null } };

export type CoursesPathsQueryVariables = Exact<{ [key: string]: never; }>;


export type CoursesPathsQuery = { __typename?: 'Query', CoursesPaths: Array<{ __typename?: 'CoursesPaths', id?: number | null } | null> };

export type EventDetailsOutputQueryVariables = Exact<{
  eventDetailsOutputId: Scalars['Int'];
}>;


export type EventDetailsOutputQuery = { __typename?: 'Query', EventDetailsOutput: { __typename?: 'EventDetailsOutput', id?: number | null, price?: string | null, titleEn?: string | null, titleAr?: string | null, defaultLanguage?: string | null, discussionStatus?: boolean | null, timeTableStatus?: boolean | null, backgroundImagesUrls?: Array<string | null> | null, keywordsAr?: Array<string | null> | null, keywordsEn?: Array<string | null> | null, descriptionAr?: string | null, descriptionEn?: string | null, address?: string | null, addressInstructions?: string | null, locationLatitude?: any | null, locationLongitude?: any | null, youtubeUrl?: string | null, introductionAr?: string | null, introductionEn?: string | null, objectivesAr?: string | null, objectivesEn?: string | null, mainThemeAr?: string | null, mainThemeEn?: string | null, outcomesAr?: string | null, outcomesEn?: string | null, cmeNumber?: string | null, whyTargetedAudienceAr?: string | null, whyTargetedAudienceEn?: string | null, isTraineeCertificateAvailable?: boolean | null, isAllProfessionsTargeted?: boolean | null, isSponsored?: boolean | null, sponsorshipImagesUrls?: any | null, cmeHours?: any | null, isAccredited?: boolean | null, isAccreditedSHA?: boolean | null, startDate?: any | null, endDate?: any | null, shortDescriptionAr?: string | null, shortDescriptionEn?: string | null, methodOfDelivery?: { __typename?: 'MethodOfDelivery', id: number, titleAr: string, titleEn: string } | null, eventType?: { __typename?: 'EventType', id: number, titleAr: string, titleEn: string } | null, Quiz?: { __typename?: 'Quiz', id: number, name?: string | null, QuizQuestion: Array<{ __typename?: 'QuizQuestion', questionEn: string, questionType: string, questionAr: string, id: string, questionOrder?: number | null, createdAt: any, rightAnswer?: string | null, QuizQuestionAnswer: Array<{ __typename?: 'QuizQuestionAnswer', answerAr: string, answerEn: string, id: string, createdAt: any }> }> } | null, Discussion?: Array<{ __typename?: 'Discussion', id: number, comment: string, createdAt: any, User: { __typename?: 'User', id: number, username?: string | null, logoUrl?: string | null, name?: string | null, nameAr?: string | null } } | null> | null, packageEvents?: Array<{ __typename?: 'Event', id: number, titleAr: string, titleEn: string, startDate?: any | null, endDate?: any | null, introductionAr?: string | null, introductionEn?: string | null, shortDescriptionAr?: string | null, shortDescriptionEn?: string | null, isAccredited: boolean, isAccreditedSHA?: boolean | null, cmeHours?: any | null, isTraineeCertificateAvailable: boolean, methodOfDelivery: { __typename?: 'MethodOfDelivery', id: number, titleAr: string, titleEn: string }, eventType: { __typename?: 'EventType', id: number, titleEn: string, titleAr: string }, eventLanguages: Array<{ __typename?: 'Language', id: number, title: string }> } | null> | null, package?: { __typename?: 'Event', id: number, titleAr: string, titleEn: string } | null, folder?: { __typename?: 'EventFolder', id: number, titleAr: string, titleEn: string } | null, targetedAudiences?: Array<{ __typename?: 'Profession', id: number, titleEn: string, titleAr?: string | null } | null> | null, targetedSpecialities?: Array<{ __typename?: 'Specialty', id: number, titleEn: string, titleAr?: string | null } | null> | null, eventDays?: Array<{ __typename?: 'EventDay', id?: number | null, deletedAt?: any | null, outlineAr?: string | null, outlineEn?: string | null, date?: any | null, startTime?: any | null, endTime?: any | null, methodOfDelivery?: { __typename?: 'MethodOfDelivery', id: number, titleEn: string, titleAr: string } | null, trainerLessons?: Array<{ __typename?: 'TrainerEventDayLesson', id: number, outlineAr: string, outlineEn: string, startTime: any, endTime: any, TrainerEventDayLessonType: { __typename?: 'TrainerEventDayLessonType', id: number, titleAr: string, titleEn: string }, methodOfTeaching?: { __typename?: 'MethodOfTeachingType', id: number, titleAr: string, titleEn: string } | null } | null> | null } | null> | null, pricingPlan?: { __typename?: 'PricingPlan', id: number, hasMultiPartDiscount?: boolean | null, multiPartDiscountPrice?: any | null, hasGroupDiscountEndDate?: boolean | null, freePlanCertificateCmeIsPaid?: boolean | null, freePlanCertificateStatus?: string | null, hasWorkshop?: boolean | null, groupDiscountEndDate?: any | null, groupDiscountMinNumberOfRegistrants?: number | null, groupDiscountPrice?: any | null, hasGroupDiscount?: boolean | null, hasDiscount?: boolean | null, discountPercentage?: any | null, hasDiscountEndDate?: boolean | null, discountEndDate?: any | null, hasLateRegistration?: boolean | null, lateRegistrationStartDate?: any | null, pricingPlanType?: { __typename?: 'PricingPlanType', id: number } | null } | null, eventParts?: Array<{ __typename?: 'EventPart', id: number, outlineAr: string, outlineEn: string, pricingPlan: { __typename?: 'PricingPlan', id: number, hasWorkshop?: boolean | null, groupDiscountEndDate?: any | null, groupDiscountMinNumberOfRegistrants?: number | null, groupDiscountPrice?: any | null, hasGroupDiscount?: boolean | null, pricingPlanType?: { __typename?: 'PricingPlanType', id: number } | null }, eventDays: Array<{ __typename?: 'EventDay', id?: number | null, outlineAr?: string | null, outlineEn?: string | null, date?: any | null, startTime?: any | null, endTime?: any | null, trainerLessons?: Array<{ __typename?: 'TrainerEventDayLesson', outlineAr: string, outlineEn: string, startTime: any, endTime: any, TrainerEventDayLessonType: { __typename?: 'TrainerEventDayLessonType', id: number, titleAr: string, titleEn: string }, methodOfTeaching?: { __typename?: 'MethodOfTeachingType', id: number, titleAr: string, titleEn: string } | null } | null> | null }> } | null> | null, eventLanguages?: Array<{ __typename?: 'Language', id: number, title: string } | null> | null, trainerEvents?: Array<{ __typename?: 'TrainerEvent', id: number, trainer?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, image?: string | null, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null, specialty?: { __typename?: 'Specialty', id: number, titleEn: string, titleAr?: string | null } | null } | null } | null> | null, traineeEvents?: Array<{ __typename?: 'TraineeEventModel', bookingStatusId?: number | null, trainee?: { __typename?: 'TraineeModel', image?: string | null } | null } | null> | null } };

export type ListCoursesQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EventWhereInput>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type ListCoursesQuery = { __typename?: 'Query', listCourses?: Array<{ __typename?: 'listCoursesOutput', id?: number | null, folderId?: number | null, titleAr?: string | null, titleEn?: string | null, cmeHours?: any | null, isAccredited?: boolean | null, isAccreditedSHA?: boolean | null, startDate?: any | null, shortDescriptionAr?: string | null, shortDescriptionEn?: string | null, defaultLanguage?: string | null, price?: string | null, imageUrl?: string | null, eventTypeId?: number | null, methodOfDelivery?: { __typename?: 'MethodOfDelivery', id: number, titleAr: string, titleEn: string } | null, pricingPlan?: { __typename?: 'PricingPlan', id: number, hasDiscount?: boolean | null, discountPercentage?: any | null, hasDiscountEndDate?: boolean | null, discountEndDate?: any | null } | null } | null> | null };

export type FindHeroImagesQueryVariables = Exact<{ [key: string]: never; }>;


export type FindHeroImagesQuery = { __typename?: 'Query', findHeroImages?: Array<{ __typename?: 'Settings', id: number, nameAr: string, nameEn: string, value?: any | null } | null> | null };

export type FindNotificationQueryVariables = Exact<{
  where?: InputMaybe<NotificationFindManyInputType>;
}>;


export type FindNotificationQuery = { __typename?: 'Query', findManyNotification: Array<{ __typename?: 'Notification', id: number, message?: string | null, title?: string | null, link?: string | null, read?: boolean | null, metadata?: any | null, createdAt?: any | null }> };

export type ReadNotificationMutationVariables = Exact<{ [key: string]: never; }>;


export type ReadNotificationMutation = { __typename?: 'Mutation', readNotification: { __typename?: 'BatchPayload', count: number } };

export type AddEducationMutationVariables = Exact<{
  data: AddEducationInputType;
}>;


export type AddEducationMutation = { __typename?: 'Mutation', addEducation: Array<{ __typename?: 'Education', id: number, university?: string | null, graduationYear?: any | null, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null, specialty?: { __typename?: 'Specialty', id: number, titleEn: string, titleAr?: string | null } | null, qualification?: { __typename?: 'Qualification', id: number, title: string } | null } | null> };

export type AddProfessionalSkillMutationVariables = Exact<{
  data: AddProfessionalSkillInputType;
}>;


export type AddProfessionalSkillMutation = { __typename?: 'Mutation', AddProfessionalSkill: Array<{ __typename?: 'ProfessionalSkills', id: number, yearsOfExperience?: number | null, placeOfWork?: string | null, natureOfWork?: string | null, type?: ProfessionalSkillsType | null, academicRank?: { __typename?: 'AcademicRank', id: number, titleAr: string, titleEn: string } | null } | null> };

export type AddScientificResearchMutationVariables = Exact<{
  data: AddScientificResearchInputType;
}>;


export type AddScientificResearchMutation = { __typename?: 'Mutation', AddScientificResearch: Array<{ __typename?: 'ScientificResearch', id: number, description?: string | null, type?: ScientificResearchType | null, role?: ScientificResearchRole | null } | null> };

export type AddTrainingExperienceMutationVariables = Exact<{
  data: AddTrainingExperienceInputType;
}>;


export type AddTrainingExperienceMutation = { __typename?: 'Mutation', AddTrainingExperience: Array<{ __typename?: 'TrainingExperience', id: number, eventName?: string | null, executingAgency?: string | null } | null> };

export type AddBecomeTrainerApplicationMutationVariables = Exact<{ [key: string]: never; }>;


export type AddBecomeTrainerApplicationMutation = { __typename?: 'Mutation', createOneBecomeTrainerApplication: { __typename?: 'BecomeTrainerApplication', id: number } };

export type FindManyAcademicRankQueryVariables = Exact<{ [key: string]: never; }>;


export type FindManyAcademicRankQuery = { __typename?: 'Query', findManyAcademicRank: Array<{ __typename?: 'AcademicRank', id: number, titleAr: string, titleEn: string }> };

export type FindProfileQueryVariables = Exact<{
  where: UserWhereUniqueInput;
}>;


export type FindProfileQuery = { __typename?: 'Query', findProfile?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, linkedIn?: string | null, twitter?: string | null, identityNo?: any | null, birthday?: any | null, commercialRecord?: string | null, nameOnCommercialRecord?: string | null, logoUrl?: string | null, email: string, username?: string | null, fcmToken?: string | null, mobileNumber?: string | null, cv?: string | null, image?: string | null, gender?: Gender | null, scfhs?: string | null, scfhsExp?: any | null, createdAt?: any | null, role: { __typename?: 'Role', id: number, titleAr: string, titleEn: string }, nationality?: { __typename?: 'Country', id: number, name: string } | null, specialty?: { __typename?: 'Specialty', id: number, titleEn: string, titleAr?: string | null } | null, Qualification?: { __typename?: 'Qualification', id: number, title: string } | null, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null, trainerCv?: { __typename?: 'Cv', id: number, education: Array<{ __typename?: 'Education', id: number, university?: string | null, graduationYear?: any | null, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null, specialty?: { __typename?: 'Specialty', id: number, titleEn: string, titleAr?: string | null } | null, qualification?: { __typename?: 'Qualification', id: number, title: string } | null }>, qualification?: { __typename?: 'Qualification', id: number, title: string } | null, rank?: { __typename?: 'Rank', id: number, title: string } | null, professionalSkills: Array<{ __typename?: 'ProfessionalSkills', id: number, yearsOfExperience?: number | null, placeOfWork?: string | null, natureOfWork?: string | null, type?: ProfessionalSkillsType | null, academicRank?: { __typename?: 'AcademicRank', id: number, titleAr: string, titleEn: string } | null }>, trainingExperience: Array<{ __typename?: 'TrainingExperience', id: number, eventName?: string | null, executingAgency?: string | null }>, scientificResearches: Array<{ __typename?: 'ScientificResearch', id: number, description?: string | null, type?: ScientificResearchType | null, role?: ScientificResearchRole | null }> } | null, city?: { __typename?: 'City', id: number, name: string } | null, inviter?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null } | null, bankAccount?: { __typename?: 'BankAccount', id: number, accountHolderName?: string | null, bankName?: string | null, iban: string } | null, memberNeeds: Array<{ __typename?: 'MemberNeeds', id: number, data?: any | null, status: MemberNeedsStatus, createdAt?: any | null }>, traineeEvents: Array<{ __typename?: 'TraineeEvent', createdAt?: any | null, id: number, Certificate?: { __typename?: 'Certificate', id?: number | null, isEligible?: boolean | null } | null, bookingStatus?: { __typename?: 'BookingStatus', id: number, titleAr: string, titleEn: string } | null, event: { __typename?: 'Event', id: number, titleEn: string, titleAr: string, shortDescriptionAr?: string | null, shortDescriptionEn?: string | null, defaultLanguage?: string | null, imageUrl?: string | null, folderId: number, startDate?: any | null, isTraineeCertificateAvailable: boolean, isTrainerCertificateAvailable: boolean } }> } | null };

export type FindBasicInfoProfileQueryVariables = Exact<{
  where: UserWhereUniqueInput;
}>;


export type FindBasicInfoProfileQuery = { __typename?: 'Query', findProfile?: { __typename?: 'User', id: number, name?: string | null, email: string, username?: string | null, fcmToken?: string | null, mobileNumber?: string | null, gender?: Gender | null, scfhs?: string | null, nationality?: { __typename?: 'Country', id: number, name: string } | null, specialty?: { __typename?: 'Specialty', id: number, titleEn: string, titleAr?: string | null } | null, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null, city?: { __typename?: 'City', id: number, name: string } | null, trainerCv?: { __typename?: 'Cv', id: number, qualification?: { __typename?: 'Qualification', id: number, title: string } | null, rank?: { __typename?: 'Rank', id: number, title: string } | null } | null, Qualification?: { __typename?: 'Qualification', id: number, title: string } | null } | null };

export type GetCertificateQueryVariables = Exact<{
  traineeEventId?: InputMaybe<Scalars['Int']>;
  trainerEventId?: InputMaybe<Scalars['Int']>;
  certificateId?: InputMaybe<Scalars['Int']>;
}>;


export type GetCertificateQuery = { __typename?: 'Query', getCertificate?: { __typename?: 'Certificate', id?: number | null, traineeId?: number | null, metaData?: any | null, isEligible?: boolean | null, createdAt?: any | null, template?: { __typename?: 'Template', data: any } | null, event?: { __typename?: 'Event', titleEn: string, id: number, address?: string | null, startDate?: any | null, cmeHours?: any | null, cmeNumber?: string | null, eventDays: Array<{ __typename?: 'EventDay', date?: any | null }> } | null, traineeEvent?: { __typename?: 'TraineeEvent', id: number, review?: { __typename?: 'TraineeEventReview', id: number } | null } | null } | null };

export type RemoveEducationMutationVariables = Exact<{
  data: RemoveEducationInputType;
}>;


export type RemoveEducationMutation = { __typename?: 'Mutation', removeEducation: Array<{ __typename?: 'Education', id: number, university?: string | null, graduationYear?: any | null, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null, specialty?: { __typename?: 'Specialty', id: number, titleEn: string, titleAr?: string | null } | null, qualification?: { __typename?: 'Qualification', id: number, title: string } | null } | null> };

export type RemoveProfessionalSkillMutationVariables = Exact<{
  data: RemoveProfessionalSkillInputType;
}>;


export type RemoveProfessionalSkillMutation = { __typename?: 'Mutation', removeProfessionalSkill: Array<{ __typename?: 'ProfessionalSkills', id: number, yearsOfExperience?: number | null, placeOfWork?: string | null, natureOfWork?: string | null, type?: ProfessionalSkillsType | null, academicRank?: { __typename?: 'AcademicRank', id: number, titleAr: string, titleEn: string } | null } | null> };

export type RemoveScientificResearchMutationVariables = Exact<{
  where: RemoveScientificResearchInputType;
}>;


export type RemoveScientificResearchMutation = { __typename?: 'Mutation', removeScientificResearch: Array<{ __typename?: 'ScientificResearch', id: number, description?: string | null, type?: ScientificResearchType | null, role?: ScientificResearchRole | null } | null> };

export type RemoveTrainingExperienceMutationVariables = Exact<{
  where: RemoveTrainingExperienceInputType;
}>;


export type RemoveTrainingExperienceMutation = { __typename?: 'Mutation', removeTrainingExperience?: Array<{ __typename?: 'TrainingExperience', id: number, eventName?: string | null, executingAgency?: string | null } | null> | null };

export type UpdateCvMutationVariables = Exact<{
  data: UpdateCvInputType;
}>;


export type UpdateCvMutation = { __typename?: 'Mutation', updateCv: { __typename?: 'Cv', id: number, rank?: { __typename?: 'Rank', id: number, title: string } | null, qualification?: { __typename?: 'Qualification', id: number, title: string } | null } };

export type UpdateBankAccountMutationVariables = Exact<{
  data: UpdateBankAccountInputType;
}>;


export type UpdateBankAccountMutation = { __typename?: 'Mutation', updateBankAccount: { __typename?: 'BankAccount', accountHolderName?: string | null, bankName?: string | null, iban: string, id: number } };

export type UpdateProfileMutationVariables = Exact<{
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, linkedIn?: string | null, twitter?: string | null, identityNo?: any | null, birthday?: any | null, commercialRecord?: string | null, nameOnCommercialRecord?: string | null, logoUrl?: string | null, email: string, username?: string | null, mobileNumber?: string | null, image?: string | null, cv?: string | null, gender?: Gender | null, scfhs?: string | null, scfhsExp?: any | null, createdAt?: any | null, role: { __typename?: 'Role', id: number, titleAr: string, titleEn: string }, nationality?: { __typename?: 'Country', id: number, name: string } | null, specialty?: { __typename?: 'Specialty', id: number, titleEn: string, titleAr?: string | null } | null, Qualification?: { __typename?: 'Qualification', id: number, title: string } | null, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null, trainerCv?: { __typename?: 'Cv', id: number, education: Array<{ __typename?: 'Education', id: number, university?: string | null, graduationYear?: any | null, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null, specialty?: { __typename?: 'Specialty', id: number, titleEn: string, titleAr?: string | null } | null, qualification?: { __typename?: 'Qualification', id: number, title: string } | null }>, qualification?: { __typename?: 'Qualification', id: number, title: string } | null, rank?: { __typename?: 'Rank', id: number, title: string } | null, professionalSkills: Array<{ __typename?: 'ProfessionalSkills', id: number, yearsOfExperience?: number | null, placeOfWork?: string | null, natureOfWork?: string | null, type?: ProfessionalSkillsType | null, academicRank?: { __typename?: 'AcademicRank', id: number, titleAr: string, titleEn: string } | null }>, trainingExperience: Array<{ __typename?: 'TrainingExperience', id: number, eventName?: string | null, executingAgency?: string | null }>, scientificResearches: Array<{ __typename?: 'ScientificResearch', id: number, description?: string | null, type?: ScientificResearchType | null, role?: ScientificResearchRole | null }> } | null, city?: { __typename?: 'City', id: number, name: string } | null, inviter?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null } | null, bankAccount?: { __typename?: 'BankAccount', id: number, accountHolderName?: string | null, bankName?: string | null, iban: string } | null } };

export type AddReviewMutationVariables = Exact<{
  data: ReviewInput;
}>;


export type AddReviewMutation = { __typename?: 'Mutation', AddReview: boolean };

export type FindReviewChoicesQueryVariables = Exact<{ [key: string]: never; }>;


export type FindReviewChoicesQuery = { __typename?: 'Query', findManyTraineeEventReviewChoice: Array<{ __typename?: 'TraineeEventReviewChoice', id: number, isGood: boolean, titleAr: string, titleEn: string }>, findManyTraineeTrainerReviewChoice: Array<{ __typename?: 'TraineeTrainerReviewChoice', id: number, isGood: boolean, titleAr: string, titleEn: string }> };

export type FindReviewQueryVariables = Exact<{
  where: FindReviewInput;
}>;


export type FindReviewQuery = { __typename?: 'Query', findReview?: { __typename?: 'findReviewOutput', TraineeEventReview?: { __typename?: 'TraineeEventReview', id: number, reviewOfFive: number, why?: string | null, traineeEventReviewChoices: Array<{ __typename?: 'TraineeEventReviewChoice', id: number }> } | null, TraineeTrainerReview?: Array<{ __typename?: 'TraineeTrainerReview', id: number, reviewOfFive: number, why?: string | null, trainerEventId: number, choices: Array<{ __typename?: 'TraineeTrainerReviewChoice', id: number }> } | null> | null, Event?: { __typename?: 'Event', titleEn: string, titleAr: string, trainerEvents: Array<{ __typename?: 'TrainerEvent', id: number, trainer?: { __typename?: 'User', name?: string | null, image?: string | null } | null }> } | null } | null };

export type FindBasicInfoUniqueTraineeEventQueryVariables = Exact<{
  where: TraineeEventWhereUniqueInput;
}>;


export type FindBasicInfoUniqueTraineeEventQuery = { __typename?: 'Query', findUniqueTraineeEvent?: { __typename?: 'TraineeEvent', id: number, registrantToken?: string | null, trainee: { __typename?: 'User', name?: string | null, nameAr?: string | null }, event: { __typename?: 'Event', id: number, titleEn: string, titleAr: string, address?: string | null, addressInstructions?: string | null, eventTypeId: number, ZoomMeeting?: { __typename?: 'ZoomMeeting', joinUrl?: string | null, id: number, isProcessed: boolean, isStarted: boolean, meetingId?: string | null, password?: string | null, startUrl?: string | null, registrationUrl?: string | null, duration?: number | null, type?: string | null, startDateTime?: any | null, endDateTime?: any | null } | null, eventParts: Array<{ __typename?: 'EventPart', id: number, outlineAr: string, outlineEn: string, eventDays: Array<{ __typename?: 'EventDay', id?: number | null, outlineAr?: string | null, outlineEn?: string | null, startTime?: any | null, endTime?: any | null, date?: any | null }> }>, eventDays: Array<{ __typename?: 'EventDay', id?: number | null, outlineAr?: string | null, outlineEn?: string | null, startTime?: any | null, endTime?: any | null, date?: any | null }> } } | null };

export type FindInvoiceQueryVariables = Exact<{
  where: TraineeEventWhereUniqueInput;
}>;


export type FindInvoiceQuery = { __typename?: 'Query', findUniqueTraineeEvent?: { __typename?: 'TraineeEvent', id: number, registrantToken?: string | null, createdAt?: any | null, price: any, tax: any, workshopPrice?: any | null, certificatePrice?: any | null, totalToPay: any, isLateRegistrant: boolean, isGroupRegistrant: boolean, methodOfDeliveryId?: number | null, isWorkshopRegistrant: boolean, isIndividualPay?: boolean | null, hasBookedAllParts?: boolean | null, couponeDiscount?: any | null, trainee: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, mobileNumber?: string | null }, Certificate?: { __typename?: 'Certificate', id?: number | null, metaData?: any | null, isEligible?: boolean | null, createdAt?: any | null, event?: { __typename?: 'Event', id: number, titleEn: string, titleAr: string } | null, traineeEvent?: { __typename?: 'TraineeEvent', id: number } | null } | null, event: { __typename?: 'Event', id: number, titleEn: string, titleAr: string, folderId: number, shortDescriptionAr?: string | null, shortDescriptionEn?: string | null, startDate?: any | null, locationLongitude?: any | null, locationLatitude?: any | null, address?: string | null, addressInstructions?: string | null, cityId?: number | null, defaultLanguage?: string | null, methodOfDeliveryId?: number | null, eventTypeId: number, packageId?: number | null, ZoomMeeting?: { __typename?: 'ZoomMeeting', joinUrl?: string | null, id: number, isProcessed: boolean, isStarted: boolean, meetingId?: string | null, password?: string | null, startUrl?: string | null, registrationUrl?: string | null, duration?: number | null, type?: string | null, startDateTime?: any | null, endDateTime?: any | null } | null, Quiz?: { __typename?: 'Quiz', id: number, name?: string | null, QuizQuestion: Array<{ __typename?: 'QuizQuestion', questionEn: string, questionType: string, questionAr: string, id: string, questionOrder?: number | null, createdAt: any, rightAnswer?: string | null, QuizQuestionAnswer: Array<{ __typename?: 'QuizQuestionAnswer', answerAr: string, answerEn: string, id: string, createdAt: any }> }> } | null, pricingPlan: { __typename?: 'PricingPlan', id: number, freePlanCertificateStatus?: string | null, freePlanCertificateCmePrice?: any | null, pricingPlanTypeId?: number | null }, eventDays: Array<{ __typename?: 'EventDay', id?: number | null, outlineAr?: string | null, outlineEn?: string | null, startTime?: any | null, endTime?: any | null, zoomMeetings?: Array<{ __typename?: 'ZoomMeeting', joinUrl?: string | null, id: number, meetingId?: string | null, password?: string | null, startUrl?: string | null, registrationUrl?: string | null, duration?: number | null, type?: string | null, startDateTime?: any | null, endDateTime?: any | null } | null> | null, trainerLessons?: Array<{ __typename?: 'TrainerEventDayLesson', id: number, outlineEn: string, outlineAr: string, startTime: any, endTime: any, methodOfTeachingTypeId?: number | null, trainerEvent?: { __typename?: 'TrainerEvent', id: number, trainer?: { __typename?: 'User', id: number, name?: string | null, image?: string | null } | null } | null } | null> | null }>, trainerEventStudyMaterials: Array<{ __typename?: 'TrainerEventStudyMaterial', id: number, title: string, url: string, media?: string | null, order: number, trainerEventStudyMaterialGroup?: { __typename?: 'TrainerEventStudyMaterialGroup', id: number, order: number, title: string } | null }>, packageEvents: Array<{ __typename?: 'Event', id: number, titleAr: string, titleEn: string }> }, parts: Array<{ __typename?: 'TraineeEventPart', id: number, partTotalPrice: any, eventPart: { __typename?: 'EventPart', id: number, outlineAr: string, outlineEn: string, pricingPlan: { __typename?: 'PricingPlan', id: number, pricingPlanTypeId?: number | null } } }>, group?: { __typename?: 'TraineeEventGroup', id: number, groupCertificatePrice?: any | null, groupPrice: any, groupTax: any, groupTotalToPay: any, traineeEvents: Array<{ __typename?: 'TraineeEvent', id: number, trainee: { __typename?: 'User', id: number, email: string, name?: string | null } }>, groupTransactions: Array<{ __typename?: 'Transition', id: number, amount: any, tax: any, fullAmount: any, mediator?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null } | null, paymentWay: { __typename?: 'PaymentWay', id: number, title: string }, transitionPurpose: { __typename?: 'TransitionPurpose', id: number, titleAr: string, titleEn: string }, status: { __typename?: 'TransitionStatusType', id: number, titleEn: string, titleAr: string } }> } | null, bookingStatus?: { __typename?: 'BookingStatus', id: number, titleEn: string, titleAr: string } | null, transitions: Array<{ __typename?: 'Transition', id: number, amount: any, tax: any, fullAmount: any, mediator?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null } | null, paymentWay: { __typename?: 'PaymentWay', id: number, title: string }, transitionPurpose: { __typename?: 'TransitionPurpose', id: number, titleAr: string, titleEn: string }, status: { __typename?: 'TransitionStatusType', id: number, titleEn: string, titleAr: string } }> } | null };

export type AddContactUsDataMutationVariables = Exact<{
  data: AddContactUsDataType;
}>;


export type AddContactUsDataMutation = { __typename?: 'Mutation', AddContactUsData: Array<{ __typename?: 'ContactUsData', id: number, isRead?: boolean | null, createdAt?: any | null } | null> };

export type FindManyContactUsDataQueryVariables = Exact<{
  where?: InputMaybe<ContactUsDataWhereInput>;
  orderBy?: InputMaybe<Array<InputMaybe<ContactUsDataOrderByWithRelationInput>> | InputMaybe<ContactUsDataOrderByWithRelationInput>>;
}>;


export type FindManyContactUsDataQuery = { __typename?: 'Query', findManyContactUsData: Array<{ __typename?: 'ContactUsData', id: number, firstName: string, lastName: string, email: string, phoneNumber?: string | null, subject: string, message: string, reason: string, isRead?: boolean | null, attachment?: string | null, createdAt?: any | null }> };

export type RemoveContactUsDataMutationVariables = Exact<{
  where: RemoveContactUsDataType;
}>;


export type RemoveContactUsDataMutation = { __typename?: 'Mutation', removeContactUsData?: Array<{ __typename?: 'ContactUsData', id: number, createdAt?: any | null } | null> | null };

export type UpdateContactUsDataMutationVariables = Exact<{
  data: UpdateContactUsDataType;
}>;


export type UpdateContactUsDataMutation = { __typename?: 'Mutation', UpdateContactUsData: Array<{ __typename?: 'ContactUsData', id: number, isRead?: boolean | null, createdAt?: any | null } | null> };

export type CreateOneCouponMutationVariables = Exact<{
  data: CouponCreateInput;
}>;


export type CreateOneCouponMutation = { __typename?: 'Mutation', createOneCoupon: { __typename?: 'Coupon', id: number } };

export type DeleteOneCouponMutationVariables = Exact<{
  where: CouponWhereUniqueInput;
}>;


export type DeleteOneCouponMutation = { __typename?: 'Mutation', deleteOneCoupon?: { __typename?: 'Coupon', id: number } | null };

export type FindManyCouponQueryVariables = Exact<{
  where?: InputMaybe<CouponWhereInput>;
}>;


export type FindManyCouponQuery = { __typename?: 'Query', findManyCoupon: Array<{ __typename?: 'Coupon', id: number, code: string, expiryDate: any, couponType: CouponType, createdAt?: any | null, percentageDiscount?: any | null, fixedAmountDiscount?: any | null, isForAllEvents: boolean, isForAllSpecialties: boolean, inviterId?: number | null, professions: Array<{ __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string }>, events: Array<{ __typename?: 'Event', id: number, titleEn: string, titleAr: string }>, _count: { __typename?: 'CouponCountOutputType', TraineeEvent: number } }> };

export type UpdateOneCouponMutationVariables = Exact<{
  data: CouponUpdateInput;
  where: CouponWhereUniqueInput;
}>;


export type UpdateOneCouponMutation = { __typename?: 'Mutation', updateOneCoupon: { __typename?: 'Coupon', id: number } };

export type FindManyEmailQueryVariables = Exact<{
  where: EmailWhereInput;
}>;


export type FindManyEmailQuery = { __typename?: 'Query', findManyEmail: { __typename?: 'EmailTemplate', event: { __typename?: 'Event', titleEn: string, titleAr: string, startDate?: any | null, locationLatitude?: any | null, locationLongitude?: any | null, cmeHours?: any | null, address?: string | null, addressInstructions?: string | null, methodOfDeliveryId?: number | null }, listEmailOutput: Array<{ __typename?: 'listEmailOutput', bookingStatus?: string | null, key?: string | null, date?: any | null, method?: string | null, target?: string | null, template?: { __typename?: 'zohoTemplate', template_key?: string | null, subject?: string | null, template_alias?: string | null, html?: string | null } | null, users?: Array<{ __typename?: 'userslistEmailOutput', shouldShowEmailMsg?: boolean | null, name?: string | null, emailState?: any | null, zoomLink?: string | null, bookingId?: number | null, userId?: number | null, email?: string | null, qrImage?: string | null, zohoEmail?: { __typename?: 'zohoEmail', id?: number | null, clicked?: boolean | null, opened?: boolean | null, sent?: boolean | null, softBounce?: boolean | null, hardBounce?: boolean | null, htmlData?: string | null, subject?: string | null, request_id?: string | null } | null, Certificate?: { __typename?: 'Certificate', id?: number | null } | null } | null> | null } | null> } };

export type GetCertificationQueryVariables = Exact<{
  data: GetCertInputType;
}>;


export type GetCertificationQuery = { __typename?: 'Query', getCertification?: { __typename?: 'CertificateSummery', traineeEvent?: { __typename?: 'TraineeEvent', trainee: { __typename?: 'User', name?: string | null, nameAr?: string | null }, event: { __typename?: 'Event', address?: string | null, cmeHours?: any | null, titleEn: string, titleAr: string, startDate?: any | null, cmeNumber?: string | null, trainerEvents: Array<{ __typename?: 'TrainerEvent', trainer?: { __typename?: 'User', name?: string | null, nameAr?: string | null } | null }>, eventDays: Array<{ __typename?: 'EventDay', date?: any | null }>, city?: { __typename?: 'City', name: string } | null } } | null, traineeCertificate?: { __typename?: 'Template', id: number, data: any } | null, trainerCertificate?: { __typename?: 'Template', id: number, data: any } | null } | null };

export type ResendCertificateMutationVariables = Exact<{
  where: ResendCertificateInput;
}>;


export type ResendCertificateMutation = { __typename?: 'Mutation', resendCertificate: boolean };

export type CreateOneDiscussionMutationVariables = Exact<{
  data: DiscussionCreateInput;
}>;


export type CreateOneDiscussionMutation = { __typename?: 'Mutation', createOneDiscussion: { __typename?: 'Discussion', id: number, comment: string, createdAt: any, User: { __typename?: 'User', id: number, username?: string | null, logoUrl?: string | null, name?: string | null, nameAr?: string | null }, Parent?: { __typename?: 'Discussion', id: number, comment: string, createdAt: any, User: { __typename?: 'User', id: number, username?: string | null, logoUrl?: string | null, name?: string | null, nameAr?: string | null }, Replies: Array<{ __typename?: 'Discussion', id: number, comment: string, createdAt: any, User: { __typename?: 'User', id: number, username?: string | null, logoUrl?: string | null, name?: string | null, nameAr?: string | null } }> } | null } };

export type CancelEventMutationVariables = Exact<{
  where: EventIdInput;
}>;


export type CancelEventMutation = { __typename?: 'Mutation', CancelEvent: { __typename?: 'Event', id: number } };

export type DeleteEventMutationVariables = Exact<{
  where: EventIdInput;
}>;


export type DeleteEventMutation = { __typename?: 'Mutation', deleteEvent: { __typename?: 'Event', id: number } };

export type EmergancyNotificationMutationVariables = Exact<{
  where: EmergancyNotificationInput;
}>;


export type EmergancyNotificationMutation = { __typename?: 'Mutation', EmergancyNotification: { __typename?: 'Event', id: number } };

export type EventStopRegistrationMutationVariables = Exact<{
  where: EventStopInput;
}>;


export type EventStopRegistrationMutation = { __typename?: 'Mutation', eventStopRegistration: { __typename?: 'Event', isRegistraionClosed?: boolean | null } };

export type IsRegistraionClosedQueryVariables = Exact<{
  where: EventWhereUniqueInput;
}>;


export type IsRegistraionClosedQuery = { __typename?: 'Query', findUniqueEvent?: { __typename?: 'Event', isRegistraionClosed?: boolean | null, id: number } | null };

export type RemindMeMutationVariables = Exact<{
  data: RemindInputType;
}>;


export type RemindMeMutation = { __typename?: 'Mutation', remindMe: boolean };

export type CalendarQueryQueryVariables = Exact<{
  where?: InputMaybe<EventDayWhereInput>;
}>;


export type CalendarQueryQuery = { __typename?: 'Query', findManyEvent: Array<{ __typename?: 'Event', id: number, titleEn: string, titleAr: string, startDate?: any | null, endDate?: any | null, cmeHours?: any | null, cmeNumber?: string | null, eventDays: Array<{ __typename?: 'EventDay', id?: number | null, startTime?: any | null, endTime?: any | null, outlineAr?: string | null, outlineEn?: string | null, deletedAt?: any | null }>, trainerEvents: Array<{ __typename?: 'TrainerEvent', trainer?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null } | null }> }> };

export type EventAttendanceQueryVariables = Exact<{
  where: EventWhereUniqueInput;
  traineeEventsWhere?: InputMaybe<TraineeEventWhereInput>;
  eventDaysWhere2?: InputMaybe<EventDayWhereInput>;
}>;


export type EventAttendanceQuery = { __typename?: 'Query', findUniqueEvent?: { __typename?: 'Event', id: number, eventTypeId: number, pricingPlan: { __typename?: 'PricingPlan', id: number, freePlanCertificateStatus?: string | null, pricingPlanTypeId?: number | null }, eventDays: Array<{ __typename?: 'EventDay', id?: number | null, date?: any | null, zoomDuration?: number | null, startTime?: any | null, endTime?: any | null, deletedAt?: any | null }>, traineeEvents: Array<{ __typename?: 'TraineeEvent', id: number, bookingStatusId?: number | null, certificatePrice?: any | null, trainee: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, scfhs?: string | null, mobileNumber?: string | null, email: string, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null }, attendance: Array<{ __typename?: 'TraineeEventDayAttendance', id: number, eventDayId: number, joinTime: any, leaveTime?: any | null, duration?: number | null }>, traineeEventStudyMaterialAttendance: Array<{ __typename?: 'TraineeEventStudyMaterialAttendance', trainerEventStudyMaterialId: number, progressPercentage?: any | null, trainerEventStudyMaterial: { __typename?: 'TrainerEventStudyMaterial', id: number, media?: string | null } }>, Certificate?: { __typename?: 'Certificate', id?: number | null } | null }>, trainerEventStudyMaterialGroups: Array<{ __typename?: 'TrainerEventStudyMaterialGroup', id: number, title: string, order: number, StudyMaterials: Array<{ __typename?: 'TrainerEventStudyMaterial', id: number, title: string, media?: string | null, url: string, deletedAt?: any | null, order: number, traineeEventStudyMaterialAttendance: Array<{ __typename?: 'TraineeEventStudyMaterialAttendance', id: number, progressPercentage?: any | null, trainerEventStudyMaterialId: number }> }> }>, trainerEvents: Array<{ __typename?: 'TrainerEvent', id: number, trainer?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, mobileNumber?: string | null, email: string, scfhs?: string | null, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null } | null, Certificate?: { __typename?: 'Certificate', id?: number | null } | null }> } | null };

export type PricingPlanFragmentFragment = { __typename?: 'PricingPlan', id: number, hasLateRegistration?: boolean | null, freePlanCertificateCmeIsPaid?: boolean | null, freePlanCertificateStatus?: string | null, lateRegistrationStartDate?: any | null, hasGroupDiscount?: boolean | null, groupDiscountPrice?: any | null, hasGroupDiscountEndDate?: boolean | null, groupDiscountEndDate?: any | null, groupDiscountMinNumberOfRegistrants?: number | null, freePlanCertificateCmePrice?: any | null, paidPlanPrice?: any | null, paidPlanOnsitePrice?: any | null, cardFee?: boolean | null, paidPlanLateRegistrationPrice?: any | null, basedOnSpecialtyPlanOtherSpecialtiesPrice?: any | null, basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: any | null, basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: any | null, hasWorkshop?: boolean | null, workshopPrice?: any | null, workshopLateRegistrationPrice?: any | null, workshopGroupDiscountPrice?: any | null, pricingPlanTypeId?: number | null, pricingPlanSpecialtyPrices: Array<{ __typename?: 'PricingPlanSpecialtyPrice', id: number, price: any, priceOnsite?: any | null, LateRegistrationPrice?: any | null, professions: Array<{ __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string }> }> };

export type TrainerFragmentFragment = { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, image?: string | null, email: string, specialty?: { __typename?: 'Specialty', id: number, titleAr?: string | null, titleEn: string } | null, profession?: { __typename?: 'Profession', id: number, titleEn: string, titleAr?: string | null } | null };

export type UpdateEventDraftMutationVariables = Exact<{
  data: EventUpdateInput;
  where: EventWhereUniqueInput;
}>;


export type UpdateEventDraftMutation = { __typename?: 'Mutation', updateOneEvent: { __typename?: 'Event', id: number, discussionStatus: boolean, timeTableStatus: boolean, startDate?: any | null, endDate?: any | null, cmeHours?: any | null, cmeNumber?: string | null, isAccredited: boolean, isAccreditedSHA?: boolean | null, hideVideoProgress?: boolean | null, zoomMode?: string | null, isContentProvidedByAcademy: boolean, isTraineeCertificateAvailable: boolean, isTrainerCertificateAvailable: boolean, titleEn: string, titleAr: string, minAttendancePercentageToGetCertificate?: any | null, onsiteCapacity?: number | null, onlineCapacity?: number | null, address?: string | null, addressInstructions?: string | null, locationLatitude?: any | null, locationLongitude?: any | null, imageUrl?: string | null, backgroundImagesUrls: Array<string>, sponsorshipImagesUrls?: any | null, isSponsored: boolean, keywordsAr: Array<string>, keywordsEn: Array<string>, descriptionAr?: string | null, descriptionEn?: string | null, defaultLanguage?: string | null, visibleOnArchive?: boolean | null, eventType: { __typename?: 'EventType', id: number, titleAr: string, titleEn: string }, methodOfDelivery: { __typename?: 'MethodOfDelivery', id: number, titleAr: string, titleEn: string }, traineeCertificateTemplate?: { __typename?: 'Template', id: number, title: string } | null, trainerCertificateTemplate?: { __typename?: 'Template', id: number, title: string } | null, leaderTrainer?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, image?: string | null, email: string, specialty?: { __typename?: 'Specialty', id: number, titleAr?: string | null, titleEn: string } | null, profession?: { __typename?: 'Profession', id: number, titleEn: string, titleAr?: string | null } | null } | null, city?: { __typename?: 'City', id: number, name: string } | null, pricingPlan: { __typename?: 'PricingPlan', hasMultiPartDiscount?: boolean | null, multiPartDiscountPrice?: any | null, id: number, hasLateRegistration?: boolean | null, freePlanCertificateCmeIsPaid?: boolean | null, freePlanCertificateStatus?: string | null, lateRegistrationStartDate?: any | null, hasGroupDiscount?: boolean | null, groupDiscountPrice?: any | null, hasGroupDiscountEndDate?: boolean | null, groupDiscountEndDate?: any | null, groupDiscountMinNumberOfRegistrants?: number | null, freePlanCertificateCmePrice?: any | null, paidPlanPrice?: any | null, paidPlanOnsitePrice?: any | null, cardFee?: boolean | null, paidPlanLateRegistrationPrice?: any | null, basedOnSpecialtyPlanOtherSpecialtiesPrice?: any | null, basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: any | null, basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: any | null, hasWorkshop?: boolean | null, workshopPrice?: any | null, workshopLateRegistrationPrice?: any | null, workshopGroupDiscountPrice?: any | null, pricingPlanTypeId?: number | null, pricingPlanSpecialtyPrices: Array<{ __typename?: 'PricingPlanSpecialtyPrice', id: number, price: any, priceOnsite?: any | null, LateRegistrationPrice?: any | null, professions: Array<{ __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string }> }> }, eventParts: Array<{ __typename?: 'EventPart', id: number, outlineAr: string, outlineEn: string, pricingPlanId: number, pricingPlan: { __typename?: 'PricingPlan', id: number, hasLateRegistration?: boolean | null, freePlanCertificateCmeIsPaid?: boolean | null, freePlanCertificateStatus?: string | null, lateRegistrationStartDate?: any | null, hasGroupDiscount?: boolean | null, groupDiscountPrice?: any | null, hasGroupDiscountEndDate?: boolean | null, groupDiscountEndDate?: any | null, groupDiscountMinNumberOfRegistrants?: number | null, freePlanCertificateCmePrice?: any | null, paidPlanPrice?: any | null, paidPlanOnsitePrice?: any | null, cardFee?: boolean | null, paidPlanLateRegistrationPrice?: any | null, basedOnSpecialtyPlanOtherSpecialtiesPrice?: any | null, basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: any | null, basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: any | null, hasWorkshop?: boolean | null, workshopPrice?: any | null, workshopLateRegistrationPrice?: any | null, workshopGroupDiscountPrice?: any | null, pricingPlanTypeId?: number | null, pricingPlanSpecialtyPrices: Array<{ __typename?: 'PricingPlanSpecialtyPrice', id: number, price: any, priceOnsite?: any | null, LateRegistrationPrice?: any | null, professions: Array<{ __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string }> }> }, eventDays: Array<{ __typename?: 'EventDay', id?: number | null, outlineAr?: string | null, outlineEn?: string | null }> }>, eventDays: Array<{ __typename?: 'EventDay', id?: number | null, outlineAr?: string | null, outlineEn?: string | null, startTime?: any | null, endTime?: any | null, date?: any | null, deletedAt?: any | null, trainerTimeSlots?: Array<{ __typename?: 'TrainerEventDayTimeSlot', id: number, startTime: any, endTime: any, deletedAt?: any | null, trainerEvent: { __typename?: 'TrainerEvent', id: number, trainer?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, image?: string | null, specialty?: { __typename?: 'Specialty', id: number, titleAr?: string | null, titleEn: string } | null } | null } } | null> | null }> } };

export type CreateEventMutationVariables = Exact<{
  data: EventCreateInput;
}>;


export type CreateEventMutation = { __typename?: 'Mutation', createOneEvent: { __typename?: 'Event', id: number, startDate?: any | null, endDate?: any | null, isTrainerCertificateAvailable: boolean, isTraineeCertificateAvailable: boolean, minAttendancePercentageToGetCertificate?: any | null, onsiteCapacity?: number | null, address?: string | null, addressInstructions?: string | null, addressAr?: string | null, addressInstructionsAr?: string | null, locationLongitude?: any | null, locationLatitude?: any | null, onlineCapacity?: number | null, imageUrl?: string | null, backgroundImagesUrls: Array<string>, sponsorshipImagesUrls?: any | null, isSponsored: boolean, hideVideoProgress?: boolean | null, keywordsAr: Array<string>, keywordsEn: Array<string>, descriptionAr?: string | null, descriptionEn?: string | null, defaultLanguage?: string | null, titleAr: string, titleEn: string, cmeHours?: any | null, cmeNumber?: string | null, createdAt?: any | null, isContentProvidedByAcademy: boolean, eventType: { __typename?: 'EventType', id: number, titleEn: string, titleAr: string }, trainerCertificateTemplate?: { __typename?: 'Template', id: number, title: string } | null, traineeCertificateTemplate?: { __typename?: 'Template', id: number, title: string } | null, leaderTrainer?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, image?: string | null, email: string, specialty?: { __typename?: 'Specialty', id: number, titleAr?: string | null, titleEn: string } | null, profession?: { __typename?: 'Profession', id: number, titleEn: string, titleAr?: string | null } | null } | null, city?: { __typename?: 'City', id: number, name: string } | null, folder: { __typename?: 'EventFolder', id: number, titleEn: string, titleAr: string }, coupons: Array<{ __typename?: 'Coupon', id: number }>, pricingPlan: { __typename?: 'PricingPlan', hasMultiPartDiscount?: boolean | null, multiPartDiscountPrice?: any | null, id: number, hasLateRegistration?: boolean | null, freePlanCertificateCmeIsPaid?: boolean | null, freePlanCertificateStatus?: string | null, lateRegistrationStartDate?: any | null, hasGroupDiscount?: boolean | null, groupDiscountPrice?: any | null, hasGroupDiscountEndDate?: boolean | null, groupDiscountEndDate?: any | null, groupDiscountMinNumberOfRegistrants?: number | null, freePlanCertificateCmePrice?: any | null, paidPlanPrice?: any | null, paidPlanOnsitePrice?: any | null, cardFee?: boolean | null, paidPlanLateRegistrationPrice?: any | null, basedOnSpecialtyPlanOtherSpecialtiesPrice?: any | null, basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: any | null, basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: any | null, hasWorkshop?: boolean | null, workshopPrice?: any | null, workshopLateRegistrationPrice?: any | null, workshopGroupDiscountPrice?: any | null, pricingPlanTypeId?: number | null, pricingPlanSpecialtyPrices: Array<{ __typename?: 'PricingPlanSpecialtyPrice', id: number, price: any, priceOnsite?: any | null, LateRegistrationPrice?: any | null, professions: Array<{ __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string }> }> } } };

export type FindEventBasicInfoQueryVariables = Exact<{
  where: EventWhereUniqueInput;
}>;


export type FindEventBasicInfoQuery = { __typename?: 'Query', findUniqueEvent?: { __typename?: 'Event', id: number, titleAr: string, titleEn: string, startDate?: any | null, endDate?: any | null, eventTypeId: number, folder: { __typename?: 'EventFolder', id: number, titleEn: string, titleAr: string }, pricingPlan: { __typename?: 'PricingPlan', id: number, hasGroupDiscount?: boolean | null }, eventDays: Array<{ __typename?: 'EventDay', id?: number | null, startTime?: any | null, endTime?: any | null }>, traineeEvents: Array<{ __typename?: 'TraineeEvent', id: number, traineeId: number, createdAt?: any | null, trainee: { __typename?: 'User', id: number, name?: string | null, email: string } }>, Quiz?: { __typename?: 'Quiz', id: number, name?: string | null, QuizQuestion: Array<{ __typename?: 'QuizQuestion', questionEn: string, questionType: string, questionAr: string, id: string, questionOrder?: number | null, createdAt: any, rightAnswer?: string | null, QuizQuestionAnswer: Array<{ __typename?: 'QuizQuestionAnswer', answerAr: string, answerEn: string, id: string, createdAt: any }> }> } | null } | null };

export type FindEventContentAddedByTrainersQueryVariables = Exact<{
  where: EventWhereUniqueInput;
}>;


export type FindEventContentAddedByTrainersQuery = { __typename?: 'Query', findUniqueEvent?: { __typename?: 'Event', trainerEvents: Array<{ __typename?: 'TrainerEvent', id: number, contentIsAdded?: boolean | null, introductionAr?: string | null, isAllProfessionsTargeted?: boolean | null, objectivesAr?: string | null, objectivesEn?: string | null, mainThemeEn?: string | null, mainThemeAr?: string | null, outcomesEn?: string | null, outcomesAr?: string | null, whyTargetedAudienceAr?: string | null, whyTargetedAudienceEn?: string | null, youtubeUrl?: string | null, introductionEn?: string | null, deletedAt?: any | null, targetedAudiences: Array<{ __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string }>, targetedSpecialities: Array<{ __typename?: 'Specialty', id: number, titleAr?: string | null, titleEn: string }>, trainer?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, image?: string | null, email: string, specialty?: { __typename?: 'Specialty', id: number, titleAr?: string | null, titleEn: string } | null, profession?: { __typename?: 'Profession', id: number, titleEn: string, titleAr?: string | null } | null } | null }> } | null };

export type FindManyEventDayQueryVariables = Exact<{
  where: EventDayWhereInput;
}>;


export type FindManyEventDayQuery = { __typename?: 'Query', findManyEventDay: Array<{ __typename?: 'EventDay', id?: number | null, outlineAr?: string | null, outlineEn?: string | null, startTime?: any | null, endTime?: any | null, date?: any | null, deletedAt?: any | null, attendanceHours?: any | null, brother?: { __typename?: 'EventDay', id?: number | null } | null, siblings?: Array<{ __typename?: 'EventDay', id?: number | null, startTime?: any | null, endTime?: any | null } | null> | null, methodOfDelivery?: { __typename?: 'MethodOfDelivery', id: number, titleAr: string, titleEn: string } | null, zoomMeetings?: Array<{ __typename?: 'ZoomMeeting', id: number, startDateTime?: any | null, endDateTime?: any | null } | null> | null }> };

export type FindOneEventDayQueryVariables = Exact<{
  where: EventDayWhereUniqueInput;
}>;


export type FindOneEventDayQuery = { __typename?: 'Query', findUniqueEventDay?: { __typename?: 'EventDay', id?: number | null, outlineAr?: string | null, outlineEn?: string | null, startTime?: any | null, endTime?: any | null, date?: any | null, deletedAt?: any | null, attendanceHours?: any | null, methodOfDelivery?: { __typename?: 'MethodOfDelivery', id: number, titleAr: string, titleEn: string } | null, zoomMeetings?: Array<{ __typename?: 'ZoomMeeting', id: number, startDateTime?: any | null, endDateTime?: any | null } | null> | null } | null };

export type TrainerEventFragmentFragment = { __typename?: 'TrainerEvent', id: number, deletedAt?: any | null, trainer?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, image?: string | null, specialty?: { __typename?: 'Specialty', id: number, titleAr?: string | null, titleEn: string } | null, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null } | null };

export type FindUniqueEventContentQueryVariables = Exact<{
  where: EventWhereUniqueInput;
  trainerEventsWhere?: InputMaybe<TrainerEventWhereInput>;
}>;


export type FindUniqueEventContentQuery = { __typename?: 'Query', findUniqueEvent?: { __typename?: 'Event', id: number, titleAr: string, titleEn: string, startDate?: any | null, endDate?: any | null, eventTypeId: number, ZoomMeeting?: { __typename?: 'ZoomMeeting', id: number, type?: string | null, meetingId?: string | null, joinUrl?: string | null, startUrl?: string | null } | null, eventLanguages: Array<{ __typename?: 'Language', id: number, title: string }>, trainerEvents: Array<{ __typename?: 'TrainerEvent', id: number, deletedAt?: any | null, trainer?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, image?: string | null, specialty?: { __typename?: 'Specialty', id: number, titleAr?: string | null, titleEn: string } | null, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null } | null }>, methodOfDelivery: { __typename?: 'MethodOfDelivery', id: number, titleAr: string, titleEn: string }, eventDays: Array<{ __typename?: 'EventDay', id?: number | null, outlineAr?: string | null, outlineEn?: string | null, startTime?: any | null, endTime?: any | null, date?: any | null, deletedAt?: any | null, attendanceHours?: any | null, methodOfDelivery?: { __typename?: 'MethodOfDelivery', id: number, titleAr: string, titleEn: string } | null, trainerLessons?: Array<{ __typename?: 'TrainerEventDayLesson', id: number, startTime: any, endTime: any, outlineAr: string, outlineEn: string, TrainerEventDayLessonType: { __typename?: 'TrainerEventDayLessonType', id: number, titleEn: string, titleAr: string }, trainerEvent?: { __typename?: 'TrainerEvent', id: number, deletedAt?: any | null, trainer?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, image?: string | null, specialty?: { __typename?: 'Specialty', id: number, titleAr?: string | null, titleEn: string } | null, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null } | null } | null } | null> | null, trainerTimeSlots?: Array<{ __typename?: 'TrainerEventDayTimeSlot', id: number, startTime: any, endTime: any, deletedAt?: any | null, trainerEvent: { __typename?: 'TrainerEvent', id: number, deletedAt?: any | null, trainer?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, image?: string | null, specialty?: { __typename?: 'Specialty', id: number, titleAr?: string | null, titleEn: string } | null, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null } | null } } | null> | null, zoomMeetings?: Array<{ __typename?: 'ZoomMeeting', id: number, startDateTime?: any | null, endDateTime?: any | null } | null> | null }> } | null };

export type FindUniqueEventDraftQueryVariables = Exact<{
  where: EventWhereUniqueInput;
}>;


export type FindUniqueEventDraftQuery = { __typename?: 'Query', findUniqueEvent?: { __typename?: 'Event', id: number, discussionStatus: boolean, timeTableStatus: boolean, zoomMode?: string | null, startDate?: any | null, endDate?: any | null, isAccredited: boolean, isAccreditedSHA?: boolean | null, hideVideoProgress?: boolean | null, cmeHours?: any | null, cmeNumber?: string | null, folderId: number, isContentProvidedByAcademy: boolean, isTraineeCertificateAvailable: boolean, isTrainerCertificateAvailable: boolean, defaultLanguage?: string | null, titleEn: string, titleAr: string, minAttendancePercentageToGetCertificate?: any | null, onsiteCapacity?: number | null, onlineCapacity?: number | null, address?: string | null, addressInstructions?: string | null, addressAr?: string | null, addressInstructionsAr?: string | null, locationLatitude?: any | null, locationLongitude?: any | null, imageUrl?: string | null, backgroundImagesUrls: Array<string>, sponsorshipImagesUrls?: any | null, isSponsored: boolean, keywordsAr: Array<string>, keywordsEn: Array<string>, descriptionAr?: string | null, descriptionEn?: string | null, visibleOnArchive?: boolean | null, packageEvents: Array<{ __typename?: 'Event', id: number, titleAr: string, titleEn: string }>, ZoomMeeting?: { __typename?: 'ZoomMeeting', id: number, joinUrl?: string | null, startUrl?: string | null, isStarted: boolean, meetingId?: string | null, type?: string | null, password?: string | null, registrationUrl?: string | null, duration?: number | null, startDateTime?: any | null, endDateTime?: any | null } | null, eventType: { __typename?: 'EventType', id: number, titleAr: string, titleEn: string }, folder: { __typename?: 'EventFolder', id: number, titleAr: string, titleEn: string }, methodOfDelivery: { __typename?: 'MethodOfDelivery', id: number, titleAr: string, titleEn: string }, traineeCertificateTemplate?: { __typename?: 'Template', id: number, title: string } | null, trainerCertificateTemplate?: { __typename?: 'Template', id: number, title: string } | null, leaderTrainer?: { __typename?: 'User', id: number, nameAr?: string | null, name?: string | null, image?: string | null, specialty?: { __typename?: 'Specialty', id: number, titleAr?: string | null, titleEn: string } | null, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null } | null, city?: { __typename?: 'City', id: number, name: string } | null, pricingPlan: { __typename?: 'PricingPlan', hasMultiPartDiscount?: boolean | null, multiPartDiscountPrice?: any | null, paymentType?: string | null, hasDiscount?: boolean | null, discountPercentage?: any | null, hasDiscountEndDate?: boolean | null, discountEndDate?: any | null, id: number, hasLateRegistration?: boolean | null, freePlanCertificateCmeIsPaid?: boolean | null, freePlanCertificateStatus?: string | null, lateRegistrationStartDate?: any | null, hasGroupDiscount?: boolean | null, groupDiscountPrice?: any | null, hasGroupDiscountEndDate?: boolean | null, groupDiscountEndDate?: any | null, groupDiscountMinNumberOfRegistrants?: number | null, freePlanCertificateCmePrice?: any | null, paidPlanPrice?: any | null, paidPlanOnsitePrice?: any | null, cardFee?: boolean | null, paidPlanLateRegistrationPrice?: any | null, basedOnSpecialtyPlanOtherSpecialtiesPrice?: any | null, basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: any | null, basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: any | null, hasWorkshop?: boolean | null, workshopPrice?: any | null, workshopLateRegistrationPrice?: any | null, workshopGroupDiscountPrice?: any | null, pricingPlanTypeId?: number | null, pricingPlanSpecialtyPrices: Array<{ __typename?: 'PricingPlanSpecialtyPrice', id: number, price: any, priceOnsite?: any | null, LateRegistrationPrice?: any | null, professions: Array<{ __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string }> }> }, eventParts: Array<{ __typename?: 'EventPart', id: number, outlineAr: string, outlineEn: string, pricingPlanId: number, pricingPlan: { __typename?: 'PricingPlan', id: number, hasLateRegistration?: boolean | null, freePlanCertificateCmeIsPaid?: boolean | null, freePlanCertificateStatus?: string | null, lateRegistrationStartDate?: any | null, hasGroupDiscount?: boolean | null, groupDiscountPrice?: any | null, hasGroupDiscountEndDate?: boolean | null, groupDiscountEndDate?: any | null, groupDiscountMinNumberOfRegistrants?: number | null, freePlanCertificateCmePrice?: any | null, paidPlanPrice?: any | null, paidPlanOnsitePrice?: any | null, cardFee?: boolean | null, paidPlanLateRegistrationPrice?: any | null, basedOnSpecialtyPlanOtherSpecialtiesPrice?: any | null, basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: any | null, basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: any | null, hasWorkshop?: boolean | null, workshopPrice?: any | null, workshopLateRegistrationPrice?: any | null, workshopGroupDiscountPrice?: any | null, pricingPlanTypeId?: number | null, pricingPlanSpecialtyPrices: Array<{ __typename?: 'PricingPlanSpecialtyPrice', id: number, price: any, priceOnsite?: any | null, LateRegistrationPrice?: any | null, professions: Array<{ __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string }> }> }, eventDays: Array<{ __typename?: 'EventDay', id?: number | null, outlineAr?: string | null, outlineEn?: string | null }> }>, eventDays: Array<{ __typename?: 'EventDay', id?: number | null, outlineAr?: string | null, outlineEn?: string | null, startTime?: any | null, endTime?: any | null, date?: any | null, deletedAt?: any | null, trainerTimeSlots?: Array<{ __typename?: 'TrainerEventDayTimeSlot', id: number, startTime: any, endTime: any, deletedAt?: any | null, trainerEvent: { __typename?: 'TrainerEvent', id: number, trainer?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, image?: string | null, specialty?: { __typename?: 'Specialty', id: number, titleAr?: string | null, titleEn: string } | null, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null } | null } } | null> | null }> } | null };

export type FindUniqueEventIntroContentQueryVariables = Exact<{
  where: EventWhereUniqueInput;
}>;


export type FindUniqueEventIntroContentQuery = { __typename?: 'Query', findUniqueEvent?: { __typename?: 'Event', id: number, introductionAr?: string | null, isAllProfessionsTargeted?: boolean | null, objectivesAr?: string | null, objectivesEn?: string | null, shortDescriptionAr?: string | null, shortDescriptionEn?: string | null, mainThemeEn?: string | null, mainThemeAr?: string | null, outcomesEn?: string | null, outcomesAr?: string | null, whyTargetedAudienceAr?: string | null, whyTargetedAudienceEn?: string | null, introductionEn?: string | null, youtubeUrl?: string | null, targetedAudiences: Array<{ __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string }>, targetedSpecialities: Array<{ __typename?: 'Specialty', id: number, titleAr?: string | null, titleEn: string }> } | null };

export type FindUniqueEventLessonsTimeSlotsQueryVariables = Exact<{
  where: EventWhereUniqueInput;
  eventDaysWhere?: InputMaybe<EventDayWhereInput>;
}>;


export type FindUniqueEventLessonsTimeSlotsQuery = { __typename?: 'Query', findUniqueEvent?: { __typename?: 'Event', id: number, titleAr: string, titleEn: string, trainerEvents: Array<{ __typename?: 'TrainerEvent', id: number, deletedAt?: any | null, trainer?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, image?: string | null, specialty?: { __typename?: 'Specialty', id: number, titleAr?: string | null, titleEn: string } | null, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null } | null }>, eventDays: Array<{ __typename?: 'EventDay', id?: number | null, outlineEn?: string | null, outlineAr?: string | null, startTime?: any | null, endTime?: any | null, date?: any | null, deletedAt?: any | null, trainerLessons?: Array<{ __typename?: 'TrainerEventDayLesson', id: number, startTime: any, endTime: any, outlineAr: string, outlineEn: string, deletedAt?: any | null, TrainerEventDayLessonType: { __typename?: 'TrainerEventDayLessonType', titleAr: string, titleEn: string, id: number }, methodOfTeaching?: { __typename?: 'MethodOfTeachingType', id: number, titleAr: string, titleEn: string } | null, trainerEvent?: { __typename?: 'TrainerEvent', id: number, trainerId: number, trainer?: { __typename?: 'User', id: number, nameAr?: string | null, name?: string | null } | null } | null } | null> | null, trainerTimeSlots?: Array<{ __typename?: 'TrainerEventDayTimeSlot', id: number, startTime: any, endTime: any } | null> | null }>, Blogs: Array<{ __typename?: 'Blogs', id: number, title: string, description?: string | null, content?: string | null, titleAr?: string | null, descriptionAr?: string | null, contentAr?: string | null, socialMedia: Array<string>, thumbnailImage?: string | null, image?: string | null }> } | null };

export type EventDayPreviewFragmentFragment = { __typename?: 'EventDay', id?: number | null, outlineAr?: string | null, outlineEn?: string | null, startTime?: any | null, endTime?: any | null, date?: any | null, deletedAt?: any | null, trainerLessons?: Array<{ __typename?: 'TrainerEventDayLesson', id: number, startTime: any, endTime: any, outlineAr: string, outlineEn: string, TrainerEventDayLessonType: { __typename?: 'TrainerEventDayLessonType', id: number, titleEn: string, titleAr: string }, trainerEvent?: { __typename?: 'TrainerEvent', trainer?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, image?: string | null, specialty?: { __typename?: 'Specialty', id: number, titleAr?: string | null, titleEn: string } | null, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null } | null } | null } | null> | null, trainerTimeSlots?: Array<{ __typename?: 'TrainerEventDayTimeSlot', id: number, startTime: any, endTime: any, deletedAt?: any | null, trainerEvent: { __typename?: 'TrainerEvent', id: number, deletedAt?: any | null, trainer?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, image?: string | null, specialty?: { __typename?: 'Specialty', id: number, titleAr?: string | null, titleEn: string } | null, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null } | null } } | null> | null };

export type PricingPlanPreviewFragmentFragment = { __typename?: 'PricingPlan', id: number, hasLateRegistration?: boolean | null, freePlanCertificateCmeIsPaid?: boolean | null, freePlanCertificateStatus?: string | null, lateRegistrationStartDate?: any | null, hasGroupDiscount?: boolean | null, groupDiscountPrice?: any | null, hasGroupDiscountEndDate?: boolean | null, hasMultiPartDiscount?: boolean | null, multiPartDiscountPrice?: any | null, groupDiscountEndDate?: any | null, groupDiscountMinNumberOfRegistrants?: number | null, freePlanCertificateCmePrice?: any | null, paidPlanPrice?: any | null, cardFee?: boolean | null, paidPlanLateRegistrationPrice?: any | null, basedOnSpecialtyPlanOtherSpecialtiesPrice?: any | null, basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: any | null, hasWorkshop?: boolean | null, workshopPrice?: any | null, workshopLateRegistrationPrice?: any | null, workshopGroupDiscountPrice?: any | null, pricingPlanTypeId?: number | null, pricingPlanSpecialtyPrices: Array<{ __typename?: 'PricingPlanSpecialtyPrice', id: number, price: any, LateRegistrationPrice?: any | null, professions: Array<{ __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string }> }>, pricingPlanType?: { __typename?: 'PricingPlanType', id: number, titleAr: string, titleEn: string } | null };

export type PreviewEventQueryVariables = Exact<{
  where: EventWhereUniqueInput;
}>;


export type PreviewEventQuery = { __typename?: 'Query', findUniqueEvent?: { __typename?: 'Event', id: number, startDate?: any | null, endDate?: any | null, isTrainerCertificateAvailable: boolean, isTraineeCertificateAvailable: boolean, minAttendancePercentageToGetCertificate?: any | null, isAccredited: boolean, isAccreditedSHA?: boolean | null, onsiteCapacity?: number | null, address?: string | null, addressAr?: string | null, backgroundImagesUrls: Array<string>, sponsorshipImagesUrls?: any | null, isSponsored: boolean, keywordsAr: Array<string>, keywordsEn: Array<string>, descriptionAr?: string | null, descriptionEn?: string | null, isContentProvidedByAcademy: boolean, titleAr: string, titleEn: string, addressInstructions?: string | null, addressInstructionsAr?: string | null, locationLongitude?: any | null, locationLatitude?: any | null, onlineCapacity?: number | null, imageUrl?: string | null, cmeHours?: any | null, cmeNumber?: string | null, introductionAr?: string | null, introductionEn?: string | null, objectivesAr?: string | null, objectivesEn?: string | null, mainThemeAr?: string | null, shortDescriptionAr?: string | null, shortDescriptionEn?: string | null, mainThemeEn?: string | null, isAllProfessionsTargeted?: boolean | null, outcomesAr?: string | null, outcomesEn?: string | null, whyTargetedAudienceAr?: string | null, whyTargetedAudienceEn?: string | null, visibleOnArchive?: boolean | null, eventType: { __typename?: 'EventType', id: number, titleEn: string, titleAr: string }, folder: { __typename?: 'EventFolder', id: number, titleAr: string, titleEn: string }, trainerCertificateTemplate?: { __typename?: 'Template', id: number, title: string } | null, traineeCertificateTemplate?: { __typename?: 'Template', id: number, title: string } | null, leaderTrainer?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, image?: string | null, role: { __typename?: 'Role', id: number, titleAr: string, titleEn: string }, specialty?: { __typename?: 'Specialty', id: number, titleEn: string, titleAr?: string | null } | null, profession?: { __typename?: 'Profession', id: number, titleEn: string, titleAr?: string | null } | null } | null, city?: { __typename?: 'City', id: number, name: string } | null, targetedSpecialities: Array<{ __typename?: 'Specialty', id: number, titleAr?: string | null, titleEn: string }>, pricingPlan: { __typename?: 'PricingPlan', id: number, hasLateRegistration?: boolean | null, freePlanCertificateCmeIsPaid?: boolean | null, freePlanCertificateStatus?: string | null, lateRegistrationStartDate?: any | null, hasGroupDiscount?: boolean | null, groupDiscountPrice?: any | null, hasGroupDiscountEndDate?: boolean | null, hasMultiPartDiscount?: boolean | null, multiPartDiscountPrice?: any | null, groupDiscountEndDate?: any | null, groupDiscountMinNumberOfRegistrants?: number | null, freePlanCertificateCmePrice?: any | null, paidPlanPrice?: any | null, cardFee?: boolean | null, paidPlanLateRegistrationPrice?: any | null, basedOnSpecialtyPlanOtherSpecialtiesPrice?: any | null, basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: any | null, hasWorkshop?: boolean | null, workshopPrice?: any | null, workshopLateRegistrationPrice?: any | null, workshopGroupDiscountPrice?: any | null, pricingPlanTypeId?: number | null, pricingPlanSpecialtyPrices: Array<{ __typename?: 'PricingPlanSpecialtyPrice', id: number, price: any, LateRegistrationPrice?: any | null, professions: Array<{ __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string }> }>, pricingPlanType?: { __typename?: 'PricingPlanType', id: number, titleAr: string, titleEn: string } | null }, methodOfDelivery: { __typename?: 'MethodOfDelivery', id: number, titleAr: string, titleEn: string }, targetedAudiences: Array<{ __typename?: 'Profession', id: number, titleEn: string, titleAr?: string | null }>, eventParts: Array<{ __typename?: 'EventPart', id: number, outlineAr: string, outlineEn: string, pricingPlan: { __typename?: 'PricingPlan', id: number, hasLateRegistration?: boolean | null, freePlanCertificateCmeIsPaid?: boolean | null, freePlanCertificateStatus?: string | null, lateRegistrationStartDate?: any | null, hasGroupDiscount?: boolean | null, groupDiscountPrice?: any | null, hasGroupDiscountEndDate?: boolean | null, hasMultiPartDiscount?: boolean | null, multiPartDiscountPrice?: any | null, groupDiscountEndDate?: any | null, groupDiscountMinNumberOfRegistrants?: number | null, freePlanCertificateCmePrice?: any | null, paidPlanPrice?: any | null, cardFee?: boolean | null, paidPlanLateRegistrationPrice?: any | null, basedOnSpecialtyPlanOtherSpecialtiesPrice?: any | null, basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: any | null, hasWorkshop?: boolean | null, workshopPrice?: any | null, workshopLateRegistrationPrice?: any | null, workshopGroupDiscountPrice?: any | null, pricingPlanTypeId?: number | null, pricingPlanSpecialtyPrices: Array<{ __typename?: 'PricingPlanSpecialtyPrice', id: number, price: any, LateRegistrationPrice?: any | null, professions: Array<{ __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string }> }>, pricingPlanType?: { __typename?: 'PricingPlanType', id: number, titleAr: string, titleEn: string } | null }, eventDays: Array<{ __typename?: 'EventDay', id?: number | null, outlineAr?: string | null, outlineEn?: string | null, startTime?: any | null, endTime?: any | null, date?: any | null, deletedAt?: any | null, trainerLessons?: Array<{ __typename?: 'TrainerEventDayLesson', id: number, startTime: any, endTime: any, outlineAr: string, outlineEn: string, TrainerEventDayLessonType: { __typename?: 'TrainerEventDayLessonType', id: number, titleEn: string, titleAr: string }, trainerEvent?: { __typename?: 'TrainerEvent', trainer?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, image?: string | null, specialty?: { __typename?: 'Specialty', id: number, titleAr?: string | null, titleEn: string } | null, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null } | null } | null } | null> | null, trainerTimeSlots?: Array<{ __typename?: 'TrainerEventDayTimeSlot', id: number, startTime: any, endTime: any, deletedAt?: any | null, trainerEvent: { __typename?: 'TrainerEvent', id: number, deletedAt?: any | null, trainer?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, image?: string | null, specialty?: { __typename?: 'Specialty', id: number, titleAr?: string | null, titleEn: string } | null, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null } | null } } | null> | null }> }>, eventDays: Array<{ __typename?: 'EventDay', id?: number | null, outlineAr?: string | null, outlineEn?: string | null, startTime?: any | null, endTime?: any | null, date?: any | null, deletedAt?: any | null, trainerLessons?: Array<{ __typename?: 'TrainerEventDayLesson', id: number, startTime: any, endTime: any, outlineAr: string, outlineEn: string, TrainerEventDayLessonType: { __typename?: 'TrainerEventDayLessonType', id: number, titleEn: string, titleAr: string }, trainerEvent?: { __typename?: 'TrainerEvent', trainer?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, image?: string | null, specialty?: { __typename?: 'Specialty', id: number, titleAr?: string | null, titleEn: string } | null, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null } | null } | null } | null> | null, trainerTimeSlots?: Array<{ __typename?: 'TrainerEventDayTimeSlot', id: number, startTime: any, endTime: any, deletedAt?: any | null, trainerEvent: { __typename?: 'TrainerEvent', id: number, deletedAt?: any | null, trainer?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, image?: string | null, specialty?: { __typename?: 'Specialty', id: number, titleAr?: string | null, titleEn: string } | null, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null } | null } } | null> | null }>, trainerEvents: Array<{ __typename?: 'TrainerEvent', id: number, deletedAt?: any | null, trainer?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, image?: string | null, specialty?: { __typename?: 'Specialty', id: number, titleAr?: string | null, titleEn: string } | null, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null } | null }>, trainerEventStudyMaterials: Array<{ __typename?: 'TrainerEventStudyMaterial', id: number, url: string, media?: string | null, trainerEvent?: { __typename?: 'TrainerEvent', id: number, deletedAt?: any | null, trainer?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, image?: string | null, specialty?: { __typename?: 'Specialty', id: number, titleAr?: string | null, titleEn: string } | null, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null } | null } | null }>, eventLanguages: Array<{ __typename?: 'Language', id: number, title: string }> } | null };

export type ScheduleQueryVariables = Exact<{
  where: EventWhereInput;
}>;


export type ScheduleQuery = { __typename?: 'Query', findManyEvent: Array<{ __typename?: 'Event', id: number, startDate?: any | null, endDate?: any | null, titleEn: string, titleAr: string, cmeHours?: any | null, cmeNumber?: string | null, isAccredited: boolean, isAccreditedSHA?: boolean | null, pricingPlan: { __typename?: 'PricingPlan', paidPlanPrice?: any | null, cardFee?: boolean | null, basedOnSpecialtyPlanOtherSpecialtiesPrice?: any | null, pricingPlanType?: { __typename?: 'PricingPlanType', id: number } | null, pricingPlanSpecialtyPrices: Array<{ __typename?: 'PricingPlanSpecialtyPrice', id: number, price: any }> }, eventParts: Array<{ __typename?: 'EventPart', id: number, pricingPlan: { __typename?: 'PricingPlan', paidPlanPrice?: any | null, cardFee?: boolean | null, basedOnSpecialtyPlanOtherSpecialtiesPrice?: any | null, pricingPlanType?: { __typename?: 'PricingPlanType', id: number } | null, pricingPlanSpecialtyPrices: Array<{ __typename?: 'PricingPlanSpecialtyPrice', id: number, price: any }> } }> }> };

export type UpdateEventIntroContentMutationVariables = Exact<{
  data: EventUpdateInput;
  where: EventWhereUniqueInput;
}>;


export type UpdateEventIntroContentMutation = { __typename?: 'Mutation', updateOneEvent: { __typename?: 'Event', id: number, introductionAr?: string | null, isAllProfessionsTargeted?: boolean | null, objectivesAr?: string | null, objectivesEn?: string | null, shortDescriptionAr?: string | null, shortDescriptionEn?: string | null, mainThemeEn?: string | null, mainThemeAr?: string | null, outcomesEn?: string | null, outcomesAr?: string | null, whyTargetedAudienceAr?: string | null, whyTargetedAudienceEn?: string | null, introductionEn?: string | null, targetedAudiences: Array<{ __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string }>, targetedSpecialities: Array<{ __typename?: 'Specialty', id: number, titleAr?: string | null, titleEn: string }> } };

export type UpdateOneEventContentMutationVariables = Exact<{
  data: EventUpdateInput;
  where: EventWhereUniqueInput;
}>;


export type UpdateOneEventContentMutation = { __typename?: 'Mutation', updateOneEvent: { __typename?: 'Event', id: number, titleAr: string, titleEn: string, eventLanguages: Array<{ __typename?: 'Language', id: number, title: string }>, trainerEvents: Array<{ __typename?: 'TrainerEvent', id: number, deletedAt?: any | null, trainer?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, image?: string | null, deletedAt?: any | null, specialty?: { __typename?: 'Specialty', id: number, titleAr?: string | null, titleEn: string } | null, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null } | null }>, methodOfDelivery: { __typename?: 'MethodOfDelivery', id: number, titleAr: string, titleEn: string }, eventDays: Array<{ __typename?: 'EventDay', id?: number | null, outlineAr?: string | null, outlineEn?: string | null, startTime?: any | null, endTime?: any | null, date?: any | null, deletedAt?: any | null, methodOfDelivery?: { __typename?: 'MethodOfDelivery', id: number, titleAr: string, titleEn: string } | null, zoomMeetings?: Array<{ __typename?: 'ZoomMeeting', id: number, startDateTime?: any | null, endDateTime?: any | null } | null> | null, trainerLessons?: Array<{ __typename?: 'TrainerEventDayLesson', id: number, startTime: any, endTime: any, outlineAr: string, outlineEn: string, TrainerEventDayLessonType: { __typename?: 'TrainerEventDayLessonType', id: number, titleEn: string, titleAr: string }, trainerEvent?: { __typename?: 'TrainerEvent', id: number, deletedAt?: any | null, trainer?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, deletedAt?: any | null, specialty?: { __typename?: 'Specialty', id: number, titleAr?: string | null, titleEn: string } | null, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null } | null } | null } | null> | null, trainerTimeSlots?: Array<{ __typename?: 'TrainerEventDayTimeSlot', id: number, startTime: any, endTime: any, deletedAt?: any | null, trainerEvent: { __typename?: 'TrainerEvent', id: number, deletedAt?: any | null, trainer?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, deletedAt?: any | null, specialty?: { __typename?: 'Specialty', id: number, titleAr?: string | null, titleEn: string } | null, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null } | null } } | null> | null }> } };

export type TrainerEvent3FragmentFragment = { __typename?: 'TrainerEvent', id: number, deletedAt?: any | null, trainer?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, image?: string | null, specialty?: { __typename?: 'Specialty', id: number, titleAr?: string | null, titleEn: string } | null, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null } | null };

export type UpdateOneEventDayMutationVariables = Exact<{
  data: EventDayUpdateInput;
  where: EventDayWhereUniqueInput;
}>;


export type UpdateOneEventDayMutation = { __typename?: 'Mutation', updateOneEventDay: { __typename?: 'EventDay', id?: number | null, outlineAr?: string | null, outlineEn?: string | null, startTime?: any | null, endTime?: any | null, date?: any | null, deletedAt?: any | null, methodOfDelivery?: { __typename?: 'MethodOfDelivery', id: number, titleAr: string, titleEn: string } | null, trainerLessons?: Array<{ __typename?: 'TrainerEventDayLesson', id: number, startTime: any, endTime: any, outlineAr: string, outlineEn: string, TrainerEventDayLessonType: { __typename?: 'TrainerEventDayLessonType', id: number, titleEn: string, titleAr: string } } | null> | null, trainerTimeSlots?: Array<{ __typename?: 'TrainerEventDayTimeSlot', id: number, startTime: any, endTime: any, deletedAt?: any | null, trainerEvent: { __typename?: 'TrainerEvent', id: number, deletedAt?: any | null, trainer?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, image?: string | null, specialty?: { __typename?: 'Specialty', id: number, titleAr?: string | null, titleEn: string } | null, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null } | null } } | null> | null, zoomMeetings?: Array<{ __typename?: 'ZoomMeeting', id: number, startDateTime?: any | null, endDateTime?: any | null } | null> | null } };

export type UpdateOnePricingPlanMutationVariables = Exact<{
  data: PricingPlanUpdateInput;
  where: PricingPlanWhereUniqueInput;
}>;


export type UpdateOnePricingPlanMutation = { __typename?: 'Mutation', updateOnePricingPlan: { __typename?: 'PricingPlan', id: number, hasLateRegistration?: boolean | null, freePlanCertificateCmeIsPaid?: boolean | null, freePlanCertificateStatus?: string | null, lateRegistrationStartDate?: any | null, hasGroupDiscount?: boolean | null, hasMultiPartDiscount?: boolean | null, multiPartDiscountPrice?: any | null, groupDiscountPrice?: any | null, hasGroupDiscountEndDate?: boolean | null, groupDiscountEndDate?: any | null, groupDiscountMinNumberOfRegistrants?: number | null, freePlanCertificateCmePrice?: any | null, paidPlanPrice?: any | null, paidPlanOnsitePrice?: any | null, cardFee?: boolean | null, paidPlanLateRegistrationPrice?: any | null, basedOnSpecialtyPlanOtherSpecialtiesPrice?: any | null, basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice?: any | null, basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice?: any | null, hasWorkshop?: boolean | null, workshopPrice?: any | null, workshopLateRegistrationPrice?: any | null, workshopGroupDiscountPrice?: any | null, pricingPlanTypeId?: number | null, pricingPlanSpecialtyPrices: Array<{ __typename?: 'PricingPlanSpecialtyPrice', id: number, price: any, priceOnsite?: any | null, LateRegistrationPrice?: any | null, professions: Array<{ __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string }> }> } };

export type FindEventsNamesQueryVariables = Exact<{
  where?: InputMaybe<EventWhereInput>;
}>;


export type FindEventsNamesQuery = { __typename?: 'Query', findManyEvent: Array<{ __typename?: 'Event', id: number, titleEn: string, titleAr: string }> };

export type GenerateCertificateMutationVariables = Exact<{
  data: GenerateCertificateInputType;
}>;


export type GenerateCertificateMutation = { __typename?: 'Mutation', generateCertificate: boolean };

export type AddEventIdentityCardTemplateMutationVariables = Exact<{
  data: AddEventIdentityCardTemplateType;
}>;


export type AddEventIdentityCardTemplateMutation = { __typename?: 'Mutation', addEventIdentityCardTemplate: { __typename?: 'EventIdentityCardTemplate', id: number, templateData?: any | null, eventId?: number | null, createdAt?: any | null } };

export type FindUniqueEventIdentityCardTemplateQueryVariables = Exact<{
  where: EventIdentityCardTemplateWhereUniqueInput;
}>;


export type FindUniqueEventIdentityCardTemplateQuery = { __typename?: 'Query', findUniqueEventIdentityCardTemplate?: { __typename?: 'EventIdentityCardTemplate', id: number, eventId?: number | null, templateData?: any | null, createdAt?: any | null, event?: { __typename?: 'Event', id: number, titleEn: string, titleAr: string } | null } | null };

export type AddEventMediaTrackingMutationVariables = Exact<{
  data: AddEventMediaTrackingType;
}>;


export type AddEventMediaTrackingMutation = { __typename?: 'Mutation', addEventMediaTracking: { __typename?: 'EventMediaTracking', id: number, twitter?: boolean | null, facebook?: boolean | null, instagram?: boolean | null, email?: boolean | null, linkedin?: boolean | null, whatsApp?: boolean | null, google?: boolean | null, telegram?: boolean | null, ertiqaa?: boolean | null, anat?: boolean | null, friend?: boolean | null, eventId?: number | null, traineeId?: number | null, createdAt?: any | null } };

export type FindManyEventMediaTrackingQueryVariables = Exact<{
  where: EventMediaTrackingWhereInput;
  orderBy: Array<InputMaybe<EventMediaTrackingOrderByWithRelationInput>> | InputMaybe<EventMediaTrackingOrderByWithRelationInput>;
}>;


export type FindManyEventMediaTrackingQuery = { __typename?: 'Query', findManyEventMediaTracking: Array<{ __typename?: 'EventMediaTracking', id: number, twitter?: boolean | null, facebook?: boolean | null, instagram?: boolean | null, email?: boolean | null, linkedin?: boolean | null, whatsApp?: boolean | null, google?: boolean | null, telegram?: boolean | null, ertiqaa?: boolean | null, anat?: boolean | null, friend?: boolean | null, eventId?: number | null, traineeId?: number | null, createdAt?: any | null, event?: { __typename?: 'Event', id: number, titleEn: string, titleAr: string } | null, trainee?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, email: string } | null }> };

export type RemoveEventMediaTrackingMutationVariables = Exact<{
  where: RemoveEventMediaTrackingType;
}>;


export type RemoveEventMediaTrackingMutation = { __typename?: 'Mutation', removeEventMediaTracking?: Array<{ __typename?: 'EventMediaTracking', id: number, createdAt?: any | null } | null> | null };

export type CreateHiddenEventsMutationVariables = Exact<{
  data: HiddenEventsCreateInput;
}>;


export type CreateHiddenEventsMutation = { __typename?: 'Mutation', createOneHiddenEvents: { __typename?: 'HiddenEvents', id: number, eventId?: number | null, event?: { __typename?: 'Event', id: number, titleAr: string, titleEn: string } | null } };

export type DeleteHiddenEventsMutationVariables = Exact<{
  where: HiddenEventsWhereUniqueInput;
}>;


export type DeleteHiddenEventsMutation = { __typename?: 'Mutation', deleteOneHiddenEvents?: { __typename?: 'HiddenEvents', id: number, eventId?: number | null } | null };

export type FindManyHiddenEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type FindManyHiddenEventsQuery = { __typename?: 'Query', findManyHiddenEvents: Array<{ __typename?: 'HiddenEvents', id: number, eventId?: number | null, event?: { __typename?: 'Event', id: number, titleAr: string, titleEn: string } | null }> };

export type FindManyLanguageQueryVariables = Exact<{ [key: string]: never; }>;


export type FindManyLanguageQuery = { __typename?: 'Query', findManyLanguage: Array<{ __typename?: 'Language', id: number, title: string }> };

export type AddMemberNeedSettingsMutationVariables = Exact<{
  data: AddMemberNeedSettingsType;
}>;


export type AddMemberNeedSettingsMutation = { __typename?: 'Mutation', AddMemberNeedSettings: Array<{ __typename?: 'MemberNeedSettings', id: number, titleEn?: string | null, titleAr: string, createdAt?: any | null } | null> };

export type FindManyMemberNeedSettingsQueryVariables = Exact<{
  where?: InputMaybe<MemberNeedSettingsWhereInput>;
  orderBy?: InputMaybe<Array<InputMaybe<MemberNeedSettingsOrderByWithRelationInput>> | InputMaybe<MemberNeedSettingsOrderByWithRelationInput>>;
}>;


export type FindManyMemberNeedSettingsQuery = { __typename?: 'Query', findManyMemberNeedSettings: Array<{ __typename?: 'MemberNeedSettings', id: number, titleEn?: string | null, titleAr: string, createdAt?: any | null }> };

export type RemoveMemberNeedSettingsMutationVariables = Exact<{
  where: RemoveMemberNeedSettingsType;
}>;


export type RemoveMemberNeedSettingsMutation = { __typename?: 'Mutation', removeMemberNeedSettings?: Array<{ __typename?: 'MemberNeedSettings', id: number, titleEn?: string | null, titleAr: string, createdAt?: any | null } | null> | null };

export type AddMemberNeedsMutationVariables = Exact<{
  data: AddMemberNeedsType;
}>;


export type AddMemberNeedsMutation = { __typename?: 'Mutation', AddMemberNeeds: Array<{ __typename?: 'MemberNeeds', id: number, data?: any | null, createdAt?: any | null, status: MemberNeedsStatus } | null> };

export type FindManyMemberNeedsQueryVariables = Exact<{
  where: MemberNeedsWhereInput;
  orderBy: Array<InputMaybe<MemberNeedsOrderByWithRelationInput>> | InputMaybe<MemberNeedsOrderByWithRelationInput>;
}>;


export type FindManyMemberNeedsQuery = { __typename?: 'Query', findManyMemberNeeds: Array<{ __typename?: 'MemberNeeds', id: number, data?: any | null, status: MemberNeedsStatus, userId?: number | null, createdAt?: any | null, user?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, email: string } | null }> };

export type RemoveMemberNeedsMutationVariables = Exact<{
  where: RemoveMemberNeedsType;
}>;


export type RemoveMemberNeedsMutation = { __typename?: 'Mutation', removeMemberNeeds?: Array<{ __typename?: 'MemberNeeds', id: number, createdAt?: any | null } | null> | null };

export type FindManyMethodOfTeachingQueryVariables = Exact<{ [key: string]: never; }>;


export type FindManyMethodOfTeachingQuery = { __typename?: 'Query', findManyMethodOfTeachingType: Array<{ __typename?: 'MethodOfTeachingType', id: number, titleAr: string, titleEn: string }> };

export type FindOrganizersNamesQueryVariables = Exact<{
  where: RoleWhereUniqueInput;
}>;


export type FindOrganizersNamesQuery = { __typename?: 'Query', findUniqueRole?: { __typename?: 'Role', id: number, users: Array<{ __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, image?: string | null, role: { __typename?: 'Role', id: number, titleAr: string, titleEn: string } }> } | null };

export type CreateOneQuizMutationVariables = Exact<{
  data: QuizCreateOneInput;
}>;


export type CreateOneQuizMutation = { __typename?: 'Mutation', createOneQuiz: { __typename?: 'Quiz', id: number, name?: string | null, QuizQuestion: Array<{ __typename?: 'QuizQuestion', questionEn: string, questionType: string, questionAr: string, id: string, questionOrder?: number | null, createdAt: any, rightAnswer?: string | null, QuizQuestionAnswer: Array<{ __typename?: 'QuizQuestionAnswer', answerAr: string, answerEn: string, id: string, createdAt: any }> }> } };

export type DeleteOneQuizMutationVariables = Exact<{
  where: QuizWhereUniqueInput;
}>;


export type DeleteOneQuizMutation = { __typename?: 'Mutation', deleteOneQuiz?: { __typename?: 'Quiz', id: number, name?: string | null } | null };

export type FindQuizQueryVariables = Exact<{
  where: QuizWhereUniqueInput;
}>;


export type FindQuizQuery = { __typename?: 'Query', findUniqueQuiz?: { __typename?: 'Quiz', id: number, name?: string | null } | null };

export type UpdateOneQuizMutationVariables = Exact<{
  data: QuizUpdateInput;
  where: QuizWhereUniqueInput;
}>;


export type UpdateOneQuizMutation = { __typename?: 'Mutation', updateOneQuiz: { __typename?: 'Quiz', id: number } };

export type CreateOneQuizQuestionMutationVariables = Exact<{
  data: QuizQuestionCreateInput;
}>;


export type CreateOneQuizQuestionMutation = { __typename?: 'Mutation', createOneQuizQuestion: { __typename?: 'QuizQuestion', id: string, questionAr: string, questionEn: string, questionOrder?: number | null, questionType: string, rightAnswer?: string | null, createdAt: any, QuizQuestionAnswer: Array<{ __typename?: 'QuizQuestionAnswer', answerAr: string, answerEn: string, id: string, createdAt: any }> } };

export type DeleteOneQuizQuestionMutationVariables = Exact<{
  where: QuizQuestionWhereUniqueInput;
}>;


export type DeleteOneQuizQuestionMutation = { __typename?: 'Mutation', deleteOneQuizQuestion?: { __typename?: 'QuizQuestion', id: string, questionAr: string, questionEn: string, rightAnswer?: string | null, questionOrder?: number | null, questionType: string, createdAt: any } | null };

export type UpdateManyQuizQuestionMutationVariables = Exact<{
  data: Array<InputMaybe<QuizQuestionUpdateManyInput>> | InputMaybe<QuizQuestionUpdateManyInput>;
}>;


export type UpdateManyQuizQuestionMutation = { __typename?: 'Mutation', updateManyQuizQuestion: { __typename: 'BatchPayload' } };

export type UpdateOneQuizQuestionMutationVariables = Exact<{
  data: QuizQuestionUpdateInput;
  where: QuizQuestionWhereUniqueInput;
}>;


export type UpdateOneQuizQuestionMutation = { __typename?: 'Mutation', updateOneQuizQuestion: { __typename?: 'QuizQuestion', id: string } };

export type CreateOneQuizQuestionAnswerMutationVariables = Exact<{
  data: QuizQuestionAnswerCreateInput;
}>;


export type CreateOneQuizQuestionAnswerMutation = { __typename?: 'Mutation', createOneQuizQuestionAnswer: { __typename?: 'QuizQuestionAnswer', id: string } };

export type DeleteOneQuizQuestionAnswerMutationVariables = Exact<{
  where: QuizQuestionAnswerWhereUniqueInput;
}>;


export type DeleteOneQuizQuestionAnswerMutation = { __typename?: 'Mutation', deleteOneQuizQuestionAnswer?: { __typename?: 'QuizQuestionAnswer', id: string } | null };

export type UpdateOneQuizQuestionAnswerMutationVariables = Exact<{
  data: QuizQuestionAnswerUpdateInput;
  where: QuizQuestionAnswerWhereUniqueInput;
}>;


export type UpdateOneQuizQuestionAnswerMutation = { __typename?: 'Mutation', updateOneQuizQuestionAnswer: { __typename?: 'QuizQuestionAnswer', id: string } };

export type CreateOneQuizResultMutationVariables = Exact<{
  data: QuizResultCreateOneInput;
}>;


export type CreateOneQuizResultMutation = { __typename?: 'Mutation', createOneQuizResult: { __typename?: 'QuizResult', id: number, eventId?: number | null, userId?: number | null, quizId?: number | null, quizQuestionId?: string | null, quizQuestionAnswerId?: string | null } };

export type FindManyQuizResultQueryVariables = Exact<{
  where?: InputMaybe<QuizResultWhereInput>;
}>;


export type FindManyQuizResultQuery = { __typename?: 'Query', findManyQuizResult: Array<{ __typename?: 'QuizResult', id: number, quizQuestionId?: string | null, quizQuestionAnswerId?: string | null }> };

export type RecordAttendanceMutationVariables = Exact<{
  data: RecordAttendanceInput;
}>;


export type RecordAttendanceMutation = { __typename?: 'Mutation', recordAttendance?: { __typename?: 'recordAttendanceResult', TraineeEventDayAttendances: Array<{ __typename?: 'TraineeEventDayAttendance', id: number, joinTime: any, leaveTime?: any | null, duration?: number | null } | null>, EventDay?: { __typename?: 'EventDay', id?: number | null, outlineAr?: string | null, outlineEn?: string | null, startTime?: any | null, endTime?: any | null, event?: { __typename?: 'Event', id: number, titleAr: string, titleEn: string } | null } | null, Trainee?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, image?: string | null, email: string } | null } | null };

export type SetUnprocessedAttendanceMutationVariables = Exact<{
  data: SetAttendanceType;
}>;


export type SetUnprocessedAttendanceMutation = { __typename?: 'Mutation', updateOneTraineeEventDayAttendance: boolean };

export type UnprocessedAttendanceQueryVariables = Exact<{
  where: GetAttendanceType;
}>;


export type UnprocessedAttendanceQuery = { __typename?: 'Query', findManyTraineeEventDayAttendance: Array<{ __typename?: 'TraineeEventDayAttendance', id: number, participantName: string }> };

export type AdminAnalysisQueryVariables = Exact<{
  where: AdminAnalysisWhere;
}>;


export type AdminAnalysisQuery = { __typename?: 'Query', adminAnalysis: { __typename?: 'adminAnalysisOutput', createdAt?: any | null, lastLogin?: any | null } };

export type EventAnalysisQueryVariables = Exact<{
  where: EventAnalysisWhere;
}>;


export type EventAnalysisQuery = { __typename?: 'Query', eventAnalysis: Array<{ __typename?: 'eventAnalysisOutput', name?: string | null, value?: any | null, eventDeliveryMethod?: number | null }> };

export type EventsReportFindOneQueryVariables = Exact<{
  where: EventsReportUniqueObject;
}>;


export type EventsReportFindOneQuery = { __typename?: 'Query', findUniqueEventsReport: { __typename?: 'EventsReport', isProvidedByAcadmeyResult: Array<{ __typename?: 'ProvidedByCoulmn', isContentProvidedByAcademy?: boolean | null, total?: number | null, month?: number | null, year?: number | null }>, languageResult: Array<{ __typename?: 'LanguageCoulmn', languageId?: number | null, total?: number | null, month?: number | null, year?: number | null }>, EventResult: Array<{ __typename?: 'EventCoulmn', month?: number | null, total?: number | null, year?: number | null }>, howHeardAboutEventResult: Array<{ __typename?: 'HowHeardAboutEventCoulmn', howHeardAboutEventId?: number | null, month?: number | null, total?: number | null, year?: number | null }> } };

export type MarketersReportQueryVariables = Exact<{
  where: MarketersReportUniqueObject;
}>;


export type MarketersReportQuery = { __typename?: 'Query', findUniqueMarketersReport: { __typename?: 'MarketersReport', countRecord: Array<{ __typename?: 'CountRecord', total?: number | null, year?: number | null, month?: number | null }> } };

export type OrganizersReportQueryVariables = Exact<{
  where: OrganizersReportUniqueObject;
}>;


export type OrganizersReportQuery = { __typename?: 'Query', findUniqueOrganizersReport: { __typename?: 'OrganizersReport', countRecord: Array<{ __typename?: 'CountRecord', total?: number | null, year?: number | null, month?: number | null }> } };

export type TraineesReportQueryVariables = Exact<{
  where: TraineesReportUniqueObject;
}>;


export type TraineesReportQuery = { __typename?: 'Query', findUniqueTraineesReport: { __typename?: 'TraineesReport', usersWithNamesRecord: number, genderRecord: Array<{ __typename?: 'GenderRecord', gender?: string | null, total?: number | null, year?: number | null, month?: number | null }>, regionRecord: Array<{ __typename?: 'RegionRecord', city?: string | null, lat?: any | null, lng?: any | null, total?: number | null, year?: number | null, month?: number | null }> } };

export type TrainersReportQueryVariables = Exact<{
  where: TrainersReportUniqueObject;
}>;


export type TrainersReportQuery = { __typename?: 'Query', findUniqueTrainersReport: { __typename?: 'TrainersReport', becomeTrainerRecord: Array<{ __typename?: 'BecomeTrainerRecord', total?: number | null, state?: string | null, year?: number | null, month?: number | null }>, regionRecord: Array<{ __typename?: 'RegionRecord', total?: number | null, city?: string | null, lat?: any | null, lng?: any | null, year?: number | null, month?: number | null }>, countRecord: Array<{ __typename?: 'CountRecord', total?: number | null, year?: number | null, month?: number | null }> } };

export type MarketerAnalysisQueryVariables = Exact<{
  where: MarketerAnalysisWhere;
}>;


export type MarketerAnalysisQuery = { __typename?: 'Query', marketerAnalysis: { __typename?: 'marketerAnalysisOutput', createdAt?: any | null, eventsAnalysis?: Array<any | null> | null, lastLogin?: any | null, numberOfCompletedEvents?: number | null } };

export type OrgnizerAnalysisQueryVariables = Exact<{
  where: OrgnizerAnalysisWhere;
}>;


export type OrgnizerAnalysisQuery = { __typename?: 'Query', orgnizerAnalysis: { __typename?: 'orgnizerAnalysisOutput', createdAt?: any | null, eventsAnalysis?: Array<any | null> | null, lastLogin?: any | null, numberOfCompletedEvents?: number | null } };

export type TraineeAnalysisQueryVariables = Exact<{
  where: TraineeAnalysisWhere;
}>;


export type TraineeAnalysisQuery = { __typename?: 'Query', traineeAnalysis: { __typename?: 'traineeAnalysisOutput', adminNotes?: Array<string | null> | null, createdAt?: any | null, lastLogin?: any | null, numberOfCompletedEvents?: number | null, numberOfRegisteredEvents?: number | null } };

export type TrainerAnalysisQueryVariables = Exact<{
  where: TrainerAnalysisWhere;
}>;


export type TrainerAnalysisQuery = { __typename?: 'Query', trainerAnalysis: { __typename?: 'trainerAnalysisOutput', createdAt?: any | null, lastLogin?: any | null, numberOfCompletedEvents?: number | null } };

export type UserRoleQueryVariables = Exact<{
  where: UserWhereUniqueInput;
}>;


export type UserRoleQuery = { __typename?: 'Query', findUniqueUser?: { __typename?: 'User', roleId: number } | null };

export type FindSchedulingQueryVariables = Exact<{
  where: FindSchedulingInput;
}>;


export type FindSchedulingQuery = { __typename?: 'Query', findScheduling?: Array<{ __typename?: 'Scheduling', id: string, name: string, state: string, startOn: any, startedon?: any | null } | null> | null };

export type UpdateJobMutationVariables = Exact<{
  data: UpdateJobInput;
}>;


export type UpdateJobMutation = { __typename?: 'Mutation', updateJob: { __typename?: 'Scheduling', id: string, name: string, state: string, startOn: any, startedon?: any | null } };

export type CreateOneAutomatedEmailsMutationVariables = Exact<{
  data: AutomatedEmailsCreateInput;
}>;


export type CreateOneAutomatedEmailsMutation = { __typename?: 'Mutation', createOneAutomatedEmails: { __typename?: 'AutomatedEmails', id: number, title: string, days: number, sendTo: DynamicEmailSendTo, time: DynamicEmailTime, forRegistrans: DynamicEmailForRegistrans, whenEventHasClasses: DynamicwhenEventHasClasses, template?: { __typename?: 'Template', id: number, title: string } | null, notification?: { __typename?: 'Notification', id: number, link?: string | null, message?: string | null, title?: string | null } | null } };

export type CreateOneUserMutationVariables = Exact<{
  data: UserCreateInput;
}>;


export type CreateOneUserMutation = { __typename?: 'Mutation', createOneUser: { __typename?: 'User', id: number } };

export type DeleteOneAutomatedEmailsMutationVariables = Exact<{
  where: AutomatedEmailsWhereUniqueInput;
}>;


export type DeleteOneAutomatedEmailsMutation = { __typename?: 'Mutation', deleteOneAutomatedEmails?: { __typename?: 'AutomatedEmails', id: number } | null };

export type FindAutomatedEmailsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<InputMaybe<AutomatedEmailsOrderByWithRelationInput>> | InputMaybe<AutomatedEmailsOrderByWithRelationInput>>;
}>;


export type FindAutomatedEmailsQuery = { __typename?: 'Query', findManyAutomatedEmails: Array<{ __typename?: 'AutomatedEmails', id: number, title: string, days: number, sendTo: DynamicEmailSendTo, time: DynamicEmailTime, forRegistrans: DynamicEmailForRegistrans, message?: string | null, whenEventHasClasses: DynamicwhenEventHasClasses, template?: { __typename?: 'Template', id: number, title: string } | null, notification?: { __typename?: 'Notification', id: number, link?: string | null, message?: string | null, title?: string | null } | null }> };

export type FindCardFeeQueryVariables = Exact<{ [key: string]: never; }>;


export type FindCardFeeQuery = { __typename?: 'Query', findCardFee?: { __typename?: 'Settings', value?: any | null } | null };

export type FindGeneralCouponQueryVariables = Exact<{ [key: string]: never; }>;


export type FindGeneralCouponQuery = { __typename?: 'Query', findGeneralCoupon?: { __typename?: 'Settings', value?: any | null } | null };

export type FindPublishExpenseQueryVariables = Exact<{ [key: string]: never; }>;


export type FindPublishExpenseQuery = { __typename?: 'Query', findPublishExpense?: { __typename?: 'Settings', value?: any | null } | null };

export type FindRemoveUserPasswordQueryVariables = Exact<{ [key: string]: never; }>;


export type FindRemoveUserPasswordQuery = { __typename?: 'Query', findRemoveUserPassword?: { __typename?: 'Settings', value?: any | null } | null };

export type FindTaxSettingsQueryVariables = Exact<{
  where: SettingsWhereUniqueInput;
}>;


export type FindTaxSettingsQuery = { __typename?: 'Query', findUniqueSettings?: { __typename?: 'Settings', id: number, nameAr: string, nameEn: string, value?: any | null } | null };

export type FindVatNumberQueryVariables = Exact<{ [key: string]: never; }>;


export type FindVatNumberQuery = { __typename?: 'Query', findVatNumber?: { __typename?: 'Settings', value?: any | null } | null };

export type UpdateCardFeeSettingsMutationVariables = Exact<{
  data: CardFeeInputType;
}>;


export type UpdateCardFeeSettingsMutation = { __typename?: 'Mutation', updateCardFeeSettings: { __typename?: 'Settings', id: number, nameAr: string, nameEn: string, value?: any | null } };

export type UpdateGeneralCouponSettingsMutationVariables = Exact<{
  data: GeneralCouponInputType;
}>;


export type UpdateGeneralCouponSettingsMutation = { __typename?: 'Mutation', updateGeneralCouponSettings: { __typename?: 'Settings', id: number, nameAr: string, nameEn: string, value?: any | null } };

export type UpdateHeroImagesMutationVariables = Exact<{
  eventImages?: InputMaybe<Array<IndexImagesInputType> | IndexImagesInputType>;
  indexImages?: InputMaybe<Array<IndexImagesInputType> | IndexImagesInputType>;
}>;


export type UpdateHeroImagesMutation = { __typename?: 'Mutation', updateHeroImages?: Array<{ __typename?: 'Settings', id: number, nameAr: string, nameEn: string, value?: any | null } | null> | null };

export type UpdateInstantNotificationsMutationVariables = Exact<{
  data: InstantNotificationsBellInputType;
}>;


export type UpdateInstantNotificationsMutation = { __typename?: 'Mutation', updateInstantNotifications: { __typename?: 'Settings', id: number, nameAr: string, nameEn: string, value?: any | null } };

export type UpdateOneAutomatedEmailsMutationVariables = Exact<{
  data: AutomatedEmailsUpdateInput;
  where: AutomatedEmailsWhereUniqueInput;
}>;


export type UpdateOneAutomatedEmailsMutation = { __typename?: 'Mutation', updateOneAutomatedEmails: { __typename?: 'AutomatedEmails', id: number, title: string, days: number, sendTo: DynamicEmailSendTo, time: DynamicEmailTime, forRegistrans: DynamicEmailForRegistrans, whenEventHasClasses: DynamicwhenEventHasClasses, template?: { __typename?: 'Template', id: number, title: string } | null } };

export type UpdatePublishExpenseSettingsMutationVariables = Exact<{
  data: PublishExpenseInputType;
}>;


export type UpdatePublishExpenseSettingsMutation = { __typename?: 'Mutation', updatePublishExpenseSettings: { __typename?: 'Settings', id: number, nameAr: string, nameEn: string, value?: any | null } };

export type UpdateRemoveUserPasswordSettingsMutationVariables = Exact<{
  data: RemoveUserPasswordInputType;
}>;


export type UpdateRemoveUserPasswordSettingsMutation = { __typename?: 'Mutation', updateRemoveUserPasswordSettings: { __typename?: 'Settings', id: number, nameAr: string, nameEn: string, value?: any | null } };

export type UpdateTaxNumberSettingsMutationVariables = Exact<{
  data: TaxNumberInputType;
}>;


export type UpdateTaxNumberSettingsMutation = { __typename?: 'Mutation', updateTaxNumberSettings: { __typename?: 'Settings', nameAr: string, nameEn: string, value?: any | null } };

export type UpdateTaxSettingsMutationVariables = Exact<{
  data: TaxInputType;
}>;


export type UpdateTaxSettingsMutation = { __typename?: 'Mutation', updateTaxSettings: { __typename?: 'Settings', id: number, nameAr: string, nameEn: string, value?: any | null } };

export type CreateOneTraineeEventReviewChoiceMutationVariables = Exact<{
  data: TraineeEventReviewChoiceCreateInput;
}>;


export type CreateOneTraineeEventReviewChoiceMutation = { __typename?: 'Mutation', createOneTraineeEventReviewChoice: { __typename?: 'TraineeEventReviewChoice', id: number } };

export type CreateOneTraineeTrainerReviewChoiceMutationVariables = Exact<{
  data: TraineeTrainerReviewChoiceCreateInput;
}>;


export type CreateOneTraineeTrainerReviewChoiceMutation = { __typename?: 'Mutation', createOneTraineeTrainerReviewChoice: { __typename?: 'TraineeTrainerReviewChoice', id: number } };

export type DeleteOneTraineeEventReviewChoiceMutationVariables = Exact<{
  where: TraineeEventReviewChoiceWhereUniqueInput;
}>;


export type DeleteOneTraineeEventReviewChoiceMutation = { __typename?: 'Mutation', deleteOneTraineeEventReviewChoice?: { __typename?: 'TraineeEventReviewChoice', id: number } | null };

export type DeleteOneTraineeTrainerReviewChoiceMutationVariables = Exact<{
  where: TraineeTrainerReviewChoiceWhereUniqueInput;
}>;


export type DeleteOneTraineeTrainerReviewChoiceMutation = { __typename?: 'Mutation', deleteOneTraineeTrainerReviewChoice?: { __typename?: 'TraineeTrainerReviewChoice', id: number } | null };

export type UpdateOneTraineeEventReviewChoiceMutationVariables = Exact<{
  data: TraineeEventReviewChoiceUpdateInput;
  where: TraineeEventReviewChoiceWhereUniqueInput;
}>;


export type UpdateOneTraineeEventReviewChoiceMutation = { __typename?: 'Mutation', updateOneTraineeEventReviewChoice: { __typename?: 'TraineeEventReviewChoice', id: number } };

export type UpdateOneTraineeTrainerReviewChoiceMutationVariables = Exact<{
  data: TraineeTrainerReviewChoiceUpdateInput;
  where: TraineeTrainerReviewChoiceWhereUniqueInput;
}>;


export type UpdateOneTraineeTrainerReviewChoiceMutation = { __typename?: 'Mutation', updateOneTraineeTrainerReviewChoice: { __typename?: 'TraineeTrainerReviewChoice', id: number } };

export type CreateProfessionMutationVariables = Exact<{
  data: ProfessionCreateInput;
}>;


export type CreateProfessionMutation = { __typename?: 'Mutation', createOneProfession: { __typename?: 'Profession', id: number, titleEn: string } };

export type CreateSpecialtyMutationVariables = Exact<{
  data: SpecialtyCreateInput;
}>;


export type CreateSpecialtyMutation = { __typename?: 'Mutation', createOneSpecialty: { __typename?: 'Specialty', id: number, titleEn: string } };

export type DeleteProfessionMutationVariables = Exact<{
  where: ProfessionWhereUniqueInput;
}>;


export type DeleteProfessionMutation = { __typename?: 'Mutation', deleteOneProfession?: { __typename?: 'Profession', id: number, titleEn: string } | null };

export type DeleteSpecialtyMutationVariables = Exact<{
  where: SpecialtyWhereUniqueInput;
}>;


export type DeleteSpecialtyMutation = { __typename?: 'Mutation', deleteOneSpecialty?: { __typename?: 'Specialty', id: number, titleEn: string } | null };

export type FindManyQualificationQueryVariables = Exact<{ [key: string]: never; }>;


export type FindManyQualificationQuery = { __typename?: 'Query', findManyQualification: Array<{ __typename?: 'Qualification', id: number, title: string }> };

export type FindManySpecialtyQueryVariables = Exact<{
  where?: InputMaybe<SpecialtyWhereInput>;
}>;


export type FindManySpecialtyQuery = { __typename?: 'Query', findManySpecialty: Array<{ __typename?: 'Specialty', id: number, titleAr?: string | null, titleEn: string }> };

export type FindManyProfessionQueryVariables = Exact<{ [key: string]: never; }>;


export type FindManyProfessionQuery = { __typename?: 'Query', findManyProfession: Array<{ __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string, Specialties: Array<{ __typename?: 'Specialty', id: number, professionId: number, titleAr?: string | null, titleEn: string }> }> };

export type FindProfessionsNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type FindProfessionsNamesQuery = { __typename?: 'Query', findManyProfession: Array<{ __typename?: 'Profession', id: number, titleEn: string }> };

export type UpdateProfessionMutationVariables = Exact<{
  data: ProfessionUpdateInput;
  where: ProfessionWhereUniqueInput;
}>;


export type UpdateProfessionMutation = { __typename?: 'Mutation', updateOneProfession: { __typename?: 'Profession', id: number, titleEn: string } };

export type UpdateSpecialtyMutationVariables = Exact<{
  data: SpecialtyUpdateInput;
  where: SpecialtyWhereUniqueInput;
}>;


export type UpdateSpecialtyMutation = { __typename?: 'Mutation', updateOneSpecialty: { __typename?: 'Specialty', id: number, titleEn: string } };

export type AddStudyMaterialGroupMutationVariables = Exact<{
  data: TrainerEventStudyMaterialGroupCreateInput;
}>;


export type AddStudyMaterialGroupMutation = { __typename?: 'Mutation', createOneTrainerEventStudyMaterialGroup: { __typename?: 'TrainerEventStudyMaterialGroup', id: number, title: string, order: number } };

export type DeleteStudyMaterialGroupMutationVariables = Exact<{
  where: TrainerEventStudyMaterialGroupWhereUniqueInput;
}>;


export type DeleteStudyMaterialGroupMutation = { __typename?: 'Mutation', deleteOneTrainerEventStudyMaterialGroup?: { __typename?: 'TrainerEventStudyMaterialGroup', id: number } | null };

export type FindManyStudyMaterialGroupQueryVariables = Exact<{
  where: TrainerEventStudyMaterialGroupWhereInput;
  traineeEventId?: InputMaybe<Scalars['Int']>;
}>;


export type FindManyStudyMaterialGroupQuery = { __typename?: 'Query', findManyTrainerEventStudyMaterialGroup: Array<{ __typename?: 'TrainerEventStudyMaterialGroup', id: number, title: string, order: number, createdAt?: any | null, event: { __typename?: 'Event', id: number, titleEn: string, titleAr: string, startDate?: any | null, endDate?: any | null, minAttendancePercentageToGetCertificate?: any | null, discussionStatus: boolean, introductionAr?: string | null, introductionEn?: string | null, objectivesAr?: string | null, objectivesEn?: string | null, mainThemeAr?: string | null, mainThemeEn?: string | null, outcomesAr?: string | null, outcomesEn?: string | null, isAllProfessionsTargeted?: boolean | null, whyTargetedAudienceAr?: string | null, whyTargetedAudienceEn?: string | null, Discussion: Array<{ __typename?: 'Discussion', id: number, comment: string, createdAt: any, Replies: Array<{ __typename?: 'Discussion', id: number, comment: string, createdAt: any, User: { __typename?: 'User', id: number, username?: string | null, logoUrl?: string | null, name?: string | null, nameAr?: string | null } }>, User: { __typename?: 'User', id: number, username?: string | null, logoUrl?: string | null, name?: string | null, nameAr?: string | null } }>, targetedAudiences: Array<{ __typename?: 'Profession', id: number, titleEn: string, titleAr?: string | null }>, targetedSpecialities: Array<{ __typename?: 'Specialty', id: number, titleEn: string, titleAr?: string | null }>, trainerEvents: Array<{ __typename?: 'TrainerEvent', id: number, trainer?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, image?: string | null, profession?: { __typename?: 'Profession', id: number, titleEn: string, titleAr?: string | null } | null, specialty?: { __typename?: 'Specialty', id: number, titleEn: string, titleAr?: string | null } | null } | null }> }, StudyMaterials: Array<{ __typename?: 'TrainerEventStudyMaterial', id: number, url: string, title: string, media?: string | null, order: number, createdAt?: any | null, event: { __typename?: 'Event', id: number, titleEn: string, titleAr: string, startDate?: any | null, endDate?: any | null, minAttendancePercentageToGetCertificate?: any | null, discussionStatus: boolean, hideVideoProgress?: boolean | null, Discussion: Array<{ __typename?: 'Discussion', id: number, comment: string, createdAt: any, Replies: Array<{ __typename?: 'Discussion', id: number, comment: string, createdAt: any, User: { __typename?: 'User', id: number, username?: string | null, logoUrl?: string | null, name?: string | null, nameAr?: string | null } }>, User: { __typename?: 'User', id: number, username?: string | null, logoUrl?: string | null, name?: string | null, nameAr?: string | null } }> }, Quiz?: { __typename?: 'Quiz', id: number, name?: string | null, QuizQuestion: Array<{ __typename?: 'QuizQuestion', questionEn: string, questionType: string, questionAr: string, id: string, questionOrder?: number | null, createdAt: any, rightAnswer?: string | null, QuizQuestionAnswer: Array<{ __typename?: 'QuizQuestionAnswer', answerAr: string, answerEn: string, id: string, createdAt: any }> }> } | null, traineeEventStudyMaterialAttendance: Array<{ __typename?: 'TraineeEventStudyMaterialAttendance', traineeEventId: number, progressPercentage?: any | null, traineeEvent: { __typename?: 'TraineeEvent', Certificate?: { __typename?: 'Certificate', id?: number | null, metaData?: any | null, createdAt?: any | null, event?: { __typename?: 'Event', id: number, titleEn: string, titleAr: string } | null, traineeEvent?: { __typename?: 'TraineeEvent', id: number } | null } | null } }> }> }> };

export type FindManyStudyMaterialGroupProgressQueryVariables = Exact<{
  where: TrainerEventStudyMaterialGroupWhereInput;
  traineeEventId?: InputMaybe<Scalars['Int']>;
}>;


export type FindManyStudyMaterialGroupProgressQuery = { __typename?: 'Query', findManyTrainerEventStudyMaterialGroup: Array<{ __typename?: 'TrainerEventStudyMaterialGroup', id: number, StudyMaterials: Array<{ __typename?: 'TrainerEventStudyMaterial', id: number, event: { __typename?: 'Event', id: number, minAttendancePercentageToGetCertificate?: any | null }, traineeEventStudyMaterialAttendance: Array<{ __typename?: 'TraineeEventStudyMaterialAttendance', traineeEventId: number, progressPercentage?: any | null }> }> }> };

export type FindOneStudyMaterialGroupQueryVariables = Exact<{
  where: TrainerEventStudyMaterialGroupWhereUniqueInput;
}>;


export type FindOneStudyMaterialGroupQuery = { __typename?: 'Query', findOneTrainerEventStudyMaterialGroup?: { __typename?: 'TrainerEventStudyMaterialGroup', id: number, title: string, order: number, createdAt?: any | null, StudyMaterials: Array<{ __typename?: 'TrainerEventStudyMaterial', id: number, url: string, title: string, media?: string | null, order: number, createdAt?: any | null, event: { __typename?: 'Event', startDate?: any | null, endDate?: any | null } }> } | null };

export type UpdateStudyMaterialGroupMutationVariables = Exact<{
  data: TrainerEventStudyMaterialGroupUpdateInput;
  where: TrainerEventStudyMaterialGroupWhereUniqueInput;
}>;


export type UpdateStudyMaterialGroupMutation = { __typename?: 'Mutation', updateOneTrainerEventStudyMaterialGroup?: { __typename?: 'TrainerEventStudyMaterialGroup', id: number, title: string, order: number } | null };

export type CreateOneTemplateMutationVariables = Exact<{
  data: TemplateCreateInput;
  certificateType?: InputMaybe<Scalars['String']>;
}>;


export type CreateOneTemplateMutation = { __typename?: 'Mutation', createOneTemplate: { __typename?: 'Template', id: number, data: any, title: string, subject?: string | null, purpose: TemplatePurpose } };

export type DeleteOneTemplateMutationVariables = Exact<{
  where: TemplateWhereUniqueInput;
}>;


export type DeleteOneTemplateMutation = { __typename?: 'Mutation', deleteOneTemplate?: { __typename?: 'Template', id: number } | null };

export type FindManyCertificateQueryVariables = Exact<{ [key: string]: never; }>;


export type FindManyCertificateQuery = { __typename?: 'Query', findManyTemplate: Array<{ __typename?: 'Template', id: number, title: string }> };

export type FindManyEmailTemplateQueryVariables = Exact<{ [key: string]: never; }>;


export type FindManyEmailTemplateQuery = { __typename?: 'Query', findManyTemplate: Array<{ __typename?: 'Template', id: number, title: string }> };

export type FindUniqueTemplateQueryVariables = Exact<{
  where: TemplateWhereUniqueInput;
}>;


export type FindUniqueTemplateQuery = { __typename?: 'Query', findUniqueTemplate?: { __typename?: 'Template', id: number, purpose: TemplatePurpose, title: string, data: any } | null };

export type UpdateOneTemplateMutationVariables = Exact<{
  data: TemplateUpdateInput;
  where: TemplateWhereUniqueInput;
}>;


export type UpdateOneTemplateMutation = { __typename?: 'Mutation', updateOneTemplate: { __typename?: 'Template', id: number, purpose: TemplatePurpose, title: string, data: any } };

export type AddStudyMaterialMutationVariables = Exact<{
  data: TrainerEventStudyMaterialCreateInput;
  quizValues: Scalars['Json'];
}>;


export type AddStudyMaterialMutation = { __typename?: 'Mutation', createOneTrainerEventStudyMaterial: { __typename?: 'TrainerEventStudyMaterial', id: number, url: string, title: string, media?: string | null, eventId: number, trainerEvent?: { __typename?: 'TrainerEvent', id: number, trainer?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null } | null } | null } };

export type CreateOneTrainerEventDayLessonMutationVariables = Exact<{
  data: TrainerEventDayLessonCreateInput;
}>;


export type CreateOneTrainerEventDayLessonMutation = { __typename?: 'Mutation', createOneTrainerEventDayLesson: { __typename?: 'TrainerEventDayLesson', id: number, startTime: any, endTime: any, outlineAr: string, outlineEn: string, eventDayId: number, deletedAt?: any | null, methodOfTeaching?: { __typename?: 'MethodOfTeachingType', id: number, titleAr: string, titleEn: string } | null, trainerEvent?: { __typename?: 'TrainerEvent', id: number, trainer?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null } | null } | null } };

export type DeleteOneTrainerEventDayLessonMutationVariables = Exact<{
  where: TrainerEventDayLessonWhereUniqueInput;
}>;


export type DeleteOneTrainerEventDayLessonMutation = { __typename?: 'Mutation', deleteOneTrainerEventDayLesson?: { __typename?: 'TrainerEventDayLesson', id: number, eventDayId: number } | null };

export type DeleteStudyMaterialMutationVariables = Exact<{
  where: TrainerEventStudyMaterialWhereUniqueInput;
}>;


export type DeleteStudyMaterialMutation = { __typename?: 'Mutation', deleteOneTrainerEventStudyMaterial?: { __typename?: 'TrainerEventStudyMaterial', id: number } | null };

export type FindEventLeaderTrainerQueryVariables = Exact<{
  where: EventWhereUniqueInput;
}>;


export type FindEventLeaderTrainerQuery = { __typename?: 'Query', findUniqueEvent?: { __typename?: 'Event', id: number, leaderTrainer?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, image?: string | null, specialty?: { __typename?: 'Specialty', id: number, titleAr?: string | null, titleEn: string } | null, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null } | null } | null };

export type FindManyTrainerEventQueryVariables = Exact<{
  where?: InputMaybe<TrainerEventWhereInput>;
}>;


export type FindManyTrainerEventQuery = { __typename?: 'Query', findManyTrainerEvent: Array<{ __typename?: 'TrainerEvent', id: number, registrantId?: string | null, joinUrl?: string | null, trainer?: { __typename?: 'User', id: number, name?: string | null, email: string, nameAr?: string | null, image?: string | null, specialty?: { __typename?: 'Specialty', id: number, titleAr?: string | null, titleEn: string } | null, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null } | null, event: { __typename?: 'Event', titleEn: string, titleAr: string, ZoomMeeting?: { __typename?: 'ZoomMeeting', type?: string | null, meetingId?: string | null } | null } }> };

export type FindOneStudyMaterialQueryVariables = Exact<{
  where: TrainerEventStudyMaterialWhereUniqueInput;
}>;


export type FindOneStudyMaterialQuery = { __typename?: 'Query', findOneTrainerEventStudyMaterial?: { __typename?: 'TrainerEventStudyMaterial', id: number, url: string, title: string, media?: string | null, order: number, createdAt?: any | null, eventId: number, trainerEventStudyMaterialGroupId?: number | null, event: { __typename?: 'Event', startDate?: any | null, endDate?: any | null }, trainerEventStudyMaterialGroup?: { __typename?: 'TrainerEventStudyMaterialGroup', id: number, title: string, order: number } | null, Quiz?: { __typename?: 'Quiz', id: number, name?: string | null, QuizQuestion: Array<{ __typename?: 'QuizQuestion', questionEn: string, questionType: string, questionAr: string, id: string, questionOrder?: number | null, createdAt: any, rightAnswer?: string | null, QuizQuestionAnswer: Array<{ __typename?: 'QuizQuestionAnswer', answerAr: string, answerEn: string, id: string, createdAt: any }> }> } | null } | null };

export type EventDayFragmentFragment = { __typename?: 'EventDay', id?: number | null, outlineAr?: string | null, outlineEn?: string | null, date?: any | null, deletedAt?: any | null };

export type FindTrainerTimeSlotsQueryVariables = Exact<{
  where: TrainerEventWhereUniqueInput;
  trainerLessonsWhere?: InputMaybe<TrainerEventDayLessonWhereInput>;
  trainerTimeSlotsWhere?: InputMaybe<TrainerEventDayTimeSlotWhereInput>;
  eventDaysWhere?: InputMaybe<EventDayWhereInput>;
}>;


export type FindTrainerTimeSlotsQuery = { __typename?: 'Query', findUniqueTrainerEvent?: { __typename?: 'TrainerEvent', id: number, event: { __typename?: 'Event', id: number, titleAr: string, titleEn: string, eventDays: Array<{ __typename?: 'EventDay', id?: number | null, outlineEn?: string | null, outlineAr?: string | null, startTime?: any | null, endTime?: any | null, date?: any | null, trainerLessons?: Array<{ __typename?: 'TrainerEventDayLesson', id: number, startTime: any, endTime: any, outlineAr: string, outlineEn: string, deletedAt?: any | null, methodOfTeaching?: { __typename?: 'MethodOfTeachingType', id: number, titleAr: string, titleEn: string } | null, trainerEvent?: { __typename?: 'TrainerEvent', trainer?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null } | null } | null } | null> | null, trainerTimeSlots?: Array<{ __typename?: 'TrainerEventDayTimeSlot', id: number, startTime: any, endTime: any } | null> | null }> } } | null };

export type FindTrainersNamesQueryVariables = Exact<{
  where: RoleWhereUniqueInput;
  take?: InputMaybe<Scalars['Int']>;
  usersWhere?: InputMaybe<UserWhereInput>;
}>;


export type FindTrainersNamesQuery = { __typename?: 'Query', findUniqueRole?: { __typename?: 'Role', id: number, users: Array<{ __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, image?: string | null, email: string, specialty?: { __typename?: 'Specialty', id: number, titleAr?: string | null, titleEn: string } | null, profession?: { __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string } | null }> } | null };

export type TrainerIsAddedToEventQueryVariables = Exact<{
  where: TrainerEventWhereUniqueInput;
}>;


export type TrainerIsAddedToEventQuery = { __typename?: 'Query', findUniqueTrainerEvent?: { __typename?: 'TrainerEvent', id: number } | null };

export type TrainerIsLeaderTrainerQueryVariables = Exact<{
  where: EventWhereUniqueInput;
}>;


export type TrainerIsLeaderTrainerQuery = { __typename?: 'Query', findUniqueEvent?: { __typename?: 'Event', leaderTrainerId?: number | null, addedById?: number | null } | null };

export type UpdateBecomeTrainerApplicationMutationVariables = Exact<{
  data: BecomeTrainerApplicationUpdateInput;
  where: BecomeTrainerApplicationWhereUniqueInput;
}>;


export type UpdateBecomeTrainerApplicationMutation = { __typename?: 'Mutation', updateOneBecomeTrainerApplication: { __typename?: 'BecomeTrainerApplication', id: number } };

export type UpdateOneTrainerEventDayLessonMutationVariables = Exact<{
  data: TrainerEventDayLessonUpdateInput;
  where: TrainerEventDayLessonWhereUniqueInput;
}>;


export type UpdateOneTrainerEventDayLessonMutation = { __typename?: 'Mutation', updateOneTrainerEventDayLesson: { __typename?: 'TrainerEventDayLesson', id: number, startTime: any, endTime: any, outlineAr: string, outlineEn: string, eventDayId: number, deletedAt?: any | null, methodOfTeaching?: { __typename?: 'MethodOfTeachingType', id: number, titleAr: string, titleEn: string } | null, trainerEvent?: { __typename?: 'TrainerEvent', id: number, trainer?: { __typename?: 'User', name?: string | null, nameAr?: string | null, id: number } | null } | null } };

export type UpdateStudyMaterialMutationVariables = Exact<{
  data: TrainerEventStudyMaterialUpdateInput;
  where: TrainerEventStudyMaterialWhereUniqueInput;
  quizValues?: InputMaybe<Scalars['Json']>;
}>;


export type UpdateStudyMaterialMutation = { __typename?: 'Mutation', updateOneTrainerEventStudyMaterial?: { __typename?: 'TrainerEventStudyMaterial', id: number, url: string, title: string, media?: string | null } | null };

export type FindUniqueTrainerEventContentQueryVariables = Exact<{
  where: TrainerEventWhereUniqueInput;
}>;


export type FindUniqueTrainerEventContentQuery = { __typename?: 'Query', findUniqueTrainerEvent?: { __typename?: 'TrainerEvent', id: number, contentIsAdded?: boolean | null, introductionAr?: string | null, introductionEn?: string | null, objectivesAr?: string | null, objectivesEn?: string | null, mainThemeEn?: string | null, mainThemeAr?: string | null, outcomesEn?: string | null, outcomesAr?: string | null, whyTargetedAudienceAr?: string | null, whyTargetedAudienceEn?: string | null, youtubeUrl?: string | null, targetedAudiences: Array<{ __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string }> } | null };

export type FindUniqueUserQueryVariables = Exact<{
  where: UserWhereUniqueInput;
}>;


export type FindUniqueUserQuery = { __typename?: 'Query', findUniqueUser?: { __typename?: 'User', id: number, name?: string | null, nameAr?: string | null, email: string, image?: string | null, specialty?: { __typename?: 'Specialty', id: number, titleEn: string } | null, profession?: { __typename?: 'Profession', id: number, titleEn: string } | null } | null };

export type UpdateOneTrainerEventContentMutationVariables = Exact<{
  data: TrainerEventUpdateInput;
  where: TrainerEventWhereUniqueInput;
}>;


export type UpdateOneTrainerEventContentMutation = { __typename?: 'Mutation', updateOneTrainerEvent: { __typename?: 'TrainerEvent', id: number, contentIsAdded?: boolean | null, introductionAr?: string | null, objectivesAr?: string | null, objectivesEn?: string | null, mainThemeEn?: string | null, mainThemeAr?: string | null, outcomesEn?: string | null, outcomesAr?: string | null, whyTargetedAudienceAr?: string | null, whyTargetedAudienceEn?: string | null, youtubeUrl?: string | null, introductionEn?: string | null, targetedAudiences: Array<{ __typename?: 'Profession', id: number, titleAr?: string | null, titleEn: string }> } };

export type AddExpenseMutationVariables = Exact<{
  data: AddExpenseType;
}>;


export type AddExpenseMutation = { __typename?: 'Mutation', AddExpense: { __typename?: 'Transition', id: number } };

export type AddPaymentMutationVariables = Exact<{
  data: AddPaymentType;
}>;


export type AddPaymentMutation = { __typename?: 'Mutation', AddPayment: { __typename?: 'done', balance: any } };

export type AuthorizationFormQueryVariables = Exact<{
  where: EventWhereUniqueInput;
}>;


export type AuthorizationFormQuery = { __typename?: 'Query', findUniqueEvent?: { __typename?: 'Event', id: number, invitersCanApprovePayments?: boolean | null, methodOfDeliveryId?: number | null, titleAr: string, startDate?: any | null, endDate?: any | null, zoomMode?: string | null, eventTypeId: number, pricingPlan: { __typename?: 'PricingPlan', paidPlanPrice?: any | null, freePlanCertificateStatus?: string | null, freePlanCertificateCmePrice?: any | null, pricingPlanTypeId?: number | null, basedOnSpecialtyPlanOtherSpecialtiesPrice?: any | null }, inviterCouponProfits?: Array<{ __typename?: 'InviterCouponProfit', eventId?: number | null, inviterId?: number | null, profit?: any | null }> | null, ZoomMeeting?: { __typename?: 'ZoomMeeting', meetingId?: string | null, type?: string | null, startDateTime?: any | null, endDateTime?: any | null } | null } | null };

export type CheckValidityGroupBookingQueryVariables = Exact<{
  where: EventWhereUniqueInput;
}>;


export type CheckValidityGroupBookingQuery = { __typename?: 'Query', findUniqueEvent?: { __typename?: 'Event', id: number, methodOfDeliveryId?: number | null, pricingPlan: { __typename?: 'PricingPlan', id: number, hasGroupDiscount?: boolean | null, groupDiscountEndDate?: any | null, groupDiscountMinNumberOfRegistrants?: number | null } } | null };

export type FindBalanceQueryVariables = Exact<{
  where: UserWhereUniqueInput;
}>;


export type FindBalanceQuery = { __typename?: 'Query', findUniqueUser?: { __typename?: 'User', id: number, balance: any, marketerBalance: any, roleId: number } | null };

export type FindManyTransitionStatusTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type FindManyTransitionStatusTypeQuery = { __typename?: 'Query', findManyTransitionStatusType: Array<{ __typename?: 'TransitionStatusType', id: number, titleEn: string, titleAr: string }> };

export type IncomeStatementQueryVariables = Exact<{
  where: IncomeStatementWhereInput;
}>;


export type IncomeStatementQuery = { __typename?: 'Query', incomeStatement: Array<{ __typename?: 'incomeStatementOutput', category: string, expenses: any, income: any, source: string, tax: any, moyasarFee: any, couponDiscount: any, couponMarketerDiscount: any, eventId?: any | null }> };

export type RemoveExpenseMutationMutationVariables = Exact<{
  data: RemoveExpenseInputType;
}>;


export type RemoveExpenseMutationMutation = { __typename?: 'Mutation', removeExpenseMutation?: { __typename: 'Transition' } | null };

export type UpdateAuthorizationFormMutationVariables = Exact<{
  data: EventUpdateInput;
  where: EventWhereUniqueInput;
}>;


export type UpdateAuthorizationFormMutation = { __typename?: 'Mutation', updateOneEvent: { __typename?: 'Event', id: number, invitersCanApprovePayments?: boolean | null } };

export type UpdateBookingTransitionStatusMutationVariables = Exact<{
  data: UpdateBookingTransitionStatusInputType;
}>;


export type UpdateBookingTransitionStatusMutation = { __typename?: 'Mutation', updateBookingTransitionStatus: { __typename?: 'Transition', id: number } };

export type FindUniqueTransitionQueryVariables = Exact<{
  where: TransitionWhereUniqueInput;
}>;


export type FindUniqueTransitionQuery = { __typename?: 'Query', findUniqueTransition?: { __typename?: 'Transition', id: number, amount: any, tax: any, fullAmount: any, receiptUrl?: string | null, paymentWay: { __typename?: 'PaymentWay', id: number, title: string }, transitionPurpose: { __typename?: 'TransitionPurpose', id: number, titleAr: string, titleEn: string }, status: { __typename?: 'TransitionStatusType', id: number, titleEn: string, titleAr: string }, transitionType: { __typename?: 'TransitionType', id: number, titleAr: string, titleEn: string } } | null };

export type DeleteManyUsersMutationVariables = Exact<{
  where?: InputMaybe<UserWhereInput>;
}>;


export type DeleteManyUsersMutation = { __typename?: 'Mutation', deleteManyUsers: { __typename?: 'BatchPayload', count: number } };

export type DeleteUserMutationVariables = Exact<{
  where: UserWhereUniqueInput;
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteOneUser: { __typename?: 'User', id: number } };

export type MergeAccountsMutationVariables = Exact<{
  data: MergeAccountsInputType;
}>;


export type MergeAccountsMutation = { __typename?: 'Mutation', mergeAccounts: boolean };

export type CreateOneZoomMutationVariables = Exact<{
  data: ZoomCreateInput;
}>;


export type CreateOneZoomMutation = { __typename?: 'Mutation', createOneZoom: { __typename?: 'Zoom', duration?: number | null, id?: string | null, agenda?: string | null, registration_url?: string | null, start_url?: string | null, start_time?: string | null, timezone?: string | null, topic?: string | null, type?: number | null, recurrence?: { __typename?: 'Recurrence', end_date_time?: string | null } | null } };

export type FindOneZoomQueryVariables = Exact<{
  where: ZoomWhereUniqueInput;
}>;


export type FindOneZoomQuery = { __typename?: 'Query', findOneZoom?: { __typename?: 'Zoom', agenda?: string | null, close_registration?: boolean | null, default_password?: boolean | null, duration?: number | null, id?: string | null, password?: string | null, registration_url?: string | null, start_time?: string | null, start_url?: string | null, timezone?: string | null, topic?: string | null, type?: number | null, occurrences?: Array<{ __typename?: 'zoomOccurrences', occurrence_id?: string | null, start_time?: string | null, status?: string | null, duration?: number | null }> | null, recurrence?: { __typename?: 'Recurrence', end_date_time?: string | null, type?: number | null } | null, settings?: { __typename?: 'zoomSettings', meeting_authentication?: boolean | null, registrants_email_notification?: boolean | null, registrants_confirmation_email?: boolean | null } | null } | null };

export type UpdateOneZoomMutationVariables = Exact<{
  data: ZoomUpdateInput;
  where: ZoomWhereUpdateInput;
}>;


export type UpdateOneZoomMutation = { __typename?: 'Mutation', updateOneZoom: { __typename?: 'Zoom', agenda?: string | null, id?: string | null, registration_url?: string | null, start_url?: string | null, duration?: number | null, topic?: string | null, settings?: { __typename?: 'zoomSettings', meeting_authentication?: boolean | null, registrants_email_notification?: boolean | null, registrants_confirmation_email?: boolean | null } | null } };

export type CreateManyZoomRegistrantMutationVariables = Exact<{
  data: Array<ZoomRegistrantCreateOneInput> | ZoomRegistrantCreateOneInput;
}>;


export type CreateManyZoomRegistrantMutation = { __typename?: 'Mutation', createManyZoomRegistrant: { __typename?: 'ZoomRegistrant', id?: any | null } };

export type CreateOneZoomRegistrantMutationVariables = Exact<{
  data: ZoomRegistrantCreateOneInput;
}>;


export type CreateOneZoomRegistrantMutation = { __typename?: 'Mutation', createOneZoomRegistrant: { __typename?: 'ZoomRegistrant', id?: any | null, join_url?: string | null, phone?: string | null } };

export type DeleteOneZoomRegistrantMutationVariables = Exact<{
  where: ZoomRegistrantWhereUniqueInput;
}>;


export type DeleteOneZoomRegistrantMutation = { __typename?: 'Mutation', deleteOneZoomRegistrant?: { __typename?: 'ZoomRegistrant', industry?: string | null } | null };

export type FindManyZoomRegistrantQueryVariables = Exact<{
  where: ZoomRegistrantWhereManyInput;
}>;


export type FindManyZoomRegistrantQuery = { __typename?: 'Query', findManyZoomRegistrant?: Array<{ __typename?: 'ZoomRegistrant', email: string, auto_approve?: boolean | null, country?: string | null, first_name: string, last_name?: string | null, join_url?: string | null, page_number?: number | null, registrant_id?: string | null, job_title?: string | null, industry?: string | null } | null> | null };

export type FindUniqueZoomRegistrantQueryVariables = Exact<{
  where: ZoomRegistrantWherefindUniqueInput;
}>;


export type FindUniqueZoomRegistrantQuery = { __typename?: 'Query', findUniqueZoomRegistrant?: { __typename?: 'ZoomRegistrant', id?: any | null, first_name: string, email: string, zoomMode?: string | null, last_name?: string | null, phone?: string | null, country?: string | null, job_title?: string | null, industry?: string | null, registrant_id?: string | null, join_url?: string | null, auto_approve?: boolean | null } | null };

export const PricingPlanFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PricingPlanFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PricingPlan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasLateRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"freePlanCertificateCmeIsPaid"}},{"kind":"Field","name":{"kind":"Name","value":"freePlanCertificateStatus"}},{"kind":"Field","name":{"kind":"Name","value":"lateRegistrationStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"hasGroupDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"groupDiscountPrice"}},{"kind":"Field","name":{"kind":"Name","value":"hasGroupDiscountEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"groupDiscountEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"groupDiscountMinNumberOfRegistrants"}},{"kind":"Field","name":{"kind":"Name","value":"freePlanCertificateCmePrice"}},{"kind":"Field","name":{"kind":"Name","value":"paidPlanPrice"}},{"kind":"Field","name":{"kind":"Name","value":"paidPlanOnsitePrice"}},{"kind":"Field","name":{"kind":"Name","value":"cardFee"}},{"kind":"Field","name":{"kind":"Name","value":"paidPlanLateRegistrationPrice"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlanSpecialtyPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceOnsite"}},{"kind":"Field","name":{"kind":"Name","value":"LateRegistrationPrice"}},{"kind":"Field","name":{"kind":"Name","value":"professions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"basedOnSpecialtyPlanOtherSpecialtiesPrice"}},{"kind":"Field","name":{"kind":"Name","value":"basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice"}},{"kind":"Field","name":{"kind":"Name","value":"basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice"}},{"kind":"Field","name":{"kind":"Name","value":"hasWorkshop"}},{"kind":"Field","name":{"kind":"Name","value":"workshopPrice"}},{"kind":"Field","name":{"kind":"Name","value":"workshopLateRegistrationPrice"}},{"kind":"Field","name":{"kind":"Name","value":"workshopGroupDiscountPrice"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlanTypeId"}}]}}]} as unknown as DocumentNode<PricingPlanFragmentFragment, unknown>;
export const TrainerFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TrainerFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"specialty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}}]}}]} as unknown as DocumentNode<TrainerFragmentFragment, unknown>;
export const TrainerEventFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TrainerEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TrainerEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trainer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"specialty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}}]} as unknown as DocumentNode<TrainerEventFragmentFragment, unknown>;
export const EventDayPreviewFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventDayPreviewFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventDay"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"trainerLessons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"TrainerEventDayLessonType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trainer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"specialty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerTimeSlots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"trainerEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trainer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"specialty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}}]}}]} as unknown as DocumentNode<EventDayPreviewFragmentFragment, unknown>;
export const PricingPlanPreviewFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PricingPlanPreviewFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PricingPlan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasLateRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"freePlanCertificateCmeIsPaid"}},{"kind":"Field","name":{"kind":"Name","value":"freePlanCertificateStatus"}},{"kind":"Field","name":{"kind":"Name","value":"lateRegistrationStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"hasGroupDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"groupDiscountPrice"}},{"kind":"Field","name":{"kind":"Name","value":"hasGroupDiscountEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"hasMultiPartDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"multiPartDiscountPrice"}},{"kind":"Field","name":{"kind":"Name","value":"groupDiscountEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"groupDiscountMinNumberOfRegistrants"}},{"kind":"Field","name":{"kind":"Name","value":"freePlanCertificateCmePrice"}},{"kind":"Field","name":{"kind":"Name","value":"paidPlanPrice"}},{"kind":"Field","name":{"kind":"Name","value":"cardFee"}},{"kind":"Field","name":{"kind":"Name","value":"paidPlanLateRegistrationPrice"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlanSpecialtyPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"LateRegistrationPrice"}},{"kind":"Field","name":{"kind":"Name","value":"professions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"basedOnSpecialtyPlanOtherSpecialtiesPrice"}},{"kind":"Field","name":{"kind":"Name","value":"basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice"}},{"kind":"Field","name":{"kind":"Name","value":"hasWorkshop"}},{"kind":"Field","name":{"kind":"Name","value":"workshopPrice"}},{"kind":"Field","name":{"kind":"Name","value":"workshopLateRegistrationPrice"}},{"kind":"Field","name":{"kind":"Name","value":"workshopGroupDiscountPrice"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlanType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlanTypeId"}}]}}]} as unknown as DocumentNode<PricingPlanPreviewFragmentFragment, unknown>;
export const TrainerEvent3FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TrainerEvent3Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TrainerEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trainer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"specialty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}}]} as unknown as DocumentNode<TrainerEvent3FragmentFragment, unknown>;
export const EventDayFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventDayFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventDay"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}}]} as unknown as DocumentNode<EventDayFragmentFragment, unknown>;
export const AddBlogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddBlogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BlogsCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneBlogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionAr"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"contentAr"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailImage"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}}]}}]} as unknown as DocumentNode<AddBlogsMutation, AddBlogsMutationVariables>;
export const DeleteBlogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteBlogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BlogsWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneBlogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteBlogsMutation, DeleteBlogsMutationVariables>;
export const FindManyBlogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindManyBlogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BlogsWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BlogsOrderByWithRelationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyBlogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionAr"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"contentAr"}},{"kind":"Field","name":{"kind":"Name","value":"socialMedia"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailImage"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}}]}}]}}]}}]} as unknown as DocumentNode<FindManyBlogsQuery, FindManyBlogsQueryVariables>;
export const UpdateBlogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateBlogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BlogsUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BlogsWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneBlogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionAr"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"contentAr"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailImage"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}}]}}]} as unknown as DocumentNode<UpdateBlogsMutation, UpdateBlogsMutationVariables>;
export const FindManyCityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindManyCity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CityWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyCity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<FindManyCityQuery, FindManyCityQueryVariables>;
export const FindManyCountryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindManyCountry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyCountry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<FindManyCountryQuery, FindManyCountryQueryVariables>;
export const FindManyStateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindManyState"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StateWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyState"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<FindManyStateQuery, FindManyStateQueryVariables>;
export const FindUniqueCityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindUniqueCity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CityWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueCity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"countryId"}},{"kind":"Field","name":{"kind":"Name","value":"stateId"}}]}}]}}]} as unknown as DocumentNode<FindUniqueCityQuery, FindUniqueCityQueryVariables>;
export const SendFcmDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendFCM"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FCMInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendFCM"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<SendFcmMutation, SendFcmMutationVariables>;
export const AddMemberToGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddMemberToGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddMemberToGroupInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AddMemberToGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AddMemberToGroupMutation, AddMemberToGroupMutationVariables>;
export const DeleteOneTraineeEventGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneTraineeEventGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TraineeEventGroupWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneTraineeEventGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteOneTraineeEventGroupMutation, DeleteOneTraineeEventGroupMutationVariables>;
export const RemoveUserFromGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveUserFromGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TraineeEventUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TraineeEventWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneTraineeEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveUserFromGroupMutation, RemoveUserFromGroupMutationVariables>;
export const ResendEmailGroupBookingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResendEmailGroupBooking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingEmailInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resendBookingEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ResendEmailGroupBookingMutation, ResendEmailGroupBookingMutationVariables>;
export const UpdateGroupBookingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateGroupBooking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TraineeEventGroupUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TraineeEventGroupWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneTraineeEventGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateGroupBookingMutation, UpdateGroupBookingMutationVariables>;
export const EventRatingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventRatings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trainerEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"traineeTrainerReviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reviewOfFive"}},{"kind":"Field","name":{"kind":"Name","value":"why"}},{"kind":"Field","name":{"kind":"Name","value":"choices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isGood"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trainer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"traineeEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trainee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"traineeEventReviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reviewOfFive"}},{"kind":"Field","name":{"kind":"Name","value":"why"}},{"kind":"Field","name":{"kind":"Name","value":"traineeEventReviewChoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isGood"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"TraineeEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trainee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EventRatingsQuery, EventRatingsQueryVariables>;
export const FindManyRankDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindManyRank"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyRank"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<FindManyRankQuery, FindManyRankQueryVariables>;
export const FindManyZohoEmailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindManyZohoEmails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ZohoEmailWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyZohoEmails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"opened"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"clicked"}},{"kind":"Field","name":{"kind":"Name","value":"softBounce"}},{"kind":"Field","name":{"kind":"Name","value":"hardBounce"}},{"kind":"Field","name":{"kind":"Name","value":"sent"}},{"kind":"Field","name":{"kind":"Name","value":"User"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mobileNumber"}},{"kind":"Field","name":{"kind":"Name","value":"inviter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"TraineeEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bookingStatusId"}},{"kind":"Field","name":{"kind":"Name","value":"registrantToken"}},{"kind":"Field","name":{"kind":"Name","value":"Certificate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"addressInstructions"}},{"kind":"Field","name":{"kind":"Name","value":"locationLatitude"}},{"kind":"Field","name":{"kind":"Name","value":"locationLongitude"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"eventDays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"zohoTemplateId"}}]}}]}}]}}]} as unknown as DocumentNode<FindManyZohoEmailsQuery, FindManyZohoEmailsQueryVariables>;
export const FindMemberBasicInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindMemberBasicInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"roleId"}}]}}]}}]} as unknown as DocumentNode<FindMemberBasicInfoQuery, FindMemberBasicInfoQueryVariables>;
export const FindTraineeAttendanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindTraineeAttendance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TraineeEventWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyTraineeEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trainee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"scfhs"}},{"kind":"Field","name":{"kind":"Name","value":"mobileNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"traineeEventStudyMaterialAttendance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"progressPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"trainerEventStudyMaterialId"}},{"kind":"Field","name":{"kind":"Name","value":"trainerEventStudyMaterial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"media"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"eventTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"eventDays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"zoomDuration"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerEventStudyMaterialGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"StudyMaterials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"media"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"traineeEventStudyMaterialAttendance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"progressPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"trainerEventStudyMaterialId"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Certificate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attendance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"eventDayId"}},{"kind":"Field","name":{"kind":"Name","value":"joinTime"}},{"kind":"Field","name":{"kind":"Name","value":"leaveTime"}}]}}]}}]}}]} as unknown as DocumentNode<FindTraineeAttendanceQuery, FindTraineeAttendanceQueryVariables>;
export const FindUserRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindUserRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}}]}}]}}]} as unknown as DocumentNode<FindUserRoleQuery, FindUserRoleQueryVariables>;
export const OrganizerEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrganizerEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addedEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"addedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"methodOfDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}}]}}]}}]} as unknown as DocumentNode<OrganizerEventsQuery, OrganizerEventsQueryVariables>;
export const TrainerRatingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TrainerRatings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trainerEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"traineeTrainerReviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reviewOfFive"}},{"kind":"Field","name":{"kind":"Name","value":"why"}},{"kind":"Field","name":{"kind":"Name","value":"choices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isGood"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"traineeEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trainee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TrainerRatingsQuery, TrainerRatingsQueryVariables>;
export const TraineeAttendanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TraineeAttendance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"traineeEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"traineeId"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attendance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventDayId"}},{"kind":"Field","name":{"kind":"Name","value":"eventDay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"zoomDuration"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"traineeAttendance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"joinTime"}},{"kind":"Field","name":{"kind":"Name","value":"leaveTime"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TraineeAttendanceQuery, TraineeAttendanceQueryVariables>;
export const TraineeEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TraineeEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TraineeEventWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyTraineeEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trainee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"specialtyId"}},{"kind":"Field","name":{"kind":"Name","value":"professionId"}},{"kind":"Field","name":{"kind":"Name","value":"specialty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"nationality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bookingStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"methodOfDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalToPay"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkshopRegistrant"}},{"kind":"Field","name":{"kind":"Name","value":"transitions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentWay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"attendance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventDayId"}},{"kind":"Field","name":{"kind":"Name","value":"joinTime"}},{"kind":"Field","name":{"kind":"Name","value":"leaveTime"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"review"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reviewOfFive"}}]}}]}}]}}]} as unknown as DocumentNode<TraineeEventsQuery, TraineeEventsQueryVariables>;
export const TraineeEventFindManyQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TraineeEventFindManyQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TraineeEventWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyTraineeEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"totalToPay"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"ZoomMeeting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"meetingId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"methodOfDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventDays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"inviter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventDay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bookingStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"mobileNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventMediaTracking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"twitter"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"linkedin"}},{"kind":"Field","name":{"kind":"Name","value":"whatsApp"}},{"kind":"Field","name":{"kind":"Name","value":"google"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"ertiqaa"}},{"kind":"Field","name":{"kind":"Name","value":"anat"}},{"kind":"Field","name":{"kind":"Name","value":"friend"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"adminNotes"}}]}}]}}]}}]} as unknown as DocumentNode<TraineeEventFindManyQueryQuery, TraineeEventFindManyQueryQueryVariables>;
export const TraineeEventReviewChoicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TraineeEventReviewChoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyTraineeEventReviewChoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"isGood"}}]}}]}}]} as unknown as DocumentNode<TraineeEventReviewChoicesQuery, TraineeEventReviewChoicesQueryVariables>;
export const TraineeNeedsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TraineeNeeds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberNeeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<TraineeNeedsQuery, TraineeNeedsQueryVariables>;
export const TraineeRatingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TraineeRatings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"traineeEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"traineeTrainerReviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reviewOfFive"}},{"kind":"Field","name":{"kind":"Name","value":"why"}},{"kind":"Field","name":{"kind":"Name","value":"choices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isGood"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trainer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"review"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reviewOfFive"}},{"kind":"Field","name":{"kind":"Name","value":"why"}},{"kind":"Field","name":{"kind":"Name","value":"traineeEventReviewChoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isGood"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TraineeRatingsQuery, TraineeRatingsQueryVariables>;
export const TraineeTrainerReviewChoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TraineeTrainerReviewChoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyTraineeTrainerReviewChoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"isGood"}}]}}]}}]} as unknown as DocumentNode<TraineeTrainerReviewChoiceQuery, TraineeTrainerReviewChoiceQueryVariables>;
export const TrainerEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TrainerEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TrainerEventWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyTrainerEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trainer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"methodOfDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transitions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentWay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TrainerEventsQuery, TrainerEventsQueryVariables>;
export const UpdateOneCvDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOneCv"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CvUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CvWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneCv"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"education"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"university"}},{"kind":"Field","name":{"kind":"Name","value":"profession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"graduationYear"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rank"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professionalSkills"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"yearsOfExperience"}},{"kind":"Field","name":{"kind":"Name","value":"academicRank"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"placeOfWork"}},{"kind":"Field","name":{"kind":"Name","value":"natureOfWork"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainingExperience"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventName"}},{"kind":"Field","name":{"kind":"Name","value":"executingAgency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scientificResearches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOneCvMutation, UpdateOneCvMutationVariables>;
export const UpdateUserRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;
export const DestroyWaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DestroyWA"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"destroyWhatsAppInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"destroyWhatsApp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<DestroyWaMutation, DestroyWaMutationVariables>;
export const FindWaStateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindWAState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findWAState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ProfilePicUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"wid"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"platform"}},{"kind":"Field","name":{"kind":"Name","value":"pushName"}}]}}]}}]} as unknown as DocumentNode<FindWaStateQuery, FindWaStateQueryVariables>;
export const FindWhatsAppMsgsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindWhatsAppMsgs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"findWhatsAppMsgsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findWhatsAppMsgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"locationLatitude"}},{"kind":"Field","name":{"kind":"Name","value":"locationLongitude"}},{"kind":"Field","name":{"kind":"Name","value":"cmeHours"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressInstructions"}},{"kind":"Field","name":{"kind":"Name","value":"methodOfDeliveryId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"listMsgOutput"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bookingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"msg"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"method"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"msgState"}},{"kind":"Field","name":{"kind":"Name","value":"bookingId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FindWhatsAppMsgsQuery, FindWhatsAppMsgsQueryVariables>;
export const FindWhatsAppQrDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindWhatsAppQr"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whatsAppGetQr"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<FindWhatsAppQrQuery, FindWhatsAppQrQueryVariables>;
export const InitializeWaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InitializeWA"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"initializeWhatsAppInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initializeWhatsApp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<InitializeWaMutation, InitializeWaMutationVariables>;
export const LogoutWaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LogoutWA"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"logoutWhatsAppInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logoutWhatsApp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<LogoutWaMutation, LogoutWaMutationVariables>;
export const ResetWaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResetWA"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"resetWhatsAppInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetWhatsApp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<ResetWaMutation, ResetWaMutationVariables>;
export const UpdateWhatsAppMsgsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateWhatsAppMsgs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"updateWhatsAppMsgsInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateWhatsAppMsgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<UpdateWhatsAppMsgsMutation, UpdateWhatsAppMsgsMutationVariables>;
export const WhatsAppSendManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"WhatsAppSendMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"whatsAppSendManyInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whatsAppSendMany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<WhatsAppSendManyMutation, WhatsAppSendManyMutationVariables>;
export const DeleteBookingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteBooking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TraineeEventWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneTraineeEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteBookingMutation, DeleteBookingMutationVariables>;
export const GroupBookingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GroupBooking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TraineeEventGroupWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyTraineeEventGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"traineeEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"totalToPay"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"bookingStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mobileNumber"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupTotalToPay"}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GroupBookingQuery, GroupBookingQueryVariables>;
export const TurnToGuestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TurnToGuest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"turnToGuestInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"turnToGuest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<TurnToGuestMutation, TurnToGuestMutationVariables>;
export const UpdateAllBookingsMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAllBookingsMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"updateAllBookingsMethodInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAllBookingsMethod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateAllBookingsMethodMutation, UpdateAllBookingsMethodMutationVariables>;
export const UpdateBookingMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateBookingMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"updateBookingMethodInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBookingMethod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateBookingMethodMutation, UpdateBookingMethodMutationVariables>;
export const AnalyticsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Analytics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AnalyticsInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"analytics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<AnalyticsMutation, AnalyticsMutationVariables>;
export const ContactUsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ContactUs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactUsType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContactUs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<ContactUsMutation, ContactUsMutationVariables>;
export const SendEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"sendEmailInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<SendEmailMutation, SendEmailMutationVariables>;
export const AddBookingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddBooking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AddBooking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"traineeEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"totalToPay"}},{"kind":"Field","name":{"kind":"Name","value":"isLateRegistrant"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkshopRegistrant"}},{"kind":"Field","name":{"kind":"Name","value":"isGroupRegistrant"}},{"kind":"Field","name":{"kind":"Name","value":"certificatePrice"}},{"kind":"Field","name":{"kind":"Name","value":"workshopPrice"}},{"kind":"Field","name":{"kind":"Name","value":"walletBalance"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardFee"}},{"kind":"Field","name":{"kind":"Name","value":"hasWorkshop"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlanTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"eventTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventDays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}},{"kind":"Field","name":{"kind":"Name","value":"brotherId"}},{"kind":"Field","name":{"kind":"Name","value":"brother"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}},{"kind":"Field","name":{"kind":"Name","value":"brotherId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"siblings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}},{"kind":"Field","name":{"kind":"Name","value":"brotherId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trainerLessons"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"methodOfDeliveryId"}},{"kind":"Field","name":{"kind":"Name","value":"methodOfDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventMediaTracking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"traineeId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"eventMediaTracking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"traineeId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"parts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventPart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventPartId"}},{"kind":"Field","name":{"kind":"Name","value":"partTotalPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"couponeDiscount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"traineeEventGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupPrice"}},{"kind":"Field","name":{"kind":"Name","value":"groupWalletBalance"}},{"kind":"Field","name":{"kind":"Name","value":"groupWorkshopPrice"}},{"kind":"Field","name":{"kind":"Name","value":"groupCertificatePrice"}},{"kind":"Field","name":{"kind":"Name","value":"groupTax"}},{"kind":"Field","name":{"kind":"Name","value":"groupTotalToPay"}},{"kind":"Field","name":{"kind":"Name","value":"isGroupPay"}},{"kind":"Field","name":{"kind":"Name","value":"couponeDiscount"}}]}}]}}]}}]} as unknown as DocumentNode<AddBookingMutation, AddBookingMutationVariables>;
export const AddHowHeardAboutEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddHowHeardAboutEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"addHowHeardAboutEventInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addHowHeardAboutEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<AddHowHeardAboutEventMutation, AddHowHeardAboutEventMutationVariables>;
export const AddRemindMeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddRemindMe"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemindMeInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AddRemindMe"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<AddRemindMeMutation, AddRemindMeMutationVariables>;
export const ApplyCouponToBookingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApplyCouponToBooking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ApplyCouponToBookingInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ApplyCouponToBooking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<ApplyCouponToBookingMutation, ApplyCouponToBookingMutationVariables>;
export const BuyCertificateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BuyCertificate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TraineeEventUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TraineeEventWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyCertificate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<BuyCertificateMutation, BuyCertificateMutationVariables>;
export const FindManyHowHeardAboutEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindManyHowHeardAboutEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyHowHeardAboutEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}}]} as unknown as DocumentNode<FindManyHowHeardAboutEventQuery, FindManyHowHeardAboutEventQueryVariables>;
export const FreeBookingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FreeBooking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"freeBookingInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"freeBooking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isPaid"}},{"kind":"Field","name":{"kind":"Name","value":"eventName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"reference_number"}},{"kind":"Field","name":{"kind":"Name","value":"amount_format"}},{"kind":"Field","name":{"kind":"Name","value":"fee_format"}}]}}]}}]} as unknown as DocumentNode<FreeBookingMutation, FreeBookingMutationVariables>;
export const GetBookingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBooking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"getBookingInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getBooking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"traineeEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"totalToPay"}},{"kind":"Field","name":{"kind":"Name","value":"isLateRegistrant"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkshopRegistrant"}},{"kind":"Field","name":{"kind":"Name","value":"isGroupRegistrant"}},{"kind":"Field","name":{"kind":"Name","value":"certificatePrice"}},{"kind":"Field","name":{"kind":"Name","value":"workshopPrice"}},{"kind":"Field","name":{"kind":"Name","value":"walletBalance"}},{"kind":"Field","name":{"kind":"Name","value":"bookingStatusId"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"eventTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventDays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}},{"kind":"Field","name":{"kind":"Name","value":"brotherId"}},{"kind":"Field","name":{"kind":"Name","value":"brother"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}},{"kind":"Field","name":{"kind":"Name","value":"brotherId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"siblings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}},{"kind":"Field","name":{"kind":"Name","value":"brotherId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trainerLessons"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"methodOfDeliveryId"}},{"kind":"Field","name":{"kind":"Name","value":"methodOfDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardFee"}},{"kind":"Field","name":{"kind":"Name","value":"hasWorkshop"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlanTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventMediaTracking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"traineeId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"eventMediaTracking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"traineeId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"parts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventPart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventPartId"}},{"kind":"Field","name":{"kind":"Name","value":"partTotalPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"couponeDiscount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"traineeEventGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupPrice"}},{"kind":"Field","name":{"kind":"Name","value":"groupWalletBalance"}},{"kind":"Field","name":{"kind":"Name","value":"groupWorkshopPrice"}},{"kind":"Field","name":{"kind":"Name","value":"groupCertificatePrice"}},{"kind":"Field","name":{"kind":"Name","value":"groupTax"}},{"kind":"Field","name":{"kind":"Name","value":"groupTotalToPay"}},{"kind":"Field","name":{"kind":"Name","value":"isGroupPay"}},{"kind":"Field","name":{"kind":"Name","value":"couponeDiscount"}}]}}]}}]}}]} as unknown as DocumentNode<GetBookingQuery, GetBookingQueryVariables>;
export const GetBookingEventIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBookingEventId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"getBookingInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getBooking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"traineeEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trainee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"defaultLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBookingEventIdQuery, GetBookingEventIdQueryVariables>;
export const GetWalletTransitionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWalletTransition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"getWalletInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getWalletTransition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isPaid"}},{"kind":"Field","name":{"kind":"Name","value":"eventName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"reference_number"}},{"kind":"Field","name":{"kind":"Name","value":"amount_format"}},{"kind":"Field","name":{"kind":"Name","value":"fee_format"}}]}}]}}]} as unknown as DocumentNode<GetWalletTransitionQuery, GetWalletTransitionQueryVariables>;
export const HasBookingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HasBooking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TraineeEventWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueTraineeEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bookingStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<HasBookingQuery, HasBookingQueryVariables>;
export const InitiateBookingTransitionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InitiateBookingTransition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InitiateBookingTransitionInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"InitiateBookingTransition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"paymentWay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"fullAmount"}},{"kind":"Field","name":{"kind":"Name","value":"transitionPurpose"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}}]}}]}}]} as unknown as DocumentNode<InitiateBookingTransitionMutation, InitiateBookingTransitionMutationVariables>;
export const MoyasarInitiateTransitionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MoyasarInitiateTransition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"moyasarInitiateTransition"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"moyasarInitiateTransition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<MoyasarInitiateTransitionMutation, MoyasarInitiateTransitionMutationVariables>;
export const PayWithWalletDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PayWithWallet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"walletTransition"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payWithWallet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transition"}},{"kind":"Field","name":{"kind":"Name","value":"traineeEventId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<PayWithWalletMutation, PayWithWalletMutationVariables>;
export const UpdateBookingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateBooking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"updateBookingInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UpdateBooking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"traineeEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"totalToPay"}},{"kind":"Field","name":{"kind":"Name","value":"isLateRegistrant"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkshopRegistrant"}},{"kind":"Field","name":{"kind":"Name","value":"isGroupRegistrant"}},{"kind":"Field","name":{"kind":"Name","value":"certificatePrice"}},{"kind":"Field","name":{"kind":"Name","value":"workshopPrice"}},{"kind":"Field","name":{"kind":"Name","value":"walletBalance"}},{"kind":"Field","name":{"kind":"Name","value":"bookingStatusId"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateBookingMutation, UpdateBookingMutationVariables>;
export const GetCoursePriceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCoursePrice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCoursePrice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"eventTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"defaultLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardFee"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlanTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"freePlanCertificateStatus"}},{"kind":"Field","name":{"kind":"Name","value":"hasDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"discountPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"hasDiscountEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"discountEndDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAccredited"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventDays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trainerLessons"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"methodOfDeliveryId"}},{"kind":"Field","name":{"kind":"Name","value":"methodOfDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"traineeEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trainee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"totalToPay"}},{"kind":"Field","name":{"kind":"Name","value":"walletBalance"}},{"kind":"Field","name":{"kind":"Name","value":"isLateRegistrant"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkshopRegistrant"}},{"kind":"Field","name":{"kind":"Name","value":"isGroupRegistrant"}},{"kind":"Field","name":{"kind":"Name","value":"certificatePrice"}},{"kind":"Field","name":{"kind":"Name","value":"workshopPrice"}},{"kind":"Field","name":{"kind":"Name","value":"parts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventPartId"}},{"kind":"Field","name":{"kind":"Name","value":"partTotalPrice"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"IsProfessionCompatable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"IsProfessionCompatable"}}]}},{"kind":"Field","name":{"kind":"Name","value":"traineeEventGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupWorkshopPrice"}},{"kind":"Field","name":{"kind":"Name","value":"groupWalletBalance"}},{"kind":"Field","name":{"kind":"Name","value":"groupTotalToPay"}},{"kind":"Field","name":{"kind":"Name","value":"groupTax"}},{"kind":"Field","name":{"kind":"Name","value":"groupPrice"}},{"kind":"Field","name":{"kind":"Name","value":"groupCertificatePrice"}},{"kind":"Field","name":{"kind":"Name","value":"areWorkshopRegistrants"}},{"kind":"Field","name":{"kind":"Name","value":"areLateRegistrants"}},{"kind":"Field","name":{"kind":"Name","value":"isGroupPay"}},{"kind":"Field","name":{"kind":"Name","value":"traineeEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"totalToPay"}},{"kind":"Field","name":{"kind":"Name","value":"walletBalance"}},{"kind":"Field","name":{"kind":"Name","value":"isLateRegistrant"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkshopRegistrant"}},{"kind":"Field","name":{"kind":"Name","value":"isGroupRegistrant"}},{"kind":"Field","name":{"kind":"Name","value":"certificatePrice"}},{"kind":"Field","name":{"kind":"Name","value":"workshopPrice"}},{"kind":"Field","name":{"kind":"Name","value":"parts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventPartId"}},{"kind":"Field","name":{"kind":"Name","value":"partTotalPrice"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"seatsError"}},{"kind":"Field","name":{"kind":"Name","value":"seatsErrorArray"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventDayId"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]}}]} as unknown as DocumentNode<GetCoursePriceQuery, GetCoursePriceQueryVariables>;
export const CoursesPathsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CoursesPaths"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CoursesPaths"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CoursesPathsQuery, CoursesPathsQueryVariables>;
export const EventDetailsOutputDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventDetailsOutput"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventDetailsOutputId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"EventDetailsOutput"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventDetailsOutputId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"methodOfDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"defaultLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Quiz"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"QuizQuestion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"questionEn"}},{"kind":"Field","name":{"kind":"Name","value":"questionType"}},{"kind":"Field","name":{"kind":"Name","value":"questionAr"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"questionOrder"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"rightAnswer"}},{"kind":"Field","name":{"kind":"Name","value":"QuizQuestionAnswer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answerAr"}},{"kind":"Field","name":{"kind":"Name","value":"answerEn"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discussionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"timeTableStatus"}},{"kind":"Field","name":{"kind":"Name","value":"Discussion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"User"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"packageEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"introductionAr"}},{"kind":"Field","name":{"kind":"Name","value":"introductionEn"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescriptionAr"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescriptionEn"}},{"kind":"Field","name":{"kind":"Name","value":"isAccredited"}},{"kind":"Field","name":{"kind":"Name","value":"isAccreditedSHA"}},{"kind":"Field","name":{"kind":"Name","value":"cmeHours"}},{"kind":"Field","name":{"kind":"Name","value":"methodOfDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isTraineeCertificateAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventLanguages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"backgroundImagesUrls"}},{"kind":"Field","name":{"kind":"Name","value":"keywordsAr"}},{"kind":"Field","name":{"kind":"Name","value":"keywordsEn"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionAr"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEn"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressInstructions"}},{"kind":"Field","name":{"kind":"Name","value":"locationLatitude"}},{"kind":"Field","name":{"kind":"Name","value":"locationLongitude"}},{"kind":"Field","name":{"kind":"Name","value":"youtubeUrl"}},{"kind":"Field","name":{"kind":"Name","value":"introductionAr"}},{"kind":"Field","name":{"kind":"Name","value":"introductionEn"}},{"kind":"Field","name":{"kind":"Name","value":"objectivesAr"}},{"kind":"Field","name":{"kind":"Name","value":"objectivesEn"}},{"kind":"Field","name":{"kind":"Name","value":"mainThemeAr"}},{"kind":"Field","name":{"kind":"Name","value":"mainThemeEn"}},{"kind":"Field","name":{"kind":"Name","value":"outcomesAr"}},{"kind":"Field","name":{"kind":"Name","value":"outcomesEn"}},{"kind":"Field","name":{"kind":"Name","value":"cmeNumber"}},{"kind":"Field","name":{"kind":"Name","value":"whyTargetedAudienceAr"}},{"kind":"Field","name":{"kind":"Name","value":"whyTargetedAudienceEn"}},{"kind":"Field","name":{"kind":"Name","value":"isTraineeCertificateAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"folder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetedAudiences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetedSpecialities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAllProfessionsTargeted"}},{"kind":"Field","name":{"kind":"Name","value":"isSponsored"}},{"kind":"Field","name":{"kind":"Name","value":"sponsorshipImagesUrls"}},{"kind":"Field","name":{"kind":"Name","value":"cmeHours"}},{"kind":"Field","name":{"kind":"Name","value":"isAccredited"}},{"kind":"Field","name":{"kind":"Name","value":"isAccreditedSHA"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shortDescriptionAr"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescriptionEn"}},{"kind":"Field","name":{"kind":"Name","value":"eventDays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"methodOfDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerLessons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"TrainerEventDayLessonType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"methodOfTeaching"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasMultiPartDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"multiPartDiscountPrice"}},{"kind":"Field","name":{"kind":"Name","value":"hasGroupDiscountEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"freePlanCertificateCmeIsPaid"}},{"kind":"Field","name":{"kind":"Name","value":"freePlanCertificateStatus"}},{"kind":"Field","name":{"kind":"Name","value":"hasWorkshop"}},{"kind":"Field","name":{"kind":"Name","value":"groupDiscountEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"groupDiscountMinNumberOfRegistrants"}},{"kind":"Field","name":{"kind":"Name","value":"groupDiscountPrice"}},{"kind":"Field","name":{"kind":"Name","value":"hasGroupDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"hasDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"discountPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"hasDiscountEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"discountEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"hasLateRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"lateRegistrationStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlanType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventParts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasWorkshop"}},{"kind":"Field","name":{"kind":"Name","value":"groupDiscountEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"groupDiscountMinNumberOfRegistrants"}},{"kind":"Field","name":{"kind":"Name","value":"groupDiscountPrice"}},{"kind":"Field","name":{"kind":"Name","value":"hasGroupDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlanType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventDays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"trainerLessons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"TrainerEventDayLessonType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"methodOfTeaching"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventLanguages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trainer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"profession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"traineeEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bookingStatusId"}},{"kind":"Field","name":{"kind":"Name","value":"trainee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EventDetailsOutputQuery, EventDetailsOutputQueryVariables>;
export const ListCoursesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListCourses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EventWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listCourses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"cmeHours"}},{"kind":"Field","name":{"kind":"Name","value":"isAccredited"}},{"kind":"Field","name":{"kind":"Name","value":"isAccreditedSHA"}},{"kind":"Field","name":{"kind":"Name","value":"methodOfDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescriptionAr"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescriptionEn"}},{"kind":"Field","name":{"kind":"Name","value":"defaultLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"eventTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"discountPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"hasDiscountEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"discountEndDate"}}]}}]}}]}}]} as unknown as DocumentNode<ListCoursesQuery, ListCoursesQueryVariables>;
export const FindHeroImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindHeroImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findHeroImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<FindHeroImagesQuery, FindHeroImagesQueryVariables>;
export const FindNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationFindManyInputType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyNotification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"read"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<FindNotificationQuery, FindNotificationQueryVariables>;
export const ReadNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReadNotification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"readNotification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<ReadNotificationMutation, ReadNotificationMutationVariables>;
export const AddEducationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddEducation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"addEducationInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addEducation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"university"}},{"kind":"Field","name":{"kind":"Name","value":"profession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"graduationYear"}}]}}]}}]} as unknown as DocumentNode<AddEducationMutation, AddEducationMutationVariables>;
export const AddProfessionalSkillDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddProfessionalSkill"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"addProfessionalSkillInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AddProfessionalSkill"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"yearsOfExperience"}},{"kind":"Field","name":{"kind":"Name","value":"academicRank"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"placeOfWork"}},{"kind":"Field","name":{"kind":"Name","value":"natureOfWork"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<AddProfessionalSkillMutation, AddProfessionalSkillMutationVariables>;
export const AddScientificResearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddScientificResearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"addScientificResearchInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AddScientificResearch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]} as unknown as DocumentNode<AddScientificResearchMutation, AddScientificResearchMutationVariables>;
export const AddTrainingExperienceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddTrainingExperience"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"addTrainingExperienceInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AddTrainingExperience"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventName"}},{"kind":"Field","name":{"kind":"Name","value":"executingAgency"}}]}}]}}]} as unknown as DocumentNode<AddTrainingExperienceMutation, AddTrainingExperienceMutationVariables>;
export const AddBecomeTrainerApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddBecomeTrainerApplication"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneBecomeTrainerApplication"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AddBecomeTrainerApplicationMutation, AddBecomeTrainerApplicationMutationVariables>;
export const FindManyAcademicRankDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindManyAcademicRank"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyAcademicRank"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}}]} as unknown as DocumentNode<FindManyAcademicRankQuery, FindManyAcademicRankQueryVariables>;
export const FindProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"linkedIn"}},{"kind":"Field","name":{"kind":"Name","value":"twitter"}},{"kind":"Field","name":{"kind":"Name","value":"identityNo"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"commercialRecord"}},{"kind":"Field","name":{"kind":"Name","value":"nameOnCommercialRecord"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"fcmToken"}},{"kind":"Field","name":{"kind":"Name","value":"mobileNumber"}},{"kind":"Field","name":{"kind":"Name","value":"cv"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"nationality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Qualification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scfhs"}},{"kind":"Field","name":{"kind":"Name","value":"scfhsExp"}},{"kind":"Field","name":{"kind":"Name","value":"trainerCv"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"education"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"university"}},{"kind":"Field","name":{"kind":"Name","value":"profession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"graduationYear"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rank"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professionalSkills"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"yearsOfExperience"}},{"kind":"Field","name":{"kind":"Name","value":"academicRank"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"placeOfWork"}},{"kind":"Field","name":{"kind":"Name","value":"natureOfWork"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainingExperience"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventName"}},{"kind":"Field","name":{"kind":"Name","value":"executingAgency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scientificResearches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inviter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"bankAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountHolderName"}},{"kind":"Field","name":{"kind":"Name","value":"bankName"}},{"kind":"Field","name":{"kind":"Name","value":"iban"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberNeeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"traineeEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Certificate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isEligible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bookingStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescriptionAr"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescriptionEn"}},{"kind":"Field","name":{"kind":"Name","value":"defaultLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"isTraineeCertificateAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"isTrainerCertificateAvailable"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FindProfileQuery, FindProfileQueryVariables>;
export const FindBasicInfoProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindBasicInfoProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"fcmToken"}},{"kind":"Field","name":{"kind":"Name","value":"mobileNumber"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"nationality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerCv"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"qualification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rank"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Qualification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scfhs"}}]}}]}}]} as unknown as DocumentNode<FindBasicInfoProfileQuery, FindBasicInfoProfileQueryVariables>;
export const GetCertificateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCertificate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"traineeEventId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trainerEventId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"certificateId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCertificate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"traineeEventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"traineeEventId"}}},{"kind":"Argument","name":{"kind":"Name","value":"trainerEventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trainerEventId"}}},{"kind":"Argument","name":{"kind":"Name","value":"certificateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"certificateId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"traineeId"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"cmeHours"}},{"kind":"Field","name":{"kind":"Name","value":"cmeNumber"}},{"kind":"Field","name":{"kind":"Name","value":"eventDays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}},{"kind":"Field","name":{"kind":"Name","value":"isEligible"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"traineeEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"review"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCertificateQuery, GetCertificateQueryVariables>;
export const RemoveEducationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveEducation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"removeEducationInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeEducation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"university"}},{"kind":"Field","name":{"kind":"Name","value":"profession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"graduationYear"}}]}}]}}]} as unknown as DocumentNode<RemoveEducationMutation, RemoveEducationMutationVariables>;
export const RemoveProfessionalSkillDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveProfessionalSkill"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"removeProfessionalSkillInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeProfessionalSkill"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"yearsOfExperience"}},{"kind":"Field","name":{"kind":"Name","value":"academicRank"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"placeOfWork"}},{"kind":"Field","name":{"kind":"Name","value":"natureOfWork"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<RemoveProfessionalSkillMutation, RemoveProfessionalSkillMutationVariables>;
export const RemoveScientificResearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveScientificResearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"removeScientificResearchInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeScientificResearch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]} as unknown as DocumentNode<RemoveScientificResearchMutation, RemoveScientificResearchMutationVariables>;
export const RemoveTrainingExperienceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveTrainingExperience"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"removeTrainingExperienceInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeTrainingExperience"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventName"}},{"kind":"Field","name":{"kind":"Name","value":"executingAgency"}}]}}]}}]} as unknown as DocumentNode<RemoveTrainingExperienceMutation, RemoveTrainingExperienceMutationVariables>;
export const UpdateCvDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCv"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"updateCvInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCv"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rank"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCvMutation, UpdateCvMutationVariables>;
export const UpdateBankAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateBankAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"updateBankAccountInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBankAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountHolderName"}},{"kind":"Field","name":{"kind":"Name","value":"bankName"}},{"kind":"Field","name":{"kind":"Name","value":"iban"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateBankAccountMutation, UpdateBankAccountMutationVariables>;
export const UpdateProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"linkedIn"}},{"kind":"Field","name":{"kind":"Name","value":"twitter"}},{"kind":"Field","name":{"kind":"Name","value":"identityNo"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"commercialRecord"}},{"kind":"Field","name":{"kind":"Name","value":"nameOnCommercialRecord"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"mobileNumber"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"cv"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"nationality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Qualification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scfhs"}},{"kind":"Field","name":{"kind":"Name","value":"scfhsExp"}},{"kind":"Field","name":{"kind":"Name","value":"trainerCv"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"education"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"university"}},{"kind":"Field","name":{"kind":"Name","value":"profession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"graduationYear"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rank"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professionalSkills"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"yearsOfExperience"}},{"kind":"Field","name":{"kind":"Name","value":"academicRank"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"placeOfWork"}},{"kind":"Field","name":{"kind":"Name","value":"natureOfWork"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainingExperience"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventName"}},{"kind":"Field","name":{"kind":"Name","value":"executingAgency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scientificResearches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inviter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"bankAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountHolderName"}},{"kind":"Field","name":{"kind":"Name","value":"bankName"}},{"kind":"Field","name":{"kind":"Name","value":"iban"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const AddReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReviewInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AddReview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<AddReviewMutation, AddReviewMutationVariables>;
export const FindReviewChoicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindReviewChoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyTraineeEventReviewChoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isGood"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"findManyTraineeTrainerReviewChoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isGood"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}}]} as unknown as DocumentNode<FindReviewChoicesQuery, FindReviewChoicesQueryVariables>;
export const FindReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"findReviewInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findReview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TraineeEventReview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reviewOfFive"}},{"kind":"Field","name":{"kind":"Name","value":"traineeEventReviewChoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"why"}}]}},{"kind":"Field","name":{"kind":"Name","value":"TraineeTrainerReview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reviewOfFive"}},{"kind":"Field","name":{"kind":"Name","value":"why"}},{"kind":"Field","name":{"kind":"Name","value":"choices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerEventId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"trainerEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trainer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FindReviewQuery, FindReviewQueryVariables>;
export const FindBasicInfoUniqueTraineeEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindBasicInfoUniqueTraineeEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TraineeEventWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueTraineeEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trainee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrantToken"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"ZoomMeeting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"joinUrl"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isProcessed"}},{"kind":"Field","name":{"kind":"Name","value":"isStarted"}},{"kind":"Field","name":{"kind":"Name","value":"meetingId"}},{"kind":"Field","name":{"kind":"Name","value":"password"}},{"kind":"Field","name":{"kind":"Name","value":"startUrl"}},{"kind":"Field","name":{"kind":"Name","value":"registrationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"startDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"endDateTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addressInstructions"}},{"kind":"Field","name":{"kind":"Name","value":"eventParts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"eventDays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventDays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventTypeId"}}]}}]}}]}}]} as unknown as DocumentNode<FindBasicInfoUniqueTraineeEventQuery, FindBasicInfoUniqueTraineeEventQueryVariables>;
export const FindInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TraineeEventWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueTraineeEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trainee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"mobileNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrantToken"}},{"kind":"Field","name":{"kind":"Name","value":"Certificate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}},{"kind":"Field","name":{"kind":"Name","value":"isEligible"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"traineeEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescriptionAr"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescriptionEn"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"locationLongitude"}},{"kind":"Field","name":{"kind":"Name","value":"locationLatitude"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressInstructions"}},{"kind":"Field","name":{"kind":"Name","value":"cityId"}},{"kind":"Field","name":{"kind":"Name","value":"defaultLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"ZoomMeeting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"joinUrl"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isProcessed"}},{"kind":"Field","name":{"kind":"Name","value":"isStarted"}},{"kind":"Field","name":{"kind":"Name","value":"meetingId"}},{"kind":"Field","name":{"kind":"Name","value":"password"}},{"kind":"Field","name":{"kind":"Name","value":"startUrl"}},{"kind":"Field","name":{"kind":"Name","value":"registrationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"startDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"endDateTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Quiz"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"QuizQuestion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"questionEn"}},{"kind":"Field","name":{"kind":"Name","value":"questionType"}},{"kind":"Field","name":{"kind":"Name","value":"questionAr"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"questionOrder"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"rightAnswer"}},{"kind":"Field","name":{"kind":"Name","value":"QuizQuestionAnswer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answerAr"}},{"kind":"Field","name":{"kind":"Name","value":"answerEn"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"freePlanCertificateStatus"}},{"kind":"Field","name":{"kind":"Name","value":"freePlanCertificateCmePrice"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlanTypeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"methodOfDeliveryId"}},{"kind":"Field","name":{"kind":"Name","value":"eventDays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"zoomMeetings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"joinUrl"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"meetingId"}},{"kind":"Field","name":{"kind":"Name","value":"password"}},{"kind":"Field","name":{"kind":"Name","value":"startUrl"}},{"kind":"Field","name":{"kind":"Name","value":"registrationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"startDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"endDateTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerLessons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"methodOfTeachingTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"trainerEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trainer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerEventStudyMaterials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"media"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"trainerEventStudyMaterialGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"packageEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"packageId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"workshopPrice"}},{"kind":"Field","name":{"kind":"Name","value":"certificatePrice"}},{"kind":"Field","name":{"kind":"Name","value":"parts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"partTotalPrice"}},{"kind":"Field","name":{"kind":"Name","value":"eventPart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlanTypeId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalToPay"}},{"kind":"Field","name":{"kind":"Name","value":"isLateRegistrant"}},{"kind":"Field","name":{"kind":"Name","value":"isGroupRegistrant"}},{"kind":"Field","name":{"kind":"Name","value":"methodOfDeliveryId"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkshopRegistrant"}},{"kind":"Field","name":{"kind":"Name","value":"isIndividualPay"}},{"kind":"Field","name":{"kind":"Name","value":"hasBookedAllParts"}},{"kind":"Field","name":{"kind":"Name","value":"couponeDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupCertificatePrice"}},{"kind":"Field","name":{"kind":"Name","value":"groupPrice"}},{"kind":"Field","name":{"kind":"Name","value":"groupTax"}},{"kind":"Field","name":{"kind":"Name","value":"groupTotalToPay"}},{"kind":"Field","name":{"kind":"Name","value":"traineeEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trainee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"groupTransactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mediator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentWay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"fullAmount"}},{"kind":"Field","name":{"kind":"Name","value":"transitionPurpose"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bookingStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transitions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mediator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentWay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"fullAmount"}},{"kind":"Field","name":{"kind":"Name","value":"transitionPurpose"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FindInvoiceQuery, FindInvoiceQueryVariables>;
export const AddContactUsDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddContactUsData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"addContactUsDataType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AddContactUsData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<AddContactUsDataMutation, AddContactUsDataMutationVariables>;
export const FindManyContactUsDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindManyContactUsData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactUsDataWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactUsDataOrderByWithRelationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyContactUsData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"attachment"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<FindManyContactUsDataQuery, FindManyContactUsDataQueryVariables>;
export const RemoveContactUsDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveContactUsData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"removeContactUsDataType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeContactUsData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<RemoveContactUsDataMutation, RemoveContactUsDataMutationVariables>;
export const UpdateContactUsDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateContactUsData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"updateContactUsDataType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UpdateContactUsData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<UpdateContactUsDataMutation, UpdateContactUsDataMutationVariables>;
export const CreateOneCouponDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOneCoupon"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CouponCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneCoupon"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateOneCouponMutation, CreateOneCouponMutationVariables>;
export const DeleteOneCouponDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneCoupon"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CouponWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneCoupon"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteOneCouponMutation, DeleteOneCouponMutationVariables>;
export const FindManyCouponDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindManyCoupon"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CouponWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyCoupon"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"professions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expiryDate"}},{"kind":"Field","name":{"kind":"Name","value":"couponType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiryDate"}},{"kind":"Field","name":{"kind":"Name","value":"percentageDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmountDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"isForAllEvents"}},{"kind":"Field","name":{"kind":"Name","value":"isForAllSpecialties"}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inviterId"}},{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TraineeEvent"}}]}}]}}]}}]} as unknown as DocumentNode<FindManyCouponQuery, FindManyCouponQueryVariables>;
export const UpdateOneCouponDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOneCoupon"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CouponUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CouponWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneCoupon"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateOneCouponMutation, UpdateOneCouponMutationVariables>;
export const FindManyEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindManyEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"emailWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"locationLatitude"}},{"kind":"Field","name":{"kind":"Name","value":"locationLongitude"}},{"kind":"Field","name":{"kind":"Name","value":"cmeHours"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressInstructions"}},{"kind":"Field","name":{"kind":"Name","value":"methodOfDeliveryId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"listEmailOutput"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bookingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"method"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"template_key"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"template_alias"}},{"kind":"Field","name":{"kind":"Name","value":"html"}}]}},{"kind":"Field","name":{"kind":"Name","value":"method"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shouldShowEmailMsg"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"emailState"}},{"kind":"Field","name":{"kind":"Name","value":"zoomLink"}},{"kind":"Field","name":{"kind":"Name","value":"bookingId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"qrImage"}},{"kind":"Field","name":{"kind":"Name","value":"zohoEmail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clicked"}},{"kind":"Field","name":{"kind":"Name","value":"opened"}},{"kind":"Field","name":{"kind":"Name","value":"sent"}},{"kind":"Field","name":{"kind":"Name","value":"softBounce"}},{"kind":"Field","name":{"kind":"Name","value":"hardBounce"}},{"kind":"Field","name":{"kind":"Name","value":"htmlData"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"request_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Certificate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FindManyEmailQuery, FindManyEmailQueryVariables>;
export const GetCertificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCertification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"getCertInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCertification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"traineeEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trainee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trainerEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trainer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"cmeHours"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"cmeNumber"}},{"kind":"Field","name":{"kind":"Name","value":"eventDays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"traineeCertificate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerCertificate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]}}]}}]} as unknown as DocumentNode<GetCertificationQuery, GetCertificationQueryVariables>;
export const ResendCertificateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResendCertificate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"resendCertificateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resendCertificate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}]}]}}]} as unknown as DocumentNode<ResendCertificateMutation, ResendCertificateMutationVariables>;
export const CreateOneDiscussionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOneDiscussion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DiscussionCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneDiscussion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"User"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"User"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Replies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"User"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateOneDiscussionMutation, CreateOneDiscussionMutationVariables>;
export const CancelEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eventIdInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CancelEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CancelEventMutation, CancelEventMutationVariables>;
export const DeleteEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eventIdInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteEventMutation, DeleteEventMutationVariables>;
export const EmergancyNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EmergancyNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"emergancyNotificationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"EmergancyNotification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<EmergancyNotificationMutation, EmergancyNotificationMutationVariables>;
export const EventStopRegistrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EventStopRegistration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eventStopInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventStopRegistration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isRegistraionClosed"}}]}}]}}]} as unknown as DocumentNode<EventStopRegistrationMutation, EventStopRegistrationMutationVariables>;
export const IsRegistraionClosedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IsRegistraionClosed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isRegistraionClosed"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<IsRegistraionClosedQuery, IsRegistraionClosedQueryVariables>;
export const RemindMeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemindMe"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemindInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"remindMe"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<RemindMeMutation, RemindMeMutationVariables>;
export const CalendarQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CalendarQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EventDayWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"folderId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"IntValue","value":"2"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"cmeHours"}},{"kind":"Field","name":{"kind":"Name","value":"cmeNumber"}},{"kind":"Field","name":{"kind":"Name","value":"eventDays"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trainer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CalendarQueryQuery, CalendarQueryQueryVariables>;
export const EventAttendanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventAttendance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"traineeEventsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TraineeEventWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventDaysWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EventDayWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"freePlanCertificateStatus"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlanTypeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventDays"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventDaysWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"zoomDuration"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"traineeEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"traineeEventsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bookingStatusId"}},{"kind":"Field","name":{"kind":"Name","value":"certificatePrice"}},{"kind":"Field","name":{"kind":"Name","value":"trainee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"scfhs"}},{"kind":"Field","name":{"kind":"Name","value":"mobileNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"profession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"attendance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventDayId"}},{"kind":"Field","name":{"kind":"Name","value":"joinTime"}},{"kind":"Field","name":{"kind":"Name","value":"leaveTime"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"traineeEventStudyMaterialAttendance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trainerEventStudyMaterialId"}},{"kind":"Field","name":{"kind":"Name","value":"progressPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"trainerEventStudyMaterial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"media"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Certificate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerEventStudyMaterialGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"StudyMaterials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"media"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"traineeEventStudyMaterialAttendance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"progressPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"trainerEventStudyMaterialId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trainer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"mobileNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"scfhs"}},{"kind":"Field","name":{"kind":"Name","value":"profession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Certificate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EventAttendanceQuery, EventAttendanceQueryVariables>;
export const UpdateEventDraftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEventDraft"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"discussionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"timeTableStatus"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cmeHours"}},{"kind":"Field","name":{"kind":"Name","value":"cmeNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isAccredited"}},{"kind":"Field","name":{"kind":"Name","value":"isAccreditedSHA"}},{"kind":"Field","name":{"kind":"Name","value":"hideVideoProgress"}},{"kind":"Field","name":{"kind":"Name","value":"zoomMode"}},{"kind":"Field","name":{"kind":"Name","value":"isContentProvidedByAcademy"}},{"kind":"Field","name":{"kind":"Name","value":"isTraineeCertificateAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"isTrainerCertificateAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"methodOfDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"traineeCertificateTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerCertificateTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"minAttendancePercentageToGetCertificate"}},{"kind":"Field","name":{"kind":"Name","value":"leaderTrainer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TrainerFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onsiteCapacity"}},{"kind":"Field","name":{"kind":"Name","value":"onlineCapacity"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressInstructions"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationLatitude"}},{"kind":"Field","name":{"kind":"Name","value":"locationLongitude"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundImagesUrls"}},{"kind":"Field","name":{"kind":"Name","value":"sponsorshipImagesUrls"}},{"kind":"Field","name":{"kind":"Name","value":"isSponsored"}},{"kind":"Field","name":{"kind":"Name","value":"keywordsAr"}},{"kind":"Field","name":{"kind":"Name","value":"keywordsEn"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionAr"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEn"}},{"kind":"Field","name":{"kind":"Name","value":"defaultLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"visibleOnArchive"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PricingPlanFragment"}},{"kind":"Field","name":{"kind":"Name","value":"hasMultiPartDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"multiPartDiscountPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventParts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PricingPlanFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlanId"}},{"kind":"Field","name":{"kind":"Name","value":"eventDays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventDays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"trainerTimeSlots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"trainerEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trainer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"specialty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}}]}}]}}]}},...TrainerFragmentFragmentDoc.definitions,...PricingPlanFragmentFragmentDoc.definitions]} as unknown as DocumentNode<UpdateEventDraftMutation, UpdateEventDraftMutationVariables>;
export const CreateEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isTrainerCertificateAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"trainerCertificateTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isTraineeCertificateAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"traineeCertificateTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"minAttendancePercentageToGetCertificate"}},{"kind":"Field","name":{"kind":"Name","value":"leaderTrainer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TrainerFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onsiteCapacity"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressInstructions"}},{"kind":"Field","name":{"kind":"Name","value":"addressAr"}},{"kind":"Field","name":{"kind":"Name","value":"addressInstructionsAr"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationLongitude"}},{"kind":"Field","name":{"kind":"Name","value":"locationLatitude"}},{"kind":"Field","name":{"kind":"Name","value":"onlineCapacity"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundImagesUrls"}},{"kind":"Field","name":{"kind":"Name","value":"sponsorshipImagesUrls"}},{"kind":"Field","name":{"kind":"Name","value":"isSponsored"}},{"kind":"Field","name":{"kind":"Name","value":"hideVideoProgress"}},{"kind":"Field","name":{"kind":"Name","value":"keywordsAr"}},{"kind":"Field","name":{"kind":"Name","value":"keywordsEn"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionAr"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEn"}},{"kind":"Field","name":{"kind":"Name","value":"defaultLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"cmeHours"}},{"kind":"Field","name":{"kind":"Name","value":"cmeNumber"}},{"kind":"Field","name":{"kind":"Name","value":"folder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coupons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PricingPlanFragment"}},{"kind":"Field","name":{"kind":"Name","value":"hasMultiPartDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"multiPartDiscountPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isContentProvidedByAcademy"}}]}}]}},...TrainerFragmentFragmentDoc.definitions,...PricingPlanFragmentFragmentDoc.definitions]} as unknown as DocumentNode<CreateEventMutation, CreateEventMutationVariables>;
export const FindEventBasicInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindEventBasicInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"folder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasGroupDiscount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventDays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"traineeEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"traineeId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"IntValue","value":"5"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"traineeId"}},{"kind":"Field","name":{"kind":"Name","value":"trainee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Quiz"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"QuizQuestion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"questionEn"}},{"kind":"Field","name":{"kind":"Name","value":"questionType"}},{"kind":"Field","name":{"kind":"Name","value":"questionAr"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"questionOrder"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"rightAnswer"}},{"kind":"Field","name":{"kind":"Name","value":"QuizQuestionAnswer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answerAr"}},{"kind":"Field","name":{"kind":"Name","value":"answerEn"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FindEventBasicInfoQuery, FindEventBasicInfoQueryVariables>;
export const FindEventContentAddedByTrainersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindEventContentAddedByTrainers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trainerEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentIsAdded"}},{"kind":"Field","name":{"kind":"Name","value":"introductionAr"}},{"kind":"Field","name":{"kind":"Name","value":"targetedAudiences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetedSpecialities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAllProfessionsTargeted"}},{"kind":"Field","name":{"kind":"Name","value":"objectivesAr"}},{"kind":"Field","name":{"kind":"Name","value":"objectivesEn"}},{"kind":"Field","name":{"kind":"Name","value":"mainThemeEn"}},{"kind":"Field","name":{"kind":"Name","value":"mainThemeAr"}},{"kind":"Field","name":{"kind":"Name","value":"outcomesEn"}},{"kind":"Field","name":{"kind":"Name","value":"outcomesAr"}},{"kind":"Field","name":{"kind":"Name","value":"whyTargetedAudienceAr"}},{"kind":"Field","name":{"kind":"Name","value":"whyTargetedAudienceEn"}},{"kind":"Field","name":{"kind":"Name","value":"youtubeUrl"}},{"kind":"Field","name":{"kind":"Name","value":"introductionEn"}},{"kind":"Field","name":{"kind":"Name","value":"trainer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"specialty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}}]}}]}}]} as unknown as DocumentNode<FindEventContentAddedByTrainersQuery, FindEventContentAddedByTrainersQueryVariables>;
export const FindManyEventDayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindManyEventDay"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventDayWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyEventDay"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"attendanceHours"}},{"kind":"Field","name":{"kind":"Name","value":"brother"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"siblings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"methodOfDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zoomMeetings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"endDateTime"}}]}}]}}]}}]} as unknown as DocumentNode<FindManyEventDayQuery, FindManyEventDayQueryVariables>;
export const FindOneEventDayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindOneEventDay"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventDayWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueEventDay"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"attendanceHours"}},{"kind":"Field","name":{"kind":"Name","value":"methodOfDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zoomMeetings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"endDateTime"}}]}}]}}]}}]} as unknown as DocumentNode<FindOneEventDayQuery, FindOneEventDayQueryVariables>;
export const FindUniqueEventContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindUniqueEventContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trainerEventsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TrainerEventWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"ZoomMeeting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"meetingId"}},{"kind":"Field","name":{"kind":"Name","value":"joinUrl"}},{"kind":"Field","name":{"kind":"Name","value":"startUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"eventTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"eventLanguages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trainerEventsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TrainerEventFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"methodOfDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventDays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"attendanceHours"}},{"kind":"Field","name":{"kind":"Name","value":"methodOfDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerLessons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"TrainerEventDayLessonType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TrainerEventFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerTimeSlots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"trainerEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TrainerEventFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zoomMeetings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"endDateTime"}}]}}]}}]}}]}},...TrainerEventFragmentFragmentDoc.definitions]} as unknown as DocumentNode<FindUniqueEventContentQuery, FindUniqueEventContentQueryVariables>;
export const FindUniqueEventDraftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindUniqueEventDraft"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"discussionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"timeTableStatus"}},{"kind":"Field","name":{"kind":"Name","value":"packageEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zoomMode"}},{"kind":"Field","name":{"kind":"Name","value":"ZoomMeeting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"joinUrl"}},{"kind":"Field","name":{"kind":"Name","value":"startUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isStarted"}},{"kind":"Field","name":{"kind":"Name","value":"meetingId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"password"}},{"kind":"Field","name":{"kind":"Name","value":"registrationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"startDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"endDateTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAccredited"}},{"kind":"Field","name":{"kind":"Name","value":"isAccreditedSHA"}},{"kind":"Field","name":{"kind":"Name","value":"hideVideoProgress"}},{"kind":"Field","name":{"kind":"Name","value":"cmeHours"}},{"kind":"Field","name":{"kind":"Name","value":"cmeNumber"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}},{"kind":"Field","name":{"kind":"Name","value":"folder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isContentProvidedByAcademy"}},{"kind":"Field","name":{"kind":"Name","value":"isTraineeCertificateAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"isTrainerCertificateAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"defaultLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"methodOfDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"traineeCertificateTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerCertificateTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"minAttendancePercentageToGetCertificate"}},{"kind":"Field","name":{"kind":"Name","value":"leaderTrainer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"specialty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"onsiteCapacity"}},{"kind":"Field","name":{"kind":"Name","value":"onlineCapacity"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressInstructions"}},{"kind":"Field","name":{"kind":"Name","value":"addressAr"}},{"kind":"Field","name":{"kind":"Name","value":"addressInstructionsAr"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationLatitude"}},{"kind":"Field","name":{"kind":"Name","value":"locationLongitude"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundImagesUrls"}},{"kind":"Field","name":{"kind":"Name","value":"sponsorshipImagesUrls"}},{"kind":"Field","name":{"kind":"Name","value":"isSponsored"}},{"kind":"Field","name":{"kind":"Name","value":"keywordsAr"}},{"kind":"Field","name":{"kind":"Name","value":"keywordsEn"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionAr"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEn"}},{"kind":"Field","name":{"kind":"Name","value":"visibleOnArchive"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PricingPlanFragment"}},{"kind":"Field","name":{"kind":"Name","value":"hasMultiPartDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"multiPartDiscountPrice"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}},{"kind":"Field","name":{"kind":"Name","value":"hasDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"discountPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"hasDiscountEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"discountEndDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventParts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PricingPlanFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlanId"}},{"kind":"Field","name":{"kind":"Name","value":"eventDays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventDays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"trainerTimeSlots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"trainerEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trainer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"specialty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}}]}}]}}]}},...PricingPlanFragmentFragmentDoc.definitions]} as unknown as DocumentNode<FindUniqueEventDraftQuery, FindUniqueEventDraftQueryVariables>;
export const FindUniqueEventIntroContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindUniqueEventIntroContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"introductionAr"}},{"kind":"Field","name":{"kind":"Name","value":"targetedAudiences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetedSpecialities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAllProfessionsTargeted"}},{"kind":"Field","name":{"kind":"Name","value":"objectivesAr"}},{"kind":"Field","name":{"kind":"Name","value":"objectivesEn"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescriptionAr"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescriptionEn"}},{"kind":"Field","name":{"kind":"Name","value":"mainThemeEn"}},{"kind":"Field","name":{"kind":"Name","value":"mainThemeAr"}},{"kind":"Field","name":{"kind":"Name","value":"outcomesEn"}},{"kind":"Field","name":{"kind":"Name","value":"outcomesAr"}},{"kind":"Field","name":{"kind":"Name","value":"whyTargetedAudienceAr"}},{"kind":"Field","name":{"kind":"Name","value":"whyTargetedAudienceEn"}},{"kind":"Field","name":{"kind":"Name","value":"introductionEn"}},{"kind":"Field","name":{"kind":"Name","value":"youtubeUrl"}}]}}]}}]} as unknown as DocumentNode<FindUniqueEventIntroContentQuery, FindUniqueEventIntroContentQueryVariables>;
export const FindUniqueEventLessonsTimeSlotsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindUniqueEventLessonsTimeSlots"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventDaysWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EventDayWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"trainerEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trainer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"specialty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventDays"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventDaysWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"trainerLessons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"TrainerEventDayLessonType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"methodOfTeaching"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trainerId"}},{"kind":"Field","name":{"kind":"Name","value":"trainer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerTimeSlots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Blogs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionAr"}},{"kind":"Field","name":{"kind":"Name","value":"contentAr"}},{"kind":"Field","name":{"kind":"Name","value":"socialMedia"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailImage"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}}]}}]}}]} as unknown as DocumentNode<FindUniqueEventLessonsTimeSlotsQuery, FindUniqueEventLessonsTimeSlotsQueryVariables>;
export const PreviewEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PreviewEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"folder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isTrainerCertificateAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"trainerCertificateTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isTraineeCertificateAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"traineeCertificateTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"minAttendancePercentageToGetCertificate"}},{"kind":"Field","name":{"kind":"Name","value":"isAccredited"}},{"kind":"Field","name":{"kind":"Name","value":"isAccreditedSHA"}},{"kind":"Field","name":{"kind":"Name","value":"leaderTrainer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"onsiteCapacity"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"addressAr"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundImagesUrls"}},{"kind":"Field","name":{"kind":"Name","value":"sponsorshipImagesUrls"}},{"kind":"Field","name":{"kind":"Name","value":"isSponsored"}},{"kind":"Field","name":{"kind":"Name","value":"keywordsAr"}},{"kind":"Field","name":{"kind":"Name","value":"keywordsEn"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionAr"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEn"}},{"kind":"Field","name":{"kind":"Name","value":"isContentProvidedByAcademy"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addressInstructions"}},{"kind":"Field","name":{"kind":"Name","value":"addressInstructionsAr"}},{"kind":"Field","name":{"kind":"Name","value":"locationLongitude"}},{"kind":"Field","name":{"kind":"Name","value":"locationLatitude"}},{"kind":"Field","name":{"kind":"Name","value":"onlineCapacity"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"cmeHours"}},{"kind":"Field","name":{"kind":"Name","value":"cmeNumber"}},{"kind":"Field","name":{"kind":"Name","value":"introductionAr"}},{"kind":"Field","name":{"kind":"Name","value":"introductionEn"}},{"kind":"Field","name":{"kind":"Name","value":"objectivesAr"}},{"kind":"Field","name":{"kind":"Name","value":"objectivesEn"}},{"kind":"Field","name":{"kind":"Name","value":"mainThemeAr"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescriptionAr"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescriptionEn"}},{"kind":"Field","name":{"kind":"Name","value":"mainThemeEn"}},{"kind":"Field","name":{"kind":"Name","value":"targetedSpecialities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAllProfessionsTargeted"}},{"kind":"Field","name":{"kind":"Name","value":"outcomesAr"}},{"kind":"Field","name":{"kind":"Name","value":"outcomesEn"}},{"kind":"Field","name":{"kind":"Name","value":"whyTargetedAudienceAr"}},{"kind":"Field","name":{"kind":"Name","value":"whyTargetedAudienceEn"}},{"kind":"Field","name":{"kind":"Name","value":"visibleOnArchive"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PricingPlanPreviewFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"methodOfDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetedAudiences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventParts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PricingPlanPreviewFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventDays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventDayPreviewFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventDays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventDayPreviewFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trainer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"specialty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerEventStudyMaterials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"media"}},{"kind":"Field","name":{"kind":"Name","value":"trainerEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trainer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"specialty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventLanguages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}},...PricingPlanPreviewFragmentFragmentDoc.definitions,...EventDayPreviewFragmentFragmentDoc.definitions]} as unknown as DocumentNode<PreviewEventQuery, PreviewEventQueryVariables>;
export const ScheduleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Schedule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"cmeHours"}},{"kind":"Field","name":{"kind":"Name","value":"cmeNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isAccredited"}},{"kind":"Field","name":{"kind":"Name","value":"isAccreditedSHA"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricingPlanType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paidPlanPrice"}},{"kind":"Field","name":{"kind":"Name","value":"cardFee"}},{"kind":"Field","name":{"kind":"Name","value":"basedOnSpecialtyPlanOtherSpecialtiesPrice"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlanSpecialtyPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventParts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricingPlanType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paidPlanPrice"}},{"kind":"Field","name":{"kind":"Name","value":"cardFee"}},{"kind":"Field","name":{"kind":"Name","value":"basedOnSpecialtyPlanOtherSpecialtiesPrice"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlanSpecialtyPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ScheduleQuery, ScheduleQueryVariables>;
export const UpdateEventIntroContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEventIntroContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"introductionAr"}},{"kind":"Field","name":{"kind":"Name","value":"targetedAudiences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetedSpecialities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAllProfessionsTargeted"}},{"kind":"Field","name":{"kind":"Name","value":"objectivesAr"}},{"kind":"Field","name":{"kind":"Name","value":"objectivesEn"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescriptionAr"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescriptionEn"}},{"kind":"Field","name":{"kind":"Name","value":"mainThemeEn"}},{"kind":"Field","name":{"kind":"Name","value":"mainThemeAr"}},{"kind":"Field","name":{"kind":"Name","value":"outcomesEn"}},{"kind":"Field","name":{"kind":"Name","value":"outcomesAr"}},{"kind":"Field","name":{"kind":"Name","value":"whyTargetedAudienceAr"}},{"kind":"Field","name":{"kind":"Name","value":"whyTargetedAudienceEn"}},{"kind":"Field","name":{"kind":"Name","value":"introductionEn"}}]}}]}}]} as unknown as DocumentNode<UpdateEventIntroContentMutation, UpdateEventIntroContentMutationVariables>;
export const UpdateOneEventContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOneEventContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"eventLanguages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trainer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"specialty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"methodOfDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventDays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"methodOfDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zoomMeetings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"endDateTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerLessons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"TrainerEventDayLessonType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trainer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"specialty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerTimeSlots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"trainerEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trainer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"specialty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOneEventContentMutation, UpdateOneEventContentMutationVariables>;
export const UpdateOneEventDayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOneEventDay"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventDayUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventDayWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneEventDay"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"methodOfDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerLessons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"TrainerEventDayLessonType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerTimeSlots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"trainerEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TrainerEvent3Fragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zoomMeetings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"endDateTime"}}]}}]}}]}},...TrainerEvent3FragmentFragmentDoc.definitions]} as unknown as DocumentNode<UpdateOneEventDayMutation, UpdateOneEventDayMutationVariables>;
export const UpdateOnePricingPlanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOnePricingPlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PricingPlanUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PricingPlanWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOnePricingPlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasLateRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"freePlanCertificateCmeIsPaid"}},{"kind":"Field","name":{"kind":"Name","value":"freePlanCertificateStatus"}},{"kind":"Field","name":{"kind":"Name","value":"lateRegistrationStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"hasGroupDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"hasMultiPartDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"multiPartDiscountPrice"}},{"kind":"Field","name":{"kind":"Name","value":"groupDiscountPrice"}},{"kind":"Field","name":{"kind":"Name","value":"hasGroupDiscountEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"groupDiscountEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"groupDiscountMinNumberOfRegistrants"}},{"kind":"Field","name":{"kind":"Name","value":"freePlanCertificateCmePrice"}},{"kind":"Field","name":{"kind":"Name","value":"paidPlanPrice"}},{"kind":"Field","name":{"kind":"Name","value":"paidPlanOnsitePrice"}},{"kind":"Field","name":{"kind":"Name","value":"cardFee"}},{"kind":"Field","name":{"kind":"Name","value":"paidPlanLateRegistrationPrice"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlanSpecialtyPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceOnsite"}},{"kind":"Field","name":{"kind":"Name","value":"LateRegistrationPrice"}},{"kind":"Field","name":{"kind":"Name","value":"professions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"basedOnSpecialtyPlanOtherSpecialtiesPrice"}},{"kind":"Field","name":{"kind":"Name","value":"basedOnSpecialtyPlanOtherSpecialtiesOnsitePrice"}},{"kind":"Field","name":{"kind":"Name","value":"basedOnSpecialtyPlanOtherSpecialtiesLateRegistrationPrice"}},{"kind":"Field","name":{"kind":"Name","value":"hasWorkshop"}},{"kind":"Field","name":{"kind":"Name","value":"workshopPrice"}},{"kind":"Field","name":{"kind":"Name","value":"workshopLateRegistrationPrice"}},{"kind":"Field","name":{"kind":"Name","value":"workshopGroupDiscountPrice"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlanTypeId"}}]}}]}}]} as unknown as DocumentNode<UpdateOnePricingPlanMutation, UpdateOnePricingPlanMutationVariables>;
export const FindEventsNamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findEventsNames"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EventWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}}]}}]} as unknown as DocumentNode<FindEventsNamesQuery, FindEventsNamesQueryVariables>;
export const GenerateCertificateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"generateCertificate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"generateCertificateInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateCertificate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<GenerateCertificateMutation, GenerateCertificateMutationVariables>;
export const AddEventIdentityCardTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddEventIdentityCardTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"addEventIdentityCardTemplateType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addEventIdentityCardTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateData"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<AddEventIdentityCardTemplateMutation, AddEventIdentityCardTemplateMutationVariables>;
export const FindUniqueEventIdentityCardTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindUniqueEventIdentityCardTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventIdentityCardTemplateWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueEventIdentityCardTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"templateData"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<FindUniqueEventIdentityCardTemplateQuery, FindUniqueEventIdentityCardTemplateQueryVariables>;
export const AddEventMediaTrackingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddEventMediaTracking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"addEventMediaTrackingType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addEventMediaTracking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"twitter"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"linkedin"}},{"kind":"Field","name":{"kind":"Name","value":"whatsApp"}},{"kind":"Field","name":{"kind":"Name","value":"google"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"ertiqaa"}},{"kind":"Field","name":{"kind":"Name","value":"anat"}},{"kind":"Field","name":{"kind":"Name","value":"friend"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"traineeId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<AddEventMediaTrackingMutation, AddEventMediaTrackingMutationVariables>;
export const FindManyEventMediaTrackingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindManyEventMediaTracking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventMediaTrackingWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventMediaTrackingOrderByWithRelationInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyEventMediaTracking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"twitter"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"linkedin"}},{"kind":"Field","name":{"kind":"Name","value":"whatsApp"}},{"kind":"Field","name":{"kind":"Name","value":"google"}},{"kind":"Field","name":{"kind":"Name","value":"telegram"}},{"kind":"Field","name":{"kind":"Name","value":"ertiqaa"}},{"kind":"Field","name":{"kind":"Name","value":"anat"}},{"kind":"Field","name":{"kind":"Name","value":"friend"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"traineeId"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<FindManyEventMediaTrackingQuery, FindManyEventMediaTrackingQueryVariables>;
export const RemoveEventMediaTrackingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveEventMediaTracking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"removeEventMediaTrackingType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeEventMediaTracking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<RemoveEventMediaTrackingMutation, RemoveEventMediaTrackingMutationVariables>;
export const CreateHiddenEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateHiddenEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"HiddenEventsCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneHiddenEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}}]}}]} as unknown as DocumentNode<CreateHiddenEventsMutation, CreateHiddenEventsMutationVariables>;
export const DeleteHiddenEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteHiddenEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"HiddenEventsWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneHiddenEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}}]}}]}}]} as unknown as DocumentNode<DeleteHiddenEventsMutation, DeleteHiddenEventsMutationVariables>;
export const FindManyHiddenEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindManyHiddenEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyHiddenEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}}]}}]} as unknown as DocumentNode<FindManyHiddenEventsQuery, FindManyHiddenEventsQueryVariables>;
export const FindManyLanguageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindManyLanguage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyLanguage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<FindManyLanguageQuery, FindManyLanguageQueryVariables>;
export const AddMemberNeedSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddMemberNeedSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"addMemberNeedSettingsType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AddMemberNeedSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<AddMemberNeedSettingsMutation, AddMemberNeedSettingsMutationVariables>;
export const FindManyMemberNeedSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindManyMemberNeedSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MemberNeedSettingsWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MemberNeedSettingsOrderByWithRelationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyMemberNeedSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<FindManyMemberNeedSettingsQuery, FindManyMemberNeedSettingsQueryVariables>;
export const RemoveMemberNeedSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveMemberNeedSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"removeMemberNeedSettingsType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeMemberNeedSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<RemoveMemberNeedSettingsMutation, RemoveMemberNeedSettingsMutationVariables>;
export const AddMemberNeedsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddMemberNeeds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"addMemberNeedsType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AddMemberNeeds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<AddMemberNeedsMutation, AddMemberNeedsMutationVariables>;
export const FindManyMemberNeedsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindManyMemberNeeds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MemberNeedsWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MemberNeedsOrderByWithRelationInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyMemberNeeds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<FindManyMemberNeedsQuery, FindManyMemberNeedsQueryVariables>;
export const RemoveMemberNeedsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveMemberNeeds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"removeMemberNeedsType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeMemberNeeds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<RemoveMemberNeedsMutation, RemoveMemberNeedsMutationVariables>;
export const FindManyMethodOfTeachingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindManyMethodOfTeaching"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyMethodOfTeachingType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}}]} as unknown as DocumentNode<FindManyMethodOfTeachingQuery, FindManyMethodOfTeachingQueryVariables>;
export const FindOrganizersNamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindOrganizersNames"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RoleWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FindOrganizersNamesQuery, FindOrganizersNamesQueryVariables>;
export const CreateOneQuizDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOneQuiz"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QuizCreateOneInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneQuiz"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"QuizQuestion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"questionEn"}},{"kind":"Field","name":{"kind":"Name","value":"questionType"}},{"kind":"Field","name":{"kind":"Name","value":"questionAr"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"questionOrder"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"rightAnswer"}},{"kind":"Field","name":{"kind":"Name","value":"QuizQuestionAnswer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answerAr"}},{"kind":"Field","name":{"kind":"Name","value":"answerEn"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateOneQuizMutation, CreateOneQuizMutationVariables>;
export const DeleteOneQuizDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneQuiz"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QuizWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneQuiz"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<DeleteOneQuizMutation, DeleteOneQuizMutationVariables>;
export const FindQuizDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindQuiz"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QuizWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueQuiz"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<FindQuizQuery, FindQuizQueryVariables>;
export const UpdateOneQuizDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOneQuiz"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QuizUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QuizWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneQuiz"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateOneQuizMutation, UpdateOneQuizMutationVariables>;
export const CreateOneQuizQuestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOneQuizQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QuizQuestionCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneQuizQuestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"questionAr"}},{"kind":"Field","name":{"kind":"Name","value":"questionEn"}},{"kind":"Field","name":{"kind":"Name","value":"questionOrder"}},{"kind":"Field","name":{"kind":"Name","value":"questionType"}},{"kind":"Field","name":{"kind":"Name","value":"rightAnswer"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"QuizQuestionAnswer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answerAr"}},{"kind":"Field","name":{"kind":"Name","value":"answerEn"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<CreateOneQuizQuestionMutation, CreateOneQuizQuestionMutationVariables>;
export const DeleteOneQuizQuestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneQuizQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QuizQuestionWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneQuizQuestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"questionAr"}},{"kind":"Field","name":{"kind":"Name","value":"questionEn"}},{"kind":"Field","name":{"kind":"Name","value":"rightAnswer"}},{"kind":"Field","name":{"kind":"Name","value":"questionOrder"}},{"kind":"Field","name":{"kind":"Name","value":"questionType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<DeleteOneQuizQuestionMutation, DeleteOneQuizQuestionMutationVariables>;
export const UpdateManyQuizQuestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateManyQuizQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QuizQuestionUpdateManyInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateManyQuizQuestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpdateManyQuizQuestionMutation, UpdateManyQuizQuestionMutationVariables>;
export const UpdateOneQuizQuestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOneQuizQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QuizQuestionUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QuizQuestionWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneQuizQuestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateOneQuizQuestionMutation, UpdateOneQuizQuestionMutationVariables>;
export const CreateOneQuizQuestionAnswerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOneQuizQuestionAnswer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QuizQuestionAnswerCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneQuizQuestionAnswer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateOneQuizQuestionAnswerMutation, CreateOneQuizQuestionAnswerMutationVariables>;
export const DeleteOneQuizQuestionAnswerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneQuizQuestionAnswer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QuizQuestionAnswerWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneQuizQuestionAnswer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteOneQuizQuestionAnswerMutation, DeleteOneQuizQuestionAnswerMutationVariables>;
export const UpdateOneQuizQuestionAnswerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOneQuizQuestionAnswer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QuizQuestionAnswerUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QuizQuestionAnswerWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneQuizQuestionAnswer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateOneQuizQuestionAnswerMutation, UpdateOneQuizQuestionAnswerMutationVariables>;
export const CreateOneQuizResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOneQuizResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QuizResultCreateOneInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneQuizResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"quizId"}},{"kind":"Field","name":{"kind":"Name","value":"quizQuestionId"}},{"kind":"Field","name":{"kind":"Name","value":"quizQuestionAnswerId"}}]}}]}}]} as unknown as DocumentNode<CreateOneQuizResultMutation, CreateOneQuizResultMutationVariables>;
export const FindManyQuizResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindManyQuizResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QuizResultWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyQuizResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quizQuestionId"}},{"kind":"Field","name":{"kind":"Name","value":"quizQuestionAnswerId"}}]}}]}}]} as unknown as DocumentNode<FindManyQuizResultQuery, FindManyQuizResultQueryVariables>;
export const RecordAttendanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RecordAttendance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"recordAttendanceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordAttendance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TraineeEventDayAttendances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"joinTime"}},{"kind":"Field","name":{"kind":"Name","value":"leaveTime"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"EventDay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Trainee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<RecordAttendanceMutation, RecordAttendanceMutationVariables>;
export const SetUnprocessedAttendanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"setUnprocessedAttendance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"setAttendanceType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneTraineeEventDayAttendance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<SetUnprocessedAttendanceMutation, SetUnprocessedAttendanceMutationVariables>;
export const UnprocessedAttendanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UnprocessedAttendance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"getAttendanceType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyTraineeEventDayAttendance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"participantName"}}]}}]}}]} as unknown as DocumentNode<UnprocessedAttendanceQuery, UnprocessedAttendanceQueryVariables>;
export const AdminAnalysisDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminAnalysis"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"adminAnalysisWhere"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminAnalysis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastLogin"}}]}}]}}]} as unknown as DocumentNode<AdminAnalysisQuery, AdminAnalysisQueryVariables>;
export const EventAnalysisDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventAnalysis"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"eventAnalysisWhere"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventAnalysis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"eventDeliveryMethod"}}]}}]}}]} as unknown as DocumentNode<EventAnalysisQuery, EventAnalysisQueryVariables>;
export const EventsReportFindOneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventsReportFindOne"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventsReportUniqueObject"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueEventsReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isProvidedByAcadmeyResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isContentProvidedByAcademy"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"languageResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"languageId"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"EventResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"howHeardAboutEventResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"howHeardAboutEventId"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}}]}}]} as unknown as DocumentNode<EventsReportFindOneQuery, EventsReportFindOneQueryVariables>;
export const MarketersReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MarketersReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MarketersReportUniqueObject"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueMarketersReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}}]}}]}}]} as unknown as DocumentNode<MarketersReportQuery, MarketersReportQueryVariables>;
export const OrganizersReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrganizersReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizersReportUniqueObject"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueOrganizersReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}}]}}]}}]} as unknown as DocumentNode<OrganizersReportQuery, OrganizersReportQueryVariables>;
export const TraineesReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TraineesReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TraineesReportUniqueObject"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueTraineesReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"genderRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"regionRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usersWithNamesRecord"}}]}}]}}]} as unknown as DocumentNode<TraineesReportQuery, TraineesReportQueryVariables>;
export const TrainersReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TrainersReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TrainersReportUniqueObject"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueTrainersReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"becomeTrainerRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"regionRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}},{"kind":"Field","name":{"kind":"Name","value":"countRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}}]}}]}}]}}]} as unknown as DocumentNode<TrainersReportQuery, TrainersReportQueryVariables>;
export const MarketerAnalysisDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MarketerAnalysis"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"marketerAnalysisWhere"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketerAnalysis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"eventsAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"lastLogin"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfCompletedEvents"}}]}}]}}]} as unknown as DocumentNode<MarketerAnalysisQuery, MarketerAnalysisQueryVariables>;
export const OrgnizerAnalysisDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrgnizerAnalysis"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"orgnizerAnalysisWhere"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgnizerAnalysis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"eventsAnalysis"}},{"kind":"Field","name":{"kind":"Name","value":"lastLogin"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfCompletedEvents"}}]}}]}}]} as unknown as DocumentNode<OrgnizerAnalysisQuery, OrgnizerAnalysisQueryVariables>;
export const TraineeAnalysisDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TraineeAnalysis"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"traineeAnalysisWhere"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"traineeAnalysis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminNotes"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastLogin"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfCompletedEvents"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfRegisteredEvents"}}]}}]}}]} as unknown as DocumentNode<TraineeAnalysisQuery, TraineeAnalysisQueryVariables>;
export const TrainerAnalysisDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TrainerAnalysis"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"trainerAnalysisWhere"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trainerAnalysis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastLogin"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfCompletedEvents"}}]}}]}}]} as unknown as DocumentNode<TrainerAnalysisQuery, TrainerAnalysisQueryVariables>;
export const UserRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roleId"}}]}}]}}]} as unknown as DocumentNode<UserRoleQuery, UserRoleQueryVariables>;
export const FindSchedulingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindScheduling"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"findSchedulingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findScheduling"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"startOn"}},{"kind":"Field","name":{"kind":"Name","value":"startedon"}}]}}]}}]} as unknown as DocumentNode<FindSchedulingQuery, FindSchedulingQueryVariables>;
export const UpdateJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"updateJobInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"startOn"}},{"kind":"Field","name":{"kind":"Name","value":"startedon"}}]}}]}}]} as unknown as DocumentNode<UpdateJobMutation, UpdateJobMutationVariables>;
export const CreateOneAutomatedEmailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOneAutomatedEmails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AutomatedEmailsCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneAutomatedEmails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"sendTo"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"forRegistrans"}},{"kind":"Field","name":{"kind":"Name","value":"whenEventHasClasses"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<CreateOneAutomatedEmailsMutation, CreateOneAutomatedEmailsMutationVariables>;
export const CreateOneUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOneUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateOneUserMutation, CreateOneUserMutationVariables>;
export const DeleteOneAutomatedEmailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneAutomatedEmails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AutomatedEmailsWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneAutomatedEmails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteOneAutomatedEmailsMutation, DeleteOneAutomatedEmailsMutationVariables>;
export const FindAutomatedEmailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindAutomatedEmails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AutomatedEmailsOrderByWithRelationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyAutomatedEmails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"sendTo"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"forRegistrans"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"whenEventHasClasses"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<FindAutomatedEmailsQuery, FindAutomatedEmailsQueryVariables>;
export const FindCardFeeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindCardFee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findCardFee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<FindCardFeeQuery, FindCardFeeQueryVariables>;
export const FindGeneralCouponDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindGeneralCoupon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findGeneralCoupon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<FindGeneralCouponQuery, FindGeneralCouponQueryVariables>;
export const FindPublishExpenseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindPublishExpense"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findPublishExpense"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<FindPublishExpenseQuery, FindPublishExpenseQueryVariables>;
export const FindRemoveUserPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindRemoveUserPassword"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findRemoveUserPassword"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<FindRemoveUserPasswordQuery, FindRemoveUserPasswordQueryVariables>;
export const FindTaxSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindTaxSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SettingsWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<FindTaxSettingsQuery, FindTaxSettingsQueryVariables>;
export const FindVatNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindVatNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findVatNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<FindVatNumberQuery, FindVatNumberQueryVariables>;
export const UpdateCardFeeSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCardFeeSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cardFeeInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCardFeeSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<UpdateCardFeeSettingsMutation, UpdateCardFeeSettingsMutationVariables>;
export const UpdateGeneralCouponSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateGeneralCouponSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"generalCouponInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateGeneralCouponSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<UpdateGeneralCouponSettingsMutation, UpdateGeneralCouponSettingsMutationVariables>;
export const UpdateHeroImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateHeroImages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventImages"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"indexImagesInputType"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"indexImages"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"indexImagesInputType"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateHeroImages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"eventImages"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventImages"}}},{"kind":"Argument","name":{"kind":"Name","value":"indexImages"},"value":{"kind":"Variable","name":{"kind":"Name","value":"indexImages"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<UpdateHeroImagesMutation, UpdateHeroImagesMutationVariables>;
export const UpdateInstantNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateInstantNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"instantNotificationsBellInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateInstantNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<UpdateInstantNotificationsMutation, UpdateInstantNotificationsMutationVariables>;
export const UpdateOneAutomatedEmailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOneAutomatedEmails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AutomatedEmailsUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AutomatedEmailsWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneAutomatedEmails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"sendTo"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"forRegistrans"}},{"kind":"Field","name":{"kind":"Name","value":"whenEventHasClasses"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOneAutomatedEmailsMutation, UpdateOneAutomatedEmailsMutationVariables>;
export const UpdatePublishExpenseSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePublishExpenseSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"publishExpenseInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePublishExpenseSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<UpdatePublishExpenseSettingsMutation, UpdatePublishExpenseSettingsMutationVariables>;
export const UpdateRemoveUserPasswordSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateRemoveUserPasswordSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"removeUserPasswordInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRemoveUserPasswordSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<UpdateRemoveUserPasswordSettingsMutation, UpdateRemoveUserPasswordSettingsMutationVariables>;
export const UpdateTaxNumberSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTaxNumberSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"taxNumberInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTaxNumberSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<UpdateTaxNumberSettingsMutation, UpdateTaxNumberSettingsMutationVariables>;
export const UpdateTaxSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTaxSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"taxInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTaxSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"nameEn"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<UpdateTaxSettingsMutation, UpdateTaxSettingsMutationVariables>;
export const CreateOneTraineeEventReviewChoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createOneTraineeEventReviewChoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TraineeEventReviewChoiceCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneTraineeEventReviewChoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateOneTraineeEventReviewChoiceMutation, CreateOneTraineeEventReviewChoiceMutationVariables>;
export const CreateOneTraineeTrainerReviewChoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createOneTraineeTrainerReviewChoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TraineeTrainerReviewChoiceCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneTraineeTrainerReviewChoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateOneTraineeTrainerReviewChoiceMutation, CreateOneTraineeTrainerReviewChoiceMutationVariables>;
export const DeleteOneTraineeEventReviewChoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteOneTraineeEventReviewChoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TraineeEventReviewChoiceWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneTraineeEventReviewChoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteOneTraineeEventReviewChoiceMutation, DeleteOneTraineeEventReviewChoiceMutationVariables>;
export const DeleteOneTraineeTrainerReviewChoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteOneTraineeTrainerReviewChoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TraineeTrainerReviewChoiceWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneTraineeTrainerReviewChoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteOneTraineeTrainerReviewChoiceMutation, DeleteOneTraineeTrainerReviewChoiceMutationVariables>;
export const UpdateOneTraineeEventReviewChoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateOneTraineeEventReviewChoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TraineeEventReviewChoiceUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TraineeEventReviewChoiceWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneTraineeEventReviewChoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateOneTraineeEventReviewChoiceMutation, UpdateOneTraineeEventReviewChoiceMutationVariables>;
export const UpdateOneTraineeTrainerReviewChoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateOneTraineeTrainerReviewChoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TraineeTrainerReviewChoiceUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TraineeTrainerReviewChoiceWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneTraineeTrainerReviewChoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateOneTraineeTrainerReviewChoiceMutation, UpdateOneTraineeTrainerReviewChoiceMutationVariables>;
export const CreateProfessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProfession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneProfession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}}]} as unknown as DocumentNode<CreateProfessionMutation, CreateProfessionMutationVariables>;
export const CreateSpecialtyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSpecialty"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SpecialtyCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneSpecialty"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}}]} as unknown as DocumentNode<CreateSpecialtyMutation, CreateSpecialtyMutationVariables>;
export const DeleteProfessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProfession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneProfession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}}]} as unknown as DocumentNode<DeleteProfessionMutation, DeleteProfessionMutationVariables>;
export const DeleteSpecialtyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSpecialty"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SpecialtyWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneSpecialty"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}}]} as unknown as DocumentNode<DeleteSpecialtyMutation, DeleteSpecialtyMutationVariables>;
export const FindManyQualificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindManyQualification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyQualification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<FindManyQualificationQuery, FindManyQualificationQueryVariables>;
export const FindManySpecialtyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindManySpecialty"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SpecialtyWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManySpecialty"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}}]} as unknown as DocumentNode<FindManySpecialtyQuery, FindManySpecialtyQueryVariables>;
export const FindManyProfessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindManyProfession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyProfession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"Specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"professionId"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}}]}}]} as unknown as DocumentNode<FindManyProfessionQuery, FindManyProfessionQueryVariables>;
export const FindProfessionsNamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindProfessionsNames"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyProfession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}}]} as unknown as DocumentNode<FindProfessionsNamesQuery, FindProfessionsNamesQueryVariables>;
export const UpdateProfessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProfession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneProfession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}}]} as unknown as DocumentNode<UpdateProfessionMutation, UpdateProfessionMutationVariables>;
export const UpdateSpecialtyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSpecialty"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SpecialtyUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SpecialtyWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneSpecialty"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}}]} as unknown as DocumentNode<UpdateSpecialtyMutation, UpdateSpecialtyMutationVariables>;
export const AddStudyMaterialGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddStudyMaterialGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TrainerEventStudyMaterialGroupCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneTrainerEventStudyMaterialGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]} as unknown as DocumentNode<AddStudyMaterialGroupMutation, AddStudyMaterialGroupMutationVariables>;
export const DeleteStudyMaterialGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteStudyMaterialGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TrainerEventStudyMaterialGroupWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneTrainerEventStudyMaterialGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteStudyMaterialGroupMutation, DeleteStudyMaterialGroupMutationVariables>;
export const FindManyStudyMaterialGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindManyStudyMaterialGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TrainerEventStudyMaterialGroupWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"traineeEventId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyTrainerEventStudyMaterialGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"traineeEventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"traineeEventId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"minAttendancePercentageToGetCertificate"}},{"kind":"Field","name":{"kind":"Name","value":"discussionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"Discussion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"NullValue"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"Replies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"User"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"User"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"introductionAr"}},{"kind":"Field","name":{"kind":"Name","value":"introductionEn"}},{"kind":"Field","name":{"kind":"Name","value":"objectivesAr"}},{"kind":"Field","name":{"kind":"Name","value":"objectivesEn"}},{"kind":"Field","name":{"kind":"Name","value":"mainThemeAr"}},{"kind":"Field","name":{"kind":"Name","value":"mainThemeEn"}},{"kind":"Field","name":{"kind":"Name","value":"outcomesAr"}},{"kind":"Field","name":{"kind":"Name","value":"outcomesEn"}},{"kind":"Field","name":{"kind":"Name","value":"targetedAudiences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetedSpecialities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAllProfessionsTargeted"}},{"kind":"Field","name":{"kind":"Name","value":"whyTargetedAudienceAr"}},{"kind":"Field","name":{"kind":"Name","value":"whyTargetedAudienceEn"}},{"kind":"Field","name":{"kind":"Name","value":"trainerEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trainer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"profession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"StudyMaterials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"media"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"minAttendancePercentageToGetCertificate"}},{"kind":"Field","name":{"kind":"Name","value":"discussionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"hideVideoProgress"}},{"kind":"Field","name":{"kind":"Name","value":"Discussion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"NullValue"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"Replies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"User"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"User"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Quiz"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"QuizQuestion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"questionEn"}},{"kind":"Field","name":{"kind":"Name","value":"questionType"}},{"kind":"Field","name":{"kind":"Name","value":"questionAr"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"questionOrder"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"rightAnswer"}},{"kind":"Field","name":{"kind":"Name","value":"QuizQuestionAnswer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answerAr"}},{"kind":"Field","name":{"kind":"Name","value":"answerEn"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"traineeEventStudyMaterialAttendance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"traineeEventId"}},{"kind":"Field","name":{"kind":"Name","value":"progressPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"traineeEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Certificate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"traineeEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FindManyStudyMaterialGroupQuery, FindManyStudyMaterialGroupQueryVariables>;
export const FindManyStudyMaterialGroupProgressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindManyStudyMaterialGroupProgress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TrainerEventStudyMaterialGroupWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"traineeEventId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyTrainerEventStudyMaterialGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"traineeEventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"traineeEventId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"StudyMaterials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"minAttendancePercentageToGetCertificate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"traineeEventStudyMaterialAttendance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"traineeEventId"}},{"kind":"Field","name":{"kind":"Name","value":"progressPercentage"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FindManyStudyMaterialGroupProgressQuery, FindManyStudyMaterialGroupProgressQueryVariables>;
export const FindOneStudyMaterialGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindOneStudyMaterialGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TrainerEventStudyMaterialGroupWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findOneTrainerEventStudyMaterialGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"StudyMaterials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"media"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FindOneStudyMaterialGroupQuery, FindOneStudyMaterialGroupQueryVariables>;
export const UpdateStudyMaterialGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateStudyMaterialGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TrainerEventStudyMaterialGroupUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TrainerEventStudyMaterialGroupWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneTrainerEventStudyMaterialGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]} as unknown as DocumentNode<UpdateStudyMaterialGroupMutation, UpdateStudyMaterialGroupMutationVariables>;
export const CreateOneTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOneTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TemplateCreateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"certificateType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"certificateType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"certificateType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"purpose"}}]}}]}}]} as unknown as DocumentNode<CreateOneTemplateMutation, CreateOneTemplateMutationVariables>;
export const DeleteOneTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TemplateWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteOneTemplateMutation, DeleteOneTemplateMutationVariables>;
export const FindManyCertificateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindManyCertificate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"purpose"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"certificate"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<FindManyCertificateQuery, FindManyCertificateQueryVariables>;
export const FindManyEmailTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindManyEmailTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"purpose"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"email"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<FindManyEmailTemplateQuery, FindManyEmailTemplateQueryVariables>;
export const FindUniqueTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindUniqueTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TemplateWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"purpose"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]}}]} as unknown as DocumentNode<FindUniqueTemplateQuery, FindUniqueTemplateQueryVariables>;
export const UpdateOneTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOneTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TemplateUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TemplateWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"purpose"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]}}]} as unknown as DocumentNode<UpdateOneTemplateMutation, UpdateOneTemplateMutationVariables>;
export const AddStudyMaterialDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddStudyMaterial"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TrainerEventStudyMaterialCreateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quizValues"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Json"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneTrainerEventStudyMaterial"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"quizValues"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quizValues"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"media"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"trainerEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trainer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddStudyMaterialMutation, AddStudyMaterialMutationVariables>;
export const CreateOneTrainerEventDayLessonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOneTrainerEventDayLesson"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TrainerEventDayLessonCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneTrainerEventDayLesson"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"eventDayId"}},{"kind":"Field","name":{"kind":"Name","value":"methodOfTeaching"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trainer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}}]}}]} as unknown as DocumentNode<CreateOneTrainerEventDayLessonMutation, CreateOneTrainerEventDayLessonMutationVariables>;
export const DeleteOneTrainerEventDayLessonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneTrainerEventDayLesson"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TrainerEventDayLessonWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneTrainerEventDayLesson"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventDayId"}}]}}]}}]} as unknown as DocumentNode<DeleteOneTrainerEventDayLessonMutation, DeleteOneTrainerEventDayLessonMutationVariables>;
export const DeleteStudyMaterialDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteStudyMaterial"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TrainerEventStudyMaterialWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneTrainerEventStudyMaterial"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteStudyMaterialMutation, DeleteStudyMaterialMutationVariables>;
export const FindEventLeaderTrainerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindEventLeaderTrainer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"leaderTrainer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"specialty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FindEventLeaderTrainerQuery, FindEventLeaderTrainerQueryVariables>;
export const FindManyTrainerEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindManyTrainerEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TrainerEventWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyTrainerEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"registrantId"}},{"kind":"Field","name":{"kind":"Name","value":"joinUrl"}},{"kind":"Field","name":{"kind":"Name","value":"trainer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"specialty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ZoomMeeting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"meetingId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}}]}}]}}]} as unknown as DocumentNode<FindManyTrainerEventQuery, FindManyTrainerEventQueryVariables>;
export const FindOneStudyMaterialDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindOneStudyMaterial"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TrainerEventStudyMaterialWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findOneTrainerEventStudyMaterial"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"media"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerEventStudyMaterialGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"trainerEventStudyMaterialGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Quiz"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"QuizQuestion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"questionEn"}},{"kind":"Field","name":{"kind":"Name","value":"questionType"}},{"kind":"Field","name":{"kind":"Name","value":"questionAr"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"questionOrder"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"rightAnswer"}},{"kind":"Field","name":{"kind":"Name","value":"QuizQuestionAnswer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answerAr"}},{"kind":"Field","name":{"kind":"Name","value":"answerEn"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FindOneStudyMaterialQuery, FindOneStudyMaterialQueryVariables>;
export const FindTrainerTimeSlotsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindTrainerTimeSlots"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TrainerEventWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trainerLessonsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TrainerEventDayLessonWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trainerTimeSlotsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TrainerEventDayTimeSlotWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventDaysWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EventDayWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueTrainerEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"eventDays"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventDaysWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"trainerLessons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trainerLessonsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"methodOfTeaching"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trainer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerTimeSlots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trainerTimeSlotsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FindTrainerTimeSlotsQuery, FindTrainerTimeSlotsQueryVariables>;
export const FindTrainersNamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindTrainersNames"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RoleWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"usersWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"usersWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"specialty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FindTrainersNamesQuery, FindTrainersNamesQueryVariables>;
export const TrainerIsAddedToEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TrainerIsAddedToEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TrainerEventWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueTrainerEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<TrainerIsAddedToEventQuery, TrainerIsAddedToEventQueryVariables>;
export const TrainerIsLeaderTrainerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TrainerIsLeaderTrainer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leaderTrainerId"}},{"kind":"Field","name":{"kind":"Name","value":"addedById"}}]}}]}}]} as unknown as DocumentNode<TrainerIsLeaderTrainerQuery, TrainerIsLeaderTrainerQueryVariables>;
export const UpdateBecomeTrainerApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateBecomeTrainerApplication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BecomeTrainerApplicationUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BecomeTrainerApplicationWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneBecomeTrainerApplication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateBecomeTrainerApplicationMutation, UpdateBecomeTrainerApplicationMutationVariables>;
export const UpdateOneTrainerEventDayLessonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOneTrainerEventDayLesson"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TrainerEventDayLessonUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TrainerEventDayLessonWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneTrainerEventDayLesson"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"outlineAr"}},{"kind":"Field","name":{"kind":"Name","value":"outlineEn"}},{"kind":"Field","name":{"kind":"Name","value":"eventDayId"}},{"kind":"Field","name":{"kind":"Name","value":"methodOfTeaching"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"trainerEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trainer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOneTrainerEventDayLessonMutation, UpdateOneTrainerEventDayLessonMutationVariables>;
export const UpdateStudyMaterialDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateStudyMaterial"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TrainerEventStudyMaterialUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TrainerEventStudyMaterialWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quizValues"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Json"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneTrainerEventStudyMaterial"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"quizValues"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quizValues"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"media"}}]}}]}}]} as unknown as DocumentNode<UpdateStudyMaterialMutation, UpdateStudyMaterialMutationVariables>;
export const FindUniqueTrainerEventContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findUniqueTrainerEventContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TrainerEventWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueTrainerEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentIsAdded"}},{"kind":"Field","name":{"kind":"Name","value":"introductionAr"}},{"kind":"Field","name":{"kind":"Name","value":"introductionEn"}},{"kind":"Field","name":{"kind":"Name","value":"targetedAudiences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"objectivesAr"}},{"kind":"Field","name":{"kind":"Name","value":"objectivesEn"}},{"kind":"Field","name":{"kind":"Name","value":"mainThemeEn"}},{"kind":"Field","name":{"kind":"Name","value":"mainThemeAr"}},{"kind":"Field","name":{"kind":"Name","value":"outcomesEn"}},{"kind":"Field","name":{"kind":"Name","value":"outcomesAr"}},{"kind":"Field","name":{"kind":"Name","value":"whyTargetedAudienceAr"}},{"kind":"Field","name":{"kind":"Name","value":"whyTargetedAudienceEn"}},{"kind":"Field","name":{"kind":"Name","value":"youtubeUrl"}},{"kind":"Field","name":{"kind":"Name","value":"introductionEn"}}]}}]}}]} as unknown as DocumentNode<FindUniqueTrainerEventContentQuery, FindUniqueTrainerEventContentQueryVariables>;
export const FindUniqueUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindUniqueUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameAr"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"specialty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}}]}}]} as unknown as DocumentNode<FindUniqueUserQuery, FindUniqueUserQueryVariables>;
export const UpdateOneTrainerEventContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateOneTrainerEventContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TrainerEventUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TrainerEventWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneTrainerEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentIsAdded"}},{"kind":"Field","name":{"kind":"Name","value":"introductionAr"}},{"kind":"Field","name":{"kind":"Name","value":"targetedAudiences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"objectivesAr"}},{"kind":"Field","name":{"kind":"Name","value":"objectivesEn"}},{"kind":"Field","name":{"kind":"Name","value":"mainThemeEn"}},{"kind":"Field","name":{"kind":"Name","value":"mainThemeAr"}},{"kind":"Field","name":{"kind":"Name","value":"outcomesEn"}},{"kind":"Field","name":{"kind":"Name","value":"outcomesAr"}},{"kind":"Field","name":{"kind":"Name","value":"whyTargetedAudienceAr"}},{"kind":"Field","name":{"kind":"Name","value":"whyTargetedAudienceEn"}},{"kind":"Field","name":{"kind":"Name","value":"youtubeUrl"}},{"kind":"Field","name":{"kind":"Name","value":"introductionEn"}}]}}]}}]} as unknown as DocumentNode<UpdateOneTrainerEventContentMutation, UpdateOneTrainerEventContentMutationVariables>;
export const AddExpenseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddExpense"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddExpenseType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AddExpense"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AddExpenseMutation, AddExpenseMutationVariables>;
export const AddPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddPaymentType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AddPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"balance"}}]}}]}}]} as unknown as DocumentNode<AddPaymentMutation, AddPaymentMutationVariables>;
export const AuthorizationFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AuthorizationForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paidPlanPrice"}},{"kind":"Field","name":{"kind":"Name","value":"freePlanCertificateStatus"}},{"kind":"Field","name":{"kind":"Name","value":"freePlanCertificateCmePrice"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlanTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"basedOnSpecialtyPlanOtherSpecialtiesPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invitersCanApprovePayments"}},{"kind":"Field","name":{"kind":"Name","value":"methodOfDeliveryId"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"zoomMode"}},{"kind":"Field","name":{"kind":"Name","value":"inviterCouponProfits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"inviterId"}},{"kind":"Field","name":{"kind":"Name","value":"profit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ZoomMeeting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meetingId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"startDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"endDateTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventTypeId"}}]}}]}}]} as unknown as DocumentNode<AuthorizationFormQuery, AuthorizationFormQueryVariables>;
export const CheckValidityGroupBookingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckValidityGroupBooking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasGroupDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"groupDiscountEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"groupDiscountMinNumberOfRegistrants"}}]}},{"kind":"Field","name":{"kind":"Name","value":"methodOfDeliveryId"}}]}}]}}]} as unknown as DocumentNode<CheckValidityGroupBookingQuery, CheckValidityGroupBookingQueryVariables>;
export const FindBalanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindBalance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"marketerBalance"}},{"kind":"Field","name":{"kind":"Name","value":"roleId"}}]}}]}}]} as unknown as DocumentNode<FindBalanceQuery, FindBalanceQueryVariables>;
export const FindManyTransitionStatusTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindManyTransitionStatusType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyTransitionStatusType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}}]}}]} as unknown as DocumentNode<FindManyTransitionStatusTypeQuery, FindManyTransitionStatusTypeQueryVariables>;
export const IncomeStatementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IncomeStatement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"incomeStatementWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incomeStatement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"expenses"}},{"kind":"Field","name":{"kind":"Name","value":"income"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"moyasarFee"}},{"kind":"Field","name":{"kind":"Name","value":"couponDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"couponMarketerDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}}]}}]}}]} as unknown as DocumentNode<IncomeStatementQuery, IncomeStatementQueryVariables>;
export const RemoveExpenseMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveExpenseMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"removeExpenseInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeExpenseMutation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<RemoveExpenseMutationMutation, RemoveExpenseMutationMutationVariables>;
export const UpdateAuthorizationFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAuthorizationForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invitersCanApprovePayments"}}]}}]}}]} as unknown as DocumentNode<UpdateAuthorizationFormMutation, UpdateAuthorizationFormMutationVariables>;
export const UpdateBookingTransitionStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateBookingTransitionStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"updateBookingTransitionStatusInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBookingTransitionStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateBookingTransitionStatusMutation, UpdateBookingTransitionStatusMutationVariables>;
export const FindUniqueTransitionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindUniqueTransition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransitionWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueTransition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"paymentWay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"fullAmount"}},{"kind":"Field","name":{"kind":"Name","value":"receiptUrl"}},{"kind":"Field","name":{"kind":"Name","value":"transitionPurpose"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transitionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"titleAr"}},{"kind":"Field","name":{"kind":"Name","value":"titleEn"}}]}}]}}]}}]} as unknown as DocumentNode<FindUniqueTransitionQuery, FindUniqueTransitionQueryVariables>;
export const DeleteManyUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteManyUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteManyUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<DeleteManyUsersMutation, DeleteManyUsersMutationVariables>;
export const DeleteUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteUserMutation, DeleteUserMutationVariables>;
export const MergeAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MergeAccounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MergeAccountsInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mergeAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<MergeAccountsMutation, MergeAccountsMutationVariables>;
export const CreateOneZoomDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOneZoom"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ZoomCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneZoom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agenda"}},{"kind":"Field","name":{"kind":"Name","value":"recurrence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"end_date_time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"registration_url"}},{"kind":"Field","name":{"kind":"Name","value":"start_url"}},{"kind":"Field","name":{"kind":"Name","value":"start_time"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<CreateOneZoomMutation, CreateOneZoomMutationVariables>;
export const FindOneZoomDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindOneZoom"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ZoomWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findOneZoom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agenda"}},{"kind":"Field","name":{"kind":"Name","value":"close_registration"}},{"kind":"Field","name":{"kind":"Name","value":"default_password"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"password"}},{"kind":"Field","name":{"kind":"Name","value":"occurrences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"occurrence_id"}},{"kind":"Field","name":{"kind":"Name","value":"start_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recurrence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"end_date_time"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"registration_url"}},{"kind":"Field","name":{"kind":"Name","value":"start_time"}},{"kind":"Field","name":{"kind":"Name","value":"start_url"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meeting_authentication"}},{"kind":"Field","name":{"kind":"Name","value":"registrants_email_notification"}},{"kind":"Field","name":{"kind":"Name","value":"registrants_confirmation_email"}}]}}]}}]}}]} as unknown as DocumentNode<FindOneZoomQuery, FindOneZoomQueryVariables>;
export const UpdateOneZoomDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOneZoom"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ZoomUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ZoomWhereUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneZoom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agenda"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"registration_url"}},{"kind":"Field","name":{"kind":"Name","value":"start_url"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"topic"}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meeting_authentication"}},{"kind":"Field","name":{"kind":"Name","value":"registrants_email_notification"}},{"kind":"Field","name":{"kind":"Name","value":"registrants_confirmation_email"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOneZoomMutation, UpdateOneZoomMutationVariables>;
export const CreateManyZoomRegistrantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateManyZoomRegistrant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ZoomRegistrantCreateOneInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createManyZoomRegistrant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateManyZoomRegistrantMutation, CreateManyZoomRegistrantMutationVariables>;
export const CreateOneZoomRegistrantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOneZoomRegistrant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ZoomRegistrantCreateOneInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneZoomRegistrant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"join_url"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}}]} as unknown as DocumentNode<CreateOneZoomRegistrantMutation, CreateOneZoomRegistrantMutationVariables>;
export const DeleteOneZoomRegistrantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneZoomRegistrant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ZoomRegistrantWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneZoomRegistrant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"industry"}}]}}]}}]} as unknown as DocumentNode<DeleteOneZoomRegistrantMutation, DeleteOneZoomRegistrantMutationVariables>;
export const FindManyZoomRegistrantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindManyZoomRegistrant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ZoomRegistrantWhereManyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyZoomRegistrant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"auto_approve"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"join_url"}},{"kind":"Field","name":{"kind":"Name","value":"page_number"}},{"kind":"Field","name":{"kind":"Name","value":"registrant_id"}},{"kind":"Field","name":{"kind":"Name","value":"job_title"}},{"kind":"Field","name":{"kind":"Name","value":"industry"}}]}}]}}]} as unknown as DocumentNode<FindManyZoomRegistrantQuery, FindManyZoomRegistrantQueryVariables>;
export const FindUniqueZoomRegistrantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindUniqueZoomRegistrant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ZoomRegistrantWherefindUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueZoomRegistrant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"zoomMode"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"job_title"}},{"kind":"Field","name":{"kind":"Name","value":"industry"}},{"kind":"Field","name":{"kind":"Name","value":"registrant_id"}},{"kind":"Field","name":{"kind":"Name","value":"join_url"}},{"kind":"Field","name":{"kind":"Name","value":"auto_approve"}}]}}]}}]} as unknown as DocumentNode<FindUniqueZoomRegistrantQuery, FindUniqueZoomRegistrantQueryVariables>;